var dr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yo(Me) {
  return Me && Me.__esModule && Object.prototype.hasOwnProperty.call(Me, "default") ? Me.default : Me;
}
function ip(Me) {
  if (Object.prototype.hasOwnProperty.call(Me, "__esModule")) return Me;
  var ge = Me.default;
  if (typeof ge == "function") {
    var ne = function C() {
      return this instanceof C ? Reflect.construct(ge, arguments, this.constructor) : ge.apply(this, arguments);
    };
    ne.prototype = ge.prototype;
  } else ne = {};
  return Object.defineProperty(ne, "__esModule", { value: !0 }), Object.keys(Me).forEach(function(C) {
    var Z = Object.getOwnPropertyDescriptor(Me, C);
    Object.defineProperty(ne, C, Z.get ? Z : {
      enumerable: !0,
      get: function() {
        return Me[C];
      }
    });
  }), ne;
}
var El = { exports: {} }, Es = {}, xl = { exports: {} }, Kt = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ic;
function np() {
  if (ic) return Kt;
  ic = 1;
  var Me = Symbol.for("react.element"), ge = Symbol.for("react.portal"), ne = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), Z = Symbol.for("react.profiler"), _ = Symbol.for("react.provider"), P = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), E = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), l = Symbol.iterator;
  function u(_e) {
    return _e === null || typeof _e != "object" ? null : (_e = l && _e[l] || _e["@@iterator"], typeof _e == "function" ? _e : null);
  }
  var a = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, n = Object.assign, c = {};
  function g(_e, ke, Pe) {
    this.props = _e, this.context = ke, this.refs = c, this.updater = Pe || a;
  }
  g.prototype.isReactComponent = {}, g.prototype.setState = function(_e, ke) {
    if (typeof _e != "object" && typeof _e != "function" && _e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, _e, ke, "setState");
  }, g.prototype.forceUpdate = function(_e) {
    this.updater.enqueueForceUpdate(this, _e, "forceUpdate");
  };
  function f() {
  }
  f.prototype = g.prototype;
  function p(_e, ke, Pe) {
    this.props = _e, this.context = ke, this.refs = c, this.updater = Pe || a;
  }
  var s = p.prototype = new f();
  s.constructor = p, n(s, g.prototype), s.isPureReactComponent = !0;
  var S = Array.isArray, b = Object.prototype.hasOwnProperty, o = { current: null }, A = { key: !0, ref: !0, __self: !0, __source: !0 };
  function T(_e, ke, Pe) {
    var fe, xe = {}, Ee = null, Ie = null;
    if (ke != null) for (fe in ke.ref !== void 0 && (Ie = ke.ref), ke.key !== void 0 && (Ee = "" + ke.key), ke) b.call(ke, fe) && !A.hasOwnProperty(fe) && (xe[fe] = ke[fe]);
    var je = arguments.length - 2;
    if (je === 1) xe.children = Pe;
    else if (1 < je) {
      for (var Ue = Array(je), He = 0; He < je; He++) Ue[He] = arguments[He + 2];
      xe.children = Ue;
    }
    if (_e && _e.defaultProps) for (fe in je = _e.defaultProps, je) xe[fe] === void 0 && (xe[fe] = je[fe]);
    return { $$typeof: Me, type: _e, key: Ee, ref: Ie, props: xe, _owner: o.current };
  }
  function R(_e, ke) {
    return { $$typeof: Me, type: _e.type, key: ke, ref: _e.ref, props: _e.props, _owner: _e._owner };
  }
  function L(_e) {
    return typeof _e == "object" && _e !== null && _e.$$typeof === Me;
  }
  function z(_e) {
    var ke = { "=": "=0", ":": "=2" };
    return "$" + _e.replace(/[=:]/g, function(Pe) {
      return ke[Pe];
    });
  }
  var U = /\/+/g;
  function J(_e, ke) {
    return typeof _e == "object" && _e !== null && _e.key != null ? z("" + _e.key) : ke.toString(36);
  }
  function F(_e, ke, Pe, fe, xe) {
    var Ee = typeof _e;
    (Ee === "undefined" || Ee === "boolean") && (_e = null);
    var Ie = !1;
    if (_e === null) Ie = !0;
    else switch (Ee) {
      case "string":
      case "number":
        Ie = !0;
        break;
      case "object":
        switch (_e.$$typeof) {
          case Me:
          case ge:
            Ie = !0;
        }
    }
    if (Ie) return Ie = _e, xe = xe(Ie), _e = fe === "" ? "." + J(Ie, 0) : fe, S(xe) ? (Pe = "", _e != null && (Pe = _e.replace(U, "$&/") + "/"), F(xe, ke, Pe, "", function(He) {
      return He;
    })) : xe != null && (L(xe) && (xe = R(xe, Pe + (!xe.key || Ie && Ie.key === xe.key ? "" : ("" + xe.key).replace(U, "$&/") + "/") + _e)), ke.push(xe)), 1;
    if (Ie = 0, fe = fe === "" ? "." : fe + ":", S(_e)) for (var je = 0; je < _e.length; je++) {
      Ee = _e[je];
      var Ue = fe + J(Ee, je);
      Ie += F(Ee, ke, Pe, Ue, xe);
    }
    else if (Ue = u(_e), typeof Ue == "function") for (_e = Ue.call(_e), je = 0; !(Ee = _e.next()).done; ) Ee = Ee.value, Ue = fe + J(Ee, je++), Ie += F(Ee, ke, Pe, Ue, xe);
    else if (Ee === "object") throw ke = String(_e), Error("Objects are not valid as a React child (found: " + (ke === "[object Object]" ? "object with keys {" + Object.keys(_e).join(", ") + "}" : ke) + "). If you meant to render a collection of children, use an array instead.");
    return Ie;
  }
  function se(_e, ke, Pe) {
    if (_e == null) return _e;
    var fe = [], xe = 0;
    return F(_e, fe, "", "", function(Ee) {
      return ke.call(Pe, Ee, xe++);
    }), fe;
  }
  function ee(_e) {
    if (_e._status === -1) {
      var ke = _e._result;
      ke = ke(), ke.then(function(Pe) {
        (_e._status === 0 || _e._status === -1) && (_e._status = 1, _e._result = Pe);
      }, function(Pe) {
        (_e._status === 0 || _e._status === -1) && (_e._status = 2, _e._result = Pe);
      }), _e._status === -1 && (_e._status = 0, _e._result = ke);
    }
    if (_e._status === 1) return _e._result.default;
    throw _e._result;
  }
  var ie = { current: null }, W = { transition: null }, Q = { ReactCurrentDispatcher: ie, ReactCurrentBatchConfig: W, ReactCurrentOwner: o };
  function de() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return Kt.Children = { map: se, forEach: function(_e, ke, Pe) {
    se(_e, function() {
      ke.apply(this, arguments);
    }, Pe);
  }, count: function(_e) {
    var ke = 0;
    return se(_e, function() {
      ke++;
    }), ke;
  }, toArray: function(_e) {
    return se(_e, function(ke) {
      return ke;
    }) || [];
  }, only: function(_e) {
    if (!L(_e)) throw Error("React.Children.only expected to receive a single React element child.");
    return _e;
  } }, Kt.Component = g, Kt.Fragment = ne, Kt.Profiler = Z, Kt.PureComponent = p, Kt.StrictMode = C, Kt.Suspense = y, Kt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Q, Kt.act = de, Kt.cloneElement = function(_e, ke, Pe) {
    if (_e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + _e + ".");
    var fe = n({}, _e.props), xe = _e.key, Ee = _e.ref, Ie = _e._owner;
    if (ke != null) {
      if (ke.ref !== void 0 && (Ee = ke.ref, Ie = o.current), ke.key !== void 0 && (xe = "" + ke.key), _e.type && _e.type.defaultProps) var je = _e.type.defaultProps;
      for (Ue in ke) b.call(ke, Ue) && !A.hasOwnProperty(Ue) && (fe[Ue] = ke[Ue] === void 0 && je !== void 0 ? je[Ue] : ke[Ue]);
    }
    var Ue = arguments.length - 2;
    if (Ue === 1) fe.children = Pe;
    else if (1 < Ue) {
      je = Array(Ue);
      for (var He = 0; He < Ue; He++) je[He] = arguments[He + 2];
      fe.children = je;
    }
    return { $$typeof: Me, type: _e.type, key: xe, ref: Ee, props: fe, _owner: Ie };
  }, Kt.createContext = function(_e) {
    return _e = { $$typeof: P, _currentValue: _e, _currentValue2: _e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, _e.Provider = { $$typeof: _, _context: _e }, _e.Consumer = _e;
  }, Kt.createElement = T, Kt.createFactory = function(_e) {
    var ke = T.bind(null, _e);
    return ke.type = _e, ke;
  }, Kt.createRef = function() {
    return { current: null };
  }, Kt.forwardRef = function(_e) {
    return { $$typeof: x, render: _e };
  }, Kt.isValidElement = L, Kt.lazy = function(_e) {
    return { $$typeof: d, _payload: { _status: -1, _result: _e }, _init: ee };
  }, Kt.memo = function(_e, ke) {
    return { $$typeof: E, type: _e, compare: ke === void 0 ? null : ke };
  }, Kt.startTransition = function(_e) {
    var ke = W.transition;
    W.transition = {};
    try {
      _e();
    } finally {
      W.transition = ke;
    }
  }, Kt.unstable_act = de, Kt.useCallback = function(_e, ke) {
    return ie.current.useCallback(_e, ke);
  }, Kt.useContext = function(_e) {
    return ie.current.useContext(_e);
  }, Kt.useDebugValue = function() {
  }, Kt.useDeferredValue = function(_e) {
    return ie.current.useDeferredValue(_e);
  }, Kt.useEffect = function(_e, ke) {
    return ie.current.useEffect(_e, ke);
  }, Kt.useId = function() {
    return ie.current.useId();
  }, Kt.useImperativeHandle = function(_e, ke, Pe) {
    return ie.current.useImperativeHandle(_e, ke, Pe);
  }, Kt.useInsertionEffect = function(_e, ke) {
    return ie.current.useInsertionEffect(_e, ke);
  }, Kt.useLayoutEffect = function(_e, ke) {
    return ie.current.useLayoutEffect(_e, ke);
  }, Kt.useMemo = function(_e, ke) {
    return ie.current.useMemo(_e, ke);
  }, Kt.useReducer = function(_e, ke, Pe) {
    return ie.current.useReducer(_e, ke, Pe);
  }, Kt.useRef = function(_e) {
    return ie.current.useRef(_e);
  }, Kt.useState = function(_e) {
    return ie.current.useState(_e);
  }, Kt.useSyncExternalStore = function(_e, ke, Pe) {
    return ie.current.useSyncExternalStore(_e, ke, Pe);
  }, Kt.useTransition = function() {
    return ie.current.useTransition();
  }, Kt.version = "18.3.1", Kt;
}
var nc;
function tf() {
  return nc || (nc = 1, xl.exports = np()), xl.exports;
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ac;
function ap() {
  if (ac) return Es;
  ac = 1;
  var Me = tf(), ge = Symbol.for("react.element"), ne = Symbol.for("react.fragment"), C = Object.prototype.hasOwnProperty, Z = Me.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, _ = { key: !0, ref: !0, __self: !0, __source: !0 };
  function P(x, y, E) {
    var d, l = {}, u = null, a = null;
    E !== void 0 && (u = "" + E), y.key !== void 0 && (u = "" + y.key), y.ref !== void 0 && (a = y.ref);
    for (d in y) C.call(y, d) && !_.hasOwnProperty(d) && (l[d] = y[d]);
    if (x && x.defaultProps) for (d in y = x.defaultProps, y) l[d] === void 0 && (l[d] = y[d]);
    return { $$typeof: ge, type: x, key: u, ref: a, props: l, _owner: Z.current };
  }
  return Es.Fragment = ne, Es.jsx = P, Es.jsxs = P, Es;
}
var sc;
function sp() {
  return sc || (sc = 1, El.exports = ap()), El.exports;
}
var ft = sp(), Xt = tf();
const ga = /* @__PURE__ */ Yo(Xt);
var Fo = {}, Cl = { exports: {} }, pi = {}, kl = { exports: {} }, Al = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oc;
function op() {
  return oc || (oc = 1, function(Me) {
    function ge(W, Q) {
      var de = W.length;
      W.push(Q);
      e: for (; 0 < de; ) {
        var _e = de - 1 >>> 1, ke = W[_e];
        if (0 < Z(ke, Q)) W[_e] = Q, W[de] = ke, de = _e;
        else break e;
      }
    }
    function ne(W) {
      return W.length === 0 ? null : W[0];
    }
    function C(W) {
      if (W.length === 0) return null;
      var Q = W[0], de = W.pop();
      if (de !== Q) {
        W[0] = de;
        e: for (var _e = 0, ke = W.length, Pe = ke >>> 1; _e < Pe; ) {
          var fe = 2 * (_e + 1) - 1, xe = W[fe], Ee = fe + 1, Ie = W[Ee];
          if (0 > Z(xe, de)) Ee < ke && 0 > Z(Ie, xe) ? (W[_e] = Ie, W[Ee] = de, _e = Ee) : (W[_e] = xe, W[fe] = de, _e = fe);
          else if (Ee < ke && 0 > Z(Ie, de)) W[_e] = Ie, W[Ee] = de, _e = Ee;
          else break e;
        }
      }
      return Q;
    }
    function Z(W, Q) {
      var de = W.sortIndex - Q.sortIndex;
      return de !== 0 ? de : W.id - Q.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var _ = performance;
      Me.unstable_now = function() {
        return _.now();
      };
    } else {
      var P = Date, x = P.now();
      Me.unstable_now = function() {
        return P.now() - x;
      };
    }
    var y = [], E = [], d = 1, l = null, u = 3, a = !1, n = !1, c = !1, g = typeof setTimeout == "function" ? setTimeout : null, f = typeof clearTimeout == "function" ? clearTimeout : null, p = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function s(W) {
      for (var Q = ne(E); Q !== null; ) {
        if (Q.callback === null) C(E);
        else if (Q.startTime <= W) C(E), Q.sortIndex = Q.expirationTime, ge(y, Q);
        else break;
        Q = ne(E);
      }
    }
    function S(W) {
      if (c = !1, s(W), !n) if (ne(y) !== null) n = !0, ee(b);
      else {
        var Q = ne(E);
        Q !== null && ie(S, Q.startTime - W);
      }
    }
    function b(W, Q) {
      n = !1, c && (c = !1, f(T), T = -1), a = !0;
      var de = u;
      try {
        for (s(Q), l = ne(y); l !== null && (!(l.expirationTime > Q) || W && !z()); ) {
          var _e = l.callback;
          if (typeof _e == "function") {
            l.callback = null, u = l.priorityLevel;
            var ke = _e(l.expirationTime <= Q);
            Q = Me.unstable_now(), typeof ke == "function" ? l.callback = ke : l === ne(y) && C(y), s(Q);
          } else C(y);
          l = ne(y);
        }
        if (l !== null) var Pe = !0;
        else {
          var fe = ne(E);
          fe !== null && ie(S, fe.startTime - Q), Pe = !1;
        }
        return Pe;
      } finally {
        l = null, u = de, a = !1;
      }
    }
    var o = !1, A = null, T = -1, R = 5, L = -1;
    function z() {
      return !(Me.unstable_now() - L < R);
    }
    function U() {
      if (A !== null) {
        var W = Me.unstable_now();
        L = W;
        var Q = !0;
        try {
          Q = A(!0, W);
        } finally {
          Q ? J() : (o = !1, A = null);
        }
      } else o = !1;
    }
    var J;
    if (typeof p == "function") J = function() {
      p(U);
    };
    else if (typeof MessageChannel < "u") {
      var F = new MessageChannel(), se = F.port2;
      F.port1.onmessage = U, J = function() {
        se.postMessage(null);
      };
    } else J = function() {
      g(U, 0);
    };
    function ee(W) {
      A = W, o || (o = !0, J());
    }
    function ie(W, Q) {
      T = g(function() {
        W(Me.unstable_now());
      }, Q);
    }
    Me.unstable_IdlePriority = 5, Me.unstable_ImmediatePriority = 1, Me.unstable_LowPriority = 4, Me.unstable_NormalPriority = 3, Me.unstable_Profiling = null, Me.unstable_UserBlockingPriority = 2, Me.unstable_cancelCallback = function(W) {
      W.callback = null;
    }, Me.unstable_continueExecution = function() {
      n || a || (n = !0, ee(b));
    }, Me.unstable_forceFrameRate = function(W) {
      0 > W || 125 < W ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : R = 0 < W ? Math.floor(1e3 / W) : 5;
    }, Me.unstable_getCurrentPriorityLevel = function() {
      return u;
    }, Me.unstable_getFirstCallbackNode = function() {
      return ne(y);
    }, Me.unstable_next = function(W) {
      switch (u) {
        case 1:
        case 2:
        case 3:
          var Q = 3;
          break;
        default:
          Q = u;
      }
      var de = u;
      u = Q;
      try {
        return W();
      } finally {
        u = de;
      }
    }, Me.unstable_pauseExecution = function() {
    }, Me.unstable_requestPaint = function() {
    }, Me.unstable_runWithPriority = function(W, Q) {
      switch (W) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          W = 3;
      }
      var de = u;
      u = W;
      try {
        return Q();
      } finally {
        u = de;
      }
    }, Me.unstable_scheduleCallback = function(W, Q, de) {
      var _e = Me.unstable_now();
      switch (typeof de == "object" && de !== null ? (de = de.delay, de = typeof de == "number" && 0 < de ? _e + de : _e) : de = _e, W) {
        case 1:
          var ke = -1;
          break;
        case 2:
          ke = 250;
          break;
        case 5:
          ke = 1073741823;
          break;
        case 4:
          ke = 1e4;
          break;
        default:
          ke = 5e3;
      }
      return ke = de + ke, W = { id: d++, callback: Q, priorityLevel: W, startTime: de, expirationTime: ke, sortIndex: -1 }, de > _e ? (W.sortIndex = de, ge(E, W), ne(y) === null && W === ne(E) && (c ? (f(T), T = -1) : c = !0, ie(S, de - _e))) : (W.sortIndex = ke, ge(y, W), n || a || (n = !0, ee(b))), W;
    }, Me.unstable_shouldYield = z, Me.unstable_wrapCallback = function(W) {
      var Q = u;
      return function() {
        var de = u;
        u = Q;
        try {
          return W.apply(this, arguments);
        } finally {
          u = de;
        }
      };
    };
  }(Al)), Al;
}
var uc;
function up() {
  return uc || (uc = 1, kl.exports = op()), kl.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lc;
function lp() {
  if (lc) return pi;
  lc = 1;
  var Me = tf(), ge = up();
  function ne(t) {
    for (var i = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, w = 1; w < arguments.length; w++) i += "&args[]=" + encodeURIComponent(arguments[w]);
    return "Minified React error #" + t + "; visit " + i + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var C = /* @__PURE__ */ new Set(), Z = {};
  function _(t, i) {
    P(t, i), P(t + "Capture", i);
  }
  function P(t, i) {
    for (Z[t] = i, t = 0; t < i.length; t++) C.add(i[t]);
  }
  var x = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), y = Object.prototype.hasOwnProperty, E = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, d = {}, l = {};
  function u(t) {
    return y.call(l, t) ? !0 : y.call(d, t) ? !1 : E.test(t) ? l[t] = !0 : (d[t] = !0, !1);
  }
  function a(t, i, w, N) {
    if (w !== null && w.type === 0) return !1;
    switch (typeof i) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return N ? !1 : w !== null ? !w.acceptsBooleans : (t = t.toLowerCase().slice(0, 5), t !== "data-" && t !== "aria-");
      default:
        return !1;
    }
  }
  function n(t, i, w, N) {
    if (i === null || typeof i > "u" || a(t, i, w, N)) return !0;
    if (N) return !1;
    if (w !== null) switch (w.type) {
      case 3:
        return !i;
      case 4:
        return i === !1;
      case 5:
        return isNaN(i);
      case 6:
        return isNaN(i) || 1 > i;
    }
    return !1;
  }
  function c(t, i, w, N, ae, ye, ze) {
    this.acceptsBooleans = i === 2 || i === 3 || i === 4, this.attributeName = N, this.attributeNamespace = ae, this.mustUseProperty = w, this.propertyName = t, this.type = i, this.sanitizeURL = ye, this.removeEmptyString = ze;
  }
  var g = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(t) {
    g[t] = new c(t, 0, !1, t, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(t) {
    var i = t[0];
    g[i] = new c(i, 1, !1, t[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(t) {
    g[t] = new c(t, 2, !1, t.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(t) {
    g[t] = new c(t, 2, !1, t, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(t) {
    g[t] = new c(t, 3, !1, t.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(t) {
    g[t] = new c(t, 3, !0, t, null, !1, !1);
  }), ["capture", "download"].forEach(function(t) {
    g[t] = new c(t, 4, !1, t, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(t) {
    g[t] = new c(t, 6, !1, t, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(t) {
    g[t] = new c(t, 5, !1, t.toLowerCase(), null, !1, !1);
  });
  var f = /[\-:]([a-z])/g;
  function p(t) {
    return t[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(t) {
    var i = t.replace(
      f,
      p
    );
    g[i] = new c(i, 1, !1, t, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(t) {
    var i = t.replace(f, p);
    g[i] = new c(i, 1, !1, t, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(t) {
    var i = t.replace(f, p);
    g[i] = new c(i, 1, !1, t, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(t) {
    g[t] = new c(t, 1, !1, t.toLowerCase(), null, !1, !1);
  }), g.xlinkHref = new c("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(t) {
    g[t] = new c(t, 1, !1, t.toLowerCase(), null, !0, !0);
  });
  function s(t, i, w, N) {
    var ae = g.hasOwnProperty(i) ? g[i] : null;
    (ae !== null ? ae.type !== 0 : N || !(2 < i.length) || i[0] !== "o" && i[0] !== "O" || i[1] !== "n" && i[1] !== "N") && (n(i, w, ae, N) && (w = null), N || ae === null ? u(i) && (w === null ? t.removeAttribute(i) : t.setAttribute(i, "" + w)) : ae.mustUseProperty ? t[ae.propertyName] = w === null ? ae.type === 3 ? !1 : "" : w : (i = ae.attributeName, N = ae.attributeNamespace, w === null ? t.removeAttribute(i) : (ae = ae.type, w = ae === 3 || ae === 4 && w === !0 ? "" : "" + w, N ? t.setAttributeNS(N, i, w) : t.setAttribute(i, w))));
  }
  var S = Me.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, b = Symbol.for("react.element"), o = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), T = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), L = Symbol.for("react.provider"), z = Symbol.for("react.context"), U = Symbol.for("react.forward_ref"), J = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), se = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), ie = Symbol.for("react.offscreen"), W = Symbol.iterator;
  function Q(t) {
    return t === null || typeof t != "object" ? null : (t = W && t[W] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var de = Object.assign, _e;
  function ke(t) {
    if (_e === void 0) try {
      throw Error();
    } catch (w) {
      var i = w.stack.trim().match(/\n( *(at )?)/);
      _e = i && i[1] || "";
    }
    return `
` + _e + t;
  }
  var Pe = !1;
  function fe(t, i) {
    if (!t || Pe) return "";
    Pe = !0;
    var w = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (i) if (i = function() {
        throw Error();
      }, Object.defineProperty(i.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(i, []);
        } catch (ht) {
          var N = ht;
        }
        Reflect.construct(t, [], i);
      } else {
        try {
          i.call();
        } catch (ht) {
          N = ht;
        }
        t.call(i.prototype);
      }
      else {
        try {
          throw Error();
        } catch (ht) {
          N = ht;
        }
        t();
      }
    } catch (ht) {
      if (ht && N && typeof ht.stack == "string") {
        for (var ae = ht.stack.split(`
`), ye = N.stack.split(`
`), ze = ae.length - 1, Qe = ye.length - 1; 1 <= ze && 0 <= Qe && ae[ze] !== ye[Qe]; ) Qe--;
        for (; 1 <= ze && 0 <= Qe; ze--, Qe--) if (ae[ze] !== ye[Qe]) {
          if (ze !== 1 || Qe !== 1)
            do
              if (ze--, Qe--, 0 > Qe || ae[ze] !== ye[Qe]) {
                var rt = `
` + ae[ze].replace(" at new ", " at ");
                return t.displayName && rt.includes("<anonymous>") && (rt = rt.replace("<anonymous>", t.displayName)), rt;
              }
            while (1 <= ze && 0 <= Qe);
          break;
        }
      }
    } finally {
      Pe = !1, Error.prepareStackTrace = w;
    }
    return (t = t ? t.displayName || t.name : "") ? ke(t) : "";
  }
  function xe(t) {
    switch (t.tag) {
      case 5:
        return ke(t.type);
      case 16:
        return ke("Lazy");
      case 13:
        return ke("Suspense");
      case 19:
        return ke("SuspenseList");
      case 0:
      case 2:
      case 15:
        return t = fe(t.type, !1), t;
      case 11:
        return t = fe(t.type.render, !1), t;
      case 1:
        return t = fe(t.type, !0), t;
      default:
        return "";
    }
  }
  function Ee(t) {
    if (t == null) return null;
    if (typeof t == "function") return t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case A:
        return "Fragment";
      case o:
        return "Portal";
      case R:
        return "Profiler";
      case T:
        return "StrictMode";
      case J:
        return "Suspense";
      case F:
        return "SuspenseList";
    }
    if (typeof t == "object") switch (t.$$typeof) {
      case z:
        return (t.displayName || "Context") + ".Consumer";
      case L:
        return (t._context.displayName || "Context") + ".Provider";
      case U:
        var i = t.render;
        return t = t.displayName, t || (t = i.displayName || i.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
      case se:
        return i = t.displayName || null, i !== null ? i : Ee(t.type) || "Memo";
      case ee:
        i = t._payload, t = t._init;
        try {
          return Ee(t(i));
        } catch {
        }
    }
    return null;
  }
  function Ie(t) {
    var i = t.type;
    switch (t.tag) {
      case 24:
        return "Cache";
      case 9:
        return (i.displayName || "Context") + ".Consumer";
      case 10:
        return (i._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return t = i.render, t = t.displayName || t.name || "", i.displayName || (t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return i;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Ee(i);
      case 8:
        return i === T ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof i == "function") return i.displayName || i.name || null;
        if (typeof i == "string") return i;
    }
    return null;
  }
  function je(t) {
    switch (typeof t) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function Ue(t) {
    var i = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (i === "checkbox" || i === "radio");
  }
  function He(t) {
    var i = Ue(t) ? "checked" : "value", w = Object.getOwnPropertyDescriptor(t.constructor.prototype, i), N = "" + t[i];
    if (!t.hasOwnProperty(i) && typeof w < "u" && typeof w.get == "function" && typeof w.set == "function") {
      var ae = w.get, ye = w.set;
      return Object.defineProperty(t, i, { configurable: !0, get: function() {
        return ae.call(this);
      }, set: function(ze) {
        N = "" + ze, ye.call(this, ze);
      } }), Object.defineProperty(t, i, { enumerable: w.enumerable }), { getValue: function() {
        return N;
      }, setValue: function(ze) {
        N = "" + ze;
      }, stopTracking: function() {
        t._valueTracker = null, delete t[i];
      } };
    }
  }
  function Ze(t) {
    t._valueTracker || (t._valueTracker = He(t));
  }
  function $e(t) {
    if (!t) return !1;
    var i = t._valueTracker;
    if (!i) return !0;
    var w = i.getValue(), N = "";
    return t && (N = Ue(t) ? t.checked ? "true" : "false" : t.value), t = N, t !== w ? (i.setValue(t), !0) : !1;
  }
  function We(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  function Ve(t, i) {
    var w = i.checked;
    return de({}, i, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: w ?? t._wrapperState.initialChecked });
  }
  function Re(t, i) {
    var w = i.defaultValue == null ? "" : i.defaultValue, N = i.checked != null ? i.checked : i.defaultChecked;
    w = je(i.value != null ? i.value : w), t._wrapperState = { initialChecked: N, initialValue: w, controlled: i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null };
  }
  function De(t, i) {
    i = i.checked, i != null && s(t, "checked", i, !1);
  }
  function Ne(t, i) {
    De(t, i);
    var w = je(i.value), N = i.type;
    if (w != null) N === "number" ? (w === 0 && t.value === "" || t.value != w) && (t.value = "" + w) : t.value !== "" + w && (t.value = "" + w);
    else if (N === "submit" || N === "reset") {
      t.removeAttribute("value");
      return;
    }
    i.hasOwnProperty("value") ? re(t, i.type, w) : i.hasOwnProperty("defaultValue") && re(t, i.type, je(i.defaultValue)), i.checked == null && i.defaultChecked != null && (t.defaultChecked = !!i.defaultChecked);
  }
  function we(t, i, w) {
    if (i.hasOwnProperty("value") || i.hasOwnProperty("defaultValue")) {
      var N = i.type;
      if (!(N !== "submit" && N !== "reset" || i.value !== void 0 && i.value !== null)) return;
      i = "" + t._wrapperState.initialValue, w || i === t.value || (t.value = i), t.defaultValue = i;
    }
    w = t.name, w !== "" && (t.name = ""), t.defaultChecked = !!t._wrapperState.initialChecked, w !== "" && (t.name = w);
  }
  function re(t, i, w) {
    (i !== "number" || We(t.ownerDocument) !== t) && (w == null ? t.defaultValue = "" + t._wrapperState.initialValue : t.defaultValue !== "" + w && (t.defaultValue = "" + w));
  }
  var $ = Array.isArray;
  function Ce(t, i, w, N) {
    if (t = t.options, i) {
      i = {};
      for (var ae = 0; ae < w.length; ae++) i["$" + w[ae]] = !0;
      for (w = 0; w < t.length; w++) ae = i.hasOwnProperty("$" + t[w].value), t[w].selected !== ae && (t[w].selected = ae), ae && N && (t[w].defaultSelected = !0);
    } else {
      for (w = "" + je(w), i = null, ae = 0; ae < t.length; ae++) {
        if (t[ae].value === w) {
          t[ae].selected = !0, N && (t[ae].defaultSelected = !0);
          return;
        }
        i !== null || t[ae].disabled || (i = t[ae]);
      }
      i !== null && (i.selected = !0);
    }
  }
  function ve(t, i) {
    if (i.dangerouslySetInnerHTML != null) throw Error(ne(91));
    return de({}, i, { value: void 0, defaultValue: void 0, children: "" + t._wrapperState.initialValue });
  }
  function Y(t, i) {
    var w = i.value;
    if (w == null) {
      if (w = i.children, i = i.defaultValue, w != null) {
        if (i != null) throw Error(ne(92));
        if ($(w)) {
          if (1 < w.length) throw Error(ne(93));
          w = w[0];
        }
        i = w;
      }
      i == null && (i = ""), w = i;
    }
    t._wrapperState = { initialValue: je(w) };
  }
  function G(t, i) {
    var w = je(i.value), N = je(i.defaultValue);
    w != null && (w = "" + w, w !== t.value && (t.value = w), i.defaultValue == null && t.defaultValue !== w && (t.defaultValue = w)), N != null && (t.defaultValue = "" + N);
  }
  function Ae(t) {
    var i = t.textContent;
    i === t._wrapperState.initialValue && i !== "" && i !== null && (t.value = i);
  }
  function e(t) {
    switch (t) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function r(t, i) {
    return t == null || t === "http://www.w3.org/1999/xhtml" ? e(i) : t === "http://www.w3.org/2000/svg" && i === "foreignObject" ? "http://www.w3.org/1999/xhtml" : t;
  }
  var h, k = function(t) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(i, w, N, ae) {
      MSApp.execUnsafeLocalFunction(function() {
        return t(i, w, N, ae);
      });
    } : t;
  }(function(t, i) {
    if (t.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in t) t.innerHTML = i;
    else {
      for (h = h || document.createElement("div"), h.innerHTML = "<svg>" + i.valueOf().toString() + "</svg>", i = h.firstChild; t.firstChild; ) t.removeChild(t.firstChild);
      for (; i.firstChild; ) t.appendChild(i.firstChild);
    }
  });
  function I(t, i) {
    if (i) {
      var w = t.firstChild;
      if (w && w === t.lastChild && w.nodeType === 3) {
        w.nodeValue = i;
        return;
      }
    }
    t.textContent = i;
  }
  var B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, j = ["Webkit", "ms", "Moz", "O"];
  Object.keys(B).forEach(function(t) {
    j.forEach(function(i) {
      i = i + t.charAt(0).toUpperCase() + t.substring(1), B[i] = B[t];
    });
  });
  function H(t, i, w) {
    return i == null || typeof i == "boolean" || i === "" ? "" : w || typeof i != "number" || i === 0 || B.hasOwnProperty(t) && B[t] ? ("" + i).trim() : i + "px";
  }
  function X(t, i) {
    t = t.style;
    for (var w in i) if (i.hasOwnProperty(w)) {
      var N = w.indexOf("--") === 0, ae = H(w, i[w], N);
      w === "float" && (w = "cssFloat"), N ? t.setProperty(w, ae) : t[w] = ae;
    }
  }
  var ue = de({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function pe(t, i) {
    if (i) {
      if (ue[t] && (i.children != null || i.dangerouslySetInnerHTML != null)) throw Error(ne(137, t));
      if (i.dangerouslySetInnerHTML != null) {
        if (i.children != null) throw Error(ne(60));
        if (typeof i.dangerouslySetInnerHTML != "object" || !("__html" in i.dangerouslySetInnerHTML)) throw Error(ne(61));
      }
      if (i.style != null && typeof i.style != "object") throw Error(ne(62));
    }
  }
  function M(t, i) {
    if (t.indexOf("-") === -1) return typeof i.is == "string";
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var q = null;
  function K(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var be = null, te = null, he = null;
  function D(t) {
    if (t = us(t)) {
      if (typeof be != "function") throw Error(ne(280));
      var i = t.stateNode;
      i && (i = Js(i), be(t.stateNode, t.type, i));
    }
  }
  function Se(t) {
    te ? he ? he.push(t) : he = [t] : te = t;
  }
  function le() {
    if (te) {
      var t = te, i = he;
      if (he = te = null, D(t), i) for (t = 0; t < i.length; t++) D(i[t]);
    }
  }
  function m(t, i) {
    return t(i);
  }
  function oe() {
  }
  var me = !1;
  function O(t, i, w) {
    if (me) return t(i, w);
    me = !0;
    try {
      return m(t, i, w);
    } finally {
      me = !1, (te !== null || he !== null) && (oe(), le());
    }
  }
  function ce(t, i) {
    var w = t.stateNode;
    if (w === null) return null;
    var N = Js(w);
    if (N === null) return null;
    w = N[i];
    e: switch (i) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (N = !N.disabled) || (t = t.type, N = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !N;
        break e;
      default:
        t = !1;
    }
    if (t) return null;
    if (w && typeof w != "function") throw Error(ne(231, i, typeof w));
    return w;
  }
  var Oe = !1;
  if (x) try {
    var Be = {};
    Object.defineProperty(Be, "passive", { get: function() {
      Oe = !0;
    } }), window.addEventListener("test", Be, Be), window.removeEventListener("test", Be, Be);
  } catch {
    Oe = !1;
  }
  function Ge(t, i, w, N, ae, ye, ze, Qe, rt) {
    var ht = Array.prototype.slice.call(arguments, 3);
    try {
      i.apply(w, ht);
    } catch (yt) {
      this.onError(yt);
    }
  }
  var Fe = !1, Ye = null, Ke = !1, et = null, Je = { onError: function(t) {
    Fe = !0, Ye = t;
  } };
  function nt(t, i, w, N, ae, ye, ze, Qe, rt) {
    Fe = !1, Ye = null, Ge.apply(Je, arguments);
  }
  function pt(t, i, w, N, ae, ye, ze, Qe, rt) {
    if (nt.apply(this, arguments), Fe) {
      if (Fe) {
        var ht = Ye;
        Fe = !1, Ye = null;
      } else throw Error(ne(198));
      Ke || (Ke = !0, et = ht);
    }
  }
  function vt(t) {
    var i = t, w = t;
    if (t.alternate) for (; i.return; ) i = i.return;
    else {
      t = i;
      do
        i = t, (i.flags & 4098) !== 0 && (w = i.return), t = i.return;
      while (t);
    }
    return i.tag === 3 ? w : null;
  }
  function bt(t) {
    if (t.tag === 13) {
      var i = t.memoizedState;
      if (i === null && (t = t.alternate, t !== null && (i = t.memoizedState)), i !== null) return i.dehydrated;
    }
    return null;
  }
  function At(t) {
    if (vt(t) !== t) throw Error(ne(188));
  }
  function ot(t) {
    var i = t.alternate;
    if (!i) {
      if (i = vt(t), i === null) throw Error(ne(188));
      return i !== t ? null : t;
    }
    for (var w = t, N = i; ; ) {
      var ae = w.return;
      if (ae === null) break;
      var ye = ae.alternate;
      if (ye === null) {
        if (N = ae.return, N !== null) {
          w = N;
          continue;
        }
        break;
      }
      if (ae.child === ye.child) {
        for (ye = ae.child; ye; ) {
          if (ye === w) return At(ae), t;
          if (ye === N) return At(ae), i;
          ye = ye.sibling;
        }
        throw Error(ne(188));
      }
      if (w.return !== N.return) w = ae, N = ye;
      else {
        for (var ze = !1, Qe = ae.child; Qe; ) {
          if (Qe === w) {
            ze = !0, w = ae, N = ye;
            break;
          }
          if (Qe === N) {
            ze = !0, N = ae, w = ye;
            break;
          }
          Qe = Qe.sibling;
        }
        if (!ze) {
          for (Qe = ye.child; Qe; ) {
            if (Qe === w) {
              ze = !0, w = ye, N = ae;
              break;
            }
            if (Qe === N) {
              ze = !0, N = ye, w = ae;
              break;
            }
            Qe = Qe.sibling;
          }
          if (!ze) throw Error(ne(189));
        }
      }
      if (w.alternate !== N) throw Error(ne(190));
    }
    if (w.tag !== 3) throw Error(ne(188));
    return w.stateNode.current === w ? t : i;
  }
  function ct(t) {
    return t = ot(t), t !== null ? gt(t) : null;
  }
  function gt(t) {
    if (t.tag === 5 || t.tag === 6) return t;
    for (t = t.child; t !== null; ) {
      var i = gt(t);
      if (i !== null) return i;
      t = t.sibling;
    }
    return null;
  }
  var Ct = ge.unstable_scheduleCallback, xt = ge.unstable_cancelCallback, Ot = ge.unstable_shouldYield, Nt = ge.unstable_requestPaint, Pt = ge.unstable_now, Gt = ge.unstable_getCurrentPriorityLevel, Bt = ge.unstable_ImmediatePriority, or = ge.unstable_UserBlockingPriority, ar = ge.unstable_NormalPriority, ur = ge.unstable_LowPriority, hr = ge.unstable_IdlePriority, wt = null, $t = null;
  function lr(t) {
    if ($t && typeof $t.onCommitFiberRoot == "function") try {
      $t.onCommitFiberRoot(wt, t, void 0, (t.current.flags & 128) === 128);
    } catch {
    }
  }
  var tr = Math.clz32 ? Math.clz32 : ii, Xr = Math.log, gi = Math.LN2;
  function ii(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (Xr(t) / gi | 0) | 0;
  }
  var Br = 64, Er = 4194304;
  function kr(t) {
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return t & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return t;
    }
  }
  function qr(t, i) {
    var w = t.pendingLanes;
    if (w === 0) return 0;
    var N = 0, ae = t.suspendedLanes, ye = t.pingedLanes, ze = w & 268435455;
    if (ze !== 0) {
      var Qe = ze & ~ae;
      Qe !== 0 ? N = kr(Qe) : (ye &= ze, ye !== 0 && (N = kr(ye)));
    } else ze = w & ~ae, ze !== 0 ? N = kr(ze) : ye !== 0 && (N = kr(ye));
    if (N === 0) return 0;
    if (i !== 0 && i !== N && (i & ae) === 0 && (ae = N & -N, ye = i & -i, ae >= ye || ae === 16 && (ye & 4194240) !== 0)) return i;
    if ((N & 4) !== 0 && (N |= w & 16), i = t.entangledLanes, i !== 0) for (t = t.entanglements, i &= N; 0 < i; ) w = 31 - tr(i), ae = 1 << w, N |= t[w], i &= ~ae;
    return N;
  }
  function yr(t, i) {
    switch (t) {
      case 1:
      case 2:
      case 4:
        return i + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Or(t, i) {
    for (var w = t.suspendedLanes, N = t.pingedLanes, ae = t.expirationTimes, ye = t.pendingLanes; 0 < ye; ) {
      var ze = 31 - tr(ye), Qe = 1 << ze, rt = ae[ze];
      rt === -1 ? ((Qe & w) === 0 || (Qe & N) !== 0) && (ae[ze] = yr(Qe, i)) : rt <= i && (t.expiredLanes |= Qe), ye &= ~Qe;
    }
  }
  function yn(t) {
    return t = t.pendingLanes & -1073741825, t !== 0 ? t : t & 1073741824 ? 1073741824 : 0;
  }
  function wn() {
    var t = Br;
    return Br <<= 1, (Br & 4194240) === 0 && (Br = 64), t;
  }
  function bn(t) {
    for (var i = [], w = 0; 31 > w; w++) i.push(t);
    return i;
  }
  function Yi(t, i, w) {
    t.pendingLanes |= i, i !== 536870912 && (t.suspendedLanes = 0, t.pingedLanes = 0), t = t.eventTimes, i = 31 - tr(i), t[i] = w;
  }
  function ya(t, i) {
    var w = t.pendingLanes & ~i;
    t.pendingLanes = i, t.suspendedLanes = 0, t.pingedLanes = 0, t.expiredLanes &= i, t.mutableReadLanes &= i, t.entangledLanes &= i, i = t.entanglements;
    var N = t.eventTimes;
    for (t = t.expirationTimes; 0 < w; ) {
      var ae = 31 - tr(w), ye = 1 << ae;
      i[ae] = 0, N[ae] = -1, t[ae] = -1, w &= ~ye;
    }
  }
  function Xi(t, i) {
    var w = t.entangledLanes |= i;
    for (t = t.entanglements; w; ) {
      var N = 31 - tr(w), ae = 1 << N;
      ae & i | t[N] & i && (t[N] |= i), w &= ~ae;
    }
  }
  var Qt = 0;
  function qi(t) {
    return t &= -t, 1 < t ? 4 < t ? (t & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var Qi, _i, ni, Vt, Qr, Kr = !1, zr = [], Fr = null, oi = null, ui = null, Di = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map(), V = [], Te = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Le(t, i) {
    switch (t) {
      case "focusin":
      case "focusout":
        Fr = null;
        break;
      case "dragenter":
      case "dragleave":
        oi = null;
        break;
      case "mouseover":
      case "mouseout":
        ui = null;
        break;
      case "pointerover":
      case "pointerout":
        Di.delete(i.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        v.delete(i.pointerId);
    }
  }
  function Xe(t, i, w, N, ae, ye) {
    return t === null || t.nativeEvent !== ye ? (t = { blockedOn: i, domEventName: w, eventSystemFlags: N, nativeEvent: ye, targetContainers: [ae] }, i !== null && (i = us(i), i !== null && _i(i)), t) : (t.eventSystemFlags |= N, i = t.targetContainers, ae !== null && i.indexOf(ae) === -1 && i.push(ae), t);
  }
  function at(t, i, w, N, ae) {
    switch (i) {
      case "focusin":
        return Fr = Xe(Fr, t, i, w, N, ae), !0;
      case "dragenter":
        return oi = Xe(oi, t, i, w, N, ae), !0;
      case "mouseover":
        return ui = Xe(ui, t, i, w, N, ae), !0;
      case "pointerover":
        var ye = ae.pointerId;
        return Di.set(ye, Xe(Di.get(ye) || null, t, i, w, N, ae)), !0;
      case "gotpointercapture":
        return ye = ae.pointerId, v.set(ye, Xe(v.get(ye) || null, t, i, w, N, ae)), !0;
    }
    return !1;
  }
  function lt(t) {
    var i = ia(t.target);
    if (i !== null) {
      var w = vt(i);
      if (w !== null) {
        if (i = w.tag, i === 13) {
          if (i = bt(w), i !== null) {
            t.blockedOn = i, Qr(t.priority, function() {
              ni(w);
            });
            return;
          }
        } else if (i === 3 && w.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = w.tag === 3 ? w.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function Et(t) {
    if (t.blockedOn !== null) return !1;
    for (var i = t.targetContainers; 0 < i.length; ) {
      var w = wa(t.domEventName, t.eventSystemFlags, i[0], t.nativeEvent);
      if (w === null) {
        w = t.nativeEvent;
        var N = new w.constructor(w.type, w);
        q = N, w.target.dispatchEvent(N), q = null;
      } else return i = us(w), i !== null && _i(i), t.blockedOn = w, !1;
      i.shift();
    }
    return !0;
  }
  function Tt(t, i, w) {
    Et(t) && w.delete(i);
  }
  function Yt() {
    Kr = !1, Fr !== null && Et(Fr) && (Fr = null), oi !== null && Et(oi) && (oi = null), ui !== null && Et(ui) && (ui = null), Di.forEach(Tt), v.forEach(Tt);
  }
  function zt(t, i) {
    t.blockedOn === i && (t.blockedOn = null, Kr || (Kr = !0, ge.unstable_scheduleCallback(ge.unstable_NormalPriority, Yt)));
  }
  function fr(t) {
    function i(ae) {
      return zt(ae, t);
    }
    if (0 < zr.length) {
      zt(zr[0], t);
      for (var w = 1; w < zr.length; w++) {
        var N = zr[w];
        N.blockedOn === t && (N.blockedOn = null);
      }
    }
    for (Fr !== null && zt(Fr, t), oi !== null && zt(oi, t), ui !== null && zt(ui, t), Di.forEach(i), v.forEach(i), w = 0; w < V.length; w++) N = V[w], N.blockedOn === t && (N.blockedOn = null);
    for (; 0 < V.length && (w = V[0], w.blockedOn === null); ) lt(w), w.blockedOn === null && V.shift();
  }
  var $r = S.ReactCurrentBatchConfig, Ci = !0;
  function Bi(t, i, w, N) {
    var ae = Qt, ye = $r.transition;
    $r.transition = null;
    try {
      Qt = 1, Ai(t, i, w, N);
    } finally {
      Qt = ae, $r.transition = ye;
    }
  }
  function ki(t, i, w, N) {
    var ae = Qt, ye = $r.transition;
    $r.transition = null;
    try {
      Qt = 4, Ai(t, i, w, N);
    } finally {
      Qt = ae, $r.transition = ye;
    }
  }
  function Ai(t, i, w, N) {
    if (Ci) {
      var ae = wa(t, i, w, N);
      if (ae === null) du(t, i, N, yi, w), Le(t, N);
      else if (at(ae, t, i, w, N)) N.stopPropagation();
      else if (Le(t, N), i & 4 && -1 < Te.indexOf(t)) {
        for (; ae !== null; ) {
          var ye = us(ae);
          if (ye !== null && Qi(ye), ye = wa(t, i, w, N), ye === null && du(t, i, N, yi, w), ye === ae) break;
          ae = ye;
        }
        ae !== null && N.stopPropagation();
      } else du(t, i, N, null, w);
    }
  }
  var yi = null;
  function wa(t, i, w, N) {
    if (yi = null, t = K(N), t = ia(t), t !== null) if (i = vt(t), i === null) t = null;
    else if (w = i.tag, w === 13) {
      if (t = bt(i), t !== null) return t;
      t = null;
    } else if (w === 3) {
      if (i.stateNode.current.memoizedState.isDehydrated) return i.tag === 3 ? i.stateNode.containerInfo : null;
      t = null;
    } else i !== t && (t = null);
    return yi = t, null;
  }
  function Yn(t) {
    switch (t) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Gt()) {
          case Bt:
            return 1;
          case or:
            return 4;
          case ar:
          case ur:
            return 16;
          case hr:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ki = null, Qa = null, Xn = null;
  function Ls() {
    if (Xn) return Xn;
    var t, i = Qa, w = i.length, N, ae = "value" in Ki ? Ki.value : Ki.textContent, ye = ae.length;
    for (t = 0; t < w && i[t] === ae[t]; t++) ;
    var ze = w - t;
    for (N = 1; N <= ze && i[w - N] === ae[ye - N]; N++) ;
    return Xn = ae.slice(t, 1 < N ? 1 - N : void 0);
  }
  function qn(t) {
    var i = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && i === 13 && (t = 13)) : t = i, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function ba() {
    return !0;
  }
  function Qn() {
    return !1;
  }
  function Pr(t) {
    function i(w, N, ae, ye, ze) {
      this._reactName = w, this._targetInst = ae, this.type = N, this.nativeEvent = ye, this.target = ze, this.currentTarget = null;
      for (var Qe in t) t.hasOwnProperty(Qe) && (w = t[Qe], this[Qe] = w ? w(ye) : ye[Qe]);
      return this.isDefaultPrevented = (ye.defaultPrevented != null ? ye.defaultPrevented : ye.returnValue === !1) ? ba : Qn, this.isPropagationStopped = Qn, this;
    }
    return de(i.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var w = this.nativeEvent;
      w && (w.preventDefault ? w.preventDefault() : typeof w.returnValue != "unknown" && (w.returnValue = !1), this.isDefaultPrevented = ba);
    }, stopPropagation: function() {
      var w = this.nativeEvent;
      w && (w.stopPropagation ? w.stopPropagation() : typeof w.cancelBubble != "unknown" && (w.cancelBubble = !0), this.isPropagationStopped = ba);
    }, persist: function() {
    }, isPersistent: ba }), i;
  }
  var zi = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(t) {
    return t.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Sa = Pr(zi), wi = de({}, zi, { view: 0, detail: 0 }), Ns = Pr(wi), xr, Ka, un, Fi = de({}, wi, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Ja, button: 0, buttons: 0, relatedTarget: function(t) {
    return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
  }, movementX: function(t) {
    return "movementX" in t ? t.movementX : (t !== un && (un && t.type === "mousemove" ? (xr = t.screenX - un.screenX, Ka = t.screenY - un.screenY) : Ka = xr = 0, un = t), xr);
  }, movementY: function(t) {
    return "movementY" in t ? t.movementY : Ka;
  } }), Ds = Pr(Fi), Ko = de({}, Fi, { dataTransfer: 0 }), $o = Pr(Ko), Jo = de({}, wi, { relatedTarget: 0 }), $a = Pr(Jo), eu = de({}, zi, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), tu = Pr(eu), ru = de({}, zi, { clipboardData: function(t) {
    return "clipboardData" in t ? t.clipboardData : window.clipboardData;
  } }), iu = Pr(ru), ln = de({}, zi, { data: 0 }), Ar = Pr(ln), Bs = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Kn = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, nu = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function zs(t) {
    var i = this.nativeEvent;
    return i.getModifierState ? i.getModifierState(t) : (t = nu[t]) ? !!i[t] : !1;
  }
  function Ja() {
    return zs;
  }
  var Ea = de({}, wi, { key: function(t) {
    if (t.key) {
      var i = Bs[t.key] || t.key;
      if (i !== "Unidentified") return i;
    }
    return t.type === "keypress" ? (t = qn(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? Kn[t.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Ja, charCode: function(t) {
    return t.type === "keypress" ? qn(t) : 0;
  }, keyCode: function(t) {
    return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
  }, which: function(t) {
    return t.type === "keypress" ? qn(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
  } }), Sn = Pr(Ea), Fs = de({}, Fi, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), es = Pr(Fs), er = de({}, wi, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Ja }), ts = Pr(er), Us = de({}, zi, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), js = Pr(Us), Lr = de({}, Fi, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), $i = Pr(Lr), qt = [9, 13, 27, 32], $n = x && "CompositionEvent" in window, sr = null;
  x && "documentMode" in document && (sr = document.documentMode);
  var xa = x && "TextEvent" in window && !sr, Ji = x && (!$n || sr && 8 < sr && 11 >= sr), wr = " ", Ti = !1;
  function Jn(t, i) {
    switch (t) {
      case "keyup":
        return qt.indexOf(i.keyCode) !== -1;
      case "keydown":
        return i.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Hs(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var en = !1;
  function au(t, i) {
    switch (t) {
      case "compositionend":
        return Hs(i);
      case "keypress":
        return i.which !== 32 ? null : (Ti = !0, wr);
      case "textInput":
        return t = i.data, t === wr && Ti ? null : t;
      default:
        return null;
    }
  }
  function bi(t, i) {
    if (en) return t === "compositionend" || !$n && Jn(t, i) ? (t = Ls(), Xn = Qa = Ki = null, en = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(i.ctrlKey || i.altKey || i.metaKey) || i.ctrlKey && i.altKey) {
          if (i.char && 1 < i.char.length) return i.char;
          if (i.which) return String.fromCharCode(i.which);
        }
        return null;
      case "compositionend":
        return Ji && i.locale !== "ko" ? null : i.data;
      default:
        return null;
    }
  }
  var ea = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function En(t) {
    var i = t && t.nodeName && t.nodeName.toLowerCase();
    return i === "input" ? !!ea[t.type] : i === "textarea";
  }
  function Ca(t, i, w, N) {
    Se(N), i = Qs(i, "onChange"), 0 < i.length && (w = new Sa("onChange", "change", null, w, N), t.push({ event: w, listeners: i }));
  }
  var xn = null, Cn = null;
  function Ur(t) {
    yf(t, 0);
  }
  function kn(t) {
    var i = Ma(t);
    if ($e(i)) return t;
  }
  function su(t, i) {
    if (t === "change") return i;
  }
  var Gs = !1;
  if (x) {
    var ta;
    if (x) {
      var ra = "oninput" in document;
      if (!ra) {
        var Vs = document.createElement("div");
        Vs.setAttribute("oninput", "return;"), ra = typeof Vs.oninput == "function";
      }
      ta = ra;
    } else ta = !1;
    Gs = ta && (!document.documentMode || 9 < document.documentMode);
  }
  function An() {
    xn && (xn.detachEvent("onpropertychange", ka), Cn = xn = null);
  }
  function ka(t) {
    if (t.propertyName === "value" && kn(Cn)) {
      var i = [];
      Ca(i, Cn, t, K(t)), O(Ur, i);
    }
  }
  function ou(t, i, w) {
    t === "focusin" ? (An(), xn = i, Cn = w, xn.attachEvent("onpropertychange", ka)) : t === "focusout" && An();
  }
  function uu(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown") return kn(Cn);
  }
  function Ws(t, i) {
    if (t === "click") return kn(i);
  }
  function rs(t, i) {
    if (t === "input" || t === "change") return kn(i);
  }
  function is(t, i) {
    return t === i && (t !== 0 || 1 / t === 1 / i) || t !== t && i !== i;
  }
  var Mr = typeof Object.is == "function" ? Object.is : is;
  function qe(t, i) {
    if (Mr(t, i)) return !0;
    if (typeof t != "object" || t === null || typeof i != "object" || i === null) return !1;
    var w = Object.keys(t), N = Object.keys(i);
    if (w.length !== N.length) return !1;
    for (N = 0; N < w.length; N++) {
      var ae = w[N];
      if (!y.call(i, ae) || !Mr(t[ae], i[ae])) return !1;
    }
    return !0;
  }
  function tt(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function dt(t, i) {
    var w = tt(t);
    t = 0;
    for (var N; w; ) {
      if (w.nodeType === 3) {
        if (N = t + w.textContent.length, t <= i && N >= i) return { node: w, offset: i - t };
        t = N;
      }
      e: {
        for (; w; ) {
          if (w.nextSibling) {
            w = w.nextSibling;
            break e;
          }
          w = w.parentNode;
        }
        w = void 0;
      }
      w = tt(w);
    }
  }
  function mt(t, i) {
    return t && i ? t === i ? !0 : t && t.nodeType === 3 ? !1 : i && i.nodeType === 3 ? mt(t, i.parentNode) : "contains" in t ? t.contains(i) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(i) & 16) : !1 : !1;
  }
  function Ft() {
    for (var t = window, i = We(); i instanceof t.HTMLIFrameElement; ) {
      try {
        var w = typeof i.contentWindow.location.href == "string";
      } catch {
        w = !1;
      }
      if (w) t = i.contentWindow;
      else break;
      i = We(t.document);
    }
    return i;
  }
  function Ut(t) {
    var i = t && t.nodeName && t.nodeName.toLowerCase();
    return i && (i === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || i === "textarea" || t.contentEditable === "true");
  }
  function Wt(t) {
    var i = Ft(), w = t.focusedElem, N = t.selectionRange;
    if (i !== w && w && w.ownerDocument && mt(w.ownerDocument.documentElement, w)) {
      if (N !== null && Ut(w)) {
        if (i = N.start, t = N.end, t === void 0 && (t = i), "selectionStart" in w) w.selectionStart = i, w.selectionEnd = Math.min(t, w.value.length);
        else if (t = (i = w.ownerDocument || document) && i.defaultView || window, t.getSelection) {
          t = t.getSelection();
          var ae = w.textContent.length, ye = Math.min(N.start, ae);
          N = N.end === void 0 ? ye : Math.min(N.end, ae), !t.extend && ye > N && (ae = N, N = ye, ye = ae), ae = dt(w, ye);
          var ze = dt(
            w,
            N
          );
          ae && ze && (t.rangeCount !== 1 || t.anchorNode !== ae.node || t.anchorOffset !== ae.offset || t.focusNode !== ze.node || t.focusOffset !== ze.offset) && (i = i.createRange(), i.setStart(ae.node, ae.offset), t.removeAllRanges(), ye > N ? (t.addRange(i), t.extend(ze.node, ze.offset)) : (i.setEnd(ze.node, ze.offset), t.addRange(i)));
        }
      }
      for (i = [], t = w; t = t.parentNode; ) t.nodeType === 1 && i.push({ element: t, left: t.scrollLeft, top: t.scrollTop });
      for (typeof w.focus == "function" && w.focus(), w = 0; w < i.length; w++) t = i[w], t.element.scrollLeft = t.left, t.element.scrollTop = t.top;
    }
  }
  var rr = x && "documentMode" in document && 11 >= document.documentMode, jr = null, Ui = null, fn = null, Tn = !1;
  function Zs(t, i, w) {
    var N = w.window === w ? w.document : w.nodeType === 9 ? w : w.ownerDocument;
    Tn || jr == null || jr !== We(N) || (N = jr, "selectionStart" in N && Ut(N) ? N = { start: N.selectionStart, end: N.selectionEnd } : (N = (N.ownerDocument && N.ownerDocument.defaultView || window).getSelection(), N = { anchorNode: N.anchorNode, anchorOffset: N.anchorOffset, focusNode: N.focusNode, focusOffset: N.focusOffset }), fn && qe(fn, N) || (fn = N, N = Qs(Ui, "onSelect"), 0 < N.length && (i = new Sa("onSelect", "select", null, i, w), t.push({ event: i, listeners: N }), i.target = jr)));
  }
  function Ys(t, i) {
    var w = {};
    return w[t.toLowerCase()] = i.toLowerCase(), w["Webkit" + t] = "webkit" + i, w["Moz" + t] = "moz" + i, w;
  }
  var Aa = { animationend: Ys("Animation", "AnimationEnd"), animationiteration: Ys("Animation", "AnimationIteration"), animationstart: Ys("Animation", "AnimationStart"), transitionend: Ys("Transition", "TransitionEnd") }, lu = {}, hf = {};
  x && (hf = document.createElement("div").style, "AnimationEvent" in window || (delete Aa.animationend.animation, delete Aa.animationiteration.animation, delete Aa.animationstart.animation), "TransitionEvent" in window || delete Aa.transitionend.transition);
  function Xs(t) {
    if (lu[t]) return lu[t];
    if (!Aa[t]) return t;
    var i = Aa[t], w;
    for (w in i) if (i.hasOwnProperty(w) && w in hf) return lu[t] = i[w];
    return t;
  }
  var cf = Xs("animationend"), df = Xs("animationiteration"), pf = Xs("animationstart"), vf = Xs("transitionend"), mf = /* @__PURE__ */ new Map(), gf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Pn(t, i) {
    mf.set(t, i), _(i, [t]);
  }
  for (var fu = 0; fu < gf.length; fu++) {
    var hu = gf[fu], cd = hu.toLowerCase(), dd = hu[0].toUpperCase() + hu.slice(1);
    Pn(cd, "on" + dd);
  }
  Pn(cf, "onAnimationEnd"), Pn(df, "onAnimationIteration"), Pn(pf, "onAnimationStart"), Pn("dblclick", "onDoubleClick"), Pn("focusin", "onFocus"), Pn("focusout", "onBlur"), Pn(vf, "onTransitionEnd"), P("onMouseEnter", ["mouseout", "mouseover"]), P("onMouseLeave", ["mouseout", "mouseover"]), P("onPointerEnter", ["pointerout", "pointerover"]), P("onPointerLeave", ["pointerout", "pointerover"]), _("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), _("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), _("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), _("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), _("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), _("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var ns = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), pd = new Set("cancel close invalid load scroll toggle".split(" ").concat(ns));
  function _f(t, i, w) {
    var N = t.type || "unknown-event";
    t.currentTarget = w, pt(N, i, void 0, t), t.currentTarget = null;
  }
  function yf(t, i) {
    i = (i & 4) !== 0;
    for (var w = 0; w < t.length; w++) {
      var N = t[w], ae = N.event;
      N = N.listeners;
      e: {
        var ye = void 0;
        if (i) for (var ze = N.length - 1; 0 <= ze; ze--) {
          var Qe = N[ze], rt = Qe.instance, ht = Qe.currentTarget;
          if (Qe = Qe.listener, rt !== ye && ae.isPropagationStopped()) break e;
          _f(ae, Qe, ht), ye = rt;
        }
        else for (ze = 0; ze < N.length; ze++) {
          if (Qe = N[ze], rt = Qe.instance, ht = Qe.currentTarget, Qe = Qe.listener, rt !== ye && ae.isPropagationStopped()) break e;
          _f(ae, Qe, ht), ye = rt;
        }
      }
    }
    if (Ke) throw t = et, Ke = !1, et = null, t;
  }
  function pr(t, i) {
    var w = i[yu];
    w === void 0 && (w = i[yu] = /* @__PURE__ */ new Set());
    var N = t + "__bubble";
    w.has(N) || (wf(i, t, 2, !1), w.add(N));
  }
  function cu(t, i, w) {
    var N = 0;
    i && (N |= 4), wf(w, t, N, i);
  }
  var qs = "_reactListening" + Math.random().toString(36).slice(2);
  function as(t) {
    if (!t[qs]) {
      t[qs] = !0, C.forEach(function(w) {
        w !== "selectionchange" && (pd.has(w) || cu(w, !1, t), cu(w, !0, t));
      });
      var i = t.nodeType === 9 ? t : t.ownerDocument;
      i === null || i[qs] || (i[qs] = !0, cu("selectionchange", !1, i));
    }
  }
  function wf(t, i, w, N) {
    switch (Yn(i)) {
      case 1:
        var ae = Bi;
        break;
      case 4:
        ae = ki;
        break;
      default:
        ae = Ai;
    }
    w = ae.bind(null, i, w, t), ae = void 0, !Oe || i !== "touchstart" && i !== "touchmove" && i !== "wheel" || (ae = !0), N ? ae !== void 0 ? t.addEventListener(i, w, { capture: !0, passive: ae }) : t.addEventListener(i, w, !0) : ae !== void 0 ? t.addEventListener(i, w, { passive: ae }) : t.addEventListener(i, w, !1);
  }
  function du(t, i, w, N, ae) {
    var ye = N;
    if ((i & 1) === 0 && (i & 2) === 0 && N !== null) e: for (; ; ) {
      if (N === null) return;
      var ze = N.tag;
      if (ze === 3 || ze === 4) {
        var Qe = N.stateNode.containerInfo;
        if (Qe === ae || Qe.nodeType === 8 && Qe.parentNode === ae) break;
        if (ze === 4) for (ze = N.return; ze !== null; ) {
          var rt = ze.tag;
          if ((rt === 3 || rt === 4) && (rt = ze.stateNode.containerInfo, rt === ae || rt.nodeType === 8 && rt.parentNode === ae)) return;
          ze = ze.return;
        }
        for (; Qe !== null; ) {
          if (ze = ia(Qe), ze === null) return;
          if (rt = ze.tag, rt === 5 || rt === 6) {
            N = ye = ze;
            continue e;
          }
          Qe = Qe.parentNode;
        }
      }
      N = N.return;
    }
    O(function() {
      var ht = ye, yt = K(w), St = [];
      e: {
        var _t = mf.get(t);
        if (_t !== void 0) {
          var Mt = Sa, Rt = t;
          switch (t) {
            case "keypress":
              if (qn(w) === 0) break e;
            case "keydown":
            case "keyup":
              Mt = Sn;
              break;
            case "focusin":
              Rt = "focus", Mt = $a;
              break;
            case "focusout":
              Rt = "blur", Mt = $a;
              break;
            case "beforeblur":
            case "afterblur":
              Mt = $a;
              break;
            case "click":
              if (w.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Mt = Ds;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Mt = $o;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Mt = ts;
              break;
            case cf:
            case df:
            case pf:
              Mt = tu;
              break;
            case vf:
              Mt = js;
              break;
            case "scroll":
              Mt = Ns;
              break;
            case "wheel":
              Mt = $i;
              break;
            case "copy":
            case "cut":
            case "paste":
              Mt = iu;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Mt = es;
          }
          var Lt = (i & 4) !== 0, Tr = !Lt && t === "scroll", st = Lt ? _t !== null ? _t + "Capture" : null : _t;
          Lt = [];
          for (var it = ht, ut; it !== null; ) {
            ut = it;
            var kt = ut.stateNode;
            if (ut.tag === 5 && kt !== null && (ut = kt, st !== null && (kt = ce(it, st), kt != null && Lt.push(ss(it, kt, ut)))), Tr) break;
            it = it.return;
          }
          0 < Lt.length && (_t = new Mt(_t, Rt, null, w, yt), St.push({ event: _t, listeners: Lt }));
        }
      }
      if ((i & 7) === 0) {
        e: {
          if (_t = t === "mouseover" || t === "pointerover", Mt = t === "mouseout" || t === "pointerout", _t && w !== q && (Rt = w.relatedTarget || w.fromElement) && (ia(Rt) || Rt[hn])) break e;
          if ((Mt || _t) && (_t = yt.window === yt ? yt : (_t = yt.ownerDocument) ? _t.defaultView || _t.parentWindow : window, Mt ? (Rt = w.relatedTarget || w.toElement, Mt = ht, Rt = Rt ? ia(Rt) : null, Rt !== null && (Tr = vt(Rt), Rt !== Tr || Rt.tag !== 5 && Rt.tag !== 6) && (Rt = null)) : (Mt = null, Rt = ht), Mt !== Rt)) {
            if (Lt = Ds, kt = "onMouseLeave", st = "onMouseEnter", it = "mouse", (t === "pointerout" || t === "pointerover") && (Lt = es, kt = "onPointerLeave", st = "onPointerEnter", it = "pointer"), Tr = Mt == null ? _t : Ma(Mt), ut = Rt == null ? _t : Ma(Rt), _t = new Lt(kt, it + "leave", Mt, w, yt), _t.target = Tr, _t.relatedTarget = ut, kt = null, ia(yt) === ht && (Lt = new Lt(st, it + "enter", Rt, w, yt), Lt.target = ut, Lt.relatedTarget = Tr, kt = Lt), Tr = kt, Mt && Rt) t: {
              for (Lt = Mt, st = Rt, it = 0, ut = Lt; ut; ut = Ta(ut)) it++;
              for (ut = 0, kt = st; kt; kt = Ta(kt)) ut++;
              for (; 0 < it - ut; ) Lt = Ta(Lt), it--;
              for (; 0 < ut - it; ) st = Ta(st), ut--;
              for (; it--; ) {
                if (Lt === st || st !== null && Lt === st.alternate) break t;
                Lt = Ta(Lt), st = Ta(st);
              }
              Lt = null;
            }
            else Lt = null;
            Mt !== null && bf(St, _t, Mt, Lt, !1), Rt !== null && Tr !== null && bf(St, Tr, Rt, Lt, !0);
          }
        }
        e: {
          if (_t = ht ? Ma(ht) : window, Mt = _t.nodeName && _t.nodeName.toLowerCase(), Mt === "select" || Mt === "input" && _t.type === "file") var Dt = su;
          else if (En(_t)) if (Gs) Dt = rs;
          else {
            Dt = uu;
            var jt = ou;
          }
          else (Mt = _t.nodeName) && Mt.toLowerCase() === "input" && (_t.type === "checkbox" || _t.type === "radio") && (Dt = Ws);
          if (Dt && (Dt = Dt(t, ht))) {
            Ca(St, Dt, w, yt);
            break e;
          }
          jt && jt(t, _t, ht), t === "focusout" && (jt = _t._wrapperState) && jt.controlled && _t.type === "number" && re(_t, "number", _t.value);
        }
        switch (jt = ht ? Ma(ht) : window, t) {
          case "focusin":
            (En(jt) || jt.contentEditable === "true") && (jr = jt, Ui = ht, fn = null);
            break;
          case "focusout":
            fn = Ui = jr = null;
            break;
          case "mousedown":
            Tn = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Tn = !1, Zs(St, w, yt);
            break;
          case "selectionchange":
            if (rr) break;
          case "keydown":
          case "keyup":
            Zs(St, w, yt);
        }
        var Ht;
        if ($n) e: {
          switch (t) {
            case "compositionstart":
              var Zt = "onCompositionStart";
              break e;
            case "compositionend":
              Zt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Zt = "onCompositionUpdate";
              break e;
          }
          Zt = void 0;
        }
        else en ? Jn(t, w) && (Zt = "onCompositionEnd") : t === "keydown" && w.keyCode === 229 && (Zt = "onCompositionStart");
        Zt && (Ji && w.locale !== "ko" && (en || Zt !== "onCompositionStart" ? Zt === "onCompositionEnd" && en && (Ht = Ls()) : (Ki = yt, Qa = "value" in Ki ? Ki.value : Ki.textContent, en = !0)), jt = Qs(ht, Zt), 0 < jt.length && (Zt = new Ar(Zt, t, null, w, yt), St.push({ event: Zt, listeners: jt }), Ht ? Zt.data = Ht : (Ht = Hs(w), Ht !== null && (Zt.data = Ht)))), (Ht = xa ? au(t, w) : bi(t, w)) && (ht = Qs(ht, "onBeforeInput"), 0 < ht.length && (yt = new Ar("onBeforeInput", "beforeinput", null, w, yt), St.push({ event: yt, listeners: ht }), yt.data = Ht));
      }
      yf(St, i);
    });
  }
  function ss(t, i, w) {
    return { instance: t, listener: i, currentTarget: w };
  }
  function Qs(t, i) {
    for (var w = i + "Capture", N = []; t !== null; ) {
      var ae = t, ye = ae.stateNode;
      ae.tag === 5 && ye !== null && (ae = ye, ye = ce(t, w), ye != null && N.unshift(ss(t, ye, ae)), ye = ce(t, i), ye != null && N.push(ss(t, ye, ae))), t = t.return;
    }
    return N;
  }
  function Ta(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5);
    return t || null;
  }
  function bf(t, i, w, N, ae) {
    for (var ye = i._reactName, ze = []; w !== null && w !== N; ) {
      var Qe = w, rt = Qe.alternate, ht = Qe.stateNode;
      if (rt !== null && rt === N) break;
      Qe.tag === 5 && ht !== null && (Qe = ht, ae ? (rt = ce(w, ye), rt != null && ze.unshift(ss(w, rt, Qe))) : ae || (rt = ce(w, ye), rt != null && ze.push(ss(w, rt, Qe)))), w = w.return;
    }
    ze.length !== 0 && t.push({ event: i, listeners: ze });
  }
  var vd = /\r\n?/g, md = /\u0000|\uFFFD/g;
  function Sf(t) {
    return (typeof t == "string" ? t : "" + t).replace(vd, `
`).replace(md, "");
  }
  function Ks(t, i, w) {
    if (i = Sf(i), Sf(t) !== i && w) throw Error(ne(425));
  }
  function $s() {
  }
  var pu = null, vu = null;
  function mu(t, i) {
    return t === "textarea" || t === "noscript" || typeof i.children == "string" || typeof i.children == "number" || typeof i.dangerouslySetInnerHTML == "object" && i.dangerouslySetInnerHTML !== null && i.dangerouslySetInnerHTML.__html != null;
  }
  var gu = typeof setTimeout == "function" ? setTimeout : void 0, gd = typeof clearTimeout == "function" ? clearTimeout : void 0, Ef = typeof Promise == "function" ? Promise : void 0, _d = typeof queueMicrotask == "function" ? queueMicrotask : typeof Ef < "u" ? function(t) {
    return Ef.resolve(null).then(t).catch(yd);
  } : gu;
  function yd(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function _u(t, i) {
    var w = i, N = 0;
    do {
      var ae = w.nextSibling;
      if (t.removeChild(w), ae && ae.nodeType === 8) if (w = ae.data, w === "/$") {
        if (N === 0) {
          t.removeChild(ae), fr(i);
          return;
        }
        N--;
      } else w !== "$" && w !== "$?" && w !== "$!" || N++;
      w = ae;
    } while (w);
    fr(i);
  }
  function Mn(t) {
    for (; t != null; t = t.nextSibling) {
      var i = t.nodeType;
      if (i === 1 || i === 3) break;
      if (i === 8) {
        if (i = t.data, i === "$" || i === "$!" || i === "$?") break;
        if (i === "/$") return null;
      }
    }
    return t;
  }
  function xf(t) {
    t = t.previousSibling;
    for (var i = 0; t; ) {
      if (t.nodeType === 8) {
        var w = t.data;
        if (w === "$" || w === "$!" || w === "$?") {
          if (i === 0) return t;
          i--;
        } else w === "/$" && i++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  var Pa = Math.random().toString(36).slice(2), tn = "__reactFiber$" + Pa, os = "__reactProps$" + Pa, hn = "__reactContainer$" + Pa, yu = "__reactEvents$" + Pa, wd = "__reactListeners$" + Pa, bd = "__reactHandles$" + Pa;
  function ia(t) {
    var i = t[tn];
    if (i) return i;
    for (var w = t.parentNode; w; ) {
      if (i = w[hn] || w[tn]) {
        if (w = i.alternate, i.child !== null || w !== null && w.child !== null) for (t = xf(t); t !== null; ) {
          if (w = t[tn]) return w;
          t = xf(t);
        }
        return i;
      }
      t = w, w = t.parentNode;
    }
    return null;
  }
  function us(t) {
    return t = t[tn] || t[hn], !t || t.tag !== 5 && t.tag !== 6 && t.tag !== 13 && t.tag !== 3 ? null : t;
  }
  function Ma(t) {
    if (t.tag === 5 || t.tag === 6) return t.stateNode;
    throw Error(ne(33));
  }
  function Js(t) {
    return t[os] || null;
  }
  var wu = [], Ia = -1;
  function In(t) {
    return { current: t };
  }
  function vr(t) {
    0 > Ia || (t.current = wu[Ia], wu[Ia] = null, Ia--);
  }
  function cr(t, i) {
    Ia++, wu[Ia] = t.current, t.current = i;
  }
  var Rn = {}, Jr = In(Rn), li = In(!1), na = Rn;
  function Ra(t, i) {
    var w = t.type.contextTypes;
    if (!w) return Rn;
    var N = t.stateNode;
    if (N && N.__reactInternalMemoizedUnmaskedChildContext === i) return N.__reactInternalMemoizedMaskedChildContext;
    var ae = {}, ye;
    for (ye in w) ae[ye] = i[ye];
    return N && (t = t.stateNode, t.__reactInternalMemoizedUnmaskedChildContext = i, t.__reactInternalMemoizedMaskedChildContext = ae), ae;
  }
  function fi(t) {
    return t = t.childContextTypes, t != null;
  }
  function eo() {
    vr(li), vr(Jr);
  }
  function Cf(t, i, w) {
    if (Jr.current !== Rn) throw Error(ne(168));
    cr(Jr, i), cr(li, w);
  }
  function kf(t, i, w) {
    var N = t.stateNode;
    if (i = i.childContextTypes, typeof N.getChildContext != "function") return w;
    N = N.getChildContext();
    for (var ae in N) if (!(ae in i)) throw Error(ne(108, Ie(t) || "Unknown", ae));
    return de({}, w, N);
  }
  function to(t) {
    return t = (t = t.stateNode) && t.__reactInternalMemoizedMergedChildContext || Rn, na = Jr.current, cr(Jr, t), cr(li, li.current), !0;
  }
  function Af(t, i, w) {
    var N = t.stateNode;
    if (!N) throw Error(ne(169));
    w ? (t = kf(t, i, na), N.__reactInternalMemoizedMergedChildContext = t, vr(li), vr(Jr), cr(Jr, t)) : vr(li), cr(li, w);
  }
  var cn = null, ro = !1, bu = !1;
  function Tf(t) {
    cn === null ? cn = [t] : cn.push(t);
  }
  function Sd(t) {
    ro = !0, Tf(t);
  }
  function On() {
    if (!bu && cn !== null) {
      bu = !0;
      var t = 0, i = Qt;
      try {
        var w = cn;
        for (Qt = 1; t < w.length; t++) {
          var N = w[t];
          do
            N = N(!0);
          while (N !== null);
        }
        cn = null, ro = !1;
      } catch (ae) {
        throw cn !== null && (cn = cn.slice(t + 1)), Ct(Bt, On), ae;
      } finally {
        Qt = i, bu = !1;
      }
    }
    return null;
  }
  var Oa = [], La = 0, io = null, no = 0, Pi = [], Mi = 0, aa = null, dn = 1, pn = "";
  function sa(t, i) {
    Oa[La++] = no, Oa[La++] = io, io = t, no = i;
  }
  function Pf(t, i, w) {
    Pi[Mi++] = dn, Pi[Mi++] = pn, Pi[Mi++] = aa, aa = t;
    var N = dn;
    t = pn;
    var ae = 32 - tr(N) - 1;
    N &= ~(1 << ae), w += 1;
    var ye = 32 - tr(i) + ae;
    if (30 < ye) {
      var ze = ae - ae % 5;
      ye = (N & (1 << ze) - 1).toString(32), N >>= ze, ae -= ze, dn = 1 << 32 - tr(i) + ae | w << ae | N, pn = ye + t;
    } else dn = 1 << ye | w << ae | N, pn = t;
  }
  function Su(t) {
    t.return !== null && (sa(t, 1), Pf(t, 1, 0));
  }
  function Eu(t) {
    for (; t === io; ) io = Oa[--La], Oa[La] = null, no = Oa[--La], Oa[La] = null;
    for (; t === aa; ) aa = Pi[--Mi], Pi[Mi] = null, pn = Pi[--Mi], Pi[Mi] = null, dn = Pi[--Mi], Pi[Mi] = null;
  }
  var Si = null, Ei = null, mr = !1, ji = null;
  function Mf(t, i) {
    var w = Li(5, null, null, 0);
    w.elementType = "DELETED", w.stateNode = i, w.return = t, i = t.deletions, i === null ? (t.deletions = [w], t.flags |= 16) : i.push(w);
  }
  function If(t, i) {
    switch (t.tag) {
      case 5:
        var w = t.type;
        return i = i.nodeType !== 1 || w.toLowerCase() !== i.nodeName.toLowerCase() ? null : i, i !== null ? (t.stateNode = i, Si = t, Ei = Mn(i.firstChild), !0) : !1;
      case 6:
        return i = t.pendingProps === "" || i.nodeType !== 3 ? null : i, i !== null ? (t.stateNode = i, Si = t, Ei = null, !0) : !1;
      case 13:
        return i = i.nodeType !== 8 ? null : i, i !== null ? (w = aa !== null ? { id: dn, overflow: pn } : null, t.memoizedState = { dehydrated: i, treeContext: w, retryLane: 1073741824 }, w = Li(18, null, null, 0), w.stateNode = i, w.return = t, t.child = w, Si = t, Ei = null, !0) : !1;
      default:
        return !1;
    }
  }
  function xu(t) {
    return (t.mode & 1) !== 0 && (t.flags & 128) === 0;
  }
  function Cu(t) {
    if (mr) {
      var i = Ei;
      if (i) {
        var w = i;
        if (!If(t, i)) {
          if (xu(t)) throw Error(ne(418));
          i = Mn(w.nextSibling);
          var N = Si;
          i && If(t, i) ? Mf(N, w) : (t.flags = t.flags & -4097 | 2, mr = !1, Si = t);
        }
      } else {
        if (xu(t)) throw Error(ne(418));
        t.flags = t.flags & -4097 | 2, mr = !1, Si = t;
      }
    }
  }
  function Rf(t) {
    for (t = t.return; t !== null && t.tag !== 5 && t.tag !== 3 && t.tag !== 13; ) t = t.return;
    Si = t;
  }
  function ao(t) {
    if (t !== Si) return !1;
    if (!mr) return Rf(t), mr = !0, !1;
    var i;
    if ((i = t.tag !== 3) && !(i = t.tag !== 5) && (i = t.type, i = i !== "head" && i !== "body" && !mu(t.type, t.memoizedProps)), i && (i = Ei)) {
      if (xu(t)) throw Of(), Error(ne(418));
      for (; i; ) Mf(t, i), i = Mn(i.nextSibling);
    }
    if (Rf(t), t.tag === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(ne(317));
      e: {
        for (t = t.nextSibling, i = 0; t; ) {
          if (t.nodeType === 8) {
            var w = t.data;
            if (w === "/$") {
              if (i === 0) {
                Ei = Mn(t.nextSibling);
                break e;
              }
              i--;
            } else w !== "$" && w !== "$!" && w !== "$?" || i++;
          }
          t = t.nextSibling;
        }
        Ei = null;
      }
    } else Ei = Si ? Mn(t.stateNode.nextSibling) : null;
    return !0;
  }
  function Of() {
    for (var t = Ei; t; ) t = Mn(t.nextSibling);
  }
  function Na() {
    Ei = Si = null, mr = !1;
  }
  function ku(t) {
    ji === null ? ji = [t] : ji.push(t);
  }
  var Ed = S.ReactCurrentBatchConfig;
  function ls(t, i, w) {
    if (t = w.ref, t !== null && typeof t != "function" && typeof t != "object") {
      if (w._owner) {
        if (w = w._owner, w) {
          if (w.tag !== 1) throw Error(ne(309));
          var N = w.stateNode;
        }
        if (!N) throw Error(ne(147, t));
        var ae = N, ye = "" + t;
        return i !== null && i.ref !== null && typeof i.ref == "function" && i.ref._stringRef === ye ? i.ref : (i = function(ze) {
          var Qe = ae.refs;
          ze === null ? delete Qe[ye] : Qe[ye] = ze;
        }, i._stringRef = ye, i);
      }
      if (typeof t != "string") throw Error(ne(284));
      if (!w._owner) throw Error(ne(290, t));
    }
    return t;
  }
  function so(t, i) {
    throw t = Object.prototype.toString.call(i), Error(ne(31, t === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : t));
  }
  function Lf(t) {
    var i = t._init;
    return i(t._payload);
  }
  function Nf(t) {
    function i(st, it) {
      if (t) {
        var ut = st.deletions;
        ut === null ? (st.deletions = [it], st.flags |= 16) : ut.push(it);
      }
    }
    function w(st, it) {
      if (!t) return null;
      for (; it !== null; ) i(st, it), it = it.sibling;
      return null;
    }
    function N(st, it) {
      for (st = /* @__PURE__ */ new Map(); it !== null; ) it.key !== null ? st.set(it.key, it) : st.set(it.index, it), it = it.sibling;
      return st;
    }
    function ae(st, it) {
      return st = jn(st, it), st.index = 0, st.sibling = null, st;
    }
    function ye(st, it, ut) {
      return st.index = ut, t ? (ut = st.alternate, ut !== null ? (ut = ut.index, ut < it ? (st.flags |= 2, it) : ut) : (st.flags |= 2, it)) : (st.flags |= 1048576, it);
    }
    function ze(st) {
      return t && st.alternate === null && (st.flags |= 2), st;
    }
    function Qe(st, it, ut, kt) {
      return it === null || it.tag !== 6 ? (it = gl(ut, st.mode, kt), it.return = st, it) : (it = ae(it, ut), it.return = st, it);
    }
    function rt(st, it, ut, kt) {
      var Dt = ut.type;
      return Dt === A ? yt(st, it, ut.props.children, kt, ut.key) : it !== null && (it.elementType === Dt || typeof Dt == "object" && Dt !== null && Dt.$$typeof === ee && Lf(Dt) === it.type) ? (kt = ae(it, ut.props), kt.ref = ls(st, it, ut), kt.return = st, kt) : (kt = Io(ut.type, ut.key, ut.props, null, st.mode, kt), kt.ref = ls(st, it, ut), kt.return = st, kt);
    }
    function ht(st, it, ut, kt) {
      return it === null || it.tag !== 4 || it.stateNode.containerInfo !== ut.containerInfo || it.stateNode.implementation !== ut.implementation ? (it = _l(ut, st.mode, kt), it.return = st, it) : (it = ae(it, ut.children || []), it.return = st, it);
    }
    function yt(st, it, ut, kt, Dt) {
      return it === null || it.tag !== 7 ? (it = pa(ut, st.mode, kt, Dt), it.return = st, it) : (it = ae(it, ut), it.return = st, it);
    }
    function St(st, it, ut) {
      if (typeof it == "string" && it !== "" || typeof it == "number") return it = gl("" + it, st.mode, ut), it.return = st, it;
      if (typeof it == "object" && it !== null) {
        switch (it.$$typeof) {
          case b:
            return ut = Io(it.type, it.key, it.props, null, st.mode, ut), ut.ref = ls(st, null, it), ut.return = st, ut;
          case o:
            return it = _l(it, st.mode, ut), it.return = st, it;
          case ee:
            var kt = it._init;
            return St(st, kt(it._payload), ut);
        }
        if ($(it) || Q(it)) return it = pa(it, st.mode, ut, null), it.return = st, it;
        so(st, it);
      }
      return null;
    }
    function _t(st, it, ut, kt) {
      var Dt = it !== null ? it.key : null;
      if (typeof ut == "string" && ut !== "" || typeof ut == "number") return Dt !== null ? null : Qe(st, it, "" + ut, kt);
      if (typeof ut == "object" && ut !== null) {
        switch (ut.$$typeof) {
          case b:
            return ut.key === Dt ? rt(st, it, ut, kt) : null;
          case o:
            return ut.key === Dt ? ht(st, it, ut, kt) : null;
          case ee:
            return Dt = ut._init, _t(
              st,
              it,
              Dt(ut._payload),
              kt
            );
        }
        if ($(ut) || Q(ut)) return Dt !== null ? null : yt(st, it, ut, kt, null);
        so(st, ut);
      }
      return null;
    }
    function Mt(st, it, ut, kt, Dt) {
      if (typeof kt == "string" && kt !== "" || typeof kt == "number") return st = st.get(ut) || null, Qe(it, st, "" + kt, Dt);
      if (typeof kt == "object" && kt !== null) {
        switch (kt.$$typeof) {
          case b:
            return st = st.get(kt.key === null ? ut : kt.key) || null, rt(it, st, kt, Dt);
          case o:
            return st = st.get(kt.key === null ? ut : kt.key) || null, ht(it, st, kt, Dt);
          case ee:
            var jt = kt._init;
            return Mt(st, it, ut, jt(kt._payload), Dt);
        }
        if ($(kt) || Q(kt)) return st = st.get(ut) || null, yt(it, st, kt, Dt, null);
        so(it, kt);
      }
      return null;
    }
    function Rt(st, it, ut, kt) {
      for (var Dt = null, jt = null, Ht = it, Zt = it = 0, Vr = null; Ht !== null && Zt < ut.length; Zt++) {
        Ht.index > Zt ? (Vr = Ht, Ht = null) : Vr = Ht.sibling;
        var nr = _t(st, Ht, ut[Zt], kt);
        if (nr === null) {
          Ht === null && (Ht = Vr);
          break;
        }
        t && Ht && nr.alternate === null && i(st, Ht), it = ye(nr, it, Zt), jt === null ? Dt = nr : jt.sibling = nr, jt = nr, Ht = Vr;
      }
      if (Zt === ut.length) return w(st, Ht), mr && sa(st, Zt), Dt;
      if (Ht === null) {
        for (; Zt < ut.length; Zt++) Ht = St(st, ut[Zt], kt), Ht !== null && (it = ye(Ht, it, Zt), jt === null ? Dt = Ht : jt.sibling = Ht, jt = Ht);
        return mr && sa(st, Zt), Dt;
      }
      for (Ht = N(st, Ht); Zt < ut.length; Zt++) Vr = Mt(Ht, st, Zt, ut[Zt], kt), Vr !== null && (t && Vr.alternate !== null && Ht.delete(Vr.key === null ? Zt : Vr.key), it = ye(Vr, it, Zt), jt === null ? Dt = Vr : jt.sibling = Vr, jt = Vr);
      return t && Ht.forEach(function(Hn) {
        return i(st, Hn);
      }), mr && sa(st, Zt), Dt;
    }
    function Lt(st, it, ut, kt) {
      var Dt = Q(ut);
      if (typeof Dt != "function") throw Error(ne(150));
      if (ut = Dt.call(ut), ut == null) throw Error(ne(151));
      for (var jt = Dt = null, Ht = it, Zt = it = 0, Vr = null, nr = ut.next(); Ht !== null && !nr.done; Zt++, nr = ut.next()) {
        Ht.index > Zt ? (Vr = Ht, Ht = null) : Vr = Ht.sibling;
        var Hn = _t(st, Ht, nr.value, kt);
        if (Hn === null) {
          Ht === null && (Ht = Vr);
          break;
        }
        t && Ht && Hn.alternate === null && i(st, Ht), it = ye(Hn, it, Zt), jt === null ? Dt = Hn : jt.sibling = Hn, jt = Hn, Ht = Vr;
      }
      if (nr.done) return w(
        st,
        Ht
      ), mr && sa(st, Zt), Dt;
      if (Ht === null) {
        for (; !nr.done; Zt++, nr = ut.next()) nr = St(st, nr.value, kt), nr !== null && (it = ye(nr, it, Zt), jt === null ? Dt = nr : jt.sibling = nr, jt = nr);
        return mr && sa(st, Zt), Dt;
      }
      for (Ht = N(st, Ht); !nr.done; Zt++, nr = ut.next()) nr = Mt(Ht, st, Zt, nr.value, kt), nr !== null && (t && nr.alternate !== null && Ht.delete(nr.key === null ? Zt : nr.key), it = ye(nr, it, Zt), jt === null ? Dt = nr : jt.sibling = nr, jt = nr);
      return t && Ht.forEach(function(rp) {
        return i(st, rp);
      }), mr && sa(st, Zt), Dt;
    }
    function Tr(st, it, ut, kt) {
      if (typeof ut == "object" && ut !== null && ut.type === A && ut.key === null && (ut = ut.props.children), typeof ut == "object" && ut !== null) {
        switch (ut.$$typeof) {
          case b:
            e: {
              for (var Dt = ut.key, jt = it; jt !== null; ) {
                if (jt.key === Dt) {
                  if (Dt = ut.type, Dt === A) {
                    if (jt.tag === 7) {
                      w(st, jt.sibling), it = ae(jt, ut.props.children), it.return = st, st = it;
                      break e;
                    }
                  } else if (jt.elementType === Dt || typeof Dt == "object" && Dt !== null && Dt.$$typeof === ee && Lf(Dt) === jt.type) {
                    w(st, jt.sibling), it = ae(jt, ut.props), it.ref = ls(st, jt, ut), it.return = st, st = it;
                    break e;
                  }
                  w(st, jt);
                  break;
                } else i(st, jt);
                jt = jt.sibling;
              }
              ut.type === A ? (it = pa(ut.props.children, st.mode, kt, ut.key), it.return = st, st = it) : (kt = Io(ut.type, ut.key, ut.props, null, st.mode, kt), kt.ref = ls(st, it, ut), kt.return = st, st = kt);
            }
            return ze(st);
          case o:
            e: {
              for (jt = ut.key; it !== null; ) {
                if (it.key === jt) if (it.tag === 4 && it.stateNode.containerInfo === ut.containerInfo && it.stateNode.implementation === ut.implementation) {
                  w(st, it.sibling), it = ae(it, ut.children || []), it.return = st, st = it;
                  break e;
                } else {
                  w(st, it);
                  break;
                }
                else i(st, it);
                it = it.sibling;
              }
              it = _l(ut, st.mode, kt), it.return = st, st = it;
            }
            return ze(st);
          case ee:
            return jt = ut._init, Tr(st, it, jt(ut._payload), kt);
        }
        if ($(ut)) return Rt(st, it, ut, kt);
        if (Q(ut)) return Lt(st, it, ut, kt);
        so(st, ut);
      }
      return typeof ut == "string" && ut !== "" || typeof ut == "number" ? (ut = "" + ut, it !== null && it.tag === 6 ? (w(st, it.sibling), it = ae(it, ut), it.return = st, st = it) : (w(st, it), it = gl(ut, st.mode, kt), it.return = st, st = it), ze(st)) : w(st, it);
    }
    return Tr;
  }
  var Da = Nf(!0), Df = Nf(!1), oo = In(null), uo = null, Ba = null, Au = null;
  function Tu() {
    Au = Ba = uo = null;
  }
  function Pu(t) {
    var i = oo.current;
    vr(oo), t._currentValue = i;
  }
  function Mu(t, i, w) {
    for (; t !== null; ) {
      var N = t.alternate;
      if ((t.childLanes & i) !== i ? (t.childLanes |= i, N !== null && (N.childLanes |= i)) : N !== null && (N.childLanes & i) !== i && (N.childLanes |= i), t === w) break;
      t = t.return;
    }
  }
  function za(t, i) {
    uo = t, Au = Ba = null, t = t.dependencies, t !== null && t.firstContext !== null && ((t.lanes & i) !== 0 && (hi = !0), t.firstContext = null);
  }
  function Ii(t) {
    var i = t._currentValue;
    if (Au !== t) if (t = { context: t, memoizedValue: i, next: null }, Ba === null) {
      if (uo === null) throw Error(ne(308));
      Ba = t, uo.dependencies = { lanes: 0, firstContext: t };
    } else Ba = Ba.next = t;
    return i;
  }
  var oa = null;
  function Iu(t) {
    oa === null ? oa = [t] : oa.push(t);
  }
  function Bf(t, i, w, N) {
    var ae = i.interleaved;
    return ae === null ? (w.next = w, Iu(i)) : (w.next = ae.next, ae.next = w), i.interleaved = w, vn(t, N);
  }
  function vn(t, i) {
    t.lanes |= i;
    var w = t.alternate;
    for (w !== null && (w.lanes |= i), w = t, t = t.return; t !== null; ) t.childLanes |= i, w = t.alternate, w !== null && (w.childLanes |= i), w = t, t = t.return;
    return w.tag === 3 ? w.stateNode : null;
  }
  var Ln = !1;
  function Ru(t) {
    t.updateQueue = { baseState: t.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function zf(t, i) {
    t = t.updateQueue, i.updateQueue === t && (i.updateQueue = { baseState: t.baseState, firstBaseUpdate: t.firstBaseUpdate, lastBaseUpdate: t.lastBaseUpdate, shared: t.shared, effects: t.effects });
  }
  function mn(t, i) {
    return { eventTime: t, lane: i, tag: 0, payload: null, callback: null, next: null };
  }
  function Nn(t, i, w) {
    var N = t.updateQueue;
    if (N === null) return null;
    if (N = N.shared, (ir & 2) !== 0) {
      var ae = N.pending;
      return ae === null ? i.next = i : (i.next = ae.next, ae.next = i), N.pending = i, vn(t, w);
    }
    return ae = N.interleaved, ae === null ? (i.next = i, Iu(N)) : (i.next = ae.next, ae.next = i), N.interleaved = i, vn(t, w);
  }
  function lo(t, i, w) {
    if (i = i.updateQueue, i !== null && (i = i.shared, (w & 4194240) !== 0)) {
      var N = i.lanes;
      N &= t.pendingLanes, w |= N, i.lanes = w, Xi(t, w);
    }
  }
  function Ff(t, i) {
    var w = t.updateQueue, N = t.alternate;
    if (N !== null && (N = N.updateQueue, w === N)) {
      var ae = null, ye = null;
      if (w = w.firstBaseUpdate, w !== null) {
        do {
          var ze = { eventTime: w.eventTime, lane: w.lane, tag: w.tag, payload: w.payload, callback: w.callback, next: null };
          ye === null ? ae = ye = ze : ye = ye.next = ze, w = w.next;
        } while (w !== null);
        ye === null ? ae = ye = i : ye = ye.next = i;
      } else ae = ye = i;
      w = { baseState: N.baseState, firstBaseUpdate: ae, lastBaseUpdate: ye, shared: N.shared, effects: N.effects }, t.updateQueue = w;
      return;
    }
    t = w.lastBaseUpdate, t === null ? w.firstBaseUpdate = i : t.next = i, w.lastBaseUpdate = i;
  }
  function fo(t, i, w, N) {
    var ae = t.updateQueue;
    Ln = !1;
    var ye = ae.firstBaseUpdate, ze = ae.lastBaseUpdate, Qe = ae.shared.pending;
    if (Qe !== null) {
      ae.shared.pending = null;
      var rt = Qe, ht = rt.next;
      rt.next = null, ze === null ? ye = ht : ze.next = ht, ze = rt;
      var yt = t.alternate;
      yt !== null && (yt = yt.updateQueue, Qe = yt.lastBaseUpdate, Qe !== ze && (Qe === null ? yt.firstBaseUpdate = ht : Qe.next = ht, yt.lastBaseUpdate = rt));
    }
    if (ye !== null) {
      var St = ae.baseState;
      ze = 0, yt = ht = rt = null, Qe = ye;
      do {
        var _t = Qe.lane, Mt = Qe.eventTime;
        if ((N & _t) === _t) {
          yt !== null && (yt = yt.next = {
            eventTime: Mt,
            lane: 0,
            tag: Qe.tag,
            payload: Qe.payload,
            callback: Qe.callback,
            next: null
          });
          e: {
            var Rt = t, Lt = Qe;
            switch (_t = i, Mt = w, Lt.tag) {
              case 1:
                if (Rt = Lt.payload, typeof Rt == "function") {
                  St = Rt.call(Mt, St, _t);
                  break e;
                }
                St = Rt;
                break e;
              case 3:
                Rt.flags = Rt.flags & -65537 | 128;
              case 0:
                if (Rt = Lt.payload, _t = typeof Rt == "function" ? Rt.call(Mt, St, _t) : Rt, _t == null) break e;
                St = de({}, St, _t);
                break e;
              case 2:
                Ln = !0;
            }
          }
          Qe.callback !== null && Qe.lane !== 0 && (t.flags |= 64, _t = ae.effects, _t === null ? ae.effects = [Qe] : _t.push(Qe));
        } else Mt = { eventTime: Mt, lane: _t, tag: Qe.tag, payload: Qe.payload, callback: Qe.callback, next: null }, yt === null ? (ht = yt = Mt, rt = St) : yt = yt.next = Mt, ze |= _t;
        if (Qe = Qe.next, Qe === null) {
          if (Qe = ae.shared.pending, Qe === null) break;
          _t = Qe, Qe = _t.next, _t.next = null, ae.lastBaseUpdate = _t, ae.shared.pending = null;
        }
      } while (!0);
      if (yt === null && (rt = St), ae.baseState = rt, ae.firstBaseUpdate = ht, ae.lastBaseUpdate = yt, i = ae.shared.interleaved, i !== null) {
        ae = i;
        do
          ze |= ae.lane, ae = ae.next;
        while (ae !== i);
      } else ye === null && (ae.shared.lanes = 0);
      fa |= ze, t.lanes = ze, t.memoizedState = St;
    }
  }
  function Uf(t, i, w) {
    if (t = i.effects, i.effects = null, t !== null) for (i = 0; i < t.length; i++) {
      var N = t[i], ae = N.callback;
      if (ae !== null) {
        if (N.callback = null, N = w, typeof ae != "function") throw Error(ne(191, ae));
        ae.call(N);
      }
    }
  }
  var fs = {}, rn = In(fs), hs = In(fs), cs = In(fs);
  function ua(t) {
    if (t === fs) throw Error(ne(174));
    return t;
  }
  function Ou(t, i) {
    switch (cr(cs, i), cr(hs, t), cr(rn, fs), t = i.nodeType, t) {
      case 9:
      case 11:
        i = (i = i.documentElement) ? i.namespaceURI : r(null, "");
        break;
      default:
        t = t === 8 ? i.parentNode : i, i = t.namespaceURI || null, t = t.tagName, i = r(i, t);
    }
    vr(rn), cr(rn, i);
  }
  function Fa() {
    vr(rn), vr(hs), vr(cs);
  }
  function jf(t) {
    ua(cs.current);
    var i = ua(rn.current), w = r(i, t.type);
    i !== w && (cr(hs, t), cr(rn, w));
  }
  function Lu(t) {
    hs.current === t && (vr(rn), vr(hs));
  }
  var br = In(0);
  function ho(t) {
    for (var i = t; i !== null; ) {
      if (i.tag === 13) {
        var w = i.memoizedState;
        if (w !== null && (w = w.dehydrated, w === null || w.data === "$?" || w.data === "$!")) return i;
      } else if (i.tag === 19 && i.memoizedProps.revealOrder !== void 0) {
        if ((i.flags & 128) !== 0) return i;
      } else if (i.child !== null) {
        i.child.return = i, i = i.child;
        continue;
      }
      if (i === t) break;
      for (; i.sibling === null; ) {
        if (i.return === null || i.return === t) return null;
        i = i.return;
      }
      i.sibling.return = i.return, i = i.sibling;
    }
    return null;
  }
  var Nu = [];
  function Du() {
    for (var t = 0; t < Nu.length; t++) Nu[t]._workInProgressVersionPrimary = null;
    Nu.length = 0;
  }
  var co = S.ReactCurrentDispatcher, Bu = S.ReactCurrentBatchConfig, la = 0, Sr = null, Nr = null, Hr = null, po = !1, ds = !1, ps = 0, xd = 0;
  function ei() {
    throw Error(ne(321));
  }
  function zu(t, i) {
    if (i === null) return !1;
    for (var w = 0; w < i.length && w < t.length; w++) if (!Mr(t[w], i[w])) return !1;
    return !0;
  }
  function Fu(t, i, w, N, ae, ye) {
    if (la = ye, Sr = i, i.memoizedState = null, i.updateQueue = null, i.lanes = 0, co.current = t === null || t.memoizedState === null ? Td : Pd, t = w(N, ae), ds) {
      ye = 0;
      do {
        if (ds = !1, ps = 0, 25 <= ye) throw Error(ne(301));
        ye += 1, Hr = Nr = null, i.updateQueue = null, co.current = Md, t = w(N, ae);
      } while (ds);
    }
    if (co.current = go, i = Nr !== null && Nr.next !== null, la = 0, Hr = Nr = Sr = null, po = !1, i) throw Error(ne(300));
    return t;
  }
  function Uu() {
    var t = ps !== 0;
    return ps = 0, t;
  }
  function nn() {
    var t = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Hr === null ? Sr.memoizedState = Hr = t : Hr = Hr.next = t, Hr;
  }
  function Ri() {
    if (Nr === null) {
      var t = Sr.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = Nr.next;
    var i = Hr === null ? Sr.memoizedState : Hr.next;
    if (i !== null) Hr = i, Nr = t;
    else {
      if (t === null) throw Error(ne(310));
      Nr = t, t = { memoizedState: Nr.memoizedState, baseState: Nr.baseState, baseQueue: Nr.baseQueue, queue: Nr.queue, next: null }, Hr === null ? Sr.memoizedState = Hr = t : Hr = Hr.next = t;
    }
    return Hr;
  }
  function vs(t, i) {
    return typeof i == "function" ? i(t) : i;
  }
  function ju(t) {
    var i = Ri(), w = i.queue;
    if (w === null) throw Error(ne(311));
    w.lastRenderedReducer = t;
    var N = Nr, ae = N.baseQueue, ye = w.pending;
    if (ye !== null) {
      if (ae !== null) {
        var ze = ae.next;
        ae.next = ye.next, ye.next = ze;
      }
      N.baseQueue = ae = ye, w.pending = null;
    }
    if (ae !== null) {
      ye = ae.next, N = N.baseState;
      var Qe = ze = null, rt = null, ht = ye;
      do {
        var yt = ht.lane;
        if ((la & yt) === yt) rt !== null && (rt = rt.next = { lane: 0, action: ht.action, hasEagerState: ht.hasEagerState, eagerState: ht.eagerState, next: null }), N = ht.hasEagerState ? ht.eagerState : t(N, ht.action);
        else {
          var St = {
            lane: yt,
            action: ht.action,
            hasEagerState: ht.hasEagerState,
            eagerState: ht.eagerState,
            next: null
          };
          rt === null ? (Qe = rt = St, ze = N) : rt = rt.next = St, Sr.lanes |= yt, fa |= yt;
        }
        ht = ht.next;
      } while (ht !== null && ht !== ye);
      rt === null ? ze = N : rt.next = Qe, Mr(N, i.memoizedState) || (hi = !0), i.memoizedState = N, i.baseState = ze, i.baseQueue = rt, w.lastRenderedState = N;
    }
    if (t = w.interleaved, t !== null) {
      ae = t;
      do
        ye = ae.lane, Sr.lanes |= ye, fa |= ye, ae = ae.next;
      while (ae !== t);
    } else ae === null && (w.lanes = 0);
    return [i.memoizedState, w.dispatch];
  }
  function Hu(t) {
    var i = Ri(), w = i.queue;
    if (w === null) throw Error(ne(311));
    w.lastRenderedReducer = t;
    var N = w.dispatch, ae = w.pending, ye = i.memoizedState;
    if (ae !== null) {
      w.pending = null;
      var ze = ae = ae.next;
      do
        ye = t(ye, ze.action), ze = ze.next;
      while (ze !== ae);
      Mr(ye, i.memoizedState) || (hi = !0), i.memoizedState = ye, i.baseQueue === null && (i.baseState = ye), w.lastRenderedState = ye;
    }
    return [ye, N];
  }
  function Hf() {
  }
  function Gf(t, i) {
    var w = Sr, N = Ri(), ae = i(), ye = !Mr(N.memoizedState, ae);
    if (ye && (N.memoizedState = ae, hi = !0), N = N.queue, Gu(Zf.bind(null, w, N, t), [t]), N.getSnapshot !== i || ye || Hr !== null && Hr.memoizedState.tag & 1) {
      if (w.flags |= 2048, ms(9, Wf.bind(null, w, N, ae, i), void 0, null), Gr === null) throw Error(ne(349));
      (la & 30) !== 0 || Vf(w, i, ae);
    }
    return ae;
  }
  function Vf(t, i, w) {
    t.flags |= 16384, t = { getSnapshot: i, value: w }, i = Sr.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Sr.updateQueue = i, i.stores = [t]) : (w = i.stores, w === null ? i.stores = [t] : w.push(t));
  }
  function Wf(t, i, w, N) {
    i.value = w, i.getSnapshot = N, Yf(i) && Xf(t);
  }
  function Zf(t, i, w) {
    return w(function() {
      Yf(i) && Xf(t);
    });
  }
  function Yf(t) {
    var i = t.getSnapshot;
    t = t.value;
    try {
      var w = i();
      return !Mr(t, w);
    } catch {
      return !0;
    }
  }
  function Xf(t) {
    var i = vn(t, 1);
    i !== null && Wi(i, t, 1, -1);
  }
  function qf(t) {
    var i = nn();
    return typeof t == "function" && (t = t()), i.memoizedState = i.baseState = t, t = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: vs, lastRenderedState: t }, i.queue = t, t = t.dispatch = Ad.bind(null, Sr, t), [i.memoizedState, t];
  }
  function ms(t, i, w, N) {
    return t = { tag: t, create: i, destroy: w, deps: N, next: null }, i = Sr.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Sr.updateQueue = i, i.lastEffect = t.next = t) : (w = i.lastEffect, w === null ? i.lastEffect = t.next = t : (N = w.next, w.next = t, t.next = N, i.lastEffect = t)), t;
  }
  function Qf() {
    return Ri().memoizedState;
  }
  function vo(t, i, w, N) {
    var ae = nn();
    Sr.flags |= t, ae.memoizedState = ms(1 | i, w, void 0, N === void 0 ? null : N);
  }
  function mo(t, i, w, N) {
    var ae = Ri();
    N = N === void 0 ? null : N;
    var ye = void 0;
    if (Nr !== null) {
      var ze = Nr.memoizedState;
      if (ye = ze.destroy, N !== null && zu(N, ze.deps)) {
        ae.memoizedState = ms(i, w, ye, N);
        return;
      }
    }
    Sr.flags |= t, ae.memoizedState = ms(1 | i, w, ye, N);
  }
  function Kf(t, i) {
    return vo(8390656, 8, t, i);
  }
  function Gu(t, i) {
    return mo(2048, 8, t, i);
  }
  function $f(t, i) {
    return mo(4, 2, t, i);
  }
  function Jf(t, i) {
    return mo(4, 4, t, i);
  }
  function eh(t, i) {
    if (typeof i == "function") return t = t(), i(t), function() {
      i(null);
    };
    if (i != null) return t = t(), i.current = t, function() {
      i.current = null;
    };
  }
  function th(t, i, w) {
    return w = w != null ? w.concat([t]) : null, mo(4, 4, eh.bind(null, i, t), w);
  }
  function Vu() {
  }
  function rh(t, i) {
    var w = Ri();
    i = i === void 0 ? null : i;
    var N = w.memoizedState;
    return N !== null && i !== null && zu(i, N[1]) ? N[0] : (w.memoizedState = [t, i], t);
  }
  function ih(t, i) {
    var w = Ri();
    i = i === void 0 ? null : i;
    var N = w.memoizedState;
    return N !== null && i !== null && zu(i, N[1]) ? N[0] : (t = t(), w.memoizedState = [t, i], t);
  }
  function nh(t, i, w) {
    return (la & 21) === 0 ? (t.baseState && (t.baseState = !1, hi = !0), t.memoizedState = w) : (Mr(w, i) || (w = wn(), Sr.lanes |= w, fa |= w, t.baseState = !0), i);
  }
  function Cd(t, i) {
    var w = Qt;
    Qt = w !== 0 && 4 > w ? w : 4, t(!0);
    var N = Bu.transition;
    Bu.transition = {};
    try {
      t(!1), i();
    } finally {
      Qt = w, Bu.transition = N;
    }
  }
  function ah() {
    return Ri().memoizedState;
  }
  function kd(t, i, w) {
    var N = Fn(t);
    if (w = { lane: N, action: w, hasEagerState: !1, eagerState: null, next: null }, sh(t)) oh(i, w);
    else if (w = Bf(t, i, w, N), w !== null) {
      var ae = si();
      Wi(w, t, N, ae), uh(w, i, N);
    }
  }
  function Ad(t, i, w) {
    var N = Fn(t), ae = { lane: N, action: w, hasEagerState: !1, eagerState: null, next: null };
    if (sh(t)) oh(i, ae);
    else {
      var ye = t.alternate;
      if (t.lanes === 0 && (ye === null || ye.lanes === 0) && (ye = i.lastRenderedReducer, ye !== null)) try {
        var ze = i.lastRenderedState, Qe = ye(ze, w);
        if (ae.hasEagerState = !0, ae.eagerState = Qe, Mr(Qe, ze)) {
          var rt = i.interleaved;
          rt === null ? (ae.next = ae, Iu(i)) : (ae.next = rt.next, rt.next = ae), i.interleaved = ae;
          return;
        }
      } catch {
      } finally {
      }
      w = Bf(t, i, ae, N), w !== null && (ae = si(), Wi(w, t, N, ae), uh(w, i, N));
    }
  }
  function sh(t) {
    var i = t.alternate;
    return t === Sr || i !== null && i === Sr;
  }
  function oh(t, i) {
    ds = po = !0;
    var w = t.pending;
    w === null ? i.next = i : (i.next = w.next, w.next = i), t.pending = i;
  }
  function uh(t, i, w) {
    if ((w & 4194240) !== 0) {
      var N = i.lanes;
      N &= t.pendingLanes, w |= N, i.lanes = w, Xi(t, w);
    }
  }
  var go = { readContext: Ii, useCallback: ei, useContext: ei, useEffect: ei, useImperativeHandle: ei, useInsertionEffect: ei, useLayoutEffect: ei, useMemo: ei, useReducer: ei, useRef: ei, useState: ei, useDebugValue: ei, useDeferredValue: ei, useTransition: ei, useMutableSource: ei, useSyncExternalStore: ei, useId: ei, unstable_isNewReconciler: !1 }, Td = { readContext: Ii, useCallback: function(t, i) {
    return nn().memoizedState = [t, i === void 0 ? null : i], t;
  }, useContext: Ii, useEffect: Kf, useImperativeHandle: function(t, i, w) {
    return w = w != null ? w.concat([t]) : null, vo(
      4194308,
      4,
      eh.bind(null, i, t),
      w
    );
  }, useLayoutEffect: function(t, i) {
    return vo(4194308, 4, t, i);
  }, useInsertionEffect: function(t, i) {
    return vo(4, 2, t, i);
  }, useMemo: function(t, i) {
    var w = nn();
    return i = i === void 0 ? null : i, t = t(), w.memoizedState = [t, i], t;
  }, useReducer: function(t, i, w) {
    var N = nn();
    return i = w !== void 0 ? w(i) : i, N.memoizedState = N.baseState = i, t = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: t, lastRenderedState: i }, N.queue = t, t = t.dispatch = kd.bind(null, Sr, t), [N.memoizedState, t];
  }, useRef: function(t) {
    var i = nn();
    return t = { current: t }, i.memoizedState = t;
  }, useState: qf, useDebugValue: Vu, useDeferredValue: function(t) {
    return nn().memoizedState = t;
  }, useTransition: function() {
    var t = qf(!1), i = t[0];
    return t = Cd.bind(null, t[1]), nn().memoizedState = t, [i, t];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(t, i, w) {
    var N = Sr, ae = nn();
    if (mr) {
      if (w === void 0) throw Error(ne(407));
      w = w();
    } else {
      if (w = i(), Gr === null) throw Error(ne(349));
      (la & 30) !== 0 || Vf(N, i, w);
    }
    ae.memoizedState = w;
    var ye = { value: w, getSnapshot: i };
    return ae.queue = ye, Kf(Zf.bind(
      null,
      N,
      ye,
      t
    ), [t]), N.flags |= 2048, ms(9, Wf.bind(null, N, ye, w, i), void 0, null), w;
  }, useId: function() {
    var t = nn(), i = Gr.identifierPrefix;
    if (mr) {
      var w = pn, N = dn;
      w = (N & ~(1 << 32 - tr(N) - 1)).toString(32) + w, i = ":" + i + "R" + w, w = ps++, 0 < w && (i += "H" + w.toString(32)), i += ":";
    } else w = xd++, i = ":" + i + "r" + w.toString(32) + ":";
    return t.memoizedState = i;
  }, unstable_isNewReconciler: !1 }, Pd = {
    readContext: Ii,
    useCallback: rh,
    useContext: Ii,
    useEffect: Gu,
    useImperativeHandle: th,
    useInsertionEffect: $f,
    useLayoutEffect: Jf,
    useMemo: ih,
    useReducer: ju,
    useRef: Qf,
    useState: function() {
      return ju(vs);
    },
    useDebugValue: Vu,
    useDeferredValue: function(t) {
      var i = Ri();
      return nh(i, Nr.memoizedState, t);
    },
    useTransition: function() {
      var t = ju(vs)[0], i = Ri().memoizedState;
      return [t, i];
    },
    useMutableSource: Hf,
    useSyncExternalStore: Gf,
    useId: ah,
    unstable_isNewReconciler: !1
  }, Md = { readContext: Ii, useCallback: rh, useContext: Ii, useEffect: Gu, useImperativeHandle: th, useInsertionEffect: $f, useLayoutEffect: Jf, useMemo: ih, useReducer: Hu, useRef: Qf, useState: function() {
    return Hu(vs);
  }, useDebugValue: Vu, useDeferredValue: function(t) {
    var i = Ri();
    return Nr === null ? i.memoizedState = t : nh(i, Nr.memoizedState, t);
  }, useTransition: function() {
    var t = Hu(vs)[0], i = Ri().memoizedState;
    return [t, i];
  }, useMutableSource: Hf, useSyncExternalStore: Gf, useId: ah, unstable_isNewReconciler: !1 };
  function Hi(t, i) {
    if (t && t.defaultProps) {
      i = de({}, i), t = t.defaultProps;
      for (var w in t) i[w] === void 0 && (i[w] = t[w]);
      return i;
    }
    return i;
  }
  function Wu(t, i, w, N) {
    i = t.memoizedState, w = w(N, i), w = w == null ? i : de({}, i, w), t.memoizedState = w, t.lanes === 0 && (t.updateQueue.baseState = w);
  }
  var _o = { isMounted: function(t) {
    return (t = t._reactInternals) ? vt(t) === t : !1;
  }, enqueueSetState: function(t, i, w) {
    t = t._reactInternals;
    var N = si(), ae = Fn(t), ye = mn(N, ae);
    ye.payload = i, w != null && (ye.callback = w), i = Nn(t, ye, ae), i !== null && (Wi(i, t, ae, N), lo(i, t, ae));
  }, enqueueReplaceState: function(t, i, w) {
    t = t._reactInternals;
    var N = si(), ae = Fn(t), ye = mn(N, ae);
    ye.tag = 1, ye.payload = i, w != null && (ye.callback = w), i = Nn(t, ye, ae), i !== null && (Wi(i, t, ae, N), lo(i, t, ae));
  }, enqueueForceUpdate: function(t, i) {
    t = t._reactInternals;
    var w = si(), N = Fn(t), ae = mn(w, N);
    ae.tag = 2, i != null && (ae.callback = i), i = Nn(t, ae, N), i !== null && (Wi(i, t, N, w), lo(i, t, N));
  } };
  function lh(t, i, w, N, ae, ye, ze) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(N, ye, ze) : i.prototype && i.prototype.isPureReactComponent ? !qe(w, N) || !qe(ae, ye) : !0;
  }
  function fh(t, i, w) {
    var N = !1, ae = Rn, ye = i.contextType;
    return typeof ye == "object" && ye !== null ? ye = Ii(ye) : (ae = fi(i) ? na : Jr.current, N = i.contextTypes, ye = (N = N != null) ? Ra(t, ae) : Rn), i = new i(w, ye), t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, i.updater = _o, t.stateNode = i, i._reactInternals = t, N && (t = t.stateNode, t.__reactInternalMemoizedUnmaskedChildContext = ae, t.__reactInternalMemoizedMaskedChildContext = ye), i;
  }
  function hh(t, i, w, N) {
    t = i.state, typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps(w, N), typeof i.UNSAFE_componentWillReceiveProps == "function" && i.UNSAFE_componentWillReceiveProps(w, N), i.state !== t && _o.enqueueReplaceState(i, i.state, null);
  }
  function Zu(t, i, w, N) {
    var ae = t.stateNode;
    ae.props = w, ae.state = t.memoizedState, ae.refs = {}, Ru(t);
    var ye = i.contextType;
    typeof ye == "object" && ye !== null ? ae.context = Ii(ye) : (ye = fi(i) ? na : Jr.current, ae.context = Ra(t, ye)), ae.state = t.memoizedState, ye = i.getDerivedStateFromProps, typeof ye == "function" && (Wu(t, i, ye, w), ae.state = t.memoizedState), typeof i.getDerivedStateFromProps == "function" || typeof ae.getSnapshotBeforeUpdate == "function" || typeof ae.UNSAFE_componentWillMount != "function" && typeof ae.componentWillMount != "function" || (i = ae.state, typeof ae.componentWillMount == "function" && ae.componentWillMount(), typeof ae.UNSAFE_componentWillMount == "function" && ae.UNSAFE_componentWillMount(), i !== ae.state && _o.enqueueReplaceState(ae, ae.state, null), fo(t, w, ae, N), ae.state = t.memoizedState), typeof ae.componentDidMount == "function" && (t.flags |= 4194308);
  }
  function Ua(t, i) {
    try {
      var w = "", N = i;
      do
        w += xe(N), N = N.return;
      while (N);
      var ae = w;
    } catch (ye) {
      ae = `
Error generating stack: ` + ye.message + `
` + ye.stack;
    }
    return { value: t, source: i, stack: ae, digest: null };
  }
  function Yu(t, i, w) {
    return { value: t, source: null, stack: w ?? null, digest: i ?? null };
  }
  function Xu(t, i) {
    try {
      console.error(i.value);
    } catch (w) {
      setTimeout(function() {
        throw w;
      });
    }
  }
  var Id = typeof WeakMap == "function" ? WeakMap : Map;
  function ch(t, i, w) {
    w = mn(-1, w), w.tag = 3, w.payload = { element: null };
    var N = i.value;
    return w.callback = function() {
      Co || (Co = !0, ll = N), Xu(t, i);
    }, w;
  }
  function dh(t, i, w) {
    w = mn(-1, w), w.tag = 3;
    var N = t.type.getDerivedStateFromError;
    if (typeof N == "function") {
      var ae = i.value;
      w.payload = function() {
        return N(ae);
      }, w.callback = function() {
        Xu(t, i);
      };
    }
    var ye = t.stateNode;
    return ye !== null && typeof ye.componentDidCatch == "function" && (w.callback = function() {
      Xu(t, i), typeof N != "function" && (Bn === null ? Bn = /* @__PURE__ */ new Set([this]) : Bn.add(this));
      var ze = i.stack;
      this.componentDidCatch(i.value, { componentStack: ze !== null ? ze : "" });
    }), w;
  }
  function ph(t, i, w) {
    var N = t.pingCache;
    if (N === null) {
      N = t.pingCache = new Id();
      var ae = /* @__PURE__ */ new Set();
      N.set(i, ae);
    } else ae = N.get(i), ae === void 0 && (ae = /* @__PURE__ */ new Set(), N.set(i, ae));
    ae.has(w) || (ae.add(w), t = Wd.bind(null, t, i, w), i.then(t, t));
  }
  function vh(t) {
    do {
      var i;
      if ((i = t.tag === 13) && (i = t.memoizedState, i = i !== null ? i.dehydrated !== null : !0), i) return t;
      t = t.return;
    } while (t !== null);
    return null;
  }
  function mh(t, i, w, N, ae) {
    return (t.mode & 1) === 0 ? (t === i ? t.flags |= 65536 : (t.flags |= 128, w.flags |= 131072, w.flags &= -52805, w.tag === 1 && (w.alternate === null ? w.tag = 17 : (i = mn(-1, 1), i.tag = 2, Nn(w, i, 1))), w.lanes |= 1), t) : (t.flags |= 65536, t.lanes = ae, t);
  }
  var Rd = S.ReactCurrentOwner, hi = !1;
  function ai(t, i, w, N) {
    i.child = t === null ? Df(i, null, w, N) : Da(i, t.child, w, N);
  }
  function gh(t, i, w, N, ae) {
    w = w.render;
    var ye = i.ref;
    return za(i, ae), N = Fu(t, i, w, N, ye, ae), w = Uu(), t !== null && !hi ? (i.updateQueue = t.updateQueue, i.flags &= -2053, t.lanes &= ~ae, gn(t, i, ae)) : (mr && w && Su(i), i.flags |= 1, ai(t, i, N, ae), i.child);
  }
  function _h(t, i, w, N, ae) {
    if (t === null) {
      var ye = w.type;
      return typeof ye == "function" && !ml(ye) && ye.defaultProps === void 0 && w.compare === null && w.defaultProps === void 0 ? (i.tag = 15, i.type = ye, yh(t, i, ye, N, ae)) : (t = Io(w.type, null, N, i, i.mode, ae), t.ref = i.ref, t.return = i, i.child = t);
    }
    if (ye = t.child, (t.lanes & ae) === 0) {
      var ze = ye.memoizedProps;
      if (w = w.compare, w = w !== null ? w : qe, w(ze, N) && t.ref === i.ref) return gn(t, i, ae);
    }
    return i.flags |= 1, t = jn(ye, N), t.ref = i.ref, t.return = i, i.child = t;
  }
  function yh(t, i, w, N, ae) {
    if (t !== null) {
      var ye = t.memoizedProps;
      if (qe(ye, N) && t.ref === i.ref) if (hi = !1, i.pendingProps = N = ye, (t.lanes & ae) !== 0) (t.flags & 131072) !== 0 && (hi = !0);
      else return i.lanes = t.lanes, gn(t, i, ae);
    }
    return qu(t, i, w, N, ae);
  }
  function wh(t, i, w) {
    var N = i.pendingProps, ae = N.children, ye = t !== null ? t.memoizedState : null;
    if (N.mode === "hidden") if ((i.mode & 1) === 0) i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, cr(Ha, xi), xi |= w;
    else {
      if ((w & 1073741824) === 0) return t = ye !== null ? ye.baseLanes | w : w, i.lanes = i.childLanes = 1073741824, i.memoizedState = { baseLanes: t, cachePool: null, transitions: null }, i.updateQueue = null, cr(Ha, xi), xi |= t, null;
      i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, N = ye !== null ? ye.baseLanes : w, cr(Ha, xi), xi |= N;
    }
    else ye !== null ? (N = ye.baseLanes | w, i.memoizedState = null) : N = w, cr(Ha, xi), xi |= N;
    return ai(t, i, ae, w), i.child;
  }
  function bh(t, i) {
    var w = i.ref;
    (t === null && w !== null || t !== null && t.ref !== w) && (i.flags |= 512, i.flags |= 2097152);
  }
  function qu(t, i, w, N, ae) {
    var ye = fi(w) ? na : Jr.current;
    return ye = Ra(i, ye), za(i, ae), w = Fu(t, i, w, N, ye, ae), N = Uu(), t !== null && !hi ? (i.updateQueue = t.updateQueue, i.flags &= -2053, t.lanes &= ~ae, gn(t, i, ae)) : (mr && N && Su(i), i.flags |= 1, ai(t, i, w, ae), i.child);
  }
  function Sh(t, i, w, N, ae) {
    if (fi(w)) {
      var ye = !0;
      to(i);
    } else ye = !1;
    if (za(i, ae), i.stateNode === null) wo(t, i), fh(i, w, N), Zu(i, w, N, ae), N = !0;
    else if (t === null) {
      var ze = i.stateNode, Qe = i.memoizedProps;
      ze.props = Qe;
      var rt = ze.context, ht = w.contextType;
      typeof ht == "object" && ht !== null ? ht = Ii(ht) : (ht = fi(w) ? na : Jr.current, ht = Ra(i, ht));
      var yt = w.getDerivedStateFromProps, St = typeof yt == "function" || typeof ze.getSnapshotBeforeUpdate == "function";
      St || typeof ze.UNSAFE_componentWillReceiveProps != "function" && typeof ze.componentWillReceiveProps != "function" || (Qe !== N || rt !== ht) && hh(i, ze, N, ht), Ln = !1;
      var _t = i.memoizedState;
      ze.state = _t, fo(i, N, ze, ae), rt = i.memoizedState, Qe !== N || _t !== rt || li.current || Ln ? (typeof yt == "function" && (Wu(i, w, yt, N), rt = i.memoizedState), (Qe = Ln || lh(i, w, Qe, N, _t, rt, ht)) ? (St || typeof ze.UNSAFE_componentWillMount != "function" && typeof ze.componentWillMount != "function" || (typeof ze.componentWillMount == "function" && ze.componentWillMount(), typeof ze.UNSAFE_componentWillMount == "function" && ze.UNSAFE_componentWillMount()), typeof ze.componentDidMount == "function" && (i.flags |= 4194308)) : (typeof ze.componentDidMount == "function" && (i.flags |= 4194308), i.memoizedProps = N, i.memoizedState = rt), ze.props = N, ze.state = rt, ze.context = ht, N = Qe) : (typeof ze.componentDidMount == "function" && (i.flags |= 4194308), N = !1);
    } else {
      ze = i.stateNode, zf(t, i), Qe = i.memoizedProps, ht = i.type === i.elementType ? Qe : Hi(i.type, Qe), ze.props = ht, St = i.pendingProps, _t = ze.context, rt = w.contextType, typeof rt == "object" && rt !== null ? rt = Ii(rt) : (rt = fi(w) ? na : Jr.current, rt = Ra(i, rt));
      var Mt = w.getDerivedStateFromProps;
      (yt = typeof Mt == "function" || typeof ze.getSnapshotBeforeUpdate == "function") || typeof ze.UNSAFE_componentWillReceiveProps != "function" && typeof ze.componentWillReceiveProps != "function" || (Qe !== St || _t !== rt) && hh(i, ze, N, rt), Ln = !1, _t = i.memoizedState, ze.state = _t, fo(i, N, ze, ae);
      var Rt = i.memoizedState;
      Qe !== St || _t !== Rt || li.current || Ln ? (typeof Mt == "function" && (Wu(i, w, Mt, N), Rt = i.memoizedState), (ht = Ln || lh(i, w, ht, N, _t, Rt, rt) || !1) ? (yt || typeof ze.UNSAFE_componentWillUpdate != "function" && typeof ze.componentWillUpdate != "function" || (typeof ze.componentWillUpdate == "function" && ze.componentWillUpdate(N, Rt, rt), typeof ze.UNSAFE_componentWillUpdate == "function" && ze.UNSAFE_componentWillUpdate(N, Rt, rt)), typeof ze.componentDidUpdate == "function" && (i.flags |= 4), typeof ze.getSnapshotBeforeUpdate == "function" && (i.flags |= 1024)) : (typeof ze.componentDidUpdate != "function" || Qe === t.memoizedProps && _t === t.memoizedState || (i.flags |= 4), typeof ze.getSnapshotBeforeUpdate != "function" || Qe === t.memoizedProps && _t === t.memoizedState || (i.flags |= 1024), i.memoizedProps = N, i.memoizedState = Rt), ze.props = N, ze.state = Rt, ze.context = rt, N = ht) : (typeof ze.componentDidUpdate != "function" || Qe === t.memoizedProps && _t === t.memoizedState || (i.flags |= 4), typeof ze.getSnapshotBeforeUpdate != "function" || Qe === t.memoizedProps && _t === t.memoizedState || (i.flags |= 1024), N = !1);
    }
    return Qu(t, i, w, N, ye, ae);
  }
  function Qu(t, i, w, N, ae, ye) {
    bh(t, i);
    var ze = (i.flags & 128) !== 0;
    if (!N && !ze) return ae && Af(i, w, !1), gn(t, i, ye);
    N = i.stateNode, Rd.current = i;
    var Qe = ze && typeof w.getDerivedStateFromError != "function" ? null : N.render();
    return i.flags |= 1, t !== null && ze ? (i.child = Da(i, t.child, null, ye), i.child = Da(i, null, Qe, ye)) : ai(t, i, Qe, ye), i.memoizedState = N.state, ae && Af(i, w, !0), i.child;
  }
  function Eh(t) {
    var i = t.stateNode;
    i.pendingContext ? Cf(t, i.pendingContext, i.pendingContext !== i.context) : i.context && Cf(t, i.context, !1), Ou(t, i.containerInfo);
  }
  function xh(t, i, w, N, ae) {
    return Na(), ku(ae), i.flags |= 256, ai(t, i, w, N), i.child;
  }
  var Ku = { dehydrated: null, treeContext: null, retryLane: 0 };
  function $u(t) {
    return { baseLanes: t, cachePool: null, transitions: null };
  }
  function Ch(t, i, w) {
    var N = i.pendingProps, ae = br.current, ye = !1, ze = (i.flags & 128) !== 0, Qe;
    if ((Qe = ze) || (Qe = t !== null && t.memoizedState === null ? !1 : (ae & 2) !== 0), Qe ? (ye = !0, i.flags &= -129) : (t === null || t.memoizedState !== null) && (ae |= 1), cr(br, ae & 1), t === null)
      return Cu(i), t = i.memoizedState, t !== null && (t = t.dehydrated, t !== null) ? ((i.mode & 1) === 0 ? i.lanes = 1 : t.data === "$!" ? i.lanes = 8 : i.lanes = 1073741824, null) : (ze = N.children, t = N.fallback, ye ? (N = i.mode, ye = i.child, ze = { mode: "hidden", children: ze }, (N & 1) === 0 && ye !== null ? (ye.childLanes = 0, ye.pendingProps = ze) : ye = Ro(ze, N, 0, null), t = pa(t, N, w, null), ye.return = i, t.return = i, ye.sibling = t, i.child = ye, i.child.memoizedState = $u(w), i.memoizedState = Ku, t) : Ju(i, ze));
    if (ae = t.memoizedState, ae !== null && (Qe = ae.dehydrated, Qe !== null)) return Od(t, i, ze, N, Qe, ae, w);
    if (ye) {
      ye = N.fallback, ze = i.mode, ae = t.child, Qe = ae.sibling;
      var rt = { mode: "hidden", children: N.children };
      return (ze & 1) === 0 && i.child !== ae ? (N = i.child, N.childLanes = 0, N.pendingProps = rt, i.deletions = null) : (N = jn(ae, rt), N.subtreeFlags = ae.subtreeFlags & 14680064), Qe !== null ? ye = jn(Qe, ye) : (ye = pa(ye, ze, w, null), ye.flags |= 2), ye.return = i, N.return = i, N.sibling = ye, i.child = N, N = ye, ye = i.child, ze = t.child.memoizedState, ze = ze === null ? $u(w) : { baseLanes: ze.baseLanes | w, cachePool: null, transitions: ze.transitions }, ye.memoizedState = ze, ye.childLanes = t.childLanes & ~w, i.memoizedState = Ku, N;
    }
    return ye = t.child, t = ye.sibling, N = jn(ye, { mode: "visible", children: N.children }), (i.mode & 1) === 0 && (N.lanes = w), N.return = i, N.sibling = null, t !== null && (w = i.deletions, w === null ? (i.deletions = [t], i.flags |= 16) : w.push(t)), i.child = N, i.memoizedState = null, N;
  }
  function Ju(t, i) {
    return i = Ro({ mode: "visible", children: i }, t.mode, 0, null), i.return = t, t.child = i;
  }
  function yo(t, i, w, N) {
    return N !== null && ku(N), Da(i, t.child, null, w), t = Ju(i, i.pendingProps.children), t.flags |= 2, i.memoizedState = null, t;
  }
  function Od(t, i, w, N, ae, ye, ze) {
    if (w)
      return i.flags & 256 ? (i.flags &= -257, N = Yu(Error(ne(422))), yo(t, i, ze, N)) : i.memoizedState !== null ? (i.child = t.child, i.flags |= 128, null) : (ye = N.fallback, ae = i.mode, N = Ro({ mode: "visible", children: N.children }, ae, 0, null), ye = pa(ye, ae, ze, null), ye.flags |= 2, N.return = i, ye.return = i, N.sibling = ye, i.child = N, (i.mode & 1) !== 0 && Da(i, t.child, null, ze), i.child.memoizedState = $u(ze), i.memoizedState = Ku, ye);
    if ((i.mode & 1) === 0) return yo(t, i, ze, null);
    if (ae.data === "$!") {
      if (N = ae.nextSibling && ae.nextSibling.dataset, N) var Qe = N.dgst;
      return N = Qe, ye = Error(ne(419)), N = Yu(ye, N, void 0), yo(t, i, ze, N);
    }
    if (Qe = (ze & t.childLanes) !== 0, hi || Qe) {
      if (N = Gr, N !== null) {
        switch (ze & -ze) {
          case 4:
            ae = 2;
            break;
          case 16:
            ae = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            ae = 32;
            break;
          case 536870912:
            ae = 268435456;
            break;
          default:
            ae = 0;
        }
        ae = (ae & (N.suspendedLanes | ze)) !== 0 ? 0 : ae, ae !== 0 && ae !== ye.retryLane && (ye.retryLane = ae, vn(t, ae), Wi(N, t, ae, -1));
      }
      return vl(), N = Yu(Error(ne(421))), yo(t, i, ze, N);
    }
    return ae.data === "$?" ? (i.flags |= 128, i.child = t.child, i = Zd.bind(null, t), ae._reactRetry = i, null) : (t = ye.treeContext, Ei = Mn(ae.nextSibling), Si = i, mr = !0, ji = null, t !== null && (Pi[Mi++] = dn, Pi[Mi++] = pn, Pi[Mi++] = aa, dn = t.id, pn = t.overflow, aa = i), i = Ju(i, N.children), i.flags |= 4096, i);
  }
  function kh(t, i, w) {
    t.lanes |= i;
    var N = t.alternate;
    N !== null && (N.lanes |= i), Mu(t.return, i, w);
  }
  function el(t, i, w, N, ae) {
    var ye = t.memoizedState;
    ye === null ? t.memoizedState = { isBackwards: i, rendering: null, renderingStartTime: 0, last: N, tail: w, tailMode: ae } : (ye.isBackwards = i, ye.rendering = null, ye.renderingStartTime = 0, ye.last = N, ye.tail = w, ye.tailMode = ae);
  }
  function Ah(t, i, w) {
    var N = i.pendingProps, ae = N.revealOrder, ye = N.tail;
    if (ai(t, i, N.children, w), N = br.current, (N & 2) !== 0) N = N & 1 | 2, i.flags |= 128;
    else {
      if (t !== null && (t.flags & 128) !== 0) e: for (t = i.child; t !== null; ) {
        if (t.tag === 13) t.memoizedState !== null && kh(t, w, i);
        else if (t.tag === 19) kh(t, w, i);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === i) break e;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === i) break e;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      N &= 1;
    }
    if (cr(br, N), (i.mode & 1) === 0) i.memoizedState = null;
    else switch (ae) {
      case "forwards":
        for (w = i.child, ae = null; w !== null; ) t = w.alternate, t !== null && ho(t) === null && (ae = w), w = w.sibling;
        w = ae, w === null ? (ae = i.child, i.child = null) : (ae = w.sibling, w.sibling = null), el(i, !1, ae, w, ye);
        break;
      case "backwards":
        for (w = null, ae = i.child, i.child = null; ae !== null; ) {
          if (t = ae.alternate, t !== null && ho(t) === null) {
            i.child = ae;
            break;
          }
          t = ae.sibling, ae.sibling = w, w = ae, ae = t;
        }
        el(i, !0, w, null, ye);
        break;
      case "together":
        el(i, !1, null, null, void 0);
        break;
      default:
        i.memoizedState = null;
    }
    return i.child;
  }
  function wo(t, i) {
    (i.mode & 1) === 0 && t !== null && (t.alternate = null, i.alternate = null, i.flags |= 2);
  }
  function gn(t, i, w) {
    if (t !== null && (i.dependencies = t.dependencies), fa |= i.lanes, (w & i.childLanes) === 0) return null;
    if (t !== null && i.child !== t.child) throw Error(ne(153));
    if (i.child !== null) {
      for (t = i.child, w = jn(t, t.pendingProps), i.child = w, w.return = i; t.sibling !== null; ) t = t.sibling, w = w.sibling = jn(t, t.pendingProps), w.return = i;
      w.sibling = null;
    }
    return i.child;
  }
  function Ld(t, i, w) {
    switch (i.tag) {
      case 3:
        Eh(i), Na();
        break;
      case 5:
        jf(i);
        break;
      case 1:
        fi(i.type) && to(i);
        break;
      case 4:
        Ou(i, i.stateNode.containerInfo);
        break;
      case 10:
        var N = i.type._context, ae = i.memoizedProps.value;
        cr(oo, N._currentValue), N._currentValue = ae;
        break;
      case 13:
        if (N = i.memoizedState, N !== null)
          return N.dehydrated !== null ? (cr(br, br.current & 1), i.flags |= 128, null) : (w & i.child.childLanes) !== 0 ? Ch(t, i, w) : (cr(br, br.current & 1), t = gn(t, i, w), t !== null ? t.sibling : null);
        cr(br, br.current & 1);
        break;
      case 19:
        if (N = (w & i.childLanes) !== 0, (t.flags & 128) !== 0) {
          if (N) return Ah(t, i, w);
          i.flags |= 128;
        }
        if (ae = i.memoizedState, ae !== null && (ae.rendering = null, ae.tail = null, ae.lastEffect = null), cr(br, br.current), N) break;
        return null;
      case 22:
      case 23:
        return i.lanes = 0, wh(t, i, w);
    }
    return gn(t, i, w);
  }
  var Th, tl, Ph, Mh;
  Th = function(t, i) {
    for (var w = i.child; w !== null; ) {
      if (w.tag === 5 || w.tag === 6) t.appendChild(w.stateNode);
      else if (w.tag !== 4 && w.child !== null) {
        w.child.return = w, w = w.child;
        continue;
      }
      if (w === i) break;
      for (; w.sibling === null; ) {
        if (w.return === null || w.return === i) return;
        w = w.return;
      }
      w.sibling.return = w.return, w = w.sibling;
    }
  }, tl = function() {
  }, Ph = function(t, i, w, N) {
    var ae = t.memoizedProps;
    if (ae !== N) {
      t = i.stateNode, ua(rn.current);
      var ye = null;
      switch (w) {
        case "input":
          ae = Ve(t, ae), N = Ve(t, N), ye = [];
          break;
        case "select":
          ae = de({}, ae, { value: void 0 }), N = de({}, N, { value: void 0 }), ye = [];
          break;
        case "textarea":
          ae = ve(t, ae), N = ve(t, N), ye = [];
          break;
        default:
          typeof ae.onClick != "function" && typeof N.onClick == "function" && (t.onclick = $s);
      }
      pe(w, N);
      var ze;
      w = null;
      for (ht in ae) if (!N.hasOwnProperty(ht) && ae.hasOwnProperty(ht) && ae[ht] != null) if (ht === "style") {
        var Qe = ae[ht];
        for (ze in Qe) Qe.hasOwnProperty(ze) && (w || (w = {}), w[ze] = "");
      } else ht !== "dangerouslySetInnerHTML" && ht !== "children" && ht !== "suppressContentEditableWarning" && ht !== "suppressHydrationWarning" && ht !== "autoFocus" && (Z.hasOwnProperty(ht) ? ye || (ye = []) : (ye = ye || []).push(ht, null));
      for (ht in N) {
        var rt = N[ht];
        if (Qe = ae != null ? ae[ht] : void 0, N.hasOwnProperty(ht) && rt !== Qe && (rt != null || Qe != null)) if (ht === "style") if (Qe) {
          for (ze in Qe) !Qe.hasOwnProperty(ze) || rt && rt.hasOwnProperty(ze) || (w || (w = {}), w[ze] = "");
          for (ze in rt) rt.hasOwnProperty(ze) && Qe[ze] !== rt[ze] && (w || (w = {}), w[ze] = rt[ze]);
        } else w || (ye || (ye = []), ye.push(
          ht,
          w
        )), w = rt;
        else ht === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, Qe = Qe ? Qe.__html : void 0, rt != null && Qe !== rt && (ye = ye || []).push(ht, rt)) : ht === "children" ? typeof rt != "string" && typeof rt != "number" || (ye = ye || []).push(ht, "" + rt) : ht !== "suppressContentEditableWarning" && ht !== "suppressHydrationWarning" && (Z.hasOwnProperty(ht) ? (rt != null && ht === "onScroll" && pr("scroll", t), ye || Qe === rt || (ye = [])) : (ye = ye || []).push(ht, rt));
      }
      w && (ye = ye || []).push("style", w);
      var ht = ye;
      (i.updateQueue = ht) && (i.flags |= 4);
    }
  }, Mh = function(t, i, w, N) {
    w !== N && (i.flags |= 4);
  };
  function gs(t, i) {
    if (!mr) switch (t.tailMode) {
      case "hidden":
        i = t.tail;
        for (var w = null; i !== null; ) i.alternate !== null && (w = i), i = i.sibling;
        w === null ? t.tail = null : w.sibling = null;
        break;
      case "collapsed":
        w = t.tail;
        for (var N = null; w !== null; ) w.alternate !== null && (N = w), w = w.sibling;
        N === null ? i || t.tail === null ? t.tail = null : t.tail.sibling = null : N.sibling = null;
    }
  }
  function ti(t) {
    var i = t.alternate !== null && t.alternate.child === t.child, w = 0, N = 0;
    if (i) for (var ae = t.child; ae !== null; ) w |= ae.lanes | ae.childLanes, N |= ae.subtreeFlags & 14680064, N |= ae.flags & 14680064, ae.return = t, ae = ae.sibling;
    else for (ae = t.child; ae !== null; ) w |= ae.lanes | ae.childLanes, N |= ae.subtreeFlags, N |= ae.flags, ae.return = t, ae = ae.sibling;
    return t.subtreeFlags |= N, t.childLanes = w, i;
  }
  function Nd(t, i, w) {
    var N = i.pendingProps;
    switch (Eu(i), i.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ti(i), null;
      case 1:
        return fi(i.type) && eo(), ti(i), null;
      case 3:
        return N = i.stateNode, Fa(), vr(li), vr(Jr), Du(), N.pendingContext && (N.context = N.pendingContext, N.pendingContext = null), (t === null || t.child === null) && (ao(i) ? i.flags |= 4 : t === null || t.memoizedState.isDehydrated && (i.flags & 256) === 0 || (i.flags |= 1024, ji !== null && (cl(ji), ji = null))), tl(t, i), ti(i), null;
      case 5:
        Lu(i);
        var ae = ua(cs.current);
        if (w = i.type, t !== null && i.stateNode != null) Ph(t, i, w, N, ae), t.ref !== i.ref && (i.flags |= 512, i.flags |= 2097152);
        else {
          if (!N) {
            if (i.stateNode === null) throw Error(ne(166));
            return ti(i), null;
          }
          if (t = ua(rn.current), ao(i)) {
            N = i.stateNode, w = i.type;
            var ye = i.memoizedProps;
            switch (N[tn] = i, N[os] = ye, t = (i.mode & 1) !== 0, w) {
              case "dialog":
                pr("cancel", N), pr("close", N);
                break;
              case "iframe":
              case "object":
              case "embed":
                pr("load", N);
                break;
              case "video":
              case "audio":
                for (ae = 0; ae < ns.length; ae++) pr(ns[ae], N);
                break;
              case "source":
                pr("error", N);
                break;
              case "img":
              case "image":
              case "link":
                pr(
                  "error",
                  N
                ), pr("load", N);
                break;
              case "details":
                pr("toggle", N);
                break;
              case "input":
                Re(N, ye), pr("invalid", N);
                break;
              case "select":
                N._wrapperState = { wasMultiple: !!ye.multiple }, pr("invalid", N);
                break;
              case "textarea":
                Y(N, ye), pr("invalid", N);
            }
            pe(w, ye), ae = null;
            for (var ze in ye) if (ye.hasOwnProperty(ze)) {
              var Qe = ye[ze];
              ze === "children" ? typeof Qe == "string" ? N.textContent !== Qe && (ye.suppressHydrationWarning !== !0 && Ks(N.textContent, Qe, t), ae = ["children", Qe]) : typeof Qe == "number" && N.textContent !== "" + Qe && (ye.suppressHydrationWarning !== !0 && Ks(
                N.textContent,
                Qe,
                t
              ), ae = ["children", "" + Qe]) : Z.hasOwnProperty(ze) && Qe != null && ze === "onScroll" && pr("scroll", N);
            }
            switch (w) {
              case "input":
                Ze(N), we(N, ye, !0);
                break;
              case "textarea":
                Ze(N), Ae(N);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof ye.onClick == "function" && (N.onclick = $s);
            }
            N = ae, i.updateQueue = N, N !== null && (i.flags |= 4);
          } else {
            ze = ae.nodeType === 9 ? ae : ae.ownerDocument, t === "http://www.w3.org/1999/xhtml" && (t = e(w)), t === "http://www.w3.org/1999/xhtml" ? w === "script" ? (t = ze.createElement("div"), t.innerHTML = "<script><\/script>", t = t.removeChild(t.firstChild)) : typeof N.is == "string" ? t = ze.createElement(w, { is: N.is }) : (t = ze.createElement(w), w === "select" && (ze = t, N.multiple ? ze.multiple = !0 : N.size && (ze.size = N.size))) : t = ze.createElementNS(t, w), t[tn] = i, t[os] = N, Th(t, i, !1, !1), i.stateNode = t;
            e: {
              switch (ze = M(w, N), w) {
                case "dialog":
                  pr("cancel", t), pr("close", t), ae = N;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  pr("load", t), ae = N;
                  break;
                case "video":
                case "audio":
                  for (ae = 0; ae < ns.length; ae++) pr(ns[ae], t);
                  ae = N;
                  break;
                case "source":
                  pr("error", t), ae = N;
                  break;
                case "img":
                case "image":
                case "link":
                  pr(
                    "error",
                    t
                  ), pr("load", t), ae = N;
                  break;
                case "details":
                  pr("toggle", t), ae = N;
                  break;
                case "input":
                  Re(t, N), ae = Ve(t, N), pr("invalid", t);
                  break;
                case "option":
                  ae = N;
                  break;
                case "select":
                  t._wrapperState = { wasMultiple: !!N.multiple }, ae = de({}, N, { value: void 0 }), pr("invalid", t);
                  break;
                case "textarea":
                  Y(t, N), ae = ve(t, N), pr("invalid", t);
                  break;
                default:
                  ae = N;
              }
              pe(w, ae), Qe = ae;
              for (ye in Qe) if (Qe.hasOwnProperty(ye)) {
                var rt = Qe[ye];
                ye === "style" ? X(t, rt) : ye === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, rt != null && k(t, rt)) : ye === "children" ? typeof rt == "string" ? (w !== "textarea" || rt !== "") && I(t, rt) : typeof rt == "number" && I(t, "" + rt) : ye !== "suppressContentEditableWarning" && ye !== "suppressHydrationWarning" && ye !== "autoFocus" && (Z.hasOwnProperty(ye) ? rt != null && ye === "onScroll" && pr("scroll", t) : rt != null && s(t, ye, rt, ze));
              }
              switch (w) {
                case "input":
                  Ze(t), we(t, N, !1);
                  break;
                case "textarea":
                  Ze(t), Ae(t);
                  break;
                case "option":
                  N.value != null && t.setAttribute("value", "" + je(N.value));
                  break;
                case "select":
                  t.multiple = !!N.multiple, ye = N.value, ye != null ? Ce(t, !!N.multiple, ye, !1) : N.defaultValue != null && Ce(
                    t,
                    !!N.multiple,
                    N.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof ae.onClick == "function" && (t.onclick = $s);
              }
              switch (w) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  N = !!N.autoFocus;
                  break e;
                case "img":
                  N = !0;
                  break e;
                default:
                  N = !1;
              }
            }
            N && (i.flags |= 4);
          }
          i.ref !== null && (i.flags |= 512, i.flags |= 2097152);
        }
        return ti(i), null;
      case 6:
        if (t && i.stateNode != null) Mh(t, i, t.memoizedProps, N);
        else {
          if (typeof N != "string" && i.stateNode === null) throw Error(ne(166));
          if (w = ua(cs.current), ua(rn.current), ao(i)) {
            if (N = i.stateNode, w = i.memoizedProps, N[tn] = i, (ye = N.nodeValue !== w) && (t = Si, t !== null)) switch (t.tag) {
              case 3:
                Ks(N.nodeValue, w, (t.mode & 1) !== 0);
                break;
              case 5:
                t.memoizedProps.suppressHydrationWarning !== !0 && Ks(N.nodeValue, w, (t.mode & 1) !== 0);
            }
            ye && (i.flags |= 4);
          } else N = (w.nodeType === 9 ? w : w.ownerDocument).createTextNode(N), N[tn] = i, i.stateNode = N;
        }
        return ti(i), null;
      case 13:
        if (vr(br), N = i.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (mr && Ei !== null && (i.mode & 1) !== 0 && (i.flags & 128) === 0) Of(), Na(), i.flags |= 98560, ye = !1;
          else if (ye = ao(i), N !== null && N.dehydrated !== null) {
            if (t === null) {
              if (!ye) throw Error(ne(318));
              if (ye = i.memoizedState, ye = ye !== null ? ye.dehydrated : null, !ye) throw Error(ne(317));
              ye[tn] = i;
            } else Na(), (i.flags & 128) === 0 && (i.memoizedState = null), i.flags |= 4;
            ti(i), ye = !1;
          } else ji !== null && (cl(ji), ji = null), ye = !0;
          if (!ye) return i.flags & 65536 ? i : null;
        }
        return (i.flags & 128) !== 0 ? (i.lanes = w, i) : (N = N !== null, N !== (t !== null && t.memoizedState !== null) && N && (i.child.flags |= 8192, (i.mode & 1) !== 0 && (t === null || (br.current & 1) !== 0 ? Dr === 0 && (Dr = 3) : vl())), i.updateQueue !== null && (i.flags |= 4), ti(i), null);
      case 4:
        return Fa(), tl(t, i), t === null && as(i.stateNode.containerInfo), ti(i), null;
      case 10:
        return Pu(i.type._context), ti(i), null;
      case 17:
        return fi(i.type) && eo(), ti(i), null;
      case 19:
        if (vr(br), ye = i.memoizedState, ye === null) return ti(i), null;
        if (N = (i.flags & 128) !== 0, ze = ye.rendering, ze === null) if (N) gs(ye, !1);
        else {
          if (Dr !== 0 || t !== null && (t.flags & 128) !== 0) for (t = i.child; t !== null; ) {
            if (ze = ho(t), ze !== null) {
              for (i.flags |= 128, gs(ye, !1), N = ze.updateQueue, N !== null && (i.updateQueue = N, i.flags |= 4), i.subtreeFlags = 0, N = w, w = i.child; w !== null; ) ye = w, t = N, ye.flags &= 14680066, ze = ye.alternate, ze === null ? (ye.childLanes = 0, ye.lanes = t, ye.child = null, ye.subtreeFlags = 0, ye.memoizedProps = null, ye.memoizedState = null, ye.updateQueue = null, ye.dependencies = null, ye.stateNode = null) : (ye.childLanes = ze.childLanes, ye.lanes = ze.lanes, ye.child = ze.child, ye.subtreeFlags = 0, ye.deletions = null, ye.memoizedProps = ze.memoizedProps, ye.memoizedState = ze.memoizedState, ye.updateQueue = ze.updateQueue, ye.type = ze.type, t = ze.dependencies, ye.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }), w = w.sibling;
              return cr(br, br.current & 1 | 2), i.child;
            }
            t = t.sibling;
          }
          ye.tail !== null && Pt() > Ga && (i.flags |= 128, N = !0, gs(ye, !1), i.lanes = 4194304);
        }
        else {
          if (!N) if (t = ho(ze), t !== null) {
            if (i.flags |= 128, N = !0, w = t.updateQueue, w !== null && (i.updateQueue = w, i.flags |= 4), gs(ye, !0), ye.tail === null && ye.tailMode === "hidden" && !ze.alternate && !mr) return ti(i), null;
          } else 2 * Pt() - ye.renderingStartTime > Ga && w !== 1073741824 && (i.flags |= 128, N = !0, gs(ye, !1), i.lanes = 4194304);
          ye.isBackwards ? (ze.sibling = i.child, i.child = ze) : (w = ye.last, w !== null ? w.sibling = ze : i.child = ze, ye.last = ze);
        }
        return ye.tail !== null ? (i = ye.tail, ye.rendering = i, ye.tail = i.sibling, ye.renderingStartTime = Pt(), i.sibling = null, w = br.current, cr(br, N ? w & 1 | 2 : w & 1), i) : (ti(i), null);
      case 22:
      case 23:
        return pl(), N = i.memoizedState !== null, t !== null && t.memoizedState !== null !== N && (i.flags |= 8192), N && (i.mode & 1) !== 0 ? (xi & 1073741824) !== 0 && (ti(i), i.subtreeFlags & 6 && (i.flags |= 8192)) : ti(i), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(ne(156, i.tag));
  }
  function Dd(t, i) {
    switch (Eu(i), i.tag) {
      case 1:
        return fi(i.type) && eo(), t = i.flags, t & 65536 ? (i.flags = t & -65537 | 128, i) : null;
      case 3:
        return Fa(), vr(li), vr(Jr), Du(), t = i.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (i.flags = t & -65537 | 128, i) : null;
      case 5:
        return Lu(i), null;
      case 13:
        if (vr(br), t = i.memoizedState, t !== null && t.dehydrated !== null) {
          if (i.alternate === null) throw Error(ne(340));
          Na();
        }
        return t = i.flags, t & 65536 ? (i.flags = t & -65537 | 128, i) : null;
      case 19:
        return vr(br), null;
      case 4:
        return Fa(), null;
      case 10:
        return Pu(i.type._context), null;
      case 22:
      case 23:
        return pl(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var bo = !1, ri = !1, Bd = typeof WeakSet == "function" ? WeakSet : Set, It = null;
  function ja(t, i) {
    var w = t.ref;
    if (w !== null) if (typeof w == "function") try {
      w(null);
    } catch (N) {
      Cr(t, i, N);
    }
    else w.current = null;
  }
  function rl(t, i, w) {
    try {
      w();
    } catch (N) {
      Cr(t, i, N);
    }
  }
  var Ih = !1;
  function zd(t, i) {
    if (pu = Ci, t = Ft(), Ut(t)) {
      if ("selectionStart" in t) var w = { start: t.selectionStart, end: t.selectionEnd };
      else e: {
        w = (w = t.ownerDocument) && w.defaultView || window;
        var N = w.getSelection && w.getSelection();
        if (N && N.rangeCount !== 0) {
          w = N.anchorNode;
          var ae = N.anchorOffset, ye = N.focusNode;
          N = N.focusOffset;
          try {
            w.nodeType, ye.nodeType;
          } catch {
            w = null;
            break e;
          }
          var ze = 0, Qe = -1, rt = -1, ht = 0, yt = 0, St = t, _t = null;
          t: for (; ; ) {
            for (var Mt; St !== w || ae !== 0 && St.nodeType !== 3 || (Qe = ze + ae), St !== ye || N !== 0 && St.nodeType !== 3 || (rt = ze + N), St.nodeType === 3 && (ze += St.nodeValue.length), (Mt = St.firstChild) !== null; )
              _t = St, St = Mt;
            for (; ; ) {
              if (St === t) break t;
              if (_t === w && ++ht === ae && (Qe = ze), _t === ye && ++yt === N && (rt = ze), (Mt = St.nextSibling) !== null) break;
              St = _t, _t = St.parentNode;
            }
            St = Mt;
          }
          w = Qe === -1 || rt === -1 ? null : { start: Qe, end: rt };
        } else w = null;
      }
      w = w || { start: 0, end: 0 };
    } else w = null;
    for (vu = { focusedElem: t, selectionRange: w }, Ci = !1, It = i; It !== null; ) if (i = It, t = i.child, (i.subtreeFlags & 1028) !== 0 && t !== null) t.return = i, It = t;
    else for (; It !== null; ) {
      i = It;
      try {
        var Rt = i.alternate;
        if ((i.flags & 1024) !== 0) switch (i.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Rt !== null) {
              var Lt = Rt.memoizedProps, Tr = Rt.memoizedState, st = i.stateNode, it = st.getSnapshotBeforeUpdate(i.elementType === i.type ? Lt : Hi(i.type, Lt), Tr);
              st.__reactInternalSnapshotBeforeUpdate = it;
            }
            break;
          case 3:
            var ut = i.stateNode.containerInfo;
            ut.nodeType === 1 ? ut.textContent = "" : ut.nodeType === 9 && ut.documentElement && ut.removeChild(ut.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(ne(163));
        }
      } catch (kt) {
        Cr(i, i.return, kt);
      }
      if (t = i.sibling, t !== null) {
        t.return = i.return, It = t;
        break;
      }
      It = i.return;
    }
    return Rt = Ih, Ih = !1, Rt;
  }
  function _s(t, i, w) {
    var N = i.updateQueue;
    if (N = N !== null ? N.lastEffect : null, N !== null) {
      var ae = N = N.next;
      do {
        if ((ae.tag & t) === t) {
          var ye = ae.destroy;
          ae.destroy = void 0, ye !== void 0 && rl(i, w, ye);
        }
        ae = ae.next;
      } while (ae !== N);
    }
  }
  function So(t, i) {
    if (i = i.updateQueue, i = i !== null ? i.lastEffect : null, i !== null) {
      var w = i = i.next;
      do {
        if ((w.tag & t) === t) {
          var N = w.create;
          w.destroy = N();
        }
        w = w.next;
      } while (w !== i);
    }
  }
  function il(t) {
    var i = t.ref;
    if (i !== null) {
      var w = t.stateNode;
      switch (t.tag) {
        case 5:
          t = w;
          break;
        default:
          t = w;
      }
      typeof i == "function" ? i(t) : i.current = t;
    }
  }
  function Rh(t) {
    var i = t.alternate;
    i !== null && (t.alternate = null, Rh(i)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (i = t.stateNode, i !== null && (delete i[tn], delete i[os], delete i[yu], delete i[wd], delete i[bd])), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  function Oh(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 4;
  }
  function Lh(t) {
    e: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || Oh(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.flags & 2 || t.child === null || t.tag === 4) continue e;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function nl(t, i, w) {
    var N = t.tag;
    if (N === 5 || N === 6) t = t.stateNode, i ? w.nodeType === 8 ? w.parentNode.insertBefore(t, i) : w.insertBefore(t, i) : (w.nodeType === 8 ? (i = w.parentNode, i.insertBefore(t, w)) : (i = w, i.appendChild(t)), w = w._reactRootContainer, w != null || i.onclick !== null || (i.onclick = $s));
    else if (N !== 4 && (t = t.child, t !== null)) for (nl(t, i, w), t = t.sibling; t !== null; ) nl(t, i, w), t = t.sibling;
  }
  function al(t, i, w) {
    var N = t.tag;
    if (N === 5 || N === 6) t = t.stateNode, i ? w.insertBefore(t, i) : w.appendChild(t);
    else if (N !== 4 && (t = t.child, t !== null)) for (al(t, i, w), t = t.sibling; t !== null; ) al(t, i, w), t = t.sibling;
  }
  var Zr = null, Gi = !1;
  function Dn(t, i, w) {
    for (w = w.child; w !== null; ) Nh(t, i, w), w = w.sibling;
  }
  function Nh(t, i, w) {
    if ($t && typeof $t.onCommitFiberUnmount == "function") try {
      $t.onCommitFiberUnmount(wt, w);
    } catch {
    }
    switch (w.tag) {
      case 5:
        ri || ja(w, i);
      case 6:
        var N = Zr, ae = Gi;
        Zr = null, Dn(t, i, w), Zr = N, Gi = ae, Zr !== null && (Gi ? (t = Zr, w = w.stateNode, t.nodeType === 8 ? t.parentNode.removeChild(w) : t.removeChild(w)) : Zr.removeChild(w.stateNode));
        break;
      case 18:
        Zr !== null && (Gi ? (t = Zr, w = w.stateNode, t.nodeType === 8 ? _u(t.parentNode, w) : t.nodeType === 1 && _u(t, w), fr(t)) : _u(Zr, w.stateNode));
        break;
      case 4:
        N = Zr, ae = Gi, Zr = w.stateNode.containerInfo, Gi = !0, Dn(t, i, w), Zr = N, Gi = ae;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!ri && (N = w.updateQueue, N !== null && (N = N.lastEffect, N !== null))) {
          ae = N = N.next;
          do {
            var ye = ae, ze = ye.destroy;
            ye = ye.tag, ze !== void 0 && ((ye & 2) !== 0 || (ye & 4) !== 0) && rl(w, i, ze), ae = ae.next;
          } while (ae !== N);
        }
        Dn(t, i, w);
        break;
      case 1:
        if (!ri && (ja(w, i), N = w.stateNode, typeof N.componentWillUnmount == "function")) try {
          N.props = w.memoizedProps, N.state = w.memoizedState, N.componentWillUnmount();
        } catch (Qe) {
          Cr(w, i, Qe);
        }
        Dn(t, i, w);
        break;
      case 21:
        Dn(t, i, w);
        break;
      case 22:
        w.mode & 1 ? (ri = (N = ri) || w.memoizedState !== null, Dn(t, i, w), ri = N) : Dn(t, i, w);
        break;
      default:
        Dn(t, i, w);
    }
  }
  function Dh(t) {
    var i = t.updateQueue;
    if (i !== null) {
      t.updateQueue = null;
      var w = t.stateNode;
      w === null && (w = t.stateNode = new Bd()), i.forEach(function(N) {
        var ae = Yd.bind(null, t, N);
        w.has(N) || (w.add(N), N.then(ae, ae));
      });
    }
  }
  function Vi(t, i) {
    var w = i.deletions;
    if (w !== null) for (var N = 0; N < w.length; N++) {
      var ae = w[N];
      try {
        var ye = t, ze = i, Qe = ze;
        e: for (; Qe !== null; ) {
          switch (Qe.tag) {
            case 5:
              Zr = Qe.stateNode, Gi = !1;
              break e;
            case 3:
              Zr = Qe.stateNode.containerInfo, Gi = !0;
              break e;
            case 4:
              Zr = Qe.stateNode.containerInfo, Gi = !0;
              break e;
          }
          Qe = Qe.return;
        }
        if (Zr === null) throw Error(ne(160));
        Nh(ye, ze, ae), Zr = null, Gi = !1;
        var rt = ae.alternate;
        rt !== null && (rt.return = null), ae.return = null;
      } catch (ht) {
        Cr(ae, i, ht);
      }
    }
    if (i.subtreeFlags & 12854) for (i = i.child; i !== null; ) Bh(i, t), i = i.sibling;
  }
  function Bh(t, i) {
    var w = t.alternate, N = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Vi(i, t), an(t), N & 4) {
          try {
            _s(3, t, t.return), So(3, t);
          } catch (Lt) {
            Cr(t, t.return, Lt);
          }
          try {
            _s(5, t, t.return);
          } catch (Lt) {
            Cr(t, t.return, Lt);
          }
        }
        break;
      case 1:
        Vi(i, t), an(t), N & 512 && w !== null && ja(w, w.return);
        break;
      case 5:
        if (Vi(i, t), an(t), N & 512 && w !== null && ja(w, w.return), t.flags & 32) {
          var ae = t.stateNode;
          try {
            I(ae, "");
          } catch (Lt) {
            Cr(t, t.return, Lt);
          }
        }
        if (N & 4 && (ae = t.stateNode, ae != null)) {
          var ye = t.memoizedProps, ze = w !== null ? w.memoizedProps : ye, Qe = t.type, rt = t.updateQueue;
          if (t.updateQueue = null, rt !== null) try {
            Qe === "input" && ye.type === "radio" && ye.name != null && De(ae, ye), M(Qe, ze);
            var ht = M(Qe, ye);
            for (ze = 0; ze < rt.length; ze += 2) {
              var yt = rt[ze], St = rt[ze + 1];
              yt === "style" ? X(ae, St) : yt === "dangerouslySetInnerHTML" ? k(ae, St) : yt === "children" ? I(ae, St) : s(ae, yt, St, ht);
            }
            switch (Qe) {
              case "input":
                Ne(ae, ye);
                break;
              case "textarea":
                G(ae, ye);
                break;
              case "select":
                var _t = ae._wrapperState.wasMultiple;
                ae._wrapperState.wasMultiple = !!ye.multiple;
                var Mt = ye.value;
                Mt != null ? Ce(ae, !!ye.multiple, Mt, !1) : _t !== !!ye.multiple && (ye.defaultValue != null ? Ce(
                  ae,
                  !!ye.multiple,
                  ye.defaultValue,
                  !0
                ) : Ce(ae, !!ye.multiple, ye.multiple ? [] : "", !1));
            }
            ae[os] = ye;
          } catch (Lt) {
            Cr(t, t.return, Lt);
          }
        }
        break;
      case 6:
        if (Vi(i, t), an(t), N & 4) {
          if (t.stateNode === null) throw Error(ne(162));
          ae = t.stateNode, ye = t.memoizedProps;
          try {
            ae.nodeValue = ye;
          } catch (Lt) {
            Cr(t, t.return, Lt);
          }
        }
        break;
      case 3:
        if (Vi(i, t), an(t), N & 4 && w !== null && w.memoizedState.isDehydrated) try {
          fr(i.containerInfo);
        } catch (Lt) {
          Cr(t, t.return, Lt);
        }
        break;
      case 4:
        Vi(i, t), an(t);
        break;
      case 13:
        Vi(i, t), an(t), ae = t.child, ae.flags & 8192 && (ye = ae.memoizedState !== null, ae.stateNode.isHidden = ye, !ye || ae.alternate !== null && ae.alternate.memoizedState !== null || (ul = Pt())), N & 4 && Dh(t);
        break;
      case 22:
        if (yt = w !== null && w.memoizedState !== null, t.mode & 1 ? (ri = (ht = ri) || yt, Vi(i, t), ri = ht) : Vi(i, t), an(t), N & 8192) {
          if (ht = t.memoizedState !== null, (t.stateNode.isHidden = ht) && !yt && (t.mode & 1) !== 0) for (It = t, yt = t.child; yt !== null; ) {
            for (St = It = yt; It !== null; ) {
              switch (_t = It, Mt = _t.child, _t.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  _s(4, _t, _t.return);
                  break;
                case 1:
                  ja(_t, _t.return);
                  var Rt = _t.stateNode;
                  if (typeof Rt.componentWillUnmount == "function") {
                    N = _t, w = _t.return;
                    try {
                      i = N, Rt.props = i.memoizedProps, Rt.state = i.memoizedState, Rt.componentWillUnmount();
                    } catch (Lt) {
                      Cr(N, w, Lt);
                    }
                  }
                  break;
                case 5:
                  ja(_t, _t.return);
                  break;
                case 22:
                  if (_t.memoizedState !== null) {
                    Uh(St);
                    continue;
                  }
              }
              Mt !== null ? (Mt.return = _t, It = Mt) : Uh(St);
            }
            yt = yt.sibling;
          }
          e: for (yt = null, St = t; ; ) {
            if (St.tag === 5) {
              if (yt === null) {
                yt = St;
                try {
                  ae = St.stateNode, ht ? (ye = ae.style, typeof ye.setProperty == "function" ? ye.setProperty("display", "none", "important") : ye.display = "none") : (Qe = St.stateNode, rt = St.memoizedProps.style, ze = rt != null && rt.hasOwnProperty("display") ? rt.display : null, Qe.style.display = H("display", ze));
                } catch (Lt) {
                  Cr(t, t.return, Lt);
                }
              }
            } else if (St.tag === 6) {
              if (yt === null) try {
                St.stateNode.nodeValue = ht ? "" : St.memoizedProps;
              } catch (Lt) {
                Cr(t, t.return, Lt);
              }
            } else if ((St.tag !== 22 && St.tag !== 23 || St.memoizedState === null || St === t) && St.child !== null) {
              St.child.return = St, St = St.child;
              continue;
            }
            if (St === t) break e;
            for (; St.sibling === null; ) {
              if (St.return === null || St.return === t) break e;
              yt === St && (yt = null), St = St.return;
            }
            yt === St && (yt = null), St.sibling.return = St.return, St = St.sibling;
          }
        }
        break;
      case 19:
        Vi(i, t), an(t), N & 4 && Dh(t);
        break;
      case 21:
        break;
      default:
        Vi(
          i,
          t
        ), an(t);
    }
  }
  function an(t) {
    var i = t.flags;
    if (i & 2) {
      try {
        e: {
          for (var w = t.return; w !== null; ) {
            if (Oh(w)) {
              var N = w;
              break e;
            }
            w = w.return;
          }
          throw Error(ne(160));
        }
        switch (N.tag) {
          case 5:
            var ae = N.stateNode;
            N.flags & 32 && (I(ae, ""), N.flags &= -33);
            var ye = Lh(t);
            al(t, ye, ae);
            break;
          case 3:
          case 4:
            var ze = N.stateNode.containerInfo, Qe = Lh(t);
            nl(t, Qe, ze);
            break;
          default:
            throw Error(ne(161));
        }
      } catch (rt) {
        Cr(t, t.return, rt);
      }
      t.flags &= -3;
    }
    i & 4096 && (t.flags &= -4097);
  }
  function Fd(t, i, w) {
    It = t, zh(t);
  }
  function zh(t, i, w) {
    for (var N = (t.mode & 1) !== 0; It !== null; ) {
      var ae = It, ye = ae.child;
      if (ae.tag === 22 && N) {
        var ze = ae.memoizedState !== null || bo;
        if (!ze) {
          var Qe = ae.alternate, rt = Qe !== null && Qe.memoizedState !== null || ri;
          Qe = bo;
          var ht = ri;
          if (bo = ze, (ri = rt) && !ht) for (It = ae; It !== null; ) ze = It, rt = ze.child, ze.tag === 22 && ze.memoizedState !== null ? jh(ae) : rt !== null ? (rt.return = ze, It = rt) : jh(ae);
          for (; ye !== null; ) It = ye, zh(ye), ye = ye.sibling;
          It = ae, bo = Qe, ri = ht;
        }
        Fh(t);
      } else (ae.subtreeFlags & 8772) !== 0 && ye !== null ? (ye.return = ae, It = ye) : Fh(t);
    }
  }
  function Fh(t) {
    for (; It !== null; ) {
      var i = It;
      if ((i.flags & 8772) !== 0) {
        var w = i.alternate;
        try {
          if ((i.flags & 8772) !== 0) switch (i.tag) {
            case 0:
            case 11:
            case 15:
              ri || So(5, i);
              break;
            case 1:
              var N = i.stateNode;
              if (i.flags & 4 && !ri) if (w === null) N.componentDidMount();
              else {
                var ae = i.elementType === i.type ? w.memoizedProps : Hi(i.type, w.memoizedProps);
                N.componentDidUpdate(ae, w.memoizedState, N.__reactInternalSnapshotBeforeUpdate);
              }
              var ye = i.updateQueue;
              ye !== null && Uf(i, ye, N);
              break;
            case 3:
              var ze = i.updateQueue;
              if (ze !== null) {
                if (w = null, i.child !== null) switch (i.child.tag) {
                  case 5:
                    w = i.child.stateNode;
                    break;
                  case 1:
                    w = i.child.stateNode;
                }
                Uf(i, ze, w);
              }
              break;
            case 5:
              var Qe = i.stateNode;
              if (w === null && i.flags & 4) {
                w = Qe;
                var rt = i.memoizedProps;
                switch (i.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    rt.autoFocus && w.focus();
                    break;
                  case "img":
                    rt.src && (w.src = rt.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (i.memoizedState === null) {
                var ht = i.alternate;
                if (ht !== null) {
                  var yt = ht.memoizedState;
                  if (yt !== null) {
                    var St = yt.dehydrated;
                    St !== null && fr(St);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(ne(163));
          }
          ri || i.flags & 512 && il(i);
        } catch (_t) {
          Cr(i, i.return, _t);
        }
      }
      if (i === t) {
        It = null;
        break;
      }
      if (w = i.sibling, w !== null) {
        w.return = i.return, It = w;
        break;
      }
      It = i.return;
    }
  }
  function Uh(t) {
    for (; It !== null; ) {
      var i = It;
      if (i === t) {
        It = null;
        break;
      }
      var w = i.sibling;
      if (w !== null) {
        w.return = i.return, It = w;
        break;
      }
      It = i.return;
    }
  }
  function jh(t) {
    for (; It !== null; ) {
      var i = It;
      try {
        switch (i.tag) {
          case 0:
          case 11:
          case 15:
            var w = i.return;
            try {
              So(4, i);
            } catch (rt) {
              Cr(i, w, rt);
            }
            break;
          case 1:
            var N = i.stateNode;
            if (typeof N.componentDidMount == "function") {
              var ae = i.return;
              try {
                N.componentDidMount();
              } catch (rt) {
                Cr(i, ae, rt);
              }
            }
            var ye = i.return;
            try {
              il(i);
            } catch (rt) {
              Cr(i, ye, rt);
            }
            break;
          case 5:
            var ze = i.return;
            try {
              il(i);
            } catch (rt) {
              Cr(i, ze, rt);
            }
        }
      } catch (rt) {
        Cr(i, i.return, rt);
      }
      if (i === t) {
        It = null;
        break;
      }
      var Qe = i.sibling;
      if (Qe !== null) {
        Qe.return = i.return, It = Qe;
        break;
      }
      It = i.return;
    }
  }
  var Ud = Math.ceil, Eo = S.ReactCurrentDispatcher, sl = S.ReactCurrentOwner, Oi = S.ReactCurrentBatchConfig, ir = 0, Gr = null, Ir = null, Yr = 0, xi = 0, Ha = In(0), Dr = 0, ys = null, fa = 0, xo = 0, ol = 0, ws = null, ci = null, ul = 0, Ga = 1 / 0, _n = null, Co = !1, ll = null, Bn = null, ko = !1, zn = null, Ao = 0, bs = 0, fl = null, To = -1, Po = 0;
  function si() {
    return (ir & 6) !== 0 ? Pt() : To !== -1 ? To : To = Pt();
  }
  function Fn(t) {
    return (t.mode & 1) === 0 ? 1 : (ir & 2) !== 0 && Yr !== 0 ? Yr & -Yr : Ed.transition !== null ? (Po === 0 && (Po = wn()), Po) : (t = Qt, t !== 0 || (t = window.event, t = t === void 0 ? 16 : Yn(t.type)), t);
  }
  function Wi(t, i, w, N) {
    if (50 < bs) throw bs = 0, fl = null, Error(ne(185));
    Yi(t, w, N), ((ir & 2) === 0 || t !== Gr) && (t === Gr && ((ir & 2) === 0 && (xo |= w), Dr === 4 && Un(t, Yr)), di(t, N), w === 1 && ir === 0 && (i.mode & 1) === 0 && (Ga = Pt() + 500, ro && On()));
  }
  function di(t, i) {
    var w = t.callbackNode;
    Or(t, i);
    var N = qr(t, t === Gr ? Yr : 0);
    if (N === 0) w !== null && xt(w), t.callbackNode = null, t.callbackPriority = 0;
    else if (i = N & -N, t.callbackPriority !== i) {
      if (w != null && xt(w), i === 1) t.tag === 0 ? Sd(Gh.bind(null, t)) : Tf(Gh.bind(null, t)), _d(function() {
        (ir & 6) === 0 && On();
      }), w = null;
      else {
        switch (qi(N)) {
          case 1:
            w = Bt;
            break;
          case 4:
            w = or;
            break;
          case 16:
            w = ar;
            break;
          case 536870912:
            w = hr;
            break;
          default:
            w = ar;
        }
        w = Kh(w, Hh.bind(null, t));
      }
      t.callbackPriority = i, t.callbackNode = w;
    }
  }
  function Hh(t, i) {
    if (To = -1, Po = 0, (ir & 6) !== 0) throw Error(ne(327));
    var w = t.callbackNode;
    if (Va() && t.callbackNode !== w) return null;
    var N = qr(t, t === Gr ? Yr : 0);
    if (N === 0) return null;
    if ((N & 30) !== 0 || (N & t.expiredLanes) !== 0 || i) i = Mo(t, N);
    else {
      i = N;
      var ae = ir;
      ir |= 2;
      var ye = Wh();
      (Gr !== t || Yr !== i) && (_n = null, Ga = Pt() + 500, ca(t, i));
      do
        try {
          Gd();
          break;
        } catch (Qe) {
          Vh(t, Qe);
        }
      while (!0);
      Tu(), Eo.current = ye, ir = ae, Ir !== null ? i = 0 : (Gr = null, Yr = 0, i = Dr);
    }
    if (i !== 0) {
      if (i === 2 && (ae = yn(t), ae !== 0 && (N = ae, i = hl(t, ae))), i === 1) throw w = ys, ca(t, 0), Un(t, N), di(t, Pt()), w;
      if (i === 6) Un(t, N);
      else {
        if (ae = t.current.alternate, (N & 30) === 0 && !jd(ae) && (i = Mo(t, N), i === 2 && (ye = yn(t), ye !== 0 && (N = ye, i = hl(t, ye))), i === 1)) throw w = ys, ca(t, 0), Un(t, N), di(t, Pt()), w;
        switch (t.finishedWork = ae, t.finishedLanes = N, i) {
          case 0:
          case 1:
            throw Error(ne(345));
          case 2:
            da(t, ci, _n);
            break;
          case 3:
            if (Un(t, N), (N & 130023424) === N && (i = ul + 500 - Pt(), 10 < i)) {
              if (qr(t, 0) !== 0) break;
              if (ae = t.suspendedLanes, (ae & N) !== N) {
                si(), t.pingedLanes |= t.suspendedLanes & ae;
                break;
              }
              t.timeoutHandle = gu(da.bind(null, t, ci, _n), i);
              break;
            }
            da(t, ci, _n);
            break;
          case 4:
            if (Un(t, N), (N & 4194240) === N) break;
            for (i = t.eventTimes, ae = -1; 0 < N; ) {
              var ze = 31 - tr(N);
              ye = 1 << ze, ze = i[ze], ze > ae && (ae = ze), N &= ~ye;
            }
            if (N = ae, N = Pt() - N, N = (120 > N ? 120 : 480 > N ? 480 : 1080 > N ? 1080 : 1920 > N ? 1920 : 3e3 > N ? 3e3 : 4320 > N ? 4320 : 1960 * Ud(N / 1960)) - N, 10 < N) {
              t.timeoutHandle = gu(da.bind(null, t, ci, _n), N);
              break;
            }
            da(t, ci, _n);
            break;
          case 5:
            da(t, ci, _n);
            break;
          default:
            throw Error(ne(329));
        }
      }
    }
    return di(t, Pt()), t.callbackNode === w ? Hh.bind(null, t) : null;
  }
  function hl(t, i) {
    var w = ws;
    return t.current.memoizedState.isDehydrated && (ca(t, i).flags |= 256), t = Mo(t, i), t !== 2 && (i = ci, ci = w, i !== null && cl(i)), t;
  }
  function cl(t) {
    ci === null ? ci = t : ci.push.apply(ci, t);
  }
  function jd(t) {
    for (var i = t; ; ) {
      if (i.flags & 16384) {
        var w = i.updateQueue;
        if (w !== null && (w = w.stores, w !== null)) for (var N = 0; N < w.length; N++) {
          var ae = w[N], ye = ae.getSnapshot;
          ae = ae.value;
          try {
            if (!Mr(ye(), ae)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (w = i.child, i.subtreeFlags & 16384 && w !== null) w.return = i, i = w;
      else {
        if (i === t) break;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === t) return !0;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    return !0;
  }
  function Un(t, i) {
    for (i &= ~ol, i &= ~xo, t.suspendedLanes |= i, t.pingedLanes &= ~i, t = t.expirationTimes; 0 < i; ) {
      var w = 31 - tr(i), N = 1 << w;
      t[w] = -1, i &= ~N;
    }
  }
  function Gh(t) {
    if ((ir & 6) !== 0) throw Error(ne(327));
    Va();
    var i = qr(t, 0);
    if ((i & 1) === 0) return di(t, Pt()), null;
    var w = Mo(t, i);
    if (t.tag !== 0 && w === 2) {
      var N = yn(t);
      N !== 0 && (i = N, w = hl(t, N));
    }
    if (w === 1) throw w = ys, ca(t, 0), Un(t, i), di(t, Pt()), w;
    if (w === 6) throw Error(ne(345));
    return t.finishedWork = t.current.alternate, t.finishedLanes = i, da(t, ci, _n), di(t, Pt()), null;
  }
  function dl(t, i) {
    var w = ir;
    ir |= 1;
    try {
      return t(i);
    } finally {
      ir = w, ir === 0 && (Ga = Pt() + 500, ro && On());
    }
  }
  function ha(t) {
    zn !== null && zn.tag === 0 && (ir & 6) === 0 && Va();
    var i = ir;
    ir |= 1;
    var w = Oi.transition, N = Qt;
    try {
      if (Oi.transition = null, Qt = 1, t) return t();
    } finally {
      Qt = N, Oi.transition = w, ir = i, (ir & 6) === 0 && On();
    }
  }
  function pl() {
    xi = Ha.current, vr(Ha);
  }
  function ca(t, i) {
    t.finishedWork = null, t.finishedLanes = 0;
    var w = t.timeoutHandle;
    if (w !== -1 && (t.timeoutHandle = -1, gd(w)), Ir !== null) for (w = Ir.return; w !== null; ) {
      var N = w;
      switch (Eu(N), N.tag) {
        case 1:
          N = N.type.childContextTypes, N != null && eo();
          break;
        case 3:
          Fa(), vr(li), vr(Jr), Du();
          break;
        case 5:
          Lu(N);
          break;
        case 4:
          Fa();
          break;
        case 13:
          vr(br);
          break;
        case 19:
          vr(br);
          break;
        case 10:
          Pu(N.type._context);
          break;
        case 22:
        case 23:
          pl();
      }
      w = w.return;
    }
    if (Gr = t, Ir = t = jn(t.current, null), Yr = xi = i, Dr = 0, ys = null, ol = xo = fa = 0, ci = ws = null, oa !== null) {
      for (i = 0; i < oa.length; i++) if (w = oa[i], N = w.interleaved, N !== null) {
        w.interleaved = null;
        var ae = N.next, ye = w.pending;
        if (ye !== null) {
          var ze = ye.next;
          ye.next = ae, N.next = ze;
        }
        w.pending = N;
      }
      oa = null;
    }
    return t;
  }
  function Vh(t, i) {
    do {
      var w = Ir;
      try {
        if (Tu(), co.current = go, po) {
          for (var N = Sr.memoizedState; N !== null; ) {
            var ae = N.queue;
            ae !== null && (ae.pending = null), N = N.next;
          }
          po = !1;
        }
        if (la = 0, Hr = Nr = Sr = null, ds = !1, ps = 0, sl.current = null, w === null || w.return === null) {
          Dr = 1, ys = i, Ir = null;
          break;
        }
        e: {
          var ye = t, ze = w.return, Qe = w, rt = i;
          if (i = Yr, Qe.flags |= 32768, rt !== null && typeof rt == "object" && typeof rt.then == "function") {
            var ht = rt, yt = Qe, St = yt.tag;
            if ((yt.mode & 1) === 0 && (St === 0 || St === 11 || St === 15)) {
              var _t = yt.alternate;
              _t ? (yt.updateQueue = _t.updateQueue, yt.memoizedState = _t.memoizedState, yt.lanes = _t.lanes) : (yt.updateQueue = null, yt.memoizedState = null);
            }
            var Mt = vh(ze);
            if (Mt !== null) {
              Mt.flags &= -257, mh(Mt, ze, Qe, ye, i), Mt.mode & 1 && ph(ye, ht, i), i = Mt, rt = ht;
              var Rt = i.updateQueue;
              if (Rt === null) {
                var Lt = /* @__PURE__ */ new Set();
                Lt.add(rt), i.updateQueue = Lt;
              } else Rt.add(rt);
              break e;
            } else {
              if ((i & 1) === 0) {
                ph(ye, ht, i), vl();
                break e;
              }
              rt = Error(ne(426));
            }
          } else if (mr && Qe.mode & 1) {
            var Tr = vh(ze);
            if (Tr !== null) {
              (Tr.flags & 65536) === 0 && (Tr.flags |= 256), mh(Tr, ze, Qe, ye, i), ku(Ua(rt, Qe));
              break e;
            }
          }
          ye = rt = Ua(rt, Qe), Dr !== 4 && (Dr = 2), ws === null ? ws = [ye] : ws.push(ye), ye = ze;
          do {
            switch (ye.tag) {
              case 3:
                ye.flags |= 65536, i &= -i, ye.lanes |= i;
                var st = ch(ye, rt, i);
                Ff(ye, st);
                break e;
              case 1:
                Qe = rt;
                var it = ye.type, ut = ye.stateNode;
                if ((ye.flags & 128) === 0 && (typeof it.getDerivedStateFromError == "function" || ut !== null && typeof ut.componentDidCatch == "function" && (Bn === null || !Bn.has(ut)))) {
                  ye.flags |= 65536, i &= -i, ye.lanes |= i;
                  var kt = dh(ye, Qe, i);
                  Ff(ye, kt);
                  break e;
                }
            }
            ye = ye.return;
          } while (ye !== null);
        }
        Yh(w);
      } catch (Dt) {
        i = Dt, Ir === w && w !== null && (Ir = w = w.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Wh() {
    var t = Eo.current;
    return Eo.current = go, t === null ? go : t;
  }
  function vl() {
    (Dr === 0 || Dr === 3 || Dr === 2) && (Dr = 4), Gr === null || (fa & 268435455) === 0 && (xo & 268435455) === 0 || Un(Gr, Yr);
  }
  function Mo(t, i) {
    var w = ir;
    ir |= 2;
    var N = Wh();
    (Gr !== t || Yr !== i) && (_n = null, ca(t, i));
    do
      try {
        Hd();
        break;
      } catch (ae) {
        Vh(t, ae);
      }
    while (!0);
    if (Tu(), ir = w, Eo.current = N, Ir !== null) throw Error(ne(261));
    return Gr = null, Yr = 0, Dr;
  }
  function Hd() {
    for (; Ir !== null; ) Zh(Ir);
  }
  function Gd() {
    for (; Ir !== null && !Ot(); ) Zh(Ir);
  }
  function Zh(t) {
    var i = Qh(t.alternate, t, xi);
    t.memoizedProps = t.pendingProps, i === null ? Yh(t) : Ir = i, sl.current = null;
  }
  function Yh(t) {
    var i = t;
    do {
      var w = i.alternate;
      if (t = i.return, (i.flags & 32768) === 0) {
        if (w = Nd(w, i, xi), w !== null) {
          Ir = w;
          return;
        }
      } else {
        if (w = Dd(w, i), w !== null) {
          w.flags &= 32767, Ir = w;
          return;
        }
        if (t !== null) t.flags |= 32768, t.subtreeFlags = 0, t.deletions = null;
        else {
          Dr = 6, Ir = null;
          return;
        }
      }
      if (i = i.sibling, i !== null) {
        Ir = i;
        return;
      }
      Ir = i = t;
    } while (i !== null);
    Dr === 0 && (Dr = 5);
  }
  function da(t, i, w) {
    var N = Qt, ae = Oi.transition;
    try {
      Oi.transition = null, Qt = 1, Vd(t, i, w, N);
    } finally {
      Oi.transition = ae, Qt = N;
    }
    return null;
  }
  function Vd(t, i, w, N) {
    do
      Va();
    while (zn !== null);
    if ((ir & 6) !== 0) throw Error(ne(327));
    w = t.finishedWork;
    var ae = t.finishedLanes;
    if (w === null) return null;
    if (t.finishedWork = null, t.finishedLanes = 0, w === t.current) throw Error(ne(177));
    t.callbackNode = null, t.callbackPriority = 0;
    var ye = w.lanes | w.childLanes;
    if (ya(t, ye), t === Gr && (Ir = Gr = null, Yr = 0), (w.subtreeFlags & 2064) === 0 && (w.flags & 2064) === 0 || ko || (ko = !0, Kh(ar, function() {
      return Va(), null;
    })), ye = (w.flags & 15990) !== 0, (w.subtreeFlags & 15990) !== 0 || ye) {
      ye = Oi.transition, Oi.transition = null;
      var ze = Qt;
      Qt = 1;
      var Qe = ir;
      ir |= 4, sl.current = null, zd(t, w), Bh(w, t), Wt(vu), Ci = !!pu, vu = pu = null, t.current = w, Fd(w), Nt(), ir = Qe, Qt = ze, Oi.transition = ye;
    } else t.current = w;
    if (ko && (ko = !1, zn = t, Ao = ae), ye = t.pendingLanes, ye === 0 && (Bn = null), lr(w.stateNode), di(t, Pt()), i !== null) for (N = t.onRecoverableError, w = 0; w < i.length; w++) ae = i[w], N(ae.value, { componentStack: ae.stack, digest: ae.digest });
    if (Co) throw Co = !1, t = ll, ll = null, t;
    return (Ao & 1) !== 0 && t.tag !== 0 && Va(), ye = t.pendingLanes, (ye & 1) !== 0 ? t === fl ? bs++ : (bs = 0, fl = t) : bs = 0, On(), null;
  }
  function Va() {
    if (zn !== null) {
      var t = qi(Ao), i = Oi.transition, w = Qt;
      try {
        if (Oi.transition = null, Qt = 16 > t ? 16 : t, zn === null) var N = !1;
        else {
          if (t = zn, zn = null, Ao = 0, (ir & 6) !== 0) throw Error(ne(331));
          var ae = ir;
          for (ir |= 4, It = t.current; It !== null; ) {
            var ye = It, ze = ye.child;
            if ((It.flags & 16) !== 0) {
              var Qe = ye.deletions;
              if (Qe !== null) {
                for (var rt = 0; rt < Qe.length; rt++) {
                  var ht = Qe[rt];
                  for (It = ht; It !== null; ) {
                    var yt = It;
                    switch (yt.tag) {
                      case 0:
                      case 11:
                      case 15:
                        _s(8, yt, ye);
                    }
                    var St = yt.child;
                    if (St !== null) St.return = yt, It = St;
                    else for (; It !== null; ) {
                      yt = It;
                      var _t = yt.sibling, Mt = yt.return;
                      if (Rh(yt), yt === ht) {
                        It = null;
                        break;
                      }
                      if (_t !== null) {
                        _t.return = Mt, It = _t;
                        break;
                      }
                      It = Mt;
                    }
                  }
                }
                var Rt = ye.alternate;
                if (Rt !== null) {
                  var Lt = Rt.child;
                  if (Lt !== null) {
                    Rt.child = null;
                    do {
                      var Tr = Lt.sibling;
                      Lt.sibling = null, Lt = Tr;
                    } while (Lt !== null);
                  }
                }
                It = ye;
              }
            }
            if ((ye.subtreeFlags & 2064) !== 0 && ze !== null) ze.return = ye, It = ze;
            else e: for (; It !== null; ) {
              if (ye = It, (ye.flags & 2048) !== 0) switch (ye.tag) {
                case 0:
                case 11:
                case 15:
                  _s(9, ye, ye.return);
              }
              var st = ye.sibling;
              if (st !== null) {
                st.return = ye.return, It = st;
                break e;
              }
              It = ye.return;
            }
          }
          var it = t.current;
          for (It = it; It !== null; ) {
            ze = It;
            var ut = ze.child;
            if ((ze.subtreeFlags & 2064) !== 0 && ut !== null) ut.return = ze, It = ut;
            else e: for (ze = it; It !== null; ) {
              if (Qe = It, (Qe.flags & 2048) !== 0) try {
                switch (Qe.tag) {
                  case 0:
                  case 11:
                  case 15:
                    So(9, Qe);
                }
              } catch (Dt) {
                Cr(Qe, Qe.return, Dt);
              }
              if (Qe === ze) {
                It = null;
                break e;
              }
              var kt = Qe.sibling;
              if (kt !== null) {
                kt.return = Qe.return, It = kt;
                break e;
              }
              It = Qe.return;
            }
          }
          if (ir = ae, On(), $t && typeof $t.onPostCommitFiberRoot == "function") try {
            $t.onPostCommitFiberRoot(wt, t);
          } catch {
          }
          N = !0;
        }
        return N;
      } finally {
        Qt = w, Oi.transition = i;
      }
    }
    return !1;
  }
  function Xh(t, i, w) {
    i = Ua(w, i), i = ch(t, i, 1), t = Nn(t, i, 1), i = si(), t !== null && (Yi(t, 1, i), di(t, i));
  }
  function Cr(t, i, w) {
    if (t.tag === 3) Xh(t, t, w);
    else for (; i !== null; ) {
      if (i.tag === 3) {
        Xh(i, t, w);
        break;
      } else if (i.tag === 1) {
        var N = i.stateNode;
        if (typeof i.type.getDerivedStateFromError == "function" || typeof N.componentDidCatch == "function" && (Bn === null || !Bn.has(N))) {
          t = Ua(w, t), t = dh(i, t, 1), i = Nn(i, t, 1), t = si(), i !== null && (Yi(i, 1, t), di(i, t));
          break;
        }
      }
      i = i.return;
    }
  }
  function Wd(t, i, w) {
    var N = t.pingCache;
    N !== null && N.delete(i), i = si(), t.pingedLanes |= t.suspendedLanes & w, Gr === t && (Yr & w) === w && (Dr === 4 || Dr === 3 && (Yr & 130023424) === Yr && 500 > Pt() - ul ? ca(t, 0) : ol |= w), di(t, i);
  }
  function qh(t, i) {
    i === 0 && ((t.mode & 1) === 0 ? i = 1 : (i = Er, Er <<= 1, (Er & 130023424) === 0 && (Er = 4194304)));
    var w = si();
    t = vn(t, i), t !== null && (Yi(t, i, w), di(t, w));
  }
  function Zd(t) {
    var i = t.memoizedState, w = 0;
    i !== null && (w = i.retryLane), qh(t, w);
  }
  function Yd(t, i) {
    var w = 0;
    switch (t.tag) {
      case 13:
        var N = t.stateNode, ae = t.memoizedState;
        ae !== null && (w = ae.retryLane);
        break;
      case 19:
        N = t.stateNode;
        break;
      default:
        throw Error(ne(314));
    }
    N !== null && N.delete(i), qh(t, w);
  }
  var Qh;
  Qh = function(t, i, w) {
    if (t !== null) if (t.memoizedProps !== i.pendingProps || li.current) hi = !0;
    else {
      if ((t.lanes & w) === 0 && (i.flags & 128) === 0) return hi = !1, Ld(t, i, w);
      hi = (t.flags & 131072) !== 0;
    }
    else hi = !1, mr && (i.flags & 1048576) !== 0 && Pf(i, no, i.index);
    switch (i.lanes = 0, i.tag) {
      case 2:
        var N = i.type;
        wo(t, i), t = i.pendingProps;
        var ae = Ra(i, Jr.current);
        za(i, w), ae = Fu(null, i, N, t, ae, w);
        var ye = Uu();
        return i.flags |= 1, typeof ae == "object" && ae !== null && typeof ae.render == "function" && ae.$$typeof === void 0 ? (i.tag = 1, i.memoizedState = null, i.updateQueue = null, fi(N) ? (ye = !0, to(i)) : ye = !1, i.memoizedState = ae.state !== null && ae.state !== void 0 ? ae.state : null, Ru(i), ae.updater = _o, i.stateNode = ae, ae._reactInternals = i, Zu(i, N, t, w), i = Qu(null, i, N, !0, ye, w)) : (i.tag = 0, mr && ye && Su(i), ai(null, i, ae, w), i = i.child), i;
      case 16:
        N = i.elementType;
        e: {
          switch (wo(t, i), t = i.pendingProps, ae = N._init, N = ae(N._payload), i.type = N, ae = i.tag = qd(N), t = Hi(N, t), ae) {
            case 0:
              i = qu(null, i, N, t, w);
              break e;
            case 1:
              i = Sh(null, i, N, t, w);
              break e;
            case 11:
              i = gh(null, i, N, t, w);
              break e;
            case 14:
              i = _h(null, i, N, Hi(N.type, t), w);
              break e;
          }
          throw Error(ne(
            306,
            N,
            ""
          ));
        }
        return i;
      case 0:
        return N = i.type, ae = i.pendingProps, ae = i.elementType === N ? ae : Hi(N, ae), qu(t, i, N, ae, w);
      case 1:
        return N = i.type, ae = i.pendingProps, ae = i.elementType === N ? ae : Hi(N, ae), Sh(t, i, N, ae, w);
      case 3:
        e: {
          if (Eh(i), t === null) throw Error(ne(387));
          N = i.pendingProps, ye = i.memoizedState, ae = ye.element, zf(t, i), fo(i, N, null, w);
          var ze = i.memoizedState;
          if (N = ze.element, ye.isDehydrated) if (ye = { element: N, isDehydrated: !1, cache: ze.cache, pendingSuspenseBoundaries: ze.pendingSuspenseBoundaries, transitions: ze.transitions }, i.updateQueue.baseState = ye, i.memoizedState = ye, i.flags & 256) {
            ae = Ua(Error(ne(423)), i), i = xh(t, i, N, w, ae);
            break e;
          } else if (N !== ae) {
            ae = Ua(Error(ne(424)), i), i = xh(t, i, N, w, ae);
            break e;
          } else for (Ei = Mn(i.stateNode.containerInfo.firstChild), Si = i, mr = !0, ji = null, w = Df(i, null, N, w), i.child = w; w; ) w.flags = w.flags & -3 | 4096, w = w.sibling;
          else {
            if (Na(), N === ae) {
              i = gn(t, i, w);
              break e;
            }
            ai(t, i, N, w);
          }
          i = i.child;
        }
        return i;
      case 5:
        return jf(i), t === null && Cu(i), N = i.type, ae = i.pendingProps, ye = t !== null ? t.memoizedProps : null, ze = ae.children, mu(N, ae) ? ze = null : ye !== null && mu(N, ye) && (i.flags |= 32), bh(t, i), ai(t, i, ze, w), i.child;
      case 6:
        return t === null && Cu(i), null;
      case 13:
        return Ch(t, i, w);
      case 4:
        return Ou(i, i.stateNode.containerInfo), N = i.pendingProps, t === null ? i.child = Da(i, null, N, w) : ai(t, i, N, w), i.child;
      case 11:
        return N = i.type, ae = i.pendingProps, ae = i.elementType === N ? ae : Hi(N, ae), gh(t, i, N, ae, w);
      case 7:
        return ai(t, i, i.pendingProps, w), i.child;
      case 8:
        return ai(t, i, i.pendingProps.children, w), i.child;
      case 12:
        return ai(t, i, i.pendingProps.children, w), i.child;
      case 10:
        e: {
          if (N = i.type._context, ae = i.pendingProps, ye = i.memoizedProps, ze = ae.value, cr(oo, N._currentValue), N._currentValue = ze, ye !== null) if (Mr(ye.value, ze)) {
            if (ye.children === ae.children && !li.current) {
              i = gn(t, i, w);
              break e;
            }
          } else for (ye = i.child, ye !== null && (ye.return = i); ye !== null; ) {
            var Qe = ye.dependencies;
            if (Qe !== null) {
              ze = ye.child;
              for (var rt = Qe.firstContext; rt !== null; ) {
                if (rt.context === N) {
                  if (ye.tag === 1) {
                    rt = mn(-1, w & -w), rt.tag = 2;
                    var ht = ye.updateQueue;
                    if (ht !== null) {
                      ht = ht.shared;
                      var yt = ht.pending;
                      yt === null ? rt.next = rt : (rt.next = yt.next, yt.next = rt), ht.pending = rt;
                    }
                  }
                  ye.lanes |= w, rt = ye.alternate, rt !== null && (rt.lanes |= w), Mu(
                    ye.return,
                    w,
                    i
                  ), Qe.lanes |= w;
                  break;
                }
                rt = rt.next;
              }
            } else if (ye.tag === 10) ze = ye.type === i.type ? null : ye.child;
            else if (ye.tag === 18) {
              if (ze = ye.return, ze === null) throw Error(ne(341));
              ze.lanes |= w, Qe = ze.alternate, Qe !== null && (Qe.lanes |= w), Mu(ze, w, i), ze = ye.sibling;
            } else ze = ye.child;
            if (ze !== null) ze.return = ye;
            else for (ze = ye; ze !== null; ) {
              if (ze === i) {
                ze = null;
                break;
              }
              if (ye = ze.sibling, ye !== null) {
                ye.return = ze.return, ze = ye;
                break;
              }
              ze = ze.return;
            }
            ye = ze;
          }
          ai(t, i, ae.children, w), i = i.child;
        }
        return i;
      case 9:
        return ae = i.type, N = i.pendingProps.children, za(i, w), ae = Ii(ae), N = N(ae), i.flags |= 1, ai(t, i, N, w), i.child;
      case 14:
        return N = i.type, ae = Hi(N, i.pendingProps), ae = Hi(N.type, ae), _h(t, i, N, ae, w);
      case 15:
        return yh(t, i, i.type, i.pendingProps, w);
      case 17:
        return N = i.type, ae = i.pendingProps, ae = i.elementType === N ? ae : Hi(N, ae), wo(t, i), i.tag = 1, fi(N) ? (t = !0, to(i)) : t = !1, za(i, w), fh(i, N, ae), Zu(i, N, ae, w), Qu(null, i, N, !0, t, w);
      case 19:
        return Ah(t, i, w);
      case 22:
        return wh(t, i, w);
    }
    throw Error(ne(156, i.tag));
  };
  function Kh(t, i) {
    return Ct(t, i);
  }
  function Xd(t, i, w, N) {
    this.tag = t, this.key = w, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = i, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = N, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Li(t, i, w, N) {
    return new Xd(t, i, w, N);
  }
  function ml(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function qd(t) {
    if (typeof t == "function") return ml(t) ? 1 : 0;
    if (t != null) {
      if (t = t.$$typeof, t === U) return 11;
      if (t === se) return 14;
    }
    return 2;
  }
  function jn(t, i) {
    var w = t.alternate;
    return w === null ? (w = Li(t.tag, i, t.key, t.mode), w.elementType = t.elementType, w.type = t.type, w.stateNode = t.stateNode, w.alternate = t, t.alternate = w) : (w.pendingProps = i, w.type = t.type, w.flags = 0, w.subtreeFlags = 0, w.deletions = null), w.flags = t.flags & 14680064, w.childLanes = t.childLanes, w.lanes = t.lanes, w.child = t.child, w.memoizedProps = t.memoizedProps, w.memoizedState = t.memoizedState, w.updateQueue = t.updateQueue, i = t.dependencies, w.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }, w.sibling = t.sibling, w.index = t.index, w.ref = t.ref, w;
  }
  function Io(t, i, w, N, ae, ye) {
    var ze = 2;
    if (N = t, typeof t == "function") ml(t) && (ze = 1);
    else if (typeof t == "string") ze = 5;
    else e: switch (t) {
      case A:
        return pa(w.children, ae, ye, i);
      case T:
        ze = 8, ae |= 8;
        break;
      case R:
        return t = Li(12, w, i, ae | 2), t.elementType = R, t.lanes = ye, t;
      case J:
        return t = Li(13, w, i, ae), t.elementType = J, t.lanes = ye, t;
      case F:
        return t = Li(19, w, i, ae), t.elementType = F, t.lanes = ye, t;
      case ie:
        return Ro(w, ae, ye, i);
      default:
        if (typeof t == "object" && t !== null) switch (t.$$typeof) {
          case L:
            ze = 10;
            break e;
          case z:
            ze = 9;
            break e;
          case U:
            ze = 11;
            break e;
          case se:
            ze = 14;
            break e;
          case ee:
            ze = 16, N = null;
            break e;
        }
        throw Error(ne(130, t == null ? t : typeof t, ""));
    }
    return i = Li(ze, w, i, ae), i.elementType = t, i.type = N, i.lanes = ye, i;
  }
  function pa(t, i, w, N) {
    return t = Li(7, t, N, i), t.lanes = w, t;
  }
  function Ro(t, i, w, N) {
    return t = Li(22, t, N, i), t.elementType = ie, t.lanes = w, t.stateNode = { isHidden: !1 }, t;
  }
  function gl(t, i, w) {
    return t = Li(6, t, null, i), t.lanes = w, t;
  }
  function _l(t, i, w) {
    return i = Li(4, t.children !== null ? t.children : [], t.key, i), i.lanes = w, i.stateNode = { containerInfo: t.containerInfo, pendingChildren: null, implementation: t.implementation }, i;
  }
  function Qd(t, i, w, N, ae) {
    this.tag = i, this.containerInfo = t, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = bn(0), this.expirationTimes = bn(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = bn(0), this.identifierPrefix = N, this.onRecoverableError = ae, this.mutableSourceEagerHydrationData = null;
  }
  function yl(t, i, w, N, ae, ye, ze, Qe, rt) {
    return t = new Qd(t, i, w, Qe, rt), i === 1 ? (i = 1, ye === !0 && (i |= 8)) : i = 0, ye = Li(3, null, null, i), t.current = ye, ye.stateNode = t, ye.memoizedState = { element: N, isDehydrated: w, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Ru(ye), t;
  }
  function Kd(t, i, w) {
    var N = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: o, key: N == null ? null : "" + N, children: t, containerInfo: i, implementation: w };
  }
  function $h(t) {
    if (!t) return Rn;
    t = t._reactInternals;
    e: {
      if (vt(t) !== t || t.tag !== 1) throw Error(ne(170));
      var i = t;
      do {
        switch (i.tag) {
          case 3:
            i = i.stateNode.context;
            break e;
          case 1:
            if (fi(i.type)) {
              i = i.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        i = i.return;
      } while (i !== null);
      throw Error(ne(171));
    }
    if (t.tag === 1) {
      var w = t.type;
      if (fi(w)) return kf(t, w, i);
    }
    return i;
  }
  function Jh(t, i, w, N, ae, ye, ze, Qe, rt) {
    return t = yl(w, N, !0, t, ae, ye, ze, Qe, rt), t.context = $h(null), w = t.current, N = si(), ae = Fn(w), ye = mn(N, ae), ye.callback = i ?? null, Nn(w, ye, ae), t.current.lanes = ae, Yi(t, ae, N), di(t, N), t;
  }
  function Oo(t, i, w, N) {
    var ae = i.current, ye = si(), ze = Fn(ae);
    return w = $h(w), i.context === null ? i.context = w : i.pendingContext = w, i = mn(ye, ze), i.payload = { element: t }, N = N === void 0 ? null : N, N !== null && (i.callback = N), t = Nn(ae, i, ze), t !== null && (Wi(t, ae, ze, ye), lo(t, ae, ze)), ze;
  }
  function Lo(t) {
    if (t = t.current, !t.child) return null;
    switch (t.child.tag) {
      case 5:
        return t.child.stateNode;
      default:
        return t.child.stateNode;
    }
  }
  function ec(t, i) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var w = t.retryLane;
      t.retryLane = w !== 0 && w < i ? w : i;
    }
  }
  function wl(t, i) {
    ec(t, i), (t = t.alternate) && ec(t, i);
  }
  function $d() {
    return null;
  }
  var tc = typeof reportError == "function" ? reportError : function(t) {
    console.error(t);
  };
  function bl(t) {
    this._internalRoot = t;
  }
  No.prototype.render = bl.prototype.render = function(t) {
    var i = this._internalRoot;
    if (i === null) throw Error(ne(409));
    Oo(t, i, null, null);
  }, No.prototype.unmount = bl.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var i = t.containerInfo;
      ha(function() {
        Oo(null, t, null, null);
      }), i[hn] = null;
    }
  };
  function No(t) {
    this._internalRoot = t;
  }
  No.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var i = Vt();
      t = { blockedOn: null, target: t, priority: i };
      for (var w = 0; w < V.length && i !== 0 && i < V[w].priority; w++) ;
      V.splice(w, 0, t), w === 0 && lt(t);
    }
  };
  function Sl(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function Do(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11 && (t.nodeType !== 8 || t.nodeValue !== " react-mount-point-unstable "));
  }
  function rc() {
  }
  function Jd(t, i, w, N, ae) {
    if (ae) {
      if (typeof N == "function") {
        var ye = N;
        N = function() {
          var ht = Lo(ze);
          ye.call(ht);
        };
      }
      var ze = Jh(i, N, t, 0, null, !1, !1, "", rc);
      return t._reactRootContainer = ze, t[hn] = ze.current, as(t.nodeType === 8 ? t.parentNode : t), ha(), ze;
    }
    for (; ae = t.lastChild; ) t.removeChild(ae);
    if (typeof N == "function") {
      var Qe = N;
      N = function() {
        var ht = Lo(rt);
        Qe.call(ht);
      };
    }
    var rt = yl(t, 0, !1, null, null, !1, !1, "", rc);
    return t._reactRootContainer = rt, t[hn] = rt.current, as(t.nodeType === 8 ? t.parentNode : t), ha(function() {
      Oo(i, rt, w, N);
    }), rt;
  }
  function Bo(t, i, w, N, ae) {
    var ye = w._reactRootContainer;
    if (ye) {
      var ze = ye;
      if (typeof ae == "function") {
        var Qe = ae;
        ae = function() {
          var rt = Lo(ze);
          Qe.call(rt);
        };
      }
      Oo(i, ze, t, ae);
    } else ze = Jd(w, i, t, ae, N);
    return Lo(ze);
  }
  Qi = function(t) {
    switch (t.tag) {
      case 3:
        var i = t.stateNode;
        if (i.current.memoizedState.isDehydrated) {
          var w = kr(i.pendingLanes);
          w !== 0 && (Xi(i, w | 1), di(i, Pt()), (ir & 6) === 0 && (Ga = Pt() + 500, On()));
        }
        break;
      case 13:
        ha(function() {
          var N = vn(t, 1);
          if (N !== null) {
            var ae = si();
            Wi(N, t, 1, ae);
          }
        }), wl(t, 1);
    }
  }, _i = function(t) {
    if (t.tag === 13) {
      var i = vn(t, 134217728);
      if (i !== null) {
        var w = si();
        Wi(i, t, 134217728, w);
      }
      wl(t, 134217728);
    }
  }, ni = function(t) {
    if (t.tag === 13) {
      var i = Fn(t), w = vn(t, i);
      if (w !== null) {
        var N = si();
        Wi(w, t, i, N);
      }
      wl(t, i);
    }
  }, Vt = function() {
    return Qt;
  }, Qr = function(t, i) {
    var w = Qt;
    try {
      return Qt = t, i();
    } finally {
      Qt = w;
    }
  }, be = function(t, i, w) {
    switch (i) {
      case "input":
        if (Ne(t, w), i = w.name, w.type === "radio" && i != null) {
          for (w = t; w.parentNode; ) w = w.parentNode;
          for (w = w.querySelectorAll("input[name=" + JSON.stringify("" + i) + '][type="radio"]'), i = 0; i < w.length; i++) {
            var N = w[i];
            if (N !== t && N.form === t.form) {
              var ae = Js(N);
              if (!ae) throw Error(ne(90));
              $e(N), Ne(N, ae);
            }
          }
        }
        break;
      case "textarea":
        G(t, w);
        break;
      case "select":
        i = w.value, i != null && Ce(t, !!w.multiple, i, !1);
    }
  }, m = dl, oe = ha;
  var ep = { usingClientEntryPoint: !1, Events: [us, Ma, Js, Se, le, dl] }, Ss = { findFiberByHostInstance: ia, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, tp = { bundleType: Ss.bundleType, version: Ss.version, rendererPackageName: Ss.rendererPackageName, rendererConfig: Ss.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: S.ReactCurrentDispatcher, findHostInstanceByFiber: function(t) {
    return t = ct(t), t === null ? null : t.stateNode;
  }, findFiberByHostInstance: Ss.findFiberByHostInstance || $d, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var zo = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!zo.isDisabled && zo.supportsFiber) try {
      wt = zo.inject(tp), $t = zo;
    } catch {
    }
  }
  return pi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ep, pi.createPortal = function(t, i) {
    var w = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Sl(i)) throw Error(ne(200));
    return Kd(t, i, null, w);
  }, pi.createRoot = function(t, i) {
    if (!Sl(t)) throw Error(ne(299));
    var w = !1, N = "", ae = tc;
    return i != null && (i.unstable_strictMode === !0 && (w = !0), i.identifierPrefix !== void 0 && (N = i.identifierPrefix), i.onRecoverableError !== void 0 && (ae = i.onRecoverableError)), i = yl(t, 1, !1, null, null, w, !1, N, ae), t[hn] = i.current, as(t.nodeType === 8 ? t.parentNode : t), new bl(i);
  }, pi.findDOMNode = function(t) {
    if (t == null) return null;
    if (t.nodeType === 1) return t;
    var i = t._reactInternals;
    if (i === void 0)
      throw typeof t.render == "function" ? Error(ne(188)) : (t = Object.keys(t).join(","), Error(ne(268, t)));
    return t = ct(i), t = t === null ? null : t.stateNode, t;
  }, pi.flushSync = function(t) {
    return ha(t);
  }, pi.hydrate = function(t, i, w) {
    if (!Do(i)) throw Error(ne(200));
    return Bo(null, t, i, !0, w);
  }, pi.hydrateRoot = function(t, i, w) {
    if (!Sl(t)) throw Error(ne(405));
    var N = w != null && w.hydratedSources || null, ae = !1, ye = "", ze = tc;
    if (w != null && (w.unstable_strictMode === !0 && (ae = !0), w.identifierPrefix !== void 0 && (ye = w.identifierPrefix), w.onRecoverableError !== void 0 && (ze = w.onRecoverableError)), i = Jh(i, null, t, 1, w ?? null, ae, !1, ye, ze), t[hn] = i.current, as(t), N) for (t = 0; t < N.length; t++) w = N[t], ae = w._getVersion, ae = ae(w._source), i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [w, ae] : i.mutableSourceEagerHydrationData.push(
      w,
      ae
    );
    return new No(i);
  }, pi.render = function(t, i, w) {
    if (!Do(i)) throw Error(ne(200));
    return Bo(null, t, i, !1, w);
  }, pi.unmountComponentAtNode = function(t) {
    if (!Do(t)) throw Error(ne(40));
    return t._reactRootContainer ? (ha(function() {
      Bo(null, null, t, !1, function() {
        t._reactRootContainer = null, t[hn] = null;
      });
    }), !0) : !1;
  }, pi.unstable_batchedUpdates = dl, pi.unstable_renderSubtreeIntoContainer = function(t, i, w, N) {
    if (!Do(w)) throw Error(ne(200));
    if (t == null || t._reactInternals === void 0) throw Error(ne(38));
    return Bo(t, i, w, !1, N);
  }, pi.version = "18.3.1-next-f1338f8080-20240426", pi;
}
var fc;
function fp() {
  if (fc) return Cl.exports;
  fc = 1;
  function Me() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(Me);
      } catch (ge) {
        console.error(ge);
      }
  }
  return Me(), Cl.exports = lp(), Cl.exports;
}
var hc;
function hp() {
  if (hc) return Fo;
  hc = 1;
  var Me = fp();
  return Fo.createRoot = Me.createRoot, Fo.hydrateRoot = Me.hydrateRoot, Fo;
}
var cp = hp();
const dp = /* @__PURE__ */ Yo(cp), rf = () => {
  const Me = document.getElementById("product-info"), ge = JSON.parse((Me == null ? void 0 : Me.textContent) || "{}");
  return window.shineon = window.shineon || {}, window.shineon.product_info = ge, ge;
}, nf = () => {
  const Me = rf();
  return pp(Me);
}, pp = (Me) => {
  var ge;
  return !Me.shop_cf || !((ge = Me.shop_pt_id_obj) != null && ge.custom_fields) ? [] : Me.shop_pt_id_obj.custom_fields.map((ne) => ({
    ...Me.shop_cf[ne.key],
    id: ne
  }));
}, vp = ({ hasErrors: Me, setUserInteracted: ge }) => (Xt.useEffect(() => {
  const ne = Array.from(document.querySelectorAll('form[action="/cart/add"]')).filter(
    (Z) => Z.querySelector('button[type="submit"]')
  );
  if (!ne.length) return;
  const C = () => {
    ge(!0);
  };
  return ne.forEach((Z) => {
    Z.querySelectorAll(".so-validation-mask").forEach((P) => P.remove());
  }), Me ? ne.forEach((Z) => {
    const _ = Z.querySelector('button[type="submit"]');
    if (!_) return;
    const P = _.parentElement;
    if (!P) return;
    P.style.position = "relative";
    const x = document.createElement("div");
    x.className = "so-validation-mask", x.addEventListener("click", C), P.appendChild(x);
  }) : ge(!1), () => {
    ne.forEach((Z) => {
      Z.querySelectorAll(".so-validation-mask").forEach((P) => {
        P.removeEventListener("click", C), P.remove();
      });
    });
  };
}, [Me]), null), mp = ({ uploads: Me, validationErrors: ge, hasErrors: ne, setUserInteracted: C }) => (Xt.useEffect(() => {
  const Z = Array.from(document.querySelectorAll("form")).filter(
    (_) => _.querySelector('button[type="submit"]')
  );
  Z.length && Z.forEach((_) => {
    const P = _.querySelector('input[name="properties[Upload]"]');
    if (P && P.remove(), Me.Upload) {
      const x = document.createElement("input");
      x.type = "hidden", x.name = "properties[Upload]", x.value = Me.Upload, _.appendChild(x);
    }
  });
}, [Me.Upload]), /* @__PURE__ */ ft.jsx(
  vp,
  {
    validationErrors: ge,
    hasErrors: ne,
    setUserInteracted: C
  }
)), af = rf();
let Tl = af.selected_variant;
const gp = {
  get variantInputs() {
    return document.querySelectorAll(af.variant_id_input);
  }
}, _p = () => {
  const Me = document.querySelectorAll('form[action="/cart/add"]');
  return Array.from(Me).map((ge) => ge.getAttribute("id"));
}, yp = () => (Tl || gp.variantInputs.forEach((Me) => {
  if (Me) {
    const ge = parseInt(Me.value);
    Tl = af.product.variants.find((ne) => ne.id === ge);
  }
}), Tl), wp = ({ product_cf: Me, required: ge, formId: ne, onBeforeInput: C, onChange: Z }) => {
  const _ = (P, x) => ({
    type: "text",
    id: P.id.key,
    name: `properties[${P.name}]`,
    autoComplete: "off",
    placeholder: P.placeholder,
    form: x,
    pattern: P.pattern,
    required: ge,
    className: `so-field__input ${P.class || ""}`,
    minLength: P.minlength > 0 ? P.minlength : void 0,
    maxLength: P.maxlength > 0 ? P.maxlength : 20,
    onBeforeInput: C,
    onChange: Z
  });
  return /* @__PURE__ */ ft.jsx("input", { ..._(Me, ne) });
}, bp = {
  first: ["t", "a", "f", "h", "b"],
  last: ["w", "e", "t", "i", "o", "s", "d", "f", "h", "k", "l", "z", "b", "q"]
}, Sp = ({ previewConfig: Me, inputs: ge, product_cf: ne, metalType: C }) => {
  var g, f, p;
  const Z = Me.chains || {}, _ = Me.fields[0].class, P = _.includes("graduation") ? !1 : ((g = Z.left) == null ? void 0 : g[C]) || ((f = Z.right) == null ? void 0 : f[C]) || ((p = Z.vertical) == null ? void 0 : p[C]), x = (s) => {
    var A, T, R, L;
    const S = (ge[s.id.key] || s.name).replace(/\s+/g, ""), b = ((L = (R = (T = (A = Me.symbolAtEnd) == null ? void 0 : A[0]) == null ? void 0 : T.options) == null ? void 0 : R[0]) == null ? void 0 : L.code) || "";
    return (Me.flowerSymbol || "") + S + b;
  }, y = x(ne), E = y.length >= 2, d = (s, S) => {
    if (!S) return "";
    const b = S.toLowerCase();
    return bp[s].includes(b) ? `${s}-letter-${b}` : "";
  }, l = d("first", y[0]), u = d("last", y[y.length - 1]), a = (s) => {
    const S = Array.isArray(s) ? s : [s], b = `preview-items-${S.length}`;
    return /* @__PURE__ */ ft.jsx("div", { className: `preview-w ${_} ${b}`, children: S.map((o, A) => /* @__PURE__ */ ft.jsxs("div", { className: `preview-item preview-item-${A + 1}`, children: [
      /* @__PURE__ */ ft.jsx("span", { className: `preview ${_}`, children: x(o) }),
      /* @__PURE__ */ ft.jsx("span", { className: `preview colored-with-gradient ${_} preview-mask`, children: x(o) })
    ] }, o.id.key)) });
  }, n = (s) => {
    var A, T;
    const S = Me.isVertical ? "vertical" : s, o = (Array.isArray(Me.inputFields) ? Me.inputFields : [ne]).length;
    if (Me.isVertical && o > 1) {
      const R = Object.keys(Z.vertical.multiple).find((L) => parseInt(L) === o);
      if (R)
        return /* @__PURE__ */ ft.jsx(
          "img",
          {
            src: (A = Z.vertical.multiple[R]) == null ? void 0 : A[C],
            className: `chain-${s}`,
            alt: `${s.charAt(0).toUpperCase() + s.slice(1)} chain for ${o} items`,
            "data-metal": C,
            "data-items": o
          }
        );
    }
    return /* @__PURE__ */ ft.jsx(
      "img",
      {
        src: (T = Z[S]) == null ? void 0 : T[C],
        className: `chain-${s}`,
        alt: `${s.charAt(0).toUpperCase() + s.slice(1)} chain`,
        "data-metal": C
      }
    );
  }, c = (s = !1) => {
    const S = document.querySelector(".preview-vertical"), b = S == null ? void 0 : S.querySelector(".chain-vertical"), o = S == null ? void 0 : S.querySelector(".preview-w");
    if (!b || !o || !S) return;
    const A = b.offsetWidth + o.offsetWidth, T = 10, R = A + T;
    (!S.style.minHeight || s.type === "load") && (S.style.minHeight = `${R}px`), S.style.height = `${A + T}px`;
  };
  return Xt.useEffect(() => {
    c();
  }, [y]), Xt.useEffect(() => {
    const s = (S) => {
      c(S);
    };
    return window.addEventListener("load", s), () => {
      window.removeEventListener("load", s);
      const S = document.querySelector(".preview-vertical");
      S && (S.style.height = "");
    };
  }, []), /* @__PURE__ */ ft.jsx(
    "div",
    {
      className: `font-preview-w ${P ? "w-chains" : ""} ${Me.isVertical ? "vertical" : ""}`,
      "data-metal": C,
      children: /* @__PURE__ */ ft.jsx("div", { className: `position-wrap ${Me.isVertical ? "preview-vertical" : ""}`, children: P ? /* @__PURE__ */ ft.jsx(ft.Fragment, { children: Me.isVertical ? /* @__PURE__ */ ft.jsxs(ft.Fragment, { children: [
        /* @__PURE__ */ ft.jsx("span", { className: `font-preview-chain chain-vertical ${_}`, children: n("vertical") }),
        a(Me.inputFields || ne)
      ] }) : /* @__PURE__ */ ft.jsxs(ft.Fragment, { children: [
        /* @__PURE__ */ ft.jsx("span", { className: `font-preview-chain chain-left ${_} ${l}`, children: n("left") }),
        a(Me.inputFields || ne),
        /* @__PURE__ */ ft.jsx(
          "span",
          {
            className: `font-preview-chain chain-right ${_} ${u}`,
            style: { opacity: E ? 1 : 0 },
            children: n("right")
          }
        )
      ] }) }) : a(Me.inputFields || ne) })
    }
  );
}, Ep = ({ previewSelectionConfig: Me, index: ge, setSelectedAccessory: ne }) => {
  const C = Me.selection.isMultiple[ge];
  return handleAccessoryChange = (Z) => {
    const _ = Z.target.value;
    ne(_);
  }, /* @__PURE__ */ ft.jsx("div", { className: "so-accessories", children: /* @__PURE__ */ ft.jsx("div", { className: `so-${C.field_type}-container`, children: /* @__PURE__ */ ft.jsx("div", { className: "so-options-grid sm", children: /* @__PURE__ */ ft.jsx("ul", { className: "so-accessories-list", children: C.options.map((Z) => {
    var _;
    return /* @__PURE__ */ ft.jsxs("li", { children: [
      /* @__PURE__ */ ft.jsx(
        "input",
        {
          type: "radio",
          name: C.name,
          id: `${C.name}-${Z}`,
          value: Z,
          style: { position: "absolute", opacity: 0 },
          onChange: handleAccessoryChange
        }
      ),
      /* @__PURE__ */ ft.jsxs("label", { className: "so-accessory-option", htmlFor: `${C.name}-${Z}`, children: [
        /* @__PURE__ */ ft.jsx(
          "div",
          {
            className: `so-custom-field-birthstone-circle ${Z} no-loop ${(_ = C.class) != null && _.includes("engraving") ? "no-loop" : ""}`,
            children: /* @__PURE__ */ ft.jsx("span", { className: "visually-hidden", children: Z })
          }
        ),
        /* @__PURE__ */ ft.jsx("span", { children: Z })
      ] })
    ] }, Z);
  }) }) }) }, C.field_type) });
}, xp = ({ productCustomFields: Me, productInfo: ge, metalType: ne, index: C, inputs: Z, product_cf: _ }) => {
  var u, a, n;
  const [P, x] = Xt.useState("January"), y = Me.filter(
    (c) => c.field_type === "birthstone" && c.class === "so-birthstone-input"
  ), E = Me.filter(
    (c) => c.field_type === "custom" && c.class === "so-birthstone-input"
  ), d = {
    selection: {
      birthstones: y,
      isMultiple: E
    },
    itemPreview: ((u = ge.product_metafields) == null ? void 0 : u.item_preview) || !1
  }, l = !!((n = (a = d.selection) == null ? void 0 : a.birthstones) != null && n.length);
  return /* @__PURE__ */ ft.jsxs("div", { className: "preview-with-selection flex", children: [
    /* @__PURE__ */ ft.jsxs("div", { className: "so-item-preview-w", children: [
      /* @__PURE__ */ ft.jsx("div", { className: `selected-accessory ${P}` }),
      /* @__PURE__ */ ft.jsx("div", { className: "input-preview", children: Z[_.id.key] || "" }),
      /* @__PURE__ */ ft.jsx("img", { className: "so-item", src: d.itemPreview[ne], alt: "" })
    ] }),
    l && /* @__PURE__ */ ft.jsx(
      Ep,
      {
        previewSelectionConfig: d,
        index: C,
        setSelectedAccessory: x
      }
    )
  ] });
}, Cp = ({ currentVariant: Me, productInfo: ge, previewConfig: ne, inputs: C, metalType: Z }) => {
  const _ = ne.engraving.imgSrc, P = ne.engraving.zone, x = Xt.useRef(null), [y, E] = Xt.useState(!1), d = async () => {
    const c = ne.engraving;
    if (!(c != null && c.font)) return !1;
    const { family: g, size: f, weight: p, url: s, style: S = "normal" } = c.font;
    if (!g || !f || !p || !(s != null && s[0])) return !1;
    const b = () => document.fonts.check(`${p} ${f} ${g}`);
    if (b())
      return E(!0), !0;
    try {
      const A = await new FontFace(g, `url(${s[0]})`, {
        style: S,
        weight: p,
        display: "swap"
      }).load();
      return document.fonts.add(A), await document.fonts.ready, E(!0), !0;
    } catch (o) {
      return console.error("Font loading failed:", o), new Promise((A) => {
        let R = 0;
        const L = () => {
          R++, b() ? (E(!0), A(!0)) : R < 3 ? setTimeout(L, 500) : (console.error("Font failed to load after 3 attempts"), A(!1));
        };
        L();
      });
    }
  }, l = (c, g, f, p, s) => {
    const S = f.zoneWidth, b = p === 1 ? f.zoneHeight : f.zoneHeight * 0.5;
    let o = 1, A = 2e3, T = null;
    for (; o <= A; ) {
      const L = Math.floor((o + A) / 2);
      c.font = `${L}px ${c.font.split(" ").slice(-1)}`;
      const z = c.measureText(g), U = z.width / s, J = Math.max(z.actualBoundingBoxAscent + z.actualBoundingBoxDescent, L);
      if (U > S || J > b)
        A = L - 1;
      else if (U < S * 0.95)
        o = L + 1;
      else {
        T = L;
        break;
      }
    }
    return T || Math.min(A, o);
  }, u = (c, g, f, p, s) => {
    const S = f.x;
    let b;
    const o = 30, A = p, T = f.y - p / 2 - (f.y + p / 2);
    if (g === 1)
      b = f.y;
    else if (T > -132) {
      const R = A * 2 + o, L = f.y - R / 2;
      c === 0 ? b = L + A / 2 : b = L + A * 1.5 + o;
    } else
      c === 0 ? b = f.y - f.zoneHeight / 4 : b = f.y + f.zoneHeight / 4;
    return { x: S, y: b };
  }, a = (c) => c === "gold" ? {
    color: "#9c7539",
    shadowColor: "rgba(0, 0, 0, 0.4)",
    shadowBlur: 2,
    shadowOffsetX: 1,
    shadowOffsetY: 1
  } : {
    color: "rgba(0, 0, 0, 0.6)",
    shadowColor: "rgba(0, 0, 0, 0.4)",
    shadowBlur: 2,
    shadowOffsetX: 1,
    shadowOffsetY: 1
  }, n = async (c, g, f) => {
    c.clearRect(0, 0, g.width, g.height), c.drawImage(f, 0, 0);
    const p = ne.engraving;
    if (!P || !(p != null && p.font) || !y) return;
    const s = P, S = Object.values(C).filter(Boolean), { family: b, weight: o } = p.font, A = p.font.multiplier || 1, T = ne.inputFields.length < 2 ? ["Your Words"] : ["Your Words", "Here"], R = S.length ? S : T, L = R.reduce((J, F) => J.length >= F.length ? J : F), z = l(c, L, s, R.length, A);
    c.font = `${o} ${z}px "${b}"`, c.textAlign = s.textAlign || "center", c.textBaseline = "middle";
    const U = [];
    R.forEach((J, F) => {
      const se = u(F, R.length, s, z);
      let ee = se.x;
      s.textAlign === "right" ? ee = se.x + s.zoneWidth / 2 : s.textAlign === "left" && (ee = se.x - s.zoneWidth / 2), U.push({
        x: se.x,
        // Store original position for debug box
        y: se.y,
        width: s.zoneWidth
      });
      const ie = a(Z);
      c.font = `${o} ${z}px "${b}"`, c.textAlign = s.textAlign || "center", c.textBaseline = "middle", c.fillStyle = ie.color, c.shadowColor = ie.shadowColor, c.shadowBlur = z * 0.02, c.shadowOffsetX = z * 0.01, c.shadowOffsetY = z * 0.01, c.fillText(J, ee, se.y);
    });
  };
  return Xt.useEffect(() => {
    d();
  }, []), Xt.useEffect(() => {
    const c = x.current, g = c.getContext("2d"), f = new Image(), p = async () => {
      c.width = f.width, c.height = f.height, await n(g, c, f);
    };
    return f.onload = p, f.src = _, () => {
      f.onload = null;
    };
  }, [_, C, Z, y]), /* @__PURE__ */ ft.jsx("div", { className: "engraving-preview", children: /* @__PURE__ */ ft.jsx("canvas", { ref: x, className: "engraving-canvas" }) });
}, kp = (Me, ge = !1) => Me ? ge ? Me.charAt(0).toUpperCase() + Me.slice(1).toLowerCase() : Me : "", Ap = ({
  previewConfig: Me,
  currentVariant: ge,
  productInfo: ne,
  productCustomFields: C,
  formId: Z,
  inputFields: _,
  inputs: P,
  setInputs: x,
  validationErrors: y,
  showErrors: E
}) => {
  var f;
  const [d, l] = Xt.useState({}), [u, a] = Xt.useState({});
  Xt.useEffect(() => {
    const p = _.slice(0, ne.variant_metafields[ge.id].engravings || _.length).map((b) => b.id.key), s = Object.entries(P).reduce((b, [o, A]) => (p.includes(o) && (b[o] = A), b), {});
    x(s);
    const S = Object.entries(s).reduce((b, [o, A]) => (b[o] = (A == null ? void 0 : A.length) || 0, b), {});
    l(S);
  }, [ge.id]), Xt.useEffect(() => {
    if (E && y.inputs.length > 0 && y.upload.length === 0) {
      const p = document.querySelectorAll(".so-field-wrapper.error");
      p.length > 0 && p[0].scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [E, y.inputs, y.upload]);
  const n = ((f = ne.variant_metafields[ge.id]) == null ? void 0 : f.metal) || "stainless", c = (p) => {
    const s = p.target.value, S = Me.fields.length > 0, b = kp(s, S);
    p.target.value = b, l((o) => ({
      ...o,
      [p.target.id]: b.length
    })), x((o) => ({
      ...o,
      [p.target.id]: b
    }));
  }, g = (p, s) => {
    const S = s.pattern;
    S && (new RegExp(S).test(p.data) ? a((o) => ({
      ...o,
      [s.id.key]: {
        show: !1,
        symbol: ""
      }
    })) : (p.preventDefault(), a((o) => ({
      ...o,
      [s.id.key]: {
        show: !0,
        symbol: p.data
      }
    }))));
  };
  return /* @__PURE__ */ ft.jsxs(ft.Fragment, { children: [
    _.slice(0, ne.variant_metafields[ge.id].engravings || _.length).map((p, s) => {
      var S, b;
      return /* @__PURE__ */ ft.jsxs(
        "div",
        {
          className: `so-field-wrapper ${E && y.inputs.includes(p.id.key) ? "error" : ""}`,
          children: [
            /* @__PURE__ */ ft.jsx("label", { className: "so-form__label", children: p.name }),
            /* @__PURE__ */ ft.jsx("div", { className: "so-field", children: /* @__PURE__ */ ft.jsxs("div", { className: "so-input-counter-w", children: [
              /* @__PURE__ */ ft.jsx(
                wp,
                {
                  product_cf: p,
                  formId: Z,
                  required: p.required,
                  onChange: (o) => c(o),
                  onBeforeInput: (o) => g(o, p)
                }
              ),
              ((S = u[p.id.key]) == null ? void 0 : S.show) && /* @__PURE__ */ ft.jsxs("span", { className: "so-wrong-input-notification", children: [
                'Invalid character: "',
                u[p.id.key].symbol,
                '"'
              ] }),
              !((b = u[p.id.key]) != null && b.show) && /* @__PURE__ */ ft.jsxs(
                "span",
                {
                  className: `so-counter ${d[p.id.key] ? "so-input-filled" : ""}`,
                  children: [
                    d[p.id.key] || 0,
                    "/",
                    p.maxlength || 20
                  ]
                }
              )
            ] }) }),
            Me.itemPreview && /* @__PURE__ */ ft.jsx(
              xp,
              {
                productCustomFields: C,
                productInfo: ne,
                metalType: n,
                index: s,
                inputs: P,
                product_cf: p
              }
            )
          ]
        },
        `input-field-${p.id.key}`
      );
    }),
    Me.engraving.imgSrc && /* @__PURE__ */ ft.jsx(
      Cp,
      {
        currentVariant: ge,
        productInfo: ne,
        previewConfig: Me,
        inputs: P,
        metalType: n
      }
    ),
    Me.fields.length > 0 && /* @__PURE__ */ ft.jsx(
      Sp,
      {
        previewConfig: Me,
        inputs: P,
        product_cf: _[0],
        metalType: n
      }
    )
  ] });
};
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function cc(Me, ge) {
  var ne = Object.keys(Me);
  if (Object.getOwnPropertySymbols) {
    var C = Object.getOwnPropertySymbols(Me);
    ge && (C = C.filter(function(Z) {
      return Object.getOwnPropertyDescriptor(Me, Z).enumerable;
    })), ne.push.apply(ne, C);
  }
  return ne;
}
function Zc(Me) {
  for (var ge = 1; ge < arguments.length; ge++) {
    var ne = arguments[ge] != null ? arguments[ge] : {};
    ge % 2 ? cc(Object(ne), !0).forEach(function(C) {
      Ip(Me, C, ne[C]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Me, Object.getOwnPropertyDescriptors(ne)) : cc(Object(ne)).forEach(function(C) {
      Object.defineProperty(Me, C, Object.getOwnPropertyDescriptor(ne, C));
    });
  }
  return Me;
}
function Tp(Me, ge) {
  if (typeof Me != "object" || !Me) return Me;
  var ne = Me[Symbol.toPrimitive];
  if (ne !== void 0) {
    var C = ne.call(Me, ge);
    if (typeof C != "object") return C;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Me);
}
function Yc(Me) {
  var ge = Tp(Me, "string");
  return typeof ge == "symbol" ? ge : ge + "";
}
function Wl(Me) {
  "@babel/helpers - typeof";
  return Wl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ge) {
    return typeof ge;
  } : function(ge) {
    return ge && typeof Symbol == "function" && ge.constructor === Symbol && ge !== Symbol.prototype ? "symbol" : typeof ge;
  }, Wl(Me);
}
function Pp(Me, ge) {
  if (!(Me instanceof ge))
    throw new TypeError("Cannot call a class as a function");
}
function dc(Me, ge) {
  for (var ne = 0; ne < ge.length; ne++) {
    var C = ge[ne];
    C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(Me, Yc(C.key), C);
  }
}
function Mp(Me, ge, ne) {
  return ge && dc(Me.prototype, ge), ne && dc(Me, ne), Object.defineProperty(Me, "prototype", {
    writable: !1
  }), Me;
}
function Ip(Me, ge, ne) {
  return ge = Yc(ge), ge in Me ? Object.defineProperty(Me, ge, {
    value: ne,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Me[ge] = ne, Me;
}
function Xc(Me) {
  return Rp(Me) || Op(Me) || Lp(Me) || Np();
}
function Rp(Me) {
  if (Array.isArray(Me)) return Zl(Me);
}
function Op(Me) {
  if (typeof Symbol < "u" && Me[Symbol.iterator] != null || Me["@@iterator"] != null) return Array.from(Me);
}
function Lp(Me, ge) {
  if (Me) {
    if (typeof Me == "string") return Zl(Me, ge);
    var ne = Object.prototype.toString.call(Me).slice(8, -1);
    if (ne === "Object" && Me.constructor && (ne = Me.constructor.name), ne === "Map" || ne === "Set") return Array.from(Me);
    if (ne === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ne)) return Zl(Me, ge);
  }
}
function Zl(Me, ge) {
  (ge == null || ge > Me.length) && (ge = Me.length);
  for (var ne = 0, C = new Array(ge); ne < ge; ne++) C[ne] = Me[ne];
  return C;
}
function Np() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Xo = typeof window < "u" && typeof window.document < "u", on = Xo ? window : {}, sf = Xo && on.document.documentElement ? "ontouchstart" in on.document.documentElement : !1, of = Xo ? "PointerEvent" in on : !1, gr = "cropper", uf = "all", qc = "crop", Qc = "move", Kc = "zoom", va = "e", ma = "w", Wa = "s", Gn = "n", xs = "ne", Cs = "nw", ks = "se", As = "sw", Yl = "".concat(gr, "-crop"), pc = "".concat(gr, "-disabled"), mi = "".concat(gr, "-hidden"), vc = "".concat(gr, "-hide"), Dp = "".concat(gr, "-invisible"), Wo = "".concat(gr, "-modal"), Xl = "".concat(gr, "-move"), Rs = "".concat(gr, "Action"), Uo = "".concat(gr, "Preview"), lf = "crop", $c = "move", Jc = "none", ql = "crop", Ql = "cropend", Kl = "cropmove", $l = "cropstart", mc = "dblclick", Bp = sf ? "touchstart" : "mousedown", zp = sf ? "touchmove" : "mousemove", Fp = sf ? "touchend touchcancel" : "mouseup", gc = of ? "pointerdown" : Bp, _c = of ? "pointermove" : zp, yc = of ? "pointerup pointercancel" : Fp, wc = "ready", bc = "resize", Sc = "wheel", Jl = "zoom", Ec = "image/jpeg", Up = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, jp = /^data:/, Hp = /^data:image\/jpeg;base64,/, Gp = /^img|canvas$/i, ed = 200, td = 100, xc = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: lf,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: ed,
  minContainerHeight: td,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Vp = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Wp = Number.isNaN || on.isNaN;
function Jt(Me) {
  return typeof Me == "number" && !Wp(Me);
}
var Cc = function(ge) {
  return ge > 0 && ge < 1 / 0;
};
function Pl(Me) {
  return typeof Me > "u";
}
function _a(Me) {
  return Wl(Me) === "object" && Me !== null;
}
var Zp = Object.prototype.hasOwnProperty;
function Za(Me) {
  if (!_a(Me))
    return !1;
  try {
    var ge = Me.constructor, ne = ge.prototype;
    return ge && ne && Zp.call(ne, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function vi(Me) {
  return typeof Me == "function";
}
var Yp = Array.prototype.slice;
function rd(Me) {
  return Array.from ? Array.from(Me) : Yp.call(Me);
}
function Rr(Me, ge) {
  return Me && vi(ge) && (Array.isArray(Me) || Jt(Me.length) ? rd(Me).forEach(function(ne, C) {
    ge.call(Me, ne, C, Me);
  }) : _a(Me) && Object.keys(Me).forEach(function(ne) {
    ge.call(Me, Me[ne], ne, Me);
  })), Me;
}
var _r = Object.assign || function(ge) {
  for (var ne = arguments.length, C = new Array(ne > 1 ? ne - 1 : 0), Z = 1; Z < ne; Z++)
    C[Z - 1] = arguments[Z];
  return _a(ge) && C.length > 0 && C.forEach(function(_) {
    _a(_) && Object.keys(_).forEach(function(P) {
      ge[P] = _[P];
    });
  }), ge;
}, Xp = /\.\d*(?:0|9){12}\d*$/;
function Xa(Me) {
  var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Xp.test(Me) ? Math.round(Me * ge) / ge : Me;
}
var qp = /^width|height|left|top|marginLeft|marginTop$/;
function Wn(Me, ge) {
  var ne = Me.style;
  Rr(ge, function(C, Z) {
    qp.test(Z) && Jt(C) && (C = "".concat(C, "px")), ne[Z] = C;
  });
}
function Qp(Me, ge) {
  return Me.classList ? Me.classList.contains(ge) : Me.className.indexOf(ge) > -1;
}
function Wr(Me, ge) {
  if (ge) {
    if (Jt(Me.length)) {
      Rr(Me, function(C) {
        Wr(C, ge);
      });
      return;
    }
    if (Me.classList) {
      Me.classList.add(ge);
      return;
    }
    var ne = Me.className.trim();
    ne ? ne.indexOf(ge) < 0 && (Me.className = "".concat(ne, " ").concat(ge)) : Me.className = ge;
  }
}
function sn(Me, ge) {
  if (ge) {
    if (Jt(Me.length)) {
      Rr(Me, function(ne) {
        sn(ne, ge);
      });
      return;
    }
    if (Me.classList) {
      Me.classList.remove(ge);
      return;
    }
    Me.className.indexOf(ge) >= 0 && (Me.className = Me.className.replace(ge, ""));
  }
}
function Ya(Me, ge, ne) {
  if (ge) {
    if (Jt(Me.length)) {
      Rr(Me, function(C) {
        Ya(C, ge, ne);
      });
      return;
    }
    ne ? Wr(Me, ge) : sn(Me, ge);
  }
}
var Kp = /([a-z\d])([A-Z])/g;
function ff(Me) {
  return Me.replace(Kp, "$1-$2").toLowerCase();
}
function ef(Me, ge) {
  return _a(Me[ge]) ? Me[ge] : Me.dataset ? Me.dataset[ge] : Me.getAttribute("data-".concat(ff(ge)));
}
function Os(Me, ge, ne) {
  _a(ne) ? Me[ge] = ne : Me.dataset ? Me.dataset[ge] = ne : Me.setAttribute("data-".concat(ff(ge)), ne);
}
function $p(Me, ge) {
  if (_a(Me[ge]))
    try {
      delete Me[ge];
    } catch {
      Me[ge] = void 0;
    }
  else if (Me.dataset)
    try {
      delete Me.dataset[ge];
    } catch {
      Me.dataset[ge] = void 0;
    }
  else
    Me.removeAttribute("data-".concat(ff(ge)));
}
var id = /\s\s*/, nd = function() {
  var Me = !1;
  if (Xo) {
    var ge = !1, ne = function() {
    }, C = Object.defineProperty({}, "once", {
      get: function() {
        return Me = !0, ge;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(_) {
        ge = _;
      }
    });
    on.addEventListener("test", ne, C), on.removeEventListener("test", ne, C);
  }
  return Me;
}();
function Zi(Me, ge, ne) {
  var C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Z = ne;
  ge.trim().split(id).forEach(function(_) {
    if (!nd) {
      var P = Me.listeners;
      P && P[_] && P[_][ne] && (Z = P[_][ne], delete P[_][ne], Object.keys(P[_]).length === 0 && delete P[_], Object.keys(P).length === 0 && delete Me.listeners);
    }
    Me.removeEventListener(_, Z, C);
  });
}
function Ni(Me, ge, ne) {
  var C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Z = ne;
  ge.trim().split(id).forEach(function(_) {
    if (C.once && !nd) {
      var P = Me.listeners, x = P === void 0 ? {} : P;
      Z = function() {
        delete x[_][ne], Me.removeEventListener(_, Z, C);
        for (var E = arguments.length, d = new Array(E), l = 0; l < E; l++)
          d[l] = arguments[l];
        ne.apply(Me, d);
      }, x[_] || (x[_] = {}), x[_][ne] && Me.removeEventListener(_, x[_][ne], C), x[_][ne] = Z, Me.listeners = x;
    }
    Me.addEventListener(_, Z, C);
  });
}
function qa(Me, ge, ne) {
  var C;
  return vi(Event) && vi(CustomEvent) ? C = new CustomEvent(ge, {
    detail: ne,
    bubbles: !0,
    cancelable: !0
  }) : (C = document.createEvent("CustomEvent"), C.initCustomEvent(ge, !0, !0, ne)), Me.dispatchEvent(C);
}
function ad(Me) {
  var ge = Me.getBoundingClientRect();
  return {
    left: ge.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: ge.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var Ml = on.location, Jp = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function kc(Me) {
  var ge = Me.match(Jp);
  return ge !== null && (ge[1] !== Ml.protocol || ge[2] !== Ml.hostname || ge[3] !== Ml.port);
}
function Ac(Me) {
  var ge = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return Me + (Me.indexOf("?") === -1 ? "?" : "&") + ge;
}
function Is(Me) {
  var ge = Me.rotate, ne = Me.scaleX, C = Me.scaleY, Z = Me.translateX, _ = Me.translateY, P = [];
  Jt(Z) && Z !== 0 && P.push("translateX(".concat(Z, "px)")), Jt(_) && _ !== 0 && P.push("translateY(".concat(_, "px)")), Jt(ge) && ge !== 0 && P.push("rotate(".concat(ge, "deg)")), Jt(ne) && ne !== 1 && P.push("scaleX(".concat(ne, ")")), Jt(C) && C !== 1 && P.push("scaleY(".concat(C, ")"));
  var x = P.length ? P.join(" ") : "none";
  return {
    WebkitTransform: x,
    msTransform: x,
    transform: x
  };
}
function e0(Me) {
  var ge = Zc({}, Me), ne = 0;
  return Rr(Me, function(C, Z) {
    delete ge[Z], Rr(ge, function(_) {
      var P = Math.abs(C.startX - _.startX), x = Math.abs(C.startY - _.startY), y = Math.abs(C.endX - _.endX), E = Math.abs(C.endY - _.endY), d = Math.sqrt(P * P + x * x), l = Math.sqrt(y * y + E * E), u = (l - d) / d;
      Math.abs(u) > Math.abs(ne) && (ne = u);
    });
  }), ne;
}
function jo(Me, ge) {
  var ne = Me.pageX, C = Me.pageY, Z = {
    endX: ne,
    endY: C
  };
  return ge ? Z : Zc({
    startX: ne,
    startY: C
  }, Z);
}
function t0(Me) {
  var ge = 0, ne = 0, C = 0;
  return Rr(Me, function(Z) {
    var _ = Z.startX, P = Z.startY;
    ge += _, ne += P, C += 1;
  }), ge /= C, ne /= C, {
    pageX: ge,
    pageY: ne
  };
}
function Zn(Me) {
  var ge = Me.aspectRatio, ne = Me.height, C = Me.width, Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", _ = Cc(C), P = Cc(ne);
  if (_ && P) {
    var x = ne * ge;
    Z === "contain" && x > C || Z === "cover" && x < C ? ne = C / ge : C = ne * ge;
  } else _ ? ne = C / ge : P && (C = ne * ge);
  return {
    width: C,
    height: ne
  };
}
function r0(Me) {
  var ge = Me.width, ne = Me.height, C = Me.degree;
  if (C = Math.abs(C) % 180, C === 90)
    return {
      width: ne,
      height: ge
    };
  var Z = C % 90 * Math.PI / 180, _ = Math.sin(Z), P = Math.cos(Z), x = ge * P + ne * _, y = ge * _ + ne * P;
  return C > 90 ? {
    width: y,
    height: x
  } : {
    width: x,
    height: y
  };
}
function i0(Me, ge, ne, C) {
  var Z = ge.aspectRatio, _ = ge.naturalWidth, P = ge.naturalHeight, x = ge.rotate, y = x === void 0 ? 0 : x, E = ge.scaleX, d = E === void 0 ? 1 : E, l = ge.scaleY, u = l === void 0 ? 1 : l, a = ne.aspectRatio, n = ne.naturalWidth, c = ne.naturalHeight, g = C.fillColor, f = g === void 0 ? "transparent" : g, p = C.imageSmoothingEnabled, s = p === void 0 ? !0 : p, S = C.imageSmoothingQuality, b = S === void 0 ? "low" : S, o = C.maxWidth, A = o === void 0 ? 1 / 0 : o, T = C.maxHeight, R = T === void 0 ? 1 / 0 : T, L = C.minWidth, z = L === void 0 ? 0 : L, U = C.minHeight, J = U === void 0 ? 0 : U, F = document.createElement("canvas"), se = F.getContext("2d"), ee = Zn({
    aspectRatio: a,
    width: A,
    height: R
  }), ie = Zn({
    aspectRatio: a,
    width: z,
    height: J
  }, "cover"), W = Math.min(ee.width, Math.max(ie.width, n)), Q = Math.min(ee.height, Math.max(ie.height, c)), de = Zn({
    aspectRatio: Z,
    width: A,
    height: R
  }), _e = Zn({
    aspectRatio: Z,
    width: z,
    height: J
  }, "cover"), ke = Math.min(de.width, Math.max(_e.width, _)), Pe = Math.min(de.height, Math.max(_e.height, P)), fe = [-ke / 2, -Pe / 2, ke, Pe];
  return F.width = Xa(W), F.height = Xa(Q), se.fillStyle = f, se.fillRect(0, 0, W, Q), se.save(), se.translate(W / 2, Q / 2), se.rotate(y * Math.PI / 180), se.scale(d, u), se.imageSmoothingEnabled = s, se.imageSmoothingQuality = b, se.drawImage.apply(se, [Me].concat(Xc(fe.map(function(xe) {
    return Math.floor(Xa(xe));
  })))), se.restore(), F;
}
var sd = String.fromCharCode;
function n0(Me, ge, ne) {
  var C = "";
  ne += ge;
  for (var Z = ge; Z < ne; Z += 1)
    C += sd(Me.getUint8(Z));
  return C;
}
var a0 = /^data:.*,/;
function s0(Me) {
  var ge = Me.replace(a0, ""), ne = atob(ge), C = new ArrayBuffer(ne.length), Z = new Uint8Array(C);
  return Rr(Z, function(_, P) {
    Z[P] = ne.charCodeAt(P);
  }), C;
}
function o0(Me, ge) {
  for (var ne = [], C = 8192, Z = new Uint8Array(Me); Z.length > 0; )
    ne.push(sd.apply(null, rd(Z.subarray(0, C)))), Z = Z.subarray(C);
  return "data:".concat(ge, ";base64,").concat(btoa(ne.join("")));
}
function u0(Me) {
  var ge = new DataView(Me), ne;
  try {
    var C, Z, _;
    if (ge.getUint8(0) === 255 && ge.getUint8(1) === 216)
      for (var P = ge.byteLength, x = 2; x + 1 < P; ) {
        if (ge.getUint8(x) === 255 && ge.getUint8(x + 1) === 225) {
          Z = x;
          break;
        }
        x += 1;
      }
    if (Z) {
      var y = Z + 4, E = Z + 10;
      if (n0(ge, y, 4) === "Exif") {
        var d = ge.getUint16(E);
        if (C = d === 18761, (C || d === 19789) && ge.getUint16(E + 2, C) === 42) {
          var l = ge.getUint32(E + 4, C);
          l >= 8 && (_ = E + l);
        }
      }
    }
    if (_) {
      var u = ge.getUint16(_, C), a, n;
      for (n = 0; n < u; n += 1)
        if (a = _ + n * 12 + 2, ge.getUint16(a, C) === 274) {
          a += 8, ne = ge.getUint16(a, C), ge.setUint16(a, 1, C);
          break;
        }
    }
  } catch {
    ne = 1;
  }
  return ne;
}
function l0(Me) {
  var ge = 0, ne = 1, C = 1;
  switch (Me) {
    // Flip horizontal
    case 2:
      ne = -1;
      break;
    // Rotate left 180°
    case 3:
      ge = -180;
      break;
    // Flip vertical
    case 4:
      C = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      ge = 90, C = -1;
      break;
    // Rotate right 90°
    case 6:
      ge = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      ge = 90, ne = -1;
      break;
    // Rotate left 90°
    case 8:
      ge = -90;
      break;
  }
  return {
    rotate: ge,
    scaleX: ne,
    scaleY: C
  };
}
var f0 = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var ge = this.element, ne = this.options, C = this.container, Z = this.cropper, _ = Number(ne.minContainerWidth), P = Number(ne.minContainerHeight);
    Wr(Z, mi), sn(ge, mi);
    var x = {
      width: Math.max(C.offsetWidth, _ >= 0 ? _ : ed),
      height: Math.max(C.offsetHeight, P >= 0 ? P : td)
    };
    this.containerData = x, Wn(Z, {
      width: x.width,
      height: x.height
    }), Wr(ge, mi), sn(Z, mi);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var ge = this.containerData, ne = this.imageData, C = this.options.viewMode, Z = Math.abs(ne.rotate) % 180 === 90, _ = Z ? ne.naturalHeight : ne.naturalWidth, P = Z ? ne.naturalWidth : ne.naturalHeight, x = _ / P, y = ge.width, E = ge.height;
    ge.height * x > ge.width ? C === 3 ? y = ge.height * x : E = ge.width / x : C === 3 ? E = ge.width / x : y = ge.height * x;
    var d = {
      aspectRatio: x,
      naturalWidth: _,
      naturalHeight: P,
      width: y,
      height: E
    };
    this.canvasData = d, this.limited = C === 1 || C === 2, this.limitCanvas(!0, !0), d.width = Math.min(Math.max(d.width, d.minWidth), d.maxWidth), d.height = Math.min(Math.max(d.height, d.minHeight), d.maxHeight), d.left = (ge.width - d.width) / 2, d.top = (ge.height - d.height) / 2, d.oldLeft = d.left, d.oldTop = d.top, this.initialCanvasData = _r({}, d);
  },
  limitCanvas: function(ge, ne) {
    var C = this.options, Z = this.containerData, _ = this.canvasData, P = this.cropBoxData, x = C.viewMode, y = _.aspectRatio, E = this.cropped && P;
    if (ge) {
      var d = Number(C.minCanvasWidth) || 0, l = Number(C.minCanvasHeight) || 0;
      x > 1 ? (d = Math.max(d, Z.width), l = Math.max(l, Z.height), x === 3 && (l * y > d ? d = l * y : l = d / y)) : x > 0 && (d ? d = Math.max(d, E ? P.width : 0) : l ? l = Math.max(l, E ? P.height : 0) : E && (d = P.width, l = P.height, l * y > d ? d = l * y : l = d / y));
      var u = Zn({
        aspectRatio: y,
        width: d,
        height: l
      });
      d = u.width, l = u.height, _.minWidth = d, _.minHeight = l, _.maxWidth = 1 / 0, _.maxHeight = 1 / 0;
    }
    if (ne)
      if (x > (E ? 0 : 1)) {
        var a = Z.width - _.width, n = Z.height - _.height;
        _.minLeft = Math.min(0, a), _.minTop = Math.min(0, n), _.maxLeft = Math.max(0, a), _.maxTop = Math.max(0, n), E && this.limited && (_.minLeft = Math.min(P.left, P.left + (P.width - _.width)), _.minTop = Math.min(P.top, P.top + (P.height - _.height)), _.maxLeft = P.left, _.maxTop = P.top, x === 2 && (_.width >= Z.width && (_.minLeft = Math.min(0, a), _.maxLeft = Math.max(0, a)), _.height >= Z.height && (_.minTop = Math.min(0, n), _.maxTop = Math.max(0, n))));
      } else
        _.minLeft = -_.width, _.minTop = -_.height, _.maxLeft = Z.width, _.maxTop = Z.height;
  },
  renderCanvas: function(ge, ne) {
    var C = this.canvasData, Z = this.imageData;
    if (ne) {
      var _ = r0({
        width: Z.naturalWidth * Math.abs(Z.scaleX || 1),
        height: Z.naturalHeight * Math.abs(Z.scaleY || 1),
        degree: Z.rotate || 0
      }), P = _.width, x = _.height, y = C.width * (P / C.naturalWidth), E = C.height * (x / C.naturalHeight);
      C.left -= (y - C.width) / 2, C.top -= (E - C.height) / 2, C.width = y, C.height = E, C.aspectRatio = P / x, C.naturalWidth = P, C.naturalHeight = x, this.limitCanvas(!0, !1);
    }
    (C.width > C.maxWidth || C.width < C.minWidth) && (C.left = C.oldLeft), (C.height > C.maxHeight || C.height < C.minHeight) && (C.top = C.oldTop), C.width = Math.min(Math.max(C.width, C.minWidth), C.maxWidth), C.height = Math.min(Math.max(C.height, C.minHeight), C.maxHeight), this.limitCanvas(!1, !0), C.left = Math.min(Math.max(C.left, C.minLeft), C.maxLeft), C.top = Math.min(Math.max(C.top, C.minTop), C.maxTop), C.oldLeft = C.left, C.oldTop = C.top, Wn(this.canvas, _r({
      width: C.width,
      height: C.height
    }, Is({
      translateX: C.left,
      translateY: C.top
    }))), this.renderImage(ge), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(ge) {
    var ne = this.canvasData, C = this.imageData, Z = C.naturalWidth * (ne.width / ne.naturalWidth), _ = C.naturalHeight * (ne.height / ne.naturalHeight);
    _r(C, {
      width: Z,
      height: _,
      left: (ne.width - Z) / 2,
      top: (ne.height - _) / 2
    }), Wn(this.image, _r({
      width: C.width,
      height: C.height
    }, Is(_r({
      translateX: C.left,
      translateY: C.top
    }, C)))), ge && this.output();
  },
  initCropBox: function() {
    var ge = this.options, ne = this.canvasData, C = ge.aspectRatio || ge.initialAspectRatio, Z = Number(ge.autoCropArea) || 0.8, _ = {
      width: ne.width,
      height: ne.height
    };
    C && (ne.height * C > ne.width ? _.height = _.width / C : _.width = _.height * C), this.cropBoxData = _, this.limitCropBox(!0, !0), _.width = Math.min(Math.max(_.width, _.minWidth), _.maxWidth), _.height = Math.min(Math.max(_.height, _.minHeight), _.maxHeight), _.width = Math.max(_.minWidth, _.width * Z), _.height = Math.max(_.minHeight, _.height * Z), _.left = ne.left + (ne.width - _.width) / 2, _.top = ne.top + (ne.height - _.height) / 2, _.oldLeft = _.left, _.oldTop = _.top, this.initialCropBoxData = _r({}, _);
  },
  limitCropBox: function(ge, ne) {
    var C = this.options, Z = this.containerData, _ = this.canvasData, P = this.cropBoxData, x = this.limited, y = C.aspectRatio;
    if (ge) {
      var E = Number(C.minCropBoxWidth) || 0, d = Number(C.minCropBoxHeight) || 0, l = x ? Math.min(Z.width, _.width, _.width + _.left, Z.width - _.left) : Z.width, u = x ? Math.min(Z.height, _.height, _.height + _.top, Z.height - _.top) : Z.height;
      E = Math.min(E, Z.width), d = Math.min(d, Z.height), y && (E && d ? d * y > E ? d = E / y : E = d * y : E ? d = E / y : d && (E = d * y), u * y > l ? u = l / y : l = u * y), P.minWidth = Math.min(E, l), P.minHeight = Math.min(d, u), P.maxWidth = l, P.maxHeight = u;
    }
    ne && (x ? (P.minLeft = Math.max(0, _.left), P.minTop = Math.max(0, _.top), P.maxLeft = Math.min(Z.width, _.left + _.width) - P.width, P.maxTop = Math.min(Z.height, _.top + _.height) - P.height) : (P.minLeft = 0, P.minTop = 0, P.maxLeft = Z.width - P.width, P.maxTop = Z.height - P.height));
  },
  renderCropBox: function() {
    var ge = this.options, ne = this.containerData, C = this.cropBoxData;
    (C.width > C.maxWidth || C.width < C.minWidth) && (C.left = C.oldLeft), (C.height > C.maxHeight || C.height < C.minHeight) && (C.top = C.oldTop), C.width = Math.min(Math.max(C.width, C.minWidth), C.maxWidth), C.height = Math.min(Math.max(C.height, C.minHeight), C.maxHeight), this.limitCropBox(!1, !0), C.left = Math.min(Math.max(C.left, C.minLeft), C.maxLeft), C.top = Math.min(Math.max(C.top, C.minTop), C.maxTop), C.oldLeft = C.left, C.oldTop = C.top, ge.movable && ge.cropBoxMovable && Os(this.face, Rs, C.width >= ne.width && C.height >= ne.height ? Qc : uf), Wn(this.cropBox, _r({
      width: C.width,
      height: C.height
    }, Is({
      translateX: C.left,
      translateY: C.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), qa(this.element, ql, this.getData());
  }
}, h0 = {
  initPreview: function() {
    var ge = this.element, ne = this.crossOrigin, C = this.options.preview, Z = ne ? this.crossOriginUrl : this.url, _ = ge.alt || "The image to preview", P = document.createElement("img");
    if (ne && (P.crossOrigin = ne), P.src = Z, P.alt = _, this.viewBox.appendChild(P), this.viewBoxImage = P, !!C) {
      var x = C;
      typeof C == "string" ? x = ge.ownerDocument.querySelectorAll(C) : C.querySelector && (x = [C]), this.previews = x, Rr(x, function(y) {
        var E = document.createElement("img");
        Os(y, Uo, {
          width: y.offsetWidth,
          height: y.offsetHeight,
          html: y.innerHTML
        }), ne && (E.crossOrigin = ne), E.src = Z, E.alt = _, E.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', y.innerHTML = "", y.appendChild(E);
      });
    }
  },
  resetPreview: function() {
    Rr(this.previews, function(ge) {
      var ne = ef(ge, Uo);
      Wn(ge, {
        width: ne.width,
        height: ne.height
      }), ge.innerHTML = ne.html, $p(ge, Uo);
    });
  },
  preview: function() {
    var ge = this.imageData, ne = this.canvasData, C = this.cropBoxData, Z = C.width, _ = C.height, P = ge.width, x = ge.height, y = C.left - ne.left - ge.left, E = C.top - ne.top - ge.top;
    !this.cropped || this.disabled || (Wn(this.viewBoxImage, _r({
      width: P,
      height: x
    }, Is(_r({
      translateX: -y,
      translateY: -E
    }, ge)))), Rr(this.previews, function(d) {
      var l = ef(d, Uo), u = l.width, a = l.height, n = u, c = a, g = 1;
      Z && (g = u / Z, c = _ * g), _ && c > a && (g = a / _, n = Z * g, c = a), Wn(d, {
        width: n,
        height: c
      }), Wn(d.getElementsByTagName("img")[0], _r({
        width: P * g,
        height: x * g
      }, Is(_r({
        translateX: -y * g,
        translateY: -E * g
      }, ge))));
    }));
  }
}, c0 = {
  bind: function() {
    var ge = this.element, ne = this.options, C = this.cropper;
    vi(ne.cropstart) && Ni(ge, $l, ne.cropstart), vi(ne.cropmove) && Ni(ge, Kl, ne.cropmove), vi(ne.cropend) && Ni(ge, Ql, ne.cropend), vi(ne.crop) && Ni(ge, ql, ne.crop), vi(ne.zoom) && Ni(ge, Jl, ne.zoom), Ni(C, gc, this.onCropStart = this.cropStart.bind(this)), ne.zoomable && ne.zoomOnWheel && Ni(C, Sc, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), ne.toggleDragModeOnDblclick && Ni(C, mc, this.onDblclick = this.dblclick.bind(this)), Ni(ge.ownerDocument, _c, this.onCropMove = this.cropMove.bind(this)), Ni(ge.ownerDocument, yc, this.onCropEnd = this.cropEnd.bind(this)), ne.responsive && Ni(window, bc, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var ge = this.element, ne = this.options, C = this.cropper;
    vi(ne.cropstart) && Zi(ge, $l, ne.cropstart), vi(ne.cropmove) && Zi(ge, Kl, ne.cropmove), vi(ne.cropend) && Zi(ge, Ql, ne.cropend), vi(ne.crop) && Zi(ge, ql, ne.crop), vi(ne.zoom) && Zi(ge, Jl, ne.zoom), Zi(C, gc, this.onCropStart), ne.zoomable && ne.zoomOnWheel && Zi(C, Sc, this.onWheel, {
      passive: !1,
      capture: !0
    }), ne.toggleDragModeOnDblclick && Zi(C, mc, this.onDblclick), Zi(ge.ownerDocument, _c, this.onCropMove), Zi(ge.ownerDocument, yc, this.onCropEnd), ne.responsive && Zi(window, bc, this.onResize);
  }
}, d0 = {
  resize: function() {
    if (!this.disabled) {
      var ge = this.options, ne = this.container, C = this.containerData, Z = ne.offsetWidth / C.width, _ = ne.offsetHeight / C.height, P = Math.abs(Z - 1) > Math.abs(_ - 1) ? Z : _;
      if (P !== 1) {
        var x, y;
        ge.restore && (x = this.getCanvasData(), y = this.getCropBoxData()), this.render(), ge.restore && (this.setCanvasData(Rr(x, function(E, d) {
          x[d] = E * P;
        })), this.setCropBoxData(Rr(y, function(E, d) {
          y[d] = E * P;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === Jc || this.setDragMode(Qp(this.dragBox, Yl) ? $c : lf);
  },
  wheel: function(ge) {
    var ne = this, C = Number(this.options.wheelZoomRatio) || 0.1, Z = 1;
    this.disabled || (ge.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      ne.wheeling = !1;
    }, 50), ge.deltaY ? Z = ge.deltaY > 0 ? 1 : -1 : ge.wheelDelta ? Z = -ge.wheelDelta / 120 : ge.detail && (Z = ge.detail > 0 ? 1 : -1), this.zoom(-Z * C, ge)));
  },
  cropStart: function(ge) {
    var ne = ge.buttons, C = ge.button;
    if (!(this.disabled || (ge.type === "mousedown" || ge.type === "pointerdown" && ge.pointerType === "mouse") && // No primary button (Usually the left button)
    (Jt(ne) && ne !== 1 || Jt(C) && C !== 0 || ge.ctrlKey))) {
      var Z = this.options, _ = this.pointers, P;
      ge.changedTouches ? Rr(ge.changedTouches, function(x) {
        _[x.identifier] = jo(x);
      }) : _[ge.pointerId || 0] = jo(ge), Object.keys(_).length > 1 && Z.zoomable && Z.zoomOnTouch ? P = Kc : P = ef(ge.target, Rs), Up.test(P) && qa(this.element, $l, {
        originalEvent: ge,
        action: P
      }) !== !1 && (ge.preventDefault(), this.action = P, this.cropping = !1, P === qc && (this.cropping = !0, Wr(this.dragBox, Wo)));
    }
  },
  cropMove: function(ge) {
    var ne = this.action;
    if (!(this.disabled || !ne)) {
      var C = this.pointers;
      ge.preventDefault(), qa(this.element, Kl, {
        originalEvent: ge,
        action: ne
      }) !== !1 && (ge.changedTouches ? Rr(ge.changedTouches, function(Z) {
        _r(C[Z.identifier] || {}, jo(Z, !0));
      }) : _r(C[ge.pointerId || 0] || {}, jo(ge, !0)), this.change(ge));
    }
  },
  cropEnd: function(ge) {
    if (!this.disabled) {
      var ne = this.action, C = this.pointers;
      ge.changedTouches ? Rr(ge.changedTouches, function(Z) {
        delete C[Z.identifier];
      }) : delete C[ge.pointerId || 0], ne && (ge.preventDefault(), Object.keys(C).length || (this.action = ""), this.cropping && (this.cropping = !1, Ya(this.dragBox, Wo, this.cropped && this.options.modal)), qa(this.element, Ql, {
        originalEvent: ge,
        action: ne
      }));
    }
  }
}, p0 = {
  change: function(ge) {
    var ne = this.options, C = this.canvasData, Z = this.containerData, _ = this.cropBoxData, P = this.pointers, x = this.action, y = ne.aspectRatio, E = _.left, d = _.top, l = _.width, u = _.height, a = E + l, n = d + u, c = 0, g = 0, f = Z.width, p = Z.height, s = !0, S;
    !y && ge.shiftKey && (y = l && u ? l / u : 1), this.limited && (c = _.minLeft, g = _.minTop, f = c + Math.min(Z.width, C.width, C.left + C.width), p = g + Math.min(Z.height, C.height, C.top + C.height));
    var b = P[Object.keys(P)[0]], o = {
      x: b.endX - b.startX,
      y: b.endY - b.startY
    }, A = function(R) {
      switch (R) {
        case va:
          a + o.x > f && (o.x = f - a);
          break;
        case ma:
          E + o.x < c && (o.x = c - E);
          break;
        case Gn:
          d + o.y < g && (o.y = g - d);
          break;
        case Wa:
          n + o.y > p && (o.y = p - n);
          break;
      }
    };
    switch (x) {
      // Move crop box
      case uf:
        E += o.x, d += o.y;
        break;
      // Resize crop box
      case va:
        if (o.x >= 0 && (a >= f || y && (d <= g || n >= p))) {
          s = !1;
          break;
        }
        A(va), l += o.x, l < 0 && (x = ma, l = -l, E -= l), y && (u = l / y, d += (_.height - u) / 2);
        break;
      case Gn:
        if (o.y <= 0 && (d <= g || y && (E <= c || a >= f))) {
          s = !1;
          break;
        }
        A(Gn), u -= o.y, d += o.y, u < 0 && (x = Wa, u = -u, d -= u), y && (l = u * y, E += (_.width - l) / 2);
        break;
      case ma:
        if (o.x <= 0 && (E <= c || y && (d <= g || n >= p))) {
          s = !1;
          break;
        }
        A(ma), l -= o.x, E += o.x, l < 0 && (x = va, l = -l, E -= l), y && (u = l / y, d += (_.height - u) / 2);
        break;
      case Wa:
        if (o.y >= 0 && (n >= p || y && (E <= c || a >= f))) {
          s = !1;
          break;
        }
        A(Wa), u += o.y, u < 0 && (x = Gn, u = -u, d -= u), y && (l = u * y, E += (_.width - l) / 2);
        break;
      case xs:
        if (y) {
          if (o.y <= 0 && (d <= g || a >= f)) {
            s = !1;
            break;
          }
          A(Gn), u -= o.y, d += o.y, l = u * y;
        } else
          A(Gn), A(va), o.x >= 0 ? a < f ? l += o.x : o.y <= 0 && d <= g && (s = !1) : l += o.x, o.y <= 0 ? d > g && (u -= o.y, d += o.y) : (u -= o.y, d += o.y);
        l < 0 && u < 0 ? (x = As, u = -u, l = -l, d -= u, E -= l) : l < 0 ? (x = Cs, l = -l, E -= l) : u < 0 && (x = ks, u = -u, d -= u);
        break;
      case Cs:
        if (y) {
          if (o.y <= 0 && (d <= g || E <= c)) {
            s = !1;
            break;
          }
          A(Gn), u -= o.y, d += o.y, l = u * y, E += _.width - l;
        } else
          A(Gn), A(ma), o.x <= 0 ? E > c ? (l -= o.x, E += o.x) : o.y <= 0 && d <= g && (s = !1) : (l -= o.x, E += o.x), o.y <= 0 ? d > g && (u -= o.y, d += o.y) : (u -= o.y, d += o.y);
        l < 0 && u < 0 ? (x = ks, u = -u, l = -l, d -= u, E -= l) : l < 0 ? (x = xs, l = -l, E -= l) : u < 0 && (x = As, u = -u, d -= u);
        break;
      case As:
        if (y) {
          if (o.x <= 0 && (E <= c || n >= p)) {
            s = !1;
            break;
          }
          A(ma), l -= o.x, E += o.x, u = l / y;
        } else
          A(Wa), A(ma), o.x <= 0 ? E > c ? (l -= o.x, E += o.x) : o.y >= 0 && n >= p && (s = !1) : (l -= o.x, E += o.x), o.y >= 0 ? n < p && (u += o.y) : u += o.y;
        l < 0 && u < 0 ? (x = xs, u = -u, l = -l, d -= u, E -= l) : l < 0 ? (x = ks, l = -l, E -= l) : u < 0 && (x = Cs, u = -u, d -= u);
        break;
      case ks:
        if (y) {
          if (o.x >= 0 && (a >= f || n >= p)) {
            s = !1;
            break;
          }
          A(va), l += o.x, u = l / y;
        } else
          A(Wa), A(va), o.x >= 0 ? a < f ? l += o.x : o.y >= 0 && n >= p && (s = !1) : l += o.x, o.y >= 0 ? n < p && (u += o.y) : u += o.y;
        l < 0 && u < 0 ? (x = Cs, u = -u, l = -l, d -= u, E -= l) : l < 0 ? (x = As, l = -l, E -= l) : u < 0 && (x = xs, u = -u, d -= u);
        break;
      // Move canvas
      case Qc:
        this.move(o.x, o.y), s = !1;
        break;
      // Zoom canvas
      case Kc:
        this.zoom(e0(P), ge), s = !1;
        break;
      // Create crop box
      case qc:
        if (!o.x || !o.y) {
          s = !1;
          break;
        }
        S = ad(this.cropper), E = b.startX - S.left, d = b.startY - S.top, l = _.minWidth, u = _.minHeight, o.x > 0 ? x = o.y > 0 ? ks : xs : o.x < 0 && (E -= l, x = o.y > 0 ? As : Cs), o.y < 0 && (d -= u), this.cropped || (sn(this.cropBox, mi), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    s && (_.width = l, _.height = u, _.left = E, _.top = d, this.action = x, this.renderCropBox()), Rr(P, function(T) {
      T.startX = T.endX, T.startY = T.endY;
    });
  }
}, v0 = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && Wr(this.dragBox, Wo), sn(this.cropBox, mi), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = _r({}, this.initialImageData), this.canvasData = _r({}, this.initialCanvasData), this.cropBoxData = _r({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (_r(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), sn(this.dragBox, Wo), Wr(this.cropBox, mi)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(ge) {
    var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && ge && (this.isImg && (this.element.src = ge), ne ? (this.url = ge, this.image.src = ge, this.ready && (this.viewBoxImage.src = ge, Rr(this.previews, function(C) {
      C.getElementsByTagName("img")[0].src = ge;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(ge))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, sn(this.cropper, pc)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, Wr(this.cropper, pc)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var ge = this.element;
    return ge[gr] ? (ge[gr] = void 0, this.isImg && this.replaced && (ge.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(ge) {
    var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge, C = this.canvasData, Z = C.left, _ = C.top;
    return this.moveTo(Pl(ge) ? ge : Z + Number(ge), Pl(ne) ? ne : _ + Number(ne));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(ge) {
    var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge, C = this.canvasData, Z = !1;
    return ge = Number(ge), ne = Number(ne), this.ready && !this.disabled && this.options.movable && (Jt(ge) && (C.left = ge, Z = !0), Jt(ne) && (C.top = ne, Z = !0), Z && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(ge, ne) {
    var C = this.canvasData;
    return ge = Number(ge), ge < 0 ? ge = 1 / (1 - ge) : ge = 1 + ge, this.zoomTo(C.width * ge / C.naturalWidth, null, ne);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(ge, ne, C) {
    var Z = this.options, _ = this.canvasData, P = _.width, x = _.height, y = _.naturalWidth, E = _.naturalHeight;
    if (ge = Number(ge), ge >= 0 && this.ready && !this.disabled && Z.zoomable) {
      var d = y * ge, l = E * ge;
      if (qa(this.element, Jl, {
        ratio: ge,
        oldRatio: P / y,
        originalEvent: C
      }) === !1)
        return this;
      if (C) {
        var u = this.pointers, a = ad(this.cropper), n = u && Object.keys(u).length ? t0(u) : {
          pageX: C.pageX,
          pageY: C.pageY
        };
        _.left -= (d - P) * ((n.pageX - a.left - _.left) / P), _.top -= (l - x) * ((n.pageY - a.top - _.top) / x);
      } else Za(ne) && Jt(ne.x) && Jt(ne.y) ? (_.left -= (d - P) * ((ne.x - _.left) / P), _.top -= (l - x) * ((ne.y - _.top) / x)) : (_.left -= (d - P) / 2, _.top -= (l - x) / 2);
      _.width = d, _.height = l, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(ge) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(ge));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(ge) {
    return ge = Number(ge), Jt(ge) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = ge % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(ge) {
    var ne = this.imageData.scaleY;
    return this.scale(ge, Jt(ne) ? ne : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(ge) {
    var ne = this.imageData.scaleX;
    return this.scale(Jt(ne) ? ne : 1, ge);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(ge) {
    var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge, C = this.imageData, Z = !1;
    return ge = Number(ge), ne = Number(ne), this.ready && !this.disabled && this.options.scalable && (Jt(ge) && (C.scaleX = ge, Z = !0), Jt(ne) && (C.scaleY = ne, Z = !0), Z && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, ne = this.options, C = this.imageData, Z = this.canvasData, _ = this.cropBoxData, P;
    if (this.ready && this.cropped) {
      P = {
        x: _.left - Z.left,
        y: _.top - Z.top,
        width: _.width,
        height: _.height
      };
      var x = C.width / C.naturalWidth;
      if (Rr(P, function(d, l) {
        P[l] = d / x;
      }), ge) {
        var y = Math.round(P.y + P.height), E = Math.round(P.x + P.width);
        P.x = Math.round(P.x), P.y = Math.round(P.y), P.width = E - P.x, P.height = y - P.y;
      }
    } else
      P = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return ne.rotatable && (P.rotate = C.rotate || 0), ne.scalable && (P.scaleX = C.scaleX || 1, P.scaleY = C.scaleY || 1), P;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(ge) {
    var ne = this.options, C = this.imageData, Z = this.canvasData, _ = {};
    if (this.ready && !this.disabled && Za(ge)) {
      var P = !1;
      ne.rotatable && Jt(ge.rotate) && ge.rotate !== C.rotate && (C.rotate = ge.rotate, P = !0), ne.scalable && (Jt(ge.scaleX) && ge.scaleX !== C.scaleX && (C.scaleX = ge.scaleX, P = !0), Jt(ge.scaleY) && ge.scaleY !== C.scaleY && (C.scaleY = ge.scaleY, P = !0)), P && this.renderCanvas(!0, !0);
      var x = C.width / C.naturalWidth;
      Jt(ge.x) && (_.left = ge.x * x + Z.left), Jt(ge.y) && (_.top = ge.y * x + Z.top), Jt(ge.width) && (_.width = ge.width * x), Jt(ge.height) && (_.height = ge.height * x), this.setCropBoxData(_);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? _r({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? _r({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var ge = this.canvasData, ne = {};
    return this.ready && Rr(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(C) {
      ne[C] = ge[C];
    }), ne;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(ge) {
    var ne = this.canvasData, C = ne.aspectRatio;
    return this.ready && !this.disabled && Za(ge) && (Jt(ge.left) && (ne.left = ge.left), Jt(ge.top) && (ne.top = ge.top), Jt(ge.width) ? (ne.width = ge.width, ne.height = ge.width / C) : Jt(ge.height) && (ne.height = ge.height, ne.width = ge.height * C), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var ge = this.cropBoxData, ne;
    return this.ready && this.cropped && (ne = {
      left: ge.left,
      top: ge.top,
      width: ge.width,
      height: ge.height
    }), ne || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(ge) {
    var ne = this.cropBoxData, C = this.options.aspectRatio, Z, _;
    return this.ready && this.cropped && !this.disabled && Za(ge) && (Jt(ge.left) && (ne.left = ge.left), Jt(ge.top) && (ne.top = ge.top), Jt(ge.width) && ge.width !== ne.width && (Z = !0, ne.width = ge.width), Jt(ge.height) && ge.height !== ne.height && (_ = !0, ne.height = ge.height), C && (Z ? ne.height = ne.width / C : _ && (ne.width = ne.height * C)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var ne = this.canvasData, C = i0(this.image, this.imageData, ne, ge);
    if (!this.cropped)
      return C;
    var Z = this.getData(ge.rounded), _ = Z.x, P = Z.y, x = Z.width, y = Z.height, E = C.width / Math.floor(ne.naturalWidth);
    E !== 1 && (_ *= E, P *= E, x *= E, y *= E);
    var d = x / y, l = Zn({
      aspectRatio: d,
      width: ge.maxWidth || 1 / 0,
      height: ge.maxHeight || 1 / 0
    }), u = Zn({
      aspectRatio: d,
      width: ge.minWidth || 0,
      height: ge.minHeight || 0
    }, "cover"), a = Zn({
      aspectRatio: d,
      width: ge.width || (E !== 1 ? C.width : x),
      height: ge.height || (E !== 1 ? C.height : y)
    }), n = a.width, c = a.height;
    n = Math.min(l.width, Math.max(u.width, n)), c = Math.min(l.height, Math.max(u.height, c));
    var g = document.createElement("canvas"), f = g.getContext("2d");
    g.width = Xa(n), g.height = Xa(c), f.fillStyle = ge.fillColor || "transparent", f.fillRect(0, 0, n, c);
    var p = ge.imageSmoothingEnabled, s = p === void 0 ? !0 : p, S = ge.imageSmoothingQuality;
    f.imageSmoothingEnabled = s, S && (f.imageSmoothingQuality = S);
    var b = C.width, o = C.height, A = _, T = P, R, L, z, U, J, F;
    A <= -x || A > b ? (A = 0, R = 0, z = 0, J = 0) : A <= 0 ? (z = -A, A = 0, R = Math.min(b, x + A), J = R) : A <= b && (z = 0, R = Math.min(x, b - A), J = R), R <= 0 || T <= -y || T > o ? (T = 0, L = 0, U = 0, F = 0) : T <= 0 ? (U = -T, T = 0, L = Math.min(o, y + T), F = L) : T <= o && (U = 0, L = Math.min(y, o - T), F = L);
    var se = [A, T, R, L];
    if (J > 0 && F > 0) {
      var ee = n / x;
      se.push(z * ee, U * ee, J * ee, F * ee);
    }
    return f.drawImage.apply(f, [C].concat(Xc(se.map(function(ie) {
      return Math.floor(Xa(ie));
    })))), g;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(ge) {
    var ne = this.options;
    return !this.disabled && !Pl(ge) && (ne.aspectRatio = Math.max(0, ge) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(ge) {
    var ne = this.options, C = this.dragBox, Z = this.face;
    if (this.ready && !this.disabled) {
      var _ = ge === lf, P = ne.movable && ge === $c;
      ge = _ || P ? ge : Jc, ne.dragMode = ge, Os(C, Rs, ge), Ya(C, Yl, _), Ya(C, Xl, P), ne.cropBoxMovable || (Os(Z, Rs, ge), Ya(Z, Yl, _), Ya(Z, Xl, P));
    }
    return this;
  }
}, m0 = on.Cropper, od = /* @__PURE__ */ function() {
  function Me(ge) {
    var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Pp(this, Me), !ge || !Gp.test(ge.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = ge, this.options = _r({}, xc, Za(ne) && ne), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return Mp(Me, [{
    key: "init",
    value: function() {
      var ne = this.element, C = ne.tagName.toLowerCase(), Z;
      if (!ne[gr]) {
        if (ne[gr] = this, C === "img") {
          if (this.isImg = !0, Z = ne.getAttribute("src") || "", this.originalUrl = Z, !Z)
            return;
          Z = ne.src;
        } else C === "canvas" && window.HTMLCanvasElement && (Z = ne.toDataURL());
        this.load(Z);
      }
    }
  }, {
    key: "load",
    value: function(ne) {
      var C = this;
      if (ne) {
        this.url = ne, this.imageData = {};
        var Z = this.element, _ = this.options;
        if (!_.rotatable && !_.scalable && (_.checkOrientation = !1), !_.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (jp.test(ne)) {
          Hp.test(ne) ? this.read(s0(ne)) : this.clone();
          return;
        }
        var P = new XMLHttpRequest(), x = this.clone.bind(this);
        this.reloading = !0, this.xhr = P, P.onabort = x, P.onerror = x, P.ontimeout = x, P.onprogress = function() {
          P.getResponseHeader("content-type") !== Ec && P.abort();
        }, P.onload = function() {
          C.read(P.response);
        }, P.onloadend = function() {
          C.reloading = !1, C.xhr = null;
        }, _.checkCrossOrigin && kc(ne) && Z.crossOrigin && (ne = Ac(ne)), P.open("GET", ne, !0), P.responseType = "arraybuffer", P.withCredentials = Z.crossOrigin === "use-credentials", P.send();
      }
    }
  }, {
    key: "read",
    value: function(ne) {
      var C = this.options, Z = this.imageData, _ = u0(ne), P = 0, x = 1, y = 1;
      if (_ > 1) {
        this.url = o0(ne, Ec);
        var E = l0(_);
        P = E.rotate, x = E.scaleX, y = E.scaleY;
      }
      C.rotatable && (Z.rotate = P), C.scalable && (Z.scaleX = x, Z.scaleY = y), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var ne = this.element, C = this.url, Z = ne.crossOrigin, _ = C;
      this.options.checkCrossOrigin && kc(C) && (Z || (Z = "anonymous"), _ = Ac(C)), this.crossOrigin = Z, this.crossOriginUrl = _;
      var P = document.createElement("img");
      Z && (P.crossOrigin = Z), P.src = _ || C, P.alt = ne.alt || "The image to crop", this.image = P, P.onload = this.start.bind(this), P.onerror = this.stop.bind(this), Wr(P, vc), ne.parentNode.insertBefore(P, ne.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var ne = this, C = this.image;
      C.onload = null, C.onerror = null, this.sizing = !0;
      var Z = on.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(on.navigator.userAgent), _ = function(E, d) {
        _r(ne.imageData, {
          naturalWidth: E,
          naturalHeight: d,
          aspectRatio: E / d
        }), ne.initialImageData = _r({}, ne.imageData), ne.sizing = !1, ne.sized = !0, ne.build();
      };
      if (C.naturalWidth && !Z) {
        _(C.naturalWidth, C.naturalHeight);
        return;
      }
      var P = document.createElement("img"), x = document.body || document.documentElement;
      this.sizingImage = P, P.onload = function() {
        _(P.width, P.height), Z || x.removeChild(P);
      }, P.src = C.src, Z || (P.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", x.appendChild(P));
    }
  }, {
    key: "stop",
    value: function() {
      var ne = this.image;
      ne.onload = null, ne.onerror = null, ne.parentNode.removeChild(ne), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var ne = this.element, C = this.options, Z = this.image, _ = ne.parentNode, P = document.createElement("div");
        P.innerHTML = Vp;
        var x = P.querySelector(".".concat(gr, "-container")), y = x.querySelector(".".concat(gr, "-canvas")), E = x.querySelector(".".concat(gr, "-drag-box")), d = x.querySelector(".".concat(gr, "-crop-box")), l = d.querySelector(".".concat(gr, "-face"));
        this.container = _, this.cropper = x, this.canvas = y, this.dragBox = E, this.cropBox = d, this.viewBox = x.querySelector(".".concat(gr, "-view-box")), this.face = l, y.appendChild(Z), Wr(ne, mi), _.insertBefore(x, ne.nextSibling), sn(Z, vc), this.initPreview(), this.bind(), C.initialAspectRatio = Math.max(0, C.initialAspectRatio) || NaN, C.aspectRatio = Math.max(0, C.aspectRatio) || NaN, C.viewMode = Math.max(0, Math.min(3, Math.round(C.viewMode))) || 0, Wr(d, mi), C.guides || Wr(d.getElementsByClassName("".concat(gr, "-dashed")), mi), C.center || Wr(d.getElementsByClassName("".concat(gr, "-center")), mi), C.background && Wr(x, "".concat(gr, "-bg")), C.highlight || Wr(l, Dp), C.cropBoxMovable && (Wr(l, Xl), Os(l, Rs, uf)), C.cropBoxResizable || (Wr(d.getElementsByClassName("".concat(gr, "-line")), mi), Wr(d.getElementsByClassName("".concat(gr, "-point")), mi)), this.render(), this.ready = !0, this.setDragMode(C.dragMode), C.autoCrop && this.crop(), this.setData(C.data), vi(C.ready) && Ni(ne, wc, C.ready, {
          once: !0
        }), qa(ne, wc);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var ne = this.cropper.parentNode;
        ne && ne.removeChild(this.cropper), sn(this.element, mi);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = m0, Me;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(ne) {
      _r(xc, Za(ne) && ne);
    }
  }]);
}();
_r(od.prototype, f0, h0, c0, d0, p0, v0);
const g0 = Xt.forwardRef(
  ({ previewContent: Me, transformationArray: ge, currentVariant: ne, transformationData: C, onFileProcessed: Z, setUserInteracted: _ }, P) => {
    const x = Xt.useRef(null), y = {
      minResolution: 500,
      upload_wrapper: ".preview-upload"
    }, E = () => C.zone_width / C.zone_height, d = () => {
      if (!C) return;
      const u = document.querySelector(".transformation-mask"), a = document.querySelector(y.upload_wrapper);
      if (!u || !a) return;
      const n = u.offsetWidth / C.width, c = u.offsetHeight / C.height;
      a.style.left = `${C.zone_offset_x * n}px`, a.style.top = `${C.zone_offset_y * c}px`, a.style.width = `${C.zone_width * n}px`, a.style.height = `${C.zone_height * c}px`;
    };
    Xt.useEffect(() => {
      if (!C) return;
      const u = new ResizeObserver(() => {
        var n;
        d(), (n = P.current) != null && n.cropper && P.current.cropper.resize();
      }), a = document.querySelector(".preview-wrapper");
      return a && u.observe(a), () => {
        u.disconnect();
      };
    }, [C]);
    const l = Xt.useCallback(async () => {
      var u;
      if (!(!(Me != null && Me.file) || !((u = P.current) != null && u.cropper)))
        try {
          const a = P.current.cropper.getCroppedCanvas({
            imageSmoothingEnabled: !0,
            imageSmoothingQuality: "high",
            maxWidth: 4096,
            maxHeight: 4096,
            fillColor: "#fff"
          }), n = await new Promise((f) => a.toBlob(f, Me.file.type, 1)), c = new File([n], Me.file.name, {
            type: Me.file.type,
            lastModified: Date.now()
          }), g = new DataTransfer();
          g.items.add(c), Z == null || Z(g.files[0]), _(!1);
        } catch (a) {
          console.error("Error processing file:", a);
        }
    }, [Me]);
    return Xt.useEffect(() => {
      if (x.current)
        return d(), P.current = {
          cropper: new od(x.current, {
            viewMode: 3,
            dragMode: "move",
            aspectRatio: E(),
            restore: !1,
            modal: !1,
            guides: !1,
            center: !1,
            highlight: !1,
            background: !1,
            autoCropArea: 1,
            wheelZoomRatio: 0.1,
            cropBoxMovable: !1,
            cropBoxResizable: !1,
            toggleDragModeOnDblclick: !1,
            minCropBoxWidth: y.minResolution,
            minCropBoxHeight: y.minResolution,
            minContainerWidth: document.querySelector(y.upload_wrapper).offsetWidth,
            minContainerHeight: document.querySelector(y.upload_wrapper).offsetHeight,
            checkOrientation: !1,
            checkCrossOrigin: !1,
            zoomOnWheel: !0,
            crop: () => {
              l();
            }
          })
        }, () => {
          var u;
          (u = P.current) != null && u.cropper && P.current.cropper.destroy();
        };
    }, [Me, ne, l]), /* @__PURE__ */ ft.jsx("div", { className: "preview-wrapper", children: /* @__PURE__ */ ft.jsxs("div", { className: `preview-container ${Me ? "has-upload" : ""}`, children: [
      /* @__PURE__ */ ft.jsx("div", { className: "preview-upload", children: Me && /* @__PURE__ */ ft.jsx(
        "img",
        {
          ref: x,
          src: Me.imageUrl,
          alt: "Uploaded preview",
          className: "preview-content uploaded-image"
        }
      ) }),
      ge && ge[1] && /* @__PURE__ */ ft.jsx(
        "img",
        {
          src: ge[1],
          alt: "Background",
          className: "preview-content transformation-mask"
        }
      )
    ] }) });
  }
), _0 = ({ itemClass: Me }) => /* @__PURE__ */ ft.jsx("div", { className: Me, children: /* @__PURE__ */ ft.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ ft.jsx(
  "path",
  {
    d: "M12 5V19M5 12H19",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) }) }), y0 = ({ itemClass: Me }) => /* @__PURE__ */ ft.jsx("div", { className: Me, children: /* @__PURE__ */ ft.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ ft.jsx("path", { d: "M5 12H19", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) }), w0 = ({ itemClass: Me }) => /* @__PURE__ */ ft.jsx("div", { className: Me, children: /* @__PURE__ */ ft.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", children: /* @__PURE__ */ ft.jsx("path", { d: "M12 8h27.711c6.739 0 12.157 5.548 11.997 12.286l-2.347 98.568C93.925 51.834 170.212 7.73 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.835 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l19.738-19.738c4.498-4.498 11.753-4.785 16.501-.552C160.213 433.246 205.895 452 256 452c108.322 0 196-87.662 196-196 0-108.322-87.662-196-196-196-79.545 0-147.941 47.282-178.675 115.302l126.389-3.009c6.737-.16 12.286 5.257 12.286 11.997V212c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.373-12-12V20C0 13.373 5.373 8 12 8z" }) }) }), Ho = {
  Plus: _0,
  Minus: y0,
  Rotate: w0
}, b0 = 0.1, S0 = ({ isUploading: Me, previewContent: ge, onFileSelect: ne, cropperRef: C }) => {
  const Z = () => Me ? "Uploading..." : ge ? "Change Image" : "Upload Image", _ = () => {
    var E;
    (E = C.current) != null && E.cropper && C.current.cropper.rotate(-15);
  }, P = () => {
    var E;
    (E = C.current) != null && E.cropper && C.current.cropper.rotate(15);
  }, x = () => {
    var E;
    (E = C.current) != null && E.cropper && C.current.cropper.zoom(b0);
  }, y = () => {
    var E;
    (E = C.current) != null && E.cropper && C.current.cropper.zoom(-0.1);
  };
  return /* @__PURE__ */ ft.jsxs("div", { className: "upload-controls", children: [
    ge && /* @__PURE__ */ ft.jsx("div", { className: "cropper-btn-section", children: /* @__PURE__ */ ft.jsxs("div", { className: "cropper-btn-group", children: [
      /* @__PURE__ */ ft.jsx("button", { className: "cropper-btn", onClick: _, type: "button", children: /* @__PURE__ */ ft.jsx(Ho.Rotate, { itemClass: "leading-[0]" }) }),
      /* @__PURE__ */ ft.jsx("button", { className: "cropper-btn rotate-right", onClick: P, type: "button", children: /* @__PURE__ */ ft.jsx(Ho.Rotate, { itemClass: "leading-[0]" }) }),
      /* @__PURE__ */ ft.jsx("button", { className: "cropper-btn", onClick: x, type: "button", children: /* @__PURE__ */ ft.jsx(Ho.Plus, { itemClass: "leading-[0]" }) }),
      /* @__PURE__ */ ft.jsx("button", { className: "cropper-btn", onClick: y, type: "button", children: /* @__PURE__ */ ft.jsx(Ho.Minus, { itemClass: "leading-[0]" }) })
    ] }) }),
    /* @__PURE__ */ ft.jsxs("div", { className: "upload-btn-wrapper", children: [
      /* @__PURE__ */ ft.jsx(
        "input",
        {
          type: "file",
          accept: "image/*",
          onChange: ne,
          className: "upload-input",
          style: { cursor: "pointer" }
        }
      ),
      /* @__PURE__ */ ft.jsx("div", { className: "upload-info-w", children: /* @__PURE__ */ ft.jsx("div", { className: "upload-info btn button", children: /* @__PURE__ */ ft.jsx("span", { className: "upload-status", children: Z() }) }) })
    ] })
  ] });
}, Go = {
  en: {
    errors: {
      invalid_character: " isn't available"
    },
    buyer_upload: {
      confirmDesign: "Confirm Design",
      confirming: "Confirming...",
      confirmed: "Confirmed"
    }
  },
  fr: {
    errors: {
      invalid_character: " n'est pas disponible"
    }
  },
  es: {
    errors: {
      invalid_character: " no está disponible"
    }
  },
  de: {
    errors: {
      invalid_character: " ist nicht verfügbar"
    }
  },
  it: {
    errors: {
      invalid_character: " non è disponibile"
    }
  },
  pt: {
    errors: {
      invalid_character: " não está disponível"
    }
  },
  ua: {
    errors: {
      invalid_character: " недоступний"
    }
  },
  pl: {
    errors: {
      invalid_character: " jest niedostępny"
    }
  }
}, E0 = () => {
  var ne;
  const Me = ((ne = window.Shopify) == null ? void 0 : ne.locale) || "en", ge = Go[Me] || Go.en;
  return new Proxy(ge, {
    get: (C, Z) => typeof C[Z] == "object" && C[Z] !== null ? new Proxy(C[Z], {
      get: (_, P) => {
        var x;
        return _[P] || ((x = Go.en[Z]) == null ? void 0 : x[P]) || `[${Z}.${P}]`;
      }
    }) : C[Z] || Go.en[Z] || `[${Z}]`
  });
}, ud = ({ registeredFile: Me, currentVariant: ge, setUploads: ne, showErrors: C, setUserInteracted: Z }) => {
  const [_, P] = Xt.useState(!1), [x, y] = Xt.useState(!1), { buyer_upload: E } = E0(), d = Xt.useCallback(async () => {
    var u;
    try {
      if (P(!0), !Me || !(ge != null && ge.id)) {
        console.error("Missing file or variant id", {
          file: Me,
          variantId: ge == null ? void 0 : ge.id
        });
        return;
      }
      const a = new FormData();
      a.append("id", ge.id), a.append("quantity", "1"), a.append("properties[Upload]", Me);
      const n = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-SO-REQUEST": "file-upload"
        },
        body: a
      });
      if (!n.ok)
        throw new Error(`File upload failed: ${n.status}`);
      const g = (u = (await n.json()).properties) == null ? void 0 : u.Upload;
      if (!g)
        throw new Error("No file URL received");
      const s = (await (await fetch("/cart.js")).json()).items.find(
        (S) => {
          var b;
          return S.id === ge.id && ((b = S.properties) == null ? void 0 : b.Upload) === g;
        }
      );
      s && await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: s.key,
          quantity: 0
        })
      }), g && (ne((S) => ({
        ...S,
        Upload: g
      })), y(!0), Z && Z(!1));
    } catch (a) {
      console.error("Failed to confirm design:", a);
    } finally {
      P(!1);
    }
  }, [Me, ge == null ? void 0 : ge.id]), l = () => x ? "so-btn-success" : C ? "so-btn-danger" : "";
  return /* @__PURE__ */ ft.jsx("div", { className: "button-row", children: /* @__PURE__ */ ft.jsx("div", { className: "design-confirmation", children: /* @__PURE__ */ ft.jsx(
    "button",
    {
      className: `btn button ${l()}`,
      onClick: d,
      disabled: _ || x,
      children: _ ? /* @__PURE__ */ ft.jsxs(ft.Fragment, { children: [
        /* @__PURE__ */ ft.jsx("svg", { className: "spinner", viewBox: "0 0 24 24", children: /* @__PURE__ */ ft.jsx("path", { d: "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" }) }),
        E.confirming
      ] }) : x ? /* @__PURE__ */ ft.jsxs(ft.Fragment, { children: [
        /* @__PURE__ */ ft.jsx("span", { children: E.confirmed }),
        /* @__PURE__ */ ft.jsx("svg", { className: "checkmark", viewBox: "0 0 16 16", children: /* @__PURE__ */ ft.jsx("path", { d: "M3 8l3.5 3.5L13 5" }) })
      ] }) : /* @__PURE__ */ ft.jsx("span", { children: E.confirmDesign })
    }
  ) }) });
}, x0 = ({ message: Me, type: ge = "error" }) => /* @__PURE__ */ ft.jsx("div", { className: `so-notification ${ge}`, children: /* @__PURE__ */ ft.jsx("span", { children: Me }) }), C0 = ({ currentVariant: Me, productInfo: ge, setUploads: ne, showErrors: C, setUserInteracted: Z }) => {
  const [_, P] = Xt.useState(null), [x, y] = Xt.useState(!1), [E, d] = Xt.useState(null), l = Xt.useRef(null), [u, a] = Xt.useState(null), n = (s, S = 3e3) => {
    d(s), setTimeout(() => d(null), S);
  }, c = (s) => {
    const S = s.target, b = S.files[0], o = () => {
      S.value = "";
    }, A = {
      "image/jpeg": 10,
      // 10MB
      "image/png": 10,
      "image/jpg": 10,
      "image/webp": 10,
      "image/bmp": 5
    };
    if (!b || !A.hasOwnProperty(b.type)) {
      n("Please upload a valid image file (JPEG, PNG, WebP, or BMP)."), o();
      return;
    }
    if (b.size / (1024 * 1024) > A[b.type]) {
      n(`File size must be less than ${A[b.type]}MB`), o();
      return;
    }
    const R = new Image(), L = URL.createObjectURL(b);
    R.onload = () => {
      if (URL.revokeObjectURL(L), R.width < 500 || R.height < 500) {
        n("Image dimensions must be at least 500x500px"), o();
        return;
      }
      y(!0);
      const z = new FileReader();
      z.onload = (U) => {
        P({
          imageUrl: U.target.result,
          type: "upload",
          file: b
        }), y(!1), Z(!1);
      }, z.readAsDataURL(b);
    }, R.onerror = () => {
      URL.revokeObjectURL(L), n("Error loading image. Please try another file."), o();
    }, R.src = L;
  }, g = (s) => {
    ne((S) => ({
      ...S,
      file: s,
      Upload: null
    })), a(s);
  }, p = (() => {
    var S, b, o, A;
    const s = ge.variant_metafields[Me.id];
    if ((s == null ? void 0 : s.engravable) === 1) {
      const T = s.options[0], R = Object.keys(ge.variant_metafields).find((L) => {
        var U;
        const z = ge.variant_metafields[L];
        return z.engravable === 0 && ((U = z.options) == null ? void 0 : U.includes(T));
      });
      if (R) {
        const L = ge.variant_metafields[R], z = ((b = (S = L == null ? void 0 : L.transformations_filenames_json) == null ? void 0 : S[0]) == null ? void 0 : b.split(",")) || [];
        return {
          array: z,
          data: L == null ? void 0 : L.transformations_json[z[0]]
        };
      }
    }
    if ((s == null ? void 0 : s.engravable) === 0) {
      const T = ((A = (o = s == null ? void 0 : s.transformations_filenames_json) == null ? void 0 : o[0]) == null ? void 0 : A.split(",")) || [];
      return {
        array: T,
        data: s == null ? void 0 : s.transformations_json[T[0]]
      };
    }
    return { array: [], data: null };
  })();
  return /* @__PURE__ */ ft.jsxs(
    "div",
    {
      className: `uploading-container ${_ ? "has-upload" : "no-upload"} ${C ? "error" : ""}`,
      children: [
        E && /* @__PURE__ */ ft.jsx(x0, { message: E }),
        /* @__PURE__ */ ft.jsx(
          g0,
          {
            ref: l,
            previewContent: _,
            transformationArray: p.array,
            transformationData: p.data,
            onFileProcessed: g,
            setUserInteracted: Z
          }
        ),
        /* @__PURE__ */ ft.jsxs("div", { className: `upload-overlay ${_ ? "" : "empty-state-overlay"}`, children: [
          /* @__PURE__ */ ft.jsx(
            S0,
            {
              isUploading: x,
              previewContent: _,
              onFileSelect: c,
              cropperRef: l
            }
          ),
          _ && /* @__PURE__ */ ft.jsx(
            ud,
            {
              currentVariant: Me,
              registeredFile: u,
              setUploads: ne,
              showErrors: C,
              setUserInteracted: Z
            },
            u ? u.lastModified : "no-file"
          )
        ] })
      ]
    }
  );
}, Zo = {
  heart: /* @__PURE__ */ ft.jsx("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" }),
  pin: /* @__PURE__ */ ft.jsx("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" }),
  stone: /* @__PURE__ */ ft.jsx("path", { d: "M12 2L2 8.5L12 15L22 8.5L12 2ZM12 17L2 10.5L12 22L22 10.5L12 17Z" })
}, Tc = ({ renderInMap: Me, onMarkerChange: ge, selectedType: ne, metalType: C }) => {
  var y;
  const _ = nf().filter((E) => {
    var d;
    return E.field_type === "custom" && ((d = E.slug) == null ? void 0 : d.includes("capture-"));
  }), P = {
    heart: "#323232",
    pin: `var(--metal-border-${C})`,
    stone: "#000000"
  };
  if (Me)
    return ne !== "none" ? /* @__PURE__ */ ft.jsx("div", { className: "icon-marker", style: { color: P[ne] }, children: /* @__PURE__ */ ft.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: Zo[ne] }) }) : null;
  const x = (y = _[0]) == null ? void 0 : y.options.marker;
  return /* @__PURE__ */ ft.jsxs("div", { className: "marker-selector", children: [
    /* @__PURE__ */ ft.jsx("label", { className: "marker-label", children: "Marker style:" }),
    /* @__PURE__ */ ft.jsx("div", { className: "marker-swatches", children: x.map((E) => /* @__PURE__ */ ft.jsxs("label", { className: "marker-swatch", children: [
      /* @__PURE__ */ ft.jsx(
        "input",
        {
          type: "radio",
          name: "marker-type",
          value: E.value,
          checked: ne === E.value,
          onChange: (d) => ge(d.target.value)
        }
      ),
      /* @__PURE__ */ ft.jsxs("span", { children: [
        E.value !== "none" && /* @__PURE__ */ ft.jsx(
          "svg",
          {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            style: { color: P[E.value] },
            children: Zo[E.value]
          }
        ),
        E.label
      ] })
    ] }, E.value)) })
  ] });
};
function Ps(Me) {
  throw new Error('Could not dynamically require "' + Me + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Il = { exports: {} }, Pc;
function ld() {
  return Pc || (Pc = 1, function(Me, ge) {
    if ((typeof ne > "u" || !ne) && typeof self < "u") var ne = self;
    (function(C) {
      Me.exports = C();
    })(function() {
      return (/* @__PURE__ */ function() {
        function C(Z, _, P) {
          function x(d, l) {
            if (!_[d]) {
              if (!Z[d]) {
                var u = typeof Ps == "function" && Ps;
                if (!l && u) return u(d, !0);
                if (y) return y(d, !0);
                var a = new Error("Cannot find module '" + d + "'");
                throw a.code = "MODULE_NOT_FOUND", a;
              }
              var n = _[d] = { exports: {} };
              Z[d][0].call(n.exports, function(c) {
                var g = Z[d][1][c];
                return x(g || c);
              }, n, n.exports, C, Z, _, P);
            }
            return _[d].exports;
          }
          for (var y = typeof Ps == "function" && Ps, E = 0; E < P.length; E++) x(P[E]);
          return x;
        }
        return C;
      }())({ 1: [function(C, Z, _) {
        function P(x) {
          if (Array.isArray(x)) return x;
        }
        Z.exports = P;
      }, {}], 2: [function(C, Z, _) {
        function P(x) {
          if (Array.isArray(x)) {
            for (var y = 0, E = new Array(x.length); y < x.length; y++)
              E[y] = x[y];
            return E;
          }
        }
        Z.exports = P;
      }, {}], 3: [function(C, Z, _) {
        function P(x) {
          if (x === void 0)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return x;
        }
        Z.exports = P;
      }, {}], 4: [function(C, Z, _) {
        function P(x, y) {
          if (!(x instanceof y))
            throw new TypeError("Cannot call a class as a function");
        }
        Z.exports = P;
      }, {}], 5: [function(C, Z, _) {
        var P = C("./setPrototypeOf");
        function x() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function y(E, d, l) {
          return x() ? Z.exports = y = Reflect.construct : Z.exports = y = function(a, n, c) {
            var g = [null];
            g.push.apply(g, n);
            var f = Function.bind.apply(a, g), p = new f();
            return c && P(p, c.prototype), p;
          }, y.apply(null, arguments);
        }
        Z.exports = y;
      }, { "./setPrototypeOf": 18 }], 6: [function(C, Z, _) {
        function P(y, E) {
          for (var d = 0; d < E.length; d++) {
            var l = E[d];
            l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(y, l.key, l);
          }
        }
        function x(y, E, d) {
          return E && P(y.prototype, E), d && P(y, d), y;
        }
        Z.exports = x;
      }, {}], 7: [function(C, Z, _) {
        function P(x, y, E) {
          return y in x ? Object.defineProperty(x, y, {
            value: E,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : x[y] = E, x;
        }
        Z.exports = P;
      }, {}], 8: [function(C, Z, _) {
        function P() {
          return Z.exports = P = Object.assign || function(x) {
            for (var y = 1; y < arguments.length; y++) {
              var E = arguments[y];
              for (var d in E)
                Object.prototype.hasOwnProperty.call(E, d) && (x[d] = E[d]);
            }
            return x;
          }, P.apply(this, arguments);
        }
        Z.exports = P;
      }, {}], 9: [function(C, Z, _) {
        function P(x) {
          return Z.exports = P = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
            return E.__proto__ || Object.getPrototypeOf(E);
          }, P(x);
        }
        Z.exports = P;
      }, {}], 10: [function(C, Z, _) {
        var P = C("./setPrototypeOf");
        function x(y, E) {
          if (typeof E != "function" && E !== null)
            throw new TypeError("Super expression must either be null or a function");
          y.prototype = Object.create(E && E.prototype, {
            constructor: {
              value: y,
              writable: !0,
              configurable: !0
            }
          }), E && P(y, E);
        }
        Z.exports = x;
      }, { "./setPrototypeOf": 18 }], 11: [function(C, Z, _) {
        function P(x) {
          return x && x.__esModule ? x : {
            default: x
          };
        }
        Z.exports = P;
      }, {}], 12: [function(C, Z, _) {
        var P = C("../helpers/typeof");
        function x() {
          if (typeof WeakMap != "function") return null;
          var E = /* @__PURE__ */ new WeakMap();
          return x = function() {
            return E;
          }, E;
        }
        function y(E) {
          if (E && E.__esModule)
            return E;
          if (E === null || P(E) !== "object" && typeof E != "function")
            return {
              default: E
            };
          var d = x();
          if (d && d.has(E))
            return d.get(E);
          var l = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var a in E)
            if (Object.prototype.hasOwnProperty.call(E, a)) {
              var n = u ? Object.getOwnPropertyDescriptor(E, a) : null;
              n && (n.get || n.set) ? Object.defineProperty(l, a, n) : l[a] = E[a];
            }
          return l.default = E, d && d.set(E, l), l;
        }
        Z.exports = y;
      }, { "../helpers/typeof": 21 }], 13: [function(C, Z, _) {
        function P(x) {
          if (Symbol.iterator in Object(x) || Object.prototype.toString.call(x) === "[object Arguments]") return Array.from(x);
        }
        Z.exports = P;
      }, {}], 14: [function(C, Z, _) {
        function P(x, y) {
          if (Symbol.iterator in Object(x) || Object.prototype.toString.call(x) === "[object Arguments]") {
            var E = [], d = !0, l = !1, u = void 0;
            try {
              for (var a = x[Symbol.iterator](), n; !(d = (n = a.next()).done) && (E.push(n.value), !(y && E.length === y)); d = !0)
                ;
            } catch (c) {
              l = !0, u = c;
            } finally {
              try {
                !d && a.return != null && a.return();
              } finally {
                if (l) throw u;
              }
            }
            return E;
          }
        }
        Z.exports = P;
      }, {}], 15: [function(C, Z, _) {
        function P() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
        Z.exports = P;
      }, {}], 16: [function(C, Z, _) {
        function P() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }
        Z.exports = P;
      }, {}], 17: [function(C, Z, _) {
        var P = C("../helpers/typeof"), x = C("./assertThisInitialized");
        function y(E, d) {
          return d && (P(d) === "object" || typeof d == "function") ? d : x(E);
        }
        Z.exports = y;
      }, { "../helpers/typeof": 21, "./assertThisInitialized": 3 }], 18: [function(C, Z, _) {
        function P(x, y) {
          return Z.exports = P = Object.setPrototypeOf || function(d, l) {
            return d.__proto__ = l, d;
          }, P(x, y);
        }
        Z.exports = P;
      }, {}], 19: [function(C, Z, _) {
        var P = C("./arrayWithHoles"), x = C("./iterableToArrayLimit"), y = C("./nonIterableRest");
        function E(d, l) {
          return P(d) || x(d, l) || y();
        }
        Z.exports = E;
      }, { "./arrayWithHoles": 1, "./iterableToArrayLimit": 14, "./nonIterableRest": 15 }], 20: [function(C, Z, _) {
        var P = C("./arrayWithoutHoles"), x = C("./iterableToArray"), y = C("./nonIterableSpread");
        function E(d) {
          return P(d) || x(d) || y();
        }
        Z.exports = E;
      }, { "./arrayWithoutHoles": 2, "./iterableToArray": 13, "./nonIterableSpread": 16 }], 21: [function(C, Z, _) {
        function P(y) {
          return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? P = function(d) {
            return typeof d;
          } : P = function(d) {
            return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
          }, P(y);
        }
        function x(y) {
          return typeof Symbol == "function" && P(Symbol.iterator) === "symbol" ? Z.exports = x = function(d) {
            return P(d);
          } : Z.exports = x = function(d) {
            return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : P(d);
          }, x(y);
        }
        Z.exports = x;
      }, {}], 22: [function(C, Z, _) {
        Z.exports = C("regenerator-runtime");
      }, { "regenerator-runtime": 153 }], 23: [function(C, Z, _) {
        var P = C("./src/converter");
        function x(y, E) {
          var d = new P(y, E);
          return function(l) {
            return d.convert(l);
          };
        }
        x.BIN = "01", x.OCT = "01234567", x.DEC = "0123456789", x.HEX = "0123456789abcdef", Z.exports = x;
      }, { "./src/converter": 24 }], 24: [function(C, Z, _) {
        function P(x, y) {
          if (!x || !y || !x.length || !y.length)
            throw new Error("Bad alphabet");
          this.srcAlphabet = x, this.dstAlphabet = y;
        }
        P.prototype.convert = function(x) {
          var y, E, d, l = {}, u = this.srcAlphabet.length, a = this.dstAlphabet.length, n = x.length, c = typeof x == "string" ? "" : [];
          if (!this.isValid(x))
            throw new Error('Number "' + x + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
          if (this.srcAlphabet === this.dstAlphabet)
            return x;
          for (y = 0; y < n; y++)
            l[y] = this.srcAlphabet.indexOf(x[y]);
          do {
            for (E = 0, d = 0, y = 0; y < n; y++)
              E = E * u + l[y], E >= a ? (l[d++] = parseInt(E / a, 10), E = E % a) : d > 0 && (l[d++] = 0);
            n = d, c = this.dstAlphabet.slice(E, E + 1).concat(c);
          } while (d !== 0);
          return c;
        }, P.prototype.isValid = function(x) {
          for (var y = 0; y < x.length; ++y)
            if (this.srcAlphabet.indexOf(x[y]) === -1)
              return !1;
          return !0;
        }, Z.exports = P;
      }, {}], 25: [function(C, Z, _) {
        (function(P) {
          var x = C("object-assign");
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */
          function y(ie, W) {
            if (ie === W)
              return 0;
            for (var Q = ie.length, de = W.length, _e = 0, ke = Math.min(Q, de); _e < ke; ++_e)
              if (ie[_e] !== W[_e]) {
                Q = ie[_e], de = W[_e];
                break;
              }
            return Q < de ? -1 : de < Q ? 1 : 0;
          }
          function E(ie) {
            return P.Buffer && typeof P.Buffer.isBuffer == "function" ? P.Buffer.isBuffer(ie) : !!(ie != null && ie._isBuffer);
          }
          var d = C("util/"), l = Object.prototype.hasOwnProperty, u = Array.prototype.slice, a = function() {
            return (function() {
            }).name === "foo";
          }();
          function n(ie) {
            return Object.prototype.toString.call(ie);
          }
          function c(ie) {
            return E(ie) || typeof P.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(ie) : ie ? !!(ie instanceof DataView || ie.buffer && ie.buffer instanceof ArrayBuffer) : !1;
          }
          var g = Z.exports = A, f = /\s*function\s+([^\(\s]*)\s*/;
          function p(ie) {
            if (d.isFunction(ie)) {
              if (a)
                return ie.name;
              var W = ie.toString(), Q = W.match(f);
              return Q && Q[1];
            }
          }
          g.AssertionError = function(W) {
            this.name = "AssertionError", this.actual = W.actual, this.expected = W.expected, this.operator = W.operator, W.message ? (this.message = W.message, this.generatedMessage = !1) : (this.message = b(this), this.generatedMessage = !0);
            var Q = W.stackStartFunction || o;
            if (Error.captureStackTrace)
              Error.captureStackTrace(this, Q);
            else {
              var de = new Error();
              if (de.stack) {
                var _e = de.stack, ke = p(Q), Pe = _e.indexOf(`
` + ke);
                if (Pe >= 0) {
                  var fe = _e.indexOf(`
`, Pe + 1);
                  _e = _e.substring(fe + 1);
                }
                this.stack = _e;
              }
            }
          }, d.inherits(g.AssertionError, Error);
          function s(ie, W) {
            return typeof ie == "string" ? ie.length < W ? ie : ie.slice(0, W) : ie;
          }
          function S(ie) {
            if (a || !d.isFunction(ie))
              return d.inspect(ie);
            var W = p(ie), Q = W ? ": " + W : "";
            return "[Function" + Q + "]";
          }
          function b(ie) {
            return s(S(ie.actual), 128) + " " + ie.operator + " " + s(S(ie.expected), 128);
          }
          function o(ie, W, Q, de, _e) {
            throw new g.AssertionError({
              message: Q,
              actual: ie,
              expected: W,
              operator: de,
              stackStartFunction: _e
            });
          }
          g.fail = o;
          function A(ie, W) {
            ie || o(ie, !0, W, "==", g.ok);
          }
          g.ok = A, g.equal = function(W, Q, de) {
            W != Q && o(W, Q, de, "==", g.equal);
          }, g.notEqual = function(W, Q, de) {
            W == Q && o(W, Q, de, "!=", g.notEqual);
          }, g.deepEqual = function(W, Q, de) {
            T(W, Q, !1) || o(W, Q, de, "deepEqual", g.deepEqual);
          }, g.deepStrictEqual = function(W, Q, de) {
            T(W, Q, !0) || o(W, Q, de, "deepStrictEqual", g.deepStrictEqual);
          };
          function T(ie, W, Q, de) {
            if (ie === W)
              return !0;
            if (E(ie) && E(W))
              return y(ie, W) === 0;
            if (d.isDate(ie) && d.isDate(W))
              return ie.getTime() === W.getTime();
            if (d.isRegExp(ie) && d.isRegExp(W))
              return ie.source === W.source && ie.global === W.global && ie.multiline === W.multiline && ie.lastIndex === W.lastIndex && ie.ignoreCase === W.ignoreCase;
            if ((ie === null || typeof ie != "object") && (W === null || typeof W != "object"))
              return Q ? ie === W : ie == W;
            if (c(ie) && c(W) && n(ie) === n(W) && !(ie instanceof Float32Array || ie instanceof Float64Array))
              return y(
                new Uint8Array(ie.buffer),
                new Uint8Array(W.buffer)
              ) === 0;
            if (E(ie) !== E(W))
              return !1;
            de = de || { actual: [], expected: [] };
            var _e = de.actual.indexOf(ie);
            return _e !== -1 && _e === de.expected.indexOf(W) ? !0 : (de.actual.push(ie), de.expected.push(W), L(ie, W, Q, de));
          }
          function R(ie) {
            return Object.prototype.toString.call(ie) == "[object Arguments]";
          }
          function L(ie, W, Q, de) {
            if (ie == null || W === null || W === void 0)
              return !1;
            if (d.isPrimitive(ie) || d.isPrimitive(W))
              return ie === W;
            if (Q && Object.getPrototypeOf(ie) !== Object.getPrototypeOf(W))
              return !1;
            var _e = R(ie), ke = R(W);
            if (_e && !ke || !_e && ke)
              return !1;
            if (_e)
              return ie = u.call(ie), W = u.call(W), T(ie, W, Q);
            var Pe = ee(ie), fe = ee(W), xe, Ee;
            if (Pe.length !== fe.length)
              return !1;
            for (Pe.sort(), fe.sort(), Ee = Pe.length - 1; Ee >= 0; Ee--)
              if (Pe[Ee] !== fe[Ee])
                return !1;
            for (Ee = Pe.length - 1; Ee >= 0; Ee--)
              if (xe = Pe[Ee], !T(ie[xe], W[xe], Q, de))
                return !1;
            return !0;
          }
          g.notDeepEqual = function(W, Q, de) {
            T(W, Q, !1) && o(W, Q, de, "notDeepEqual", g.notDeepEqual);
          }, g.notDeepStrictEqual = z;
          function z(ie, W, Q) {
            T(ie, W, !0) && o(ie, W, Q, "notDeepStrictEqual", z);
          }
          g.strictEqual = function(W, Q, de) {
            W !== Q && o(W, Q, de, "===", g.strictEqual);
          }, g.notStrictEqual = function(W, Q, de) {
            W === Q && o(W, Q, de, "!==", g.notStrictEqual);
          };
          function U(ie, W) {
            if (!ie || !W)
              return !1;
            if (Object.prototype.toString.call(W) == "[object RegExp]")
              return W.test(ie);
            try {
              if (ie instanceof W)
                return !0;
            } catch {
            }
            return Error.isPrototypeOf(W) ? !1 : W.call({}, ie) === !0;
          }
          function J(ie) {
            var W;
            try {
              ie();
            } catch (Q) {
              W = Q;
            }
            return W;
          }
          function F(ie, W, Q, de) {
            var _e;
            if (typeof W != "function")
              throw new TypeError('"block" argument must be a function');
            typeof Q == "string" && (de = Q, Q = null), _e = J(W), de = (Q && Q.name ? " (" + Q.name + ")." : ".") + (de ? " " + de : "."), ie && !_e && o(_e, Q, "Missing expected exception" + de);
            var ke = typeof de == "string", Pe = !ie && d.isError(_e), fe = !ie && _e && !Q;
            if ((Pe && ke && U(_e, Q) || fe) && o(_e, Q, "Got unwanted exception" + de), ie && _e && Q && !U(_e, Q) || !ie && _e)
              throw _e;
          }
          g.throws = function(ie, W, Q) {
            F(!0, ie, W, Q);
          }, g.doesNotThrow = function(ie, W, Q) {
            F(!1, ie, W, Q);
          }, g.ifError = function(ie) {
            if (ie) throw ie;
          };
          function se(ie, W) {
            ie || o(ie, !0, W, "==", se);
          }
          g.strict = x(se, g, {
            equal: g.strictEqual,
            deepEqual: g.deepStrictEqual,
            notEqual: g.notStrictEqual,
            notDeepEqual: g.notDeepStrictEqual
          }), g.strict.strict = g.strict;
          var ee = Object.keys || function(ie) {
            var W = [];
            for (var Q in ie)
              l.call(ie, Q) && W.push(Q);
            return W;
          };
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "object-assign": 84, "util/": 28 }], 26: [function(C, Z, _) {
        typeof Object.create == "function" ? Z.exports = function(x, y) {
          x.super_ = y, x.prototype = Object.create(y.prototype, {
            constructor: {
              value: x,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          });
        } : Z.exports = function(x, y) {
          x.super_ = y;
          var E = function() {
          };
          E.prototype = y.prototype, x.prototype = new E(), x.prototype.constructor = x;
        };
      }, {}], 27: [function(C, Z, _) {
        Z.exports = function(x) {
          return x && typeof x == "object" && typeof x.copy == "function" && typeof x.fill == "function" && typeof x.readUInt8 == "function";
        };
      }, {}], 28: [function(C, Z, _) {
        (function(P, x) {
          var y = /%[sdj%]/g;
          _.format = function(fe) {
            if (!L(fe)) {
              for (var xe = [], Ee = 0; Ee < arguments.length; Ee++)
                xe.push(l(arguments[Ee]));
              return xe.join(" ");
            }
            for (var Ee = 1, Ie = arguments, je = Ie.length, Ue = String(fe).replace(y, function(Ze) {
              if (Ze === "%%") return "%";
              if (Ee >= je) return Ze;
              switch (Ze) {
                case "%s":
                  return String(Ie[Ee++]);
                case "%d":
                  return Number(Ie[Ee++]);
                case "%j":
                  try {
                    return JSON.stringify(Ie[Ee++]);
                  } catch {
                    return "[Circular]";
                  }
                default:
                  return Ze;
              }
            }), He = Ie[Ee]; Ee < je; He = Ie[++Ee])
              A(He) || !F(He) ? Ue += " " + He : Ue += " " + l(He);
            return Ue;
          }, _.deprecate = function(fe, xe) {
            if (U(x.process))
              return function() {
                return _.deprecate(fe, xe).apply(this, arguments);
              };
            if (P.noDeprecation === !0)
              return fe;
            var Ee = !1;
            function Ie() {
              if (!Ee) {
                if (P.throwDeprecation)
                  throw new Error(xe);
                P.traceDeprecation ? console.trace(xe) : console.error(xe), Ee = !0;
              }
              return fe.apply(this, arguments);
            }
            return Ie;
          };
          var E = {}, d;
          _.debuglog = function(fe) {
            if (U(d) && (d = P.env.NODE_DEBUG || ""), fe = fe.toUpperCase(), !E[fe])
              if (new RegExp("\\b" + fe + "\\b", "i").test(d)) {
                var xe = P.pid;
                E[fe] = function() {
                  var Ee = _.format.apply(_, arguments);
                  console.error("%s %d: %s", fe, xe, Ee);
                };
              } else
                E[fe] = function() {
                };
            return E[fe];
          };
          function l(fe, xe) {
            var Ee = {
              seen: [],
              stylize: a
            };
            return arguments.length >= 3 && (Ee.depth = arguments[2]), arguments.length >= 4 && (Ee.colors = arguments[3]), o(xe) ? Ee.showHidden = xe : xe && _._extend(Ee, xe), U(Ee.showHidden) && (Ee.showHidden = !1), U(Ee.depth) && (Ee.depth = 2), U(Ee.colors) && (Ee.colors = !1), U(Ee.customInspect) && (Ee.customInspect = !0), Ee.colors && (Ee.stylize = u), c(Ee, fe, Ee.depth);
          }
          _.inspect = l, l.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39]
          }, l.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            // "name": intentionally not styling
            regexp: "red"
          };
          function u(fe, xe) {
            var Ee = l.styles[xe];
            return Ee ? "\x1B[" + l.colors[Ee][0] + "m" + fe + "\x1B[" + l.colors[Ee][1] + "m" : fe;
          }
          function a(fe, xe) {
            return fe;
          }
          function n(fe) {
            var xe = {};
            return fe.forEach(function(Ee, Ie) {
              xe[Ee] = !0;
            }), xe;
          }
          function c(fe, xe, Ee) {
            if (fe.customInspect && xe && ie(xe.inspect) && // Filter out the util module, it's inspect function is special
            xe.inspect !== _.inspect && // Also filter out any prototype objects using the circular check.
            !(xe.constructor && xe.constructor.prototype === xe)) {
              var Ie = xe.inspect(Ee, fe);
              return L(Ie) || (Ie = c(fe, Ie, Ee)), Ie;
            }
            var je = g(fe, xe);
            if (je)
              return je;
            var Ue = Object.keys(xe), He = n(Ue);
            if (fe.showHidden && (Ue = Object.getOwnPropertyNames(xe)), ee(xe) && (Ue.indexOf("message") >= 0 || Ue.indexOf("description") >= 0))
              return f(xe);
            if (Ue.length === 0) {
              if (ie(xe)) {
                var Ze = xe.name ? ": " + xe.name : "";
                return fe.stylize("[Function" + Ze + "]", "special");
              }
              if (J(xe))
                return fe.stylize(RegExp.prototype.toString.call(xe), "regexp");
              if (se(xe))
                return fe.stylize(Date.prototype.toString.call(xe), "date");
              if (ee(xe))
                return f(xe);
            }
            var $e = "", We = !1, Ve = ["{", "}"];
            if (b(xe) && (We = !0, Ve = ["[", "]"]), ie(xe)) {
              var Re = xe.name ? ": " + xe.name : "";
              $e = " [Function" + Re + "]";
            }
            if (J(xe) && ($e = " " + RegExp.prototype.toString.call(xe)), se(xe) && ($e = " " + Date.prototype.toUTCString.call(xe)), ee(xe) && ($e = " " + f(xe)), Ue.length === 0 && (!We || xe.length == 0))
              return Ve[0] + $e + Ve[1];
            if (Ee < 0)
              return J(xe) ? fe.stylize(RegExp.prototype.toString.call(xe), "regexp") : fe.stylize("[Object]", "special");
            fe.seen.push(xe);
            var De;
            return We ? De = p(fe, xe, Ee, He, Ue) : De = Ue.map(function(Ne) {
              return s(fe, xe, Ee, He, Ne, We);
            }), fe.seen.pop(), S(De, $e, Ve);
          }
          function g(fe, xe) {
            if (U(xe))
              return fe.stylize("undefined", "undefined");
            if (L(xe)) {
              var Ee = "'" + JSON.stringify(xe).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return fe.stylize(Ee, "string");
            }
            if (R(xe))
              return fe.stylize("" + xe, "number");
            if (o(xe))
              return fe.stylize("" + xe, "boolean");
            if (A(xe))
              return fe.stylize("null", "null");
          }
          function f(fe) {
            return "[" + Error.prototype.toString.call(fe) + "]";
          }
          function p(fe, xe, Ee, Ie, je) {
            for (var Ue = [], He = 0, Ze = xe.length; He < Ze; ++He)
              Pe(xe, String(He)) ? Ue.push(s(
                fe,
                xe,
                Ee,
                Ie,
                String(He),
                !0
              )) : Ue.push("");
            return je.forEach(function($e) {
              $e.match(/^\d+$/) || Ue.push(s(
                fe,
                xe,
                Ee,
                Ie,
                $e,
                !0
              ));
            }), Ue;
          }
          function s(fe, xe, Ee, Ie, je, Ue) {
            var He, Ze, $e;
            if ($e = Object.getOwnPropertyDescriptor(xe, je) || { value: xe[je] }, $e.get ? $e.set ? Ze = fe.stylize("[Getter/Setter]", "special") : Ze = fe.stylize("[Getter]", "special") : $e.set && (Ze = fe.stylize("[Setter]", "special")), Pe(Ie, je) || (He = "[" + je + "]"), Ze || (fe.seen.indexOf($e.value) < 0 ? (A(Ee) ? Ze = c(fe, $e.value, null) : Ze = c(fe, $e.value, Ee - 1), Ze.indexOf(`
`) > -1 && (Ue ? Ze = Ze.split(`
`).map(function(We) {
              return "  " + We;
            }).join(`
`).substr(2) : Ze = `
` + Ze.split(`
`).map(function(We) {
              return "   " + We;
            }).join(`
`))) : Ze = fe.stylize("[Circular]", "special")), U(He)) {
              if (Ue && je.match(/^\d+$/))
                return Ze;
              He = JSON.stringify("" + je), He.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (He = He.substr(1, He.length - 2), He = fe.stylize(He, "name")) : (He = He.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), He = fe.stylize(He, "string"));
            }
            return He + ": " + Ze;
          }
          function S(fe, xe, Ee) {
            var Ie = fe.reduce(function(je, Ue) {
              return Ue.indexOf(`
`) >= 0, je + Ue.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            return Ie > 60 ? Ee[0] + (xe === "" ? "" : xe + `
 `) + " " + fe.join(`,
  `) + " " + Ee[1] : Ee[0] + xe + " " + fe.join(", ") + " " + Ee[1];
          }
          function b(fe) {
            return Array.isArray(fe);
          }
          _.isArray = b;
          function o(fe) {
            return typeof fe == "boolean";
          }
          _.isBoolean = o;
          function A(fe) {
            return fe === null;
          }
          _.isNull = A;
          function T(fe) {
            return fe == null;
          }
          _.isNullOrUndefined = T;
          function R(fe) {
            return typeof fe == "number";
          }
          _.isNumber = R;
          function L(fe) {
            return typeof fe == "string";
          }
          _.isString = L;
          function z(fe) {
            return typeof fe == "symbol";
          }
          _.isSymbol = z;
          function U(fe) {
            return fe === void 0;
          }
          _.isUndefined = U;
          function J(fe) {
            return F(fe) && Q(fe) === "[object RegExp]";
          }
          _.isRegExp = J;
          function F(fe) {
            return typeof fe == "object" && fe !== null;
          }
          _.isObject = F;
          function se(fe) {
            return F(fe) && Q(fe) === "[object Date]";
          }
          _.isDate = se;
          function ee(fe) {
            return F(fe) && (Q(fe) === "[object Error]" || fe instanceof Error);
          }
          _.isError = ee;
          function ie(fe) {
            return typeof fe == "function";
          }
          _.isFunction = ie;
          function W(fe) {
            return fe === null || typeof fe == "boolean" || typeof fe == "number" || typeof fe == "string" || typeof fe == "symbol" || // ES6 symbol
            typeof fe > "u";
          }
          _.isPrimitive = W, _.isBuffer = C("./support/isBuffer");
          function Q(fe) {
            return Object.prototype.toString.call(fe);
          }
          function de(fe) {
            return fe < 10 ? "0" + fe.toString(10) : fe.toString(10);
          }
          var _e = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ];
          function ke() {
            var fe = /* @__PURE__ */ new Date(), xe = [
              de(fe.getHours()),
              de(fe.getMinutes()),
              de(fe.getSeconds())
            ].join(":");
            return [fe.getDate(), _e[fe.getMonth()], xe].join(" ");
          }
          _.log = function() {
            console.log("%s - %s", ke(), _.format.apply(_, arguments));
          }, _.inherits = C("inherits"), _._extend = function(fe, xe) {
            if (!xe || !F(xe)) return fe;
            for (var Ee = Object.keys(xe), Ie = Ee.length; Ie--; )
              fe[Ee[Ie]] = xe[Ee[Ie]];
            return fe;
          };
          function Pe(fe, xe) {
            return Object.prototype.hasOwnProperty.call(fe, xe);
          }
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "./support/isBuffer": 27, _process: 133, inherits: 26 }], 29: [function(C, Z, _) {
        _.byteLength = a, _.toByteArray = c, _.fromByteArray = p;
        for (var P = [], x = [], y = typeof Uint8Array < "u" ? Uint8Array : Array, E = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d = 0, l = E.length; d < l; ++d)
          P[d] = E[d], x[E.charCodeAt(d)] = d;
        x[45] = 62, x[95] = 63;
        function u(s) {
          var S = s.length;
          if (S % 4 > 0)
            throw new Error("Invalid string. Length must be a multiple of 4");
          var b = s.indexOf("=");
          b === -1 && (b = S);
          var o = b === S ? 0 : 4 - b % 4;
          return [b, o];
        }
        function a(s) {
          var S = u(s), b = S[0], o = S[1];
          return (b + o) * 3 / 4 - o;
        }
        function n(s, S, b) {
          return (S + b) * 3 / 4 - b;
        }
        function c(s) {
          var S, b = u(s), o = b[0], A = b[1], T = new y(n(s, o, A)), R = 0, L = A > 0 ? o - 4 : o, z;
          for (z = 0; z < L; z += 4)
            S = x[s.charCodeAt(z)] << 18 | x[s.charCodeAt(z + 1)] << 12 | x[s.charCodeAt(z + 2)] << 6 | x[s.charCodeAt(z + 3)], T[R++] = S >> 16 & 255, T[R++] = S >> 8 & 255, T[R++] = S & 255;
          return A === 2 && (S = x[s.charCodeAt(z)] << 2 | x[s.charCodeAt(z + 1)] >> 4, T[R++] = S & 255), A === 1 && (S = x[s.charCodeAt(z)] << 10 | x[s.charCodeAt(z + 1)] << 4 | x[s.charCodeAt(z + 2)] >> 2, T[R++] = S >> 8 & 255, T[R++] = S & 255), T;
        }
        function g(s) {
          return P[s >> 18 & 63] + P[s >> 12 & 63] + P[s >> 6 & 63] + P[s & 63];
        }
        function f(s, S, b) {
          for (var o, A = [], T = S; T < b; T += 3)
            o = (s[T] << 16 & 16711680) + (s[T + 1] << 8 & 65280) + (s[T + 2] & 255), A.push(g(o));
          return A.join("");
        }
        function p(s) {
          for (var S, b = s.length, o = b % 3, A = [], T = 16383, R = 0, L = b - o; R < L; R += T)
            A.push(f(
              s,
              R,
              R + T > L ? L : R + T
            ));
          return o === 1 ? (S = s[b - 1], A.push(
            P[S >> 2] + P[S << 4 & 63] + "=="
          )) : o === 2 && (S = (s[b - 2] << 8) + s[b - 1], A.push(
            P[S >> 10] + P[S >> 4 & 63] + P[S << 2 & 63] + "="
          )), A.join("");
        }
      }, {}], 30: [function(C, Z, _) {
        var P = C("./lib/encoder"), x = C("./lib/decoder");
        Z.exports = {
          encode: P,
          decode: x
        };
      }, { "./lib/decoder": 31, "./lib/encoder": 32 }], 31: [function(C, Z, _) {
        (function(P) {
          function x(y, E) {
            if (this.pos = 0, this.buffer = y, this.is_with_alpha = !!E, this.bottom_up = !0, this.flag = this.buffer.toString("utf-8", 0, this.pos += 2), this.flag != "BM") throw new Error("Invalid BMP File");
            this.parseHeader(), this.parseRGBA();
          }
          x.prototype.parseHeader = function() {
            if (this.fileSize = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.reserved = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.offset = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.headerSize = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.width = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.height = this.buffer.readInt32LE(this.pos), this.pos += 4, this.planes = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.bitPP = this.buffer.readUInt16LE(this.pos), this.pos += 2, this.compress = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.rawSize = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.hr = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.vr = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.colors = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.importantColors = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
              var y = this.colors === 0 ? 1 << this.bitPP : this.colors;
              this.palette = new Array(y);
              for (var E = 0; E < y; E++) {
                var d = this.buffer.readUInt8(this.pos++), l = this.buffer.readUInt8(this.pos++), u = this.buffer.readUInt8(this.pos++), a = this.buffer.readUInt8(this.pos++);
                this.palette[E] = {
                  red: u,
                  green: l,
                  blue: d,
                  quad: a
                };
              }
            }
            this.height < 0 && (this.height *= -1, this.bottom_up = !1);
          }, x.prototype.parseRGBA = function() {
            var y = "bit" + this.bitPP, E = this.width * this.height * 4;
            this.data = new P(E), this[y]();
          }, x.prototype.bit1 = function() {
            for (var y = Math.ceil(this.width / 8), E = y % 4, d = this.height >= 0 ? this.height - 1 : -this.height, d = this.height - 1; d >= 0; d--) {
              for (var l = this.bottom_up ? d : this.height - 1 - d, u = 0; u < y; u++)
                for (var a = this.buffer.readUInt8(this.pos++), n = l * this.width * 4 + u * 8 * 4, c = 0; c < 8 && u * 8 + c < this.width; c++) {
                  var g = this.palette[a >> 7 - c & 1];
                  this.data[n + c * 4] = 0, this.data[n + c * 4 + 1] = g.blue, this.data[n + c * 4 + 2] = g.green, this.data[n + c * 4 + 3] = g.red;
                }
              E != 0 && (this.pos += 4 - E);
            }
          }, x.prototype.bit4 = function() {
            if (this.compress == 2) {
              let A = function(T) {
                var R = this.palette[T];
                this.data[y] = 0, this.data[y + 1] = R.blue, this.data[y + 2] = R.green, this.data[y + 3] = R.red, y += 4;
              };
              this.data.fill(255);
              for (var y = 0, E = this.bottom_up ? this.height - 1 : 0, d = !1; y < this.data.length; ) {
                var l = this.buffer.readUInt8(this.pos++), u = this.buffer.readUInt8(this.pos++);
                if (l == 0)
                  if (u == 0) {
                    this.bottom_up ? E-- : E++, y = E * this.width * 4, d = !1;
                    continue;
                  } else {
                    if (u == 1)
                      break;
                    if (u == 2) {
                      var a = this.buffer.readUInt8(this.pos++), n = this.buffer.readUInt8(this.pos++);
                      this.bottom_up ? E -= n : E += n, y += n * this.width * 4 + a * 4;
                    } else {
                      for (var c = this.buffer.readUInt8(this.pos++), g = 0; g < u; g++)
                        d ? A.call(this, c & 15) : A.call(this, (c & 240) >> 4), g & 1 && g + 1 < u && (c = this.buffer.readUInt8(this.pos++)), d = !d;
                      (u + 1 >> 1 & 1) == 1 && this.pos++;
                    }
                  }
                else
                  for (var g = 0; g < l; g++)
                    d ? A.call(this, u & 15) : A.call(this, (u & 240) >> 4), d = !d;
              }
            } else
              for (var f = Math.ceil(this.width / 2), p = f % 4, n = this.height - 1; n >= 0; n--) {
                for (var s = this.bottom_up ? n : this.height - 1 - n, a = 0; a < f; a++) {
                  var u = this.buffer.readUInt8(this.pos++), y = s * this.width * 4 + a * 2 * 4, S = u >> 4, b = u & 15, o = this.palette[S];
                  if (this.data[y] = 0, this.data[y + 1] = o.blue, this.data[y + 2] = o.green, this.data[y + 3] = o.red, a * 2 + 1 >= this.width) break;
                  o = this.palette[b], this.data[y + 4] = 0, this.data[y + 4 + 1] = o.blue, this.data[y + 4 + 2] = o.green, this.data[y + 4 + 3] = o.red;
                }
                p != 0 && (this.pos += 4 - p);
              }
          }, x.prototype.bit8 = function() {
            if (this.compress == 1) {
              let s = function(S) {
                var b = this.palette[S];
                this.data[y] = 0, this.data[y + 1] = b.blue, this.data[y + 2] = b.green, this.data[y + 3] = b.red, y += 4;
              };
              this.data.fill(255);
              for (var y = 0, E = this.bottom_up ? this.height - 1 : 0; y < this.data.length; ) {
                var d = this.buffer.readUInt8(this.pos++), l = this.buffer.readUInt8(this.pos++);
                if (d == 0)
                  if (l == 0) {
                    this.bottom_up ? E-- : E++, y = E * this.width * 4;
                    continue;
                  } else {
                    if (l == 1)
                      break;
                    if (l == 2) {
                      var u = this.buffer.readUInt8(this.pos++), a = this.buffer.readUInt8(this.pos++);
                      this.bottom_up ? E -= a : E += a, y += a * this.width * 4 + u * 4;
                    } else {
                      for (var n = 0; n < l; n++) {
                        var c = this.buffer.readUInt8(this.pos++);
                        s.call(this, c);
                      }
                      l & !0 && this.pos++;
                    }
                  }
                else
                  for (var n = 0; n < d; n++)
                    s.call(this, l);
              }
            } else
              for (var g = this.width % 4, a = this.height - 1; a >= 0; a--) {
                for (var f = this.bottom_up ? a : this.height - 1 - a, u = 0; u < this.width; u++) {
                  var l = this.buffer.readUInt8(this.pos++), y = f * this.width * 4 + u * 4;
                  if (l < this.palette.length) {
                    var p = this.palette[l];
                    this.data[y] = 0, this.data[y + 1] = p.blue, this.data[y + 2] = p.green, this.data[y + 3] = p.red;
                  } else
                    this.data[y] = 0, this.data[y + 1] = 255, this.data[y + 2] = 255, this.data[y + 3] = 255;
                }
                g != 0 && (this.pos += 4 - g);
              }
          }, x.prototype.bit15 = function() {
            for (var y = this.width % 3, E = parseInt("11111", 2), d = E, l = this.height - 1; l >= 0; l--) {
              for (var u = this.bottom_up ? l : this.height - 1 - l, a = 0; a < this.width; a++) {
                var n = this.buffer.readUInt16LE(this.pos);
                this.pos += 2;
                var c = (n & d) / d * 255 | 0, g = (n >> 5 & d) / d * 255 | 0, f = (n >> 10 & d) / d * 255 | 0, p = n >> 15 ? 255 : 0, s = u * this.width * 4 + a * 4;
                this.data[s] = p, this.data[s + 1] = c, this.data[s + 2] = g, this.data[s + 3] = f;
              }
              this.pos += y;
            }
          }, x.prototype.bit16 = function() {
            var y = this.width % 2 * 2;
            this.maskRed = 31744, this.maskGreen = 992, this.maskBlue = 31, this.mask0 = 0, this.compress == 3 && (this.maskRed = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.maskGreen = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.maskBlue = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.mask0 = this.buffer.readUInt32LE(this.pos), this.pos += 4);
            for (var E = [0, 0, 0], d = 0; d < 16; d++)
              this.maskRed >> d & 1 && E[0]++, this.maskGreen >> d & 1 && E[1]++, this.maskBlue >> d & 1 && E[2]++;
            E[1] += E[0], E[2] += E[1], E[0] = 8 - E[0], E[1] -= 8, E[2] -= 8;
            for (var l = this.height - 1; l >= 0; l--) {
              for (var u = this.bottom_up ? l : this.height - 1 - l, a = 0; a < this.width; a++) {
                var n = this.buffer.readUInt16LE(this.pos);
                this.pos += 2;
                var c = (n & this.maskBlue) << E[0], g = (n & this.maskGreen) >> E[1], f = (n & this.maskRed) >> E[2], p = u * this.width * 4 + a * 4;
                this.data[p] = 0, this.data[p + 1] = c, this.data[p + 2] = g, this.data[p + 3] = f;
              }
              this.pos += y;
            }
          }, x.prototype.bit24 = function() {
            for (var y = this.height - 1; y >= 0; y--) {
              for (var E = this.bottom_up ? y : this.height - 1 - y, d = 0; d < this.width; d++) {
                var l = this.buffer.readUInt8(this.pos++), u = this.buffer.readUInt8(this.pos++), a = this.buffer.readUInt8(this.pos++), n = E * this.width * 4 + d * 4;
                this.data[n] = 0, this.data[n + 1] = l, this.data[n + 2] = u, this.data[n + 3] = a;
              }
              this.pos += this.width % 4;
            }
          }, x.prototype.bit32 = function() {
            if (this.compress == 3) {
              this.maskRed = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.maskGreen = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.maskBlue = this.buffer.readUInt32LE(this.pos), this.pos += 4, this.mask0 = this.buffer.readUInt32LE(this.pos), this.pos += 4;
              for (var y = this.height - 1; y >= 0; y--)
                for (var E = this.bottom_up ? y : this.height - 1 - y, d = 0; d < this.width; d++) {
                  var l = this.buffer.readUInt8(this.pos++), u = this.buffer.readUInt8(this.pos++), a = this.buffer.readUInt8(this.pos++), n = this.buffer.readUInt8(this.pos++), c = E * this.width * 4 + d * 4;
                  this.data[c] = l, this.data[c + 1] = u, this.data[c + 2] = a, this.data[c + 3] = n;
                }
            } else
              for (var y = this.height - 1; y >= 0; y--)
                for (var E = this.bottom_up ? y : this.height - 1 - y, d = 0; d < this.width; d++) {
                  var u = this.buffer.readUInt8(this.pos++), a = this.buffer.readUInt8(this.pos++), n = this.buffer.readUInt8(this.pos++), l = this.buffer.readUInt8(this.pos++), c = E * this.width * 4 + d * 4;
                  this.data[c] = l, this.data[c + 1] = u, this.data[c + 2] = a, this.data[c + 3] = n;
                }
          }, x.prototype.getData = function() {
            return this.data;
          }, Z.exports = function(y) {
            var E = new x(y);
            return E;
          };
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 32: [function(C, Z, _) {
        (function(P) {
          function x(y) {
            this.buffer = y.data, this.width = y.width, this.height = y.height, this.extraBytes = this.width % 4, this.rgbSize = this.height * (3 * this.width + this.extraBytes), this.headerInfoSize = 40, this.data = [], this.flag = "BM", this.reserved = 0, this.offset = 54, this.fileSize = this.rgbSize + this.offset, this.planes = 1, this.bitPP = 24, this.compress = 0, this.hr = 0, this.vr = 0, this.colors = 0, this.importantColors = 0;
          }
          x.prototype.encode = function() {
            var y = new P(this.offset + this.rgbSize);
            this.pos = 0, y.write(this.flag, this.pos, 2), this.pos += 2, y.writeUInt32LE(this.fileSize, this.pos), this.pos += 4, y.writeUInt32LE(this.reserved, this.pos), this.pos += 4, y.writeUInt32LE(this.offset, this.pos), this.pos += 4, y.writeUInt32LE(this.headerInfoSize, this.pos), this.pos += 4, y.writeUInt32LE(this.width, this.pos), this.pos += 4, y.writeInt32LE(-this.height, this.pos), this.pos += 4, y.writeUInt16LE(this.planes, this.pos), this.pos += 2, y.writeUInt16LE(this.bitPP, this.pos), this.pos += 2, y.writeUInt32LE(this.compress, this.pos), this.pos += 4, y.writeUInt32LE(this.rgbSize, this.pos), this.pos += 4, y.writeUInt32LE(this.hr, this.pos), this.pos += 4, y.writeUInt32LE(this.vr, this.pos), this.pos += 4, y.writeUInt32LE(this.colors, this.pos), this.pos += 4, y.writeUInt32LE(this.importantColors, this.pos), this.pos += 4;
            for (var E = 0, d = 3 * this.width + this.extraBytes, l = 0; l < this.height; l++) {
              for (var u = 0; u < this.width; u++) {
                var a = this.pos + l * d + u * 3;
                E++, y[a] = this.buffer[E++], y[a + 1] = this.buffer[E++], y[a + 2] = this.buffer[E++];
              }
              if (this.extraBytes > 0) {
                var n = this.pos + l * d + this.width * 3;
                y.fill(0, n, n + this.extraBytes);
              }
            }
            return y;
          }, Z.exports = function(y, E) {
            var d = new x(y), l = d.encode();
            return {
              data: l,
              width: y.width,
              height: y.height
            };
          };
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 33: [function(C, Z, _) {
      }, {}], 34: [function(C, Z, _) {
        (function(P, x) {
          var y = C("assert"), E = C("pako/lib/zlib/zstream"), d = C("pako/lib/zlib/deflate.js"), l = C("pako/lib/zlib/inflate.js"), u = C("pako/lib/zlib/constants");
          for (var a in u)
            _[a] = u[a];
          _.NONE = 0, _.DEFLATE = 1, _.INFLATE = 2, _.GZIP = 3, _.GUNZIP = 4, _.DEFLATERAW = 5, _.INFLATERAW = 6, _.UNZIP = 7;
          var n = 31, c = 139;
          function g(f) {
            if (typeof f != "number" || f < _.DEFLATE || f > _.UNZIP)
              throw new TypeError("Bad argument");
            this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = f, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
          }
          g.prototype.close = function() {
            if (this.write_in_progress) {
              this.pending_close = !0;
              return;
            }
            this.pending_close = !1, y(this.init_done, "close before init"), y(this.mode <= _.UNZIP), this.mode === _.DEFLATE || this.mode === _.GZIP || this.mode === _.DEFLATERAW ? d.deflateEnd(this.strm) : (this.mode === _.INFLATE || this.mode === _.GUNZIP || this.mode === _.INFLATERAW || this.mode === _.UNZIP) && l.inflateEnd(this.strm), this.mode = _.NONE, this.dictionary = null;
          }, g.prototype.write = function(f, p, s, S, b, o, A) {
            return this._write(!0, f, p, s, S, b, o, A);
          }, g.prototype.writeSync = function(f, p, s, S, b, o, A) {
            return this._write(!1, f, p, s, S, b, o, A);
          }, g.prototype._write = function(f, p, s, S, b, o, A, T) {
            if (y.equal(arguments.length, 8), y(this.init_done, "write before init"), y(this.mode !== _.NONE, "already finalized"), y.equal(!1, this.write_in_progress, "write already in progress"), y.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, y.equal(!1, p === void 0, "must provide flush value"), this.write_in_progress = !0, p !== _.Z_NO_FLUSH && p !== _.Z_PARTIAL_FLUSH && p !== _.Z_SYNC_FLUSH && p !== _.Z_FULL_FLUSH && p !== _.Z_FINISH && p !== _.Z_BLOCK)
              throw new Error("Invalid flush value");
            if (s == null && (s = x.alloc(0), b = 0, S = 0), this.strm.avail_in = b, this.strm.input = s, this.strm.next_in = S, this.strm.avail_out = T, this.strm.output = o, this.strm.next_out = A, this.flush = p, !f)
              return this._process(), this._checkError() ? this._afterSync() : void 0;
            var R = this;
            return P.nextTick(function() {
              R._process(), R._after();
            }), this;
          }, g.prototype._afterSync = function() {
            var f = this.strm.avail_out, p = this.strm.avail_in;
            return this.write_in_progress = !1, [p, f];
          }, g.prototype._process = function() {
            var f = null;
            switch (this.mode) {
              case _.DEFLATE:
              case _.GZIP:
              case _.DEFLATERAW:
                this.err = d.deflate(this.strm, this.flush);
                break;
              case _.UNZIP:
                switch (this.strm.avail_in > 0 && (f = this.strm.next_in), this.gzip_id_bytes_read) {
                  case 0:
                    if (f === null)
                      break;
                    if (this.strm.input[f] === n) {
                      if (this.gzip_id_bytes_read = 1, f++, this.strm.avail_in === 1)
                        break;
                    } else {
                      this.mode = _.INFLATE;
                      break;
                    }
                  // fallthrough
                  case 1:
                    if (f === null)
                      break;
                    this.strm.input[f] === c ? (this.gzip_id_bytes_read = 2, this.mode = _.GUNZIP) : this.mode = _.INFLATE;
                    break;
                  default:
                    throw new Error("invalid number of gzip magic number bytes read");
                }
              // fallthrough
              case _.INFLATE:
              case _.GUNZIP:
              case _.INFLATERAW:
                for (this.err = l.inflate(
                  this.strm,
                  this.flush
                  // If data was encoded with dictionary
                ), this.err === _.Z_NEED_DICT && this.dictionary && (this.err = l.inflateSetDictionary(this.strm, this.dictionary), this.err === _.Z_OK ? this.err = l.inflate(this.strm, this.flush) : this.err === _.Z_DATA_ERROR && (this.err = _.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === _.GUNZIP && this.err === _.Z_STREAM_END && this.strm.next_in[0] !== 0; )
                  this.reset(), this.err = l.inflate(this.strm, this.flush);
                break;
              default:
                throw new Error("Unknown mode " + this.mode);
            }
          }, g.prototype._checkError = function() {
            switch (this.err) {
              case _.Z_OK:
              case _.Z_BUF_ERROR:
                if (this.strm.avail_out !== 0 && this.flush === _.Z_FINISH)
                  return this._error("unexpected end of file"), !1;
                break;
              case _.Z_STREAM_END:
                break;
              case _.Z_NEED_DICT:
                return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
              default:
                return this._error("Zlib error"), !1;
            }
            return !0;
          }, g.prototype._after = function() {
            if (this._checkError()) {
              var f = this.strm.avail_out, p = this.strm.avail_in;
              this.write_in_progress = !1, this.callback(p, f), this.pending_close && this.close();
            }
          }, g.prototype._error = function(f) {
            this.strm.msg && (f = this.strm.msg), this.onerror(
              f,
              this.err
              // no hope of rescue.
            ), this.write_in_progress = !1, this.pending_close && this.close();
          }, g.prototype.init = function(f, p, s, S, b) {
            y(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), y(f >= 8 && f <= 15, "invalid windowBits"), y(p >= -1 && p <= 9, "invalid compression level"), y(s >= 1 && s <= 9, "invalid memlevel"), y(S === _.Z_FILTERED || S === _.Z_HUFFMAN_ONLY || S === _.Z_RLE || S === _.Z_FIXED || S === _.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(p, f, s, S, b), this._setDictionary();
          }, g.prototype.params = function() {
            throw new Error("deflateParams Not supported");
          }, g.prototype.reset = function() {
            this._reset(), this._setDictionary();
          }, g.prototype._init = function(f, p, s, S, b) {
            switch (this.level = f, this.windowBits = p, this.memLevel = s, this.strategy = S, this.flush = _.Z_NO_FLUSH, this.err = _.Z_OK, (this.mode === _.GZIP || this.mode === _.GUNZIP) && (this.windowBits += 16), this.mode === _.UNZIP && (this.windowBits += 32), (this.mode === _.DEFLATERAW || this.mode === _.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new E(), this.mode) {
              case _.DEFLATE:
              case _.GZIP:
              case _.DEFLATERAW:
                this.err = d.deflateInit2(this.strm, this.level, _.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                break;
              case _.INFLATE:
              case _.GUNZIP:
              case _.INFLATERAW:
              case _.UNZIP:
                this.err = l.inflateInit2(this.strm, this.windowBits);
                break;
              default:
                throw new Error("Unknown mode " + this.mode);
            }
            this.err !== _.Z_OK && this._error("Init error"), this.dictionary = b, this.write_in_progress = !1, this.init_done = !0;
          }, g.prototype._setDictionary = function() {
            if (this.dictionary != null) {
              switch (this.err = _.Z_OK, this.mode) {
                case _.DEFLATE:
                case _.DEFLATERAW:
                  this.err = d.deflateSetDictionary(this.strm, this.dictionary);
                  break;
              }
              this.err !== _.Z_OK && this._error("Failed to set dictionary");
            }
          }, g.prototype._reset = function() {
            switch (this.err = _.Z_OK, this.mode) {
              case _.DEFLATE:
              case _.DEFLATERAW:
              case _.GZIP:
                this.err = d.deflateReset(this.strm);
                break;
              case _.INFLATE:
              case _.INFLATERAW:
              case _.GUNZIP:
                this.err = l.inflateReset(this.strm);
                break;
            }
            this.err !== _.Z_OK && this._error("Failed to reset stream");
          }, _.Zlib = g;
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { _process: 133, assert: 25, buffer: 48, "pako/lib/zlib/constants": 38, "pako/lib/zlib/deflate.js": 40, "pako/lib/zlib/inflate.js": 42, "pako/lib/zlib/zstream": 46 }], 35: [function(C, Z, _) {
        (function(P) {
          var x = C("buffer").Buffer, y = C("stream").Transform, E = C("./binding"), d = C("util"), l = C("assert").ok, u = C("buffer").kMaxLength, a = "Cannot create final Buffer. It would be larger than 0x" + u.toString(16) + " bytes";
          E.Z_MIN_WINDOWBITS = 8, E.Z_MAX_WINDOWBITS = 15, E.Z_DEFAULT_WINDOWBITS = 15, E.Z_MIN_CHUNK = 64, E.Z_MAX_CHUNK = 1 / 0, E.Z_DEFAULT_CHUNK = 16 * 1024, E.Z_MIN_MEMLEVEL = 1, E.Z_MAX_MEMLEVEL = 9, E.Z_DEFAULT_MEMLEVEL = 8, E.Z_MIN_LEVEL = -1, E.Z_MAX_LEVEL = 9, E.Z_DEFAULT_LEVEL = E.Z_DEFAULT_COMPRESSION;
          for (var n = Object.keys(E), c = 0; c < n.length; c++) {
            var g = n[c];
            g.match(/^Z/) && Object.defineProperty(_, g, {
              enumerable: !0,
              value: E[g],
              writable: !1
            });
          }
          for (var f = {
            Z_OK: E.Z_OK,
            Z_STREAM_END: E.Z_STREAM_END,
            Z_NEED_DICT: E.Z_NEED_DICT,
            Z_ERRNO: E.Z_ERRNO,
            Z_STREAM_ERROR: E.Z_STREAM_ERROR,
            Z_DATA_ERROR: E.Z_DATA_ERROR,
            Z_MEM_ERROR: E.Z_MEM_ERROR,
            Z_BUF_ERROR: E.Z_BUF_ERROR,
            Z_VERSION_ERROR: E.Z_VERSION_ERROR
          }, p = Object.keys(f), s = 0; s < p.length; s++) {
            var S = p[s];
            f[f[S]] = S;
          }
          Object.defineProperty(_, "codes", {
            enumerable: !0,
            value: Object.freeze(f),
            writable: !1
          }), _.Deflate = A, _.Inflate = T, _.Gzip = R, _.Gunzip = L, _.DeflateRaw = z, _.InflateRaw = U, _.Unzip = J, _.createDeflate = function(W) {
            return new A(W);
          }, _.createInflate = function(W) {
            return new T(W);
          }, _.createDeflateRaw = function(W) {
            return new z(W);
          }, _.createInflateRaw = function(W) {
            return new U(W);
          }, _.createGzip = function(W) {
            return new R(W);
          }, _.createGunzip = function(W) {
            return new L(W);
          }, _.createUnzip = function(W) {
            return new J(W);
          }, _.deflate = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new A(Q), W, de);
          }, _.deflateSync = function(W, Q) {
            return o(new A(Q), W);
          }, _.gzip = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new R(Q), W, de);
          }, _.gzipSync = function(W, Q) {
            return o(new R(Q), W);
          }, _.deflateRaw = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new z(Q), W, de);
          }, _.deflateRawSync = function(W, Q) {
            return o(new z(Q), W);
          }, _.unzip = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new J(Q), W, de);
          }, _.unzipSync = function(W, Q) {
            return o(new J(Q), W);
          }, _.inflate = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new T(Q), W, de);
          }, _.inflateSync = function(W, Q) {
            return o(new T(Q), W);
          }, _.gunzip = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new L(Q), W, de);
          }, _.gunzipSync = function(W, Q) {
            return o(new L(Q), W);
          }, _.inflateRaw = function(W, Q, de) {
            return typeof Q == "function" && (de = Q, Q = {}), b(new U(Q), W, de);
          }, _.inflateRawSync = function(W, Q) {
            return o(new U(Q), W);
          };
          function b(W, Q, de) {
            var _e = [], ke = 0;
            W.on("error", fe), W.on("end", xe), W.end(Q), Pe();
            function Pe() {
              for (var Ee; (Ee = W.read()) !== null; )
                _e.push(Ee), ke += Ee.length;
              W.once("readable", Pe);
            }
            function fe(Ee) {
              W.removeListener("end", xe), W.removeListener("readable", Pe), de(Ee);
            }
            function xe() {
              var Ee, Ie = null;
              ke >= u ? Ie = new RangeError(a) : Ee = x.concat(_e, ke), _e = [], W.close(), de(Ie, Ee);
            }
          }
          function o(W, Q) {
            if (typeof Q == "string" && (Q = x.from(Q)), !x.isBuffer(Q)) throw new TypeError("Not a string or buffer");
            var de = W._finishFlushFlag;
            return W._processChunk(Q, de);
          }
          function A(W) {
            if (!(this instanceof A)) return new A(W);
            se.call(this, W, E.DEFLATE);
          }
          function T(W) {
            if (!(this instanceof T)) return new T(W);
            se.call(this, W, E.INFLATE);
          }
          function R(W) {
            if (!(this instanceof R)) return new R(W);
            se.call(this, W, E.GZIP);
          }
          function L(W) {
            if (!(this instanceof L)) return new L(W);
            se.call(this, W, E.GUNZIP);
          }
          function z(W) {
            if (!(this instanceof z)) return new z(W);
            se.call(this, W, E.DEFLATERAW);
          }
          function U(W) {
            if (!(this instanceof U)) return new U(W);
            se.call(this, W, E.INFLATERAW);
          }
          function J(W) {
            if (!(this instanceof J)) return new J(W);
            se.call(this, W, E.UNZIP);
          }
          function F(W) {
            return W === E.Z_NO_FLUSH || W === E.Z_PARTIAL_FLUSH || W === E.Z_SYNC_FLUSH || W === E.Z_FULL_FLUSH || W === E.Z_FINISH || W === E.Z_BLOCK;
          }
          function se(W, Q) {
            var de = this;
            if (this._opts = W = W || {}, this._chunkSize = W.chunkSize || _.Z_DEFAULT_CHUNK, y.call(this, W), W.flush && !F(W.flush))
              throw new Error("Invalid flush flag: " + W.flush);
            if (W.finishFlush && !F(W.finishFlush))
              throw new Error("Invalid flush flag: " + W.finishFlush);
            if (this._flushFlag = W.flush || E.Z_NO_FLUSH, this._finishFlushFlag = typeof W.finishFlush < "u" ? W.finishFlush : E.Z_FINISH, W.chunkSize && (W.chunkSize < _.Z_MIN_CHUNK || W.chunkSize > _.Z_MAX_CHUNK))
              throw new Error("Invalid chunk size: " + W.chunkSize);
            if (W.windowBits && (W.windowBits < _.Z_MIN_WINDOWBITS || W.windowBits > _.Z_MAX_WINDOWBITS))
              throw new Error("Invalid windowBits: " + W.windowBits);
            if (W.level && (W.level < _.Z_MIN_LEVEL || W.level > _.Z_MAX_LEVEL))
              throw new Error("Invalid compression level: " + W.level);
            if (W.memLevel && (W.memLevel < _.Z_MIN_MEMLEVEL || W.memLevel > _.Z_MAX_MEMLEVEL))
              throw new Error("Invalid memLevel: " + W.memLevel);
            if (W.strategy && W.strategy != _.Z_FILTERED && W.strategy != _.Z_HUFFMAN_ONLY && W.strategy != _.Z_RLE && W.strategy != _.Z_FIXED && W.strategy != _.Z_DEFAULT_STRATEGY)
              throw new Error("Invalid strategy: " + W.strategy);
            if (W.dictionary && !x.isBuffer(W.dictionary))
              throw new Error("Invalid dictionary: it should be a Buffer instance");
            this._handle = new E.Zlib(Q);
            var _e = this;
            this._hadError = !1, this._handle.onerror = function(fe, xe) {
              ee(_e), _e._hadError = !0;
              var Ee = new Error(fe);
              Ee.errno = xe, Ee.code = _.codes[xe], _e.emit("error", Ee);
            };
            var ke = _.Z_DEFAULT_COMPRESSION;
            typeof W.level == "number" && (ke = W.level);
            var Pe = _.Z_DEFAULT_STRATEGY;
            typeof W.strategy == "number" && (Pe = W.strategy), this._handle.init(W.windowBits || _.Z_DEFAULT_WINDOWBITS, ke, W.memLevel || _.Z_DEFAULT_MEMLEVEL, Pe, W.dictionary), this._buffer = x.allocUnsafe(this._chunkSize), this._offset = 0, this._level = ke, this._strategy = Pe, this.once("end", this.close), Object.defineProperty(this, "_closed", {
              get: function() {
                return !de._handle;
              },
              configurable: !0,
              enumerable: !0
            });
          }
          d.inherits(se, y), se.prototype.params = function(W, Q, de) {
            if (W < _.Z_MIN_LEVEL || W > _.Z_MAX_LEVEL)
              throw new RangeError("Invalid compression level: " + W);
            if (Q != _.Z_FILTERED && Q != _.Z_HUFFMAN_ONLY && Q != _.Z_RLE && Q != _.Z_FIXED && Q != _.Z_DEFAULT_STRATEGY)
              throw new TypeError("Invalid strategy: " + Q);
            if (this._level !== W || this._strategy !== Q) {
              var _e = this;
              this.flush(E.Z_SYNC_FLUSH, function() {
                l(_e._handle, "zlib binding closed"), _e._handle.params(W, Q), _e._hadError || (_e._level = W, _e._strategy = Q, de && de());
              });
            } else
              P.nextTick(de);
          }, se.prototype.reset = function() {
            return l(this._handle, "zlib binding closed"), this._handle.reset();
          }, se.prototype._flush = function(W) {
            this._transform(x.alloc(0), "", W);
          }, se.prototype.flush = function(W, Q) {
            var de = this, _e = this._writableState;
            (typeof W == "function" || W === void 0 && !Q) && (Q = W, W = E.Z_FULL_FLUSH), _e.ended ? Q && P.nextTick(Q) : _e.ending ? Q && this.once("end", Q) : _e.needDrain ? Q && this.once("drain", function() {
              return de.flush(W, Q);
            }) : (this._flushFlag = W, this.write(x.alloc(0), "", Q));
          }, se.prototype.close = function(W) {
            ee(this, W), P.nextTick(ie, this);
          };
          function ee(W, Q) {
            Q && P.nextTick(Q), W._handle && (W._handle.close(), W._handle = null);
          }
          function ie(W) {
            W.emit("close");
          }
          se.prototype._transform = function(W, Q, de) {
            var _e, ke = this._writableState, Pe = ke.ending || ke.ended, fe = Pe && (!W || ke.length === W.length);
            if (W !== null && !x.isBuffer(W)) return de(new Error("invalid input"));
            if (!this._handle) return de(new Error("zlib binding closed"));
            fe ? _e = this._finishFlushFlag : (_e = this._flushFlag, W.length >= ke.length && (this._flushFlag = this._opts.flush || E.Z_NO_FLUSH)), this._processChunk(W, _e, de);
          }, se.prototype._processChunk = function(W, Q, de) {
            var _e = W && W.length, ke = this._chunkSize - this._offset, Pe = 0, fe = this, xe = typeof de == "function";
            if (!xe) {
              var Ee = [], Ie = 0, je;
              this.on("error", function(We) {
                je = We;
              }), l(this._handle, "zlib binding closed");
              do
                var Ue = this._handle.writeSync(
                  Q,
                  W,
                  // in
                  Pe,
                  // in_off
                  _e,
                  // in_len
                  this._buffer,
                  // out
                  this._offset,
                  //out_off
                  ke
                );
              while (!this._hadError && $e(Ue[0], Ue[1]));
              if (this._hadError)
                throw je;
              if (Ie >= u)
                throw ee(this), new RangeError(a);
              var He = x.concat(Ee, Ie);
              return ee(this), He;
            }
            l(this._handle, "zlib binding closed");
            var Ze = this._handle.write(
              Q,
              W,
              // in
              Pe,
              // in_off
              _e,
              // in_len
              this._buffer,
              // out
              this._offset,
              //out_off
              ke
            );
            Ze.buffer = W, Ze.callback = $e;
            function $e(We, Ve) {
              if (this && (this.buffer = null, this.callback = null), !fe._hadError) {
                var Re = ke - Ve;
                if (l(Re >= 0, "have should not go down"), Re > 0) {
                  var De = fe._buffer.slice(fe._offset, fe._offset + Re);
                  fe._offset += Re, xe ? fe.push(De) : (Ee.push(De), Ie += De.length);
                }
                if ((Ve === 0 || fe._offset >= fe._chunkSize) && (ke = fe._chunkSize, fe._offset = 0, fe._buffer = x.allocUnsafe(fe._chunkSize)), Ve === 0) {
                  if (Pe += _e - We, _e = We, !xe) return !0;
                  var Ne = fe._handle.write(Q, W, Pe, _e, fe._buffer, fe._offset, fe._chunkSize);
                  Ne.callback = $e, Ne.buffer = W;
                  return;
                }
                if (!xe) return !1;
                de();
              }
            }
          }, d.inherits(A, se), d.inherits(T, se), d.inherits(R, se), d.inherits(L, se), d.inherits(z, se), d.inherits(U, se), d.inherits(J, se);
        }).call(this, C("_process"));
      }, { "./binding": 34, _process: 133, assert: 25, buffer: 48, stream: 155, util: 186 }], 36: [function(C, Z, _) {
        var P = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
        function x(d, l) {
          return Object.prototype.hasOwnProperty.call(d, l);
        }
        _.assign = function(d) {
          for (var l = Array.prototype.slice.call(arguments, 1); l.length; ) {
            var u = l.shift();
            if (u) {
              if (typeof u != "object")
                throw new TypeError(u + "must be non-object");
              for (var a in u)
                x(u, a) && (d[a] = u[a]);
            }
          }
          return d;
        }, _.shrinkBuf = function(d, l) {
          return d.length === l ? d : d.subarray ? d.subarray(0, l) : (d.length = l, d);
        };
        var y = {
          arraySet: function(d, l, u, a, n) {
            if (l.subarray && d.subarray) {
              d.set(l.subarray(u, u + a), n);
              return;
            }
            for (var c = 0; c < a; c++)
              d[n + c] = l[u + c];
          },
          // Join array of chunks to single array.
          flattenChunks: function(d) {
            var l, u, a, n, c, g;
            for (a = 0, l = 0, u = d.length; l < u; l++)
              a += d[l].length;
            for (g = new Uint8Array(a), n = 0, l = 0, u = d.length; l < u; l++)
              c = d[l], g.set(c, n), n += c.length;
            return g;
          }
        }, E = {
          arraySet: function(d, l, u, a, n) {
            for (var c = 0; c < a; c++)
              d[n + c] = l[u + c];
          },
          // Join array of chunks to single array.
          flattenChunks: function(d) {
            return [].concat.apply([], d);
          }
        };
        _.setTyped = function(d) {
          d ? (_.Buf8 = Uint8Array, _.Buf16 = Uint16Array, _.Buf32 = Int32Array, _.assign(_, y)) : (_.Buf8 = Array, _.Buf16 = Array, _.Buf32 = Array, _.assign(_, E));
        }, _.setTyped(P);
      }, {}], 37: [function(C, Z, _) {
        function P(x, y, E, d) {
          for (var l = x & 65535 | 0, u = x >>> 16 & 65535 | 0, a = 0; E !== 0; ) {
            a = E > 2e3 ? 2e3 : E, E -= a;
            do
              l = l + y[d++] | 0, u = u + l | 0;
            while (--a);
            l %= 65521, u %= 65521;
          }
          return l | u << 16 | 0;
        }
        Z.exports = P;
      }, {}], 38: [function(C, Z, _) {
        Z.exports = {
          /* Allowed flush values; see deflate() and inflate() below for details */
          Z_NO_FLUSH: 0,
          Z_PARTIAL_FLUSH: 1,
          Z_SYNC_FLUSH: 2,
          Z_FULL_FLUSH: 3,
          Z_FINISH: 4,
          Z_BLOCK: 5,
          Z_TREES: 6,
          /* Return codes for the compression/decompression functions. Negative values
          * are errors, positive values are used for special but normal events.
          */
          Z_OK: 0,
          Z_STREAM_END: 1,
          Z_NEED_DICT: 2,
          Z_ERRNO: -1,
          Z_STREAM_ERROR: -2,
          Z_DATA_ERROR: -3,
          //Z_MEM_ERROR:     -4,
          Z_BUF_ERROR: -5,
          //Z_VERSION_ERROR: -6,
          /* compression levels */
          Z_NO_COMPRESSION: 0,
          Z_BEST_SPEED: 1,
          Z_BEST_COMPRESSION: 9,
          Z_DEFAULT_COMPRESSION: -1,
          Z_FILTERED: 1,
          Z_HUFFMAN_ONLY: 2,
          Z_RLE: 3,
          Z_FIXED: 4,
          Z_DEFAULT_STRATEGY: 0,
          /* Possible values of the data_type field (though see inflate()) */
          Z_BINARY: 0,
          Z_TEXT: 1,
          //Z_ASCII:                1, // = Z_TEXT (deprecated)
          Z_UNKNOWN: 2,
          /* The deflate compression method */
          Z_DEFLATED: 8
          //Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
      }, {}], 39: [function(C, Z, _) {
        function P() {
          for (var E, d = [], l = 0; l < 256; l++) {
            E = l;
            for (var u = 0; u < 8; u++)
              E = E & 1 ? 3988292384 ^ E >>> 1 : E >>> 1;
            d[l] = E;
          }
          return d;
        }
        var x = P();
        function y(E, d, l, u) {
          var a = x, n = u + l;
          E ^= -1;
          for (var c = u; c < n; c++)
            E = E >>> 8 ^ a[(E ^ d[c]) & 255];
          return E ^ -1;
        }
        Z.exports = y;
      }, {}], 40: [function(C, Z, _) {
        var P = C("../utils/common"), x = C("./trees"), y = C("./adler32"), E = C("./crc32"), d = C("./messages"), l = 0, u = 1, a = 3, n = 4, c = 5, g = 0, f = 1, p = -2, s = -3, S = -5, b = -1, o = 1, A = 2, T = 3, R = 4, L = 0, z = 2, U = 8, J = 9, F = 15, se = 8, ee = 29, ie = 256, W = ie + 1 + ee, Q = 30, de = 19, _e = 2 * W + 1, ke = 15, Pe = 3, fe = 258, xe = fe + Pe + 1, Ee = 32, Ie = 42, je = 69, Ue = 73, He = 91, Ze = 103, $e = 113, We = 666, Ve = 1, Re = 2, De = 3, Ne = 4, we = 3;
        function re(m, oe) {
          return m.msg = d[oe], oe;
        }
        function $(m) {
          return (m << 1) - (m > 4 ? 9 : 0);
        }
        function Ce(m) {
          for (var oe = m.length; --oe >= 0; )
            m[oe] = 0;
        }
        function ve(m) {
          var oe = m.state, me = oe.pending;
          me > m.avail_out && (me = m.avail_out), me !== 0 && (P.arraySet(m.output, oe.pending_buf, oe.pending_out, me, m.next_out), m.next_out += me, oe.pending_out += me, m.total_out += me, m.avail_out -= me, oe.pending -= me, oe.pending === 0 && (oe.pending_out = 0));
        }
        function Y(m, oe) {
          x._tr_flush_block(m, m.block_start >= 0 ? m.block_start : -1, m.strstart - m.block_start, oe), m.block_start = m.strstart, ve(m.strm);
        }
        function G(m, oe) {
          m.pending_buf[m.pending++] = oe;
        }
        function Ae(m, oe) {
          m.pending_buf[m.pending++] = oe >>> 8 & 255, m.pending_buf[m.pending++] = oe & 255;
        }
        function e(m, oe, me, O) {
          var ce = m.avail_in;
          return ce > O && (ce = O), ce === 0 ? 0 : (m.avail_in -= ce, P.arraySet(oe, m.input, m.next_in, ce, me), m.state.wrap === 1 ? m.adler = y(m.adler, oe, ce, me) : m.state.wrap === 2 && (m.adler = E(m.adler, oe, ce, me)), m.next_in += ce, m.total_in += ce, ce);
        }
        function r(m, oe) {
          var me = m.max_chain_length, O = m.strstart, ce, Oe, Be = m.prev_length, Ge = m.nice_match, Fe = m.strstart > m.w_size - xe ? m.strstart - (m.w_size - xe) : 0, Ye = m.window, Ke = m.w_mask, et = m.prev, Je = m.strstart + fe, nt = Ye[O + Be - 1], pt = Ye[O + Be];
          m.prev_length >= m.good_match && (me >>= 2), Ge > m.lookahead && (Ge = m.lookahead);
          do
            if (ce = oe, !(Ye[ce + Be] !== pt || Ye[ce + Be - 1] !== nt || Ye[ce] !== Ye[O] || Ye[++ce] !== Ye[O + 1])) {
              O += 2, ce++;
              do
                ;
              while (Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && O < Je);
              if (Oe = fe - (Je - O), O = Je - fe, Oe > Be) {
                if (m.match_start = oe, Be = Oe, Oe >= Ge)
                  break;
                nt = Ye[O + Be - 1], pt = Ye[O + Be];
              }
            }
          while ((oe = et[oe & Ke]) > Fe && --me !== 0);
          return Be <= m.lookahead ? Be : m.lookahead;
        }
        function h(m) {
          var oe = m.w_size, me, O, ce, Oe, Be;
          do {
            if (Oe = m.window_size - m.lookahead - m.strstart, m.strstart >= oe + (oe - xe)) {
              P.arraySet(m.window, m.window, oe, oe, 0), m.match_start -= oe, m.strstart -= oe, m.block_start -= oe, O = m.hash_size, me = O;
              do
                ce = m.head[--me], m.head[me] = ce >= oe ? ce - oe : 0;
              while (--O);
              O = oe, me = O;
              do
                ce = m.prev[--me], m.prev[me] = ce >= oe ? ce - oe : 0;
              while (--O);
              Oe += oe;
            }
            if (m.strm.avail_in === 0)
              break;
            if (O = e(m.strm, m.window, m.strstart + m.lookahead, Oe), m.lookahead += O, m.lookahead + m.insert >= Pe)
              for (Be = m.strstart - m.insert, m.ins_h = m.window[Be], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[Be + 1]) & m.hash_mask; m.insert && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[Be + Pe - 1]) & m.hash_mask, m.prev[Be & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = Be, Be++, m.insert--, !(m.lookahead + m.insert < Pe)); )
                ;
          } while (m.lookahead < xe && m.strm.avail_in !== 0);
        }
        function k(m, oe) {
          var me = 65535;
          for (me > m.pending_buf_size - 5 && (me = m.pending_buf_size - 5); ; ) {
            if (m.lookahead <= 1) {
              if (h(m), m.lookahead === 0 && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            m.strstart += m.lookahead, m.lookahead = 0;
            var O = m.block_start + me;
            if ((m.strstart === 0 || m.strstart >= O) && (m.lookahead = m.strstart - O, m.strstart = O, Y(m, !1), m.strm.avail_out === 0) || m.strstart - m.block_start >= m.w_size - xe && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : (m.strstart > m.block_start && (Y(m, !1), m.strm.avail_out === 0), Ve);
        }
        function I(m, oe) {
          for (var me, O; ; ) {
            if (m.lookahead < xe) {
              if (h(m), m.lookahead < xe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (me = 0, m.lookahead >= Pe && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), me !== 0 && m.strstart - me <= m.w_size - xe && (m.match_length = r(m, me)), m.match_length >= Pe)
              if (O = x._tr_tally(m, m.strstart - m.match_start, m.match_length - Pe), m.lookahead -= m.match_length, m.match_length <= m.max_lazy_match && m.lookahead >= Pe) {
                m.match_length--;
                do
                  m.strstart++, m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart;
                while (--m.match_length !== 0);
                m.strstart++;
              } else
                m.strstart += m.match_length, m.match_length = 0, m.ins_h = m.window[m.strstart], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + 1]) & m.hash_mask;
            else
              O = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++;
            if (O && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = m.strstart < Pe - 1 ? m.strstart : Pe - 1, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function B(m, oe) {
          for (var me, O, ce; ; ) {
            if (m.lookahead < xe) {
              if (h(m), m.lookahead < xe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (me = 0, m.lookahead >= Pe && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), m.prev_length = m.match_length, m.prev_match = m.match_start, m.match_length = Pe - 1, me !== 0 && m.prev_length < m.max_lazy_match && m.strstart - me <= m.w_size - xe && (m.match_length = r(m, me), m.match_length <= 5 && (m.strategy === o || m.match_length === Pe && m.strstart - m.match_start > 4096) && (m.match_length = Pe - 1)), m.prev_length >= Pe && m.match_length <= m.prev_length) {
              ce = m.strstart + m.lookahead - Pe, O = x._tr_tally(m, m.strstart - 1 - m.prev_match, m.prev_length - Pe), m.lookahead -= m.prev_length - 1, m.prev_length -= 2;
              do
                ++m.strstart <= ce && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart);
              while (--m.prev_length !== 0);
              if (m.match_available = 0, m.match_length = Pe - 1, m.strstart++, O && (Y(m, !1), m.strm.avail_out === 0))
                return Ve;
            } else if (m.match_available) {
              if (O = x._tr_tally(m, 0, m.window[m.strstart - 1]), O && Y(m, !1), m.strstart++, m.lookahead--, m.strm.avail_out === 0)
                return Ve;
            } else
              m.match_available = 1, m.strstart++, m.lookahead--;
          }
          return m.match_available && (O = x._tr_tally(m, 0, m.window[m.strstart - 1]), m.match_available = 0), m.insert = m.strstart < Pe - 1 ? m.strstart : Pe - 1, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function j(m, oe) {
          for (var me, O, ce, Oe, Be = m.window; ; ) {
            if (m.lookahead <= fe) {
              if (h(m), m.lookahead <= fe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (m.match_length = 0, m.lookahead >= Pe && m.strstart > 0 && (ce = m.strstart - 1, O = Be[ce], O === Be[++ce] && O === Be[++ce] && O === Be[++ce])) {
              Oe = m.strstart + fe;
              do
                ;
              while (O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && ce < Oe);
              m.match_length = fe - (Oe - ce), m.match_length > m.lookahead && (m.match_length = m.lookahead);
            }
            if (m.match_length >= Pe ? (me = x._tr_tally(m, 1, m.match_length - Pe), m.lookahead -= m.match_length, m.strstart += m.match_length, m.match_length = 0) : (me = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++), me && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function H(m, oe) {
          for (var me; ; ) {
            if (m.lookahead === 0 && (h(m), m.lookahead === 0)) {
              if (oe === l)
                return Ve;
              break;
            }
            if (m.match_length = 0, me = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++, me && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function X(m, oe, me, O, ce) {
          this.good_length = m, this.max_lazy = oe, this.nice_length = me, this.max_chain = O, this.func = ce;
        }
        var ue;
        ue = [
          /*      good lazy nice chain */
          new X(0, 0, 0, 0, k),
          /* 0 store only */
          new X(4, 4, 8, 4, I),
          /* 1 max speed, no lazy matches */
          new X(4, 5, 16, 8, I),
          /* 2 */
          new X(4, 6, 32, 32, I),
          /* 3 */
          new X(4, 4, 16, 16, B),
          /* 4 lazy matches */
          new X(8, 16, 32, 32, B),
          /* 5 */
          new X(8, 16, 128, 128, B),
          /* 6 */
          new X(8, 32, 128, 256, B),
          /* 7 */
          new X(32, 128, 258, 1024, B),
          /* 8 */
          new X(32, 258, 258, 4096, B)
          /* 9 max compression */
        ];
        function pe(m) {
          m.window_size = 2 * m.w_size, Ce(m.head), m.max_lazy_match = ue[m.level].max_lazy, m.good_match = ue[m.level].good_length, m.nice_match = ue[m.level].nice_length, m.max_chain_length = ue[m.level].max_chain, m.strstart = 0, m.block_start = 0, m.lookahead = 0, m.insert = 0, m.match_length = m.prev_length = Pe - 1, m.match_available = 0, m.ins_h = 0;
        }
        function M() {
          this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = U, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new P.Buf16(_e * 2), this.dyn_dtree = new P.Buf16((2 * Q + 1) * 2), this.bl_tree = new P.Buf16((2 * de + 1) * 2), Ce(this.dyn_ltree), Ce(this.dyn_dtree), Ce(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new P.Buf16(ke + 1), this.heap = new P.Buf16(2 * W + 1), Ce(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new P.Buf16(2 * W + 1), Ce(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
        }
        function q(m) {
          var oe;
          return !m || !m.state ? re(m, p) : (m.total_in = m.total_out = 0, m.data_type = z, oe = m.state, oe.pending = 0, oe.pending_out = 0, oe.wrap < 0 && (oe.wrap = -oe.wrap), oe.status = oe.wrap ? Ie : $e, m.adler = oe.wrap === 2 ? 0 : 1, oe.last_flush = l, x._tr_init(oe), g);
        }
        function K(m) {
          var oe = q(m);
          return oe === g && pe(m.state), oe;
        }
        function be(m, oe) {
          return !m || !m.state || m.state.wrap !== 2 ? p : (m.state.gzhead = oe, g);
        }
        function te(m, oe, me, O, ce, Oe) {
          if (!m)
            return p;
          var Be = 1;
          if (oe === b && (oe = 6), O < 0 ? (Be = 0, O = -O) : O > 15 && (Be = 2, O -= 16), ce < 1 || ce > J || me !== U || O < 8 || O > 15 || oe < 0 || oe > 9 || Oe < 0 || Oe > R)
            return re(m, p);
          O === 8 && (O = 9);
          var Ge = new M();
          return m.state = Ge, Ge.strm = m, Ge.wrap = Be, Ge.gzhead = null, Ge.w_bits = O, Ge.w_size = 1 << Ge.w_bits, Ge.w_mask = Ge.w_size - 1, Ge.hash_bits = ce + 7, Ge.hash_size = 1 << Ge.hash_bits, Ge.hash_mask = Ge.hash_size - 1, Ge.hash_shift = ~~((Ge.hash_bits + Pe - 1) / Pe), Ge.window = new P.Buf8(Ge.w_size * 2), Ge.head = new P.Buf16(Ge.hash_size), Ge.prev = new P.Buf16(Ge.w_size), Ge.lit_bufsize = 1 << ce + 6, Ge.pending_buf_size = Ge.lit_bufsize * 4, Ge.pending_buf = new P.Buf8(Ge.pending_buf_size), Ge.d_buf = 1 * Ge.lit_bufsize, Ge.l_buf = 3 * Ge.lit_bufsize, Ge.level = oe, Ge.strategy = Oe, Ge.method = me, K(m);
        }
        function he(m, oe) {
          return te(m, oe, U, F, se, L);
        }
        function D(m, oe) {
          var me, O, ce, Oe;
          if (!m || !m.state || oe > c || oe < 0)
            return m ? re(m, p) : p;
          if (O = m.state, !m.output || !m.input && m.avail_in !== 0 || O.status === We && oe !== n)
            return re(m, m.avail_out === 0 ? S : p);
          if (O.strm = m, me = O.last_flush, O.last_flush = oe, O.status === Ie)
            if (O.wrap === 2)
              m.adler = 0, G(O, 31), G(O, 139), G(O, 8), O.gzhead ? (G(
                O,
                (O.gzhead.text ? 1 : 0) + (O.gzhead.hcrc ? 2 : 0) + (O.gzhead.extra ? 4 : 0) + (O.gzhead.name ? 8 : 0) + (O.gzhead.comment ? 16 : 0)
              ), G(O, O.gzhead.time & 255), G(O, O.gzhead.time >> 8 & 255), G(O, O.gzhead.time >> 16 & 255), G(O, O.gzhead.time >> 24 & 255), G(O, O.level === 9 ? 2 : O.strategy >= A || O.level < 2 ? 4 : 0), G(O, O.gzhead.os & 255), O.gzhead.extra && O.gzhead.extra.length && (G(O, O.gzhead.extra.length & 255), G(O, O.gzhead.extra.length >> 8 & 255)), O.gzhead.hcrc && (m.adler = E(m.adler, O.pending_buf, O.pending, 0)), O.gzindex = 0, O.status = je) : (G(O, 0), G(O, 0), G(O, 0), G(O, 0), G(O, 0), G(O, O.level === 9 ? 2 : O.strategy >= A || O.level < 2 ? 4 : 0), G(O, we), O.status = $e);
            else {
              var Be = U + (O.w_bits - 8 << 4) << 8, Ge = -1;
              O.strategy >= A || O.level < 2 ? Ge = 0 : O.level < 6 ? Ge = 1 : O.level === 6 ? Ge = 2 : Ge = 3, Be |= Ge << 6, O.strstart !== 0 && (Be |= Ee), Be += 31 - Be % 31, O.status = $e, Ae(O, Be), O.strstart !== 0 && (Ae(O, m.adler >>> 16), Ae(O, m.adler & 65535)), m.adler = 1;
            }
          if (O.status === je)
            if (O.gzhead.extra) {
              for (ce = O.pending; O.gzindex < (O.gzhead.extra.length & 65535) && !(O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)); )
                G(O, O.gzhead.extra[O.gzindex] & 255), O.gzindex++;
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), O.gzindex === O.gzhead.extra.length && (O.gzindex = 0, O.status = Ue);
            } else
              O.status = Ue;
          if (O.status === Ue)
            if (O.gzhead.name) {
              ce = O.pending;
              do {
                if (O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)) {
                  Oe = 1;
                  break;
                }
                O.gzindex < O.gzhead.name.length ? Oe = O.gzhead.name.charCodeAt(O.gzindex++) & 255 : Oe = 0, G(O, Oe);
              } while (Oe !== 0);
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), Oe === 0 && (O.gzindex = 0, O.status = He);
            } else
              O.status = He;
          if (O.status === He)
            if (O.gzhead.comment) {
              ce = O.pending;
              do {
                if (O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)) {
                  Oe = 1;
                  break;
                }
                O.gzindex < O.gzhead.comment.length ? Oe = O.gzhead.comment.charCodeAt(O.gzindex++) & 255 : Oe = 0, G(O, Oe);
              } while (Oe !== 0);
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), Oe === 0 && (O.status = Ze);
            } else
              O.status = Ze;
          if (O.status === Ze && (O.gzhead.hcrc ? (O.pending + 2 > O.pending_buf_size && ve(m), O.pending + 2 <= O.pending_buf_size && (G(O, m.adler & 255), G(O, m.adler >> 8 & 255), m.adler = 0, O.status = $e)) : O.status = $e), O.pending !== 0) {
            if (ve(m), m.avail_out === 0)
              return O.last_flush = -1, g;
          } else if (m.avail_in === 0 && $(oe) <= $(me) && oe !== n)
            return re(m, S);
          if (O.status === We && m.avail_in !== 0)
            return re(m, S);
          if (m.avail_in !== 0 || O.lookahead !== 0 || oe !== l && O.status !== We) {
            var Fe = O.strategy === A ? H(O, oe) : O.strategy === T ? j(O, oe) : ue[O.level].func(O, oe);
            if ((Fe === De || Fe === Ne) && (O.status = We), Fe === Ve || Fe === De)
              return m.avail_out === 0 && (O.last_flush = -1), g;
            if (Fe === Re && (oe === u ? x._tr_align(O) : oe !== c && (x._tr_stored_block(O, 0, 0, !1), oe === a && (Ce(O.head), O.lookahead === 0 && (O.strstart = 0, O.block_start = 0, O.insert = 0))), ve(m), m.avail_out === 0))
              return O.last_flush = -1, g;
          }
          return oe !== n ? g : O.wrap <= 0 ? f : (O.wrap === 2 ? (G(O, m.adler & 255), G(O, m.adler >> 8 & 255), G(O, m.adler >> 16 & 255), G(O, m.adler >> 24 & 255), G(O, m.total_in & 255), G(O, m.total_in >> 8 & 255), G(O, m.total_in >> 16 & 255), G(O, m.total_in >> 24 & 255)) : (Ae(O, m.adler >>> 16), Ae(O, m.adler & 65535)), ve(m), O.wrap > 0 && (O.wrap = -O.wrap), O.pending !== 0 ? g : f);
        }
        function Se(m) {
          var oe;
          return !m || !m.state ? p : (oe = m.state.status, oe !== Ie && oe !== je && oe !== Ue && oe !== He && oe !== Ze && oe !== $e && oe !== We ? re(m, p) : (m.state = null, oe === $e ? re(m, s) : g));
        }
        function le(m, oe) {
          var me = oe.length, O, ce, Oe, Be, Ge, Fe, Ye, Ke;
          if (!m || !m.state || (O = m.state, Be = O.wrap, Be === 2 || Be === 1 && O.status !== Ie || O.lookahead))
            return p;
          for (Be === 1 && (m.adler = y(m.adler, oe, me, 0)), O.wrap = 0, me >= O.w_size && (Be === 0 && (Ce(O.head), O.strstart = 0, O.block_start = 0, O.insert = 0), Ke = new P.Buf8(O.w_size), P.arraySet(Ke, oe, me - O.w_size, O.w_size, 0), oe = Ke, me = O.w_size), Ge = m.avail_in, Fe = m.next_in, Ye = m.input, m.avail_in = me, m.next_in = 0, m.input = oe, h(O); O.lookahead >= Pe; ) {
            ce = O.strstart, Oe = O.lookahead - (Pe - 1);
            do
              O.ins_h = (O.ins_h << O.hash_shift ^ O.window[ce + Pe - 1]) & O.hash_mask, O.prev[ce & O.w_mask] = O.head[O.ins_h], O.head[O.ins_h] = ce, ce++;
            while (--Oe);
            O.strstart = ce, O.lookahead = Pe - 1, h(O);
          }
          return O.strstart += O.lookahead, O.block_start = O.strstart, O.insert = O.lookahead, O.lookahead = 0, O.match_length = O.prev_length = Pe - 1, O.match_available = 0, m.next_in = Fe, m.input = Ye, m.avail_in = Ge, O.wrap = Be, g;
        }
        _.deflateInit = he, _.deflateInit2 = te, _.deflateReset = K, _.deflateResetKeep = q, _.deflateSetHeader = be, _.deflate = D, _.deflateEnd = Se, _.deflateSetDictionary = le, _.deflateInfo = "pako deflate (from Nodeca project)";
      }, { "../utils/common": 36, "./adler32": 37, "./crc32": 39, "./messages": 44, "./trees": 45 }], 41: [function(C, Z, _) {
        var P = 30, x = 12;
        Z.exports = function(E, d) {
          var l, u, a, n, c, g, f, p, s, S, b, o, A, T, R, L, z, U, J, F, se, ee, ie, W, Q;
          l = E.state, u = E.next_in, W = E.input, a = u + (E.avail_in - 5), n = E.next_out, Q = E.output, c = n - (d - E.avail_out), g = n + (E.avail_out - 257), f = l.dmax, p = l.wsize, s = l.whave, S = l.wnext, b = l.window, o = l.hold, A = l.bits, T = l.lencode, R = l.distcode, L = (1 << l.lenbits) - 1, z = (1 << l.distbits) - 1;
          e:
            do {
              A < 15 && (o += W[u++] << A, A += 8, o += W[u++] << A, A += 8), U = T[o & L];
              t:
                for (; ; ) {
                  if (J = U >>> 24, o >>>= J, A -= J, J = U >>> 16 & 255, J === 0)
                    Q[n++] = U & 65535;
                  else if (J & 16) {
                    F = U & 65535, J &= 15, J && (A < J && (o += W[u++] << A, A += 8), F += o & (1 << J) - 1, o >>>= J, A -= J), A < 15 && (o += W[u++] << A, A += 8, o += W[u++] << A, A += 8), U = R[o & z];
                    r:
                      for (; ; ) {
                        if (J = U >>> 24, o >>>= J, A -= J, J = U >>> 16 & 255, J & 16) {
                          if (se = U & 65535, J &= 15, A < J && (o += W[u++] << A, A += 8, A < J && (o += W[u++] << A, A += 8)), se += o & (1 << J) - 1, se > f) {
                            E.msg = "invalid distance too far back", l.mode = P;
                            break e;
                          }
                          if (o >>>= J, A -= J, J = n - c, se > J) {
                            if (J = se - J, J > s && l.sane) {
                              E.msg = "invalid distance too far back", l.mode = P;
                              break e;
                            }
                            if (ee = 0, ie = b, S === 0) {
                              if (ee += p - J, J < F) {
                                F -= J;
                                do
                                  Q[n++] = b[ee++];
                                while (--J);
                                ee = n - se, ie = Q;
                              }
                            } else if (S < J) {
                              if (ee += p + S - J, J -= S, J < F) {
                                F -= J;
                                do
                                  Q[n++] = b[ee++];
                                while (--J);
                                if (ee = 0, S < F) {
                                  J = S, F -= J;
                                  do
                                    Q[n++] = b[ee++];
                                  while (--J);
                                  ee = n - se, ie = Q;
                                }
                              }
                            } else if (ee += S - J, J < F) {
                              F -= J;
                              do
                                Q[n++] = b[ee++];
                              while (--J);
                              ee = n - se, ie = Q;
                            }
                            for (; F > 2; )
                              Q[n++] = ie[ee++], Q[n++] = ie[ee++], Q[n++] = ie[ee++], F -= 3;
                            F && (Q[n++] = ie[ee++], F > 1 && (Q[n++] = ie[ee++]));
                          } else {
                            ee = n - se;
                            do
                              Q[n++] = Q[ee++], Q[n++] = Q[ee++], Q[n++] = Q[ee++], F -= 3;
                            while (F > 2);
                            F && (Q[n++] = Q[ee++], F > 1 && (Q[n++] = Q[ee++]));
                          }
                        } else if ((J & 64) === 0) {
                          U = R[(U & 65535) + (o & (1 << J) - 1)];
                          continue r;
                        } else {
                          E.msg = "invalid distance code", l.mode = P;
                          break e;
                        }
                        break;
                      }
                  } else if ((J & 64) === 0) {
                    U = T[(U & 65535) + (o & (1 << J) - 1)];
                    continue t;
                  } else if (J & 32) {
                    l.mode = x;
                    break e;
                  } else {
                    E.msg = "invalid literal/length code", l.mode = P;
                    break e;
                  }
                  break;
                }
            } while (u < a && n < g);
          F = A >> 3, u -= F, A -= F << 3, o &= (1 << A) - 1, E.next_in = u, E.next_out = n, E.avail_in = u < a ? 5 + (a - u) : 5 - (u - a), E.avail_out = n < g ? 257 + (g - n) : 257 - (n - g), l.hold = o, l.bits = A;
        };
      }, {}], 42: [function(C, Z, _) {
        var P = C("../utils/common"), x = C("./adler32"), y = C("./crc32"), E = C("./inffast"), d = C("./inftrees"), l = 0, u = 1, a = 2, n = 4, c = 5, g = 6, f = 0, p = 1, s = 2, S = -2, b = -3, o = -4, A = -5, T = 8, R = 1, L = 2, z = 3, U = 4, J = 5, F = 6, se = 7, ee = 8, ie = 9, W = 10, Q = 11, de = 12, _e = 13, ke = 14, Pe = 15, fe = 16, xe = 17, Ee = 18, Ie = 19, je = 20, Ue = 21, He = 22, Ze = 23, $e = 24, We = 25, Ve = 26, Re = 27, De = 28, Ne = 29, we = 30, re = 31, $ = 32, Ce = 852, ve = 592, Y = 15, G = Y;
        function Ae(te) {
          return (te >>> 24 & 255) + (te >>> 8 & 65280) + ((te & 65280) << 8) + ((te & 255) << 24);
        }
        function e() {
          this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new P.Buf16(320), this.work = new P.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
        }
        function r(te) {
          var he;
          return !te || !te.state ? S : (he = te.state, te.total_in = te.total_out = he.total = 0, te.msg = "", he.wrap && (te.adler = he.wrap & 1), he.mode = R, he.last = 0, he.havedict = 0, he.dmax = 32768, he.head = null, he.hold = 0, he.bits = 0, he.lencode = he.lendyn = new P.Buf32(Ce), he.distcode = he.distdyn = new P.Buf32(ve), he.sane = 1, he.back = -1, f);
        }
        function h(te) {
          var he;
          return !te || !te.state ? S : (he = te.state, he.wsize = 0, he.whave = 0, he.wnext = 0, r(te));
        }
        function k(te, he) {
          var D, Se;
          return !te || !te.state || (Se = te.state, he < 0 ? (D = 0, he = -he) : (D = (he >> 4) + 1, he < 48 && (he &= 15)), he && (he < 8 || he > 15)) ? S : (Se.window !== null && Se.wbits !== he && (Se.window = null), Se.wrap = D, Se.wbits = he, h(te));
        }
        function I(te, he) {
          var D, Se;
          return te ? (Se = new e(), te.state = Se, Se.window = null, D = k(te, he), D !== f && (te.state = null), D) : S;
        }
        function B(te) {
          return I(te, G);
        }
        var j = !0, H, X;
        function ue(te) {
          if (j) {
            var he;
            for (H = new P.Buf32(512), X = new P.Buf32(32), he = 0; he < 144; )
              te.lens[he++] = 8;
            for (; he < 256; )
              te.lens[he++] = 9;
            for (; he < 280; )
              te.lens[he++] = 7;
            for (; he < 288; )
              te.lens[he++] = 8;
            for (d(u, te.lens, 0, 288, H, 0, te.work, { bits: 9 }), he = 0; he < 32; )
              te.lens[he++] = 5;
            d(a, te.lens, 0, 32, X, 0, te.work, { bits: 5 }), j = !1;
          }
          te.lencode = H, te.lenbits = 9, te.distcode = X, te.distbits = 5;
        }
        function pe(te, he, D, Se) {
          var le, m = te.state;
          return m.window === null && (m.wsize = 1 << m.wbits, m.wnext = 0, m.whave = 0, m.window = new P.Buf8(m.wsize)), Se >= m.wsize ? (P.arraySet(m.window, he, D - m.wsize, m.wsize, 0), m.wnext = 0, m.whave = m.wsize) : (le = m.wsize - m.wnext, le > Se && (le = Se), P.arraySet(m.window, he, D - Se, le, m.wnext), Se -= le, Se ? (P.arraySet(m.window, he, D - Se, Se, 0), m.wnext = Se, m.whave = m.wsize) : (m.wnext += le, m.wnext === m.wsize && (m.wnext = 0), m.whave < m.wsize && (m.whave += le))), 0;
        }
        function M(te, he) {
          var D, Se, le, m, oe, me, O, ce, Oe, Be, Ge, Fe, Ye, Ke, et = 0, Je, nt, pt, vt, bt, At, ot, ct, gt = new P.Buf8(4), Ct, xt, Ot = (
            /* permutation of code lengths */
            [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
          );
          if (!te || !te.state || !te.output || !te.input && te.avail_in !== 0)
            return S;
          D = te.state, D.mode === de && (D.mode = _e), oe = te.next_out, le = te.output, O = te.avail_out, m = te.next_in, Se = te.input, me = te.avail_in, ce = D.hold, Oe = D.bits, Be = me, Ge = O, ct = f;
          e:
            for (; ; )
              switch (D.mode) {
                case R:
                  if (D.wrap === 0) {
                    D.mode = _e;
                    break;
                  }
                  for (; Oe < 16; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if (D.wrap & 2 && ce === 35615) {
                    D.check = 0, gt[0] = ce & 255, gt[1] = ce >>> 8 & 255, D.check = y(D.check, gt, 2, 0), ce = 0, Oe = 0, D.mode = L;
                    break;
                  }
                  if (D.flags = 0, D.head && (D.head.done = !1), !(D.wrap & 1) || /* check if zlib header allowed */
                  (((ce & 255) << 8) + (ce >> 8)) % 31) {
                    te.msg = "incorrect header check", D.mode = we;
                    break;
                  }
                  if ((ce & 15) !== T) {
                    te.msg = "unknown compression method", D.mode = we;
                    break;
                  }
                  if (ce >>>= 4, Oe -= 4, ot = (ce & 15) + 8, D.wbits === 0)
                    D.wbits = ot;
                  else if (ot > D.wbits) {
                    te.msg = "invalid window size", D.mode = we;
                    break;
                  }
                  D.dmax = 1 << ot, te.adler = D.check = 1, D.mode = ce & 512 ? W : de, ce = 0, Oe = 0;
                  break;
                case L:
                  for (; Oe < 16; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if (D.flags = ce, (D.flags & 255) !== T) {
                    te.msg = "unknown compression method", D.mode = we;
                    break;
                  }
                  if (D.flags & 57344) {
                    te.msg = "unknown header flags set", D.mode = we;
                    break;
                  }
                  D.head && (D.head.text = ce >> 8 & 1), D.flags & 512 && (gt[0] = ce & 255, gt[1] = ce >>> 8 & 255, D.check = y(D.check, gt, 2, 0)), ce = 0, Oe = 0, D.mode = z;
                /* falls through */
                case z:
                  for (; Oe < 32; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  D.head && (D.head.time = ce), D.flags & 512 && (gt[0] = ce & 255, gt[1] = ce >>> 8 & 255, gt[2] = ce >>> 16 & 255, gt[3] = ce >>> 24 & 255, D.check = y(D.check, gt, 4, 0)), ce = 0, Oe = 0, D.mode = U;
                /* falls through */
                case U:
                  for (; Oe < 16; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  D.head && (D.head.xflags = ce & 255, D.head.os = ce >> 8), D.flags & 512 && (gt[0] = ce & 255, gt[1] = ce >>> 8 & 255, D.check = y(D.check, gt, 2, 0)), ce = 0, Oe = 0, D.mode = J;
                /* falls through */
                case J:
                  if (D.flags & 1024) {
                    for (; Oe < 16; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    D.length = ce, D.head && (D.head.extra_len = ce), D.flags & 512 && (gt[0] = ce & 255, gt[1] = ce >>> 8 & 255, D.check = y(D.check, gt, 2, 0)), ce = 0, Oe = 0;
                  } else D.head && (D.head.extra = null);
                  D.mode = F;
                /* falls through */
                case F:
                  if (D.flags & 1024 && (Fe = D.length, Fe > me && (Fe = me), Fe && (D.head && (ot = D.head.extra_len - D.length, D.head.extra || (D.head.extra = new Array(D.head.extra_len)), P.arraySet(
                    D.head.extra,
                    Se,
                    m,
                    // extra field is limited to 65536 bytes
                    // - no need for additional size check
                    Fe,
                    /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    ot
                  )), D.flags & 512 && (D.check = y(D.check, Se, Fe, m)), me -= Fe, m += Fe, D.length -= Fe), D.length))
                    break e;
                  D.length = 0, D.mode = se;
                /* falls through */
                case se:
                  if (D.flags & 2048) {
                    if (me === 0)
                      break e;
                    Fe = 0;
                    do
                      ot = Se[m + Fe++], D.head && ot && D.length < 65536 && (D.head.name += String.fromCharCode(ot));
                    while (ot && Fe < me);
                    if (D.flags & 512 && (D.check = y(D.check, Se, Fe, m)), me -= Fe, m += Fe, ot)
                      break e;
                  } else D.head && (D.head.name = null);
                  D.length = 0, D.mode = ee;
                /* falls through */
                case ee:
                  if (D.flags & 4096) {
                    if (me === 0)
                      break e;
                    Fe = 0;
                    do
                      ot = Se[m + Fe++], D.head && ot && D.length < 65536 && (D.head.comment += String.fromCharCode(ot));
                    while (ot && Fe < me);
                    if (D.flags & 512 && (D.check = y(D.check, Se, Fe, m)), me -= Fe, m += Fe, ot)
                      break e;
                  } else D.head && (D.head.comment = null);
                  D.mode = ie;
                /* falls through */
                case ie:
                  if (D.flags & 512) {
                    for (; Oe < 16; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    if (ce !== (D.check & 65535)) {
                      te.msg = "header crc mismatch", D.mode = we;
                      break;
                    }
                    ce = 0, Oe = 0;
                  }
                  D.head && (D.head.hcrc = D.flags >> 9 & 1, D.head.done = !0), te.adler = D.check = 0, D.mode = de;
                  break;
                case W:
                  for (; Oe < 32; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  te.adler = D.check = Ae(ce), ce = 0, Oe = 0, D.mode = Q;
                /* falls through */
                case Q:
                  if (D.havedict === 0)
                    return te.next_out = oe, te.avail_out = O, te.next_in = m, te.avail_in = me, D.hold = ce, D.bits = Oe, s;
                  te.adler = D.check = 1, D.mode = de;
                /* falls through */
                case de:
                  if (he === c || he === g)
                    break e;
                /* falls through */
                case _e:
                  if (D.last) {
                    ce >>>= Oe & 7, Oe -= Oe & 7, D.mode = Re;
                    break;
                  }
                  for (; Oe < 3; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  switch (D.last = ce & 1, ce >>>= 1, Oe -= 1, ce & 3) {
                    case 0:
                      D.mode = ke;
                      break;
                    case 1:
                      if (ue(D), D.mode = je, he === g) {
                        ce >>>= 2, Oe -= 2;
                        break e;
                      }
                      break;
                    case 2:
                      D.mode = xe;
                      break;
                    case 3:
                      te.msg = "invalid block type", D.mode = we;
                  }
                  ce >>>= 2, Oe -= 2;
                  break;
                case ke:
                  for (ce >>>= Oe & 7, Oe -= Oe & 7; Oe < 32; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if ((ce & 65535) !== (ce >>> 16 ^ 65535)) {
                    te.msg = "invalid stored block lengths", D.mode = we;
                    break;
                  }
                  if (D.length = ce & 65535, ce = 0, Oe = 0, D.mode = Pe, he === g)
                    break e;
                /* falls through */
                case Pe:
                  D.mode = fe;
                /* falls through */
                case fe:
                  if (Fe = D.length, Fe) {
                    if (Fe > me && (Fe = me), Fe > O && (Fe = O), Fe === 0)
                      break e;
                    P.arraySet(le, Se, m, Fe, oe), me -= Fe, m += Fe, O -= Fe, oe += Fe, D.length -= Fe;
                    break;
                  }
                  D.mode = de;
                  break;
                case xe:
                  for (; Oe < 14; ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if (D.nlen = (ce & 31) + 257, ce >>>= 5, Oe -= 5, D.ndist = (ce & 31) + 1, ce >>>= 5, Oe -= 5, D.ncode = (ce & 15) + 4, ce >>>= 4, Oe -= 4, D.nlen > 286 || D.ndist > 30) {
                    te.msg = "too many length or distance symbols", D.mode = we;
                    break;
                  }
                  D.have = 0, D.mode = Ee;
                /* falls through */
                case Ee:
                  for (; D.have < D.ncode; ) {
                    for (; Oe < 3; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    D.lens[Ot[D.have++]] = ce & 7, ce >>>= 3, Oe -= 3;
                  }
                  for (; D.have < 19; )
                    D.lens[Ot[D.have++]] = 0;
                  if (D.lencode = D.lendyn, D.lenbits = 7, Ct = { bits: D.lenbits }, ct = d(l, D.lens, 0, 19, D.lencode, 0, D.work, Ct), D.lenbits = Ct.bits, ct) {
                    te.msg = "invalid code lengths set", D.mode = we;
                    break;
                  }
                  D.have = 0, D.mode = Ie;
                /* falls through */
                case Ie:
                  for (; D.have < D.nlen + D.ndist; ) {
                    for (; et = D.lencode[ce & (1 << D.lenbits) - 1], Je = et >>> 24, nt = et >>> 16 & 255, pt = et & 65535, !(Je <= Oe); ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    if (pt < 16)
                      ce >>>= Je, Oe -= Je, D.lens[D.have++] = pt;
                    else {
                      if (pt === 16) {
                        for (xt = Je + 2; Oe < xt; ) {
                          if (me === 0)
                            break e;
                          me--, ce += Se[m++] << Oe, Oe += 8;
                        }
                        if (ce >>>= Je, Oe -= Je, D.have === 0) {
                          te.msg = "invalid bit length repeat", D.mode = we;
                          break;
                        }
                        ot = D.lens[D.have - 1], Fe = 3 + (ce & 3), ce >>>= 2, Oe -= 2;
                      } else if (pt === 17) {
                        for (xt = Je + 3; Oe < xt; ) {
                          if (me === 0)
                            break e;
                          me--, ce += Se[m++] << Oe, Oe += 8;
                        }
                        ce >>>= Je, Oe -= Je, ot = 0, Fe = 3 + (ce & 7), ce >>>= 3, Oe -= 3;
                      } else {
                        for (xt = Je + 7; Oe < xt; ) {
                          if (me === 0)
                            break e;
                          me--, ce += Se[m++] << Oe, Oe += 8;
                        }
                        ce >>>= Je, Oe -= Je, ot = 0, Fe = 11 + (ce & 127), ce >>>= 7, Oe -= 7;
                      }
                      if (D.have + Fe > D.nlen + D.ndist) {
                        te.msg = "invalid bit length repeat", D.mode = we;
                        break;
                      }
                      for (; Fe--; )
                        D.lens[D.have++] = ot;
                    }
                  }
                  if (D.mode === we)
                    break;
                  if (D.lens[256] === 0) {
                    te.msg = "invalid code -- missing end-of-block", D.mode = we;
                    break;
                  }
                  if (D.lenbits = 9, Ct = { bits: D.lenbits }, ct = d(u, D.lens, 0, D.nlen, D.lencode, 0, D.work, Ct), D.lenbits = Ct.bits, ct) {
                    te.msg = "invalid literal/lengths set", D.mode = we;
                    break;
                  }
                  if (D.distbits = 6, D.distcode = D.distdyn, Ct = { bits: D.distbits }, ct = d(a, D.lens, D.nlen, D.ndist, D.distcode, 0, D.work, Ct), D.distbits = Ct.bits, ct) {
                    te.msg = "invalid distances set", D.mode = we;
                    break;
                  }
                  if (D.mode = je, he === g)
                    break e;
                /* falls through */
                case je:
                  D.mode = Ue;
                /* falls through */
                case Ue:
                  if (me >= 6 && O >= 258) {
                    te.next_out = oe, te.avail_out = O, te.next_in = m, te.avail_in = me, D.hold = ce, D.bits = Oe, E(te, Ge), oe = te.next_out, le = te.output, O = te.avail_out, m = te.next_in, Se = te.input, me = te.avail_in, ce = D.hold, Oe = D.bits, D.mode === de && (D.back = -1);
                    break;
                  }
                  for (D.back = 0; et = D.lencode[ce & (1 << D.lenbits) - 1], Je = et >>> 24, nt = et >>> 16 & 255, pt = et & 65535, !(Je <= Oe); ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if (nt && (nt & 240) === 0) {
                    for (vt = Je, bt = nt, At = pt; et = D.lencode[At + ((ce & (1 << vt + bt) - 1) >> vt)], Je = et >>> 24, nt = et >>> 16 & 255, pt = et & 65535, !(vt + Je <= Oe); ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    ce >>>= vt, Oe -= vt, D.back += vt;
                  }
                  if (ce >>>= Je, Oe -= Je, D.back += Je, D.length = pt, nt === 0) {
                    D.mode = Ve;
                    break;
                  }
                  if (nt & 32) {
                    D.back = -1, D.mode = de;
                    break;
                  }
                  if (nt & 64) {
                    te.msg = "invalid literal/length code", D.mode = we;
                    break;
                  }
                  D.extra = nt & 15, D.mode = He;
                /* falls through */
                case He:
                  if (D.extra) {
                    for (xt = D.extra; Oe < xt; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    D.length += ce & (1 << D.extra) - 1, ce >>>= D.extra, Oe -= D.extra, D.back += D.extra;
                  }
                  D.was = D.length, D.mode = Ze;
                /* falls through */
                case Ze:
                  for (; et = D.distcode[ce & (1 << D.distbits) - 1], Je = et >>> 24, nt = et >>> 16 & 255, pt = et & 65535, !(Je <= Oe); ) {
                    if (me === 0)
                      break e;
                    me--, ce += Se[m++] << Oe, Oe += 8;
                  }
                  if ((nt & 240) === 0) {
                    for (vt = Je, bt = nt, At = pt; et = D.distcode[At + ((ce & (1 << vt + bt) - 1) >> vt)], Je = et >>> 24, nt = et >>> 16 & 255, pt = et & 65535, !(vt + Je <= Oe); ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    ce >>>= vt, Oe -= vt, D.back += vt;
                  }
                  if (ce >>>= Je, Oe -= Je, D.back += Je, nt & 64) {
                    te.msg = "invalid distance code", D.mode = we;
                    break;
                  }
                  D.offset = pt, D.extra = nt & 15, D.mode = $e;
                /* falls through */
                case $e:
                  if (D.extra) {
                    for (xt = D.extra; Oe < xt; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    D.offset += ce & (1 << D.extra) - 1, ce >>>= D.extra, Oe -= D.extra, D.back += D.extra;
                  }
                  if (D.offset > D.dmax) {
                    te.msg = "invalid distance too far back", D.mode = we;
                    break;
                  }
                  D.mode = We;
                /* falls through */
                case We:
                  if (O === 0)
                    break e;
                  if (Fe = Ge - O, D.offset > Fe) {
                    if (Fe = D.offset - Fe, Fe > D.whave && D.sane) {
                      te.msg = "invalid distance too far back", D.mode = we;
                      break;
                    }
                    Fe > D.wnext ? (Fe -= D.wnext, Ye = D.wsize - Fe) : Ye = D.wnext - Fe, Fe > D.length && (Fe = D.length), Ke = D.window;
                  } else
                    Ke = le, Ye = oe - D.offset, Fe = D.length;
                  Fe > O && (Fe = O), O -= Fe, D.length -= Fe;
                  do
                    le[oe++] = Ke[Ye++];
                  while (--Fe);
                  D.length === 0 && (D.mode = Ue);
                  break;
                case Ve:
                  if (O === 0)
                    break e;
                  le[oe++] = D.length, O--, D.mode = Ue;
                  break;
                case Re:
                  if (D.wrap) {
                    for (; Oe < 32; ) {
                      if (me === 0)
                        break e;
                      me--, ce |= Se[m++] << Oe, Oe += 8;
                    }
                    if (Ge -= O, te.total_out += Ge, D.total += Ge, Ge && (te.adler = D.check = /*UPDATE(state.check, put - _out, _out);*/
                    D.flags ? y(D.check, le, Ge, oe - Ge) : x(D.check, le, Ge, oe - Ge)), Ge = O, (D.flags ? ce : Ae(ce)) !== D.check) {
                      te.msg = "incorrect data check", D.mode = we;
                      break;
                    }
                    ce = 0, Oe = 0;
                  }
                  D.mode = De;
                /* falls through */
                case De:
                  if (D.wrap && D.flags) {
                    for (; Oe < 32; ) {
                      if (me === 0)
                        break e;
                      me--, ce += Se[m++] << Oe, Oe += 8;
                    }
                    if (ce !== (D.total & 4294967295)) {
                      te.msg = "incorrect length check", D.mode = we;
                      break;
                    }
                    ce = 0, Oe = 0;
                  }
                  D.mode = Ne;
                /* falls through */
                case Ne:
                  ct = p;
                  break e;
                case we:
                  ct = b;
                  break e;
                case re:
                  return o;
                case $:
                /* falls through */
                default:
                  return S;
              }
          return te.next_out = oe, te.avail_out = O, te.next_in = m, te.avail_in = me, D.hold = ce, D.bits = Oe, (D.wsize || Ge !== te.avail_out && D.mode < we && (D.mode < Re || he !== n)) && pe(te, te.output, te.next_out, Ge - te.avail_out), Be -= te.avail_in, Ge -= te.avail_out, te.total_in += Be, te.total_out += Ge, D.total += Ge, D.wrap && Ge && (te.adler = D.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
          D.flags ? y(D.check, le, Ge, te.next_out - Ge) : x(D.check, le, Ge, te.next_out - Ge)), te.data_type = D.bits + (D.last ? 64 : 0) + (D.mode === de ? 128 : 0) + (D.mode === je || D.mode === Pe ? 256 : 0), (Be === 0 && Ge === 0 || he === n) && ct === f && (ct = A), ct;
        }
        function q(te) {
          if (!te || !te.state)
            return S;
          var he = te.state;
          return he.window && (he.window = null), te.state = null, f;
        }
        function K(te, he) {
          var D;
          return !te || !te.state || (D = te.state, (D.wrap & 2) === 0) ? S : (D.head = he, he.done = !1, f);
        }
        function be(te, he) {
          var D = he.length, Se, le, m;
          return !te || !te.state || (Se = te.state, Se.wrap !== 0 && Se.mode !== Q) ? S : Se.mode === Q && (le = 1, le = x(le, he, D, 0), le !== Se.check) ? b : (m = pe(te, he, D, D), m ? (Se.mode = re, o) : (Se.havedict = 1, f));
        }
        _.inflateReset = h, _.inflateReset2 = k, _.inflateResetKeep = r, _.inflateInit = B, _.inflateInit2 = I, _.inflate = M, _.inflateEnd = q, _.inflateGetHeader = K, _.inflateSetDictionary = be, _.inflateInfo = "pako inflate (from Nodeca project)";
      }, { "../utils/common": 36, "./adler32": 37, "./crc32": 39, "./inffast": 41, "./inftrees": 43 }], 43: [function(C, Z, _) {
        var P = C("../utils/common"), x = 15, y = 852, E = 592, d = 0, l = 1, u = 2, a = [
          /* Length codes 257..285 base */
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          13,
          15,
          17,
          19,
          23,
          27,
          31,
          35,
          43,
          51,
          59,
          67,
          83,
          99,
          115,
          131,
          163,
          195,
          227,
          258,
          0,
          0
        ], n = [
          /* Length codes 257..285 extra */
          16,
          16,
          16,
          16,
          16,
          16,
          16,
          16,
          17,
          17,
          17,
          17,
          18,
          18,
          18,
          18,
          19,
          19,
          19,
          19,
          20,
          20,
          20,
          20,
          21,
          21,
          21,
          21,
          16,
          72,
          78
        ], c = [
          /* Distance codes 0..29 base */
          1,
          2,
          3,
          4,
          5,
          7,
          9,
          13,
          17,
          25,
          33,
          49,
          65,
          97,
          129,
          193,
          257,
          385,
          513,
          769,
          1025,
          1537,
          2049,
          3073,
          4097,
          6145,
          8193,
          12289,
          16385,
          24577,
          0,
          0
        ], g = [
          /* Distance codes 0..29 extra */
          16,
          16,
          16,
          16,
          17,
          17,
          18,
          18,
          19,
          19,
          20,
          20,
          21,
          21,
          22,
          22,
          23,
          23,
          24,
          24,
          25,
          25,
          26,
          26,
          27,
          27,
          28,
          28,
          29,
          29,
          64,
          64
        ];
        Z.exports = function(p, s, S, b, o, A, T, R) {
          var L = R.bits, z = 0, U = 0, J = 0, F = 0, se = 0, ee = 0, ie = 0, W = 0, Q = 0, de = 0, _e, ke, Pe, fe, xe, Ee = null, Ie = 0, je, Ue = new P.Buf16(x + 1), He = new P.Buf16(x + 1), Ze = null, $e = 0, We, Ve, Re;
          for (z = 0; z <= x; z++)
            Ue[z] = 0;
          for (U = 0; U < b; U++)
            Ue[s[S + U]]++;
          for (se = L, F = x; F >= 1 && Ue[F] === 0; F--)
            ;
          if (se > F && (se = F), F === 0)
            return o[A++] = 1 << 24 | 64 << 16 | 0, o[A++] = 1 << 24 | 64 << 16 | 0, R.bits = 1, 0;
          for (J = 1; J < F && Ue[J] === 0; J++)
            ;
          for (se < J && (se = J), W = 1, z = 1; z <= x; z++)
            if (W <<= 1, W -= Ue[z], W < 0)
              return -1;
          if (W > 0 && (p === d || F !== 1))
            return -1;
          for (He[1] = 0, z = 1; z < x; z++)
            He[z + 1] = He[z] + Ue[z];
          for (U = 0; U < b; U++)
            s[S + U] !== 0 && (T[He[s[S + U]]++] = U);
          if (p === d ? (Ee = Ze = T, je = 19) : p === l ? (Ee = a, Ie -= 257, Ze = n, $e -= 257, je = 256) : (Ee = c, Ze = g, je = -1), de = 0, U = 0, z = J, xe = A, ee = se, ie = 0, Pe = -1, Q = 1 << se, fe = Q - 1, p === l && Q > y || p === u && Q > E)
            return 1;
          for (; ; ) {
            We = z - ie, T[U] < je ? (Ve = 0, Re = T[U]) : T[U] > je ? (Ve = Ze[$e + T[U]], Re = Ee[Ie + T[U]]) : (Ve = 96, Re = 0), _e = 1 << z - ie, ke = 1 << ee, J = ke;
            do
              ke -= _e, o[xe + (de >> ie) + ke] = We << 24 | Ve << 16 | Re | 0;
            while (ke !== 0);
            for (_e = 1 << z - 1; de & _e; )
              _e >>= 1;
            if (_e !== 0 ? (de &= _e - 1, de += _e) : de = 0, U++, --Ue[z] === 0) {
              if (z === F)
                break;
              z = s[S + T[U]];
            }
            if (z > se && (de & fe) !== Pe) {
              for (ie === 0 && (ie = se), xe += J, ee = z - ie, W = 1 << ee; ee + ie < F && (W -= Ue[ee + ie], !(W <= 0)); )
                ee++, W <<= 1;
              if (Q += 1 << ee, p === l && Q > y || p === u && Q > E)
                return 1;
              Pe = de & fe, o[Pe] = se << 24 | ee << 16 | xe - A | 0;
            }
          }
          return de !== 0 && (o[xe + de] = z - ie << 24 | 64 << 16 | 0), R.bits = se, 0;
        };
      }, { "../utils/common": 36 }], 44: [function(C, Z, _) {
        Z.exports = {
          2: "need dictionary",
          /* Z_NEED_DICT       2  */
          1: "stream end",
          /* Z_STREAM_END      1  */
          0: "",
          /* Z_OK              0  */
          "-1": "file error",
          /* Z_ERRNO         (-1) */
          "-2": "stream error",
          /* Z_STREAM_ERROR  (-2) */
          "-3": "data error",
          /* Z_DATA_ERROR    (-3) */
          "-4": "insufficient memory",
          /* Z_MEM_ERROR     (-4) */
          "-5": "buffer error",
          /* Z_BUF_ERROR     (-5) */
          "-6": "incompatible version"
          /* Z_VERSION_ERROR (-6) */
        };
      }, {}], 45: [function(C, Z, _) {
        var P = C("../utils/common"), x = 4, y = 0, E = 1, d = 2;
        function l(M) {
          for (var q = M.length; --q >= 0; )
            M[q] = 0;
        }
        var u = 0, a = 1, n = 2, c = 3, g = 258, f = 29, p = 256, s = p + 1 + f, S = 30, b = 19, o = 2 * s + 1, A = 15, T = 16, R = 7, L = 256, z = 16, U = 17, J = 18, F = (
          /* extra bits for each length code */
          [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
        ), se = (
          /* extra bits for each distance code */
          [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
        ), ee = (
          /* extra bits for each bit length code */
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
        ), ie = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], W = 512, Q = new Array((s + 2) * 2);
        l(Q);
        var de = new Array(S * 2);
        l(de);
        var _e = new Array(W);
        l(_e);
        var ke = new Array(g - c + 1);
        l(ke);
        var Pe = new Array(f);
        l(Pe);
        var fe = new Array(S);
        l(fe);
        function xe(M, q, K, be, te) {
          this.static_tree = M, this.extra_bits = q, this.extra_base = K, this.elems = be, this.max_length = te, this.has_stree = M && M.length;
        }
        var Ee, Ie, je;
        function Ue(M, q) {
          this.dyn_tree = M, this.max_code = 0, this.stat_desc = q;
        }
        function He(M) {
          return M < 256 ? _e[M] : _e[256 + (M >>> 7)];
        }
        function Ze(M, q) {
          M.pending_buf[M.pending++] = q & 255, M.pending_buf[M.pending++] = q >>> 8 & 255;
        }
        function $e(M, q, K) {
          M.bi_valid > T - K ? (M.bi_buf |= q << M.bi_valid & 65535, Ze(M, M.bi_buf), M.bi_buf = q >> T - M.bi_valid, M.bi_valid += K - T) : (M.bi_buf |= q << M.bi_valid & 65535, M.bi_valid += K);
        }
        function We(M, q, K) {
          $e(
            M,
            K[q * 2],
            K[q * 2 + 1]
            /*.Len*/
          );
        }
        function Ve(M, q) {
          var K = 0;
          do
            K |= M & 1, M >>>= 1, K <<= 1;
          while (--q > 0);
          return K >>> 1;
        }
        function Re(M) {
          M.bi_valid === 16 ? (Ze(M, M.bi_buf), M.bi_buf = 0, M.bi_valid = 0) : M.bi_valid >= 8 && (M.pending_buf[M.pending++] = M.bi_buf & 255, M.bi_buf >>= 8, M.bi_valid -= 8);
        }
        function De(M, q) {
          var K = q.dyn_tree, be = q.max_code, te = q.stat_desc.static_tree, he = q.stat_desc.has_stree, D = q.stat_desc.extra_bits, Se = q.stat_desc.extra_base, le = q.stat_desc.max_length, m, oe, me, O, ce, Oe, Be = 0;
          for (O = 0; O <= A; O++)
            M.bl_count[O] = 0;
          for (K[M.heap[M.heap_max] * 2 + 1] = 0, m = M.heap_max + 1; m < o; m++)
            oe = M.heap[m], O = K[K[oe * 2 + 1] * 2 + 1] + 1, O > le && (O = le, Be++), K[oe * 2 + 1] = O, !(oe > be) && (M.bl_count[O]++, ce = 0, oe >= Se && (ce = D[oe - Se]), Oe = K[oe * 2], M.opt_len += Oe * (O + ce), he && (M.static_len += Oe * (te[oe * 2 + 1] + ce)));
          if (Be !== 0) {
            do {
              for (O = le - 1; M.bl_count[O] === 0; )
                O--;
              M.bl_count[O]--, M.bl_count[O + 1] += 2, M.bl_count[le]--, Be -= 2;
            } while (Be > 0);
            for (O = le; O !== 0; O--)
              for (oe = M.bl_count[O]; oe !== 0; )
                me = M.heap[--m], !(me > be) && (K[me * 2 + 1] !== O && (M.opt_len += (O - K[me * 2 + 1]) * K[me * 2], K[me * 2 + 1] = O), oe--);
          }
        }
        function Ne(M, q, K) {
          var be = new Array(A + 1), te = 0, he, D;
          for (he = 1; he <= A; he++)
            be[he] = te = te + K[he - 1] << 1;
          for (D = 0; D <= q; D++) {
            var Se = M[D * 2 + 1];
            Se !== 0 && (M[D * 2] = Ve(be[Se]++, Se));
          }
        }
        function we() {
          var M, q, K, be, te, he = new Array(A + 1);
          for (K = 0, be = 0; be < f - 1; be++)
            for (Pe[be] = K, M = 0; M < 1 << F[be]; M++)
              ke[K++] = be;
          for (ke[K - 1] = be, te = 0, be = 0; be < 16; be++)
            for (fe[be] = te, M = 0; M < 1 << se[be]; M++)
              _e[te++] = be;
          for (te >>= 7; be < S; be++)
            for (fe[be] = te << 7, M = 0; M < 1 << se[be] - 7; M++)
              _e[256 + te++] = be;
          for (q = 0; q <= A; q++)
            he[q] = 0;
          for (M = 0; M <= 143; )
            Q[M * 2 + 1] = 8, M++, he[8]++;
          for (; M <= 255; )
            Q[M * 2 + 1] = 9, M++, he[9]++;
          for (; M <= 279; )
            Q[M * 2 + 1] = 7, M++, he[7]++;
          for (; M <= 287; )
            Q[M * 2 + 1] = 8, M++, he[8]++;
          for (Ne(Q, s + 1, he), M = 0; M < S; M++)
            de[M * 2 + 1] = 5, de[M * 2] = Ve(M, 5);
          Ee = new xe(Q, F, p + 1, s, A), Ie = new xe(de, se, 0, S, A), je = new xe(new Array(0), ee, 0, b, R);
        }
        function re(M) {
          var q;
          for (q = 0; q < s; q++)
            M.dyn_ltree[q * 2] = 0;
          for (q = 0; q < S; q++)
            M.dyn_dtree[q * 2] = 0;
          for (q = 0; q < b; q++)
            M.bl_tree[q * 2] = 0;
          M.dyn_ltree[L * 2] = 1, M.opt_len = M.static_len = 0, M.last_lit = M.matches = 0;
        }
        function $(M) {
          M.bi_valid > 8 ? Ze(M, M.bi_buf) : M.bi_valid > 0 && (M.pending_buf[M.pending++] = M.bi_buf), M.bi_buf = 0, M.bi_valid = 0;
        }
        function Ce(M, q, K, be) {
          $(M), Ze(M, K), Ze(M, ~K), P.arraySet(M.pending_buf, M.window, q, K, M.pending), M.pending += K;
        }
        function ve(M, q, K, be) {
          var te = q * 2, he = K * 2;
          return M[te] < M[he] || M[te] === M[he] && be[q] <= be[K];
        }
        function Y(M, q, K) {
          for (var be = M.heap[K], te = K << 1; te <= M.heap_len && (te < M.heap_len && ve(q, M.heap[te + 1], M.heap[te], M.depth) && te++, !ve(q, be, M.heap[te], M.depth)); )
            M.heap[K] = M.heap[te], K = te, te <<= 1;
          M.heap[K] = be;
        }
        function G(M, q, K) {
          var be, te, he = 0, D, Se;
          if (M.last_lit !== 0)
            do
              be = M.pending_buf[M.d_buf + he * 2] << 8 | M.pending_buf[M.d_buf + he * 2 + 1], te = M.pending_buf[M.l_buf + he], he++, be === 0 ? We(M, te, q) : (D = ke[te], We(M, D + p + 1, q), Se = F[D], Se !== 0 && (te -= Pe[D], $e(M, te, Se)), be--, D = He(be), We(M, D, K), Se = se[D], Se !== 0 && (be -= fe[D], $e(M, be, Se)));
            while (he < M.last_lit);
          We(M, L, q);
        }
        function Ae(M, q) {
          var K = q.dyn_tree, be = q.stat_desc.static_tree, te = q.stat_desc.has_stree, he = q.stat_desc.elems, D, Se, le = -1, m;
          for (M.heap_len = 0, M.heap_max = o, D = 0; D < he; D++)
            K[D * 2] !== 0 ? (M.heap[++M.heap_len] = le = D, M.depth[D] = 0) : K[D * 2 + 1] = 0;
          for (; M.heap_len < 2; )
            m = M.heap[++M.heap_len] = le < 2 ? ++le : 0, K[m * 2] = 1, M.depth[m] = 0, M.opt_len--, te && (M.static_len -= be[m * 2 + 1]);
          for (q.max_code = le, D = M.heap_len >> 1; D >= 1; D--)
            Y(M, K, D);
          m = he;
          do
            D = M.heap[
              1
              /*SMALLEST*/
            ], M.heap[
              1
              /*SMALLEST*/
            ] = M.heap[M.heap_len--], Y(
              M,
              K,
              1
              /*SMALLEST*/
            ), Se = M.heap[
              1
              /*SMALLEST*/
            ], M.heap[--M.heap_max] = D, M.heap[--M.heap_max] = Se, K[m * 2] = K[D * 2] + K[Se * 2], M.depth[m] = (M.depth[D] >= M.depth[Se] ? M.depth[D] : M.depth[Se]) + 1, K[D * 2 + 1] = K[Se * 2 + 1] = m, M.heap[
              1
              /*SMALLEST*/
            ] = m++, Y(
              M,
              K,
              1
              /*SMALLEST*/
            );
          while (M.heap_len >= 2);
          M.heap[--M.heap_max] = M.heap[
            1
            /*SMALLEST*/
          ], De(M, q), Ne(K, le, M.bl_count);
        }
        function e(M, q, K) {
          var be, te = -1, he, D = q[0 * 2 + 1], Se = 0, le = 7, m = 4;
          for (D === 0 && (le = 138, m = 3), q[(K + 1) * 2 + 1] = 65535, be = 0; be <= K; be++)
            he = D, D = q[(be + 1) * 2 + 1], !(++Se < le && he === D) && (Se < m ? M.bl_tree[he * 2] += Se : he !== 0 ? (he !== te && M.bl_tree[he * 2]++, M.bl_tree[z * 2]++) : Se <= 10 ? M.bl_tree[U * 2]++ : M.bl_tree[J * 2]++, Se = 0, te = he, D === 0 ? (le = 138, m = 3) : he === D ? (le = 6, m = 3) : (le = 7, m = 4));
        }
        function r(M, q, K) {
          var be, te = -1, he, D = q[0 * 2 + 1], Se = 0, le = 7, m = 4;
          for (D === 0 && (le = 138, m = 3), be = 0; be <= K; be++)
            if (he = D, D = q[(be + 1) * 2 + 1], !(++Se < le && he === D)) {
              if (Se < m)
                do
                  We(M, he, M.bl_tree);
                while (--Se !== 0);
              else he !== 0 ? (he !== te && (We(M, he, M.bl_tree), Se--), We(M, z, M.bl_tree), $e(M, Se - 3, 2)) : Se <= 10 ? (We(M, U, M.bl_tree), $e(M, Se - 3, 3)) : (We(M, J, M.bl_tree), $e(M, Se - 11, 7));
              Se = 0, te = he, D === 0 ? (le = 138, m = 3) : he === D ? (le = 6, m = 3) : (le = 7, m = 4);
            }
        }
        function h(M) {
          var q;
          for (e(M, M.dyn_ltree, M.l_desc.max_code), e(M, M.dyn_dtree, M.d_desc.max_code), Ae(M, M.bl_desc), q = b - 1; q >= 3 && M.bl_tree[ie[q] * 2 + 1] === 0; q--)
            ;
          return M.opt_len += 3 * (q + 1) + 5 + 5 + 4, q;
        }
        function k(M, q, K, be) {
          var te;
          for ($e(M, q - 257, 5), $e(M, K - 1, 5), $e(M, be - 4, 4), te = 0; te < be; te++)
            $e(M, M.bl_tree[ie[te] * 2 + 1], 3);
          r(M, M.dyn_ltree, q - 1), r(M, M.dyn_dtree, K - 1);
        }
        function I(M) {
          var q = 4093624447, K;
          for (K = 0; K <= 31; K++, q >>>= 1)
            if (q & 1 && M.dyn_ltree[K * 2] !== 0)
              return y;
          if (M.dyn_ltree[9 * 2] !== 0 || M.dyn_ltree[10 * 2] !== 0 || M.dyn_ltree[13 * 2] !== 0)
            return E;
          for (K = 32; K < p; K++)
            if (M.dyn_ltree[K * 2] !== 0)
              return E;
          return y;
        }
        var B = !1;
        function j(M) {
          B || (we(), B = !0), M.l_desc = new Ue(M.dyn_ltree, Ee), M.d_desc = new Ue(M.dyn_dtree, Ie), M.bl_desc = new Ue(M.bl_tree, je), M.bi_buf = 0, M.bi_valid = 0, re(M);
        }
        function H(M, q, K, be) {
          $e(M, (u << 1) + (be ? 1 : 0), 3), Ce(M, q, K);
        }
        function X(M) {
          $e(M, a << 1, 3), We(M, L, Q), Re(M);
        }
        function ue(M, q, K, be) {
          var te, he, D = 0;
          M.level > 0 ? (M.strm.data_type === d && (M.strm.data_type = I(M)), Ae(M, M.l_desc), Ae(M, M.d_desc), D = h(M), te = M.opt_len + 3 + 7 >>> 3, he = M.static_len + 3 + 7 >>> 3, he <= te && (te = he)) : te = he = K + 5, K + 4 <= te && q !== -1 ? H(M, q, K, be) : M.strategy === x || he === te ? ($e(M, (a << 1) + (be ? 1 : 0), 3), G(M, Q, de)) : ($e(M, (n << 1) + (be ? 1 : 0), 3), k(M, M.l_desc.max_code + 1, M.d_desc.max_code + 1, D + 1), G(M, M.dyn_ltree, M.dyn_dtree)), re(M), be && $(M);
        }
        function pe(M, q, K) {
          return M.pending_buf[M.d_buf + M.last_lit * 2] = q >>> 8 & 255, M.pending_buf[M.d_buf + M.last_lit * 2 + 1] = q & 255, M.pending_buf[M.l_buf + M.last_lit] = K & 255, M.last_lit++, q === 0 ? M.dyn_ltree[K * 2]++ : (M.matches++, q--, M.dyn_ltree[(ke[K] + p + 1) * 2]++, M.dyn_dtree[He(q) * 2]++), M.last_lit === M.lit_bufsize - 1;
        }
        _._tr_init = j, _._tr_stored_block = H, _._tr_flush_block = ue, _._tr_tally = pe, _._tr_align = X;
      }, { "../utils/common": 36 }], 46: [function(C, Z, _) {
        function P() {
          this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
        }
        Z.exports = P;
      }, {}], 47: [function(C, Z, _) {
        arguments[4][33][0].apply(_, arguments);
      }, { dup: 33 }], 48: [function(C, Z, _) {
        (function(a) {
          var x = C("base64-js"), y = C("ieee754"), E = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
          _.Buffer = a, _.SlowBuffer = A, _.INSPECT_MAX_BYTES = 50;
          var d = 2147483647;
          _.kMaxLength = d, a.TYPED_ARRAY_SUPPORT = l(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
            "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
          );
          function l() {
            try {
              var ve = new Uint8Array(1), Y = { foo: function() {
                return 42;
              } };
              return Object.setPrototypeOf(Y, Uint8Array.prototype), Object.setPrototypeOf(ve, Y), ve.foo() === 42;
            } catch {
              return !1;
            }
          }
          Object.defineProperty(a.prototype, "parent", {
            enumerable: !0,
            get: function() {
              if (a.isBuffer(this))
                return this.buffer;
            }
          }), Object.defineProperty(a.prototype, "offset", {
            enumerable: !0,
            get: function() {
              if (a.isBuffer(this))
                return this.byteOffset;
            }
          });
          function u(ve) {
            if (ve > d)
              throw new RangeError('The value "' + ve + '" is invalid for option "size"');
            var Y = new Uint8Array(ve);
            return Object.setPrototypeOf(Y, a.prototype), Y;
          }
          function a(ve, Y, G) {
            if (typeof ve == "number") {
              if (typeof Y == "string")
                throw new TypeError(
                  'The "string" argument must be of type string. Received type number'
                );
              return f(ve);
            }
            return n(ve, Y, G);
          }
          typeof Symbol < "u" && Symbol.species != null && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
            value: null,
            configurable: !0,
            enumerable: !1,
            writable: !1
          }), a.poolSize = 8192;
          function n(ve, Y, G) {
            if (typeof ve == "string")
              return p(ve, Y);
            if (ArrayBuffer.isView(ve))
              return s(ve);
            if (ve == null)
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ve
              );
            if (re(ve, ArrayBuffer) || ve && re(ve.buffer, ArrayBuffer))
              return S(ve, Y, G);
            if (typeof ve == "number")
              throw new TypeError(
                'The "value" argument must not be of type number. Received type number'
              );
            var Ae = ve.valueOf && ve.valueOf();
            if (Ae != null && Ae !== ve)
              return a.from(Ae, Y, G);
            var e = b(ve);
            if (e) return e;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ve[Symbol.toPrimitive] == "function")
              return a.from(
                ve[Symbol.toPrimitive]("string"),
                Y,
                G
              );
            throw new TypeError(
              "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ve
            );
          }
          a.from = function(ve, Y, G) {
            return n(ve, Y, G);
          }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
          function c(ve) {
            if (typeof ve != "number")
              throw new TypeError('"size" argument must be of type number');
            if (ve < 0)
              throw new RangeError('The value "' + ve + '" is invalid for option "size"');
          }
          function g(ve, Y, G) {
            return c(ve), ve <= 0 ? u(ve) : Y !== void 0 ? typeof G == "string" ? u(ve).fill(Y, G) : u(ve).fill(Y) : u(ve);
          }
          a.alloc = function(ve, Y, G) {
            return g(ve, Y, G);
          };
          function f(ve) {
            return c(ve), u(ve < 0 ? 0 : o(ve) | 0);
          }
          a.allocUnsafe = function(ve) {
            return f(ve);
          }, a.allocUnsafeSlow = function(ve) {
            return f(ve);
          };
          function p(ve, Y) {
            if ((typeof Y != "string" || Y === "") && (Y = "utf8"), !a.isEncoding(Y))
              throw new TypeError("Unknown encoding: " + Y);
            var G = T(ve, Y) | 0, Ae = u(G), e = Ae.write(ve, Y);
            return e !== G && (Ae = Ae.slice(0, e)), Ae;
          }
          function s(ve) {
            for (var Y = ve.length < 0 ? 0 : o(ve.length) | 0, G = u(Y), Ae = 0; Ae < Y; Ae += 1)
              G[Ae] = ve[Ae] & 255;
            return G;
          }
          function S(ve, Y, G) {
            if (Y < 0 || ve.byteLength < Y)
              throw new RangeError('"offset" is outside of buffer bounds');
            if (ve.byteLength < Y + (G || 0))
              throw new RangeError('"length" is outside of buffer bounds');
            var Ae;
            return Y === void 0 && G === void 0 ? Ae = new Uint8Array(ve) : G === void 0 ? Ae = new Uint8Array(ve, Y) : Ae = new Uint8Array(ve, Y, G), Object.setPrototypeOf(Ae, a.prototype), Ae;
          }
          function b(ve) {
            if (a.isBuffer(ve)) {
              var Y = o(ve.length) | 0, G = u(Y);
              return G.length === 0 || ve.copy(G, 0, 0, Y), G;
            }
            if (ve.length !== void 0)
              return typeof ve.length != "number" || $(ve.length) ? u(0) : s(ve);
            if (ve.type === "Buffer" && Array.isArray(ve.data))
              return s(ve.data);
          }
          function o(ve) {
            if (ve >= d)
              throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d.toString(16) + " bytes");
            return ve | 0;
          }
          function A(ve) {
            return +ve != ve && (ve = 0), a.alloc(+ve);
          }
          a.isBuffer = function(Y) {
            return Y != null && Y._isBuffer === !0 && Y !== a.prototype;
          }, a.compare = function(Y, G) {
            if (re(Y, Uint8Array) && (Y = a.from(Y, Y.offset, Y.byteLength)), re(G, Uint8Array) && (G = a.from(G, G.offset, G.byteLength)), !a.isBuffer(Y) || !a.isBuffer(G))
              throw new TypeError(
                'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
              );
            if (Y === G) return 0;
            for (var Ae = Y.length, e = G.length, r = 0, h = Math.min(Ae, e); r < h; ++r)
              if (Y[r] !== G[r]) {
                Ae = Y[r], e = G[r];
                break;
              }
            return Ae < e ? -1 : e < Ae ? 1 : 0;
          }, a.isEncoding = function(Y) {
            switch (String(Y).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, a.concat = function(Y, G) {
            if (!Array.isArray(Y))
              throw new TypeError('"list" argument must be an Array of Buffers');
            if (Y.length === 0)
              return a.alloc(0);
            var Ae;
            if (G === void 0)
              for (G = 0, Ae = 0; Ae < Y.length; ++Ae)
                G += Y[Ae].length;
            var e = a.allocUnsafe(G), r = 0;
            for (Ae = 0; Ae < Y.length; ++Ae) {
              var h = Y[Ae];
              if (re(h, Uint8Array) && (h = a.from(h)), !a.isBuffer(h))
                throw new TypeError('"list" argument must be an Array of Buffers');
              h.copy(e, r), r += h.length;
            }
            return e;
          };
          function T(ve, Y) {
            if (a.isBuffer(ve))
              return ve.length;
            if (ArrayBuffer.isView(ve) || re(ve, ArrayBuffer))
              return ve.byteLength;
            if (typeof ve != "string")
              throw new TypeError(
                'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ve
              );
            var G = ve.length, Ae = arguments.length > 2 && arguments[2] === !0;
            if (!Ae && G === 0) return 0;
            for (var e = !1; ; )
              switch (Y) {
                case "ascii":
                case "latin1":
                case "binary":
                  return G;
                case "utf8":
                case "utf-8":
                  return Ve(ve).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return G * 2;
                case "hex":
                  return G >>> 1;
                case "base64":
                  return Ne(ve).length;
                default:
                  if (e)
                    return Ae ? -1 : Ve(ve).length;
                  Y = ("" + Y).toLowerCase(), e = !0;
              }
          }
          a.byteLength = T;
          function R(ve, Y, G) {
            var Ae = !1;
            if ((Y === void 0 || Y < 0) && (Y = 0), Y > this.length || ((G === void 0 || G > this.length) && (G = this.length), G <= 0) || (G >>>= 0, Y >>>= 0, G <= Y))
              return "";
            for (ve || (ve = "utf8"); ; )
              switch (ve) {
                case "hex":
                  return xe(this, Y, G);
                case "utf8":
                case "utf-8":
                  return de(this, Y, G);
                case "ascii":
                  return Pe(this, Y, G);
                case "latin1":
                case "binary":
                  return fe(this, Y, G);
                case "base64":
                  return Q(this, Y, G);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return Ee(this, Y, G);
                default:
                  if (Ae) throw new TypeError("Unknown encoding: " + ve);
                  ve = (ve + "").toLowerCase(), Ae = !0;
              }
          }
          a.prototype._isBuffer = !0;
          function L(ve, Y, G) {
            var Ae = ve[Y];
            ve[Y] = ve[G], ve[G] = Ae;
          }
          a.prototype.swap16 = function() {
            var Y = this.length;
            if (Y % 2 !== 0)
              throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var G = 0; G < Y; G += 2)
              L(this, G, G + 1);
            return this;
          }, a.prototype.swap32 = function() {
            var Y = this.length;
            if (Y % 4 !== 0)
              throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var G = 0; G < Y; G += 4)
              L(this, G, G + 3), L(this, G + 1, G + 2);
            return this;
          }, a.prototype.swap64 = function() {
            var Y = this.length;
            if (Y % 8 !== 0)
              throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var G = 0; G < Y; G += 8)
              L(this, G, G + 7), L(this, G + 1, G + 6), L(this, G + 2, G + 5), L(this, G + 3, G + 4);
            return this;
          }, a.prototype.toString = function() {
            var Y = this.length;
            return Y === 0 ? "" : arguments.length === 0 ? de(this, 0, Y) : R.apply(this, arguments);
          }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(Y) {
            if (!a.isBuffer(Y)) throw new TypeError("Argument must be a Buffer");
            return this === Y ? !0 : a.compare(this, Y) === 0;
          }, a.prototype.inspect = function() {
            var Y = "", G = _.INSPECT_MAX_BYTES;
            return Y = this.toString("hex", 0, G).replace(/(.{2})/g, "$1 ").trim(), this.length > G && (Y += " ... "), "<Buffer " + Y + ">";
          }, E && (a.prototype[E] = a.prototype.inspect), a.prototype.compare = function(Y, G, Ae, e, r) {
            if (re(Y, Uint8Array) && (Y = a.from(Y, Y.offset, Y.byteLength)), !a.isBuffer(Y))
              throw new TypeError(
                'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Y
              );
            if (G === void 0 && (G = 0), Ae === void 0 && (Ae = Y ? Y.length : 0), e === void 0 && (e = 0), r === void 0 && (r = this.length), G < 0 || Ae > Y.length || e < 0 || r > this.length)
              throw new RangeError("out of range index");
            if (e >= r && G >= Ae)
              return 0;
            if (e >= r)
              return -1;
            if (G >= Ae)
              return 1;
            if (G >>>= 0, Ae >>>= 0, e >>>= 0, r >>>= 0, this === Y) return 0;
            for (var h = r - e, k = Ae - G, I = Math.min(h, k), B = this.slice(e, r), j = Y.slice(G, Ae), H = 0; H < I; ++H)
              if (B[H] !== j[H]) {
                h = B[H], k = j[H];
                break;
              }
            return h < k ? -1 : k < h ? 1 : 0;
          };
          function z(ve, Y, G, Ae, e) {
            if (ve.length === 0) return -1;
            if (typeof G == "string" ? (Ae = G, G = 0) : G > 2147483647 ? G = 2147483647 : G < -2147483648 && (G = -2147483648), G = +G, $(G) && (G = e ? 0 : ve.length - 1), G < 0 && (G = ve.length + G), G >= ve.length) {
              if (e) return -1;
              G = ve.length - 1;
            } else if (G < 0)
              if (e) G = 0;
              else return -1;
            if (typeof Y == "string" && (Y = a.from(Y, Ae)), a.isBuffer(Y))
              return Y.length === 0 ? -1 : U(ve, Y, G, Ae, e);
            if (typeof Y == "number")
              return Y = Y & 255, typeof Uint8Array.prototype.indexOf == "function" ? e ? Uint8Array.prototype.indexOf.call(ve, Y, G) : Uint8Array.prototype.lastIndexOf.call(ve, Y, G) : U(ve, [Y], G, Ae, e);
            throw new TypeError("val must be string, number or Buffer");
          }
          function U(ve, Y, G, Ae, e) {
            var r = 1, h = ve.length, k = Y.length;
            if (Ae !== void 0 && (Ae = String(Ae).toLowerCase(), Ae === "ucs2" || Ae === "ucs-2" || Ae === "utf16le" || Ae === "utf-16le")) {
              if (ve.length < 2 || Y.length < 2)
                return -1;
              r = 2, h /= 2, k /= 2, G /= 2;
            }
            function I(ue, pe) {
              return r === 1 ? ue[pe] : ue.readUInt16BE(pe * r);
            }
            var B;
            if (e) {
              var j = -1;
              for (B = G; B < h; B++)
                if (I(ve, B) === I(Y, j === -1 ? 0 : B - j)) {
                  if (j === -1 && (j = B), B - j + 1 === k) return j * r;
                } else
                  j !== -1 && (B -= B - j), j = -1;
            } else
              for (G + k > h && (G = h - k), B = G; B >= 0; B--) {
                for (var H = !0, X = 0; X < k; X++)
                  if (I(ve, B + X) !== I(Y, X)) {
                    H = !1;
                    break;
                  }
                if (H) return B;
              }
            return -1;
          }
          a.prototype.includes = function(Y, G, Ae) {
            return this.indexOf(Y, G, Ae) !== -1;
          }, a.prototype.indexOf = function(Y, G, Ae) {
            return z(this, Y, G, Ae, !0);
          }, a.prototype.lastIndexOf = function(Y, G, Ae) {
            return z(this, Y, G, Ae, !1);
          };
          function J(ve, Y, G, Ae) {
            G = Number(G) || 0;
            var e = ve.length - G;
            Ae ? (Ae = Number(Ae), Ae > e && (Ae = e)) : Ae = e;
            var r = Y.length;
            Ae > r / 2 && (Ae = r / 2);
            for (var h = 0; h < Ae; ++h) {
              var k = parseInt(Y.substr(h * 2, 2), 16);
              if ($(k)) return h;
              ve[G + h] = k;
            }
            return h;
          }
          function F(ve, Y, G, Ae) {
            return we(Ve(Y, ve.length - G), ve, G, Ae);
          }
          function se(ve, Y, G, Ae) {
            return we(Re(Y), ve, G, Ae);
          }
          function ee(ve, Y, G, Ae) {
            return se(ve, Y, G, Ae);
          }
          function ie(ve, Y, G, Ae) {
            return we(Ne(Y), ve, G, Ae);
          }
          function W(ve, Y, G, Ae) {
            return we(De(Y, ve.length - G), ve, G, Ae);
          }
          a.prototype.write = function(Y, G, Ae, e) {
            if (G === void 0)
              e = "utf8", Ae = this.length, G = 0;
            else if (Ae === void 0 && typeof G == "string")
              e = G, Ae = this.length, G = 0;
            else if (isFinite(G))
              G = G >>> 0, isFinite(Ae) ? (Ae = Ae >>> 0, e === void 0 && (e = "utf8")) : (e = Ae, Ae = void 0);
            else
              throw new Error(
                "Buffer.write(string, encoding, offset[, length]) is no longer supported"
              );
            var r = this.length - G;
            if ((Ae === void 0 || Ae > r) && (Ae = r), Y.length > 0 && (Ae < 0 || G < 0) || G > this.length)
              throw new RangeError("Attempt to write outside buffer bounds");
            e || (e = "utf8");
            for (var h = !1; ; )
              switch (e) {
                case "hex":
                  return J(this, Y, G, Ae);
                case "utf8":
                case "utf-8":
                  return F(this, Y, G, Ae);
                case "ascii":
                  return se(this, Y, G, Ae);
                case "latin1":
                case "binary":
                  return ee(this, Y, G, Ae);
                case "base64":
                  return ie(this, Y, G, Ae);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return W(this, Y, G, Ae);
                default:
                  if (h) throw new TypeError("Unknown encoding: " + e);
                  e = ("" + e).toLowerCase(), h = !0;
              }
          }, a.prototype.toJSON = function() {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          function Q(ve, Y, G) {
            return Y === 0 && G === ve.length ? x.fromByteArray(ve) : x.fromByteArray(ve.slice(Y, G));
          }
          function de(ve, Y, G) {
            G = Math.min(ve.length, G);
            for (var Ae = [], e = Y; e < G; ) {
              var r = ve[e], h = null, k = r > 239 ? 4 : r > 223 ? 3 : r > 191 ? 2 : 1;
              if (e + k <= G) {
                var I, B, j, H;
                switch (k) {
                  case 1:
                    r < 128 && (h = r);
                    break;
                  case 2:
                    I = ve[e + 1], (I & 192) === 128 && (H = (r & 31) << 6 | I & 63, H > 127 && (h = H));
                    break;
                  case 3:
                    I = ve[e + 1], B = ve[e + 2], (I & 192) === 128 && (B & 192) === 128 && (H = (r & 15) << 12 | (I & 63) << 6 | B & 63, H > 2047 && (H < 55296 || H > 57343) && (h = H));
                    break;
                  case 4:
                    I = ve[e + 1], B = ve[e + 2], j = ve[e + 3], (I & 192) === 128 && (B & 192) === 128 && (j & 192) === 128 && (H = (r & 15) << 18 | (I & 63) << 12 | (B & 63) << 6 | j & 63, H > 65535 && H < 1114112 && (h = H));
                }
              }
              h === null ? (h = 65533, k = 1) : h > 65535 && (h -= 65536, Ae.push(h >>> 10 & 1023 | 55296), h = 56320 | h & 1023), Ae.push(h), e += k;
            }
            return ke(Ae);
          }
          var _e = 4096;
          function ke(ve) {
            var Y = ve.length;
            if (Y <= _e)
              return String.fromCharCode.apply(String, ve);
            for (var G = "", Ae = 0; Ae < Y; )
              G += String.fromCharCode.apply(
                String,
                ve.slice(Ae, Ae += _e)
              );
            return G;
          }
          function Pe(ve, Y, G) {
            var Ae = "";
            G = Math.min(ve.length, G);
            for (var e = Y; e < G; ++e)
              Ae += String.fromCharCode(ve[e] & 127);
            return Ae;
          }
          function fe(ve, Y, G) {
            var Ae = "";
            G = Math.min(ve.length, G);
            for (var e = Y; e < G; ++e)
              Ae += String.fromCharCode(ve[e]);
            return Ae;
          }
          function xe(ve, Y, G) {
            var Ae = ve.length;
            (!Y || Y < 0) && (Y = 0), (!G || G < 0 || G > Ae) && (G = Ae);
            for (var e = "", r = Y; r < G; ++r)
              e += Ce[ve[r]];
            return e;
          }
          function Ee(ve, Y, G) {
            for (var Ae = ve.slice(Y, G), e = "", r = 0; r < Ae.length; r += 2)
              e += String.fromCharCode(Ae[r] + Ae[r + 1] * 256);
            return e;
          }
          a.prototype.slice = function(Y, G) {
            var Ae = this.length;
            Y = ~~Y, G = G === void 0 ? Ae : ~~G, Y < 0 ? (Y += Ae, Y < 0 && (Y = 0)) : Y > Ae && (Y = Ae), G < 0 ? (G += Ae, G < 0 && (G = 0)) : G > Ae && (G = Ae), G < Y && (G = Y);
            var e = this.subarray(Y, G);
            return Object.setPrototypeOf(e, a.prototype), e;
          };
          function Ie(ve, Y, G) {
            if (ve % 1 !== 0 || ve < 0) throw new RangeError("offset is not uint");
            if (ve + Y > G) throw new RangeError("Trying to access beyond buffer length");
          }
          a.prototype.readUIntLE = function(Y, G, Ae) {
            Y = Y >>> 0, G = G >>> 0, Ae || Ie(Y, G, this.length);
            for (var e = this[Y], r = 1, h = 0; ++h < G && (r *= 256); )
              e += this[Y + h] * r;
            return e;
          }, a.prototype.readUIntBE = function(Y, G, Ae) {
            Y = Y >>> 0, G = G >>> 0, Ae || Ie(Y, G, this.length);
            for (var e = this[Y + --G], r = 1; G > 0 && (r *= 256); )
              e += this[Y + --G] * r;
            return e;
          }, a.prototype.readUInt8 = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 1, this.length), this[Y];
          }, a.prototype.readUInt16LE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 2, this.length), this[Y] | this[Y + 1] << 8;
          }, a.prototype.readUInt16BE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 2, this.length), this[Y] << 8 | this[Y + 1];
          }, a.prototype.readUInt32LE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), (this[Y] | this[Y + 1] << 8 | this[Y + 2] << 16) + this[Y + 3] * 16777216;
          }, a.prototype.readUInt32BE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), this[Y] * 16777216 + (this[Y + 1] << 16 | this[Y + 2] << 8 | this[Y + 3]);
          }, a.prototype.readIntLE = function(Y, G, Ae) {
            Y = Y >>> 0, G = G >>> 0, Ae || Ie(Y, G, this.length);
            for (var e = this[Y], r = 1, h = 0; ++h < G && (r *= 256); )
              e += this[Y + h] * r;
            return r *= 128, e >= r && (e -= Math.pow(2, 8 * G)), e;
          }, a.prototype.readIntBE = function(Y, G, Ae) {
            Y = Y >>> 0, G = G >>> 0, Ae || Ie(Y, G, this.length);
            for (var e = G, r = 1, h = this[Y + --e]; e > 0 && (r *= 256); )
              h += this[Y + --e] * r;
            return r *= 128, h >= r && (h -= Math.pow(2, 8 * G)), h;
          }, a.prototype.readInt8 = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 1, this.length), this[Y] & 128 ? (255 - this[Y] + 1) * -1 : this[Y];
          }, a.prototype.readInt16LE = function(Y, G) {
            Y = Y >>> 0, G || Ie(Y, 2, this.length);
            var Ae = this[Y] | this[Y + 1] << 8;
            return Ae & 32768 ? Ae | 4294901760 : Ae;
          }, a.prototype.readInt16BE = function(Y, G) {
            Y = Y >>> 0, G || Ie(Y, 2, this.length);
            var Ae = this[Y + 1] | this[Y] << 8;
            return Ae & 32768 ? Ae | 4294901760 : Ae;
          }, a.prototype.readInt32LE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), this[Y] | this[Y + 1] << 8 | this[Y + 2] << 16 | this[Y + 3] << 24;
          }, a.prototype.readInt32BE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), this[Y] << 24 | this[Y + 1] << 16 | this[Y + 2] << 8 | this[Y + 3];
          }, a.prototype.readFloatLE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), y.read(this, Y, !0, 23, 4);
          }, a.prototype.readFloatBE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 4, this.length), y.read(this, Y, !1, 23, 4);
          }, a.prototype.readDoubleLE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 8, this.length), y.read(this, Y, !0, 52, 8);
          }, a.prototype.readDoubleBE = function(Y, G) {
            return Y = Y >>> 0, G || Ie(Y, 8, this.length), y.read(this, Y, !1, 52, 8);
          };
          function je(ve, Y, G, Ae, e, r) {
            if (!a.isBuffer(ve)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (Y > e || Y < r) throw new RangeError('"value" argument is out of bounds');
            if (G + Ae > ve.length) throw new RangeError("Index out of range");
          }
          a.prototype.writeUIntLE = function(Y, G, Ae, e) {
            if (Y = +Y, G = G >>> 0, Ae = Ae >>> 0, !e) {
              var r = Math.pow(2, 8 * Ae) - 1;
              je(this, Y, G, Ae, r, 0);
            }
            var h = 1, k = 0;
            for (this[G] = Y & 255; ++k < Ae && (h *= 256); )
              this[G + k] = Y / h & 255;
            return G + Ae;
          }, a.prototype.writeUIntBE = function(Y, G, Ae, e) {
            if (Y = +Y, G = G >>> 0, Ae = Ae >>> 0, !e) {
              var r = Math.pow(2, 8 * Ae) - 1;
              je(this, Y, G, Ae, r, 0);
            }
            var h = Ae - 1, k = 1;
            for (this[G + h] = Y & 255; --h >= 0 && (k *= 256); )
              this[G + h] = Y / k & 255;
            return G + Ae;
          }, a.prototype.writeUInt8 = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 1, 255, 0), this[G] = Y & 255, G + 1;
          }, a.prototype.writeUInt16LE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 2, 65535, 0), this[G] = Y & 255, this[G + 1] = Y >>> 8, G + 2;
          }, a.prototype.writeUInt16BE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 2, 65535, 0), this[G] = Y >>> 8, this[G + 1] = Y & 255, G + 2;
          }, a.prototype.writeUInt32LE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 4, 4294967295, 0), this[G + 3] = Y >>> 24, this[G + 2] = Y >>> 16, this[G + 1] = Y >>> 8, this[G] = Y & 255, G + 4;
          }, a.prototype.writeUInt32BE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 4, 4294967295, 0), this[G] = Y >>> 24, this[G + 1] = Y >>> 16, this[G + 2] = Y >>> 8, this[G + 3] = Y & 255, G + 4;
          }, a.prototype.writeIntLE = function(Y, G, Ae, e) {
            if (Y = +Y, G = G >>> 0, !e) {
              var r = Math.pow(2, 8 * Ae - 1);
              je(this, Y, G, Ae, r - 1, -r);
            }
            var h = 0, k = 1, I = 0;
            for (this[G] = Y & 255; ++h < Ae && (k *= 256); )
              Y < 0 && I === 0 && this[G + h - 1] !== 0 && (I = 1), this[G + h] = (Y / k >> 0) - I & 255;
            return G + Ae;
          }, a.prototype.writeIntBE = function(Y, G, Ae, e) {
            if (Y = +Y, G = G >>> 0, !e) {
              var r = Math.pow(2, 8 * Ae - 1);
              je(this, Y, G, Ae, r - 1, -r);
            }
            var h = Ae - 1, k = 1, I = 0;
            for (this[G + h] = Y & 255; --h >= 0 && (k *= 256); )
              Y < 0 && I === 0 && this[G + h + 1] !== 0 && (I = 1), this[G + h] = (Y / k >> 0) - I & 255;
            return G + Ae;
          }, a.prototype.writeInt8 = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 1, 127, -128), Y < 0 && (Y = 255 + Y + 1), this[G] = Y & 255, G + 1;
          }, a.prototype.writeInt16LE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 2, 32767, -32768), this[G] = Y & 255, this[G + 1] = Y >>> 8, G + 2;
          }, a.prototype.writeInt16BE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 2, 32767, -32768), this[G] = Y >>> 8, this[G + 1] = Y & 255, G + 2;
          }, a.prototype.writeInt32LE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 4, 2147483647, -2147483648), this[G] = Y & 255, this[G + 1] = Y >>> 8, this[G + 2] = Y >>> 16, this[G + 3] = Y >>> 24, G + 4;
          }, a.prototype.writeInt32BE = function(Y, G, Ae) {
            return Y = +Y, G = G >>> 0, Ae || je(this, Y, G, 4, 2147483647, -2147483648), Y < 0 && (Y = 4294967295 + Y + 1), this[G] = Y >>> 24, this[G + 1] = Y >>> 16, this[G + 2] = Y >>> 8, this[G + 3] = Y & 255, G + 4;
          };
          function Ue(ve, Y, G, Ae, e, r) {
            if (G + Ae > ve.length) throw new RangeError("Index out of range");
            if (G < 0) throw new RangeError("Index out of range");
          }
          function He(ve, Y, G, Ae, e) {
            return Y = +Y, G = G >>> 0, e || Ue(ve, Y, G, 4), y.write(ve, Y, G, Ae, 23, 4), G + 4;
          }
          a.prototype.writeFloatLE = function(Y, G, Ae) {
            return He(this, Y, G, !0, Ae);
          }, a.prototype.writeFloatBE = function(Y, G, Ae) {
            return He(this, Y, G, !1, Ae);
          };
          function Ze(ve, Y, G, Ae, e) {
            return Y = +Y, G = G >>> 0, e || Ue(ve, Y, G, 8), y.write(ve, Y, G, Ae, 52, 8), G + 8;
          }
          a.prototype.writeDoubleLE = function(Y, G, Ae) {
            return Ze(this, Y, G, !0, Ae);
          }, a.prototype.writeDoubleBE = function(Y, G, Ae) {
            return Ze(this, Y, G, !1, Ae);
          }, a.prototype.copy = function(Y, G, Ae, e) {
            if (!a.isBuffer(Y)) throw new TypeError("argument should be a Buffer");
            if (Ae || (Ae = 0), !e && e !== 0 && (e = this.length), G >= Y.length && (G = Y.length), G || (G = 0), e > 0 && e < Ae && (e = Ae), e === Ae || Y.length === 0 || this.length === 0) return 0;
            if (G < 0)
              throw new RangeError("targetStart out of bounds");
            if (Ae < 0 || Ae >= this.length) throw new RangeError("Index out of range");
            if (e < 0) throw new RangeError("sourceEnd out of bounds");
            e > this.length && (e = this.length), Y.length - G < e - Ae && (e = Y.length - G + Ae);
            var r = e - Ae;
            if (this === Y && typeof Uint8Array.prototype.copyWithin == "function")
              this.copyWithin(G, Ae, e);
            else if (this === Y && Ae < G && G < e)
              for (var h = r - 1; h >= 0; --h)
                Y[h + G] = this[h + Ae];
            else
              Uint8Array.prototype.set.call(
                Y,
                this.subarray(Ae, e),
                G
              );
            return r;
          }, a.prototype.fill = function(Y, G, Ae, e) {
            if (typeof Y == "string") {
              if (typeof G == "string" ? (e = G, G = 0, Ae = this.length) : typeof Ae == "string" && (e = Ae, Ae = this.length), e !== void 0 && typeof e != "string")
                throw new TypeError("encoding must be a string");
              if (typeof e == "string" && !a.isEncoding(e))
                throw new TypeError("Unknown encoding: " + e);
              if (Y.length === 1) {
                var r = Y.charCodeAt(0);
                (e === "utf8" && r < 128 || e === "latin1") && (Y = r);
              }
            } else typeof Y == "number" ? Y = Y & 255 : typeof Y == "boolean" && (Y = Number(Y));
            if (G < 0 || this.length < G || this.length < Ae)
              throw new RangeError("Out of range index");
            if (Ae <= G)
              return this;
            G = G >>> 0, Ae = Ae === void 0 ? this.length : Ae >>> 0, Y || (Y = 0);
            var h;
            if (typeof Y == "number")
              for (h = G; h < Ae; ++h)
                this[h] = Y;
            else {
              var k = a.isBuffer(Y) ? Y : a.from(Y, e), I = k.length;
              if (I === 0)
                throw new TypeError('The value "' + Y + '" is invalid for argument "value"');
              for (h = 0; h < Ae - G; ++h)
                this[h + G] = k[h % I];
            }
            return this;
          };
          var $e = /[^+/0-9A-Za-z-_]/g;
          function We(ve) {
            if (ve = ve.split("=")[0], ve = ve.trim().replace($e, ""), ve.length < 2) return "";
            for (; ve.length % 4 !== 0; )
              ve = ve + "=";
            return ve;
          }
          function Ve(ve, Y) {
            Y = Y || 1 / 0;
            for (var G, Ae = ve.length, e = null, r = [], h = 0; h < Ae; ++h) {
              if (G = ve.charCodeAt(h), G > 55295 && G < 57344) {
                if (!e) {
                  if (G > 56319) {
                    (Y -= 3) > -1 && r.push(239, 191, 189);
                    continue;
                  } else if (h + 1 === Ae) {
                    (Y -= 3) > -1 && r.push(239, 191, 189);
                    continue;
                  }
                  e = G;
                  continue;
                }
                if (G < 56320) {
                  (Y -= 3) > -1 && r.push(239, 191, 189), e = G;
                  continue;
                }
                G = (e - 55296 << 10 | G - 56320) + 65536;
              } else e && (Y -= 3) > -1 && r.push(239, 191, 189);
              if (e = null, G < 128) {
                if ((Y -= 1) < 0) break;
                r.push(G);
              } else if (G < 2048) {
                if ((Y -= 2) < 0) break;
                r.push(
                  G >> 6 | 192,
                  G & 63 | 128
                );
              } else if (G < 65536) {
                if ((Y -= 3) < 0) break;
                r.push(
                  G >> 12 | 224,
                  G >> 6 & 63 | 128,
                  G & 63 | 128
                );
              } else if (G < 1114112) {
                if ((Y -= 4) < 0) break;
                r.push(
                  G >> 18 | 240,
                  G >> 12 & 63 | 128,
                  G >> 6 & 63 | 128,
                  G & 63 | 128
                );
              } else
                throw new Error("Invalid code point");
            }
            return r;
          }
          function Re(ve) {
            for (var Y = [], G = 0; G < ve.length; ++G)
              Y.push(ve.charCodeAt(G) & 255);
            return Y;
          }
          function De(ve, Y) {
            for (var G, Ae, e, r = [], h = 0; h < ve.length && !((Y -= 2) < 0); ++h)
              G = ve.charCodeAt(h), Ae = G >> 8, e = G % 256, r.push(e), r.push(Ae);
            return r;
          }
          function Ne(ve) {
            return x.toByteArray(We(ve));
          }
          function we(ve, Y, G, Ae) {
            for (var e = 0; e < Ae && !(e + G >= Y.length || e >= ve.length); ++e)
              Y[e + G] = ve[e];
            return e;
          }
          function re(ve, Y) {
            return ve instanceof Y || ve != null && ve.constructor != null && ve.constructor.name != null && ve.constructor.name === Y.name;
          }
          function $(ve) {
            return ve !== ve;
          }
          var Ce = function() {
            for (var ve = "0123456789abcdef", Y = new Array(256), G = 0; G < 16; ++G)
              for (var Ae = G * 16, e = 0; e < 16; ++e)
                Y[Ae + e] = ve[G] + ve[e];
            return Y;
          }();
        }).call(this, C("buffer").Buffer);
      }, { "base64-js": 29, buffer: 48, ieee754: 73 }], 49: [function(C, Z, _) {
        var P = C("buffer").Buffer;
        Z.exports = function(x, y) {
          if (P.isBuffer(x) && P.isBuffer(y)) {
            if (typeof x.equals == "function") return x.equals(y);
            if (x.length !== y.length) return !1;
            for (var E = 0; E < x.length; E++)
              if (x[E] !== y[E]) return !1;
            return !0;
          }
        };
      }, { buffer: 48 }], 50: [function(C, Z, _) {
        Z.exports = {
          100: "Continue",
          101: "Switching Protocols",
          102: "Processing",
          200: "OK",
          201: "Created",
          202: "Accepted",
          203: "Non-Authoritative Information",
          204: "No Content",
          205: "Reset Content",
          206: "Partial Content",
          207: "Multi-Status",
          208: "Already Reported",
          226: "IM Used",
          300: "Multiple Choices",
          301: "Moved Permanently",
          302: "Found",
          303: "See Other",
          304: "Not Modified",
          305: "Use Proxy",
          307: "Temporary Redirect",
          308: "Permanent Redirect",
          400: "Bad Request",
          401: "Unauthorized",
          402: "Payment Required",
          403: "Forbidden",
          404: "Not Found",
          405: "Method Not Allowed",
          406: "Not Acceptable",
          407: "Proxy Authentication Required",
          408: "Request Timeout",
          409: "Conflict",
          410: "Gone",
          411: "Length Required",
          412: "Precondition Failed",
          413: "Payload Too Large",
          414: "URI Too Long",
          415: "Unsupported Media Type",
          416: "Range Not Satisfiable",
          417: "Expectation Failed",
          418: "I'm a teapot",
          421: "Misdirected Request",
          422: "Unprocessable Entity",
          423: "Locked",
          424: "Failed Dependency",
          425: "Unordered Collection",
          426: "Upgrade Required",
          428: "Precondition Required",
          429: "Too Many Requests",
          431: "Request Header Fields Too Large",
          451: "Unavailable For Legal Reasons",
          500: "Internal Server Error",
          501: "Not Implemented",
          502: "Bad Gateway",
          503: "Service Unavailable",
          504: "Gateway Timeout",
          505: "HTTP Version Not Supported",
          506: "Variant Also Negotiates",
          507: "Insufficient Storage",
          508: "Loop Detected",
          509: "Bandwidth Limit Exceeded",
          510: "Not Extended",
          511: "Network Authentication Required"
        };
      }, {}], 51: [function(C, Z, _) {
        (function(P) {
          function x(o) {
            return Array.isArray ? Array.isArray(o) : b(o) === "[object Array]";
          }
          _.isArray = x;
          function y(o) {
            return typeof o == "boolean";
          }
          _.isBoolean = y;
          function E(o) {
            return o === null;
          }
          _.isNull = E;
          function d(o) {
            return o == null;
          }
          _.isNullOrUndefined = d;
          function l(o) {
            return typeof o == "number";
          }
          _.isNumber = l;
          function u(o) {
            return typeof o == "string";
          }
          _.isString = u;
          function a(o) {
            return typeof o == "symbol";
          }
          _.isSymbol = a;
          function n(o) {
            return o === void 0;
          }
          _.isUndefined = n;
          function c(o) {
            return b(o) === "[object RegExp]";
          }
          _.isRegExp = c;
          function g(o) {
            return typeof o == "object" && o !== null;
          }
          _.isObject = g;
          function f(o) {
            return b(o) === "[object Date]";
          }
          _.isDate = f;
          function p(o) {
            return b(o) === "[object Error]" || o instanceof Error;
          }
          _.isError = p;
          function s(o) {
            return typeof o == "function";
          }
          _.isFunction = s;
          function S(o) {
            return o === null || typeof o == "boolean" || typeof o == "number" || typeof o == "string" || typeof o == "symbol" || // ES6 symbol
            typeof o > "u";
          }
          _.isPrimitive = S, _.isBuffer = P.isBuffer;
          function b(o) {
            return Object.prototype.toString.call(o);
          }
        }).call(this, { isBuffer: C("../../is-buffer/index.js") });
      }, { "../../is-buffer/index.js": 76 }], 52: [function(C, Z, _) {
        var P = Object.create || z, x = Object.keys || U, y = Function.prototype.bind || J;
        function E() {
          (!this._events || !Object.prototype.hasOwnProperty.call(this, "_events")) && (this._events = P(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }
        Z.exports = E, E.EventEmitter = E, E.prototype._events = void 0, E.prototype._maxListeners = void 0;
        var d = 10, l;
        try {
          var u = {};
          Object.defineProperty && Object.defineProperty(u, "x", { value: 0 }), l = u.x === 0;
        } catch {
          l = !1;
        }
        l ? Object.defineProperty(E, "defaultMaxListeners", {
          enumerable: !0,
          get: function() {
            return d;
          },
          set: function(F) {
            if (typeof F != "number" || F < 0 || F !== F)
              throw new TypeError('"defaultMaxListeners" must be a positive number');
            d = F;
          }
        }) : E.defaultMaxListeners = d, E.prototype.setMaxListeners = function(se) {
          if (typeof se != "number" || se < 0 || isNaN(se))
            throw new TypeError('"n" argument must be a positive number');
          return this._maxListeners = se, this;
        };
        function a(F) {
          return F._maxListeners === void 0 ? E.defaultMaxListeners : F._maxListeners;
        }
        E.prototype.getMaxListeners = function() {
          return a(this);
        };
        function n(F, se, ee) {
          if (se)
            F.call(ee);
          else
            for (var ie = F.length, W = R(F, ie), Q = 0; Q < ie; ++Q)
              W[Q].call(ee);
        }
        function c(F, se, ee, ie) {
          if (se)
            F.call(ee, ie);
          else
            for (var W = F.length, Q = R(F, W), de = 0; de < W; ++de)
              Q[de].call(ee, ie);
        }
        function g(F, se, ee, ie, W) {
          if (se)
            F.call(ee, ie, W);
          else
            for (var Q = F.length, de = R(F, Q), _e = 0; _e < Q; ++_e)
              de[_e].call(ee, ie, W);
        }
        function f(F, se, ee, ie, W, Q) {
          if (se)
            F.call(ee, ie, W, Q);
          else
            for (var de = F.length, _e = R(F, de), ke = 0; ke < de; ++ke)
              _e[ke].call(ee, ie, W, Q);
        }
        function p(F, se, ee, ie) {
          if (se)
            F.apply(ee, ie);
          else
            for (var W = F.length, Q = R(F, W), de = 0; de < W; ++de)
              Q[de].apply(ee, ie);
        }
        E.prototype.emit = function(se) {
          var ee, ie, W, Q, de, _e, ke = se === "error";
          if (_e = this._events, _e)
            ke = ke && _e.error == null;
          else if (!ke)
            return !1;
          if (ke) {
            if (arguments.length > 1 && (ee = arguments[1]), ee instanceof Error)
              throw ee;
            var Pe = new Error('Unhandled "error" event. (' + ee + ")");
            throw Pe.context = ee, Pe;
          }
          if (ie = _e[se], !ie)
            return !1;
          var fe = typeof ie == "function";
          switch (W = arguments.length, W) {
            // fast cases
            case 1:
              n(ie, fe, this);
              break;
            case 2:
              c(ie, fe, this, arguments[1]);
              break;
            case 3:
              g(ie, fe, this, arguments[1], arguments[2]);
              break;
            case 4:
              f(ie, fe, this, arguments[1], arguments[2], arguments[3]);
              break;
            // slower
            default:
              for (Q = new Array(W - 1), de = 1; de < W; de++)
                Q[de - 1] = arguments[de];
              p(ie, fe, this, Q);
          }
          return !0;
        };
        function s(F, se, ee, ie) {
          var W, Q, de;
          if (typeof ee != "function")
            throw new TypeError('"listener" argument must be a function');
          if (Q = F._events, Q ? (Q.newListener && (F.emit(
            "newListener",
            se,
            ee.listener ? ee.listener : ee
          ), Q = F._events), de = Q[se]) : (Q = F._events = P(null), F._eventsCount = 0), !de)
            de = Q[se] = ee, ++F._eventsCount;
          else if (typeof de == "function" ? de = Q[se] = ie ? [ee, de] : [de, ee] : ie ? de.unshift(ee) : de.push(ee), !de.warned && (W = a(F), W && W > 0 && de.length > W)) {
            de.warned = !0;
            var _e = new Error("Possible EventEmitter memory leak detected. " + de.length + ' "' + String(se) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
            _e.name = "MaxListenersExceededWarning", _e.emitter = F, _e.type = se, _e.count = de.length, typeof console == "object" && console.warn && console.warn("%s: %s", _e.name, _e.message);
          }
          return F;
        }
        E.prototype.addListener = function(se, ee) {
          return s(this, se, ee, !1);
        }, E.prototype.on = E.prototype.addListener, E.prototype.prependListener = function(se, ee) {
          return s(this, se, ee, !0);
        };
        function S() {
          if (!this.fired)
            switch (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length) {
              case 0:
                return this.listener.call(this.target);
              case 1:
                return this.listener.call(this.target, arguments[0]);
              case 2:
                return this.listener.call(this.target, arguments[0], arguments[1]);
              case 3:
                return this.listener.call(
                  this.target,
                  arguments[0],
                  arguments[1],
                  arguments[2]
                );
              default:
                for (var F = new Array(arguments.length), se = 0; se < F.length; ++se)
                  F[se] = arguments[se];
                this.listener.apply(this.target, F);
            }
        }
        function b(F, se, ee) {
          var ie = { fired: !1, wrapFn: void 0, target: F, type: se, listener: ee }, W = y.call(S, ie);
          return W.listener = ee, ie.wrapFn = W, W;
        }
        E.prototype.once = function(se, ee) {
          if (typeof ee != "function")
            throw new TypeError('"listener" argument must be a function');
          return this.on(se, b(this, se, ee)), this;
        }, E.prototype.prependOnceListener = function(se, ee) {
          if (typeof ee != "function")
            throw new TypeError('"listener" argument must be a function');
          return this.prependListener(se, b(this, se, ee)), this;
        }, E.prototype.removeListener = function(se, ee) {
          var ie, W, Q, de, _e;
          if (typeof ee != "function")
            throw new TypeError('"listener" argument must be a function');
          if (W = this._events, !W)
            return this;
          if (ie = W[se], !ie)
            return this;
          if (ie === ee || ie.listener === ee)
            --this._eventsCount === 0 ? this._events = P(null) : (delete W[se], W.removeListener && this.emit("removeListener", se, ie.listener || ee));
          else if (typeof ie != "function") {
            for (Q = -1, de = ie.length - 1; de >= 0; de--)
              if (ie[de] === ee || ie[de].listener === ee) {
                _e = ie[de].listener, Q = de;
                break;
              }
            if (Q < 0)
              return this;
            Q === 0 ? ie.shift() : T(ie, Q), ie.length === 1 && (W[se] = ie[0]), W.removeListener && this.emit("removeListener", se, _e || ee);
          }
          return this;
        }, E.prototype.removeAllListeners = function(se) {
          var ee, ie, W;
          if (ie = this._events, !ie)
            return this;
          if (!ie.removeListener)
            return arguments.length === 0 ? (this._events = P(null), this._eventsCount = 0) : ie[se] && (--this._eventsCount === 0 ? this._events = P(null) : delete ie[se]), this;
          if (arguments.length === 0) {
            var Q = x(ie), de;
            for (W = 0; W < Q.length; ++W)
              de = Q[W], de !== "removeListener" && this.removeAllListeners(de);
            return this.removeAllListeners("removeListener"), this._events = P(null), this._eventsCount = 0, this;
          }
          if (ee = ie[se], typeof ee == "function")
            this.removeListener(se, ee);
          else if (ee)
            for (W = ee.length - 1; W >= 0; W--)
              this.removeListener(se, ee[W]);
          return this;
        };
        function o(F, se, ee) {
          var ie = F._events;
          if (!ie)
            return [];
          var W = ie[se];
          return W ? typeof W == "function" ? ee ? [W.listener || W] : [W] : ee ? L(W) : R(W, W.length) : [];
        }
        E.prototype.listeners = function(se) {
          return o(this, se, !0);
        }, E.prototype.rawListeners = function(se) {
          return o(this, se, !1);
        }, E.listenerCount = function(F, se) {
          return typeof F.listenerCount == "function" ? F.listenerCount(se) : A.call(F, se);
        }, E.prototype.listenerCount = A;
        function A(F) {
          var se = this._events;
          if (se) {
            var ee = se[F];
            if (typeof ee == "function")
              return 1;
            if (ee)
              return ee.length;
          }
          return 0;
        }
        E.prototype.eventNames = function() {
          return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
        };
        function T(F, se) {
          for (var ee = se, ie = ee + 1, W = F.length; ie < W; ee += 1, ie += 1)
            F[ee] = F[ie];
          F.pop();
        }
        function R(F, se) {
          for (var ee = new Array(se), ie = 0; ie < se; ++ie)
            ee[ie] = F[ie];
          return ee;
        }
        function L(F) {
          for (var se = new Array(F.length), ee = 0; ee < se.length; ++ee)
            se[ee] = F[ee].listener || F[ee];
          return se;
        }
        function z(F) {
          var se = function() {
          };
          return se.prototype = F, new se();
        }
        function U(F) {
          for (var se in F) Object.prototype.hasOwnProperty.call(F, se);
          return se;
        }
        function J(F) {
          var se = this;
          return function() {
            return se.apply(F, arguments);
          };
        }
      }, {}], 53: [function(C, Z, _) {
        var P = C("./lib/parser");
        function x() {
          return (0, eval)("this");
        }
        Z.exports = {
          create: function(y, E) {
            if (E = E || x(), y instanceof E.ArrayBuffer) {
              var d = C("./lib/dom-bufferstream");
              return new P(new d(y, 0, y.byteLength, !0, E));
            } else {
              var l = C("./lib/bufferstream");
              return new P(new l(y, 0, y.length, !0));
            }
          }
        };
      }, { "./lib/bufferstream": 54, "./lib/dom-bufferstream": 56, "./lib/parser": 60 }], 54: [function(C, Z, _) {
        function P(x, y, E, d) {
          this.buffer = x, this.offset = y || 0, E = typeof E == "number" ? E : x.length, this.endPosition = this.offset + E, this.setBigEndian(d);
        }
        P.prototype = {
          setBigEndian: function(x) {
            this.bigEndian = !!x;
          },
          nextUInt8: function() {
            var x = this.buffer.readUInt8(this.offset);
            return this.offset += 1, x;
          },
          nextInt8: function() {
            var x = this.buffer.readInt8(this.offset);
            return this.offset += 1, x;
          },
          nextUInt16: function() {
            var x = this.bigEndian ? this.buffer.readUInt16BE(this.offset) : this.buffer.readUInt16LE(this.offset);
            return this.offset += 2, x;
          },
          nextUInt32: function() {
            var x = this.bigEndian ? this.buffer.readUInt32BE(this.offset) : this.buffer.readUInt32LE(this.offset);
            return this.offset += 4, x;
          },
          nextInt16: function() {
            var x = this.bigEndian ? this.buffer.readInt16BE(this.offset) : this.buffer.readInt16LE(this.offset);
            return this.offset += 2, x;
          },
          nextInt32: function() {
            var x = this.bigEndian ? this.buffer.readInt32BE(this.offset) : this.buffer.readInt32LE(this.offset);
            return this.offset += 4, x;
          },
          nextFloat: function() {
            var x = this.bigEndian ? this.buffer.readFloatBE(this.offset) : this.buffer.readFloatLE(this.offset);
            return this.offset += 4, x;
          },
          nextDouble: function() {
            var x = this.bigEndian ? this.buffer.readDoubleBE(this.offset) : this.buffer.readDoubleLE(this.offset);
            return this.offset += 8, x;
          },
          nextBuffer: function(x) {
            var y = this.buffer.slice(this.offset, this.offset + x);
            return this.offset += x, y;
          },
          remainingLength: function() {
            return this.endPosition - this.offset;
          },
          nextString: function(x) {
            var y = this.buffer.toString("utf8", this.offset, this.offset + x);
            return this.offset += x, y;
          },
          mark: function() {
            var x = this;
            return {
              openWithOffset: function(y) {
                return y = (y || 0) + this.offset, new P(x.buffer, y, x.endPosition - y, x.bigEndian);
              },
              offset: this.offset
            };
          },
          offsetFrom: function(x) {
            return this.offset - x.offset;
          },
          skip: function(x) {
            this.offset += x;
          },
          branch: function(x, y) {
            return y = typeof y == "number" ? y : this.endPosition - (this.offset + x), new P(this.buffer, this.offset + x, y, this.bigEndian);
          }
        }, Z.exports = P;
      }, {}], 55: [function(C, Z, _) {
        function P(a) {
          return parseInt(a, 10);
        }
        var x = 3600, y = 60;
        function E(a, n) {
          a = a.map(P), n = n.map(P);
          var c = a[0], g = a[1] - 1, f = a[2], p = n[0], s = n[1], S = n[2], b = Date.UTC(c, g, f, p, s, S, 0), o = b / 1e3;
          return o;
        }
        function d(a) {
          var n = a.substr(0, 10).split("-"), c = a.substr(11, 8).split(":"), g = a.substr(19, 6), f = g.split(":").map(P), p = f[0] * x + f[1] * y, s = E(n, c);
          if (s -= p, typeof s == "number" && !isNaN(s))
            return s;
        }
        function l(a) {
          var n = a.split(" "), c = n[0].split(":"), g = n[1].split(":"), f = E(c, g);
          if (typeof f == "number" && !isNaN(f))
            return f;
        }
        function u(a) {
          var n = a.length === 19 && a.charAt(4) === ":", c = a.length === 25 && a.charAt(10) === "T";
          if (c)
            return d(a);
          if (n)
            return l(a);
        }
        Z.exports = {
          parseDateWithSpecFormat: l,
          parseDateWithTimezoneFormat: d,
          parseExifDate: u
        };
      }, {}], 56: [function(C, Z, _) {
        function P(x, y, E, d, l, u) {
          this.global = l, y = y || 0, E = E || x.byteLength - y, this.arrayBuffer = x.slice(y, y + E), this.view = new l.DataView(this.arrayBuffer, 0, this.arrayBuffer.byteLength), this.setBigEndian(d), this.offset = 0, this.parentOffset = (u || 0) + y;
        }
        P.prototype = {
          setBigEndian: function(x) {
            this.littleEndian = !x;
          },
          nextUInt8: function() {
            var x = this.view.getUint8(this.offset);
            return this.offset += 1, x;
          },
          nextInt8: function() {
            var x = this.view.getInt8(this.offset);
            return this.offset += 1, x;
          },
          nextUInt16: function() {
            var x = this.view.getUint16(this.offset, this.littleEndian);
            return this.offset += 2, x;
          },
          nextUInt32: function() {
            var x = this.view.getUint32(this.offset, this.littleEndian);
            return this.offset += 4, x;
          },
          nextInt16: function() {
            var x = this.view.getInt16(this.offset, this.littleEndian);
            return this.offset += 2, x;
          },
          nextInt32: function() {
            var x = this.view.getInt32(this.offset, this.littleEndian);
            return this.offset += 4, x;
          },
          nextFloat: function() {
            var x = this.view.getFloat32(this.offset, this.littleEndian);
            return this.offset += 4, x;
          },
          nextDouble: function() {
            var x = this.view.getFloat64(this.offset, this.littleEndian);
            return this.offset += 8, x;
          },
          nextBuffer: function(x) {
            var y = this.arrayBuffer.slice(this.offset, this.offset + x);
            return this.offset += x, y;
          },
          remainingLength: function() {
            return this.arrayBuffer.byteLength - this.offset;
          },
          nextString: function(x) {
            var y = this.arrayBuffer.slice(this.offset, this.offset + x);
            return y = String.fromCharCode.apply(null, new this.global.Uint8Array(y)), this.offset += x, y;
          },
          mark: function() {
            var x = this;
            return {
              openWithOffset: function(y) {
                return y = (y || 0) + this.offset, new P(x.arrayBuffer, y, x.arrayBuffer.byteLength - y, !x.littleEndian, x.global, x.parentOffset);
              },
              offset: this.offset,
              getParentOffset: function() {
                return x.parentOffset;
              }
            };
          },
          offsetFrom: function(x) {
            return this.parentOffset + this.offset - (x.offset + x.getParentOffset());
          },
          skip: function(x) {
            this.offset += x;
          },
          branch: function(x, y) {
            return y = typeof y == "number" ? y : this.arrayBuffer.byteLength - (this.offset + x), new P(this.arrayBuffer, this.offset + x, y, !this.littleEndian, this.global, this.parentOffset);
          }
        }, Z.exports = P;
      }, {}], 57: [function(C, Z, _) {
        Z.exports = {
          exif: {
            1: "InteropIndex",
            2: "InteropVersion",
            11: "ProcessingSoftware",
            254: "SubfileType",
            255: "OldSubfileType",
            256: "ImageWidth",
            257: "ImageHeight",
            258: "BitsPerSample",
            259: "Compression",
            262: "PhotometricInterpretation",
            263: "Thresholding",
            264: "CellWidth",
            265: "CellLength",
            266: "FillOrder",
            269: "DocumentName",
            270: "ImageDescription",
            271: "Make",
            272: "Model",
            273: "StripOffsets",
            274: "Orientation",
            277: "SamplesPerPixel",
            278: "RowsPerStrip",
            279: "StripByteCounts",
            280: "MinSampleValue",
            281: "MaxSampleValue",
            282: "XResolution",
            283: "YResolution",
            284: "PlanarConfiguration",
            285: "PageName",
            286: "XPosition",
            287: "YPosition",
            288: "FreeOffsets",
            289: "FreeByteCounts",
            290: "GrayResponseUnit",
            291: "GrayResponseCurve",
            292: "T4Options",
            293: "T6Options",
            296: "ResolutionUnit",
            297: "PageNumber",
            300: "ColorResponseUnit",
            301: "TransferFunction",
            305: "Software",
            306: "ModifyDate",
            315: "Artist",
            316: "HostComputer",
            317: "Predictor",
            318: "WhitePoint",
            319: "PrimaryChromaticities",
            320: "ColorMap",
            321: "HalftoneHints",
            322: "TileWidth",
            323: "TileLength",
            324: "TileOffsets",
            325: "TileByteCounts",
            326: "BadFaxLines",
            327: "CleanFaxData",
            328: "ConsecutiveBadFaxLines",
            330: "SubIFD",
            332: "InkSet",
            333: "InkNames",
            334: "NumberofInks",
            336: "DotRange",
            337: "TargetPrinter",
            338: "ExtraSamples",
            339: "SampleFormat",
            340: "SMinSampleValue",
            341: "SMaxSampleValue",
            342: "TransferRange",
            343: "ClipPath",
            344: "XClipPathUnits",
            345: "YClipPathUnits",
            346: "Indexed",
            347: "JPEGTables",
            351: "OPIProxy",
            400: "GlobalParametersIFD",
            401: "ProfileType",
            402: "FaxProfile",
            403: "CodingMethods",
            404: "VersionYear",
            405: "ModeNumber",
            433: "Decode",
            434: "DefaultImageColor",
            435: "T82Options",
            437: "JPEGTables",
            512: "JPEGProc",
            513: "ThumbnailOffset",
            514: "ThumbnailLength",
            515: "JPEGRestartInterval",
            517: "JPEGLosslessPredictors",
            518: "JPEGPointTransforms",
            519: "JPEGQTables",
            520: "JPEGDCTables",
            521: "JPEGACTables",
            529: "YCbCrCoefficients",
            530: "YCbCrSubSampling",
            531: "YCbCrPositioning",
            532: "ReferenceBlackWhite",
            559: "StripRowCounts",
            700: "ApplicationNotes",
            999: "USPTOMiscellaneous",
            4096: "RelatedImageFileFormat",
            4097: "RelatedImageWidth",
            4098: "RelatedImageHeight",
            18246: "Rating",
            18247: "XP_DIP_XML",
            18248: "StitchInfo",
            18249: "RatingPercent",
            32781: "ImageID",
            32931: "WangTag1",
            32932: "WangAnnotation",
            32933: "WangTag3",
            32934: "WangTag4",
            32995: "Matteing",
            32996: "DataType",
            32997: "ImageDepth",
            32998: "TileDepth",
            33405: "Model2",
            33421: "CFARepeatPatternDim",
            33422: "CFAPattern2",
            33423: "BatteryLevel",
            33424: "KodakIFD",
            33432: "Copyright",
            33434: "ExposureTime",
            33437: "FNumber",
            33445: "MDFileTag",
            33446: "MDScalePixel",
            33447: "MDColorTable",
            33448: "MDLabName",
            33449: "MDSampleInfo",
            33450: "MDPrepDate",
            33451: "MDPrepTime",
            33452: "MDFileUnits",
            33550: "PixelScale",
            33589: "AdventScale",
            33590: "AdventRevision",
            33628: "UIC1Tag",
            33629: "UIC2Tag",
            33630: "UIC3Tag",
            33631: "UIC4Tag",
            33723: "IPTC-NAA",
            33918: "IntergraphPacketData",
            33919: "IntergraphFlagRegisters",
            33920: "IntergraphMatrix",
            33921: "INGRReserved",
            33922: "ModelTiePoint",
            34016: "Site",
            34017: "ColorSequence",
            34018: "IT8Header",
            34019: "RasterPadding",
            34020: "BitsPerRunLength",
            34021: "BitsPerExtendedRunLength",
            34022: "ColorTable",
            34023: "ImageColorIndicator",
            34024: "BackgroundColorIndicator",
            34025: "ImageColorValue",
            34026: "BackgroundColorValue",
            34027: "PixelIntensityRange",
            34028: "TransparencyIndicator",
            34029: "ColorCharacterization",
            34030: "HCUsage",
            34031: "TrapIndicator",
            34032: "CMYKEquivalent",
            34118: "SEMInfo",
            34152: "AFCP_IPTC",
            34232: "PixelMagicJBIGOptions",
            34264: "ModelTransform",
            34306: "WB_GRGBLevels",
            34310: "LeafData",
            34377: "PhotoshopSettings",
            34665: "ExifOffset",
            34675: "ICC_Profile",
            34687: "TIFF_FXExtensions",
            34688: "MultiProfiles",
            34689: "SharedData",
            34690: "T88Options",
            34732: "ImageLayer",
            34735: "GeoTiffDirectory",
            34736: "GeoTiffDoubleParams",
            34737: "GeoTiffAsciiParams",
            34850: "ExposureProgram",
            34852: "SpectralSensitivity",
            34853: "GPSInfo",
            34855: "ISO",
            34856: "Opto-ElectricConvFactor",
            34857: "Interlace",
            34858: "TimeZoneOffset",
            34859: "SelfTimerMode",
            34864: "SensitivityType",
            34865: "StandardOutputSensitivity",
            34866: "RecommendedExposureIndex",
            34867: "ISOSpeed",
            34868: "ISOSpeedLatitudeyyy",
            34869: "ISOSpeedLatitudezzz",
            34908: "FaxRecvParams",
            34909: "FaxSubAddress",
            34910: "FaxRecvTime",
            34954: "LeafSubIFD",
            36864: "ExifVersion",
            36867: "DateTimeOriginal",
            36868: "CreateDate",
            37121: "ComponentsConfiguration",
            37122: "CompressedBitsPerPixel",
            37377: "ShutterSpeedValue",
            37378: "ApertureValue",
            37379: "BrightnessValue",
            37380: "ExposureCompensation",
            37381: "MaxApertureValue",
            37382: "SubjectDistance",
            37383: "MeteringMode",
            37384: "LightSource",
            37385: "Flash",
            37386: "FocalLength",
            37387: "FlashEnergy",
            37388: "SpatialFrequencyResponse",
            37389: "Noise",
            37390: "FocalPlaneXResolution",
            37391: "FocalPlaneYResolution",
            37392: "FocalPlaneResolutionUnit",
            37393: "ImageNumber",
            37394: "SecurityClassification",
            37395: "ImageHistory",
            37396: "SubjectArea",
            37397: "ExposureIndex",
            37398: "TIFF-EPStandardID",
            37399: "SensingMethod",
            37434: "CIP3DataFile",
            37435: "CIP3Sheet",
            37436: "CIP3Side",
            37439: "StoNits",
            37500: "MakerNote",
            37510: "UserComment",
            37520: "SubSecTime",
            37521: "SubSecTimeOriginal",
            37522: "SubSecTimeDigitized",
            37679: "MSDocumentText",
            37680: "MSPropertySetStorage",
            37681: "MSDocumentTextPosition",
            37724: "ImageSourceData",
            40091: "XPTitle",
            40092: "XPComment",
            40093: "XPAuthor",
            40094: "XPKeywords",
            40095: "XPSubject",
            40960: "FlashpixVersion",
            40961: "ColorSpace",
            40962: "ExifImageWidth",
            40963: "ExifImageHeight",
            40964: "RelatedSoundFile",
            40965: "InteropOffset",
            41483: "FlashEnergy",
            41484: "SpatialFrequencyResponse",
            41485: "Noise",
            41486: "FocalPlaneXResolution",
            41487: "FocalPlaneYResolution",
            41488: "FocalPlaneResolutionUnit",
            41489: "ImageNumber",
            41490: "SecurityClassification",
            41491: "ImageHistory",
            41492: "SubjectLocation",
            41493: "ExposureIndex",
            41494: "TIFF-EPStandardID",
            41495: "SensingMethod",
            41728: "FileSource",
            41729: "SceneType",
            41730: "CFAPattern",
            41985: "CustomRendered",
            41986: "ExposureMode",
            41987: "WhiteBalance",
            41988: "DigitalZoomRatio",
            41989: "FocalLengthIn35mmFormat",
            41990: "SceneCaptureType",
            41991: "GainControl",
            41992: "Contrast",
            41993: "Saturation",
            41994: "Sharpness",
            41995: "DeviceSettingDescription",
            41996: "SubjectDistanceRange",
            42016: "ImageUniqueID",
            42032: "OwnerName",
            42033: "SerialNumber",
            42034: "LensInfo",
            42035: "LensMake",
            42036: "LensModel",
            42037: "LensSerialNumber",
            42112: "GDALMetadata",
            42113: "GDALNoData",
            42240: "Gamma",
            44992: "ExpandSoftware",
            44993: "ExpandLens",
            44994: "ExpandFilm",
            44995: "ExpandFilterLens",
            44996: "ExpandScanner",
            44997: "ExpandFlashLamp",
            48129: "PixelFormat",
            48130: "Transformation",
            48131: "Uncompressed",
            48132: "ImageType",
            48256: "ImageWidth",
            48257: "ImageHeight",
            48258: "WidthResolution",
            48259: "HeightResolution",
            48320: "ImageOffset",
            48321: "ImageByteCount",
            48322: "AlphaOffset",
            48323: "AlphaByteCount",
            48324: "ImageDataDiscard",
            48325: "AlphaDataDiscard",
            50215: "OceScanjobDesc",
            50216: "OceApplicationSelector",
            50217: "OceIDNumber",
            50218: "OceImageLogic",
            50255: "Annotations",
            50341: "PrintIM",
            50560: "USPTOOriginalContentType",
            50706: "DNGVersion",
            50707: "DNGBackwardVersion",
            50708: "UniqueCameraModel",
            50709: "LocalizedCameraModel",
            50710: "CFAPlaneColor",
            50711: "CFALayout",
            50712: "LinearizationTable",
            50713: "BlackLevelRepeatDim",
            50714: "BlackLevel",
            50715: "BlackLevelDeltaH",
            50716: "BlackLevelDeltaV",
            50717: "WhiteLevel",
            50718: "DefaultScale",
            50719: "DefaultCropOrigin",
            50720: "DefaultCropSize",
            50721: "ColorMatrix1",
            50722: "ColorMatrix2",
            50723: "CameraCalibration1",
            50724: "CameraCalibration2",
            50725: "ReductionMatrix1",
            50726: "ReductionMatrix2",
            50727: "AnalogBalance",
            50728: "AsShotNeutral",
            50729: "AsShotWhiteXY",
            50730: "BaselineExposure",
            50731: "BaselineNoise",
            50732: "BaselineSharpness",
            50733: "BayerGreenSplit",
            50734: "LinearResponseLimit",
            50735: "CameraSerialNumber",
            50736: "DNGLensInfo",
            50737: "ChromaBlurRadius",
            50738: "AntiAliasStrength",
            50739: "ShadowScale",
            50740: "DNGPrivateData",
            50741: "MakerNoteSafety",
            50752: "RawImageSegmentation",
            50778: "CalibrationIlluminant1",
            50779: "CalibrationIlluminant2",
            50780: "BestQualityScale",
            50781: "RawDataUniqueID",
            50784: "AliasLayerMetadata",
            50827: "OriginalRawFileName",
            50828: "OriginalRawFileData",
            50829: "ActiveArea",
            50830: "MaskedAreas",
            50831: "AsShotICCProfile",
            50832: "AsShotPreProfileMatrix",
            50833: "CurrentICCProfile",
            50834: "CurrentPreProfileMatrix",
            50879: "ColorimetricReference",
            50898: "PanasonicTitle",
            50899: "PanasonicTitle2",
            50931: "CameraCalibrationSig",
            50932: "ProfileCalibrationSig",
            50933: "ProfileIFD",
            50934: "AsShotProfileName",
            50935: "NoiseReductionApplied",
            50936: "ProfileName",
            50937: "ProfileHueSatMapDims",
            50938: "ProfileHueSatMapData1",
            50939: "ProfileHueSatMapData2",
            50940: "ProfileToneCurve",
            50941: "ProfileEmbedPolicy",
            50942: "ProfileCopyright",
            50964: "ForwardMatrix1",
            50965: "ForwardMatrix2",
            50966: "PreviewApplicationName",
            50967: "PreviewApplicationVersion",
            50968: "PreviewSettingsName",
            50969: "PreviewSettingsDigest",
            50970: "PreviewColorSpace",
            50971: "PreviewDateTime",
            50972: "RawImageDigest",
            50973: "OriginalRawFileDigest",
            50974: "SubTileBlockSize",
            50975: "RowInterleaveFactor",
            50981: "ProfileLookTableDims",
            50982: "ProfileLookTableData",
            51008: "OpcodeList1",
            51009: "OpcodeList2",
            51022: "OpcodeList3",
            51041: "NoiseProfile",
            51043: "TimeCodes",
            51044: "FrameRate",
            51058: "TStop",
            51081: "ReelName",
            51089: "OriginalDefaultFinalSize",
            51090: "OriginalBestQualitySize",
            51091: "OriginalDefaultCropSize",
            51105: "CameraLabel",
            51107: "ProfileHueSatMapEncoding",
            51108: "ProfileLookTableEncoding",
            51109: "BaselineExposureOffset",
            51110: "DefaultBlackRender",
            51111: "NewRawImageDigest",
            51112: "RawToPreviewGain",
            51125: "DefaultUserCrop",
            59932: "Padding",
            59933: "OffsetSchema",
            65e3: "OwnerName",
            65001: "SerialNumber",
            65002: "Lens",
            65024: "KDC_IFD",
            65100: "RawFile",
            65101: "Converter",
            65102: "WhiteBalance",
            65105: "Exposure",
            65106: "Shadows",
            65107: "Brightness",
            65108: "Contrast",
            65109: "Saturation",
            65110: "Sharpness",
            65111: "Smoothness",
            65112: "MoireFilter"
          },
          gps: {
            0: "GPSVersionID",
            1: "GPSLatitudeRef",
            2: "GPSLatitude",
            3: "GPSLongitudeRef",
            4: "GPSLongitude",
            5: "GPSAltitudeRef",
            6: "GPSAltitude",
            7: "GPSTimeStamp",
            8: "GPSSatellites",
            9: "GPSStatus",
            10: "GPSMeasureMode",
            11: "GPSDOP",
            12: "GPSSpeedRef",
            13: "GPSSpeed",
            14: "GPSTrackRef",
            15: "GPSTrack",
            16: "GPSImgDirectionRef",
            17: "GPSImgDirection",
            18: "GPSMapDatum",
            19: "GPSDestLatitudeRef",
            20: "GPSDestLatitude",
            21: "GPSDestLongitudeRef",
            22: "GPSDestLongitude",
            23: "GPSDestBearingRef",
            24: "GPSDestBearing",
            25: "GPSDestDistanceRef",
            26: "GPSDestDistance",
            27: "GPSProcessingMethod",
            28: "GPSAreaInformation",
            29: "GPSDateStamp",
            30: "GPSDifferential",
            31: "GPSHPositioningError"
          }
        };
      }, {}], 58: [function(C, Z, _) {
        function P(l, u) {
          switch (l) {
            case 1:
              return u.nextUInt8();
            case 3:
              return u.nextUInt16();
            case 4:
              return u.nextUInt32();
            case 5:
              return [u.nextUInt32(), u.nextUInt32()];
            case 6:
              return u.nextInt8();
            case 8:
              return u.nextUInt16();
            case 9:
              return u.nextUInt32();
            case 10:
              return [u.nextInt32(), u.nextInt32()];
            case 11:
              return u.nextFloat();
            case 12:
              return u.nextDouble();
            default:
              throw new Error("Invalid format while decoding: " + l);
          }
        }
        function x(l) {
          switch (l) {
            case 1:
            case 2:
            case 6:
            case 7:
              return 1;
            case 3:
            case 8:
              return 2;
            case 4:
            case 9:
            case 11:
              return 4;
            case 5:
            case 10:
            case 12:
              return 8;
            default:
              return 0;
          }
        }
        function y(l, u) {
          var a = u.nextUInt16(), n = u.nextUInt16(), c = x(n), g = u.nextUInt32(), f = c * g, p, s;
          if (f > 4 && (u = l.openWithOffset(u.nextUInt32())), n === 2) {
            p = u.nextString(g);
            var S = p.indexOf("\0");
            S !== -1 && (p = p.substr(0, S));
          } else if (n === 7)
            p = u.nextBuffer(g);
          else if (n !== 0)
            for (p = [], s = 0; s < g; ++s)
              p.push(P(n, u));
          return f < 4 && u.skip(4 - f), [a, p, n];
        }
        function E(l, u, a) {
          var n = u.nextUInt16(), c, g;
          for (g = 0; g < n; ++g)
            c = y(l, u), a(c[0], c[1], c[2]);
        }
        function d(l) {
          var u = l.nextString(6);
          if (u !== "Exif\0\0")
            throw new Error("Invalid EXIF header");
          var a = l.mark(), n = l.nextUInt16();
          if (n === 18761)
            l.setBigEndian(!1);
          else if (n === 19789)
            l.setBigEndian(!0);
          else
            throw new Error("Invalid TIFF header");
          if (l.nextUInt16() !== 42)
            throw new Error("Invalid TIFF data");
          return a;
        }
        Z.exports = {
          IFD0: 1,
          IFD1: 2,
          GPSIFD: 3,
          SubIFD: 4,
          InteropIFD: 5,
          parseTags: function(l, u) {
            var a;
            try {
              a = d(l);
            } catch {
              return !1;
            }
            var n, c, g, f = a.openWithOffset(l.nextUInt32()), p = this.IFD0;
            E(a, f, function(R, L, z) {
              switch (R) {
                case 34853:
                  c = L[0];
                  break;
                case 34665:
                  n = L[0];
                  break;
                default:
                  u(p, R, L, z);
                  break;
              }
            });
            var s = f.nextUInt32();
            if (s !== 0) {
              var S = a.openWithOffset(s);
              E(a, S, u.bind(null, this.IFD1));
            }
            if (c) {
              var b = a.openWithOffset(c);
              E(a, b, u.bind(null, this.GPSIFD));
            }
            if (n) {
              var o = a.openWithOffset(n), A = this.InteropIFD;
              E(a, o, function(R, L, z) {
                R === 40965 ? g = L[0] : u(A, R, L, z);
              });
            }
            if (g) {
              var T = a.openWithOffset(g);
              E(a, T, u.bind(null, this.InteropIFD));
            }
            return !0;
          }
        };
      }, {}], 59: [function(C, Z, _) {
        Z.exports = {
          parseSections: function(P, x) {
            var y, E;
            for (P.setBigEndian(!0); P.remainingLength() > 0 && E !== 218; ) {
              if (P.nextUInt8() !== 255)
                throw new Error("Invalid JPEG section offset");
              E = P.nextUInt8(), E >= 208 && E <= 217 || E === 218 ? y = 0 : y = P.nextUInt16() - 2, x(E, P.branch(0, y)), P.skip(y);
            }
          },
          //stream should be located after SOF section size and in big endian mode, like passed to parseSections iterator
          getSizeFromSOFSection: function(P) {
            return P.skip(1), {
              height: P.nextUInt16(),
              width: P.nextUInt16()
            };
          },
          getSectionName: function(P) {
            var x, y;
            switch (P) {
              case 216:
                x = "SOI";
                break;
              case 196:
                x = "DHT";
                break;
              case 219:
                x = "DQT";
                break;
              case 221:
                x = "DRI";
                break;
              case 218:
                x = "SOS";
                break;
              case 254:
                x = "COM";
                break;
              case 217:
                x = "EOI";
                break;
              default:
                P >= 224 && P <= 239 ? (x = "APP", y = P - 224) : P >= 192 && P <= 207 && P !== 196 && P !== 200 && P !== 204 ? (x = "SOF", y = P - 192) : P >= 208 && P <= 215 && (x = "RST", y = P - 208);
                break;
            }
            var E = {
              name: x
            };
            return typeof y == "number" && (E.index = y), E;
          }
        };
      }, {}], 60: [function(C, Z, _) {
        var P = C("./jpeg"), x = C("./exif"), y = C("./simplify");
        function E(l, u, a, n, c, g, f) {
          this.startMarker = l, this.tags = u, this.imageSize = a, this.thumbnailOffset = n, this.thumbnailLength = c, this.thumbnailType = g, this.app1Offset = f;
        }
        E.prototype = {
          hasThumbnail: function(l) {
            return !this.thumbnailOffset || !this.thumbnailLength ? !1 : typeof l != "string" ? !0 : l.toLowerCase().trim() === "image/jpeg" ? this.thumbnailType === 6 : l.toLowerCase().trim() === "image/tiff" ? this.thumbnailType === 1 : !1;
          },
          getThumbnailOffset: function() {
            return this.app1Offset + 6 + this.thumbnailOffset;
          },
          getThumbnailLength: function() {
            return this.thumbnailLength;
          },
          getThumbnailBuffer: function() {
            return this._getThumbnailStream().nextBuffer(this.thumbnailLength);
          },
          _getThumbnailStream: function() {
            return this.startMarker.openWithOffset(this.getThumbnailOffset());
          },
          getImageSize: function() {
            return this.imageSize;
          },
          getThumbnailSize: function() {
            var l = this._getThumbnailStream(), u;
            return P.parseSections(l, function(a, n) {
              P.getSectionName(a).name === "SOF" && (u = P.getSizeFromSOFSection(n));
            }), u;
          }
        };
        function d(l) {
          this.stream = l, this.flags = {
            readBinaryTags: !1,
            resolveTagNames: !0,
            simplifyValues: !0,
            imageSize: !0,
            hidePointers: !0,
            returnTags: !0
          };
        }
        d.prototype = {
          enableBinaryFields: function(l) {
            return this.flags.readBinaryTags = !!l, this;
          },
          enablePointers: function(l) {
            return this.flags.hidePointers = !l, this;
          },
          enableTagNames: function(l) {
            return this.flags.resolveTagNames = !!l, this;
          },
          enableImageSize: function(l) {
            return this.flags.imageSize = !!l, this;
          },
          enableReturnTags: function(l) {
            return this.flags.returnTags = !!l, this;
          },
          enableSimpleValues: function(l) {
            return this.flags.simplifyValues = !!l, this;
          },
          parse: function() {
            var l = this.stream.mark(), u = l.openWithOffset(0), a = this.flags, n, c, g, f, p, s, S, b, o;
            return a.resolveTagNames && (S = C("./exif-tags")), a.resolveTagNames ? (n = {}, b = function(A) {
              return n[A.name];
            }, o = function(A, T) {
              n[A.name] = T;
            }) : (n = [], b = function(A) {
              var T;
              for (T = 0; T < n.length; ++T)
                if (n[T].type === A.type && n[T].section === A.section)
                  return n.value;
            }, o = function(A, T) {
              var R;
              for (R = 0; R < n.length; ++R)
                if (n[R].type === A.type && n[R].section === A.section) {
                  n.value = T;
                  return;
                }
            }), P.parseSections(u, function(A, T) {
              var R, L = T.offsetFrom(l);
              A === 225 ? (R = x.parseTags(T, function(z, U, J, F) {
                if (!(!a.readBinaryTags && F === 7)) {
                  if (U === 513) {
                    if (g = J[0], a.hidePointers)
                      return;
                  } else if (U === 514) {
                    if (f = J[0], a.hidePointers)
                      return;
                  } else if (U === 259 && (p = J[0], a.hidePointers))
                    return;
                  if (a.returnTags)
                    if (a.simplifyValues && (J = y.simplifyValue(J, F)), a.resolveTagNames) {
                      var se = z === x.GPSIFD ? S.gps : S.exif, ee = se[U];
                      ee || (ee = S.exif[U]), n.hasOwnProperty(ee) || (n[ee] = J);
                    } else
                      n.push({
                        section: z,
                        type: U,
                        value: J
                      });
                }
              }), R && (s = L)) : a.imageSize && P.getSectionName(A).name === "SOF" && (c = P.getSizeFromSOFSection(T));
            }), a.simplifyValues && (y.castDegreeValues(b, o), y.castDateValues(b, o)), new E(l, n, c, g, f, p, s);
          }
        }, Z.exports = d;
      }, { "./exif": 58, "./exif-tags": 57, "./jpeg": 59, "./simplify": 61 }], 61: [function(C, Z, _) {
        var P = C("./exif"), x = C("./date"), y = [
          {
            section: P.GPSIFD,
            type: 2,
            name: "GPSLatitude",
            refType: 1,
            refName: "GPSLatitudeRef",
            posVal: "N"
          },
          {
            section: P.GPSIFD,
            type: 4,
            name: "GPSLongitude",
            refType: 3,
            refName: "GPSLongitudeRef",
            posVal: "E"
          }
        ], E = [
          {
            section: P.SubIFD,
            type: 306,
            name: "ModifyDate"
          },
          {
            section: P.SubIFD,
            type: 36867,
            name: "DateTimeOriginal"
          },
          {
            section: P.SubIFD,
            type: 36868,
            name: "CreateDate"
          },
          {
            section: P.SubIFD,
            type: 306,
            name: "ModifyDate"
          }
        ];
        Z.exports = {
          castDegreeValues: function(d, l) {
            y.forEach(function(u) {
              var a = d(u);
              if (a) {
                var n = d({ section: u.section, type: u.refType, name: u.refName }), c = n === u.posVal ? 1 : -1, g = (a[0] + a[1] / 60 + a[2] / 3600) * c;
                l(u, g);
              }
            });
          },
          castDateValues: function(d, l) {
            E.forEach(function(u) {
              var a = d(u);
              if (a) {
                var n = x.parseExifDate(a);
                typeof n < "u" && l(u, n);
              }
            });
          },
          simplifyValue: function(d, l) {
            return Array.isArray(d) && (d = d.map(function(u) {
              return l === 10 || l === 5 ? u[0] / u[1] : u;
            }), d.length === 1 && (d = d[0])), d;
          }
        };
      }, { "./date": 55, "./exif": 58 }], 62: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault"), x = P(C("@babel/runtime/helpers/toConsumableArray")), y = function(a) {
          return (0, x.default)(a).map(function(n) {
            return n.charCodeAt(0);
          });
        }, E = y("META-INF/mozilla.rsa"), d = y("[Content_Types].xml"), l = y("_rels/.rels");
        Z.exports = function(u) {
          var a = u instanceof Uint8Array ? u : new Uint8Array(u);
          if (!(a && a.length > 1))
            return null;
          var n = function(z, U) {
            U = Object.assign({
              offset: 0
            }, U);
            for (var J = 0; J < z.length; J++)
              if (U.mask) {
                if (z[J] !== (U.mask[J] & a[J + U.offset]))
                  return !1;
              } else if (z[J] !== a[J + U.offset])
                return !1;
            return !0;
          }, c = function(z, U) {
            return n(y(z), U);
          };
          if (n([255, 216, 255]))
            return {
              ext: "jpg",
              mime: "image/jpeg"
            };
          if (n([137, 80, 78, 71, 13, 10, 26, 10]))
            return {
              ext: "png",
              mime: "image/png"
            };
          if (n([71, 73, 70]))
            return {
              ext: "gif",
              mime: "image/gif"
            };
          if (n([87, 69, 66, 80], {
            offset: 8
          }))
            return {
              ext: "webp",
              mime: "image/webp"
            };
          if (n([70, 76, 73, 70]))
            return {
              ext: "flif",
              mime: "image/flif"
            };
          if ((n([73, 73, 42, 0]) || n([77, 77, 0, 42])) && n([67, 82], {
            offset: 8
          }))
            return {
              ext: "cr2",
              mime: "image/x-canon-cr2"
            };
          if (n([73, 73, 42, 0]) || n([77, 77, 0, 42]))
            return {
              ext: "tif",
              mime: "image/tiff"
            };
          if (n([66, 77]))
            return {
              ext: "bmp",
              mime: "image/bmp"
            };
          if (n([73, 73, 188]))
            return {
              ext: "jxr",
              mime: "image/vnd.ms-photo"
            };
          if (n([56, 66, 80, 83]))
            return {
              ext: "psd",
              mime: "image/vnd.adobe.photoshop"
            };
          if (n([80, 75, 3, 4])) {
            if (n([109, 105, 109, 101, 116, 121, 112, 101, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 101, 112, 117, 98, 43, 122, 105, 112], {
              offset: 30
            }))
              return {
                ext: "epub",
                mime: "application/epub+zip"
              };
            if (n(E, {
              offset: 30
            }))
              return {
                ext: "xpi",
                mime: "application/x-xpinstall"
              };
            if (c("mimetypeapplication/vnd.oasis.opendocument.text", {
              offset: 30
            }))
              return {
                ext: "odt",
                mime: "application/vnd.oasis.opendocument.text"
              };
            if (c("mimetypeapplication/vnd.oasis.opendocument.spreadsheet", {
              offset: 30
            }))
              return {
                ext: "ods",
                mime: "application/vnd.oasis.opendocument.spreadsheet"
              };
            if (c("mimetypeapplication/vnd.oasis.opendocument.presentation", {
              offset: 30
            }))
              return {
                ext: "odp",
                mime: "application/vnd.oasis.opendocument.presentation"
              };
            var g = function(z) {
              var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              return z.findIndex(function(J, F, se) {
                return F >= U && se[F] === 80 && se[F + 1] === 75 && se[F + 2] === 3 && se[F + 3] === 4;
              });
            }, f = 0, p = !1, s = null;
            do {
              var S = f + 30;
              if (p || (p = n(d, {
                offset: S
              }) || n(l, {
                offset: S
              })), s || (c("word/", {
                offset: S
              }) ? s = {
                ext: "docx",
                mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              } : c("ppt/", {
                offset: S
              }) ? s = {
                ext: "pptx",
                mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
              } : c("xl/", {
                offset: S
              }) && (s = {
                ext: "xlsx",
                mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              })), p && s)
                return s;
              f = g(a, S);
            } while (f >= 0);
            if (s)
              return s;
          }
          if (n([80, 75]) && (a[2] === 3 || a[2] === 5 || a[2] === 7) && (a[3] === 4 || a[3] === 6 || a[3] === 8))
            return {
              ext: "zip",
              mime: "application/zip"
            };
          if (n([117, 115, 116, 97, 114], {
            offset: 257
          }))
            return {
              ext: "tar",
              mime: "application/x-tar"
            };
          if (n([82, 97, 114, 33, 26, 7]) && (a[6] === 0 || a[6] === 1))
            return {
              ext: "rar",
              mime: "application/x-rar-compressed"
            };
          if (n([31, 139, 8]))
            return {
              ext: "gz",
              mime: "application/gzip"
            };
          if (n([66, 90, 104]))
            return {
              ext: "bz2",
              mime: "application/x-bzip2"
            };
          if (n([55, 122, 188, 175, 39, 28]))
            return {
              ext: "7z",
              mime: "application/x-7z-compressed"
            };
          if (n([120, 1]))
            return {
              ext: "dmg",
              mime: "application/x-apple-diskimage"
            };
          if (n([51, 103, 112, 53]) || // 3gp5
          n([0, 0, 0]) && n([102, 116, 121, 112], {
            offset: 4
          }) && (n([109, 112, 52, 49], {
            offset: 8
          }) || // MP41
          n([109, 112, 52, 50], {
            offset: 8
          }) || // MP42
          n([105, 115, 111, 109], {
            offset: 8
          }) || // ISOM
          n([105, 115, 111, 50], {
            offset: 8
          }) || // ISO2
          n([109, 109, 112, 52], {
            offset: 8
          }) || // MMP4
          n([77, 52, 86], {
            offset: 8
          }) || // M4V
          n([100, 97, 115, 104], {
            offset: 8
          })))
            return {
              ext: "mp4",
              mime: "video/mp4"
            };
          if (n([77, 84, 104, 100]))
            return {
              ext: "mid",
              mime: "audio/midi"
            };
          if (n([26, 69, 223, 163])) {
            var b = a.subarray(4, 4100), o = b.findIndex(function(L, z, U) {
              return U[z] === 66 && U[z + 1] === 130;
            });
            if (o !== -1) {
              var A = o + 3, T = function(z) {
                return (0, x.default)(z).every(function(U, J) {
                  return b[A + J] === U.charCodeAt(0);
                });
              };
              if (T("matroska"))
                return {
                  ext: "mkv",
                  mime: "video/x-matroska"
                };
              if (T("webm"))
                return {
                  ext: "webm",
                  mime: "video/webm"
                };
            }
          }
          if (n([0, 0, 0, 20, 102, 116, 121, 112, 113, 116, 32, 32]) || n([102, 114, 101, 101], {
            offset: 4
          }) || n([102, 116, 121, 112, 113, 116, 32, 32], {
            offset: 4
          }) || n([109, 100, 97, 116], {
            offset: 4
          }) || // MJPEG
          n([119, 105, 100, 101], {
            offset: 4
          }))
            return {
              ext: "mov",
              mime: "video/quicktime"
            };
          if (n([82, 73, 70, 70])) {
            if (n([65, 86, 73], {
              offset: 8
            }))
              return {
                ext: "avi",
                mime: "video/vnd.avi"
              };
            if (n([87, 65, 86, 69], {
              offset: 8
            }))
              return {
                ext: "wav",
                mime: "audio/vnd.wave"
              };
            if (n([81, 76, 67, 77], {
              offset: 8
            }))
              return {
                ext: "qcp",
                mime: "audio/qcelp"
              };
          }
          if (n([48, 38, 178, 117, 142, 102, 207, 17, 166, 217]))
            return {
              ext: "wmv",
              mime: "video/x-ms-wmv"
            };
          if (n([0, 0, 1, 186]) || n([0, 0, 1, 179]))
            return {
              ext: "mpg",
              mime: "video/mpeg"
            };
          if (n([102, 116, 121, 112, 51, 103], {
            offset: 4
          }))
            return {
              ext: "3gp",
              mime: "video/3gpp"
            };
          for (var R = 0; R < 2 && R < a.length - 16; R++) {
            if (n([73, 68, 51], {
              offset: R
            }) || // ID3 header
            n([255, 226], {
              offset: R,
              mask: [255, 226]
            }))
              return {
                ext: "mp3",
                mime: "audio/mpeg"
              };
            if (n([255, 228], {
              offset: R,
              mask: [255, 228]
            }))
              return {
                ext: "mp2",
                mime: "audio/mpeg"
              };
            if (n([255, 248], {
              offset: R,
              mask: [255, 252]
            }))
              return {
                ext: "mp2",
                mime: "audio/mpeg"
              };
            if (n([255, 240], {
              offset: R,
              mask: [255, 252]
            }))
              return {
                ext: "mp4",
                mime: "audio/mpeg"
              };
          }
          if (n([102, 116, 121, 112, 77, 52, 65], {
            offset: 4
          }) || n([77, 52, 65, 32]))
            return {
              // MPEG-4 layer 3 (audio)
              ext: "m4a",
              mime: "audio/mp4"
              // RFC 4337
            };
          if (n([79, 112, 117, 115, 72, 101, 97, 100], {
            offset: 28
          }))
            return {
              ext: "opus",
              mime: "audio/opus"
            };
          if (n([79, 103, 103, 83]))
            return n([128, 116, 104, 101, 111, 114, 97], {
              offset: 28
            }) ? {
              ext: "ogv",
              mime: "video/ogg"
            } : n([1, 118, 105, 100, 101, 111, 0], {
              offset: 28
            }) ? {
              ext: "ogm",
              mime: "video/ogg"
            } : n([127, 70, 76, 65, 67], {
              offset: 28
            }) ? {
              ext: "oga",
              mime: "audio/ogg"
            } : n([83, 112, 101, 101, 120, 32, 32], {
              offset: 28
            }) ? {
              ext: "spx",
              mime: "audio/ogg"
            } : n([1, 118, 111, 114, 98, 105, 115], {
              offset: 28
            }) ? {
              ext: "ogg",
              mime: "audio/ogg"
            } : {
              ext: "ogx",
              mime: "application/ogg"
            };
          if (n([102, 76, 97, 67]))
            return {
              ext: "flac",
              mime: "audio/x-flac"
            };
          if (n([77, 65, 67, 32]))
            return {
              ext: "ape",
              mime: "audio/ape"
            };
          if (n([119, 118, 112, 107]))
            return {
              ext: "wv",
              mime: "audio/wavpack"
            };
          if (n([35, 33, 65, 77, 82, 10]))
            return {
              ext: "amr",
              mime: "audio/amr"
            };
          if (n([37, 80, 68, 70]))
            return {
              ext: "pdf",
              mime: "application/pdf"
            };
          if (n([77, 90]))
            return {
              ext: "exe",
              mime: "application/x-msdownload"
            };
          if ((a[0] === 67 || a[0] === 70) && n([87, 83], {
            offset: 1
          }))
            return {
              ext: "swf",
              mime: "application/x-shockwave-flash"
            };
          if (n([123, 92, 114, 116, 102]))
            return {
              ext: "rtf",
              mime: "application/rtf"
            };
          if (n([0, 97, 115, 109]))
            return {
              ext: "wasm",
              mime: "application/wasm"
            };
          if (n([119, 79, 70, 70]) && (n([0, 1, 0, 0], {
            offset: 4
          }) || n([79, 84, 84, 79], {
            offset: 4
          })))
            return {
              ext: "woff",
              mime: "font/woff"
            };
          if (n([119, 79, 70, 50]) && (n([0, 1, 0, 0], {
            offset: 4
          }) || n([79, 84, 84, 79], {
            offset: 4
          })))
            return {
              ext: "woff2",
              mime: "font/woff2"
            };
          if (n([76, 80], {
            offset: 34
          }) && (n([0, 0, 1], {
            offset: 8
          }) || n([1, 0, 2], {
            offset: 8
          }) || n([2, 0, 2], {
            offset: 8
          })))
            return {
              ext: "eot",
              mime: "application/vnd.ms-fontobject"
            };
          if (n([0, 1, 0, 0, 0]))
            return {
              ext: "ttf",
              mime: "font/ttf"
            };
          if (n([79, 84, 84, 79, 0]))
            return {
              ext: "otf",
              mime: "font/otf"
            };
          if (n([0, 0, 1, 0]))
            return {
              ext: "ico",
              mime: "image/x-icon"
            };
          if (n([0, 0, 2, 0]))
            return {
              ext: "cur",
              mime: "image/x-icon"
            };
          if (n([70, 76, 86, 1]))
            return {
              ext: "flv",
              mime: "video/x-flv"
            };
          if (n([37, 33]))
            return {
              ext: "ps",
              mime: "application/postscript"
            };
          if (n([253, 55, 122, 88, 90, 0]))
            return {
              ext: "xz",
              mime: "application/x-xz"
            };
          if (n([83, 81, 76, 105]))
            return {
              ext: "sqlite",
              mime: "application/x-sqlite3"
            };
          if (n([78, 69, 83, 26]))
            return {
              ext: "nes",
              mime: "application/x-nintendo-nes-rom"
            };
          if (n([67, 114, 50, 52]))
            return {
              ext: "crx",
              mime: "application/x-google-chrome-extension"
            };
          if (n([77, 83, 67, 70]) || n([73, 83, 99, 40]))
            return {
              ext: "cab",
              mime: "application/vnd.ms-cab-compressed"
            };
          if (n([33, 60, 97, 114, 99, 104, 62, 10, 100, 101, 98, 105, 97, 110, 45, 98, 105, 110, 97, 114, 121]))
            return {
              ext: "deb",
              mime: "application/x-deb"
            };
          if (n([33, 60, 97, 114, 99, 104, 62]))
            return {
              ext: "ar",
              mime: "application/x-unix-archive"
            };
          if (n([237, 171, 238, 219]))
            return {
              ext: "rpm",
              mime: "application/x-rpm"
            };
          if (n([31, 160]) || n([31, 157]))
            return {
              ext: "Z",
              mime: "application/x-compress"
            };
          if (n([76, 90, 73, 80]))
            return {
              ext: "lz",
              mime: "application/x-lzip"
            };
          if (n([208, 207, 17, 224, 161, 177, 26, 225]))
            return {
              ext: "msi",
              mime: "application/x-msi"
            };
          if (n([6, 14, 43, 52, 2, 5, 1, 1, 13, 1, 2, 1, 1, 2]))
            return {
              ext: "mxf",
              mime: "application/mxf"
            };
          if (n([71], {
            offset: 4
          }) && (n([71], {
            offset: 192
          }) || n([71], {
            offset: 196
          })))
            return {
              ext: "mts",
              mime: "video/mp2t"
            };
          if (n([66, 76, 69, 78, 68, 69, 82]))
            return {
              ext: "blend",
              mime: "application/x-blender"
            };
          if (n([66, 80, 71, 251]))
            return {
              ext: "bpg",
              mime: "image/bpg"
            };
          if (n([0, 0, 0, 12, 106, 80, 32, 32, 13, 10, 135, 10])) {
            if (n([106, 112, 50, 32], {
              offset: 20
            }))
              return {
                ext: "jp2",
                mime: "image/jp2"
              };
            if (n([106, 112, 120, 32], {
              offset: 20
            }))
              return {
                ext: "jpx",
                mime: "image/jpx"
              };
            if (n([106, 112, 109, 32], {
              offset: 20
            }))
              return {
                ext: "jpm",
                mime: "image/jpm"
              };
            if (n([109, 106, 112, 50], {
              offset: 20
            }))
              return {
                ext: "mj2",
                mime: "image/mj2"
              };
          }
          if (n([70, 79, 82, 77, 0]))
            return {
              ext: "aif",
              mime: "audio/aiff"
            };
          if (c("<?xml "))
            return {
              ext: "xml",
              mime: "application/xml"
            };
          if (n([66, 79, 79, 75, 77, 79, 66, 73], {
            offset: 60
          }))
            return {
              ext: "mobi",
              mime: "application/x-mobipocket-ebook"
            };
          if (n([102, 116, 121, 112], {
            offset: 4
          })) {
            if (n([109, 105, 102, 49], {
              offset: 8
            }))
              return {
                ext: "heic",
                mime: "image/heif"
              };
            if (n([109, 115, 102, 49], {
              offset: 8
            }))
              return {
                ext: "heic",
                mime: "image/heif-sequence"
              };
            if (n([104, 101, 105, 99], {
              offset: 8
            }) || n([104, 101, 105, 120], {
              offset: 8
            }))
              return {
                ext: "heic",
                mime: "image/heic"
              };
            if (n([104, 101, 118, 99], {
              offset: 8
            }) || n([104, 101, 118, 120], {
              offset: 8
            }))
              return {
                ext: "heic",
                mime: "image/heic-sequence"
              };
          }
          return n([171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10]) ? {
            ext: "ktx",
            mime: "image/ktx"
          } : null;
        };
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/toConsumableArray": 20 }], 63: [function(C, Z, _) {
        var P = C("is-callable"), x = Object.prototype.toString, y = Object.prototype.hasOwnProperty, E = function(n, c, g) {
          for (var f = 0, p = n.length; f < p; f++)
            y.call(n, f) && (g == null ? c(n[f], f, n) : c.call(g, n[f], f, n));
        }, d = function(n, c, g) {
          for (var f = 0, p = n.length; f < p; f++)
            g == null ? c(n.charAt(f), f, n) : c.call(g, n.charAt(f), f, n);
        }, l = function(n, c, g) {
          for (var f in n)
            y.call(n, f) && (g == null ? c(n[f], f, n) : c.call(g, n[f], f, n));
        }, u = function(n, c, g) {
          if (!P(c))
            throw new TypeError("iterator must be a function");
          var f;
          arguments.length >= 3 && (f = g), x.call(n) === "[object Array]" ? E(n, c, f) : typeof n == "string" ? d(n, c, f) : l(n, c, f);
        };
        Z.exports = u;
      }, { "is-callable": 77 }], 64: [function(C, Z, _) {
        function P(d, l, u, c) {
          var n = 0, c = c === void 0 ? {} : c, g = c.loop === void 0 ? null : c.loop, f = c.palette === void 0 ? null : c.palette;
          if (l <= 0 || u <= 0 || l > 65535 || u > 65535)
            throw new Error("Width/Height invalid.");
          function p(L) {
            var z = L.length;
            if (z < 2 || z > 256 || z & z - 1)
              throw new Error(
                "Invalid code/color length, must be power of 2 and 2 .. 256."
              );
            return z;
          }
          d[n++] = 71, d[n++] = 73, d[n++] = 70, d[n++] = 56, d[n++] = 57, d[n++] = 97;
          var s = 0, S = 0;
          if (f !== null) {
            for (var b = p(f); b >>= 1; ) ++s;
            if (b = 1 << s, --s, c.background !== void 0) {
              if (S = c.background, S >= b)
                throw new Error("Background index out of range.");
              if (S === 0)
                throw new Error("Background index explicitly passed as 0.");
            }
          }
          if (d[n++] = l & 255, d[n++] = l >> 8 & 255, d[n++] = u & 255, d[n++] = u >> 8 & 255, d[n++] = (f !== null ? 128 : 0) | // Global Color Table Flag.
          s, d[n++] = S, d[n++] = 0, f !== null)
            for (var o = 0, A = f.length; o < A; ++o) {
              var T = f[o];
              d[n++] = T >> 16 & 255, d[n++] = T >> 8 & 255, d[n++] = T & 255;
            }
          if (g !== null) {
            if (g < 0 || g > 65535)
              throw new Error("Loop count invalid.");
            d[n++] = 33, d[n++] = 255, d[n++] = 11, d[n++] = 78, d[n++] = 69, d[n++] = 84, d[n++] = 83, d[n++] = 67, d[n++] = 65, d[n++] = 80, d[n++] = 69, d[n++] = 50, d[n++] = 46, d[n++] = 48, d[n++] = 3, d[n++] = 1, d[n++] = g & 255, d[n++] = g >> 8 & 255, d[n++] = 0;
          }
          var R = !1;
          this.addFrame = function(L, z, U, J, F, se) {
            if (R === !0 && (--n, R = !1), se = se === void 0 ? {} : se, L < 0 || z < 0 || L > 65535 || z > 65535)
              throw new Error("x/y invalid.");
            if (U <= 0 || J <= 0 || U > 65535 || J > 65535)
              throw new Error("Width/Height invalid.");
            if (F.length < U * J)
              throw new Error("Not enough pixels for the frame size.");
            var ee = !0, ie = se.palette;
            if (ie == null && (ee = !1, ie = f), ie == null)
              throw new Error("Must supply either a local or global palette.");
            for (var W = p(ie), Q = 0; W >>= 1; ) ++Q;
            W = 1 << Q;
            var de = se.delay === void 0 ? 0 : se.delay, _e = se.disposal === void 0 ? 0 : se.disposal;
            if (_e < 0 || _e > 3)
              throw new Error("Disposal out of range.");
            var ke = !1, Pe = 0;
            if (se.transparent !== void 0 && se.transparent !== null && (ke = !0, Pe = se.transparent, Pe < 0 || Pe >= W))
              throw new Error("Transparent color index.");
            if ((_e !== 0 || ke || de !== 0) && (d[n++] = 33, d[n++] = 249, d[n++] = 4, d[n++] = _e << 2 | (ke === !0 ? 1 : 0), d[n++] = de & 255, d[n++] = de >> 8 & 255, d[n++] = Pe, d[n++] = 0), d[n++] = 44, d[n++] = L & 255, d[n++] = L >> 8 & 255, d[n++] = z & 255, d[n++] = z >> 8 & 255, d[n++] = U & 255, d[n++] = U >> 8 & 255, d[n++] = J & 255, d[n++] = J >> 8 & 255, d[n++] = ee === !0 ? 128 | Q - 1 : 0, ee === !0)
              for (var fe = 0, xe = ie.length; fe < xe; ++fe) {
                var Ee = ie[fe];
                d[n++] = Ee >> 16 & 255, d[n++] = Ee >> 8 & 255, d[n++] = Ee & 255;
              }
            return n = x(
              d,
              n,
              Q < 2 ? 2 : Q,
              F
            ), n;
          }, this.end = function() {
            return R === !1 && (d[n++] = 59, R = !0), n;
          }, this.getOutputBuffer = function() {
            return d;
          }, this.setOutputBuffer = function(L) {
            d = L;
          }, this.getOutputBufferPosition = function() {
            return n;
          }, this.setOutputBufferPosition = function(L) {
            n = L;
          };
        }
        function x(d, l, u, a) {
          d[l++] = u;
          var n = l++, c = 1 << u, g = c - 1, f = c + 1, p = f + 1, s = u + 1, S = 0, b = 0;
          function o(se) {
            for (; S >= se; )
              d[l++] = b & 255, b >>= 8, S -= 8, l === n + 256 && (d[n] = 255, n = l++);
          }
          function A(se) {
            b |= se << S, S += s, o(8);
          }
          var T = a[0] & g, R = {};
          A(c);
          for (var L = 1, z = a.length; L < z; ++L) {
            var U = a[L] & g, J = T << 8 | U, F = R[J];
            if (F === void 0) {
              for (b |= T << S, S += s; S >= 8; )
                d[l++] = b & 255, b >>= 8, S -= 8, l === n + 256 && (d[n] = 255, n = l++);
              p === 4096 ? (A(c), p = f + 1, s = u + 1, R = {}) : (p >= 1 << s && ++s, R[J] = p++), T = U;
            } else
              T = F;
          }
          return A(T), A(f), o(1), n + 1 === l ? d[n] = 0 : (d[n] = l - n - 1, d[l++] = 0), l;
        }
        function y(d) {
          var l = 0;
          if (d[l++] !== 71 || d[l++] !== 73 || d[l++] !== 70 || d[l++] !== 56 || (d[l++] + 1 & 253) !== 56 || d[l++] !== 97)
            throw new Error("Invalid GIF 87a/89a header.");
          var u = d[l++] | d[l++] << 8, a = d[l++] | d[l++] << 8, n = d[l++], c = n >> 7, g = n & 7, f = 1 << g + 1;
          d[l++], d[l++];
          var p = null, s = null;
          c && (p = l, s = f, l += f * 3);
          var S = !0, b = [], o = 0, A = null, T = 0, R = null;
          for (this.width = u, this.height = a; S && l < d.length; )
            switch (d[l++]) {
              case 33:
                switch (d[l++]) {
                  case 255:
                    if (d[l] !== 11 || // 21 FF already read, check block size.
                    // NETSCAPE2.0
                    d[l + 1] == 78 && d[l + 2] == 69 && d[l + 3] == 84 && d[l + 4] == 83 && d[l + 5] == 67 && d[l + 6] == 65 && d[l + 7] == 80 && d[l + 8] == 69 && d[l + 9] == 50 && d[l + 10] == 46 && d[l + 11] == 48 && // Sub-block
                    d[l + 12] == 3 && d[l + 13] == 1 && d[l + 16] == 0)
                      l += 14, R = d[l++] | d[l++] << 8, l++;
                    else
                      for (l += 12; ; ) {
                        var L = d[l++];
                        if (!(L >= 0)) throw Error("Invalid block size");
                        if (L === 0) break;
                        l += L;
                      }
                    break;
                  case 249:
                    if (d[l++] !== 4 || d[l + 4] !== 0)
                      throw new Error("Invalid graphics extension block.");
                    var z = d[l++];
                    o = d[l++] | d[l++] << 8, A = d[l++], (z & 1) === 0 && (A = null), T = z >> 2 & 7, l++;
                    break;
                  case 254:
                    for (; ; ) {
                      var L = d[l++];
                      if (!(L >= 0)) throw Error("Invalid block size");
                      if (L === 0) break;
                      l += L;
                    }
                    break;
                  default:
                    throw new Error(
                      "Unknown graphic control label: 0x" + d[l - 1].toString(16)
                    );
                }
                break;
              case 44:
                var U = d[l++] | d[l++] << 8, J = d[l++] | d[l++] << 8, F = d[l++] | d[l++] << 8, se = d[l++] | d[l++] << 8, ee = d[l++], ie = ee >> 7, W = ee >> 6 & 1, Q = ee & 7, de = 1 << Q + 1, _e = p, ke = s, Pe = !1;
                if (ie) {
                  var Pe = !0;
                  _e = l, ke = de, l += de * 3;
                }
                var fe = l;
                for (l++; ; ) {
                  var L = d[l++];
                  if (!(L >= 0)) throw Error("Invalid block size");
                  if (L === 0) break;
                  l += L;
                }
                b.push({
                  x: U,
                  y: J,
                  width: F,
                  height: se,
                  has_local_palette: Pe,
                  palette_offset: _e,
                  palette_size: ke,
                  data_offset: fe,
                  data_length: l - fe,
                  transparent_index: A,
                  interlaced: !!W,
                  delay: o,
                  disposal: T
                });
                break;
              case 59:
                S = !1;
                break;
              default:
                throw new Error("Unknown gif block: 0x" + d[l - 1].toString(16));
            }
          this.numFrames = function() {
            return b.length;
          }, this.loopCount = function() {
            return R;
          }, this.frameInfo = function(xe) {
            if (xe < 0 || xe >= b.length)
              throw new Error("Frame index out of range.");
            return b[xe];
          }, this.decodeAndBlitFrameBGRA = function(xe, Ee) {
            var Ie = this.frameInfo(xe), je = Ie.width * Ie.height, Ue = new Uint8Array(je);
            E(
              d,
              Ie.data_offset,
              Ue,
              je
            );
            var He = Ie.palette_offset, Ze = Ie.transparent_index;
            Ze === null && (Ze = 256);
            var $e = Ie.width, We = u - $e, Ve = $e, Re = (Ie.y * u + Ie.x) * 4, De = ((Ie.y + Ie.height) * u + Ie.x) * 4, Ne = Re, we = We * 4;
            Ie.interlaced === !0 && (we += u * 4 * 7);
            for (var re = 8, $ = 0, Ce = Ue.length; $ < Ce; ++$) {
              var ve = Ue[$];
              if (Ve === 0 && (Ne += we, Ve = $e, Ne >= De && (we = We * 4 + u * 4 * (re - 1), Ne = Re + ($e + We) * (re << 1), re >>= 1)), ve === Ze)
                Ne += 4;
              else {
                var Y = d[He + ve * 3], G = d[He + ve * 3 + 1], Ae = d[He + ve * 3 + 2];
                Ee[Ne++] = Ae, Ee[Ne++] = G, Ee[Ne++] = Y, Ee[Ne++] = 255;
              }
              --Ve;
            }
          }, this.decodeAndBlitFrameRGBA = function(xe, Ee) {
            var Ie = this.frameInfo(xe), je = Ie.width * Ie.height, Ue = new Uint8Array(je);
            E(
              d,
              Ie.data_offset,
              Ue,
              je
            );
            var He = Ie.palette_offset, Ze = Ie.transparent_index;
            Ze === null && (Ze = 256);
            var $e = Ie.width, We = u - $e, Ve = $e, Re = (Ie.y * u + Ie.x) * 4, De = ((Ie.y + Ie.height) * u + Ie.x) * 4, Ne = Re, we = We * 4;
            Ie.interlaced === !0 && (we += u * 4 * 7);
            for (var re = 8, $ = 0, Ce = Ue.length; $ < Ce; ++$) {
              var ve = Ue[$];
              if (Ve === 0 && (Ne += we, Ve = $e, Ne >= De && (we = We * 4 + u * 4 * (re - 1), Ne = Re + ($e + We) * (re << 1), re >>= 1)), ve === Ze)
                Ne += 4;
              else {
                var Y = d[He + ve * 3], G = d[He + ve * 3 + 1], Ae = d[He + ve * 3 + 2];
                Ee[Ne++] = Y, Ee[Ne++] = G, Ee[Ne++] = Ae, Ee[Ne++] = 255;
              }
              --Ve;
            }
          };
        }
        function E(d, l, u, a) {
          for (var n = d[l++], c = 1 << n, g = c + 1, f = g + 1, p = n + 1, s = (1 << p) - 1, S = 0, b = 0, o = 0, A = d[l++], T = new Int32Array(4096), R = null; ; ) {
            for (; S < 16 && A !== 0; )
              b |= d[l++] << S, S += 8, A === 1 ? A = d[l++] : --A;
            if (S < p)
              break;
            var L = b & s;
            if (b >>= p, S -= p, L === c) {
              f = g + 1, p = n + 1, s = (1 << p) - 1, R = null;
              continue;
            } else if (L === g)
              break;
            for (var z = L < f ? L : R, U = 0, J = z; J > c; )
              J = T[J] >> 8, ++U;
            var F = J, se = o + U + (z !== L ? 1 : 0);
            if (se > a) {
              console.log("Warning, gif stream longer than expected.");
              return;
            }
            u[o++] = F, o += U;
            var ee = o;
            for (z !== L && (u[o++] = F), J = z; U--; )
              J = T[J], u[--ee] = J & 255, J >>= 8;
            R !== null && f < 4096 && (T[f++] = R << 8 | F, f >= s + 1 && p < 12 && (++p, s = s << 1 | 1)), R = L;
          }
          return o !== a && console.log("Warning, gif stream shorter than expected."), u;
        }
        try {
          _.GifWriter = P, _.GifReader = y;
        } catch {
        }
      }, {}], 65: [function(C, Z, _) {
        (function(P) {
          class x {
            /**
             * BitmapImage is a class that hold an RGBA (red, green, blue, alpha) representation of an image. It's shape is borrowed from the Jimp package to make it easy to transfer GIF image frames into Jimp and Jimp images into GIF image frames. Each instance has a `bitmap` property having the following properties:
             * 
             * Property | Description
             * --- | ---
             * bitmap.width | width of image in pixels
             * bitmap.height | height of image in pixels
             * bitmap.data | a Buffer whose every four bytes represents a pixel, each sequential byte of a pixel corresponding to the red, green, blue, and alpha values of the pixel
             *
             * Its constructor supports the following signatures:
             *
             * * new BitmapImage(bitmap: { width: number, height: number, data: Buffer })
             * * new BitmapImage(bitmapImage: BitmapImage)
             * * new BitmapImage(width: number, height: number, buffer: Buffer)
             * * new BitmapImage(width: number, height: number, backgroundRGBA?: number)
             * 
             * When a `BitmapImage` is provided, the constructed `BitmapImage` is a deep clone of the provided one, so that each image's pixel data can subsequently be modified without affecting each other.
             *
             * `backgroundRGBA` is an optional parameter representing a pixel as a single number. In hex, the number is as follows: 0xRRGGBBAA, where RR is the red byte, GG the green byte, BB, the blue byte, and AA the alpha value. An AA of 0x00 is considered transparent, and all non-zero AA values are treated as opaque.
             */
            constructor(...E) {
              if (E.length === 0)
                throw new Error("constructor requires parameters");
              const d = E[0];
              if (d !== null && typeof d == "object")
                if (d instanceof x) {
                  const l = d.bitmap;
                  this.bitmap = {
                    width: l.width,
                    height: l.height,
                    data: new P(l.width * l.height * 4)
                  }, l.data.copy(this.bitmap.data);
                } else if (d.width && d.height && d.data)
                  this.bitmap = d;
                else
                  throw new Error("unrecognized constructor parameters");
              else if (typeof d == "number" && typeof E[1] == "number") {
                const l = d, u = E[1], a = E[2];
                this.bitmap = { width: l, height: u }, P.isBuffer(a) ? this.bitmap.data = a : (this.bitmap.data = new P(l * u * 4), typeof a == "number" && this.fillRGBA(a));
              } else
                throw new Error("unrecognized constructor parameters");
            }
            /**
             * Copy a square portion of this image into another image. 
             * 
             * @param {BitmapImage} toImage Image into which to copy the square
             * @param {number} toX x-coord in toImage of upper-left corner of receiving square
             * @param {number} toY y-coord in toImage of upper-left corner of receiving square
             * @param {number} fromX x-coord in this image of upper-left corner of source square
             * @param {number} fromY y-coord in this image of upper-left corner of source square
             * @return {BitmapImage} The present image to allow for chaining.
             */
            blit(E, d, l, u, a, n, c) {
              if (u + n > this.bitmap.width)
                throw new Error("copy exceeds width of source bitmap");
              if (d + n > E.bitmap.width)
                throw new Error("copy exceeds width of target bitmap");
              if (a + c > this.bitmap.height)
                throw new Error("copy exceeds height of source bitmap");
              if (l + c > E.bitmap.height)
                throw new Erro("copy exceeds height of target bitmap");
              const g = this.bitmap.data, f = E.bitmap.data, p = this.bitmap.width * 4, s = E.bitmap.width * 4, S = n * 4;
              let b = a * p + u * 4, o = l * s + d * 4;
              for (; --c >= 0; )
                g.copy(f, o, b, b + S), b += p, o += s;
              return this;
            }
            /**
             * Fills the image with a single color.
             * 
             * @param {number} rgba Color with which to fill image, expressed as a singlenumber in the form 0xRRGGBBAA, where AA is 0x00 for transparent and any other value for opaque.
             * @return {BitmapImage} The present image to allow for chaining.
             */
            fillRGBA(E) {
              const d = this.bitmap.data, l = this.bitmap.height * 4;
              let u = 0;
              for (; u < l; )
                d.writeUInt32BE(E, u), u += 4;
              for (; u < d.length; )
                d.copy(d, u, 0, l), u += l;
              return this;
            }
            /**
             * Gets the RGBA number of the pixel at the given coordinate in the form 0xRRGGBBAA, where AA is the alpha value, with alpha 0x00 encoding to transparency in GIFs.
             * 
             * @param {number} x x-coord of pixel
             * @param {number} y y-coord of pixel
             * @return {number} RGBA of pixel in 0xRRGGBBAA form
             */
            getRGBA(E, d) {
              const l = (d * this.bitmap.width + E) * 4;
              return this.bitmap.data.readUInt32BE(l);
            }
            /**
             * Gets a set of all RGBA colors found within the image.
             * 
             * @return {Set} Set of all RGBA colors that the image contains.
             */
            getRGBASet() {
              const E = /* @__PURE__ */ new Set(), d = this.bitmap.data;
              for (let l = 0; l < d.length; l += 4)
                E.add(d.readUInt32BE(l, !0));
              return E;
            }
            /**
             * Converts the image to greyscale using inferred Adobe metrics.
             * 
             * @return {BitmapImage} The present image to allow for chaining.
             */
            greyscale() {
              const E = this.bitmap.data;
              return this.scan(0, 0, this.bitmap.width, this.bitmap.height, (d, l, u) => {
                const a = Math.round(
                  0.299 * E[u] + 0.587 * E[u + 1] + 0.114 * E[u + 2]
                );
                E[u] = a, E[u + 1] = a, E[u + 2] = a;
              }), this;
            }
            /**
             * Reframes the image as if placing a frame around the original image and replacing the original image with the newly framed image. When the new frame is strictly within the boundaries of the original image, this method crops the image. When any of the new boundaries exceed those of the original image, the `fillRGBA` must be provided to indicate the color with which to fill the extra space added to the image.
             * 
             * @param {number} xOffset The x-coord offset of the upper-left pixel of the desired image relative to the present image.
             * @param {number} yOffset The y-coord offset of the upper-left pixel of the desired image relative to the present image.
             * @param {number} width The width of the new image after reframing
             * @param {number} height The height of the new image after reframing
             * @param {number} fillRGBA The color with which to fill space added to the image as a result of the reframing, in 0xRRGGBBAA format, where AA is 0x00 to indicate transparent and a non-zero value to indicate opaque. This parameter is only required when the reframing exceeds the original boundaries (i.e. does not simply perform a crop).
             * @return {BitmapImage} The present image to allow for chaining.
             */
            reframe(E, d, l, u, a) {
              const n = E < 0 ? 0 : E, c = d < 0 ? 0 : d, g = l + n > this.bitmap.width ? this.bitmap.width - n : l, f = u + c > this.bitmap.height ? this.bitmap.height - c : u, p = E < 0 ? -E : 0, s = d < 0 ? -d : 0;
              let S;
              if (a === void 0) {
                if (n !== E || c != d || g !== l || f !== u)
                  throw new GifError("fillRGBA required for this reframing");
                S = new x(l, u);
              } else
                S = new x(l, u, a);
              return this.blit(S, p, s, n, c, g, f), this.bitmap = S.bitmap, this;
            }
            /**
             * Scales the image size up by an integer factor. Each pixel of the original image becomes a square of the same color in the new image having a size of `factor` x `factor` pixels.
             * 
             * @param {number} factor The factor by which to scale up the image. Must be an integer >= 1.
             * @return {BitmapImage} The present image to allow for chaining.
             */
            scale(E) {
              if (E === 1)
                return;
              if (!Number.isInteger(E) || E < 1)
                throw new Error("the scale must be an integer >= 1");
              const d = this.bitmap.width, l = this.bitmap.height, u = d * E * 4, a = this.bitmap.data, n = new P(l * u * E);
              let c = 0, g, f = 0;
              for (let p = 0; p < l; ++p) {
                g = f;
                for (let s = 0; s < d; ++s) {
                  const S = a.readUInt32BE(c, !0);
                  for (let b = 0; b < E; ++b)
                    n.writeUInt32BE(S, f), f += 4;
                  c += 4;
                }
                for (let s = 1; s < E; ++s)
                  n.copy(n, f, g, f), f += u, g += u;
              }
              return this.bitmap = {
                width: d * E,
                height: l * E,
                data: n
              }, this;
            }
            /**
             * Scans all coordinates of the image, handing each in turn to the provided handler function.
             *
             * @param {function} scanHandler A function(x: number, y: number, bi: number) to be called for each pixel of the image with that pixel's x-coord, y-coord, and index into the `data` buffer. The function accesses the pixel at this coordinate by accessing the `this.data` at index `bi`.
             * @see scanAllIndexes
             */
            scanAllCoords(E) {
              const d = this.bitmap.width, l = this.bitmap.data.length;
              let u = 0, a = 0;
              for (let n = 0; n < l; n += 4)
                E(u, a, n), ++u === d && (u = 0, ++a);
            }
            /**
             * Scans all pixels of the image, handing the index of each in turn to the provided handler function. Runs a bit faster than `scanAllCoords()`, should the handler not need pixel coordinates.
             *
             * @param {function} scanHandler A function(bi: number) to be called for each pixel of the image with that pixel's index into the `data` buffer. The pixels is found at index 'bi' within `this.data`.
             * @see scanAllCoords
             */
            scanAllIndexes(E) {
              const d = this.bitmap.data.length;
              for (let l = 0; l < d; l += 4)
                E(l);
            }
          }
          Z.exports = x;
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 66: [function(C, Z, _) {
        class P {
          // width - width of GIF in pixels
          // height - height of GIF in pixels
          // loops - 0 = unending; (n > 0) = iterate n times
          // usesTransparency - whether any frames have transparent pixels
          // colorScope - scope of color tables in GIF
          // frames - array of frames
          // buffer - GIF-formatted data
          /**
           * Gif is a class representing an encoded GIF. It is intended to be a read-only representation of a byte-encoded GIF. Only encoders and decoders should be creating instances of this class.
           * 
           * Property | Description
           * --- | ---
           * width | width of the GIF at its widest
           * height | height of the GIF at its highest
           * loops | the number of times the GIF should loop before stopping; 0 => loop indefinately
           * usesTransparency | boolean indicating whether at least one frame contains at least one transparent pixel
           * colorScope | the scope of the color tables as encoded within the GIF; either Gif.GlobalColorsOnly (== 1) or Gif.LocalColorsOnly (== 2).
           * frames | a array of GifFrame instances, one for each frame of the GIF
           * buffer | a Buffer holding the encoding's byte data
           * 
           * Its constructor should only ever be called by the GIF encoder or decoder.
           *
           * @param {Buffer} buffer A Buffer containing the encoded bytes
           * @param {GifFrame[]} frames Array of frames found in the encoding
           * @param {object} spec Properties of the encoding as listed above
           */
          constructor(E, d, l) {
            this.width = l.width, this.height = l.height, this.loops = l.loops, this.usesTransparency = l.usesTransparency, this.colorScope = l.colorScope, this.frames = d, this.buffer = E;
          }
        }
        P.GlobalColorsPreferred = 0, P.GlobalColorsOnly = 1, P.LocalColorsOnly = 2;
        class x extends Error {
          /**
           * GifError is a class representing a GIF-related error
           * 
           * @param {string|Error} messageOrError
           */
          constructor(E) {
            super(E), E instanceof Error && (this.stack = "Gif" + E.stack);
          }
        }
        _.Gif = P, _.GifError = x;
      }, {}], 67: [function(C, Z, _) {
        (function(P, x) {
          const y = C("omggif"), { Gif: E, GifError: d } = C("./gif");
          let l;
          P.nextTick(() => {
            l = C("./gifutil");
          });
          const { GifFrame: u } = C("./gifframe"), a = 200, n = 100;
          class c {
            // _transparentRGBA - RGB given to transparent pixels (alpha=0) on decode; defaults to null indicating 0x000000, which is fastest
            /**
             * GifCodec is a class that both encodes and decodes GIFs. It implements both the `encode()` method expected of an encoder and the `decode()` method expected of a decoder, and it wraps the `omggif` GIF encoder/decoder package. GifCodec serves as this library's default encoder and decoder, but it's possible to wrap other GIF encoders and decoders for use by `gifwrap` as well. GifCodec will not encode GIFs with interlacing.
             * 
             * Instances of this class are stateless and can be shared across multiple encodings and decodings.
             * 
             * Its constructor takes one option argument:
             * 
             * @param {object} options Optionally takes an objection whose only possible property is `transparentRGB`. Images are internally represented in RGBA format, where A is the alpha value of a pixel. When `transparentRGB` is provided, this RGB value (excluding alpha) is assigned to transparent pixels, which are also given alpha value 0x00. (All opaque pixels are given alpha value 0xFF). The RGB color of transparent pixels shouldn't matter for most applications. Defaults to 0x000000.
             */
            constructor(L = {}) {
              this._transparentRGB = null, typeof L.transparentRGB == "number" && L.transparentRGB !== 0 && (this._transparentRGBA = L.transparentRGB * 256), this._testInitialBufferSize = 0;
            }
            /**
             * Decodes a GIF from a Buffer to yield an instance of Gif. Transparent pixels of the GIF are given alpha values of 0x00, and opaque pixels are given alpha values of 0xFF. The RGB values of transparent pixels default to 0x000000 but can be overridden by the constructor's `transparentRGB` option.
             * 
             * @param {Buffer} buffer Bytes of an encoded GIF to decode.
             * @return {Promise} A Promise that resolves to an instance of the Gif class, representing the encoded GIF.
             * @throws {GifError} Error upon encountered an encoding-related problem with a GIF, so that the caller can distinguish between software errors and problems with GIFs.
             */
            decodeGif(L) {
              try {
                let z;
                try {
                  z = new y.GifReader(L);
                } catch (se) {
                  throw new d(se);
                }
                const U = z.numFrames(), J = [], F = {
                  width: z.width,
                  height: z.height,
                  loops: z.loopCount()
                };
                F.usesTransparency = !1;
                for (let se = 0; se < U; ++se) {
                  const ee = this._decodeFrame(z, se, F.usesTransparency);
                  J.push(ee.frame), ee.usesTransparency && (F.usesTransparency = !0);
                }
                return Promise.resolve(new E(L, J, F));
              } catch (z) {
                return Promise.reject(z);
              }
            }
            /**
             * Encodes a GIF from provided frames. Each pixel having an alpha value of 0x00 renders as transparent within the encoding, while all pixels of non-zero alpha value render as opaque.
             * 
             * @param {GifFrame[]} frames Array of frames to encode
             * @param {object} spec An optional object that may provide values for `loops` and `colorScope`, as defined for the Gif class. However, `colorSpace` may also take the value Gif.GlobalColorsPreferred (== 0) to indicate that the encoder should attempt to create only a global color table. `loop` defaults to 0, looping indefinitely, and `colorScope` defaults to Gif.GlobalColorsPreferred.
             * @return {Promise} A Promise that resolves to an instance of the Gif class, representing the encoded GIF.
             * @throws {GifError} Error upon encountered an encoding-related problem with a GIF, so that the caller can distinguish between software errors and problems with GIFs.
             */
            encodeGif(L, z = {}) {
              try {
                if (L === null || L.length === 0)
                  throw new d("there are no frames");
                const U = l.getMaxDimensions(L);
                return z = Object.assign({}, z), z.width = U.maxWidth, z.height = U.maxHeight, z.loops = z.loops || 0, z.colorScope = z.colorScope || E.GlobalColorsPreferred, Promise.resolve(this._encodeGif(L, z));
              } catch (U) {
                return Promise.reject(U);
              }
            }
            _decodeFrame(L, z, U) {
              let J, F;
              try {
                if (J = L.frameInfo(z), F = new x(L.width * L.height * 4), L.decodeAndBlitFrameRGBA(z, F), J.width !== L.width || J.height !== L.height) {
                  if (J.y && (F = F.slice(J.y * L.width * 4)), L.width > J.width)
                    for (let ie = 0; ie < J.height; ++ie)
                      F.copy(
                        F,
                        ie * J.width * 4,
                        (J.x + ie * L.width) * 4,
                        (J.x + ie * L.width) * 4 + J.width * 4
                      );
                  F = F.slice(0, J.width * J.height * 4);
                }
              } catch (ie) {
                throw new d(ie);
              }
              let se = !1;
              if (this._transparentRGBA === null) {
                if (!U)
                  for (let ie = 3; ie < F.length; ie += 4)
                    F[ie] === 0 && (se = !0, ie = F.length);
              } else
                for (let ie = 3; ie < F.length; ie += 4)
                  F[ie] === 0 && (F.writeUInt32BE(this._transparentRGBA, ie - 3), se = !0);
              return { frame: new u(J.width, J.height, F, {
                xOffset: J.x,
                yOffset: J.y,
                disposalMethod: J.disposal,
                interlaced: J.interlaced,
                delayCentisecs: J.delay
              }), usesTransparency: se };
            }
            _encodeGif(L, z) {
              let U;
              if (z.colorScope === E.LocalColorsOnly)
                U = l.getColorInfo(L, 0);
              else if (U = l.getColorInfo(L, 256), !U.colors) {
                if (z.colorScope === E.GlobalColorsOnly)
                  throw new d(
                    "Too many color indexes for global color table"
                  );
                z.colorScope = E.LocalColorsOnly;
              }
              z.usesTransparency = U.usesTransparency;
              const J = U.palettes;
              return z.colorScope === E.LocalColorsOnly ? s(L, z, 2e3, J) : p(L, z, 2e3, U);
            }
            _getSizeEstimateGlobal(L, z) {
              if (this._testInitialBufferSize > 0)
                return this._testInitialBufferSize;
              let U = a + 3 * 256;
              const J = A(L);
              return z.forEach((F) => {
                U += b(F, J);
              }), U;
            }
            _getSizeEstimateLocal(L, z) {
              if (this._testInitialBufferSize > 0)
                return this._testInitialBufferSize;
              let U = a;
              for (let J = 0; J < z.length; ++J) {
                const F = L[J], se = A(F);
                U += b(z[J], se);
              }
              return U;
            }
          }
          _.GifCodec = c;
          function g(R, L) {
            const z = R.indexOf(L);
            return z === -1 ? null : z;
          }
          function f(R, L) {
            for (var z = 0, U = R.length - 1, J; z <= U; )
              if (J = Math.floor((z + U) / 2), R[J] > L)
                U = J - 1;
              else if (R[J] < L)
                z = J + 1;
              else
                return J;
            return null;
          }
          function p(R, L, z, U) {
            const J = {
              colors: U.colors.slice(),
              usesTransparency: U.usesTransparency
            };
            S(J);
            const F = {
              palette: J.colors,
              loop: L.loops
            };
            let se = new x(z), ee;
            try {
              ee = new y.GifWriter(
                se,
                L.width,
                L.height,
                F
              );
            } catch (ie) {
              throw new d(ie);
            }
            for (let ie = 0; ie < R.length; ++ie)
              se = T(ee, ie, R[ie], U, !1);
            return new E(se.slice(0, ee.end()), R, L);
          }
          function s(R, L, z, U) {
            const J = {
              loop: L.loops
            };
            let F = new x(z), se;
            try {
              se = new y.GifWriter(
                F,
                L.width,
                L.height,
                J
              );
            } catch (ee) {
              throw new d(ee);
            }
            for (let ee = 0; ee < R.length; ++ee)
              F = T(se, ee, R[ee], U[ee], !0);
            return new E(F.slice(0, se.end()), R, L);
          }
          function S(R) {
            const L = R.colors;
            R.usesTransparency && L.push(0);
            const z = L.length;
            let U = 2;
            for (; z > U; )
              U <<= 1;
            L.length = U, L.fill(0, z);
          }
          function b(R, L) {
            let z = R.bitmap.width * R.bitmap.height;
            return z = Math.ceil(z * L / 8), z += Math.ceil(z / 255), n + z + 3 * 256;
          }
          function o(R, L, z) {
            const U = z.colors, J = U.length <= 8 ? (
              // guess at the break-even
              g
            ) : f, F = L.bitmap.data, se = new x(F.length / 4);
            let ee = U.length, ie = 0, W = 0;
            for (; ie < F.length; ) {
              if (F[ie + 3] !== 0) {
                const Q = F.readUInt32BE(ie, !0) >> 8 & 16777215;
                se[W] = J(U, Q);
              } else
                se[W] = ee;
              ie += 4, ++W;
            }
            if (z.usesTransparency) {
              if (ee === 256)
                throw new d(`Frame ${R} already has 256 colorsand so can't use transparency`);
            } else
              ee = null;
            return { buffer: se, transparentIndex: ee };
          }
          function A(R) {
            let L = R.indexCount, z = 0;
            for (--L; L; )
              ++z, L >>= 1;
            return z > 0 ? z : 1;
          }
          function T(R, L, z, U, J) {
            if (z.interlaced)
              throw new d("writing interlaced GIFs is not supported");
            const F = o(L, z, U), se = {
              delay: z.delayCentisecs,
              disposal: z.disposalMethod,
              transparent: F.transparentIndex
            };
            J && (S(U), se.palette = U.colors);
            try {
              let ee = R.getOutputBuffer(), ie = R.getOutputBufferPosition(), W, Q = !0;
              for (; Q; )
                if (W = R.addFrame(
                  z.xOffset,
                  z.yOffset,
                  z.bitmap.width,
                  z.bitmap.height,
                  F.buffer,
                  se
                ), Q = !1, W >= ee.length - 1) {
                  const de = new x(ee.length * 1.5);
                  ee.copy(de), R.setOutputBuffer(de), R.setOutputBufferPosition(ie), ee = de, Q = !0;
                }
              return ee;
            } catch (ee) {
              throw new d(ee);
            }
          }
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { "./gif": 66, "./gifframe": 68, "./gifutil": 69, _process: 133, buffer: 48, omggif: 64 }], 68: [function(C, Z, _) {
        const P = C("./bitmapimage"), { GifError: x } = C("./gif");
        class y extends P {
          // xOffset - x offset of bitmap on GIF (defaults to 0)
          // yOffset - y offset of bitmap on GIF (defaults to 0)
          // disposalMethod - pixel disposal method when handling partial images
          // delayCentisecs - duration of frame in hundredths of a second
          // interlaced - whether the image is interlaced (defaults to false)
          /**
           * GifFrame is a class representing an image frame of a GIF. GIFs contain one or more instances of GifFrame.
           * 
           * Property | Description
           * --- | ---
           * xOffset | x-coord of position within GIF at which to render the image (defaults to 0)
           * yOffset | y-coord of position within GIF at which to render the image (defaults to 0)
           * disposalMethod | GIF disposal method; only relevant when the frames aren't all the same size (defaults to 2, disposing to background color)
           * delayCentisecs | duration of the frame in hundreths of a second
           * interlaced | boolean indicating whether the frame renders interlaced
           * 
           * Its constructor supports the following signatures:
           * 
           * * new GifFrame(bitmap: {width: number, height: number, data: Buffer}, options?)
           * * new GifFrame(bitmapImage: BitmapImage, options?)
           * * new GifFrame(width: number, height: number, buffer: Buffer, options?)
           * * new GifFrame(width: number, height: number, backgroundRGBA?: number, options?)
           * * new GifFrame(frame: GifFrame)
           * 
           * See the base class BitmapImage for a discussion of all parameters but `options` and `frame`. `options` is an optional argument providing initial values for the above-listed GifFrame properties. Each property within option is itself optional.
           * 
           * Provide a `frame` to the constructor to create a clone of the provided frame. The new frame includes a copy of the provided frame's pixel data so that each can subsequently be modified without affecting each other.
           */
          constructor(...d) {
            if (super(...d), d[0] instanceof y) {
              const l = d[0];
              this.xOffset = l.xOffset, this.yOffset = l.yOffset, this.disposalMethod = l.disposalMethod, this.delayCentisecs = l.delayCentisecs, this.interlaced = l.interlaced;
            } else {
              const l = d[d.length - 1];
              let u = {};
              typeof l == "object" && !(l instanceof P) && (u = l), this.xOffset = u.xOffset || 0, this.yOffset = u.yOffset || 0, this.disposalMethod = u.disposalMethod !== void 0 ? u.disposalMethod : y.DisposeToBackgroundColor, this.delayCentisecs = u.delayCentisecs || 8, this.interlaced = u.interlaced || !1;
            }
          }
          /**
           * Get a summary of the colors found within the frame. The return value is an object of the following form:
           * 
           * Property | Description
           * --- | ---
           * colors | An array of all the opaque colors found within the frame. Each color is given as an RGB number of the form 0xRRGGBB. The array is sorted by increasing number. Will be an empty array when the image is completely transparent.
           * usesTransparency | boolean indicating whether there are any transparent pixels within the frame. A pixel is considered transparent if its alpha value is 0x00.
           * indexCount | The number of color indexes required to represent this palette of colors. It is equal to the number of opaque colors plus one if the image includes transparency.
           * 
           * @return {object} An object representing a color palette as described above.
           */
          getPalette() {
            const d = /* @__PURE__ */ new Set(), l = this.bitmap.data;
            let u = 0, a = !1;
            for (; u < l.length; ) {
              if (l[u + 3] === 0)
                a = !0;
              else {
                const f = l.readUInt32BE(u, !0) >> 8 & 16777215;
                d.add(f);
              }
              u += 4;
            }
            const n = new Array(d.size), c = d.values();
            for (u = 0; u < n.length; ++u)
              n[u] = c.next().value;
            n.sort((f, p) => f - p);
            let g = n.length;
            return a && ++g, { colors: n, usesTransparency: a, indexCount: g };
          }
        }
        y.DisposeToAnything = 0, y.DisposeNothing = 1, y.DisposeToBackgroundColor = 2, y.DisposeToPrevious = 3, _.GifFrame = y;
      }, { "./bitmapimage": 65, "./gif": 66 }], 69: [function(C, Z, _) {
        (function(P) {
          const x = C("fs"), y = C("image-q"), E = C("./bitmapimage"), { GifFrame: d } = C("./gifframe"), { GifError: l } = C("./gif"), { GifCodec: u } = C("./gifcodec"), a = [".jpg", ".jpeg", ".png", ".bmp"], n = new u();
          _.cloneFrames = function(p) {
            let s = [];
            return p.forEach((S) => {
              s.push(new d(S));
            }), s;
          }, _.getColorInfo = function(p, s) {
            let S = !1;
            const b = [];
            for (let L = 0; L < p.length; ++L) {
              let z = p[L].getPalette();
              if (z.usesTransparency && (S = !0), z.indexCount > 256)
                throw new l(`Frame ${L} uses more than 256 color indexes`);
              b.push(z);
            }
            if (s === 0)
              return { usesTransparency: S, palettes: b };
            const o = /* @__PURE__ */ new Set();
            b.forEach((L) => {
              L.colors.forEach((z) => {
                o.add(z);
              });
            });
            let A = o.size;
            if (S && ++A, s && A > s)
              return { usesTransparency: S, palettes: b };
            const T = new Array(o.size), R = o.values();
            for (let L = 0; L < T.length; ++L)
              T[L] = R.next().value;
            return T.sort((L, z) => L - z), { colors: T, indexCount: A, usesTransparency: S, palettes: b };
          }, _.copyAsJimp = function(p, s) {
            return _.shareAsJimp(p, new E(s));
          }, _.getMaxDimensions = function(p) {
            let s = 0, S = 0;
            return p.forEach((b) => {
              const o = b.xOffset + b.bitmap.width;
              o > s && (s = o);
              const A = b.yOffset + b.bitmap.height;
              A > S && (S = A);
            }), { maxWidth: s, maxHeight: S };
          }, _.quantizeDekker = function(p, s, S) {
            s = s || 256, c(p, "NeuQuantFloat", s, 0, S);
          }, _.quantizeSorokin = function(p, s, S, b) {
            s = s || 256, S = S || "min-pop";
            let o;
            switch (S) {
              case "min-pop":
                o = 2;
                break;
              case "top-pop":
                o = 1;
                break;
              default:
                throw new Error(`Invalid quantizeSorokin histogram '${S}'`);
            }
            c(p, "RGBQuant", s, o, b);
          }, _.quantizeWu = function(p, s, S, b) {
            if (s = s || 256, S = S || 5, S < 1 || S > 8)
              throw new Error("Invalid quantization quality");
            c(p, "WuQuant", s, S, b);
          }, _.read = function(p, s) {
            return s = s || n, P.isBuffer(p) ? s.decodeGif(p) : g(p).then((S) => s.decodeGif(S));
          }, _.shareAsJimp = function(p, s) {
            const S = new p(
              s.bitmap.width,
              s.bitmap.height,
              0
            );
            return S.bitmap.data = s.bitmap.data, S;
          }, _.write = function(p, s, S, b) {
            b = b || n;
            const o = p.match(/\.[a-zA-Z]+$/);
            if (o !== null && a.includes(o[0].toLowerCase()))
              throw new Error(`GIF '${p}' has an unexpected suffix`);
            return b.encodeGif(s, S).then((A) => f(p, A.buffer).then(() => A));
          };
          function c(p, s, S, b, o) {
            const A = Array.isArray(p) ? p : [p], T = [
              "FloydSteinberg",
              "FalseFloydSteinberg",
              "Stucki",
              "Atkinson",
              "Jarvis",
              "Burkes",
              "Sierra",
              "TwoSierra",
              "SierraLite"
            ];
            if (o) {
              if (T.indexOf(o.ditherAlgorithm) < 0)
                throw new Error(`Invalid ditherAlgorithm '${o.ditherAlgorithm}'`);
              o.serpentine === void 0 && (o.serpentine = !0), o.minimumColorDistanceToDither === void 0 && (o.minimumColorDistanceToDither = 0), o.calculateErrorLikeGIMP === void 0 && (o.calculateErrorLikeGIMP = !1);
            }
            const R = new y.distance.Euclidean(), L = new y.palette[s](R, S, b);
            let z;
            o ? z = new y.image.ErrorDiffusionArray(
              R,
              y.image.ErrorDiffusionArrayKernel[o.ditherAlgorithm],
              o.serpentine,
              o.minimumColorDistanceToDither,
              o.calculateErrorLikeGIMP
            ) : z = new y.image.NearestColor(R);
            const U = [];
            A.forEach((F) => {
              const se = F.bitmap.data, ee = new ArrayBuffer(se.length), ie = new Uint32Array(ee);
              for (let Q = 0, de = 0; Q < se.length; Q += 4, ++de)
                ie[de] = se.readUInt32LE(Q, !0);
              const W = y.utils.PointContainer.fromUint32Array(
                ie,
                F.bitmap.width,
                F.bitmap.height
              );
              L.sample(W), U.push(W);
            });
            const J = L.quantize();
            for (let F = 0; F < A.length; ++F) {
              const se = A[F].bitmap.data, ie = z.quantize(U[F], J).toUint32Array();
              for (let W = 0, Q = 0; W < se.length; W += 4, ++Q)
                se.writeUInt32LE(ie[Q], W);
            }
          }
          function g(p) {
            return new Promise((s, S) => {
              x.readFile(p, (b, o) => b ? S(b) : s(o));
            });
          }
          function f(p, s) {
            return new Promise((S, b) => {
              x.writeFile(p, s, (o) => o ? b(o) : S());
            });
          }
        }).call(this, { isBuffer: C("../../is-buffer/index.js") });
      }, { "../../is-buffer/index.js": 76, "./bitmapimage": 65, "./gif": 66, "./gifcodec": 67, "./gifframe": 68, fs: 47, "image-q": 74 }], 70: [function(C, Z, _) {
        const P = C("./bitmapimage"), { Gif: x, GifError: y } = C("./gif"), { GifCodec: E } = C("./gifcodec"), { GifFrame: d } = C("./gifframe"), l = C("./gifutil");
        Z.exports = {
          BitmapImage: P,
          Gif: x,
          GifCodec: E,
          GifFrame: d,
          GifUtil: l,
          GifError: y
        };
      }, { "./bitmapimage": 65, "./gif": 66, "./gifcodec": 67, "./gifframe": 68, "./gifutil": 69 }], 71: [function(C, Z, _) {
        (function(P) {
          var x;
          typeof ne < "u" ? x = ne : typeof P < "u" ? x = P : typeof self < "u" ? x = self : x = {}, Z.exports = x;
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, {}], 72: [function(C, Z, _) {
        var P = C("http"), x = C("url"), y = Z.exports;
        for (var E in P)
          P.hasOwnProperty(E) && (y[E] = P[E]);
        y.request = function(l, u) {
          return l = d(l), P.request.call(this, l, u);
        }, y.get = function(l, u) {
          return l = d(l), P.get.call(this, l, u);
        };
        function d(l) {
          if (typeof l == "string" && (l = x.parse(l)), l.protocol || (l.protocol = "https:"), l.protocol !== "https:")
            throw new Error('Protocol "' + l.protocol + '" not supported. Expected "https:"');
          return l;
        }
      }, { http: 156, url: 180 }], 73: [function(C, Z, _) {
        _.read = function(P, x, y, E, d) {
          var l, u, a = d * 8 - E - 1, n = (1 << a) - 1, c = n >> 1, g = -7, f = y ? d - 1 : 0, p = y ? -1 : 1, s = P[x + f];
          for (f += p, l = s & (1 << -g) - 1, s >>= -g, g += a; g > 0; l = l * 256 + P[x + f], f += p, g -= 8)
            ;
          for (u = l & (1 << -g) - 1, l >>= -g, g += E; g > 0; u = u * 256 + P[x + f], f += p, g -= 8)
            ;
          if (l === 0)
            l = 1 - c;
          else {
            if (l === n)
              return u ? NaN : (s ? -1 : 1) * (1 / 0);
            u = u + Math.pow(2, E), l = l - c;
          }
          return (s ? -1 : 1) * u * Math.pow(2, l - E);
        }, _.write = function(P, x, y, E, d, l) {
          var u, a, n, c = l * 8 - d - 1, g = (1 << c) - 1, f = g >> 1, p = d === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, s = E ? 0 : l - 1, S = E ? 1 : -1, b = x < 0 || x === 0 && 1 / x < 0 ? 1 : 0;
          for (x = Math.abs(x), isNaN(x) || x === 1 / 0 ? (a = isNaN(x) ? 1 : 0, u = g) : (u = Math.floor(Math.log(x) / Math.LN2), x * (n = Math.pow(2, -u)) < 1 && (u--, n *= 2), u + f >= 1 ? x += p / n : x += p * Math.pow(2, 1 - f), x * n >= 2 && (u++, n /= 2), u + f >= g ? (a = 0, u = g) : u + f >= 1 ? (a = (x * n - 1) * Math.pow(2, d), u = u + f) : (a = x * Math.pow(2, f - 1) * Math.pow(2, d), u = 0)); d >= 8; P[y + s] = a & 255, s += S, a /= 256, d -= 8)
            ;
          for (u = u << d | a, c += d; c > 0; P[y + s] = u & 255, s += S, u /= 256, c -= 8)
            ;
          P[y + s - S] |= b * 128;
        };
      }, {}], 74: [function(C, Z, _) {
        (function(x, y) {
          typeof _ == "object" && typeof Z == "object" ? Z.exports = y() : typeof _ == "object" ? _.iq = y() : x.iq = y();
        })(this, function() {
          return (
            /******/
            function(P) {
              var x = {};
              function y(E) {
                if (x[E])
                  return x[E].exports;
                var d = x[E] = {
                  /******/
                  exports: {},
                  /******/
                  id: E,
                  /******/
                  loaded: !1
                  /******/
                };
                return P[E].call(d.exports, d, d.exports, y), d.loaded = !0, d.exports;
              }
              return y.m = P, y.c = x, y.p = "", y(0);
            }([
              /* 0 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * iq.ts - Image Quantization Library
                 */
                var E = y(1);
                x.constants = E;
                var d = y(3);
                x.conversion = d;
                var l = y(12);
                x.distance = l;
                var u = y(20);
                x.palette = u;
                var a = y(30);
                x.image = a;
                var n = y(35);
                x.quality = n;
                var c = y(37);
                x.utils = c;
              },
              /* 1 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * constants.ts - part of Image Quantization Library
                 */
                var E = y(2);
                x.bt709 = E;
              },
              /* 2 */
              /***/
              function(P, x) {
                var y;
                (function(l) {
                  l[l.RED = 0.2126] = "RED", l[l.GREEN = 0.7152] = "GREEN", l[l.BLUE = 0.0722] = "BLUE", l[l.WHITE = 1] = "WHITE";
                })(y || (y = {})), x.Y = y;
                var E;
                (function(l) {
                  l[l.RED = 0.64] = "RED", l[l.GREEN = 0.3] = "GREEN", l[l.BLUE = 0.15] = "BLUE", l[l.WHITE = 0.3127] = "WHITE";
                })(E || (E = {})), x.x = E;
                var d;
                (function(l) {
                  l[l.RED = 0.33] = "RED", l[l.GREEN = 0.6] = "GREEN", l[l.BLUE = 0.06] = "BLUE", l[l.WHITE = 0.329] = "WHITE";
                })(d || (d = {})), x.y = d;
              },
              /* 3 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * iq.ts - Image Quantization Library
                 */
                var E = y(4);
                x.rgb2xyz = E.rgb2xyz;
                var d = y(5);
                x.rgb2hsl = d.rgb2hsl;
                var l = y(7);
                x.rgb2lab = l.rgb2lab;
                var u = y(9);
                x.lab2xyz = u.lab2xyz;
                var a = y(10);
                x.lab2rgb = a.lab2rgb;
                var n = y(8);
                x.xyz2lab = n.xyz2lab;
                var c = y(11);
                x.xyz2rgb = c.xyz2rgb;
              },
              /* 4 */
              /***/
              function(P, x) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * rgb2xyz.ts - part of Image Quantization Library
                 */
                function y(d) {
                  return d > 0.04045 ? Math.pow((d + 0.055) / 1.055, 2.4) : d / 12.92;
                }
                function E(d, l, u) {
                  return d = y(d / 255), l = y(l / 255), u = y(u / 255), {
                    x: d * 0.4124 + l * 0.3576 + u * 0.1805,
                    y: d * 0.2126 + l * 0.7152 + u * 0.0722,
                    z: d * 0.0193 + l * 0.1192 + u * 0.9505
                  };
                }
                x.rgb2xyz = E;
              },
              /* 5 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * rgb2hsl.ts - part of Image Quantization Library
                 */
                var E = y(6);
                function d(l, u, a) {
                  var n = E.min3(l, u, a), c = E.max3(l, u, a), g = c - n, f = (n + c) / 510, p = 0;
                  f > 0 && f < 1 && (p = g / (f < 0.5 ? c + n : 510 - c - n));
                  var s = 0;
                  return g > 0 && (c === l ? s = (u - a) / g : c === u ? s = 2 + (a - l) / g : s = 4 + (l - u) / g, s *= 60, s < 0 && (s += 360)), { h: s, s: p, l: f };
                }
                x.rgb2hsl = d;
              },
              /* 6 */
              /***/
              function(P, x) {
                function y(c) {
                  return c * (Math.PI / 180);
                }
                x.degrees2radians = y;
                function E(c, g, f) {
                  var p = c;
                  return p < g && (p = g), p < f && (p = f), p;
                }
                x.max3 = E;
                function d(c, g, f) {
                  var p = c;
                  return p > g && (p = g), p > f && (p = f), p;
                }
                x.min3 = d;
                function l(c, g, f) {
                  return c > f && (c = f), c < g && (c = g), c | 0;
                }
                x.intInRange = l;
                function u(c) {
                  return c = Math.round(c), c > 255 ? c = 255 : c < 0 && (c = 0), c;
                }
                x.inRange0to255Rounded = u;
                function a(c) {
                  return c > 255 ? c = 255 : c < 0 && (c = 0), c;
                }
                x.inRange0to255 = a;
                function n(c, g) {
                  var f = typeof c[0], p;
                  if (f === "number" || f === "string") {
                    for (var s = /* @__PURE__ */ Object.create(null), S = 0, b = c.length; S < b; S++) {
                      var o = c[S];
                      s[o] || s[o] === 0 || (s[o] = S);
                    }
                    p = c.sort(function(T, R) {
                      return g(T, R) || s[T] - s[R];
                    });
                  } else {
                    var A = c.slice(0);
                    p = c.sort(function(T, R) {
                      return g(T, R) || A.indexOf(T) - A.indexOf(R);
                    });
                  }
                  return p;
                }
                x.stableSort = n;
              },
              /* 7 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * rgb2lab.ts - part of Image Quantization Library
                 */
                var E = y(4), d = y(8);
                function l(u, a, n) {
                  var c = E.rgb2xyz(u, a, n);
                  return d.xyz2lab(c.x, c.y, c.z);
                }
                x.rgb2lab = l;
              },
              /* 8 */
              /***/
              function(P, x) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * xyz2lab.ts - part of Image Quantization Library
                 */
                var y = 0.95047, E = 1, d = 1.08883;
                function l(a) {
                  return a > 8856e-6 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116;
                }
                function u(a, n, c) {
                  if (a = l(a / y), n = l(n / E), c = l(c / d), 116 * n - 16 < 0)
                    throw new Error("xxx");
                  return {
                    L: Math.max(0, 116 * n - 16),
                    a: 500 * (a - n),
                    b: 200 * (n - c)
                  };
                }
                x.xyz2lab = u;
              },
              /* 9 */
              /***/
              function(P, x) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * lab2xyz.ts - part of Image Quantization Library
                 */
                var y = 0.95047, E = 1, d = 1.08883;
                function l(a) {
                  return a > 0.206893034 ? Math.pow(a, 3) : (a - 16 / 116) / 7.787;
                }
                function u(a, n, c) {
                  var g = (a + 16) / 116, f = n / 500 + g, p = g - c / 200;
                  return {
                    x: y * l(f),
                    y: E * l(g),
                    z: d * l(p)
                  };
                }
                x.lab2xyz = u;
              },
              /* 10 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * lab2rgb.ts - part of Image Quantization Library
                 */
                var E = y(9), d = y(11);
                function l(u, a, n) {
                  var c = E.lab2xyz(u, a, n);
                  return d.xyz2rgb(c.x, c.y, c.z);
                }
                x.lab2rgb = l;
              },
              /* 11 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * xyz2rgb.ts - part of Image Quantization Library
                 */
                var E = y(6);
                function d(u) {
                  return u > 31308e-7 ? 1.055 * Math.pow(u, 1 / 2.4) - 0.055 : 12.92 * u;
                }
                function l(u, a, n) {
                  var c = d(u * 3.2406 + a * -1.5372 + n * -0.4986), g = d(u * -0.9689 + a * 1.8758 + n * 0.0415), f = d(u * 0.0557 + a * -0.204 + n * 1.057);
                  return {
                    r: E.inRange0to255Rounded(c * 255),
                    g: E.inRange0to255Rounded(g * 255),
                    b: E.inRange0to255Rounded(f * 255)
                  };
                }
                x.xyz2rgb = l;
              },
              /* 12 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * iq.ts - Image Quantization Library
                 */
                var E = y(13);
                x.AbstractDistanceCalculator = E.AbstractDistanceCalculator;
                var d = y(14);
                x.CIE94Textiles = d.CIE94Textiles, x.CIE94GraphicArts = d.CIE94GraphicArts;
                var l = y(15);
                x.CIEDE2000 = l.CIEDE2000;
                var u = y(16);
                x.CMETRIC = u.CMETRIC;
                var a = y(17);
                x.AbstractEuclidean = a.AbstractEuclidean, x.Euclidean = a.Euclidean, x.EuclideanRgbQuantWOAlpha = a.EuclideanRgbQuantWOAlpha, x.EuclideanRgbQuantWithAlpha = a.EuclideanRgbQuantWithAlpha;
                var n = y(18);
                x.AbstractManhattan = n.AbstractManhattan, x.Manhattan = n.Manhattan, x.ManhattanSRGB = n.ManhattanSRGB, x.ManhattanNommyde = n.ManhattanNommyde;
                var c = y(19);
                x.PNGQUANT = c.PNGQUANT;
              },
              /* 13 */
              /***/
              function(P, x) {
                var y = function() {
                  function E() {
                    this._setDefaults(), this.setWhitePoint(255, 255, 255, 255);
                  }
                  return E.prototype.setWhitePoint = function(d, l, u, a) {
                    this._whitePoint = {
                      r: d > 0 ? 255 / d : 0,
                      g: l > 0 ? 255 / l : 0,
                      b: u > 0 ? 255 / u : 0,
                      a: a > 0 ? 255 / a : 0
                    }, this._maxDistance = this.calculateRaw(d, l, u, a, 0, 0, 0, 0);
                  }, E.prototype.calculateNormalized = function(d, l) {
                    return this.calculateRaw(d.r, d.g, d.b, d.a, l.r, l.g, l.b, l.a) / this._maxDistance;
                  }, E.prototype._setDefaults = function() {
                  }, E;
                }();
                x.AbstractDistanceCalculator = y;
              },
              /* 14 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(g, f) {
                  for (var p in f) f.hasOwnProperty(p) && (g[p] = f[p]);
                  function s() {
                    this.constructor = g;
                  }
                  g.prototype = f === null ? Object.create(f) : (s.prototype = f.prototype, new s());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * cie94.ts - part of Image Quantization Library
                 */
                var d = y(13), l = y(7), u = y(6), a = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype.calculateRaw = function(p, s, S, b, o, A, T, R) {
                    var L = l.rgb2lab(u.inRange0to255(p * this._whitePoint.r), u.inRange0to255(s * this._whitePoint.g), u.inRange0to255(S * this._whitePoint.b)), z = l.rgb2lab(u.inRange0to255(o * this._whitePoint.r), u.inRange0to255(A * this._whitePoint.g), u.inRange0to255(T * this._whitePoint.b)), U = L.L - z.L, J = L.a - z.a, F = L.b - z.b, se = Math.sqrt(L.a * L.a + L.b * L.b), ee = Math.sqrt(z.a * z.a + z.b * z.b), ie = se - ee, W = J * J + F * F - ie * ie;
                    W = W < 0 ? 0 : Math.sqrt(W);
                    var Q = (R - b) * this._whitePoint.a * this._kA;
                    return Math.sqrt(Math.pow(U / this._Kl, 2) + Math.pow(ie / (1 + this._K1 * se), 2) + Math.pow(W / (1 + this._K2 * se), 2) + Math.pow(Q, 2));
                  }, f;
                }(d.AbstractDistanceCalculator);
                x.AbstractCIE94 = a;
                var n = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._Kl = 2, this._K1 = 0.048, this._K2 = 0.014, this._kA = 0.25 * 50 / 255;
                  }, f;
                }(a);
                x.CIE94Textiles = n;
                var c = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._Kl = 1, this._K1 = 0.045, this._K2 = 0.015, this._kA = 0.25 * 100 / 255;
                  }, f;
                }(a);
                x.CIE94GraphicArts = c;
              },
              /* 15 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(n, c) {
                  for (var g in c) c.hasOwnProperty(g) && (n[g] = c[g]);
                  function f() {
                    this.constructor = n;
                  }
                  n.prototype = c === null ? Object.create(c) : (f.prototype = c.prototype, new f());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * ciede2000.ts - part of Image Quantization Library
                 */
                var d = y(13), l = y(7), u = y(6), a = function(n) {
                  E(c, n);
                  function c() {
                    n.apply(this, arguments);
                  }
                  return c.prototype.calculateRaw = function(g, f, p, s, S, b, o, A) {
                    var T = l.rgb2lab(u.inRange0to255(g * this._whitePoint.r), u.inRange0to255(f * this._whitePoint.g), u.inRange0to255(p * this._whitePoint.b)), R = l.rgb2lab(u.inRange0to255(S * this._whitePoint.r), u.inRange0to255(b * this._whitePoint.g), u.inRange0to255(o * this._whitePoint.b)), L = (A - s) * this._whitePoint.a * c._kA, z = this.calculateRawInLab(T, R);
                    return Math.sqrt(z + L * L);
                  }, c.prototype.calculateRawInLab = function(g, f) {
                    var p = g.L, s = g.a, S = g.b, b = f.L, o = f.a, A = f.b, T = Math.sqrt(s * s + S * S), R = Math.sqrt(o * o + A * A), L = Math.pow((T + R) / 2, 7), z = 0.5 * (1 - Math.sqrt(L / (L + c._pow25to7))), U = (1 + z) * s, J = (1 + z) * o, F = Math.sqrt(U * U + S * S), se = Math.sqrt(J * J + A * A), ee = F * se, ie = c._calculatehp(S, U), W = c._calculatehp(A, J), Q = Math.abs(ie - W), de = b - p, _e = se - F, ke = c._calculate_dHp(ee, Q, W, ie), Pe = c._calculate_ahp(ee, Q, ie, W), fe = c._calculateT(Pe), xe = (F + se) / 2, Ee = Math.pow((p + b) / 2 - 50, 2), Ie = 1 + 0.015 * Ee / Math.sqrt(20 + Ee), je = 1 + 0.045 * xe, Ue = 1 + 0.015 * fe * xe, He = c._calculateRT(Pe, xe), Ze = de / Ie, $e = _e / je, We = ke / Ue;
                    return Math.pow(Ze, 2) + Math.pow($e, 2) + Math.pow(We, 2) + He * $e * We;
                  }, c._calculatehp = function(g, f) {
                    var p = Math.atan2(g, f);
                    return p >= 0 ? p : p + c._deg360InRad;
                  }, c._calculateRT = function(g, f) {
                    var p = Math.pow(f, 7), s = 2 * Math.sqrt(p / (p + c._pow25to7)), S = c._deg30InRad * Math.exp(-Math.pow((g - c._deg275InRad) / c._deg25InRad, 2));
                    return -Math.sin(2 * S) * s;
                  }, c._calculateT = function(g) {
                    return 1 - 0.17 * Math.cos(g - c._deg30InRad) + 0.24 * Math.cos(g * 2) + 0.32 * Math.cos(g * 3 + c._deg6InRad) - 0.2 * Math.cos(g * 4 - c._deg63InRad);
                  }, c._calculate_ahp = function(g, f, p, s) {
                    var S = p + s;
                    return g == 0 ? S : f <= c._deg180InRad ? S / 2 : S < c._deg360InRad ? (S + c._deg360InRad) / 2 : (S - c._deg360InRad) / 2;
                  }, c._calculate_dHp = function(g, f, p, s) {
                    var S;
                    return g == 0 ? S = 0 : f <= c._deg180InRad ? S = p - s : p <= s ? S = p - s + c._deg360InRad : S = p - s - c._deg360InRad, 2 * Math.sqrt(g) * Math.sin(S / 2);
                  }, c._kA = 0.25 * 100 / 255, c._pow25to7 = Math.pow(25, 7), c._deg360InRad = u.degrees2radians(360), c._deg180InRad = u.degrees2radians(180), c._deg30InRad = u.degrees2radians(30), c._deg6InRad = u.degrees2radians(6), c._deg63InRad = u.degrees2radians(63), c._deg275InRad = u.degrees2radians(275), c._deg25InRad = u.degrees2radians(25), c;
                }(d.AbstractDistanceCalculator);
                x.CIEDE2000 = a;
              },
              /* 16 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(u, a) {
                  for (var n in a) a.hasOwnProperty(n) && (u[n] = a[n]);
                  function c() {
                    this.constructor = u;
                  }
                  u.prototype = a === null ? Object.create(a) : (c.prototype = a.prototype, new c());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * cmetric.ts - part of Image Quantization Library
                 */
                var d = y(13), l = function(u) {
                  E(a, u);
                  function a() {
                    u.apply(this, arguments);
                  }
                  return a.prototype.calculateRaw = function(n, c, g, f, p, s, S, b) {
                    var o = (n + p) / 2 * this._whitePoint.r, A = (n - p) * this._whitePoint.r, T = (c - s) * this._whitePoint.g, R = (g - S) * this._whitePoint.b, L = ((512 + o) * A * A >> 8) + 4 * T * T + ((767 - o) * R * R >> 8), z = (b - f) * this._whitePoint.a;
                    return Math.sqrt(L + z * z);
                  }, a;
                }(d.AbstractDistanceCalculator);
                x.CMETRIC = l;
              },
              /* 17 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(g, f) {
                  for (var p in f) f.hasOwnProperty(p) && (g[p] = f[p]);
                  function s() {
                    this.constructor = g;
                  }
                  g.prototype = f === null ? Object.create(f) : (s.prototype = f.prototype, new s());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * euclidean.ts - part of Image Quantization Library
                 */
                var d = y(13), l = y(2), u = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype.calculateRaw = function(p, s, S, b, o, A, T, R) {
                    var L = o - p, z = A - s, U = T - S, J = R - b;
                    return Math.sqrt(this._kR * L * L + this._kG * z * z + this._kB * U * U + this._kA * J * J);
                  }, f;
                }(d.AbstractDistanceCalculator);
                x.AbstractEuclidean = u;
                var a = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
                  }, f;
                }(u);
                x.Euclidean = a;
                var n = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = l.Y.RED, this._kG = l.Y.GREEN, this._kB = l.Y.BLUE, this._kA = 1;
                  }, f;
                }(u);
                x.EuclideanRgbQuantWithAlpha = n;
                var c = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = l.Y.RED, this._kG = l.Y.GREEN, this._kB = l.Y.BLUE, this._kA = 0;
                  }, f;
                }(u);
                x.EuclideanRgbQuantWOAlpha = c;
              },
              /* 18 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(g, f) {
                  for (var p in f) f.hasOwnProperty(p) && (g[p] = f[p]);
                  function s() {
                    this.constructor = g;
                  }
                  g.prototype = f === null ? Object.create(f) : (s.prototype = f.prototype, new s());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * manhattanNeuQuant.ts - part of Image Quantization Library
                 */
                var d = y(13), l = y(2), u = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype.calculateRaw = function(p, s, S, b, o, A, T, R) {
                    var L = o - p, z = A - s, U = T - S, J = R - b;
                    return L < 0 && (L = 0 - L), z < 0 && (z = 0 - z), U < 0 && (U = 0 - U), J < 0 && (J = 0 - J), this._kR * L + this._kG * z + this._kB * U + this._kA * J;
                  }, f;
                }(d.AbstractDistanceCalculator);
                x.AbstractManhattan = u;
                var a = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = 1, this._kG = 1, this._kB = 1, this._kA = 1;
                  }, f;
                }(u);
                x.Manhattan = a;
                var n = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = 0.4984, this._kG = 0.8625, this._kB = 0.2979, this._kA = 1;
                  }, f;
                }(u);
                x.ManhattanNommyde = n;
                var c = function(g) {
                  E(f, g);
                  function f() {
                    g.apply(this, arguments);
                  }
                  return f.prototype._setDefaults = function() {
                    this._kR = l.Y.RED, this._kG = l.Y.GREEN, this._kB = l.Y.BLUE, this._kA = 1;
                  }, f;
                }(u);
                x.ManhattanSRGB = c;
              },
              /* 19 */
              /***/
              function(P, x, y) {
                var E = this && this.__extends || function(u, a) {
                  for (var n in a) a.hasOwnProperty(n) && (u[n] = a[n]);
                  function c() {
                    this.constructor = u;
                  }
                  u.prototype = a === null ? Object.create(a) : (c.prototype = a.prototype, new c());
                };
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * pngQuant.ts - part of Image Quantization Library
                 */
                var d = y(13), l = function(u) {
                  E(a, u);
                  function a() {
                    u.apply(this, arguments);
                  }
                  return a.prototype.calculateRaw = function(n, c, g, f, p, s, S, b) {
                    var o = (b - f) * this._whitePoint.a;
                    return this._colordifference_ch(n * this._whitePoint.r, p * this._whitePoint.r, o) + this._colordifference_ch(c * this._whitePoint.g, s * this._whitePoint.g, o) + this._colordifference_ch(g * this._whitePoint.b, S * this._whitePoint.b, o);
                  }, a.prototype._colordifference_ch = function(n, c, g) {
                    var f = n - c, p = f + g;
                    return f * f + p * p;
                  }, a;
                }(d.AbstractDistanceCalculator);
                x.PNGQUANT = l;
              },
              /* 20 */
              /***/
              function(P, x, y) {
                var E = y(21);
                x.NeuQuant = E.NeuQuant;
                var d = y(25);
                x.NeuQuantFloat = d.NeuQuantFloat;
                var l = y(26);
                x.RGBQuant = l.RGBQuant;
                var u = y(27);
                x.ColorHistogram = u.ColorHistogram;
                var a = y(29);
                x.WuQuant = a.WuQuant, x.WuColorCube = a.WuColorCube;
              },
              /* 21 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve TypeScript port:
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * neuquant.ts - part of Image Quantization Library
                 */
                var E = y(22), d = y(24), l = 3, u = function() {
                  function n(c) {
                    this.r = this.g = this.b = this.a = c;
                  }
                  return n.prototype.toPoint = function() {
                    return d.Point.createByRGBA(this.r >> l, this.g >> l, this.b >> l, this.a >> l);
                  }, n.prototype.subtract = function(c, g, f, p) {
                    this.r -= c | 0, this.g -= g | 0, this.b -= f | 0, this.a -= p | 0;
                  }, n;
                }(), a = function() {
                  function n(c, g) {
                    g === void 0 && (g = 256), this._distance = c, this._pointArray = [], this._sampleFactor = 1, this._networkSize = g, this._distance.setWhitePoint(255 << l, 255 << l, 255 << l, 255 << l);
                  }
                  return n.prototype.sample = function(c) {
                    this._pointArray = this._pointArray.concat(c.getPointArray());
                  }, n.prototype.quantize = function() {
                    return this._init(), this._learn(), this._buildPalette();
                  }, n.prototype._init = function() {
                    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
                    for (var c = 0; c < this._networkSize; c++)
                      this._network[c] = new u((c << l + 8) / this._networkSize | 0), this._freq[c] = n._initialBias / this._networkSize | 0, this._bias[c] = 0;
                  }, n.prototype._learn = function() {
                    var c = this._sampleFactor, g = this._pointArray.length;
                    g < n._minpicturebytes && (c = 1);
                    var f = 30 + (c - 1) / 3 | 0, p = g / c | 0, s = p / n._nCycles | 0, S = n._initAlpha, b = (this._networkSize >> 3) * n._radiusBias, o = b >> n._radiusBiasShift;
                    o <= 1 && (o = 0);
                    for (var A = 0; A < o; A++)
                      this._radPower[A] = S * ((o * o - A * A) * n._radBias / (o * o)) >>> 0;
                    var T;
                    g < n._minpicturebytes ? T = 1 : g % n._prime1 != 0 ? T = n._prime1 : g % n._prime2 != 0 ? T = n._prime2 : g % n._prime3 != 0 ? T = n._prime3 : T = n._prime4;
                    for (var A = 0, R = 0; A < p; ) {
                      var L = this._pointArray[R], z = L.b << l, U = L.g << l, J = L.r << l, F = L.a << l, se = this._contest(z, U, J, F);
                      if (this._alterSingle(S, se, z, U, J, F), o !== 0 && this._alterNeighbour(o, se, z, U, J, F), R += T, R >= g && (R -= g), A++, s === 0 && (s = 1), A % s === 0) {
                        S -= S / f | 0, b -= b / n._radiusDecrease | 0, o = b >> n._radiusBiasShift, o <= 1 && (o = 0);
                        for (var ee = 0; ee < o; ee++)
                          this._radPower[ee] = S * ((o * o - ee * ee) * n._radBias / (o * o)) >>> 0;
                      }
                    }
                  }, n.prototype._buildPalette = function() {
                    var c = new E.Palette();
                    return this._network.forEach(function(g) {
                      c.add(g.toPoint());
                    }), c.sort(), c;
                  }, n.prototype._alterNeighbour = function(c, g, f, p, s, S) {
                    var b = g - c;
                    b < -1 && (b = -1);
                    var o = g + c;
                    o > this._networkSize && (o = this._networkSize);
                    for (var A = g + 1, T = g - 1, R = 1; A < o || T > b; ) {
                      var L = this._radPower[R++] / n._alphaRadBias;
                      if (A < o) {
                        var z = this._network[A++];
                        z.subtract(L * (z.r - s), L * (z.g - p), L * (z.b - f), L * (z.a - S));
                      }
                      if (T > b) {
                        var z = this._network[T--];
                        z.subtract(L * (z.r - s), L * (z.g - p), L * (z.b - f), L * (z.a - S));
                      }
                    }
                  }, n.prototype._alterSingle = function(c, g, f, p, s, S) {
                    c /= n._initAlpha;
                    var b = this._network[g];
                    b.subtract(c * (b.r - s), c * (b.g - p), c * (b.b - f), c * (b.a - S));
                  }, n.prototype._contest = function(c, g, f, p) {
                    for (var s = 1020 << l, S = 2147483647, b = S, o = -1, A = o, T = 0; T < this._networkSize; T++) {
                      var R = this._network[T], L = this._distance.calculateNormalized(R, { r: f, g, b: c, a: p }) * s | 0;
                      L < S && (S = L, o = T);
                      var z = L - (this._bias[T] >> n._initialBiasShift - l);
                      z < b && (b = z, A = T);
                      var U = this._freq[T] >> n._betaShift;
                      this._freq[T] -= U, this._bias[T] += U << n._gammaShift;
                    }
                    return this._freq[o] += n._beta, this._bias[o] -= n._betaGamma, A;
                  }, n._prime1 = 499, n._prime2 = 491, n._prime3 = 487, n._prime4 = 503, n._minpicturebytes = n._prime4, n._nCycles = 100, n._initialBiasShift = 16, n._initialBias = 1 << n._initialBiasShift, n._gammaShift = 10, n._betaShift = 10, n._beta = n._initialBias >> n._betaShift, n._betaGamma = n._initialBias << n._gammaShift - n._betaShift, n._radiusBiasShift = 6, n._radiusBias = 1 << n._radiusBiasShift, n._radiusDecrease = 30, n._alphaBiasShift = 10, n._initAlpha = 1 << n._alphaBiasShift, n._radBiasShift = 8, n._radBias = 1 << n._radBiasShift, n._alphaRadBiasShift = n._alphaBiasShift + n._radBiasShift, n._alphaRadBias = 1 << n._alphaRadBiasShift, n;
                }();
                x.NeuQuant = a;
              },
              /* 22 */
              /***/
              function(P, x, y) {
                var E = y(23), d = y(5), l = 10;
                function u(n, c) {
                  for (var g = 360, f = g / c, p = f / 2, s = 1, S = f - p; s < c; s++, S += f)
                    if (n >= S && n < S + f)
                      return s;
                  return 0;
                }
                x.hueGroup = u;
                var a = function() {
                  function n() {
                    this._pointArray = [], this._i32idx = {}, this._pointContainer = new E.PointContainer(), this._pointContainer.setHeight(1), this._pointArray = this._pointContainer.getPointArray();
                  }
                  return n.prototype.add = function(c) {
                    this._pointArray.push(c), this._pointContainer.setWidth(this._pointArray.length);
                  }, n.prototype.has = function(c) {
                    for (var g = this._pointArray.length - 1; g >= 0; g--)
                      if (c.uint32 === this._pointArray[g].uint32)
                        return !0;
                    return !1;
                  }, n.prototype.getNearestColor = function(c, g) {
                    return this._pointArray[this.getNearestIndex(c, g) | 0];
                  }, n.prototype.getPointContainer = function() {
                    return this._pointContainer;
                  }, n.prototype._nearestPointFromCache = function(c) {
                    return typeof this._i32idx[c] == "number" ? this._i32idx[c] : -1;
                  }, n.prototype.getNearestIndex = function(c, g) {
                    var f = this._nearestPointFromCache("" + g.uint32);
                    if (f >= 0)
                      return f;
                    var p = Number.MAX_VALUE;
                    f = 0;
                    for (var s = 0, S = this._pointArray.length; s < S; s++) {
                      var b = this._pointArray[s], o = c.calculateRaw(g.r, g.g, g.b, g.a, b.r, b.g, b.b, b.a);
                      o < p && (p = o, f = s);
                    }
                    return this._i32idx[g.uint32] = f, f;
                  }, n.prototype.sort = function() {
                    this._i32idx = {}, this._pointArray.sort(function(c, g) {
                      var f = d.rgb2hsl(c.r, c.g, c.b), p = d.rgb2hsl(g.r, g.g, g.b), s = c.r === c.g && c.g === c.b ? 0 : 1 + u(f.h, l), S = g.r === g.g && g.g === g.b ? 0 : 1 + u(p.h, l), b = S - s;
                      if (b)
                        return -b;
                      var o = c.getLuminosity(!0), A = g.getLuminosity(!0);
                      if (A - o !== 0)
                        return A - o;
                      var T = (p.s * 100 | 0) - (f.s * 100 | 0);
                      return T ? -T : 0;
                    });
                  }, n;
                }();
                x.Palette = a;
              },
              /* 23 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * pointContainer.ts - part of Image Quantization Library
                 */
                var E = y(24), d = function() {
                  function l() {
                    this._width = 0, this._height = 0, this._pointArray = [];
                  }
                  return l.prototype.getWidth = function() {
                    return this._width;
                  }, l.prototype.getHeight = function() {
                    return this._height;
                  }, l.prototype.setWidth = function(u) {
                    this._width = u;
                  }, l.prototype.setHeight = function(u) {
                    this._height = u;
                  }, l.prototype.getPointArray = function() {
                    return this._pointArray;
                  }, l.prototype.clone = function() {
                    var u = new l();
                    u._width = this._width, u._height = this._height;
                    for (var a = 0, n = this._pointArray.length; a < n; a++)
                      u._pointArray[a] = E.Point.createByUint32(this._pointArray[a].uint32 | 0);
                    return u;
                  }, l.prototype.toUint32Array = function() {
                    for (var u = this._pointArray.length, a = new Uint32Array(u), n = 0; n < u; n++)
                      a[n] = this._pointArray[n].uint32;
                    return a;
                  }, l.prototype.toUint8Array = function() {
                    return new Uint8Array(this.toUint32Array().buffer);
                  }, l.fromHTMLImageElement = function(u) {
                    var a = u.naturalWidth, n = u.naturalHeight, c = document.createElement("canvas");
                    c.width = a, c.height = n;
                    var g = c.getContext("2d");
                    return g.drawImage(u, 0, 0, a, n, 0, 0, a, n), l.fromHTMLCanvasElement(c);
                  }, l.fromHTMLCanvasElement = function(u) {
                    var a = u.width, n = u.height, c = u.getContext("2d"), g = c.getImageData(0, 0, a, n);
                    return l.fromImageData(g);
                  }, l.fromNodeCanvas = function(u) {
                    return l.fromHTMLCanvasElement(u);
                  }, l.fromImageData = function(u) {
                    var a = u.width, n = u.height;
                    return l.fromCanvasPixelArray(u.data, a, n);
                  }, l.fromArray = function(u, a, n) {
                    var c = new Uint8Array(u);
                    return l.fromUint8Array(c, a, n);
                  }, l.fromCanvasPixelArray = function(u, a, n) {
                    return l.fromArray(u, a, n);
                  }, l.fromUint8Array = function(u, a, n) {
                    return l.fromUint32Array(new Uint32Array(u.buffer), a, n);
                  }, l.fromUint32Array = function(u, a, n) {
                    var c = new l();
                    c._width = a, c._height = n;
                    for (var g = 0, f = u.length; g < f; g++)
                      c._pointArray[g] = E.Point.createByUint32(u[g] | 0);
                    return c;
                  }, l;
                }();
                x.PointContainer = d;
              },
              /* 24 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * point.ts - part of Image Quantization Library
                 */
                var E = y(2), d = function() {
                  function l() {
                    this.uint32 = -1 >>> 0, this.r = this.g = this.b = this.a = 0, this.rgba = new Array(4), this.rgba[0] = 0, this.rgba[1] = 0, this.rgba[2] = 0, this.rgba[3] = 0;
                  }
                  return l.createByQuadruplet = function(u) {
                    var a = new l();
                    return a.r = u[0] | 0, a.g = u[1] | 0, a.b = u[2] | 0, a.a = u[3] | 0, a._loadUINT32(), a._loadQuadruplet(), a;
                  }, l.createByRGBA = function(u, a, n, c) {
                    var g = new l();
                    return g.r = u | 0, g.g = a | 0, g.b = n | 0, g.a = c | 0, g._loadUINT32(), g._loadQuadruplet(), g;
                  }, l.createByUint32 = function(u) {
                    var a = new l();
                    return a.uint32 = u >>> 0, a._loadRGBA(), a._loadQuadruplet(), a;
                  }, l.prototype.from = function(u) {
                    this.r = u.r, this.g = u.g, this.b = u.b, this.a = u.a, this.uint32 = u.uint32, this.rgba[0] = u.r, this.rgba[1] = u.g, this.rgba[2] = u.b, this.rgba[3] = u.a;
                  }, l.prototype.getLuminosity = function(u) {
                    var a = this.r, n = this.g, c = this.b;
                    return u && (a = Math.min(255, 255 - this.a + this.a * a / 255), n = Math.min(255, 255 - this.a + this.a * n / 255), c = Math.min(255, 255 - this.a + this.a * c / 255)), a * E.Y.RED + n * E.Y.GREEN + c * E.Y.BLUE;
                  }, l.prototype._loadUINT32 = function() {
                    this.uint32 = (this.a << 24 | this.b << 16 | this.g << 8 | this.r) >>> 0;
                  }, l.prototype._loadRGBA = function() {
                    this.r = this.uint32 & 255, this.g = this.uint32 >>> 8 & 255, this.b = this.uint32 >>> 16 & 255, this.a = this.uint32 >>> 24 & 255;
                  }, l.prototype._loadQuadruplet = function() {
                    this.rgba[0] = this.r, this.rgba[1] = this.g, this.rgba[2] = this.b, this.rgba[3] = this.a;
                  }, l;
                }();
                x.Point = d;
              },
              /* 25 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve TypeScript port:
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * neuquant.ts - part of Image Quantization Library
                 */
                var E = y(22), d = y(24), l = 3, u = function() {
                  function n(c) {
                    this.r = this.g = this.b = this.a = c;
                  }
                  return n.prototype.toPoint = function() {
                    return d.Point.createByRGBA(this.r >> l, this.g >> l, this.b >> l, this.a >> l);
                  }, n.prototype.subtract = function(c, g, f, p) {
                    this.r -= c, this.g -= g, this.b -= f, this.a -= p;
                  }, n;
                }(), a = function() {
                  function n(c, g) {
                    g === void 0 && (g = 256), this._distance = c, this._pointArray = [], this._sampleFactor = 1, this._networkSize = g, this._distance.setWhitePoint(255 << l, 255 << l, 255 << l, 255 << l);
                  }
                  return n.prototype.sample = function(c) {
                    this._pointArray = this._pointArray.concat(c.getPointArray());
                  }, n.prototype.quantize = function() {
                    return this._init(), this._learn(), this._buildPalette();
                  }, n.prototype._init = function() {
                    this._freq = [], this._bias = [], this._radPower = [], this._network = [];
                    for (var c = 0; c < this._networkSize; c++)
                      this._network[c] = new u((c << l + 8) / this._networkSize), this._freq[c] = n._initialBias / this._networkSize, this._bias[c] = 0;
                  }, n.prototype._learn = function() {
                    var c = this._sampleFactor, g = this._pointArray.length;
                    g < n._minpicturebytes && (c = 1);
                    var f = 30 + (c - 1) / 3, p = g / c, s = p / n._nCycles | 0, S = n._initAlpha, b = (this._networkSize >> 3) * n._radiusBias, o = b >> n._radiusBiasShift;
                    o <= 1 && (o = 0);
                    for (var A = 0; A < o; A++)
                      this._radPower[A] = S * ((o * o - A * A) * n._radBias / (o * o));
                    var T;
                    g < n._minpicturebytes ? T = 1 : g % n._prime1 != 0 ? T = n._prime1 : g % n._prime2 != 0 ? T = n._prime2 : g % n._prime3 != 0 ? T = n._prime3 : T = n._prime4;
                    for (var A = 0, R = 0; A < p; ) {
                      var L = this._pointArray[R], z = L.b << l, U = L.g << l, J = L.r << l, F = L.a << l, se = this._contest(z, U, J, F);
                      if (this._alterSingle(S, se, z, U, J, F), o != 0 && this._alterNeighbour(o, se, z, U, J, F), R += T, R >= g && (R -= g), A++, s == 0 && (s = 1), A % s == 0) {
                        S -= S / f, b -= b / n._radiusDecrease, o = b >> n._radiusBiasShift, o <= 1 && (o = 0);
                        for (var ee = 0; ee < o; ee++)
                          this._radPower[ee] = S * ((o * o - ee * ee) * n._radBias / (o * o));
                      }
                    }
                  }, n.prototype._buildPalette = function() {
                    var c = new E.Palette();
                    return this._network.forEach(function(g) {
                      c.add(g.toPoint());
                    }), c.sort(), c;
                  }, n.prototype._alterNeighbour = function(c, g, f, p, s, S) {
                    var b = g - c;
                    b < -1 && (b = -1);
                    var o = g + c;
                    o > this._networkSize && (o = this._networkSize);
                    for (var A = g + 1, T = g - 1, R = 1; A < o || T > b; ) {
                      var L = this._radPower[R++] / n._alphaRadBias;
                      if (A < o) {
                        var z = this._network[A++];
                        z.subtract(L * (z.r - s), L * (z.g - p), L * (z.b - f), L * (z.a - S));
                      }
                      if (T > b) {
                        var z = this._network[T--];
                        z.subtract(L * (z.r - s), L * (z.g - p), L * (z.b - f), L * (z.a - S));
                      }
                    }
                  }, n.prototype._alterSingle = function(c, g, f, p, s, S) {
                    c /= n._initAlpha;
                    var b = this._network[g];
                    b.subtract(c * (b.r - s), c * (b.g - p), c * (b.b - f), c * (b.a - S));
                  }, n.prototype._contest = function(c, g, f, p) {
                    for (var s = 1020 << l, S = 2147483647, b = S, o = -1, A = o, T = 0; T < this._networkSize; T++) {
                      var R = this._network[T], L = this._distance.calculateNormalized(R, { r: f, g, b: c, a: p }) * s;
                      L < S && (S = L, o = T);
                      var z = L - (this._bias[T] >> n._initialBiasShift - l);
                      z < b && (b = z, A = T);
                      var U = this._freq[T] >> n._betaShift;
                      this._freq[T] -= U, this._bias[T] += U << n._gammaShift;
                    }
                    return this._freq[o] += n._beta, this._bias[o] -= n._betaGamma, A;
                  }, n._prime1 = 499, n._prime2 = 491, n._prime3 = 487, n._prime4 = 503, n._minpicturebytes = n._prime4, n._nCycles = 100, n._initialBiasShift = 16, n._initialBias = 1 << n._initialBiasShift, n._gammaShift = 10, n._betaShift = 10, n._beta = n._initialBias >> n._betaShift, n._betaGamma = n._initialBias << n._gammaShift - n._betaShift, n._radiusBiasShift = 6, n._radiusBias = 1 << n._radiusBiasShift, n._radiusDecrease = 30, n._alphaBiasShift = 10, n._initAlpha = 1 << n._alphaBiasShift, n._radBiasShift = 8, n._radBias = 1 << n._radBiasShift, n._alphaRadBiasShift = n._alphaBiasShift + n._radBiasShift, n._alphaRadBias = 1 << n._alphaRadBiasShift, n;
                }();
                x.NeuQuantFloat = a;
              },
              /* 26 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve TypeScript port:
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * rgbquant.ts - part of Image Quantization Library
                 */
                var E = y(22), d = y(24), l = y(27), u = y(6), a = /* @__PURE__ */ function() {
                  function c(g, f, p) {
                    this.index = g, this.color = f, this.distance = p;
                  }
                  return c;
                }(), n = function() {
                  function c(g, f, p) {
                    f === void 0 && (f = 256), p === void 0 && (p = 2), this._distance = g, this._colors = f, this._histogram = new l.ColorHistogram(p, f), this._initialDistance = 0.01, this._distanceIncrement = 5e-3;
                  }
                  return c.prototype.sample = function(g) {
                    this._histogram.sample(g);
                  }, c.prototype.quantize = function() {
                    var g = this._histogram.getImportanceSortedColorsIDXI32();
                    if (g.length === 0)
                      throw new Error("No colors in image");
                    var f = this._buildPalette(g);
                    return f.sort(), f;
                  }, c.prototype._buildPalette = function(g) {
                    for (var f = new E.Palette(), p = f.getPointContainer().getPointArray(), s = new Array(g.length), S = 0; S < g.length; S++)
                      p.push(d.Point.createByUint32(g[S])), s[S] = 1;
                    for (var b = p.length, o = [], A = b, T = this._initialDistance; A > this._colors; ) {
                      o.length = 0;
                      for (var S = 0; S < b; S++)
                        if (s[S] !== 0) {
                          for (var R = p[S], L = S + 1; L < b; L++)
                            if (s[L] !== 0) {
                              var z = p[L], U = this._distance.calculateNormalized(R, z);
                              U < T && (o.push(new a(L, z, U)), s[L] = 0, A--);
                            }
                        }
                      T += A > this._colors * 3 ? this._initialDistance : this._distanceIncrement;
                    }
                    if (A < this._colors) {
                      u.stableSort(o, function(ie, W) {
                        return W.distance - ie.distance;
                      });
                      for (var J = 0; A < this._colors && J < o.length; ) {
                        var F = o[J];
                        s[F.index] = 1, A++, J++;
                      }
                    }
                    for (var se = p.length, ee = se - 1; ee >= 0; ee--)
                      s[ee] === 0 && (ee !== se - 1 && (p[ee] = p[se - 1]), --se);
                    return p.length = se, f;
                  }, c;
                }();
                x.RGBQuant = n;
              },
              /* 27 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve TypeScript port:
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * colorHistogram.ts - part of Image Quantization Library
                 */
                var E = y(28), d = y(6), l = function() {
                  function u(a, n) {
                    this._method = a, this._minHueCols = n << 2, this._initColors = n << 2, this._hueStats = new E.HueStatistics(u._hueGroups, this._minHueCols), this._histogram = /* @__PURE__ */ Object.create(null);
                  }
                  return u.prototype.sample = function(a) {
                    switch (this._method) {
                      case 1:
                        this._colorStats1D(a);
                        break;
                      case 2:
                        this._colorStats2D(a);
                        break;
                    }
                  }, u.prototype.getImportanceSortedColorsIDXI32 = function() {
                    var a = this, n = d.stableSort(Object.keys(this._histogram), function(b, o) {
                      return a._histogram[o] - a._histogram[b];
                    });
                    if (n.length === 0)
                      return [];
                    var c;
                    switch (this._method) {
                      case 1:
                        var g = Math.min(n.length, this._initColors), f = n[g - 1], p = this._histogram[f];
                        c = n.slice(0, g);
                        for (var s = g, S = n.length; s < S && this._histogram[n[s]] == p; )
                          c.push(n[s++]);
                        this._hueStats.injectIntoArray(c);
                        break;
                      case 2:
                        c = n;
                        break;
                      default:
                        throw new Error("Incorrect method");
                    }
                    return c.map(function(b) {
                      return +b;
                    });
                  }, u.prototype._colorStats1D = function(a) {
                    for (var n = this._histogram, c = a.getPointArray(), g = c.length, f = 0; f < g; f++) {
                      var p = c[f].uint32;
                      this._hueStats.check(p), p in n ? n[p]++ : n[p] = 1;
                    }
                  }, u.prototype._colorStats2D = function(a) {
                    var n = this, c = a.getWidth(), g = a.getHeight(), f = a.getPointArray(), p = u._boxSize[0], s = u._boxSize[1], S = p * s, b = this._makeBoxes(c, g, p, s), o = this._histogram;
                    b.forEach(function(A) {
                      var T = Math.round(A.w * A.h / S) * u._boxPixels;
                      T < 2 && (T = 2);
                      var R = {};
                      n._iterateBox(A, c, function(L) {
                        var z = f[L].uint32;
                        n._hueStats.check(z), z in o ? o[z]++ : z in R ? ++R[z] >= T && (o[z] = R[z]) : R[z] = 1;
                      });
                    }), this._hueStats.injectIntoDictionary(o);
                  }, u.prototype._iterateBox = function(a, n, c) {
                    var g = a, f = g.y * n + g.x, p = (g.y + g.h - 1) * n + (g.x + g.w - 1), s = n - g.w + 1, S = 0, b = f;
                    do
                      c.call(this, b), b += ++S % g.w == 0 ? s : 1;
                    while (b <= p);
                  }, u.prototype._makeBoxes = function(a, n, c, g) {
                    for (var f = a % c, p = n % g, s = a - f, S = n - p, b = [], o = 0; o < n; o += g)
                      for (var A = 0; A < a; A += c)
                        b.push({ x: A, y: o, w: A == s ? f : c, h: o == S ? p : g });
                    return b;
                  }, u._boxSize = [64, 64], u._boxPixels = 2, u._hueGroups = 10, u;
                }();
                x.ColorHistogram = l;
              },
              /* 28 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * hueStatistics.ts - part of Image Quantization Library
                 */
                var E = y(5), d = y(22), l = /* @__PURE__ */ function() {
                  function a() {
                    this.num = 0, this.cols = [];
                  }
                  return a;
                }(), u = function() {
                  function a(n, c) {
                    this._numGroups = n, this._minCols = c, this._stats = [];
                    for (var g = 0; g <= n; g++)
                      this._stats[g] = new l();
                    this._groupsFull = 0;
                  }
                  return a.prototype.check = function(n) {
                    this._groupsFull == this._numGroups + 1 && (this.check = function() {
                    });
                    var c = n & 255, g = n >>> 8 & 255, f = n >>> 16 & 255, p = c == g && g == f ? 0 : 1 + d.hueGroup(E.rgb2hsl(c, g, f).h, this._numGroups), s = this._stats[p], S = this._minCols;
                    s.num++, !(s.num > S) && (s.num == S && this._groupsFull++, s.num <= S && this._stats[p].cols.push(n));
                  }, a.prototype.injectIntoDictionary = function(n) {
                    for (var c = 0; c <= this._numGroups; c++)
                      this._stats[c].num <= this._minCols && this._stats[c].cols.forEach(function(g) {
                        n[g] ? n[g]++ : n[g] = 1;
                      });
                  }, a.prototype.injectIntoArray = function(n) {
                    for (var c = 0; c <= this._numGroups; c++)
                      this._stats[c].num <= this._minCols && this._stats[c].cols.forEach(function(g) {
                        n.indexOf(g) == -1 && n.push(g);
                      });
                  }, a;
                }();
                x.HueStatistics = u;
              },
              /* 29 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * wuQuant.ts - part of Image Quantization Library
                 */
                var E = y(22), d = y(24);
                function l(p) {
                  for (var s = [], S = 0; S < p; S++)
                    s[S] = 0;
                  return s;
                }
                function u(p, s, S, b) {
                  for (var o = new Array(p), A = 0; A < p; A++) {
                    o[A] = new Array(s);
                    for (var T = 0; T < s; T++) {
                      o[A][T] = new Array(S);
                      for (var R = 0; R < S; R++) {
                        o[A][T][R] = new Array(b);
                        for (var L = 0; L < b; L++)
                          o[A][T][R][L] = 0;
                      }
                    }
                  }
                  return o;
                }
                function a(p, s, S) {
                  for (var b = new Array(p), o = 0; o < p; o++) {
                    b[o] = new Array(s);
                    for (var A = 0; A < s; A++) {
                      b[o][A] = new Array(S);
                      for (var T = 0; T < S; T++)
                        b[o][A][T] = 0;
                    }
                  }
                  return b;
                }
                function n(p, s, S, b, o) {
                  for (var A = 0; A < s; A++) {
                    p[A] = [];
                    for (var T = 0; T < S; T++) {
                      p[A][T] = [];
                      for (var R = 0; R < b; R++)
                        p[A][T][R] = o;
                    }
                  }
                }
                function c(p, s, S) {
                  for (var b = 0; b < s; b++)
                    p[b] = S;
                }
                var g = /* @__PURE__ */ function() {
                  function p() {
                  }
                  return p;
                }();
                x.WuColorCube = g;
                var f = function() {
                  function p(s, S, b) {
                    S === void 0 && (S = 256), b === void 0 && (b = 5), this._distance = s, this._setQuality(b), this._initialize(S);
                  }
                  return p.prototype.sample = function(s) {
                    for (var S = s.getPointArray(), b = 0, o = S.length; b < o; b++)
                      this._addColor(S[b]);
                    this._pixels = this._pixels.concat(S);
                  }, p.prototype.quantize = function() {
                    this._preparePalette();
                    for (var s = new E.Palette(), S = 0; S < this._colors; S++)
                      if (this._sums[S] > 0) {
                        var b = this._sums[S], o = this._reds[S] / b, A = this._greens[S] / b, T = this._blues[S] / b, R = this._alphas[S] / b, L = d.Point.createByRGBA(o | 0, A | 0, T | 0, R | 0);
                        s.add(L);
                      }
                    return s.sort(), s;
                  }, p.prototype._preparePalette = function() {
                    this._calculateMoments();
                    for (var s = 0, S = l(this._colors), b = 1; b < this._colors; ++b) {
                      this._cut(this._cubes[s], this._cubes[b]) ? (S[s] = this._cubes[s].volume > 1 ? this._calculateVariance(this._cubes[s]) : 0, S[b] = this._cubes[b].volume > 1 ? this._calculateVariance(this._cubes[b]) : 0) : (S[s] = 0, b--), s = 0;
                      for (var o = S[0], A = 1; A <= b; ++A)
                        S[A] > o && (o = S[A], s = A);
                      if (o <= 0) {
                        this._colors = b + 1;
                        break;
                      }
                    }
                    for (var T = [], R = [], L = [], z = [], U = 0; U < this._colors; ++U) {
                      var J = p._volume(this._cubes[U], this._weights);
                      J > 0 ? (T[U] = p._volume(this._cubes[U], this._momentsRed) / J | 0, R[U] = p._volume(this._cubes[U], this._momentsGreen) / J | 0, L[U] = p._volume(this._cubes[U], this._momentsBlue) / J | 0, z[U] = p._volume(this._cubes[U], this._momentsAlpha) / J | 0) : (T[U] = 0, R[U] = 0, L[U] = 0, z[U] = 0);
                    }
                    this._reds = l(this._colors + 1), this._greens = l(this._colors + 1), this._blues = l(this._colors + 1), this._alphas = l(this._colors + 1), this._sums = l(this._colors + 1);
                    for (var A = 0, F = this._pixels.length; A < F; A++) {
                      for (var se = this._pixels[A], ee = -1, ie = ee, W = Number.MAX_VALUE, Q = 0; Q < this._colors; Q++) {
                        var de = T[Q], _e = R[Q], ke = L[Q], Pe = z[Q], fe = this._distance.calculateRaw(de, _e, ke, Pe, se.r, se.g, se.b, se.a);
                        fe < W && (W = fe, ie = Q);
                      }
                      this._reds[ie] += se.r, this._greens[ie] += se.g, this._blues[ie] += se.b, this._alphas[ie] += se.a, this._sums[ie]++;
                    }
                  }, p.prototype._addColor = function(s) {
                    var S = 8 - this._significantBitsPerChannel, b = (s.r >> S) + 1, o = (s.g >> S) + 1, A = (s.b >> S) + 1, T = (s.a >> S) + 1;
                    this._weights[T][b][o][A]++, this._momentsRed[T][b][o][A] += s.r, this._momentsGreen[T][b][o][A] += s.g, this._momentsBlue[T][b][o][A] += s.b, this._momentsAlpha[T][b][o][A] += s.a, this._moments[T][b][o][A] += this._table[s.r] + this._table[s.g] + this._table[s.b] + this._table[s.a];
                  }, p.prototype._calculateMoments = function() {
                    for (var s = [], S = [], b = [], o = [], A = [], T = [], R = a(this._sideSize, this._sideSize, this._sideSize), L = a(this._sideSize, this._sideSize, this._sideSize), z = a(this._sideSize, this._sideSize, this._sideSize), U = a(this._sideSize, this._sideSize, this._sideSize), J = a(this._sideSize, this._sideSize, this._sideSize), F = a(this._sideSize, this._sideSize, this._sideSize), se = 1; se <= this._alphaMaxSideIndex; ++se) {
                      n(R, this._sideSize, this._sideSize, this._sideSize, 0), n(L, this._sideSize, this._sideSize, this._sideSize, 0), n(z, this._sideSize, this._sideSize, this._sideSize, 0), n(U, this._sideSize, this._sideSize, this._sideSize, 0), n(J, this._sideSize, this._sideSize, this._sideSize, 0), n(F, this._sideSize, this._sideSize, this._sideSize, 0);
                      for (var ee = 1; ee <= this._maxSideIndex; ++ee) {
                        c(s, this._sideSize, 0), c(S, this._sideSize, 0), c(b, this._sideSize, 0), c(o, this._sideSize, 0), c(A, this._sideSize, 0), c(T, this._sideSize, 0);
                        for (var ie = 1; ie <= this._maxSideIndex; ++ie)
                          for (var W = 0, Q = 0, de = 0, _e = 0, ke = 0, Pe = 0, fe = 1; fe <= this._maxSideIndex; ++fe)
                            W += this._weights[se][ee][ie][fe], Q += this._momentsRed[se][ee][ie][fe], de += this._momentsGreen[se][ee][ie][fe], _e += this._momentsBlue[se][ee][ie][fe], ke += this._momentsAlpha[se][ee][ie][fe], Pe += this._moments[se][ee][ie][fe], s[fe] += W, S[fe] += Q, b[fe] += de, o[fe] += _e, A[fe] += ke, T[fe] += Pe, R[ee][ie][fe] = R[ee - 1][ie][fe] + s[fe], L[ee][ie][fe] = L[ee - 1][ie][fe] + S[fe], z[ee][ie][fe] = z[ee - 1][ie][fe] + b[fe], U[ee][ie][fe] = U[ee - 1][ie][fe] + o[fe], J[ee][ie][fe] = J[ee - 1][ie][fe] + A[fe], F[ee][ie][fe] = F[ee - 1][ie][fe] + T[fe], this._weights[se][ee][ie][fe] = this._weights[se - 1][ee][ie][fe] + R[ee][ie][fe], this._momentsRed[se][ee][ie][fe] = this._momentsRed[se - 1][ee][ie][fe] + L[ee][ie][fe], this._momentsGreen[se][ee][ie][fe] = this._momentsGreen[se - 1][ee][ie][fe] + z[ee][ie][fe], this._momentsBlue[se][ee][ie][fe] = this._momentsBlue[se - 1][ee][ie][fe] + U[ee][ie][fe], this._momentsAlpha[se][ee][ie][fe] = this._momentsAlpha[se - 1][ee][ie][fe] + J[ee][ie][fe], this._moments[se][ee][ie][fe] = this._moments[se - 1][ee][ie][fe] + F[ee][ie][fe];
                      }
                    }
                  }, p._volumeFloat = function(s, S) {
                    return S[s.alphaMaximum][s.redMaximum][s.greenMaximum][s.blueMaximum] - S[s.alphaMaximum][s.redMaximum][s.greenMinimum][s.blueMaximum] - S[s.alphaMaximum][s.redMinimum][s.greenMaximum][s.blueMaximum] + S[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMaximum] - S[s.alphaMinimum][s.redMaximum][s.greenMaximum][s.blueMaximum] + S[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMaximum] + S[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMaximum] - S[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMaximum] - (S[s.alphaMaximum][s.redMaximum][s.greenMaximum][s.blueMinimum] - S[s.alphaMinimum][s.redMaximum][s.greenMaximum][s.blueMinimum] - S[s.alphaMaximum][s.redMaximum][s.greenMinimum][s.blueMinimum] + S[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMinimum] - S[s.alphaMaximum][s.redMinimum][s.greenMaximum][s.blueMinimum] + S[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMinimum] + S[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMinimum] - S[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                  }, p._volume = function(s, S) {
                    return p._volumeFloat(s, S) | 0;
                  }, p._top = function(s, S, b, o) {
                    var A;
                    switch (S) {
                      case p.alpha:
                        A = o[b][s.redMaximum][s.greenMaximum][s.blueMaximum] - o[b][s.redMaximum][s.greenMinimum][s.blueMaximum] - o[b][s.redMinimum][s.greenMaximum][s.blueMaximum] + o[b][s.redMinimum][s.greenMinimum][s.blueMaximum] - (o[b][s.redMaximum][s.greenMaximum][s.blueMinimum] - o[b][s.redMaximum][s.greenMinimum][s.blueMinimum] - o[b][s.redMinimum][s.greenMaximum][s.blueMinimum] + o[b][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                        break;
                      case p.red:
                        A = o[s.alphaMaximum][b][s.greenMaximum][s.blueMaximum] - o[s.alphaMaximum][b][s.greenMinimum][s.blueMaximum] - o[s.alphaMinimum][b][s.greenMaximum][s.blueMaximum] + o[s.alphaMinimum][b][s.greenMinimum][s.blueMaximum] - (o[s.alphaMaximum][b][s.greenMaximum][s.blueMinimum] - o[s.alphaMaximum][b][s.greenMinimum][s.blueMinimum] - o[s.alphaMinimum][b][s.greenMaximum][s.blueMinimum] + o[s.alphaMinimum][b][s.greenMinimum][s.blueMinimum]);
                        break;
                      case p.green:
                        A = o[s.alphaMaximum][s.redMaximum][b][s.blueMaximum] - o[s.alphaMaximum][s.redMinimum][b][s.blueMaximum] - o[s.alphaMinimum][s.redMaximum][b][s.blueMaximum] + o[s.alphaMinimum][s.redMinimum][b][s.blueMaximum] - (o[s.alphaMaximum][s.redMaximum][b][s.blueMinimum] - o[s.alphaMaximum][s.redMinimum][b][s.blueMinimum] - o[s.alphaMinimum][s.redMaximum][b][s.blueMinimum] + o[s.alphaMinimum][s.redMinimum][b][s.blueMinimum]);
                        break;
                      case p.blue:
                        A = o[s.alphaMaximum][s.redMaximum][s.greenMaximum][b] - o[s.alphaMaximum][s.redMaximum][s.greenMinimum][b] - o[s.alphaMaximum][s.redMinimum][s.greenMaximum][b] + o[s.alphaMaximum][s.redMinimum][s.greenMinimum][b] - (o[s.alphaMinimum][s.redMaximum][s.greenMaximum][b] - o[s.alphaMinimum][s.redMaximum][s.greenMinimum][b] - o[s.alphaMinimum][s.redMinimum][s.greenMaximum][b] + o[s.alphaMinimum][s.redMinimum][s.greenMinimum][b]);
                        break;
                      default:
                        throw new Error("impossible");
                    }
                    return A | 0;
                  }, p._bottom = function(s, S, b) {
                    switch (S) {
                      case p.alpha:
                        return -b[s.alphaMinimum][s.redMaximum][s.greenMaximum][s.blueMaximum] + b[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMaximum] + b[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMaximum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMaximum] - (-b[s.alphaMinimum][s.redMaximum][s.greenMaximum][s.blueMinimum] + b[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMinimum] + b[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMinimum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                      case p.red:
                        return -b[s.alphaMaximum][s.redMinimum][s.greenMaximum][s.blueMaximum] + b[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMaximum] + b[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMaximum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMaximum] - (-b[s.alphaMaximum][s.redMinimum][s.greenMaximum][s.blueMinimum] + b[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMinimum] + b[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMinimum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                      case p.green:
                        return -b[s.alphaMaximum][s.redMaximum][s.greenMinimum][s.blueMaximum] + b[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMaximum] + b[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMaximum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMaximum] - (-b[s.alphaMaximum][s.redMaximum][s.greenMinimum][s.blueMinimum] + b[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMinimum] + b[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMinimum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                      case p.blue:
                        return -b[s.alphaMaximum][s.redMaximum][s.greenMaximum][s.blueMinimum] + b[s.alphaMaximum][s.redMaximum][s.greenMinimum][s.blueMinimum] + b[s.alphaMaximum][s.redMinimum][s.greenMaximum][s.blueMinimum] - b[s.alphaMaximum][s.redMinimum][s.greenMinimum][s.blueMinimum] - (-b[s.alphaMinimum][s.redMaximum][s.greenMaximum][s.blueMinimum] + b[s.alphaMinimum][s.redMaximum][s.greenMinimum][s.blueMinimum] + b[s.alphaMinimum][s.redMinimum][s.greenMaximum][s.blueMinimum] - b[s.alphaMinimum][s.redMinimum][s.greenMinimum][s.blueMinimum]);
                      default:
                        return 0;
                    }
                  }, p.prototype._calculateVariance = function(s) {
                    var S = p._volume(s, this._momentsRed), b = p._volume(s, this._momentsGreen), o = p._volume(s, this._momentsBlue), A = p._volume(s, this._momentsAlpha), T = p._volumeFloat(s, this._moments), R = p._volume(s, this._weights), L = S * S + b * b + o * o + A * A;
                    return T - L / R;
                  }, p.prototype._maximize = function(s, S, b, o, A, T, R, L, z) {
                    for (var U = p._bottom(s, S, this._momentsRed) | 0, J = p._bottom(s, S, this._momentsGreen) | 0, F = p._bottom(s, S, this._momentsBlue) | 0, se = p._bottom(s, S, this._momentsAlpha) | 0, ee = p._bottom(s, S, this._weights) | 0, ie = 0, W = -1, Q = b; Q < o; ++Q) {
                      var de = U + p._top(s, S, Q, this._momentsRed), _e = J + p._top(s, S, Q, this._momentsGreen), ke = F + p._top(s, S, Q, this._momentsBlue), Pe = se + p._top(s, S, Q, this._momentsAlpha), fe = ee + p._top(s, S, Q, this._weights);
                      if (fe != 0) {
                        var xe = de * de + _e * _e + ke * ke + Pe * Pe, Ee = xe / fe;
                        de = A - de, _e = T - _e, ke = R - ke, Pe = L - Pe, fe = z - fe, fe != 0 && (xe = de * de + _e * _e + ke * ke + Pe * Pe, Ee += xe / fe, Ee > ie && (ie = Ee, W = Q));
                      }
                    }
                    return { max: ie, position: W };
                  }, p.prototype._cut = function(s, S) {
                    var b, o = p._volume(s, this._momentsRed), A = p._volume(s, this._momentsGreen), T = p._volume(s, this._momentsBlue), R = p._volume(s, this._momentsAlpha), L = p._volume(s, this._weights), z = this._maximize(s, p.red, s.redMinimum + 1, s.redMaximum, o, A, T, R, L), U = this._maximize(s, p.green, s.greenMinimum + 1, s.greenMaximum, o, A, T, R, L), J = this._maximize(s, p.blue, s.blueMinimum + 1, s.blueMaximum, o, A, T, R, L), F = this._maximize(s, p.alpha, s.alphaMinimum + 1, s.alphaMaximum, o, A, T, R, L);
                    if (F.max >= z.max && F.max >= U.max && F.max >= J.max) {
                      if (b = p.alpha, F.position < 0)
                        return !1;
                    } else
                      z.max >= F.max && z.max >= U.max && z.max >= J.max ? b = p.red : U.max >= F.max && U.max >= z.max && U.max >= J.max ? b = p.green : b = p.blue;
                    switch (S.redMaximum = s.redMaximum, S.greenMaximum = s.greenMaximum, S.blueMaximum = s.blueMaximum, S.alphaMaximum = s.alphaMaximum, b) {
                      case p.red:
                        S.redMinimum = s.redMaximum = z.position, S.greenMinimum = s.greenMinimum, S.blueMinimum = s.blueMinimum, S.alphaMinimum = s.alphaMinimum;
                        break;
                      case p.green:
                        S.greenMinimum = s.greenMaximum = U.position, S.redMinimum = s.redMinimum, S.blueMinimum = s.blueMinimum, S.alphaMinimum = s.alphaMinimum;
                        break;
                      case p.blue:
                        S.blueMinimum = s.blueMaximum = J.position, S.redMinimum = s.redMinimum, S.greenMinimum = s.greenMinimum, S.alphaMinimum = s.alphaMinimum;
                        break;
                      case p.alpha:
                        S.alphaMinimum = s.alphaMaximum = F.position, S.blueMinimum = s.blueMinimum, S.redMinimum = s.redMinimum, S.greenMinimum = s.greenMinimum;
                        break;
                    }
                    return s.volume = (s.redMaximum - s.redMinimum) * (s.greenMaximum - s.greenMinimum) * (s.blueMaximum - s.blueMinimum) * (s.alphaMaximum - s.alphaMinimum), S.volume = (S.redMaximum - S.redMinimum) * (S.greenMaximum - S.greenMinimum) * (S.blueMaximum - S.blueMinimum) * (S.alphaMaximum - S.alphaMinimum), !0;
                  }, p.prototype._initialize = function(s) {
                    this._colors = s, this._cubes = [];
                    for (var S = 0; S < s; S++)
                      this._cubes[S] = new g();
                    this._cubes[0].redMinimum = 0, this._cubes[0].greenMinimum = 0, this._cubes[0].blueMinimum = 0, this._cubes[0].alphaMinimum = 0, this._cubes[0].redMaximum = this._maxSideIndex, this._cubes[0].greenMaximum = this._maxSideIndex, this._cubes[0].blueMaximum = this._maxSideIndex, this._cubes[0].alphaMaximum = this._alphaMaxSideIndex, this._weights = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsRed = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsGreen = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsBlue = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._momentsAlpha = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._moments = u(this._alphaSideSize, this._sideSize, this._sideSize, this._sideSize), this._table = [];
                    for (var b = 0; b < 256; ++b)
                      this._table[b] = b * b;
                    this._pixels = [];
                  }, p.prototype._setQuality = function(s) {
                    s === void 0 && (s = 5), this._significantBitsPerChannel = s, this._maxSideIndex = 1 << this._significantBitsPerChannel, this._alphaMaxSideIndex = this._maxSideIndex, this._sideSize = this._maxSideIndex + 1, this._alphaSideSize = this._alphaMaxSideIndex + 1;
                  }, p.alpha = 3, p.red = 2, p.green = 1, p.blue = 0, p;
                }();
                x.WuQuant = f;
              },
              /* 30 */
              /***/
              function(P, x, y) {
                var E = y(31);
                x.NearestColor = E.NearestColor;
                var d = y(32);
                x.ErrorDiffusionArray = d.ErrorDiffusionArray, x.ErrorDiffusionArrayKernel = d.ErrorDiffusionArrayKernel;
                var l = y(33);
                x.ErrorDiffusionRiemersma = l.ErrorDiffusionRiemersma;
              },
              /* 31 */
              /***/
              function(P, x) {
                var y = function() {
                  function E(d) {
                    this._distance = d;
                  }
                  return E.prototype.quantize = function(d, l) {
                    for (var u = d.getPointArray(), a = d.getWidth(), n = d.getHeight(), c = 0; c < n; c++)
                      for (var g = 0, f = c * a; g < a; g++, f++) {
                        var p = u[f];
                        p.from(l.getNearestColor(this._distance, p));
                      }
                    return d;
                  }, E;
                }();
                x.NearestColor = y;
              },
              /* 32 */
              /***/
              function(P, x, y) {
                var E = y(24), d = y(6);
                (function(a) {
                  a[a.FloydSteinberg = 0] = "FloydSteinberg", a[a.FalseFloydSteinberg = 1] = "FalseFloydSteinberg", a[a.Stucki = 2] = "Stucki", a[a.Atkinson = 3] = "Atkinson", a[a.Jarvis = 4] = "Jarvis", a[a.Burkes = 5] = "Burkes", a[a.Sierra = 6] = "Sierra", a[a.TwoSierra = 7] = "TwoSierra", a[a.SierraLite = 8] = "SierraLite";
                })(x.ErrorDiffusionArrayKernel || (x.ErrorDiffusionArrayKernel = {}));
                var l = x.ErrorDiffusionArrayKernel, u = function() {
                  function a(n, c, g, f, p) {
                    g === void 0 && (g = !0), f === void 0 && (f = 0), p === void 0 && (p = !1), this._setKernel(c), this._distance = n, this._minColorDistance = f, this._serpentine = g, this._calculateErrorLikeGIMP = p;
                  }
                  return a.prototype.quantize = function(n, c) {
                    for (var g = n.getPointArray(), f = new E.Point(), p = n.getWidth(), s = n.getHeight(), S = [], b = 1, o = 1, A = 0; A < this._kernel.length; A++) {
                      var T = this._kernel[A][2] + 1;
                      o < T && (o = T);
                    }
                    for (var A = 0; A < o; A++)
                      this._fillErrorLine(S[A] = [], p);
                    for (var R = 0; R < s; R++) {
                      this._serpentine && (b = b * -1);
                      var L = R * p, z = b == 1 ? 0 : p - 1, U = b == 1 ? p : -1;
                      this._fillErrorLine(S[0], p), S.push(S.shift());
                      for (var J = S[0], F = z, se = L + z; F !== U; F += b, se += b) {
                        var ee = g[se], ie = J[F];
                        f.from(ee);
                        var W = E.Point.createByRGBA(d.inRange0to255Rounded(ee.r + ie[0]), d.inRange0to255Rounded(ee.g + ie[1]), d.inRange0to255Rounded(ee.b + ie[2]), d.inRange0to255Rounded(ee.a + ie[3])), Q = c.getNearestColor(this._distance, W);
                        if (ee.from(Q), this._minColorDistance) {
                          var de = this._distance.calculateNormalized(ee, Q);
                          if (de < this._minColorDistance)
                            continue;
                        }
                        var _e = void 0, ke = void 0, Pe = void 0, fe = void 0;
                        this._calculateErrorLikeGIMP ? (_e = W.r - Q.r, ke = W.g - Q.g, Pe = W.b - Q.b, fe = W.a - Q.a) : (_e = f.r - Q.r, ke = f.g - Q.g, Pe = f.b - Q.b, fe = f.a - Q.a);
                        for (var xe = b == 1 ? 0 : this._kernel.length - 1, Ee = b == 1 ? this._kernel.length : -1, A = xe; A !== Ee; A += b) {
                          var Ie = this._kernel[A][1] * b, je = this._kernel[A][2];
                          if (Ie + F >= 0 && Ie + F < p && je + R >= 0 && je + R < s) {
                            var Ue = this._kernel[A][0], He = S[je][Ie + F];
                            He[0] = He[0] + _e * Ue, He[1] = He[1] + ke * Ue, He[2] = He[2] + Pe * Ue, He[3] = He[3] + fe * Ue;
                          }
                        }
                      }
                    }
                    return n;
                  }, a.prototype._fillErrorLine = function(n, c) {
                    n.length > c && (n.length = c);
                    for (var g = n.length, f = 0; f < g; f++) {
                      var p = n[f];
                      p[0] = p[1] = p[2] = p[3] = 0;
                    }
                    for (var f = g; f < c; f++)
                      n[f] = [0, 0, 0, 0];
                  }, a.prototype._setKernel = function(n) {
                    switch (n) {
                      case l.FloydSteinberg:
                        this._kernel = [
                          [7 / 16, 1, 0],
                          [3 / 16, -1, 1],
                          [5 / 16, 0, 1],
                          [1 / 16, 1, 1]
                        ];
                        break;
                      case l.FalseFloydSteinberg:
                        this._kernel = [
                          [3 / 8, 1, 0],
                          [3 / 8, 0, 1],
                          [2 / 8, 1, 1]
                        ];
                        break;
                      case l.Stucki:
                        this._kernel = [
                          [8 / 42, 1, 0],
                          [4 / 42, 2, 0],
                          [2 / 42, -2, 1],
                          [4 / 42, -1, 1],
                          [8 / 42, 0, 1],
                          [4 / 42, 1, 1],
                          [2 / 42, 2, 1],
                          [1 / 42, -2, 2],
                          [2 / 42, -1, 2],
                          [4 / 42, 0, 2],
                          [2 / 42, 1, 2],
                          [1 / 42, 2, 2]
                        ];
                        break;
                      case l.Atkinson:
                        this._kernel = [
                          [1 / 8, 1, 0],
                          [1 / 8, 2, 0],
                          [1 / 8, -1, 1],
                          [1 / 8, 0, 1],
                          [1 / 8, 1, 1],
                          [1 / 8, 0, 2]
                        ];
                        break;
                      case l.Jarvis:
                        this._kernel = [
                          [7 / 48, 1, 0],
                          [5 / 48, 2, 0],
                          [3 / 48, -2, 1],
                          [5 / 48, -1, 1],
                          [7 / 48, 0, 1],
                          [5 / 48, 1, 1],
                          [3 / 48, 2, 1],
                          [1 / 48, -2, 2],
                          [3 / 48, -1, 2],
                          [5 / 48, 0, 2],
                          [3 / 48, 1, 2],
                          [1 / 48, 2, 2]
                        ];
                        break;
                      case l.Burkes:
                        this._kernel = [
                          [8 / 32, 1, 0],
                          [4 / 32, 2, 0],
                          [2 / 32, -2, 1],
                          [4 / 32, -1, 1],
                          [8 / 32, 0, 1],
                          [4 / 32, 1, 1],
                          [2 / 32, 2, 1]
                        ];
                        break;
                      case l.Sierra:
                        this._kernel = [
                          [5 / 32, 1, 0],
                          [3 / 32, 2, 0],
                          [2 / 32, -2, 1],
                          [4 / 32, -1, 1],
                          [5 / 32, 0, 1],
                          [4 / 32, 1, 1],
                          [2 / 32, 2, 1],
                          [2 / 32, -1, 2],
                          [3 / 32, 0, 2],
                          [2 / 32, 1, 2]
                        ];
                        break;
                      case l.TwoSierra:
                        this._kernel = [
                          [4 / 16, 1, 0],
                          [3 / 16, 2, 0],
                          [1 / 16, -2, 1],
                          [2 / 16, -1, 1],
                          [3 / 16, 0, 1],
                          [2 / 16, 1, 1],
                          [1 / 16, 2, 1]
                        ];
                        break;
                      case l.SierraLite:
                        this._kernel = [
                          [2 / 4, 1, 0],
                          [1 / 4, -1, 1],
                          [1 / 4, 0, 1]
                        ];
                        break;
                      default:
                        throw new Error("ErrorDiffusionArray: unknown kernel = " + n);
                    }
                  }, a;
                }();
                x.ErrorDiffusionArray = u;
              },
              /* 33 */
              /***/
              function(P, x, y) {
                var E = y(34), d = y(24), l = y(6), u = function() {
                  function a(n, c, g) {
                    c === void 0 && (c = 16), g === void 0 && (g = 1), this._distance = n, this._errorPropagation = g, this._errorQueueSize = c, this._max = this._errorQueueSize, this._createWeights();
                  }
                  return a.prototype.quantize = function(n, c) {
                    for (var g = this, f = new E.HilbertCurveBase(), p = n.getPointArray(), s = n.getWidth(), S = n.getHeight(), b = [], o = 0, A = 0; A < this._errorQueueSize; A++)
                      b[A] = { r: 0, g: 0, b: 0, a: 0 };
                    return f.walk(s, S, function(T, R) {
                      for (var L = p[T + R * s], z = L.r, U = L.g, J = L.b, F = L.a, se = 0; se < g._errorQueueSize; se++) {
                        var ee = g._weights[se], ie = b[(se + o) % g._errorQueueSize];
                        z += ie.r * ee, U += ie.g * ee, J += ie.b * ee, F += ie.a * ee;
                      }
                      var W = d.Point.createByRGBA(l.inRange0to255Rounded(z), l.inRange0to255Rounded(U), l.inRange0to255Rounded(J), l.inRange0to255Rounded(F)), Q = c.getNearestColor(g._distance, W);
                      o = (o + 1) % g._errorQueueSize;
                      var de = (o + g._errorQueueSize - 1) % g._errorQueueSize;
                      b[de].r = L.r - Q.r, b[de].g = L.g - Q.g, b[de].b = L.b - Q.b, b[de].a = L.a - Q.a, L.from(Q);
                    }), n;
                  }, a.prototype._createWeights = function() {
                    this._weights = [];
                    for (var n = Math.exp(Math.log(this._max) / (this._errorQueueSize - 1)), c = 0, g = 1; c < this._errorQueueSize; c++)
                      this._weights[c] = (g + 0.5 | 0) / this._max * this._errorPropagation, g *= n;
                  }, a;
                }();
                x.ErrorDiffusionRiemersma = u;
              },
              /* 34 */
              /***/
              function(P, x) {
                var y;
                (function(d) {
                  d[d.NONE = 0] = "NONE", d[d.UP = 1] = "UP", d[d.LEFT = 2] = "LEFT", d[d.RIGHT = 3] = "RIGHT", d[d.DOWN = 4] = "DOWN";
                })(y || (y = {}));
                var E = function() {
                  function d() {
                  }
                  return d.prototype.walk = function(l, u, a) {
                    this._x = 0, this._y = 0, this._d = 0, this._width = l, this._height = u, this._callback = a;
                    var n = Math.max(l, u);
                    this._level = Math.log(n) / Math.log(2) + 1 | 0, this._walkHilbert(y.UP), this._visit(y.NONE);
                  }, d.prototype._walkHilbert = function(l) {
                    if (!(this._level < 1)) {
                      switch (this._level--, l) {
                        case y.LEFT:
                          this._walkHilbert(y.UP), this._visit(y.RIGHT), this._walkHilbert(y.LEFT), this._visit(y.DOWN), this._walkHilbert(y.LEFT), this._visit(y.LEFT), this._walkHilbert(y.DOWN);
                          break;
                        case y.RIGHT:
                          this._walkHilbert(y.DOWN), this._visit(y.LEFT), this._walkHilbert(y.RIGHT), this._visit(y.UP), this._walkHilbert(y.RIGHT), this._visit(y.RIGHT), this._walkHilbert(y.UP);
                          break;
                        case y.UP:
                          this._walkHilbert(y.LEFT), this._visit(y.DOWN), this._walkHilbert(y.UP), this._visit(y.RIGHT), this._walkHilbert(y.UP), this._visit(y.UP), this._walkHilbert(y.RIGHT);
                          break;
                        case y.DOWN:
                          this._walkHilbert(y.RIGHT), this._visit(y.UP), this._walkHilbert(y.DOWN), this._visit(y.LEFT), this._walkHilbert(y.DOWN), this._visit(y.DOWN), this._walkHilbert(y.LEFT);
                          break;
                      }
                      this._level++;
                    }
                  }, d.prototype._visit = function(l) {
                    switch (this._x >= 0 && this._x < this._width && this._y >= 0 && this._y < this._height && (this._callback(this._x, this._y, this._d), this._d++), l) {
                      case y.LEFT:
                        this._x--;
                        break;
                      case y.RIGHT:
                        this._x++;
                        break;
                      case y.UP:
                        this._y--;
                        break;
                      case y.DOWN:
                        this._y++;
                        break;
                    }
                  }, d;
                }();
                x.HilbertCurveBase = E;
              },
              /* 35 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * iq.ts - Image Quantization Library
                 */
                var E = y(36);
                x.SSIM = E.SSIM;
              },
              /* 36 */
              /***/
              function(P, x, y) {
                var E = y(2), d = 0.01, l = 0.03, u = function() {
                  function a() {
                  }
                  return a.prototype.compare = function(n, c) {
                    if (n.getHeight() !== c.getHeight() || n.getWidth() !== c.getWidth())
                      throw new Error("Images have different sizes!");
                    var g = 8, f = (1 << g) - 1, p = Math.pow(d * f, 2), s = Math.pow(l * f, 2), S = 0, b = 0;
                    return this._iterate(n, c, function(o, A, T, R) {
                      for (var L = 0, z = 0, U = 0, J = 0; J < o.length; J++)
                        z += Math.pow(o[J] - T, 2), U += Math.pow(A[J] - R, 2), L += (o[J] - T) * (A[J] - R);
                      var F = o.length - 1;
                      z /= F, U /= F, L /= F;
                      var se = (2 * T * R + p) * (2 * L + s), ee = (Math.pow(T, 2) + Math.pow(R, 2) + p) * (z + U + s), ie = se / ee;
                      b += ie, S++;
                    }), b / S;
                  }, a.prototype._iterate = function(n, c, g) {
                    for (var f = 8, p = n.getWidth(), s = n.getHeight(), S = 0; S < s; S += f)
                      for (var b = 0; b < p; b += f) {
                        var o = Math.min(f, p - b), A = Math.min(f, s - S), T = this._calculateLumaValuesForWindow(n, b, S, o, A), R = this._calculateLumaValuesForWindow(c, b, S, o, A), L = this._calculateAverageLuma(T), z = this._calculateAverageLuma(R);
                        g(T, R, L, z);
                      }
                  }, a.prototype._calculateLumaValuesForWindow = function(n, c, g, f, p) {
                    for (var s = n.getPointArray(), S = [], b = 0, o = g; o < g + p; o++)
                      for (var A = o * n.getWidth(), T = c; T < c + f; T++) {
                        var R = s[A + T];
                        S[b] = R.r * E.Y.RED + R.g * E.Y.GREEN + R.b * E.Y.BLUE, b++;
                      }
                    return S;
                  }, a.prototype._calculateAverageLuma = function(n) {
                    for (var c = 0, g = 0; g < n.length; g++)
                      c += n[g];
                    return c / n.length;
                  }, a;
                }();
                x.SSIM = u;
              },
              /* 37 */
              /***/
              function(P, x, y) {
                /**
                 * @preserve
                 * Copyright 2015-2016 Igor Bezkrovnyi
                 * All rights reserved. (MIT Licensed)
                 *
                 * iq.ts - Image Quantization Library
                 */
                var E = y(6);
                x.arithmetic = E;
                var d = y(28);
                x.HueStatistics = d.HueStatistics;
                var l = y(22);
                x.Palette = l.Palette;
                var u = y(24);
                x.Point = u.Point;
                var a = y(23);
                x.PointContainer = a.PointContainer;
              }
              /******/
            ])
          );
        });
      }, {}], 75: [function(C, Z, _) {
        typeof Object.create == "function" ? Z.exports = function(x, y) {
          y && (x.super_ = y, x.prototype = Object.create(y.prototype, {
            constructor: {
              value: x,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : Z.exports = function(x, y) {
          if (y) {
            x.super_ = y;
            var E = function() {
            };
            E.prototype = y.prototype, x.prototype = new E(), x.prototype.constructor = x;
          }
        };
      }, {}], 76: [function(C, Z, _) {
        /*!
         * Determine if an object is a Buffer
         *
         * @author   Feross Aboukhadijeh <https://feross.org>
         * @license  MIT
         */
        Z.exports = function(y) {
          return y != null && (P(y) || x(y) || !!y._isBuffer);
        };
        function P(y) {
          return !!y.constructor && typeof y.constructor.isBuffer == "function" && y.constructor.isBuffer(y);
        }
        function x(y) {
          return typeof y.readFloatLE == "function" && typeof y.slice == "function" && P(y.slice(0, 0));
        }
      }, {}], 77: [function(C, Z, _) {
        var P = Function.prototype.toString, x = /^\s*class\b/, y = function(c) {
          try {
            var g = P.call(c);
            return x.test(g);
          } catch {
            return !1;
          }
        }, E = function(c) {
          try {
            return y(c) ? !1 : (P.call(c), !0);
          } catch {
            return !1;
          }
        }, d = Object.prototype.toString, l = "[object Function]", u = "[object GeneratorFunction]", a = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol";
        Z.exports = function(c) {
          if (!c || typeof c != "function" && typeof c != "object")
            return !1;
          if (typeof c == "function" && !c.prototype)
            return !0;
          if (a)
            return E(c);
          if (y(c))
            return !1;
          var g = d.call(c);
          return g === l || g === u;
        };
      }, {}], 78: [function(C, Z, _) {
        Z.exports = x;
        var P = Object.prototype.toString;
        function x(y) {
          var E = P.call(y);
          return E === "[object Function]" || typeof y == "function" && E !== "[object RegExp]" || typeof ne < "u" && // IE8 and below
          (y === ne.setTimeout || y === ne.alert || y === ne.confirm || y === ne.prompt);
        }
      }, {}], 79: [function(C, Z, _) {
        var P = {}.toString;
        Z.exports = Array.isArray || function(x) {
          return P.call(x) == "[object Array]";
        };
      }, {}], 80: [function(C, Z, _) {
        var P = C("./lib/encoder"), x = C("./lib/decoder");
        Z.exports = {
          encode: P,
          decode: x
        };
      }, { "./lib/decoder": 81, "./lib/encoder": 82 }], 81: [function(C, Z, _) {
        (function(P) {
          var x = function() {
            var d = new Int32Array([
              0,
              1,
              8,
              16,
              9,
              2,
              3,
              10,
              17,
              24,
              32,
              25,
              18,
              11,
              4,
              5,
              12,
              19,
              26,
              33,
              40,
              48,
              41,
              34,
              27,
              20,
              13,
              6,
              7,
              14,
              21,
              28,
              35,
              42,
              49,
              56,
              57,
              50,
              43,
              36,
              29,
              22,
              15,
              23,
              30,
              37,
              44,
              51,
              58,
              59,
              52,
              45,
              38,
              31,
              39,
              46,
              53,
              60,
              61,
              54,
              47,
              55,
              62,
              63
            ]), l = 4017, u = 799, a = 3406, n = 2276, c = 1567, g = 3784, f = 5793, p = 2896;
            function s() {
            }
            function S(z, U) {
              for (var J = 0, F = [], se, ee, ie = 16; ie > 0 && !z[ie - 1]; )
                ie--;
              F.push({ children: [], index: 0 });
              var W = F[0], Q;
              for (se = 0; se < ie; se++) {
                for (ee = 0; ee < z[se]; ee++) {
                  for (W = F.pop(), W.children[W.index] = U[J]; W.index > 0; ) {
                    if (F.length === 0)
                      throw new Error("Could not recreate Huffman Table");
                    W = F.pop();
                  }
                  for (W.index++, F.push(W); F.length <= se; )
                    F.push(Q = { children: [], index: 0 }), W.children[W.index] = Q.children, W = Q;
                  J++;
                }
                se + 1 < ie && (F.push(Q = { children: [], index: 0 }), W.children[W.index] = Q.children, W = Q);
              }
              return F[0].children;
            }
            function b(z, U, J, F, se, ee, ie, W, Q, de) {
              J.precision, J.samplesPerLine, J.scanLines;
              var _e = J.mcusPerLine, ke = J.progressive;
              J.maxH, J.maxV;
              var Pe = U, fe = 0, xe = 0;
              function Ee() {
                if (xe > 0)
                  return xe--, fe >> xe & 1;
                if (fe = z[U++], fe == 255) {
                  var j = z[U++];
                  if (j)
                    throw new Error("unexpected marker: " + (fe << 8 | j).toString(16));
                }
                return xe = 7, fe >>> 7;
              }
              function Ie(j) {
                for (var H = j, X; (X = Ee()) !== null; ) {
                  if (H = H[X], typeof H == "number")
                    return H;
                  if (typeof H != "object")
                    throw new Error("invalid huffman sequence");
                }
                return null;
              }
              function je(j) {
                for (var H = 0; j > 0; ) {
                  var X = Ee();
                  if (X === null) return;
                  H = H << 1 | X, j--;
                }
                return H;
              }
              function Ue(j) {
                var H = je(j);
                return H >= 1 << j - 1 ? H : H + (-1 << j) + 1;
              }
              function He(j, H) {
                var X = Ie(j.huffmanTableDC), ue = X === 0 ? 0 : Ue(X);
                H[0] = j.pred += ue;
                for (var pe = 1; pe < 64; ) {
                  var M = Ie(j.huffmanTableAC), q = M & 15, K = M >> 4;
                  if (q === 0) {
                    if (K < 15)
                      break;
                    pe += 16;
                    continue;
                  }
                  pe += K;
                  var be = d[pe];
                  H[be] = Ue(q), pe++;
                }
              }
              function Ze(j, H) {
                var X = Ie(j.huffmanTableDC), ue = X === 0 ? 0 : Ue(X) << Q;
                H[0] = j.pred += ue;
              }
              function $e(j, H) {
                H[0] |= Ee() << Q;
              }
              var We = 0;
              function Ve(j, H) {
                if (We > 0) {
                  We--;
                  return;
                }
                for (var X = ee, ue = ie; X <= ue; ) {
                  var pe = Ie(j.huffmanTableAC), M = pe & 15, q = pe >> 4;
                  if (M === 0) {
                    if (q < 15) {
                      We = je(q) + (1 << q) - 1;
                      break;
                    }
                    X += 16;
                    continue;
                  }
                  X += q;
                  var K = d[X];
                  H[K] = Ue(M) * (1 << Q), X++;
                }
              }
              var Re = 0, De;
              function Ne(j, H) {
                for (var X = ee, ue = ie, pe = 0; X <= ue; ) {
                  var M = d[X], q = H[M] < 0 ? -1 : 1;
                  switch (Re) {
                    case 0:
                      var K = Ie(j.huffmanTableAC), be = K & 15, pe = K >> 4;
                      if (be === 0)
                        pe < 15 ? (We = je(pe) + (1 << pe), Re = 4) : (pe = 16, Re = 1);
                      else {
                        if (be !== 1)
                          throw new Error("invalid ACn encoding");
                        De = Ue(be), Re = pe ? 2 : 3;
                      }
                      continue;
                    case 1:
                    // skipping r zero items
                    case 2:
                      H[M] ? H[M] += (Ee() << Q) * q : (pe--, pe === 0 && (Re = Re == 2 ? 3 : 0));
                      break;
                    case 3:
                      H[M] ? H[M] += (Ee() << Q) * q : (H[M] = De << Q, Re = 0);
                      break;
                    case 4:
                      H[M] && (H[M] += (Ee() << Q) * q);
                      break;
                  }
                  X++;
                }
                Re === 4 && (We--, We === 0 && (Re = 0));
              }
              function we(j, H, X, ue, pe) {
                var M = X / _e | 0, q = X % _e, K = M * j.v + ue, be = q * j.h + pe;
                j.blocks[K] === void 0 && de.tolerantDecoding || H(j, j.blocks[K][be]);
              }
              function re(j, H, X) {
                var ue = X / j.blocksPerLine | 0, pe = X % j.blocksPerLine;
                j.blocks[ue] === void 0 && de.tolerantDecoding || H(j, j.blocks[ue][pe]);
              }
              var $ = F.length, Ce, ve, Y, G, Ae, e;
              ke ? ee === 0 ? e = W === 0 ? Ze : $e : e = W === 0 ? Ve : Ne : e = He;
              var r = 0, h, k;
              $ == 1 ? k = F[0].blocksPerLine * F[0].blocksPerColumn : k = _e * J.mcusPerColumn, se || (se = k);
              for (var I, B; r < k; ) {
                for (ve = 0; ve < $; ve++)
                  F[ve].pred = 0;
                if (We = 0, $ == 1)
                  for (Ce = F[0], Ae = 0; Ae < se; Ae++)
                    re(Ce, e, r), r++;
                else
                  for (Ae = 0; Ae < se; Ae++) {
                    for (ve = 0; ve < $; ve++)
                      for (Ce = F[ve], I = Ce.h, B = Ce.v, Y = 0; Y < B; Y++)
                        for (G = 0; G < I; G++)
                          we(Ce, e, r, Y, G);
                    if (r++, r === k) break;
                  }
                if (r === k)
                  do {
                    if (z[U] === 255 && z[U + 1] !== 0)
                      break;
                    U += 1;
                  } while (U < z.length - 2);
                if (xe = 0, h = z[U] << 8 | z[U + 1], h < 65280)
                  throw new Error("marker was not found");
                if (h >= 65488 && h <= 65495)
                  U += 2;
                else
                  break;
              }
              return U - Pe;
            }
            function o(z, U) {
              var J = [], F = U.blocksPerLine, se = U.blocksPerColumn, ee = F << 3, ie = new Int32Array(64), W = new Uint8Array(64);
              function Q(je, Ue, He) {
                var Ze = U.quantizationTable, $e, We, Ve, Re, De, Ne, we, re, $, Ce = He, ve;
                for (ve = 0; ve < 64; ve++)
                  Ce[ve] = je[ve] * Ze[ve];
                for (ve = 0; ve < 8; ++ve) {
                  var Y = 8 * ve;
                  if (Ce[1 + Y] == 0 && Ce[2 + Y] == 0 && Ce[3 + Y] == 0 && Ce[4 + Y] == 0 && Ce[5 + Y] == 0 && Ce[6 + Y] == 0 && Ce[7 + Y] == 0) {
                    $ = f * Ce[0 + Y] + 512 >> 10, Ce[0 + Y] = $, Ce[1 + Y] = $, Ce[2 + Y] = $, Ce[3 + Y] = $, Ce[4 + Y] = $, Ce[5 + Y] = $, Ce[6 + Y] = $, Ce[7 + Y] = $;
                    continue;
                  }
                  $e = f * Ce[0 + Y] + 128 >> 8, We = f * Ce[4 + Y] + 128 >> 8, Ve = Ce[2 + Y], Re = Ce[6 + Y], De = p * (Ce[1 + Y] - Ce[7 + Y]) + 128 >> 8, re = p * (Ce[1 + Y] + Ce[7 + Y]) + 128 >> 8, Ne = Ce[3 + Y] << 4, we = Ce[5 + Y] << 4, $ = $e - We + 1 >> 1, $e = $e + We + 1 >> 1, We = $, $ = Ve * g + Re * c + 128 >> 8, Ve = Ve * c - Re * g + 128 >> 8, Re = $, $ = De - we + 1 >> 1, De = De + we + 1 >> 1, we = $, $ = re + Ne + 1 >> 1, Ne = re - Ne + 1 >> 1, re = $, $ = $e - Re + 1 >> 1, $e = $e + Re + 1 >> 1, Re = $, $ = We - Ve + 1 >> 1, We = We + Ve + 1 >> 1, Ve = $, $ = De * n + re * a + 2048 >> 12, De = De * a - re * n + 2048 >> 12, re = $, $ = Ne * u + we * l + 2048 >> 12, Ne = Ne * l - we * u + 2048 >> 12, we = $, Ce[0 + Y] = $e + re, Ce[7 + Y] = $e - re, Ce[1 + Y] = We + we, Ce[6 + Y] = We - we, Ce[2 + Y] = Ve + Ne, Ce[5 + Y] = Ve - Ne, Ce[3 + Y] = Re + De, Ce[4 + Y] = Re - De;
                }
                for (ve = 0; ve < 8; ++ve) {
                  var G = ve;
                  if (Ce[8 + G] == 0 && Ce[16 + G] == 0 && Ce[24 + G] == 0 && Ce[32 + G] == 0 && Ce[40 + G] == 0 && Ce[48 + G] == 0 && Ce[56 + G] == 0) {
                    $ = f * He[ve + 0] + 8192 >> 14, Ce[0 + G] = $, Ce[8 + G] = $, Ce[16 + G] = $, Ce[24 + G] = $, Ce[32 + G] = $, Ce[40 + G] = $, Ce[48 + G] = $, Ce[56 + G] = $;
                    continue;
                  }
                  $e = f * Ce[0 + G] + 2048 >> 12, We = f * Ce[32 + G] + 2048 >> 12, Ve = Ce[16 + G], Re = Ce[48 + G], De = p * (Ce[8 + G] - Ce[56 + G]) + 2048 >> 12, re = p * (Ce[8 + G] + Ce[56 + G]) + 2048 >> 12, Ne = Ce[24 + G], we = Ce[40 + G], $ = $e - We + 1 >> 1, $e = $e + We + 1 >> 1, We = $, $ = Ve * g + Re * c + 2048 >> 12, Ve = Ve * c - Re * g + 2048 >> 12, Re = $, $ = De - we + 1 >> 1, De = De + we + 1 >> 1, we = $, $ = re + Ne + 1 >> 1, Ne = re - Ne + 1 >> 1, re = $, $ = $e - Re + 1 >> 1, $e = $e + Re + 1 >> 1, Re = $, $ = We - Ve + 1 >> 1, We = We + Ve + 1 >> 1, Ve = $, $ = De * n + re * a + 2048 >> 12, De = De * a - re * n + 2048 >> 12, re = $, $ = Ne * u + we * l + 2048 >> 12, Ne = Ne * l - we * u + 2048 >> 12, we = $, Ce[0 + G] = $e + re, Ce[56 + G] = $e - re, Ce[8 + G] = We + we, Ce[48 + G] = We - we, Ce[16 + G] = Ve + Ne, Ce[40 + G] = Ve - Ne, Ce[24 + G] = Re + De, Ce[32 + G] = Re - De;
                }
                for (ve = 0; ve < 64; ++ve) {
                  var Ae = 128 + (Ce[ve] + 8 >> 4);
                  Ue[ve] = Ae < 0 ? 0 : Ae > 255 ? 255 : Ae;
                }
              }
              L(ee * se * 8);
              for (var de, _e, ke = 0; ke < se; ke++) {
                var Pe = ke << 3;
                for (de = 0; de < 8; de++)
                  J.push(new Uint8Array(ee));
                for (var fe = 0; fe < F; fe++) {
                  Q(U.blocks[ke][fe], W, ie);
                  var xe = 0, Ee = fe << 3;
                  for (_e = 0; _e < 8; _e++) {
                    var Ie = J[Pe + _e];
                    for (de = 0; de < 8; de++)
                      Ie[Ee + de] = W[xe++];
                  }
                }
              }
              return J;
            }
            function A(z) {
              return z < 0 ? 0 : z > 255 ? 255 : z;
            }
            s.prototype = {
              load: function(U) {
                var J = new XMLHttpRequest();
                J.open("GET", U, !0), J.responseType = "arraybuffer", J.onload = (function() {
                  var F = new Uint8Array(J.response || J.mozResponseArrayBuffer);
                  this.parse(F), this.onload && this.onload();
                }).bind(this), J.send(null);
              },
              parse: function(U) {
                var J = this.opts.maxResolutionInMP * 1e3 * 1e3, F = 0;
                U.length;
                function se() {
                  var pe = U[F] << 8 | U[F + 1];
                  return F += 2, pe;
                }
                function ee() {
                  var pe = se(), M = U.subarray(F, F + pe - 2);
                  return F += M.length, M;
                }
                function ie(pe) {
                  var M = 0, q = 0, K, be;
                  for (be in pe.components)
                    pe.components.hasOwnProperty(be) && (K = pe.components[be], M < K.h && (M = K.h), q < K.v && (q = K.v));
                  var te = Math.ceil(pe.samplesPerLine / 8 / M), he = Math.ceil(pe.scanLines / 8 / q);
                  for (be in pe.components)
                    if (pe.components.hasOwnProperty(be)) {
                      K = pe.components[be];
                      var D = Math.ceil(Math.ceil(pe.samplesPerLine / 8) * K.h / M), Se = Math.ceil(Math.ceil(pe.scanLines / 8) * K.v / q), le = te * K.h, m = he * K.v, oe = m * le, me = [];
                      L(oe * 256);
                      for (var O = 0; O < m; O++) {
                        for (var ce = [], Oe = 0; Oe < le; Oe++)
                          ce.push(new Int32Array(64));
                        me.push(ce);
                      }
                      K.blocksPerLine = D, K.blocksPerColumn = Se, K.blocks = me;
                    }
                  pe.maxH = M, pe.maxV = q, pe.mcusPerLine = te, pe.mcusPerColumn = he;
                }
                var W = null, Q = null, de, _e, ke = [], Pe = [], fe = [], xe = [], Ee = se();
                if (Ee != 65496)
                  throw new Error("SOI not found");
                for (Ee = se(); Ee != 65497; ) {
                  var Ie, je;
                  switch (Ee) {
                    case 65280:
                      break;
                    case 65504:
                    // APP0 (Application Specific)
                    case 65505:
                    // APP1
                    case 65506:
                    // APP2
                    case 65507:
                    // APP3
                    case 65508:
                    // APP4
                    case 65509:
                    // APP5
                    case 65510:
                    // APP6
                    case 65511:
                    // APP7
                    case 65512:
                    // APP8
                    case 65513:
                    // APP9
                    case 65514:
                    // APP10
                    case 65515:
                    // APP11
                    case 65516:
                    // APP12
                    case 65517:
                    // APP13
                    case 65518:
                    // APP14
                    case 65519:
                    // APP15
                    case 65534:
                      var Ue = ee();
                      Ee === 65504 && Ue[0] === 74 && Ue[1] === 70 && Ue[2] === 73 && Ue[3] === 70 && Ue[4] === 0 && (W = {
                        version: { major: Ue[5], minor: Ue[6] },
                        densityUnits: Ue[7],
                        xDensity: Ue[8] << 8 | Ue[9],
                        yDensity: Ue[10] << 8 | Ue[11],
                        thumbWidth: Ue[12],
                        thumbHeight: Ue[13],
                        thumbData: Ue.subarray(14, 14 + 3 * Ue[12] * Ue[13])
                      }), Ee === 65505 && Ue[0] === 69 && Ue[1] === 120 && Ue[2] === 105 && Ue[3] === 102 && Ue[4] === 0 && (this.exifBuffer = Ue.subarray(5, Ue.length)), Ee === 65518 && Ue[0] === 65 && Ue[1] === 100 && Ue[2] === 111 && Ue[3] === 98 && Ue[4] === 101 && Ue[5] === 0 && (Q = {
                        version: Ue[6],
                        flags0: Ue[7] << 8 | Ue[8],
                        flags1: Ue[9] << 8 | Ue[10],
                        transformCode: Ue[11]
                      });
                      break;
                    case 65499:
                      for (var He = se(), Ze = He + F - 2; F < Ze; ) {
                        var $e = U[F++];
                        L(256);
                        var We = new Int32Array(64);
                        if ($e >> 4 === 0)
                          for (je = 0; je < 64; je++) {
                            var Ve = d[je];
                            We[Ve] = U[F++];
                          }
                        else if ($e >> 4 === 1)
                          for (je = 0; je < 64; je++) {
                            var Ve = d[je];
                            We[Ve] = se();
                          }
                        else
                          throw new Error("DQT: invalid table spec");
                        ke[$e & 15] = We;
                      }
                      break;
                    case 65472:
                    // SOF0 (Start of Frame, Baseline DCT)
                    case 65473:
                    // SOF1 (Start of Frame, Extended DCT)
                    case 65474:
                      se(), de = {}, de.extended = Ee === 65473, de.progressive = Ee === 65474, de.precision = U[F++], de.scanLines = se(), de.samplesPerLine = se(), de.components = {}, de.componentsOrder = [];
                      var Re = de.scanLines * de.samplesPerLine;
                      if (Re > J) {
                        var De = Math.ceil((Re - J) / 1e6);
                        throw new Error(`maxResolutionInMP limit exceeded by ${De}MP`);
                      }
                      var Ne = U[F++], we;
                      for (Ie = 0; Ie < Ne; Ie++) {
                        we = U[F];
                        var re = U[F + 1] >> 4, $ = U[F + 1] & 15, Ce = U[F + 2];
                        de.componentsOrder.push(we), de.components[we] = {
                          h: re,
                          v: $,
                          quantizationIdx: Ce
                        }, F += 3;
                      }
                      ie(de), Pe.push(de);
                      break;
                    case 65476:
                      var ve = se();
                      for (Ie = 2; Ie < ve; ) {
                        var Y = U[F++], G = new Uint8Array(16), Ae = 0;
                        for (je = 0; je < 16; je++, F++)
                          Ae += G[je] = U[F];
                        L(16 + Ae);
                        var e = new Uint8Array(Ae);
                        for (je = 0; je < Ae; je++, F++)
                          e[je] = U[F];
                        Ie += 17 + Ae, (Y >> 4 === 0 ? xe : fe)[Y & 15] = S(G, e);
                      }
                      break;
                    case 65501:
                      se(), _e = se();
                      break;
                    case 65498:
                      se();
                      var r = U[F++], h = [], k;
                      for (Ie = 0; Ie < r; Ie++) {
                        k = de.components[U[F++]];
                        var I = U[F++];
                        k.huffmanTableDC = xe[I >> 4], k.huffmanTableAC = fe[I & 15], h.push(k);
                      }
                      var B = U[F++], j = U[F++], H = U[F++], X = b(
                        U,
                        F,
                        de,
                        h,
                        _e,
                        B,
                        j,
                        H >> 4,
                        H & 15,
                        this.opts
                      );
                      F += X;
                      break;
                    case 65535:
                      U[F] !== 255 && F--;
                      break;
                    default:
                      if (U[F - 3] == 255 && U[F - 2] >= 192 && U[F - 2] <= 254) {
                        F -= 3;
                        break;
                      }
                      throw new Error("unknown JPEG marker " + Ee.toString(16));
                  }
                  Ee = se();
                }
                if (Pe.length != 1)
                  throw new Error("only single frame JPEGs supported");
                for (var Ie = 0; Ie < Pe.length; Ie++) {
                  var ue = Pe[Ie].components;
                  for (var je in ue)
                    ue[je].quantizationTable = ke[ue[je].quantizationIdx], delete ue[je].quantizationIdx;
                }
                this.width = de.samplesPerLine, this.height = de.scanLines, this.jfif = W, this.adobe = Q, this.components = [];
                for (var Ie = 0; Ie < de.componentsOrder.length; Ie++) {
                  var k = de.components[de.componentsOrder[Ie]];
                  this.components.push({
                    lines: o(de, k),
                    scaleX: k.h / de.maxH,
                    scaleY: k.v / de.maxV
                  });
                }
              },
              getData: function(U, J) {
                var F = this.width / U, se = this.height / J, ee, ie, W, Q, de, _e, ke, Pe, fe, xe, Ee = 0, Ie, je, Ue, He, Ze, $e, We, Ve, Re, De, Ne, we = U * J * this.components.length;
                L(we);
                var re = new Uint8Array(we);
                switch (this.components.length) {
                  case 1:
                    for (ee = this.components[0], xe = 0; xe < J; xe++)
                      for (de = ee.lines[0 | xe * ee.scaleY * se], fe = 0; fe < U; fe++)
                        Ie = de[0 | fe * ee.scaleX * F], re[Ee++] = Ie;
                    break;
                  case 2:
                    for (ee = this.components[0], ie = this.components[1], xe = 0; xe < J; xe++)
                      for (de = ee.lines[0 | xe * ee.scaleY * se], _e = ie.lines[0 | xe * ie.scaleY * se], fe = 0; fe < U; fe++)
                        Ie = de[0 | fe * ee.scaleX * F], re[Ee++] = Ie, Ie = _e[0 | fe * ie.scaleX * F], re[Ee++] = Ie;
                    break;
                  case 3:
                    for (Ne = !0, this.adobe && this.adobe.transformCode ? Ne = !0 : typeof this.opts.colorTransform < "u" && (Ne = !!this.opts.colorTransform), ee = this.components[0], ie = this.components[1], W = this.components[2], xe = 0; xe < J; xe++)
                      for (de = ee.lines[0 | xe * ee.scaleY * se], _e = ie.lines[0 | xe * ie.scaleY * se], ke = W.lines[0 | xe * W.scaleY * se], fe = 0; fe < U; fe++)
                        Ne ? (Ie = de[0 | fe * ee.scaleX * F], je = _e[0 | fe * ie.scaleX * F], Ue = ke[0 | fe * W.scaleX * F], Ve = A(Ie + 1.402 * (Ue - 128)), Re = A(Ie - 0.3441363 * (je - 128) - 0.71413636 * (Ue - 128)), De = A(Ie + 1.772 * (je - 128))) : (Ve = de[0 | fe * ee.scaleX * F], Re = _e[0 | fe * ie.scaleX * F], De = ke[0 | fe * W.scaleX * F]), re[Ee++] = Ve, re[Ee++] = Re, re[Ee++] = De;
                    break;
                  case 4:
                    if (!this.adobe)
                      throw new Error("Unsupported color mode (4 components)");
                    for (Ne = !1, this.adobe && this.adobe.transformCode ? Ne = !0 : typeof this.opts.colorTransform < "u" && (Ne = !!this.opts.colorTransform), ee = this.components[0], ie = this.components[1], W = this.components[2], Q = this.components[3], xe = 0; xe < J; xe++)
                      for (de = ee.lines[0 | xe * ee.scaleY * se], _e = ie.lines[0 | xe * ie.scaleY * se], ke = W.lines[0 | xe * W.scaleY * se], Pe = Q.lines[0 | xe * Q.scaleY * se], fe = 0; fe < U; fe++)
                        Ne ? (Ie = de[0 | fe * ee.scaleX * F], je = _e[0 | fe * ie.scaleX * F], Ue = ke[0 | fe * W.scaleX * F], He = Pe[0 | fe * Q.scaleX * F], Ze = 255 - A(Ie + 1.402 * (Ue - 128)), $e = 255 - A(Ie - 0.3441363 * (je - 128) - 0.71413636 * (Ue - 128)), We = 255 - A(Ie + 1.772 * (je - 128))) : (Ze = de[0 | fe * ee.scaleX * F], $e = _e[0 | fe * ie.scaleX * F], We = ke[0 | fe * W.scaleX * F], He = Pe[0 | fe * Q.scaleX * F]), re[Ee++] = 255 - Ze, re[Ee++] = 255 - $e, re[Ee++] = 255 - We, re[Ee++] = 255 - He;
                    break;
                  default:
                    throw new Error("Unsupported color mode");
                }
                return re;
              },
              copyToImageData: function(U, J) {
                var F = U.width, se = U.height, ee = U.data, ie = this.getData(F, se), W = 0, Q = 0, de, _e, ke, Pe, fe, xe, Ee, Ie, je;
                switch (this.components.length) {
                  case 1:
                    for (_e = 0; _e < se; _e++)
                      for (de = 0; de < F; de++)
                        ke = ie[W++], ee[Q++] = ke, ee[Q++] = ke, ee[Q++] = ke, J && (ee[Q++] = 255);
                    break;
                  case 3:
                    for (_e = 0; _e < se; _e++)
                      for (de = 0; de < F; de++)
                        Ee = ie[W++], Ie = ie[W++], je = ie[W++], ee[Q++] = Ee, ee[Q++] = Ie, ee[Q++] = je, J && (ee[Q++] = 255);
                    break;
                  case 4:
                    for (_e = 0; _e < se; _e++)
                      for (de = 0; de < F; de++)
                        fe = ie[W++], xe = ie[W++], ke = ie[W++], Pe = ie[W++], Ee = 255 - A(fe * (1 - Pe / 255) + Pe), Ie = 255 - A(xe * (1 - Pe / 255) + Pe), je = 255 - A(ke * (1 - Pe / 255) + Pe), ee[Q++] = Ee, ee[Q++] = Ie, ee[Q++] = je, J && (ee[Q++] = 255);
                    break;
                  default:
                    throw new Error("Unsupported color mode");
                }
              }
            };
            var T = 0, R = 0;
            function L(z = 0) {
              var U = T + z;
              if (U > R) {
                var J = Math.ceil((U - R) / 1024 / 1024);
                throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${J}MB`);
              }
              T = U;
            }
            return s.resetMaxMemoryUsage = function(z) {
              T = 0, R = z;
            }, s.getBytesAllocated = function() {
              return T;
            }, s.requestMemoryAllocation = L, s;
          }();
          typeof Z < "u" ? Z.exports = y : typeof ne < "u" && (ne["jpeg-js"] = ne["jpeg-js"] || {}, ne["jpeg-js"].decode = y);
          function y(E, d = {}) {
            var l = {
              // "undefined" means "Choose whether to transform colors based on the image’s color model."
              colorTransform: void 0,
              useTArray: !1,
              formatAsRGBA: !0,
              tolerantDecoding: !0,
              maxResolutionInMP: 100,
              // Don't decode more than 100 megapixels
              maxMemoryUsageInMB: 512
              // Don't decode if memory footprint is more than 512MB
            }, u = { ...l, ...d }, a = new Uint8Array(E), n = new x();
            n.opts = u, x.resetMaxMemoryUsage(u.maxMemoryUsageInMB * 1024 * 1024), n.parse(a);
            var c = u.formatAsRGBA ? 4 : 3, g = n.width * n.height * c;
            try {
              x.requestMemoryAllocation(g);
              var f = {
                width: n.width,
                height: n.height,
                exifBuffer: n.exifBuffer,
                data: u.useTArray ? new Uint8Array(g) : new P(g)
              };
            } catch (p) {
              throw p instanceof RangeError ? new Error("Could not allocate enough memory for the image. Required: " + g) : p;
            }
            return n.copyToImageData(f, u.formatAsRGBA), f;
          }
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 82: [function(C, Z, _) {
        (function(P) {
          function x(E) {
            var d = Math.floor, l = new Array(64), u = new Array(64), a = new Array(64), n = new Array(64), c, g, f, p, s = new Array(65535), S = new Array(65535), b = new Array(64), o = new Array(64), A = [], T = 0, R = 7, L = new Array(64), z = new Array(64), U = new Array(64), J = new Array(256), F = new Array(2048), se, ee = [
              0,
              1,
              5,
              6,
              14,
              15,
              27,
              28,
              2,
              4,
              7,
              13,
              16,
              26,
              29,
              42,
              3,
              8,
              12,
              17,
              25,
              30,
              41,
              43,
              9,
              11,
              18,
              24,
              31,
              40,
              44,
              53,
              10,
              19,
              23,
              32,
              39,
              45,
              52,
              54,
              20,
              22,
              33,
              38,
              46,
              51,
              55,
              60,
              21,
              34,
              37,
              47,
              50,
              56,
              59,
              61,
              35,
              36,
              48,
              49,
              57,
              58,
              62,
              63
            ], ie = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], W = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], Q = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], de = [
              1,
              2,
              3,
              0,
              4,
              17,
              5,
              18,
              33,
              49,
              65,
              6,
              19,
              81,
              97,
              7,
              34,
              113,
              20,
              50,
              129,
              145,
              161,
              8,
              35,
              66,
              177,
              193,
              21,
              82,
              209,
              240,
              36,
              51,
              98,
              114,
              130,
              9,
              10,
              22,
              23,
              24,
              25,
              26,
              37,
              38,
              39,
              40,
              41,
              42,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              67,
              68,
              69,
              70,
              71,
              72,
              73,
              74,
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90,
              99,
              100,
              101,
              102,
              103,
              104,
              105,
              106,
              115,
              116,
              117,
              118,
              119,
              120,
              121,
              122,
              131,
              132,
              133,
              134,
              135,
              136,
              137,
              138,
              146,
              147,
              148,
              149,
              150,
              151,
              152,
              153,
              154,
              162,
              163,
              164,
              165,
              166,
              167,
              168,
              169,
              170,
              178,
              179,
              180,
              181,
              182,
              183,
              184,
              185,
              186,
              194,
              195,
              196,
              197,
              198,
              199,
              200,
              201,
              202,
              210,
              211,
              212,
              213,
              214,
              215,
              216,
              217,
              218,
              225,
              226,
              227,
              228,
              229,
              230,
              231,
              232,
              233,
              234,
              241,
              242,
              243,
              244,
              245,
              246,
              247,
              248,
              249,
              250
            ], _e = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], ke = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], Pe = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], fe = [
              0,
              1,
              2,
              3,
              17,
              4,
              5,
              33,
              49,
              6,
              18,
              65,
              81,
              7,
              97,
              113,
              19,
              34,
              50,
              129,
              8,
              20,
              66,
              145,
              161,
              177,
              193,
              9,
              35,
              51,
              82,
              240,
              21,
              98,
              114,
              209,
              10,
              22,
              36,
              52,
              225,
              37,
              241,
              23,
              24,
              25,
              26,
              38,
              39,
              40,
              41,
              42,
              53,
              54,
              55,
              56,
              57,
              58,
              67,
              68,
              69,
              70,
              71,
              72,
              73,
              74,
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90,
              99,
              100,
              101,
              102,
              103,
              104,
              105,
              106,
              115,
              116,
              117,
              118,
              119,
              120,
              121,
              122,
              130,
              131,
              132,
              133,
              134,
              135,
              136,
              137,
              138,
              146,
              147,
              148,
              149,
              150,
              151,
              152,
              153,
              154,
              162,
              163,
              164,
              165,
              166,
              167,
              168,
              169,
              170,
              178,
              179,
              180,
              181,
              182,
              183,
              184,
              185,
              186,
              194,
              195,
              196,
              197,
              198,
              199,
              200,
              201,
              202,
              210,
              211,
              212,
              213,
              214,
              215,
              216,
              217,
              218,
              226,
              227,
              228,
              229,
              230,
              231,
              232,
              233,
              234,
              242,
              243,
              244,
              245,
              246,
              247,
              248,
              249,
              250
            ];
            function xe(G) {
              for (var Ae = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
              ], e = 0; e < 64; e++) {
                var r = d((Ae[e] * G + 50) / 100);
                r < 1 ? r = 1 : r > 255 && (r = 255), l[ee[e]] = r;
              }
              for (var h = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
              ], k = 0; k < 64; k++) {
                var I = d((h[k] * G + 50) / 100);
                I < 1 ? I = 1 : I > 255 && (I = 255), u[ee[k]] = I;
              }
              for (var B = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                0.785694958,
                0.5411961,
                0.275899379
              ], j = 0, H = 0; H < 8; H++)
                for (var X = 0; X < 8; X++)
                  a[j] = 1 / (l[ee[j]] * B[H] * B[X] * 8), n[j] = 1 / (u[ee[j]] * B[H] * B[X] * 8), j++;
            }
            function Ee(G, Ae) {
              for (var e = 0, r = 0, h = new Array(), k = 1; k <= 16; k++) {
                for (var I = 1; I <= G[k]; I++)
                  h[Ae[r]] = [], h[Ae[r]][0] = e, h[Ae[r]][1] = k, r++, e++;
                e *= 2;
              }
              return h;
            }
            function Ie() {
              c = Ee(ie, W), g = Ee(_e, ke), f = Ee(Q, de), p = Ee(Pe, fe);
            }
            function je() {
              for (var G = 1, Ae = 2, e = 1; e <= 15; e++) {
                for (var r = G; r < Ae; r++)
                  S[32767 + r] = e, s[32767 + r] = [], s[32767 + r][1] = e, s[32767 + r][0] = r;
                for (var h = -(Ae - 1); h <= -G; h++)
                  S[32767 + h] = e, s[32767 + h] = [], s[32767 + h][1] = e, s[32767 + h][0] = Ae - 1 + h;
                G <<= 1, Ae <<= 1;
              }
            }
            function Ue() {
              for (var G = 0; G < 256; G++)
                F[G] = 19595 * G, F[G + 256 >> 0] = 38470 * G, F[G + 512 >> 0] = 7471 * G + 32768, F[G + 768 >> 0] = -11059 * G, F[G + 1024 >> 0] = -21709 * G, F[G + 1280 >> 0] = 32768 * G + 8421375, F[G + 1536 >> 0] = -27439 * G, F[G + 1792 >> 0] = -5329 * G;
            }
            function He(G) {
              for (var Ae = G[0], e = G[1] - 1; e >= 0; )
                Ae & 1 << e && (T |= 1 << R), e--, R--, R < 0 && (T == 255 ? (Ze(255), Ze(0)) : Ze(T), R = 7, T = 0);
            }
            function Ze(G) {
              A.push(G);
            }
            function $e(G) {
              Ze(G >> 8 & 255), Ze(G & 255);
            }
            function We(G, Ae) {
              var e, r, h, k, I, B, j, H, X = 0, ue, pe = 8, M = 64;
              for (ue = 0; ue < pe; ++ue) {
                e = G[X], r = G[X + 1], h = G[X + 2], k = G[X + 3], I = G[X + 4], B = G[X + 5], j = G[X + 6], H = G[X + 7];
                var q = e + H, K = e - H, be = r + j, te = r - j, he = h + B, D = h - B, Se = k + I, le = k - I, m = q + Se, oe = q - Se, me = be + he, O = be - he;
                G[X] = m + me, G[X + 4] = m - me;
                var ce = (O + oe) * 0.707106781;
                G[X + 2] = oe + ce, G[X + 6] = oe - ce, m = le + D, me = D + te, O = te + K;
                var Oe = (m - O) * 0.382683433, Be = 0.5411961 * m + Oe, Ge = 1.306562965 * O + Oe, Fe = me * 0.707106781, Ye = K + Fe, Ke = K - Fe;
                G[X + 5] = Ke + Be, G[X + 3] = Ke - Be, G[X + 1] = Ye + Ge, G[X + 7] = Ye - Ge, X += 8;
              }
              for (X = 0, ue = 0; ue < pe; ++ue) {
                e = G[X], r = G[X + 8], h = G[X + 16], k = G[X + 24], I = G[X + 32], B = G[X + 40], j = G[X + 48], H = G[X + 56];
                var et = e + H, Je = e - H, nt = r + j, pt = r - j, vt = h + B, bt = h - B, At = k + I, ot = k - I, ct = et + At, gt = et - At, Ct = nt + vt, xt = nt - vt;
                G[X] = ct + Ct, G[X + 32] = ct - Ct;
                var Ot = (xt + gt) * 0.707106781;
                G[X + 16] = gt + Ot, G[X + 48] = gt - Ot, ct = ot + bt, Ct = bt + pt, xt = pt + Je;
                var Nt = (ct - xt) * 0.382683433, Pt = 0.5411961 * ct + Nt, Gt = 1.306562965 * xt + Nt, Bt = Ct * 0.707106781, or = Je + Bt, ar = Je - Bt;
                G[X + 40] = ar + Pt, G[X + 24] = ar - Pt, G[X + 8] = or + Gt, G[X + 56] = or - Gt, X++;
              }
              var ur;
              for (ue = 0; ue < M; ++ue)
                ur = G[ue] * Ae[ue], b[ue] = ur > 0 ? ur + 0.5 | 0 : ur - 0.5 | 0;
              return b;
            }
            function Ve() {
              $e(65504), $e(16), Ze(74), Ze(70), Ze(73), Ze(70), Ze(0), Ze(1), Ze(1), Ze(0), $e(1), $e(1), Ze(0), Ze(0);
            }
            function Re(G) {
              if (G) {
                $e(65505), G[0] === 69 && G[1] === 120 && G[2] === 105 && G[3] === 102 ? $e(G.length + 2) : ($e(G.length + 5 + 2), Ze(69), Ze(120), Ze(105), Ze(102), Ze(0));
                for (var Ae = 0; Ae < G.length; Ae++)
                  Ze(G[Ae]);
              }
            }
            function De(G, Ae) {
              $e(65472), $e(17), Ze(8), $e(Ae), $e(G), Ze(3), Ze(1), Ze(17), Ze(0), Ze(2), Ze(17), Ze(1), Ze(3), Ze(17), Ze(1);
            }
            function Ne() {
              $e(65499), $e(132), Ze(0);
              for (var G = 0; G < 64; G++)
                Ze(l[G]);
              Ze(1);
              for (var Ae = 0; Ae < 64; Ae++)
                Ze(u[Ae]);
            }
            function we() {
              $e(65476), $e(418), Ze(0);
              for (var G = 0; G < 16; G++)
                Ze(ie[G + 1]);
              for (var Ae = 0; Ae <= 11; Ae++)
                Ze(W[Ae]);
              Ze(16);
              for (var e = 0; e < 16; e++)
                Ze(Q[e + 1]);
              for (var r = 0; r <= 161; r++)
                Ze(de[r]);
              Ze(1);
              for (var h = 0; h < 16; h++)
                Ze(_e[h + 1]);
              for (var k = 0; k <= 11; k++)
                Ze(ke[k]);
              Ze(17);
              for (var I = 0; I < 16; I++)
                Ze(Pe[I + 1]);
              for (var B = 0; B <= 161; B++)
                Ze(fe[B]);
            }
            function re() {
              $e(65498), $e(12), Ze(3), Ze(1), Ze(0), Ze(2), Ze(17), Ze(3), Ze(17), Ze(0), Ze(63), Ze(0);
            }
            function $(G, Ae, e, r, h) {
              for (var k = h[0], I = h[240], B, j = 16, H = 63, X = 64, ue = We(G, Ae), pe = 0; pe < X; ++pe)
                o[ee[pe]] = ue[pe];
              var M = o[0] - e;
              e = o[0], M == 0 ? He(r[0]) : (B = 32767 + M, He(r[S[B]]), He(s[B]));
              for (var q = 63; q > 0 && o[q] == 0; q--)
                ;
              if (q == 0)
                return He(k), e;
              for (var K = 1, be; K <= q; ) {
                for (var te = K; o[K] == 0 && K <= q; ++K)
                  ;
                var he = K - te;
                if (he >= j) {
                  be = he >> 4;
                  for (var D = 1; D <= be; ++D)
                    He(I);
                  he = he & 15;
                }
                B = 32767 + o[K], He(h[(he << 4) + S[B]]), He(s[B]), K++;
              }
              return q != H && He(k), e;
            }
            function Ce() {
              for (var G = String.fromCharCode, Ae = 0; Ae < 256; Ae++)
                J[Ae] = G(Ae);
            }
            this.encode = function(G, Ae) {
              (/* @__PURE__ */ new Date()).getTime(), Ae && ve(Ae), A = new Array(), T = 0, R = 7, $e(65496), Ve(), Re(G.exifBuffer), Ne(), De(G.width, G.height), we(), re();
              var e = 0, r = 0, h = 0;
              T = 0, R = 7, this.encode.displayName = "_encode_";
              for (var k = G.data, I = G.width, B = G.height, j = I * 4, H, X = 0, ue, pe, M, q, K, be, te, he; X < B; ) {
                for (H = 0; H < j; ) {
                  for (q = j * X + H, K = q, be = -1, te = 0, he = 0; he < 64; he++)
                    te = he >> 3, be = (he & 7) * 4, K = q + te * j + be, X + te >= B && (K -= j * (X + 1 + te - B)), H + be >= j && (K -= H + be - j + 4), ue = k[K++], pe = k[K++], M = k[K++], L[he] = (F[ue] + F[pe + 256 >> 0] + F[M + 512 >> 0] >> 16) - 128, z[he] = (F[ue + 768 >> 0] + F[pe + 1024 >> 0] + F[M + 1280 >> 0] >> 16) - 128, U[he] = (F[ue + 1280 >> 0] + F[pe + 1536 >> 0] + F[M + 1792 >> 0] >> 16) - 128;
                  e = $(L, a, e, c, f), r = $(z, n, r, g, p), h = $(U, n, h, g, p), H += 32;
                }
                X += 8;
              }
              if (R >= 0) {
                var D = [];
                D[1] = R + 1, D[0] = (1 << R + 1) - 1, He(D);
              }
              return $e(65497), typeof Z > "u" ? new Uint8Array(A) : new P(A);
            };
            function ve(G) {
              if (G <= 0 && (G = 1), G > 100 && (G = 100), se != G) {
                var Ae = 0;
                G < 50 ? Ae = Math.floor(5e3 / G) : Ae = Math.floor(200 - G * 2), xe(Ae), se = G;
              }
            }
            function Y() {
              var G = (/* @__PURE__ */ new Date()).getTime();
              E || (E = 50), Ce(), Ie(), je(), Ue(), ve(E), (/* @__PURE__ */ new Date()).getTime() - G;
            }
            Y();
          }
          typeof Z < "u" ? Z.exports = y : typeof ne < "u" && (ne["jpeg-js"] = ne["jpeg-js"] || {}, ne["jpeg-js"].encode = y);
          function y(E, d) {
            typeof d > "u" && (d = 50);
            var l = new x(d), u = l.encode(E, d);
            return {
              data: u,
              width: E.width,
              height: E.height
            };
          }
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 83: [function(C, Z, _) {
        (function(P) {
          var x = C("path"), y = C("fs"), E = parseInt("0777", 8);
          Z.exports = d.mkdirp = d.mkdirP = d;
          function d(l, u, a, n) {
            typeof u == "function" ? (a = u, u = {}) : (!u || typeof u != "object") && (u = { mode: u });
            var c = u.mode, g = u.fs || y;
            c === void 0 && (c = E & ~P.umask()), n || (n = null);
            var f = a || function() {
            };
            l = x.resolve(l), g.mkdir(l, c, function(p) {
              if (!p)
                return n = n || l, f(null, n);
              switch (p.code) {
                case "ENOENT":
                  d(x.dirname(l), u, function(s, S) {
                    s ? f(s, S) : d(l, u, f, S);
                  });
                  break;
                // In the case of any other error, just see if there's a dir
                // there already.  If so, then hooray!  If not, then something
                // is borked.
                default:
                  g.stat(l, function(s, S) {
                    s || !S.isDirectory() ? f(p, n) : f(null, n);
                  });
                  break;
              }
            });
          }
          d.sync = function l(u, a, n) {
            (!a || typeof a != "object") && (a = { mode: a });
            var c = a.mode, g = a.fs || y;
            c === void 0 && (c = E & ~P.umask()), n || (n = null), u = x.resolve(u);
            try {
              g.mkdirSync(u, c), n = n || u;
            } catch (p) {
              switch (p.code) {
                case "ENOENT":
                  n = l(x.dirname(u), a, n), l(u, a, n);
                  break;
                // In the case of any other error, just see if there's a dir
                // there already.  If so, then hooray!  If not, then something
                // is borked.
                default:
                  var f;
                  try {
                    f = g.statSync(u);
                  } catch {
                    throw p;
                  }
                  if (!f.isDirectory()) throw p;
                  break;
              }
            }
            return n;
          };
        }).call(this, C("_process"));
      }, { _process: 133, fs: 47, path: 107 }], 84: [function(C, Z, _) {
        var P = Object.getOwnPropertySymbols, x = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
        function E(l) {
          if (l == null)
            throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(l);
        }
        function d() {
          try {
            if (!Object.assign)
              return !1;
            var l = new String("abc");
            if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
              return !1;
            for (var u = {}, a = 0; a < 10; a++)
              u["_" + String.fromCharCode(a)] = a;
            var n = Object.getOwnPropertyNames(u).map(function(g) {
              return u[g];
            });
            if (n.join("") !== "0123456789")
              return !1;
            var c = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(g) {
              c[g] = g;
            }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
          } catch {
            return !1;
          }
        }
        Z.exports = d() ? Object.assign : function(l, u) {
          for (var a, n = E(l), c, g = 1; g < arguments.length; g++) {
            a = Object(arguments[g]);
            for (var f in a)
              x.call(a, f) && (n[f] = a[f]);
            if (P) {
              c = P(a);
              for (var p = 0; p < c.length; p++)
                y.call(a, c[p]) && (n[c[p]] = a[c[p]]);
            }
          }
          return n;
        };
      }, {}], 85: [function(C, Z, _) {
        arguments[4][64][0].apply(_, arguments);
      }, { dup: 64 }], 86: [function(C, Z, _) {
        var P = C("./lib/utils/common").assign, x = C("./lib/deflate"), y = C("./lib/inflate"), E = C("./lib/zlib/constants"), d = {};
        P(d, x, y, E), Z.exports = d;
      }, { "./lib/deflate": 87, "./lib/inflate": 88, "./lib/utils/common": 89, "./lib/zlib/constants": 92 }], 87: [function(C, Z, _) {
        var P = C("./zlib/deflate"), x = C("./utils/common"), y = C("./utils/strings"), E = C("./zlib/messages"), d = C("./zlib/zstream"), l = Object.prototype.toString, u = 0, a = 4, n = 0, c = 1, g = 2, f = -1, p = 0, s = 8;
        function S(T) {
          if (!(this instanceof S)) return new S(T);
          this.options = x.assign({
            level: f,
            method: s,
            chunkSize: 16384,
            windowBits: 15,
            memLevel: 8,
            strategy: p,
            to: ""
          }, T || {});
          var R = this.options;
          R.raw && R.windowBits > 0 ? R.windowBits = -R.windowBits : R.gzip && R.windowBits > 0 && R.windowBits < 16 && (R.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new d(), this.strm.avail_out = 0;
          var L = P.deflateInit2(
            this.strm,
            R.level,
            R.method,
            R.windowBits,
            R.memLevel,
            R.strategy
          );
          if (L !== n)
            throw new Error(E[L]);
          if (R.header && P.deflateSetHeader(this.strm, R.header), R.dictionary) {
            var z;
            if (typeof R.dictionary == "string" ? z = y.string2buf(R.dictionary) : l.call(R.dictionary) === "[object ArrayBuffer]" ? z = new Uint8Array(R.dictionary) : z = R.dictionary, L = P.deflateSetDictionary(this.strm, z), L !== n)
              throw new Error(E[L]);
            this._dict_set = !0;
          }
        }
        S.prototype.push = function(T, R) {
          var L = this.strm, z = this.options.chunkSize, U, J;
          if (this.ended)
            return !1;
          J = R === ~~R ? R : R === !0 ? a : u, typeof T == "string" ? L.input = y.string2buf(T) : l.call(T) === "[object ArrayBuffer]" ? L.input = new Uint8Array(T) : L.input = T, L.next_in = 0, L.avail_in = L.input.length;
          do {
            if (L.avail_out === 0 && (L.output = new x.Buf8(z), L.next_out = 0, L.avail_out = z), U = P.deflate(L, J), U !== c && U !== n)
              return this.onEnd(U), this.ended = !0, !1;
            (L.avail_out === 0 || L.avail_in === 0 && (J === a || J === g)) && (this.options.to === "string" ? this.onData(y.buf2binstring(x.shrinkBuf(L.output, L.next_out))) : this.onData(x.shrinkBuf(L.output, L.next_out)));
          } while ((L.avail_in > 0 || L.avail_out === 0) && U !== c);
          return J === a ? (U = P.deflateEnd(this.strm), this.onEnd(U), this.ended = !0, U === n) : (J === g && (this.onEnd(n), L.avail_out = 0), !0);
        }, S.prototype.onData = function(T) {
          this.chunks.push(T);
        }, S.prototype.onEnd = function(T) {
          T === n && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = x.flattenChunks(this.chunks)), this.chunks = [], this.err = T, this.msg = this.strm.msg;
        };
        function b(T, R) {
          var L = new S(R);
          if (L.push(T, !0), L.err)
            throw L.msg || E[L.err];
          return L.result;
        }
        function o(T, R) {
          return R = R || {}, R.raw = !0, b(T, R);
        }
        function A(T, R) {
          return R = R || {}, R.gzip = !0, b(T, R);
        }
        _.Deflate = S, _.deflate = b, _.deflateRaw = o, _.gzip = A;
      }, { "./utils/common": 89, "./utils/strings": 90, "./zlib/deflate": 94, "./zlib/messages": 99, "./zlib/zstream": 101 }], 88: [function(C, Z, _) {
        var P = C("./zlib/inflate"), x = C("./utils/common"), y = C("./utils/strings"), E = C("./zlib/constants"), d = C("./zlib/messages"), l = C("./zlib/zstream"), u = C("./zlib/gzheader"), a = Object.prototype.toString;
        function n(f) {
          if (!(this instanceof n)) return new n(f);
          this.options = x.assign({
            chunkSize: 16384,
            windowBits: 0,
            to: ""
          }, f || {});
          var p = this.options;
          p.raw && p.windowBits >= 0 && p.windowBits < 16 && (p.windowBits = -p.windowBits, p.windowBits === 0 && (p.windowBits = -15)), p.windowBits >= 0 && p.windowBits < 16 && !(f && f.windowBits) && (p.windowBits += 32), p.windowBits > 15 && p.windowBits < 48 && (p.windowBits & 15) === 0 && (p.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l(), this.strm.avail_out = 0;
          var s = P.inflateInit2(
            this.strm,
            p.windowBits
          );
          if (s !== E.Z_OK)
            throw new Error(d[s]);
          this.header = new u(), P.inflateGetHeader(this.strm, this.header);
        }
        n.prototype.push = function(f, p) {
          var s = this.strm, S = this.options.chunkSize, b = this.options.dictionary, o, A, T, R, L, z, U = !1;
          if (this.ended)
            return !1;
          A = p === ~~p ? p : p === !0 ? E.Z_FINISH : E.Z_NO_FLUSH, typeof f == "string" ? s.input = y.binstring2buf(f) : a.call(f) === "[object ArrayBuffer]" ? s.input = new Uint8Array(f) : s.input = f, s.next_in = 0, s.avail_in = s.input.length;
          do {
            if (s.avail_out === 0 && (s.output = new x.Buf8(S), s.next_out = 0, s.avail_out = S), o = P.inflate(s, E.Z_NO_FLUSH), o === E.Z_NEED_DICT && b && (typeof b == "string" ? z = y.string2buf(b) : a.call(b) === "[object ArrayBuffer]" ? z = new Uint8Array(b) : z = b, o = P.inflateSetDictionary(this.strm, z)), o === E.Z_BUF_ERROR && U === !0 && (o = E.Z_OK, U = !1), o !== E.Z_STREAM_END && o !== E.Z_OK)
              return this.onEnd(o), this.ended = !0, !1;
            s.next_out && (s.avail_out === 0 || o === E.Z_STREAM_END || s.avail_in === 0 && (A === E.Z_FINISH || A === E.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (T = y.utf8border(s.output, s.next_out), R = s.next_out - T, L = y.buf2string(s.output, T), s.next_out = R, s.avail_out = S - R, R && x.arraySet(s.output, s.output, T, R, 0), this.onData(L)) : this.onData(x.shrinkBuf(s.output, s.next_out))), s.avail_in === 0 && s.avail_out === 0 && (U = !0);
          } while ((s.avail_in > 0 || s.avail_out === 0) && o !== E.Z_STREAM_END);
          return o === E.Z_STREAM_END && (A = E.Z_FINISH), A === E.Z_FINISH ? (o = P.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, o === E.Z_OK) : (A === E.Z_SYNC_FLUSH && (this.onEnd(E.Z_OK), s.avail_out = 0), !0);
        }, n.prototype.onData = function(f) {
          this.chunks.push(f);
        }, n.prototype.onEnd = function(f) {
          f === E.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = x.flattenChunks(this.chunks)), this.chunks = [], this.err = f, this.msg = this.strm.msg;
        };
        function c(f, p) {
          var s = new n(p);
          if (s.push(f, !0), s.err)
            throw s.msg || d[s.err];
          return s.result;
        }
        function g(f, p) {
          return p = p || {}, p.raw = !0, c(f, p);
        }
        _.Inflate = n, _.inflate = c, _.inflateRaw = g, _.ungzip = c;
      }, { "./utils/common": 89, "./utils/strings": 90, "./zlib/constants": 92, "./zlib/gzheader": 95, "./zlib/inflate": 97, "./zlib/messages": 99, "./zlib/zstream": 101 }], 89: [function(C, Z, _) {
        arguments[4][36][0].apply(_, arguments);
      }, { dup: 36 }], 90: [function(C, Z, _) {
        var P = C("./common"), x = !0, y = !0;
        try {
          String.fromCharCode.apply(null, [0]);
        } catch {
          x = !1;
        }
        try {
          String.fromCharCode.apply(null, new Uint8Array(1));
        } catch {
          y = !1;
        }
        for (var E = new P.Buf8(256), d = 0; d < 256; d++)
          E[d] = d >= 252 ? 6 : d >= 248 ? 5 : d >= 240 ? 4 : d >= 224 ? 3 : d >= 192 ? 2 : 1;
        E[254] = E[254] = 1, _.string2buf = function(u) {
          var a, n, c, g, f, p = u.length, s = 0;
          for (g = 0; g < p; g++)
            n = u.charCodeAt(g), (n & 64512) === 55296 && g + 1 < p && (c = u.charCodeAt(g + 1), (c & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (c - 56320), g++)), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
          for (a = new P.Buf8(s), f = 0, g = 0; f < s; g++)
            n = u.charCodeAt(g), (n & 64512) === 55296 && g + 1 < p && (c = u.charCodeAt(g + 1), (c & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (c - 56320), g++)), n < 128 ? a[f++] = n : n < 2048 ? (a[f++] = 192 | n >>> 6, a[f++] = 128 | n & 63) : n < 65536 ? (a[f++] = 224 | n >>> 12, a[f++] = 128 | n >>> 6 & 63, a[f++] = 128 | n & 63) : (a[f++] = 240 | n >>> 18, a[f++] = 128 | n >>> 12 & 63, a[f++] = 128 | n >>> 6 & 63, a[f++] = 128 | n & 63);
          return a;
        };
        function l(u, a) {
          if (a < 65537 && (u.subarray && y || !u.subarray && x))
            return String.fromCharCode.apply(null, P.shrinkBuf(u, a));
          for (var n = "", c = 0; c < a; c++)
            n += String.fromCharCode(u[c]);
          return n;
        }
        _.buf2binstring = function(u) {
          return l(u, u.length);
        }, _.binstring2buf = function(u) {
          for (var a = new P.Buf8(u.length), n = 0, c = a.length; n < c; n++)
            a[n] = u.charCodeAt(n);
          return a;
        }, _.buf2string = function(u, a) {
          var n, c, g, f, p = a || u.length, s = new Array(p * 2);
          for (c = 0, n = 0; n < p; ) {
            if (g = u[n++], g < 128) {
              s[c++] = g;
              continue;
            }
            if (f = E[g], f > 4) {
              s[c++] = 65533, n += f - 1;
              continue;
            }
            for (g &= f === 2 ? 31 : f === 3 ? 15 : 7; f > 1 && n < p; )
              g = g << 6 | u[n++] & 63, f--;
            if (f > 1) {
              s[c++] = 65533;
              continue;
            }
            g < 65536 ? s[c++] = g : (g -= 65536, s[c++] = 55296 | g >> 10 & 1023, s[c++] = 56320 | g & 1023);
          }
          return l(s, c);
        }, _.utf8border = function(u, a) {
          var n;
          for (a = a || u.length, a > u.length && (a = u.length), n = a - 1; n >= 0 && (u[n] & 192) === 128; )
            n--;
          return n < 0 || n === 0 ? a : n + E[u[n]] > a ? n : a;
        };
      }, { "./common": 89 }], 91: [function(C, Z, _) {
        arguments[4][37][0].apply(_, arguments);
      }, { dup: 37 }], 92: [function(C, Z, _) {
        arguments[4][38][0].apply(_, arguments);
      }, { dup: 38 }], 93: [function(C, Z, _) {
        arguments[4][39][0].apply(_, arguments);
      }, { dup: 39 }], 94: [function(C, Z, _) {
        var P = C("../utils/common"), x = C("./trees"), y = C("./adler32"), E = C("./crc32"), d = C("./messages"), l = 0, u = 1, a = 3, n = 4, c = 5, g = 0, f = 1, p = -2, s = -3, S = -5, b = -1, o = 1, A = 2, T = 3, R = 4, L = 0, z = 2, U = 8, J = 9, F = 15, se = 8, ee = 29, ie = 256, W = ie + 1 + ee, Q = 30, de = 19, _e = 2 * W + 1, ke = 15, Pe = 3, fe = 258, xe = fe + Pe + 1, Ee = 32, Ie = 42, je = 69, Ue = 73, He = 91, Ze = 103, $e = 113, We = 666, Ve = 1, Re = 2, De = 3, Ne = 4, we = 3;
        function re(m, oe) {
          return m.msg = d[oe], oe;
        }
        function $(m) {
          return (m << 1) - (m > 4 ? 9 : 0);
        }
        function Ce(m) {
          for (var oe = m.length; --oe >= 0; )
            m[oe] = 0;
        }
        function ve(m) {
          var oe = m.state, me = oe.pending;
          me > m.avail_out && (me = m.avail_out), me !== 0 && (P.arraySet(m.output, oe.pending_buf, oe.pending_out, me, m.next_out), m.next_out += me, oe.pending_out += me, m.total_out += me, m.avail_out -= me, oe.pending -= me, oe.pending === 0 && (oe.pending_out = 0));
        }
        function Y(m, oe) {
          x._tr_flush_block(m, m.block_start >= 0 ? m.block_start : -1, m.strstart - m.block_start, oe), m.block_start = m.strstart, ve(m.strm);
        }
        function G(m, oe) {
          m.pending_buf[m.pending++] = oe;
        }
        function Ae(m, oe) {
          m.pending_buf[m.pending++] = oe >>> 8 & 255, m.pending_buf[m.pending++] = oe & 255;
        }
        function e(m, oe, me, O) {
          var ce = m.avail_in;
          return ce > O && (ce = O), ce === 0 ? 0 : (m.avail_in -= ce, P.arraySet(oe, m.input, m.next_in, ce, me), m.state.wrap === 1 ? m.adler = y(m.adler, oe, ce, me) : m.state.wrap === 2 && (m.adler = E(m.adler, oe, ce, me)), m.next_in += ce, m.total_in += ce, ce);
        }
        function r(m, oe) {
          var me = m.max_chain_length, O = m.strstart, ce, Oe, Be = m.prev_length, Ge = m.nice_match, Fe = m.strstart > m.w_size - xe ? m.strstart - (m.w_size - xe) : 0, Ye = m.window, Ke = m.w_mask, et = m.prev, Je = m.strstart + fe, nt = Ye[O + Be - 1], pt = Ye[O + Be];
          m.prev_length >= m.good_match && (me >>= 2), Ge > m.lookahead && (Ge = m.lookahead);
          do
            if (ce = oe, !(Ye[ce + Be] !== pt || Ye[ce + Be - 1] !== nt || Ye[ce] !== Ye[O] || Ye[++ce] !== Ye[O + 1])) {
              O += 2, ce++;
              do
                ;
              while (Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && Ye[++O] === Ye[++ce] && O < Je);
              if (Oe = fe - (Je - O), O = Je - fe, Oe > Be) {
                if (m.match_start = oe, Be = Oe, Oe >= Ge)
                  break;
                nt = Ye[O + Be - 1], pt = Ye[O + Be];
              }
            }
          while ((oe = et[oe & Ke]) > Fe && --me !== 0);
          return Be <= m.lookahead ? Be : m.lookahead;
        }
        function h(m) {
          var oe = m.w_size, me, O, ce, Oe, Be;
          do {
            if (Oe = m.window_size - m.lookahead - m.strstart, m.strstart >= oe + (oe - xe)) {
              P.arraySet(m.window, m.window, oe, oe, 0), m.match_start -= oe, m.strstart -= oe, m.block_start -= oe, O = m.hash_size, me = O;
              do
                ce = m.head[--me], m.head[me] = ce >= oe ? ce - oe : 0;
              while (--O);
              O = oe, me = O;
              do
                ce = m.prev[--me], m.prev[me] = ce >= oe ? ce - oe : 0;
              while (--O);
              Oe += oe;
            }
            if (m.strm.avail_in === 0)
              break;
            if (O = e(m.strm, m.window, m.strstart + m.lookahead, Oe), m.lookahead += O, m.lookahead + m.insert >= Pe)
              for (Be = m.strstart - m.insert, m.ins_h = m.window[Be], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[Be + 1]) & m.hash_mask; m.insert && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[Be + Pe - 1]) & m.hash_mask, m.prev[Be & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = Be, Be++, m.insert--, !(m.lookahead + m.insert < Pe)); )
                ;
          } while (m.lookahead < xe && m.strm.avail_in !== 0);
        }
        function k(m, oe) {
          var me = 65535;
          for (me > m.pending_buf_size - 5 && (me = m.pending_buf_size - 5); ; ) {
            if (m.lookahead <= 1) {
              if (h(m), m.lookahead === 0 && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            m.strstart += m.lookahead, m.lookahead = 0;
            var O = m.block_start + me;
            if ((m.strstart === 0 || m.strstart >= O) && (m.lookahead = m.strstart - O, m.strstart = O, Y(m, !1), m.strm.avail_out === 0) || m.strstart - m.block_start >= m.w_size - xe && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : (m.strstart > m.block_start && (Y(m, !1), m.strm.avail_out === 0), Ve);
        }
        function I(m, oe) {
          for (var me, O; ; ) {
            if (m.lookahead < xe) {
              if (h(m), m.lookahead < xe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (me = 0, m.lookahead >= Pe && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), me !== 0 && m.strstart - me <= m.w_size - xe && (m.match_length = r(m, me)), m.match_length >= Pe)
              if (O = x._tr_tally(m, m.strstart - m.match_start, m.match_length - Pe), m.lookahead -= m.match_length, m.match_length <= m.max_lazy_match && m.lookahead >= Pe) {
                m.match_length--;
                do
                  m.strstart++, m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart;
                while (--m.match_length !== 0);
                m.strstart++;
              } else
                m.strstart += m.match_length, m.match_length = 0, m.ins_h = m.window[m.strstart], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + 1]) & m.hash_mask;
            else
              O = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++;
            if (O && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = m.strstart < Pe - 1 ? m.strstart : Pe - 1, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function B(m, oe) {
          for (var me, O, ce; ; ) {
            if (m.lookahead < xe) {
              if (h(m), m.lookahead < xe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (me = 0, m.lookahead >= Pe && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), m.prev_length = m.match_length, m.prev_match = m.match_start, m.match_length = Pe - 1, me !== 0 && m.prev_length < m.max_lazy_match && m.strstart - me <= m.w_size - xe && (m.match_length = r(m, me), m.match_length <= 5 && (m.strategy === o || m.match_length === Pe && m.strstart - m.match_start > 4096) && (m.match_length = Pe - 1)), m.prev_length >= Pe && m.match_length <= m.prev_length) {
              ce = m.strstart + m.lookahead - Pe, O = x._tr_tally(m, m.strstart - 1 - m.prev_match, m.prev_length - Pe), m.lookahead -= m.prev_length - 1, m.prev_length -= 2;
              do
                ++m.strstart <= ce && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + Pe - 1]) & m.hash_mask, me = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart);
              while (--m.prev_length !== 0);
              if (m.match_available = 0, m.match_length = Pe - 1, m.strstart++, O && (Y(m, !1), m.strm.avail_out === 0))
                return Ve;
            } else if (m.match_available) {
              if (O = x._tr_tally(m, 0, m.window[m.strstart - 1]), O && Y(m, !1), m.strstart++, m.lookahead--, m.strm.avail_out === 0)
                return Ve;
            } else
              m.match_available = 1, m.strstart++, m.lookahead--;
          }
          return m.match_available && (O = x._tr_tally(m, 0, m.window[m.strstart - 1]), m.match_available = 0), m.insert = m.strstart < Pe - 1 ? m.strstart : Pe - 1, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function j(m, oe) {
          for (var me, O, ce, Oe, Be = m.window; ; ) {
            if (m.lookahead <= fe) {
              if (h(m), m.lookahead <= fe && oe === l)
                return Ve;
              if (m.lookahead === 0)
                break;
            }
            if (m.match_length = 0, m.lookahead >= Pe && m.strstart > 0 && (ce = m.strstart - 1, O = Be[ce], O === Be[++ce] && O === Be[++ce] && O === Be[++ce])) {
              Oe = m.strstart + fe;
              do
                ;
              while (O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && O === Be[++ce] && ce < Oe);
              m.match_length = fe - (Oe - ce), m.match_length > m.lookahead && (m.match_length = m.lookahead);
            }
            if (m.match_length >= Pe ? (me = x._tr_tally(m, 1, m.match_length - Pe), m.lookahead -= m.match_length, m.strstart += m.match_length, m.match_length = 0) : (me = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++), me && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function H(m, oe) {
          for (var me; ; ) {
            if (m.lookahead === 0 && (h(m), m.lookahead === 0)) {
              if (oe === l)
                return Ve;
              break;
            }
            if (m.match_length = 0, me = x._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++, me && (Y(m, !1), m.strm.avail_out === 0))
              return Ve;
          }
          return m.insert = 0, oe === n ? (Y(m, !0), m.strm.avail_out === 0 ? De : Ne) : m.last_lit && (Y(m, !1), m.strm.avail_out === 0) ? Ve : Re;
        }
        function X(m, oe, me, O, ce) {
          this.good_length = m, this.max_lazy = oe, this.nice_length = me, this.max_chain = O, this.func = ce;
        }
        var ue;
        ue = [
          /*      good lazy nice chain */
          new X(0, 0, 0, 0, k),
          /* 0 store only */
          new X(4, 4, 8, 4, I),
          /* 1 max speed, no lazy matches */
          new X(4, 5, 16, 8, I),
          /* 2 */
          new X(4, 6, 32, 32, I),
          /* 3 */
          new X(4, 4, 16, 16, B),
          /* 4 lazy matches */
          new X(8, 16, 32, 32, B),
          /* 5 */
          new X(8, 16, 128, 128, B),
          /* 6 */
          new X(8, 32, 128, 256, B),
          /* 7 */
          new X(32, 128, 258, 1024, B),
          /* 8 */
          new X(32, 258, 258, 4096, B)
          /* 9 max compression */
        ];
        function pe(m) {
          m.window_size = 2 * m.w_size, Ce(m.head), m.max_lazy_match = ue[m.level].max_lazy, m.good_match = ue[m.level].good_length, m.nice_match = ue[m.level].nice_length, m.max_chain_length = ue[m.level].max_chain, m.strstart = 0, m.block_start = 0, m.lookahead = 0, m.insert = 0, m.match_length = m.prev_length = Pe - 1, m.match_available = 0, m.ins_h = 0;
        }
        function M() {
          this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = U, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new P.Buf16(_e * 2), this.dyn_dtree = new P.Buf16((2 * Q + 1) * 2), this.bl_tree = new P.Buf16((2 * de + 1) * 2), Ce(this.dyn_ltree), Ce(this.dyn_dtree), Ce(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new P.Buf16(ke + 1), this.heap = new P.Buf16(2 * W + 1), Ce(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new P.Buf16(2 * W + 1), Ce(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
        }
        function q(m) {
          var oe;
          return !m || !m.state ? re(m, p) : (m.total_in = m.total_out = 0, m.data_type = z, oe = m.state, oe.pending = 0, oe.pending_out = 0, oe.wrap < 0 && (oe.wrap = -oe.wrap), oe.status = oe.wrap ? Ie : $e, m.adler = oe.wrap === 2 ? 0 : 1, oe.last_flush = l, x._tr_init(oe), g);
        }
        function K(m) {
          var oe = q(m);
          return oe === g && pe(m.state), oe;
        }
        function be(m, oe) {
          return !m || !m.state || m.state.wrap !== 2 ? p : (m.state.gzhead = oe, g);
        }
        function te(m, oe, me, O, ce, Oe) {
          if (!m)
            return p;
          var Be = 1;
          if (oe === b && (oe = 6), O < 0 ? (Be = 0, O = -O) : O > 15 && (Be = 2, O -= 16), ce < 1 || ce > J || me !== U || O < 8 || O > 15 || oe < 0 || oe > 9 || Oe < 0 || Oe > R)
            return re(m, p);
          O === 8 && (O = 9);
          var Ge = new M();
          return m.state = Ge, Ge.strm = m, Ge.wrap = Be, Ge.gzhead = null, Ge.w_bits = O, Ge.w_size = 1 << Ge.w_bits, Ge.w_mask = Ge.w_size - 1, Ge.hash_bits = ce + 7, Ge.hash_size = 1 << Ge.hash_bits, Ge.hash_mask = Ge.hash_size - 1, Ge.hash_shift = ~~((Ge.hash_bits + Pe - 1) / Pe), Ge.window = new P.Buf8(Ge.w_size * 2), Ge.head = new P.Buf16(Ge.hash_size), Ge.prev = new P.Buf16(Ge.w_size), Ge.lit_bufsize = 1 << ce + 6, Ge.pending_buf_size = Ge.lit_bufsize * 4, Ge.pending_buf = new P.Buf8(Ge.pending_buf_size), Ge.d_buf = 1 * Ge.lit_bufsize, Ge.l_buf = 3 * Ge.lit_bufsize, Ge.level = oe, Ge.strategy = Oe, Ge.method = me, K(m);
        }
        function he(m, oe) {
          return te(m, oe, U, F, se, L);
        }
        function D(m, oe) {
          var me, O, ce, Oe;
          if (!m || !m.state || oe > c || oe < 0)
            return m ? re(m, p) : p;
          if (O = m.state, !m.output || !m.input && m.avail_in !== 0 || O.status === We && oe !== n)
            return re(m, m.avail_out === 0 ? S : p);
          if (O.strm = m, me = O.last_flush, O.last_flush = oe, O.status === Ie)
            if (O.wrap === 2)
              m.adler = 0, G(O, 31), G(O, 139), G(O, 8), O.gzhead ? (G(
                O,
                (O.gzhead.text ? 1 : 0) + (O.gzhead.hcrc ? 2 : 0) + (O.gzhead.extra ? 4 : 0) + (O.gzhead.name ? 8 : 0) + (O.gzhead.comment ? 16 : 0)
              ), G(O, O.gzhead.time & 255), G(O, O.gzhead.time >> 8 & 255), G(O, O.gzhead.time >> 16 & 255), G(O, O.gzhead.time >> 24 & 255), G(O, O.level === 9 ? 2 : O.strategy >= A || O.level < 2 ? 4 : 0), G(O, O.gzhead.os & 255), O.gzhead.extra && O.gzhead.extra.length && (G(O, O.gzhead.extra.length & 255), G(O, O.gzhead.extra.length >> 8 & 255)), O.gzhead.hcrc && (m.adler = E(m.adler, O.pending_buf, O.pending, 0)), O.gzindex = 0, O.status = je) : (G(O, 0), G(O, 0), G(O, 0), G(O, 0), G(O, 0), G(O, O.level === 9 ? 2 : O.strategy >= A || O.level < 2 ? 4 : 0), G(O, we), O.status = $e);
            else {
              var Be = U + (O.w_bits - 8 << 4) << 8, Ge = -1;
              O.strategy >= A || O.level < 2 ? Ge = 0 : O.level < 6 ? Ge = 1 : O.level === 6 ? Ge = 2 : Ge = 3, Be |= Ge << 6, O.strstart !== 0 && (Be |= Ee), Be += 31 - Be % 31, O.status = $e, Ae(O, Be), O.strstart !== 0 && (Ae(O, m.adler >>> 16), Ae(O, m.adler & 65535)), m.adler = 1;
            }
          if (O.status === je)
            if (O.gzhead.extra) {
              for (ce = O.pending; O.gzindex < (O.gzhead.extra.length & 65535) && !(O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)); )
                G(O, O.gzhead.extra[O.gzindex] & 255), O.gzindex++;
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), O.gzindex === O.gzhead.extra.length && (O.gzindex = 0, O.status = Ue);
            } else
              O.status = Ue;
          if (O.status === Ue)
            if (O.gzhead.name) {
              ce = O.pending;
              do {
                if (O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)) {
                  Oe = 1;
                  break;
                }
                O.gzindex < O.gzhead.name.length ? Oe = O.gzhead.name.charCodeAt(O.gzindex++) & 255 : Oe = 0, G(O, Oe);
              } while (Oe !== 0);
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), Oe === 0 && (O.gzindex = 0, O.status = He);
            } else
              O.status = He;
          if (O.status === He)
            if (O.gzhead.comment) {
              ce = O.pending;
              do {
                if (O.pending === O.pending_buf_size && (O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), ve(m), ce = O.pending, O.pending === O.pending_buf_size)) {
                  Oe = 1;
                  break;
                }
                O.gzindex < O.gzhead.comment.length ? Oe = O.gzhead.comment.charCodeAt(O.gzindex++) & 255 : Oe = 0, G(O, Oe);
              } while (Oe !== 0);
              O.gzhead.hcrc && O.pending > ce && (m.adler = E(m.adler, O.pending_buf, O.pending - ce, ce)), Oe === 0 && (O.status = Ze);
            } else
              O.status = Ze;
          if (O.status === Ze && (O.gzhead.hcrc ? (O.pending + 2 > O.pending_buf_size && ve(m), O.pending + 2 <= O.pending_buf_size && (G(O, m.adler & 255), G(O, m.adler >> 8 & 255), m.adler = 0, O.status = $e)) : O.status = $e), O.pending !== 0) {
            if (ve(m), m.avail_out === 0)
              return O.last_flush = -1, g;
          } else if (m.avail_in === 0 && $(oe) <= $(me) && oe !== n)
            return re(m, S);
          if (O.status === We && m.avail_in !== 0)
            return re(m, S);
          if (m.avail_in !== 0 || O.lookahead !== 0 || oe !== l && O.status !== We) {
            var Fe = O.strategy === A ? H(O, oe) : O.strategy === T ? j(O, oe) : ue[O.level].func(O, oe);
            if ((Fe === De || Fe === Ne) && (O.status = We), Fe === Ve || Fe === De)
              return m.avail_out === 0 && (O.last_flush = -1), g;
            if (Fe === Re && (oe === u ? x._tr_align(O) : oe !== c && (x._tr_stored_block(O, 0, 0, !1), oe === a && (Ce(O.head), O.lookahead === 0 && (O.strstart = 0, O.block_start = 0, O.insert = 0))), ve(m), m.avail_out === 0))
              return O.last_flush = -1, g;
          }
          return oe !== n ? g : O.wrap <= 0 ? f : (O.wrap === 2 ? (G(O, m.adler & 255), G(O, m.adler >> 8 & 255), G(O, m.adler >> 16 & 255), G(O, m.adler >> 24 & 255), G(O, m.total_in & 255), G(O, m.total_in >> 8 & 255), G(O, m.total_in >> 16 & 255), G(O, m.total_in >> 24 & 255)) : (Ae(O, m.adler >>> 16), Ae(O, m.adler & 65535)), ve(m), O.wrap > 0 && (O.wrap = -O.wrap), O.pending !== 0 ? g : f);
        }
        function Se(m) {
          var oe;
          return !m || !m.state ? p : (oe = m.state.status, oe !== Ie && oe !== je && oe !== Ue && oe !== He && oe !== Ze && oe !== $e && oe !== We ? re(m, p) : (m.state = null, oe === $e ? re(m, s) : g));
        }
        function le(m, oe) {
          var me = oe.length, O, ce, Oe, Be, Ge, Fe, Ye, Ke;
          if (!m || !m.state || (O = m.state, Be = O.wrap, Be === 2 || Be === 1 && O.status !== Ie || O.lookahead))
            return p;
          for (Be === 1 && (m.adler = y(m.adler, oe, me, 0)), O.wrap = 0, me >= O.w_size && (Be === 0 && (Ce(O.head), O.strstart = 0, O.block_start = 0, O.insert = 0), Ke = new P.Buf8(O.w_size), P.arraySet(Ke, oe, me - O.w_size, O.w_size, 0), oe = Ke, me = O.w_size), Ge = m.avail_in, Fe = m.next_in, Ye = m.input, m.avail_in = me, m.next_in = 0, m.input = oe, h(O); O.lookahead >= Pe; ) {
            ce = O.strstart, Oe = O.lookahead - (Pe - 1);
            do
              O.ins_h = (O.ins_h << O.hash_shift ^ O.window[ce + Pe - 1]) & O.hash_mask, O.prev[ce & O.w_mask] = O.head[O.ins_h], O.head[O.ins_h] = ce, ce++;
            while (--Oe);
            O.strstart = ce, O.lookahead = Pe - 1, h(O);
          }
          return O.strstart += O.lookahead, O.block_start = O.strstart, O.insert = O.lookahead, O.lookahead = 0, O.match_length = O.prev_length = Pe - 1, O.match_available = 0, m.next_in = Fe, m.input = Ye, m.avail_in = Ge, O.wrap = Be, g;
        }
        _.deflateInit = he, _.deflateInit2 = te, _.deflateReset = K, _.deflateResetKeep = q, _.deflateSetHeader = be, _.deflate = D, _.deflateEnd = Se, _.deflateSetDictionary = le, _.deflateInfo = "pako deflate (from Nodeca project)";
      }, { "../utils/common": 89, "./adler32": 91, "./crc32": 93, "./messages": 99, "./trees": 100 }], 95: [function(C, Z, _) {
        function P() {
          this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
        }
        Z.exports = P;
      }, {}], 96: [function(C, Z, _) {
        arguments[4][41][0].apply(_, arguments);
      }, { dup: 41 }], 97: [function(C, Z, _) {
        arguments[4][42][0].apply(_, arguments);
      }, { "../utils/common": 89, "./adler32": 91, "./crc32": 93, "./inffast": 96, "./inftrees": 98, dup: 42 }], 98: [function(C, Z, _) {
        arguments[4][43][0].apply(_, arguments);
      }, { "../utils/common": 89, dup: 43 }], 99: [function(C, Z, _) {
        arguments[4][44][0].apply(_, arguments);
      }, { dup: 44 }], 100: [function(C, Z, _) {
        var P = C("../utils/common"), x = 4, y = 0, E = 1, d = 2;
        function l(M) {
          for (var q = M.length; --q >= 0; )
            M[q] = 0;
        }
        var u = 0, a = 1, n = 2, c = 3, g = 258, f = 29, p = 256, s = p + 1 + f, S = 30, b = 19, o = 2 * s + 1, A = 15, T = 16, R = 7, L = 256, z = 16, U = 17, J = 18, F = (
          /* extra bits for each length code */
          [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
        ), se = (
          /* extra bits for each distance code */
          [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
        ), ee = (
          /* extra bits for each bit length code */
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
        ), ie = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], W = 512, Q = new Array((s + 2) * 2);
        l(Q);
        var de = new Array(S * 2);
        l(de);
        var _e = new Array(W);
        l(_e);
        var ke = new Array(g - c + 1);
        l(ke);
        var Pe = new Array(f);
        l(Pe);
        var fe = new Array(S);
        l(fe);
        function xe(M, q, K, be, te) {
          this.static_tree = M, this.extra_bits = q, this.extra_base = K, this.elems = be, this.max_length = te, this.has_stree = M && M.length;
        }
        var Ee, Ie, je;
        function Ue(M, q) {
          this.dyn_tree = M, this.max_code = 0, this.stat_desc = q;
        }
        function He(M) {
          return M < 256 ? _e[M] : _e[256 + (M >>> 7)];
        }
        function Ze(M, q) {
          M.pending_buf[M.pending++] = q & 255, M.pending_buf[M.pending++] = q >>> 8 & 255;
        }
        function $e(M, q, K) {
          M.bi_valid > T - K ? (M.bi_buf |= q << M.bi_valid & 65535, Ze(M, M.bi_buf), M.bi_buf = q >> T - M.bi_valid, M.bi_valid += K - T) : (M.bi_buf |= q << M.bi_valid & 65535, M.bi_valid += K);
        }
        function We(M, q, K) {
          $e(
            M,
            K[q * 2],
            K[q * 2 + 1]
            /*.Len*/
          );
        }
        function Ve(M, q) {
          var K = 0;
          do
            K |= M & 1, M >>>= 1, K <<= 1;
          while (--q > 0);
          return K >>> 1;
        }
        function Re(M) {
          M.bi_valid === 16 ? (Ze(M, M.bi_buf), M.bi_buf = 0, M.bi_valid = 0) : M.bi_valid >= 8 && (M.pending_buf[M.pending++] = M.bi_buf & 255, M.bi_buf >>= 8, M.bi_valid -= 8);
        }
        function De(M, q) {
          var K = q.dyn_tree, be = q.max_code, te = q.stat_desc.static_tree, he = q.stat_desc.has_stree, D = q.stat_desc.extra_bits, Se = q.stat_desc.extra_base, le = q.stat_desc.max_length, m, oe, me, O, ce, Oe, Be = 0;
          for (O = 0; O <= A; O++)
            M.bl_count[O] = 0;
          for (K[M.heap[M.heap_max] * 2 + 1] = 0, m = M.heap_max + 1; m < o; m++)
            oe = M.heap[m], O = K[K[oe * 2 + 1] * 2 + 1] + 1, O > le && (O = le, Be++), K[oe * 2 + 1] = O, !(oe > be) && (M.bl_count[O]++, ce = 0, oe >= Se && (ce = D[oe - Se]), Oe = K[oe * 2], M.opt_len += Oe * (O + ce), he && (M.static_len += Oe * (te[oe * 2 + 1] + ce)));
          if (Be !== 0) {
            do {
              for (O = le - 1; M.bl_count[O] === 0; )
                O--;
              M.bl_count[O]--, M.bl_count[O + 1] += 2, M.bl_count[le]--, Be -= 2;
            } while (Be > 0);
            for (O = le; O !== 0; O--)
              for (oe = M.bl_count[O]; oe !== 0; )
                me = M.heap[--m], !(me > be) && (K[me * 2 + 1] !== O && (M.opt_len += (O - K[me * 2 + 1]) * K[me * 2], K[me * 2 + 1] = O), oe--);
          }
        }
        function Ne(M, q, K) {
          var be = new Array(A + 1), te = 0, he, D;
          for (he = 1; he <= A; he++)
            be[he] = te = te + K[he - 1] << 1;
          for (D = 0; D <= q; D++) {
            var Se = M[D * 2 + 1];
            Se !== 0 && (M[D * 2] = Ve(be[Se]++, Se));
          }
        }
        function we() {
          var M, q, K, be, te, he = new Array(A + 1);
          for (K = 0, be = 0; be < f - 1; be++)
            for (Pe[be] = K, M = 0; M < 1 << F[be]; M++)
              ke[K++] = be;
          for (ke[K - 1] = be, te = 0, be = 0; be < 16; be++)
            for (fe[be] = te, M = 0; M < 1 << se[be]; M++)
              _e[te++] = be;
          for (te >>= 7; be < S; be++)
            for (fe[be] = te << 7, M = 0; M < 1 << se[be] - 7; M++)
              _e[256 + te++] = be;
          for (q = 0; q <= A; q++)
            he[q] = 0;
          for (M = 0; M <= 143; )
            Q[M * 2 + 1] = 8, M++, he[8]++;
          for (; M <= 255; )
            Q[M * 2 + 1] = 9, M++, he[9]++;
          for (; M <= 279; )
            Q[M * 2 + 1] = 7, M++, he[7]++;
          for (; M <= 287; )
            Q[M * 2 + 1] = 8, M++, he[8]++;
          for (Ne(Q, s + 1, he), M = 0; M < S; M++)
            de[M * 2 + 1] = 5, de[M * 2] = Ve(M, 5);
          Ee = new xe(Q, F, p + 1, s, A), Ie = new xe(de, se, 0, S, A), je = new xe(new Array(0), ee, 0, b, R);
        }
        function re(M) {
          var q;
          for (q = 0; q < s; q++)
            M.dyn_ltree[q * 2] = 0;
          for (q = 0; q < S; q++)
            M.dyn_dtree[q * 2] = 0;
          for (q = 0; q < b; q++)
            M.bl_tree[q * 2] = 0;
          M.dyn_ltree[L * 2] = 1, M.opt_len = M.static_len = 0, M.last_lit = M.matches = 0;
        }
        function $(M) {
          M.bi_valid > 8 ? Ze(M, M.bi_buf) : M.bi_valid > 0 && (M.pending_buf[M.pending++] = M.bi_buf), M.bi_buf = 0, M.bi_valid = 0;
        }
        function Ce(M, q, K, be) {
          $(M), Ze(M, K), Ze(M, ~K), P.arraySet(M.pending_buf, M.window, q, K, M.pending), M.pending += K;
        }
        function ve(M, q, K, be) {
          var te = q * 2, he = K * 2;
          return M[te] < M[he] || M[te] === M[he] && be[q] <= be[K];
        }
        function Y(M, q, K) {
          for (var be = M.heap[K], te = K << 1; te <= M.heap_len && (te < M.heap_len && ve(q, M.heap[te + 1], M.heap[te], M.depth) && te++, !ve(q, be, M.heap[te], M.depth)); )
            M.heap[K] = M.heap[te], K = te, te <<= 1;
          M.heap[K] = be;
        }
        function G(M, q, K) {
          var be, te, he = 0, D, Se;
          if (M.last_lit !== 0)
            do
              be = M.pending_buf[M.d_buf + he * 2] << 8 | M.pending_buf[M.d_buf + he * 2 + 1], te = M.pending_buf[M.l_buf + he], he++, be === 0 ? We(M, te, q) : (D = ke[te], We(M, D + p + 1, q), Se = F[D], Se !== 0 && (te -= Pe[D], $e(M, te, Se)), be--, D = He(be), We(M, D, K), Se = se[D], Se !== 0 && (be -= fe[D], $e(M, be, Se)));
            while (he < M.last_lit);
          We(M, L, q);
        }
        function Ae(M, q) {
          var K = q.dyn_tree, be = q.stat_desc.static_tree, te = q.stat_desc.has_stree, he = q.stat_desc.elems, D, Se, le = -1, m;
          for (M.heap_len = 0, M.heap_max = o, D = 0; D < he; D++)
            K[D * 2] !== 0 ? (M.heap[++M.heap_len] = le = D, M.depth[D] = 0) : K[D * 2 + 1] = 0;
          for (; M.heap_len < 2; )
            m = M.heap[++M.heap_len] = le < 2 ? ++le : 0, K[m * 2] = 1, M.depth[m] = 0, M.opt_len--, te && (M.static_len -= be[m * 2 + 1]);
          for (q.max_code = le, D = M.heap_len >> 1; D >= 1; D--)
            Y(M, K, D);
          m = he;
          do
            D = M.heap[
              1
              /*SMALLEST*/
            ], M.heap[
              1
              /*SMALLEST*/
            ] = M.heap[M.heap_len--], Y(
              M,
              K,
              1
              /*SMALLEST*/
            ), Se = M.heap[
              1
              /*SMALLEST*/
            ], M.heap[--M.heap_max] = D, M.heap[--M.heap_max] = Se, K[m * 2] = K[D * 2] + K[Se * 2], M.depth[m] = (M.depth[D] >= M.depth[Se] ? M.depth[D] : M.depth[Se]) + 1, K[D * 2 + 1] = K[Se * 2 + 1] = m, M.heap[
              1
              /*SMALLEST*/
            ] = m++, Y(
              M,
              K,
              1
              /*SMALLEST*/
            );
          while (M.heap_len >= 2);
          M.heap[--M.heap_max] = M.heap[
            1
            /*SMALLEST*/
          ], De(M, q), Ne(K, le, M.bl_count);
        }
        function e(M, q, K) {
          var be, te = -1, he, D = q[0 * 2 + 1], Se = 0, le = 7, m = 4;
          for (D === 0 && (le = 138, m = 3), q[(K + 1) * 2 + 1] = 65535, be = 0; be <= K; be++)
            he = D, D = q[(be + 1) * 2 + 1], !(++Se < le && he === D) && (Se < m ? M.bl_tree[he * 2] += Se : he !== 0 ? (he !== te && M.bl_tree[he * 2]++, M.bl_tree[z * 2]++) : Se <= 10 ? M.bl_tree[U * 2]++ : M.bl_tree[J * 2]++, Se = 0, te = he, D === 0 ? (le = 138, m = 3) : he === D ? (le = 6, m = 3) : (le = 7, m = 4));
        }
        function r(M, q, K) {
          var be, te = -1, he, D = q[0 * 2 + 1], Se = 0, le = 7, m = 4;
          for (D === 0 && (le = 138, m = 3), be = 0; be <= K; be++)
            if (he = D, D = q[(be + 1) * 2 + 1], !(++Se < le && he === D)) {
              if (Se < m)
                do
                  We(M, he, M.bl_tree);
                while (--Se !== 0);
              else he !== 0 ? (he !== te && (We(M, he, M.bl_tree), Se--), We(M, z, M.bl_tree), $e(M, Se - 3, 2)) : Se <= 10 ? (We(M, U, M.bl_tree), $e(M, Se - 3, 3)) : (We(M, J, M.bl_tree), $e(M, Se - 11, 7));
              Se = 0, te = he, D === 0 ? (le = 138, m = 3) : he === D ? (le = 6, m = 3) : (le = 7, m = 4);
            }
        }
        function h(M) {
          var q;
          for (e(M, M.dyn_ltree, M.l_desc.max_code), e(M, M.dyn_dtree, M.d_desc.max_code), Ae(M, M.bl_desc), q = b - 1; q >= 3 && M.bl_tree[ie[q] * 2 + 1] === 0; q--)
            ;
          return M.opt_len += 3 * (q + 1) + 5 + 5 + 4, q;
        }
        function k(M, q, K, be) {
          var te;
          for ($e(M, q - 257, 5), $e(M, K - 1, 5), $e(M, be - 4, 4), te = 0; te < be; te++)
            $e(M, M.bl_tree[ie[te] * 2 + 1], 3);
          r(M, M.dyn_ltree, q - 1), r(M, M.dyn_dtree, K - 1);
        }
        function I(M) {
          var q = 4093624447, K;
          for (K = 0; K <= 31; K++, q >>>= 1)
            if (q & 1 && M.dyn_ltree[K * 2] !== 0)
              return y;
          if (M.dyn_ltree[9 * 2] !== 0 || M.dyn_ltree[10 * 2] !== 0 || M.dyn_ltree[13 * 2] !== 0)
            return E;
          for (K = 32; K < p; K++)
            if (M.dyn_ltree[K * 2] !== 0)
              return E;
          return y;
        }
        var B = !1;
        function j(M) {
          B || (we(), B = !0), M.l_desc = new Ue(M.dyn_ltree, Ee), M.d_desc = new Ue(M.dyn_dtree, Ie), M.bl_desc = new Ue(M.bl_tree, je), M.bi_buf = 0, M.bi_valid = 0, re(M);
        }
        function H(M, q, K, be) {
          $e(M, (u << 1) + (be ? 1 : 0), 3), Ce(M, q, K);
        }
        function X(M) {
          $e(M, a << 1, 3), We(M, L, Q), Re(M);
        }
        function ue(M, q, K, be) {
          var te, he, D = 0;
          M.level > 0 ? (M.strm.data_type === d && (M.strm.data_type = I(M)), Ae(M, M.l_desc), Ae(M, M.d_desc), D = h(M), te = M.opt_len + 3 + 7 >>> 3, he = M.static_len + 3 + 7 >>> 3, he <= te && (te = he)) : te = he = K + 5, K + 4 <= te && q !== -1 ? H(M, q, K, be) : M.strategy === x || he === te ? ($e(M, (a << 1) + (be ? 1 : 0), 3), G(M, Q, de)) : ($e(M, (n << 1) + (be ? 1 : 0), 3), k(M, M.l_desc.max_code + 1, M.d_desc.max_code + 1, D + 1), G(M, M.dyn_ltree, M.dyn_dtree)), re(M), be && $(M);
        }
        function pe(M, q, K) {
          return M.pending_buf[M.d_buf + M.last_lit * 2] = q >>> 8 & 255, M.pending_buf[M.d_buf + M.last_lit * 2 + 1] = q & 255, M.pending_buf[M.l_buf + M.last_lit] = K & 255, M.last_lit++, q === 0 ? M.dyn_ltree[K * 2]++ : (M.matches++, q--, M.dyn_ltree[(ke[K] + p + 1) * 2]++, M.dyn_dtree[He(q) * 2]++), M.last_lit === M.lit_bufsize - 1;
        }
        _._tr_init = j, _._tr_stored_block = H, _._tr_flush_block = ue, _._tr_tally = pe, _._tr_align = X;
      }, { "../utils/common": 89 }], 101: [function(C, Z, _) {
        arguments[4][46][0].apply(_, arguments);
      }, { dup: 46 }], 102: [function(C, Z, _) {
        Z.exports = function(d) {
          if (!d)
            throw new Error("no data provided");
          d = d.toString().trim();
          var l = {
            pages: [],
            chars: [],
            kernings: []
          }, u = d.split(/\r\n?|\n/g);
          if (u.length === 0)
            throw new Error("no data in BMFont file");
          for (var a = 0; a < u.length; a++) {
            var n = P(u[a], a);
            if (n)
              if (n.key === "page") {
                if (typeof n.data.id != "number")
                  throw new Error("malformed file at line " + a + " -- needs page id=N");
                if (typeof n.data.file != "string")
                  throw new Error("malformed file at line " + a + ' -- needs page file="path"');
                l.pages[n.data.id] = n.data.file;
              } else n.key === "chars" || n.key === "kernings" || (n.key === "char" ? l.chars.push(n.data) : n.key === "kerning" ? l.kernings.push(n.data) : l[n.key] = n.data);
          }
          return l;
        };
        function P(E, d) {
          if (E = E.replace(/\t+/g, " ").trim(), !E)
            return null;
          var l = E.indexOf(" ");
          if (l === -1)
            throw new Error("no named row at line " + d);
          var u = E.substring(0, l);
          E = E.substring(l + 1), E = E.replace(/letter=[\'\"]\S+[\'\"]/gi, ""), E = E.split("="), E = E.map(function(f) {
            return f.trim().match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);
          });
          for (var a = [], n = 0; n < E.length; n++) {
            var c = E[n];
            n === 0 ? a.push({
              key: c[0],
              data: ""
            }) : n === E.length - 1 ? a[a.length - 1].data = x(c[0]) : (a[a.length - 1].data = x(c[0]), a.push({
              key: c[1],
              data: ""
            }));
          }
          var g = {
            key: u,
            data: {}
          };
          return a.forEach(function(f) {
            g.data[f.key] = f.data;
          }), g;
        }
        function x(E) {
          return !E || E.length === 0 ? "" : E.indexOf('"') === 0 || E.indexOf("'") === 0 ? E.substring(1, E.length - 1) : E.indexOf(",") !== -1 ? y(E) : parseInt(E, 10);
        }
        function y(E) {
          return E.split(",").map(function(d) {
            return parseInt(d, 10);
          });
        }
      }, {}], 103: [function(C, Z, _) {
        var P = [66, 77, 70];
        Z.exports = function(g) {
          if (g.length < 6)
            throw new Error("invalid buffer length for BMFont");
          var f = P.every(function(o, A) {
            return g.readUInt8(A) === o;
          });
          if (!f)
            throw new Error("BMFont missing BMF byte header");
          var p = 3, s = g.readUInt8(p++);
          if (s > 3)
            throw new Error("Only supports BMFont Binary v3 (BMFont App v1.10)");
          for (var S = { kernings: [], chars: [] }, b = 0; b < 5; b++)
            p += x(S, g, p);
          return S;
        };
        function x(c, g, f) {
          if (f > g.length - 1)
            return 0;
          var p = g.readUInt8(f++), s = g.readInt32LE(f);
          switch (f += 4, p) {
            case 1:
              c.info = y(g, f);
              break;
            case 2:
              c.common = E(g, f);
              break;
            case 3:
              c.pages = d(g, f, s);
              break;
            case 4:
              c.chars = l(g, f, s);
              break;
            case 5:
              c.kernings = u(g, f, s);
              break;
          }
          return 5 + s;
        }
        function y(c, g) {
          var f = {};
          f.size = c.readInt16LE(g);
          var p = c.readUInt8(g + 2);
          return f.smooth = p >> 7 & 1, f.unicode = p >> 6 & 1, f.italic = p >> 5 & 1, f.bold = p >> 4 & 1, p >> 3 & 1 && (f.fixedHeight = 1), f.charset = c.readUInt8(g + 3) || "", f.stretchH = c.readUInt16LE(g + 4), f.aa = c.readUInt8(g + 6), f.padding = [
            c.readInt8(g + 7),
            c.readInt8(g + 8),
            c.readInt8(g + 9),
            c.readInt8(g + 10)
          ], f.spacing = [
            c.readInt8(g + 11),
            c.readInt8(g + 12)
          ], f.outline = c.readUInt8(g + 13), f.face = n(c, g + 14), f;
        }
        function E(c, g) {
          var f = {};
          return f.lineHeight = c.readUInt16LE(g), f.base = c.readUInt16LE(g + 2), f.scaleW = c.readUInt16LE(g + 4), f.scaleH = c.readUInt16LE(g + 6), f.pages = c.readUInt16LE(g + 8), c.readUInt8(g + 10), f.packed = 0, f.alphaChnl = c.readUInt8(g + 11), f.redChnl = c.readUInt8(g + 12), f.greenChnl = c.readUInt8(g + 13), f.blueChnl = c.readUInt8(g + 14), f;
        }
        function d(c, g, f) {
          for (var p = [], s = a(c, g), S = s.length + 1, b = f / S, o = 0; o < b; o++)
            p[o] = c.slice(g, g + s.length).toString("utf8"), g += S;
          return p;
        }
        function l(c, g, f) {
          for (var p = [], s = f / 20, S = 0; S < s; S++) {
            var b = {}, o = S * 20;
            b.id = c.readUInt32LE(g + 0 + o), b.x = c.readUInt16LE(g + 4 + o), b.y = c.readUInt16LE(g + 6 + o), b.width = c.readUInt16LE(g + 8 + o), b.height = c.readUInt16LE(g + 10 + o), b.xoffset = c.readInt16LE(g + 12 + o), b.yoffset = c.readInt16LE(g + 14 + o), b.xadvance = c.readInt16LE(g + 16 + o), b.page = c.readUInt8(g + 18 + o), b.chnl = c.readUInt8(g + 19 + o), p[S] = b;
          }
          return p;
        }
        function u(c, g, f) {
          for (var p = [], s = f / 10, S = 0; S < s; S++) {
            var b = {}, o = S * 10;
            b.first = c.readUInt32LE(g + 0 + o), b.second = c.readUInt32LE(g + 4 + o), b.amount = c.readInt16LE(g + 8 + o), p[S] = b;
          }
          return p;
        }
        function a(c, g) {
          for (var f = g; f < c.length && c[f] !== 0; f++)
            ;
          return c.slice(g, f);
        }
        function n(c, g) {
          return a(c, g).toString("utf8");
        }
      }, {}], 104: [function(C, Z, _) {
        var P = C("./parse-attribs"), x = C("xml-parse-from-string"), y = {
          scaleh: "scaleH",
          scalew: "scaleW",
          stretchh: "stretchH",
          lineheight: "lineHeight",
          alphachnl: "alphaChnl",
          redchnl: "redChnl",
          greenchnl: "greenChnl",
          bluechnl: "blueChnl"
        };
        Z.exports = function(a) {
          a = a.toString();
          var n = x(a), c = {
            pages: [],
            chars: [],
            kernings: []
          };
          ["info", "common"].forEach(function(o) {
            var A = n.getElementsByTagName(o)[0];
            A && (c[o] = P(E(A)));
          });
          var g = n.getElementsByTagName("pages")[0];
          if (!g)
            throw new Error("malformed file -- no <pages> element");
          for (var f = g.getElementsByTagName("page"), p = 0; p < f.length; p++) {
            var s = f[p], S = parseInt(s.getAttribute("id"), 10), b = s.getAttribute("file");
            if (isNaN(S))
              throw new Error('malformed file -- page "id" attribute is NaN');
            if (!b)
              throw new Error('malformed file -- needs page "file" attribute');
            c.pages[parseInt(S, 10)] = b;
          }
          return ["chars", "kernings"].forEach(function(o) {
            var A = n.getElementsByTagName(o)[0];
            if (A)
              for (var T = o.substring(0, o.length - 1), R = A.getElementsByTagName(T), L = 0; L < R.length; L++) {
                var z = R[L];
                c[o].push(P(E(z)));
              }
          }), c;
        };
        function E(u) {
          var a = d(u);
          return a.reduce(function(n, c) {
            var g = l(c.nodeName);
            return n[g] = c.nodeValue, n;
          }, {});
        }
        function d(u) {
          for (var a = [], n = 0; n < u.attributes.length; n++)
            a.push(u.attributes[n]);
          return a;
        }
        function l(u) {
          return y[u.toLowerCase()] || u;
        }
      }, { "./parse-attribs": 105, "xml-parse-from-string": 188 }], 105: [function(C, Z, _) {
        var P = "chasrset";
        Z.exports = function(E) {
          P in E && (E.charset = E[P], delete E[P]);
          for (var d in E)
            d === "face" || d === "charset" || (d === "padding" || d === "spacing" ? E[d] = x(E[d]) : E[d] = parseInt(E[d], 10));
          return E;
        };
        function x(y) {
          return y.split(",").map(function(E) {
            return parseInt(E, 10);
          });
        }
      }, {}], 106: [function(C, Z, _) {
        var P = C("trim"), x = C("for-each"), y = function(E) {
          return Object.prototype.toString.call(E) === "[object Array]";
        };
        Z.exports = function(E) {
          if (!E)
            return {};
          var d = {};
          return x(
            P(E).split(`
`),
            function(l) {
              var u = l.indexOf(":"), a = P(l.slice(0, u)).toLowerCase(), n = P(l.slice(u + 1));
              typeof d[a] > "u" ? d[a] = n : y(d[a]) ? d[a].push(n) : d[a] = [d[a], n];
            }
          ), d;
        };
      }, { "for-each": 63, trim: 179 }], 107: [function(C, Z, _) {
        (function(P) {
          function x(l, u) {
            for (var a = 0, n = l.length - 1; n >= 0; n--) {
              var c = l[n];
              c === "." ? l.splice(n, 1) : c === ".." ? (l.splice(n, 1), a++) : a && (l.splice(n, 1), a--);
            }
            if (u)
              for (; a--; a)
                l.unshift("..");
            return l;
          }
          _.resolve = function() {
            for (var l = "", u = !1, a = arguments.length - 1; a >= -1 && !u; a--) {
              var n = a >= 0 ? arguments[a] : P.cwd();
              if (typeof n != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!n)
                continue;
              l = n + "/" + l, u = n.charAt(0) === "/";
            }
            return l = x(E(l.split("/"), function(c) {
              return !!c;
            }), !u).join("/"), (u ? "/" : "") + l || ".";
          }, _.normalize = function(l) {
            var u = _.isAbsolute(l), a = d(l, -1) === "/";
            return l = x(E(l.split("/"), function(n) {
              return !!n;
            }), !u).join("/"), !l && !u && (l = "."), l && a && (l += "/"), (u ? "/" : "") + l;
          }, _.isAbsolute = function(l) {
            return l.charAt(0) === "/";
          }, _.join = function() {
            var l = Array.prototype.slice.call(arguments, 0);
            return _.normalize(E(l, function(u, a) {
              if (typeof u != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return u;
            }).join("/"));
          }, _.relative = function(l, u) {
            l = _.resolve(l).substr(1), u = _.resolve(u).substr(1);
            function a(S) {
              for (var b = 0; b < S.length && S[b] === ""; b++)
                ;
              for (var o = S.length - 1; o >= 0 && S[o] === ""; o--)
                ;
              return b > o ? [] : S.slice(b, o - b + 1);
            }
            for (var n = a(l.split("/")), c = a(u.split("/")), g = Math.min(n.length, c.length), f = g, p = 0; p < g; p++)
              if (n[p] !== c[p]) {
                f = p;
                break;
              }
            for (var s = [], p = f; p < n.length; p++)
              s.push("..");
            return s = s.concat(c.slice(f)), s.join("/");
          }, _.sep = "/", _.delimiter = ":", _.dirname = function(l) {
            if (typeof l != "string" && (l = l + ""), l.length === 0) return ".";
            for (var u = l.charCodeAt(0), a = u === 47, n = -1, c = !0, g = l.length - 1; g >= 1; --g)
              if (u = l.charCodeAt(g), u === 47) {
                if (!c) {
                  n = g;
                  break;
                }
              } else
                c = !1;
            return n === -1 ? a ? "/" : "." : a && n === 1 ? "/" : l.slice(0, n);
          };
          function y(l) {
            typeof l != "string" && (l = l + "");
            var u = 0, a = -1, n = !0, c;
            for (c = l.length - 1; c >= 0; --c)
              if (l.charCodeAt(c) === 47) {
                if (!n) {
                  u = c + 1;
                  break;
                }
              } else a === -1 && (n = !1, a = c + 1);
            return a === -1 ? "" : l.slice(u, a);
          }
          _.basename = function(l, u) {
            var a = y(l);
            return u && a.substr(-1 * u.length) === u && (a = a.substr(0, a.length - u.length)), a;
          }, _.extname = function(l) {
            typeof l != "string" && (l = l + "");
            for (var u = -1, a = 0, n = -1, c = !0, g = 0, f = l.length - 1; f >= 0; --f) {
              var p = l.charCodeAt(f);
              if (p === 47) {
                if (!c) {
                  a = f + 1;
                  break;
                }
                continue;
              }
              n === -1 && (c = !1, n = f + 1), p === 46 ? u === -1 ? u = f : g !== 1 && (g = 1) : u !== -1 && (g = -1);
            }
            return u === -1 || n === -1 || // We saw a non-dot character immediately before the dot
            g === 0 || // The (right-most) trimmed path component is exactly '..'
            g === 1 && u === n - 1 && u === a + 1 ? "" : l.slice(u, n);
          };
          function E(l, u) {
            if (l.filter) return l.filter(u);
            for (var a = [], n = 0; n < l.length; n++)
              u(l[n], n, l) && a.push(l[n]);
            return a;
          }
          var d = "ab".substr(-1) === "b" ? function(l, u, a) {
            return l.substr(u, a);
          } : function(l, u, a) {
            return u < 0 && (u = l.length + u), l.substr(u, a);
          };
        }).call(this, C("_process"));
      }, { _process: 133 }], 108: [function(C, Z, _) {
        (function(P) {
          var x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
            return typeof c;
          } : function(c) {
            return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
          }, y = C("http"), E = C("https"), d = C("url"), l = C("querystring"), u = C("zlib"), a = C("util"), n = function(g, f) {
            if (typeof g != "string" && !g.hasOwnProperty("url"))
              throw new Error("Missing url option from options for request method.");
            var p = (typeof g > "u" ? "undefined" : x(g)) === "object" ? d.parse(g.url) : d.parse(g), s = { hostname: p.hostname, port: p.port || (p.protocol.toLowerCase() === "http:" ? 80 : 443), path: p.path, method: "GET", headers: {}, auth: p.auth || null, parse: "none", stream: !1 };
            if ((typeof g > "u" ? "undefined" : x(g)) === "object" && (s = Object.assign(s, g)), s.port = Number(s.port), s.hasOwnProperty("timeout") && delete s.timeout, s.compressed === !0 && (s.headers["accept-encoding"] = "gzip, deflate"), g.hasOwnProperty("form")) {
              if (x(g.form) !== "object")
                throw new Error("phin 'form' option must be of type Object if present.");
              var S = l.stringify(g.form);
              s.headers["Content-Type"] = "application/x-www-form-urlencoded", s.headers["Content-Length"] = P.byteLength(S), g.data = S;
            }
            var b = void 0, o = function(L) {
              var z = L;
              s.compressed === !0 && (L.headers["content-encoding"] === "gzip" ? z = L.pipe(u.createGunzip()) : L.headers["content-encoding"] === "deflate" && (z = L.pipe(u.createInflate()))), s.stream === !0 ? (L.stream = z, f(null, L)) : (L.body = new P([]), z.on("data", function(U) {
                L.body = P.concat([L.body, U]);
              }), z.on("end", function() {
                if (f) {
                  if (s.parse === "json")
                    try {
                      L.body = JSON.parse(L.body.toString());
                    } catch {
                      f("Invalid JSON received.", L);
                      return;
                    }
                  f(null, L);
                }
              }));
            };
            switch (p.protocol.toLowerCase()) {
              case "http:":
                b = y.request(s, o);
                break;
              case "https:":
                b = E.request(s, o);
                break;
              default:
                f && f(new Error("Invalid / unknown URL protocol. Expected HTTP or HTTPS."), null);
                return;
            }
            if (typeof g.timeout == "number" && b.setTimeout(g.timeout, function() {
              b.abort(), f(new Error("Timeout has been reached."), null), f = null;
            }), b.on("error", function(R) {
              f && f(R, null);
            }), g.hasOwnProperty("data")) {
              var A = g.data;
              if (!(g.data instanceof P) && x(g.data) === "object") {
                var T = s.headers["content-type"] || s.headers["Content-Type"];
                if (T === "application/x-www-form-urlencoded")
                  A = l.stringify(g.data);
                else
                  try {
                    A = JSON.stringify(g.data);
                  } catch {
                    f(new Error("Couldn't stringify object. (Likely due to a circular reference.)"), null);
                  }
              }
              b.write(A);
            }
            b.end();
          };
          n.promisified = function(c, g) {
            return new Promise(function(f, p) {
              n(c, function(s, S) {
                s ? p(s) : f(S);
              });
            });
          }, a.promisify && (n[a.promisify.custom] = n.promisified), Z.exports = n;
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48, http: 156, https: 72, querystring: 137, url: 180, util: 186, zlib: 35 }], 109: [function(C, Z, _) {
        Z.exports = P;
        function P(c, g, f, p, s, S) {
          S || (S = {});
          for (var b = S.threshold === void 0 ? 0.1 : S.threshold, o = 35215 * b * b, A = 0, T = 0; T < s; T++)
            for (var R = 0; R < p; R++) {
              var L = (T * p + R) * 4, z = y(c, g, L, L);
              if (z > o)
                !S.includeAA && (x(c, R, T, p, s, g) || x(g, R, T, p, s, c)) ? f && a(f, L, 255, 255, 0) : (f && a(f, L, 255, 0, 0), A++);
              else if (f) {
                var U = u(n(c, L), 0.1);
                a(f, L, U, U, U);
              }
            }
          return A;
        }
        function x(c, g, f, p, s, S) {
          for (var b = Math.max(g - 1, 0), o = Math.max(f - 1, 0), A = Math.min(g + 1, p - 1), T = Math.min(f + 1, s - 1), R = (f * p + g) * 4, L = 0, z = 0, U = 0, J = 0, F = 0, se, ee, ie, W, Q = b; Q <= A; Q++)
            for (var de = o; de <= T; de++)
              if (!(Q === g && de === f)) {
                var _e = y(c, c, R, (de * p + Q) * 4, !0);
                if (_e === 0 ? L++ : _e < 0 ? U++ : _e > 0 && z++, L > 2) return !1;
                S && (_e < J && (J = _e, se = Q, ee = de), _e > F && (F = _e, ie = Q, W = de));
              }
          return S ? U === 0 || z === 0 ? !1 : !x(c, se, ee, p, s) && !x(S, se, ee, p, s) || !x(c, ie, W, p, s) && !x(S, ie, W, p, s) : !0;
        }
        function y(c, g, f, p, s) {
          var S = c[f + 3] / 255, b = g[p + 3] / 255, o = u(c[f + 0], S), A = u(c[f + 1], S), T = u(c[f + 2], S), R = u(g[p + 0], b), L = u(g[p + 1], b), z = u(g[p + 2], b), U = E(o, A, T) - E(R, L, z);
          if (s) return U;
          var J = d(o, A, T) - d(R, L, z), F = l(o, A, T) - l(R, L, z);
          return 0.5053 * U * U + 0.299 * J * J + 0.1957 * F * F;
        }
        function E(c, g, f) {
          return c * 0.29889531 + g * 0.58662247 + f * 0.11448223;
        }
        function d(c, g, f) {
          return c * 0.59597799 - g * 0.2741761 - f * 0.32180189;
        }
        function l(c, g, f) {
          return c * 0.21147017 - g * 0.52261711 + f * 0.31114694;
        }
        function u(c, g) {
          return 255 + (c - 255) * g;
        }
        function a(c, g, f, p, s) {
          c[g + 0] = f, c[g + 1] = p, c[g + 2] = s, c[g + 3] = 255;
        }
        function n(c, g) {
          var f = c[g + 3] / 255, p = u(c[g + 0], f), s = u(c[g + 1], f), S = u(c[g + 2], f);
          return E(p, s, S);
        }
      }, {}], 110: [function(C, Z, _) {
        (function(P) {
          var x = C("./interlace"), y = {
            1: {
              // L
              0: 0,
              1: 0,
              2: 0,
              3: 255
            },
            2: {
              // LA
              0: 0,
              1: 0,
              2: 0,
              3: 1
            },
            3: {
              // RGB
              0: 0,
              1: 1,
              2: 2,
              3: 255
            },
            4: {
              // RGBA
              0: 0,
              1: 1,
              2: 2,
              3: 3
            }
          };
          function E(u, a) {
            var n = [], c = 0;
            function g() {
              if (c === u.length)
                throw new Error("Ran out of data");
              var f = u[c];
              c++;
              var p, s, S, b, o, A, T, R;
              switch (a) {
                default:
                  throw new Error("unrecognised depth");
                case 16:
                  T = u[c], c++, n.push((f << 8) + T);
                  break;
                case 4:
                  T = f & 15, R = f >> 4, n.push(R, T);
                  break;
                case 2:
                  o = f & 3, A = f >> 2 & 3, T = f >> 4 & 3, R = f >> 6 & 3, n.push(R, T, A, o);
                  break;
                case 1:
                  p = f & 1, s = f >> 1 & 1, S = f >> 2 & 1, b = f >> 3 & 1, o = f >> 4 & 1, A = f >> 5 & 1, T = f >> 6 & 1, R = f >> 7 & 1, n.push(R, T, A, o, b, S, s, p);
                  break;
              }
            }
            return {
              get: function(f) {
                for (; n.length < f; )
                  g();
                var p = n.slice(0, f);
                return n = n.slice(f), p;
              },
              resetAfterLine: function() {
                n.length = 0;
              },
              end: function() {
                if (c !== u.length)
                  throw new Error("extra data found");
              }
            };
          }
          function d(u, a, n, c, g, f) {
            for (var p = u.width, s = u.height, S = u.index, b = 0; b < s; b++)
              for (var o = 0; o < p; o++) {
                for (var A = n(o, b, S), T = 0; T < 4; T++) {
                  var R = y[c][T];
                  if (R === 255)
                    a[A + T] = 255;
                  else {
                    var L = R + f;
                    if (L === g.length)
                      throw new Error("Ran out of data");
                    a[A + T] = g[L];
                  }
                }
                f += c;
              }
            return f;
          }
          function l(u, a, n, c, g, f) {
            for (var p = u.width, s = u.height, S = u.index, b = 0; b < s; b++) {
              for (var o = 0; o < p; o++)
                for (var A = g.get(c), T = n(o, b, S), R = 0; R < 4; R++) {
                  var L = y[c][R];
                  a[T + R] = L !== 255 ? A[L] : f;
                }
              g.resetAfterLine();
            }
          }
          _.dataToBitMap = function(u, a) {
            var n = a.width, c = a.height, g = a.depth, f = a.bpp, p = a.interlace;
            if (g !== 8)
              var s = E(u, g);
            var S;
            g <= 8 ? S = new P(n * c * 4) : S = new Uint16Array(n * c * 4);
            var b = Math.pow(2, g) - 1, o = 0, A, T;
            if (p)
              A = x.getImagePasses(n, c), T = x.getInterlaceIterator(n, c);
            else {
              var R = 0;
              T = function() {
                var z = R;
                return R += 4, z;
              }, A = [{ width: n, height: c }];
            }
            for (var L = 0; L < A.length; L++)
              g === 8 ? o = d(A[L], S, T, f, u, o) : l(A[L], S, T, f, s, b);
            if (g === 8) {
              if (o !== u.length)
                throw new Error("extra data found");
            } else
              s.end();
            return S;
          };
        }).call(this, C("buffer").Buffer);
      }, { "./interlace": 120, buffer: 48 }], 111: [function(C, Z, _) {
        (function(P) {
          var x = C("./constants");
          Z.exports = function(y, E, d, l) {
            var u = [x.COLORTYPE_COLOR_ALPHA, x.COLORTYPE_ALPHA].indexOf(l.colorType) !== -1;
            if (l.colorType === l.inputColorType) {
              var a = function() {
                var z = new ArrayBuffer(2);
                return new DataView(z).setInt16(
                  0,
                  256,
                  !0
                  /* littleEndian */
                ), new Int16Array(z)[0] !== 256;
              }();
              if (l.bitDepth === 8 || l.bitDepth === 16 && a)
                return y;
            }
            var n = l.bitDepth !== 16 ? y : new Uint16Array(y.buffer), c = 255, g = x.COLORTYPE_TO_BPP_MAP[l.inputColorType];
            g == 4 && !l.inputHasAlpha && (g = 3);
            var f = x.COLORTYPE_TO_BPP_MAP[l.colorType];
            l.bitDepth === 16 && (c = 65535, f *= 2);
            var p = new P(E * d * f), s = 0, S = 0, b = l.bgColor || {};
            b.red === void 0 && (b.red = c), b.green === void 0 && (b.green = c), b.blue === void 0 && (b.blue = c);
            function o(z, U) {
              var J, F, se, ee = c;
              switch (l.inputColorType) {
                case x.COLORTYPE_COLOR_ALPHA:
                  ee = z[U + 3], J = z[U], F = z[U + 1], se = z[U + 2];
                  break;
                case x.COLORTYPE_COLOR:
                  J = z[U], F = z[U + 1], se = z[U + 2];
                  break;
                case x.COLORTYPE_ALPHA:
                  ee = z[U + 1], J = z[U], F = J, se = J;
                  break;
                case x.COLORTYPE_GRAYSCALE:
                  J = z[U], F = J, se = J;
                  break;
                default:
                  throw new Error("input color type:" + l.inputColorType + " is not supported at present");
              }
              return l.inputHasAlpha && (u || (ee /= c, J = Math.min(Math.max(Math.round((1 - ee) * b.red + ee * J), 0), c), F = Math.min(Math.max(Math.round((1 - ee) * b.green + ee * F), 0), c), se = Math.min(Math.max(Math.round((1 - ee) * b.blue + ee * se), 0), c))), { red: J, green: F, blue: se, alpha: ee };
            }
            for (var A = 0; A < d; A++)
              for (var T = 0; T < E; T++) {
                var R = o(n, s);
                switch (l.colorType) {
                  case x.COLORTYPE_COLOR_ALPHA:
                  case x.COLORTYPE_COLOR:
                    l.bitDepth === 8 ? (p[S] = R.red, p[S + 1] = R.green, p[S + 2] = R.blue, u && (p[S + 3] = R.alpha)) : (p.writeUInt16BE(R.red, S), p.writeUInt16BE(R.green, S + 2), p.writeUInt16BE(R.blue, S + 4), u && p.writeUInt16BE(R.alpha, S + 6));
                    break;
                  case x.COLORTYPE_ALPHA:
                  case x.COLORTYPE_GRAYSCALE:
                    var L = (R.red + R.green + R.blue) / 3;
                    l.bitDepth === 8 ? (p[S] = L, u && (p[S + 1] = R.alpha)) : (p.writeUInt16BE(L, S), u && p.writeUInt16BE(R.alpha, S + 2));
                    break;
                }
                s += g, S += f;
              }
            return p;
          };
        }).call(this, C("buffer").Buffer);
      }, { "./constants": 113, buffer: 48 }], 112: [function(C, Z, _) {
        (function(P, x) {
          var y = C("util"), E = C("stream"), d = Z.exports = function() {
            E.call(this), this._buffers = [], this._buffered = 0, this._reads = [], this._paused = !1, this._encoding = "utf8", this.writable = !0;
          };
          y.inherits(d, E), d.prototype.read = function(l, u) {
            this._reads.push({
              length: Math.abs(l),
              // if length < 0 then at most this length
              allowLess: l < 0,
              func: u
            }), P.nextTick((function() {
              this._process(), this._paused && this._reads.length > 0 && (this._paused = !1, this.emit("drain"));
            }).bind(this));
          }, d.prototype.write = function(l, u) {
            if (!this.writable)
              return this.emit("error", new Error("Stream not writable")), !1;
            var a;
            return x.isBuffer(l) ? a = l : a = new x(l, u || this._encoding), this._buffers.push(a), this._buffered += a.length, this._process(), this._reads && this._reads.length === 0 && (this._paused = !0), this.writable && !this._paused;
          }, d.prototype.end = function(l, u) {
            l && this.write(l, u), this.writable = !1, this._buffers && (this._buffers.length === 0 ? this._end() : (this._buffers.push(null), this._process()));
          }, d.prototype.destroySoon = d.prototype.end, d.prototype._end = function() {
            this._reads.length > 0 && this.emit(
              "error",
              new Error("There are some read requests waiting on finished stream")
            ), this.destroy();
          }, d.prototype.destroy = function() {
            this._buffers && (this.writable = !1, this._reads = null, this._buffers = null, this.emit("close"));
          }, d.prototype._processReadAllowingLess = function(l) {
            this._reads.shift();
            var u = this._buffers[0];
            u.length > l.length ? (this._buffered -= l.length, this._buffers[0] = u.slice(l.length), l.func.call(this, u.slice(0, l.length))) : (this._buffered -= u.length, this._buffers.shift(), l.func.call(this, u));
          }, d.prototype._processRead = function(l) {
            this._reads.shift();
            for (var u = 0, a = 0, n = new x(l.length); u < l.length; ) {
              var c = this._buffers[a++], g = Math.min(c.length, l.length - u);
              c.copy(n, u, 0, g), u += g, g !== c.length && (this._buffers[--a] = c.slice(g));
            }
            a > 0 && this._buffers.splice(0, a), this._buffered -= l.length, l.func.call(this, n);
          }, d.prototype._process = function() {
            try {
              for (; this._buffered > 0 && this._reads && this._reads.length > 0; ) {
                var l = this._reads[0];
                if (l.allowLess)
                  this._processReadAllowingLess(l);
                else if (this._buffered >= l.length)
                  this._processRead(l);
                else
                  break;
              }
              this._buffers && this._buffers.length > 0 && this._buffers[0] === null && this._end();
            } catch (u) {
              this.emit("error", u);
            }
          };
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { _process: 133, buffer: 48, stream: 155, util: 186 }], 113: [function(C, Z, _) {
        Z.exports = {
          PNG_SIGNATURE: [137, 80, 78, 71, 13, 10, 26, 10],
          TYPE_IHDR: 1229472850,
          TYPE_IEND: 1229278788,
          TYPE_IDAT: 1229209940,
          TYPE_PLTE: 1347179589,
          TYPE_tRNS: 1951551059,
          // eslint-disable-line camelcase
          TYPE_gAMA: 1732332865,
          // eslint-disable-line camelcase
          // color-type bits
          COLORTYPE_GRAYSCALE: 0,
          COLORTYPE_PALETTE: 1,
          COLORTYPE_COLOR: 2,
          COLORTYPE_ALPHA: 4,
          // e.g. grayscale and alpha
          // color-type combinations
          COLORTYPE_PALETTE_COLOR: 3,
          COLORTYPE_COLOR_ALPHA: 6,
          COLORTYPE_TO_BPP_MAP: {
            0: 1,
            2: 3,
            3: 1,
            4: 2,
            6: 4
          },
          GAMMA_DIVISION: 1e5
        };
      }, {}], 114: [function(C, Z, _) {
        var P = [];
        (function() {
          for (var y = 0; y < 256; y++) {
            for (var E = y, d = 0; d < 8; d++)
              E & 1 ? E = 3988292384 ^ E >>> 1 : E = E >>> 1;
            P[y] = E;
          }
        })();
        var x = Z.exports = function() {
          this._crc = -1;
        };
        x.prototype.write = function(y) {
          for (var E = 0; E < y.length; E++)
            this._crc = P[(this._crc ^ y[E]) & 255] ^ this._crc >>> 8;
          return !0;
        }, x.prototype.crc32 = function() {
          return this._crc ^ -1;
        }, x.crc32 = function(y) {
          for (var E = -1, d = 0; d < y.length; d++)
            E = P[(E ^ y[d]) & 255] ^ E >>> 8;
          return E ^ -1;
        };
      }, {}], 115: [function(C, Z, _) {
        (function(P) {
          var x = C("./paeth-predictor");
          function y(S, b, o, A, T) {
            for (var R = 0; R < o; R++)
              A[T + R] = S[b + R];
          }
          function E(S, b, o) {
            for (var A = 0, T = b + o, R = b; R < T; R++)
              A += Math.abs(S[R]);
            return A;
          }
          function d(S, b, o, A, T, R) {
            for (var L = 0; L < o; L++) {
              var z = L >= R ? S[b + L - R] : 0, U = S[b + L] - z;
              A[T + L] = U;
            }
          }
          function l(S, b, o, A) {
            for (var T = 0, R = 0; R < o; R++) {
              var L = R >= A ? S[b + R - A] : 0, z = S[b + R] - L;
              T += Math.abs(z);
            }
            return T;
          }
          function u(S, b, o, A, T) {
            for (var R = 0; R < o; R++) {
              var L = b > 0 ? S[b + R - o] : 0, z = S[b + R] - L;
              A[T + R] = z;
            }
          }
          function a(S, b, o) {
            for (var A = 0, T = b + o, R = b; R < T; R++) {
              var L = b > 0 ? S[R - o] : 0, z = S[R] - L;
              A += Math.abs(z);
            }
            return A;
          }
          function n(S, b, o, A, T, R) {
            for (var L = 0; L < o; L++) {
              var z = L >= R ? S[b + L - R] : 0, U = b > 0 ? S[b + L - o] : 0, J = S[b + L] - (z + U >> 1);
              A[T + L] = J;
            }
          }
          function c(S, b, o, A) {
            for (var T = 0, R = 0; R < o; R++) {
              var L = R >= A ? S[b + R - A] : 0, z = b > 0 ? S[b + R - o] : 0, U = S[b + R] - (L + z >> 1);
              T += Math.abs(U);
            }
            return T;
          }
          function g(S, b, o, A, T, R) {
            for (var L = 0; L < o; L++) {
              var z = L >= R ? S[b + L - R] : 0, U = b > 0 ? S[b + L - o] : 0, J = b > 0 && L >= R ? S[b + L - (o + R)] : 0, F = S[b + L] - x(z, U, J);
              A[T + L] = F;
            }
          }
          function f(S, b, o, A) {
            for (var T = 0, R = 0; R < o; R++) {
              var L = R >= A ? S[b + R - A] : 0, z = b > 0 ? S[b + R - o] : 0, U = b > 0 && R >= A ? S[b + R - (o + A)] : 0, J = S[b + R] - x(L, z, U);
              T += Math.abs(J);
            }
            return T;
          }
          var p = {
            0: y,
            1: d,
            2: u,
            3: n,
            4: g
          }, s = {
            0: E,
            1: l,
            2: a,
            3: c,
            4: f
          };
          Z.exports = function(S, b, o, A, T) {
            var R;
            if (!("filterType" in A) || A.filterType === -1)
              R = [0, 1, 2, 3, 4];
            else if (typeof A.filterType == "number")
              R = [A.filterType];
            else
              throw new Error("unrecognised filter types");
            A.bitDepth === 16 && (T *= 2);
            for (var L = b * T, z = 0, U = 0, J = new P((L + 1) * o), F = R[0], se = 0; se < o; se++) {
              if (R.length > 1)
                for (var ee = 1 / 0, ie = 0; ie < R.length; ie++) {
                  var W = s[R[ie]](S, U, L, T);
                  W < ee && (F = R[ie], ee = W);
                }
              J[z] = F, z++, p[F](S, U, L, J, z, T), z += L, U += L;
            }
            return J;
          };
        }).call(this, C("buffer").Buffer);
      }, { "./paeth-predictor": 124, buffer: 48 }], 116: [function(C, Z, _) {
        (function(P) {
          var x = C("util"), y = C("./chunkstream"), E = C("./filter-parse"), d = Z.exports = function(l) {
            y.call(this);
            var u = [], a = this;
            this._filter = new E(l, {
              read: this.read.bind(this),
              write: function(n) {
                u.push(n);
              },
              complete: function() {
                a.emit("complete", P.concat(u));
              }
            }), this._filter.start();
          };
          x.inherits(d, y);
        }).call(this, C("buffer").Buffer);
      }, { "./chunkstream": 112, "./filter-parse": 118, buffer: 48, util: 186 }], 117: [function(C, Z, _) {
        (function(P) {
          var x = C("./sync-reader"), y = C("./filter-parse");
          _.process = function(E, d) {
            var l = [], u = new x(E), a = new y(d, {
              read: u.read.bind(u),
              write: function(n) {
                l.push(n);
              },
              complete: function() {
              }
            });
            return a.start(), u.process(), P.concat(l);
          };
        }).call(this, C("buffer").Buffer);
      }, { "./filter-parse": 118, "./sync-reader": 131, buffer: 48 }], 118: [function(C, Z, _) {
        (function(P) {
          var x = C("./interlace"), y = C("./paeth-predictor");
          function E(l, u, a) {
            var n = l * u;
            return a !== 8 && (n = Math.ceil(n / (8 / a))), n;
          }
          var d = Z.exports = function(l, u) {
            var a = l.width, n = l.height, c = l.interlace, g = l.bpp, f = l.depth;
            if (this.read = u.read, this.write = u.write, this.complete = u.complete, this._imageIndex = 0, this._images = [], c)
              for (var p = x.getImagePasses(a, n), s = 0; s < p.length; s++)
                this._images.push({
                  byteWidth: E(p[s].width, g, f),
                  height: p[s].height,
                  lineIndex: 0
                });
            else
              this._images.push({
                byteWidth: E(a, g, f),
                height: n,
                lineIndex: 0
              });
            f === 8 ? this._xComparison = g : f === 16 ? this._xComparison = g * 2 : this._xComparison = 1;
          };
          d.prototype.start = function() {
            this.read(this._images[this._imageIndex].byteWidth + 1, this._reverseFilterLine.bind(this));
          }, d.prototype._unFilterType1 = function(l, u, a) {
            for (var n = this._xComparison, c = n - 1, g = 0; g < a; g++) {
              var f = l[1 + g], p = g > c ? u[g - n] : 0;
              u[g] = f + p;
            }
          }, d.prototype._unFilterType2 = function(l, u, a) {
            for (var n = this._lastLine, c = 0; c < a; c++) {
              var g = l[1 + c], f = n ? n[c] : 0;
              u[c] = g + f;
            }
          }, d.prototype._unFilterType3 = function(l, u, a) {
            for (var n = this._xComparison, c = n - 1, g = this._lastLine, f = 0; f < a; f++) {
              var p = l[1 + f], s = g ? g[f] : 0, S = f > c ? u[f - n] : 0, b = Math.floor((S + s) / 2);
              u[f] = p + b;
            }
          }, d.prototype._unFilterType4 = function(l, u, a) {
            for (var n = this._xComparison, c = n - 1, g = this._lastLine, f = 0; f < a; f++) {
              var p = l[1 + f], s = g ? g[f] : 0, S = f > c ? u[f - n] : 0, b = f > c && g ? g[f - n] : 0, o = y(S, s, b);
              u[f] = p + o;
            }
          }, d.prototype._reverseFilterLine = function(l) {
            var u = l[0], a, n = this._images[this._imageIndex], c = n.byteWidth;
            if (u === 0)
              a = l.slice(1, c + 1);
            else
              switch (a = new P(c), u) {
                case 1:
                  this._unFilterType1(l, a, c);
                  break;
                case 2:
                  this._unFilterType2(l, a, c);
                  break;
                case 3:
                  this._unFilterType3(l, a, c);
                  break;
                case 4:
                  this._unFilterType4(l, a, c);
                  break;
                default:
                  throw new Error("Unrecognised filter type - " + u);
              }
            this.write(a), n.lineIndex++, n.lineIndex >= n.height ? (this._lastLine = null, this._imageIndex++, n = this._images[this._imageIndex]) : this._lastLine = a, n ? this.read(n.byteWidth + 1, this._reverseFilterLine.bind(this)) : (this._lastLine = null, this.complete());
          };
        }).call(this, C("buffer").Buffer);
      }, { "./interlace": 120, "./paeth-predictor": 124, buffer: 48 }], 119: [function(C, Z, _) {
        (function(P) {
          function x(d, l, u, a, n) {
            for (var c = 0, g = 0; g < a; g++)
              for (var f = 0; f < u; f++) {
                var p = n[d[c]];
                if (!p)
                  throw new Error("index " + d[c] + " not in palette");
                for (var s = 0; s < 4; s++)
                  l[c + s] = p[s];
                c += 4;
              }
          }
          function y(d, l, u, a, n) {
            for (var c = 0, g = 0; g < a; g++)
              for (var f = 0; f < u; f++) {
                var p = !1;
                if (n.length === 1 ? n[0] === d[c] && (p = !0) : n[0] === d[c] && n[1] === d[c + 1] && n[2] === d[c + 2] && (p = !0), p)
                  for (var s = 0; s < 4; s++)
                    l[c + s] = 0;
                c += 4;
              }
          }
          function E(d, l, u, a, n) {
            for (var c = 255, g = Math.pow(2, n) - 1, f = 0, p = 0; p < a; p++)
              for (var s = 0; s < u; s++) {
                for (var S = 0; S < 4; S++)
                  l[f + S] = Math.floor(d[f + S] * c / g + 0.5);
                f += 4;
              }
          }
          Z.exports = function(d, l) {
            var u = l.depth, a = l.width, n = l.height, c = l.colorType, g = l.transColor, f = l.palette, p = d;
            return c === 3 ? x(d, p, a, n, f) : (g && y(d, p, a, n, g), u !== 8 && (u === 16 && (p = new P(a * n * 4)), E(d, p, a, n, u))), p;
          };
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 120: [function(C, Z, _) {
        var P = [
          {
            // pass 1 - 1px
            x: [0],
            y: [0]
          },
          {
            // pass 2 - 1px
            x: [4],
            y: [0]
          },
          {
            // pass 3 - 2px
            x: [0, 4],
            y: [4]
          },
          {
            // pass 4 - 4px
            x: [2, 6],
            y: [0, 4]
          },
          {
            // pass 5 - 8px
            x: [0, 2, 4, 6],
            y: [2, 6]
          },
          {
            // pass 6 - 16px
            x: [1, 3, 5, 7],
            y: [0, 2, 4, 6]
          },
          {
            // pass 7 - 32px
            x: [0, 1, 2, 3, 4, 5, 6, 7],
            y: [1, 3, 5, 7]
          }
        ];
        _.getImagePasses = function(x, y) {
          for (var E = [], d = x % 8, l = y % 8, u = (x - d) / 8, a = (y - l) / 8, n = 0; n < P.length; n++) {
            for (var c = P[n], g = u * c.x.length, f = a * c.y.length, p = 0; p < c.x.length && c.x[p] < d; p++)
              g++;
            for (p = 0; p < c.y.length && c.y[p] < l; p++)
              f++;
            g > 0 && f > 0 && E.push({ width: g, height: f, index: n });
          }
          return E;
        }, _.getInterlaceIterator = function(x) {
          return function(y, E, d) {
            var l = y % P[d].x.length, u = (y - l) / P[d].x.length * 8 + P[d].x[l], a = E % P[d].y.length, n = (E - a) / P[d].y.length * 8 + P[d].y[a];
            return u * 4 + n * x * 4;
          };
        };
      }, {}], 121: [function(C, Z, _) {
        (function(P) {
          var x = C("util"), y = C("stream"), E = C("./constants"), d = C("./packer"), l = Z.exports = function(u) {
            y.call(this);
            var a = u || {};
            this._packer = new d(a), this._deflate = this._packer.createDeflate(), this.readable = !0;
          };
          x.inherits(l, y), l.prototype.pack = function(u, a, n, c) {
            this.emit("data", new P(E.PNG_SIGNATURE)), this.emit("data", this._packer.packIHDR(a, n)), c && this.emit("data", this._packer.packGAMA(c));
            var g = this._packer.filterData(u, a, n);
            this._deflate.on("error", this.emit.bind(this, "error")), this._deflate.on("data", (function(f) {
              this.emit("data", this._packer.packIDAT(f));
            }).bind(this)), this._deflate.on("end", (function() {
              this.emit("data", this._packer.packIEND()), this.emit("end");
            }).bind(this)), this._deflate.end(g);
          };
        }).call(this, C("buffer").Buffer);
      }, { "./constants": 113, "./packer": 123, buffer: 48, stream: 155, util: 186 }], 122: [function(C, Z, _) {
        (function(P) {
          var x = !0, y = C("zlib");
          y.deflateSync || (x = !1);
          var E = C("./constants"), d = C("./packer");
          Z.exports = function(l, u) {
            if (!x)
              throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");
            var a = u || {}, n = new d(a), c = [];
            c.push(new P(E.PNG_SIGNATURE)), c.push(n.packIHDR(l.width, l.height)), l.gamma && c.push(n.packGAMA(l.gamma));
            var g = n.filterData(l.data, l.width, l.height), f = y.deflateSync(g, n.getDeflateOptions());
            if (g = null, !f || !f.length)
              throw new Error("bad png - invalid compressed data response");
            return c.push(n.packIDAT(f)), c.push(n.packIEND()), P.concat(c);
          };
        }).call(this, C("buffer").Buffer);
      }, { "./constants": 113, "./packer": 123, buffer: 48, zlib: 35 }], 123: [function(C, Z, _) {
        (function(P) {
          var x = C("./constants"), y = C("./crc"), E = C("./bitpacker"), d = C("./filter-pack"), l = C("zlib"), u = Z.exports = function(a) {
            if (this._options = a, a.deflateChunkSize = a.deflateChunkSize || 32 * 1024, a.deflateLevel = a.deflateLevel != null ? a.deflateLevel : 9, a.deflateStrategy = a.deflateStrategy != null ? a.deflateStrategy : 3, a.inputHasAlpha = a.inputHasAlpha != null ? a.inputHasAlpha : !0, a.deflateFactory = a.deflateFactory || l.createDeflate, a.bitDepth = a.bitDepth || 8, a.colorType = typeof a.colorType == "number" ? a.colorType : x.COLORTYPE_COLOR_ALPHA, a.inputColorType = typeof a.inputColorType == "number" ? a.inputColorType : x.COLORTYPE_COLOR_ALPHA, [
              x.COLORTYPE_GRAYSCALE,
              x.COLORTYPE_COLOR,
              x.COLORTYPE_COLOR_ALPHA,
              x.COLORTYPE_ALPHA
            ].indexOf(a.colorType) === -1)
              throw new Error("option color type:" + a.colorType + " is not supported at present");
            if ([
              x.COLORTYPE_GRAYSCALE,
              x.COLORTYPE_COLOR,
              x.COLORTYPE_COLOR_ALPHA,
              x.COLORTYPE_ALPHA
            ].indexOf(a.inputColorType) === -1)
              throw new Error("option input color type:" + a.inputColorType + " is not supported at present");
            if (a.bitDepth !== 8 && a.bitDepth !== 16)
              throw new Error("option bit depth:" + a.bitDepth + " is not supported at present");
          };
          u.prototype.getDeflateOptions = function() {
            return {
              chunkSize: this._options.deflateChunkSize,
              level: this._options.deflateLevel,
              strategy: this._options.deflateStrategy
            };
          }, u.prototype.createDeflate = function() {
            return this._options.deflateFactory(this.getDeflateOptions());
          }, u.prototype.filterData = function(a, n, c) {
            var g = E(a, n, c, this._options), f = x.COLORTYPE_TO_BPP_MAP[this._options.colorType], p = d(g, n, c, this._options, f);
            return p;
          }, u.prototype._packChunk = function(a, n) {
            var c = n ? n.length : 0, g = new P(c + 12);
            return g.writeUInt32BE(c, 0), g.writeUInt32BE(a, 4), n && n.copy(g, 8), g.writeInt32BE(y.crc32(g.slice(4, g.length - 4)), g.length - 4), g;
          }, u.prototype.packGAMA = function(a) {
            var n = new P(4);
            return n.writeUInt32BE(Math.floor(a * x.GAMMA_DIVISION), 0), this._packChunk(x.TYPE_gAMA, n);
          }, u.prototype.packIHDR = function(a, n) {
            var c = new P(13);
            return c.writeUInt32BE(a, 0), c.writeUInt32BE(n, 4), c[8] = this._options.bitDepth, c[9] = this._options.colorType, c[10] = 0, c[11] = 0, c[12] = 0, this._packChunk(x.TYPE_IHDR, c);
          }, u.prototype.packIDAT = function(a) {
            return this._packChunk(x.TYPE_IDAT, a);
          }, u.prototype.packIEND = function() {
            return this._packChunk(x.TYPE_IEND, null);
          };
        }).call(this, C("buffer").Buffer);
      }, { "./bitpacker": 111, "./constants": 113, "./crc": 114, "./filter-pack": 115, buffer: 48, zlib: 35 }], 124: [function(C, Z, _) {
        Z.exports = function(x, y, E) {
          var d = x + y - E, l = Math.abs(d - x), u = Math.abs(d - y), a = Math.abs(d - E);
          return l <= u && l <= a ? x : u <= a ? y : E;
        };
      }, {}], 125: [function(C, Z, _) {
        var P = C("util"), x = C("zlib"), y = C("./chunkstream"), E = C("./filter-parse-async"), d = C("./parser"), l = C("./bitmapper"), u = C("./format-normaliser"), a = Z.exports = function(n) {
          y.call(this), this._parser = new d(n, {
            read: this.read.bind(this),
            error: this._handleError.bind(this),
            metadata: this._handleMetaData.bind(this),
            gamma: this.emit.bind(this, "gamma"),
            palette: this._handlePalette.bind(this),
            transColor: this._handleTransColor.bind(this),
            finished: this._finished.bind(this),
            inflateData: this._inflateData.bind(this)
          }), this._options = n, this.writable = !0, this._parser.start();
        };
        P.inherits(a, y), a.prototype._handleError = function(n) {
          this.emit("error", n), this.writable = !1, this.destroy(), this._inflate && this._inflate.destroy && this._inflate.destroy(), this._filter && (this._filter.destroy(), this._filter.on("error", function() {
          })), this.errord = !0;
        }, a.prototype._inflateData = function(n) {
          if (!this._inflate)
            if (this._bitmapInfo.interlace)
              this._inflate = x.createInflate(), this._inflate.on("error", this.emit.bind(this, "error")), this._filter.on("complete", this._complete.bind(this)), this._inflate.pipe(this._filter);
            else {
              var c = (this._bitmapInfo.width * this._bitmapInfo.bpp * this._bitmapInfo.depth + 7 >> 3) + 1, g = c * this._bitmapInfo.height, f = Math.max(g, x.Z_MIN_CHUNK);
              this._inflate = x.createInflate({ chunkSize: f });
              var p = g, s = this.emit.bind(this, "error");
              this._inflate.on("error", function(b) {
                p && s(b);
              }), this._filter.on("complete", this._complete.bind(this));
              var S = this._filter.write.bind(this._filter);
              this._inflate.on("data", function(b) {
                p && (b.length > p && (b = b.slice(0, p)), p -= b.length, S(b));
              }), this._inflate.on("end", this._filter.end.bind(this._filter));
            }
          this._inflate.write(n);
        }, a.prototype._handleMetaData = function(n) {
          this.emit("metadata", n), this._bitmapInfo = Object.create(n), this._filter = new E(this._bitmapInfo);
        }, a.prototype._handleTransColor = function(n) {
          this._bitmapInfo.transColor = n;
        }, a.prototype._handlePalette = function(n) {
          this._bitmapInfo.palette = n;
        }, a.prototype._finished = function() {
          this.errord || (this._inflate ? this._inflate.end() : this.emit("error", "No Inflate block"), this.destroySoon());
        }, a.prototype._complete = function(n) {
          if (!this.errord) {
            try {
              var c = l.dataToBitMap(n, this._bitmapInfo), g = u(c, this._bitmapInfo);
              c = null;
            } catch (f) {
              this._handleError(f);
              return;
            }
            this.emit("parsed", g);
          }
        };
      }, { "./bitmapper": 110, "./chunkstream": 112, "./filter-parse-async": 116, "./format-normaliser": 119, "./parser": 127, util: 186, zlib: 35 }], 126: [function(C, Z, _) {
        (function(P) {
          var x = !0, y = C("zlib"), E = C("./sync-inflate");
          y.deflateSync || (x = !1);
          var d = C("./sync-reader"), l = C("./filter-parse-sync"), u = C("./parser"), a = C("./bitmapper"), n = C("./format-normaliser");
          Z.exports = function(c, g) {
            if (!x)
              throw new Error("To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0");
            var f;
            function p(de) {
              f = de;
            }
            var s;
            function S(de) {
              s = de;
            }
            function b(de) {
              s.transColor = de;
            }
            function o(de) {
              s.palette = de;
            }
            var A;
            function T(de) {
              A = de;
            }
            var R = [];
            function L(de) {
              R.push(de);
            }
            var z = new d(c), U = new u(g, {
              read: z.read.bind(z),
              error: p,
              metadata: S,
              gamma: T,
              palette: o,
              transColor: b,
              inflateData: L
            });
            if (U.start(), z.process(), f)
              throw f;
            var J = P.concat(R);
            R.length = 0;
            var F;
            if (s.interlace)
              F = y.inflateSync(J);
            else {
              var se = (s.width * s.bpp * s.depth + 7 >> 3) + 1, ee = se * s.height;
              F = E(J, { chunkSize: ee, maxLength: ee });
            }
            if (J = null, !F || !F.length)
              throw new Error("bad png - invalid inflate data response");
            var ie = l.process(F, s);
            J = null;
            var W = a.dataToBitMap(ie, s);
            ie = null;
            var Q = n(W, s);
            return s.data = Q, s.gamma = A || 0, s;
          };
        }).call(this, C("buffer").Buffer);
      }, { "./bitmapper": 110, "./filter-parse-sync": 117, "./format-normaliser": 119, "./parser": 127, "./sync-inflate": 130, "./sync-reader": 131, buffer: 48, zlib: 35 }], 127: [function(C, Z, _) {
        (function(P) {
          var x = C("./constants"), y = C("./crc"), E = Z.exports = function(d, l) {
            this._options = d, d.checkCRC = d.checkCRC !== !1, this._hasIHDR = !1, this._hasIEND = !1, this._palette = [], this._colorType = 0, this._chunks = {}, this._chunks[x.TYPE_IHDR] = this._handleIHDR.bind(this), this._chunks[x.TYPE_IEND] = this._handleIEND.bind(this), this._chunks[x.TYPE_IDAT] = this._handleIDAT.bind(this), this._chunks[x.TYPE_PLTE] = this._handlePLTE.bind(this), this._chunks[x.TYPE_tRNS] = this._handleTRNS.bind(this), this._chunks[x.TYPE_gAMA] = this._handleGAMA.bind(this), this.read = l.read, this.error = l.error, this.metadata = l.metadata, this.gamma = l.gamma, this.transColor = l.transColor, this.palette = l.palette, this.parsed = l.parsed, this.inflateData = l.inflateData, this.finished = l.finished;
          };
          E.prototype.start = function() {
            this.read(
              x.PNG_SIGNATURE.length,
              this._parseSignature.bind(this)
            );
          }, E.prototype._parseSignature = function(d) {
            for (var l = x.PNG_SIGNATURE, u = 0; u < l.length; u++)
              if (d[u] !== l[u]) {
                this.error(new Error("Invalid file signature"));
                return;
              }
            this.read(8, this._parseChunkBegin.bind(this));
          }, E.prototype._parseChunkBegin = function(d) {
            for (var l = d.readUInt32BE(0), u = d.readUInt32BE(4), a = "", n = 4; n < 8; n++)
              a += String.fromCharCode(d[n]);
            var c = !!(d[4] & 32);
            if (!this._hasIHDR && u !== x.TYPE_IHDR) {
              this.error(new Error("Expected IHDR on beggining"));
              return;
            }
            if (this._crc = new y(), this._crc.write(new P(a)), this._chunks[u])
              return this._chunks[u](l);
            if (!c) {
              this.error(new Error("Unsupported critical chunk type " + a));
              return;
            }
            this.read(l + 4, this._skipChunk.bind(this));
          }, E.prototype._skipChunk = function() {
            this.read(8, this._parseChunkBegin.bind(this));
          }, E.prototype._handleChunkEnd = function() {
            this.read(4, this._parseChunkEnd.bind(this));
          }, E.prototype._parseChunkEnd = function(d) {
            var l = d.readInt32BE(0), u = this._crc.crc32();
            if (this._options.checkCRC && u !== l) {
              this.error(new Error("Crc error - " + l + " - " + u));
              return;
            }
            this._hasIEND || this.read(8, this._parseChunkBegin.bind(this));
          }, E.prototype._handleIHDR = function(d) {
            this.read(d, this._parseIHDR.bind(this));
          }, E.prototype._parseIHDR = function(d) {
            this._crc.write(d);
            var l = d.readUInt32BE(0), u = d.readUInt32BE(4), a = d[8], n = d[9], c = d[10], g = d[11], f = d[12];
            if (a !== 8 && a !== 4 && a !== 2 && a !== 1 && a !== 16) {
              this.error(new Error("Unsupported bit depth " + a));
              return;
            }
            if (!(n in x.COLORTYPE_TO_BPP_MAP)) {
              this.error(new Error("Unsupported color type"));
              return;
            }
            if (c !== 0) {
              this.error(new Error("Unsupported compression method"));
              return;
            }
            if (g !== 0) {
              this.error(new Error("Unsupported filter method"));
              return;
            }
            if (f !== 0 && f !== 1) {
              this.error(new Error("Unsupported interlace method"));
              return;
            }
            this._colorType = n;
            var p = x.COLORTYPE_TO_BPP_MAP[this._colorType];
            this._hasIHDR = !0, this.metadata({
              width: l,
              height: u,
              depth: a,
              interlace: !!f,
              palette: !!(n & x.COLORTYPE_PALETTE),
              color: !!(n & x.COLORTYPE_COLOR),
              alpha: !!(n & x.COLORTYPE_ALPHA),
              bpp: p,
              colorType: n
            }), this._handleChunkEnd();
          }, E.prototype._handlePLTE = function(d) {
            this.read(d, this._parsePLTE.bind(this));
          }, E.prototype._parsePLTE = function(d) {
            this._crc.write(d);
            for (var l = Math.floor(d.length / 3), u = 0; u < l; u++)
              this._palette.push([
                d[u * 3],
                d[u * 3 + 1],
                d[u * 3 + 2],
                255
              ]);
            this.palette(this._palette), this._handleChunkEnd();
          }, E.prototype._handleTRNS = function(d) {
            this.read(d, this._parseTRNS.bind(this));
          }, E.prototype._parseTRNS = function(d) {
            if (this._crc.write(d), this._colorType === x.COLORTYPE_PALETTE_COLOR) {
              if (this._palette.length === 0) {
                this.error(new Error("Transparency chunk must be after palette"));
                return;
              }
              if (d.length > this._palette.length) {
                this.error(new Error("More transparent colors than palette size"));
                return;
              }
              for (var l = 0; l < d.length; l++)
                this._palette[l][3] = d[l];
              this.palette(this._palette);
            }
            this._colorType === x.COLORTYPE_GRAYSCALE && this.transColor([d.readUInt16BE(0)]), this._colorType === x.COLORTYPE_COLOR && this.transColor([d.readUInt16BE(0), d.readUInt16BE(2), d.readUInt16BE(4)]), this._handleChunkEnd();
          }, E.prototype._handleGAMA = function(d) {
            this.read(d, this._parseGAMA.bind(this));
          }, E.prototype._parseGAMA = function(d) {
            this._crc.write(d), this.gamma(d.readUInt32BE(0) / x.GAMMA_DIVISION), this._handleChunkEnd();
          }, E.prototype._handleIDAT = function(d) {
            this.read(-d, this._parseIDAT.bind(this, d));
          }, E.prototype._parseIDAT = function(d, l) {
            if (this._crc.write(l), this._colorType === x.COLORTYPE_PALETTE_COLOR && this._palette.length === 0)
              throw new Error("Expected palette not found");
            this.inflateData(l);
            var u = d - l.length;
            u > 0 ? this._handleIDAT(u) : this._handleChunkEnd();
          }, E.prototype._handleIEND = function(d) {
            this.read(d, this._parseIEND.bind(this));
          }, E.prototype._parseIEND = function(d) {
            this._crc.write(d), this._hasIEND = !0, this._handleChunkEnd(), this.finished && this.finished();
          };
        }).call(this, C("buffer").Buffer);
      }, { "./constants": 113, "./crc": 114, buffer: 48 }], 128: [function(C, Z, _) {
        var P = C("./parser-sync"), x = C("./packer-sync");
        _.read = function(y, E) {
          return P(y, E || {});
        }, _.write = function(y, E) {
          return x(y, E);
        };
      }, { "./packer-sync": 122, "./parser-sync": 126 }], 129: [function(C, Z, _) {
        (function(P, x) {
          var y = C("util"), E = C("stream"), d = C("./parser-async"), l = C("./packer-async"), u = C("./png-sync"), a = _.PNG = function(n) {
            E.call(this), n = n || {}, this.width = n.width | 0, this.height = n.height | 0, this.data = this.width > 0 && this.height > 0 ? new x(4 * this.width * this.height) : null, n.fill && this.data && this.data.fill(0), this.gamma = 0, this.readable = this.writable = !0, this._parser = new d(n), this._parser.on("error", this.emit.bind(this, "error")), this._parser.on("close", this._handleClose.bind(this)), this._parser.on("metadata", this._metadata.bind(this)), this._parser.on("gamma", this._gamma.bind(this)), this._parser.on("parsed", (function(c) {
              this.data = c, this.emit("parsed", c);
            }).bind(this)), this._packer = new l(n), this._packer.on("data", this.emit.bind(this, "data")), this._packer.on("end", this.emit.bind(this, "end")), this._parser.on("close", this._handleClose.bind(this)), this._packer.on("error", this.emit.bind(this, "error"));
          };
          y.inherits(a, E), a.sync = u, a.prototype.pack = function() {
            return !this.data || !this.data.length ? (this.emit("error", "No data provided"), this) : (P.nextTick((function() {
              this._packer.pack(this.data, this.width, this.height, this.gamma);
            }).bind(this)), this);
          }, a.prototype.parse = function(n, c) {
            if (c) {
              var g, f;
              g = (function(p) {
                this.removeListener("error", f), this.data = p, c(null, this);
              }).bind(this), f = (function(p) {
                this.removeListener("parsed", g), c(p, null);
              }).bind(this), this.once("parsed", g), this.once("error", f);
            }
            return this.end(n), this;
          }, a.prototype.write = function(n) {
            return this._parser.write(n), !0;
          }, a.prototype.end = function(n) {
            this._parser.end(n);
          }, a.prototype._metadata = function(n) {
            this.width = n.width, this.height = n.height, this.emit("metadata", n);
          }, a.prototype._gamma = function(n) {
            this.gamma = n;
          }, a.prototype._handleClose = function() {
            !this._parser.writable && !this._packer.readable && this.emit("close");
          }, a.bitblt = function(n, c, g, f, p, s, S, b) {
            if (g |= 0, f |= 0, p |= 0, s |= 0, S |= 0, b |= 0, g > n.width || f > n.height || g + p > n.width || f + s > n.height)
              throw new Error("bitblt reading outside image");
            if (S > c.width || b > c.height || S + p > c.width || b + s > c.height)
              throw new Error("bitblt writing outside image");
            for (var o = 0; o < s; o++)
              n.data.copy(
                c.data,
                (b + o) * c.width + S << 2,
                (f + o) * n.width + g << 2,
                (f + o) * n.width + g + p << 2
              );
          }, a.prototype.bitblt = function(n, c, g, f, p, s, S) {
            return a.bitblt(this, n, c, g, f, p, s, S), this;
          }, a.adjustGamma = function(n) {
            if (n.gamma) {
              for (var c = 0; c < n.height; c++)
                for (var g = 0; g < n.width; g++)
                  for (var f = n.width * c + g << 2, p = 0; p < 3; p++) {
                    var s = n.data[f + p] / 255;
                    s = Math.pow(s, 1 / 2.2 / n.gamma), n.data[f + p] = Math.round(s * 255);
                  }
              n.gamma = 0;
            }
          }, a.prototype.adjustGamma = function() {
            a.adjustGamma(this);
          };
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { "./packer-async": 121, "./parser-async": 125, "./png-sync": 128, _process: 133, buffer: 48, stream: 155, util: 186 }], 130: [function(C, Z, _) {
        (function(P, x) {
          var y = C("assert").ok, E = C("zlib"), d = C("util"), l = C("buffer").kMaxLength;
          function u(f) {
            if (!(this instanceof u))
              return new u(f);
            f && f.chunkSize < E.Z_MIN_CHUNK && (f.chunkSize = E.Z_MIN_CHUNK), E.Inflate.call(this, f), this._offset = this._offset === void 0 ? this._outOffset : this._offset, this._buffer = this._buffer || this._outBuffer, f && f.maxLength != null && (this._maxLength = f.maxLength);
          }
          function a(f) {
            return new u(f);
          }
          function n(f, p) {
            f._handle && (f._handle.close(), f._handle = null);
          }
          u.prototype._processChunk = function(f, p, s) {
            if (typeof s == "function")
              return E.Inflate._processChunk.call(this, f, p, s);
            var S = this, b = f && f.length, o = this._chunkSize - this._offset, A = this._maxLength, T = 0, R = [], L = 0, z;
            this.on("error", function(se) {
              z = se;
            });
            function U(se, ee) {
              if (!S._hadError) {
                var ie = o - ee;
                if (y(ie >= 0, "have should not go down"), ie > 0) {
                  var W = S._buffer.slice(S._offset, S._offset + ie);
                  if (S._offset += ie, W.length > A && (W = W.slice(0, A)), R.push(W), L += W.length, A -= W.length, A === 0)
                    return !1;
                }
                return (ee === 0 || S._offset >= S._chunkSize) && (o = S._chunkSize, S._offset = 0, S._buffer = x.allocUnsafe(S._chunkSize)), ee === 0 ? (T += b - se, b = se, !0) : !1;
              }
            }
            y(this._handle, "zlib binding closed");
            do {
              var J = this._handle.writeSync(
                p,
                f,
                // in
                T,
                // in_off
                b,
                // in_len
                this._buffer,
                // out
                this._offset,
                //out_off
                o
              );
              J = J || this._writeState;
            } while (!this._hadError && U(J[0], J[1]));
            if (this._hadError)
              throw z;
            if (L >= l)
              throw n(this), new RangeError("Cannot create final Buffer. It would be larger than 0x" + l.toString(16) + " bytes");
            var F = x.concat(R, L);
            return n(this), F;
          }, d.inherits(u, E.Inflate);
          function c(f, p) {
            if (typeof p == "string" && (p = x.from(p)), !(p instanceof x))
              throw new TypeError("Not a string or buffer");
            var s = f._finishFlushFlag;
            return s == null && (s = E.Z_FINISH), f._processChunk(p, s);
          }
          function g(f, p) {
            return c(new u(p), f);
          }
          Z.exports = _ = g, _.Inflate = u, _.createInflate = a, _.inflateSync = g;
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { _process: 133, assert: 25, buffer: 48, util: 186, zlib: 35 }], 131: [function(C, Z, _) {
        var P = Z.exports = function(x) {
          this._buffer = x, this._reads = [];
        };
        P.prototype.read = function(x, y) {
          this._reads.push({
            length: Math.abs(x),
            // if length < 0 then at most this length
            allowLess: x < 0,
            func: y
          });
        }, P.prototype.process = function() {
          for (; this._reads.length > 0 && this._buffer.length; ) {
            var x = this._reads[0];
            if (this._buffer.length && (this._buffer.length >= x.length || x.allowLess)) {
              this._reads.shift();
              var y = this._buffer;
              this._buffer = y.slice(x.length), x.func.call(this, y.slice(0, x.length));
            } else
              break;
          }
          if (this._reads.length > 0)
            return new Error("There are some read requests waitng on finished stream");
          if (this._buffer.length > 0)
            return new Error("unrecognised content at end of stream");
        };
      }, {}], 132: [function(C, Z, _) {
        (function(P) {
          typeof P > "u" || !P.version || P.version.indexOf("v0.") === 0 || P.version.indexOf("v1.") === 0 && P.version.indexOf("v1.8.") !== 0 ? Z.exports = { nextTick: x } : Z.exports = P;
          function x(y, E, d, l) {
            if (typeof y != "function")
              throw new TypeError('"callback" argument must be a function');
            var u = arguments.length, a, n;
            switch (u) {
              case 0:
              case 1:
                return P.nextTick(y);
              case 2:
                return P.nextTick(function() {
                  y.call(null, E);
                });
              case 3:
                return P.nextTick(function() {
                  y.call(null, E, d);
                });
              case 4:
                return P.nextTick(function() {
                  y.call(null, E, d, l);
                });
              default:
                for (a = new Array(u - 1), n = 0; n < a.length; )
                  a[n++] = arguments[n];
                return P.nextTick(function() {
                  y.apply(null, a);
                });
            }
          }
        }).call(this, C("_process"));
      }, { _process: 133 }], 133: [function(C, Z, _) {
        var P = Z.exports = {}, x, y;
        function E() {
          throw new Error("setTimeout has not been defined");
        }
        function d() {
          throw new Error("clearTimeout has not been defined");
        }
        (function() {
          try {
            typeof setTimeout == "function" ? x = setTimeout : x = E;
          } catch {
            x = E;
          }
          try {
            typeof clearTimeout == "function" ? y = clearTimeout : y = d;
          } catch {
            y = d;
          }
        })();
        function l(b) {
          if (x === setTimeout)
            return setTimeout(b, 0);
          if ((x === E || !x) && setTimeout)
            return x = setTimeout, setTimeout(b, 0);
          try {
            return x(b, 0);
          } catch {
            try {
              return x.call(null, b, 0);
            } catch {
              return x.call(this, b, 0);
            }
          }
        }
        function u(b) {
          if (y === clearTimeout)
            return clearTimeout(b);
          if ((y === d || !y) && clearTimeout)
            return y = clearTimeout, clearTimeout(b);
          try {
            return y(b);
          } catch {
            try {
              return y.call(null, b);
            } catch {
              return y.call(this, b);
            }
          }
        }
        var a = [], n = !1, c, g = -1;
        function f() {
          !n || !c || (n = !1, c.length ? a = c.concat(a) : g = -1, a.length && p());
        }
        function p() {
          if (!n) {
            var b = l(f);
            n = !0;
            for (var o = a.length; o; ) {
              for (c = a, a = []; ++g < o; )
                c && c[g].run();
              g = -1, o = a.length;
            }
            c = null, n = !1, u(b);
          }
        }
        P.nextTick = function(b) {
          var o = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var A = 1; A < arguments.length; A++)
              o[A - 1] = arguments[A];
          a.push(new s(b, o)), a.length === 1 && !n && l(p);
        };
        function s(b, o) {
          this.fun = b, this.array = o;
        }
        s.prototype.run = function() {
          this.fun.apply(null, this.array);
        }, P.title = "browser", P.browser = !0, P.env = {}, P.argv = [], P.version = "", P.versions = {};
        function S() {
        }
        P.on = S, P.addListener = S, P.once = S, P.off = S, P.removeListener = S, P.removeAllListeners = S, P.emit = S, P.prependListener = S, P.prependOnceListener = S, P.listeners = function(b) {
          return [];
        }, P.binding = function(b) {
          throw new Error("process.binding is not supported");
        }, P.cwd = function() {
          return "/";
        }, P.chdir = function(b) {
          throw new Error("process.chdir is not supported");
        }, P.umask = function() {
          return 0;
        };
      }, {}], 134: [function(C, Z, _) {
        (function(P) {
          (function(x) {
            var y = typeof _ == "object" && _ && !_.nodeType && _, E = typeof Z == "object" && Z && !Z.nodeType && Z, d = typeof P == "object" && P;
            (d.global === d || d.window === d || d.self === d) && (x = d);
            var l, u = 2147483647, a = 36, n = 1, c = 26, g = 38, f = 700, p = 72, s = 128, S = "-", b = /^xn--/, o = /[^\x20-\x7E]/, A = /[\x2E\u3002\uFF0E\uFF61]/g, T = {
              overflow: "Overflow: input needs wider integers to process",
              "not-basic": "Illegal input >= 0x80 (not a basic code point)",
              "invalid-input": "Invalid input"
            }, R = a - n, L = Math.floor, z = String.fromCharCode, U;
            function J(xe) {
              throw new RangeError(T[xe]);
            }
            function F(xe, Ee) {
              for (var Ie = xe.length, je = []; Ie--; )
                je[Ie] = Ee(xe[Ie]);
              return je;
            }
            function se(xe, Ee) {
              var Ie = xe.split("@"), je = "";
              Ie.length > 1 && (je = Ie[0] + "@", xe = Ie[1]), xe = xe.replace(A, ".");
              var Ue = xe.split("."), He = F(Ue, Ee).join(".");
              return je + He;
            }
            function ee(xe) {
              for (var Ee = [], Ie = 0, je = xe.length, Ue, He; Ie < je; )
                Ue = xe.charCodeAt(Ie++), Ue >= 55296 && Ue <= 56319 && Ie < je ? (He = xe.charCodeAt(Ie++), (He & 64512) == 56320 ? Ee.push(((Ue & 1023) << 10) + (He & 1023) + 65536) : (Ee.push(Ue), Ie--)) : Ee.push(Ue);
              return Ee;
            }
            function ie(xe) {
              return F(xe, function(Ee) {
                var Ie = "";
                return Ee > 65535 && (Ee -= 65536, Ie += z(Ee >>> 10 & 1023 | 55296), Ee = 56320 | Ee & 1023), Ie += z(Ee), Ie;
              }).join("");
            }
            function W(xe) {
              return xe - 48 < 10 ? xe - 22 : xe - 65 < 26 ? xe - 65 : xe - 97 < 26 ? xe - 97 : a;
            }
            function Q(xe, Ee) {
              return xe + 22 + 75 * (xe < 26) - ((Ee != 0) << 5);
            }
            function de(xe, Ee, Ie) {
              var je = 0;
              for (xe = Ie ? L(xe / f) : xe >> 1, xe += L(xe / Ee); xe > R * c >> 1; je += a)
                xe = L(xe / R);
              return L(je + (R + 1) * xe / (xe + g));
            }
            function _e(xe) {
              var Ee = [], Ie = xe.length, je, Ue = 0, He = s, Ze = p, $e, We, Ve, Re, De, Ne, we, re, $;
              for ($e = xe.lastIndexOf(S), $e < 0 && ($e = 0), We = 0; We < $e; ++We)
                xe.charCodeAt(We) >= 128 && J("not-basic"), Ee.push(xe.charCodeAt(We));
              for (Ve = $e > 0 ? $e + 1 : 0; Ve < Ie; ) {
                for (Re = Ue, De = 1, Ne = a; Ve >= Ie && J("invalid-input"), we = W(xe.charCodeAt(Ve++)), (we >= a || we > L((u - Ue) / De)) && J("overflow"), Ue += we * De, re = Ne <= Ze ? n : Ne >= Ze + c ? c : Ne - Ze, !(we < re); Ne += a)
                  $ = a - re, De > L(u / $) && J("overflow"), De *= $;
                je = Ee.length + 1, Ze = de(Ue - Re, je, Re == 0), L(Ue / je) > u - He && J("overflow"), He += L(Ue / je), Ue %= je, Ee.splice(Ue++, 0, He);
              }
              return ie(Ee);
            }
            function ke(xe) {
              var Ee, Ie, je, Ue, He, Ze, $e, We, Ve, Re, De, Ne = [], we, re, $, Ce;
              for (xe = ee(xe), we = xe.length, Ee = s, Ie = 0, He = p, Ze = 0; Ze < we; ++Ze)
                De = xe[Ze], De < 128 && Ne.push(z(De));
              for (je = Ue = Ne.length, Ue && Ne.push(S); je < we; ) {
                for ($e = u, Ze = 0; Ze < we; ++Ze)
                  De = xe[Ze], De >= Ee && De < $e && ($e = De);
                for (re = je + 1, $e - Ee > L((u - Ie) / re) && J("overflow"), Ie += ($e - Ee) * re, Ee = $e, Ze = 0; Ze < we; ++Ze)
                  if (De = xe[Ze], De < Ee && ++Ie > u && J("overflow"), De == Ee) {
                    for (We = Ie, Ve = a; Re = Ve <= He ? n : Ve >= He + c ? c : Ve - He, !(We < Re); Ve += a)
                      Ce = We - Re, $ = a - Re, Ne.push(
                        z(Q(Re + Ce % $, 0))
                      ), We = L(Ce / $);
                    Ne.push(z(Q(We, 0))), He = de(Ie, re, je == Ue), Ie = 0, ++je;
                  }
                ++Ie, ++Ee;
              }
              return Ne.join("");
            }
            function Pe(xe) {
              return se(xe, function(Ee) {
                return b.test(Ee) ? _e(Ee.slice(4).toLowerCase()) : Ee;
              });
            }
            function fe(xe) {
              return se(xe, function(Ee) {
                return o.test(Ee) ? "xn--" + ke(Ee) : Ee;
              });
            }
            if (l = {
              /**
               * A string representing the current Punycode.js version number.
               * @memberOf punycode
               * @type String
               */
              version: "1.4.1",
              /**
               * An object of methods to convert from JavaScript's internal character
               * representation (UCS-2) to Unicode code points, and back.
               * @see <https://mathiasbynens.be/notes/javascript-encoding>
               * @memberOf punycode
               * @type Object
               */
              ucs2: {
                decode: ee,
                encode: ie
              },
              decode: _e,
              encode: ke,
              toASCII: fe,
              toUnicode: Pe
            }, y && E)
              if (Z.exports == y)
                E.exports = l;
              else
                for (U in l)
                  l.hasOwnProperty(U) && (y[U] = l[U]);
            else
              x.punycode = l;
          })(this);
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, {}], 135: [function(C, Z, _) {
        function P(y, E) {
          return Object.prototype.hasOwnProperty.call(y, E);
        }
        Z.exports = function(y, E, d, l) {
          E = E || "&", d = d || "=";
          var u = {};
          if (typeof y != "string" || y.length === 0)
            return u;
          var a = /\+/g;
          y = y.split(E);
          var n = 1e3;
          l && typeof l.maxKeys == "number" && (n = l.maxKeys);
          var c = y.length;
          n > 0 && c > n && (c = n);
          for (var g = 0; g < c; ++g) {
            var f = y[g].replace(a, "%20"), p = f.indexOf(d), s, S, b, o;
            p >= 0 ? (s = f.substr(0, p), S = f.substr(p + 1)) : (s = f, S = ""), b = decodeURIComponent(s), o = decodeURIComponent(S), P(u, b) ? x(u[b]) ? u[b].push(o) : u[b] = [u[b], o] : u[b] = o;
          }
          return u;
        };
        var x = Array.isArray || function(y) {
          return Object.prototype.toString.call(y) === "[object Array]";
        };
      }, {}], 136: [function(C, Z, _) {
        var P = function(d) {
          switch (typeof d) {
            case "string":
              return d;
            case "boolean":
              return d ? "true" : "false";
            case "number":
              return isFinite(d) ? d : "";
            default:
              return "";
          }
        };
        Z.exports = function(d, l, u, a) {
          return l = l || "&", u = u || "=", d === null && (d = void 0), typeof d == "object" ? y(E(d), function(n) {
            var c = encodeURIComponent(P(n)) + u;
            return x(d[n]) ? y(d[n], function(g) {
              return c + encodeURIComponent(P(g));
            }).join(l) : c + encodeURIComponent(P(d[n]));
          }).join(l) : a ? encodeURIComponent(P(a)) + u + encodeURIComponent(P(d)) : "";
        };
        var x = Array.isArray || function(d) {
          return Object.prototype.toString.call(d) === "[object Array]";
        };
        function y(d, l) {
          if (d.map) return d.map(l);
          for (var u = [], a = 0; a < d.length; a++)
            u.push(l(d[a], a));
          return u;
        }
        var E = Object.keys || function(d) {
          var l = [];
          for (var u in d)
            Object.prototype.hasOwnProperty.call(d, u) && l.push(u);
          return l;
        };
      }, {}], 137: [function(C, Z, _) {
        _.decode = _.parse = C("./decode"), _.encode = _.stringify = C("./encode");
      }, { "./decode": 135, "./encode": 136 }], 138: [function(C, Z, _) {
        Z.exports = C("./lib/_stream_duplex.js");
      }, { "./lib/_stream_duplex.js": 139 }], 139: [function(C, Z, _) {
        var P = C("process-nextick-args"), x = Object.keys || function(f) {
          var p = [];
          for (var s in f)
            p.push(s);
          return p;
        };
        Z.exports = n;
        var y = C("core-util-is");
        y.inherits = C("inherits");
        var E = C("./_stream_readable"), d = C("./_stream_writable");
        y.inherits(n, E);
        for (var l = x(d.prototype), u = 0; u < l.length; u++) {
          var a = l[u];
          n.prototype[a] || (n.prototype[a] = d.prototype[a]);
        }
        function n(f) {
          if (!(this instanceof n)) return new n(f);
          E.call(this, f), d.call(this, f), f && f.readable === !1 && (this.readable = !1), f && f.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, f && f.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", c);
        }
        Object.defineProperty(n.prototype, "writableHighWaterMark", {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: !1,
          get: function() {
            return this._writableState.highWaterMark;
          }
        });
        function c() {
          this.allowHalfOpen || this._writableState.ended || P.nextTick(g, this);
        }
        function g(f) {
          f.end();
        }
        Object.defineProperty(n.prototype, "destroyed", {
          get: function() {
            return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
          },
          set: function(f) {
            this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = f, this._writableState.destroyed = f);
          }
        }), n.prototype._destroy = function(f, p) {
          this.push(null), this.end(), P.nextTick(p, f);
        };
      }, { "./_stream_readable": 141, "./_stream_writable": 143, "core-util-is": 51, inherits: 75, "process-nextick-args": 132 }], 140: [function(C, Z, _) {
        Z.exports = y;
        var P = C("./_stream_transform"), x = C("core-util-is");
        x.inherits = C("inherits"), x.inherits(y, P);
        function y(E) {
          if (!(this instanceof y)) return new y(E);
          P.call(this, E);
        }
        y.prototype._transform = function(E, d, l) {
          l(null, E);
        };
      }, { "./_stream_transform": 142, "core-util-is": 51, inherits: 75 }], 141: [function(C, Z, _) {
        (function(P, x) {
          var y = C("process-nextick-args");
          Z.exports = L;
          var E = C("isarray"), d;
          L.ReadableState = R, C("events").EventEmitter;
          var l = function(Re, De) {
            return Re.listeners(De).length;
          }, u = C("./internal/streams/stream"), a = C("safe-buffer").Buffer, n = x.Uint8Array || function() {
          };
          function c(Re) {
            return a.from(Re);
          }
          function g(Re) {
            return a.isBuffer(Re) || Re instanceof n;
          }
          var f = C("core-util-is");
          f.inherits = C("inherits");
          var p = C("util"), s = void 0;
          p && p.debuglog ? s = p.debuglog("stream") : s = function() {
          };
          var S = C("./internal/streams/BufferList"), b = C("./internal/streams/destroy"), o;
          f.inherits(L, u);
          var A = ["error", "close", "destroy", "pause", "resume"];
          function T(Re, De, Ne) {
            if (typeof Re.prependListener == "function") return Re.prependListener(De, Ne);
            !Re._events || !Re._events[De] ? Re.on(De, Ne) : E(Re._events[De]) ? Re._events[De].unshift(Ne) : Re._events[De] = [Ne, Re._events[De]];
          }
          function R(Re, De) {
            d = d || C("./_stream_duplex"), Re = Re || {};
            var Ne = De instanceof d;
            this.objectMode = !!Re.objectMode, Ne && (this.objectMode = this.objectMode || !!Re.readableObjectMode);
            var we = Re.highWaterMark, re = Re.readableHighWaterMark, $ = this.objectMode ? 16 : 16 * 1024;
            we || we === 0 ? this.highWaterMark = we : Ne && (re || re === 0) ? this.highWaterMark = re : this.highWaterMark = $, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new S(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = Re.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Re.encoding && (o || (o = C("string_decoder/").StringDecoder), this.decoder = new o(Re.encoding), this.encoding = Re.encoding);
          }
          function L(Re) {
            if (d = d || C("./_stream_duplex"), !(this instanceof L)) return new L(Re);
            this._readableState = new R(Re, this), this.readable = !0, Re && (typeof Re.read == "function" && (this._read = Re.read), typeof Re.destroy == "function" && (this._destroy = Re.destroy)), u.call(this);
          }
          Object.defineProperty(L.prototype, "destroyed", {
            get: function() {
              return this._readableState === void 0 ? !1 : this._readableState.destroyed;
            },
            set: function(Re) {
              this._readableState && (this._readableState.destroyed = Re);
            }
          }), L.prototype.destroy = b.destroy, L.prototype._undestroy = b.undestroy, L.prototype._destroy = function(Re, De) {
            this.push(null), De(Re);
          }, L.prototype.push = function(Re, De) {
            var Ne = this._readableState, we;
            return Ne.objectMode ? we = !0 : typeof Re == "string" && (De = De || Ne.defaultEncoding, De !== Ne.encoding && (Re = a.from(Re, De), De = ""), we = !0), z(this, Re, De, !1, we);
          }, L.prototype.unshift = function(Re) {
            return z(this, Re, null, !0, !1);
          };
          function z(Re, De, Ne, we, re) {
            var $ = Re._readableState;
            if (De === null)
              $.reading = !1, W(Re, $);
            else {
              var Ce;
              re || (Ce = J($, De)), Ce ? Re.emit("error", Ce) : $.objectMode || De && De.length > 0 ? (typeof De != "string" && !$.objectMode && Object.getPrototypeOf(De) !== a.prototype && (De = c(De)), we ? $.endEmitted ? Re.emit("error", new Error("stream.unshift() after end event")) : U(Re, $, De, !0) : $.ended ? Re.emit("error", new Error("stream.push() after EOF")) : ($.reading = !1, $.decoder && !Ne ? (De = $.decoder.write(De), $.objectMode || De.length !== 0 ? U(Re, $, De, !1) : _e(Re, $)) : U(Re, $, De, !1))) : we || ($.reading = !1);
            }
            return F($);
          }
          function U(Re, De, Ne, we) {
            De.flowing && De.length === 0 && !De.sync ? (Re.emit("data", Ne), Re.read(0)) : (De.length += De.objectMode ? 1 : Ne.length, we ? De.buffer.unshift(Ne) : De.buffer.push(Ne), De.needReadable && Q(Re)), _e(Re, De);
          }
          function J(Re, De) {
            var Ne;
            return !g(De) && typeof De != "string" && De !== void 0 && !Re.objectMode && (Ne = new TypeError("Invalid non-string/buffer chunk")), Ne;
          }
          function F(Re) {
            return !Re.ended && (Re.needReadable || Re.length < Re.highWaterMark || Re.length === 0);
          }
          L.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, L.prototype.setEncoding = function(Re) {
            return o || (o = C("string_decoder/").StringDecoder), this._readableState.decoder = new o(Re), this._readableState.encoding = Re, this;
          };
          var se = 8388608;
          function ee(Re) {
            return Re >= se ? Re = se : (Re--, Re |= Re >>> 1, Re |= Re >>> 2, Re |= Re >>> 4, Re |= Re >>> 8, Re |= Re >>> 16, Re++), Re;
          }
          function ie(Re, De) {
            return Re <= 0 || De.length === 0 && De.ended ? 0 : De.objectMode ? 1 : Re !== Re ? De.flowing && De.length ? De.buffer.head.data.length : De.length : (Re > De.highWaterMark && (De.highWaterMark = ee(Re)), Re <= De.length ? Re : De.ended ? De.length : (De.needReadable = !0, 0));
          }
          L.prototype.read = function(Re) {
            s("read", Re), Re = parseInt(Re, 10);
            var De = this._readableState, Ne = Re;
            if (Re !== 0 && (De.emittedReadable = !1), Re === 0 && De.needReadable && (De.length >= De.highWaterMark || De.ended))
              return s("read: emitReadable", De.length, De.ended), De.length === 0 && De.ended ? $e(this) : Q(this), null;
            if (Re = ie(Re, De), Re === 0 && De.ended)
              return De.length === 0 && $e(this), null;
            var we = De.needReadable;
            s("need readable", we), (De.length === 0 || De.length - Re < De.highWaterMark) && (we = !0, s("length less than watermark", we)), De.ended || De.reading ? (we = !1, s("reading or ended", we)) : we && (s("do read"), De.reading = !0, De.sync = !0, De.length === 0 && (De.needReadable = !0), this._read(De.highWaterMark), De.sync = !1, De.reading || (Re = ie(Ne, De)));
            var re;
            return Re > 0 ? re = je(Re, De) : re = null, re === null ? (De.needReadable = !0, Re = 0) : De.length -= Re, De.length === 0 && (De.ended || (De.needReadable = !0), Ne !== Re && De.ended && $e(this)), re !== null && this.emit("data", re), re;
          };
          function W(Re, De) {
            if (!De.ended) {
              if (De.decoder) {
                var Ne = De.decoder.end();
                Ne && Ne.length && (De.buffer.push(Ne), De.length += De.objectMode ? 1 : Ne.length);
              }
              De.ended = !0, Q(Re);
            }
          }
          function Q(Re) {
            var De = Re._readableState;
            De.needReadable = !1, De.emittedReadable || (s("emitReadable", De.flowing), De.emittedReadable = !0, De.sync ? y.nextTick(de, Re) : de(Re));
          }
          function de(Re) {
            s("emit readable"), Re.emit("readable"), Ie(Re);
          }
          function _e(Re, De) {
            De.readingMore || (De.readingMore = !0, y.nextTick(ke, Re, De));
          }
          function ke(Re, De) {
            for (var Ne = De.length; !De.reading && !De.flowing && !De.ended && De.length < De.highWaterMark && (s("maybeReadMore read 0"), Re.read(0), Ne !== De.length); )
              Ne = De.length;
            De.readingMore = !1;
          }
          L.prototype._read = function(Re) {
            this.emit("error", new Error("_read() is not implemented"));
          }, L.prototype.pipe = function(Re, De) {
            var Ne = this, we = this._readableState;
            switch (we.pipesCount) {
              case 0:
                we.pipes = Re;
                break;
              case 1:
                we.pipes = [we.pipes, Re];
                break;
              default:
                we.pipes.push(Re);
                break;
            }
            we.pipesCount += 1, s("pipe count=%d opts=%j", we.pipesCount, De);
            var re = (!De || De.end !== !1) && Re !== P.stdout && Re !== P.stderr, $ = re ? ve : B;
            we.endEmitted ? y.nextTick($) : Ne.once("end", $), Re.on("unpipe", Ce);
            function Ce(j, H) {
              s("onunpipe"), j === Ne && H && H.hasUnpiped === !1 && (H.hasUnpiped = !0, Ae());
            }
            function ve() {
              s("onend"), Re.end();
            }
            var Y = Pe(Ne);
            Re.on("drain", Y);
            var G = !1;
            function Ae() {
              s("cleanup"), Re.removeListener("close", k), Re.removeListener("finish", I), Re.removeListener("drain", Y), Re.removeListener("error", h), Re.removeListener("unpipe", Ce), Ne.removeListener("end", ve), Ne.removeListener("end", B), Ne.removeListener("data", r), G = !0, we.awaitDrain && (!Re._writableState || Re._writableState.needDrain) && Y();
            }
            var e = !1;
            Ne.on("data", r);
            function r(j) {
              s("ondata"), e = !1;
              var H = Re.write(j);
              H === !1 && !e && ((we.pipesCount === 1 && we.pipes === Re || we.pipesCount > 1 && Ve(we.pipes, Re) !== -1) && !G && (s("false write response, pause", Ne._readableState.awaitDrain), Ne._readableState.awaitDrain++, e = !0), Ne.pause());
            }
            function h(j) {
              s("onerror", j), B(), Re.removeListener("error", h), l(Re, "error") === 0 && Re.emit("error", j);
            }
            T(Re, "error", h);
            function k() {
              Re.removeListener("finish", I), B();
            }
            Re.once("close", k);
            function I() {
              s("onfinish"), Re.removeListener("close", k), B();
            }
            Re.once("finish", I);
            function B() {
              s("unpipe"), Ne.unpipe(Re);
            }
            return Re.emit("pipe", Ne), we.flowing || (s("pipe resume"), Ne.resume()), Re;
          };
          function Pe(Re) {
            return function() {
              var De = Re._readableState;
              s("pipeOnDrain", De.awaitDrain), De.awaitDrain && De.awaitDrain--, De.awaitDrain === 0 && l(Re, "data") && (De.flowing = !0, Ie(Re));
            };
          }
          L.prototype.unpipe = function(Re) {
            var De = this._readableState, Ne = { hasUnpiped: !1 };
            if (De.pipesCount === 0) return this;
            if (De.pipesCount === 1)
              return Re && Re !== De.pipes ? this : (Re || (Re = De.pipes), De.pipes = null, De.pipesCount = 0, De.flowing = !1, Re && Re.emit("unpipe", this, Ne), this);
            if (!Re) {
              var we = De.pipes, re = De.pipesCount;
              De.pipes = null, De.pipesCount = 0, De.flowing = !1;
              for (var $ = 0; $ < re; $++)
                we[$].emit("unpipe", this, Ne);
              return this;
            }
            var Ce = Ve(De.pipes, Re);
            return Ce === -1 ? this : (De.pipes.splice(Ce, 1), De.pipesCount -= 1, De.pipesCount === 1 && (De.pipes = De.pipes[0]), Re.emit("unpipe", this, Ne), this);
          }, L.prototype.on = function(Re, De) {
            var Ne = u.prototype.on.call(this, Re, De);
            if (Re === "data")
              this._readableState.flowing !== !1 && this.resume();
            else if (Re === "readable") {
              var we = this._readableState;
              !we.endEmitted && !we.readableListening && (we.readableListening = we.needReadable = !0, we.emittedReadable = !1, we.reading ? we.length && Q(this) : y.nextTick(fe, this));
            }
            return Ne;
          }, L.prototype.addListener = L.prototype.on;
          function fe(Re) {
            s("readable nexttick read 0"), Re.read(0);
          }
          L.prototype.resume = function() {
            var Re = this._readableState;
            return Re.flowing || (s("resume"), Re.flowing = !0, xe(this, Re)), this;
          };
          function xe(Re, De) {
            De.resumeScheduled || (De.resumeScheduled = !0, y.nextTick(Ee, Re, De));
          }
          function Ee(Re, De) {
            De.reading || (s("resume read 0"), Re.read(0)), De.resumeScheduled = !1, De.awaitDrain = 0, Re.emit("resume"), Ie(Re), De.flowing && !De.reading && Re.read(0);
          }
          L.prototype.pause = function() {
            return s("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (s("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
          };
          function Ie(Re) {
            var De = Re._readableState;
            for (s("flow", De.flowing); De.flowing && Re.read() !== null; )
              ;
          }
          L.prototype.wrap = function(Re) {
            var De = this, Ne = this._readableState, we = !1;
            Re.on("end", function() {
              if (s("wrapped end"), Ne.decoder && !Ne.ended) {
                var Ce = Ne.decoder.end();
                Ce && Ce.length && De.push(Ce);
              }
              De.push(null);
            }), Re.on("data", function(Ce) {
              if (s("wrapped data"), Ne.decoder && (Ce = Ne.decoder.write(Ce)), !(Ne.objectMode && Ce == null) && !(!Ne.objectMode && (!Ce || !Ce.length))) {
                var ve = De.push(Ce);
                ve || (we = !0, Re.pause());
              }
            });
            for (var re in Re)
              this[re] === void 0 && typeof Re[re] == "function" && (this[re] = /* @__PURE__ */ function(Ce) {
                return function() {
                  return Re[Ce].apply(Re, arguments);
                };
              }(re));
            for (var $ = 0; $ < A.length; $++)
              Re.on(A[$], this.emit.bind(this, A[$]));
            return this._read = function(Ce) {
              s("wrapped _read", Ce), we && (we = !1, Re.resume());
            }, this;
          }, Object.defineProperty(L.prototype, "readableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState.highWaterMark;
            }
          }), L._fromList = je;
          function je(Re, De) {
            if (De.length === 0) return null;
            var Ne;
            return De.objectMode ? Ne = De.buffer.shift() : !Re || Re >= De.length ? (De.decoder ? Ne = De.buffer.join("") : De.buffer.length === 1 ? Ne = De.buffer.head.data : Ne = De.buffer.concat(De.length), De.buffer.clear()) : Ne = Ue(Re, De.buffer, De.decoder), Ne;
          }
          function Ue(Re, De, Ne) {
            var we;
            return Re < De.head.data.length ? (we = De.head.data.slice(0, Re), De.head.data = De.head.data.slice(Re)) : Re === De.head.data.length ? we = De.shift() : we = Ne ? He(Re, De) : Ze(Re, De), we;
          }
          function He(Re, De) {
            var Ne = De.head, we = 1, re = Ne.data;
            for (Re -= re.length; Ne = Ne.next; ) {
              var $ = Ne.data, Ce = Re > $.length ? $.length : Re;
              if (Ce === $.length ? re += $ : re += $.slice(0, Re), Re -= Ce, Re === 0) {
                Ce === $.length ? (++we, Ne.next ? De.head = Ne.next : De.head = De.tail = null) : (De.head = Ne, Ne.data = $.slice(Ce));
                break;
              }
              ++we;
            }
            return De.length -= we, re;
          }
          function Ze(Re, De) {
            var Ne = a.allocUnsafe(Re), we = De.head, re = 1;
            for (we.data.copy(Ne), Re -= we.data.length; we = we.next; ) {
              var $ = we.data, Ce = Re > $.length ? $.length : Re;
              if ($.copy(Ne, Ne.length - Re, 0, Ce), Re -= Ce, Re === 0) {
                Ce === $.length ? (++re, we.next ? De.head = we.next : De.head = De.tail = null) : (De.head = we, we.data = $.slice(Ce));
                break;
              }
              ++re;
            }
            return De.length -= re, Ne;
          }
          function $e(Re) {
            var De = Re._readableState;
            if (De.length > 0) throw new Error('"endReadable()" called on non-empty stream');
            De.endEmitted || (De.ended = !0, y.nextTick(We, De, Re));
          }
          function We(Re, De) {
            !Re.endEmitted && Re.length === 0 && (Re.endEmitted = !0, De.readable = !1, De.emit("end"));
          }
          function Ve(Re, De) {
            for (var Ne = 0, we = Re.length; Ne < we; Ne++)
              if (Re[Ne] === De) return Ne;
            return -1;
          }
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "./_stream_duplex": 139, "./internal/streams/BufferList": 144, "./internal/streams/destroy": 145, "./internal/streams/stream": 146, _process: 133, "core-util-is": 51, events: 52, inherits: 75, isarray: 79, "process-nextick-args": 132, "safe-buffer": 147, "string_decoder/": 148, util: 33 }], 142: [function(C, Z, _) {
        Z.exports = E;
        var P = C("./_stream_duplex"), x = C("core-util-is");
        x.inherits = C("inherits"), x.inherits(E, P);
        function y(u, a) {
          var n = this._transformState;
          n.transforming = !1;
          var c = n.writecb;
          if (!c)
            return this.emit("error", new Error("write callback called multiple times"));
          n.writechunk = null, n.writecb = null, a != null && this.push(a), c(u);
          var g = this._readableState;
          g.reading = !1, (g.needReadable || g.length < g.highWaterMark) && this._read(g.highWaterMark);
        }
        function E(u) {
          if (!(this instanceof E)) return new E(u);
          P.call(this, u), this._transformState = {
            afterTransform: y.bind(this),
            needTransform: !1,
            transforming: !1,
            writecb: null,
            writechunk: null,
            writeencoding: null
          }, this._readableState.needReadable = !0, this._readableState.sync = !1, u && (typeof u.transform == "function" && (this._transform = u.transform), typeof u.flush == "function" && (this._flush = u.flush)), this.on("prefinish", d);
        }
        function d() {
          var u = this;
          typeof this._flush == "function" ? this._flush(function(a, n) {
            l(u, a, n);
          }) : l(this, null, null);
        }
        E.prototype.push = function(u, a) {
          return this._transformState.needTransform = !1, P.prototype.push.call(this, u, a);
        }, E.prototype._transform = function(u, a, n) {
          throw new Error("_transform() is not implemented");
        }, E.prototype._write = function(u, a, n) {
          var c = this._transformState;
          if (c.writecb = n, c.writechunk = u, c.writeencoding = a, !c.transforming) {
            var g = this._readableState;
            (c.needTransform || g.needReadable || g.length < g.highWaterMark) && this._read(g.highWaterMark);
          }
        }, E.prototype._read = function(u) {
          var a = this._transformState;
          a.writechunk !== null && a.writecb && !a.transforming ? (a.transforming = !0, this._transform(a.writechunk, a.writeencoding, a.afterTransform)) : a.needTransform = !0;
        }, E.prototype._destroy = function(u, a) {
          var n = this;
          P.prototype._destroy.call(this, u, function(c) {
            a(c), n.emit("close");
          });
        };
        function l(u, a, n) {
          if (a) return u.emit("error", a);
          if (n != null && u.push(n), u._writableState.length) throw new Error("Calling transform done when ws.length != 0");
          if (u._transformState.transforming) throw new Error("Calling transform done when still transforming");
          return u.push(null);
        }
      }, { "./_stream_duplex": 139, "core-util-is": 51, inherits: 75 }], 143: [function(C, Z, _) {
        (function(P, x, y) {
          var E = C("process-nextick-args");
          Z.exports = T;
          function d(Ee) {
            var Ie = this;
            this.next = null, this.entry = null, this.finish = function() {
              xe(Ie, Ee);
            };
          }
          var l = !P.browser && ["v0.10", "v0.9."].indexOf(P.version.slice(0, 5)) > -1 ? y : E.nextTick, u;
          T.WritableState = o;
          var a = C("core-util-is");
          a.inherits = C("inherits");
          var n = {
            deprecate: C("util-deprecate")
          }, c = C("./internal/streams/stream"), g = C("safe-buffer").Buffer, f = x.Uint8Array || function() {
          };
          function p(Ee) {
            return g.from(Ee);
          }
          function s(Ee) {
            return g.isBuffer(Ee) || Ee instanceof f;
          }
          var S = C("./internal/streams/destroy");
          a.inherits(T, c);
          function b() {
          }
          function o(Ee, Ie) {
            u = u || C("./_stream_duplex"), Ee = Ee || {};
            var je = Ie instanceof u;
            this.objectMode = !!Ee.objectMode, je && (this.objectMode = this.objectMode || !!Ee.writableObjectMode);
            var Ue = Ee.highWaterMark, He = Ee.writableHighWaterMark, Ze = this.objectMode ? 16 : 16 * 1024;
            Ue || Ue === 0 ? this.highWaterMark = Ue : je && (He || He === 0) ? this.highWaterMark = He : this.highWaterMark = Ze, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var $e = Ee.decodeStrings === !1;
            this.decodeStrings = !$e, this.defaultEncoding = Ee.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(We) {
              ee(Ie, We);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new d(this);
          }
          o.prototype.getBuffer = function() {
            for (var Ie = this.bufferedRequest, je = []; Ie; )
              je.push(Ie), Ie = Ie.next;
            return je;
          }, function() {
            try {
              Object.defineProperty(o.prototype, "buffer", {
                get: n.deprecate(function() {
                  return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
              });
            } catch {
            }
          }();
          var A;
          typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (A = Function.prototype[Symbol.hasInstance], Object.defineProperty(T, Symbol.hasInstance, {
            value: function(Ee) {
              return A.call(this, Ee) ? !0 : this !== T ? !1 : Ee && Ee._writableState instanceof o;
            }
          })) : A = function(Ee) {
            return Ee instanceof this;
          };
          function T(Ee) {
            if (u = u || C("./_stream_duplex"), !A.call(T, this) && !(this instanceof u))
              return new T(Ee);
            this._writableState = new o(Ee, this), this.writable = !0, Ee && (typeof Ee.write == "function" && (this._write = Ee.write), typeof Ee.writev == "function" && (this._writev = Ee.writev), typeof Ee.destroy == "function" && (this._destroy = Ee.destroy), typeof Ee.final == "function" && (this._final = Ee.final)), c.call(this);
          }
          T.prototype.pipe = function() {
            this.emit("error", new Error("Cannot pipe, not readable"));
          };
          function R(Ee, Ie) {
            var je = new Error("write after end");
            Ee.emit("error", je), E.nextTick(Ie, je);
          }
          function L(Ee, Ie, je, Ue) {
            var He = !0, Ze = !1;
            return je === null ? Ze = new TypeError("May not write null values to stream") : typeof je != "string" && je !== void 0 && !Ie.objectMode && (Ze = new TypeError("Invalid non-string/buffer chunk")), Ze && (Ee.emit("error", Ze), E.nextTick(Ue, Ze), He = !1), He;
          }
          T.prototype.write = function(Ee, Ie, je) {
            var Ue = this._writableState, He = !1, Ze = !Ue.objectMode && s(Ee);
            return Ze && !g.isBuffer(Ee) && (Ee = p(Ee)), typeof Ie == "function" && (je = Ie, Ie = null), Ze ? Ie = "buffer" : Ie || (Ie = Ue.defaultEncoding), typeof je != "function" && (je = b), Ue.ended ? R(this, je) : (Ze || L(this, Ue, Ee, je)) && (Ue.pendingcb++, He = U(this, Ue, Ze, Ee, Ie, je)), He;
          }, T.prototype.cork = function() {
            var Ee = this._writableState;
            Ee.corked++;
          }, T.prototype.uncork = function() {
            var Ee = this._writableState;
            Ee.corked && (Ee.corked--, !Ee.writing && !Ee.corked && !Ee.finished && !Ee.bufferProcessing && Ee.bufferedRequest && Q(this, Ee));
          }, T.prototype.setDefaultEncoding = function(Ie) {
            if (typeof Ie == "string" && (Ie = Ie.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ie + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + Ie);
            return this._writableState.defaultEncoding = Ie, this;
          };
          function z(Ee, Ie, je) {
            return !Ee.objectMode && Ee.decodeStrings !== !1 && typeof Ie == "string" && (Ie = g.from(Ie, je)), Ie;
          }
          Object.defineProperty(T.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState.highWaterMark;
            }
          });
          function U(Ee, Ie, je, Ue, He, Ze) {
            if (!je) {
              var $e = z(Ie, Ue, He);
              Ue !== $e && (je = !0, He = "buffer", Ue = $e);
            }
            var We = Ie.objectMode ? 1 : Ue.length;
            Ie.length += We;
            var Ve = Ie.length < Ie.highWaterMark;
            if (Ve || (Ie.needDrain = !0), Ie.writing || Ie.corked) {
              var Re = Ie.lastBufferedRequest;
              Ie.lastBufferedRequest = {
                chunk: Ue,
                encoding: He,
                isBuf: je,
                callback: Ze,
                next: null
              }, Re ? Re.next = Ie.lastBufferedRequest : Ie.bufferedRequest = Ie.lastBufferedRequest, Ie.bufferedRequestCount += 1;
            } else
              J(Ee, Ie, !1, We, Ue, He, Ze);
            return Ve;
          }
          function J(Ee, Ie, je, Ue, He, Ze, $e) {
            Ie.writelen = Ue, Ie.writecb = $e, Ie.writing = !0, Ie.sync = !0, je ? Ee._writev(He, Ie.onwrite) : Ee._write(He, Ze, Ie.onwrite), Ie.sync = !1;
          }
          function F(Ee, Ie, je, Ue, He) {
            --Ie.pendingcb, je ? (E.nextTick(He, Ue), E.nextTick(Pe, Ee, Ie), Ee._writableState.errorEmitted = !0, Ee.emit("error", Ue)) : (He(Ue), Ee._writableState.errorEmitted = !0, Ee.emit("error", Ue), Pe(Ee, Ie));
          }
          function se(Ee) {
            Ee.writing = !1, Ee.writecb = null, Ee.length -= Ee.writelen, Ee.writelen = 0;
          }
          function ee(Ee, Ie) {
            var je = Ee._writableState, Ue = je.sync, He = je.writecb;
            if (se(je), Ie) F(Ee, je, Ue, Ie, He);
            else {
              var Ze = de(je);
              !Ze && !je.corked && !je.bufferProcessing && je.bufferedRequest && Q(Ee, je), Ue ? l(ie, Ee, je, Ze, He) : ie(Ee, je, Ze, He);
            }
          }
          function ie(Ee, Ie, je, Ue) {
            je || W(Ee, Ie), Ie.pendingcb--, Ue(), Pe(Ee, Ie);
          }
          function W(Ee, Ie) {
            Ie.length === 0 && Ie.needDrain && (Ie.needDrain = !1, Ee.emit("drain"));
          }
          function Q(Ee, Ie) {
            Ie.bufferProcessing = !0;
            var je = Ie.bufferedRequest;
            if (Ee._writev && je && je.next) {
              var Ue = Ie.bufferedRequestCount, He = new Array(Ue), Ze = Ie.corkedRequestsFree;
              Ze.entry = je;
              for (var $e = 0, We = !0; je; )
                He[$e] = je, je.isBuf || (We = !1), je = je.next, $e += 1;
              He.allBuffers = We, J(Ee, Ie, !0, Ie.length, He, "", Ze.finish), Ie.pendingcb++, Ie.lastBufferedRequest = null, Ze.next ? (Ie.corkedRequestsFree = Ze.next, Ze.next = null) : Ie.corkedRequestsFree = new d(Ie), Ie.bufferedRequestCount = 0;
            } else {
              for (; je; ) {
                var Ve = je.chunk, Re = je.encoding, De = je.callback, Ne = Ie.objectMode ? 1 : Ve.length;
                if (J(Ee, Ie, !1, Ne, Ve, Re, De), je = je.next, Ie.bufferedRequestCount--, Ie.writing)
                  break;
              }
              je === null && (Ie.lastBufferedRequest = null);
            }
            Ie.bufferedRequest = je, Ie.bufferProcessing = !1;
          }
          T.prototype._write = function(Ee, Ie, je) {
            je(new Error("_write() is not implemented"));
          }, T.prototype._writev = null, T.prototype.end = function(Ee, Ie, je) {
            var Ue = this._writableState;
            typeof Ee == "function" ? (je = Ee, Ee = null, Ie = null) : typeof Ie == "function" && (je = Ie, Ie = null), Ee != null && this.write(Ee, Ie), Ue.corked && (Ue.corked = 1, this.uncork()), !Ue.ending && !Ue.finished && fe(this, Ue, je);
          };
          function de(Ee) {
            return Ee.ending && Ee.length === 0 && Ee.bufferedRequest === null && !Ee.finished && !Ee.writing;
          }
          function _e(Ee, Ie) {
            Ee._final(function(je) {
              Ie.pendingcb--, je && Ee.emit("error", je), Ie.prefinished = !0, Ee.emit("prefinish"), Pe(Ee, Ie);
            });
          }
          function ke(Ee, Ie) {
            !Ie.prefinished && !Ie.finalCalled && (typeof Ee._final == "function" ? (Ie.pendingcb++, Ie.finalCalled = !0, E.nextTick(_e, Ee, Ie)) : (Ie.prefinished = !0, Ee.emit("prefinish")));
          }
          function Pe(Ee, Ie) {
            var je = de(Ie);
            return je && (ke(Ee, Ie), Ie.pendingcb === 0 && (Ie.finished = !0, Ee.emit("finish"))), je;
          }
          function fe(Ee, Ie, je) {
            Ie.ending = !0, Pe(Ee, Ie), je && (Ie.finished ? E.nextTick(je) : Ee.once("finish", je)), Ie.ended = !0, Ee.writable = !1;
          }
          function xe(Ee, Ie, je) {
            var Ue = Ee.entry;
            for (Ee.entry = null; Ue; ) {
              var He = Ue.callback;
              Ie.pendingcb--, He(je), Ue = Ue.next;
            }
            Ie.corkedRequestsFree ? Ie.corkedRequestsFree.next = Ee : Ie.corkedRequestsFree = Ee;
          }
          Object.defineProperty(T.prototype, "destroyed", {
            get: function() {
              return this._writableState === void 0 ? !1 : this._writableState.destroyed;
            },
            set: function(Ee) {
              this._writableState && (this._writableState.destroyed = Ee);
            }
          }), T.prototype.destroy = S.destroy, T.prototype._undestroy = S.undestroy, T.prototype._destroy = function(Ee, Ie) {
            this.end(), Ie(Ee);
          };
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {}, C("timers").setImmediate);
      }, { "./_stream_duplex": 139, "./internal/streams/destroy": 145, "./internal/streams/stream": 146, _process: 133, "core-util-is": 51, inherits: 75, "process-nextick-args": 132, "safe-buffer": 147, timers: 176, "util-deprecate": 183 }], 144: [function(C, Z, _) {
        function P(d, l) {
          if (!(d instanceof l))
            throw new TypeError("Cannot call a class as a function");
        }
        var x = C("safe-buffer").Buffer, y = C("util");
        function E(d, l, u) {
          d.copy(l, u);
        }
        Z.exports = function() {
          function d() {
            P(this, d), this.head = null, this.tail = null, this.length = 0;
          }
          return d.prototype.push = function(u) {
            var a = { data: u, next: null };
            this.length > 0 ? this.tail.next = a : this.head = a, this.tail = a, ++this.length;
          }, d.prototype.unshift = function(u) {
            var a = { data: u, next: this.head };
            this.length === 0 && (this.tail = a), this.head = a, ++this.length;
          }, d.prototype.shift = function() {
            if (this.length !== 0) {
              var u = this.head.data;
              return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, u;
            }
          }, d.prototype.clear = function() {
            this.head = this.tail = null, this.length = 0;
          }, d.prototype.join = function(u) {
            if (this.length === 0) return "";
            for (var a = this.head, n = "" + a.data; a = a.next; )
              n += u + a.data;
            return n;
          }, d.prototype.concat = function(u) {
            if (this.length === 0) return x.alloc(0);
            if (this.length === 1) return this.head.data;
            for (var a = x.allocUnsafe(u >>> 0), n = this.head, c = 0; n; )
              E(n.data, a, c), c += n.data.length, n = n.next;
            return a;
          }, d;
        }(), y && y.inspect && y.inspect.custom && (Z.exports.prototype[y.inspect.custom] = function() {
          var d = y.inspect({ length: this.length });
          return this.constructor.name + " " + d;
        });
      }, { "safe-buffer": 147, util: 33 }], 145: [function(C, Z, _) {
        var P = C("process-nextick-args");
        function x(d, l) {
          var u = this, a = this._readableState && this._readableState.destroyed, n = this._writableState && this._writableState.destroyed;
          return a || n ? (l ? l(d) : d && (!this._writableState || !this._writableState.errorEmitted) && P.nextTick(E, this, d), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(c) {
            !l && c ? (P.nextTick(E, u, c), u._writableState && (u._writableState.errorEmitted = !0)) : l && l(c);
          }), this);
        }
        function y() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
        function E(d, l) {
          d.emit("error", l);
        }
        Z.exports = {
          destroy: x,
          undestroy: y
        };
      }, { "process-nextick-args": 132 }], 146: [function(C, Z, _) {
        Z.exports = C("events").EventEmitter;
      }, { events: 52 }], 147: [function(C, Z, _) {
        var P = C("buffer"), x = P.Buffer;
        function y(d, l) {
          for (var u in d)
            l[u] = d[u];
        }
        x.from && x.alloc && x.allocUnsafe && x.allocUnsafeSlow ? Z.exports = P : (y(P, _), _.Buffer = E);
        function E(d, l, u) {
          return x(d, l, u);
        }
        y(x, E), E.from = function(d, l, u) {
          if (typeof d == "number")
            throw new TypeError("Argument must not be a number");
          return x(d, l, u);
        }, E.alloc = function(d, l, u) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          var a = x(d);
          return l !== void 0 ? typeof u == "string" ? a.fill(l, u) : a.fill(l) : a.fill(0), a;
        }, E.allocUnsafe = function(d) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          return x(d);
        }, E.allocUnsafeSlow = function(d) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          return P.SlowBuffer(d);
        };
      }, { buffer: 48 }], 148: [function(C, Z, _) {
        var P = C("safe-buffer").Buffer, x = P.isEncoding || function(A) {
          switch (A = "" + A, A && A.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return !0;
            default:
              return !1;
          }
        };
        function y(A) {
          if (!A) return "utf8";
          for (var T; ; )
            switch (A) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return A;
              default:
                if (T) return;
                A = ("" + A).toLowerCase(), T = !0;
            }
        }
        function E(A) {
          var T = y(A);
          if (typeof T != "string" && (P.isEncoding === x || !x(A))) throw new Error("Unknown encoding: " + A);
          return T || A;
        }
        _.StringDecoder = d;
        function d(A) {
          this.encoding = E(A);
          var T;
          switch (this.encoding) {
            case "utf16le":
              this.text = f, this.end = p, T = 4;
              break;
            case "utf8":
              this.fillLast = n, T = 4;
              break;
            case "base64":
              this.text = s, this.end = S, T = 3;
              break;
            default:
              this.write = b, this.end = o;
              return;
          }
          this.lastNeed = 0, this.lastTotal = 0, this.lastChar = P.allocUnsafe(T);
        }
        d.prototype.write = function(A) {
          if (A.length === 0) return "";
          var T, R;
          if (this.lastNeed) {
            if (T = this.fillLast(A), T === void 0) return "";
            R = this.lastNeed, this.lastNeed = 0;
          } else
            R = 0;
          return R < A.length ? T ? T + this.text(A, R) : this.text(A, R) : T || "";
        }, d.prototype.end = g, d.prototype.text = c, d.prototype.fillLast = function(A) {
          if (this.lastNeed <= A.length)
            return A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          A.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, A.length), this.lastNeed -= A.length;
        };
        function l(A) {
          return A <= 127 ? 0 : A >> 5 === 6 ? 2 : A >> 4 === 14 ? 3 : A >> 3 === 30 ? 4 : A >> 6 === 2 ? -1 : -2;
        }
        function u(A, T, R) {
          var L = T.length - 1;
          if (L < R) return 0;
          var z = l(T[L]);
          return z >= 0 ? (z > 0 && (A.lastNeed = z - 1), z) : --L < R || z === -2 ? 0 : (z = l(T[L]), z >= 0 ? (z > 0 && (A.lastNeed = z - 2), z) : --L < R || z === -2 ? 0 : (z = l(T[L]), z >= 0 ? (z > 0 && (z === 2 ? z = 0 : A.lastNeed = z - 3), z) : 0));
        }
        function a(A, T, R) {
          if ((T[0] & 192) !== 128)
            return A.lastNeed = 0, "�";
          if (A.lastNeed > 1 && T.length > 1) {
            if ((T[1] & 192) !== 128)
              return A.lastNeed = 1, "�";
            if (A.lastNeed > 2 && T.length > 2 && (T[2] & 192) !== 128)
              return A.lastNeed = 2, "�";
          }
        }
        function n(A) {
          var T = this.lastTotal - this.lastNeed, R = a(this, A);
          if (R !== void 0) return R;
          if (this.lastNeed <= A.length)
            return A.copy(this.lastChar, T, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          A.copy(this.lastChar, T, 0, A.length), this.lastNeed -= A.length;
        }
        function c(A, T) {
          var R = u(this, A, T);
          if (!this.lastNeed) return A.toString("utf8", T);
          this.lastTotal = R;
          var L = A.length - (R - this.lastNeed);
          return A.copy(this.lastChar, 0, L), A.toString("utf8", T, L);
        }
        function g(A) {
          var T = A && A.length ? this.write(A) : "";
          return this.lastNeed ? T + "�" : T;
        }
        function f(A, T) {
          if ((A.length - T) % 2 === 0) {
            var R = A.toString("utf16le", T);
            if (R) {
              var L = R.charCodeAt(R.length - 1);
              if (L >= 55296 && L <= 56319)
                return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1], R.slice(0, -1);
            }
            return R;
          }
          return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = A[A.length - 1], A.toString("utf16le", T, A.length - 1);
        }
        function p(A) {
          var T = A && A.length ? this.write(A) : "";
          if (this.lastNeed) {
            var R = this.lastTotal - this.lastNeed;
            return T + this.lastChar.toString("utf16le", 0, R);
          }
          return T;
        }
        function s(A, T) {
          var R = (A.length - T) % 3;
          return R === 0 ? A.toString("base64", T) : (this.lastNeed = 3 - R, this.lastTotal = 3, R === 1 ? this.lastChar[0] = A[A.length - 1] : (this.lastChar[0] = A[A.length - 2], this.lastChar[1] = A[A.length - 1]), A.toString("base64", T, A.length - R));
        }
        function S(A) {
          var T = A && A.length ? this.write(A) : "";
          return this.lastNeed ? T + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : T;
        }
        function b(A) {
          return A.toString(this.encoding);
        }
        function o(A) {
          return A && A.length ? this.write(A) : "";
        }
      }, { "safe-buffer": 147 }], 149: [function(C, Z, _) {
        Z.exports = C("./readable").PassThrough;
      }, { "./readable": 150 }], 150: [function(C, Z, _) {
        _ = Z.exports = C("./lib/_stream_readable.js"), _.Stream = _, _.Readable = _, _.Writable = C("./lib/_stream_writable.js"), _.Duplex = C("./lib/_stream_duplex.js"), _.Transform = C("./lib/_stream_transform.js"), _.PassThrough = C("./lib/_stream_passthrough.js");
      }, { "./lib/_stream_duplex.js": 139, "./lib/_stream_passthrough.js": 140, "./lib/_stream_readable.js": 141, "./lib/_stream_transform.js": 142, "./lib/_stream_writable.js": 143 }], 151: [function(C, Z, _) {
        Z.exports = C("./readable").Transform;
      }, { "./readable": 150 }], 152: [function(C, Z, _) {
        Z.exports = C("./lib/_stream_writable.js");
      }, { "./lib/_stream_writable.js": 143 }], 153: [function(C, Z, _) {
        var P = function(x) {
          var y = Object.prototype, E = y.hasOwnProperty, d, l = typeof Symbol == "function" ? Symbol : {}, u = l.iterator || "@@iterator", a = l.asyncIterator || "@@asyncIterator", n = l.toStringTag || "@@toStringTag";
          function c(ke, Pe, fe, xe) {
            var Ee = Pe && Pe.prototype instanceof o ? Pe : o, Ie = Object.create(Ee.prototype), je = new Q(xe || []);
            return Ie._invoke = se(ke, fe, je), Ie;
          }
          x.wrap = c;
          function g(ke, Pe, fe) {
            try {
              return { type: "normal", arg: ke.call(Pe, fe) };
            } catch (xe) {
              return { type: "throw", arg: xe };
            }
          }
          var f = "suspendedStart", p = "suspendedYield", s = "executing", S = "completed", b = {};
          function o() {
          }
          function A() {
          }
          function T() {
          }
          var R = {};
          R[u] = function() {
            return this;
          };
          var L = Object.getPrototypeOf, z = L && L(L(de([])));
          z && z !== y && E.call(z, u) && (R = z);
          var U = T.prototype = o.prototype = Object.create(R);
          A.prototype = U.constructor = T, T.constructor = A, T[n] = A.displayName = "GeneratorFunction";
          function J(ke) {
            ["next", "throw", "return"].forEach(function(Pe) {
              ke[Pe] = function(fe) {
                return this._invoke(Pe, fe);
              };
            });
          }
          x.isGeneratorFunction = function(ke) {
            var Pe = typeof ke == "function" && ke.constructor;
            return Pe ? Pe === A || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (Pe.displayName || Pe.name) === "GeneratorFunction" : !1;
          }, x.mark = function(ke) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(ke, T) : (ke.__proto__ = T, n in ke || (ke[n] = "GeneratorFunction")), ke.prototype = Object.create(U), ke;
          }, x.awrap = function(ke) {
            return { __await: ke };
          };
          function F(ke) {
            function Pe(Ee, Ie, je, Ue) {
              var He = g(ke[Ee], ke, Ie);
              if (He.type === "throw")
                Ue(He.arg);
              else {
                var Ze = He.arg, $e = Ze.value;
                return $e && typeof $e == "object" && E.call($e, "__await") ? Promise.resolve($e.__await).then(function(We) {
                  Pe("next", We, je, Ue);
                }, function(We) {
                  Pe("throw", We, je, Ue);
                }) : Promise.resolve($e).then(function(We) {
                  Ze.value = We, je(Ze);
                }, function(We) {
                  return Pe("throw", We, je, Ue);
                });
              }
            }
            var fe;
            function xe(Ee, Ie) {
              function je() {
                return new Promise(function(Ue, He) {
                  Pe(Ee, Ie, Ue, He);
                });
              }
              return fe = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              fe ? fe.then(
                je,
                // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                je
              ) : je();
            }
            this._invoke = xe;
          }
          J(F.prototype), F.prototype[a] = function() {
            return this;
          }, x.AsyncIterator = F, x.async = function(ke, Pe, fe, xe) {
            var Ee = new F(
              c(ke, Pe, fe, xe)
            );
            return x.isGeneratorFunction(Pe) ? Ee : Ee.next().then(function(Ie) {
              return Ie.done ? Ie.value : Ee.next();
            });
          };
          function se(ke, Pe, fe) {
            var xe = f;
            return function(Ie, je) {
              if (xe === s)
                throw new Error("Generator is already running");
              if (xe === S) {
                if (Ie === "throw")
                  throw je;
                return _e();
              }
              for (fe.method = Ie, fe.arg = je; ; ) {
                var Ue = fe.delegate;
                if (Ue) {
                  var He = ee(Ue, fe);
                  if (He) {
                    if (He === b) continue;
                    return He;
                  }
                }
                if (fe.method === "next")
                  fe.sent = fe._sent = fe.arg;
                else if (fe.method === "throw") {
                  if (xe === f)
                    throw xe = S, fe.arg;
                  fe.dispatchException(fe.arg);
                } else fe.method === "return" && fe.abrupt("return", fe.arg);
                xe = s;
                var Ze = g(ke, Pe, fe);
                if (Ze.type === "normal") {
                  if (xe = fe.done ? S : p, Ze.arg === b)
                    continue;
                  return {
                    value: Ze.arg,
                    done: fe.done
                  };
                } else Ze.type === "throw" && (xe = S, fe.method = "throw", fe.arg = Ze.arg);
              }
            };
          }
          function ee(ke, Pe) {
            var fe = ke.iterator[Pe.method];
            if (fe === d) {
              if (Pe.delegate = null, Pe.method === "throw") {
                if (ke.iterator.return && (Pe.method = "return", Pe.arg = d, ee(ke, Pe), Pe.method === "throw"))
                  return b;
                Pe.method = "throw", Pe.arg = new TypeError(
                  "The iterator does not provide a 'throw' method"
                );
              }
              return b;
            }
            var xe = g(fe, ke.iterator, Pe.arg);
            if (xe.type === "throw")
              return Pe.method = "throw", Pe.arg = xe.arg, Pe.delegate = null, b;
            var Ee = xe.arg;
            if (!Ee)
              return Pe.method = "throw", Pe.arg = new TypeError("iterator result is not an object"), Pe.delegate = null, b;
            if (Ee.done)
              Pe[ke.resultName] = Ee.value, Pe.next = ke.nextLoc, Pe.method !== "return" && (Pe.method = "next", Pe.arg = d);
            else
              return Ee;
            return Pe.delegate = null, b;
          }
          J(U), U[n] = "Generator", U[u] = function() {
            return this;
          }, U.toString = function() {
            return "[object Generator]";
          };
          function ie(ke) {
            var Pe = { tryLoc: ke[0] };
            1 in ke && (Pe.catchLoc = ke[1]), 2 in ke && (Pe.finallyLoc = ke[2], Pe.afterLoc = ke[3]), this.tryEntries.push(Pe);
          }
          function W(ke) {
            var Pe = ke.completion || {};
            Pe.type = "normal", delete Pe.arg, ke.completion = Pe;
          }
          function Q(ke) {
            this.tryEntries = [{ tryLoc: "root" }], ke.forEach(ie, this), this.reset(!0);
          }
          x.keys = function(ke) {
            var Pe = [];
            for (var fe in ke)
              Pe.push(fe);
            return Pe.reverse(), function xe() {
              for (; Pe.length; ) {
                var Ee = Pe.pop();
                if (Ee in ke)
                  return xe.value = Ee, xe.done = !1, xe;
              }
              return xe.done = !0, xe;
            };
          };
          function de(ke) {
            if (ke) {
              var Pe = ke[u];
              if (Pe)
                return Pe.call(ke);
              if (typeof ke.next == "function")
                return ke;
              if (!isNaN(ke.length)) {
                var fe = -1, xe = function Ee() {
                  for (; ++fe < ke.length; )
                    if (E.call(ke, fe))
                      return Ee.value = ke[fe], Ee.done = !1, Ee;
                  return Ee.value = d, Ee.done = !0, Ee;
                };
                return xe.next = xe;
              }
            }
            return { next: _e };
          }
          x.values = de;
          function _e() {
            return { value: d, done: !0 };
          }
          return Q.prototype = {
            constructor: Q,
            reset: function(ke) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = d, this.done = !1, this.delegate = null, this.method = "next", this.arg = d, this.tryEntries.forEach(W), !ke)
                for (var Pe in this)
                  Pe.charAt(0) === "t" && E.call(this, Pe) && !isNaN(+Pe.slice(1)) && (this[Pe] = d);
            },
            stop: function() {
              this.done = !0;
              var ke = this.tryEntries[0], Pe = ke.completion;
              if (Pe.type === "throw")
                throw Pe.arg;
              return this.rval;
            },
            dispatchException: function(ke) {
              if (this.done)
                throw ke;
              var Pe = this;
              function fe(He, Ze) {
                return Ie.type = "throw", Ie.arg = ke, Pe.next = He, Ze && (Pe.method = "next", Pe.arg = d), !!Ze;
              }
              for (var xe = this.tryEntries.length - 1; xe >= 0; --xe) {
                var Ee = this.tryEntries[xe], Ie = Ee.completion;
                if (Ee.tryLoc === "root")
                  return fe("end");
                if (Ee.tryLoc <= this.prev) {
                  var je = E.call(Ee, "catchLoc"), Ue = E.call(Ee, "finallyLoc");
                  if (je && Ue) {
                    if (this.prev < Ee.catchLoc)
                      return fe(Ee.catchLoc, !0);
                    if (this.prev < Ee.finallyLoc)
                      return fe(Ee.finallyLoc);
                  } else if (je) {
                    if (this.prev < Ee.catchLoc)
                      return fe(Ee.catchLoc, !0);
                  } else if (Ue) {
                    if (this.prev < Ee.finallyLoc)
                      return fe(Ee.finallyLoc);
                  } else
                    throw new Error("try statement without catch or finally");
                }
              }
            },
            abrupt: function(ke, Pe) {
              for (var fe = this.tryEntries.length - 1; fe >= 0; --fe) {
                var xe = this.tryEntries[fe];
                if (xe.tryLoc <= this.prev && E.call(xe, "finallyLoc") && this.prev < xe.finallyLoc) {
                  var Ee = xe;
                  break;
                }
              }
              Ee && (ke === "break" || ke === "continue") && Ee.tryLoc <= Pe && Pe <= Ee.finallyLoc && (Ee = null);
              var Ie = Ee ? Ee.completion : {};
              return Ie.type = ke, Ie.arg = Pe, Ee ? (this.method = "next", this.next = Ee.finallyLoc, b) : this.complete(Ie);
            },
            complete: function(ke, Pe) {
              if (ke.type === "throw")
                throw ke.arg;
              return ke.type === "break" || ke.type === "continue" ? this.next = ke.arg : ke.type === "return" ? (this.rval = this.arg = ke.arg, this.method = "return", this.next = "end") : ke.type === "normal" && Pe && (this.next = Pe), b;
            },
            finish: function(ke) {
              for (var Pe = this.tryEntries.length - 1; Pe >= 0; --Pe) {
                var fe = this.tryEntries[Pe];
                if (fe.finallyLoc === ke)
                  return this.complete(fe.completion, fe.afterLoc), W(fe), b;
              }
            },
            catch: function(ke) {
              for (var Pe = this.tryEntries.length - 1; Pe >= 0; --Pe) {
                var fe = this.tryEntries[Pe];
                if (fe.tryLoc === ke) {
                  var xe = fe.completion;
                  if (xe.type === "throw") {
                    var Ee = xe.arg;
                    W(fe);
                  }
                  return Ee;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function(ke, Pe, fe) {
              return this.delegate = {
                iterator: de(ke),
                resultName: Pe,
                nextLoc: fe
              }, this.method === "next" && (this.arg = d), b;
            }
          }, x;
        }(
          // If this script is executing as a CommonJS module, use module.exports
          // as the regeneratorRuntime namespace. Otherwise create a new empty
          // object. Either way, the resulting object will be used to initialize
          // the regeneratorRuntime variable at the top of this file.
          typeof Z == "object" ? Z.exports : {}
        );
        try {
          regeneratorRuntime = P;
        } catch {
          Function("r", "regeneratorRuntime = r")(P);
        }
      }, {}], 154: [function(C, Z, _) {
        var P = C("buffer"), x = P.Buffer;
        function y(d, l) {
          for (var u in d)
            l[u] = d[u];
        }
        x.from && x.alloc && x.allocUnsafe && x.allocUnsafeSlow ? Z.exports = P : (y(P, _), _.Buffer = E);
        function E(d, l, u) {
          return x(d, l, u);
        }
        E.prototype = Object.create(x.prototype), y(x, E), E.from = function(d, l, u) {
          if (typeof d == "number")
            throw new TypeError("Argument must not be a number");
          return x(d, l, u);
        }, E.alloc = function(d, l, u) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          var a = x(d);
          return l !== void 0 ? typeof u == "string" ? a.fill(l, u) : a.fill(l) : a.fill(0), a;
        }, E.allocUnsafe = function(d) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          return x(d);
        }, E.allocUnsafeSlow = function(d) {
          if (typeof d != "number")
            throw new TypeError("Argument must be a number");
          return P.SlowBuffer(d);
        };
      }, { buffer: 48 }], 155: [function(C, Z, _) {
        Z.exports = y;
        var P = C("events").EventEmitter, x = C("inherits");
        x(y, P), y.Readable = C("readable-stream/readable.js"), y.Writable = C("readable-stream/writable.js"), y.Duplex = C("readable-stream/duplex.js"), y.Transform = C("readable-stream/transform.js"), y.PassThrough = C("readable-stream/passthrough.js"), y.Stream = y;
        function y() {
          P.call(this);
        }
        y.prototype.pipe = function(E, d) {
          var l = this;
          function u(s) {
            E.writable && E.write(s) === !1 && l.pause && l.pause();
          }
          l.on("data", u);
          function a() {
            l.readable && l.resume && l.resume();
          }
          E.on("drain", a), !E._isStdio && (!d || d.end !== !1) && (l.on("end", c), l.on("close", g));
          var n = !1;
          function c() {
            n || (n = !0, E.end());
          }
          function g() {
            n || (n = !0, typeof E.destroy == "function" && E.destroy());
          }
          function f(s) {
            if (p(), P.listenerCount(this, "error") === 0)
              throw s;
          }
          l.on("error", f), E.on("error", f);
          function p() {
            l.removeListener("data", u), E.removeListener("drain", a), l.removeListener("end", c), l.removeListener("close", g), l.removeListener("error", f), E.removeListener("error", f), l.removeListener("end", p), l.removeListener("close", p), E.removeListener("close", p);
          }
          return l.on("end", p), l.on("close", p), E.on("close", p), E.emit("pipe", l), E;
        };
      }, { events: 52, inherits: 75, "readable-stream/duplex.js": 138, "readable-stream/passthrough.js": 149, "readable-stream/readable.js": 150, "readable-stream/transform.js": 151, "readable-stream/writable.js": 152 }], 156: [function(C, Z, _) {
        (function(P) {
          var x = C("./lib/request"), y = C("./lib/response"), E = C("xtend"), d = C("builtin-status-codes"), l = C("url"), u = _;
          u.request = function(a, n) {
            typeof a == "string" ? a = l.parse(a) : a = E(a);
            var c = P.location.protocol.search(/^https?:$/) === -1 ? "http:" : "", g = a.protocol || c, f = a.hostname || a.host, p = a.port, s = a.path || "/";
            f && f.indexOf(":") !== -1 && (f = "[" + f + "]"), a.url = (f ? g + "//" + f : "") + (p ? ":" + p : "") + s, a.method = (a.method || "GET").toUpperCase(), a.headers = a.headers || {};
            var S = new x(a);
            return n && S.on("response", n), S;
          }, u.get = function(n, c) {
            var g = u.request(n, c);
            return g.end(), g;
          }, u.ClientRequest = x, u.IncomingMessage = y.IncomingMessage, u.Agent = function() {
          }, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent(), u.STATUS_CODES = d, u.METHODS = [
            "CHECKOUT",
            "CONNECT",
            "COPY",
            "DELETE",
            "GET",
            "HEAD",
            "LOCK",
            "M-SEARCH",
            "MERGE",
            "MKACTIVITY",
            "MKCOL",
            "MOVE",
            "NOTIFY",
            "OPTIONS",
            "PATCH",
            "POST",
            "PROPFIND",
            "PROPPATCH",
            "PURGE",
            "PUT",
            "REPORT",
            "SEARCH",
            "SUBSCRIBE",
            "TRACE",
            "UNLOCK",
            "UNSUBSCRIBE"
          ];
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "./lib/request": 158, "./lib/response": 159, "builtin-status-codes": 50, url: 180, xtend: 189 }], 157: [function(C, Z, _) {
        (function(P) {
          _.fetch = d(P.fetch) && d(P.ReadableStream), _.writableStream = d(P.WritableStream), _.abortController = d(P.AbortController);
          var x;
          function y() {
            if (x !== void 0) return x;
            if (P.XMLHttpRequest) {
              x = new P.XMLHttpRequest();
              try {
                x.open("GET", P.XDomainRequest ? "/" : "https://example.com");
              } catch {
                x = null;
              }
            } else
              x = null;
            return x;
          }
          function E(l) {
            var u = y();
            if (!u) return !1;
            try {
              return u.responseType = l, u.responseType === l;
            } catch {
            }
            return !1;
          }
          _.arraybuffer = _.fetch || E("arraybuffer"), _.msstream = !_.fetch && E("ms-stream"), _.mozchunkedarraybuffer = !_.fetch && E("moz-chunked-arraybuffer"), _.overrideMimeType = _.fetch || (y() ? d(y().overrideMimeType) : !1);
          function d(l) {
            return typeof l == "function";
          }
          x = null;
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, {}], 158: [function(C, Z, _) {
        (function(P, x, y) {
          var E = C("./capability"), d = C("inherits"), l = C("./response"), u = C("readable-stream"), a = l.IncomingMessage, n = l.readyStates;
          function c(s, S) {
            return E.fetch && S ? "fetch" : E.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : E.msstream ? "ms-stream" : E.arraybuffer && s ? "arraybuffer" : "text";
          }
          var g = Z.exports = function(s) {
            var S = this;
            u.Writable.call(S), S._opts = s, S._body = [], S._headers = {}, s.auth && S.setHeader("Authorization", "Basic " + y.from(s.auth).toString("base64")), Object.keys(s.headers).forEach(function(A) {
              S.setHeader(A, s.headers[A]);
            });
            var b, o = !0;
            if (s.mode === "disable-fetch" || "requestTimeout" in s && !E.abortController)
              o = !1, b = !0;
            else if (s.mode === "prefer-streaming")
              b = !1;
            else if (s.mode === "allow-wrong-content-type")
              b = !E.overrideMimeType;
            else if (!s.mode || s.mode === "default" || s.mode === "prefer-fast")
              b = !0;
            else
              throw new Error("Invalid value for opts.mode");
            S._mode = c(b, o), S._fetchTimer = null, S.on("finish", function() {
              S._onFinish();
            });
          };
          d(g, u.Writable), g.prototype.setHeader = function(s, S) {
            var b = this, o = s.toLowerCase();
            p.indexOf(o) === -1 && (b._headers[o] = {
              name: s,
              value: S
            });
          }, g.prototype.getHeader = function(s) {
            var S = this._headers[s.toLowerCase()];
            return S ? S.value : null;
          }, g.prototype.removeHeader = function(s) {
            var S = this;
            delete S._headers[s.toLowerCase()];
          }, g.prototype._onFinish = function() {
            var s = this;
            if (!s._destroyed) {
              var S = s._opts, b = s._headers, o = null;
              S.method !== "GET" && S.method !== "HEAD" && (o = new Blob(s._body, {
                type: (b["content-type"] || {}).value || ""
              }));
              var A = [];
              if (Object.keys(b).forEach(function(z) {
                var U = b[z].name, J = b[z].value;
                Array.isArray(J) ? J.forEach(function(F) {
                  A.push([U, F]);
                }) : A.push([U, J]);
              }), s._mode === "fetch") {
                var T = null;
                if (E.abortController) {
                  var R = new AbortController();
                  T = R.signal, s._fetchAbortController = R, "requestTimeout" in S && S.requestTimeout !== 0 && (s._fetchTimer = x.setTimeout(function() {
                    s.emit("requestTimeout"), s._fetchAbortController && s._fetchAbortController.abort();
                  }, S.requestTimeout));
                }
                x.fetch(s._opts.url, {
                  method: s._opts.method,
                  headers: A,
                  body: o || void 0,
                  mode: "cors",
                  credentials: S.withCredentials ? "include" : "same-origin",
                  signal: T
                }).then(function(z) {
                  s._fetchResponse = z, s._connect();
                }, function(z) {
                  x.clearTimeout(s._fetchTimer), s._destroyed || s.emit("error", z);
                });
              } else {
                var L = s._xhr = new x.XMLHttpRequest();
                try {
                  L.open(s._opts.method, s._opts.url, !0);
                } catch (z) {
                  P.nextTick(function() {
                    s.emit("error", z);
                  });
                  return;
                }
                "responseType" in L && (L.responseType = s._mode), "withCredentials" in L && (L.withCredentials = !!S.withCredentials), s._mode === "text" && "overrideMimeType" in L && L.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in S && (L.timeout = S.requestTimeout, L.ontimeout = function() {
                  s.emit("requestTimeout");
                }), A.forEach(function(z) {
                  L.setRequestHeader(z[0], z[1]);
                }), s._response = null, L.onreadystatechange = function() {
                  switch (L.readyState) {
                    case n.LOADING:
                    case n.DONE:
                      s._onXHRProgress();
                      break;
                  }
                }, s._mode === "moz-chunked-arraybuffer" && (L.onprogress = function() {
                  s._onXHRProgress();
                }), L.onerror = function() {
                  s._destroyed || s.emit("error", new Error("XHR error"));
                };
                try {
                  L.send(o);
                } catch (z) {
                  P.nextTick(function() {
                    s.emit("error", z);
                  });
                  return;
                }
              }
            }
          };
          function f(s) {
            try {
              var S = s.status;
              return S !== null && S !== 0;
            } catch {
              return !1;
            }
          }
          g.prototype._onXHRProgress = function() {
            var s = this;
            !f(s._xhr) || s._destroyed || (s._response || s._connect(), s._response._onXHRProgress());
          }, g.prototype._connect = function() {
            var s = this;
            s._destroyed || (s._response = new a(s._xhr, s._fetchResponse, s._mode, s._fetchTimer), s._response.on("error", function(S) {
              s.emit("error", S);
            }), s.emit("response", s._response));
          }, g.prototype._write = function(s, S, b) {
            var o = this;
            o._body.push(s), b();
          }, g.prototype.abort = g.prototype.destroy = function() {
            var s = this;
            s._destroyed = !0, x.clearTimeout(s._fetchTimer), s._response && (s._response._destroyed = !0), s._xhr ? s._xhr.abort() : s._fetchAbortController && s._fetchAbortController.abort();
          }, g.prototype.end = function(s, S, b) {
            var o = this;
            typeof s == "function" && (b = s, s = void 0), u.Writable.prototype.end.call(o, s, S, b);
          }, g.prototype.flushHeaders = function() {
          }, g.prototype.setTimeout = function() {
          }, g.prototype.setNoDelay = function() {
          }, g.prototype.setSocketKeepAlive = function() {
          };
          var p = [
            "accept-charset",
            "accept-encoding",
            "access-control-request-headers",
            "access-control-request-method",
            "connection",
            "content-length",
            "cookie",
            "cookie2",
            "date",
            "dnt",
            "expect",
            "host",
            "keep-alive",
            "origin",
            "referer",
            "te",
            "trailer",
            "transfer-encoding",
            "upgrade",
            "via"
          ];
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {}, C("buffer").Buffer);
      }, { "./capability": 157, "./response": 159, _process: 133, buffer: 48, inherits: 75, "readable-stream": 174 }], 159: [function(C, Z, _) {
        (function(P, x, y) {
          var E = C("./capability"), d = C("inherits"), l = C("readable-stream"), u = _.readyStates = {
            UNSENT: 0,
            OPENED: 1,
            HEADERS_RECEIVED: 2,
            LOADING: 3,
            DONE: 4
          }, a = _.IncomingMessage = function(n, c, g, f) {
            var p = this;
            if (l.Readable.call(p), p._mode = g, p.headers = {}, p.rawHeaders = [], p.trailers = {}, p.rawTrailers = [], p.on("end", function() {
              P.nextTick(function() {
                p.emit("close");
              });
            }), g === "fetch") {
              let T = function() {
                S.read().then(function(R) {
                  if (!p._destroyed) {
                    if (R.done) {
                      x.clearTimeout(f), p.push(null);
                      return;
                    }
                    p.push(y.from(R.value)), T();
                  }
                }).catch(function(R) {
                  x.clearTimeout(f), p._destroyed || p.emit("error", R);
                });
              };
              if (p._fetchResponse = c, p.url = c.url, p.statusCode = c.status, p.statusMessage = c.statusText, c.headers.forEach(function(R, L) {
                p.headers[L.toLowerCase()] = R, p.rawHeaders.push(L, R);
              }), E.writableStream) {
                var s = new WritableStream({
                  write: function(R) {
                    return new Promise(function(L, z) {
                      p._destroyed ? z() : p.push(y.from(R)) ? L() : p._resumeFetch = L;
                    });
                  },
                  close: function() {
                    x.clearTimeout(f), p._destroyed || p.push(null);
                  },
                  abort: function(R) {
                    p._destroyed || p.emit("error", R);
                  }
                });
                try {
                  c.body.pipeTo(s).catch(function(R) {
                    x.clearTimeout(f), p._destroyed || p.emit("error", R);
                  });
                  return;
                } catch {
                }
              }
              var S = c.body.getReader();
              T();
            } else {
              p._xhr = n, p._pos = 0, p.url = n.responseURL, p.statusCode = n.status, p.statusMessage = n.statusText;
              var b = n.getAllResponseHeaders().split(/\r?\n/);
              if (b.forEach(function(T) {
                var R = T.match(/^([^:]+):\s*(.*)/);
                if (R) {
                  var L = R[1].toLowerCase();
                  L === "set-cookie" ? (p.headers[L] === void 0 && (p.headers[L] = []), p.headers[L].push(R[2])) : p.headers[L] !== void 0 ? p.headers[L] += ", " + R[2] : p.headers[L] = R[2], p.rawHeaders.push(R[1], R[2]);
                }
              }), p._charset = "x-user-defined", !E.overrideMimeType) {
                var o = p.rawHeaders["mime-type"];
                if (o) {
                  var A = o.match(/;\s*charset=([^;])(;|$)/);
                  A && (p._charset = A[1].toLowerCase());
                }
                p._charset || (p._charset = "utf-8");
              }
            }
          };
          d(a, l.Readable), a.prototype._read = function() {
            var n = this, c = n._resumeFetch;
            c && (n._resumeFetch = null, c());
          }, a.prototype._onXHRProgress = function() {
            var n = this, c = n._xhr, g = null;
            switch (n._mode) {
              case "text":
                if (g = c.responseText, g.length > n._pos) {
                  var f = g.substr(n._pos);
                  if (n._charset === "x-user-defined") {
                    for (var p = y.alloc(f.length), s = 0; s < f.length; s++)
                      p[s] = f.charCodeAt(s) & 255;
                    n.push(p);
                  } else
                    n.push(f, n._charset);
                  n._pos = g.length;
                }
                break;
              case "arraybuffer":
                if (c.readyState !== u.DONE || !c.response)
                  break;
                g = c.response, n.push(y.from(new Uint8Array(g)));
                break;
              case "moz-chunked-arraybuffer":
                if (g = c.response, c.readyState !== u.LOADING || !g)
                  break;
                n.push(y.from(new Uint8Array(g)));
                break;
              case "ms-stream":
                if (g = c.response, c.readyState !== u.LOADING)
                  break;
                var S = new x.MSStreamReader();
                S.onprogress = function() {
                  S.result.byteLength > n._pos && (n.push(y.from(new Uint8Array(S.result.slice(n._pos)))), n._pos = S.result.byteLength);
                }, S.onload = function() {
                  n.push(null);
                }, S.readAsArrayBuffer(g);
                break;
            }
            n._xhr.readyState === u.DONE && n._mode !== "ms-stream" && n.push(null);
          };
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {}, C("buffer").Buffer);
      }, { "./capability": 157, _process: 133, buffer: 48, inherits: 75, "readable-stream": 174 }], 160: [function(C, Z, _) {
        function P(a, n) {
          a.prototype = Object.create(n.prototype), a.prototype.constructor = a, a.__proto__ = n;
        }
        var x = {};
        function y(a, n, c) {
          c || (c = Error);
          function g(p, s, S) {
            return typeof n == "string" ? n : n(p, s, S);
          }
          var f = /* @__PURE__ */ function(p) {
            P(s, p);
            function s(S, b, o) {
              return p.call(this, g(S, b, o)) || this;
            }
            return s;
          }(c);
          f.prototype.name = c.name, f.prototype.code = a, x[a] = f;
        }
        function E(a, n) {
          if (Array.isArray(a)) {
            var c = a.length;
            return a = a.map(function(g) {
              return String(g);
            }), c > 2 ? "one of ".concat(n, " ").concat(a.slice(0, c - 1).join(", "), ", or ") + a[c - 1] : c === 2 ? "one of ".concat(n, " ").concat(a[0], " or ").concat(a[1]) : "of ".concat(n, " ").concat(a[0]);
          } else
            return "of ".concat(n, " ").concat(String(a));
        }
        function d(a, n, c) {
          return a.substr(0, n.length) === n;
        }
        function l(a, n, c) {
          return (c === void 0 || c > a.length) && (c = a.length), a.substring(c - n.length, c) === n;
        }
        function u(a, n, c) {
          return typeof c != "number" && (c = 0), c + n.length > a.length ? !1 : a.indexOf(n, c) !== -1;
        }
        y("ERR_INVALID_OPT_VALUE", function(a, n) {
          return 'The value "' + n + '" is invalid for option "' + a + '"';
        }, TypeError), y("ERR_INVALID_ARG_TYPE", function(a, n, c) {
          var g;
          typeof n == "string" && d(n, "not ") ? (g = "must not be", n = n.replace(/^not /, "")) : g = "must be";
          var f;
          if (l(a, " argument"))
            f = "The ".concat(a, " ").concat(g, " ").concat(E(n, "type"));
          else {
            var p = u(a, ".") ? "property" : "argument";
            f = 'The "'.concat(a, '" ').concat(p, " ").concat(g, " ").concat(E(n, "type"));
          }
          return f += ". Received type ".concat(typeof c), f;
        }, TypeError), y("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), y("ERR_METHOD_NOT_IMPLEMENTED", function(a) {
          return "The " + a + " method is not implemented";
        }), y("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), y("ERR_STREAM_DESTROYED", function(a) {
          return "Cannot call " + a + " after a stream was destroyed";
        }), y("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), y("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), y("ERR_STREAM_WRITE_AFTER_END", "write after end"), y("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), y("ERR_UNKNOWN_ENCODING", function(a) {
          return "Unknown encoding: " + a;
        }, TypeError), y("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Z.exports.codes = x;
      }, {}], 161: [function(C, Z, _) {
        (function(P) {
          var x = /* @__PURE__ */ new Set();
          function y(d) {
            if (!x.has(d)) {
              var l = d + " is an experimental feature. This feature could change at any time";
              x.add(d), P.emitWarning(l, "ExperimentalWarning");
            }
          }
          function E() {
          }
          Z.exports.emitExperimentalWarning = P.emitWarning ? y : E;
        }).call(this, C("_process"));
      }, { _process: 133 }], 162: [function(C, Z, _) {
        (function(P) {
          var x = Object.keys || function(g) {
            var f = [];
            for (var p in g)
              f.push(p);
            return f;
          };
          Z.exports = a;
          var y = C("./_stream_readable"), E = C("./_stream_writable");
          C("inherits")(a, y);
          for (var d = x(E.prototype), l = 0; l < d.length; l++) {
            var u = d[l];
            a.prototype[u] || (a.prototype[u] = E.prototype[u]);
          }
          function a(g) {
            if (!(this instanceof a)) return new a(g);
            y.call(this, g), E.call(this, g), this.allowHalfOpen = !0, g && (g.readable === !1 && (this.readable = !1), g.writable === !1 && (this.writable = !1), g.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", n)));
          }
          Object.defineProperty(a.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState.highWaterMark;
            }
          }), Object.defineProperty(a.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState && this._writableState.getBuffer();
            }
          }), Object.defineProperty(a.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState.length;
            }
          });
          function n() {
            this._writableState.ended || P.nextTick(c, this);
          }
          function c(g) {
            g.end();
          }
          Object.defineProperty(a.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
            },
            set: function(f) {
              this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = f, this._writableState.destroyed = f);
            }
          });
        }).call(this, C("_process"));
      }, { "./_stream_readable": 164, "./_stream_writable": 166, _process: 133, inherits: 75 }], 163: [function(C, Z, _) {
        Z.exports = x;
        var P = C("./_stream_transform");
        C("inherits")(x, P);
        function x(y) {
          if (!(this instanceof x)) return new x(y);
          P.call(this, y);
        }
        x.prototype._transform = function(y, E, d) {
          d(null, y);
        };
      }, { "./_stream_transform": 165, inherits: 75 }], 164: [function(C, Z, _) {
        (function(P, x) {
          Z.exports = ie;
          var y;
          ie.ReadableState = ee, C("events").EventEmitter;
          var E = function($, Ce) {
            return $.listeners(Ce).length;
          }, d = C("./internal/streams/stream"), l = C("buffer").Buffer, u = x.Uint8Array || function() {
          };
          function a(re) {
            return l.from(re);
          }
          function n(re) {
            return l.isBuffer(re) || re instanceof u;
          }
          var c = C("util"), g;
          c && c.debuglog ? g = c.debuglog("stream") : g = function() {
          };
          var f = C("./internal/streams/buffer_list"), p = C("./internal/streams/destroy"), s = C("./internal/streams/state"), S = s.getHighWaterMark, b = C("../errors").codes, o = b.ERR_INVALID_ARG_TYPE, A = b.ERR_STREAM_PUSH_AFTER_EOF, T = b.ERR_METHOD_NOT_IMPLEMENTED, R = b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, L = C("../experimentalWarning"), z = L.emitExperimentalWarning, U, J;
          C("inherits")(ie, d);
          var F = ["error", "close", "destroy", "pause", "resume"];
          function se(re, $, Ce) {
            if (typeof re.prependListener == "function") return re.prependListener($, Ce);
            !re._events || !re._events[$] ? re.on($, Ce) : Array.isArray(re._events[$]) ? re._events[$].unshift(Ce) : re._events[$] = [Ce, re._events[$]];
          }
          function ee(re, $, Ce) {
            y = y || C("./_stream_duplex"), re = re || {}, typeof Ce != "boolean" && (Ce = $ instanceof y), this.objectMode = !!re.objectMode, Ce && (this.objectMode = this.objectMode || !!re.readableObjectMode), this.highWaterMark = S(this, re, "readableHighWaterMark", Ce), this.buffer = new f(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = re.emitClose !== !1, this.destroyed = !1, this.defaultEncoding = re.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, re.encoding && (U || (U = C("string_decoder/").StringDecoder), this.decoder = new U(re.encoding), this.encoding = re.encoding);
          }
          function ie(re) {
            if (y = y || C("./_stream_duplex"), !(this instanceof ie)) return new ie(re);
            var $ = this instanceof y;
            this._readableState = new ee(re, this, $), this.readable = !0, re && (typeof re.read == "function" && (this._read = re.read), typeof re.destroy == "function" && (this._destroy = re.destroy)), d.call(this);
          }
          Object.defineProperty(ie.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState === void 0 ? !1 : this._readableState.destroyed;
            },
            set: function($) {
              this._readableState && (this._readableState.destroyed = $);
            }
          }), ie.prototype.destroy = p.destroy, ie.prototype._undestroy = p.undestroy, ie.prototype._destroy = function(re, $) {
            $(re);
          }, ie.prototype.push = function(re, $) {
            var Ce = this._readableState, ve;
            return Ce.objectMode ? ve = !0 : typeof re == "string" && ($ = $ || Ce.defaultEncoding, $ !== Ce.encoding && (re = l.from(re, $), $ = ""), ve = !0), W(this, re, $, !1, ve);
          }, ie.prototype.unshift = function(re) {
            return W(this, re, null, !0, !1);
          };
          function W(re, $, Ce, ve, Y) {
            g("readableAddChunk", $);
            var G = re._readableState;
            if ($ === null)
              G.reading = !1, fe(re, G);
            else {
              var Ae;
              if (Y || (Ae = de(G, $)), Ae)
                re.emit("error", Ae);
              else if (G.objectMode || $ && $.length > 0)
                if (typeof $ != "string" && !G.objectMode && Object.getPrototypeOf($) !== l.prototype && ($ = a($)), ve)
                  G.endEmitted ? re.emit("error", new R()) : Q(re, G, $, !0);
                else if (G.ended)
                  re.emit("error", new A());
                else {
                  if (G.destroyed)
                    return !1;
                  G.reading = !1, G.decoder && !Ce ? ($ = G.decoder.write($), G.objectMode || $.length !== 0 ? Q(re, G, $, !1) : Ie(re, G)) : Q(re, G, $, !1);
                }
              else ve || (G.reading = !1, Ie(re, G));
            }
            return !G.ended && (G.length < G.highWaterMark || G.length === 0);
          }
          function Q(re, $, Ce, ve) {
            $.flowing && $.length === 0 && !$.sync ? ($.awaitDrain = 0, re.emit("data", Ce)) : ($.length += $.objectMode ? 1 : Ce.length, ve ? $.buffer.unshift(Ce) : $.buffer.push(Ce), $.needReadable && xe(re)), Ie(re, $);
          }
          function de(re, $) {
            var Ce;
            return !n($) && typeof $ != "string" && $ !== void 0 && !re.objectMode && (Ce = new o("chunk", ["string", "Buffer", "Uint8Array"], $)), Ce;
          }
          ie.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, ie.prototype.setEncoding = function(re) {
            return U || (U = C("string_decoder/").StringDecoder), this._readableState.decoder = new U(re), this._readableState.encoding = this._readableState.decoder.encoding, this;
          };
          var _e = 8388608;
          function ke(re) {
            return re >= _e ? re = _e : (re--, re |= re >>> 1, re |= re >>> 2, re |= re >>> 4, re |= re >>> 8, re |= re >>> 16, re++), re;
          }
          function Pe(re, $) {
            return re <= 0 || $.length === 0 && $.ended ? 0 : $.objectMode ? 1 : re !== re ? $.flowing && $.length ? $.buffer.head.data.length : $.length : (re > $.highWaterMark && ($.highWaterMark = ke(re)), re <= $.length ? re : $.ended ? $.length : ($.needReadable = !0, 0));
          }
          ie.prototype.read = function(re) {
            g("read", re), re = parseInt(re, 10);
            var $ = this._readableState, Ce = re;
            if (re !== 0 && ($.emittedReadable = !1), re === 0 && $.needReadable && (($.highWaterMark !== 0 ? $.length >= $.highWaterMark : $.length > 0) || $.ended))
              return g("read: emitReadable", $.length, $.ended), $.length === 0 && $.ended ? De(this) : xe(this), null;
            if (re = Pe(re, $), re === 0 && $.ended)
              return $.length === 0 && De(this), null;
            var ve = $.needReadable;
            g("need readable", ve), ($.length === 0 || $.length - re < $.highWaterMark) && (ve = !0, g("length less than watermark", ve)), $.ended || $.reading ? (ve = !1, g("reading or ended", ve)) : ve && (g("do read"), $.reading = !0, $.sync = !0, $.length === 0 && ($.needReadable = !0), this._read($.highWaterMark), $.sync = !1, $.reading || (re = Pe(Ce, $)));
            var Y;
            return re > 0 ? Y = Re(re, $) : Y = null, Y === null ? ($.needReadable = !0, re = 0) : ($.length -= re, $.awaitDrain = 0), $.length === 0 && ($.ended || ($.needReadable = !0), Ce !== re && $.ended && De(this)), Y !== null && this.emit("data", Y), Y;
          };
          function fe(re, $) {
            if (!$.ended) {
              if ($.decoder) {
                var Ce = $.decoder.end();
                Ce && Ce.length && ($.buffer.push(Ce), $.length += $.objectMode ? 1 : Ce.length);
              }
              $.ended = !0, $.sync ? xe(re) : ($.needReadable = !1, $.emittedReadable || ($.emittedReadable = !0, Ee(re)));
            }
          }
          function xe(re) {
            var $ = re._readableState;
            $.needReadable = !1, $.emittedReadable || (g("emitReadable", $.flowing), $.emittedReadable = !0, P.nextTick(Ee, re));
          }
          function Ee(re) {
            var $ = re._readableState;
            g("emitReadable_", $.destroyed, $.length, $.ended), !$.destroyed && ($.length || $.ended) && re.emit("readable"), $.needReadable = !$.flowing && !$.ended && $.length <= $.highWaterMark, Ve(re);
          }
          function Ie(re, $) {
            $.readingMore || ($.readingMore = !0, P.nextTick(je, re, $));
          }
          function je(re, $) {
            for (; !$.reading && !$.ended && ($.length < $.highWaterMark || $.flowing && $.length === 0); ) {
              var Ce = $.length;
              if (g("maybeReadMore read 0"), re.read(0), Ce === $.length)
                break;
            }
            $.readingMore = !1;
          }
          ie.prototype._read = function(re) {
            this.emit("error", new T("_read()"));
          }, ie.prototype.pipe = function(re, $) {
            var Ce = this, ve = this._readableState;
            switch (ve.pipesCount) {
              case 0:
                ve.pipes = re;
                break;
              case 1:
                ve.pipes = [ve.pipes, re];
                break;
              default:
                ve.pipes.push(re);
                break;
            }
            ve.pipesCount += 1, g("pipe count=%d opts=%j", ve.pipesCount, $);
            var Y = (!$ || $.end !== !1) && re !== P.stdout && re !== P.stderr, G = Y ? e : X;
            ve.endEmitted ? P.nextTick(G) : Ce.once("end", G), re.on("unpipe", Ae);
            function Ae(ue, pe) {
              g("onunpipe"), ue === Ce && pe && pe.hasUnpiped === !1 && (pe.hasUnpiped = !0, k());
            }
            function e() {
              g("onend"), re.end();
            }
            var r = Ue(Ce);
            re.on("drain", r);
            var h = !1;
            function k() {
              g("cleanup"), re.removeListener("close", j), re.removeListener("finish", H), re.removeListener("drain", r), re.removeListener("error", B), re.removeListener("unpipe", Ae), Ce.removeListener("end", e), Ce.removeListener("end", X), Ce.removeListener("data", I), h = !0, ve.awaitDrain && (!re._writableState || re._writableState.needDrain) && r();
            }
            Ce.on("data", I);
            function I(ue) {
              g("ondata");
              var pe = re.write(ue);
              g("dest.write", pe), pe === !1 && ((ve.pipesCount === 1 && ve.pipes === re || ve.pipesCount > 1 && we(ve.pipes, re) !== -1) && !h && (g("false write response, pause", ve.awaitDrain), ve.awaitDrain++), Ce.pause());
            }
            function B(ue) {
              g("onerror", ue), X(), re.removeListener("error", B), E(re, "error") === 0 && re.emit("error", ue);
            }
            se(re, "error", B);
            function j() {
              re.removeListener("finish", H), X();
            }
            re.once("close", j);
            function H() {
              g("onfinish"), re.removeListener("close", j), X();
            }
            re.once("finish", H);
            function X() {
              g("unpipe"), Ce.unpipe(re);
            }
            return re.emit("pipe", Ce), ve.flowing || (g("pipe resume"), Ce.resume()), re;
          };
          function Ue(re) {
            return function() {
              var Ce = re._readableState;
              g("pipeOnDrain", Ce.awaitDrain), Ce.awaitDrain && Ce.awaitDrain--, Ce.awaitDrain === 0 && E(re, "data") && (Ce.flowing = !0, Ve(re));
            };
          }
          ie.prototype.unpipe = function(re) {
            var $ = this._readableState, Ce = {
              hasUnpiped: !1
            };
            if ($.pipesCount === 0) return this;
            if ($.pipesCount === 1)
              return re && re !== $.pipes ? this : (re || (re = $.pipes), $.pipes = null, $.pipesCount = 0, $.flowing = !1, re && re.emit("unpipe", this, Ce), this);
            if (!re) {
              var ve = $.pipes, Y = $.pipesCount;
              $.pipes = null, $.pipesCount = 0, $.flowing = !1;
              for (var G = 0; G < Y; G++)
                ve[G].emit("unpipe", this, {
                  hasUnpiped: !1
                });
              return this;
            }
            var Ae = we($.pipes, re);
            return Ae === -1 ? this : ($.pipes.splice(Ae, 1), $.pipesCount -= 1, $.pipesCount === 1 && ($.pipes = $.pipes[0]), re.emit("unpipe", this, Ce), this);
          }, ie.prototype.on = function(re, $) {
            var Ce = d.prototype.on.call(this, re, $), ve = this._readableState;
            return re === "data" ? (ve.readableListening = this.listenerCount("readable") > 0, ve.flowing !== !1 && this.resume()) : re === "readable" && !ve.endEmitted && !ve.readableListening && (ve.readableListening = ve.needReadable = !0, ve.flowing = !1, ve.emittedReadable = !1, g("on readable", ve.length, ve.reading), ve.length ? xe(this) : ve.reading || P.nextTick(Ze, this)), Ce;
          }, ie.prototype.addListener = ie.prototype.on, ie.prototype.removeListener = function(re, $) {
            var Ce = d.prototype.removeListener.call(this, re, $);
            return re === "readable" && P.nextTick(He, this), Ce;
          }, ie.prototype.removeAllListeners = function(re) {
            var $ = d.prototype.removeAllListeners.apply(this, arguments);
            return (re === "readable" || re === void 0) && P.nextTick(He, this), $;
          };
          function He(re) {
            var $ = re._readableState;
            $.readableListening = re.listenerCount("readable") > 0, $.resumeScheduled && !$.paused ? $.flowing = !0 : re.listenerCount("data") > 0 && re.resume();
          }
          function Ze(re) {
            g("readable nexttick read 0"), re.read(0);
          }
          ie.prototype.resume = function() {
            var re = this._readableState;
            return re.flowing || (g("resume"), re.flowing = !re.readableListening, $e(this, re)), re.paused = !1, this;
          };
          function $e(re, $) {
            $.resumeScheduled || ($.resumeScheduled = !0, P.nextTick(We, re, $));
          }
          function We(re, $) {
            g("resume", $.reading), $.reading || re.read(0), $.resumeScheduled = !1, re.emit("resume"), Ve(re), $.flowing && !$.reading && re.read(0);
          }
          ie.prototype.pause = function() {
            return g("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (g("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          };
          function Ve(re) {
            var $ = re._readableState;
            for (g("flow", $.flowing); $.flowing && re.read() !== null; )
              ;
          }
          ie.prototype.wrap = function(re) {
            var $ = this, Ce = this._readableState, ve = !1;
            re.on("end", function() {
              if (g("wrapped end"), Ce.decoder && !Ce.ended) {
                var Ae = Ce.decoder.end();
                Ae && Ae.length && $.push(Ae);
              }
              $.push(null);
            }), re.on("data", function(Ae) {
              if (g("wrapped data"), Ce.decoder && (Ae = Ce.decoder.write(Ae)), !(Ce.objectMode && Ae == null) && !(!Ce.objectMode && (!Ae || !Ae.length))) {
                var e = $.push(Ae);
                e || (ve = !0, re.pause());
              }
            });
            for (var Y in re)
              this[Y] === void 0 && typeof re[Y] == "function" && (this[Y] = /* @__PURE__ */ function(e) {
                return function() {
                  return re[e].apply(re, arguments);
                };
              }(Y));
            for (var G = 0; G < F.length; G++)
              re.on(F[G], this.emit.bind(this, F[G]));
            return this._read = function(Ae) {
              g("wrapped _read", Ae), ve && (ve = !1, re.resume());
            }, this;
          }, typeof Symbol == "function" && (ie.prototype[Symbol.asyncIterator] = function() {
            return z("Readable[Symbol.asyncIterator]"), J === void 0 && (J = C("./internal/streams/async_iterator")), J(this);
          }), Object.defineProperty(ie.prototype, "readableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState.highWaterMark;
            }
          }), Object.defineProperty(ie.prototype, "readableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState && this._readableState.buffer;
            }
          }), Object.defineProperty(ie.prototype, "readableFlowing", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState.flowing;
            },
            set: function($) {
              this._readableState && (this._readableState.flowing = $);
            }
          }), ie._fromList = Re, Object.defineProperty(ie.prototype, "readableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._readableState.length;
            }
          });
          function Re(re, $) {
            if ($.length === 0) return null;
            var Ce;
            return $.objectMode ? Ce = $.buffer.shift() : !re || re >= $.length ? ($.decoder ? Ce = $.buffer.join("") : $.buffer.length === 1 ? Ce = $.buffer.first() : Ce = $.buffer.concat($.length), $.buffer.clear()) : Ce = $.buffer.consume(re, $.decoder), Ce;
          }
          function De(re) {
            var $ = re._readableState;
            g("endReadable", $.endEmitted), $.endEmitted || ($.ended = !0, P.nextTick(Ne, $, re));
          }
          function Ne(re, $) {
            g("endReadableNT", re.endEmitted, re.length), !re.endEmitted && re.length === 0 && (re.endEmitted = !0, $.readable = !1, $.emit("end"));
          }
          function we(re, $) {
            for (var Ce = 0, ve = re.length; Ce < ve; Ce++)
              if (re[Ce] === $) return Ce;
            return -1;
          }
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "../errors": 160, "../experimentalWarning": 161, "./_stream_duplex": 162, "./internal/streams/async_iterator": 167, "./internal/streams/buffer_list": 168, "./internal/streams/destroy": 169, "./internal/streams/state": 172, "./internal/streams/stream": 173, _process: 133, buffer: 48, events: 52, inherits: 75, "string_decoder/": 175, util: 33 }], 165: [function(C, Z, _) {
        Z.exports = a;
        var P = C("../errors").codes, x = P.ERR_METHOD_NOT_IMPLEMENTED, y = P.ERR_MULTIPLE_CALLBACK, E = P.ERR_TRANSFORM_ALREADY_TRANSFORMING, d = P.ERR_TRANSFORM_WITH_LENGTH_0, l = C("./_stream_duplex");
        C("inherits")(a, l);
        function u(g, f) {
          var p = this._transformState;
          p.transforming = !1;
          var s = p.writecb;
          if (s === null)
            return this.emit("error", new y());
          p.writechunk = null, p.writecb = null, f != null && this.push(f), s(g);
          var S = this._readableState;
          S.reading = !1, (S.needReadable || S.length < S.highWaterMark) && this._read(S.highWaterMark);
        }
        function a(g) {
          if (!(this instanceof a)) return new a(g);
          l.call(this, g), this._transformState = {
            afterTransform: u.bind(this),
            needTransform: !1,
            transforming: !1,
            writecb: null,
            writechunk: null,
            writeencoding: null
          }, this._readableState.needReadable = !0, this._readableState.sync = !1, g && (typeof g.transform == "function" && (this._transform = g.transform), typeof g.flush == "function" && (this._flush = g.flush)), this.on("prefinish", n);
        }
        function n() {
          var g = this;
          typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(f, p) {
            c(g, f, p);
          }) : c(this, null, null);
        }
        a.prototype.push = function(g, f) {
          return this._transformState.needTransform = !1, l.prototype.push.call(this, g, f);
        }, a.prototype._transform = function(g, f, p) {
          p(new x("_transform()"));
        }, a.prototype._write = function(g, f, p) {
          var s = this._transformState;
          if (s.writecb = p, s.writechunk = g, s.writeencoding = f, !s.transforming) {
            var S = this._readableState;
            (s.needTransform || S.needReadable || S.length < S.highWaterMark) && this._read(S.highWaterMark);
          }
        }, a.prototype._read = function(g) {
          var f = this._transformState;
          f.writechunk !== null && !f.transforming ? (f.transforming = !0, this._transform(f.writechunk, f.writeencoding, f.afterTransform)) : f.needTransform = !0;
        }, a.prototype._destroy = function(g, f) {
          l.prototype._destroy.call(this, g, function(p) {
            f(p);
          });
        };
        function c(g, f, p) {
          if (f) return g.emit("error", f);
          if (p != null && g.push(p), g._writableState.length) throw new d();
          if (g._transformState.transforming) throw new E();
          return g.push(null);
        }
      }, { "../errors": 160, "./_stream_duplex": 162, inherits: 75 }], 166: [function(C, Z, _) {
        (function(P, x) {
          Z.exports = se;
          function y(We) {
            var Ve = this;
            this.next = null, this.entry = null, this.finish = function() {
              $e(Ve, We);
            };
          }
          var E;
          se.WritableState = J;
          var d = {
            deprecate: C("util-deprecate")
          }, l = C("./internal/streams/stream"), u = C("buffer").Buffer, a = x.Uint8Array || function() {
          };
          function n(We) {
            return u.from(We);
          }
          function c(We) {
            return u.isBuffer(We) || We instanceof a;
          }
          var g = C("./internal/streams/destroy"), f = C("./internal/streams/state"), p = f.getHighWaterMark, s = C("../errors").codes, S = s.ERR_INVALID_ARG_TYPE, b = s.ERR_METHOD_NOT_IMPLEMENTED, o = s.ERR_MULTIPLE_CALLBACK, A = s.ERR_STREAM_CANNOT_PIPE, T = s.ERR_STREAM_DESTROYED, R = s.ERR_STREAM_NULL_VALUES, L = s.ERR_STREAM_WRITE_AFTER_END, z = s.ERR_UNKNOWN_ENCODING;
          C("inherits")(se, l);
          function U() {
          }
          function J(We, Ve, Re) {
            E = E || C("./_stream_duplex"), We = We || {}, typeof Re != "boolean" && (Re = Ve instanceof E), this.objectMode = !!We.objectMode, Re && (this.objectMode = this.objectMode || !!We.writableObjectMode), this.highWaterMark = p(this, We, "writableHighWaterMark", Re), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var De = We.decodeStrings === !1;
            this.decodeStrings = !De, this.defaultEncoding = We.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Ne) {
              Pe(Ve, Ne);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = We.emitClose !== !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new y(this);
          }
          J.prototype.getBuffer = function() {
            for (var Ve = this.bufferedRequest, Re = []; Ve; )
              Re.push(Ve), Ve = Ve.next;
            return Re;
          }, function() {
            try {
              Object.defineProperty(J.prototype, "buffer", {
                get: d.deprecate(function() {
                  return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
              });
            } catch {
            }
          }();
          var F;
          typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (F = Function.prototype[Symbol.hasInstance], Object.defineProperty(se, Symbol.hasInstance, {
            value: function(Ve) {
              return F.call(this, Ve) ? !0 : this !== se ? !1 : Ve && Ve._writableState instanceof J;
            }
          })) : F = function(Ve) {
            return Ve instanceof this;
          };
          function se(We) {
            E = E || C("./_stream_duplex");
            var Ve = this instanceof E;
            if (!Ve && !F.call(se, this)) return new se(We);
            this._writableState = new J(We, this, Ve), this.writable = !0, We && (typeof We.write == "function" && (this._write = We.write), typeof We.writev == "function" && (this._writev = We.writev), typeof We.destroy == "function" && (this._destroy = We.destroy), typeof We.final == "function" && (this._final = We.final)), l.call(this);
          }
          se.prototype.pipe = function() {
            this.emit("error", new A());
          };
          function ee(We, Ve) {
            var Re = new L();
            We.emit("error", Re), P.nextTick(Ve, Re);
          }
          function ie(We, Ve, Re, De) {
            var Ne;
            return Re === null ? Ne = new R() : typeof Re != "string" && !Ve.objectMode && (Ne = new S("chunk", ["string", "Buffer"], Re)), Ne ? (We.emit("error", Ne), P.nextTick(De, Ne), !1) : !0;
          }
          se.prototype.write = function(We, Ve, Re) {
            var De = this._writableState, Ne = !1, we = !De.objectMode && c(We);
            return we && !u.isBuffer(We) && (We = n(We)), typeof Ve == "function" && (Re = Ve, Ve = null), we ? Ve = "buffer" : Ve || (Ve = De.defaultEncoding), typeof Re != "function" && (Re = U), De.ending ? ee(this, Re) : (we || ie(this, De, We, Re)) && (De.pendingcb++, Ne = Q(this, De, we, We, Ve, Re)), Ne;
          }, se.prototype.cork = function() {
            this._writableState.corked++;
          }, se.prototype.uncork = function() {
            var We = this._writableState;
            We.corked && (We.corked--, !We.writing && !We.corked && !We.bufferProcessing && We.bufferedRequest && Ee(this, We));
          }, se.prototype.setDefaultEncoding = function(Ve) {
            if (typeof Ve == "string" && (Ve = Ve.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ve + "").toLowerCase()) > -1)) throw new z(Ve);
            return this._writableState.defaultEncoding = Ve, this;
          }, Object.defineProperty(se.prototype, "writableBuffer", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          function W(We, Ve, Re) {
            return !We.objectMode && We.decodeStrings !== !1 && typeof Ve == "string" && (Ve = u.from(Ve, Re)), Ve;
          }
          Object.defineProperty(se.prototype, "writableHighWaterMark", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState.highWaterMark;
            }
          });
          function Q(We, Ve, Re, De, Ne, we) {
            if (!Re) {
              var re = W(Ve, De, Ne);
              De !== re && (Re = !0, Ne = "buffer", De = re);
            }
            var $ = Ve.objectMode ? 1 : De.length;
            Ve.length += $;
            var Ce = Ve.length < Ve.highWaterMark;
            if (Ce || (Ve.needDrain = !0), Ve.writing || Ve.corked) {
              var ve = Ve.lastBufferedRequest;
              Ve.lastBufferedRequest = {
                chunk: De,
                encoding: Ne,
                isBuf: Re,
                callback: we,
                next: null
              }, ve ? ve.next = Ve.lastBufferedRequest : Ve.bufferedRequest = Ve.lastBufferedRequest, Ve.bufferedRequestCount += 1;
            } else
              de(We, Ve, !1, $, De, Ne, we);
            return Ce;
          }
          function de(We, Ve, Re, De, Ne, we, re) {
            Ve.writelen = De, Ve.writecb = re, Ve.writing = !0, Ve.sync = !0, Ve.destroyed ? Ve.onwrite(new T("write")) : Re ? We._writev(Ne, Ve.onwrite) : We._write(Ne, we, Ve.onwrite), Ve.sync = !1;
          }
          function _e(We, Ve, Re, De, Ne) {
            --Ve.pendingcb, Re ? (P.nextTick(Ne, De), P.nextTick(He, We, Ve), We._writableState.errorEmitted = !0, We.emit("error", De)) : (Ne(De), We._writableState.errorEmitted = !0, We.emit("error", De), He(We, Ve));
          }
          function ke(We) {
            We.writing = !1, We.writecb = null, We.length -= We.writelen, We.writelen = 0;
          }
          function Pe(We, Ve) {
            var Re = We._writableState, De = Re.sync, Ne = Re.writecb;
            if (typeof Ne != "function") throw new o();
            if (ke(Re), Ve) _e(We, Re, De, Ve, Ne);
            else {
              var we = Ie(Re) || We.destroyed;
              !we && !Re.corked && !Re.bufferProcessing && Re.bufferedRequest && Ee(We, Re), De ? P.nextTick(fe, We, Re, we, Ne) : fe(We, Re, we, Ne);
            }
          }
          function fe(We, Ve, Re, De) {
            Re || xe(We, Ve), Ve.pendingcb--, De(), He(We, Ve);
          }
          function xe(We, Ve) {
            Ve.length === 0 && Ve.needDrain && (Ve.needDrain = !1, We.emit("drain"));
          }
          function Ee(We, Ve) {
            Ve.bufferProcessing = !0;
            var Re = Ve.bufferedRequest;
            if (We._writev && Re && Re.next) {
              var De = Ve.bufferedRequestCount, Ne = new Array(De), we = Ve.corkedRequestsFree;
              we.entry = Re;
              for (var re = 0, $ = !0; Re; )
                Ne[re] = Re, Re.isBuf || ($ = !1), Re = Re.next, re += 1;
              Ne.allBuffers = $, de(We, Ve, !0, Ve.length, Ne, "", we.finish), Ve.pendingcb++, Ve.lastBufferedRequest = null, we.next ? (Ve.corkedRequestsFree = we.next, we.next = null) : Ve.corkedRequestsFree = new y(Ve), Ve.bufferedRequestCount = 0;
            } else {
              for (; Re; ) {
                var Ce = Re.chunk, ve = Re.encoding, Y = Re.callback, G = Ve.objectMode ? 1 : Ce.length;
                if (de(We, Ve, !1, G, Ce, ve, Y), Re = Re.next, Ve.bufferedRequestCount--, Ve.writing)
                  break;
              }
              Re === null && (Ve.lastBufferedRequest = null);
            }
            Ve.bufferedRequest = Re, Ve.bufferProcessing = !1;
          }
          se.prototype._write = function(We, Ve, Re) {
            Re(new b("_write()"));
          }, se.prototype._writev = null, se.prototype.end = function(We, Ve, Re) {
            var De = this._writableState;
            return typeof We == "function" ? (Re = We, We = null, Ve = null) : typeof Ve == "function" && (Re = Ve, Ve = null), We != null && this.write(We, Ve), De.corked && (De.corked = 1, this.uncork()), De.ending || Ze(this, De, Re), this;
          }, Object.defineProperty(se.prototype, "writableLength", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState.length;
            }
          });
          function Ie(We) {
            return We.ending && We.length === 0 && We.bufferedRequest === null && !We.finished && !We.writing;
          }
          function je(We, Ve) {
            We._final(function(Re) {
              Ve.pendingcb--, Re && We.emit("error", Re), Ve.prefinished = !0, We.emit("prefinish"), He(We, Ve);
            });
          }
          function Ue(We, Ve) {
            !Ve.prefinished && !Ve.finalCalled && (typeof We._final == "function" && !Ve.destroyed ? (Ve.pendingcb++, Ve.finalCalled = !0, P.nextTick(je, We, Ve)) : (Ve.prefinished = !0, We.emit("prefinish")));
          }
          function He(We, Ve) {
            var Re = Ie(Ve);
            return Re && (Ue(We, Ve), Ve.pendingcb === 0 && (Ve.finished = !0, We.emit("finish"))), Re;
          }
          function Ze(We, Ve, Re) {
            Ve.ending = !0, He(We, Ve), Re && (Ve.finished ? P.nextTick(Re) : We.once("finish", Re)), Ve.ended = !0, We.writable = !1;
          }
          function $e(We, Ve, Re) {
            var De = We.entry;
            for (We.entry = null; De; ) {
              var Ne = De.callback;
              Ve.pendingcb--, Ne(Re), De = De.next;
            }
            Ve.corkedRequestsFree.next = We;
          }
          Object.defineProperty(se.prototype, "destroyed", {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: !1,
            get: function() {
              return this._writableState === void 0 ? !1 : this._writableState.destroyed;
            },
            set: function(Ve) {
              this._writableState && (this._writableState.destroyed = Ve);
            }
          }), se.prototype.destroy = g.destroy, se.prototype._undestroy = g.undestroy, se.prototype._destroy = function(We, Ve) {
            Ve(We);
          };
        }).call(this, C("_process"), typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, { "../errors": 160, "./_stream_duplex": 162, "./internal/streams/destroy": 169, "./internal/streams/state": 172, "./internal/streams/stream": 173, _process: 133, buffer: 48, inherits: 75, "util-deprecate": 183 }], 167: [function(C, Z, _) {
        (function(P) {
          var x;
          function y(T, R, L) {
            return R in T ? Object.defineProperty(T, R, { value: L, enumerable: !0, configurable: !0, writable: !0 }) : T[R] = L, T;
          }
          var E = C("./end-of-stream"), d = Symbol("lastResolve"), l = Symbol("lastReject"), u = Symbol("error"), a = Symbol("ended"), n = Symbol("lastPromise"), c = Symbol("handlePromise"), g = Symbol("stream");
          function f(T, R) {
            return {
              value: T,
              done: R
            };
          }
          function p(T) {
            var R = T[d];
            if (R !== null) {
              var L = T[g].read();
              L !== null && (T[n] = null, T[d] = null, T[l] = null, R(f(L, !1)));
            }
          }
          function s(T) {
            P.nextTick(p, T);
          }
          function S(T, R) {
            return function(L, z) {
              T.then(function() {
                if (R[a]) {
                  L(f(void 0, !0));
                  return;
                }
                R[c](L, z);
              }, z);
            };
          }
          var b = Object.getPrototypeOf(function() {
          }), o = Object.setPrototypeOf((x = {
            get stream() {
              return this[g];
            },
            next: function() {
              var R = this, L = this[u];
              if (L !== null)
                return Promise.reject(L);
              if (this[a])
                return Promise.resolve(f(void 0, !0));
              if (this[g].destroyed)
                return new Promise(function(F, se) {
                  P.nextTick(function() {
                    R[u] ? se(R[u]) : F(f(void 0, !0));
                  });
                });
              var z = this[n], U;
              if (z)
                U = new Promise(S(z, this));
              else {
                var J = this[g].read();
                if (J !== null)
                  return Promise.resolve(f(J, !1));
                U = new Promise(this[c]);
              }
              return this[n] = U, U;
            }
          }, y(x, Symbol.asyncIterator, function() {
            return this;
          }), y(x, "return", function() {
            var R = this;
            return new Promise(function(L, z) {
              R[g].destroy(null, function(U) {
                if (U) {
                  z(U);
                  return;
                }
                L(f(void 0, !0));
              });
            });
          }), x), b), A = function(R) {
            var L, z = Object.create(o, (L = {}, y(L, g, {
              value: R,
              writable: !0
            }), y(L, d, {
              value: null,
              writable: !0
            }), y(L, l, {
              value: null,
              writable: !0
            }), y(L, u, {
              value: null,
              writable: !0
            }), y(L, a, {
              value: R._readableState.endEmitted,
              writable: !0
            }), y(L, c, {
              value: function(J, F) {
                var se = z[g].read();
                se ? (z[n] = null, z[d] = null, z[l] = null, J(f(se, !1))) : (z[d] = J, z[l] = F);
              },
              writable: !0
            }), L));
            return z[n] = null, E(R, function(U) {
              if (U && U.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var J = z[l];
                J !== null && (z[n] = null, z[d] = null, z[l] = null, J(U)), z[u] = U;
                return;
              }
              var F = z[d];
              F !== null && (z[n] = null, z[d] = null, z[l] = null, F(f(void 0, !0))), z[a] = !0;
            }), R.on("readable", s.bind(null, z)), z;
          };
          Z.exports = A;
        }).call(this, C("_process"));
      }, { "./end-of-stream": 170, _process: 133 }], 168: [function(C, Z, _) {
        function P(n) {
          for (var c = 1; c < arguments.length; c++) {
            var g = arguments[c] != null ? arguments[c] : {}, f = Object.keys(g);
            typeof Object.getOwnPropertySymbols == "function" && (f = f.concat(Object.getOwnPropertySymbols(g).filter(function(p) {
              return Object.getOwnPropertyDescriptor(g, p).enumerable;
            }))), f.forEach(function(p) {
              x(n, p, g[p]);
            });
          }
          return n;
        }
        function x(n, c, g) {
          return c in n ? Object.defineProperty(n, c, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : n[c] = g, n;
        }
        var y = C("buffer"), E = y.Buffer, d = C("util"), l = d.inspect, u = l && l.custom || "inspect";
        function a(n, c, g) {
          E.prototype.copy.call(n, c, g);
        }
        Z.exports = /* @__PURE__ */ function() {
          function n() {
            this.head = null, this.tail = null, this.length = 0;
          }
          var c = n.prototype;
          return c.push = function(f) {
            var p = {
              data: f,
              next: null
            };
            this.length > 0 ? this.tail.next = p : this.head = p, this.tail = p, ++this.length;
          }, c.unshift = function(f) {
            var p = {
              data: f,
              next: this.head
            };
            this.length === 0 && (this.tail = p), this.head = p, ++this.length;
          }, c.shift = function() {
            if (this.length !== 0) {
              var f = this.head.data;
              return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, f;
            }
          }, c.clear = function() {
            this.head = this.tail = null, this.length = 0;
          }, c.join = function(f) {
            if (this.length === 0) return "";
            for (var p = this.head, s = "" + p.data; p = p.next; )
              s += f + p.data;
            return s;
          }, c.concat = function(f) {
            if (this.length === 0) return E.alloc(0);
            for (var p = E.allocUnsafe(f >>> 0), s = this.head, S = 0; s; )
              a(s.data, p, S), S += s.data.length, s = s.next;
            return p;
          }, c.consume = function(f, p) {
            var s;
            return f < this.head.data.length ? (s = this.head.data.slice(0, f), this.head.data = this.head.data.slice(f)) : f === this.head.data.length ? s = this.shift() : s = p ? this._getString(f) : this._getBuffer(f), s;
          }, c.first = function() {
            return this.head.data;
          }, c._getString = function(f) {
            var p = this.head, s = 1, S = p.data;
            for (f -= S.length; p = p.next; ) {
              var b = p.data, o = f > b.length ? b.length : f;
              if (o === b.length ? S += b : S += b.slice(0, f), f -= o, f === 0) {
                o === b.length ? (++s, p.next ? this.head = p.next : this.head = this.tail = null) : (this.head = p, p.data = b.slice(o));
                break;
              }
              ++s;
            }
            return this.length -= s, S;
          }, c._getBuffer = function(f) {
            var p = E.allocUnsafe(f), s = this.head, S = 1;
            for (s.data.copy(p), f -= s.data.length; s = s.next; ) {
              var b = s.data, o = f > b.length ? b.length : f;
              if (b.copy(p, p.length - f, 0, o), f -= o, f === 0) {
                o === b.length ? (++S, s.next ? this.head = s.next : this.head = this.tail = null) : (this.head = s, s.data = b.slice(o));
                break;
              }
              ++S;
            }
            return this.length -= S, p;
          }, c[u] = function(g, f) {
            return l(this, P({}, f, {
              // Only inspect one level.
              depth: 0,
              // It should not recurse.
              customInspect: !1
            }));
          }, n;
        }();
      }, { buffer: 48, util: 33 }], 169: [function(C, Z, _) {
        (function(P) {
          function x(u, a) {
            var n = this, c = this._readableState && this._readableState.destroyed, g = this._writableState && this._writableState.destroyed;
            return c || g ? (a ? a(u) : u && (!this._writableState || !this._writableState.errorEmitted) && P.nextTick(l, this, u), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(u || null, function(f) {
              !a && f ? (P.nextTick(y, n, f), n._writableState && (n._writableState.errorEmitted = !0)) : a ? (P.nextTick(E, n), a(f)) : P.nextTick(E, n);
            }), this);
          }
          function y(u, a) {
            l(u, a), E(u);
          }
          function E(u) {
            u._writableState && !u._writableState.emitClose || u._readableState && !u._readableState.emitClose || u.emit("close");
          }
          function d() {
            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
          }
          function l(u, a) {
            u.emit("error", a);
          }
          Z.exports = {
            destroy: x,
            undestroy: d
          };
        }).call(this, C("_process"));
      }, { _process: 133 }], 170: [function(C, Z, _) {
        var P = C("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
        function x(l) {
          var u = !1;
          return function() {
            if (!u) {
              u = !0;
              for (var a = arguments.length, n = new Array(a), c = 0; c < a; c++)
                n[c] = arguments[c];
              l.apply(this, n);
            }
          };
        }
        function y() {
        }
        function E(l) {
          return l.setHeader && typeof l.abort == "function";
        }
        function d(l, u, a) {
          if (typeof u == "function") return d(l, null, u);
          u || (u = {}), a = x(a || y);
          var n = u.readable || u.readable !== !1 && l.readable, c = u.writable || u.writable !== !1 && l.writable, g = function() {
            l.writable || p();
          }, f = l._writableState && l._writableState.finished, p = function() {
            c = !1, f = !0, n || a.call(l);
          }, s = l._readableState && l._readableState.endEmitted, S = function() {
            n = !1, s = !0, c || a.call(l);
          }, b = function(R) {
            a.call(l, R);
          }, o = function() {
            var R;
            if (n && !s)
              return (!l._readableState || !l._readableState.ended) && (R = new P()), a.call(l, R);
            if (c && !f)
              return (!l._writableState || !l._writableState.ended) && (R = new P()), a.call(l, R);
          }, A = function() {
            l.req.on("finish", p);
          };
          return E(l) ? (l.on("complete", p), l.on("abort", o), l.req ? A() : l.on("request", A)) : c && !l._writableState && (l.on("end", g), l.on("close", g)), l.on("end", S), l.on("finish", p), u.error !== !1 && l.on("error", b), l.on("close", o), function() {
            l.removeListener("complete", p), l.removeListener("abort", o), l.removeListener("request", A), l.req && l.req.removeListener("finish", p), l.removeListener("end", g), l.removeListener("close", g), l.removeListener("finish", p), l.removeListener("end", S), l.removeListener("error", b), l.removeListener("close", o);
          };
        }
        Z.exports = d;
      }, { "../../../errors": 160 }], 171: [function(C, Z, _) {
        var P;
        function x(p) {
          var s = !1;
          return function() {
            s || (s = !0, p.apply(void 0, arguments));
          };
        }
        var y = C("../../../errors").codes, E = y.ERR_MISSING_ARGS, d = y.ERR_STREAM_DESTROYED;
        function l(p) {
          if (p) throw p;
        }
        function u(p) {
          return p.setHeader && typeof p.abort == "function";
        }
        function a(p, s, S, b) {
          b = x(b);
          var o = !1;
          p.on("close", function() {
            o = !0;
          }), P === void 0 && (P = C("./end-of-stream")), P(p, {
            readable: s,
            writable: S
          }, function(T) {
            if (T) return b(T);
            o = !0, b();
          });
          var A = !1;
          return function(T) {
            if (!o && !A) {
              if (A = !0, u(p)) return p.abort();
              if (typeof p.destroy == "function") return p.destroy();
              b(T || new d("pipe"));
            }
          };
        }
        function n(p) {
          p();
        }
        function c(p, s) {
          return p.pipe(s);
        }
        function g(p) {
          return !p.length || typeof p[p.length - 1] != "function" ? l : p.pop();
        }
        function f() {
          for (var p = arguments.length, s = new Array(p), S = 0; S < p; S++)
            s[S] = arguments[S];
          var b = g(s);
          if (Array.isArray(s[0]) && (s = s[0]), s.length < 2)
            throw new E("streams");
          var o, A = s.map(function(T, R) {
            var L = R < s.length - 1, z = R > 0;
            return a(T, L, z, function(U) {
              o || (o = U), U && A.forEach(n), !L && (A.forEach(n), b(o));
            });
          });
          return s.reduce(c);
        }
        Z.exports = f;
      }, { "../../../errors": 160, "./end-of-stream": 170 }], 172: [function(C, Z, _) {
        var P = C("../../../errors").codes.ERR_INVALID_OPT_VALUE;
        function x(E, d, l) {
          return E.highWaterMark != null ? E.highWaterMark : d ? E[l] : null;
        }
        function y(E, d, l, u) {
          var a = x(d, u, l);
          if (a != null) {
            if (!(isFinite(a) && Math.floor(a) === a) || a < 0) {
              var n = u ? l : "highWaterMark";
              throw new P(n, a);
            }
            return Math.floor(a);
          }
          return E.objectMode ? 16 : 16 * 1024;
        }
        Z.exports = {
          getHighWaterMark: y
        };
      }, { "../../../errors": 160 }], 173: [function(C, Z, _) {
        arguments[4][146][0].apply(_, arguments);
      }, { dup: 146, events: 52 }], 174: [function(C, Z, _) {
        _ = Z.exports = C("./lib/_stream_readable.js"), _.Stream = _, _.Readable = _, _.Writable = C("./lib/_stream_writable.js"), _.Duplex = C("./lib/_stream_duplex.js"), _.Transform = C("./lib/_stream_transform.js"), _.PassThrough = C("./lib/_stream_passthrough.js"), _.finished = C("./lib/internal/streams/end-of-stream.js"), _.pipeline = C("./lib/internal/streams/pipeline.js");
      }, { "./lib/_stream_duplex.js": 162, "./lib/_stream_passthrough.js": 163, "./lib/_stream_readable.js": 164, "./lib/_stream_transform.js": 165, "./lib/_stream_writable.js": 166, "./lib/internal/streams/end-of-stream.js": 170, "./lib/internal/streams/pipeline.js": 171 }], 175: [function(C, Z, _) {
        arguments[4][148][0].apply(_, arguments);
      }, { dup: 148, "safe-buffer": 154 }], 176: [function(C, Z, _) {
        (function(P, x) {
          var y = C("process/browser.js").nextTick, E = Function.prototype.apply, d = Array.prototype.slice, l = {}, u = 0;
          _.setTimeout = function() {
            return new a(E.call(setTimeout, ne, arguments), clearTimeout);
          }, _.setInterval = function() {
            return new a(E.call(setInterval, ne, arguments), clearInterval);
          }, _.clearTimeout = _.clearInterval = function(n) {
            n.close();
          };
          function a(n, c) {
            this._id = n, this._clearFn = c;
          }
          a.prototype.unref = a.prototype.ref = function() {
          }, a.prototype.close = function() {
            this._clearFn.call(ne, this._id);
          }, _.enroll = function(n, c) {
            clearTimeout(n._idleTimeoutId), n._idleTimeout = c;
          }, _.unenroll = function(n) {
            clearTimeout(n._idleTimeoutId), n._idleTimeout = -1;
          }, _._unrefActive = _.active = function(n) {
            clearTimeout(n._idleTimeoutId);
            var c = n._idleTimeout;
            c >= 0 && (n._idleTimeoutId = setTimeout(function() {
              n._onTimeout && n._onTimeout();
            }, c));
          }, _.setImmediate = typeof P == "function" ? P : function(n) {
            var c = u++, g = arguments.length < 2 ? !1 : d.call(arguments, 1);
            return l[c] = !0, y(function() {
              l[c] && (g ? n.apply(null, g) : n.call(null), _.clearImmediate(c));
            }), c;
          }, _.clearImmediate = typeof x == "function" ? x : function(n) {
            delete l[n];
          };
        }).call(this, C("timers").setImmediate, C("timers").clearImmediate);
      }, { "process/browser.js": 133, timers: 176 }], 177: [function(C, Z, _) {
        (function(P) {
          Object.defineProperty(_, "__esModule", {
            value: !0
          });
          var x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(W) {
            return typeof W;
          } : function(W) {
            return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
          };
          _.clone = u, _.addLast = c, _.addFirst = g, _.removeLast = f, _.removeFirst = p, _.insert = s, _.removeAt = S, _.replaceAt = b, _.getIn = o, _.set = A, _.setIn = R, _.update = L, _.updateIn = z, _.merge = U, _.mergeDeep = J, _.mergeIn = F, _.omit = se, _.addDefaults = ee;
          /*!
           * Timm
           *
           * Immutability helpers with fast reads and acceptable writes.
           *
           * @copyright Guillermo Grau Panea 2016
           * @license MIT
           */
          var y = "INVALID_ARGS";
          function E(W) {
            throw new Error(W);
          }
          function d(W) {
            var Q = Object.keys(W);
            return Object.getOwnPropertySymbols ? Q.concat(Object.getOwnPropertySymbols(W)) : Q;
          }
          var l = {}.hasOwnProperty;
          function u(W) {
            if (Array.isArray(W)) return W.slice();
            for (var Q = d(W), de = {}, _e = 0; _e < Q.length; _e++) {
              var ke = Q[_e];
              de[ke] = W[ke];
            }
            return de;
          }
          function a(W, Q, de) {
            var _e = de;
            _e == null && E(P.env.NODE_ENV !== "production" ? "At least one object should be provided to merge()" : y);
            for (var ke = !1, Pe = arguments.length, fe = Array(Pe > 3 ? Pe - 3 : 0), xe = 3; xe < Pe; xe++)
              fe[xe - 3] = arguments[xe];
            for (var Ee = 0; Ee < fe.length; Ee++) {
              var Ie = fe[Ee];
              if (Ie != null) {
                var je = d(Ie);
                if (je.length)
                  for (var Ue = 0; Ue <= je.length; Ue++) {
                    var He = je[Ue];
                    if (!(W && _e[He] !== void 0)) {
                      var Ze = Ie[He];
                      Q && n(_e[He]) && n(Ze) && (Ze = a(W, Q, _e[He], Ze)), !(Ze === void 0 || Ze === _e[He]) && (ke || (ke = !0, _e = u(_e)), _e[He] = Ze);
                    }
                  }
              }
            }
            return _e;
          }
          function n(W) {
            var Q = typeof W > "u" ? "undefined" : x(W);
            return W != null && Q === "object";
          }
          function c(W, Q) {
            return Array.isArray(Q) ? W.concat(Q) : W.concat([Q]);
          }
          function g(W, Q) {
            return Array.isArray(Q) ? Q.concat(W) : [Q].concat(W);
          }
          function f(W) {
            return W.length ? W.slice(0, W.length - 1) : W;
          }
          function p(W) {
            return W.length ? W.slice(1) : W;
          }
          function s(W, Q, de) {
            return W.slice(0, Q).concat(Array.isArray(de) ? de : [de]).concat(W.slice(Q));
          }
          function S(W, Q) {
            return Q >= W.length || Q < 0 ? W : W.slice(0, Q).concat(W.slice(Q + 1));
          }
          function b(W, Q, de) {
            if (W[Q] === de) return W;
            for (var _e = W.length, ke = Array(_e), Pe = 0; Pe < _e; Pe++)
              ke[Pe] = W[Pe];
            return ke[Q] = de, ke;
          }
          function o(W, Q) {
            if (!Array.isArray(Q) && E(P.env.NODE_ENV !== "production" ? "A path array should be provided when calling getIn()" : y), W != null) {
              for (var de = W, _e = 0; _e < Q.length; _e++) {
                var ke = Q[_e];
                if (de = de != null ? de[ke] : void 0, de === void 0) return de;
              }
              return de;
            }
          }
          function A(W, Q, de) {
            var _e = typeof Q == "number" ? [] : {}, ke = W ?? _e;
            if (ke[Q] === de) return ke;
            var Pe = u(ke);
            return Pe[Q] = de, Pe;
          }
          function T(W, Q, de, _e) {
            var ke = void 0, Pe = Q[_e];
            if (_e === Q.length - 1)
              ke = de;
            else {
              var fe = n(W) && n(W[Pe]) ? W[Pe] : typeof Q[_e + 1] == "number" ? [] : {};
              ke = T(fe, Q, de, _e + 1);
            }
            return A(W, Pe, ke);
          }
          function R(W, Q, de) {
            return Q.length ? T(W, Q, de, 0) : de;
          }
          function L(W, Q, de) {
            var _e = W == null ? void 0 : W[Q], ke = de(_e);
            return A(W, Q, ke);
          }
          function z(W, Q, de) {
            var _e = o(W, Q), ke = de(_e);
            return R(W, Q, ke);
          }
          function U(W, Q, de, _e, ke, Pe) {
            for (var fe = arguments.length, xe = Array(fe > 6 ? fe - 6 : 0), Ee = 6; Ee < fe; Ee++)
              xe[Ee - 6] = arguments[Ee];
            return xe.length ? a.call.apply(a, [null, !1, !1, W, Q, de, _e, ke, Pe].concat(xe)) : a(!1, !1, W, Q, de, _e, ke, Pe);
          }
          function J(W, Q, de, _e, ke, Pe) {
            for (var fe = arguments.length, xe = Array(fe > 6 ? fe - 6 : 0), Ee = 6; Ee < fe; Ee++)
              xe[Ee - 6] = arguments[Ee];
            return xe.length ? a.call.apply(a, [null, !1, !0, W, Q, de, _e, ke, Pe].concat(xe)) : a(!1, !0, W, Q, de, _e, ke, Pe);
          }
          function F(W, Q, de, _e, ke, Pe, fe) {
            var xe = o(W, Q);
            xe == null && (xe = {});
            for (var Ee = void 0, Ie = arguments.length, je = Array(Ie > 7 ? Ie - 7 : 0), Ue = 7; Ue < Ie; Ue++)
              je[Ue - 7] = arguments[Ue];
            return je.length ? Ee = a.call.apply(a, [null, !1, !1, xe, de, _e, ke, Pe, fe].concat(je)) : Ee = a(!1, !1, xe, de, _e, ke, Pe, fe), R(W, Q, Ee);
          }
          function se(W, Q) {
            for (var de = Array.isArray(Q) ? Q : [Q], _e = !1, ke = 0; ke < de.length; ke++)
              if (l.call(W, de[ke])) {
                _e = !0;
                break;
              }
            if (!_e) return W;
            for (var Pe = {}, fe = d(W), xe = 0; xe < fe.length; xe++) {
              var Ee = fe[xe];
              de.indexOf(Ee) >= 0 || (Pe[Ee] = W[Ee]);
            }
            return Pe;
          }
          function ee(W, Q, de, _e, ke, Pe) {
            for (var fe = arguments.length, xe = Array(fe > 6 ? fe - 6 : 0), Ee = 6; Ee < fe; Ee++)
              xe[Ee - 6] = arguments[Ee];
            return xe.length ? a.call.apply(a, [null, !0, !1, W, Q, de, _e, ke, Pe].concat(xe)) : a(!0, !1, W, Q, de, _e, ke, Pe);
          }
          var ie = {
            clone: u,
            addLast: c,
            addFirst: g,
            removeLast: f,
            removeFirst: p,
            insert: s,
            removeAt: S,
            replaceAt: b,
            getIn: o,
            // eslint-disable-next-line object-shorthand
            set: A,
            // so that flow doesn't complain
            setIn: R,
            update: L,
            updateIn: z,
            merge: U,
            mergeDeep: J,
            mergeIn: F,
            omit: se,
            addDefaults: ee
          };
          _.default = ie;
        }).call(this, C("_process"));
      }, { _process: 133 }], 178: [function(C, Z, _) {
        (function(P) {
          var x = /^\s+/, y = /\s+$/, E = 0, d = P.round, l = P.min, u = P.max, a = P.random;
          function n(we, re) {
            if (we = we || "", re = re || {}, we instanceof n)
              return we;
            if (!(this instanceof n))
              return new n(we, re);
            var $ = c(we);
            this._originalInput = we, this._r = $.r, this._g = $.g, this._b = $.b, this._a = $.a, this._roundA = d(100 * this._a) / 100, this._format = re.format || $.format, this._gradientType = re.gradientType, this._r < 1 && (this._r = d(this._r)), this._g < 1 && (this._g = d(this._g)), this._b < 1 && (this._b = d(this._b)), this._ok = $.ok, this._tc_id = E++;
          }
          n.prototype = {
            isDark: function() {
              return this.getBrightness() < 128;
            },
            isLight: function() {
              return !this.isDark();
            },
            isValid: function() {
              return this._ok;
            },
            getOriginalInput: function() {
              return this._originalInput;
            },
            getFormat: function() {
              return this._format;
            },
            getAlpha: function() {
              return this._a;
            },
            getBrightness: function() {
              var we = this.toRgb();
              return (we.r * 299 + we.g * 587 + we.b * 114) / 1e3;
            },
            getLuminance: function() {
              var we = this.toRgb(), re, $, Ce, ve, Y, G;
              return re = we.r / 255, $ = we.g / 255, Ce = we.b / 255, re <= 0.03928 ? ve = re / 12.92 : ve = P.pow((re + 0.055) / 1.055, 2.4), $ <= 0.03928 ? Y = $ / 12.92 : Y = P.pow(($ + 0.055) / 1.055, 2.4), Ce <= 0.03928 ? G = Ce / 12.92 : G = P.pow((Ce + 0.055) / 1.055, 2.4), 0.2126 * ve + 0.7152 * Y + 0.0722 * G;
            },
            setAlpha: function(we) {
              return this._a = fe(we), this._roundA = d(100 * this._a) / 100, this;
            },
            toHsv: function() {
              var we = s(this._r, this._g, this._b);
              return { h: we.h * 360, s: we.s, v: we.v, a: this._a };
            },
            toHsvString: function() {
              var we = s(this._r, this._g, this._b), re = d(we.h * 360), $ = d(we.s * 100), Ce = d(we.v * 100);
              return this._a == 1 ? "hsv(" + re + ", " + $ + "%, " + Ce + "%)" : "hsva(" + re + ", " + $ + "%, " + Ce + "%, " + this._roundA + ")";
            },
            toHsl: function() {
              var we = f(this._r, this._g, this._b);
              return { h: we.h * 360, s: we.s, l: we.l, a: this._a };
            },
            toHslString: function() {
              var we = f(this._r, this._g, this._b), re = d(we.h * 360), $ = d(we.s * 100), Ce = d(we.l * 100);
              return this._a == 1 ? "hsl(" + re + ", " + $ + "%, " + Ce + "%)" : "hsla(" + re + ", " + $ + "%, " + Ce + "%, " + this._roundA + ")";
            },
            toHex: function(we) {
              return b(this._r, this._g, this._b, we);
            },
            toHexString: function(we) {
              return "#" + this.toHex(we);
            },
            toHex8: function(we) {
              return o(this._r, this._g, this._b, this._a, we);
            },
            toHex8String: function(we) {
              return "#" + this.toHex8(we);
            },
            toRgb: function() {
              return { r: d(this._r), g: d(this._g), b: d(this._b), a: this._a };
            },
            toRgbString: function() {
              return this._a == 1 ? "rgb(" + d(this._r) + ", " + d(this._g) + ", " + d(this._b) + ")" : "rgba(" + d(this._r) + ", " + d(this._g) + ", " + d(this._b) + ", " + this._roundA + ")";
            },
            toPercentageRgb: function() {
              return { r: d(xe(this._r, 255) * 100) + "%", g: d(xe(this._g, 255) * 100) + "%", b: d(xe(this._b, 255) * 100) + "%", a: this._a };
            },
            toPercentageRgbString: function() {
              return this._a == 1 ? "rgb(" + d(xe(this._r, 255) * 100) + "%, " + d(xe(this._g, 255) * 100) + "%, " + d(xe(this._b, 255) * 100) + "%)" : "rgba(" + d(xe(this._r, 255) * 100) + "%, " + d(xe(this._g, 255) * 100) + "%, " + d(xe(this._b, 255) * 100) + "%, " + this._roundA + ")";
            },
            toName: function() {
              return this._a === 0 ? "transparent" : this._a < 1 ? !1 : ke[b(this._r, this._g, this._b, !0)] || !1;
            },
            toFilter: function(we) {
              var re = "#" + A(this._r, this._g, this._b, this._a), $ = re, Ce = this._gradientType ? "GradientType = 1, " : "";
              if (we) {
                var ve = n(we);
                $ = "#" + A(ve._r, ve._g, ve._b, ve._a);
              }
              return "progid:DXImageTransform.Microsoft.gradient(" + Ce + "startColorstr=" + re + ",endColorstr=" + $ + ")";
            },
            toString: function(we) {
              var re = !!we;
              we = we || this._format;
              var $ = !1, Ce = this._a < 1 && this._a >= 0, ve = !re && Ce && (we === "hex" || we === "hex6" || we === "hex3" || we === "hex4" || we === "hex8" || we === "name");
              return ve ? we === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (we === "rgb" && ($ = this.toRgbString()), we === "prgb" && ($ = this.toPercentageRgbString()), (we === "hex" || we === "hex6") && ($ = this.toHexString()), we === "hex3" && ($ = this.toHexString(!0)), we === "hex4" && ($ = this.toHex8String(!0)), we === "hex8" && ($ = this.toHex8String()), we === "name" && ($ = this.toName()), we === "hsl" && ($ = this.toHslString()), we === "hsv" && ($ = this.toHsvString()), $ || this.toHexString());
            },
            clone: function() {
              return n(this.toString());
            },
            _applyModification: function(we, re) {
              var $ = we.apply(null, [this].concat([].slice.call(re)));
              return this._r = $._r, this._g = $._g, this._b = $._b, this.setAlpha($._a), this;
            },
            lighten: function() {
              return this._applyModification(z, arguments);
            },
            brighten: function() {
              return this._applyModification(U, arguments);
            },
            darken: function() {
              return this._applyModification(J, arguments);
            },
            desaturate: function() {
              return this._applyModification(T, arguments);
            },
            saturate: function() {
              return this._applyModification(R, arguments);
            },
            greyscale: function() {
              return this._applyModification(L, arguments);
            },
            spin: function() {
              return this._applyModification(F, arguments);
            },
            _applyCombination: function(we, re) {
              return we.apply(null, [this].concat([].slice.call(re)));
            },
            analogous: function() {
              return this._applyCombination(Q, arguments);
            },
            complement: function() {
              return this._applyCombination(se, arguments);
            },
            monochromatic: function() {
              return this._applyCombination(de, arguments);
            },
            splitcomplement: function() {
              return this._applyCombination(W, arguments);
            },
            triad: function() {
              return this._applyCombination(ee, arguments);
            },
            tetrad: function() {
              return this._applyCombination(ie, arguments);
            }
          }, n.fromRatio = function(we, re) {
            if (typeof we == "object") {
              var $ = {};
              for (var Ce in we)
                we.hasOwnProperty(Ce) && (Ce === "a" ? $[Ce] = we[Ce] : $[Ce] = Ze(we[Ce]));
              we = $;
            }
            return n(we, re);
          };
          function c(we) {
            var re = { r: 0, g: 0, b: 0 }, $ = 1, Ce = null, ve = null, Y = null, G = !1, Ae = !1;
            return typeof we == "string" && (we = De(we)), typeof we == "object" && (Re(we.r) && Re(we.g) && Re(we.b) ? (re = g(we.r, we.g, we.b), G = !0, Ae = String(we.r).substr(-1) === "%" ? "prgb" : "rgb") : Re(we.h) && Re(we.s) && Re(we.v) ? (Ce = Ze(we.s), ve = Ze(we.v), re = S(we.h, Ce, ve), G = !0, Ae = "hsv") : Re(we.h) && Re(we.s) && Re(we.l) && (Ce = Ze(we.s), Y = Ze(we.l), re = p(we.h, Ce, Y), G = !0, Ae = "hsl"), we.hasOwnProperty("a") && ($ = we.a)), $ = fe($), {
              ok: G,
              format: we.format || Ae,
              r: l(255, u(re.r, 0)),
              g: l(255, u(re.g, 0)),
              b: l(255, u(re.b, 0)),
              a: $
            };
          }
          function g(we, re, $) {
            return {
              r: xe(we, 255) * 255,
              g: xe(re, 255) * 255,
              b: xe($, 255) * 255
            };
          }
          function f(we, re, $) {
            we = xe(we, 255), re = xe(re, 255), $ = xe($, 255);
            var Ce = u(we, re, $), ve = l(we, re, $), Y, G, Ae = (Ce + ve) / 2;
            if (Ce == ve)
              Y = G = 0;
            else {
              var e = Ce - ve;
              switch (G = Ae > 0.5 ? e / (2 - Ce - ve) : e / (Ce + ve), Ce) {
                case we:
                  Y = (re - $) / e + (re < $ ? 6 : 0);
                  break;
                case re:
                  Y = ($ - we) / e + 2;
                  break;
                case $:
                  Y = (we - re) / e + 4;
                  break;
              }
              Y /= 6;
            }
            return { h: Y, s: G, l: Ae };
          }
          function p(we, re, $) {
            var Ce, ve, Y;
            we = xe(we, 360), re = xe(re, 100), $ = xe($, 100);
            function G(r, h, k) {
              return k < 0 && (k += 1), k > 1 && (k -= 1), k < 1 / 6 ? r + (h - r) * 6 * k : k < 1 / 2 ? h : k < 2 / 3 ? r + (h - r) * (2 / 3 - k) * 6 : r;
            }
            if (re === 0)
              Ce = ve = Y = $;
            else {
              var Ae = $ < 0.5 ? $ * (1 + re) : $ + re - $ * re, e = 2 * $ - Ae;
              Ce = G(e, Ae, we + 1 / 3), ve = G(e, Ae, we), Y = G(e, Ae, we - 1 / 3);
            }
            return { r: Ce * 255, g: ve * 255, b: Y * 255 };
          }
          function s(we, re, $) {
            we = xe(we, 255), re = xe(re, 255), $ = xe($, 255);
            var Ce = u(we, re, $), ve = l(we, re, $), Y, G, Ae = Ce, e = Ce - ve;
            if (G = Ce === 0 ? 0 : e / Ce, Ce == ve)
              Y = 0;
            else {
              switch (Ce) {
                case we:
                  Y = (re - $) / e + (re < $ ? 6 : 0);
                  break;
                case re:
                  Y = ($ - we) / e + 2;
                  break;
                case $:
                  Y = (we - re) / e + 4;
                  break;
              }
              Y /= 6;
            }
            return { h: Y, s: G, v: Ae };
          }
          function S(we, re, $) {
            we = xe(we, 360) * 6, re = xe(re, 100), $ = xe($, 100);
            var Ce = P.floor(we), ve = we - Ce, Y = $ * (1 - re), G = $ * (1 - ve * re), Ae = $ * (1 - (1 - ve) * re), e = Ce % 6, r = [$, G, Y, Y, Ae, $][e], h = [Ae, $, $, G, Y, Y][e], k = [Y, Y, Ae, $, $, G][e];
            return { r: r * 255, g: h * 255, b: k * 255 };
          }
          function b(we, re, $, Ce) {
            var ve = [
              He(d(we).toString(16)),
              He(d(re).toString(16)),
              He(d($).toString(16))
            ];
            return Ce && ve[0].charAt(0) == ve[0].charAt(1) && ve[1].charAt(0) == ve[1].charAt(1) && ve[2].charAt(0) == ve[2].charAt(1) ? ve[0].charAt(0) + ve[1].charAt(0) + ve[2].charAt(0) : ve.join("");
          }
          function o(we, re, $, Ce, ve) {
            var Y = [
              He(d(we).toString(16)),
              He(d(re).toString(16)),
              He(d($).toString(16)),
              He($e(Ce))
            ];
            return ve && Y[0].charAt(0) == Y[0].charAt(1) && Y[1].charAt(0) == Y[1].charAt(1) && Y[2].charAt(0) == Y[2].charAt(1) && Y[3].charAt(0) == Y[3].charAt(1) ? Y[0].charAt(0) + Y[1].charAt(0) + Y[2].charAt(0) + Y[3].charAt(0) : Y.join("");
          }
          function A(we, re, $, Ce) {
            var ve = [
              He($e(Ce)),
              He(d(we).toString(16)),
              He(d(re).toString(16)),
              He(d($).toString(16))
            ];
            return ve.join("");
          }
          n.equals = function(we, re) {
            return !we || !re ? !1 : n(we).toRgbString() == n(re).toRgbString();
          }, n.random = function() {
            return n.fromRatio({
              r: a(),
              g: a(),
              b: a()
            });
          };
          function T(we, re) {
            re = re === 0 ? 0 : re || 10;
            var $ = n(we).toHsl();
            return $.s -= re / 100, $.s = Ee($.s), n($);
          }
          function R(we, re) {
            re = re === 0 ? 0 : re || 10;
            var $ = n(we).toHsl();
            return $.s += re / 100, $.s = Ee($.s), n($);
          }
          function L(we) {
            return n(we).desaturate(100);
          }
          function z(we, re) {
            re = re === 0 ? 0 : re || 10;
            var $ = n(we).toHsl();
            return $.l += re / 100, $.l = Ee($.l), n($);
          }
          function U(we, re) {
            re = re === 0 ? 0 : re || 10;
            var $ = n(we).toRgb();
            return $.r = u(0, l(255, $.r - d(255 * -(re / 100)))), $.g = u(0, l(255, $.g - d(255 * -(re / 100)))), $.b = u(0, l(255, $.b - d(255 * -(re / 100)))), n($);
          }
          function J(we, re) {
            re = re === 0 ? 0 : re || 10;
            var $ = n(we).toHsl();
            return $.l -= re / 100, $.l = Ee($.l), n($);
          }
          function F(we, re) {
            var $ = n(we).toHsl(), Ce = ($.h + re) % 360;
            return $.h = Ce < 0 ? 360 + Ce : Ce, n($);
          }
          function se(we) {
            var re = n(we).toHsl();
            return re.h = (re.h + 180) % 360, n(re);
          }
          function ee(we) {
            var re = n(we).toHsl(), $ = re.h;
            return [
              n(we),
              n({ h: ($ + 120) % 360, s: re.s, l: re.l }),
              n({ h: ($ + 240) % 360, s: re.s, l: re.l })
            ];
          }
          function ie(we) {
            var re = n(we).toHsl(), $ = re.h;
            return [
              n(we),
              n({ h: ($ + 90) % 360, s: re.s, l: re.l }),
              n({ h: ($ + 180) % 360, s: re.s, l: re.l }),
              n({ h: ($ + 270) % 360, s: re.s, l: re.l })
            ];
          }
          function W(we) {
            var re = n(we).toHsl(), $ = re.h;
            return [
              n(we),
              n({ h: ($ + 72) % 360, s: re.s, l: re.l }),
              n({ h: ($ + 216) % 360, s: re.s, l: re.l })
            ];
          }
          function Q(we, re, $) {
            re = re || 6, $ = $ || 30;
            var Ce = n(we).toHsl(), ve = 360 / $, Y = [n(we)];
            for (Ce.h = (Ce.h - (ve * re >> 1) + 720) % 360; --re; )
              Ce.h = (Ce.h + ve) % 360, Y.push(n(Ce));
            return Y;
          }
          function de(we, re) {
            re = re || 6;
            for (var $ = n(we).toHsv(), Ce = $.h, ve = $.s, Y = $.v, G = [], Ae = 1 / re; re--; )
              G.push(n({ h: Ce, s: ve, v: Y })), Y = (Y + Ae) % 1;
            return G;
          }
          n.mix = function(we, re, $) {
            $ = $ === 0 ? 0 : $ || 50;
            var Ce = n(we).toRgb(), ve = n(re).toRgb(), Y = $ / 100, G = {
              r: (ve.r - Ce.r) * Y + Ce.r,
              g: (ve.g - Ce.g) * Y + Ce.g,
              b: (ve.b - Ce.b) * Y + Ce.b,
              a: (ve.a - Ce.a) * Y + Ce.a
            };
            return n(G);
          }, n.readability = function(we, re) {
            var $ = n(we), Ce = n(re);
            return (P.max($.getLuminance(), Ce.getLuminance()) + 0.05) / (P.min($.getLuminance(), Ce.getLuminance()) + 0.05);
          }, n.isReadable = function(we, re, $) {
            var Ce = n.readability(we, re), ve, Y;
            switch (Y = !1, ve = Ne($), ve.level + ve.size) {
              case "AAsmall":
              case "AAAlarge":
                Y = Ce >= 4.5;
                break;
              case "AAlarge":
                Y = Ce >= 3;
                break;
              case "AAAsmall":
                Y = Ce >= 7;
                break;
            }
            return Y;
          }, n.mostReadable = function(we, re, $) {
            var Ce = null, ve = 0, Y, G, Ae, e;
            $ = $ || {}, G = $.includeFallbackColors, Ae = $.level, e = $.size;
            for (var r = 0; r < re.length; r++)
              Y = n.readability(we, re[r]), Y > ve && (ve = Y, Ce = n(re[r]));
            return n.isReadable(we, Ce, { level: Ae, size: e }) || !G ? Ce : ($.includeFallbackColors = !1, n.mostReadable(we, ["#fff", "#000"], $));
          };
          var _e = n.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
          }, ke = n.hexNames = Pe(_e);
          function Pe(we) {
            var re = {};
            for (var $ in we)
              we.hasOwnProperty($) && (re[we[$]] = $);
            return re;
          }
          function fe(we) {
            return we = parseFloat(we), (isNaN(we) || we < 0 || we > 1) && (we = 1), we;
          }
          function xe(we, re) {
            je(we) && (we = "100%");
            var $ = Ue(we);
            return we = l(re, u(0, parseFloat(we))), $ && (we = parseInt(we * re, 10) / 100), P.abs(we - re) < 1e-6 ? 1 : we % re / parseFloat(re);
          }
          function Ee(we) {
            return l(1, u(0, we));
          }
          function Ie(we) {
            return parseInt(we, 16);
          }
          function je(we) {
            return typeof we == "string" && we.indexOf(".") != -1 && parseFloat(we) === 1;
          }
          function Ue(we) {
            return typeof we == "string" && we.indexOf("%") != -1;
          }
          function He(we) {
            return we.length == 1 ? "0" + we : "" + we;
          }
          function Ze(we) {
            return we <= 1 && (we = we * 100 + "%"), we;
          }
          function $e(we) {
            return P.round(parseFloat(we) * 255).toString(16);
          }
          function We(we) {
            return Ie(we) / 255;
          }
          var Ve = function() {
            var we = "[-\\+]?\\d+%?", re = "[-\\+]?\\d*\\.\\d+%?", $ = "(?:" + re + ")|(?:" + we + ")", Ce = "[\\s|\\(]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")\\s*\\)?", ve = "[\\s|\\(]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")\\s*\\)?";
            return {
              CSS_UNIT: new RegExp($),
              rgb: new RegExp("rgb" + Ce),
              rgba: new RegExp("rgba" + ve),
              hsl: new RegExp("hsl" + Ce),
              hsla: new RegExp("hsla" + ve),
              hsv: new RegExp("hsv" + Ce),
              hsva: new RegExp("hsva" + ve),
              hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
              hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
              hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
              hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
            };
          }();
          function Re(we) {
            return !!Ve.CSS_UNIT.exec(we);
          }
          function De(we) {
            we = we.replace(x, "").replace(y, "").toLowerCase();
            var re = !1;
            if (_e[we])
              we = _e[we], re = !0;
            else if (we == "transparent")
              return { r: 0, g: 0, b: 0, a: 0, format: "name" };
            var $;
            return ($ = Ve.rgb.exec(we)) ? { r: $[1], g: $[2], b: $[3] } : ($ = Ve.rgba.exec(we)) ? { r: $[1], g: $[2], b: $[3], a: $[4] } : ($ = Ve.hsl.exec(we)) ? { h: $[1], s: $[2], l: $[3] } : ($ = Ve.hsla.exec(we)) ? { h: $[1], s: $[2], l: $[3], a: $[4] } : ($ = Ve.hsv.exec(we)) ? { h: $[1], s: $[2], v: $[3] } : ($ = Ve.hsva.exec(we)) ? { h: $[1], s: $[2], v: $[3], a: $[4] } : ($ = Ve.hex8.exec(we)) ? {
              r: Ie($[1]),
              g: Ie($[2]),
              b: Ie($[3]),
              a: We($[4]),
              format: re ? "name" : "hex8"
            } : ($ = Ve.hex6.exec(we)) ? {
              r: Ie($[1]),
              g: Ie($[2]),
              b: Ie($[3]),
              format: re ? "name" : "hex"
            } : ($ = Ve.hex4.exec(we)) ? {
              r: Ie($[1] + "" + $[1]),
              g: Ie($[2] + "" + $[2]),
              b: Ie($[3] + "" + $[3]),
              a: We($[4] + "" + $[4]),
              format: re ? "name" : "hex8"
            } : ($ = Ve.hex3.exec(we)) ? {
              r: Ie($[1] + "" + $[1]),
              g: Ie($[2] + "" + $[2]),
              b: Ie($[3] + "" + $[3]),
              format: re ? "name" : "hex"
            } : !1;
          }
          function Ne(we) {
            var re, $;
            return we = we || { level: "AA", size: "small" }, re = (we.level || "AA").toUpperCase(), $ = (we.size || "small").toLowerCase(), re !== "AA" && re !== "AAA" && (re = "AA"), $ !== "small" && $ !== "large" && ($ = "small"), { level: re, size: $ };
          }
          typeof Z < "u" && Z.exports ? Z.exports = n : ne.tinycolor = n;
        })(Math);
      }, {}], 179: [function(C, Z, _) {
        _ = Z.exports = P;
        function P(x) {
          return x.replace(/^\s*|\s*$/g, "");
        }
        _.left = function(x) {
          return x.replace(/^\s*/, "");
        }, _.right = function(x) {
          return x.replace(/\s*$/, "");
        };
      }, {}], 180: [function(C, Z, _) {
        var P = C("punycode"), x = C("./util");
        _.parse = T, _.resolve = L, _.resolveObject = z, _.format = R, _.Url = y;
        function y() {
          this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
        }
        var E = /^([a-z0-9.+-]+:)/i, d = /:[0-9]*$/, l = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, u = ["<", ">", '"', "`", " ", "\r", `
`, "	"], a = ["{", "}", "|", "\\", "^", "`"].concat(u), n = ["'"].concat(a), c = ["%", "/", "?", ";", "#"].concat(n), g = ["/", "?", "#"], f = 255, p = /^[+a-z0-9A-Z_-]{0,63}$/, s = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, S = {
          javascript: !0,
          "javascript:": !0
        }, b = {
          javascript: !0,
          "javascript:": !0
        }, o = {
          http: !0,
          https: !0,
          ftp: !0,
          gopher: !0,
          file: !0,
          "http:": !0,
          "https:": !0,
          "ftp:": !0,
          "gopher:": !0,
          "file:": !0
        }, A = C("querystring");
        function T(U, J, F) {
          if (U && x.isObject(U) && U instanceof y) return U;
          var se = new y();
          return se.parse(U, J, F), se;
        }
        y.prototype.parse = function(U, J, F) {
          if (!x.isString(U))
            throw new TypeError("Parameter 'url' must be a string, not " + typeof U);
          var se = U.indexOf("?"), ee = se !== -1 && se < U.indexOf("#") ? "?" : "#", ie = U.split(ee), W = /\\/g;
          ie[0] = ie[0].replace(W, "/"), U = ie.join(ee);
          var Q = U;
          if (Q = Q.trim(), !F && U.split("#").length === 1) {
            var de = l.exec(Q);
            if (de)
              return this.path = Q, this.href = Q, this.pathname = de[1], de[2] ? (this.search = de[2], J ? this.query = A.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : J && (this.search = "", this.query = {}), this;
          }
          var _e = E.exec(Q);
          if (_e) {
            _e = _e[0];
            var ke = _e.toLowerCase();
            this.protocol = ke, Q = Q.substr(_e.length);
          }
          if (F || _e || Q.match(/^\/\/[^@\/]+@[^@\/]+/)) {
            var Pe = Q.substr(0, 2) === "//";
            Pe && !(_e && b[_e]) && (Q = Q.substr(2), this.slashes = !0);
          }
          if (!b[_e] && (Pe || _e && !o[_e])) {
            for (var fe = -1, xe = 0; xe < g.length; xe++) {
              var Ee = Q.indexOf(g[xe]);
              Ee !== -1 && (fe === -1 || Ee < fe) && (fe = Ee);
            }
            var Ie, je;
            fe === -1 ? je = Q.lastIndexOf("@") : je = Q.lastIndexOf("@", fe), je !== -1 && (Ie = Q.slice(0, je), Q = Q.slice(je + 1), this.auth = decodeURIComponent(Ie)), fe = -1;
            for (var xe = 0; xe < c.length; xe++) {
              var Ee = Q.indexOf(c[xe]);
              Ee !== -1 && (fe === -1 || Ee < fe) && (fe = Ee);
            }
            fe === -1 && (fe = Q.length), this.host = Q.slice(0, fe), Q = Q.slice(fe), this.parseHost(), this.hostname = this.hostname || "";
            var Ue = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!Ue)
              for (var He = this.hostname.split(/\./), xe = 0, Ze = He.length; xe < Ze; xe++) {
                var $e = He[xe];
                if ($e && !$e.match(p)) {
                  for (var We = "", Ve = 0, Re = $e.length; Ve < Re; Ve++)
                    $e.charCodeAt(Ve) > 127 ? We += "x" : We += $e[Ve];
                  if (!We.match(p)) {
                    var De = He.slice(0, xe), Ne = He.slice(xe + 1), we = $e.match(s);
                    we && (De.push(we[1]), Ne.unshift(we[2])), Ne.length && (Q = "/" + Ne.join(".") + Q), this.hostname = De.join(".");
                    break;
                  }
                }
              }
            this.hostname.length > f ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), Ue || (this.hostname = P.toASCII(this.hostname));
            var re = this.port ? ":" + this.port : "", $ = this.hostname || "";
            this.host = $ + re, this.href += this.host, Ue && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), Q[0] !== "/" && (Q = "/" + Q));
          }
          if (!S[ke])
            for (var xe = 0, Ze = n.length; xe < Ze; xe++) {
              var Ce = n[xe];
              if (Q.indexOf(Ce) !== -1) {
                var ve = encodeURIComponent(Ce);
                ve === Ce && (ve = escape(Ce)), Q = Q.split(Ce).join(ve);
              }
            }
          var Y = Q.indexOf("#");
          Y !== -1 && (this.hash = Q.substr(Y), Q = Q.slice(0, Y));
          var G = Q.indexOf("?");
          if (G !== -1 ? (this.search = Q.substr(G), this.query = Q.substr(G + 1), J && (this.query = A.parse(this.query)), Q = Q.slice(0, G)) : J && (this.search = "", this.query = {}), Q && (this.pathname = Q), o[ke] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
            var re = this.pathname || "", Ae = this.search || "";
            this.path = re + Ae;
          }
          return this.href = this.format(), this;
        };
        function R(U) {
          return x.isString(U) && (U = T(U)), U instanceof y ? U.format() : y.prototype.format.call(U);
        }
        y.prototype.format = function() {
          var U = this.auth || "";
          U && (U = encodeURIComponent(U), U = U.replace(/%3A/i, ":"), U += "@");
          var J = this.protocol || "", F = this.pathname || "", se = this.hash || "", ee = !1, ie = "";
          this.host ? ee = U + this.host : this.hostname && (ee = U + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (ee += ":" + this.port)), this.query && x.isObject(this.query) && Object.keys(this.query).length && (ie = A.stringify(this.query));
          var W = this.search || ie && "?" + ie || "";
          return J && J.substr(-1) !== ":" && (J += ":"), this.slashes || (!J || o[J]) && ee !== !1 ? (ee = "//" + (ee || ""), F && F.charAt(0) !== "/" && (F = "/" + F)) : ee || (ee = ""), se && se.charAt(0) !== "#" && (se = "#" + se), W && W.charAt(0) !== "?" && (W = "?" + W), F = F.replace(/[?#]/g, function(Q) {
            return encodeURIComponent(Q);
          }), W = W.replace("#", "%23"), J + ee + F + W + se;
        };
        function L(U, J) {
          return T(U, !1, !0).resolve(J);
        }
        y.prototype.resolve = function(U) {
          return this.resolveObject(T(U, !1, !0)).format();
        };
        function z(U, J) {
          return U ? T(U, !1, !0).resolveObject(J) : J;
        }
        y.prototype.resolveObject = function(U) {
          if (x.isString(U)) {
            var J = new y();
            J.parse(U, !1, !0), U = J;
          }
          for (var F = new y(), se = Object.keys(this), ee = 0; ee < se.length; ee++) {
            var ie = se[ee];
            F[ie] = this[ie];
          }
          if (F.hash = U.hash, U.href === "")
            return F.href = F.format(), F;
          if (U.slashes && !U.protocol) {
            for (var W = Object.keys(U), Q = 0; Q < W.length; Q++) {
              var de = W[Q];
              de !== "protocol" && (F[de] = U[de]);
            }
            return o[F.protocol] && F.hostname && !F.pathname && (F.path = F.pathname = "/"), F.href = F.format(), F;
          }
          if (U.protocol && U.protocol !== F.protocol) {
            if (!o[U.protocol]) {
              for (var _e = Object.keys(U), ke = 0; ke < _e.length; ke++) {
                var Pe = _e[ke];
                F[Pe] = U[Pe];
              }
              return F.href = F.format(), F;
            }
            if (F.protocol = U.protocol, !U.host && !b[U.protocol]) {
              for (var Ze = (U.pathname || "").split("/"); Ze.length && !(U.host = Ze.shift()); ) ;
              U.host || (U.host = ""), U.hostname || (U.hostname = ""), Ze[0] !== "" && Ze.unshift(""), Ze.length < 2 && Ze.unshift(""), F.pathname = Ze.join("/");
            } else
              F.pathname = U.pathname;
            if (F.search = U.search, F.query = U.query, F.host = U.host || "", F.auth = U.auth, F.hostname = U.hostname || U.host, F.port = U.port, F.pathname || F.search) {
              var fe = F.pathname || "", xe = F.search || "";
              F.path = fe + xe;
            }
            return F.slashes = F.slashes || U.slashes, F.href = F.format(), F;
          }
          var Ee = F.pathname && F.pathname.charAt(0) === "/", Ie = U.host || U.pathname && U.pathname.charAt(0) === "/", je = Ie || Ee || F.host && U.pathname, Ue = je, He = F.pathname && F.pathname.split("/") || [], Ze = U.pathname && U.pathname.split("/") || [], $e = F.protocol && !o[F.protocol];
          if ($e && (F.hostname = "", F.port = null, F.host && (He[0] === "" ? He[0] = F.host : He.unshift(F.host)), F.host = "", U.protocol && (U.hostname = null, U.port = null, U.host && (Ze[0] === "" ? Ze[0] = U.host : Ze.unshift(U.host)), U.host = null), je = je && (Ze[0] === "" || He[0] === "")), Ie)
            F.host = U.host || U.host === "" ? U.host : F.host, F.hostname = U.hostname || U.hostname === "" ? U.hostname : F.hostname, F.search = U.search, F.query = U.query, He = Ze;
          else if (Ze.length)
            He || (He = []), He.pop(), He = He.concat(Ze), F.search = U.search, F.query = U.query;
          else if (!x.isNullOrUndefined(U.search)) {
            if ($e) {
              F.hostname = F.host = He.shift();
              var We = F.host && F.host.indexOf("@") > 0 ? F.host.split("@") : !1;
              We && (F.auth = We.shift(), F.host = F.hostname = We.shift());
            }
            return F.search = U.search, F.query = U.query, (!x.isNull(F.pathname) || !x.isNull(F.search)) && (F.path = (F.pathname ? F.pathname : "") + (F.search ? F.search : "")), F.href = F.format(), F;
          }
          if (!He.length)
            return F.pathname = null, F.search ? F.path = "/" + F.search : F.path = null, F.href = F.format(), F;
          for (var Ve = He.slice(-1)[0], Re = (F.host || U.host || He.length > 1) && (Ve === "." || Ve === "..") || Ve === "", De = 0, Ne = He.length; Ne >= 0; Ne--)
            Ve = He[Ne], Ve === "." ? He.splice(Ne, 1) : Ve === ".." ? (He.splice(Ne, 1), De++) : De && (He.splice(Ne, 1), De--);
          if (!je && !Ue)
            for (; De--; De)
              He.unshift("..");
          je && He[0] !== "" && (!He[0] || He[0].charAt(0) !== "/") && He.unshift(""), Re && He.join("/").substr(-1) !== "/" && He.push("");
          var we = He[0] === "" || He[0] && He[0].charAt(0) === "/";
          if ($e) {
            F.hostname = F.host = we ? "" : He.length ? He.shift() : "";
            var We = F.host && F.host.indexOf("@") > 0 ? F.host.split("@") : !1;
            We && (F.auth = We.shift(), F.host = F.hostname = We.shift());
          }
          return je = je || F.host && He.length, je && !we && He.unshift(""), He.length ? F.pathname = He.join("/") : (F.pathname = null, F.path = null), (!x.isNull(F.pathname) || !x.isNull(F.search)) && (F.path = (F.pathname ? F.pathname : "") + (F.search ? F.search : "")), F.auth = U.auth || F.auth, F.slashes = F.slashes || U.slashes, F.href = F.format(), F;
        }, y.prototype.parseHost = function() {
          var U = this.host, J = d.exec(U);
          J && (J = J[0], J !== ":" && (this.port = J.substr(1)), U = U.substr(0, U.length - J.length)), U && (this.hostname = U);
        };
      }, { "./util": 181, punycode: 134, querystring: 137 }], 181: [function(C, Z, _) {
        Z.exports = {
          isString: function(P) {
            return typeof P == "string";
          },
          isObject: function(P) {
            return typeof P == "object" && P !== null;
          },
          isNull: function(P) {
            return P === null;
          },
          isNullOrUndefined: function(P) {
            return P == null;
          }
        };
      }, {}], 182: [function(C, Z, _) {
        (function(P) {
          (function() {
            var x = {};
            typeof Z == "object" ? Z.exports = x : self.UTIF = x;
            var y;
            typeof C == "function" ? y = C("pako") : y = self.pako;
            function E() {
              (typeof P > "u" || P.env.NODE_ENV == "development") && console.log.apply(console, arguments);
            }
            (function(d, l) {
              (function() {
                var u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
                  return typeof c;
                } : function(c) {
                  return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
                }, a = function() {
                  function c(g) {
                    this.message = "JPEG error: " + g;
                  }
                  return c.prototype = Error(), c.prototype.name = "JpegError", c.constructor = c;
                }(), n = function() {
                  function c(g, f) {
                    this.message = g, this.g = f;
                  }
                  return c.prototype = Error(), c.prototype.name = "DNLMarkerError", c.constructor = c;
                }();
                (function() {
                  function c() {
                    this.M = null, this.B = -1;
                  }
                  function g(b, o) {
                    for (var A = 0, T = [], R, L, z = 16; 0 < z && !b[z - 1]; ) z--;
                    T.push({ children: [], index: 0 });
                    var U = T[0], J;
                    for (R = 0; R < z; R++) {
                      for (L = 0; L < b[R]; L++) {
                        for (U = T.pop(), U.children[U.index] = o[A]; 0 < U.index; ) U = T.pop();
                        for (U.index++, T.push(U); T.length <= R; ) T.push(J = { children: [], index: 0 }), U.children[U.index] = J.children, U = J;
                        A++;
                      }
                      R + 1 < z && (T.push(J = { children: [], index: 0 }), U.children[U.index] = J.children, U = J);
                    }
                    return T[0].children;
                  }
                  function f(b, o, A, T, R, L, z, U, J) {
                    function F() {
                      if (0 < Ie) return Ie--, Ee >> Ie & 1;
                      if (Ee = b[o++], Ee === 255) {
                        var Y = b[o++];
                        if (Y) {
                          if (Y === 220 && Pe) {
                            o += 2;
                            var G = b[o++] << 8 | b[o++];
                            if (0 < G && G !== A.g) throw new n("Found DNL marker (0xFFDC) while parsing scan data", G);
                          }
                          throw new a("unexpected marker " + (Ee << 8 | Y).toString(16));
                        }
                      }
                      return Ie = 7, Ee >>> 7;
                    }
                    function se(Y) {
                      for (; ; ) {
                        if (Y = Y[F()], typeof Y == "number") return Y;
                        if ((typeof Y > "u" ? "undefined" : u(Y)) !== "object") throw new a("invalid huffman sequence");
                      }
                    }
                    function ee(Y) {
                      for (var G = 0; 0 < Y; ) G = G << 1 | F(), Y--;
                      return G;
                    }
                    function ie(Y) {
                      if (Y === 1) return F() === 1 ? 1 : -1;
                      var G = ee(Y);
                      return G >= 1 << Y - 1 ? G : G + (-1 << Y) + 1;
                    }
                    function W(Y, G) {
                      var Ae = se(Y.D);
                      for (Ae = Ae === 0 ? 0 : ie(Ae), Y.a[G] = Y.m += Ae, Ae = 1; 64 > Ae; ) {
                        var e = se(Y.o), r = e & 15;
                        if (e >>= 4, r === 0) {
                          if (15 > e) break;
                          Ae += 16;
                        } else Ae += e, Y.a[G + S[Ae]] = ie(r), Ae++;
                      }
                    }
                    function Q(Y, G) {
                      var Ae = se(Y.D);
                      Ae = Ae === 0 ? 0 : ie(Ae) << J, Y.a[G] = Y.m += Ae;
                    }
                    function de(Y, G) {
                      Y.a[G] |= F() << J;
                    }
                    function _e(Y, G) {
                      if (0 < je) je--;
                      else for (var Ae = L; Ae <= z; ) {
                        var e = se(Y.o), r = e & 15;
                        if (e >>= 4, r === 0) {
                          if (15 > e) {
                            je = ee(e) + (1 << e) - 1;
                            break;
                          }
                          Ae += 16;
                        } else Ae += e, Y.a[G + S[Ae]] = ie(r) * (1 << J), Ae++;
                      }
                    }
                    function ke(Y, G) {
                      for (var Ae = L, e = 0, r; Ae <= z; ) {
                        r = G + S[Ae];
                        var h = 0 > Y.a[r] ? -1 : 1;
                        switch (Ue) {
                          case 0:
                            if (e = se(Y.o), r = e & 15, e >>= 4, r === 0) 15 > e ? (je = ee(e) + (1 << e), Ue = 4) : (e = 16, Ue = 1);
                            else {
                              if (r !== 1) throw new a("invalid ACn encoding");
                              He = ie(r), Ue = e ? 2 : 3;
                            }
                            continue;
                          case 1:
                          case 2:
                            Y.a[r] ? Y.a[r] += h * (F() << J) : (e--, e === 0 && (Ue = Ue === 2 ? 3 : 0));
                            break;
                          case 3:
                            Y.a[r] ? Y.a[r] += h * (F() << J) : (Y.a[r] = He << J, Ue = 0);
                            break;
                          case 4:
                            Y.a[r] && (Y.a[r] += h * (F() << J));
                        }
                        Ae++;
                      }
                      Ue === 4 && (je--, je === 0 && (Ue = 0));
                    }
                    for (var Pe = 9 < arguments.length && arguments[9] !== void 0 ? arguments[9] : !1, fe = A.P, xe = o, Ee = 0, Ie = 0, je = 0, Ue = 0, He, Ze = T.length, $e, We, Ve, Re, De = A.S ? L === 0 ? U === 0 ? Q : de : U === 0 ? _e : ke : W, Ne = 0, we = Ze === 1 ? T[0].c * T[0].l : fe * A.O, re, $; Ne < we; ) {
                      var Ce = R ? Math.min(we - Ne, R) : we;
                      for ($e = 0; $e < Ze; $e++) T[$e].m = 0;
                      if (je = 0, Ze === 1) {
                        var ve = T[0];
                        for (Re = 0; Re < Ce; Re++) De(ve, 64 * ((ve.c + 1) * (Ne / ve.c | 0) + Ne % ve.c)), Ne++;
                      } else for (Re = 0; Re < Ce; Re++) {
                        for ($e = 0; $e < Ze; $e++) for (ve = T[$e], re = ve.h, $ = ve.j, We = 0; We < $; We++) for (Ve = 0; Ve < re; Ve++) De(ve, 64 * ((ve.c + 1) * ((Ne / fe | 0) * ve.j + We) + (Ne % fe * ve.h + Ve)));
                        Ne++;
                      }
                      if (Ie = 0, (ve = s(b, o)) && ve.f && ((0, _util.warn)("decodeScan - unexpected MCU data, current marker is: " + ve.f), o = ve.offset), ve = ve && ve.F, !ve || 65280 >= ve) throw new a("marker was not found");
                      if (65488 <= ve && 65495 >= ve) o += 2;
                      else break;
                    }
                    return (ve = s(b, o)) && ve.f && ((0, _util.warn)("decodeScan - unexpected Scan data, current marker is: " + ve.f), o = ve.offset), o - xe;
                  }
                  function p(b, o) {
                    for (var A = o.c, T = o.l, R = new Int16Array(64), L = 0; L < T; L++) for (var z = 0; z < A; z++) {
                      var U = 64 * ((o.c + 1) * L + z), J = R, F = o.G, se = o.a;
                      if (!F) throw new a("missing required Quantization Table.");
                      for (var ee = 0; 64 > ee; ee += 8) {
                        var ie = se[U + ee], W = se[U + ee + 1], Q = se[U + ee + 2], de = se[U + ee + 3], _e = se[U + ee + 4], ke = se[U + ee + 5], Pe = se[U + ee + 6], fe = se[U + ee + 7];
                        if (ie *= F[ee], (W | Q | de | _e | ke | Pe | fe) === 0) ie = 5793 * ie + 512 >> 10, J[ee] = ie, J[ee + 1] = ie, J[ee + 2] = ie, J[ee + 3] = ie, J[ee + 4] = ie, J[ee + 5] = ie, J[ee + 6] = ie, J[ee + 7] = ie;
                        else {
                          W *= F[ee + 1], Q *= F[ee + 2], de *= F[ee + 3], _e *= F[ee + 4], ke *= F[ee + 5], Pe *= F[ee + 6], fe *= F[ee + 7];
                          var xe = 5793 * ie + 128 >> 8, Ee = 5793 * _e + 128 >> 8, Ie = Q, je = Pe;
                          _e = 2896 * (W - fe) + 128 >> 8, fe = 2896 * (W + fe) + 128 >> 8, de <<= 4, ke <<= 4, xe = xe + Ee + 1 >> 1, Ee = xe - Ee, ie = 3784 * Ie + 1567 * je + 128 >> 8, Ie = 1567 * Ie - 3784 * je + 128 >> 8, je = ie, _e = _e + ke + 1 >> 1, ke = _e - ke, fe = fe + de + 1 >> 1, de = fe - de, xe = xe + je + 1 >> 1, je = xe - je, Ee = Ee + Ie + 1 >> 1, Ie = Ee - Ie, ie = 2276 * _e + 3406 * fe + 2048 >> 12, _e = 3406 * _e - 2276 * fe + 2048 >> 12, fe = ie, ie = 799 * de + 4017 * ke + 2048 >> 12, de = 4017 * de - 799 * ke + 2048 >> 12, ke = ie, J[ee] = xe + fe, J[ee + 7] = xe - fe, J[ee + 1] = Ee + ke, J[ee + 6] = Ee - ke, J[ee + 2] = Ie + de, J[ee + 5] = Ie - de, J[ee + 3] = je + _e, J[ee + 4] = je - _e;
                        }
                      }
                      for (F = 0; 8 > F; ++F) ie = J[F], W = J[F + 8], Q = J[F + 16], de = J[F + 24], _e = J[F + 32], ke = J[F + 40], Pe = J[F + 48], fe = J[F + 56], (W | Q | de | _e | ke | Pe | fe) === 0 ? (ie = 5793 * ie + 8192 >> 14, ie = -2040 > ie ? 0 : 2024 <= ie ? 255 : ie + 2056 >> 4, se[U + F] = ie, se[U + F + 8] = ie, se[U + F + 16] = ie, se[U + F + 24] = ie, se[U + F + 32] = ie, se[U + F + 40] = ie, se[U + F + 48] = ie, se[U + F + 56] = ie) : (xe = 5793 * ie + 2048 >> 12, Ee = 5793 * _e + 2048 >> 12, Ie = Q, je = Pe, _e = 2896 * (W - fe) + 2048 >> 12, fe = 2896 * (W + fe) + 2048 >> 12, xe = (xe + Ee + 1 >> 1) + 4112, Ee = xe - Ee, ie = 3784 * Ie + 1567 * je + 2048 >> 12, Ie = 1567 * Ie - 3784 * je + 2048 >> 12, je = ie, _e = _e + ke + 1 >> 1, ke = _e - ke, fe = fe + de + 1 >> 1, de = fe - de, xe = xe + je + 1 >> 1, je = xe - je, Ee = Ee + Ie + 1 >> 1, Ie = Ee - Ie, ie = 2276 * _e + 3406 * fe + 2048 >> 12, _e = 3406 * _e - 2276 * fe + 2048 >> 12, fe = ie, ie = 799 * de + 4017 * ke + 2048 >> 12, de = 4017 * de - 799 * ke + 2048 >> 12, ke = ie, ie = xe + fe, fe = xe - fe, W = Ee + ke, Pe = Ee - ke, Q = Ie + de, ke = Ie - de, de = je + _e, _e = je - _e, ie = 16 > ie ? 0 : 4080 <= ie ? 255 : ie >> 4, W = 16 > W ? 0 : 4080 <= W ? 255 : W >> 4, Q = 16 > Q ? 0 : 4080 <= Q ? 255 : Q >> 4, de = 16 > de ? 0 : 4080 <= de ? 255 : de >> 4, _e = 16 > _e ? 0 : 4080 <= _e ? 255 : _e >> 4, ke = 16 > ke ? 0 : 4080 <= ke ? 255 : ke >> 4, Pe = 16 > Pe ? 0 : 4080 <= Pe ? 255 : Pe >> 4, fe = 16 > fe ? 0 : 4080 <= fe ? 255 : fe >> 4, se[U + F] = ie, se[U + F + 8] = W, se[U + F + 16] = Q, se[U + F + 24] = de, se[U + F + 32] = _e, se[U + F + 40] = ke, se[U + F + 48] = Pe, se[U + F + 56] = fe);
                    }
                    return o.a;
                  }
                  function s(b, o) {
                    var A = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : o, T = b.length - 1;
                    if (A = A < o ? A : o, o >= T) return null;
                    var R = b[o] << 8 | b[o + 1];
                    if (65472 <= R && 65534 >= R) return { f: null, F: R, offset: o };
                    for (var L = b[A] << 8 | b[A + 1]; !(65472 <= L && 65534 >= L); ) {
                      if (++A >= T) return null;
                      L = b[A] << 8 | b[A + 1];
                    }
                    return { f: R.toString(16), F: L, offset: A };
                  }
                  var S = new Uint8Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63
                  ]);
                  c.prototype = { parse: function(b) {
                    function o() {
                      var Ie = b[z] << 8 | b[z + 1];
                      return z += 2, Ie;
                    }
                    function A() {
                      var Ie = o();
                      Ie = z + Ie - 2;
                      var je = s(b, Ie, z);
                      return je && je.f && ((0, _util.warn)("readDataBlock - incorrect length, current marker is: " + je.f), Ie = je.offset), Ie = b.subarray(z, Ie), z += Ie.length, Ie;
                    }
                    function T(Ie) {
                      for (var je = Math.ceil(Ie.v / 8 / Ie.s), Ue = Math.ceil(Ie.g / 8 / Ie.u), He = 0; He < Ie.b.length; He++) {
                        xe = Ie.b[He];
                        var Ze = Math.ceil(Math.ceil(Ie.v / 8) * xe.h / Ie.s), $e = Math.ceil(Math.ceil(Ie.g / 8) * xe.j / Ie.u);
                        xe.a = new Int16Array(64 * Ue * xe.j * (je * xe.h + 1)), xe.c = Ze, xe.l = $e;
                      }
                      Ie.P = je, Ie.O = Ue;
                    }
                    var R = (1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).N, L = R === void 0 ? null : R, z = 0, U = null, J = 0;
                    R = [];
                    var F = [], se = [], ee = o();
                    if (ee !== 65496) throw new a("SOI not found");
                    for (ee = o(); ee !== 65497; ) {
                      switch (ee) {
                        case 65504:
                        case 65505:
                        case 65506:
                        case 65507:
                        case 65508:
                        case 65509:
                        case 65510:
                        case 65511:
                        case 65512:
                        case 65513:
                        case 65514:
                        case 65515:
                        case 65516:
                        case 65517:
                        case 65518:
                        case 65519:
                        case 65534:
                          var ie = A();
                          ee === 65518 && ie[0] === 65 && ie[1] === 100 && ie[2] === 111 && ie[3] === 98 && ie[4] === 101 && (U = { version: ie[5] << 8 | ie[6], Y: ie[7] << 8 | ie[8], Z: ie[9] << 8 | ie[10], W: ie[11] });
                          break;
                        case 65499:
                          ee = o() + z - 2;
                          for (var W; z < ee; ) {
                            var Q = b[z++], de = new Uint16Array(64);
                            if (Q >> 4 === 0) for (ie = 0; 64 > ie; ie++) W = S[ie], de[W] = b[z++];
                            else if (Q >> 4 === 1) for (ie = 0; 64 > ie; ie++) W = S[ie], de[W] = o();
                            else throw new a("DQT - invalid table spec");
                            R[Q & 15] = de;
                          }
                          break;
                        case 65472:
                        case 65473:
                        case 65474:
                          if (_e) throw new a("Only single frame JPEGs supported");
                          o();
                          var _e = {};
                          for (_e.X = ee === 65473, _e.S = ee === 65474, _e.precision = b[z++], ee = o(), _e.g = L || ee, _e.v = o(), _e.b = [], _e.C = {}, ie = b[z++], ee = de = Q = 0; ee < ie; ee++) {
                            W = b[z];
                            var ke = b[z + 1] >> 4, Pe = b[z + 1] & 15;
                            Q < ke && (Q = ke), de < Pe && (de = Pe), ke = _e.b.push({ h: ke, j: Pe, T: b[z + 2], G: null }), _e.C[W] = ke - 1, z += 3;
                          }
                          _e.s = Q, _e.u = de, T(_e);
                          break;
                        case 65476:
                          for (W = o(), ee = 2; ee < W; ) {
                            for (Q = b[z++], de = new Uint8Array(16), ie = ke = 0; 16 > ie; ie++, z++) ke += de[ie] = b[z];
                            for (Pe = new Uint8Array(ke), ie = 0; ie < ke; ie++, z++) Pe[ie] = b[z];
                            ee += 17 + ke, (Q >> 4 === 0 ? se : F)[Q & 15] = g(de, Pe);
                          }
                          break;
                        case 65501:
                          o();
                          var fe = o();
                          break;
                        case 65498:
                          for (ie = ++J === 1 && !L, o(), Q = b[z++], W = [], ee = 0; ee < Q; ee++) {
                            de = _e.C[b[z++]];
                            var xe = _e.b[de];
                            de = b[z++], xe.D = se[de >> 4], xe.o = F[de & 15], W.push(xe);
                          }
                          ee = b[z++], Q = b[z++], de = b[z++];
                          try {
                            var Ee = f(b, z, _e, W, fe, ee, Q, de >> 4, de & 15, ie);
                            z += Ee;
                          } catch (Ie) {
                            if (Ie instanceof n) return (0, _util.warn)('Attempting to re-parse JPEG image using "scanLines" parameter found in DNL marker (0xFFDC) segment.'), this.parse(b, { N: Ie.g });
                            throw Ie;
                          }
                          break;
                        case 65500:
                          z += 4;
                          break;
                        case 65535:
                          b[z] !== 255 && z--;
                          break;
                        default:
                          if (b[z - 3] === 255 && 192 <= b[z - 2] && 254 >= b[z - 2]) z -= 3;
                          else if ((ie = s(b, z - 2)) && ie.f) (0, _util.warn)("JpegImage.parse - unexpected data, current marker is: " + ie.f), z = ie.offset;
                          else throw new a("unknown marker " + ee.toString(16));
                      }
                      ee = o();
                    }
                    for (this.width = _e.v, this.height = _e.g, this.A = U, this.b = [], ee = 0; ee < _e.b.length; ee++)
                      xe = _e.b[ee], (fe = R[xe.T]) && (xe.G = fe), this.b.push({ R: p(_e, xe), U: xe.h / _e.s, V: xe.j / _e.u, c: xe.c, l: xe.l });
                    this.i = this.b.length;
                  }, L: function(b, o) {
                    var A = this.width / b, T = this.height / o, R, L, z = this.b.length, U = b * o * z, J = new Uint8ClampedArray(U), F = new Uint32Array(b);
                    for (L = 0; L < z; L++) {
                      var se = this.b[L], ee = se.U * A, ie = se.V * T, W = L, Q = se.R, de = se.c + 1 << 3;
                      for (R = 0; R < b; R++) se = 0 | R * ee, F[R] = (se & 4294967288) << 3 | se & 7;
                      for (ee = 0; ee < o; ee++) for (se = 0 | ee * ie, se = de * (se & 4294967288) | (se & 7) << 3, R = 0; R < b; R++) J[W] = Q[se + F[R]], W += z;
                    }
                    if (T = this.M) for (L = 0; L < U; ) for (A = se = 0; se < z; se++, L++, A += 2) J[L] = (J[L] * T[A] >> 8) + T[A + 1];
                    return J;
                  }, w: function() {
                    return this.A ? !!this.A.W : this.i === 3 ? this.B !== 0 : this.B === 1;
                  }, I: function(b) {
                    for (var o, A, T, R = 0, L = b.length; R < L; R += 3) o = b[R], A = b[R + 1], T = b[R + 2], b[R] = o - 179.456 + 1.402 * T, b[R + 1] = o + 135.459 - 0.344 * A - 0.714 * T, b[R + 2] = o - 226.816 + 1.772 * A;
                    return b;
                  }, K: function(b) {
                    for (var o, A, T, R, L = 0, z = 0, U = b.length; z < U; z += 4) o = b[z], A = b[z + 1], T = b[z + 2], R = b[z + 3], b[L++] = -122.67195406894 + A * (-660635669420364e-19 * A + 437130475926232e-18 * T - 54080610064599e-18 * o + 48449797120281e-17 * R - 0.154362151871126) + T * (-957964378445773e-18 * T + 817076911346625e-18 * o - 0.00477271405408747 * R + 1.53380253221734) + o * (961250184130688e-18 * o - 0.00266257332283933 * R + 0.48357088451265) + R * (-336197177618394e-18 * R + 0.484791561490776), b[L++] = 107.268039397724 + A * (219927104525741e-19 * A - 640992018297945e-18 * T + 659397001245577e-18 * o + 426105652938837e-18 * R - 0.176491792462875) + T * (-778269941513683e-18 * T + 0.00130872261408275 * o + 770482631801132e-18 * R - 0.151051492775562) + o * (0.00126935368114843 * o - 0.00265090189010898 * R + 0.25802910206845) + R * (-318913117588328e-18 * R - 0.213742400323665), b[L++] = -20.810012546947 + A * (-570115196973677e-18 * A - 263409051004589e-19 * T + 0.0020741088115012 * o - 0.00288260236853442 * R + 0.814272968359295) + T * (-153496057440975e-19 * T - 132689043961446e-18 * o + 560833691242812e-18 * R - 0.195152027534049) + o * (0.00174418132927582 * o - 0.00255243321439347 * R + 0.116935020465145) + R * (-343531996510555e-18 * R + 0.24165260232407);
                    return b.subarray(
                      0,
                      L
                    );
                  }, J: function(b) {
                    for (var o, A, T, R = 0, L = b.length; R < L; R += 4) o = b[R], A = b[R + 1], T = b[R + 2], b[R] = 434.456 - o - 1.402 * T, b[R + 1] = 119.541 - o + 0.344 * A + 0.714 * T, b[R + 2] = 481.816 - o - 1.772 * A;
                    return b;
                  }, H: function(b) {
                    for (var o, A, T, R, L = 0, z = 1 / 255, U = 0, J = b.length; U < J; U += 4) o = b[U] * z, A = b[U + 1] * z, T = b[U + 2] * z, R = b[U + 3] * z, b[L++] = 255 + o * (-4.387332384609988 * o + 54.48615194189176 * A + 18.82290502165302 * T + 212.25662451639585 * R - 285.2331026137004) + A * (1.7149763477362134 * A - 5.6096736904047315 * T - 17.873870861415444 * R - 5.497006427196366) + T * (-2.5217340131683033 * T - 21.248923337353073 * R + 17.5119270841813) - R * (21.86122147463605 * R + 189.48180835922747), b[L++] = 255 + o * (8.841041422036149 * o + 60.118027045597366 * A + 6.871425592049007 * T + 31.159100130055922 * R - 79.2970844816548) + A * (-15.310361306967817 * A + 17.575251261109482 * T + 131.35250912493976 * R - 190.9453302588951) + T * (4.444339102852739 * T + 9.8632861493405 * R - 24.86741582555878) - R * (20.737325471181034 * R + 187.80453709719578), b[L++] = 255 + o * (0.8842522430003296 * o + 8.078677503112928 * A + 30.89978309703729 * T - 0.23883238689178934 * R - 14.183576799673286) + A * (10.49593273432072 * A + 63.02378494754052 * T + 50.606957656360734 * R - 112.23884253719248) + T * (0.03296041114873217 * T + 115.60384449646641 * R - 193.58209356861505) - R * (22.33816807309886 * R + 180.12613974708367);
                    return b.subarray(0, L);
                  }, getData: function(b, o, A) {
                    if (4 < this.i) throw new a("Unsupported color mode");
                    if (b = this.L(b, o), this.i === 1 && A) {
                      A = b.length, o = new Uint8ClampedArray(3 * A);
                      for (var T = 0, R = 0; R < A; R++) {
                        var L = b[R];
                        o[T++] = L, o[T++] = L, o[T++] = L;
                      }
                      return o;
                    }
                    if (this.i === 3 && this.w()) return this.I(b);
                    if (this.i === 4) {
                      if (this.w()) return A ? this.K(b) : this.J(b);
                      if (A) return this.H(b);
                    }
                    return b;
                  } }, d.JpegDecoder = c;
                })();
              })(), d.encodeImage = function(u, a, n, c) {
                var g = {
                  t256: [a],
                  t257: [n],
                  t258: [8, 8, 8, 8],
                  t259: [1],
                  t262: [2],
                  t273: [1e3],
                  // strips offset
                  t277: [4],
                  t278: [n],
                  /* rows per strip */
                  t279: [a * n * 4],
                  // strip byte counts
                  t282: [1],
                  t283: [1],
                  t284: [1],
                  t286: [0],
                  t287: [0],
                  t296: [1],
                  t305: ["Photopea (UTIF.js)"],
                  t338: [1]
                };
                if (c) for (var f in c) g[f] = c[f];
                for (var p = new Uint8Array(d.encode([g])), s = new Uint8Array(u), S = new Uint8Array(1e3 + a * n * 4), f = 0; f < p.length; f++) S[f] = p[f];
                for (var f = 0; f < s.length; f++) S[1e3 + f] = s[f];
                return S.buffer;
              }, d.encode = function(u) {
                var a = new Uint8Array(2e4), n = 4, c = d._binBE;
                a[0] = 77, a[1] = 77, a[3] = 42;
                var g = 8;
                c.writeUint(a, n, g), n += 4;
                for (var f = 0; f < u.length; f++) {
                  var p = d._writeIFD(c, a, g, u[f]);
                  g = p[1], f < u.length - 1 && c.writeUint(a, p[0], g);
                }
                return a.slice(0, g).buffer;
              }, d.decode = function(u) {
                d.decode._decodeG3.allow2D = null;
                var a = new Uint8Array(u), n = 0, c = d._binBE.readASCII(a, n, 2);
                n += 2;
                var g = c == "II" ? d._binLE : d._binBE;
                g.readUshort(a, n), n += 2;
                var f = g.readUint(a, n);
                n += 4;
                for (var p = []; ; ) {
                  var s = d._readIFD(g, a, f, p);
                  if (f = g.readUint(a, s), f == 0) break;
                }
                return p;
              }, d.decodeImages = function(u, a) {
                for (var n = new Uint8Array(u), c = d._binBE.readASCII(n, 0, 2), g = 0; g < a.length; g++) {
                  var f = a[g];
                  if (f.t256 != null) {
                    f.isLE = c == "II", f.width = f.t256[0], f.height = f.t257[0];
                    var p = f.t259 ? f.t259[0] : 1, s = f.t266 ? f.t266[0] : 1;
                    f.t284 && f.t284[0] == 2 && E("PlanarConfiguration 2 should not be used!");
                    var S = (f.t258 ? Math.min(32, f.t258[0]) : 1) * (f.t277 ? f.t277[0] : 1), b = Math.ceil(f.width * S / 8) * 8, o = f.t273;
                    o == null && (o = f.t324);
                    var A = f.t279;
                    p == 1 && o.length == 1 && (A = [f.height * (b >>> 3)]), A == null && (A = f.t325);
                    var T = new Uint8Array(f.height * (b >>> 3)), R = 0;
                    if (f.t322 != null) {
                      for (var L = f.t322[0], z = f.t323[0], U = Math.floor((f.width + L - 1) / L), J = Math.floor((f.height + z - 1) / z), F = new Uint8Array(Math.ceil(L * z * S / 8) | 0), se = 0; se < J; se++)
                        for (var ee = 0; ee < U; ee++) {
                          for (var ie = se * U + ee, W = 0; W < F.length; W++) F[W] = 0;
                          d.decode._decompress(f, n, o[ie], A[ie], p, F, 0, s), p == 6 ? T = F : d._copyTile(F, Math.ceil(L * S / 8) | 0, z, T, Math.ceil(f.width * S / 8) | 0, f.height, Math.ceil(ee * L * S / 8) | 0, se * z);
                        }
                      R = T.length * 8;
                    } else {
                      var Q = f.t278 ? f.t278[0] : f.height;
                      Q = Math.min(Q, f.height);
                      for (var ie = 0; ie < o.length; ie++)
                        d.decode._decompress(f, n, o[ie], A[ie], p, T, Math.ceil(R / 8) | 0, s), R += b * Q;
                      R = Math.min(R, T.length * 8);
                    }
                    f.data = new Uint8Array(T.buffer, 0, Math.ceil(R / 8) | 0);
                  }
                }
              }, d.decode._decompress = function(u, a, n, c, g, f, p, s) {
                if (g == 1) for (var S = 0; S < c; S++) f[p + S] = a[n + S];
                else if (g == 3) d.decode._decodeG3(a, n, c, f, p, u.width, s);
                else if (g == 4) d.decode._decodeG4(a, n, c, f, p, u.width, s);
                else if (g == 5) d.decode._decodeLZW(a, n, f, p);
                else if (g == 6) d.decode._decodeOldJPEG(u, a, n, c, f, p);
                else if (g == 7) d.decode._decodeNewJPEG(u, a, n, c, f, p);
                else if (g == 8)
                  for (var b = new Uint8Array(a.buffer, n, c), o = l.inflate(b), A = 0; A < o.length; A++) f[p + A] = o[A];
                else g == 32773 ? d.decode._decodePackBits(a, n, c, f, p) : g == 32809 ? d.decode._decodeThunder(a, n, c, f, p) : E("Unknown compression", g);
                if (u.t317 && u.t317[0] == 2)
                  for (var T = u.t277 ? u.t277[0] : 1, R = u.t278 ? u.t278[0] : u.height, L = u.width * T, z = 0; z < R; z++) {
                    var U = p + z * L;
                    if (T == 3) for (var S = 3; S < L; S += 3)
                      f[U + S] = f[U + S] + f[U + S - 3] & 255, f[U + S + 1] = f[U + S + 1] + f[U + S - 2] & 255, f[U + S + 2] = f[U + S + 2] + f[U + S - 1] & 255;
                    else for (var S = T; S < L; S++) f[U + S] = f[U + S] + f[U + S - T] & 255;
                  }
              }, d.decode._decodeNikon = function(u, a, s, c, g) {
                var f, p, s;
                E(u.slice(a, a + 100)), f = u[a], a++, p = u[a], a++, E(f.toString(16), p.toString(16), s);
              }, d.decode._decodeNewJPEG = function(u, a, n, c, g, f) {
                var p = u.t347, s = p ? p.length : 0, S = new Uint8Array(s + c);
                if (p) {
                  for (var b = 216, o = 217, A = 0, T = 0; T < s - 1 && !(p[T] == 255 && p[T + 1] == o); T++)
                    S[A++] = p[T];
                  var R = a[n], L = a[n + 1];
                  (R != 255 || L != b) && (S[A++] = R, S[A++] = L);
                  for (var T = 2; T < c; T++) S[A++] = a[n + T];
                } else for (var T = 0; T < c; T++) S[T] = a[n + T];
                if (u.t262 == 32803) {
                  var z = u.t258[0], U = new LosslessJpegDecoder(), J = U.decode(S), F = J.length;
                  if (z == 16) for (var T = 0; T < F; T++)
                    g[f++] = J[T] & 255, g[f++] = J[T] >>> 8;
                  else if (z == 12) for (var T = 0; T < F; T += 2)
                    g[f++] = J[T] >>> 4, g[f++] = (J[T] << 4 | J[T + 1] >>> 8) & 255, g[f++] = J[T + 1] & 255;
                  else throw new Error("unsupported bit depth " + z);
                } else {
                  var se = new d.JpegDecoder();
                  se.parse(S);
                  for (var ee = se.getData(se.width, se.height), T = 0; T < ee.length; T++) g[f + T] = ee[T];
                }
                u.t262[0] == 6 && (u.t262[0] = 2);
              }, d.decode._decodeOldJPEGInit = function(u, a, n, c) {
                var g = 216, f = 219, p = 196, s = 221, S = 192, b = 218, o = 0, A = 0, T, R, L = !1, z, U, J, F = u.t513, se = F ? F[0] : 0, ee = u.t514, ie = ee ? ee[0] : 0, W = u.t324 || u.t273 || F, Q = u.t530, de = 0, _e = 0, ke = u.t277 ? u.t277[0] : 1, Pe = u.t515;
                if (W && (A = W[0], L = W.length > 1), !L) {
                  if (a[n] == 255 && a[n + 1] == g) return { jpegOffset: n };
                  if (F != null && (a[n + se] == 255 && a[n + se + 1] == g ? o = n + se : E("JPEGInterchangeFormat does not point to SOI"), ee == null ? E("JPEGInterchangeFormatLength field is missing") : (se >= A || se + ie <= A) && E("JPEGInterchangeFormatLength field value is invalid"), o != null))
                    return { jpegOffset: o };
                }
                if (Q != null && (de = Q[0], _e = Q[1]), F != null && ee != null)
                  if (ie >= 2 && se + ie <= A) {
                    for (a[n + se + ie - 2] == 255 && a[n + se + ie - 1] == g ? T = new Uint8Array(ie - 2) : T = new Uint8Array(ie), z = 0; z < T.length; z++) T[z] = a[n + se + z];
                    E("Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables");
                  } else E("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");
                if (T == null) {
                  var fe = 0, xe = [];
                  xe[fe++] = 255, xe[fe++] = g;
                  var Ee = u.t519;
                  if (Ee == null) throw new Error("JPEGQTables tag is missing");
                  for (z = 0; z < Ee.length; z++)
                    for (xe[fe++] = 255, xe[fe++] = f, xe[fe++] = 0, xe[fe++] = 67, xe[fe++] = z, U = 0; U < 64; U++) xe[fe++] = a[n + Ee[z] + U];
                  for (J = 0; J < 2; J++) {
                    var Ie = u[J == 0 ? "t520" : "t521"];
                    if (Ie == null) throw new Error((J == 0 ? "JPEGDCTables" : "JPEGACTables") + " tag is missing");
                    for (z = 0; z < Ie.length; z++) {
                      xe[fe++] = 255, xe[fe++] = p;
                      var je = 19;
                      for (U = 0; U < 16; U++) je += a[n + Ie[z] + U];
                      for (xe[fe++] = je >>> 8, xe[fe++] = je & 255, xe[fe++] = z | J << 4, U = 0; U < 16; U++) xe[fe++] = a[n + Ie[z] + U];
                      for (U = 0; U < je; U++) xe[fe++] = a[n + Ie[z] + 16 + U];
                    }
                  }
                  if (xe[fe++] = 255, xe[fe++] = S, xe[fe++] = 0, xe[fe++] = 8 + 3 * ke, xe[fe++] = 8, xe[fe++] = u.height >>> 8 & 255, xe[fe++] = u.height & 255, xe[fe++] = u.width >>> 8 & 255, xe[fe++] = u.width & 255, xe[fe++] = ke, ke == 1)
                    xe[fe++] = 1, xe[fe++] = 17, xe[fe++] = 0;
                  else for (z = 0; z < 3; z++)
                    xe[fe++] = z + 1, xe[fe++] = z != 0 ? 17 : (de & 15) << 4 | _e & 15, xe[fe++] = z;
                  Pe != null && Pe[0] != 0 && (xe[fe++] = 255, xe[fe++] = s, xe[fe++] = 0, xe[fe++] = 4, xe[fe++] = Pe[0] >>> 8 & 255, xe[fe++] = Pe[0] & 255), T = new Uint8Array(xe);
                }
                var Ue = -1;
                for (z = 0; z < T.length - 1; ) {
                  if (T[z] == 255 && T[z + 1] == S) {
                    Ue = z;
                    break;
                  }
                  z++;
                }
                if (Ue == -1) {
                  var He = new Uint8Array(T.length + 10 + 3 * ke);
                  He.set(T);
                  var Ze = T.length;
                  if (Ue = T.length, T = He, T[Ze++] = 255, T[Ze++] = S, T[Ze++] = 0, T[Ze++] = 8 + 3 * ke, T[Ze++] = 8, T[Ze++] = u.height >>> 8 & 255, T[Ze++] = u.height & 255, T[Ze++] = u.width >>> 8 & 255, T[Ze++] = u.width & 255, T[Ze++] = ke, ke == 1)
                    T[Ze++] = 1, T[Ze++] = 17, T[Ze++] = 0;
                  else for (z = 0; z < 3; z++)
                    T[Ze++] = z + 1, T[Ze++] = z != 0 ? 17 : (de & 15) << 4 | _e & 15, T[Ze++] = z;
                }
                if (a[A] == 255 && a[A + 1] == b) {
                  var $e = a[A + 2] << 8 | a[A + 3];
                  for (R = new Uint8Array($e + 2), R[0] = a[A], R[1] = a[A + 1], R[2] = a[A + 2], R[3] = a[A + 3], z = 0; z < $e - 2; z++) R[z + 4] = a[A + z + 4];
                } else {
                  R = new Uint8Array(8 + 2 * ke);
                  var We = 0;
                  if (R[We++] = 255, R[We++] = b, R[We++] = 0, R[We++] = 6 + 2 * ke, R[We++] = ke, ke == 1)
                    R[We++] = 1, R[We++] = 0;
                  else for (z = 0; z < 3; z++)
                    R[We++] = z + 1, R[We++] = z << 4 | z;
                  R[We++] = 0, R[We++] = 63, R[We++] = 0;
                }
                return { jpegOffset: n, tables: T, sosMarker: R, sofPosition: Ue };
              }, d.decode._decodeOldJPEG = function(u, a, n, c, g, f) {
                var p, s, S, b, o = d.decode._decodeOldJPEGInit(u, a, n, c);
                if (o.jpegOffset != null)
                  for (s = n + c - o.jpegOffset, b = new Uint8Array(s), p = 0; p < s; p++) b[p] = a[o.jpegOffset + p];
                else {
                  for (S = o.tables.length, b = new Uint8Array(S + o.sosMarker.length + c + 2), b.set(o.tables), b[o.sofPosition + 5] = u.height >>> 8 & 255, b[o.sofPosition + 6] = u.height & 255, b[o.sofPosition + 7] = u.width >>> 8 & 255, b[o.sofPosition + 8] = u.width & 255, (a[n] != 255 || a[n + 1] != SOS) && (b.set(o.sosMarker, bufoff), bufoff += sosMarker.length), p = 0; p < c; p++) b[bufoff++] = a[n + p];
                  b[bufoff++] = 255, b[bufoff++] = EOI;
                }
                var A = new d.JpegDecoder();
                A.parse(b);
                for (var T = A.getData(A.width, A.height), p = 0; p < T.length; p++) g[f + p] = T[p];
                u.t262[0] == 6 && (u.t262[0] = 2);
              }, d.decode._decodePackBits = function(u, a, n, c, g) {
                for (var f = new Int8Array(u.buffer), p = new Int8Array(c.buffer), s = a + n; a < s; ) {
                  var S = f[a];
                  if (a++, S >= 0 && S < 128) for (var b = 0; b < S + 1; b++)
                    p[g] = f[a], g++, a++;
                  if (S >= -127 && S < 0) {
                    for (var b = 0; b < -S + 1; b++)
                      p[g] = f[a], g++;
                    a++;
                  }
                }
              }, d.decode._decodeThunder = function(u, a, n, c, g) {
                for (var f = [0, 1, 0, -1], p = [0, 1, 2, 3, 0, -3, -2, -1], s = a + n, S = g * 2, b = 0; a < s; ) {
                  var o = u[a], A = o >>> 6, T = o & 63;
                  if (a++, A == 3 && (b = T & 15, c[S >>> 1] |= b << 4 * (1 - S & 1), S++), A == 0) for (var R = 0; R < T; R++)
                    c[S >>> 1] |= b << 4 * (1 - S & 1), S++;
                  if (A == 2) for (var R = 0; R < 2; R++) {
                    var L = T >>> 3 * (1 - R) & 7;
                    L != 4 && (b += p[L], c[S >>> 1] |= b << 4 * (1 - S & 1), S++);
                  }
                  if (A == 1) for (var R = 0; R < 3; R++) {
                    var L = T >>> 2 * (2 - R) & 3;
                    L != 2 && (b += f[L], c[S >>> 1] |= b << 4 * (1 - S & 1), S++);
                  }
                }
              }, d.decode._dmap = { 1: 0, "011": 1, "000011": 2, "0000011": 3, "010": -1, "000010": -2, "0000010": -3 }, d.decode._lens = function() {
                var u = function(S, b, o, A) {
                  for (var T = 0; T < b.length; T++) S[b[T]] = o + T * A;
                }, a = "00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100", n = "0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111", c = "11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011", g = "0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101", f = "00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";
                a = a.split(","), n = n.split(","), c = c.split(","), g = g.split(","), f = f.split(",");
                var p = {}, s = {};
                return u(p, a, 0, 1), u(p, c, 64, 64), u(p, f, 1792, 64), u(s, n, 0, 1), u(s, g, 64, 64), u(s, f, 1792, 64), [p, s];
              }(), d.decode._decodeG4 = function(u, a, n, c, g, f, p) {
                for (var s = d.decode, S = a << 3, b = 0, o = "", A = [], T = [], R = 0; R < f; R++) T.push(0);
                T = s._makeDiff(T);
                for (var L = 0, z = 0, U = 0, J = 0, F = 0, se = 0, ee = "", ie = 0, W = Math.ceil(f / 8) * 8; S >>> 3 < a + n; ) {
                  U = s._findDiff(T, L + (L == 0 ? 0 : 1), 1 - F), J = s._findDiff(T, U, F);
                  var Q = 0;
                  if (p == 1 && (Q = u[S >>> 3] >>> 7 - (S & 7) & 1), p == 2 && (Q = u[S >>> 3] >>> (S & 7) & 1), S++, o += Q, ee == "H") {
                    if (s._lens[F][o] != null) {
                      var de = s._lens[F][o];
                      o = "", b += de, de < 64 && (s._addNtimes(A, b, F), L += b, F = 1 - F, b = 0, ie--, ie == 0 && (ee = ""));
                    }
                  } else
                    o == "0001" && (o = "", s._addNtimes(A, J - L, F), L = J), o == "001" && (o = "", ee = "H", ie = 2), s._dmap[o] != null && (z = U + s._dmap[o], s._addNtimes(A, z - L, F), L = z, o = "", F = 1 - F);
                  A.length == f && ee == "" && (s._writeBits(A, c, g * 8 + se * W), F = 0, se++, L = 0, T = s._makeDiff(A), A = []);
                }
              }, d.decode._findDiff = function(u, a, n) {
                for (var c = 0; c < u.length; c += 2) if (u[c] >= a && u[c + 1] == n) return u[c];
              }, d.decode._makeDiff = function(u) {
                var a = [];
                u[0] == 1 && a.push(0, 1);
                for (var n = 1; n < u.length; n++) u[n - 1] != u[n] && a.push(n, u[n]);
                return a.push(u.length, 0, u.length, 1), a;
              }, d.decode._decodeG3 = function(u, a, n, c, g, f, p) {
                for (var s = d.decode, S = a << 3, b = 0, o = "", A = [], T = [], R = 0; R < f; R++) A.push(0);
                for (var L = 0, z = 0, U = 0, J = 0, F = 0, se = -1, ee = "", ie = 0, W = !1, Q = Math.ceil(f / 8) * 8; S >>> 3 < a + n; ) {
                  U = s._findDiff(T, L + (L == 0 ? 0 : 1), 1 - F), J = s._findDiff(T, U, F);
                  var de = 0;
                  if (p == 1 && (de = u[S >>> 3] >>> 7 - (S & 7) & 1), p == 2 && (de = u[S >>> 3] >>> (S & 7) & 1), S++, o += de, W) {
                    if (s._lens[F][o] != null) {
                      var _e = s._lens[F][o];
                      o = "", b += _e, _e < 64 && (s._addNtimes(A, b, F), F = 1 - F, b = 0);
                    }
                  } else if (ee == "H") {
                    if (s._lens[F][o] != null) {
                      var _e = s._lens[F][o];
                      o = "", b += _e, _e < 64 && (s._addNtimes(A, b, F), L += b, F = 1 - F, b = 0, ie--, ie == 0 && (ee = ""));
                    }
                  } else
                    o == "0001" && (o = "", s._addNtimes(A, J - L, F), L = J), o == "001" && (o = "", ee = "H", ie = 2), s._dmap[o] != null && (z = U + s._dmap[o], s._addNtimes(A, z - L, F), L = z, o = "", F = 1 - F);
                  o.endsWith("000000000001") && (se >= 0 && s._writeBits(A, c, g * 8 + se * Q), p == 1 && (W = (u[S >>> 3] >>> 7 - (S & 7) & 1) == 1), p == 2 && (W = (u[S >>> 3] >>> (S & 7) & 1) == 1), S++, s._decodeG3.allow2D == null && (s._decodeG3.allow2D = W), s._decodeG3.allow2D || (W = !0, S--), o = "", F = 0, se++, L = 0, T = s._makeDiff(A), A = []);
                }
                A.length == f && s._writeBits(A, c, g * 8 + se * Q);
              }, d.decode._addNtimes = function(u, a, n) {
                for (var c = 0; c < a; c++) u.push(n);
              }, d.decode._writeBits = function(u, a, n) {
                for (var c = 0; c < u.length; c++) a[n + c >>> 3] |= u[c] << 7 - (n + c & 7);
              }, d.decode._decodeLZW = function(u, a, n, c) {
                if (d.decode._lzwTab == null) {
                  for (var g = new Uint32Array(65535), f = new Uint16Array(65535), o = new Uint8Array(2e6), p = 0; p < 256; p++)
                    o[p << 2] = p, g[p] = p << 2, f[p] = 1;
                  d.decode._lzwTab = [g, f, o];
                }
                for (var s = d.decode._copyData, S = d.decode._lzwTab[0], b = d.decode._lzwTab[1], o = d.decode._lzwTab[2], A = 258, T = 1032, R = 9, L = a << 3, z = 256, U = 257, J = 0, F = 0, se = 0; J = u[L >>> 3] << 16 | u[L + 8 >>> 3] << 8 | u[L + 16 >>> 3], F = J >> 24 - (L & 7) - R & (1 << R) - 1, L += R, F != U; ) {
                  if (F == z) {
                    if (R = 9, A = 258, T = 1032, J = u[L >>> 3] << 16 | u[L + 8 >>> 3] << 8 | u[L + 16 >>> 3], F = J >> 24 - (L & 7) - R & (1 << R) - 1, L += R, F == U) break;
                    n[c] = F, c++;
                  } else if (F < A) {
                    var ee = S[F], ie = b[F];
                    if (s(o, ee, n, c, ie), c += ie, se >= A)
                      S[A] = T, o[S[A]] = ee[0], b[A] = 1, T = T + 1 + 3 & -4, A++;
                    else {
                      S[A] = T;
                      var W = S[se], Q = b[se];
                      s(o, W, o, T, Q), o[T + Q] = o[ee], Q++, b[A] = Q, A++, T = T + Q + 3 & -4;
                    }
                    A + 1 == 1 << R && R++;
                  } else {
                    if (se >= A)
                      S[A] = T, b[A] = 0, A++;
                    else {
                      S[A] = T;
                      var W = S[se], Q = b[se];
                      s(o, W, o, T, Q), o[T + Q] = o[T], Q++, b[A] = Q, A++, s(o, T, n, c, Q), c += Q, T = T + Q + 3 & -4;
                    }
                    A + 1 == 1 << R && R++;
                  }
                  se = F;
                }
              }, d.decode._copyData = function(u, a, n, c, g) {
                for (var f = 0; f < g; f += 4)
                  n[c + f] = u[a + f], n[c + f + 1] = u[a + f + 1], n[c + f + 2] = u[a + f + 2], n[c + f + 3] = u[a + f + 3];
              }, d.tags = {
                254: "NewSubfileType",
                255: "SubfileType",
                256: "ImageWidth",
                257: "ImageLength",
                258: "BitsPerSample",
                259: "Compression",
                262: "PhotometricInterpretation",
                266: "FillOrder",
                269: "DocumentName",
                270: "ImageDescription",
                271: "Make",
                272: "Model",
                273: "StripOffset",
                274: "Orientation",
                277: "SamplesPerPixel",
                278: "RowsPerStrip",
                279: "StripByteCounts",
                280: "MinSampleValue",
                281: "MaxSampleValue",
                282: "XResolution",
                283: "YResolution",
                284: "PlanarConfiguration",
                285: "PageName",
                286: "XPosition",
                287: "YPosition",
                292: "T4Options",
                296: "ResolutionUnit",
                297: "PageNumber",
                305: "Software",
                306: "DateTime",
                315: "Artist",
                316: "HostComputer",
                317: "Predictor",
                318: "WhitePoint",
                319: "PrimaryChromaticities",
                320: "ColorMap",
                321: "HalftoneHints",
                322: "TileWidth",
                323: "TileLength",
                324: "TileOffset",
                325: "TileByteCounts",
                330: "SubIFDs",
                336: "DotRange",
                338: "ExtraSample",
                339: "SampleFormat",
                347: "JPEGTables",
                512: "JPEGProc",
                513: "JPEGInterchangeFormat",
                514: "JPEGInterchangeFormatLength",
                519: "JPEGQTables",
                520: "JPEGDCTables",
                521: "JPEGACTables",
                529: "YCbCrCoefficients",
                530: "YCbCrSubSampling",
                531: "YCbCrPositioning",
                532: "ReferenceBlackWhite",
                700: "XMP",
                33421: "CFARepeatPatternDim",
                33422: "CFAPattern",
                33432: "Copyright",
                33434: "ExposureTime",
                33437: "FNumber",
                33723: "IPTC/NAA",
                34377: "Photoshop",
                34665: "ExifIFD",
                34675: "ICC Profile",
                34850: "ExposureProgram",
                34853: "GPSInfo",
                34855: "ISOSpeedRatings",
                34858: "TimeZoneOffset",
                34859: "SelfTimeMode",
                36867: "DateTimeOriginal",
                36868: "DateTimeDigitized",
                37377: "ShutterSpeedValue",
                37378: "ApertureValue",
                37380: "ExposureBiasValue",
                37383: "MeteringMode",
                37385: "Flash",
                37386: "FocalLength",
                37390: "FocalPlaneXResolution",
                37391: "FocalPlaneYResolution",
                37392: "FocalPlaneResolutionUnit",
                37393: "ImageNumber",
                37398: "TIFF/EPStandardID",
                37399: "SensingMethod",
                37500: "MakerNote",
                37510: "UserComment",
                37724: "ImageSourceData",
                40092: "XPComment",
                40094: "XPKeywords",
                40961: "ColorSpace",
                40962: "PixelXDimension",
                40963: "PixelXDimension",
                41486: "FocalPlaneXResolution",
                41487: "FocalPlaneYResolution",
                41488: "FocalPlaneResolutionUnit",
                41985: "CustomRendered",
                41986: "ExposureMode",
                41987: "WhiteBalance",
                41990: "SceneCaptureType",
                50706: "DNGVersion",
                50707: "DNGBackwardVersion",
                50708: "UniqueCameraModel",
                50709: "LocalizedCameraModel",
                50710: "CFAPlaneColor",
                50711: "CFALayout",
                50712: "LinearizationTable",
                50713: "BlackLevelRepeatDim",
                50714: "BlackLevel",
                50716: "BlackLevelDeltaV",
                50717: "WhiteLevel",
                50718: "DefaultScale",
                50719: "DefaultCropOrigin",
                50720: "DefaultCropSize",
                50733: "BayerGreenSplit",
                50738: "AntiAliasStrength",
                50721: "ColorMatrix1",
                50722: "ColorMatrix2",
                50723: "CameraCalibration1",
                50724: "CameraCalibration2",
                50727: "AnalogBalance",
                50728: "AsShotNeutral",
                50730: "BaselineExposure",
                50731: "BaselineNoise",
                50732: "BaselineSharpness",
                50734: "LinearResponseLimit",
                50735: "CameraSerialNumber",
                50736: "LensInfo",
                50739: "ShadowScale",
                50740: "DNGPrivateData",
                50741: "MakerNoteSafety",
                50778: "CalibrationIlluminant1",
                50779: "CalibrationIlluminant2",
                50780: "BestQualityScale",
                50781: "RawDataUniqueID",
                50827: "OriginalRawFileName",
                50829: "ActiveArea",
                50830: "MaskedAreas",
                50931: "CameraCalibrationSignature",
                50932: "ProfileCalibrationSignature",
                50935: "NoiseReductionApplied",
                50936: "ProfileName",
                50937: "ProfileHueSatMapDims",
                50938: "ProfileHueSatMapData1",
                50939: "ProfileHueSatMapData2",
                50940: "ProfileToneCurve",
                50941: "ProfileEmbedPolicy",
                50942: "ProfileCopyright",
                50964: "ForwardMatrix1",
                50965: "ForwardMatrix2",
                50966: "PreviewApplicationName",
                50967: "PreviewApplicationVersion",
                50969: "PreviewSettingsDigest",
                50970: "PreviewColorSpace",
                50971: "PreviewDateTime",
                50972: "RawImageDigest",
                51008: "OpcodeList1",
                51009: "OpcodeList2",
                51022: "OpcodeList3",
                51041: "NoiseProfile",
                51089: "OriginalDefaultFinalSize",
                51090: "OriginalBestQualityFinalSize",
                51091: "OriginalDefaultCropSize",
                51125: "DefaultUserCrop"
              }, d.ttypes = { 256: 3, 257: 3, 258: 3, 259: 3, 262: 3, 273: 4, 274: 3, 277: 3, 278: 4, 279: 4, 282: 5, 283: 5, 284: 3, 286: 5, 287: 5, 296: 3, 305: 2, 306: 2, 338: 3, 513: 4, 514: 4, 34665: 4 }, d._readIFD = function(u, a, n, c) {
                var g = u.readUshort(a, n);
                n += 2;
                var f = {};
                c.push(f);
                for (var p = 0; p < g; p++) {
                  var s = u.readUshort(a, n);
                  n += 2;
                  var S = u.readUshort(a, n);
                  n += 2;
                  var b = u.readUint(a, n);
                  n += 4;
                  var o = u.readUint(a, n);
                  n += 4;
                  var A = [];
                  if (f["t" + s] = A, S == 1 || S == 7)
                    for (var T = 0; T < b; T++) A.push(a[(b < 5 ? n - 4 : o) + T]);
                  if (S == 2 && A.push(u.readASCII(a, b < 5 ? n - 4 : o, b - 1)), S == 3)
                    for (var T = 0; T < b; T++) A.push(u.readUshort(a, (b < 3 ? n - 4 : o) + 2 * T));
                  if (S == 4)
                    for (var T = 0; T < b; T++) A.push(u.readUint(a, (b < 2 ? n - 4 : o) + 4 * T));
                  if (S == 5)
                    for (var T = 0; T < b; T++) A.push(u.readUint(a, o + T * 8) / u.readUint(a, o + T * 8 + 4));
                  if (S == 8)
                    for (var T = 0; T < b; T++) A.push(u.readShort(a, (b < 3 ? n - 4 : o) + 2 * T));
                  if (S == 9)
                    for (var T = 0; T < b; T++) A.push(u.readInt(a, (b < 2 ? n - 4 : o) + 4 * T));
                  if (S == 10)
                    for (var T = 0; T < b; T++) A.push(u.readInt(a, o + T * 8) / u.readInt(a, o + T * 8 + 4));
                  if (S == 11)
                    for (var T = 0; T < b; T++) A.push(u.readFloat(a, o + T * 4));
                  if (S == 12)
                    for (var T = 0; T < b; T++) A.push(u.readDouble(a, o + T * 8));
                  if (b != 0 && A.length == 0 && E("unknown TIFF tag type: ", S, "num:", b), s == 330) for (var T = 0; T < b; T++) d._readIFD(u, a, A[T], c);
                }
                return n;
              }, d._writeIFD = function(u, a, n, c) {
                var g = Object.keys(c);
                u.writeUshort(a, n, g.length), n += 2;
                for (var f = n + g.length * 12 + 4, p = 0; p < g.length; p++) {
                  var s = g[p], S = parseInt(s.slice(1)), b = d.ttypes[S];
                  if (b == null) throw new Error("unknown type of tag: " + S);
                  var o = c[s];
                  b == 2 && (o = o[0] + "\0");
                  var A = o.length;
                  u.writeUshort(a, n, S), n += 2, u.writeUshort(a, n, b), n += 2, u.writeUint(a, n, A), n += 4;
                  var T = [-1, 1, 1, 2, 4, 8, 0, 0, 0, 0, 0, 0, 8][b] * A, R = n;
                  if (T > 4 && (u.writeUint(a, n, f), R = f), b == 2 && u.writeASCII(a, R, o), b == 3)
                    for (var L = 0; L < A; L++) u.writeUshort(a, R + 2 * L, o[L]);
                  if (b == 4)
                    for (var L = 0; L < A; L++) u.writeUint(a, R + 4 * L, o[L]);
                  if (b == 5)
                    for (var L = 0; L < A; L++)
                      u.writeUint(a, R + 8 * L, Math.round(o[L] * 1e4)), u.writeUint(a, R + 8 * L + 4, 1e4);
                  if (b == 12)
                    for (var L = 0; L < A; L++) u.writeDouble(a, R + 8 * L, o[L]);
                  T > 4 && (T += T & 1, f += T), n += 4;
                }
                return [n, f];
              }, d.toRGBA8 = function(u) {
                var a = u.width, n = u.height, c = a * n, g = c * 4, f = u.data, p = new Uint8Array(c * 4), s = u.t262[0], S = u.t258 ? Math.min(32, u.t258[0]) : 1, b = u.isLE ? 1 : 0;
                if (s == 0)
                  for (var o = Math.ceil(S * a / 8), A = 0; A < n; A++) {
                    var T = A * o, R = A * a;
                    if (S == 1) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + (L >> 3)] >> 7 - (L & 7) & 1;
                      p[z] = p[z + 1] = p[z + 2] = (1 - U) * 255, p[z + 3] = 255;
                    }
                    if (S == 4) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + (L >> 1)] >> 4 - 4 * (L & 1) & 15;
                      p[z] = p[z + 1] = p[z + 2] = (15 - U) * 17, p[z + 3] = 255;
                    }
                    if (S == 8) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + L];
                      p[z] = p[z + 1] = p[z + 2] = 255 - U, p[z + 3] = 255;
                    }
                  }
                else if (s == 1)
                  for (var o = Math.ceil(S * a / 8), A = 0; A < n; A++) {
                    var T = A * o, R = A * a;
                    if (S == 1) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + (L >> 3)] >> 7 - (L & 7) & 1;
                      p[z] = p[z + 1] = p[z + 2] = U * 255, p[z + 3] = 255;
                    }
                    if (S == 2) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + (L >> 2)] >> 6 - 2 * (L & 3) & 3;
                      p[z] = p[z + 1] = p[z + 2] = U * 85, p[z + 3] = 255;
                    }
                    if (S == 8) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + L];
                      p[z] = p[z + 1] = p[z + 2] = U, p[z + 3] = 255;
                    }
                    if (S == 16) for (var L = 0; L < a; L++) {
                      var z = R + L << 2, U = f[T + (2 * L + b)];
                      p[z] = p[z + 1] = p[z + 2] = Math.min(255, U), p[z + 3] = 255;
                    }
                  }
                else if (s == 2)
                  if (S == 8)
                    if (u.t338)
                      if (u.t338[0] > 0) for (var L = 0; L < g; L++) p[L] = f[L];
                      else for (var L = 0; L < g; L += 4)
                        p[L] = f[L], p[L + 1] = f[L + 1], p[L + 2] = f[L + 2], p[L + 3] = 255;
                    else {
                      var J = u.t258 ? u.t258.length : 3;
                      if (J == 4) for (var L = 0; L < g; L++) p[L] = f[L];
                      if (J == 3) for (var L = 0; L < c; L++) {
                        var z = L << 2, F = L * 3;
                        p[z] = f[F], p[z + 1] = f[F + 1], p[z + 2] = f[F + 2], p[z + 3] = 255;
                      }
                    }
                  else
                    for (var L = 0; L < c; L++) {
                      var z = L << 2, F = L * 6;
                      p[z] = f[F], p[z + 1] = f[F + 2], p[z + 2] = f[F + 4], p[z + 3] = 255;
                    }
                else if (s == 3)
                  for (var se = u.t320, L = 0; L < c; L++) {
                    var z = L << 2, ee = f[L];
                    p[z] = se[ee] >> 8, p[z + 1] = se[256 + ee] >> 8, p[z + 2] = se[512 + ee] >> 8, p[z + 3] = 255;
                  }
                else if (s == 5)
                  for (var J = u.t258 ? u.t258.length : 4, ie = J > 4 ? 1 : 0, L = 0; L < c; L++) {
                    var z = L << 2, W = L * J, Q = 255 - f[W], de = 255 - f[W + 1], _e = 255 - f[W + 2], ke = (255 - f[W + 3]) * (1 / 255);
                    p[z] = ~~(Q * ke + 0.5), p[z + 1] = ~~(de * ke + 0.5), p[z + 2] = ~~(_e * ke + 0.5), p[z + 3] = 255 * (1 - ie) + f[W + 4] * ie;
                  }
                else E("Unknown Photometric interpretation: " + s);
                return p;
              }, d.replaceIMG = function() {
                for (var u = document.getElementsByTagName("img"), a = 0; a < u.length; a++) {
                  var n = u[a], c = n.getAttribute("src");
                  if (c != null) {
                    var g = c.split(".").pop().toLowerCase();
                    if (!(g != "tif" && g != "tiff")) {
                      var f = new XMLHttpRequest();
                      d._xhrs.push(f), d._imgs.push(n), f.open("GET", c), f.responseType = "arraybuffer", f.onload = d._imgLoaded, f.send();
                    }
                  }
                }
              }, d._xhrs = [], d._imgs = [], d._imgLoaded = function(u) {
                var a = u.target.response, n = d.decode(a), c = n[0];
                d.decodeImages(a, n);
                var g = d.toRGBA8(c), f = c.width, p = c.height, s = d._xhrs.indexOf(u.target), S = d._imgs[s];
                d._xhrs.splice(s, 1), d._imgs.splice(s, 1);
                var b = document.createElement("canvas");
                b.width = f, b.height = p;
                for (var o = b.getContext("2d"), A = o.createImageData(f, p), T = 0; T < g.length; T++) A.data[T] = g[T];
                o.putImageData(A, 0, 0);
                for (var R = ["style", "class", "id"], T = 0; T < R.length; T++) b.setAttribute(R[T], S.getAttribute(R[T]));
                S.parentNode.replaceChild(b, S);
              }, d._binBE = {
                nextZero: function(u, a) {
                  for (; u[a] != 0; ) a++;
                  return a;
                },
                readUshort: function(u, a) {
                  return u[a] << 8 | u[a + 1];
                },
                readShort: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 1], n[1] = u[a + 0], d._binBE.i16[0];
                },
                readInt: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 3], n[1] = u[a + 2], n[2] = u[a + 1], n[3] = u[a + 0], d._binBE.i32[0];
                },
                readUint: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 3], n[1] = u[a + 2], n[2] = u[a + 1], n[3] = u[a + 0], d._binBE.ui32[0];
                },
                readASCII: function(u, a, n) {
                  for (var c = "", g = 0; g < n; g++) c += String.fromCharCode(u[a + g]);
                  return c;
                },
                readFloat: function(u, a) {
                  for (var n = d._binBE.ui8, c = 0; c < 4; c++) n[c] = u[a + 3 - c];
                  return d._binBE.fl32[0];
                },
                readDouble: function(u, a) {
                  for (var n = d._binBE.ui8, c = 0; c < 8; c++) n[c] = u[a + 7 - c];
                  return d._binBE.fl64[0];
                },
                writeUshort: function(u, a, n) {
                  u[a] = n >> 8 & 255, u[a + 1] = n & 255;
                },
                writeUint: function(u, a, n) {
                  u[a] = n >> 24 & 255, u[a + 1] = n >> 16 & 255, u[a + 2] = n >> 8 & 255, u[a + 3] = n >> 0 & 255;
                },
                writeASCII: function(u, a, n) {
                  for (var c = 0; c < n.length; c++) u[a + c] = n.charCodeAt(c);
                },
                writeDouble: function(u, a, n) {
                  d._binBE.fl64[0] = n;
                  for (var c = 0; c < 8; c++) u[a + c] = d._binBE.ui8[7 - c];
                }
              }, d._binBE.ui8 = new Uint8Array(8), d._binBE.i16 = new Int16Array(d._binBE.ui8.buffer), d._binBE.i32 = new Int32Array(d._binBE.ui8.buffer), d._binBE.ui32 = new Uint32Array(d._binBE.ui8.buffer), d._binBE.fl32 = new Float32Array(d._binBE.ui8.buffer), d._binBE.fl64 = new Float64Array(d._binBE.ui8.buffer), d._binLE = {
                nextZero: d._binBE.nextZero,
                readUshort: function(u, a) {
                  return u[a + 1] << 8 | u[a];
                },
                readShort: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 0], n[1] = u[a + 1], d._binBE.i16[0];
                },
                readInt: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 0], n[1] = u[a + 1], n[2] = u[a + 2], n[3] = u[a + 3], d._binBE.i32[0];
                },
                readUint: function(u, a) {
                  var n = d._binBE.ui8;
                  return n[0] = u[a + 0], n[1] = u[a + 1], n[2] = u[a + 2], n[3] = u[a + 3], d._binBE.ui32[0];
                },
                readASCII: d._binBE.readASCII,
                readFloat: function(u, a) {
                  for (var n = d._binBE.ui8, c = 0; c < 4; c++) n[c] = u[a + c];
                  return d._binBE.fl32[0];
                },
                readDouble: function(u, a) {
                  for (var n = d._binBE.ui8, c = 0; c < 8; c++) n[c] = u[a + c];
                  return d._binBE.fl64[0];
                }
              }, d._copyTile = function(u, a, n, c, g, f, p, s) {
                for (var S = Math.min(a, g - p), b = Math.min(n, f - s), o = 0; o < b; o++)
                  for (var A = (s + o) * g + p, T = o * a, R = 0; R < S; R++) c[A + R] = u[T + R];
              };
            })(x, y);
          })();
        }).call(this, C("_process"));
      }, { _process: 133, pako: 86 }], 183: [function(C, Z, _) {
        (function(P) {
          Z.exports = x;
          function x(E, d) {
            if (y("noDeprecation"))
              return E;
            var l = !1;
            function u() {
              if (!l) {
                if (y("throwDeprecation"))
                  throw new Error(d);
                y("traceDeprecation") ? console.trace(d) : console.warn(d), l = !0;
              }
              return E.apply(this, arguments);
            }
            return u;
          }
          function y(E) {
            try {
              if (!P.localStorage) return !1;
            } catch {
              return !1;
            }
            var d = P.localStorage[E];
            return d == null ? !1 : String(d).toLowerCase() === "true";
          }
        }).call(this, typeof dr < "u" ? dr : typeof self < "u" ? self : typeof ne < "u" ? ne : {});
      }, {}], 184: [function(C, Z, _) {
        arguments[4][26][0].apply(_, arguments);
      }, { dup: 26 }], 185: [function(C, Z, _) {
        arguments[4][27][0].apply(_, arguments);
      }, { dup: 27 }], 186: [function(C, Z, _) {
        arguments[4][28][0].apply(_, arguments);
      }, { "./support/isBuffer": 185, _process: 133, dup: 28, inherits: 184 }], 187: [function(C, Z, _) {
        var P = C("global/window"), x = C("is-function"), y = C("parse-headers"), E = C("xtend");
        Z.exports = a, Z.exports.default = a, a.XMLHttpRequest = P.XMLHttpRequest || g, a.XDomainRequest = "withCredentials" in new a.XMLHttpRequest() ? a.XMLHttpRequest : P.XDomainRequest, d(["get", "put", "post", "patch", "head", "delete"], function(f) {
          a[f === "delete" ? "del" : f] = function(p, s, S) {
            return s = u(p, s, S), s.method = f.toUpperCase(), n(s);
          };
        });
        function d(f, p) {
          for (var s = 0; s < f.length; s++)
            p(f[s]);
        }
        function l(f) {
          for (var p in f)
            if (f.hasOwnProperty(p)) return !1;
          return !0;
        }
        function u(f, p, s) {
          var S = f;
          return x(p) ? (s = p, typeof f == "string" && (S = { uri: f })) : S = E(p, { uri: f }), S.callback = s, S;
        }
        function a(f, p, s) {
          return p = u(f, p, s), n(p);
        }
        function n(f) {
          if (typeof f.callback > "u")
            throw new Error("callback argument missing");
          var p = !1, s = function(de, _e, ke) {
            p || (p = !0, f.callback(de, _e, ke));
          };
          function S() {
            T.readyState === 4 && setTimeout(A, 0);
          }
          function b() {
            var Q = void 0;
            if (T.response ? Q = T.response : Q = T.responseText || c(T), ee)
              try {
                Q = JSON.parse(Q);
              } catch {
              }
            return Q;
          }
          function o(Q) {
            return clearTimeout(ie), Q instanceof Error || (Q = new Error("" + (Q || "Unknown XMLHttpRequest Error"))), Q.statusCode = 0, s(Q, W);
          }
          function A() {
            if (!L) {
              var Q;
              clearTimeout(ie), f.useXDR && T.status === void 0 ? Q = 200 : Q = T.status === 1223 ? 204 : T.status;
              var de = W, _e = null;
              return Q !== 0 ? (de = {
                body: b(),
                statusCode: Q,
                method: U,
                headers: {},
                url: z,
                rawRequest: T
              }, T.getAllResponseHeaders && (de.headers = y(T.getAllResponseHeaders()))) : _e = new Error("Internal XMLHttpRequest Error"), s(_e, de, de.body);
            }
          }
          var T = f.xhr || null;
          T || (f.cors || f.useXDR ? T = new a.XDomainRequest() : T = new a.XMLHttpRequest());
          var R, L, z = T.url = f.uri || f.url, U = T.method = f.method || "GET", J = f.body || f.data, F = T.headers = f.headers || {}, se = !!f.sync, ee = !1, ie, W = {
            body: void 0,
            headers: {},
            statusCode: 0,
            method: U,
            url: z,
            rawRequest: T
          };
          if ("json" in f && f.json !== !1 && (ee = !0, F.accept || F.Accept || (F.Accept = "application/json"), U !== "GET" && U !== "HEAD" && (F["content-type"] || F["Content-Type"] || (F["Content-Type"] = "application/json"), J = JSON.stringify(f.json === !0 ? J : f.json))), T.onreadystatechange = S, T.onload = A, T.onerror = o, T.onprogress = function() {
          }, T.onabort = function() {
            L = !0;
          }, T.ontimeout = o, T.open(U, z, !se, f.username, f.password), se || (T.withCredentials = !!f.withCredentials), !se && f.timeout > 0 && (ie = setTimeout(function() {
            if (!L) {
              L = !0, T.abort("timeout");
              var Q = new Error("XMLHttpRequest timeout");
              Q.code = "ETIMEDOUT", o(Q);
            }
          }, f.timeout)), T.setRequestHeader)
            for (R in F)
              F.hasOwnProperty(R) && T.setRequestHeader(R, F[R]);
          else if (f.headers && !l(f.headers))
            throw new Error("Headers cannot be set on an XDomainRequest object");
          return "responseType" in f && (T.responseType = f.responseType), "beforeSend" in f && typeof f.beforeSend == "function" && f.beforeSend(T), T.send(J || null), T;
        }
        function c(f) {
          try {
            if (f.responseType === "document")
              return f.responseXML;
            var p = f.responseXML && f.responseXML.documentElement.nodeName === "parsererror";
            if (f.responseType === "" && !p)
              return f.responseXML;
          } catch {
          }
          return null;
        }
        function g() {
        }
      }, { "global/window": 71, "is-function": 78, "parse-headers": 106, xtend: 189 }], 188: [function(C, Z, _) {
        Z.exports = function() {
          return typeof self.DOMParser < "u" ? function(x) {
            var y = new self.DOMParser();
            return y.parseFromString(x, "application/xml");
          } : typeof self.ActiveXObject < "u" && new self.ActiveXObject("Microsoft.XMLDOM") ? function(x) {
            var y = new self.ActiveXObject("Microsoft.XMLDOM");
            return y.async = "false", y.loadXML(x), y;
          } : function(x) {
            var y = document.createElement("div");
            return y.innerHTML = x, y;
          };
        }();
      }, {}], 189: [function(C, Z, _) {
        Z.exports = x;
        var P = Object.prototype.hasOwnProperty;
        function x() {
          for (var y = {}, E = 0; E < arguments.length; E++) {
            var d = arguments[E];
            for (var l in d)
              P.call(d, l) && (y[l] = d[l]);
          }
          return y;
        }
      }, {}], 190: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.srcOver = P, _.dstOver = x, _.multiply = y, _.add = E, _.screen = d, _.overlay = l, _.darken = u, _.lighten = a, _.hardLight = n, _.difference = c, _.exclusion = g;
        function P(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = (f.r * f.a + p.r * p.a * (1 - f.a)) / S, o = (f.g * f.a + p.g * p.a * (1 - f.a)) / S, A = (f.b * f.a + p.b * p.a * (1 - f.a)) / S;
          return {
            r: b,
            g: o,
            b: A,
            a: S
          };
        }
        function x(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = (p.r * p.a + f.r * f.a * (1 - p.a)) / S, o = (p.g * p.a + f.g * f.a * (1 - p.a)) / S, A = (p.b * p.a + f.b * f.a * (1 - p.a)) / S;
          return {
            r: b,
            g: o,
            b: A,
            a: S
          };
        }
        function y(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (b * T + b * (1 - p.a) + T * (1 - f.a)) / S, U = (o * R + o * (1 - p.a) + R * (1 - f.a)) / S, J = (A * L + A * (1 - p.a) + L * (1 - f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function E(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (b + T) / S, U = (o + R) / S, J = (A + L) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function d(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (b * p.a + T * f.a - b * T + b * (1 - p.a) + T * (1 - f.a)) / S, U = (o * p.a + R * f.a - o * R + o * (1 - p.a) + R * (1 - f.a)) / S, J = (A * p.a + L * f.a - A * L + A * (1 - p.a) + L * (1 - f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function l(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (2 * T <= p.a ? 2 * b * T + b * (1 - p.a) + T * (1 - f.a) : b * (1 + p.a) + T * (1 + f.a) - 2 * T * b - p.a * f.a) / S, U = (2 * R <= p.a ? 2 * o * R + o * (1 - p.a) + R * (1 - f.a) : o * (1 + p.a) + R * (1 + f.a) - 2 * R * o - p.a * f.a) / S, J = (2 * L <= p.a ? 2 * A * L + A * (1 - p.a) + L * (1 - f.a) : A * (1 + p.a) + L * (1 + f.a) - 2 * L * A - p.a * f.a) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function u(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (Math.min(b * p.a, T * f.a) + b * (1 - p.a) + T * (1 - f.a)) / S, U = (Math.min(o * p.a, R * f.a) + o * (1 - p.a) + R * (1 - f.a)) / S, J = (Math.min(A * p.a, L * f.a) + A * (1 - p.a) + L * (1 - f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function a(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (Math.max(b * p.a, T * f.a) + b * (1 - p.a) + T * (1 - f.a)) / S, U = (Math.max(o * p.a, R * f.a) + o * (1 - p.a) + R * (1 - f.a)) / S, J = (Math.max(A * p.a, L * f.a) + A * (1 - p.a) + L * (1 - f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function n(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (2 * b <= f.a ? 2 * b * T + b * (1 - p.a) + T * (1 - f.a) : b * (1 + p.a) + T * (1 + f.a) - 2 * T * b - p.a * f.a) / S, U = (2 * o <= f.a ? 2 * o * R + o * (1 - p.a) + R * (1 - f.a) : o * (1 + p.a) + R * (1 + f.a) - 2 * R * o - p.a * f.a) / S, J = (2 * A <= f.a ? 2 * A * L + A * (1 - p.a) + L * (1 - f.a) : A * (1 + p.a) + L * (1 + f.a) - 2 * L * A - p.a * f.a) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function c(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (b + T - 2 * Math.min(b * p.a, T * f.a)) / S, U = (o + R - 2 * Math.min(o * p.a, R * f.a)) / S, J = (A + L - 2 * Math.min(A * p.a, L * f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
        function g(f, p) {
          var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
          f.a *= s;
          var S = p.a + f.a - p.a * f.a, b = f.r * f.a, o = f.g * f.a, A = f.b * f.a, T = p.r * p.a, R = p.g * p.a, L = p.b * p.a, z = (b * p.a + T * f.a - 2 * b * T + b * (1 - p.a) + T * (1 - f.a)) / S, U = (o * p.a + R * f.a - 2 * o * R + o * (1 - p.a) + R * (1 - f.a)) / S, J = (A * p.a + L * f.a - 2 * A * L + A * (1 - p.a) + L * (1 - f.a)) / S;
          return {
            r: z,
            g: U,
            b: J,
            a: S
          };
        }
      }, {}], 191: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireWildcard");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = d;
        var x = C("@jimp/utils"), y = P(C("../constants")), E = P(C("./composite-modes"));
        function d(l, u, a) {
          var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, c = arguments.length > 4 ? arguments[4] : void 0;
          if (typeof n == "function" && (c = n, n = {}), !(l instanceof this.constructor))
            return x.throwError.call(this, "The source must be a Jimp image", c);
          if (typeof u != "number" || typeof a != "number")
            return x.throwError.call(this, "x and y must be numbers", c);
          var g = n, f = g.mode, p = g.opacitySource, s = g.opacityDest;
          f || (f = y.BLEND_SOURCE_OVER), (typeof p != "number" || p < 0 || p > 1) && (p = 1), (typeof s != "number" || s < 0 || s > 1) && (s = 1);
          var S = E[f];
          u = Math.round(u), a = Math.round(a);
          var b = this;
          return s !== 1 && b.opacity(s), l.scanQuiet(0, 0, l.bitmap.width, l.bitmap.height, function(o, A, T) {
            var R = b.getPixelIndex(u + o, a + A, y.EDGE_CROP), L = S({
              r: this.bitmap.data[T + 0] / 255,
              g: this.bitmap.data[T + 1] / 255,
              b: this.bitmap.data[T + 2] / 255,
              a: this.bitmap.data[T + 3] / 255
            }, {
              r: b.bitmap.data[R + 0] / 255,
              g: b.bitmap.data[R + 1] / 255,
              b: b.bitmap.data[R + 2] / 255,
              a: b.bitmap.data[R + 3] / 255
            }, p);
            b.bitmap.data[R + 0] = this.constructor.limit255(L.r * 255), b.bitmap.data[R + 1] = this.constructor.limit255(L.g * 255), b.bitmap.data[R + 2] = this.constructor.limit255(L.b * 255), b.bitmap.data[R + 3] = this.constructor.limit255(L.a * 255);
          }), (0, x.isNodePattern)(c) && c.call(this, null, this), this;
        }
        Z.exports = _.default;
      }, { "../constants": 192, "./composite-modes": 190, "@babel/runtime/helpers/interopRequireWildcard": 12, "@jimp/utils": 235 }], 192: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.EDGE_CROP = _.EDGE_WRAP = _.EDGE_EXTEND = _.BLEND_EXCLUSION = _.BLEND_DIFFERENCE = _.BLEND_HARDLIGHT = _.BLEND_LIGHTEN = _.BLEND_DARKEN = _.BLEND_OVERLAY = _.BLEND_SCREEN = _.BLEND_ADD = _.BLEND_MULTIPLY = _.BLEND_DESTINATION_OVER = _.BLEND_SOURCE_OVER = _.VERTICAL_ALIGN_BOTTOM = _.VERTICAL_ALIGN_MIDDLE = _.VERTICAL_ALIGN_TOP = _.HORIZONTAL_ALIGN_RIGHT = _.HORIZONTAL_ALIGN_CENTER = _.HORIZONTAL_ALIGN_LEFT = _.AUTO = void 0;
        var P = -1;
        _.AUTO = P;
        var x = 1;
        _.HORIZONTAL_ALIGN_LEFT = x;
        var y = 2;
        _.HORIZONTAL_ALIGN_CENTER = y;
        var E = 4;
        _.HORIZONTAL_ALIGN_RIGHT = E;
        var d = 8;
        _.VERTICAL_ALIGN_TOP = d;
        var l = 16;
        _.VERTICAL_ALIGN_MIDDLE = l;
        var u = 32;
        _.VERTICAL_ALIGN_BOTTOM = u;
        var a = "srcOver";
        _.BLEND_SOURCE_OVER = a;
        var n = "dstOver";
        _.BLEND_DESTINATION_OVER = n;
        var c = "multiply";
        _.BLEND_MULTIPLY = c;
        var g = "add";
        _.BLEND_ADD = g;
        var f = "screen";
        _.BLEND_SCREEN = f;
        var p = "overlay";
        _.BLEND_OVERLAY = p;
        var s = "darken";
        _.BLEND_DARKEN = s;
        var S = "lighten";
        _.BLEND_LIGHTEN = S;
        var b = "hardLight";
        _.BLEND_HARDLIGHT = b;
        var o = "difference";
        _.BLEND_DIFFERENCE = o;
        var A = "exclusion";
        _.BLEND_EXCLUSION = A;
        var T = 1;
        _.EDGE_EXTEND = T;
        var R = 2;
        _.EDGE_WRAP = R;
        var L = 3;
        _.EDGE_CROP = L;
      }, {}], 193: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireWildcard"), y = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.addConstants = Ze, _.addJimpMethods = $e, _.jimpEvMethod = We, _.jimpEvChange = Ve, Object.defineProperty(_, "addType", {
            enumerable: !0,
            get: function() {
              return se.addType;
            }
          }), _.default = void 0;
          for (var E = y(C("@babel/runtime/helpers/construct")), d = y(C("@babel/runtime/helpers/slicedToArray")), l = y(C("@babel/runtime/helpers/classCallCheck")), u = y(C("@babel/runtime/helpers/createClass")), a = y(C("@babel/runtime/helpers/possibleConstructorReturn")), n = y(C("@babel/runtime/helpers/getPrototypeOf")), c = y(C("@babel/runtime/helpers/assertThisInitialized")), g = y(C("@babel/runtime/helpers/inherits")), f = y(C("@babel/runtime/helpers/defineProperty")), p = y(C("@babel/runtime/helpers/typeof")), s = y(C("fs")), S = y(C("path")), b = y(C("events")), o = C("@jimp/utils"), A = y(C("any-base")), T = y(C("mkdirp")), R = y(C("pixelmatch")), L = y(C("tinycolor2")), z = y(C("./modules/phash")), U = y(C("./request")), J = y(C("./composite")), F = y(C("./utils/promisify")), se = x(C("./utils/mime")), ee = C("./utils/image-bitmap"), ie = x(C("./constants")), W = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_", Q = [NaN, NaN], de = 2; de < 65; de++) {
            var _e = (0, A.default)(A.default.BIN, W.slice(0, de))(new Array(65).join("1"));
            Q.push(_e.length);
          }
          function ke() {
          }
          function Pe(Ne) {
            return Object.prototype.toString.call(Ne).toLowerCase().indexOf("arraybuffer") > -1;
          }
          function fe(Ne) {
            for (var we = P.alloc(Ne.byteLength), re = new Uint8Array(Ne), $ = 0; $ < we.length; ++$)
              we[$] = re[$];
            return we;
          }
          function xe(Ne, we) {
            (0, U.default)(Ne, function(re, $, Ce) {
              if (re)
                return we(re);
              if ("headers" in $ && "location" in $.headers)
                return Ne.url = $.headers.location, xe(Ne, we);
              if ((0, p.default)(Ce) === "object" && P.isBuffer(Ce))
                return we(null, Ce);
              var ve = "Could not load Buffer from <" + Ne.url + "> (HTTP: " + $.statusCode + ")";
              return new Error(ve);
            });
          }
          function Ee(Ne, we) {
            s.default && typeof s.default.readFile == "function" && !Ne.match(/^(http|ftp)s?:\/\/./) ? s.default.readFile(Ne, we) : xe({
              url: Ne
            }, we);
          }
          function Ie(Ne) {
            return Ne && (0, p.default)(Ne) === "object" && typeof Ne.width == "number" && typeof Ne.height == "number" && (P.isBuffer(Ne.data) || Ne.data instanceof Uint8Array || typeof Uint8ClampedArray == "function" && Ne.data instanceof Uint8ClampedArray) && (Ne.data.length === Ne.width * Ne.height * 4 || Ne.data.length === Ne.width * Ne.height * 3);
          }
          function je(Ne) {
            if (Ne.length % 3 !== 0)
              throw new Error("Buffer length is incorrect");
            for (var we = P.allocUnsafe(Ne.length / 3 * 4), re = 0, $ = 0; $ < Ne.length; $++)
              we[re] = Ne[$], ($ + 1) % 3 === 0 && (we[++re] = 255), re++;
            return we;
          }
          var Ue = {
            data: null,
            width: null,
            height: null
          }, He = /* @__PURE__ */ function(Ne) {
            (0, g.default)(we, Ne);
            function we() {
              for (var re, $ = arguments.length, Ce = new Array($), ve = 0; ve < $; ve++)
                Ce[ve] = arguments[ve];
              (0, l.default)(this, we), re = (0, a.default)(this, (0, n.default)(we).call(this)), (0, f.default)((0, c.default)(re), "bitmap", Ue), (0, f.default)((0, c.default)(re), "_background", 0), (0, f.default)((0, c.default)(re), "_originalMime", we.MIME_PNG), (0, f.default)((0, c.default)(re), "_exif", null), (0, f.default)((0, c.default)(re), "_rgba", !0), (0, f.default)((0, c.default)(re), "writeAsync", function(pe) {
                return (0, F.default)(re.write, (0, c.default)(re), pe);
              }), (0, f.default)((0, c.default)(re), "getBase64Async", function(pe) {
                return (0, F.default)(re.getBase64, (0, c.default)(re), pe);
              }), (0, f.default)((0, c.default)(re), "getBuffer", ee.getBuffer), (0, f.default)((0, c.default)(re), "getBufferAsync", ee.getBufferAsync), (0, f.default)((0, c.default)(re), "getPixelColour", re.getPixelColor), (0, f.default)((0, c.default)(re), "setPixelColour", re.setPixelColor);
              var Y = (0, c.default)(re), G = ke;
              Pe(Ce[0]) && (Ce[0] = fe(Ce[0]));
              function Ae() {
                for (var pe = arguments.length, M = new Array(pe), q = 0; q < pe; q++)
                  M[q] = arguments[q];
                var K = M[0], be = K || {};
                be.methodName = "constructor", setTimeout(function() {
                  var te;
                  K && G === ke ? Y.emitError("constructor", K) : K || Y.emitMulti("constructor", "initialized"), (te = G).call.apply(te, [Y].concat(M));
                }, 1);
              }
              if (typeof Ce[0] == "number" && typeof Ce[1] == "number" || parseInt(Ce[0], 10) && parseInt(Ce[1], 10)) {
                var e = parseInt(Ce[0], 10), r = parseInt(Ce[1], 10);
                if (G = Ce[2], typeof Ce[2] == "number" && (re._background = Ce[2], G = Ce[3]), typeof Ce[2] == "string" && (re._background = we.cssColorToHex(Ce[2]), G = Ce[3]), typeof G > "u" && (G = ke), typeof G != "function")
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "cb must be a function", Ae));
                re.bitmap = {
                  data: P.alloc(e * r * 4),
                  width: e,
                  height: r
                };
                for (var h = 0; h < re.bitmap.data.length; h += 4)
                  re.bitmap.data.writeUInt32BE(re._background, h);
                Ae(null, (0, c.default)(re));
              } else if ((0, p.default)(Ce[0]) === "object" && Ce[0].url) {
                if (G = Ce[1] || ke, typeof G != "function")
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "cb must be a function", Ae));
                xe(Ce[0], function(pe, M) {
                  if (pe)
                    return o.throwError.call((0, c.default)(re), pe, Ae);
                  re.parseBitmap(M, Ce[0].url, Ae);
                });
              } else if (Ce[0] instanceof we) {
                var k = Ce[0];
                if (G = Ce[1], typeof G > "u" && (G = ke), typeof G != "function")
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "cb must be a function", Ae));
                re.bitmap = {
                  data: P.from(k.bitmap.data),
                  width: k.bitmap.width,
                  height: k.bitmap.height
                }, re._quality = k._quality, re._deflateLevel = k._deflateLevel, re._deflateStrategy = k._deflateStrategy, re._filterType = k._filterType, re._rgba = k._rgba, re._background = k._background, re._originalMime = k._originalMime, Ae(null, (0, c.default)(re));
              } else if (Ie(Ce[0])) {
                var I = Ce[0];
                G = Ce[1] || ke;
                var B = I.width * I.height * 4 === I.data.length, j = B ? P.from(I.data) : je(I.data);
                re.bitmap = {
                  data: j,
                  width: I.width,
                  height: I.height
                }, Ae(null, (0, c.default)(re));
              } else if (typeof Ce[0] == "string") {
                var H = Ce[0];
                if (G = Ce[1], typeof G > "u" && (G = ke), typeof G != "function")
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "cb must be a function", Ae));
                Ee(H, function(pe, M) {
                  if (pe)
                    return o.throwError.call((0, c.default)(re), pe, Ae);
                  re.parseBitmap(M, H, Ae);
                });
              } else if ((0, p.default)(Ce[0]) === "object" && P.isBuffer(Ce[0])) {
                var X = Ce[0];
                if (G = Ce[1], typeof G != "function")
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "cb must be a function", Ae));
                re.parseBitmap(X, null, Ae);
              } else {
                G = Ce[Ce.length - 1], typeof G != "function" && (G = Ce[Ce.length - 2], typeof G != "function" && (G = ke));
                var ue = we.__extraConstructors.find(function(pe) {
                  return pe.test.apply(pe, Ce);
                });
                if (ue)
                  new Promise(function(pe, M) {
                    var q;
                    return (q = ue.run).call.apply(q, [(0, c.default)(re), pe, M].concat(Ce));
                  }).then(function() {
                    return Ae(null, (0, c.default)(re));
                  }).catch(Ae);
                else
                  return (0, a.default)(re, o.throwError.call((0, c.default)(re), "No matching constructor overloading was found. Please see the docs for how to call the Jimp constructor.", Ae));
              }
              return re;
            }
            return (0, u.default)(we, [{
              key: "parseBitmap",
              value: function($, Ce, ve) {
                ee.parseBitmap.call(this, $, null, ve);
              }
              /**
               * Sets the type of the image (RGB or RGBA) when saving in a format that supports transparency (default is RGBA)
               * @param {boolean} bool A Boolean, true to use RGBA or false to use RGB
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
            }, {
              key: "rgba",
              value: function($, Ce) {
                return typeof $ != "boolean" ? o.throwError.call(this, "bool must be a boolean, true for RGBA or false for RGB", Ce) : (this._rgba = $, (0, o.isNodePattern)(Ce) && Ce.call(this, null, this), this);
              }
              /**
               * Emit for multiple listeners
               * @param {string} methodName name of the method to emit an error for
               * @param {string} eventName name of the eventName to emit an error for
               * @param {object} data to emit
               */
            }, {
              key: "emitMulti",
              value: function($, Ce) {
                var ve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                ve = Object.assign(ve, {
                  methodName: $,
                  eventName: Ce
                }), this.emit("any", ve), $ && this.emit($, ve), this.emit(Ce, ve);
              }
            }, {
              key: "emitError",
              value: function($, Ce) {
                this.emitMulti($, "error", Ce);
              }
              /**
               * Get the current height of the image
               * @return {number} height of the image
               */
            }, {
              key: "getHeight",
              value: function() {
                return this.bitmap.height;
              }
              /**
               * Get the current width of the image
               * @return {number} width of the image
               */
            }, {
              key: "getWidth",
              value: function() {
                return this.bitmap.width;
              }
              /**
               * Nicely format Jimp object when sent to the console e.g. console.log(image)
               * @returns {string} pretty printed
               */
            }, {
              key: "inspect",
              value: function() {
                return "<Jimp " + (this.bitmap === Ue ? "pending..." : this.bitmap.width + "x" + this.bitmap.height) + ">";
              }
              /**
               * Nicely format Jimp object when converted to a string
               * @returns {string} pretty printed
               */
            }, {
              key: "toString",
              value: function() {
                return "[object Jimp]";
              }
              /**
               * Returns the original MIME of the image (default: "image/png")
               * @returns {string} the MIME
               */
            }, {
              key: "getMIME",
              value: function() {
                var $ = this._originalMime || we.MIME_PNG;
                return $;
              }
              /**
               * Returns the appropriate file extension for the original MIME of the image (default: "png")
               * @returns {string} the file extension
               */
            }, {
              key: "getExtension",
              value: function() {
                var $ = this.getMIME();
                return se.getExtension($);
              }
              /**
               * Writes the image to a file
               * @param {string} path a path to the destination file
               * @param {function(Error, Jimp)} cb (optional) a function to call when the image is saved to disk
               * @returns {Jimp} this for chaining of methods
               */
            }, {
              key: "write",
              value: function($, Ce) {
                var ve = this;
                if (!s.default || !s.default.createWriteStream)
                  throw new Error("Cant access the filesystem. You can use the getBase64 method.");
                if (typeof $ != "string")
                  return o.throwError.call(this, "path must be a string", Ce);
                if (typeof Ce > "u" && (Ce = ke), typeof Ce != "function")
                  return o.throwError.call(this, "cb must be a function", Ce);
                var Y = se.getType($) || this.getMIME(), G = S.default.parse($);
                return G.dir && T.default.sync(G.dir), this.getBuffer(Y, function(Ae, e) {
                  if (Ae)
                    return o.throwError.call(ve, Ae, Ce);
                  var r = s.default.createWriteStream($);
                  r.on("open", function() {
                    r.write(e), r.end();
                  }).on("error", function(h) {
                    return o.throwError.call(ve, h, Ce);
                  }), r.on("finish", function() {
                    Ce.call(ve, null, ve);
                  });
                }), this;
              }
            }, {
              key: "getBase64",
              /**
               * Converts the image to a base 64 string
               * @param {string} mime the mime type of the image data to be created
               * @param {function(Error, Jimp)} cb a Node-style function to call with the buffer as the second argument
               * @returns {Jimp} this for chaining of methods
               */
              value: function($, Ce) {
                return $ === we.AUTO && ($ = this.getMIME()), typeof $ != "string" ? o.throwError.call(this, "mime must be a string", Ce) : typeof Ce != "function" ? o.throwError.call(this, "cb must be a function", Ce) : (this.getBuffer($, function(ve, Y) {
                  if (ve)
                    return o.throwError.call(this, ve, Ce);
                  var G = "data:" + $ + ";base64," + Y.toString("base64");
                  Ce.call(this, null, G);
                }), this);
              }
            }, {
              key: "hash",
              /**
               * Generates a perceptual hash of the image <https://en.wikipedia.org/wiki/Perceptual_hashing>. And pads the string. Can configure base.
               * @param {number} base (optional) a number between 2 and 64 representing the base for the hash (e.g. 2 is binary, 10 is decimal, 16 is hex, 64 is base 64). Defaults to 64.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {string} a string representing the hash
               */
              value: function($, Ce) {
                if ($ = $ || 64, typeof $ == "function" && (Ce = $, $ = 64), typeof $ != "number")
                  return o.throwError.call(this, "base must be a number", Ce);
                if ($ < 2 || $ > 64)
                  return o.throwError.call(this, "base must be a number between 2 and 64", Ce);
                var ve = this.pHash();
                for (ve = (0, A.default)(A.default.BIN, W.slice(0, $))(ve); ve.length < Q[$]; )
                  ve = "0" + ve;
                return (0, o.isNodePattern)(Ce) && Ce.call(this, null, ve), ve;
              }
              /**
               * Calculates the perceptual hash
               * @returns {number} the perceptual hash
               */
            }, {
              key: "pHash",
              value: function() {
                var $ = new z.default();
                return $.getHash(this);
              }
              /**
               * Calculates the hamming distance of the current image and a hash based on their perceptual hash
               * @param {hash} compareHash hash to compare to
               * @returns {number} a number ranging from 0 to 1, 0 means they are believed to be identical
               */
            }, {
              key: "distanceFromHash",
              value: function($) {
                var Ce = new z.default(), ve = Ce.getHash(this);
                return Ce.distance(ve, $);
              }
              /**
               * Converts the image to a buffer
               * @param {string} mime the mime type of the image buffer to be created
               * @param {function(Error, Jimp)} cb a Node-style function to call with the buffer as the second argument
               * @returns {Jimp} this for chaining of methods
               */
            }, {
              key: "getPixelIndex",
              /**
               * Returns the offset of a pixel in the bitmap buffer
               * @param {number} x the x coordinate
               * @param {number} y the y coordinate
               * @param {string} edgeHandling (optional) define how to sum pixels from outside the border
               * @param {number} cb (optional) a callback for when complete
               * @returns {number} the index of the pixel or -1 if not found
               */
              value: function($, Ce, ve, Y) {
                var G, Ae;
                if (typeof ve == "function" && typeof Y > "u" && (Y = ve, ve = null), ve || (ve = we.EDGE_EXTEND), typeof $ != "number" || typeof Ce != "number")
                  return o.throwError.call(this, "x and y must be numbers", Y);
                $ = Math.round($), Ce = Math.round(Ce), G = $, Ae = Ce, ve === we.EDGE_EXTEND && ($ < 0 && (G = 0), $ >= this.bitmap.width && (G = this.bitmap.width - 1), Ce < 0 && (Ae = 0), Ce >= this.bitmap.height && (Ae = this.bitmap.height - 1)), ve === we.EDGE_WRAP && ($ < 0 && (G = this.bitmap.width + $), $ >= this.bitmap.width && (G = $ % this.bitmap.width), Ce < 0 && (G = this.bitmap.height + Ce), Ce >= this.bitmap.height && (Ae = Ce % this.bitmap.height));
                var e = this.bitmap.width * Ae + G << 2;
                return (G < 0 || G >= this.bitmap.width) && (e = -1), (Ae < 0 || Ae >= this.bitmap.height) && (e = -1), (0, o.isNodePattern)(Y) && Y.call(this, null, e), e;
              }
              /**
               * Returns the hex colour value of a pixel
               * @param {number} x the x coordinate
               * @param {number} y the y coordinate
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {number} the color of the pixel
               */
            }, {
              key: "getPixelColor",
              value: function($, Ce, ve) {
                if (typeof $ != "number" || typeof Ce != "number") return o.throwError.call(this, "x and y must be numbers", ve);
                $ = Math.round($), Ce = Math.round(Ce);
                var Y = this.getPixelIndex($, Ce), G = this.bitmap.data.readUInt32BE(Y);
                return (0, o.isNodePattern)(ve) && ve.call(this, null, G), G;
              }
            }, {
              key: "setPixelColor",
              /**
               * Returns the hex colour value of a pixel
               * @param {number} hex color to set
               * @param {number} x the x coordinate
               * @param {number} y the y coordinate
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {number} the index of the pixel or -1 if not found
               */
              value: function($, Ce, ve, Y) {
                if (typeof $ != "number" || typeof Ce != "number" || typeof ve != "number") return o.throwError.call(this, "hex, x and y must be numbers", Y);
                Ce = Math.round(Ce), ve = Math.round(ve);
                var G = this.getPixelIndex(Ce, ve);
                return this.bitmap.data.writeUInt32BE($, G), (0, o.isNodePattern)(Y) && Y.call(this, null, this), this;
              }
            }, {
              key: "hasAlpha",
              /**
               * Determine if the image contains opaque pixels.
               * @return {boolean} hasAlpha whether the image contains opaque pixels
               */
              value: function() {
                for (var $ = 0; $ < this.bitmap.height; $++)
                  for (var Ce = 0; Ce < this.bitmap.width; Ce++) {
                    var ve = this.bitmap.width * $ + Ce << 2, Y = this.bitmap.data[ve + 3];
                    if (Y !== 255)
                      return !0;
                  }
                return !1;
              }
              /**
               * Iterate scan through a region of the bitmap
               * @param {number} x the x coordinate to begin the scan at
               * @param {number} y the y coordinate to begin the scan at
               * @param w the width of the scan region
               * @param h the height of the scan region
               * @returns {IterableIterator<{x: number, y: number, idx: number, image: Jimp}>}
               */
            }, {
              key: "scanIterator",
              value: function($, Ce, ve, Y) {
                return typeof $ != "number" || typeof Ce != "number" ? o.throwError.call(this, "x and y must be numbers") : typeof ve != "number" || typeof Y != "number" ? o.throwError.call(this, "w and h must be numbers") : (0, o.scanIterator)(this, $, Ce, ve, Y);
              }
            }]), we;
          }(b.default);
          function Ze(Ne) {
            var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : He;
            Object.entries(Ne).forEach(function(re) {
              var $ = (0, d.default)(re, 2), Ce = $[0], ve = $[1];
              we[Ce] = ve;
            });
          }
          function $e(Ne) {
            var we = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : He;
            Object.entries(Ne).forEach(function(re) {
              var $ = (0, d.default)(re, 2), Ce = $[0], ve = $[1];
              we.prototype[Ce] = ve;
            });
          }
          Ze(ie), $e({
            composite: J.default
          }), He.__extraConstructors = [], He.appendConstructorOption = function(Ne, we, re) {
            He.__extraConstructors.push({
              name: Ne,
              test: we,
              run: re
            });
          }, He.read = function() {
            for (var Ne = arguments.length, we = new Array(Ne), re = 0; re < Ne; re++)
              we[re] = arguments[re];
            return new Promise(function($, Ce) {
              (0, E.default)(He, we.concat([function(ve, Y) {
                ve ? Ce(ve) : $(Y);
              }]));
            });
          }, He.create = He.read, He.rgbaToInt = function(Ne, we, re, $, Ce) {
            if (typeof Ne != "number" || typeof we != "number" || typeof re != "number" || typeof $ != "number")
              return o.throwError.call(this, "r, g, b and a must be numbers", Ce);
            if (Ne < 0 || Ne > 255)
              return o.throwError.call(this, "r must be between 0 and 255", Ce);
            if ((we < 0 || we > 255) && o.throwError.call(this, "g must be between 0 and 255", Ce), re < 0 || re > 255)
              return o.throwError.call(this, "b must be between 0 and 255", Ce);
            if ($ < 0 || $ > 255)
              return o.throwError.call(this, "a must be between 0 and 255", Ce);
            Ne = Math.round(Ne), re = Math.round(re), we = Math.round(we), $ = Math.round($);
            var ve = Ne * Math.pow(256, 3) + we * Math.pow(256, 2) + re * Math.pow(256, 1) + $ * Math.pow(256, 0);
            return (0, o.isNodePattern)(Ce) && Ce.call(this, null, ve), ve;
          }, He.intToRGBA = function(Ne, we) {
            if (typeof Ne != "number")
              return o.throwError.call(this, "i must be a number", we);
            var re = {};
            return re.r = Math.floor(Ne / Math.pow(256, 3)), re.g = Math.floor((Ne - re.r * Math.pow(256, 3)) / Math.pow(256, 2)), re.b = Math.floor((Ne - re.r * Math.pow(256, 3) - re.g * Math.pow(256, 2)) / Math.pow(256, 1)), re.a = Math.floor((Ne - re.r * Math.pow(256, 3) - re.g * Math.pow(256, 2) - re.b * Math.pow(256, 1)) / Math.pow(256, 0)), (0, o.isNodePattern)(we) && we.call(this, null, re), re;
          }, He.cssColorToHex = function(Ne) {
            return Ne = Ne || 0, typeof Ne == "number" ? Number(Ne) : parseInt((0, L.default)(Ne).toHex8(), 16);
          }, He.limit255 = function(Ne) {
            return Ne = Math.max(Ne, 0), Ne = Math.min(Ne, 255), Ne;
          }, He.diff = function(Ne, we) {
            var re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1;
            if (!(Ne instanceof He) || !(we instanceof He)) return o.throwError.call(this, "img1 and img2 must be an Jimp images");
            var $ = Ne.bitmap, Ce = we.bitmap;
            if (($.width !== Ce.width || $.height !== Ce.height) && ($.width * $.height > Ce.width * Ce.height ? Ne = Ne.cloneQuiet().resize(Ce.width, Ce.height) : we = we.cloneQuiet().resize($.width, $.height)), typeof re != "number" || re < 0 || re > 1)
              return o.throwError.call(this, "threshold must be a number between 0 and 1");
            var ve = new He($.width, $.height, 4294967295), Y = (0, R.default)($.data, Ce.data, ve.bitmap.data, ve.bitmap.width, ve.bitmap.height, {
              threshold: re
            });
            return {
              percent: Y / (ve.bitmap.width * ve.bitmap.height),
              image: ve
            };
          }, He.distance = function(Ne, we) {
            var re = new z.default(), $ = re.getHash(Ne), Ce = re.getHash(we);
            return re.distance($, Ce);
          }, He.compareHashes = function(Ne, we) {
            var re = new z.default();
            return re.distance(Ne, we);
          }, He.colorDiff = function(Ne, we) {
            var re = function(Y) {
              return Math.pow(Y, 2);
            }, $ = Math.max, Ce = 255 * 255 * 3;
            return Ne.a !== 0 && !Ne.a && (Ne.a = 255), we.a !== 0 && !we.a && (we.a = 255), ($(re(Ne.r - we.r), re(Ne.r - we.r - Ne.a + we.a)) + $(re(Ne.g - we.g), re(Ne.g - we.g - Ne.a + we.a)) + $(re(Ne.b - we.b), re(Ne.b - we.b - Ne.a + we.a))) / Ce;
          };
          function We(Ne, we, re) {
            var $ = "before-" + we, Ce = we.replace(/e$/, "") + "ed";
            He.prototype[Ne] = function() {
              for (var ve, Y = arguments.length, G = new Array(Y), Ae = 0; Ae < Y; Ae++)
                G[Ae] = arguments[Ae];
              var e = G[re.length - 1], r = this;
              typeof e == "function" ? (ve = function() {
                for (var I = arguments.length, B = new Array(I), j = 0; j < I; j++)
                  B[j] = arguments[j];
                var H = B[0], X = B[1];
                H ? r.emitError(Ne, H) : r.emitMulti(Ne, Ce, (0, f.default)({}, Ne, X)), e.apply(this, B);
              }, G[G.length - 1] = ve) : ve = !1, this.emitMulti(Ne, $);
              var h;
              try {
                h = re.apply(this, G), ve || this.emitMulti(Ne, Ce, (0, f.default)({}, Ne, h));
              } catch (k) {
                k.methodName = Ne, this.emitError(Ne, k);
              }
              return h;
            }, He.prototype[Ne + "Quiet"] = re;
          }
          We("clone", "clone", function(Ne) {
            var we = new He(this);
            return (0, o.isNodePattern)(Ne) && Ne.call(we, null, we), we;
          });
          function Ve(Ne, we) {
            We(Ne, "change", we);
          }
          Ve("background", function(Ne, we) {
            return typeof Ne != "number" ? o.throwError.call(this, "hex must be a hexadecimal rgba value", we) : (this._background = Ne, (0, o.isNodePattern)(we) && we.call(this, null, this), this);
          }), Ve("scan", function(Ne, we, re, $, Ce, ve) {
            if (typeof Ne != "number" || typeof we != "number")
              return o.throwError.call(this, "x and y must be numbers", ve);
            if (typeof re != "number" || typeof $ != "number")
              return o.throwError.call(this, "w and h must be numbers", ve);
            if (typeof Ce != "function")
              return o.throwError.call(this, "f must be a function", ve);
            var Y = (0, o.scan)(this, Ne, we, re, $, Ce);
            return (0, o.isNodePattern)(ve) && ve.call(this, null, Y), Y;
          });
          {
            var Re;
            typeof ne < "u" && (typeof ne > "u" ? "undefined" : (0, p.default)(ne)) === "object" && (Re = ne), typeof self < "u" && (typeof self > "u" ? "undefined" : (0, p.default)(self)) === "object" && (Re = self), Re.Jimp = He, Re.Buffer = P;
          }
          var De = He;
          _.default = De;
        }).call(this, C("buffer").Buffer);
      }, { "./composite": 191, "./constants": 192, "./modules/phash": 194, "./request": 195, "./utils/image-bitmap": 196, "./utils/mime": 197, "./utils/promisify": 198, "@babel/runtime/helpers/assertThisInitialized": 3, "@babel/runtime/helpers/classCallCheck": 4, "@babel/runtime/helpers/construct": 5, "@babel/runtime/helpers/createClass": 6, "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/getPrototypeOf": 9, "@babel/runtime/helpers/inherits": 10, "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/interopRequireWildcard": 12, "@babel/runtime/helpers/possibleConstructorReturn": 17, "@babel/runtime/helpers/slicedToArray": 19, "@babel/runtime/helpers/typeof": 21, "@jimp/utils": 235, "any-base": 23, buffer: 48, events: 52, fs: 47, mkdirp: 83, path: 107, pixelmatch: 109, tinycolor2: 178 }], 194: [function(C, Z, _) {
        function P(l, u) {
          this.size = this.size || l, this.smallerSize = this.smallerSize || u, E(this.size);
        }
        P.prototype.size = 32, P.prototype.smallerSize = 8, P.prototype.distance = function(l, u) {
          for (var a = 0, n = 0; n < l.length; n++)
            l[n] !== u[n] && a++;
          return a / l.length;
        }, P.prototype.getHash = function(l) {
          l = l.clone().resize(this.size, this.size), l.grayscale();
          for (var u = [], a = 0; a < l.bitmap.width; a++) {
            u[a] = [];
            for (var n = 0; n < l.bitmap.height; n++)
              u[a][n] = x(l.getPixelColor(a, n)).b;
          }
          for (var c = d(u, this.size), g = 0, f = 0; f < this.smallerSize; f++)
            for (var p = 0; p < this.smallerSize; p++)
              g += c[f][p];
          for (var s = g / (this.smallerSize * this.smallerSize), S = "", b = 0; b < this.smallerSize; b++)
            for (var o = 0; o < this.smallerSize; o++)
              S += c[b][o] > s ? "1" : "0";
          return S;
        };
        function x(l) {
          var u = {};
          return u.r = Math.floor(l / Math.pow(256, 3)), u.g = Math.floor((l - u.r * Math.pow(256, 3)) / Math.pow(256, 2)), u.b = Math.floor((l - u.r * Math.pow(256, 3) - u.g * Math.pow(256, 2)) / Math.pow(256, 1)), u.a = Math.floor((l - u.r * Math.pow(256, 3) - u.g * Math.pow(256, 2) - u.b * Math.pow(256, 1)) / Math.pow(256, 0)), u;
        }
        var y = [];
        function E(l) {
          for (var u = 1; u < l; u++)
            y[u] = 1;
          y[0] = 1 / Math.sqrt(2);
        }
        function d(l, u) {
          for (var a = u, n = [], c = 0; c < a; c++) {
            n[c] = [];
            for (var g = 0; g < a; g++) {
              for (var f = 0, p = 0; p < a; p++)
                for (var s = 0; s < a; s++)
                  f += Math.cos((2 * p + 1) / (2 * a) * c * Math.PI) * Math.cos((2 * s + 1) / (2 * a) * g * Math.PI) * l[p][s];
              f *= y[c] * y[g] / 4, n[c][g] = f;
            }
          }
          return n;
        }
        Z.exports = P;
      }, {}], 195: [function(C, Z, _) {
        (function(P, x) {
          var y = C("@babel/runtime/helpers/interopRequireDefault");
          y(C("@babel/runtime/helpers/defineProperty")), y(C("@babel/runtime/helpers/extends")), P.browser, Z.exports = function(E, d) {
            var l = new XMLHttpRequest();
            l.open("GET", E.url, !0), l.responseType = "arraybuffer", l.addEventListener("load", function() {
              if (l.status < 400)
                try {
                  var u = x.from(this.response);
                  d(null, l, u);
                } catch (a) {
                  return d(new Error("Response is not a buffer for url " + E.url + ". Error: " + a.message));
                }
              else
                d(new Error("HTTP Status " + l.status + " for url " + E.url));
            }), l.addEventListener("error", function(u) {
              d(u);
            }), l.send();
          };
        }).call(this, C("_process"), C("buffer").Buffer);
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/extends": 8, "@babel/runtime/helpers/interopRequireDefault": 11, _process: 133, buffer: 48, phin: 108 }], 196: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireWildcard"), y = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.parseBitmap = b, _.getBuffer = A, _.getBufferAsync = T;
          var E = y(C("@babel/runtime/helpers/slicedToArray")), d = y(C("file-type")), l = y(C("exif-parser")), u = C("@jimp/utils"), a = x(C("../constants")), n = x(C("./mime")), c = y(C("./promisify"));
          function g(R, L) {
            var z = (0, d.default)(R);
            return z ? z.mime : L ? n.getType(L) : null;
          }
          function f(R) {
            return R._exif && R._exif.tags && R._exif.tags.Orientation || 1;
          }
          function p(R) {
            var L = R.getWidth(), z = R.getHeight();
            switch (f(R)) {
              case 1:
                return null;
              case 2:
                return function(U, J) {
                  return [L - U - 1, J];
                };
              case 3:
                return function(U, J) {
                  return [L - U - 1, z - J - 1];
                };
              case 4:
                return function(U, J) {
                  return [U, z - J - 1];
                };
              case 5:
                return function(U, J) {
                  return [J, U];
                };
              case 6:
                return function(U, J) {
                  return [J, z - U - 1];
                };
              case 7:
                return function(U, J) {
                  return [L - J - 1, z - U - 1];
                };
              case 8:
                return function(U, J) {
                  return [L - J - 1, U];
                };
              default:
                return null;
            }
          }
          function s(R, L, z, U) {
            for (var J = R.bitmap.data, F = R.bitmap.width, se = P.alloc(J.length), ee = 0; ee < L; ee++)
              for (var ie = 0; ie < z; ie++) {
                var W = U(ee, ie), Q = (0, E.default)(W, 2), de = Q[0], _e = Q[1], ke = L * ie + ee << 2, Pe = F * _e + de << 2, fe = J.readUInt32BE(Pe);
                se.writeUInt32BE(fe, ke);
              }
            R.bitmap.data = se, R.bitmap.width = L, R.bitmap.height = z;
          }
          function S(R) {
            if (!(f(R) < 2)) {
              var L = p(R), z = f(R) > 4, U = z ? R.bitmap.height : R.bitmap.width, J = z ? R.bitmap.width : R.bitmap.height;
              s(R, U, J, L);
            }
          }
          function b(R, L, z) {
            var U = g(R, L);
            if (typeof U != "string")
              return z(new Error("Could not find MIME for Buffer <" + L + ">"));
            this._originalMime = U.toLowerCase();
            try {
              var J = this.getMIME();
              if (this.constructor.decoders[J])
                this.bitmap = this.constructor.decoders[J](R);
              else
                return u.throwError.call(this, "Unsupported MIME type: " + J, z);
            } catch (F) {
              return z.call(this, F, this);
            }
            try {
              this._exif = l.default.create(R).parse(), S(this);
            } catch {
            }
            return z.call(this, null, this), this;
          }
          function o(R, L) {
            return new R(L.bitmap.width, L.bitmap.height, L._background).composite(L, 0, 0).bitmap;
          }
          function A(R, L) {
            if (R === a.AUTO && (R = this.getMIME()), typeof R != "string")
              return u.throwError.call(this, "mime must be a string", L);
            if (typeof L != "function")
              return u.throwError.call(this, "cb must be a function", L);
            if (R = R.toLowerCase(), this._rgba && this.constructor.hasAlpha[R] ? this.bitmap.data = P.from(this.bitmap.data) : this.bitmap.data = o(this.constructor, this).data, this.constructor.encoders[R]) {
              var z = this.constructor.encoders[R](this);
              L.call(this, null, z);
            } else
              L.call(this, "Unsupported MIME type: " + R);
            return this;
          }
          function T(R) {
            return (0, c.default)(A, this, R);
          }
        }).call(this, C("buffer").Buffer);
      }, { "../constants": 192, "./mime": 197, "./promisify": 198, "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/interopRequireWildcard": 12, "@babel/runtime/helpers/slicedToArray": 19, "@jimp/utils": 235, buffer: 48, "exif-parser": 53, "file-type": 62 }], 197: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.getExtension = _.getType = _.addType = void 0;
        var P = {}, x = function(u) {
          return Object.entries(P).find(function(a) {
            return a[1].includes(u);
          }) || [];
        }, y = function(u, a) {
          P[u] = a;
        };
        _.addType = y;
        var E = function(u) {
          var a = u.split("/").slice(-1), n = a[a.length - 1].split(".").pop(), c = x(n);
          return c[0];
        };
        _.getType = E;
        var d = function(u) {
          return (P[u.toLowerCase()] || [])[0];
        };
        _.getExtension = d;
      }, {}], 198: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = function(E, d) {
          for (var l = arguments.length, u = new Array(l > 2 ? l - 2 : 0), a = 2; a < l; a++)
            u[a - 2] = arguments[a];
          return new Promise(function(n, c) {
            u.push(function(g, f) {
              g && c(g), n(f);
            }), E.bind(d).apply(void 0, u);
          });
        }, x = P;
        _.default = x, Z.exports = _.default;
      }, {}], 199: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireWildcard"), x = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = n;
        var y = x(C("@babel/runtime/helpers/toConsumableArray")), E = x(C("@babel/runtime/helpers/defineProperty")), d = x(C("@babel/runtime/helpers/slicedToArray")), l = P(C("@jimp/core"));
        function u(c, g) {
          var f = Object.keys(c);
          if (Object.getOwnPropertySymbols) {
            var p = Object.getOwnPropertySymbols(c);
            g && (p = p.filter(function(s) {
              return Object.getOwnPropertyDescriptor(c, s).enumerable;
            })), f.push.apply(f, p);
          }
          return f;
        }
        function a(c) {
          for (var g = 1; g < arguments.length; g++) {
            var f = arguments[g] != null ? arguments[g] : {};
            g % 2 ? u(f, !0).forEach(function(p) {
              (0, E.default)(c, p, f[p]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(f)) : u(f).forEach(function(p) {
              Object.defineProperty(c, p, Object.getOwnPropertyDescriptor(f, p));
            });
          }
          return c;
        }
        function n(c) {
          var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l.default, f = {
            hasAlpha: {},
            encoders: {},
            decoders: {},
            class: {},
            constants: {}
          };
          function p(b) {
            Object.entries(b).forEach(function(o) {
              var A = (0, d.default)(o, 2), T = A[0], R = A[1];
              f[T] = a({}, f[T], {}, R);
            });
          }
          function s(b) {
            var o = b();
            Array.isArray(o.mime) ? l.addType.apply(void 0, (0, y.default)(o.mime)) : Object.entries(o.mime).forEach(function(A) {
              return l.addType.apply(void 0, (0, y.default)(A));
            }), delete o.mime, p(o);
          }
          function S(b) {
            var o = b(l.jimpEvChange) || {};
            !o.class && !o.constants ? p({
              class: o
            }) : p(o);
          }
          return c.types && (c.types.forEach(s), g.decoders = a({}, g.decoders, {}, f.decoders), g.encoders = a({}, g.encoders, {}, f.encoders), g.hasAlpha = a({}, g.hasAlpha, {}, f.hasAlpha)), c.plugins && c.plugins.forEach(S), (0, l.addJimpMethods)(f.class, g), (0, l.addConstants)(f.constants, g), l.default;
        }
        Z.exports = _.default;
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/interopRequireWildcard": 12, "@babel/runtime/helpers/slicedToArray": 19, "@babel/runtime/helpers/toConsumableArray": 20, "@jimp/core": 193 }], 200: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@jimp/custom")), y = P(C("@jimp/types")), E = P(C("@jimp/plugins")), d = (0, x.default)({
          types: [y.default],
          plugins: [E.default]
        });
        _.default = d, Z.exports = _.default;
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/custom": 199, "@jimp/plugins": 228, "@jimp/types": 234 }], 201: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/typeof")), y = C("@jimp/utils"), E = function() {
          return {
            /**
             * Blits a source image on to this image
             * @param {Jimp} src the source Jimp instance
             * @param {number} x the x position to blit the image
             * @param {number} y the y position to blit the image
             * @param {number} srcx (optional) the x position from which to crop the source image
             * @param {number} srcy (optional) the y position from which to crop the source image
             * @param {number} srcw (optional) the width to which to crop the source image
             * @param {number} srch (optional) the height to which to crop the source image
             * @param {function(Error, Jimp)} cb (optional) a callback for when complete
             * @returns {Jimp} this for chaining of methods
             */
            blit: function(u, a, n, c, g, f, p, s) {
              if (!(u instanceof this.constructor))
                return y.throwError.call(this, "The source must be a Jimp image", s);
              if (typeof a != "number" || typeof n != "number")
                return y.throwError.call(this, "x and y must be numbers", s);
              if (typeof c == "function")
                s = c, c = 0, g = 0, f = u.bitmap.width, p = u.bitmap.height;
              else if ((0, x.default)(c) === (0, x.default)(g) && (0, x.default)(g) === (0, x.default)(f) && (0, x.default)(f) === (0, x.default)(p))
                c = c || 0, g = g || 0, f = f || u.bitmap.width, p = p || u.bitmap.height;
              else
                return y.throwError.call(this, "srcx, srcy, srcw, srch must be numbers", s);
              a = Math.round(a), n = Math.round(n), c = Math.round(c), g = Math.round(g), f = Math.round(f), p = Math.round(p);
              var S = this.bitmap.width, b = this.bitmap.height, o = this;
              return u.scanQuiet(c, g, f, p, function(A, T, R) {
                var L = a + A - c, z = n + T - g;
                if (L >= 0 && z >= 0 && S - L > 0 && b - z > 0) {
                  var U = o.getPixelIndex(L, z), J = {
                    r: this.bitmap.data[R],
                    g: this.bitmap.data[R + 1],
                    b: this.bitmap.data[R + 2],
                    a: this.bitmap.data[R + 3]
                  }, F = {
                    r: o.bitmap.data[U],
                    g: o.bitmap.data[U + 1],
                    b: o.bitmap.data[U + 2],
                    a: o.bitmap.data[U + 3]
                  };
                  o.bitmap.data[U] = (J.a * (J.r - F.r) - F.r + 255 >> 8) + F.r, o.bitmap.data[U + 1] = (J.a * (J.g - F.g) - F.g + 255 >> 8) + F.g, o.bitmap.data[U + 2] = (J.a * (J.b - F.b) - F.b + 255 >> 8) + F.b, o.bitmap.data[U + 3] = this.constructor.limit255(F.a + J.a);
                }
              }), (0, y.isNodePattern)(s) && s.call(this, null, this), this;
            }
          };
        };
        _.default = E, Z.exports = _.default;
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/typeof": 21, "@jimp/utils": 235 }], 202: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.shgTable = _.mulTable = void 0;
        var P = [1, 57, 41, 21, 203, 34, 97, 73, 227, 91, 149, 62, 105, 45, 39, 137, 241, 107, 3, 173, 39, 71, 65, 238, 219, 101, 187, 87, 81, 151, 141, 133, 249, 117, 221, 209, 197, 187, 177, 169, 5, 153, 73, 139, 133, 127, 243, 233, 223, 107, 103, 99, 191, 23, 177, 171, 165, 159, 77, 149, 9, 139, 135, 131, 253, 245, 119, 231, 224, 109, 211, 103, 25, 195, 189, 23, 45, 175, 171, 83, 81, 79, 155, 151, 147, 9, 141, 137, 67, 131, 129, 251, 123, 30, 235, 115, 113, 221, 217, 53, 13, 51, 50, 49, 193, 189, 185, 91, 179, 175, 43, 169, 83, 163, 5, 79, 155, 19, 75, 147, 145, 143, 35, 69, 17, 67, 33, 65, 255, 251, 247, 243, 239, 59, 29, 229, 113, 111, 219, 27, 213, 105, 207, 51, 201, 199, 49, 193, 191, 47, 93, 183, 181, 179, 11, 87, 43, 85, 167, 165, 163, 161, 159, 157, 155, 77, 19, 75, 37, 73, 145, 143, 141, 35, 138, 137, 135, 67, 33, 131, 129, 255, 63, 250, 247, 61, 121, 239, 237, 117, 29, 229, 227, 225, 111, 55, 109, 216, 213, 211, 209, 207, 205, 203, 201, 199, 197, 195, 193, 48, 190, 47, 93, 185, 183, 181, 179, 178, 176, 175, 173, 171, 85, 21, 167, 165, 41, 163, 161, 5, 79, 157, 78, 154, 153, 19, 75, 149, 74, 147, 73, 144, 143, 71, 141, 140, 139, 137, 17, 135, 134, 133, 66, 131, 65, 129, 1];
        _.mulTable = P;
        var x = [0, 9, 10, 10, 14, 12, 14, 14, 16, 15, 16, 15, 16, 15, 15, 17, 18, 17, 12, 18, 16, 17, 17, 19, 19, 18, 19, 18, 18, 19, 19, 19, 20, 19, 20, 20, 20, 20, 20, 20, 15, 20, 19, 20, 20, 20, 21, 21, 21, 20, 20, 20, 21, 18, 21, 21, 21, 21, 20, 21, 17, 21, 21, 21, 22, 22, 21, 22, 22, 21, 22, 21, 19, 22, 22, 19, 20, 22, 22, 21, 21, 21, 22, 22, 22, 18, 22, 22, 21, 22, 22, 23, 22, 20, 23, 22, 22, 23, 23, 21, 19, 21, 21, 21, 23, 23, 23, 22, 23, 23, 21, 23, 22, 23, 18, 22, 23, 20, 22, 23, 23, 23, 21, 22, 20, 22, 21, 22, 24, 24, 24, 24, 24, 22, 21, 24, 23, 23, 24, 21, 24, 23, 24, 22, 24, 24, 22, 24, 24, 22, 23, 24, 24, 24, 20, 23, 22, 23, 24, 24, 24, 24, 24, 24, 24, 23, 21, 23, 22, 23, 24, 24, 24, 22, 24, 24, 24, 23, 22, 24, 24, 25, 23, 25, 25, 23, 24, 25, 25, 24, 22, 25, 25, 25, 24, 23, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 23, 25, 23, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 24, 22, 25, 25, 23, 25, 25, 20, 24, 25, 24, 25, 25, 22, 24, 25, 24, 25, 24, 25, 25, 24, 25, 25, 25, 25, 22, 25, 25, 25, 24, 25, 24, 25, 18];
        _.shgTable = x;
      }, {}], 203: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = C("./blur-tables"), y = function() {
          return {
            /**
             * A fast blur algorithm that produces similar effect to a Gaussian blur - but MUCH quicker
             * @param {number} r the pixel radius of the blur
             * @param {function(Error, Jimp)} cb (optional) a callback for when complete
             * @returns {Jimp} this for chaining of methods
             */
            blur: function(l, u) {
              if (typeof l != "number") return P.throwError.call(this, "r must be a number", u);
              if (l < 1) return P.throwError.call(this, "r must be greater than 0", u);
              for (var a, n, c, g, f, p, s, S, b, o, A, T, R, L, z = this.bitmap.width - 1, U = this.bitmap.height - 1, J = l + 1, F = x.mulTable[l], se = x.shgTable[l], ee = [], ie = [], W = [], Q = [], de = [], _e = [], ke = 2; ke-- > 0; ) {
                for (T = 0, R = 0, p = 0; p < this.bitmap.height; p++) {
                  for (a = this.bitmap.data[R] * J, n = this.bitmap.data[R + 1] * J, c = this.bitmap.data[R + 2] * J, g = this.bitmap.data[R + 3] * J, s = 1; s <= l; s++)
                    S = R + ((s > z ? z : s) << 2), a += this.bitmap.data[S++], n += this.bitmap.data[S++], c += this.bitmap.data[S++], g += this.bitmap.data[S];
                  for (f = 0; f < this.bitmap.width; f++)
                    ee[T] = a, ie[T] = n, W[T] = c, Q[T] = g, p === 0 && (de[f] = ((S = f + J) < z ? S : z) << 2, _e[f] = (S = f - l) > 0 ? S << 2 : 0), b = R + de[f], o = R + _e[f], a += this.bitmap.data[b++] - this.bitmap.data[o++], n += this.bitmap.data[b++] - this.bitmap.data[o++], c += this.bitmap.data[b++] - this.bitmap.data[o++], g += this.bitmap.data[b] - this.bitmap.data[o], T++;
                  R += this.bitmap.width << 2;
                }
                for (f = 0; f < this.bitmap.width; f++) {
                  for (A = f, a = ee[A] * J, n = ie[A] * J, c = W[A] * J, g = Q[A] * J, s = 1; s <= l; s++)
                    A += s > U ? 0 : this.bitmap.width, a += ee[A], n += ie[A], c += W[A], g += Q[A];
                  for (T = f << 2, p = 0; p < this.bitmap.height; p++)
                    L = g * F >>> se, this.bitmap.data[T + 3] = L, L > 255 && (this.bitmap.data[T + 3] = 255), L > 0 ? (L = 255 / L, this.bitmap.data[T] = (a * F >>> se) * L, this.bitmap.data[T + 1] = (n * F >>> se) * L, this.bitmap.data[T + 2] = (c * F >>> se) * L) : (this.bitmap.data[T + 2] = 0, this.bitmap.data[T + 1] = 0, this.bitmap.data[T] = 0), f === 0 && (de[p] = ((S = p + J) < U ? S : U) * this.bitmap.width, _e[p] = (S = p - l) > 0 ? S * this.bitmap.width : 0), b = f + de[p], o = f + _e[p], a += ee[b] - ee[o], n += ie[b] - ie[o], c += W[b] - W[o], g += Q[b] - Q[o], T += this.bitmap.width << 2;
                }
              }
              return (0, P.isNodePattern)(u) && u.call(this, null, this), this;
            }
          };
        };
        _.default = y, Z.exports = _.default;
      }, { "./blur-tables": 202, "@jimp/utils": 235 }], 204: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            circle: function() {
              var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = arguments.length > 1 ? arguments[1] : void 0;
              typeof d == "function" && (l = d, d = {});
              var u = d.radius || (this.bitmap.width > this.bitmap.height ? this.bitmap.height : this.bitmap.width) / 2, a = {
                x: typeof d.x == "number" ? d.x : this.bitmap.width / 2,
                y: typeof d.y == "number" ? d.y : this.bitmap.height / 2
              };
              return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(n, c, g) {
                var f = Math.sqrt(Math.pow(n - a.x, 2) + Math.pow(c - a.y, 2));
                u - f <= 0 ? this.bitmap.data[g + 3] = 0 : u - f < 1 && (this.bitmap.data[g + 3] = 255 * (u - f));
              }), (0, P.isNodePattern)(l) && l.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 205: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var y = x(C("@babel/runtime/helpers/toConsumableArray")), E = x(C("tinycolor2")), d = C("@jimp/utils");
          function l(f, p, s, S) {
            for (var b = [0, 0, 0], o = (p.length - 1) / 2, A = 0; A < p.length; A += 1)
              for (var T = 0; T < p[A].length; T += 1) {
                var R = f.getPixelIndex(s + A - o, S + T - o);
                b[0] += f.bitmap.data[R] * p[A][T], b[1] += f.bitmap.data[R + 1] * p[A][T], b[2] += f.bitmap.data[R + 2] * p[A][T];
              }
            return b;
          }
          var u = function(p) {
            return typeof p < "u" && p !== null;
          };
          function a(f) {
            return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(p, s, S) {
              var b = parseInt(0.2126 * this.bitmap.data[S] + 0.7152 * this.bitmap.data[S + 1] + 0.0722 * this.bitmap.data[S + 2], 10);
              this.bitmap.data[S] = b, this.bitmap.data[S + 1] = b, this.bitmap.data[S + 2] = b;
            }), (0, d.isNodePattern)(f) && f.call(this, null, this), this;
          }
          function n(f, p) {
            var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 50;
            return {
              r: (p.r - f.r) * (s / 100) + f.r,
              g: (p.g - f.g) * (s / 100) + f.g,
              b: (p.b - f.b) * (s / 100) + f.b
            };
          }
          function c(f, p) {
            var s = this;
            return !f || !Array.isArray(f) ? d.throwError.call(this, "actions must be an array", p) : (f = f.map(function(S) {
              return (S.apply === "xor" || S.apply === "mix") && (S.params[0] = (0, E.default)(S.params[0]).toRgb()), S;
            }), this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(S, b, o) {
              var A = {
                r: s.bitmap.data[o],
                g: s.bitmap.data[o + 1],
                b: s.bitmap.data[o + 2]
              }, T = function(L, z) {
                return s.constructor.limit255(A[L] + z);
              };
              f.forEach(function(R) {
                if (R.apply === "mix")
                  A = n(A, R.params[0], R.params[1]);
                else if (R.apply === "tint")
                  A = n(A, {
                    r: 255,
                    g: 255,
                    b: 255
                  }, R.params[0]);
                else if (R.apply === "shade")
                  A = n(A, {
                    r: 0,
                    g: 0,
                    b: 0
                  }, R.params[0]);
                else if (R.apply === "xor")
                  A = {
                    r: A.r ^ R.params[0].r,
                    g: A.g ^ R.params[0].g,
                    b: A.b ^ R.params[0].b
                  };
                else if (R.apply === "red")
                  A.r = T("r", R.params[0]);
                else if (R.apply === "green")
                  A.g = T("g", R.params[0]);
                else if (R.apply === "blue")
                  A.b = T("b", R.params[0]);
                else {
                  var L;
                  if (R.apply === "hue" && (R.apply = "spin"), A = (0, E.default)(A), !A[R.apply])
                    return d.throwError.call(s, "action " + R.apply + " not supported", p);
                  A = (L = A)[R.apply].apply(L, (0, y.default)(R.params)).toRgb();
                }
              }), s.bitmap.data[o] = A.r, s.bitmap.data[o + 1] = A.g, s.bitmap.data[o + 2] = A.b;
            }), (0, d.isNodePattern)(p) && p.call(this, null, this), this);
          }
          var g = function() {
            return {
              /**
               * Adjusts the brightness of the image
               * @param {number} val the amount to adjust the brightness, a number between -1 and +1
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              brightness: function(s, S) {
                return typeof s != "number" ? d.throwError.call(this, "val must be numbers", S) : s < -1 || s > 1 ? d.throwError.call(this, "val must be a number between -1 and +1", S) : (this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(b, o, A) {
                  s < 0 ? (this.bitmap.data[A] = this.bitmap.data[A] * (1 + s), this.bitmap.data[A + 1] = this.bitmap.data[A + 1] * (1 + s), this.bitmap.data[A + 2] = this.bitmap.data[A + 2] * (1 + s)) : (this.bitmap.data[A] = this.bitmap.data[A] + (255 - this.bitmap.data[A]) * s, this.bitmap.data[A + 1] = this.bitmap.data[A + 1] + (255 - this.bitmap.data[A + 1]) * s, this.bitmap.data[A + 2] = this.bitmap.data[A + 2] + (255 - this.bitmap.data[A + 2]) * s);
                }), (0, d.isNodePattern)(S) && S.call(this, null, this), this);
              },
              /**
               * Adjusts the contrast of the image
               * @param {number} val the amount to adjust the contrast, a number between -1 and +1
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              contrast: function(s, S) {
                if (typeof s != "number")
                  return d.throwError.call(this, "val must be numbers", S);
                if (s < -1 || s > 1)
                  return d.throwError.call(this, "val must be a number between -1 and +1", S);
                var b = (s + 1) / (1 - s);
                function o(A) {
                  return A = Math.floor(b * (A - 127) + 127), A < 0 ? 0 : A > 255 ? 255 : A;
                }
                return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(A, T, R) {
                  this.bitmap.data[R] = o(this.bitmap.data[R]), this.bitmap.data[R + 1] = o(this.bitmap.data[R + 1]), this.bitmap.data[R + 2] = o(this.bitmap.data[R + 2]);
                }), (0, d.isNodePattern)(S) && S.call(this, null, this), this;
              },
              /**
               * Apply a posterize effect
               * @param {number} n the amount to adjust the contrast, minimum threshold is two
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              posterize: function(s, S) {
                return typeof s != "number" ? d.throwError.call(this, "n must be numbers", S) : (s < 2 && (s = 2), this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(b, o, A) {
                  this.bitmap.data[A] = Math.floor(this.bitmap.data[A] / 255 * (s - 1)) / (s - 1) * 255, this.bitmap.data[A + 1] = Math.floor(this.bitmap.data[A + 1] / 255 * (s - 1)) / (s - 1) * 255, this.bitmap.data[A + 2] = Math.floor(this.bitmap.data[A + 2] / 255 * (s - 1)) / (s - 1) * 255;
                }), (0, d.isNodePattern)(S) && S.call(this, null, this), this);
              },
              /**
               * Removes colour from the image using ITU Rec 709 luminance values
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              greyscale: a,
              // Alias of greyscale for our American friends
              grayscale: a,
              /**
               * Multiplies the opacity of each pixel by a factor between 0 and 1
               * @param {number} f A number, the factor by which to multiply the opacity of each pixel
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              opacity: function(s, S) {
                return typeof s != "number" ? d.throwError.call(this, "f must be a number", S) : s < 0 || s > 1 ? d.throwError.call(this, "f must be a number from 0 to 1", S) : (this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(b, o, A) {
                  var T = this.bitmap.data[A + 3] * s;
                  this.bitmap.data[A + 3] = T;
                }), (0, d.isNodePattern)(S) && S.call(this, null, this), this);
              },
              /**
               * Applies a sepia tone to the image
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              sepia: function(s) {
                return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(S, b, o) {
                  var A = this.bitmap.data[o], T = this.bitmap.data[o + 1], R = this.bitmap.data[o + 2];
                  A = A * 0.393 + T * 0.769 + R * 0.189, T = A * 0.349 + T * 0.686 + R * 0.168, R = A * 0.272 + T * 0.534 + R * 0.131, this.bitmap.data[o] = A < 255 ? A : 255, this.bitmap.data[o + 1] = T < 255 ? T : 255, this.bitmap.data[o + 2] = R < 255 ? R : 255;
                }), (0, d.isNodePattern)(s) && s.call(this, null, this), this;
              },
              /**
               * Fades each pixel by a factor between 0 and 1
               * @param {number} f A number from 0 to 1. 0 will haven no effect. 1 will turn the image completely transparent.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              fade: function(s, S) {
                return typeof s != "number" ? d.throwError.call(this, "f must be a number", S) : s < 0 || s > 1 ? d.throwError.call(this, "f must be a number from 0 to 1", S) : (this.opacity(1 - s), (0, d.isNodePattern)(S) && S.call(this, null, this), this);
              },
              /**
               * Adds each element of the image to its local neighbors, weighted by the kernel
               * @param {array} kernel a matrix to weight the neighbors sum
               * @param {string} edgeHandling (optional) define how to sum pixels from outside the border
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              convolution: function(s, S, b) {
                typeof S == "function" && typeof b > "u" && (b = S, S = null), S || (S = this.constructor.EDGE_EXTEND);
                var o = P.from(this.bitmap.data), A = s.length, T = s[0].length, R = Math.floor(A / 2), L = Math.floor(T / 2), z = -R, U = -L, J, F, se, ee, ie, W, Q, de, _e, ke;
                return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(Pe, fe, xe) {
                  ee = 0, se = 0, F = 0;
                  for (var Ee = z; Ee <= R; Ee++)
                    for (var Ie = U; Ie <= L; Ie++)
                      de = Pe + Ie, _e = fe + Ee, J = s[Ee + R][Ie + L], ke = this.getPixelIndex(de, _e, S), ke === -1 ? (Q = 0, W = 0, ie = 0) : (ie = this.bitmap.data[ke + 0], W = this.bitmap.data[ke + 1], Q = this.bitmap.data[ke + 2]), F += J * ie, se += J * W, ee += J * Q;
                  F < 0 && (F = 0), se < 0 && (se = 0), ee < 0 && (ee = 0), F > 255 && (F = 255), se > 255 && (se = 255), ee > 255 && (ee = 255), o[xe + 0] = F, o[xe + 1] = se, o[xe + 2] = ee;
                }), this.bitmap.data = o, (0, d.isNodePattern)(b) && b.call(this, null, this), this;
              },
              /**
               * Set the alpha channel on every pixel to fully opaque
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              opaque: function(s) {
                return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(S, b, o) {
                  this.bitmap.data[o + 3] = 255;
                }), (0, d.isNodePattern)(s) && s.call(this, null, this), this;
              },
              /**
               * Pixelates the image or a region
               * @param {number} size the size of the pixels
               * @param {number} x (optional) the x position of the region to pixelate
               * @param {number} y (optional) the y position of the region to pixelate
               * @param {number} w (optional) the width of the region to pixelate
               * @param {number} h (optional) the height of the region to pixelate
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              pixelate: function(s, S, b, o, A, T) {
                if (typeof S == "function")
                  T = S, A = null, o = null, b = null, S = null;
                else {
                  if (typeof s != "number")
                    return d.throwError.call(this, "size must be a number", T);
                  if (u(S) && typeof S != "number")
                    return d.throwError.call(this, "x must be a number", T);
                  if (u(b) && typeof b != "number")
                    return d.throwError.call(this, "y must be a number", T);
                  if (u(o) && typeof o != "number")
                    return d.throwError.call(this, "w must be a number", T);
                  if (u(A) && typeof A != "number")
                    return d.throwError.call(this, "h must be a number", T);
                }
                var R = [[1 / 16, 2 / 16, 1 / 16], [2 / 16, 4 / 16, 2 / 16], [1 / 16, 2 / 16, 1 / 16]];
                S = S || 0, b = b || 0, o = u(o) ? o : this.bitmap.width - S, A = u(A) ? A : this.bitmap.height - b;
                var L = this.cloneQuiet();
                return this.scanQuiet(S, b, o, A, function(z, U, J) {
                  z = s * Math.floor(z / s), U = s * Math.floor(U / s);
                  var F = l(L, R, z, U);
                  this.bitmap.data[J] = F[0], this.bitmap.data[J + 1] = F[1], this.bitmap.data[J + 2] = F[2];
                }), (0, d.isNodePattern)(T) && T.call(this, null, this), this;
              },
              /**
               * Applies a convolution kernel to the image or a region
               * @param {array} kernel the convolution kernel
               * @param {number} x (optional) the x position of the region to apply convolution to
               * @param {number} y (optional) the y position of the region to apply convolution to
               * @param {number} w (optional) the width of the region to apply convolution to
               * @param {number} h (optional) the height of the region to apply convolution to
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              convolute: function(s, S, b, o, A, T) {
                if (!Array.isArray(s)) return d.throwError.call(this, "the kernel must be an array", T);
                if (typeof S == "function")
                  T = S, S = null, b = null, o = null, A = null;
                else {
                  if (u(S) && typeof S != "number")
                    return d.throwError.call(this, "x must be a number", T);
                  if (u(b) && typeof b != "number")
                    return d.throwError.call(this, "y must be a number", T);
                  if (u(o) && typeof o != "number")
                    return d.throwError.call(this, "w must be a number", T);
                  if (u(A) && typeof A != "number")
                    return d.throwError.call(this, "h must be a number", T);
                }
                var R = (s.length - 1) / 2;
                S = u(S) ? S : R, b = u(b) ? b : R, o = u(o) ? o : this.bitmap.width - S, A = u(A) ? A : this.bitmap.height - b;
                var L = this.cloneQuiet();
                return this.scanQuiet(S, b, o, A, function(z, U, J) {
                  var F = l(L, s, z, U);
                  this.bitmap.data[J] = this.constructor.limit255(F[0]), this.bitmap.data[J + 1] = this.constructor.limit255(F[1]), this.bitmap.data[J + 2] = this.constructor.limit255(F[2]);
                }), (0, d.isNodePattern)(T) && T.call(this, null, this), this;
              },
              /**
               * Apply multiple color modification rules
               * @param {array} actions list of color modification rules, in following format: { apply: '<rule-name>', params: [ <rule-parameters> ]  }
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp }this for chaining of methods
               */
              color: c,
              colour: c
            };
          };
          _.default = g, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/toConsumableArray": 20, "@jimp/utils": 235, buffer: 48, tinycolor2: 178 }], 206: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            contain: function(d, l, u, a, n) {
              if (typeof d != "number" || typeof l != "number")
                return P.throwError.call(this, "w and h must be numbers", n);
              typeof u == "string" && (typeof a == "function" && typeof n > "u" && (n = a), a = u, u = null), typeof u == "function" && (typeof n > "u" && (n = u), a = null, u = null), typeof a == "function" && typeof n > "u" && (n = a, a = null), u = u || this.constructor.HORIZONTAL_ALIGN_CENTER | this.constructor.VERTICAL_ALIGN_MIDDLE;
              var c = u & 7, g = u >> 3;
              if (!(c !== 0 && !(c & c - 1) || g !== 0 && !(g & g - 1)))
                return P.throwError.call(this, "only use one flag per alignment direction", n);
              var f = c >> 1, p = g >> 1, s = d / l > this.bitmap.width / this.bitmap.height ? l / this.bitmap.height : d / this.bitmap.width, S = this.cloneQuiet().scale(s, a);
              return this.resize(d, l, a), this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(b, o, A) {
                this.bitmap.data.writeUInt32BE(this._background, A);
              }), this.blit(S, (this.bitmap.width - S.bitmap.width) / 2 * f, (this.bitmap.height - S.bitmap.height) / 2 * p), (0, P.isNodePattern)(n) && n.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 207: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            cover: function(d, l, u, a, n) {
              if (typeof d != "number" || typeof l != "number")
                return P.throwError.call(this, "w and h must be numbers", n);
              u && typeof u == "function" && typeof n > "u" ? (n = u, u = null, a = null) : typeof a == "function" && typeof n > "u" && (n = a, a = null), u = u || this.constructor.HORIZONTAL_ALIGN_CENTER | this.constructor.VERTICAL_ALIGN_MIDDLE;
              var c = u & 7, g = u >> 3;
              if (!(c !== 0 && !(c & c - 1) || g !== 0 && !(g & g - 1))) return P.throwError.call(this, "only use one flag per alignment direction", n);
              var f = c >> 1, p = g >> 1, s = d / l > this.bitmap.width / this.bitmap.height ? d / this.bitmap.width : l / this.bitmap.height;
              return this.scale(s, a), this.crop((this.bitmap.width - d) / 2 * f, (this.bitmap.height - l) / 2 * p, d, l), (0, P.isNodePattern)(n) && n.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 208: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = d;
          var y = x(C("@babel/runtime/helpers/typeof")), E = C("@jimp/utils");
          function d(l) {
            return l("crop", function(u, a, n, c, g) {
              if (typeof u != "number" || typeof a != "number") return E.throwError.call(this, "x and y must be numbers", g);
              if (typeof n != "number" || typeof c != "number") return E.throwError.call(this, "w and h must be numbers", g);
              if (u = Math.round(u), a = Math.round(a), n = Math.round(n), c = Math.round(c), u === 0 && n === this.bitmap.width) {
                var f = n * a + u << 2, p = f + c * n << 2;
                this.bitmap.data = this.bitmap.data.slice(f, p);
              } else {
                var s = P.allocUnsafe(n * c * 4), S = 0;
                this.scanQuiet(u, a, n, c, function(b, o, A) {
                  var T = this.bitmap.data.readUInt32BE(A, !0);
                  s.writeUInt32BE(T, S, !0), S += 4;
                }), this.bitmap.data = s;
              }
              return this.bitmap.width = n, this.bitmap.height = c, (0, E.isNodePattern)(g) && g.call(this, null, this), this;
            }), {
              class: {
                /**
                 * Autocrop same color borders from this image
                 * @param {number} tolerance (optional): a percent value of tolerance for pixels color difference (default: 0.0002%)
                 * @param {boolean} cropOnlyFrames (optional): flag to crop only real frames: all 4 sides of the image must have some border (default: true)
                 * @param {function(Error, Jimp)} cb (optional): a callback for when complete (default: no callback)
                 * @returns {Jimp} this for chaining of methods
                 */
                autocrop: function() {
                  for (var a = this.bitmap.width, n = this.bitmap.height, c = 1, g, f = 0, p = 2e-4, s = !0, S = !1, b = arguments.length, o = new Array(b), A = 0; A < b; A++)
                    o[A] = arguments[A];
                  for (var T = 0, R = o.length; T < R; T++)
                    if (typeof o[T] == "number" && (p = o[T]), typeof o[T] == "boolean" && (s = o[T]), typeof o[T] == "function" && (g = o[T]), (0, y.default)(o[T]) === "object") {
                      var L = o[T];
                      typeof L.tolerance < "u" && (p = L.tolerance), typeof L.cropOnlyFrames < "u" && (s = L.cropOnlyFrames), typeof L.cropSymmetric < "u" && (S = L.cropSymmetric), typeof L.leaveBorder < "u" && (f = L.leaveBorder);
                    }
                  var z = this.getPixelColor(0, 0), U = this.constructor.intToRGBA(z), J = 0, F = 0, se = 0, ee = 0;
                  z = this.getPixelColor(0, 0);
                  e: for (var ie = 0; ie < n - c; ie++) {
                    for (var W = 0; W < a; W++) {
                      var Q = this.getPixelColor(W, ie), de = this.constructor.intToRGBA(Q);
                      if (this.constructor.colorDiff(U, de) > p)
                        break e;
                    }
                    J++;
                  }
                  z = this.getPixelColor(a, 0);
                  e: for (var _e = 0; _e < a - c; _e++) {
                    for (var ke = 0 + J; ke < n; ke++) {
                      var Pe = this.getPixelColor(_e, ke), fe = this.constructor.intToRGBA(Pe);
                      if (this.constructor.colorDiff(U, fe) > p)
                        break e;
                    }
                    F++;
                  }
                  z = this.getPixelColor(0, n);
                  e: for (var xe = n - 1; xe >= J + c; xe--) {
                    for (var Ee = a - F - 1; Ee >= 0; Ee--) {
                      var Ie = this.getPixelColor(Ee, xe), je = this.constructor.intToRGBA(Ie);
                      if (this.constructor.colorDiff(U, je) > p)
                        break e;
                    }
                    se++;
                  }
                  z = this.getPixelColor(a, n);
                  e: for (var Ue = a - 1; Ue >= 0 + F + c; Ue--) {
                    for (var He = n - 1; He >= 0 + J; He--) {
                      var Ze = this.getPixelColor(Ue, He), $e = this.constructor.intToRGBA(Ze);
                      if (this.constructor.colorDiff(U, $e) > p)
                        break e;
                    }
                    ee++;
                  }
                  var We = !1;
                  if (ee -= f, F -= f, J -= f, se -= f, S) {
                    var Ve = Math.min(F, ee), Re = Math.min(J, se);
                    ee = Ve, F = Ve, J = Re, se = Re;
                  }
                  ee = ee >= 0 ? ee : 0, F = F >= 0 ? F : 0, J = J >= 0 ? J : 0, se = se >= 0 ? se : 0;
                  var De = a - (ee + F), Ne = n - (se + J);
                  return s ? We = F !== 0 && J !== 0 && ee !== 0 && se !== 0 : We = F !== 0 || J !== 0 || ee !== 0 || se !== 0, We && this.crop(F, J, De, Ne), (0, E.isNodePattern)(g) && g.call(this, null, this), this;
                }
              }
            };
          }
          Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/typeof": 21, "@jimp/utils": 235, buffer: 48 }], 209: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/typeof")), y = C("@jimp/utils"), E = function() {
          return {
            displace: function(u, a, n) {
              if ((0, x.default)(u) !== "object" || u.constructor !== this.constructor)
                return y.throwError.call(this, "The source must be a Jimp image", n);
              if (typeof a != "number")
                return y.throwError.call(this, "factor must be a number", n);
              var c = this.cloneQuiet();
              return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(g, f, p) {
                var s = u.bitmap.data[p] / 256 * a;
                s = Math.round(s);
                var S = this.getPixelIndex(g + s, f);
                this.bitmap.data[S] = c.bitmap.data[p], this.bitmap.data[S + 1] = c.bitmap.data[p + 1], this.bitmap.data[S + 2] = c.bitmap.data[p + 2];
              }), (0, y.isNodePattern)(n) && n.call(this, null, this), this;
            }
          };
        };
        _.default = E, Z.exports = _.default;
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/typeof": 21, "@jimp/utils": 235 }], 210: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils");
        function x(E) {
          var d = [1, 9, 3, 11, 13, 5, 15, 7, 4, 12, 2, 10, 16, 8, 14, 6];
          return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(l, u, a) {
            var n = ((u & 3) << 2) + l % 4, c = d[n];
            this.bitmap.data[a] = Math.min(this.bitmap.data[a] + c, 255), this.bitmap.data[a + 1] = Math.min(this.bitmap.data[a + 1] + c, 255), this.bitmap.data[a + 2] = Math.min(this.bitmap.data[a + 2] + c, 255);
          }), (0, P.isNodePattern)(E) && E.call(this, null, this), this;
        }
        var y = function() {
          return {
            dither565: x,
            dither16: x
          };
        };
        _.default = y, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 211: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            fisheye: function() {
              var d = this, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                r: 2.5
              }, u = arguments.length > 1 ? arguments[1] : void 0;
              typeof l == "function" && (u = l, l = {
                r: 2.5
              });
              var a = this.cloneQuiet(), n = a.bitmap, c = n.width, g = n.height;
              return a.scanQuiet(0, 0, c, g, function(f, p) {
                var s = f / c, S = p / g, b = Math.sqrt(Math.pow(s - 0.5, 2) + Math.pow(S - 0.5, 2)), o = 2 * Math.pow(b, l.r), A = (s - 0.5) / b, T = (S - 0.5) / b, R = Math.round((o * A + 0.5) * c), L = Math.round((o * T + 0.5) * g), z = a.getPixelColor(R, L);
                d.setPixelColor(z, f, p);
              }), this.setPixelColor(a.getPixelColor(c / 2, g / 2), c / 2, g / 2), (0, P.isNodePattern)(u) && u.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 212: [function(C, Z, _) {
        (function(P) {
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var x = C("@jimp/utils");
          function y(d, l, u) {
            if (typeof d != "boolean" || typeof l != "boolean") return x.throwError.call(this, "horizontal and vertical must be Booleans", u);
            var a = P.alloc(this.bitmap.data.length);
            return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(n, c, g) {
              var f = d ? this.bitmap.width - 1 - n : n, p = l ? this.bitmap.height - 1 - c : c, s = this.bitmap.width * p + f << 2, S = this.bitmap.data.readUInt32BE(g);
              a.writeUInt32BE(S, s);
            }), this.bitmap.data = P.from(a), (0, x.isNodePattern)(u) && u.call(this, null, this), this;
          }
          var E = function() {
            return {
              flip: y,
              mirror: y
            };
          };
          _.default = E, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@jimp/utils": 235, buffer: 48 }], 213: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            gaussian: function(d, l) {
              if (typeof d != "number")
                return P.throwError.call(this, "r must be a number", l);
              if (d < 1)
                return P.throwError.call(this, "r must be greater than 0", l);
              for (var u = Math.ceil(d * 2.57), a = u * 2 + 1, n = d * d * 2, c = n * Math.PI, g = [], f = 0; f < a; f++) {
                g[f] = [];
                for (var p = 0; p < a; p++) {
                  var s = Math.pow(p - u, 2) + Math.pow(f - u, 2);
                  g[f][p] = Math.exp(-s / n) / c;
                }
              }
              for (var S = 0; S < this.bitmap.height; S++)
                for (var b = 0; b < this.bitmap.width; b++)
                  for (var o = 0, A = 0, T = 0, R = 0, L = 0, z = 0; z < a; z++) {
                    for (var U = 0; U < a; U++) {
                      var J = Math.min(this.bitmap.width - 1, Math.max(0, U + b - u)), F = Math.min(this.bitmap.height - 1, Math.max(0, z + S - u)), se = g[z][U], ee = F * this.bitmap.width + J << 2;
                      o += this.bitmap.data[ee] * se, A += this.bitmap.data[ee + 1] * se, T += this.bitmap.data[ee + 2] * se, R += this.bitmap.data[ee + 3] * se, L += se;
                    }
                    var ie = S * this.bitmap.width + b << 2;
                    this.bitmap.data[ie] = Math.round(o / L), this.bitmap.data[ie + 1] = Math.round(A / L), this.bitmap.data[ie + 2] = Math.round(T / L), this.bitmap.data[ie + 3] = Math.round(R / L);
                  }
              return (0, P.isNodePattern)(l) && l.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 214: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            invert: function(d) {
              return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(l, u, a) {
                this.bitmap.data[a] = 255 - this.bitmap.data[a], this.bitmap.data[a + 1] = 255 - this.bitmap.data[a + 1], this.bitmap.data[a + 2] = 255 - this.bitmap.data[a + 2];
              }), (0, P.isNodePattern)(d) && d.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 215: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            mask: function(d) {
              var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 ? arguments[3] : void 0;
              if (!(d instanceof this.constructor))
                return P.throwError.call(this, "The source must be a Jimp image", a);
              if (typeof l != "number" || typeof u != "number")
                return P.throwError.call(this, "x and y must be numbers", a);
              l = Math.round(l), u = Math.round(u);
              var n = this.bitmap.width, c = this.bitmap.height, g = this;
              return d.scanQuiet(0, 0, d.bitmap.width, d.bitmap.height, function(f, p, s) {
                var S = l + f, b = u + p;
                if (S >= 0 && b >= 0 && S < n && b < c) {
                  var o = g.getPixelIndex(S, b), A = this.bitmap.data, T = (A[s + 0] + A[s + 1] + A[s + 2]) / 3;
                  g.bitmap.data[o + 3] *= T / 255;
                }
              }), (0, P.isNodePattern)(a) && a.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 216: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils");
        function x() {
          var l = {
            r: new Array(256).fill(0),
            g: new Array(256).fill(0),
            b: new Array(256).fill(0)
          };
          return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(u, a, n) {
            l.r[this.bitmap.data[n + 0]]++, l.g[this.bitmap.data[n + 1]]++, l.b[this.bitmap.data[n + 2]]++;
          }), l;
        }
        var y = function(u, a, n) {
          return (u - a) * 255 / (n - a);
        }, E = function(u) {
          return [u.findIndex(function(a) {
            return a > 0;
          }), 255 - u.slice().reverse().findIndex(function(a) {
            return a > 0;
          })];
        }, d = function() {
          return {
            normalize: function(a) {
              var n = x.call(this), c = {
                r: E(n.r),
                g: E(n.g),
                b: E(n.b)
              };
              return this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(g, f, p) {
                var s = this.bitmap.data[p + 0], S = this.bitmap.data[p + 1], b = this.bitmap.data[p + 2];
                this.bitmap.data[p + 0] = y(s, c.r[0], c.r[1]), this.bitmap.data[p + 1] = y(S, c.g[0], c.g[1]), this.bitmap.data[p + 2] = y(b, c.b[0], c.b[1]);
              }), (0, P.isNodePattern)(a) && a.call(this, null, this), this;
            }
          };
        };
        _.default = d, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 217: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var y = x(C("@babel/runtime/helpers/typeof")), E = x(C("@babel/runtime/helpers/toConsumableArray")), d = x(C("path")), l = x(C("load-bmfont")), u = C("@jimp/utils"), a = C("./measure-text");
          function n(b, o, A, T, R) {
            return R === b.HORIZONTAL_ALIGN_LEFT ? 0 : R === b.HORIZONTAL_ALIGN_CENTER ? (T - (0, a.measureText)(o, A)) / 2 : T - (0, a.measureText)(o, A);
          }
          function c(b, o, A, T, R) {
            if (R.width > 0 && R.height > 0) {
              var L = o.pages[R.page];
              b.blit(L, A + R.xoffset, T + R.yoffset, R.x, R.y, R.width, R.height);
            }
            return b;
          }
          function g(b, o, A, T, R) {
            for (var L = 0; L < T.length; L++) {
              var z = void 0;
              b.chars[T[L]] ? z = T[L] : /\s/.test(T[L]) ? z = "" : z = "?";
              var U = b.chars[z] || {}, J = b.kernings[z];
              c(this, b, o, A, U || {});
              var F = J && J[T[L + 1]] ? J[T[L + 1]] : 0;
              o += F + (U.xadvance || R);
            }
          }
          function f(b, o, A) {
            var T = o.split(" "), R = [], L = [], z = 0;
            return T.forEach(function(U) {
              var J = [].concat((0, E.default)(L), [U]).join(" "), F = (0, a.measureText)(b, J);
              F <= A ? (F > z && (z = F), L.push(U)) : (R.push(L), L = [U]);
            }), R.push(L), {
              lines: R,
              longestLine: z
            };
          }
          function p(b, o, A) {
            var T = A.map(function(R) {
              return b.read(o + "/" + R);
            });
            return Promise.all(T);
          }
          var s = "browser/lib/", S = function() {
            return {
              constants: {
                measureText: a.measureText,
                measureTextHeight: a.measureTextHeight,
                FONT_SANS_8_BLACK: d.default.join(s, "fonts/open-sans/open-sans-8-black/open-sans-8-black.fnt"),
                FONT_SANS_10_BLACK: d.default.join(s, "fonts/open-sans/open-sans-10-black/open-sans-10-black.fnt"),
                FONT_SANS_12_BLACK: d.default.join(s, "fonts/open-sans/open-sans-12-black/open-sans-12-black.fnt"),
                FONT_SANS_14_BLACK: d.default.join(s, "fonts/open-sans/open-sans-14-black/open-sans-14-black.fnt"),
                FONT_SANS_16_BLACK: d.default.join(s, "fonts/open-sans/open-sans-16-black/open-sans-16-black.fnt"),
                FONT_SANS_32_BLACK: d.default.join(s, "fonts/open-sans/open-sans-32-black/open-sans-32-black.fnt"),
                FONT_SANS_64_BLACK: d.default.join(s, "fonts/open-sans/open-sans-64-black/open-sans-64-black.fnt"),
                FONT_SANS_128_BLACK: d.default.join(s, "fonts/open-sans/open-sans-128-black/open-sans-128-black.fnt"),
                FONT_SANS_8_WHITE: d.default.join(s, "fonts/open-sans/open-sans-8-white/open-sans-8-white.fnt"),
                FONT_SANS_16_WHITE: d.default.join(s, "fonts/open-sans/open-sans-16-white/open-sans-16-white.fnt"),
                FONT_SANS_32_WHITE: d.default.join(s, "fonts/open-sans/open-sans-32-white/open-sans-32-white.fnt"),
                FONT_SANS_64_WHITE: d.default.join(s, "fonts/open-sans/open-sans-64-white/open-sans-64-white.fnt"),
                FONT_SANS_128_WHITE: d.default.join(s, "fonts/open-sans/open-sans-128-white/open-sans-128-white.fnt"),
                /**
                 * Loads a bitmap font from a file
                 * @param {string} file the file path of a .fnt file
                 * @param {function(Error, Jimp)} cb (optional) a function to call when the font is loaded
                 * @returns {Promise} a promise
                 */
                loadFont: function(A, T) {
                  var R = this;
                  return typeof A != "string" ? u.throwError.call(this, "file must be a string", T) : new Promise(function(L, z) {
                    T = T || function(U, J) {
                      U ? z(U) : L(J);
                    }, (0, l.default)(A, function(U, J) {
                      var F = {}, se = {};
                      if (U)
                        return u.throwError.call(R, U, T);
                      for (var ee = 0; ee < J.chars.length; ee++)
                        F[String.fromCharCode(J.chars[ee].id)] = J.chars[ee];
                      for (var ie = 0; ie < J.kernings.length; ie++) {
                        var W = String.fromCharCode(J.kernings[ie].first);
                        se[W] = se[W] || {}, se[W][String.fromCharCode(J.kernings[ie].second)] = J.kernings[ie].amount;
                      }
                      p(R, d.default.dirname(A), J.pages).then(function(Q) {
                        T(null, {
                          chars: F,
                          kernings: se,
                          pages: Q,
                          common: J.common,
                          info: J.info
                        });
                      });
                    });
                  });
                }
              },
              class: {
                /**
                 * Draws a text on a image on a given boundary
                 * @param {Jimp} font a bitmap font loaded from `Jimp.loadFont` command
                 * @param {number} x the x position to start drawing the text
                 * @param {number} y the y position to start drawing the text
                 * @param {any} text the text to draw (string or object with `text`, `alignmentX`, and/or `alignmentY`)
                 * @param {number} maxWidth (optional) the boundary width to draw in
                 * @param {number} maxHeight (optional) the boundary height to draw in
                 * @param {function(Error, Jimp)} cb (optional) a function to call when the text is written
                 * @returns {Jimp} this for chaining of methods
                 */
                print: function(A, T, R, L, z, U, J) {
                  var F = this;
                  if (typeof z == "function" && typeof J > "u" && (J = z, z = 1 / 0), typeof z > "u" && (z = 1 / 0), typeof U == "function" && typeof J > "u" && (J = U, U = 1 / 0), typeof U > "u" && (U = 1 / 0), (0, y.default)(A) !== "object")
                    return u.throwError.call(this, "font must be a Jimp loadFont", J);
                  if (typeof T != "number" || typeof R != "number" || typeof z != "number")
                    return u.throwError.call(this, "x, y and maxWidth must be numbers", J);
                  if (typeof z != "number")
                    return u.throwError.call(this, "maxWidth must be a number", J);
                  if (typeof U != "number")
                    return u.throwError.call(this, "maxHeight must be a number", J);
                  var se, ee;
                  if ((0, y.default)(L) === "object" && L.text !== null && L.text !== void 0) {
                    se = L.alignmentX || this.constructor.HORIZONTAL_ALIGN_LEFT, ee = L.alignmentY || this.constructor.VERTICAL_ALIGN_TOP;
                    var ie = L;
                    L = ie.text;
                  } else
                    se = this.constructor.HORIZONTAL_ALIGN_LEFT, ee = this.constructor.VERTICAL_ALIGN_TOP, L = L.toString();
                  U !== 1 / 0 && ee === this.constructor.VERTICAL_ALIGN_BOTTOM ? R += U - (0, a.measureTextHeight)(A, L, z) : U !== 1 / 0 && ee === this.constructor.VERTICAL_ALIGN_MIDDLE && (R += U / 2 - (0, a.measureTextHeight)(A, L, z) / 2);
                  var W = Object.entries(A.chars)[0][1].xadvance, Q = f(A, L, z), de = Q.lines, _e = Q.longestLine;
                  return de.forEach(function(ke) {
                    var Pe = ke.join(" "), fe = n(F.constructor, A, Pe, z, se);
                    g.call(F, A, T + fe, R, Pe, W), R += A.common.lineHeight;
                  }), (0, u.isNodePattern)(J) && J.call(this, null, this, {
                    x: T + _e,
                    y: R
                  }), this;
                }
              }
            };
          };
          _.default = S, Z.exports = _.default;
        }).call(this, "/../../node_modules/@jimp/plugin-print/dist");
      }, { "./measure-text": 218, "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/toConsumableArray": 20, "@babel/runtime/helpers/typeof": 21, "@jimp/utils": 235, "load-bmfont": 219, path: 107 }], 218: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.measureText = P, _.measureTextHeight = x;
        function P(y, E) {
          for (var d = 0, l = 0; l < E.length; l++)
            if (y.chars[E[l]]) {
              var u = y.kernings[E[l]] && y.kernings[E[l]][E[l + 1]] ? y.kernings[E[l]][E[l + 1]] : 0;
              d += (y.chars[E[l]].xadvance || 0) + u;
            }
          return d;
        }
        function x(y, E, d) {
          for (var l = E.split(" "), u = "", a = y.common.lineHeight, n = 0; n < l.length; n++) {
            var c = u + l[n] + " ", g = P(y, c);
            g > d && n > 0 ? (a += y.common.lineHeight, u = l[n] + " ") : u = c;
          }
          return a;
        }
      }, {}], 219: [function(C, Z, _) {
        (function(P) {
          var x = C("xhr"), y = function() {
          }, E = C("parse-bmfont-ascii"), d = C("parse-bmfont-xml"), l = C("parse-bmfont-binary"), u = C("./lib/is-binary"), a = C("xtend"), n = function() {
            return self.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
          }();
          Z.exports = function(f, p) {
            p = typeof p == "function" ? p : y, typeof f == "string" ? f = { uri: f } : f || (f = {});
            var s = f.binary;
            s && (f = g(f)), x(f, function(S, b, o) {
              if (S)
                return p(S);
              if (!/^2/.test(b.statusCode))
                return p(new Error("http status code: " + b.statusCode));
              if (!o)
                return p(new Error("no body result"));
              var A = !1;
              if (c(o)) {
                var T = new Uint8Array(o);
                o = new P(T, "binary");
              }
              u(o) && (A = !0, typeof o == "string" && (o = new P(o, "binary"))), A || (P.isBuffer(o) && (o = o.toString(f.encoding)), o = o.trim());
              var R;
              try {
                var L = b.headers["content-type"];
                A ? R = l(o) : /json/.test(L) || o.charAt(0) === "{" ? R = JSON.parse(o) : /xml/.test(L) || o.charAt(0) === "<" ? R = d(o) : R = E(o);
              } catch (z) {
                p(new Error("error parsing font " + z.message)), p = y;
              }
              p(null, R);
            });
          };
          function c(f) {
            var p = Object.prototype.toString;
            return p.call(f) === "[object ArrayBuffer]";
          }
          function g(f) {
            if (n)
              return a(f, { responseType: "arraybuffer" });
            if (typeof self.XMLHttpRequest > "u")
              throw new Error("your browser does not support XHR loading");
            var p = new self.XMLHttpRequest();
            return p.overrideMimeType("text/plain; charset=x-user-defined"), a({
              xhr: p
            }, f);
          }
        }).call(this, C("buffer").Buffer);
      }, { "./lib/is-binary": 220, buffer: 48, "parse-bmfont-ascii": 102, "parse-bmfont-binary": 103, "parse-bmfont-xml": 104, xhr: 187, xtend: 189 }], 220: [function(C, Z, _) {
        (function(P) {
          var x = C("buffer-equal"), y = new P([66, 77, 70, 3]);
          Z.exports = function(E) {
            return typeof E == "string" ? E.substring(0, 3) === "BMF" : E.length > 4 && x(E.slice(0, 4), y);
          };
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48, "buffer-equal": 49 }], 221: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var y = C("@jimp/utils"), E = x(C("./modules/resize")), d = x(C("./modules/resize2")), l = function() {
            return {
              constants: {
                RESIZE_NEAREST_NEIGHBOR: "nearestNeighbor",
                RESIZE_BILINEAR: "bilinearInterpolation",
                RESIZE_BICUBIC: "bicubicInterpolation",
                RESIZE_HERMITE: "hermiteInterpolation",
                RESIZE_BEZIER: "bezierInterpolation"
              },
              class: {
                /**
                 * Resizes the image to a set width and height using a 2-pass bilinear algorithm
                 * @param {number} w the width to resize the image to (or Jimp.AUTO)
                 * @param {number} h the height to resize the image to (or Jimp.AUTO)
                 * @param {string} mode (optional) a scaling method (e.g. Jimp.RESIZE_BEZIER)
                 * @param {function(Error, Jimp)} cb (optional) a callback for when complete
                 * @returns {Jimp} this for chaining of methods
                 */
                resize: function(n, c, g, f) {
                  if (typeof n != "number" || typeof c != "number")
                    return y.throwError.call(this, "w and h must be numbers", f);
                  if (typeof g == "function" && typeof f > "u" && (f = g, g = null), n === this.constructor.AUTO && c === this.constructor.AUTO)
                    return y.throwError.call(this, "w and h cannot both be set to auto", f);
                  if (n === this.constructor.AUTO && (n = this.bitmap.width * (c / this.bitmap.height)), c === this.constructor.AUTO && (c = this.bitmap.height * (n / this.bitmap.width)), n < 0 || c < 0)
                    return y.throwError.call(this, "w and h must be positive numbers", f);
                  if (n = Math.round(n), c = Math.round(c), typeof d.default[g] == "function") {
                    var p = {
                      data: P.alloc(n * c * 4),
                      width: n,
                      height: c
                    };
                    d.default[g](this.bitmap, p), this.bitmap = p;
                  } else {
                    var s = this, S = new E.default(this.bitmap.width, this.bitmap.height, n, c, !0, !0, function(b) {
                      s.bitmap.data = P.from(b), s.bitmap.width = n, s.bitmap.height = c;
                    });
                    S.resize(this.bitmap.data);
                  }
                  return (0, y.isNodePattern)(f) && f.call(this, null, this), this;
                }
              }
            };
          };
          _.default = l, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "./modules/resize": 222, "./modules/resize2": 223, "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/utils": 235, buffer: 48 }], 222: [function(C, Z, _) {
        function P(x, y, E, d, l, u, a) {
          this.widthOriginal = Math.abs(Math.floor(x) || 0), this.heightOriginal = Math.abs(Math.floor(y) || 0), this.targetWidth = Math.abs(Math.floor(E) || 0), this.targetHeight = Math.abs(Math.floor(d) || 0), this.colorChannels = l ? 4 : 3, this.interpolationPass = !!u, this.resizeCallback = typeof a == "function" ? a : function() {
          }, this.targetWidthMultipliedByChannels = this.targetWidth * this.colorChannels, this.originalWidthMultipliedByChannels = this.widthOriginal * this.colorChannels, this.originalHeightMultipliedByChannels = this.heightOriginal * this.colorChannels, this.widthPassResultSize = this.targetWidthMultipliedByChannels * this.heightOriginal, this.finalResultSize = this.targetWidthMultipliedByChannels * this.targetHeight, this.initialize();
        }
        P.prototype.initialize = function() {
          if (this.widthOriginal > 0 && this.heightOriginal > 0 && this.targetWidth > 0 && this.targetHeight > 0)
            this.configurePasses();
          else
            throw new Error("Invalid settings specified for the resizer.");
        }, P.prototype.configurePasses = function() {
          this.widthOriginal === this.targetWidth ? this.resizeWidth = this.bypassResizer : (this.ratioWeightWidthPass = this.widthOriginal / this.targetWidth, this.ratioWeightWidthPass < 1 && this.interpolationPass ? (this.initializeFirstPassBuffers(!0), this.resizeWidth = this.colorChannels === 4 ? this.resizeWidthInterpolatedRGBA : this.resizeWidthInterpolatedRGB) : (this.initializeFirstPassBuffers(!1), this.resizeWidth = this.colorChannels === 4 ? this.resizeWidthRGBA : this.resizeWidthRGB)), this.heightOriginal === this.targetHeight ? this.resizeHeight = this.bypassResizer : (this.ratioWeightHeightPass = this.heightOriginal / this.targetHeight, this.ratioWeightHeightPass < 1 && this.interpolationPass ? (this.initializeSecondPassBuffers(!0), this.resizeHeight = this.resizeHeightInterpolated) : (this.initializeSecondPassBuffers(!1), this.resizeHeight = this.colorChannels === 4 ? this.resizeHeightRGBA : this.resizeHeightRGB));
        }, P.prototype._resizeWidthInterpolatedRGBChannels = function(x, y) {
          var E = y ? 4 : 3, d = this.ratioWeightWidthPass, l = this.widthBuffer, u = 0, a = 0, n = 0, c = 0, g = 0, f;
          for (f = 0; u < 1 / 3; f += E, u += d)
            for (a = f, n = 0; a < this.widthPassResultSize; n += this.originalWidthMultipliedByChannels, a += this.targetWidthMultipliedByChannels)
              l[a] = x[n], l[a + 1] = x[n + 1], l[a + 2] = x[n + 2], y && (l[a + 3] = x[n + 3]);
          u -= 1 / 3;
          var p;
          for (p = this.widthOriginal - 1; u < p; f += E, u += d)
            for (g = u % 1, c = 1 - g, a = f, n = Math.floor(u) * E; a < this.widthPassResultSize; n += this.originalWidthMultipliedByChannels, a += this.targetWidthMultipliedByChannels)
              l[a + 0] = x[n + 0] * c + x[n + E + 0] * g, l[a + 1] = x[n + 1] * c + x[n + E + 1] * g, l[a + 2] = x[n + 2] * c + x[n + E + 2] * g, y && (l[a + 3] = x[n + 3] * c + x[n + E + 3] * g);
          for (p = this.originalWidthMultipliedByChannels - E; f < this.targetWidthMultipliedByChannels; f += E)
            for (a = f, n = p; a < this.widthPassResultSize; n += this.originalWidthMultipliedByChannels, a += this.targetWidthMultipliedByChannels)
              l[a] = x[n], l[a + 1] = x[n + 1], l[a + 2] = x[n + 2], y && (l[a + 3] = x[n + 3]);
          return l;
        }, P.prototype._resizeWidthRGBChannels = function(x, y) {
          var E = y ? 4 : 3, d = this.ratioWeightWidthPass, l = 1 / d, u = this.originalWidthMultipliedByChannels - E + 1, a = this.targetWidthMultipliedByChannels - E + 1, n = this.outputWidthWorkBench, c = this.widthBuffer, g = this.outputWidthWorkBenchOpaquePixelsCount, f = 0, p = 0, s = 0, S = 0, b = 0, o = 0, A = 0, T = 1, R = 0, L = 0, z = 0, U = 0;
          do {
            for (b = 0; b < this.originalHeightMultipliedByChannels; )
              n[b++] = 0, n[b++] = 0, n[b++] = 0, y && (n[b++] = 0, g[b / E - 1] = 0);
            f = d;
            do {
              for (p = 1 + s - S, T = Math.min(f, p), b = 0, o = s; b < this.originalHeightMultipliedByChannels; o += u)
                R = x[o], L = x[++o], z = x[++o], U = y ? x[++o] : 255, n[b++] += (U ? R : 0) * T, n[b++] += (U ? L : 0) * T, n[b++] += (U ? z : 0) * T, y && (n[b++] += U * T, g[b / E - 1] += U ? T : 0);
              if (f >= p)
                s += E, S = s, f -= p;
              else {
                S += f;
                break;
              }
            } while (f > 0 && s < this.originalWidthMultipliedByChannels);
            for (b = 0, o = A; b < this.originalHeightMultipliedByChannels; o += a)
              f = y ? g[b / E] : 1, T = y ? f ? 1 / f : 0 : l, c[o] = n[b++] * T, c[++o] = n[b++] * T, c[++o] = n[b++] * T, y && (c[++o] = n[b++] * l);
            A += E;
          } while (A < this.targetWidthMultipliedByChannels);
          return c;
        }, P.prototype._resizeHeightRGBChannels = function(x, y) {
          var E = this.ratioWeightHeightPass, d = 1 / E, l = this.outputHeightWorkBench, u = this.heightBuffer, a = this.outputHeightWorkBenchOpaquePixelsCount, n = 0, c = 0, g = 0, f = 0, p = 0, s = 0, S = 0, b = 1, o = 0, A = 0, T = 0, R = 0;
          do {
            for (p = 0; p < this.targetWidthMultipliedByChannels; )
              l[p++] = 0, l[p++] = 0, l[p++] = 0, y && (l[p++] = 0, a[p / 4 - 1] = 0);
            n = E;
            do {
              for (c = 1 + g - f, b = Math.min(n, c), S = g, p = 0; p < this.targetWidthMultipliedByChannels; )
                o = x[S++], A = x[S++], T = x[S++], R = y ? x[S++] : 255, l[p++] += (R ? o : 0) * b, l[p++] += (R ? A : 0) * b, l[p++] += (R ? T : 0) * b, y && (l[p++] += R * b, a[p / 4 - 1] += R ? b : 0);
              if (n >= c)
                g = S, f = g, n -= c;
              else {
                f += n;
                break;
              }
            } while (n > 0 && g < this.widthPassResultSize);
            for (p = 0; p < this.targetWidthMultipliedByChannels; )
              n = y ? a[p / 4] : 1, b = y ? n ? 1 / n : 0 : d, u[s++] = Math.round(l[p++] * b), u[s++] = Math.round(l[p++] * b), u[s++] = Math.round(l[p++] * b), y && (u[s++] = Math.round(l[p++] * d));
          } while (s < this.finalResultSize);
          return u;
        }, P.prototype.resizeWidthInterpolatedRGB = function(x) {
          return this._resizeWidthInterpolatedRGBChannels(x, !1);
        }, P.prototype.resizeWidthInterpolatedRGBA = function(x) {
          return this._resizeWidthInterpolatedRGBChannels(x, !0);
        }, P.prototype.resizeWidthRGB = function(x) {
          return this._resizeWidthRGBChannels(x, !1);
        }, P.prototype.resizeWidthRGBA = function(x) {
          return this._resizeWidthRGBChannels(x, !0);
        }, P.prototype.resizeHeightInterpolated = function(x) {
          for (var y = this.ratioWeightHeightPass, E = this.heightBuffer, d = 0, l = 0, u = 0, a = 0, n = 0, c = 0, g = 0, f; d < 1 / 3; d += y)
            for (u = 0; u < this.targetWidthMultipliedByChannels; )
              E[l++] = Math.round(x[u++]);
          for (d -= 1 / 3, f = this.heightOriginal - 1; d < f; d += y)
            for (g = d % 1, c = 1 - g, a = Math.floor(d) * this.targetWidthMultipliedByChannels, n = a + this.targetWidthMultipliedByChannels, u = 0; u < this.targetWidthMultipliedByChannels; ++u)
              E[l++] = Math.round(x[a++] * c + x[n++] * g);
          for (; l < this.finalResultSize; )
            for (u = 0, a = f * this.targetWidthMultipliedByChannels; u < this.targetWidthMultipliedByChannels; ++u)
              E[l++] = Math.round(x[a++]);
          return E;
        }, P.prototype.resizeHeightRGB = function(x) {
          return this._resizeHeightRGBChannels(x, !1);
        }, P.prototype.resizeHeightRGBA = function(x) {
          return this._resizeHeightRGBChannels(x, !0);
        }, P.prototype.resize = function(x) {
          this.resizeCallback(this.resizeHeight(this.resizeWidth(x)));
        }, P.prototype.bypassResizer = function(x) {
          return x;
        }, P.prototype.initializeFirstPassBuffers = function(x) {
          this.widthBuffer = this.generateFloatBuffer(this.widthPassResultSize), x || (this.outputWidthWorkBench = this.generateFloatBuffer(this.originalHeightMultipliedByChannels), this.colorChannels > 3 && (this.outputWidthWorkBenchOpaquePixelsCount = this.generateFloat64Buffer(this.heightOriginal)));
        }, P.prototype.initializeSecondPassBuffers = function(x) {
          this.heightBuffer = this.generateUint8Buffer(this.finalResultSize), x || (this.outputHeightWorkBench = this.generateFloatBuffer(this.targetWidthMultipliedByChannels), this.colorChannels > 3 && (this.outputHeightWorkBenchOpaquePixelsCount = this.generateFloat64Buffer(this.targetWidth)));
        }, P.prototype.generateFloatBuffer = function(x) {
          try {
            return new Float32Array(x);
          } catch {
            return [];
          }
        }, P.prototype.generateFloat64Buffer = function(x) {
          try {
            return new Float64Array(x);
          } catch {
            return [];
          }
        }, P.prototype.generateUint8Buffer = function(x) {
          try {
            return new Uint8Array(x);
          } catch {
            return [];
          }
        }, Z.exports = P;
      }, {}], 223: [function(C, Z, _) {
        (function(P) {
          Z.exports = {
            nearestNeighbor: function(y, E) {
              for (var d = y.width, l = y.height, u = E.width, a = E.height, n = y.data, c = E.data, g = 0; g < a; g++)
                for (var f = 0; f < u; f++) {
                  var p = (g * u + f) * 4, s = Math.floor(g * l / a), S = Math.floor(f * d / u), b = (s * d + S) * 4;
                  c[p++] = n[b++], c[p++] = n[b++], c[p++] = n[b++], c[p++] = n[b++];
                }
            },
            bilinearInterpolation: function(y, E) {
              for (var d = y.width, l = y.height, u = E.width, a = E.height, n = y.data, c = E.data, g = function(U, J, F, se, ee) {
                return J === se ? F : Math.round((U - J) * ee + (se - U) * F);
              }, f = function(U, J, F, se, ee, ie, W, Q) {
                var de = (W * d + se) * 4 + J, _e = (W * d + ee) * 4 + J, ke = g(F, se, n[de], ee, n[_e]);
                if (Q === W)
                  c[U + J] = ke;
                else {
                  de = (Q * d + se) * 4 + J, _e = (Q * d + ee) * 4 + J;
                  var Pe = g(F, se, n[de], ee, n[_e]);
                  c[U + J] = g(ie, W, ke, Q, Pe);
                }
              }, p = 0; p < a; p++)
                for (var s = 0; s < u; s++) {
                  var S = (p * u + s) * 4, b = s * d / u, o = Math.floor(b), A = Math.min(Math.ceil(b), d - 1), T = p * l / a, R = Math.floor(T), L = Math.min(Math.ceil(T), l - 1);
                  f(S, 0, b, o, A, T, R, L), f(S, 1, b, o, A, T, R, L), f(S, 2, b, o, A, T, R, L), f(S, 3, b, o, A, T, R, L);
                }
            },
            _interpolate2D: function(y, E, d, l) {
              for (var u = y.data, a = E.data, n = y.width, c = y.height, g = E.width, f = E.height, p = Math.max(1, Math.floor(n / g)), s = g * p, S = Math.max(1, Math.floor(c / f)), b = f * S, o = P.alloc(s * c * 4), A = 0; A < c; A++)
                for (var T = 0; T < s; T++)
                  for (var R = T * (n - 1) / s, L = Math.floor(R), z = R - L, U = (A * n + L) * 4, J = (A * s + T) * 4, F = 0; F < 4; F++) {
                    var se = U + F, ee = L > 0 ? u[se - 4] : 2 * u[se] - u[se + 4], ie = u[se], W = u[se + 4], Q = L < n - 2 ? u[se + 8] : 2 * u[se + 4] - u[se];
                    o[J + F] = l(ee, ie, W, Q, z);
                  }
              for (var de = P.alloc(s * b * 4), _e = 0; _e < b; _e++)
                for (var ke = 0; ke < s; ke++)
                  for (var Pe = _e * (c - 1) / b, fe = Math.floor(Pe), xe = Pe - fe, Ee = (fe * s + ke) * 4, Ie = (_e * s + ke) * 4, je = 0; je < 4; je++) {
                    var Ue = Ee + je, He = fe > 0 ? o[Ue - s * 4] : 2 * o[Ue] - o[Ue + s * 4], Ze = o[Ue], $e = o[Ue + s * 4], We = fe < c - 2 ? o[Ue + s * 8] : 2 * o[Ue + s * 4] - o[Ue];
                    de[Ie + je] = l(He, Ze, $e, We, xe);
                  }
              var Ve = p * S;
              if (Ve > 1)
                for (var Re = 0; Re < f; Re++)
                  for (var De = 0; De < g; De++) {
                    for (var Ne = 0, we = 0, re = 0, $ = 0, Ce = 0, ve = 0; ve < S; ve++)
                      for (var Y = Re * S + ve, G = 0; G < p; G++) {
                        var Ae = De * p + G, e = (Y * s + Ae) * 4, r = de[e + 3];
                        r && (Ne += de[e], we += de[e + 1], re += de[e + 2], Ce++), $ += r;
                      }
                    var h = (Re * g + De) * 4;
                    a[h] = Ce ? Math.round(Ne / Ce) : 0, a[h + 1] = Ce ? Math.round(we / Ce) : 0, a[h + 2] = Ce ? Math.round(re / Ce) : 0, a[h + 3] = Math.round($ / Ve);
                  }
              else
                E.data = de;
            },
            bicubicInterpolation: function(y, E, d) {
              var l = function(a, n, c, g, f) {
                var p = g - c - a + n, s = a - n - p, S = c - a, b = n;
                return Math.max(0, Math.min(255, p * (f * f * f) + s * (f * f) + S * f + b));
              };
              return this._interpolate2D(y, E, d, l);
            },
            hermiteInterpolation: function(y, E, d) {
              var l = function(a, n, c, g, f) {
                var p = n, s = 0.5 * (c - a), S = a - 2.5 * n + 2 * c - 0.5 * g, b = 0.5 * (g - a) + 1.5 * (n - c);
                return Math.max(0, Math.min(255, Math.round(((b * f + S) * f + s) * f + p)));
              };
              return this._interpolate2D(y, E, d, l);
            },
            bezierInterpolation: function(y, E, d) {
              var l = function(a, n, c, g, f) {
                var p = n + (c - a) / 4, s = c - (g - n) / 4, S = 1 - f, b = n * S * S * S, o = 3 * p * S * S * f, A = 3 * s * S * f * f, T = c * f * f * f;
                return Math.max(0, Math.min(255, Math.round(b + o + A + T)));
              };
              return this._interpolate2D(y, E, d, l);
            }
          };
        }).call(this, C("buffer").Buffer);
      }, { buffer: 48 }], 224: [function(C, Z, _) {
        (function(P) {
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var x = C("@jimp/utils");
          function y(d, l) {
            d %= 360;
            var u = d * Math.PI / 180, a = Math.cos(u), n = Math.sin(u), c = this.bitmap.width, g = this.bitmap.height;
            if (l === !0 || typeof l == "string") {
              c = Math.ceil(Math.abs(this.bitmap.width * a) + Math.abs(this.bitmap.height * n)) + 1, g = Math.ceil(Math.abs(this.bitmap.width * n) + Math.abs(this.bitmap.height * a)) + 1, c % 2 !== 0 && c++, g % 2 !== 0 && g++;
              var f = this.cloneQuiet();
              this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(W, Q, de) {
                this.bitmap.data.writeUInt32BE(this._background, de);
              });
              var p = Math.max(c, g, this.bitmap.width, this.bitmap.height);
              this.resize(p, p, l), this.blit(f, this.bitmap.width / 2 - f.bitmap.width / 2, this.bitmap.height / 2 - f.bitmap.height / 2);
            }
            var s = this.bitmap.width, S = this.bitmap.height, b = P.alloc(this.bitmap.data.length);
            function o(W, Q) {
              return function(de, _e) {
                return {
                  x: de + W,
                  y: _e + Q
                };
              };
            }
            for (var A = o(-(s / 2), -(S / 2)), T = o(s / 2 + 0.5, S / 2 + 0.5), R = 1; R <= S; R++)
              for (var L = 1; L <= s; L++) {
                var z = A(L, R), U = T(a * z.x - n * z.y, a * z.y + n * z.x), J = s * (R - 1) + L - 1 << 2;
                if (U.x >= 0 && U.x < s && U.y >= 0 && U.y < S) {
                  var F = (s * (U.y | 0) + U.x | 0) << 2, se = this.bitmap.data.readUInt32BE(F);
                  b.writeUInt32BE(se, J);
                } else
                  b.writeUInt32BE(this._background, J);
              }
            if (this.bitmap.data = b, l === !0 || typeof l == "string") {
              var ee = s / 2 - c / 2, ie = S / 2 - g / 2;
              this.crop(ee, ie, c, g);
            }
          }
          var E = function() {
            return {
              /**
               * Rotates the image clockwise by a number of degrees. By default the width and height of the image will be resized appropriately.
               * @param {number} deg the number of degrees to rotate the image by
               * @param {string|boolean} mode (optional) resize mode or a boolean, if false then the width and height of the image will not be changed
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              rotate: function(u, a, n) {
                return (typeof a > "u" || a === null) && (a = !0), typeof a == "function" && typeof n > "u" && (n = a, a = !0), typeof u != "number" ? x.throwError.call(this, "deg must be a number", n) : typeof a != "boolean" && typeof a != "string" ? x.throwError.call(this, "mode must be a boolean or a string", n) : (y.call(this, u, a, n), (0, x.isNodePattern)(n) && n.call(this, null, this), this);
              }
            };
          };
          _.default = E, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@jimp/utils": 235, buffer: 48 }], 225: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            /**
             * Uniformly scales the image by a factor.
             * @param {number} f the factor to scale the image by
             * @param {string} mode (optional) a scaling method (e.g. Jimp.RESIZE_BEZIER)
             * @param {function(Error, Jimp)} cb (optional) a callback for when complete
             * @returns {Jimp} this for chaining of methods
             */
            scale: function(d, l, u) {
              if (typeof d != "number")
                return P.throwError.call(this, "f must be a number", u);
              if (d < 0)
                return P.throwError.call(this, "f must be a positive number", u);
              typeof l == "function" && typeof u > "u" && (u = l, l = null);
              var a = this.bitmap.width * d, n = this.bitmap.height * d;
              return this.resize(a, n, l), (0, P.isNodePattern)(u) && u.call(this, null, this), this;
            },
            /**
             * Scale the image to the largest size that fits inside the rectangle that has the given width and height.
             * @param {number} w the width to resize the image to
             * @param {number} h the height to resize the image to
             * @param {string} mode (optional) a scaling method (e.g. Jimp.RESIZE_BEZIER)
             * @param {function(Error, Jimp)} cb (optional) a callback for when complete
             * @returns {Jimp} this for chaining of methods
             */
            scaleToFit: function(d, l, u, a) {
              if (typeof d != "number" || typeof l != "number")
                return P.throwError.call(this, "w and h must be numbers", a);
              typeof u == "function" && typeof a > "u" && (a = u, u = null);
              var n = d / l > this.bitmap.width / this.bitmap.height ? l / this.bitmap.height : d / this.bitmap.width;
              return this.scale(n, u), (0, P.isNodePattern)(a) && a.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 226: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            shadow: function() {
              var d = this, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = arguments.length > 1 ? arguments[1] : void 0;
              typeof l == "function" && (u = l, l = {});
              var a = l, n = a.opacity, c = n === void 0 ? 0.7 : n, g = a.size, f = g === void 0 ? 1.1 : g, p = a.x, s = p === void 0 ? -25 : p, S = a.y, b = S === void 0 ? 25 : S, o = a.blur, A = o === void 0 ? 5 : o, T = this.clone(), R = this.clone();
              return R.scan(0, 0, R.bitmap.width, R.bitmap.height, function(L, z, U) {
                R.bitmap.data[U] = 0, R.bitmap.data[U + 1] = 0, R.bitmap.data[U + 2] = 0, R.bitmap.data[U + 3] = R.constructor.limit255(R.bitmap.data[U + 3] * c), d.bitmap.data[U] = 0, d.bitmap.data[U + 1] = 0, d.bitmap.data[U + 2] = 0, d.bitmap.data[U + 3] = 0;
              }), R.resize(R.bitmap.width * f, R.bitmap.height * f).blur(A), this.composite(R, s, b), this.composite(T, 0, 0), (0, P.isNodePattern)(u) && u.call(this, null, this), this;
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 227: [function(C, Z, _) {
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var P = C("@jimp/utils"), x = function() {
          return {
            threshold: function(d, l) {
              var u = this, a = d.max, n = d.replace, c = n === void 0 ? 255 : n, g = d.autoGreyscale, f = g === void 0 ? !0 : g;
              return typeof a != "number" ? P.throwError.call(this, "max must be a number", l) : typeof c != "number" ? P.throwError.call(this, "replace must be a number", l) : typeof f != "boolean" ? P.throwError.call(this, "autoGreyscale must be a boolean", l) : (a = this.constructor.limit255(a), c = this.constructor.limit255(c), f && this.greyscale(), this.scanQuiet(0, 0, this.bitmap.width, this.bitmap.height, function(p, s, S) {
                var b = u.bitmap.data[S] < a ? u.bitmap.data[S] : c;
                u.bitmap.data[S] = b, u.bitmap.data[S + 1] = b, u.bitmap.data[S + 2] = b;
              }), (0, P.isNodePattern)(l) && l.call(this, null, this), this);
            }
          };
        };
        _.default = x, Z.exports = _.default;
      }, { "@jimp/utils": 235 }], 228: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/toConsumableArray")), y = C("timm"), E = P(C("@jimp/plugin-blit")), d = P(C("@jimp/plugin-blur")), l = P(C("@jimp/plugin-circle")), u = P(C("@jimp/plugin-color")), a = P(C("@jimp/plugin-contain")), n = P(C("@jimp/plugin-cover")), c = P(C("@jimp/plugin-crop")), g = P(C("@jimp/plugin-displace")), f = P(C("@jimp/plugin-dither")), p = P(C("@jimp/plugin-fisheye")), s = P(C("@jimp/plugin-flip")), S = P(C("@jimp/plugin-gaussian")), b = P(C("@jimp/plugin-invert")), o = P(C("@jimp/plugin-mask")), A = P(C("@jimp/plugin-normalize")), T = P(C("@jimp/plugin-print")), R = P(C("@jimp/plugin-resize")), L = P(C("@jimp/plugin-rotate")), z = P(C("@jimp/plugin-scale")), U = P(C("@jimp/plugin-shadow")), J = P(C("@jimp/plugin-threshold")), F = [E.default, d.default, l.default, u.default, a.default, n.default, c.default, g.default, f.default, p.default, s.default, S.default, b.default, o.default, A.default, T.default, R.default, L.default, z.default, U.default, J.default], se = function(ie) {
          var W = F.map(function(Q) {
            var de = Q(ie) || {};
            return !de.class && !de.constants && (de = {
              class: de
            }), de;
          });
          return y.mergeDeep.apply(void 0, (0, x.default)(W));
        };
        _.default = se, Z.exports = _.default;
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/helpers/toConsumableArray": 20, "@jimp/plugin-blit": 201, "@jimp/plugin-blur": 203, "@jimp/plugin-circle": 204, "@jimp/plugin-color": 205, "@jimp/plugin-contain": 206, "@jimp/plugin-cover": 207, "@jimp/plugin-crop": 208, "@jimp/plugin-displace": 209, "@jimp/plugin-dither": 210, "@jimp/plugin-fisheye": 211, "@jimp/plugin-flip": 212, "@jimp/plugin-gaussian": 213, "@jimp/plugin-invert": 214, "@jimp/plugin-mask": 215, "@jimp/plugin-normalize": 216, "@jimp/plugin-print": 217, "@jimp/plugin-resize": 221, "@jimp/plugin-rotate": 224, "@jimp/plugin-scale": 225, "@jimp/plugin-shadow": 226, "@jimp/plugin-threshold": 227, timm: 177 }], 229: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/defineProperty")), y = P(C("bmp-js")), E = C("@jimp/utils"), d = "image/bmp", l = "image/x-ms-bmp";
        function u(f) {
          return (0, E.scan)(f, 0, 0, f.bitmap.width, f.bitmap.height, function(p, s, S) {
            var b = this.bitmap.data[S + 0], o = this.bitmap.data[S + 1], A = this.bitmap.data[S + 2], T = this.bitmap.data[S + 3];
            this.bitmap.data[S + 0] = T, this.bitmap.data[S + 1] = A, this.bitmap.data[S + 2] = o, this.bitmap.data[S + 3] = b;
          }).bitmap;
        }
        function a(f) {
          return (0, E.scan)({
            bitmap: f
          }, 0, 0, f.width, f.height, function(p, s, S) {
            var b = this.bitmap.data[S + 0], o = this.bitmap.data[S + 1], A = this.bitmap.data[S + 2], T = this.bitmap.data[S + 3];
            this.bitmap.data[S + 0] = T, this.bitmap.data[S + 1] = A, this.bitmap.data[S + 2] = o, this.bitmap.data[S + 3] = f.is_with_alpha ? b : 255;
          }).bitmap;
        }
        var n = function(p) {
          return a(y.default.decode(p));
        }, c = function(p) {
          return y.default.encode(u(p)).data;
        }, g = function() {
          var p, s;
          return {
            mime: (0, x.default)({}, d, ["bmp"]),
            constants: {
              MIME_BMP: d,
              MIME_X_MS_BMP: l
            },
            decoders: (p = {}, (0, x.default)(p, d, n), (0, x.default)(p, l, n), p),
            encoders: (s = {}, (0, x.default)(s, d, c), (0, x.default)(s, l, c), s)
          };
        };
        _.default = g, Z.exports = _.default;
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/utils": 235, "bmp-js": 30 }], 230: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var y = x(C("@babel/runtime/helpers/defineProperty")), E = x(C("omggif")), d = C("gifwrap"), l = "image/gif", u = function() {
            return {
              mime: (0, y.default)({}, l, ["gif"]),
              constants: {
                MIME_GIF: l
              },
              decoders: (0, y.default)({}, l, function(n) {
                var c = new E.default.GifReader(n), g = P.alloc(c.width * c.height * 4);
                return c.decodeAndBlitFrameRGBA(0, g), {
                  data: g,
                  width: c.width,
                  height: c.height
                };
              }),
              encoders: (0, y.default)({}, l, function(n) {
                var c = new d.BitmapImage(n.bitmap);
                d.GifUtil.quantizeDekker(c, 256);
                var g = new d.GifFrame(c), f = new d.GifCodec();
                return f.encodeGif([g], {}).then(function(p) {
                  return p.buffer;
                });
              })
            };
          };
          _.default = u, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, buffer: 48, gifwrap: 70, omggif: 85 }], 231: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/defineProperty")), y = P(C("jpeg-js")), E = C("@jimp/utils"), d = "image/jpeg", l = function() {
          return {
            mime: (0, x.default)({}, d, ["jpeg", "jpg", "jpe"]),
            constants: {
              MIME_JPEG: d
            },
            decoders: (0, x.default)({}, d, y.default.decode),
            encoders: (0, x.default)({}, d, function(a) {
              return y.default.encode(a.bitmap, a._quality).data;
            }),
            class: {
              // The quality to be used when saving JPEG images
              _quality: 100,
              /**
               * Sets the quality of the image when saving as JPEG format (default is 100)
               * @param {number} n The quality to use 0-100
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              quality: function(n, c) {
                return typeof n != "number" ? E.throwError.call(this, "n must be a number", c) : n < 0 || n > 100 ? E.throwError.call(this, "n must be a number 0 - 100", c) : (this._quality = Math.round(n), (0, E.isNodePattern)(c) && c.call(this, null, this), this);
              }
            }
          };
        };
        _.default = l, Z.exports = _.default;
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/utils": 235, "jpeg-js": 80 }], 232: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = P(C("@babel/runtime/helpers/defineProperty")), y = C("pngjs"), E = C("@jimp/utils"), d = "image/png", l = -1, u = 0, a = 1, n = 2, c = 3, g = 4, f = function() {
          return {
            mime: (0, x.default)({}, d, ["png"]),
            constants: {
              MIME_PNG: d,
              PNG_FILTER_AUTO: l,
              PNG_FILTER_NONE: u,
              PNG_FILTER_SUB: a,
              PNG_FILTER_UP: n,
              PNG_FILTER_AVERAGE: c,
              PNG_FILTER_PATH: g
            },
            hasAlpha: (0, x.default)({}, d, !0),
            decoders: (0, x.default)({}, d, y.PNG.sync.read),
            encoders: (0, x.default)({}, d, function(s) {
              var S = new y.PNG({
                width: s.bitmap.width,
                height: s.bitmap.height
              });
              return S.data = s.bitmap.data, y.PNG.sync.write(S, {
                width: s.bitmap.width,
                height: s.bitmap.height,
                deflateLevel: s._deflateLevel,
                deflateStrategy: s._deflateStrategy,
                filterType: s._filterType,
                colorType: typeof s._colorType == "number" ? s._colorType : s._rgba ? 6 : 2,
                inputHasAlpha: s._rgba
              });
            }),
            class: {
              _deflateLevel: 9,
              _deflateStrategy: 3,
              _filterType: l,
              _colorType: null,
              /**
               * Sets the deflate level used when saving as PNG format (default is 9)
               * @param {number} l Deflate level to use 0-9. 0 is no compression. 9 (default) is maximum compression.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              deflateLevel: function(S, b) {
                return typeof S != "number" ? E.throwError.call(this, "l must be a number", b) : S < 0 || S > 9 ? E.throwError.call(this, "l must be a number 0 - 9", b) : (this._deflateLevel = Math.round(S), (0, E.isNodePattern)(b) && b.call(this, null, this), this);
              },
              /**
               * Sets the deflate strategy used when saving as PNG format (default is 3)
               * @param {number} s Deflate strategy to use 0-3.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              deflateStrategy: function(S, b) {
                return typeof S != "number" ? E.throwError.call(this, "s must be a number", b) : S < 0 || S > 3 ? E.throwError.call(this, "s must be a number 0 - 3", b) : (this._deflateStrategy = Math.round(S), (0, E.isNodePattern)(b) && b.call(this, null, this), this);
              },
              /**
               * Sets the filter type used when saving as PNG format (default is automatic filters)
               * @param {number} f The quality to use -1-4.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              filterType: function(S, b) {
                return typeof S != "number" ? E.throwError.call(this, "n must be a number", b) : S < -1 || S > 4 ? E.throwError.call(this, "n must be -1 (auto) or a number 0 - 4", b) : (this._filterType = Math.round(S), (0, E.isNodePattern)(b) && b.call(this, null, this), this);
              },
              /**
               * Sets the color type used when saving as PNG format
               * @param {number} s color type to use 0, 2, 4, 6.
               * @param {function(Error, Jimp)} cb (optional) a callback for when complete
               * @returns {Jimp} this for chaining of methods
               */
              colorType: function(S, b) {
                return typeof S != "number" ? E.throwError.call(this, "s must be a number", b) : S !== 0 && S !== 2 && S !== 4 && S !== 6 ? E.throwError.call(this, "s must be a number 0, 2, 4, 6.", b) : (this._colorType = Math.round(S), (0, E.isNodePattern)(b) && b.call(this, null, this), this);
              }
            }
          };
        };
        _.default = f, Z.exports = _.default;
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/utils": 235, pngjs: 129 }], 233: [function(C, Z, _) {
        (function(P) {
          var x = C("@babel/runtime/helpers/interopRequireDefault");
          Object.defineProperty(_, "__esModule", {
            value: !0
          }), _.default = void 0;
          var y = x(C("@babel/runtime/helpers/defineProperty")), E = x(C("utif")), d = "image/tiff", l = function() {
            return {
              mime: (0, y.default)({}, d, ["tiff", "tif"]),
              constants: {
                MIME_TIFF: d
              },
              decoders: (0, y.default)({}, d, function(a) {
                var n = E.default.decode(a), c = n[0];
                E.default.decodeImages(a, n);
                var g = E.default.toRGBA8(c);
                return {
                  data: P.from(g),
                  width: c.t256[0],
                  height: c.t257[0]
                };
              }),
              encoders: (0, y.default)({}, d, function(a) {
                var n = E.default.encodeImage(a.bitmap.data, a.bitmap.width, a.bitmap.height);
                return P.from(n);
              })
            };
          };
          _.default = l, Z.exports = _.default;
        }).call(this, C("buffer").Buffer);
      }, { "@babel/runtime/helpers/defineProperty": 7, "@babel/runtime/helpers/interopRequireDefault": 11, buffer: 48, utif: 182 }], 234: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.default = void 0;
        var x = C("timm"), y = P(C("@jimp/jpeg")), E = P(C("@jimp/png")), d = P(C("@jimp/bmp")), l = P(C("@jimp/tiff")), u = P(C("@jimp/gif")), a = function() {
          return (0, x.mergeDeep)((0, y.default)(), (0, E.default)(), (0, d.default)(), (0, l.default)(), (0, u.default)());
        };
        _.default = a, Z.exports = _.default;
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@jimp/bmp": 229, "@jimp/gif": 230, "@jimp/jpeg": 231, "@jimp/png": 232, "@jimp/tiff": 233, timm: 177 }], 235: [function(C, Z, _) {
        var P = C("@babel/runtime/helpers/interopRequireDefault");
        Object.defineProperty(_, "__esModule", {
          value: !0
        }), _.isNodePattern = E, _.throwError = d, _.scan = l, _.scanIterator = u;
        var x = P(C("@babel/runtime/regenerator")), y = /* @__PURE__ */ x.default.mark(u);
        function E(a) {
          if (typeof a > "u")
            return !1;
          if (typeof a != "function")
            throw new TypeError("Callback must be a function");
          return !0;
        }
        function d(a, n) {
          if (typeof a == "string" && (a = new Error(a)), typeof n == "function")
            return n.call(this, a);
          throw a;
        }
        function l(a, n, c, g, f, p) {
          n = Math.round(n), c = Math.round(c), g = Math.round(g), f = Math.round(f);
          for (var s = c; s < c + f; s++)
            for (var S = n; S < n + g; S++) {
              var b = a.bitmap.width * s + S << 2;
              p.call(a, S, s, b);
            }
          return a;
        }
        function u(a, n, c, g, f) {
          var p, s, S;
          return x.default.wrap(function(o) {
            for (; ; )
              switch (o.prev = o.next) {
                case 0:
                  n = Math.round(n), c = Math.round(c), g = Math.round(g), f = Math.round(f), p = c;
                case 5:
                  if (!(p < c + f)) {
                    o.next = 17;
                    break;
                  }
                  s = n;
                case 7:
                  if (!(s < n + g)) {
                    o.next = 14;
                    break;
                  }
                  return S = a.bitmap.width * p + s << 2, o.next = 11, {
                    x: s,
                    y: p,
                    idx: S,
                    image: a
                  };
                case 11:
                  s++, o.next = 7;
                  break;
                case 14:
                  p++, o.next = 5;
                  break;
                case 17:
                case "end":
                  return o.stop();
              }
          }, y);
        }
      }, { "@babel/runtime/helpers/interopRequireDefault": 11, "@babel/runtime/regenerator": 22 }] }, {}, [200])(200);
    });
  }(Il)), Il.exports;
}
var Rl, Mc;
function qo() {
  if (Mc) return Rl;
  Mc = 1;
  function Me(ge, ne) {
    this.x = ge || 0, this.y = ne || 0;
  }
  return Me.prototype = {
    copy: function() {
      return new Me(this.x, this.y);
    }
  }, Rl = Me, Rl;
}
var Ol, Ic;
function Qo() {
  if (Ic) return Ol;
  Ic = 1;
  var Me = qo(), ge = {};
  function ne(p) {
    return ge[p] || (ge[p] = new RegExp(" " + p + '="((?:\\\\(?=")"|[^"])+)"', "i")), ge[p];
  }
  function C(p, s, S) {
    var b = " " + s + '="' + S + '"';
    return p.indexOf(" " + s + '="') === -1 ? p = p.replace(/<[a-z]+/i, function(o) {
      return o + b;
    }) : p = p.replace(ne(s), b), p;
  }
  function Z(p) {
    return p.toFixed(3).replace(".000", "");
  }
  function _(p, s) {
    return p >= s ? p % s : p >= 0 ? p : s - 1 - (-1 - p) % s;
  }
  function P(p, s) {
    return p.x * s.y - p.y * s.x;
  }
  function x(p, s, S) {
    return p <= S ? p <= s && s < S : p <= s || s < S;
  }
  function y(p) {
    return p > 0 ? 1 : p < 0 ? -1 : 0;
  }
  function E(p, s) {
    var S = new Array(3), b, o, A;
    for (S[0] = s.x, S[1] = s.y, S[2] = 1, A = 0, b = 0; b < 3; b++)
      for (o = 0; o < 3; o++)
        A += S[b] * p.at(b, o) * S[o];
    return A;
  }
  function d(p, s, S) {
    var b = new Me();
    return b.x = s.x + p * (S.x - s.x), b.y = s.y + p * (S.y - s.y), b;
  }
  function l(p, s) {
    var S = new Me();
    return S.y = y(s.x - p.x), S.x = -y(s.y - p.y), S;
  }
  function u(p, s) {
    var S = l(p, s);
    return S.y * (s.x - p.x) - S.x * (s.y - p.y);
  }
  function a(p, s, S) {
    var b, o, A, T;
    return b = s.x - p.x, o = s.y - p.y, A = S.x - p.x, T = S.y - p.y, b * T - A * o;
  }
  function n(p, s, S, b) {
    var o, A, T, R;
    return o = s.x - p.x, A = s.y - p.y, T = b.x - S.x, R = b.y - S.y, o * R - T * A;
  }
  function c(p, s, S) {
    var b, o, A, T;
    return b = s.x - p.x, o = s.y - p.y, A = S.x - p.x, T = S.y - p.y, b * A + o * T;
  }
  function g(p, s, S, b) {
    var o, A, T, R;
    return o = s.x - p.x, A = s.y - p.y, T = b.x - S.x, R = b.y - S.y, o * T + A * R;
  }
  function f(p, s) {
    return Math.sqrt((p.x - s.x) * (p.x - s.x) + (p.y - s.y) * (p.y - s.y));
  }
  return Ol = {
    luminance: function(p, s, S) {
      return Math.round(0.2126 * p + 0.7153 * s + 0.0721 * S);
    },
    between: function(p, s, S) {
      return p >= s && p <= S;
    },
    clamp: function(p, s, S) {
      return Math.min(S, Math.max(s, p));
    },
    isNumber: function(p) {
      return typeof p == "number";
    },
    setHtmlAttr: C,
    /**
     * Generates path instructions for given curve
     *
     * @param {Curve} curve
     * @param {Number} [scale]
     * @returns {string}
     */
    renderCurve: function(p, s) {
      s = s || { x: 1, y: 1 };
      var S = p.c[(p.n - 1) * 3 + 2], b = [
        "M " + Z(S.x * s.x) + " " + Z(S.y * s.y)
      ];
      return p.tag.forEach(function(o, A) {
        var T = A * 3, R = p.c[T], L = p.c[T + 1], z = p.c[T + 2];
        o === "CURVE" ? b.push(
          "C " + Z(R.x * s.x) + " " + Z(R.y * s.y) + ", " + Z(L.x * s.x) + " " + Z(L.y * s.y) + ", " + Z(z.x * s.x) + " " + Z(z.y * s.y)
        ) : o === "CORNER" && b.push(
          "L " + Z(L.x * s.x) + " " + Z(L.y * s.y) + " " + Z(z.x * s.x) + " " + Z(z.y * s.y)
        );
      }), b.join(" ");
    },
    bezier: function(s, S, b, o, A) {
      var T = 1 - s, R = new Me();
      return R.x = T * T * T * S.x + 3 * (T * T * s) * b.x + 3 * (s * s * T) * o.x + s * s * s * A.x, R.y = T * T * T * S.y + 3 * (T * T * s) * b.y + 3 * (s * s * T) * o.y + s * s * s * A.y, R;
    },
    tangent: function(s, S, b, o, A, T) {
      var R, L, z, U, J, F, se, ee, ie, W;
      return R = n(s, S, A, T), L = n(S, b, A, T), z = n(b, o, A, T), U = R - 2 * L + z, J = -2 * R + 2 * L, F = R, se = J * J - 4 * U * F, U === 0 || se < 0 ? -1 : (ee = Math.sqrt(se), ie = (-J + ee) / (2 * U), W = (-J - ee) / (2 * U), ie >= 0 && ie <= 1 ? ie : W >= 0 && W <= 1 ? W : -1);
    },
    mod: _,
    xprod: P,
    cyclic: x,
    sign: y,
    quadform: E,
    interval: d,
    dorth_infty: l,
    ddenom: u,
    dpara: a,
    cprod: n,
    iprod: c,
    iprod1: g,
    ddist: f
  }, Ol;
}
var Ll, Rc;
function Oc() {
  if (Rc) return Ll;
  Rc = 1;
  var Me = Qo(), ge = null;
  try {
    ge = ld();
  } catch {
  }
  var ne = fd(), C = 256, Z = C - 1;
  function _(y, E) {
    return C * y + E;
  }
  function P(y, E) {
    if (y = typeof y == "number" ? Me.clamp(Math.round(y), 0, Z) : 0, E = typeof E == "number" ? Me.clamp(Math.round(E), 0, Z) : Z, y > E)
      throw new Error('Invalid range "' + y + "..." + E + '"');
    return [y, E];
  }
  function x(y, E) {
    if (this.data = null, this.pixels = 0, this._sortedIndexes = null, this._cachedStats = {}, this._lookupTableH = null, typeof y == "number")
      this._createArray(y);
    else if (y instanceof ne)
      this._collectValuesBitmap(y);
    else if (ge && y instanceof ge)
      this._collectValuesJimp(y, E);
    else
      throw new Error("Unsupported image source");
  }
  return x.MODE_LUMINANCE = "luminance", x.MODE_R = "r", x.MODE_G = "g", x.MODE_B = "b", x.prototype = {
    /**
     * Initializes data array for an image of given pixel size
     * @param imageSize
     * @returns {Uint8Array|Uint16Array|Uint32Array}
     * @private
     */
    _createArray: function(y) {
      var E = y <= Math.pow(2, 8) ? Uint8Array : y <= Math.pow(2, 16) ? Uint16Array : Uint32Array;
      return this.pixels = y, this.data = new E(C);
    },
    /**
     * Aggregates color data from {@link Jimp} instance
     * @param {Jimp} source
     * @param mode
     * @private
     */
    _collectValuesJimp: function(y, E) {
      var d = y.bitmap.data, l = this._createArray(y.bitmap.width * y.bitmap.height);
      y.scan(0, 0, y.bitmap.width, y.bitmap.height, function(u, a, n) {
        var c = E === x.MODE_R ? d[n] : E === x.MODE_G ? d[n + 1] : E === x.MODE_B ? d[n + 2] : Me.luminance(d[n], d[n + 1], d[n + 2]);
        l[c]++;
      });
    },
    /**
     * Aggregates color data from {@link Bitmap} instance
     * @param {Bitmap} source
     * @private
     */
    _collectValuesBitmap: function(y) {
      for (var E = this._createArray(y.size), d = y.data.length, l, u = 0; u < d; u++)
        l = y.data[u], E[l]++;
    },
    /**
     * Returns array of color indexes in ascending order
     * @param refresh
     * @returns {*}
     * @private
     */
    _getSortedIndexes: function(y) {
      if (!y && this._sortedIndexes)
        return this._sortedIndexes;
      var E = this.data, d = new Array(C), l = 0;
      for (l; l < C; l++)
        d[l] = l;
      return d.sort(function(u, a) {
        return E[u] > E[a] ? 1 : E[u] < E[a] ? -1 : 0;
      }), this._sortedIndexes = d, d;
    },
    /**
     * Builds lookup table H from lookup tables P and S.
     * see {@link http://www.iis.sinica.edu.tw/page/jise/2001/200109_01.pdf|this paper} for more details
     *
     * @returns {Float64Array}
     * @private
     */
    _thresholdingBuildLookupTable: function() {
      var y = new Float64Array(C * C), E = new Float64Array(C * C), d = new Float64Array(C * C), l = this.pixels, u, a, n, c;
      for (u = 1; u < C; ++u)
        n = _(u, u), c = this.data[u] / l, y[n] = c, E[n] = u * c;
      for (u = 1; u < C - 1; ++u)
        c = this.data[u + 1] / l, n = _(1, u), y[n + 1] = y[n] + c, E[n + 1] = E[n] + (u + 1) * c;
      for (u = 2; u < C; u++)
        for (a = u + 1; a < C; a++)
          y[_(u, a)] = y[_(1, a)] - y[_(1, u - 1)], E[_(u, a)] = E[_(1, a)] - E[_(1, u - 1)];
      for (u = 1; u < C; ++u)
        for (a = u + 1; a < C; a++)
          n = _(u, a), d[n] = y[n] !== 0 ? E[n] * E[n] / y[n] : 0;
      return this._lookupTableH = d;
    },
    /**
     * Implements Algorithm For Multilevel Thresholding
     * Receives desired number of color stops, returns array of said size. Could be limited to a range levelMin..levelMax
     *
     * Regardless of levelMin and levelMax values it still relies on between class variances for the entire histogram
     *
     * @param amount - how many thresholds should be calculated
     * @param [levelMin=0] - histogram segment start
     * @param [levelMax=255] - histogram segment end
     * @returns {number[]}
    */
    multilevelThresholding: function(y, E, d) {
      if (E = P(E, d), d = E[1], E = E[0], y = Math.min(d - E - 2, ~~y), y < 1)
        return [];
      this._lookupTableH || this._thresholdingBuildLookupTable();
      var l = this._lookupTableH, u = null, a = 0;
      y > 4 && console.log("[Warning]: Threshold computation for more than 5 levels may take a long time");
      function n(c, g, f, p) {
        c = (c || 0) + 1, g = g || 0, f = f || new Array(y), p = p || 0;
        for (var s = p + 1, S, b = c; b < d - y + p; b++)
          S = g + l[_(c, b)], f[s - 1] = b, s + 1 < y + 1 ? n(b, S, f, s) : (S += l[_(b + 1, d)], a < S && (a = S, u = f.slice()));
      }
      return n(E || 0), u || [];
    },
    /**
     * Automatically finds threshold value using Algorithm For Multilevel Thresholding
     *
     * @param {number} [levelMin]
     * @param {number} [levelMax]
     * @returns {null|number}
     */
    autoThreshold: function(y, E) {
      var d = this.multilevelThresholding(1, y, E);
      return d.length ? d[0] : null;
    },
    /**
     * Returns dominant color in given range. Returns -1 if not a single color from the range present on the image
     *
     * @param [levelMin=0]
     * @param [levelMax=255]
     * @param [tolerance=1]
     * @returns {number}
     */
    getDominantColor: function(y, E, d) {
      y = P(y, E), E = y[1], y = y[0], d = d || 1;
      var l = this.data, u = -1, a = -1, n, c, g;
      if (y === E)
        return l[y] ? y : -1;
      for (n = y; n <= E; n++) {
        for (g = 0, c = ~~(d / -2); c < d; c++)
          g += Me.between(n + c, 0, Z) ? l[n + c] : 0;
        var f = g > a, p = a === g && (u < 0 || l[n] > l[u]);
        (f || p) && (u = n, a = g);
      }
      return a <= 0 ? -1 : u;
    },
    /**
     * Returns stats for histogram or its segment.
     *
     * Returned object contains median, mean and standard deviation for pixel values;
     * peak, mean and median number of pixels per level and few other values
     *
     * If no pixels colors from specified range present on the image - most values will be NaN
     *
     * @param {Number} [levelMin=0] - histogram segment start
     * @param {Number} [levelMax=255] - histogram segment end
     * @param {Boolean} [refresh=false] - if cached result can be returned
     * @returns {{levels: {mean: (number|*), median: *, stdDev: number, unique: number}, pixelsPerLevel: {mean: (number|*), median: (number|*), peak: number}, pixels: number}}
     */
    getStats: function(y, E, d) {
      if (y = P(y, E), E = y[1], y = y[0], !d && this._cachedStats[y + "-" + E])
        return this._cachedStats[y + "-" + E];
      var l = this.data, u = this._getSortedIndexes(), a = 0, n = null, c, g, f, p, s = 0, S = 0, b = 0, o, A, T, R = 0, L = 0;
      for (o = y; o <= E; o++)
        a += l[o], b += l[o] * o, R += l[o] === 0 ? 0 : 1, L < l[o] && (L = l[o]);
      for (c = b / a, f = a / (E - y), p = a / R, g = Math.floor(a / 2), o = 0; o < C; o++)
        T = u[o], A = l[T], !(T < y || T > E) && (S += A, s += Math.pow(T - c, 2) * A, n === null && S >= g && (n = T));
      return this._cachedStats[y + "-" + E] = {
        // various pixel counts for levels (0..255)
        levels: {
          mean: c,
          median: n,
          stdDev: Math.sqrt(s / a),
          unique: R
        },
        // what's visually represented as bars
        pixelsPerLevel: {
          mean: f,
          median: p,
          peak: L
        },
        pixels: a
      };
    }
  }, Ll = x, Ll;
}
var Nl, Lc;
function fd() {
  if (Lc) return Nl;
  Lc = 1;
  var Me = qo(), ge = Qo();
  function ne(C, Z) {
    this._histogram = null, this.width = C, this.height = Z, this.size = C * Z, this.arrayBuffer = new ArrayBuffer(this.size), this.data = new Uint8Array(this.arrayBuffer);
  }
  return Nl = ne, Oc(), ne.prototype = {
    /**
     * Returns pixel value
     *
     * @param {Number|Point} x - index, point or x
     * @param {Number} [y]
     */
    getValueAt: function(C, Z) {
      var _ = typeof C == "number" && typeof Z != "number" ? C : this.pointToIndex(C, Z);
      return this.data[_];
    },
    /**
     * Converts {@link Point} to index value
     *
     * @param {Number} index
     * @returns {Point}
     */
    indexToPoint: function(C) {
      var Z = new Me();
      return ge.between(C, 0, this.size) ? (Z.y = Math.floor(C / this.width), Z.x = C - Z.y * this.width) : (Z.x = -1, Z.y = -1), Z;
    },
    /**
     * Calculates index for point or coordinate pair
     *
     * @param {Number|Point} pointOrX
     * @param {Number} [y]
     * @returns {Number}
     */
    pointToIndex: function(C, Z) {
      var _ = C, P = Z;
      return C instanceof Me && (_ = C.x, P = C.y), !ge.between(_, 0, this.width) || !ge.between(P, 0, this.height) ? -1 : this.width * P + _;
    },
    /**
     * Makes a copy of current bitmap
     *
     * @param {Function} [iterator] optional callback, used for processing pixel value. Accepted arguments: value, index
     * @returns {Bitmap}
     */
    copy: function(C) {
      var Z = new ne(this.width, this.height), _ = typeof C == "function", P;
      for (P = 0; P < this.size; P++)
        Z.data[P] = _ ? C(this.data[P], P) : this.data[P];
      return Z;
    },
    histogram: function() {
      var C = Oc();
      return this._histogram ? this._histogram : (this._histogram = new C(this), this._histogram);
    }
  }, Nl;
}
var Dl, Nc;
function k0() {
  if (Nc) return Dl;
  Nc = 1;
  function Me(ge) {
    this.n = ge, this.tag = new Array(ge), this.c = new Array(ge * 3), this.alphaCurve = 0, this.vertex = new Array(ge), this.alpha = new Array(ge), this.alpha0 = new Array(ge), this.beta = new Array(ge);
  }
  return Dl = Me, Dl;
}
var Bl, Dc;
function A0() {
  if (Dc) return Bl;
  Dc = 1;
  function Me() {
    this.area = 0, this.len = 0, this.curve = {}, this.pt = [], this.minX = 1e5, this.minY = 1e5, this.maxX = -1, this.maxY = -1;
  }
  return Bl = Me, Bl;
}
var zl, Bc;
function T0() {
  if (Bc) return zl;
  Bc = 1;
  function Me() {
    this.data = [0, 0, 0, 0, 0, 0, 0, 0, 0];
  }
  return Me.prototype.at = function(ge, ne) {
    return this.data[ge * 3 + ne];
  }, zl = Me, zl;
}
var Fl, zc;
function P0() {
  if (zc) return Fl;
  zc = 1;
  function Me(ge, ne, C, Z, _) {
    this.x = ge, this.y = ne, this.xy = C, this.x2 = Z, this.y2 = _;
  }
  return Fl = Me, Fl;
}
var Ul, Fc;
function M0() {
  if (Fc) return Ul;
  Fc = 1;
  var Me = qo();
  function ge() {
    this.pen = 0, this.c = [new Me(), new Me()], this.t = 0, this.s = 0, this.alpha = 0;
  }
  return Ul = ge, Ul;
}
var jl, Uc;
function hd() {
  if (Uc) return jl;
  Uc = 1;
  var Me = ld(), ge = fd(), ne = k0(), C = qo(), Z = A0(), _ = T0(), P = P0(), x = M0(), y = Qo();
  function E(l) {
    this._luminanceData = null, this._pathlist = [], this._imageLoadingIdentifier = null, this._imageLoaded = !1, this._processed = !1, this._params = {
      turnPolicy: E.TURNPOLICY_MINORITY,
      turdSize: 2,
      alphaMax: 1,
      optCurve: !0,
      optTolerance: 0.2,
      threshold: E.THRESHOLD_AUTO,
      blackOnWhite: !0,
      color: E.COLOR_AUTO,
      background: E.COLOR_TRANSPARENT,
      width: null,
      height: null
    }, l && this.setParameters(l);
  }
  E.COLOR_AUTO = "auto", E.COLOR_TRANSPARENT = "transparent", E.THRESHOLD_AUTO = -1, E.TURNPOLICY_BLACK = "black", E.TURNPOLICY_WHITE = "white", E.TURNPOLICY_LEFT = "left", E.TURNPOLICY_RIGHT = "right", E.TURNPOLICY_MINORITY = "minority", E.TURNPOLICY_MAJORITY = "majority";
  var d = [
    E.TURNPOLICY_BLACK,
    E.TURNPOLICY_WHITE,
    E.TURNPOLICY_LEFT,
    E.TURNPOLICY_RIGHT,
    E.TURNPOLICY_MINORITY,
    E.TURNPOLICY_MAJORITY
  ];
  return E.prototype = {
    /**
     * Creating a new {@link Path} for every group of black pixels.
     * @private
     */
    _bmToPathlist: function() {
      var l = this, u = this._params.threshold, a = this._params.blackOnWhite, n, c = new C(0, 0), g;
      u === E.THRESHOLD_AUTO && (u = this._luminanceData.histogram().autoThreshold() || 128), n = this._luminanceData.copy(function(b) {
        var o = a ? b > u : b < u;
        return o ? 0 : 1;
      });
      function f(b) {
        for (var o = n.pointToIndex(b); o < n.size && n.data[o] !== 1; )
          o++;
        return o < n.size && n.indexToPoint(o);
      }
      function p(b, o) {
        var A, T, R;
        for (A = 2; A < 5; A++) {
          for (R = 0, T = -A + 1; T <= A - 1; T++)
            R += n.getValueAt(b + T, o + A - 1) ? 1 : -1, R += n.getValueAt(b + A - 1, o + T - 1) ? 1 : -1, R += n.getValueAt(b + T - 1, o - A) ? 1 : -1, R += n.getValueAt(b - A, o + T) ? 1 : -1;
          if (R > 0)
            return 1;
          if (R < 0)
            return 0;
        }
        return 0;
      }
      function s(b) {
        var o = new Z(), A = b.x, T = b.y, R = 0, L = 1, z;
        for (o.sign = n.getValueAt(b.x, b.y) ? "+" : "-"; o.pt.push(new C(A, T)), A > o.maxX && (o.maxX = A), A < o.minX && (o.minX = A), T > o.maxY && (o.maxY = T), T < o.minY && (o.minY = T), o.len++, A += R, T += L, o.area -= A * L, !(A === b.x && T === b.y); ) {
          var U = n.getValueAt(A + (R + L - 1) / 2, T + (L - R - 1) / 2), J = n.getValueAt(A + (R - L - 1) / 2, T + (L + R - 1) / 2);
          J && !U ? l._params.turnPolicy === "right" || l._params.turnPolicy === "black" && o.sign === "+" || l._params.turnPolicy === "white" && o.sign === "-" || l._params.turnPolicy === "majority" && p(A, T) || l._params.turnPolicy === "minority" && !p(A, T) ? (z = R, R = -L, L = z) : (z = R, R = L, L = -z) : J ? (z = R, R = -L, L = z) : U || (z = R, R = L, L = -z);
        }
        return o;
      }
      function S(b) {
        var o = b.pt[0].y, A = b.len, T, R, L, z, U, J, F;
        for (U = 1; U < A; U++)
          if (T = b.pt[U].x, R = b.pt[U].y, R !== o) {
            for (z = o < R ? o : R, L = b.maxX, J = T; J < L; J++)
              F = n.pointToIndex(J, z), n.data[F] = n.data[F] ? 0 : 1;
            o = R;
          }
      }
      for (this._pathlist = []; c = f(c); )
        g = s(c), S(g), g.area > l._params.turdSize && this._pathlist.push(g);
    },
    /**
     * Processes path list created by _bmToPathlist method creating and optimizing {@link Curve}'s
     * @private
     */
    _processPath: function() {
      var l = this;
      function u(b) {
        var o, A, T;
        b.x0 = b.pt[0].x, b.y0 = b.pt[0].y, b.sums = [];
        var R = b.sums;
        for (R.push(new P(0, 0, 0, 0, 0)), o = 0; o < b.len; o++)
          A = b.pt[o].x - b.x0, T = b.pt[o].y - b.y0, R.push(new P(
            R[o].x + A,
            R[o].y + T,
            R[o].xy + A * T,
            R[o].x2 + A * A,
            R[o].y2 + T * T
          ));
      }
      function a(b) {
        var o = b.len, A = b.pt, T, R = new Array(o), L = new Array(o), z = new Array(4);
        b.lon = new Array(o);
        var U = [new C(), new C()], J = new C(), F = new C(), se = new C(), ee, ie, W, Q, de, _e, ke, Pe, fe = 0;
        for (ie = o - 1; ie >= 0; ie--)
          A[ie].x != A[fe].x && A[ie].y != A[fe].y && (fe = ie + 1), L[ie] = fe;
        for (ie = o - 1; ie >= 0; ie--) {
          for (z[0] = z[1] = z[2] = z[3] = 0, T = (3 + 3 * (A[y.mod(ie + 1, o)].x - A[ie].x) + (A[y.mod(ie + 1, o)].y - A[ie].y)) / 2, z[T]++, U[0].x = 0, U[0].y = 0, U[1].x = 0, U[1].y = 0, fe = L[ie], Q = ie; ; ) {
            if (ee = 0, T = (3 + 3 * y.sign(A[fe].x - A[Q].x) + y.sign(A[fe].y - A[Q].y)) / 2, z[T]++, z[0] && z[1] && z[2] && z[3]) {
              R[ie] = Q, ee = 1;
              break;
            }
            if (J.x = A[fe].x - A[ie].x, J.y = A[fe].y - A[ie].y, y.xprod(U[0], J) < 0 || y.xprod(U[1], J) > 0 || (Math.abs(J.x) <= 1 && Math.abs(J.y) <= 1 || (F.x = J.x + (J.y >= 0 && (J.y > 0 || J.x < 0) ? 1 : -1), F.y = J.y + (J.x <= 0 && (J.x < 0 || J.y < 0) ? 1 : -1), y.xprod(U[0], F) >= 0 && (U[0].x = F.x, U[0].y = F.y), F.x = J.x + (J.y <= 0 && (J.y < 0 || J.x < 0) ? 1 : -1), F.y = J.y + (J.x >= 0 && (J.x > 0 || J.y < 0) ? 1 : -1), y.xprod(U[1], F) <= 0 && (U[1].x = F.x, U[1].y = F.y)), Q = fe, fe = L[Q], !y.cyclic(fe, ie, Q)))
              break;
          }
          ee === 0 && (se.x = y.sign(A[fe].x - A[Q].x), se.y = y.sign(A[fe].y - A[Q].y), J.x = A[Q].x - A[ie].x, J.y = A[Q].y - A[ie].y, de = y.xprod(U[0], J), _e = y.xprod(U[0], se), ke = y.xprod(U[1], J), Pe = y.xprod(U[1], se), W = 1e7, _e < 0 && (W = Math.floor(de / -_e)), Pe > 0 && (W = Math.min(W, Math.floor(-ke / Pe))), R[ie] = y.mod(Q + W, o));
        }
        for (W = R[o - 1], b.lon[o - 1] = W, ie = o - 2; ie >= 0; ie--)
          y.cyclic(ie + 1, R[ie], W) && (W = R[ie]), b.lon[ie] = W;
        for (ie = o - 1; y.cyclic(y.mod(ie + 1, o), W, b.lon[ie]); ie--)
          b.lon[ie] = W;
      }
      function n(b) {
        function o(_e, ke, Pe) {
          var fe = _e.len, xe = _e.pt, Ee = _e.sums, Ie, je, Ue, He, Ze, $e, We, Ve, Re, De, Ne, we, re, $, Ce = 0;
          return Pe >= fe && (Pe -= fe, Ce = 1), Ce === 0 ? (Ie = Ee[Pe + 1].x - Ee[ke].x, je = Ee[Pe + 1].y - Ee[ke].y, He = Ee[Pe + 1].x2 - Ee[ke].x2, Ue = Ee[Pe + 1].xy - Ee[ke].xy, Ze = Ee[Pe + 1].y2 - Ee[ke].y2, $e = Pe + 1 - ke) : (Ie = Ee[Pe + 1].x - Ee[ke].x + Ee[fe].x, je = Ee[Pe + 1].y - Ee[ke].y + Ee[fe].y, He = Ee[Pe + 1].x2 - Ee[ke].x2 + Ee[fe].x2, Ue = Ee[Pe + 1].xy - Ee[ke].xy + Ee[fe].xy, Ze = Ee[Pe + 1].y2 - Ee[ke].y2 + Ee[fe].y2, $e = Pe + 1 - ke + fe), Ne = (xe[ke].x + xe[Pe].x) / 2 - xe[0].x, we = (xe[ke].y + xe[Pe].y) / 2 - xe[0].y, $ = xe[Pe].x - xe[ke].x, re = -(xe[Pe].y - xe[ke].y), We = (He - 2 * Ie * Ne) / $e + Ne * Ne, Ve = (Ue - Ie * we - je * Ne) / $e + Ne * we, Re = (Ze - 2 * je * we) / $e + we * we, De = re * re * We + 2 * re * $ * Ve + $ * $ * Re, Math.sqrt(De);
        }
        var A, T, R, L, z = b.len, U = new Array(z + 1), J = new Array(z + 1), F = new Array(z), se = new Array(z + 1), ee = new Array(z + 1), ie = new Array(z + 1), W, Q, de;
        for (A = 0; A < z; A++)
          de = y.mod(b.lon[y.mod(A - 1, z)] - 1, z), de == A && (de = y.mod(A + 1, z)), de < A ? F[A] = z : F[A] = de;
        for (T = 1, A = 0; A < z; A++)
          for (; T <= F[A]; )
            se[T] = A, T++;
        for (A = 0, T = 0; A < z; T++)
          ee[T] = A, A = F[A];
        for (ee[T] = z, R = T, A = z, T = R; T > 0; T--)
          ie[T] = A, A = se[A];
        for (ie[0] = 0, U[0] = 0, T = 1; T <= R; T++)
          for (A = ie[T]; A <= ee[T]; A++) {
            for (Q = -1, L = ee[T - 1]; L >= se[A]; L--)
              W = o(b, L, A) + U[L], (Q < 0 || W < Q) && (J[A] = L, Q = W);
            U[A] = Q;
          }
        for (b.m = R, b.po = new Array(R), A = z, T = R - 1; A > 0; T--)
          A = J[A], b.po[T] = A;
      }
      function c(b) {
        function o(We, Ve, Re, De, Ne) {
          for (var we = We.len, re = We.sums, $, Ce, ve, Y, G, Ae, e, r, h, k, I, B = 0; Re >= we; )
            Re -= we, B += 1;
          for (; Ve >= we; )
            Ve -= we, B -= 1;
          for (; Re < 0; )
            Re += we, B -= 1;
          for (; Ve < 0; )
            Ve += we, B += 1;
          $ = re[Re + 1].x - re[Ve].x + B * re[we].x, Ce = re[Re + 1].y - re[Ve].y + B * re[we].y, ve = re[Re + 1].x2 - re[Ve].x2 + B * re[we].x2, Y = re[Re + 1].xy - re[Ve].xy + B * re[we].xy, G = re[Re + 1].y2 - re[Ve].y2 + B * re[we].y2, Ae = Re + 1 - Ve + B * we, De.x = $ / Ae, De.y = Ce / Ae, e = (ve - $ * $ / Ae) / Ae, r = (Y - $ * Ce / Ae) / Ae, h = (G - Ce * Ce / Ae) / Ae, k = (e + h + Math.sqrt((e - h) * (e - h) + 4 * r * r)) / 2, e -= k, h -= k, Math.abs(e) >= Math.abs(h) ? (I = Math.sqrt(e * e + r * r), I !== 0 && (Ne.x = -r / I, Ne.y = e / I)) : (I = Math.sqrt(h * h + r * r), I !== 0 && (Ne.x = -h / I, Ne.y = r / I)), I === 0 && (Ne.x = Ne.y = 0);
        }
        var A = b.m, T = b.po, R = b.len, L = b.pt, z = b.x0, U = b.y0, J = new Array(A), F = new Array(A), se = new Array(A), ee = new Array(3), ie, W, Q, de, _e, ke = new C();
        for (b.curve = new ne(A), W = 0; W < A; W++)
          Q = T[y.mod(W + 1, A)], Q = y.mod(Q - T[W], R) + T[W], J[W] = new C(), F[W] = new C(), o(b, T[W], Q, J[W], F[W]);
        for (W = 0; W < A; W++)
          if (se[W] = new _(), ie = F[W].x * F[W].x + F[W].y * F[W].y, ie === 0)
            for (Q = 0; Q < 3; Q++)
              for (de = 0; de < 3; de++)
                se[W].data[Q * 3 + de] = 0;
          else
            for (ee[0] = F[W].y, ee[1] = -F[W].x, ee[2] = -ee[1] * J[W].y - ee[0] * J[W].x, _e = 0; _e < 3; _e++)
              for (de = 0; de < 3; de++)
                se[W].data[_e * 3 + de] = ee[_e] * ee[de] / ie;
        var Pe, fe, xe, Ee, Ie, je, Ue, He, Ze, $e;
        for (W = 0; W < A; W++) {
          for (Pe = new _(), fe = new C(), ke.x = L[T[W]].x - z, ke.y = L[T[W]].y - U, Q = y.mod(W - 1, A), _e = 0; _e < 3; _e++)
            for (de = 0; de < 3; de++)
              Pe.data[_e * 3 + de] = se[Q].at(_e, de) + se[W].at(_e, de);
          for (; ; ) {
            if (Ie = Pe.at(0, 0) * Pe.at(1, 1) - Pe.at(0, 1) * Pe.at(1, 0), Ie !== 0) {
              fe.x = (-Pe.at(0, 2) * Pe.at(1, 1) + Pe.at(1, 2) * Pe.at(0, 1)) / Ie, fe.y = (Pe.at(0, 2) * Pe.at(1, 0) - Pe.at(1, 2) * Pe.at(0, 0)) / Ie;
              break;
            }
            for (Pe.at(0, 0) > Pe.at(1, 1) ? (ee[0] = -Pe.at(0, 1), ee[1] = Pe.at(0, 0)) : Pe.at(1, 1) ? (ee[0] = -Pe.at(1, 1), ee[1] = Pe.at(1, 0)) : (ee[0] = 1, ee[1] = 0), ie = ee[0] * ee[0] + ee[1] * ee[1], ee[2] = -ee[1] * ke.y - ee[0] * ke.x, _e = 0; _e < 3; _e++)
              for (de = 0; de < 3; de++)
                Pe.data[_e * 3 + de] += ee[_e] * ee[de] / ie;
          }
          if (xe = Math.abs(fe.x - ke.x), Ee = Math.abs(fe.y - ke.y), xe <= 0.5 && Ee <= 0.5) {
            b.curve.vertex[W] = new C(fe.x + z, fe.y + U);
            continue;
          }
          if (je = y.quadform(Pe, ke), He = ke.x, Ze = ke.y, Pe.at(0, 0) !== 0)
            for ($e = 0; $e < 2; $e++)
              fe.y = ke.y - 0.5 + $e, fe.x = -(Pe.at(0, 1) * fe.y + Pe.at(0, 2)) / Pe.at(0, 0), xe = Math.abs(fe.x - ke.x), Ue = y.quadform(Pe, fe), xe <= 0.5 && Ue < je && (je = Ue, He = fe.x, Ze = fe.y);
          if (Pe.at(1, 1) !== 0)
            for ($e = 0; $e < 2; $e++)
              fe.x = ke.x - 0.5 + $e, fe.y = -(Pe.at(1, 0) * fe.x + Pe.at(1, 2)) / Pe.at(1, 1), Ee = Math.abs(fe.y - ke.y), Ue = y.quadform(Pe, fe), Ee <= 0.5 && Ue < je && (je = Ue, He = fe.x, Ze = fe.y);
          for (_e = 0; _e < 2; _e++)
            for (de = 0; de < 2; de++)
              fe.x = ke.x - 0.5 + _e, fe.y = ke.y - 0.5 + de, Ue = y.quadform(Pe, fe), Ue < je && (je = Ue, He = fe.x, Ze = fe.y);
          b.curve.vertex[W] = new C(He + z, Ze + U);
        }
      }
      function g(b) {
        var o = b.curve, A = o.n, T = o.vertex, R, L, z;
        for (R = 0, L = A - 1; R < L; R++, L--)
          z = T[R], T[R] = T[L], T[L] = z;
      }
      function f(b) {
        var o = b.curve.n, A = b.curve, T, R, L, z, U, J, F, se, ee;
        for (T = 0; T < o; T++)
          R = y.mod(T + 1, o), L = y.mod(T + 2, o), ee = y.interval(1 / 2, A.vertex[L], A.vertex[R]), U = y.ddenom(A.vertex[T], A.vertex[L]), U !== 0 ? (z = y.dpara(A.vertex[T], A.vertex[R], A.vertex[L]) / U, z = Math.abs(z), J = z > 1 ? 1 - 1 / z : 0, J = J / 0.75) : J = 4 / 3, A.alpha0[R] = J, J >= l._params.alphaMax ? (A.tag[R] = "CORNER", A.c[3 * R + 1] = A.vertex[R], A.c[3 * R + 2] = ee) : (J < 0.55 ? J = 0.55 : J > 1 && (J = 1), F = y.interval(0.5 + 0.5 * J, A.vertex[T], A.vertex[R]), se = y.interval(0.5 + 0.5 * J, A.vertex[L], A.vertex[R]), A.tag[R] = "CURVE", A.c[3 * R + 0] = F, A.c[3 * R + 1] = se, A.c[3 * R + 2] = ee), A.alpha[R] = J, A.beta[R] = 0.5;
        A.alphaCurve = 1;
      }
      function p(b) {
        function o(je, Ue, He, Ze, $e, We, Ve) {
          var Re = je.curve.n, De = je.curve, Ne = De.vertex, we, re, $, Ce, ve, Y, G, Ae, e, r, h, k, I, B, j, H, X, ue, pe, M, q, K, be;
          if (Ue == He || (we = Ue, ve = y.mod(Ue + 1, Re), re = y.mod(we + 1, Re), Ce = We[re], Ce === 0))
            return 1;
          for (Ae = y.ddist(Ne[Ue], Ne[ve]), we = re; we != He; we = re)
            if (re = y.mod(we + 1, Re), $ = y.mod(we + 2, Re), We[re] != Ce || y.sign(y.cprod(Ne[Ue], Ne[ve], Ne[re], Ne[$])) != Ce || y.iprod1(Ne[Ue], Ne[ve], Ne[re], Ne[$]) < Ae * y.ddist(Ne[re], Ne[$]) * -0.999847695156)
              return 1;
          if (h = De.c[y.mod(Ue, Re) * 3 + 2].copy(), k = Ne[y.mod(Ue + 1, Re)].copy(), I = Ne[y.mod(He, Re)].copy(), B = De.c[y.mod(He, Re) * 3 + 2].copy(), Y = Ve[He] - Ve[Ue], Y -= y.dpara(Ne[0], De.c[Ue * 3 + 2], De.c[He * 3 + 2]) / 2, Ue >= He && (Y += Ve[Re]), ue = y.dpara(h, k, I), pe = y.dpara(h, k, B), M = y.dpara(h, I, B), q = ue + M - pe, pe == ue || (be = M / (M - q), K = pe / (pe - ue), H = pe * be / 2, H === 0))
            return 1;
          for (X = Y / H, G = 2 - Math.sqrt(4 - X / 0.3), Ze.c[0] = y.interval(be * G, h, k), Ze.c[1] = y.interval(K * G, B, I), Ze.alpha = G, Ze.t = be, Ze.s = K, k = Ze.c[0].copy(), I = Ze.c[1].copy(), Ze.pen = 0, we = y.mod(Ue + 1, Re); we != He; we = re) {
            if (re = y.mod(we + 1, Re), be = y.tangent(h, k, I, B, Ne[we], Ne[re]), be < -0.5 || (j = y.bezier(be, h, k, I, B), Ae = y.ddist(Ne[we], Ne[re]), Ae === 0) || (e = y.dpara(Ne[we], Ne[re], j) / Ae, Math.abs(e) > $e) || y.iprod(Ne[we], Ne[re], j) < 0 || y.iprod(Ne[re], Ne[we], j) < 0)
              return 1;
            Ze.pen += e * e;
          }
          for (we = Ue; we != He; we = re) {
            if (re = y.mod(we + 1, Re), be = y.tangent(h, k, I, B, De.c[we * 3 + 2], De.c[re * 3 + 2]), be < -0.5 || (j = y.bezier(be, h, k, I, B), Ae = y.ddist(De.c[we * 3 + 2], De.c[re * 3 + 2]), Ae === 0) || (e = y.dpara(De.c[we * 3 + 2], De.c[re * 3 + 2], j) / Ae, r = y.dpara(De.c[we * 3 + 2], De.c[re * 3 + 2], Ne[re]) / Ae, r *= 0.75 * De.alpha[re], r < 0 && (e = -e, r = -r), e < r - $e))
              return 1;
            e < r && (Ze.pen += (e - r) * (e - r));
          }
          return 0;
        }
        var A = b.curve, T = A.n, R = A.vertex, L = new Array(T + 1), z = new Array(T + 1), U = new Array(T + 1), J = new Array(T + 1), F, se, ee, ie, W = new x(), Q, de, _e, ke, Pe, fe, xe, Ee = new Array(T), Ie = new Array(T + 1);
        for (se = 0; se < T; se++)
          A.tag[se] == "CURVE" ? Ee[se] = y.sign(y.dpara(R[y.mod(se - 1, T)], R[se], R[y.mod(se + 1, T)])) : Ee[se] = 0;
        for (_e = 0, Ie[0] = 0, Q = A.vertex[0], se = 0; se < T; se++)
          de = y.mod(se + 1, T), A.tag[de] == "CURVE" && (ke = A.alpha[de], _e += 0.3 * ke * (4 - ke) * y.dpara(A.c[se * 3 + 2], R[de], A.c[de * 3 + 2]) / 2, _e += y.dpara(Q, A.c[se * 3 + 2], A.c[de * 3 + 2]) / 2), Ie[se + 1] = _e;
        for (L[0] = -1, z[0] = 0, U[0] = 0, ee = 1; ee <= T; ee++)
          for (L[ee] = ee - 1, z[ee] = z[ee - 1], U[ee] = U[ee - 1] + 1, se = ee - 2; se >= 0 && (ie = o(
            b,
            se,
            y.mod(ee, T),
            W,
            l._params.optTolerance,
            Ee,
            Ie
          ), !ie); se--)
            (U[ee] > U[se] + 1 || U[ee] == U[se] + 1 && z[ee] > z[se] + W.pen) && (L[ee] = se, z[ee] = z[se] + W.pen, U[ee] = U[se] + 1, J[ee] = W, W = new x());
        for (F = U[T], Pe = new ne(F), fe = new Array(F), xe = new Array(F), ee = T, se = F - 1; se >= 0; se--)
          L[ee] == ee - 1 ? (Pe.tag[se] = A.tag[y.mod(ee, T)], Pe.c[se * 3 + 0] = A.c[y.mod(ee, T) * 3 + 0], Pe.c[se * 3 + 1] = A.c[y.mod(ee, T) * 3 + 1], Pe.c[se * 3 + 2] = A.c[y.mod(ee, T) * 3 + 2], Pe.vertex[se] = A.vertex[y.mod(ee, T)], Pe.alpha[se] = A.alpha[y.mod(ee, T)], Pe.alpha0[se] = A.alpha0[y.mod(ee, T)], Pe.beta[se] = A.beta[y.mod(ee, T)], fe[se] = xe[se] = 1) : (Pe.tag[se] = "CURVE", Pe.c[se * 3 + 0] = J[ee].c[0], Pe.c[se * 3 + 1] = J[ee].c[1], Pe.c[se * 3 + 2] = A.c[y.mod(ee, T) * 3 + 2], Pe.vertex[se] = y.interval(
            J[ee].s,
            A.c[y.mod(ee, T) * 3 + 2],
            R[y.mod(ee, T)]
          ), Pe.alpha[se] = J[ee].alpha, Pe.alpha0[se] = J[ee].alpha, fe[se] = J[ee].s, xe[se] = J[ee].t), ee = L[ee];
        for (se = 0; se < F; se++)
          de = y.mod(se + 1, F), Pe.beta[se] = fe[se] / (fe[se] + xe[de]);
        Pe.alphaCurve = 1, b.curve = Pe;
      }
      for (var s = 0; s < this._pathlist.length; s++) {
        var S = this._pathlist[s];
        u(S), a(S), n(S), c(S), S.sign === "-" && g(S), f(S), l._params.optCurve && p(S);
      }
    },
    /**
     * Validates some of parameters
     * @param params
     * @private
     */
    _validateParameters: function(l) {
      if (l && l.turnPolicy && d.indexOf(l.turnPolicy) === -1) {
        var u = "'" + d.join("', '") + "'";
        throw new Error("Bad turnPolicy value. Allowed values are: " + u);
      }
      if (l && l.threshold != null && l.threshold !== E.THRESHOLD_AUTO && (typeof l.threshold != "number" || !y.between(l.threshold, 0, 255)))
        throw new Error("Bad threshold value. Expected to be an integer in range 0..255");
      if (l && l.optCurve != null && typeof l.optCurve != "boolean")
        throw new Error("'optCurve' must be Boolean");
    },
    _processLoadedImage: function(l) {
      var u = new ge(l.bitmap.width, l.bitmap.height), a = l.bitmap.data;
      l.scan(0, 0, l.bitmap.width, l.bitmap.height, function(n, c, g) {
        var f = a[g + 3] / 255, p = 255 + (a[g + 0] - 255) * f, s = 255 + (a[g + 1] - 255) * f, S = 255 + (a[g + 2] - 255) * f;
        u.data[g / 4] = y.luminance(p, s, S);
      }), this._luminanceData = u, this._imageLoaded = !0;
    },
    /**
     * Reads given image. Uses {@link Jimp} under the hood, so target can be whatever Jimp can take
     *
     * @param {string|Buffer|Jimp} target Image source. Could be anything that {@link Jimp} can read (buffer, local path or url). Supported formats are: PNG, JPEG or BMP
     * @param {Function} callback
     */
    loadImage: function(l, u) {
      var a = this, n = {};
      this._imageLoadingIdentifier = n, this._imageLoaded = !1, l instanceof Me ? (this._imageLoadingIdentifier = null, this._imageLoaded = !0, a._processLoadedImage(l), u.call(a, null)) : Me.read(l, function(c, g) {
        var f = a._imageLoadingIdentifier !== n;
        if (f) {
          var p = c || new Error("Another image was loaded instead");
          return u.call(a, p);
        }
        a._imageLoadingIdentifier = null, a._processLoadedImage(g), u.call(a, null);
      });
    },
    /**
     * Sets algorithm parameters
     * @param {Potrace~Options} newParams
     */
    setParameters: function(l) {
      var u, a;
      this._validateParameters(l);
      for (u in this._params)
        this._params.hasOwnProperty(u) && l.hasOwnProperty(u) && (a = this._params[u], this._params[u] = l[u], a !== this._params[u] && ["color", "background"].indexOf(u) === -1 && (this._processed = !1));
    },
    /**
     * Generates just <path> tag without rest of the SVG file
     *
     * @param {String} [fillColor] - overrides color from parameters
     * @returns {String}
     */
    getPathTag: function(l, u) {
      if (l = arguments.length === 0 ? this._params.color : l, l === E.COLOR_AUTO && (l = this._params.blackOnWhite ? "black" : "white"), !this._imageLoaded)
        throw new Error("Image should be loaded first");
      this._processed || (this._bmToPathlist(), this._processPath(), this._processed = !0);
      var a = '<path d="';
      return a += this._pathlist.map(function(n) {
        return y.renderCurve(n.curve, u);
      }).join(" "), a += '" stroke="none" fill="' + l + '" fill-rule="evenodd"/>', a;
    },
    /**
     * Returns <symbol> tag. Always has viewBox specified and comes with no fill color,
     * so it could be changed with <use> tag
     *
     * @param id
     * @returns {string}
     */
    getSymbol: function(l) {
      return '<symbol viewBox="0 0 ' + this._luminanceData.width + " " + this._luminanceData.height + '" id="' + l + '">' + this.getPathTag("") + "</symbol>";
    },
    /**
     * Generates SVG image
     * @returns {String}
     */
    getSVG: function() {
      var l = this._params.width || this._luminanceData.width, u = this._params.height || this._luminanceData.height, a = {
        x: this._params.width ? this._params.width / this._luminanceData.width : 1,
        y: this._params.height ? this._params.height / this._luminanceData.height : 1
      };
      return '<svg xmlns="http://www.w3.org/2000/svg" width="' + l + '" height="' + u + '" viewBox="0 0 ' + l + " " + u + `" version="1.1">
` + (this._params.background !== E.COLOR_TRANSPARENT ? '	<rect x="0" y="0" width="100%" height="100%" fill="' + this._params.background + `" />
` : "") + "	" + this.getPathTag(this._params.color, a) + `
</svg>`;
    }
  }, jl = E, jl;
}
var Hl, jc;
function I0() {
  if (jc) return Hl;
  jc = 1;
  var Me = hd(), ge = Qo();
  function ne(Z) {
    this._potrace = new Me(), this._calculatedThreshold = null, this._params = {
      threshold: Me.THRESHOLD_AUTO,
      blackOnWhite: !0,
      steps: ne.STEPS_AUTO,
      background: Me.COLOR_TRANSPARENT,
      fillStrategy: ne.FILL_DOMINANT,
      rangeDistribution: ne.RANGES_AUTO
    }, Z && this.setParameters(Z);
  }
  for (var C in Me)
    Object.prototype.hasOwnProperty.call(Me, C) && C === C.toUpperCase() && (ne[C] = Me[C]);
  return ne.STEPS_AUTO = -1, ne.FILL_SPREAD = "spread", ne.FILL_DOMINANT = "dominant", ne.FILL_MEDIAN = "median", ne.FILL_MEAN = "mean", ne.RANGES_AUTO = "auto", ne.RANGES_EQUAL = "equal", ne.prototype = {
    /**
     * Fine tuning to color ranges.
     *
     * If last range (featuring most saturated color) is larger than 10% of color space (25 units)
     * then we want to add another color stop, that hopefully will include darkest pixels, improving presence of
     * shadows and line art
     *
     * @param ranges
     * @private
     */
    _addExtraColorStop: function(Z) {
      var _ = this._params.blackOnWhite, P = Z[Z.length - 1], x = _ ? 0 : P.value, y = _ ? P.value : 255;
      if (y - x > 25 && P.colorIntensity !== 1) {
        var E = this._getImageHistogram(), d = E.getStats(x, y).levels, l = d.mean + d.stdDev <= 25 ? d.mean + d.stdDev : d.mean - d.stdDev <= 25 ? d.mean - d.stdDev : 25, u = _ ? E.getStats(0, l) : E.getStats(l, 255), a = u.levels.mean;
        Z.push({
          value: Math.abs((_ ? 0 : 255) - l),
          colorIntensity: isNaN(a) ? 0 : (_ ? 255 - a : a) / 255
        });
      }
      return Z;
    },
    /**
     * Calculates color intensity for each element of numeric array
     * 
     * @param {number[]} colorStops
     * @returns {{ levels: number, colorIntensity: number }[]}
     * @private
     */
    _calcColorIntensity: function(Z) {
      var _ = this._params.blackOnWhite, P = this._params.fillStrategy, x = P !== ne.FILL_SPREAD ? this._getImageHistogram() : null, y = Math.abs(this._paramThreshold() - (_ ? 0 : 255));
      return Z.map(function(E, d) {
        var l = d + 1 === Z.length ? _ ? -1 : 256 : Z[d + 1], u = Math.round(_ ? l + 1 : E), a = Math.round(_ ? E : l - 1), n = d / (Z.length - 1), c = a - u, g = x.getStats(u, a), f = -1;
        if (g.pixels === 0)
          return {
            value: E,
            colorIntensity: 0
          };
        switch (P) {
          case ne.FILL_SPREAD:
            f = (_ ? u : a) + (_ ? 1 : -1) * c * Math.max(0.5, y / 255) * n;
            break;
          case ne.FILL_DOMINANT:
            f = x.getDominantColor(u, a, ge.clamp(c, 1, 5));
            break;
          case ne.FILL_MEAN:
            f = g.levels.mean;
            break;
          case ne.FILL_MEDIAN:
            f = g.levels.median;
            break;
        }
        return d !== 0 && (f = _ ? ge.clamp(f, u, a - Math.round(c * 0.1)) : ge.clamp(f, u + Math.round(c * 0.1), a)), {
          value: E,
          colorIntensity: f === -1 ? 0 : (_ ? 255 - f : f) / 255
        };
      });
    },
    /**
     * @returns {Histogram}
     * @private
     */
    _getImageHistogram: function() {
      return this._potrace._luminanceData.histogram();
    },
    /**
     * Processes threshold, steps and rangeDistribution parameters and returns normalized array of color stops
     * @returns {*}
     * @private
     */
    _getRanges: function() {
      var Z = this._paramSteps();
      if (!Array.isArray(Z))
        return this._params.rangeDistribution === ne.RANGES_AUTO ? this._getRangesAuto() : this._getRangesEquallyDistributed();
      var _ = [], P = this._paramThreshold(), x = this._params.blackOnWhite;
      return Z.forEach(function(y) {
        _.indexOf(y) === -1 && ge.between(y, 0, 255) && _.push(y);
      }), _.length || _.push(P), _ = _.sort(function(y, E) {
        return y < E === x ? 1 : -1;
      }), x && _[0] < P ? _.unshift(P) : !x && _[_.length - 1] < P && _.push(P), this._calcColorIntensity(_);
    },
    /**
     * Calculates given (or lower) number of thresholds using automatic thresholding algorithm
     * @returns {*}
     * @private
     */
    _getRangesAuto: function() {
      var Z = this._getImageHistogram(), _ = this._paramSteps(!0), P;
      if (this._params.threshold === Me.THRESHOLD_AUTO)
        P = Z.multilevelThresholding(_);
      else {
        var x = this._paramThreshold();
        P = this._params.blackOnWhite ? Z.multilevelThresholding(_ - 1, 0, x) : Z.multilevelThresholding(_ - 1, x, 255), this._params.blackOnWhite ? P.push(x) : P.unshift(x);
      }
      return this._params.blackOnWhite && (P = P.reverse()), this._calcColorIntensity(P);
    },
    /**
     * Calculates color stops and color representing each segment, returning them
     * from least to most intense color (black or white, depending on blackOnWhite parameter)
     *
     * @private
     */
    _getRangesEquallyDistributed: function() {
      for (var Z = this._params.blackOnWhite, _ = Z ? this._paramThreshold() : 255 - this._paramThreshold(), P = this._paramSteps(), x = _ / P, y = [], E = P - 1, d; E >= 0; )
        d = Math.min(_, (E + 1) * x), d = Z ? d : 255 - d, E--, y.push(d);
      return this._calcColorIntensity(y);
    },
    /**
     * Returns valid steps value
     * @param {Boolean} [count=false]
     * @returns {number|number[]}
     * @private
     */
    _paramSteps: function(Z) {
      var _ = this._params.steps;
      if (Array.isArray(_))
        return Z ? _.length : _;
      if (_ === ne.STEPS_AUTO && this._params.threshold === Me.THRESHOLD_AUTO)
        return 4;
      var P = this._params.blackOnWhite, x = P ? this._paramThreshold() : 255 - this._paramThreshold();
      return _ === ne.STEPS_AUTO ? x > 200 ? 4 : 3 : Math.min(x, Math.max(2, _));
    },
    /**
     * Returns valid threshold value
     * @returns {number}
     * @private
     */
    _paramThreshold: function() {
      if (this._calculatedThreshold !== null)
        return this._calculatedThreshold;
      if (this._params.threshold !== Me.THRESHOLD_AUTO)
        return this._calculatedThreshold = this._params.threshold, this._calculatedThreshold;
      var Z = this._getImageHistogram().multilevelThresholding(2);
      return this._calculatedThreshold = this._params.blackOnWhite ? Z[1] : Z[0], this._calculatedThreshold = this._calculatedThreshold || 128, this._calculatedThreshold;
    },
    /**
     * Running potrace on the image multiple times with different thresholds and returns an array
     * of path tags
     *
     * @param {Boolean} [noFillColor]
     * @returns {string[]}
     * @private
     */
    _pathTags: function(Z) {
      var _ = this._getRanges(), P = this._potrace, x = this._params.blackOnWhite;
      _.length >= 10 && (_ = this._addExtraColorStop(_)), P.setParameters({ blackOnWhite: x });
      var y = 0;
      return _.map(function(E) {
        var d = E.colorIntensity;
        if (d === 0)
          return "";
        var l = !y || d === 1 ? d : (y - d) / (y - 1);
        l = ge.clamp(parseFloat(l.toFixed(3)), 0, 1), y = y + (1 - y) * l, P.setParameters({ threshold: E.value });
        var u = Z ? P.getPathTag("") : P.getPathTag();
        u = ge.setHtmlAttr(u, "fill-opacity", l.toFixed(3));
        var a = l === 0 || u.indexOf(' d=""') !== -1;
        return a ? "" : u;
      });
    },
    /**
     * Loads image.
     *
     * @param {string|Buffer|Jimp} target Image source. Could be anything that {@link Jimp} can read (buffer, local path or url). Supported formats are: PNG, JPEG or BMP
     * @param {Function} callback
     */
    loadImage: function(Z, _) {
      var P = this;
      this._potrace.loadImage(Z, function(x) {
        P._calculatedThreshold = null, _.call(P, x);
      });
    },
    /**
     * Sets parameters. Accepts same object as {Potrace}
     *
     * @param {Posterizer~Options} params
     */
    setParameters: function(Z) {
      if (Z) {
        if (this._potrace.setParameters(Z), Z.steps && !Array.isArray(Z.steps) && (!ge.isNumber(Z.steps) || !ge.between(Z.steps, 1, 255)))
          throw new Error("Bad 'steps' value");
        for (var _ in this._params)
          this._params.hasOwnProperty(_) && Z.hasOwnProperty(_) && (this._params[_] = Z[_]);
        this._calculatedThreshold = null;
      }
    },
    /**
     * Returns image as <symbol> tag. Always has viewBox specified
     *
     * @param {string} id
     */
    getSymbol: function(Z) {
      var _ = this._potrace._luminanceData.width, P = this._potrace._luminanceData.height, x = this._pathTags(!0);
      return '<symbol viewBox="0 0 ' + _ + " " + P + '" id="' + Z + '">' + x.join("") + "</symbol>";
    },
    /**
     * Generates SVG image
     * @returns {String}
     */
    getSVG: function() {
      var Z = this._potrace._luminanceData.width, _ = this._potrace._luminanceData.height, P = this._pathTags(!1), x = '<svg xmlns="http://www.w3.org/2000/svg" width="' + Z + '" height="' + _ + '" viewBox="0 0 ' + Z + " " + _ + `" version="1.1">
	` + (this._params.background !== Me.COLOR_TRANSPARENT ? '<rect x="0" y="0" width="100%" height="100%" fill="' + this._params.background + `" />
	` : "") + P.join(`
	`) + `
</svg>`;
      return x.replace(/\n(?:\t*\n)+(\t*)/g, `
$1`);
    }
  }, Hl = ne, Hl;
}
var Gl, Hc;
function R0() {
  if (Hc) return Gl;
  Hc = 1;
  var Me = hd(), ge = I0();
  function ne(Z, _, P) {
    arguments.length === 2 && (P = _, _ = {});
    var x = new Me(_);
    x.loadImage(Z, function(y) {
      if (y)
        return P(y);
      P(null, x.getSVG(), x);
    });
  }
  function C(Z, _, P) {
    arguments.length === 2 && (P = _, _ = {});
    var x = new ge(_);
    x.loadImage(Z, function(y) {
      if (y)
        return P(y);
      P(null, x.getSVG(), x);
    });
  }
  return Gl = {
    trace: ne,
    posterize: C,
    Potrace: Me,
    Posterizer: ge
  }, Gl;
}
var O0 = R0();
const Vl = /* @__PURE__ */ Yo(O0);
var Vo = { exports: {} };
const L0 = {}, N0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L0
}, Symbol.toStringTag, { value: "Module" })), Gc = /* @__PURE__ */ ip(N0);
var Ms = { exports: {} }, D0 = Ms.exports, Vc;
function B0() {
  return Vc || (Vc = 1, function(Me, ge) {
    (function(ne, C) {
      C(ge);
    })(D0, function(ne) {
      var C = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], Z = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], _ = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", P = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", x = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, y = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", E = {
        5: y,
        "5module": y + " export import",
        6: y + " const class extends export import super"
      }, d = /^in(stanceof)?$/, l = new RegExp("[" + P + "]"), u = new RegExp("[" + P + _ + "]");
      function a(v, V) {
        for (var Te = 65536, Le = 0; Le < V.length; Le += 2) {
          if (Te += V[Le], Te > v)
            return !1;
          if (Te += V[Le + 1], Te >= v)
            return !0;
        }
        return !1;
      }
      function n(v, V) {
        return v < 65 ? v === 36 : v < 91 ? !0 : v < 97 ? v === 95 : v < 123 ? !0 : v <= 65535 ? v >= 170 && l.test(String.fromCharCode(v)) : V === !1 ? !1 : a(v, Z);
      }
      function c(v, V) {
        return v < 48 ? v === 36 : v < 58 ? !0 : v < 65 ? !1 : v < 91 ? !0 : v < 97 ? v === 95 : v < 123 ? !0 : v <= 65535 ? v >= 170 && u.test(String.fromCharCode(v)) : V === !1 ? !1 : a(v, Z) || a(v, C);
      }
      var g = function(V, Te) {
        Te === void 0 && (Te = {}), this.label = V, this.keyword = Te.keyword, this.beforeExpr = !!Te.beforeExpr, this.startsExpr = !!Te.startsExpr, this.isLoop = !!Te.isLoop, this.isAssign = !!Te.isAssign, this.prefix = !!Te.prefix, this.postfix = !!Te.postfix, this.binop = Te.binop || null, this.updateContext = null;
      };
      function f(v, V) {
        return new g(v, { beforeExpr: !0, binop: V });
      }
      var p = { beforeExpr: !0 }, s = { startsExpr: !0 }, S = {};
      function b(v, V) {
        return V === void 0 && (V = {}), V.keyword = v, S[v] = new g(v, V);
      }
      var o = {
        num: new g("num", s),
        regexp: new g("regexp", s),
        string: new g("string", s),
        name: new g("name", s),
        privateId: new g("privateId", s),
        eof: new g("eof"),
        // Punctuation token types.
        bracketL: new g("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new g("]"),
        braceL: new g("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new g("}"),
        parenL: new g("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new g(")"),
        comma: new g(",", p),
        semi: new g(";", p),
        colon: new g(":", p),
        dot: new g("."),
        question: new g("?", p),
        questionDot: new g("?."),
        arrow: new g("=>", p),
        template: new g("template"),
        invalidTemplate: new g("invalidTemplate"),
        ellipsis: new g("...", p),
        backQuote: new g("`", s),
        dollarBraceL: new g("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new g("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new g("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new g("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new g("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: f("||", 1),
        logicalAND: f("&&", 2),
        bitwiseOR: f("|", 3),
        bitwiseXOR: f("^", 4),
        bitwiseAND: f("&", 5),
        equality: f("==/!=/===/!==", 6),
        relational: f("</>/<=/>=", 7),
        bitShift: f("<</>>/>>>", 8),
        plusMin: new g("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: f("%", 10),
        star: f("*", 10),
        slash: f("/", 10),
        starstar: new g("**", { beforeExpr: !0 }),
        coalesce: f("??", 1),
        // Keyword token types.
        _break: b("break"),
        _case: b("case", p),
        _catch: b("catch"),
        _continue: b("continue"),
        _debugger: b("debugger"),
        _default: b("default", p),
        _do: b("do", { isLoop: !0, beforeExpr: !0 }),
        _else: b("else", p),
        _finally: b("finally"),
        _for: b("for", { isLoop: !0 }),
        _function: b("function", s),
        _if: b("if"),
        _return: b("return", p),
        _switch: b("switch"),
        _throw: b("throw", p),
        _try: b("try"),
        _var: b("var"),
        _const: b("const"),
        _while: b("while", { isLoop: !0 }),
        _with: b("with"),
        _new: b("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: b("this", s),
        _super: b("super", s),
        _class: b("class", s),
        _extends: b("extends", p),
        _export: b("export"),
        _import: b("import", s),
        _null: b("null", s),
        _true: b("true", s),
        _false: b("false", s),
        _in: b("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: b("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: b("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: b("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: b("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, A = /\r\n?|\n|\u2028|\u2029/, T = new RegExp(A.source, "g");
      function R(v) {
        return v === 10 || v === 13 || v === 8232 || v === 8233;
      }
      function L(v, V, Te) {
        Te === void 0 && (Te = v.length);
        for (var Le = V; Le < Te; Le++) {
          var Xe = v.charCodeAt(Le);
          if (R(Xe))
            return Le < Te - 1 && Xe === 13 && v.charCodeAt(Le + 1) === 10 ? Le + 2 : Le + 1;
        }
        return -1;
      }
      var z = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, U = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, J = Object.prototype, F = J.hasOwnProperty, se = J.toString, ee = Object.hasOwn || function(v, V) {
        return F.call(v, V);
      }, ie = Array.isArray || function(v) {
        return se.call(v) === "[object Array]";
      }, W = /* @__PURE__ */ Object.create(null);
      function Q(v) {
        return W[v] || (W[v] = new RegExp("^(?:" + v.replace(/ /g, "|") + ")$"));
      }
      function de(v) {
        return v <= 65535 ? String.fromCharCode(v) : (v -= 65536, String.fromCharCode((v >> 10) + 55296, (v & 1023) + 56320));
      }
      var _e = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, ke = function(V, Te) {
        this.line = V, this.column = Te;
      };
      ke.prototype.offset = function(V) {
        return new ke(this.line, this.column + V);
      };
      var Pe = function(V, Te, Le) {
        this.start = Te, this.end = Le, V.sourceFile !== null && (this.source = V.sourceFile);
      };
      function fe(v, V) {
        for (var Te = 1, Le = 0; ; ) {
          var Xe = L(v, Le, V);
          if (Xe < 0)
            return new ke(Te, V - Le);
          ++Te, Le = Xe;
        }
      }
      var xe = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, Ee = !1;
      function Ie(v) {
        var V = {};
        for (var Te in xe)
          V[Te] = v && ee(v, Te) ? v[Te] : xe[Te];
        if (V.ecmaVersion === "latest" ? V.ecmaVersion = 1e8 : V.ecmaVersion == null ? (!Ee && typeof console == "object" && console.warn && (Ee = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), V.ecmaVersion = 11) : V.ecmaVersion >= 2015 && (V.ecmaVersion -= 2009), V.allowReserved == null && (V.allowReserved = V.ecmaVersion < 5), (!v || v.allowHashBang == null) && (V.allowHashBang = V.ecmaVersion >= 14), ie(V.onToken)) {
          var Le = V.onToken;
          V.onToken = function(Xe) {
            return Le.push(Xe);
          };
        }
        return ie(V.onComment) && (V.onComment = je(V, V.onComment)), V;
      }
      function je(v, V) {
        return function(Te, Le, Xe, at, lt, Et) {
          var Tt = {
            type: Te ? "Block" : "Line",
            value: Le,
            start: Xe,
            end: at
          };
          v.locations && (Tt.loc = new Pe(this, lt, Et)), v.ranges && (Tt.range = [Xe, at]), V.push(Tt);
        };
      }
      var Ue = 1, He = 2, Ze = 4, $e = 8, We = 16, Ve = 32, Re = 64, De = 128, Ne = 256, we = 512, re = Ue | He | Ne;
      function $(v, V) {
        return He | (v ? Ze : 0) | (V ? $e : 0);
      }
      var Ce = 0, ve = 1, Y = 2, G = 3, Ae = 4, e = 5, r = function(V, Te, Le) {
        this.options = V = Ie(V), this.sourceFile = V.sourceFile, this.keywords = Q(E[V.ecmaVersion >= 6 ? 6 : V.sourceType === "module" ? "5module" : 5]);
        var Xe = "";
        V.allowReserved !== !0 && (Xe = x[V.ecmaVersion >= 6 ? 6 : V.ecmaVersion === 5 ? 5 : 3], V.sourceType === "module" && (Xe += " await")), this.reservedWords = Q(Xe);
        var at = (Xe ? Xe + " " : "") + x.strict;
        this.reservedWordsStrict = Q(at), this.reservedWordsStrictBind = Q(at + " " + x.strictBind), this.input = String(Te), this.containsEsc = !1, Le ? (this.pos = Le, this.lineStart = this.input.lastIndexOf(`
`, Le - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(A).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = o.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = V.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && V.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(Ue), this.regexpState = null, this.privateNameStack = [];
      }, h = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      r.prototype.parse = function() {
        var V = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(V);
      }, h.inFunction.get = function() {
        return (this.currentVarScope().flags & He) > 0;
      }, h.inGenerator.get = function() {
        return (this.currentVarScope().flags & $e) > 0;
      }, h.inAsync.get = function() {
        return (this.currentVarScope().flags & Ze) > 0;
      }, h.canAwait.get = function() {
        for (var v = this.scopeStack.length - 1; v >= 0; v--) {
          var V = this.scopeStack[v], Te = V.flags;
          if (Te & (Ne | we))
            return !1;
          if (Te & He)
            return (Te & Ze) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, h.allowSuper.get = function() {
        var v = this.currentThisScope(), V = v.flags;
        return (V & Re) > 0 || this.options.allowSuperOutsideMethod;
      }, h.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & De) > 0;
      }, h.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, h.allowNewDotTarget.get = function() {
        for (var v = this.scopeStack.length - 1; v >= 0; v--) {
          var V = this.scopeStack[v], Te = V.flags;
          if (Te & (Ne | we) || Te & He && !(Te & We))
            return !0;
        }
        return !1;
      }, h.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & Ne) > 0;
      }, r.extend = function() {
        for (var V = [], Te = arguments.length; Te--; ) V[Te] = arguments[Te];
        for (var Le = this, Xe = 0; Xe < V.length; Xe++)
          Le = V[Xe](Le);
        return Le;
      }, r.parse = function(V, Te) {
        return new this(Te, V).parse();
      }, r.parseExpressionAt = function(V, Te, Le) {
        var Xe = new this(Le, V, Te);
        return Xe.nextToken(), Xe.parseExpression();
      }, r.tokenizer = function(V, Te) {
        return new this(Te, V);
      }, Object.defineProperties(r.prototype, h);
      var k = r.prototype, I = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      k.strictDirective = function(v) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          U.lastIndex = v, v += U.exec(this.input)[0].length;
          var V = I.exec(this.input.slice(v));
          if (!V)
            return !1;
          if ((V[1] || V[2]) === "use strict") {
            U.lastIndex = v + V[0].length;
            var Te = U.exec(this.input), Le = Te.index + Te[0].length, Xe = this.input.charAt(Le);
            return Xe === ";" || Xe === "}" || A.test(Te[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Xe) || Xe === "!" && this.input.charAt(Le + 1) === "=");
          }
          v += V[0].length, U.lastIndex = v, v += U.exec(this.input)[0].length, this.input[v] === ";" && v++;
        }
      }, k.eat = function(v) {
        return this.type === v ? (this.next(), !0) : !1;
      }, k.isContextual = function(v) {
        return this.type === o.name && this.value === v && !this.containsEsc;
      }, k.eatContextual = function(v) {
        return this.isContextual(v) ? (this.next(), !0) : !1;
      }, k.expectContextual = function(v) {
        this.eatContextual(v) || this.unexpected();
      }, k.canInsertSemicolon = function() {
        return this.type === o.eof || this.type === o.braceR || A.test(this.input.slice(this.lastTokEnd, this.start));
      }, k.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, k.semicolon = function() {
        !this.eat(o.semi) && !this.insertSemicolon() && this.unexpected();
      }, k.afterTrailingComma = function(v, V) {
        if (this.type === v)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), V || this.next(), !0;
      }, k.expect = function(v) {
        this.eat(v) || this.unexpected();
      }, k.unexpected = function(v) {
        this.raise(v ?? this.start, "Unexpected token");
      };
      var B = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      k.checkPatternErrors = function(v, V) {
        if (v) {
          v.trailingComma > -1 && this.raiseRecoverable(v.trailingComma, "Comma is not permitted after the rest element");
          var Te = V ? v.parenthesizedAssign : v.parenthesizedBind;
          Te > -1 && this.raiseRecoverable(Te, V ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, k.checkExpressionErrors = function(v, V) {
        if (!v)
          return !1;
        var Te = v.shorthandAssign, Le = v.doubleProto;
        if (!V)
          return Te >= 0 || Le >= 0;
        Te >= 0 && this.raise(Te, "Shorthand property assignments are valid only in destructuring patterns"), Le >= 0 && this.raiseRecoverable(Le, "Redefinition of __proto__ property");
      }, k.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, k.isSimpleAssignTarget = function(v) {
        return v.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(v.expression) : v.type === "Identifier" || v.type === "MemberExpression";
      };
      var j = r.prototype;
      j.parseTopLevel = function(v) {
        var V = /* @__PURE__ */ Object.create(null);
        for (v.body || (v.body = []); this.type !== o.eof; ) {
          var Te = this.parseStatement(null, !0, V);
          v.body.push(Te);
        }
        if (this.inModule)
          for (var Le = 0, Xe = Object.keys(this.undefinedExports); Le < Xe.length; Le += 1) {
            var at = Xe[Le];
            this.raiseRecoverable(this.undefinedExports[at].start, "Export '" + at + "' is not defined");
          }
        return this.adaptDirectivePrologue(v.body), this.next(), v.sourceType = this.options.sourceType, this.finishNode(v, "Program");
      };
      var H = { kind: "loop" }, X = { kind: "switch" };
      j.isLet = function(v) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        U.lastIndex = this.pos;
        var V = U.exec(this.input), Te = this.pos + V[0].length, Le = this.input.charCodeAt(Te);
        if (Le === 91 || Le === 92)
          return !0;
        if (v)
          return !1;
        if (Le === 123 || Le > 55295 && Le < 56320)
          return !0;
        if (n(Le, !0)) {
          for (var Xe = Te + 1; c(Le = this.input.charCodeAt(Xe), !0); )
            ++Xe;
          if (Le === 92 || Le > 55295 && Le < 56320)
            return !0;
          var at = this.input.slice(Te, Xe);
          if (!d.test(at))
            return !0;
        }
        return !1;
      }, j.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        U.lastIndex = this.pos;
        var v = U.exec(this.input), V = this.pos + v[0].length, Te;
        return !A.test(this.input.slice(this.pos, V)) && this.input.slice(V, V + 8) === "function" && (V + 8 === this.input.length || !(c(Te = this.input.charCodeAt(V + 8)) || Te > 55295 && Te < 56320));
      }, j.parseStatement = function(v, V, Te) {
        var Le = this.type, Xe = this.startNode(), at;
        switch (this.isLet(v) && (Le = o._var, at = "let"), Le) {
          case o._break:
          case o._continue:
            return this.parseBreakContinueStatement(Xe, Le.keyword);
          case o._debugger:
            return this.parseDebuggerStatement(Xe);
          case o._do:
            return this.parseDoStatement(Xe);
          case o._for:
            return this.parseForStatement(Xe);
          case o._function:
            return v && (this.strict || v !== "if" && v !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Xe, !1, !v);
          case o._class:
            return v && this.unexpected(), this.parseClass(Xe, !0);
          case o._if:
            return this.parseIfStatement(Xe);
          case o._return:
            return this.parseReturnStatement(Xe);
          case o._switch:
            return this.parseSwitchStatement(Xe);
          case o._throw:
            return this.parseThrowStatement(Xe);
          case o._try:
            return this.parseTryStatement(Xe);
          case o._const:
          case o._var:
            return at = at || this.value, v && at !== "var" && this.unexpected(), this.parseVarStatement(Xe, at);
          case o._while:
            return this.parseWhileStatement(Xe);
          case o._with:
            return this.parseWithStatement(Xe);
          case o.braceL:
            return this.parseBlock(!0, Xe);
          case o.semi:
            return this.parseEmptyStatement(Xe);
          case o._export:
          case o._import:
            if (this.options.ecmaVersion > 10 && Le === o._import) {
              U.lastIndex = this.pos;
              var lt = U.exec(this.input), Et = this.pos + lt[0].length, Tt = this.input.charCodeAt(Et);
              if (Tt === 40 || Tt === 46)
                return this.parseExpressionStatement(Xe, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (V || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), Le === o._import ? this.parseImport(Xe) : this.parseExport(Xe, Te);
          // If the statement does not start with a statement keyword or a
          // brace, it's an ExpressionStatement or LabeledStatement. We
          // simply start parsing an expression, and afterwards, if the
          // next token is a colon and the expression was a simple
          // Identifier node, we switch to interpreting it as a label.
          default:
            if (this.isAsyncFunction())
              return v && this.unexpected(), this.next(), this.parseFunctionStatement(Xe, !0, !v);
            var Yt = this.value, zt = this.parseExpression();
            return Le === o.name && zt.type === "Identifier" && this.eat(o.colon) ? this.parseLabeledStatement(Xe, Yt, zt, v) : this.parseExpressionStatement(Xe, zt);
        }
      }, j.parseBreakContinueStatement = function(v, V) {
        var Te = V === "break";
        this.next(), this.eat(o.semi) || this.insertSemicolon() ? v.label = null : this.type !== o.name ? this.unexpected() : (v.label = this.parseIdent(), this.semicolon());
        for (var Le = 0; Le < this.labels.length; ++Le) {
          var Xe = this.labels[Le];
          if ((v.label == null || Xe.name === v.label.name) && (Xe.kind != null && (Te || Xe.kind === "loop") || v.label && Te))
            break;
        }
        return Le === this.labels.length && this.raise(v.start, "Unsyntactic " + V), this.finishNode(v, Te ? "BreakStatement" : "ContinueStatement");
      }, j.parseDebuggerStatement = function(v) {
        return this.next(), this.semicolon(), this.finishNode(v, "DebuggerStatement");
      }, j.parseDoStatement = function(v) {
        return this.next(), this.labels.push(H), v.body = this.parseStatement("do"), this.labels.pop(), this.expect(o._while), v.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(o.semi) : this.semicolon(), this.finishNode(v, "DoWhileStatement");
      }, j.parseForStatement = function(v) {
        this.next();
        var V = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(H), this.enterScope(0), this.expect(o.parenL), this.type === o.semi)
          return V > -1 && this.unexpected(V), this.parseFor(v, null);
        var Te = this.isLet();
        if (this.type === o._var || this.type === o._const || Te) {
          var Le = this.startNode(), Xe = Te ? "let" : this.value;
          return this.next(), this.parseVar(Le, !0, Xe), this.finishNode(Le, "VariableDeclaration"), (this.type === o._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && Le.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === o._in ? V > -1 && this.unexpected(V) : v.await = V > -1), this.parseForIn(v, Le)) : (V > -1 && this.unexpected(V), this.parseFor(v, Le));
        }
        var at = this.isContextual("let"), lt = !1, Et = this.containsEsc, Tt = new B(), Yt = this.start, zt = V > -1 ? this.parseExprSubscripts(Tt, "await") : this.parseExpression(!0, Tt);
        return this.type === o._in || (lt = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (V > -1 ? (this.type === o._in && this.unexpected(V), v.await = !0) : lt && this.options.ecmaVersion >= 8 && (zt.start === Yt && !Et && zt.type === "Identifier" && zt.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (v.await = !1)), at && lt && this.raise(zt.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(zt, !1, Tt), this.checkLValPattern(zt), this.parseForIn(v, zt)) : (this.checkExpressionErrors(Tt, !0), V > -1 && this.unexpected(V), this.parseFor(v, zt));
      }, j.parseFunctionStatement = function(v, V, Te) {
        return this.next(), this.parseFunction(v, pe | (Te ? 0 : M), !1, V);
      }, j.parseIfStatement = function(v) {
        return this.next(), v.test = this.parseParenExpression(), v.consequent = this.parseStatement("if"), v.alternate = this.eat(o._else) ? this.parseStatement("if") : null, this.finishNode(v, "IfStatement");
      }, j.parseReturnStatement = function(v) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(o.semi) || this.insertSemicolon() ? v.argument = null : (v.argument = this.parseExpression(), this.semicolon()), this.finishNode(v, "ReturnStatement");
      }, j.parseSwitchStatement = function(v) {
        this.next(), v.discriminant = this.parseParenExpression(), v.cases = [], this.expect(o.braceL), this.labels.push(X), this.enterScope(0);
        for (var V, Te = !1; this.type !== o.braceR; )
          if (this.type === o._case || this.type === o._default) {
            var Le = this.type === o._case;
            V && this.finishNode(V, "SwitchCase"), v.cases.push(V = this.startNode()), V.consequent = [], this.next(), Le ? V.test = this.parseExpression() : (Te && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), Te = !0, V.test = null), this.expect(o.colon);
          } else
            V || this.unexpected(), V.consequent.push(this.parseStatement(null));
        return this.exitScope(), V && this.finishNode(V, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(v, "SwitchStatement");
      }, j.parseThrowStatement = function(v) {
        return this.next(), A.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), v.argument = this.parseExpression(), this.semicolon(), this.finishNode(v, "ThrowStatement");
      };
      var ue = [];
      j.parseCatchClauseParam = function() {
        var v = this.parseBindingAtom(), V = v.type === "Identifier";
        return this.enterScope(V ? Ve : 0), this.checkLValPattern(v, V ? Ae : Y), this.expect(o.parenR), v;
      }, j.parseTryStatement = function(v) {
        if (this.next(), v.block = this.parseBlock(), v.handler = null, this.type === o._catch) {
          var V = this.startNode();
          this.next(), this.eat(o.parenL) ? V.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), V.param = null, this.enterScope(0)), V.body = this.parseBlock(!1), this.exitScope(), v.handler = this.finishNode(V, "CatchClause");
        }
        return v.finalizer = this.eat(o._finally) ? this.parseBlock() : null, !v.handler && !v.finalizer && this.raise(v.start, "Missing catch or finally clause"), this.finishNode(v, "TryStatement");
      }, j.parseVarStatement = function(v, V, Te) {
        return this.next(), this.parseVar(v, !1, V, Te), this.semicolon(), this.finishNode(v, "VariableDeclaration");
      }, j.parseWhileStatement = function(v) {
        return this.next(), v.test = this.parseParenExpression(), this.labels.push(H), v.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(v, "WhileStatement");
      }, j.parseWithStatement = function(v) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), v.object = this.parseParenExpression(), v.body = this.parseStatement("with"), this.finishNode(v, "WithStatement");
      }, j.parseEmptyStatement = function(v) {
        return this.next(), this.finishNode(v, "EmptyStatement");
      }, j.parseLabeledStatement = function(v, V, Te, Le) {
        for (var Xe = 0, at = this.labels; Xe < at.length; Xe += 1) {
          var lt = at[Xe];
          lt.name === V && this.raise(Te.start, "Label '" + V + "' is already declared");
        }
        for (var Et = this.type.isLoop ? "loop" : this.type === o._switch ? "switch" : null, Tt = this.labels.length - 1; Tt >= 0; Tt--) {
          var Yt = this.labels[Tt];
          if (Yt.statementStart === v.start)
            Yt.statementStart = this.start, Yt.kind = Et;
          else
            break;
        }
        return this.labels.push({ name: V, kind: Et, statementStart: this.start }), v.body = this.parseStatement(Le ? Le.indexOf("label") === -1 ? Le + "label" : Le : "label"), this.labels.pop(), v.label = Te, this.finishNode(v, "LabeledStatement");
      }, j.parseExpressionStatement = function(v, V) {
        return v.expression = V, this.semicolon(), this.finishNode(v, "ExpressionStatement");
      }, j.parseBlock = function(v, V, Te) {
        for (v === void 0 && (v = !0), V === void 0 && (V = this.startNode()), V.body = [], this.expect(o.braceL), v && this.enterScope(0); this.type !== o.braceR; ) {
          var Le = this.parseStatement(null);
          V.body.push(Le);
        }
        return Te && (this.strict = !1), this.next(), v && this.exitScope(), this.finishNode(V, "BlockStatement");
      }, j.parseFor = function(v, V) {
        return v.init = V, this.expect(o.semi), v.test = this.type === o.semi ? null : this.parseExpression(), this.expect(o.semi), v.update = this.type === o.parenR ? null : this.parseExpression(), this.expect(o.parenR), v.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(v, "ForStatement");
      }, j.parseForIn = function(v, V) {
        var Te = this.type === o._in;
        return this.next(), V.type === "VariableDeclaration" && V.declarations[0].init != null && (!Te || this.options.ecmaVersion < 8 || this.strict || V.kind !== "var" || V.declarations[0].id.type !== "Identifier") && this.raise(
          V.start,
          (Te ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), v.left = V, v.right = Te ? this.parseExpression() : this.parseMaybeAssign(), this.expect(o.parenR), v.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(v, Te ? "ForInStatement" : "ForOfStatement");
      }, j.parseVar = function(v, V, Te, Le) {
        for (v.declarations = [], v.kind = Te; ; ) {
          var Xe = this.startNode();
          if (this.parseVarId(Xe, Te), this.eat(o.eq) ? Xe.init = this.parseMaybeAssign(V) : !Le && Te === "const" && !(this.type === o._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !Le && Xe.id.type !== "Identifier" && !(V && (this.type === o._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Xe.init = null, v.declarations.push(this.finishNode(Xe, "VariableDeclarator")), !this.eat(o.comma))
            break;
        }
        return v;
      }, j.parseVarId = function(v, V) {
        v.id = this.parseBindingAtom(), this.checkLValPattern(v.id, V === "var" ? ve : Y, !1);
      };
      var pe = 1, M = 2, q = 4;
      j.parseFunction = function(v, V, Te, Le, Xe) {
        this.initFunction(v), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !Le) && (this.type === o.star && V & M && this.unexpected(), v.generator = this.eat(o.star)), this.options.ecmaVersion >= 8 && (v.async = !!Le), V & pe && (v.id = V & q && this.type !== o.name ? null : this.parseIdent(), v.id && !(V & M) && this.checkLValSimple(v.id, this.strict || v.generator || v.async ? this.treatFunctionsAsVar ? ve : Y : G));
        var at = this.yieldPos, lt = this.awaitPos, Et = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope($(v.async, v.generator)), V & pe || (v.id = this.type === o.name ? this.parseIdent() : null), this.parseFunctionParams(v), this.parseFunctionBody(v, Te, !1, Xe), this.yieldPos = at, this.awaitPos = lt, this.awaitIdentPos = Et, this.finishNode(v, V & pe ? "FunctionDeclaration" : "FunctionExpression");
      }, j.parseFunctionParams = function(v) {
        this.expect(o.parenL), v.params = this.parseBindingList(o.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, j.parseClass = function(v, V) {
        this.next();
        var Te = this.strict;
        this.strict = !0, this.parseClassId(v, V), this.parseClassSuper(v);
        var Le = this.enterClassBody(), Xe = this.startNode(), at = !1;
        for (Xe.body = [], this.expect(o.braceL); this.type !== o.braceR; ) {
          var lt = this.parseClassElement(v.superClass !== null);
          lt && (Xe.body.push(lt), lt.type === "MethodDefinition" && lt.kind === "constructor" ? (at && this.raiseRecoverable(lt.start, "Duplicate constructor in the same class"), at = !0) : lt.key && lt.key.type === "PrivateIdentifier" && K(Le, lt) && this.raiseRecoverable(lt.key.start, "Identifier '#" + lt.key.name + "' has already been declared"));
        }
        return this.strict = Te, this.next(), v.body = this.finishNode(Xe, "ClassBody"), this.exitClassBody(), this.finishNode(v, V ? "ClassDeclaration" : "ClassExpression");
      }, j.parseClassElement = function(v) {
        if (this.eat(o.semi))
          return null;
        var V = this.options.ecmaVersion, Te = this.startNode(), Le = "", Xe = !1, at = !1, lt = "method", Et = !1;
        if (this.eatContextual("static")) {
          if (V >= 13 && this.eat(o.braceL))
            return this.parseClassStaticBlock(Te), Te;
          this.isClassElementNameStart() || this.type === o.star ? Et = !0 : Le = "static";
        }
        if (Te.static = Et, !Le && V >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === o.star) && !this.canInsertSemicolon() ? at = !0 : Le = "async"), !Le && (V >= 9 || !at) && this.eat(o.star) && (Xe = !0), !Le && !at && !Xe) {
          var Tt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? lt = Tt : Le = Tt);
        }
        if (Le ? (Te.computed = !1, Te.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), Te.key.name = Le, this.finishNode(Te.key, "Identifier")) : this.parseClassElementName(Te), V < 13 || this.type === o.parenL || lt !== "method" || Xe || at) {
          var Yt = !Te.static && be(Te, "constructor"), zt = Yt && v;
          Yt && lt !== "method" && this.raise(Te.key.start, "Constructor can't have get/set modifier"), Te.kind = Yt ? "constructor" : lt, this.parseClassMethod(Te, Xe, at, zt);
        } else
          this.parseClassField(Te);
        return Te;
      }, j.isClassElementNameStart = function() {
        return this.type === o.name || this.type === o.privateId || this.type === o.num || this.type === o.string || this.type === o.bracketL || this.type.keyword;
      }, j.parseClassElementName = function(v) {
        this.type === o.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), v.computed = !1, v.key = this.parsePrivateIdent()) : this.parsePropertyName(v);
      }, j.parseClassMethod = function(v, V, Te, Le) {
        var Xe = v.key;
        v.kind === "constructor" ? (V && this.raise(Xe.start, "Constructor can't be a generator"), Te && this.raise(Xe.start, "Constructor can't be an async method")) : v.static && be(v, "prototype") && this.raise(Xe.start, "Classes may not have a static property named prototype");
        var at = v.value = this.parseMethod(V, Te, Le);
        return v.kind === "get" && at.params.length !== 0 && this.raiseRecoverable(at.start, "getter should have no params"), v.kind === "set" && at.params.length !== 1 && this.raiseRecoverable(at.start, "setter should have exactly one param"), v.kind === "set" && at.params[0].type === "RestElement" && this.raiseRecoverable(at.params[0].start, "Setter cannot use rest params"), this.finishNode(v, "MethodDefinition");
      }, j.parseClassField = function(v) {
        return be(v, "constructor") ? this.raise(v.key.start, "Classes can't have a field named 'constructor'") : v.static && be(v, "prototype") && this.raise(v.key.start, "Classes can't have a static field named 'prototype'"), this.eat(o.eq) ? (this.enterScope(we | Re), v.value = this.parseMaybeAssign(), this.exitScope()) : v.value = null, this.semicolon(), this.finishNode(v, "PropertyDefinition");
      }, j.parseClassStaticBlock = function(v) {
        v.body = [];
        var V = this.labels;
        for (this.labels = [], this.enterScope(Ne | Re); this.type !== o.braceR; ) {
          var Te = this.parseStatement(null);
          v.body.push(Te);
        }
        return this.next(), this.exitScope(), this.labels = V, this.finishNode(v, "StaticBlock");
      }, j.parseClassId = function(v, V) {
        this.type === o.name ? (v.id = this.parseIdent(), V && this.checkLValSimple(v.id, Y, !1)) : (V === !0 && this.unexpected(), v.id = null);
      }, j.parseClassSuper = function(v) {
        v.superClass = this.eat(o._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, j.enterClassBody = function() {
        var v = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(v), v.declared;
      }, j.exitClassBody = function() {
        var v = this.privateNameStack.pop(), V = v.declared, Te = v.used;
        if (this.options.checkPrivateFields)
          for (var Le = this.privateNameStack.length, Xe = Le === 0 ? null : this.privateNameStack[Le - 1], at = 0; at < Te.length; ++at) {
            var lt = Te[at];
            ee(V, lt.name) || (Xe ? Xe.used.push(lt) : this.raiseRecoverable(lt.start, "Private field '#" + lt.name + "' must be declared in an enclosing class"));
          }
      };
      function K(v, V) {
        var Te = V.key.name, Le = v[Te], Xe = "true";
        return V.type === "MethodDefinition" && (V.kind === "get" || V.kind === "set") && (Xe = (V.static ? "s" : "i") + V.kind), Le === "iget" && Xe === "iset" || Le === "iset" && Xe === "iget" || Le === "sget" && Xe === "sset" || Le === "sset" && Xe === "sget" ? (v[Te] = "true", !1) : Le ? !0 : (v[Te] = Xe, !1);
      }
      function be(v, V) {
        var Te = v.computed, Le = v.key;
        return !Te && (Le.type === "Identifier" && Le.name === V || Le.type === "Literal" && Le.value === V);
      }
      j.parseExportAllDeclaration = function(v, V) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (v.exported = this.parseModuleExportName(), this.checkExport(V, v.exported, this.lastTokStart)) : v.exported = null), this.expectContextual("from"), this.type !== o.string && this.unexpected(), v.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (v.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(v, "ExportAllDeclaration");
      }, j.parseExport = function(v, V) {
        if (this.next(), this.eat(o.star))
          return this.parseExportAllDeclaration(v, V);
        if (this.eat(o._default))
          return this.checkExport(V, "default", this.lastTokStart), v.declaration = this.parseExportDefaultDeclaration(), this.finishNode(v, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          v.declaration = this.parseExportDeclaration(v), v.declaration.type === "VariableDeclaration" ? this.checkVariableExport(V, v.declaration.declarations) : this.checkExport(V, v.declaration.id, v.declaration.id.start), v.specifiers = [], v.source = null, this.options.ecmaVersion >= 16 && (v.attributes = []);
        else {
          if (v.declaration = null, v.specifiers = this.parseExportSpecifiers(V), this.eatContextual("from"))
            this.type !== o.string && this.unexpected(), v.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (v.attributes = this.parseWithClause());
          else {
            for (var Te = 0, Le = v.specifiers; Te < Le.length; Te += 1) {
              var Xe = Le[Te];
              this.checkUnreserved(Xe.local), this.checkLocalExport(Xe.local), Xe.local.type === "Literal" && this.raise(Xe.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            v.source = null, this.options.ecmaVersion >= 16 && (v.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(v, "ExportNamedDeclaration");
      }, j.parseExportDeclaration = function(v) {
        return this.parseStatement(null);
      }, j.parseExportDefaultDeclaration = function() {
        var v;
        if (this.type === o._function || (v = this.isAsyncFunction())) {
          var V = this.startNode();
          return this.next(), v && this.next(), this.parseFunction(V, pe | q, !1, v);
        } else if (this.type === o._class) {
          var Te = this.startNode();
          return this.parseClass(Te, "nullableID");
        } else {
          var Le = this.parseMaybeAssign();
          return this.semicolon(), Le;
        }
      }, j.checkExport = function(v, V, Te) {
        v && (typeof V != "string" && (V = V.type === "Identifier" ? V.name : V.value), ee(v, V) && this.raiseRecoverable(Te, "Duplicate export '" + V + "'"), v[V] = !0);
      }, j.checkPatternExport = function(v, V) {
        var Te = V.type;
        if (Te === "Identifier")
          this.checkExport(v, V, V.start);
        else if (Te === "ObjectPattern")
          for (var Le = 0, Xe = V.properties; Le < Xe.length; Le += 1) {
            var at = Xe[Le];
            this.checkPatternExport(v, at);
          }
        else if (Te === "ArrayPattern")
          for (var lt = 0, Et = V.elements; lt < Et.length; lt += 1) {
            var Tt = Et[lt];
            Tt && this.checkPatternExport(v, Tt);
          }
        else Te === "Property" ? this.checkPatternExport(v, V.value) : Te === "AssignmentPattern" ? this.checkPatternExport(v, V.left) : Te === "RestElement" && this.checkPatternExport(v, V.argument);
      }, j.checkVariableExport = function(v, V) {
        if (v)
          for (var Te = 0, Le = V; Te < Le.length; Te += 1) {
            var Xe = Le[Te];
            this.checkPatternExport(v, Xe.id);
          }
      }, j.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, j.parseExportSpecifier = function(v) {
        var V = this.startNode();
        return V.local = this.parseModuleExportName(), V.exported = this.eatContextual("as") ? this.parseModuleExportName() : V.local, this.checkExport(
          v,
          V.exported,
          V.exported.start
        ), this.finishNode(V, "ExportSpecifier");
      }, j.parseExportSpecifiers = function(v) {
        var V = [], Te = !0;
        for (this.expect(o.braceL); !this.eat(o.braceR); ) {
          if (Te)
            Te = !1;
          else if (this.expect(o.comma), this.afterTrailingComma(o.braceR))
            break;
          V.push(this.parseExportSpecifier(v));
        }
        return V;
      }, j.parseImport = function(v) {
        return this.next(), this.type === o.string ? (v.specifiers = ue, v.source = this.parseExprAtom()) : (v.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), v.source = this.type === o.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (v.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(v, "ImportDeclaration");
      }, j.parseImportSpecifier = function() {
        var v = this.startNode();
        return v.imported = this.parseModuleExportName(), this.eatContextual("as") ? v.local = this.parseIdent() : (this.checkUnreserved(v.imported), v.local = v.imported), this.checkLValSimple(v.local, Y), this.finishNode(v, "ImportSpecifier");
      }, j.parseImportDefaultSpecifier = function() {
        var v = this.startNode();
        return v.local = this.parseIdent(), this.checkLValSimple(v.local, Y), this.finishNode(v, "ImportDefaultSpecifier");
      }, j.parseImportNamespaceSpecifier = function() {
        var v = this.startNode();
        return this.next(), this.expectContextual("as"), v.local = this.parseIdent(), this.checkLValSimple(v.local, Y), this.finishNode(v, "ImportNamespaceSpecifier");
      }, j.parseImportSpecifiers = function() {
        var v = [], V = !0;
        if (this.type === o.name && (v.push(this.parseImportDefaultSpecifier()), !this.eat(o.comma)))
          return v;
        if (this.type === o.star)
          return v.push(this.parseImportNamespaceSpecifier()), v;
        for (this.expect(o.braceL); !this.eat(o.braceR); ) {
          if (V)
            V = !1;
          else if (this.expect(o.comma), this.afterTrailingComma(o.braceR))
            break;
          v.push(this.parseImportSpecifier());
        }
        return v;
      }, j.parseWithClause = function() {
        var v = [];
        if (!this.eat(o._with))
          return v;
        this.expect(o.braceL);
        for (var V = {}, Te = !0; !this.eat(o.braceR); ) {
          if (Te)
            Te = !1;
          else if (this.expect(o.comma), this.afterTrailingComma(o.braceR))
            break;
          var Le = this.parseImportAttribute(), Xe = Le.key.type === "Identifier" ? Le.key.name : Le.key.value;
          ee(V, Xe) && this.raiseRecoverable(Le.key.start, "Duplicate attribute key '" + Xe + "'"), V[Xe] = !0, v.push(Le);
        }
        return v;
      }, j.parseImportAttribute = function() {
        var v = this.startNode();
        return v.key = this.type === o.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(o.colon), this.type !== o.string && this.unexpected(), v.value = this.parseExprAtom(), this.finishNode(v, "ImportAttribute");
      }, j.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === o.string) {
          var v = this.parseLiteral(this.value);
          return _e.test(v.value) && this.raise(v.start, "An export name cannot include a lone surrogate."), v;
        }
        return this.parseIdent(!0);
      }, j.adaptDirectivePrologue = function(v) {
        for (var V = 0; V < v.length && this.isDirectiveCandidate(v[V]); ++V)
          v[V].directive = v[V].expression.raw.slice(1, -1);
      }, j.isDirectiveCandidate = function(v) {
        return this.options.ecmaVersion >= 5 && v.type === "ExpressionStatement" && v.expression.type === "Literal" && typeof v.expression.value == "string" && // Reject parenthesized strings.
        (this.input[v.start] === '"' || this.input[v.start] === "'");
      };
      var te = r.prototype;
      te.toAssignable = function(v, V, Te) {
        if (this.options.ecmaVersion >= 6 && v)
          switch (v.type) {
            case "Identifier":
              this.inAsync && v.name === "await" && this.raise(v.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              v.type = "ObjectPattern", Te && this.checkPatternErrors(Te, !0);
              for (var Le = 0, Xe = v.properties; Le < Xe.length; Le += 1) {
                var at = Xe[Le];
                this.toAssignable(at, V), at.type === "RestElement" && (at.argument.type === "ArrayPattern" || at.argument.type === "ObjectPattern") && this.raise(at.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              v.kind !== "init" && this.raise(v.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(v.value, V);
              break;
            case "ArrayExpression":
              v.type = "ArrayPattern", Te && this.checkPatternErrors(Te, !0), this.toAssignableList(v.elements, V);
              break;
            case "SpreadElement":
              v.type = "RestElement", this.toAssignable(v.argument, V), v.argument.type === "AssignmentPattern" && this.raise(v.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              v.operator !== "=" && this.raise(v.left.end, "Only '=' operator can be used for specifying default value."), v.type = "AssignmentPattern", delete v.operator, this.toAssignable(v.left, V);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(v.expression, V, Te);
              break;
            case "ChainExpression":
              this.raiseRecoverable(v.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!V)
                break;
            default:
              this.raise(v.start, "Assigning to rvalue");
          }
        else Te && this.checkPatternErrors(Te, !0);
        return v;
      }, te.toAssignableList = function(v, V) {
        for (var Te = v.length, Le = 0; Le < Te; Le++) {
          var Xe = v[Le];
          Xe && this.toAssignable(Xe, V);
        }
        if (Te) {
          var at = v[Te - 1];
          this.options.ecmaVersion === 6 && V && at && at.type === "RestElement" && at.argument.type !== "Identifier" && this.unexpected(at.argument.start);
        }
        return v;
      }, te.parseSpread = function(v) {
        var V = this.startNode();
        return this.next(), V.argument = this.parseMaybeAssign(!1, v), this.finishNode(V, "SpreadElement");
      }, te.parseRestBinding = function() {
        var v = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== o.name && this.unexpected(), v.argument = this.parseBindingAtom(), this.finishNode(v, "RestElement");
      }, te.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case o.bracketL:
              var v = this.startNode();
              return this.next(), v.elements = this.parseBindingList(o.bracketR, !0, !0), this.finishNode(v, "ArrayPattern");
            case o.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, te.parseBindingList = function(v, V, Te, Le) {
        for (var Xe = [], at = !0; !this.eat(v); )
          if (at ? at = !1 : this.expect(o.comma), V && this.type === o.comma)
            Xe.push(null);
          else {
            if (Te && this.afterTrailingComma(v))
              break;
            if (this.type === o.ellipsis) {
              var lt = this.parseRestBinding();
              this.parseBindingListItem(lt), Xe.push(lt), this.type === o.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(v);
              break;
            } else
              Xe.push(this.parseAssignableListItem(Le));
          }
        return Xe;
      }, te.parseAssignableListItem = function(v) {
        var V = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(V), V;
      }, te.parseBindingListItem = function(v) {
        return v;
      }, te.parseMaybeDefault = function(v, V, Te) {
        if (Te = Te || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(o.eq))
          return Te;
        var Le = this.startNodeAt(v, V);
        return Le.left = Te, Le.right = this.parseMaybeAssign(), this.finishNode(Le, "AssignmentPattern");
      }, te.checkLValSimple = function(v, V, Te) {
        V === void 0 && (V = Ce);
        var Le = V !== Ce;
        switch (v.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(v.name) && this.raiseRecoverable(v.start, (Le ? "Binding " : "Assigning to ") + v.name + " in strict mode"), Le && (V === Y && v.name === "let" && this.raiseRecoverable(v.start, "let is disallowed as a lexically bound name"), Te && (ee(Te, v.name) && this.raiseRecoverable(v.start, "Argument name clash"), Te[v.name] = !0), V !== e && this.declareName(v.name, V, v.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(v.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            Le && this.raiseRecoverable(v.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return Le && this.raiseRecoverable(v.start, "Binding parenthesized expression"), this.checkLValSimple(v.expression, V, Te);
          default:
            this.raise(v.start, (Le ? "Binding" : "Assigning to") + " rvalue");
        }
      }, te.checkLValPattern = function(v, V, Te) {
        switch (V === void 0 && (V = Ce), v.type) {
          case "ObjectPattern":
            for (var Le = 0, Xe = v.properties; Le < Xe.length; Le += 1) {
              var at = Xe[Le];
              this.checkLValInnerPattern(at, V, Te);
            }
            break;
          case "ArrayPattern":
            for (var lt = 0, Et = v.elements; lt < Et.length; lt += 1) {
              var Tt = Et[lt];
              Tt && this.checkLValInnerPattern(Tt, V, Te);
            }
            break;
          default:
            this.checkLValSimple(v, V, Te);
        }
      }, te.checkLValInnerPattern = function(v, V, Te) {
        switch (V === void 0 && (V = Ce), v.type) {
          case "Property":
            this.checkLValInnerPattern(v.value, V, Te);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(v.left, V, Te);
            break;
          case "RestElement":
            this.checkLValPattern(v.argument, V, Te);
            break;
          default:
            this.checkLValPattern(v, V, Te);
        }
      };
      var he = function(V, Te, Le, Xe, at) {
        this.token = V, this.isExpr = !!Te, this.preserveSpace = !!Le, this.override = Xe, this.generator = !!at;
      }, D = {
        b_stat: new he("{", !1),
        b_expr: new he("{", !0),
        b_tmpl: new he("${", !1),
        p_stat: new he("(", !1),
        p_expr: new he("(", !0),
        q_tmpl: new he("`", !0, !0, function(v) {
          return v.tryReadTemplateToken();
        }),
        f_stat: new he("function", !1),
        f_expr: new he("function", !0),
        f_expr_gen: new he("function", !0, !1, null, !0),
        f_gen: new he("function", !1, !1, null, !0)
      }, Se = r.prototype;
      Se.initialContext = function() {
        return [D.b_stat];
      }, Se.curContext = function() {
        return this.context[this.context.length - 1];
      }, Se.braceIsBlock = function(v) {
        var V = this.curContext();
        return V === D.f_expr || V === D.f_stat ? !0 : v === o.colon && (V === D.b_stat || V === D.b_expr) ? !V.isExpr : v === o._return || v === o.name && this.exprAllowed ? A.test(this.input.slice(this.lastTokEnd, this.start)) : v === o._else || v === o.semi || v === o.eof || v === o.parenR || v === o.arrow ? !0 : v === o.braceL ? V === D.b_stat : v === o._var || v === o._const || v === o.name ? !1 : !this.exprAllowed;
      }, Se.inGeneratorContext = function() {
        for (var v = this.context.length - 1; v >= 1; v--) {
          var V = this.context[v];
          if (V.token === "function")
            return V.generator;
        }
        return !1;
      }, Se.updateContext = function(v) {
        var V, Te = this.type;
        Te.keyword && v === o.dot ? this.exprAllowed = !1 : (V = Te.updateContext) ? V.call(this, v) : this.exprAllowed = Te.beforeExpr;
      }, Se.overrideContext = function(v) {
        this.curContext() !== v && (this.context[this.context.length - 1] = v);
      }, o.parenR.updateContext = o.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var v = this.context.pop();
        v === D.b_stat && this.curContext().token === "function" && (v = this.context.pop()), this.exprAllowed = !v.isExpr;
      }, o.braceL.updateContext = function(v) {
        this.context.push(this.braceIsBlock(v) ? D.b_stat : D.b_expr), this.exprAllowed = !0;
      }, o.dollarBraceL.updateContext = function() {
        this.context.push(D.b_tmpl), this.exprAllowed = !0;
      }, o.parenL.updateContext = function(v) {
        var V = v === o._if || v === o._for || v === o._with || v === o._while;
        this.context.push(V ? D.p_stat : D.p_expr), this.exprAllowed = !0;
      }, o.incDec.updateContext = function() {
      }, o._function.updateContext = o._class.updateContext = function(v) {
        v.beforeExpr && v !== o._else && !(v === o.semi && this.curContext() !== D.p_stat) && !(v === o._return && A.test(this.input.slice(this.lastTokEnd, this.start))) && !((v === o.colon || v === o.braceL) && this.curContext() === D.b_stat) ? this.context.push(D.f_expr) : this.context.push(D.f_stat), this.exprAllowed = !1;
      }, o.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, o.backQuote.updateContext = function() {
        this.curContext() === D.q_tmpl ? this.context.pop() : this.context.push(D.q_tmpl), this.exprAllowed = !1;
      }, o.star.updateContext = function(v) {
        if (v === o._function) {
          var V = this.context.length - 1;
          this.context[V] === D.f_expr ? this.context[V] = D.f_expr_gen : this.context[V] = D.f_gen;
        }
        this.exprAllowed = !0;
      }, o.name.updateContext = function(v) {
        var V = !1;
        this.options.ecmaVersion >= 6 && v !== o.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (V = !0), this.exprAllowed = V;
      };
      var le = r.prototype;
      le.checkPropClash = function(v, V, Te) {
        if (!(this.options.ecmaVersion >= 9 && v.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (v.computed || v.method || v.shorthand))) {
          var Le = v.key, Xe;
          switch (Le.type) {
            case "Identifier":
              Xe = Le.name;
              break;
            case "Literal":
              Xe = String(Le.value);
              break;
            default:
              return;
          }
          var at = v.kind;
          if (this.options.ecmaVersion >= 6) {
            Xe === "__proto__" && at === "init" && (V.proto && (Te ? Te.doubleProto < 0 && (Te.doubleProto = Le.start) : this.raiseRecoverable(Le.start, "Redefinition of __proto__ property")), V.proto = !0);
            return;
          }
          Xe = "$" + Xe;
          var lt = V[Xe];
          if (lt) {
            var Et;
            at === "init" ? Et = this.strict && lt.init || lt.get || lt.set : Et = lt.init || lt[at], Et && this.raiseRecoverable(Le.start, "Redefinition of property");
          } else
            lt = V[Xe] = {
              init: !1,
              get: !1,
              set: !1
            };
          lt[at] = !0;
        }
      }, le.parseExpression = function(v, V) {
        var Te = this.start, Le = this.startLoc, Xe = this.parseMaybeAssign(v, V);
        if (this.type === o.comma) {
          var at = this.startNodeAt(Te, Le);
          for (at.expressions = [Xe]; this.eat(o.comma); )
            at.expressions.push(this.parseMaybeAssign(v, V));
          return this.finishNode(at, "SequenceExpression");
        }
        return Xe;
      }, le.parseMaybeAssign = function(v, V, Te) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(v);
          this.exprAllowed = !1;
        }
        var Le = !1, Xe = -1, at = -1, lt = -1;
        V ? (Xe = V.parenthesizedAssign, at = V.trailingComma, lt = V.doubleProto, V.parenthesizedAssign = V.trailingComma = -1) : (V = new B(), Le = !0);
        var Et = this.start, Tt = this.startLoc;
        (this.type === o.parenL || this.type === o.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = v === "await");
        var Yt = this.parseMaybeConditional(v, V);
        if (Te && (Yt = Te.call(this, Yt, Et, Tt)), this.type.isAssign) {
          var zt = this.startNodeAt(Et, Tt);
          return zt.operator = this.value, this.type === o.eq && (Yt = this.toAssignable(Yt, !1, V)), Le || (V.parenthesizedAssign = V.trailingComma = V.doubleProto = -1), V.shorthandAssign >= Yt.start && (V.shorthandAssign = -1), this.type === o.eq ? this.checkLValPattern(Yt) : this.checkLValSimple(Yt), zt.left = Yt, this.next(), zt.right = this.parseMaybeAssign(v), lt > -1 && (V.doubleProto = lt), this.finishNode(zt, "AssignmentExpression");
        } else
          Le && this.checkExpressionErrors(V, !0);
        return Xe > -1 && (V.parenthesizedAssign = Xe), at > -1 && (V.trailingComma = at), Yt;
      }, le.parseMaybeConditional = function(v, V) {
        var Te = this.start, Le = this.startLoc, Xe = this.parseExprOps(v, V);
        if (this.checkExpressionErrors(V))
          return Xe;
        if (this.eat(o.question)) {
          var at = this.startNodeAt(Te, Le);
          return at.test = Xe, at.consequent = this.parseMaybeAssign(), this.expect(o.colon), at.alternate = this.parseMaybeAssign(v), this.finishNode(at, "ConditionalExpression");
        }
        return Xe;
      }, le.parseExprOps = function(v, V) {
        var Te = this.start, Le = this.startLoc, Xe = this.parseMaybeUnary(V, !1, !1, v);
        return this.checkExpressionErrors(V) || Xe.start === Te && Xe.type === "ArrowFunctionExpression" ? Xe : this.parseExprOp(Xe, Te, Le, -1, v);
      }, le.parseExprOp = function(v, V, Te, Le, Xe) {
        var at = this.type.binop;
        if (at != null && (!Xe || this.type !== o._in) && at > Le) {
          var lt = this.type === o.logicalOR || this.type === o.logicalAND, Et = this.type === o.coalesce;
          Et && (at = o.logicalAND.binop);
          var Tt = this.value;
          this.next();
          var Yt = this.start, zt = this.startLoc, fr = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Xe), Yt, zt, at, Xe), $r = this.buildBinary(V, Te, v, fr, Tt, lt || Et);
          return (lt && this.type === o.coalesce || Et && (this.type === o.logicalOR || this.type === o.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp($r, V, Te, Le, Xe);
        }
        return v;
      }, le.buildBinary = function(v, V, Te, Le, Xe, at) {
        Le.type === "PrivateIdentifier" && this.raise(Le.start, "Private identifier can only be left side of binary expression");
        var lt = this.startNodeAt(v, V);
        return lt.left = Te, lt.operator = Xe, lt.right = Le, this.finishNode(lt, at ? "LogicalExpression" : "BinaryExpression");
      }, le.parseMaybeUnary = function(v, V, Te, Le) {
        var Xe = this.start, at = this.startLoc, lt;
        if (this.isContextual("await") && this.canAwait)
          lt = this.parseAwait(Le), V = !0;
        else if (this.type.prefix) {
          var Et = this.startNode(), Tt = this.type === o.incDec;
          Et.operator = this.value, Et.prefix = !0, this.next(), Et.argument = this.parseMaybeUnary(null, !0, Tt, Le), this.checkExpressionErrors(v, !0), Tt ? this.checkLValSimple(Et.argument) : this.strict && Et.operator === "delete" && m(Et.argument) ? this.raiseRecoverable(Et.start, "Deleting local variable in strict mode") : Et.operator === "delete" && oe(Et.argument) ? this.raiseRecoverable(Et.start, "Private fields can not be deleted") : V = !0, lt = this.finishNode(Et, Tt ? "UpdateExpression" : "UnaryExpression");
        } else if (!V && this.type === o.privateId)
          (Le || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), lt = this.parsePrivateIdent(), this.type !== o._in && this.unexpected();
        else {
          if (lt = this.parseExprSubscripts(v, Le), this.checkExpressionErrors(v))
            return lt;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var Yt = this.startNodeAt(Xe, at);
            Yt.operator = this.value, Yt.prefix = !1, Yt.argument = lt, this.checkLValSimple(lt), this.next(), lt = this.finishNode(Yt, "UpdateExpression");
          }
        }
        if (!Te && this.eat(o.starstar))
          if (V)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Xe, at, lt, this.parseMaybeUnary(null, !1, !1, Le), "**", !1);
        else
          return lt;
      };
      function m(v) {
        return v.type === "Identifier" || v.type === "ParenthesizedExpression" && m(v.expression);
      }
      function oe(v) {
        return v.type === "MemberExpression" && v.property.type === "PrivateIdentifier" || v.type === "ChainExpression" && oe(v.expression) || v.type === "ParenthesizedExpression" && oe(v.expression);
      }
      le.parseExprSubscripts = function(v, V) {
        var Te = this.start, Le = this.startLoc, Xe = this.parseExprAtom(v, V);
        if (Xe.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Xe;
        var at = this.parseSubscripts(Xe, Te, Le, !1, V);
        return v && at.type === "MemberExpression" && (v.parenthesizedAssign >= at.start && (v.parenthesizedAssign = -1), v.parenthesizedBind >= at.start && (v.parenthesizedBind = -1), v.trailingComma >= at.start && (v.trailingComma = -1)), at;
      }, le.parseSubscripts = function(v, V, Te, Le, Xe) {
        for (var at = this.options.ecmaVersion >= 8 && v.type === "Identifier" && v.name === "async" && this.lastTokEnd === v.end && !this.canInsertSemicolon() && v.end - v.start === 5 && this.potentialArrowAt === v.start, lt = !1; ; ) {
          var Et = this.parseSubscript(v, V, Te, Le, at, lt, Xe);
          if (Et.optional && (lt = !0), Et === v || Et.type === "ArrowFunctionExpression") {
            if (lt) {
              var Tt = this.startNodeAt(V, Te);
              Tt.expression = Et, Et = this.finishNode(Tt, "ChainExpression");
            }
            return Et;
          }
          v = Et;
        }
      }, le.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(o.arrow);
      }, le.parseSubscriptAsyncArrow = function(v, V, Te, Le) {
        return this.parseArrowExpression(this.startNodeAt(v, V), Te, !0, Le);
      }, le.parseSubscript = function(v, V, Te, Le, Xe, at, lt) {
        var Et = this.options.ecmaVersion >= 11, Tt = Et && this.eat(o.questionDot);
        Le && Tt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var Yt = this.eat(o.bracketL);
        if (Yt || Tt && this.type !== o.parenL && this.type !== o.backQuote || this.eat(o.dot)) {
          var zt = this.startNodeAt(V, Te);
          zt.object = v, Yt ? (zt.property = this.parseExpression(), this.expect(o.bracketR)) : this.type === o.privateId && v.type !== "Super" ? zt.property = this.parsePrivateIdent() : zt.property = this.parseIdent(this.options.allowReserved !== "never"), zt.computed = !!Yt, Et && (zt.optional = Tt), v = this.finishNode(zt, "MemberExpression");
        } else if (!Le && this.eat(o.parenL)) {
          var fr = new B(), $r = this.yieldPos, Ci = this.awaitPos, Bi = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var ki = this.parseExprList(o.parenR, this.options.ecmaVersion >= 8, !1, fr);
          if (Xe && !Tt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(fr, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = $r, this.awaitPos = Ci, this.awaitIdentPos = Bi, this.parseSubscriptAsyncArrow(V, Te, ki, lt);
          this.checkExpressionErrors(fr, !0), this.yieldPos = $r || this.yieldPos, this.awaitPos = Ci || this.awaitPos, this.awaitIdentPos = Bi || this.awaitIdentPos;
          var Ai = this.startNodeAt(V, Te);
          Ai.callee = v, Ai.arguments = ki, Et && (Ai.optional = Tt), v = this.finishNode(Ai, "CallExpression");
        } else if (this.type === o.backQuote) {
          (Tt || at) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var yi = this.startNodeAt(V, Te);
          yi.tag = v, yi.quasi = this.parseTemplate({ isTagged: !0 }), v = this.finishNode(yi, "TaggedTemplateExpression");
        }
        return v;
      }, le.parseExprAtom = function(v, V, Te) {
        this.type === o.slash && this.readRegexp();
        var Le, Xe = this.potentialArrowAt === this.start;
        switch (this.type) {
          case o._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), Le = this.startNode(), this.next(), this.type === o.parenL && !this.allowDirectSuper && this.raise(Le.start, "super() call outside constructor of a subclass"), this.type !== o.dot && this.type !== o.bracketL && this.type !== o.parenL && this.unexpected(), this.finishNode(Le, "Super");
          case o._this:
            return Le = this.startNode(), this.next(), this.finishNode(Le, "ThisExpression");
          case o.name:
            var at = this.start, lt = this.startLoc, Et = this.containsEsc, Tt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !Et && Tt.name === "async" && !this.canInsertSemicolon() && this.eat(o._function))
              return this.overrideContext(D.f_expr), this.parseFunction(this.startNodeAt(at, lt), 0, !1, !0, V);
            if (Xe && !this.canInsertSemicolon()) {
              if (this.eat(o.arrow))
                return this.parseArrowExpression(this.startNodeAt(at, lt), [Tt], !1, V);
              if (this.options.ecmaVersion >= 8 && Tt.name === "async" && this.type === o.name && !Et && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return Tt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(o.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(at, lt), [Tt], !0, V);
            }
            return Tt;
          case o.regexp:
            var Yt = this.value;
            return Le = this.parseLiteral(Yt.value), Le.regex = { pattern: Yt.pattern, flags: Yt.flags }, Le;
          case o.num:
          case o.string:
            return this.parseLiteral(this.value);
          case o._null:
          case o._true:
          case o._false:
            return Le = this.startNode(), Le.value = this.type === o._null ? null : this.type === o._true, Le.raw = this.type.keyword, this.next(), this.finishNode(Le, "Literal");
          case o.parenL:
            var zt = this.start, fr = this.parseParenAndDistinguishExpression(Xe, V);
            return v && (v.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(fr) && (v.parenthesizedAssign = zt), v.parenthesizedBind < 0 && (v.parenthesizedBind = zt)), fr;
          case o.bracketL:
            return Le = this.startNode(), this.next(), Le.elements = this.parseExprList(o.bracketR, !0, !0, v), this.finishNode(Le, "ArrayExpression");
          case o.braceL:
            return this.overrideContext(D.b_expr), this.parseObj(!1, v);
          case o._function:
            return Le = this.startNode(), this.next(), this.parseFunction(Le, 0);
          case o._class:
            return this.parseClass(this.startNode(), !1);
          case o._new:
            return this.parseNew();
          case o.backQuote:
            return this.parseTemplate();
          case o._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(Te) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, le.parseExprAtomDefault = function() {
        this.unexpected();
      }, le.parseExprImport = function(v) {
        var V = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === o.parenL && !v)
          return this.parseDynamicImport(V);
        if (this.type === o.dot) {
          var Te = this.startNodeAt(V.start, V.loc && V.loc.start);
          return Te.name = "import", V.meta = this.finishNode(Te, "Identifier"), this.parseImportMeta(V);
        } else
          this.unexpected();
      }, le.parseDynamicImport = function(v) {
        if (this.next(), v.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(o.parenR) ? v.options = null : (this.expect(o.comma), this.afterTrailingComma(o.parenR) ? v.options = null : (v.options = this.parseMaybeAssign(), this.eat(o.parenR) || (this.expect(o.comma), this.afterTrailingComma(o.parenR) || this.unexpected())));
        else if (!this.eat(o.parenR)) {
          var V = this.start;
          this.eat(o.comma) && this.eat(o.parenR) ? this.raiseRecoverable(V, "Trailing comma is not allowed in import()") : this.unexpected(V);
        }
        return this.finishNode(v, "ImportExpression");
      }, le.parseImportMeta = function(v) {
        this.next();
        var V = this.containsEsc;
        return v.property = this.parseIdent(!0), v.property.name !== "meta" && this.raiseRecoverable(v.property.start, "The only valid meta property for import is 'import.meta'"), V && this.raiseRecoverable(v.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(v.start, "Cannot use 'import.meta' outside a module"), this.finishNode(v, "MetaProperty");
      }, le.parseLiteral = function(v) {
        var V = this.startNode();
        return V.value = v, V.raw = this.input.slice(this.start, this.end), V.raw.charCodeAt(V.raw.length - 1) === 110 && (V.bigint = V.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(V, "Literal");
      }, le.parseParenExpression = function() {
        this.expect(o.parenL);
        var v = this.parseExpression();
        return this.expect(o.parenR), v;
      }, le.shouldParseArrow = function(v) {
        return !this.canInsertSemicolon();
      }, le.parseParenAndDistinguishExpression = function(v, V) {
        var Te = this.start, Le = this.startLoc, Xe, at = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var lt = this.start, Et = this.startLoc, Tt = [], Yt = !0, zt = !1, fr = new B(), $r = this.yieldPos, Ci = this.awaitPos, Bi;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== o.parenR; )
            if (Yt ? Yt = !1 : this.expect(o.comma), at && this.afterTrailingComma(o.parenR, !0)) {
              zt = !0;
              break;
            } else if (this.type === o.ellipsis) {
              Bi = this.start, Tt.push(this.parseParenItem(this.parseRestBinding())), this.type === o.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              Tt.push(this.parseMaybeAssign(!1, fr, this.parseParenItem));
          var ki = this.lastTokEnd, Ai = this.lastTokEndLoc;
          if (this.expect(o.parenR), v && this.shouldParseArrow(Tt) && this.eat(o.arrow))
            return this.checkPatternErrors(fr, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = $r, this.awaitPos = Ci, this.parseParenArrowList(Te, Le, Tt, V);
          (!Tt.length || zt) && this.unexpected(this.lastTokStart), Bi && this.unexpected(Bi), this.checkExpressionErrors(fr, !0), this.yieldPos = $r || this.yieldPos, this.awaitPos = Ci || this.awaitPos, Tt.length > 1 ? (Xe = this.startNodeAt(lt, Et), Xe.expressions = Tt, this.finishNodeAt(Xe, "SequenceExpression", ki, Ai)) : Xe = Tt[0];
        } else
          Xe = this.parseParenExpression();
        if (this.options.preserveParens) {
          var yi = this.startNodeAt(Te, Le);
          return yi.expression = Xe, this.finishNode(yi, "ParenthesizedExpression");
        } else
          return Xe;
      }, le.parseParenItem = function(v) {
        return v;
      }, le.parseParenArrowList = function(v, V, Te, Le) {
        return this.parseArrowExpression(this.startNodeAt(v, V), Te, !1, Le);
      };
      var me = [];
      le.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var v = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === o.dot) {
          var V = this.startNodeAt(v.start, v.loc && v.loc.start);
          V.name = "new", v.meta = this.finishNode(V, "Identifier"), this.next();
          var Te = this.containsEsc;
          return v.property = this.parseIdent(!0), v.property.name !== "target" && this.raiseRecoverable(v.property.start, "The only valid meta property for new is 'new.target'"), Te && this.raiseRecoverable(v.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(v.start, "'new.target' can only be used in functions and class static block"), this.finishNode(v, "MetaProperty");
        }
        var Le = this.start, Xe = this.startLoc;
        return v.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), Le, Xe, !0, !1), this.eat(o.parenL) ? v.arguments = this.parseExprList(o.parenR, this.options.ecmaVersion >= 8, !1) : v.arguments = me, this.finishNode(v, "NewExpression");
      }, le.parseTemplateElement = function(v) {
        var V = v.isTagged, Te = this.startNode();
        return this.type === o.invalidTemplate ? (V || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), Te.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : Te.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), Te.tail = this.type === o.backQuote, this.finishNode(Te, "TemplateElement");
      }, le.parseTemplate = function(v) {
        v === void 0 && (v = {});
        var V = v.isTagged;
        V === void 0 && (V = !1);
        var Te = this.startNode();
        this.next(), Te.expressions = [];
        var Le = this.parseTemplateElement({ isTagged: V });
        for (Te.quasis = [Le]; !Le.tail; )
          this.type === o.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(o.dollarBraceL), Te.expressions.push(this.parseExpression()), this.expect(o.braceR), Te.quasis.push(Le = this.parseTemplateElement({ isTagged: V }));
        return this.next(), this.finishNode(Te, "TemplateLiteral");
      }, le.isAsyncProp = function(v) {
        return !v.computed && v.key.type === "Identifier" && v.key.name === "async" && (this.type === o.name || this.type === o.num || this.type === o.string || this.type === o.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === o.star) && !A.test(this.input.slice(this.lastTokEnd, this.start));
      }, le.parseObj = function(v, V) {
        var Te = this.startNode(), Le = !0, Xe = {};
        for (Te.properties = [], this.next(); !this.eat(o.braceR); ) {
          if (Le)
            Le = !1;
          else if (this.expect(o.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(o.braceR))
            break;
          var at = this.parseProperty(v, V);
          v || this.checkPropClash(at, Xe, V), Te.properties.push(at);
        }
        return this.finishNode(Te, v ? "ObjectPattern" : "ObjectExpression");
      }, le.parseProperty = function(v, V) {
        var Te = this.startNode(), Le, Xe, at, lt;
        if (this.options.ecmaVersion >= 9 && this.eat(o.ellipsis))
          return v ? (Te.argument = this.parseIdent(!1), this.type === o.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(Te, "RestElement")) : (Te.argument = this.parseMaybeAssign(!1, V), this.type === o.comma && V && V.trailingComma < 0 && (V.trailingComma = this.start), this.finishNode(Te, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (Te.method = !1, Te.shorthand = !1, (v || V) && (at = this.start, lt = this.startLoc), v || (Le = this.eat(o.star)));
        var Et = this.containsEsc;
        return this.parsePropertyName(Te), !v && !Et && this.options.ecmaVersion >= 8 && !Le && this.isAsyncProp(Te) ? (Xe = !0, Le = this.options.ecmaVersion >= 9 && this.eat(o.star), this.parsePropertyName(Te)) : Xe = !1, this.parsePropertyValue(Te, v, Le, Xe, at, lt, V, Et), this.finishNode(Te, "Property");
      }, le.parseGetterSetter = function(v) {
        var V = v.key.name;
        this.parsePropertyName(v), v.value = this.parseMethod(!1), v.kind = V;
        var Te = v.kind === "get" ? 0 : 1;
        if (v.value.params.length !== Te) {
          var Le = v.value.start;
          v.kind === "get" ? this.raiseRecoverable(Le, "getter should have no params") : this.raiseRecoverable(Le, "setter should have exactly one param");
        } else
          v.kind === "set" && v.value.params[0].type === "RestElement" && this.raiseRecoverable(v.value.params[0].start, "Setter cannot use rest params");
      }, le.parsePropertyValue = function(v, V, Te, Le, Xe, at, lt, Et) {
        (Te || Le) && this.type === o.colon && this.unexpected(), this.eat(o.colon) ? (v.value = V ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, lt), v.kind = "init") : this.options.ecmaVersion >= 6 && this.type === o.parenL ? (V && this.unexpected(), v.method = !0, v.value = this.parseMethod(Te, Le), v.kind = "init") : !V && !Et && this.options.ecmaVersion >= 5 && !v.computed && v.key.type === "Identifier" && (v.key.name === "get" || v.key.name === "set") && this.type !== o.comma && this.type !== o.braceR && this.type !== o.eq ? ((Te || Le) && this.unexpected(), this.parseGetterSetter(v)) : this.options.ecmaVersion >= 6 && !v.computed && v.key.type === "Identifier" ? ((Te || Le) && this.unexpected(), this.checkUnreserved(v.key), v.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Xe), V ? v.value = this.parseMaybeDefault(Xe, at, this.copyNode(v.key)) : this.type === o.eq && lt ? (lt.shorthandAssign < 0 && (lt.shorthandAssign = this.start), v.value = this.parseMaybeDefault(Xe, at, this.copyNode(v.key))) : v.value = this.copyNode(v.key), v.kind = "init", v.shorthand = !0) : this.unexpected();
      }, le.parsePropertyName = function(v) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(o.bracketL))
            return v.computed = !0, v.key = this.parseMaybeAssign(), this.expect(o.bracketR), v.key;
          v.computed = !1;
        }
        return v.key = this.type === o.num || this.type === o.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, le.initFunction = function(v) {
        v.id = null, this.options.ecmaVersion >= 6 && (v.generator = v.expression = !1), this.options.ecmaVersion >= 8 && (v.async = !1);
      }, le.parseMethod = function(v, V, Te) {
        var Le = this.startNode(), Xe = this.yieldPos, at = this.awaitPos, lt = this.awaitIdentPos;
        return this.initFunction(Le), this.options.ecmaVersion >= 6 && (Le.generator = v), this.options.ecmaVersion >= 8 && (Le.async = !!V), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope($(V, Le.generator) | Re | (Te ? De : 0)), this.expect(o.parenL), Le.params = this.parseBindingList(o.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(Le, !1, !0, !1), this.yieldPos = Xe, this.awaitPos = at, this.awaitIdentPos = lt, this.finishNode(Le, "FunctionExpression");
      }, le.parseArrowExpression = function(v, V, Te, Le) {
        var Xe = this.yieldPos, at = this.awaitPos, lt = this.awaitIdentPos;
        return this.enterScope($(Te, !1) | We), this.initFunction(v), this.options.ecmaVersion >= 8 && (v.async = !!Te), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, v.params = this.toAssignableList(V, !0), this.parseFunctionBody(v, !0, !1, Le), this.yieldPos = Xe, this.awaitPos = at, this.awaitIdentPos = lt, this.finishNode(v, "ArrowFunctionExpression");
      }, le.parseFunctionBody = function(v, V, Te, Le) {
        var Xe = V && this.type !== o.braceL, at = this.strict, lt = !1;
        if (Xe)
          v.body = this.parseMaybeAssign(Le), v.expression = !0, this.checkParams(v, !1);
        else {
          var Et = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(v.params);
          (!at || Et) && (lt = this.strictDirective(this.end), lt && Et && this.raiseRecoverable(v.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var Tt = this.labels;
          this.labels = [], lt && (this.strict = !0), this.checkParams(v, !at && !lt && !V && !Te && this.isSimpleParamList(v.params)), this.strict && v.id && this.checkLValSimple(v.id, e), v.body = this.parseBlock(!1, void 0, lt && !at), v.expression = !1, this.adaptDirectivePrologue(v.body.body), this.labels = Tt;
        }
        this.exitScope();
      }, le.isSimpleParamList = function(v) {
        for (var V = 0, Te = v; V < Te.length; V += 1) {
          var Le = Te[V];
          if (Le.type !== "Identifier")
            return !1;
        }
        return !0;
      }, le.checkParams = function(v, V) {
        for (var Te = /* @__PURE__ */ Object.create(null), Le = 0, Xe = v.params; Le < Xe.length; Le += 1) {
          var at = Xe[Le];
          this.checkLValInnerPattern(at, ve, V ? null : Te);
        }
      }, le.parseExprList = function(v, V, Te, Le) {
        for (var Xe = [], at = !0; !this.eat(v); ) {
          if (at)
            at = !1;
          else if (this.expect(o.comma), V && this.afterTrailingComma(v))
            break;
          var lt = void 0;
          Te && this.type === o.comma ? lt = null : this.type === o.ellipsis ? (lt = this.parseSpread(Le), Le && this.type === o.comma && Le.trailingComma < 0 && (Le.trailingComma = this.start)) : lt = this.parseMaybeAssign(!1, Le), Xe.push(lt);
        }
        return Xe;
      }, le.checkUnreserved = function(v) {
        var V = v.start, Te = v.end, Le = v.name;
        if (this.inGenerator && Le === "yield" && this.raiseRecoverable(V, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && Le === "await" && this.raiseRecoverable(V, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & re) && Le === "arguments" && this.raiseRecoverable(V, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (Le === "arguments" || Le === "await") && this.raise(V, "Cannot use " + Le + " in class static initialization block"), this.keywords.test(Le) && this.raise(V, "Unexpected keyword '" + Le + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(V, Te).indexOf("\\") !== -1)) {
          var Xe = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Xe.test(Le) && (!this.inAsync && Le === "await" && this.raiseRecoverable(V, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(V, "The keyword '" + Le + "' is reserved"));
        }
      }, le.parseIdent = function(v) {
        var V = this.parseIdentNode();
        return this.next(!!v), this.finishNode(V, "Identifier"), v || (this.checkUnreserved(V), V.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = V.start)), V;
      }, le.parseIdentNode = function() {
        var v = this.startNode();
        return this.type === o.name ? v.name = this.value : this.type.keyword ? (v.name = this.type.keyword, (v.name === "class" || v.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = o.name) : this.unexpected(), v;
      }, le.parsePrivateIdent = function() {
        var v = this.startNode();
        return this.type === o.privateId ? v.name = this.value : this.unexpected(), this.next(), this.finishNode(v, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(v.start, "Private field '#" + v.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(v)), v;
      }, le.parseYield = function(v) {
        this.yieldPos || (this.yieldPos = this.start);
        var V = this.startNode();
        return this.next(), this.type === o.semi || this.canInsertSemicolon() || this.type !== o.star && !this.type.startsExpr ? (V.delegate = !1, V.argument = null) : (V.delegate = this.eat(o.star), V.argument = this.parseMaybeAssign(v)), this.finishNode(V, "YieldExpression");
      }, le.parseAwait = function(v) {
        this.awaitPos || (this.awaitPos = this.start);
        var V = this.startNode();
        return this.next(), V.argument = this.parseMaybeUnary(null, !0, !1, v), this.finishNode(V, "AwaitExpression");
      };
      var O = r.prototype;
      O.raise = function(v, V) {
        var Te = fe(this.input, v);
        V += " (" + Te.line + ":" + Te.column + ")", this.sourceFile && (V += " in " + this.sourceFile);
        var Le = new SyntaxError(V);
        throw Le.pos = v, Le.loc = Te, Le.raisedAt = this.pos, Le;
      }, O.raiseRecoverable = O.raise, O.curPosition = function() {
        if (this.options.locations)
          return new ke(this.curLine, this.pos - this.lineStart);
      };
      var ce = r.prototype, Oe = function(V) {
        this.flags = V, this.var = [], this.lexical = [], this.functions = [];
      };
      ce.enterScope = function(v) {
        this.scopeStack.push(new Oe(v));
      }, ce.exitScope = function() {
        this.scopeStack.pop();
      }, ce.treatFunctionsAsVarInScope = function(v) {
        return v.flags & He || !this.inModule && v.flags & Ue;
      }, ce.declareName = function(v, V, Te) {
        var Le = !1;
        if (V === Y) {
          var Xe = this.currentScope();
          Le = Xe.lexical.indexOf(v) > -1 || Xe.functions.indexOf(v) > -1 || Xe.var.indexOf(v) > -1, Xe.lexical.push(v), this.inModule && Xe.flags & Ue && delete this.undefinedExports[v];
        } else if (V === Ae) {
          var at = this.currentScope();
          at.lexical.push(v);
        } else if (V === G) {
          var lt = this.currentScope();
          this.treatFunctionsAsVar ? Le = lt.lexical.indexOf(v) > -1 : Le = lt.lexical.indexOf(v) > -1 || lt.var.indexOf(v) > -1, lt.functions.push(v);
        } else
          for (var Et = this.scopeStack.length - 1; Et >= 0; --Et) {
            var Tt = this.scopeStack[Et];
            if (Tt.lexical.indexOf(v) > -1 && !(Tt.flags & Ve && Tt.lexical[0] === v) || !this.treatFunctionsAsVarInScope(Tt) && Tt.functions.indexOf(v) > -1) {
              Le = !0;
              break;
            }
            if (Tt.var.push(v), this.inModule && Tt.flags & Ue && delete this.undefinedExports[v], Tt.flags & re)
              break;
          }
        Le && this.raiseRecoverable(Te, "Identifier '" + v + "' has already been declared");
      }, ce.checkLocalExport = function(v) {
        this.scopeStack[0].lexical.indexOf(v.name) === -1 && this.scopeStack[0].var.indexOf(v.name) === -1 && (this.undefinedExports[v.name] = v);
      }, ce.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, ce.currentVarScope = function() {
        for (var v = this.scopeStack.length - 1; ; v--) {
          var V = this.scopeStack[v];
          if (V.flags & (re | we | Ne))
            return V;
        }
      }, ce.currentThisScope = function() {
        for (var v = this.scopeStack.length - 1; ; v--) {
          var V = this.scopeStack[v];
          if (V.flags & (re | we | Ne) && !(V.flags & We))
            return V;
        }
      };
      var Be = function(V, Te, Le) {
        this.type = "", this.start = Te, this.end = 0, V.options.locations && (this.loc = new Pe(V, Le)), V.options.directSourceFile && (this.sourceFile = V.options.directSourceFile), V.options.ranges && (this.range = [Te, 0]);
      }, Ge = r.prototype;
      Ge.startNode = function() {
        return new Be(this, this.start, this.startLoc);
      }, Ge.startNodeAt = function(v, V) {
        return new Be(this, v, V);
      };
      function Fe(v, V, Te, Le) {
        return v.type = V, v.end = Te, this.options.locations && (v.loc.end = Le), this.options.ranges && (v.range[1] = Te), v;
      }
      Ge.finishNode = function(v, V) {
        return Fe.call(this, v, V, this.lastTokEnd, this.lastTokEndLoc);
      }, Ge.finishNodeAt = function(v, V, Te, Le) {
        return Fe.call(this, v, V, Te, Le);
      }, Ge.copyNode = function(v) {
        var V = new Be(this, v.start, this.startLoc);
        for (var Te in v)
          V[Te] = v[Te];
        return V;
      };
      var Ye = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", Ke = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", et = Ke + " Extended_Pictographic", Je = et, nt = Je + " EBase EComp EMod EPres ExtPict", pt = nt, vt = pt, bt = {
        9: Ke,
        10: et,
        11: Je,
        12: nt,
        13: pt,
        14: vt
      }, At = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", ot = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: At
      }, ct = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", gt = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Ct = gt + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", xt = Ct + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Ot = xt + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Nt = Ot + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", Pt = Nt + " " + Ye, Gt = {
        9: gt,
        10: Ct,
        11: xt,
        12: Ot,
        13: Nt,
        14: Pt
      }, Bt = {};
      function or(v) {
        var V = Bt[v] = {
          binary: Q(bt[v] + " " + ct),
          binaryOfStrings: Q(ot[v]),
          nonBinary: {
            General_Category: Q(ct),
            Script: Q(Gt[v])
          }
        };
        V.nonBinary.Script_Extensions = V.nonBinary.Script, V.nonBinary.gc = V.nonBinary.General_Category, V.nonBinary.sc = V.nonBinary.Script, V.nonBinary.scx = V.nonBinary.Script_Extensions;
      }
      for (var ar = 0, ur = [9, 10, 11, 12, 13, 14]; ar < ur.length; ar += 1) {
        var hr = ur[ar];
        or(hr);
      }
      var wt = r.prototype, $t = function(V, Te) {
        this.parent = V, this.base = Te || this;
      };
      $t.prototype.separatedFrom = function(V) {
        for (var Te = this; Te; Te = Te.parent)
          for (var Le = V; Le; Le = Le.parent)
            if (Te.base === Le.base && Te !== Le)
              return !0;
        return !1;
      }, $t.prototype.sibling = function() {
        return new $t(this.parent, this.base);
      };
      var lr = function(V) {
        this.parser = V, this.validFlags = "gim" + (V.options.ecmaVersion >= 6 ? "uy" : "") + (V.options.ecmaVersion >= 9 ? "s" : "") + (V.options.ecmaVersion >= 13 ? "d" : "") + (V.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Bt[V.options.ecmaVersion >= 14 ? 14 : V.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      lr.prototype.reset = function(V, Te, Le) {
        var Xe = Le.indexOf("v") !== -1, at = Le.indexOf("u") !== -1;
        this.start = V | 0, this.source = Te + "", this.flags = Le, Xe && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = at && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = at && this.parser.options.ecmaVersion >= 9);
      }, lr.prototype.raise = function(V) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + V);
      }, lr.prototype.at = function(V, Te) {
        Te === void 0 && (Te = !1);
        var Le = this.source, Xe = Le.length;
        if (V >= Xe)
          return -1;
        var at = Le.charCodeAt(V);
        if (!(Te || this.switchU) || at <= 55295 || at >= 57344 || V + 1 >= Xe)
          return at;
        var lt = Le.charCodeAt(V + 1);
        return lt >= 56320 && lt <= 57343 ? (at << 10) + lt - 56613888 : at;
      }, lr.prototype.nextIndex = function(V, Te) {
        Te === void 0 && (Te = !1);
        var Le = this.source, Xe = Le.length;
        if (V >= Xe)
          return Xe;
        var at = Le.charCodeAt(V), lt;
        return !(Te || this.switchU) || at <= 55295 || at >= 57344 || V + 1 >= Xe || (lt = Le.charCodeAt(V + 1)) < 56320 || lt > 57343 ? V + 1 : V + 2;
      }, lr.prototype.current = function(V) {
        return V === void 0 && (V = !1), this.at(this.pos, V);
      }, lr.prototype.lookahead = function(V) {
        return V === void 0 && (V = !1), this.at(this.nextIndex(this.pos, V), V);
      }, lr.prototype.advance = function(V) {
        V === void 0 && (V = !1), this.pos = this.nextIndex(this.pos, V);
      }, lr.prototype.eat = function(V, Te) {
        return Te === void 0 && (Te = !1), this.current(Te) === V ? (this.advance(Te), !0) : !1;
      }, lr.prototype.eatChars = function(V, Te) {
        Te === void 0 && (Te = !1);
        for (var Le = this.pos, Xe = 0, at = V; Xe < at.length; Xe += 1) {
          var lt = at[Xe], Et = this.at(Le, Te);
          if (Et === -1 || Et !== lt)
            return !1;
          Le = this.nextIndex(Le, Te);
        }
        return this.pos = Le, !0;
      }, wt.validateRegExpFlags = function(v) {
        for (var V = v.validFlags, Te = v.flags, Le = !1, Xe = !1, at = 0; at < Te.length; at++) {
          var lt = Te.charAt(at);
          V.indexOf(lt) === -1 && this.raise(v.start, "Invalid regular expression flag"), Te.indexOf(lt, at + 1) > -1 && this.raise(v.start, "Duplicate regular expression flag"), lt === "u" && (Le = !0), lt === "v" && (Xe = !0);
        }
        this.options.ecmaVersion >= 15 && Le && Xe && this.raise(v.start, "Invalid regular expression flag");
      };
      function tr(v) {
        for (var V in v)
          return !0;
        return !1;
      }
      wt.validateRegExpPattern = function(v) {
        this.regexp_pattern(v), !v.switchN && this.options.ecmaVersion >= 9 && tr(v.groupNames) && (v.switchN = !0, this.regexp_pattern(v));
      }, wt.regexp_pattern = function(v) {
        v.pos = 0, v.lastIntValue = 0, v.lastStringValue = "", v.lastAssertionIsQuantifiable = !1, v.numCapturingParens = 0, v.maxBackReference = 0, v.groupNames = /* @__PURE__ */ Object.create(null), v.backReferenceNames.length = 0, v.branchID = null, this.regexp_disjunction(v), v.pos !== v.source.length && (v.eat(
          41
          /* ) */
        ) && v.raise("Unmatched ')'"), (v.eat(
          93
          /* ] */
        ) || v.eat(
          125
          /* } */
        )) && v.raise("Lone quantifier brackets")), v.maxBackReference > v.numCapturingParens && v.raise("Invalid escape");
        for (var V = 0, Te = v.backReferenceNames; V < Te.length; V += 1) {
          var Le = Te[V];
          v.groupNames[Le] || v.raise("Invalid named capture referenced");
        }
      }, wt.regexp_disjunction = function(v) {
        var V = this.options.ecmaVersion >= 16;
        for (V && (v.branchID = new $t(v.branchID, null)), this.regexp_alternative(v); v.eat(
          124
          /* | */
        ); )
          V && (v.branchID = v.branchID.sibling()), this.regexp_alternative(v);
        V && (v.branchID = v.branchID.parent), this.regexp_eatQuantifier(v, !0) && v.raise("Nothing to repeat"), v.eat(
          123
          /* { */
        ) && v.raise("Lone quantifier brackets");
      }, wt.regexp_alternative = function(v) {
        for (; v.pos < v.source.length && this.regexp_eatTerm(v); )
          ;
      }, wt.regexp_eatTerm = function(v) {
        return this.regexp_eatAssertion(v) ? (v.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(v) && v.switchU && v.raise("Invalid quantifier"), !0) : (v.switchU ? this.regexp_eatAtom(v) : this.regexp_eatExtendedAtom(v)) ? (this.regexp_eatQuantifier(v), !0) : !1;
      }, wt.regexp_eatAssertion = function(v) {
        var V = v.pos;
        if (v.lastAssertionIsQuantifiable = !1, v.eat(
          94
          /* ^ */
        ) || v.eat(
          36
          /* $ */
        ))
          return !0;
        if (v.eat(
          92
          /* \ */
        )) {
          if (v.eat(
            66
            /* B */
          ) || v.eat(
            98
            /* b */
          ))
            return !0;
          v.pos = V;
        }
        if (v.eat(
          40
          /* ( */
        ) && v.eat(
          63
          /* ? */
        )) {
          var Te = !1;
          if (this.options.ecmaVersion >= 9 && (Te = v.eat(
            60
            /* < */
          )), v.eat(
            61
            /* = */
          ) || v.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(v), v.eat(
              41
              /* ) */
            ) || v.raise("Unterminated group"), v.lastAssertionIsQuantifiable = !Te, !0;
        }
        return v.pos = V, !1;
      }, wt.regexp_eatQuantifier = function(v, V) {
        return V === void 0 && (V = !1), this.regexp_eatQuantifierPrefix(v, V) ? (v.eat(
          63
          /* ? */
        ), !0) : !1;
      }, wt.regexp_eatQuantifierPrefix = function(v, V) {
        return v.eat(
          42
          /* * */
        ) || v.eat(
          43
          /* + */
        ) || v.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(v, V);
      }, wt.regexp_eatBracedQuantifier = function(v, V) {
        var Te = v.pos;
        if (v.eat(
          123
          /* { */
        )) {
          var Le = 0, Xe = -1;
          if (this.regexp_eatDecimalDigits(v) && (Le = v.lastIntValue, v.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(v) && (Xe = v.lastIntValue), v.eat(
            125
            /* } */
          )))
            return Xe !== -1 && Xe < Le && !V && v.raise("numbers out of order in {} quantifier"), !0;
          v.switchU && !V && v.raise("Incomplete quantifier"), v.pos = Te;
        }
        return !1;
      }, wt.regexp_eatAtom = function(v) {
        return this.regexp_eatPatternCharacters(v) || v.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(v) || this.regexp_eatCharacterClass(v) || this.regexp_eatUncapturingGroup(v) || this.regexp_eatCapturingGroup(v);
      }, wt.regexp_eatReverseSolidusAtomEscape = function(v) {
        var V = v.pos;
        if (v.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(v))
            return !0;
          v.pos = V;
        }
        return !1;
      }, wt.regexp_eatUncapturingGroup = function(v) {
        var V = v.pos;
        if (v.eat(
          40
          /* ( */
        )) {
          if (v.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var Te = this.regexp_eatModifiers(v), Le = v.eat(
                45
                /* - */
              );
              if (Te || Le) {
                for (var Xe = 0; Xe < Te.length; Xe++) {
                  var at = Te.charAt(Xe);
                  Te.indexOf(at, Xe + 1) > -1 && v.raise("Duplicate regular expression modifiers");
                }
                if (Le) {
                  var lt = this.regexp_eatModifiers(v);
                  !Te && !lt && v.current() === 58 && v.raise("Invalid regular expression modifiers");
                  for (var Et = 0; Et < lt.length; Et++) {
                    var Tt = lt.charAt(Et);
                    (lt.indexOf(Tt, Et + 1) > -1 || Te.indexOf(Tt) > -1) && v.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (v.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(v), v.eat(
                41
                /* ) */
              ))
                return !0;
              v.raise("Unterminated group");
            }
          }
          v.pos = V;
        }
        return !1;
      }, wt.regexp_eatCapturingGroup = function(v) {
        if (v.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(v) : v.current() === 63 && v.raise("Invalid group"), this.regexp_disjunction(v), v.eat(
            41
            /* ) */
          ))
            return v.numCapturingParens += 1, !0;
          v.raise("Unterminated group");
        }
        return !1;
      }, wt.regexp_eatModifiers = function(v) {
        for (var V = "", Te = 0; (Te = v.current()) !== -1 && Xr(Te); )
          V += de(Te), v.advance();
        return V;
      };
      function Xr(v) {
        return v === 105 || v === 109 || v === 115;
      }
      wt.regexp_eatExtendedAtom = function(v) {
        return v.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(v) || this.regexp_eatCharacterClass(v) || this.regexp_eatUncapturingGroup(v) || this.regexp_eatCapturingGroup(v) || this.regexp_eatInvalidBracedQuantifier(v) || this.regexp_eatExtendedPatternCharacter(v);
      }, wt.regexp_eatInvalidBracedQuantifier = function(v) {
        return this.regexp_eatBracedQuantifier(v, !0) && v.raise("Nothing to repeat"), !1;
      }, wt.regexp_eatSyntaxCharacter = function(v) {
        var V = v.current();
        return gi(V) ? (v.lastIntValue = V, v.advance(), !0) : !1;
      };
      function gi(v) {
        return v === 36 || v >= 40 && v <= 43 || v === 46 || v === 63 || v >= 91 && v <= 94 || v >= 123 && v <= 125;
      }
      wt.regexp_eatPatternCharacters = function(v) {
        for (var V = v.pos, Te = 0; (Te = v.current()) !== -1 && !gi(Te); )
          v.advance();
        return v.pos !== V;
      }, wt.regexp_eatExtendedPatternCharacter = function(v) {
        var V = v.current();
        return V !== -1 && V !== 36 && !(V >= 40 && V <= 43) && V !== 46 && V !== 63 && V !== 91 && V !== 94 && V !== 124 ? (v.advance(), !0) : !1;
      }, wt.regexp_groupSpecifier = function(v) {
        if (v.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(v) || v.raise("Invalid group");
          var V = this.options.ecmaVersion >= 16, Te = v.groupNames[v.lastStringValue];
          if (Te)
            if (V)
              for (var Le = 0, Xe = Te; Le < Xe.length; Le += 1) {
                var at = Xe[Le];
                at.separatedFrom(v.branchID) || v.raise("Duplicate capture group name");
              }
            else
              v.raise("Duplicate capture group name");
          V ? (Te || (v.groupNames[v.lastStringValue] = [])).push(v.branchID) : v.groupNames[v.lastStringValue] = !0;
        }
      }, wt.regexp_eatGroupName = function(v) {
        if (v.lastStringValue = "", v.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(v) && v.eat(
            62
            /* > */
          ))
            return !0;
          v.raise("Invalid capture group name");
        }
        return !1;
      }, wt.regexp_eatRegExpIdentifierName = function(v) {
        if (v.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(v)) {
          for (v.lastStringValue += de(v.lastIntValue); this.regexp_eatRegExpIdentifierPart(v); )
            v.lastStringValue += de(v.lastIntValue);
          return !0;
        }
        return !1;
      }, wt.regexp_eatRegExpIdentifierStart = function(v) {
        var V = v.pos, Te = this.options.ecmaVersion >= 11, Le = v.current(Te);
        return v.advance(Te), Le === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(v, Te) && (Le = v.lastIntValue), ii(Le) ? (v.lastIntValue = Le, !0) : (v.pos = V, !1);
      };
      function ii(v) {
        return n(v, !0) || v === 36 || v === 95;
      }
      wt.regexp_eatRegExpIdentifierPart = function(v) {
        var V = v.pos, Te = this.options.ecmaVersion >= 11, Le = v.current(Te);
        return v.advance(Te), Le === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(v, Te) && (Le = v.lastIntValue), Br(Le) ? (v.lastIntValue = Le, !0) : (v.pos = V, !1);
      };
      function Br(v) {
        return c(v, !0) || v === 36 || v === 95 || v === 8204 || v === 8205;
      }
      wt.regexp_eatAtomEscape = function(v) {
        return this.regexp_eatBackReference(v) || this.regexp_eatCharacterClassEscape(v) || this.regexp_eatCharacterEscape(v) || v.switchN && this.regexp_eatKGroupName(v) ? !0 : (v.switchU && (v.current() === 99 && v.raise("Invalid unicode escape"), v.raise("Invalid escape")), !1);
      }, wt.regexp_eatBackReference = function(v) {
        var V = v.pos;
        if (this.regexp_eatDecimalEscape(v)) {
          var Te = v.lastIntValue;
          if (v.switchU)
            return Te > v.maxBackReference && (v.maxBackReference = Te), !0;
          if (Te <= v.numCapturingParens)
            return !0;
          v.pos = V;
        }
        return !1;
      }, wt.regexp_eatKGroupName = function(v) {
        if (v.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(v))
            return v.backReferenceNames.push(v.lastStringValue), !0;
          v.raise("Invalid named reference");
        }
        return !1;
      }, wt.regexp_eatCharacterEscape = function(v) {
        return this.regexp_eatControlEscape(v) || this.regexp_eatCControlLetter(v) || this.regexp_eatZero(v) || this.regexp_eatHexEscapeSequence(v) || this.regexp_eatRegExpUnicodeEscapeSequence(v, !1) || !v.switchU && this.regexp_eatLegacyOctalEscapeSequence(v) || this.regexp_eatIdentityEscape(v);
      }, wt.regexp_eatCControlLetter = function(v) {
        var V = v.pos;
        if (v.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(v))
            return !0;
          v.pos = V;
        }
        return !1;
      }, wt.regexp_eatZero = function(v) {
        return v.current() === 48 && !Qt(v.lookahead()) ? (v.lastIntValue = 0, v.advance(), !0) : !1;
      }, wt.regexp_eatControlEscape = function(v) {
        var V = v.current();
        return V === 116 ? (v.lastIntValue = 9, v.advance(), !0) : V === 110 ? (v.lastIntValue = 10, v.advance(), !0) : V === 118 ? (v.lastIntValue = 11, v.advance(), !0) : V === 102 ? (v.lastIntValue = 12, v.advance(), !0) : V === 114 ? (v.lastIntValue = 13, v.advance(), !0) : !1;
      }, wt.regexp_eatControlLetter = function(v) {
        var V = v.current();
        return Er(V) ? (v.lastIntValue = V % 32, v.advance(), !0) : !1;
      };
      function Er(v) {
        return v >= 65 && v <= 90 || v >= 97 && v <= 122;
      }
      wt.regexp_eatRegExpUnicodeEscapeSequence = function(v, V) {
        V === void 0 && (V = !1);
        var Te = v.pos, Le = V || v.switchU;
        if (v.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(v, 4)) {
            var Xe = v.lastIntValue;
            if (Le && Xe >= 55296 && Xe <= 56319) {
              var at = v.pos;
              if (v.eat(
                92
                /* \ */
              ) && v.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(v, 4)) {
                var lt = v.lastIntValue;
                if (lt >= 56320 && lt <= 57343)
                  return v.lastIntValue = (Xe - 55296) * 1024 + (lt - 56320) + 65536, !0;
              }
              v.pos = at, v.lastIntValue = Xe;
            }
            return !0;
          }
          if (Le && v.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(v) && v.eat(
            125
            /* } */
          ) && kr(v.lastIntValue))
            return !0;
          Le && v.raise("Invalid unicode escape"), v.pos = Te;
        }
        return !1;
      };
      function kr(v) {
        return v >= 0 && v <= 1114111;
      }
      wt.regexp_eatIdentityEscape = function(v) {
        if (v.switchU)
          return this.regexp_eatSyntaxCharacter(v) ? !0 : v.eat(
            47
            /* / */
          ) ? (v.lastIntValue = 47, !0) : !1;
        var V = v.current();
        return V !== 99 && (!v.switchN || V !== 107) ? (v.lastIntValue = V, v.advance(), !0) : !1;
      }, wt.regexp_eatDecimalEscape = function(v) {
        v.lastIntValue = 0;
        var V = v.current();
        if (V >= 49 && V <= 57) {
          do
            v.lastIntValue = 10 * v.lastIntValue + (V - 48), v.advance();
          while ((V = v.current()) >= 48 && V <= 57);
          return !0;
        }
        return !1;
      };
      var qr = 0, yr = 1, Or = 2;
      wt.regexp_eatCharacterClassEscape = function(v) {
        var V = v.current();
        if (yn(V))
          return v.lastIntValue = -1, v.advance(), yr;
        var Te = !1;
        if (v.switchU && this.options.ecmaVersion >= 9 && ((Te = V === 80) || V === 112)) {
          v.lastIntValue = -1, v.advance();
          var Le;
          if (v.eat(
            123
            /* { */
          ) && (Le = this.regexp_eatUnicodePropertyValueExpression(v)) && v.eat(
            125
            /* } */
          ))
            return Te && Le === Or && v.raise("Invalid property name"), Le;
          v.raise("Invalid property name");
        }
        return qr;
      };
      function yn(v) {
        return v === 100 || v === 68 || v === 115 || v === 83 || v === 119 || v === 87;
      }
      wt.regexp_eatUnicodePropertyValueExpression = function(v) {
        var V = v.pos;
        if (this.regexp_eatUnicodePropertyName(v) && v.eat(
          61
          /* = */
        )) {
          var Te = v.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(v)) {
            var Le = v.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(v, Te, Le), yr;
          }
        }
        if (v.pos = V, this.regexp_eatLoneUnicodePropertyNameOrValue(v)) {
          var Xe = v.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(v, Xe);
        }
        return qr;
      }, wt.regexp_validateUnicodePropertyNameAndValue = function(v, V, Te) {
        ee(v.unicodeProperties.nonBinary, V) || v.raise("Invalid property name"), v.unicodeProperties.nonBinary[V].test(Te) || v.raise("Invalid property value");
      }, wt.regexp_validateUnicodePropertyNameOrValue = function(v, V) {
        if (v.unicodeProperties.binary.test(V))
          return yr;
        if (v.switchV && v.unicodeProperties.binaryOfStrings.test(V))
          return Or;
        v.raise("Invalid property name");
      }, wt.regexp_eatUnicodePropertyName = function(v) {
        var V = 0;
        for (v.lastStringValue = ""; wn(V = v.current()); )
          v.lastStringValue += de(V), v.advance();
        return v.lastStringValue !== "";
      };
      function wn(v) {
        return Er(v) || v === 95;
      }
      wt.regexp_eatUnicodePropertyValue = function(v) {
        var V = 0;
        for (v.lastStringValue = ""; bn(V = v.current()); )
          v.lastStringValue += de(V), v.advance();
        return v.lastStringValue !== "";
      };
      function bn(v) {
        return wn(v) || Qt(v);
      }
      wt.regexp_eatLoneUnicodePropertyNameOrValue = function(v) {
        return this.regexp_eatUnicodePropertyValue(v);
      }, wt.regexp_eatCharacterClass = function(v) {
        if (v.eat(
          91
          /* [ */
        )) {
          var V = v.eat(
            94
            /* ^ */
          ), Te = this.regexp_classContents(v);
          return v.eat(
            93
            /* ] */
          ) || v.raise("Unterminated character class"), V && Te === Or && v.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, wt.regexp_classContents = function(v) {
        return v.current() === 93 ? yr : v.switchV ? this.regexp_classSetExpression(v) : (this.regexp_nonEmptyClassRanges(v), yr);
      }, wt.regexp_nonEmptyClassRanges = function(v) {
        for (; this.regexp_eatClassAtom(v); ) {
          var V = v.lastIntValue;
          if (v.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(v)) {
            var Te = v.lastIntValue;
            v.switchU && (V === -1 || Te === -1) && v.raise("Invalid character class"), V !== -1 && Te !== -1 && V > Te && v.raise("Range out of order in character class");
          }
        }
      }, wt.regexp_eatClassAtom = function(v) {
        var V = v.pos;
        if (v.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(v))
            return !0;
          if (v.switchU) {
            var Te = v.current();
            (Te === 99 || _i(Te)) && v.raise("Invalid class escape"), v.raise("Invalid escape");
          }
          v.pos = V;
        }
        var Le = v.current();
        return Le !== 93 ? (v.lastIntValue = Le, v.advance(), !0) : !1;
      }, wt.regexp_eatClassEscape = function(v) {
        var V = v.pos;
        if (v.eat(
          98
          /* b */
        ))
          return v.lastIntValue = 8, !0;
        if (v.switchU && v.eat(
          45
          /* - */
        ))
          return v.lastIntValue = 45, !0;
        if (!v.switchU && v.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(v))
            return !0;
          v.pos = V;
        }
        return this.regexp_eatCharacterClassEscape(v) || this.regexp_eatCharacterEscape(v);
      }, wt.regexp_classSetExpression = function(v) {
        var V = yr, Te;
        if (!this.regexp_eatClassSetRange(v)) if (Te = this.regexp_eatClassSetOperand(v)) {
          Te === Or && (V = Or);
          for (var Le = v.pos; v.eatChars(
            [38, 38]
            /* && */
          ); ) {
            if (v.current() !== 38 && (Te = this.regexp_eatClassSetOperand(v))) {
              Te !== Or && (V = yr);
              continue;
            }
            v.raise("Invalid character in character class");
          }
          if (Le !== v.pos)
            return V;
          for (; v.eatChars(
            [45, 45]
            /* -- */
          ); )
            this.regexp_eatClassSetOperand(v) || v.raise("Invalid character in character class");
          if (Le !== v.pos)
            return V;
        } else
          v.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(v)) {
            if (Te = this.regexp_eatClassSetOperand(v), !Te)
              return V;
            Te === Or && (V = Or);
          }
      }, wt.regexp_eatClassSetRange = function(v) {
        var V = v.pos;
        if (this.regexp_eatClassSetCharacter(v)) {
          var Te = v.lastIntValue;
          if (v.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(v)) {
            var Le = v.lastIntValue;
            return Te !== -1 && Le !== -1 && Te > Le && v.raise("Range out of order in character class"), !0;
          }
          v.pos = V;
        }
        return !1;
      }, wt.regexp_eatClassSetOperand = function(v) {
        return this.regexp_eatClassSetCharacter(v) ? yr : this.regexp_eatClassStringDisjunction(v) || this.regexp_eatNestedClass(v);
      }, wt.regexp_eatNestedClass = function(v) {
        var V = v.pos;
        if (v.eat(
          91
          /* [ */
        )) {
          var Te = v.eat(
            94
            /* ^ */
          ), Le = this.regexp_classContents(v);
          if (v.eat(
            93
            /* ] */
          ))
            return Te && Le === Or && v.raise("Negated character class may contain strings"), Le;
          v.pos = V;
        }
        if (v.eat(
          92
          /* \ */
        )) {
          var Xe = this.regexp_eatCharacterClassEscape(v);
          if (Xe)
            return Xe;
          v.pos = V;
        }
        return null;
      }, wt.regexp_eatClassStringDisjunction = function(v) {
        var V = v.pos;
        if (v.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (v.eat(
            123
            /* { */
          )) {
            var Te = this.regexp_classStringDisjunctionContents(v);
            if (v.eat(
              125
              /* } */
            ))
              return Te;
          } else
            v.raise("Invalid escape");
          v.pos = V;
        }
        return null;
      }, wt.regexp_classStringDisjunctionContents = function(v) {
        for (var V = this.regexp_classString(v); v.eat(
          124
          /* | */
        ); )
          this.regexp_classString(v) === Or && (V = Or);
        return V;
      }, wt.regexp_classString = function(v) {
        for (var V = 0; this.regexp_eatClassSetCharacter(v); )
          V++;
        return V === 1 ? yr : Or;
      }, wt.regexp_eatClassSetCharacter = function(v) {
        var V = v.pos;
        if (v.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(v) || this.regexp_eatClassSetReservedPunctuator(v) ? !0 : v.eat(
            98
            /* b */
          ) ? (v.lastIntValue = 8, !0) : (v.pos = V, !1);
        var Te = v.current();
        return Te < 0 || Te === v.lookahead() && Yi(Te) || ya(Te) ? !1 : (v.advance(), v.lastIntValue = Te, !0);
      };
      function Yi(v) {
        return v === 33 || v >= 35 && v <= 38 || v >= 42 && v <= 44 || v === 46 || v >= 58 && v <= 64 || v === 94 || v === 96 || v === 126;
      }
      function ya(v) {
        return v === 40 || v === 41 || v === 45 || v === 47 || v >= 91 && v <= 93 || v >= 123 && v <= 125;
      }
      wt.regexp_eatClassSetReservedPunctuator = function(v) {
        var V = v.current();
        return Xi(V) ? (v.lastIntValue = V, v.advance(), !0) : !1;
      };
      function Xi(v) {
        return v === 33 || v === 35 || v === 37 || v === 38 || v === 44 || v === 45 || v >= 58 && v <= 62 || v === 64 || v === 96 || v === 126;
      }
      wt.regexp_eatClassControlLetter = function(v) {
        var V = v.current();
        return Qt(V) || V === 95 ? (v.lastIntValue = V % 32, v.advance(), !0) : !1;
      }, wt.regexp_eatHexEscapeSequence = function(v) {
        var V = v.pos;
        if (v.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(v, 2))
            return !0;
          v.switchU && v.raise("Invalid escape"), v.pos = V;
        }
        return !1;
      }, wt.regexp_eatDecimalDigits = function(v) {
        var V = v.pos, Te = 0;
        for (v.lastIntValue = 0; Qt(Te = v.current()); )
          v.lastIntValue = 10 * v.lastIntValue + (Te - 48), v.advance();
        return v.pos !== V;
      };
      function Qt(v) {
        return v >= 48 && v <= 57;
      }
      wt.regexp_eatHexDigits = function(v) {
        var V = v.pos, Te = 0;
        for (v.lastIntValue = 0; qi(Te = v.current()); )
          v.lastIntValue = 16 * v.lastIntValue + Qi(Te), v.advance();
        return v.pos !== V;
      };
      function qi(v) {
        return v >= 48 && v <= 57 || v >= 65 && v <= 70 || v >= 97 && v <= 102;
      }
      function Qi(v) {
        return v >= 65 && v <= 70 ? 10 + (v - 65) : v >= 97 && v <= 102 ? 10 + (v - 97) : v - 48;
      }
      wt.regexp_eatLegacyOctalEscapeSequence = function(v) {
        if (this.regexp_eatOctalDigit(v)) {
          var V = v.lastIntValue;
          if (this.regexp_eatOctalDigit(v)) {
            var Te = v.lastIntValue;
            V <= 3 && this.regexp_eatOctalDigit(v) ? v.lastIntValue = V * 64 + Te * 8 + v.lastIntValue : v.lastIntValue = V * 8 + Te;
          } else
            v.lastIntValue = V;
          return !0;
        }
        return !1;
      }, wt.regexp_eatOctalDigit = function(v) {
        var V = v.current();
        return _i(V) ? (v.lastIntValue = V - 48, v.advance(), !0) : (v.lastIntValue = 0, !1);
      };
      function _i(v) {
        return v >= 48 && v <= 55;
      }
      wt.regexp_eatFixedHexDigits = function(v, V) {
        var Te = v.pos;
        v.lastIntValue = 0;
        for (var Le = 0; Le < V; ++Le) {
          var Xe = v.current();
          if (!qi(Xe))
            return v.pos = Te, !1;
          v.lastIntValue = 16 * v.lastIntValue + Qi(Xe), v.advance();
        }
        return !0;
      };
      var ni = function(V) {
        this.type = V.type, this.value = V.value, this.start = V.start, this.end = V.end, V.options.locations && (this.loc = new Pe(V, V.startLoc, V.endLoc)), V.options.ranges && (this.range = [V.start, V.end]);
      }, Vt = r.prototype;
      Vt.next = function(v) {
        !v && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new ni(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, Vt.getToken = function() {
        return this.next(), new ni(this);
      }, typeof Symbol < "u" && (Vt[Symbol.iterator] = function() {
        var v = this;
        return {
          next: function() {
            var V = v.getToken();
            return {
              done: V.type === o.eof,
              value: V
            };
          }
        };
      }), Vt.nextToken = function() {
        var v = this.curContext();
        if ((!v || !v.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(o.eof);
        if (v.override)
          return v.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, Vt.readToken = function(v) {
        return n(v, this.options.ecmaVersion >= 6) || v === 92 ? this.readWord() : this.getTokenFromCode(v);
      }, Vt.fullCharCodeAtPos = function() {
        var v = this.input.charCodeAt(this.pos);
        if (v <= 55295 || v >= 56320)
          return v;
        var V = this.input.charCodeAt(this.pos + 1);
        return V <= 56319 || V >= 57344 ? v : (v << 10) + V - 56613888;
      }, Vt.skipBlockComment = function() {
        var v = this.options.onComment && this.curPosition(), V = this.pos, Te = this.input.indexOf("*/", this.pos += 2);
        if (Te === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = Te + 2, this.options.locations)
          for (var Le = void 0, Xe = V; (Le = L(this.input, Xe, this.pos)) > -1; )
            ++this.curLine, Xe = this.lineStart = Le;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(V + 2, Te),
          V,
          this.pos,
          v,
          this.curPosition()
        );
      }, Vt.skipLineComment = function(v) {
        for (var V = this.pos, Te = this.options.onComment && this.curPosition(), Le = this.input.charCodeAt(this.pos += v); this.pos < this.input.length && !R(Le); )
          Le = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(V + v, this.pos),
          V,
          this.pos,
          Te,
          this.curPosition()
        );
      }, Vt.skipSpace = function() {
        e: for (; this.pos < this.input.length; ) {
          var v = this.input.charCodeAt(this.pos);
          switch (v) {
            case 32:
            case 160:
              ++this.pos;
              break;
            case 13:
              this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
            case 10:
            case 8232:
            case 8233:
              ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
              break;
            case 47:
              switch (this.input.charCodeAt(this.pos + 1)) {
                case 42:
                  this.skipBlockComment();
                  break;
                case 47:
                  this.skipLineComment(2);
                  break;
                default:
                  break e;
              }
              break;
            default:
              if (v > 8 && v < 14 || v >= 5760 && z.test(String.fromCharCode(v)))
                ++this.pos;
              else
                break e;
          }
        }
      }, Vt.finishToken = function(v, V) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var Te = this.type;
        this.type = v, this.value = V, this.updateContext(Te);
      }, Vt.readToken_dot = function() {
        var v = this.input.charCodeAt(this.pos + 1);
        if (v >= 48 && v <= 57)
          return this.readNumber(!0);
        var V = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && v === 46 && V === 46 ? (this.pos += 3, this.finishToken(o.ellipsis)) : (++this.pos, this.finishToken(o.dot));
      }, Vt.readToken_slash = function() {
        var v = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : v === 61 ? this.finishOp(o.assign, 2) : this.finishOp(o.slash, 1);
      }, Vt.readToken_mult_modulo_exp = function(v) {
        var V = this.input.charCodeAt(this.pos + 1), Te = 1, Le = v === 42 ? o.star : o.modulo;
        return this.options.ecmaVersion >= 7 && v === 42 && V === 42 && (++Te, Le = o.starstar, V = this.input.charCodeAt(this.pos + 2)), V === 61 ? this.finishOp(o.assign, Te + 1) : this.finishOp(Le, Te);
      }, Vt.readToken_pipe_amp = function(v) {
        var V = this.input.charCodeAt(this.pos + 1);
        if (V === v) {
          if (this.options.ecmaVersion >= 12) {
            var Te = this.input.charCodeAt(this.pos + 2);
            if (Te === 61)
              return this.finishOp(o.assign, 3);
          }
          return this.finishOp(v === 124 ? o.logicalOR : o.logicalAND, 2);
        }
        return V === 61 ? this.finishOp(o.assign, 2) : this.finishOp(v === 124 ? o.bitwiseOR : o.bitwiseAND, 1);
      }, Vt.readToken_caret = function() {
        var v = this.input.charCodeAt(this.pos + 1);
        return v === 61 ? this.finishOp(o.assign, 2) : this.finishOp(o.bitwiseXOR, 1);
      }, Vt.readToken_plus_min = function(v) {
        var V = this.input.charCodeAt(this.pos + 1);
        return V === v ? V === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || A.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(o.incDec, 2) : V === 61 ? this.finishOp(o.assign, 2) : this.finishOp(o.plusMin, 1);
      }, Vt.readToken_lt_gt = function(v) {
        var V = this.input.charCodeAt(this.pos + 1), Te = 1;
        return V === v ? (Te = v === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + Te) === 61 ? this.finishOp(o.assign, Te + 1) : this.finishOp(o.bitShift, Te)) : V === 33 && v === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (V === 61 && (Te = 2), this.finishOp(o.relational, Te));
      }, Vt.readToken_eq_excl = function(v) {
        var V = this.input.charCodeAt(this.pos + 1);
        return V === 61 ? this.finishOp(o.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : v === 61 && V === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(o.arrow)) : this.finishOp(v === 61 ? o.eq : o.prefix, 1);
      }, Vt.readToken_question = function() {
        var v = this.options.ecmaVersion;
        if (v >= 11) {
          var V = this.input.charCodeAt(this.pos + 1);
          if (V === 46) {
            var Te = this.input.charCodeAt(this.pos + 2);
            if (Te < 48 || Te > 57)
              return this.finishOp(o.questionDot, 2);
          }
          if (V === 63) {
            if (v >= 12) {
              var Le = this.input.charCodeAt(this.pos + 2);
              if (Le === 61)
                return this.finishOp(o.assign, 3);
            }
            return this.finishOp(o.coalesce, 2);
          }
        }
        return this.finishOp(o.question, 1);
      }, Vt.readToken_numberSign = function() {
        var v = this.options.ecmaVersion, V = 35;
        if (v >= 13 && (++this.pos, V = this.fullCharCodeAtPos(), n(V, !0) || V === 92))
          return this.finishToken(o.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + de(V) + "'");
      }, Vt.getTokenFromCode = function(v) {
        switch (v) {
          // The interpretation of a dot depends on whether it is followed
          // by a digit or another two dots.
          case 46:
            return this.readToken_dot();
          // Punctuation tokens.
          case 40:
            return ++this.pos, this.finishToken(o.parenL);
          case 41:
            return ++this.pos, this.finishToken(o.parenR);
          case 59:
            return ++this.pos, this.finishToken(o.semi);
          case 44:
            return ++this.pos, this.finishToken(o.comma);
          case 91:
            return ++this.pos, this.finishToken(o.bracketL);
          case 93:
            return ++this.pos, this.finishToken(o.bracketR);
          case 123:
            return ++this.pos, this.finishToken(o.braceL);
          case 125:
            return ++this.pos, this.finishToken(o.braceR);
          case 58:
            return ++this.pos, this.finishToken(o.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(o.backQuote);
          case 48:
            var V = this.input.charCodeAt(this.pos + 1);
            if (V === 120 || V === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (V === 111 || V === 79)
                return this.readRadixNumber(8);
              if (V === 98 || V === 66)
                return this.readRadixNumber(2);
            }
          // Anything else beginning with a digit is an integer, octal
          // number, or float.
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          // Quotes produce strings.
          case 34:
          case 39:
            return this.readString(v);
          // Operators are parsed inline in tiny state machines. '=' (61) is
          // often referred to. `finishOp` simply skips the amount of
          // characters it is given as second argument, and returns a token
          // of the type given by its first argument.
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(v);
          case 124:
          case 38:
            return this.readToken_pipe_amp(v);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(v);
          case 60:
          case 62:
            return this.readToken_lt_gt(v);
          case 61:
          case 33:
            return this.readToken_eq_excl(v);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(o.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + de(v) + "'");
      }, Vt.finishOp = function(v, V) {
        var Te = this.input.slice(this.pos, this.pos + V);
        return this.pos += V, this.finishToken(v, Te);
      }, Vt.readRegexp = function() {
        for (var v, V, Te = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(Te, "Unterminated regular expression");
          var Le = this.input.charAt(this.pos);
          if (A.test(Le) && this.raise(Te, "Unterminated regular expression"), v)
            v = !1;
          else {
            if (Le === "[")
              V = !0;
            else if (Le === "]" && V)
              V = !1;
            else if (Le === "/" && !V)
              break;
            v = Le === "\\";
          }
          ++this.pos;
        }
        var Xe = this.input.slice(Te, this.pos);
        ++this.pos;
        var at = this.pos, lt = this.readWord1();
        this.containsEsc && this.unexpected(at);
        var Et = this.regexpState || (this.regexpState = new lr(this));
        Et.reset(Te, Xe, lt), this.validateRegExpFlags(Et), this.validateRegExpPattern(Et);
        var Tt = null;
        try {
          Tt = new RegExp(Xe, lt);
        } catch {
        }
        return this.finishToken(o.regexp, { pattern: Xe, flags: lt, value: Tt });
      }, Vt.readInt = function(v, V, Te) {
        for (var Le = this.options.ecmaVersion >= 12 && V === void 0, Xe = Te && this.input.charCodeAt(this.pos) === 48, at = this.pos, lt = 0, Et = 0, Tt = 0, Yt = V ?? 1 / 0; Tt < Yt; ++Tt, ++this.pos) {
          var zt = this.input.charCodeAt(this.pos), fr = void 0;
          if (Le && zt === 95) {
            Xe && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), Et === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), Tt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), Et = zt;
            continue;
          }
          if (zt >= 97 ? fr = zt - 97 + 10 : zt >= 65 ? fr = zt - 65 + 10 : zt >= 48 && zt <= 57 ? fr = zt - 48 : fr = 1 / 0, fr >= v)
            break;
          Et = zt, lt = lt * v + fr;
        }
        return Le && Et === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === at || V != null && this.pos - at !== V ? null : lt;
      };
      function Qr(v, V) {
        return V ? parseInt(v, 8) : parseFloat(v.replace(/_/g, ""));
      }
      function Kr(v) {
        return typeof BigInt != "function" ? null : BigInt(v.replace(/_/g, ""));
      }
      Vt.readRadixNumber = function(v) {
        var V = this.pos;
        this.pos += 2;
        var Te = this.readInt(v);
        return Te == null && this.raise(this.start + 2, "Expected number in radix " + v), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (Te = Kr(this.input.slice(V, this.pos)), ++this.pos) : n(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(o.num, Te);
      }, Vt.readNumber = function(v) {
        var V = this.pos;
        !v && this.readInt(10, void 0, !0) === null && this.raise(V, "Invalid number");
        var Te = this.pos - V >= 2 && this.input.charCodeAt(V) === 48;
        Te && this.strict && this.raise(V, "Invalid number");
        var Le = this.input.charCodeAt(this.pos);
        if (!Te && !v && this.options.ecmaVersion >= 11 && Le === 110) {
          var Xe = Kr(this.input.slice(V, this.pos));
          return ++this.pos, n(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(o.num, Xe);
        }
        Te && /[89]/.test(this.input.slice(V, this.pos)) && (Te = !1), Le === 46 && !Te && (++this.pos, this.readInt(10), Le = this.input.charCodeAt(this.pos)), (Le === 69 || Le === 101) && !Te && (Le = this.input.charCodeAt(++this.pos), (Le === 43 || Le === 45) && ++this.pos, this.readInt(10) === null && this.raise(V, "Invalid number")), n(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var at = Qr(this.input.slice(V, this.pos), Te);
        return this.finishToken(o.num, at);
      }, Vt.readCodePoint = function() {
        var v = this.input.charCodeAt(this.pos), V;
        if (v === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var Te = ++this.pos;
          V = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, V > 1114111 && this.invalidStringToken(Te, "Code point out of bounds");
        } else
          V = this.readHexChar(4);
        return V;
      }, Vt.readString = function(v) {
        for (var V = "", Te = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var Le = this.input.charCodeAt(this.pos);
          if (Le === v)
            break;
          Le === 92 ? (V += this.input.slice(Te, this.pos), V += this.readEscapedChar(!1), Te = this.pos) : Le === 8232 || Le === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (R(Le) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return V += this.input.slice(Te, this.pos++), this.finishToken(o.string, V);
      };
      var zr = {};
      Vt.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (v) {
          if (v === zr)
            this.readInvalidTemplateToken();
          else
            throw v;
        }
        this.inTemplateElement = !1;
      }, Vt.invalidStringToken = function(v, V) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw zr;
        this.raise(v, V);
      }, Vt.readTmplToken = function() {
        for (var v = "", V = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var Te = this.input.charCodeAt(this.pos);
          if (Te === 96 || Te === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === o.template || this.type === o.invalidTemplate) ? Te === 36 ? (this.pos += 2, this.finishToken(o.dollarBraceL)) : (++this.pos, this.finishToken(o.backQuote)) : (v += this.input.slice(V, this.pos), this.finishToken(o.template, v));
          if (Te === 92)
            v += this.input.slice(V, this.pos), v += this.readEscapedChar(!0), V = this.pos;
          else if (R(Te)) {
            switch (v += this.input.slice(V, this.pos), ++this.pos, Te) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                v += `
`;
                break;
              default:
                v += String.fromCharCode(Te);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), V = this.pos;
          } else
            ++this.pos;
        }
      }, Vt.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            // fall through
            case "`":
              return this.finishToken(o.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            // fall through
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, Vt.readEscapedChar = function(v) {
        var V = this.input.charCodeAt(++this.pos);
        switch (++this.pos, V) {
          case 110:
            return `
`;
          // 'n' -> '\n'
          case 114:
            return "\r";
          // 'r' -> '\r'
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          // 'x'
          case 117:
            return de(this.readCodePoint());
          // 'u'
          case 116:
            return "	";
          // 't' -> '\t'
          case 98:
            return "\b";
          // 'b' -> '\b'
          case 118:
            return "\v";
          // 'v' -> '\u000b'
          case 102:
            return "\f";
          // 'f' -> '\f'
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          // '\r\n'
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), v) {
              var Te = this.pos - 1;
              this.invalidStringToken(
                Te,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (V >= 48 && V <= 55) {
              var Le = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Xe = parseInt(Le, 8);
              return Xe > 255 && (Le = Le.slice(0, -1), Xe = parseInt(Le, 8)), this.pos += Le.length - 1, V = this.input.charCodeAt(this.pos), (Le !== "0" || V === 56 || V === 57) && (this.strict || v) && this.invalidStringToken(
                this.pos - 1 - Le.length,
                v ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Xe);
            }
            return R(V) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(V);
        }
      }, Vt.readHexChar = function(v) {
        var V = this.pos, Te = this.readInt(16, v);
        return Te === null && this.invalidStringToken(V, "Bad character escape sequence"), Te;
      }, Vt.readWord1 = function() {
        this.containsEsc = !1;
        for (var v = "", V = !0, Te = this.pos, Le = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Xe = this.fullCharCodeAtPos();
          if (c(Xe, Le))
            this.pos += Xe <= 65535 ? 1 : 2;
          else if (Xe === 92) {
            this.containsEsc = !0, v += this.input.slice(Te, this.pos);
            var at = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var lt = this.readCodePoint();
            (V ? n : c)(lt, Le) || this.invalidStringToken(at, "Invalid Unicode escape"), v += de(lt), Te = this.pos;
          } else
            break;
          V = !1;
        }
        return v + this.input.slice(Te, this.pos);
      }, Vt.readWord = function() {
        var v = this.readWord1(), V = o.name;
        return this.keywords.test(v) && (V = S[v]), this.finishToken(V, v);
      };
      var Fr = "8.14.1";
      r.acorn = {
        Parser: r,
        version: Fr,
        defaultOptions: xe,
        Position: ke,
        SourceLocation: Pe,
        getLineInfo: fe,
        Node: Be,
        TokenType: g,
        tokTypes: o,
        keywordTypes: S,
        TokContext: he,
        tokContexts: D,
        isIdentifierChar: c,
        isIdentifierStart: n,
        Token: ni,
        isNewLine: R,
        lineBreak: A,
        lineBreakG: T,
        nonASCIIwhitespace: z
      };
      function oi(v, V) {
        return r.parse(v, V);
      }
      function ui(v, V, Te) {
        return r.parseExpressionAt(v, V, Te);
      }
      function Di(v, V) {
        return r.tokenizer(v, V);
      }
      ne.Node = Be, ne.Parser = r, ne.Position = ke, ne.SourceLocation = Pe, ne.TokContext = he, ne.Token = ni, ne.TokenType = g, ne.defaultOptions = xe, ne.getLineInfo = fe, ne.isIdentifierChar = c, ne.isIdentifierStart = n, ne.isNewLine = R, ne.keywordTypes = S, ne.lineBreak = A, ne.lineBreakG = T, ne.nonASCIIwhitespace = z, ne.parse = oi, ne.parseExpressionAt = ui, ne.tokContexts = D, ne.tokTypes = o, ne.tokenizer = Di, ne.version = Fr;
    });
  }(Ms, Ms.exports)), Ms.exports;
}
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
var z0 = Vo.exports, Wc;
function F0() {
  return Wc || (Wc = 1, function(Me) {
    (function(ge, ne) {
      ge = ge || Gc;
      var C = ge.window, Z = ge.document, _ = new function() {
        var e = /^(statics|enumerable|beans|preserve)$/, r = [], h = r.slice, k = Object.create, I = Object.getOwnPropertyDescriptor, B = Object.defineProperty, j = r.forEach || function(q, K) {
          for (var be = 0, te = this.length; be < te; be++)
            q.call(K, this[be], be, this);
        }, H = function(q, K) {
          for (var be in this)
            this.hasOwnProperty(be) && q.call(K, this[be], be, this);
        }, X = Object.assign || function(q) {
          for (var K = 1, be = arguments.length; K < be; K++) {
            var te = arguments[K];
            for (var he in te)
              te.hasOwnProperty(he) && (q[he] = te[he]);
          }
          return q;
        }, ue = function(q, K, be) {
          if (q) {
            var te = I(q, "length");
            (te && typeof te.value == "number" ? j : H).call(q, K, be = be || q);
          }
          return be;
        };
        function pe(q, K, be, te, he) {
          var D = {};
          function Se(O, ce) {
            ce = ce || (ce = I(K, O)) && (ce.get ? ce : ce.value), typeof ce == "string" && ce[0] === "#" && (ce = q[ce.substring(1)] || ce);
            var Oe = typeof ce == "function", Be = ce, Ge = he || Oe && !ce.base ? ce && ce.get ? O in q : q[O] : null, Fe;
            (!he || !Ge) && (Oe && Ge && (ce.base = Ge), Oe && te !== !1 && (Fe = O.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (D[Fe[3].toLowerCase() + Fe[4]] = Fe[2]), (!Be || Oe || !Be.get || typeof Be.get != "function" || !M.isPlainObject(Be)) && (Be = { value: Be, writable: !0 }), (I(q, O) || { configurable: !0 }).configurable && (Be.configurable = !0, Be.enumerable = be ?? !Fe), B(q, O, Be));
          }
          if (K) {
            for (var le in K)
              K.hasOwnProperty(le) && !e.test(le) && Se(le);
            for (var le in D) {
              var m = D[le], oe = q["set" + m], me = q["get" + m] || oe && q["is" + m];
              me && (te === !0 || me.length === 0) && Se(le, { get: me, set: oe });
            }
          }
          return q;
        }
        function M() {
          for (var q = 0, K = arguments.length; q < K; q++) {
            var be = arguments[q];
            be && X(this, be);
          }
          return this;
        }
        return pe(M, {
          inject: function(q) {
            if (q) {
              var K = q.statics === !0 ? q : q.statics, be = q.beans, te = q.preserve;
              K !== q && pe(this.prototype, q, q.enumerable, be, te), pe(this, K, null, be, te);
            }
            for (var he = 1, D = arguments.length; he < D; he++)
              this.inject(arguments[he]);
            return this;
          },
          extend: function() {
            for (var q = this, K, be, te = 0, he, D = arguments.length; te < D && !(K && be); te++)
              he = arguments[te], K = K || he.initialize, be = be || he.prototype;
            return K = K || function() {
              q.apply(this, arguments);
            }, be = K.prototype = be || k(this.prototype), B(
              be,
              "constructor",
              { value: K, writable: !0, configurable: !0 }
            ), pe(K, this), arguments.length && this.inject.apply(K, arguments), K.base = q, K;
          }
        }).inject({
          enumerable: !1,
          initialize: M,
          set: M,
          inject: function() {
            for (var q = 0, K = arguments.length; q < K; q++) {
              var be = arguments[q];
              be && pe(this, be, be.enumerable, be.beans, be.preserve);
            }
            return this;
          },
          extend: function() {
            var q = k(this);
            return q.inject.apply(q, arguments);
          },
          each: function(q, K) {
            return ue(this, q, K);
          },
          clone: function() {
            return new this.constructor(this);
          },
          statics: {
            set: X,
            each: ue,
            create: k,
            define: B,
            describe: I,
            clone: function(q) {
              return X(new q.constructor(), q);
            },
            isPlainObject: function(q) {
              var K = q != null && q.constructor;
              return K && (K === Object || K === M || K.name === "Object");
            },
            pick: function(q, K) {
              return q !== ne ? q : K;
            },
            slice: function(q, K, be) {
              return h.call(q, K, be);
            }
          }
        });
      }();
      Me.exports = _, _.inject({
        enumerable: !1,
        toString: function() {
          return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + _.each(this, function(e, r) {
            if (!/^_/.test(r)) {
              var h = typeof e;
              this.push(r + ": " + (h === "number" ? d.instance.number(e) : h === "string" ? "'" + e + "'" : e));
            }
          }, []).join(", ") + " }";
        },
        getClassName: function() {
          return this._class || "";
        },
        importJSON: function(e) {
          return _.importJSON(e, this);
        },
        exportJSON: function(e) {
          return _.exportJSON(this, e);
        },
        toJSON: function() {
          return _.serialize(this);
        },
        set: function(e, r) {
          return e && _.filter(this, e, r, this._prioritize), this;
        }
      }, {
        beans: !1,
        statics: {
          exports: {},
          extend: function e() {
            var r = e.base.apply(this, arguments), h = r.prototype._class;
            return h && !_.exports[h] && (_.exports[h] = r), r;
          },
          equals: function(e, r) {
            if (e === r)
              return !0;
            if (e && e.equals)
              return e.equals(r);
            if (r && r.equals)
              return r.equals(e);
            if (e && r && typeof e == "object" && typeof r == "object") {
              if (Array.isArray(e) && Array.isArray(r)) {
                var h = e.length;
                if (h !== r.length)
                  return !1;
                for (; h--; )
                  if (!_.equals(e[h], r[h]))
                    return !1;
              } else {
                var k = Object.keys(e), h = k.length;
                if (h !== Object.keys(r).length)
                  return !1;
                for (; h--; ) {
                  var I = k[h];
                  if (!(r.hasOwnProperty(I) && _.equals(e[I], r[I])))
                    return !1;
                }
              }
              return !0;
            }
            return !1;
          },
          read: function(e, r, h, k) {
            if (this === _) {
              var I = this.peek(e, r);
              return e.__index++, I;
            }
            var B = this.prototype, j = B._readIndex, H = r || j && e.__index || 0, X = e.length, ue = e[H];
            if (k = k || X - H, ue instanceof this || h && h.readNull && ue == null && k <= 1)
              return j && (e.__index = H + 1), ue && h && h.clone ? ue.clone() : ue;
            if (ue = _.create(B), j && (ue.__read = !0), ue = ue.initialize.apply(ue, H > 0 || H + k < X ? _.slice(e, H, H + k) : e) || ue, j) {
              e.__index = H + ue.__read;
              var pe = ue.__filtered;
              pe && (e.__filtered = pe, ue.__filtered = ne), ue.__read = ne;
            }
            return ue;
          },
          peek: function(e, r) {
            return e[e.__index = r || e.__index || 0];
          },
          remain: function(e) {
            return e.length - (e.__index || 0);
          },
          readList: function(e, r, h, k) {
            for (var I = [], B, j = r || 0, H = k ? j + k : e.length, X = j; X < H; X++)
              I.push(Array.isArray(B = e[X]) ? this.read(B, 0, h) : this.read(e, X, h, 1));
            return I;
          },
          readNamed: function(e, r, h, k, I) {
            var B = this.getNamed(e, r), j = B !== ne;
            if (j) {
              var H = e.__filtered;
              if (!H) {
                var X = this.getSource(e);
                H = e.__filtered = _.create(X), H.__unfiltered = X;
              }
              H[r] = ne;
            }
            return this.read(j ? [B] : e, h, k, I);
          },
          readSupported: function(e, r) {
            var h = this.getSource(e), k = this, I = !1;
            return h && Object.keys(h).forEach(function(B) {
              if (B in r) {
                var j = k.readNamed(e, B);
                j !== ne && (r[B] = j), I = !0;
              }
            }), I;
          },
          getSource: function(e) {
            var r = e.__source;
            if (r === ne) {
              var h = e.length === 1 && e[0];
              r = e.__source = h && _.isPlainObject(h) ? h : null;
            }
            return r;
          },
          getNamed: function(e, r) {
            var h = this.getSource(e);
            if (h)
              return r ? h[r] : e.__filtered || h;
          },
          hasNamed: function(e, r) {
            return !!this.getNamed(e, r);
          },
          filter: function(e, r, h, k) {
            var I;
            function B(pe) {
              if (!(h && pe in h) && !(I && pe in I)) {
                var M = r[pe];
                M !== ne && (e[pe] = M);
              }
            }
            if (k) {
              for (var j = {}, H = 0, X, ue = k.length; H < ue; H++)
                (X = k[H]) in r && (B(X), j[X] = !0);
              I = j;
            }
            return Object.keys(r.__unfiltered || r).forEach(B), e;
          },
          isPlainValue: function(e, r) {
            return _.isPlainObject(e) || Array.isArray(e) || r && typeof e == "string";
          },
          serialize: function(e, r, h, k) {
            r = r || {};
            var I = !k, B;
            if (I && (r.formatter = new d(r.precision), k = {
              length: 0,
              definitions: {},
              references: {},
              add: function(M, q) {
                var K = "#" + M._id, be = this.references[K];
                if (!be) {
                  this.length++;
                  var te = q.call(M), he = M._class;
                  he && te[0] !== he && te.unshift(he), this.definitions[K] = te, be = this.references[K] = [K];
                }
                return be;
              }
            }), e && e._serialize) {
              B = e._serialize(r, k);
              var j = e._class;
              j && !e._compactSerialize && (I || !h) && B[0] !== j && B.unshift(j);
            } else if (Array.isArray(e)) {
              B = [];
              for (var H = 0, X = e.length; H < X; H++)
                B[H] = _.serialize(e[H], r, h, k);
            } else if (_.isPlainObject(e)) {
              B = {};
              for (var ue = Object.keys(e), H = 0, X = ue.length; H < X; H++) {
                var pe = ue[H];
                B[pe] = _.serialize(
                  e[pe],
                  r,
                  h,
                  k
                );
              }
            } else typeof e == "number" ? B = r.formatter.number(e, r.precision) : B = e;
            return I && k.length > 0 ? [["dictionary", k.definitions], B] : B;
          },
          deserialize: function(e, r, h, k, I) {
            var B = e, j = !h, H = j && e && e.length && e[0][0] === "dictionary";
            if (h = h || {}, Array.isArray(e)) {
              var X = e[0], ue = X === "dictionary";
              if (e.length == 1 && /^#/.test(X))
                return h.dictionary[X];
              X = _.exports[X], B = [];
              for (var pe = X ? 1 : 0, M = e.length; pe < M; pe++)
                B.push(_.deserialize(
                  e[pe],
                  r,
                  h,
                  ue,
                  H
                ));
              if (X) {
                var q = B;
                r ? B = r(X, q, j || I) : B = new X(q);
              }
            } else if (_.isPlainObject(e)) {
              B = {}, k && (h.dictionary = B);
              for (var K in e)
                B[K] = _.deserialize(e[K], r, h);
            }
            return H ? B[1] : B;
          },
          exportJSON: function(e, r) {
            var h = _.serialize(e, r);
            return r && r.asString == !1 ? h : JSON.stringify(h);
          },
          importJSON: function(e, r) {
            return _.deserialize(
              typeof e == "string" ? JSON.parse(e) : e,
              function(h, k, I) {
                var B = I && r && r.constructor === h, j = B ? r : _.create(h.prototype);
                if (k.length === 1 && j instanceof o && (B || !(j instanceof T))) {
                  var H = k[0];
                  _.isPlainObject(H) && (H.insert = !1, B && (k = k.concat([o.INSERT])));
                }
                return (B ? j.set : h).apply(j, k), B && (r = null), j;
              }
            );
          },
          push: function(e, r) {
            var h = r.length;
            if (h < 4096)
              e.push.apply(e, r);
            else {
              var k = e.length;
              e.length += h;
              for (var I = 0; I < h; I++)
                e[k + I] = r[I];
            }
            return e;
          },
          splice: function(e, r, h, k) {
            var I = r && r.length, B = h === ne;
            h = B ? e.length : h, h > e.length && (h = e.length);
            for (var j = 0; j < I; j++)
              r[j]._index = h + j;
            if (B)
              return _.push(e, r), [];
            var H = [h, k];
            r && _.push(H, r);
            for (var X = e.splice.apply(e, H), j = 0, ue = X.length; j < ue; j++)
              X[j]._index = ne;
            for (var j = h + I, ue = e.length; j < ue; j++)
              e[j]._index = j;
            return X;
          },
          capitalize: function(e) {
            return e.replace(/\b[a-z]/g, function(r) {
              return r.toUpperCase();
            });
          },
          camelize: function(e) {
            return e.replace(/-(.)/g, function(r, h) {
              return h.toUpperCase();
            });
          },
          hyphenate: function(e) {
            return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
          }
        }
      });
      var P = {
        on: function(e, r) {
          if (typeof e != "string")
            _.each(e, function(B, j) {
              this.on(j, B);
            }, this);
          else {
            var h = this._eventTypes, k = h && h[e], I = this._callbacks = this._callbacks || {};
            I = I[e] = I[e] || [], I.indexOf(r) === -1 && (I.push(r), k && k.install && I.length === 1 && k.install.call(this, e));
          }
          return this;
        },
        off: function(e, r) {
          if (typeof e != "string") {
            _.each(e, function(j, H) {
              this.off(H, j);
            }, this);
            return;
          }
          var h = this._eventTypes, k = h && h[e], I = this._callbacks && this._callbacks[e], B;
          return I && (!r || (B = I.indexOf(r)) !== -1 && I.length === 1 ? (k && k.uninstall && k.uninstall.call(this, e), delete this._callbacks[e]) : B !== -1 && I.splice(B, 1)), this;
        },
        once: function(e, r) {
          return this.on(e, function h() {
            r.apply(this, arguments), this.off(e, h);
          });
        },
        emit: function(e, r) {
          var h = this._callbacks && this._callbacks[e];
          if (!h)
            return !1;
          var k = _.slice(arguments, 1), I = r && r.target && !r.currentTarget;
          h = h.slice(), I && (r.currentTarget = this);
          for (var B = 0, j = h.length; B < j; B++)
            if (h[B].apply(this, k) == !1) {
              r && r.stop && r.stop();
              break;
            }
          return I && delete r.currentTarget, !0;
        },
        responds: function(e) {
          return !!(this._callbacks && this._callbacks[e]);
        },
        attach: "#on",
        detach: "#off",
        fire: "#emit",
        _installEvents: function(e) {
          var r = this._eventTypes, h = this._callbacks, k = e ? "install" : "uninstall";
          if (r) {
            for (var I in h)
              if (h[I].length > 0) {
                var B = r[I], j = B && B[k];
                j && j.call(this, I);
              }
          }
        },
        statics: {
          inject: function e(r) {
            var h = r._events;
            if (h) {
              var k = {};
              _.each(h, function(I, B) {
                var j = typeof I == "string", H = j ? I : B, X = _.capitalize(H), ue = H.substring(2).toLowerCase();
                k[ue] = j ? {} : I, H = "_" + H, r["get" + X] = function() {
                  return this[H];
                }, r["set" + X] = function(pe) {
                  var M = this[H];
                  M && this.off(ue, M), pe && this.on(ue, pe), this[H] = pe;
                };
              }), r._eventTypes = k;
            }
            return e.base.apply(this, arguments);
          }
        }
      }, x = _.extend({
        _class: "PaperScope",
        initialize: function e() {
          Ae = this, this.settings = new _({
            applyMatrix: !0,
            insertItems: !0,
            handleSize: 4,
            hitTolerance: 0
          }), this.project = null, this.projects = [], this.tools = [], this._id = e._id++, e._scopes[this._id] = this;
          var r = e.prototype;
          if (!this.support) {
            var h = Ce.getContext(1, 1) || {};
            r.support = {
              nativeDash: "setLineDash" in h || "mozDash" in h,
              nativeBlendModes: ve.nativeModes
            }, Ce.release(h);
          }
          if (!this.agent) {
            var k = ge.navigator.userAgent.toLowerCase(), I = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(k) || [])[0], B = I === "darwin" ? "mac" : I, j = r.agent = r.browser = { platform: B };
            B && (j[B] = !0), k.replace(
              /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
              function(H, X, ue, pe, M) {
                if (!j.chrome) {
                  var q = X === "opera" ? pe : /^(node|trident)$/.test(X) ? M : ue;
                  j.version = q, j.versionNumber = parseFloat(q), X = { trident: "msie", jsdom: "node" }[X] || X, j.name = X, j[X] = !0;
                }
              }
            ), j.chrome && delete j.webkit, j.atom && delete j.chrome;
          }
        },
        version: "0.12.18",
        getView: function() {
          var e = this.project;
          return e && e._view;
        },
        getPaper: function() {
          return this;
        },
        execute: function(e, r) {
          var h = Ae.PaperScript.execute(e, this, r);
          return Ze.updateFocus(), h;
        },
        install: function(e) {
          var r = this;
          _.each(["project", "view", "tool"], function(k) {
            _.define(e, k, {
              configurable: !0,
              get: function() {
                return r[k];
              }
            });
          });
          for (var h in this)
            !/^_/.test(h) && this[h] && (e[h] = this[h]);
        },
        setup: function(e) {
          return Ae = this, this.project = new b(e), this;
        },
        createCanvas: function(e, r) {
          return Ce.getCanvas(e, r);
        },
        activate: function() {
          Ae = this;
        },
        clear: function() {
          for (var e = this.projects, r = this.tools, h = e.length - 1; h >= 0; h--)
            e[h].remove();
          for (var h = r.length - 1; h >= 0; h--)
            r[h].remove();
        },
        remove: function() {
          this.clear(), delete x._scopes[this._id];
        },
        statics: new function() {
          function e(r) {
            return r += "Attribute", function(h, k) {
              return h[r](k) || h[r]("data-paper-" + k);
            };
          }
          return {
            _scopes: {},
            _id: 0,
            get: function(r) {
              return this._scopes[r] || null;
            },
            getAttribute: e("get"),
            hasAttribute: e("has")
          };
        }()
      }), y = _.extend(P, {
        initialize: function(e) {
          this._scope = Ae, this._index = this._scope[this._list].push(this) - 1, (e || !this._scope[this._reference]) && this.activate();
        },
        activate: function() {
          if (!this._scope)
            return !1;
          var e = this._scope[this._reference];
          return e && e !== this && e.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", e), !0;
        },
        isActive: function() {
          return this._scope[this._reference] === this;
        },
        remove: function() {
          return this._index == null ? !1 : (_.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
        },
        getView: function() {
          return this._scope.getView();
        }
      }), E = {
        findItemBoundsCollisions: function(e, r, h) {
          function k(j) {
            for (var H = new Array(j.length), X = 0; X < j.length; X++) {
              var ue = j[X].getBounds();
              H[X] = [ue.left, ue.top, ue.right, ue.bottom];
            }
            return H;
          }
          var I = k(e), B = !r || r === e ? I : k(r);
          return this.findBoundsCollisions(I, B, h || 0);
        },
        findCurveBoundsCollisions: function(e, r, h, k) {
          function I(q) {
            for (var K = Math.min, be = Math.max, te = new Array(q.length), he = 0; he < q.length; he++) {
              var D = q[he];
              te[he] = [
                K(D[0], D[2], D[4], D[6]),
                K(D[1], D[3], D[5], D[7]),
                be(D[0], D[2], D[4], D[6]),
                be(D[1], D[3], D[5], D[7])
              ];
            }
            return te;
          }
          var B = I(e), j = !r || r === e ? B : I(r);
          if (k) {
            for (var H = this.findBoundsCollisions(
              B,
              j,
              h || 0,
              !1,
              !0
            ), X = this.findBoundsCollisions(
              B,
              j,
              h || 0,
              !0,
              !0
            ), ue = [], pe = 0, M = H.length; pe < M; pe++)
              ue[pe] = { hor: H[pe], ver: X[pe] };
            return ue;
          }
          return this.findBoundsCollisions(B, j, h || 0);
        },
        findBoundsCollisions: function(e, r, h, k, I) {
          var B = !r || e === r, j = B ? e : e.concat(r), H = e.length, X = j.length;
          function ue(vt, bt, At) {
            for (var ot = 0, ct = vt.length; ot < ct; ) {
              var gt = ct + ot >>> 1;
              j[vt[gt]][bt] < At ? ot = gt + 1 : ct = gt;
            }
            return ot - 1;
          }
          for (var pe = k ? 1 : 0, M = pe + 2, q = k ? 0 : 1, K = q + 2, be = new Array(X), te = 0; te < X; te++)
            be[te] = te;
          be.sort(function(vt, bt) {
            return j[vt][pe] - j[bt][pe];
          });
          for (var he = [], D = new Array(H), te = 0; te < X; te++) {
            var Se = be[te], le = j[Se], m = B ? Se : Se - H, oe = Se < H, me = B || !oe, O = oe ? [] : null;
            if (he.length) {
              var ce = ue(
                he,
                M,
                le[pe] - h
              ) + 1;
              if (he.splice(0, ce), B && I) {
                O = O.concat(he);
                for (var Oe = 0; Oe < he.length; Oe++) {
                  var Be = he[Oe];
                  D[Be].push(m);
                }
              } else
                for (var Ge = le[K], Fe = le[q], Oe = 0; Oe < he.length; Oe++) {
                  var Be = he[Oe], Ye = j[Be], Ke = Be < H, et = B || Be >= H;
                  (I || (oe && et || me && Ke) && Ge >= Ye[q] - h && Fe <= Ye[K] + h) && (oe && et && O.push(
                    B ? Be : Be - H
                  ), me && Ke && D[Be].push(m));
                }
            }
            if (oe && (e === r && O.push(Se), D[Se] = O), he.length) {
              var Je = le[M], nt = ue(he, M, Je);
              he.splice(nt + 1, 0, Se);
            } else
              he.push(Se);
          }
          for (var te = 0; te < D.length; te++) {
            var pt = D[te];
            pt && pt.sort(function(bt, At) {
              return bt - At;
            });
          }
          return D;
        }
      }, d = _.extend({
        initialize: function(e) {
          this.precision = _.pick(e, 5), this.multiplier = Math.pow(10, this.precision);
        },
        number: function(e) {
          return this.precision < 16 ? Math.round(e * this.multiplier) / this.multiplier : e;
        },
        pair: function(e, r, h) {
          return this.number(e) + (h || ",") + this.number(r);
        },
        point: function(e, r) {
          return this.number(e.x) + (r || ",") + this.number(e.y);
        },
        size: function(e, r) {
          return this.number(e.width) + (r || ",") + this.number(e.height);
        },
        rectangle: function(e, r) {
          return this.point(e, r) + (r || ",") + this.size(e, r);
        }
      });
      d.instance = new d();
      var l = new function() {
        var e = [
          [0.5773502691896257],
          [0, 0.7745966692414834],
          [0.33998104358485626, 0.8611363115940526],
          [0, 0.5384693101056831, 0.906179845938664],
          [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
          [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
          [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
          [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
          [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
          [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
          [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
          [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
          [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
          [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
          [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
        ], r = [
          [1],
          [0.8888888888888888, 0.5555555555555556],
          [0.6521451548625461, 0.34785484513745385],
          [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
          [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
          [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
          [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
          [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
          [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
          [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
          [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
          [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
          [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
          [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
          [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
        ], h = Math.abs, k = Math.sqrt, I = Math.pow, B = Math.log2 || function(M) {
          return Math.log(M) * Math.LOG2E;
        }, j = 1e-12, H = 112e-18;
        function X(M, q, K) {
          return M < q ? q : M > K ? K : M;
        }
        function ue(M, q, K) {
          function be(ce) {
            var Oe = ce * 134217729, Be = ce - Oe, Ge = Be + Oe, Fe = ce - Ge;
            return [Ge, Fe];
          }
          var te = q * q - M * K, he = q * q + M * K;
          if (h(te) * 3 < he) {
            var D = be(M), Se = be(q), le = be(K), m = q * q, oe = Se[0] * Se[0] - m + 2 * Se[0] * Se[1] + Se[1] * Se[1], me = M * K, O = D[0] * le[0] - me + D[0] * le[1] + D[1] * le[0] + D[1] * le[1];
            te = m - me + (oe - O);
          }
          return te;
        }
        function pe() {
          var M = Math.max.apply(Math, arguments);
          return M && (M < 1e-8 || M > 1e8) ? I(2, -Math.round(B(M))) : 0;
        }
        return {
          EPSILON: j,
          MACHINE_EPSILON: H,
          CURVETIME_EPSILON: 1e-8,
          GEOMETRIC_EPSILON: 1e-7,
          TRIGONOMETRIC_EPSILON: 1e-8,
          ANGULAR_EPSILON: 1e-5,
          KAPPA: 4 * (k(2) - 1) / 3,
          isZero: function(M) {
            return M >= -1e-12 && M <= j;
          },
          isMachineZero: function(M) {
            return M >= -112e-18 && M <= H;
          },
          clamp: X,
          integrate: function(M, q, K, be) {
            for (var te = e[be - 2], he = r[be - 2], D = (K - q) * 0.5, Se = D + q, le = 0, m = be + 1 >> 1, oe = be & 1 ? he[le++] * M(Se) : 0; le < m; ) {
              var me = D * te[le];
              oe += he[le++] * (M(Se + me) + M(Se - me));
            }
            return D * oe;
          },
          findRoot: function(M, q, K, be, te, he, D) {
            for (var Se = 0; Se < he; Se++) {
              var le = M(K), m = le / q(K), oe = K - m;
              if (h(m) < D) {
                K = oe;
                break;
              }
              le > 0 ? (te = K, K = oe <= be ? (be + te) * 0.5 : oe) : (be = K, K = oe >= te ? (be + te) * 0.5 : oe);
            }
            return X(K, be, te);
          },
          solveQuadratic: function(M, q, K, be, te, he) {
            var D, Se = 1 / 0;
            if (h(M) < j) {
              if (h(q) < j)
                return h(K) < j ? -1 : 0;
              D = -K / q;
            } else {
              q *= -0.5;
              var le = ue(M, q, K);
              if (le && h(le) < H) {
                var m = pe(h(M), h(q), h(K));
                m && (M *= m, q *= m, K *= m, le = ue(M, q, K));
              }
              if (le >= -112e-18) {
                var oe = le < 0 ? 0 : k(le), me = q + (q < 0 ? -oe : oe);
                me === 0 ? (D = K / M, Se = -D) : (D = me / M, Se = K / me);
              }
            }
            var O = 0, ce = te == null, Oe = te - j, Be = he + j;
            return isFinite(D) && (ce || D > Oe && D < Be) && (be[O++] = ce ? D : X(D, te, he)), Se !== D && isFinite(Se) && (ce || Se > Oe && Se < Be) && (be[O++] = ce ? Se : X(Se, te, he)), O;
          },
          solveCubic: function(M, q, K, be, te, he, D) {
            var Se = pe(h(M), h(q), h(K), h(be)), le, m, oe, me, O;
            Se && (M *= Se, q *= Se, K *= Se, be *= Se);
            function ce(nt) {
              le = nt;
              var pt = M * le;
              m = pt + q, oe = m * le + K, me = (pt + m) * le + oe, O = oe * le + be;
            }
            if (h(M) < j)
              M = q, m = K, oe = be, le = 1 / 0;
            else if (h(be) < j)
              m = q, oe = K, le = 0;
            else {
              ce(-(q / M) / 3);
              var Oe = O / M, Be = I(h(Oe), 1 / 3), Ge = Oe < 0 ? -1 : 1, Fe = -me / M, Ye = Fe > 0 ? 1.324717957244746 * Math.max(Be, k(Fe)) : Be, Ke = le - Ge * Ye;
              if (Ke !== le) {
                do
                  ce(Ke), Ke = me === 0 ? le : le - O / me / (1 + H);
                while (Ge * Ke > Ge * le);
                h(M) * le * le > h(be / le) && (oe = -be / le, m = (oe - K) / le);
              }
            }
            var et = l.solveQuadratic(M, m, oe, te, he, D), Je = he == null;
            return isFinite(le) && (et === 0 || et > 0 && le !== te[0] && le !== te[1]) && (Je || le > he - j && le < D + j) && (te[et++] = Je ? le : X(le, he, D)), et;
          }
        };
      }(), u = {
        _id: 1,
        _pools: {},
        get: function(e) {
          if (e) {
            var r = this._pools[e];
            return r || (r = this._pools[e] = { _id: 1 }), r._id++;
          } else
            return this._id++;
        }
      }, a = _.extend({
        _class: "Point",
        _readIndex: !0,
        initialize: function(r, h) {
          var k = typeof r, I = this.__read, B = 0;
          if (k === "number") {
            var j = typeof h == "number";
            this._set(r, j ? h : r), I && (B = j ? 2 : 1);
          } else if (k === "undefined" || r === null)
            this._set(0, 0), I && (B = r === null ? 1 : 0);
          else {
            var H = k === "string" ? r.split(/[\s,]+/) || [] : r;
            B = 1, Array.isArray(H) ? this._set(+H[0], +(H.length > 1 ? H[1] : H[0])) : "x" in H ? this._set(H.x || 0, H.y || 0) : "width" in H ? this._set(H.width || 0, H.height || 0) : "angle" in H ? (this._set(H.length || 0, 0), this.setAngle(H.angle || 0)) : (this._set(0, 0), B = 0);
          }
          return I && (this.__read = B), this;
        },
        set: "#initialize",
        _set: function(e, r) {
          return this.x = e, this.y = r, this;
        },
        equals: function(e) {
          return this === e || e && (this.x === e.x && this.y === e.y || Array.isArray(e) && this.x === e[0] && this.y === e[1]) || !1;
        },
        clone: function() {
          return new a(this.x, this.y);
        },
        toString: function() {
          var e = d.instance;
          return "{ x: " + e.number(this.x) + ", y: " + e.number(this.y) + " }";
        },
        _serialize: function(e) {
          var r = e.formatter;
          return [r.number(this.x), r.number(this.y)];
        },
        getLength: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        setLength: function(e) {
          if (this.isZero()) {
            var r = this._angle || 0;
            this._set(
              Math.cos(r) * e,
              Math.sin(r) * e
            );
          } else {
            var h = e / this.getLength();
            l.isZero(h) && this.getAngle(), this._set(
              this.x * h,
              this.y * h
            );
          }
        },
        getAngle: function() {
          return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
        },
        setAngle: function(e) {
          this.setAngleInRadians.call(this, e * Math.PI / 180);
        },
        getAngleInDegrees: "#getAngle",
        setAngleInDegrees: "#setAngle",
        getAngleInRadians: function() {
          if (arguments.length) {
            var e = a.read(arguments), r = this.getLength() * e.getLength();
            if (l.isZero(r))
              return NaN;
            var h = this.dot(e) / r;
            return Math.acos(h < -1 ? -1 : h > 1 ? 1 : h);
          } else
            return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
        },
        setAngleInRadians: function(e) {
          if (this._angle = e, !this.isZero()) {
            var r = this.getLength();
            this._set(
              Math.cos(e) * r,
              Math.sin(e) * r
            );
          }
        },
        getQuadrant: function() {
          return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
        }
      }, {
        beans: !1,
        getDirectedAngle: function() {
          var e = a.read(arguments);
          return Math.atan2(this.cross(e), this.dot(e)) * 180 / Math.PI;
        },
        getDistance: function() {
          var e = arguments, r = a.read(e), h = r.x - this.x, k = r.y - this.y, I = h * h + k * k, B = _.read(e);
          return B ? I : Math.sqrt(I);
        },
        normalize: function(e) {
          e === ne && (e = 1);
          var r = this.getLength(), h = r !== 0 ? e / r : 0, k = new a(this.x * h, this.y * h);
          return h >= 0 && (k._angle = this._angle), k;
        },
        rotate: function(e, r) {
          if (e === 0)
            return this.clone();
          e = e * Math.PI / 180;
          var h = r ? this.subtract(r) : this, k = Math.sin(e), I = Math.cos(e);
          return h = new a(
            h.x * I - h.y * k,
            h.x * k + h.y * I
          ), r ? h.add(r) : h;
        },
        transform: function(e) {
          return e ? e._transformPoint(this) : this;
        },
        add: function() {
          var e = a.read(arguments);
          return new a(this.x + e.x, this.y + e.y);
        },
        subtract: function() {
          var e = a.read(arguments);
          return new a(this.x - e.x, this.y - e.y);
        },
        multiply: function() {
          var e = a.read(arguments);
          return new a(this.x * e.x, this.y * e.y);
        },
        divide: function() {
          var e = a.read(arguments);
          return new a(this.x / e.x, this.y / e.y);
        },
        modulo: function() {
          var e = a.read(arguments);
          return new a(this.x % e.x, this.y % e.y);
        },
        negate: function() {
          return new a(-this.x, -this.y);
        },
        isInside: function() {
          return f.read(arguments).contains(this);
        },
        isClose: function() {
          var e = arguments, r = a.read(e), h = _.read(e);
          return this.getDistance(r) <= h;
        },
        isCollinear: function() {
          var e = a.read(arguments);
          return a.isCollinear(this.x, this.y, e.x, e.y);
        },
        isColinear: "#isCollinear",
        isOrthogonal: function() {
          var e = a.read(arguments);
          return a.isOrthogonal(this.x, this.y, e.x, e.y);
        },
        isZero: function() {
          var e = l.isZero;
          return e(this.x) && e(this.y);
        },
        isNaN: function() {
          return isNaN(this.x) || isNaN(this.y);
        },
        isInQuadrant: function(e) {
          return this.x * (e > 1 && e < 4 ? -1 : 1) >= 0 && this.y * (e > 2 ? -1 : 1) >= 0;
        },
        dot: function() {
          var e = a.read(arguments);
          return this.x * e.x + this.y * e.y;
        },
        cross: function() {
          var e = a.read(arguments);
          return this.x * e.y - this.y * e.x;
        },
        project: function() {
          var e = a.read(arguments), r = e.isZero() ? 0 : this.dot(e) / e.dot(e);
          return new a(
            e.x * r,
            e.y * r
          );
        },
        statics: {
          min: function() {
            var e = arguments, r = a.read(e), h = a.read(e);
            return new a(
              Math.min(r.x, h.x),
              Math.min(r.y, h.y)
            );
          },
          max: function() {
            var e = arguments, r = a.read(e), h = a.read(e);
            return new a(
              Math.max(r.x, h.x),
              Math.max(r.y, h.y)
            );
          },
          random: function() {
            return new a(Math.random(), Math.random());
          },
          isCollinear: function(e, r, h, k) {
            return Math.abs(e * k - r * h) <= Math.sqrt((e * e + r * r) * (h * h + k * k)) * 1e-8;
          },
          isOrthogonal: function(e, r, h, k) {
            return Math.abs(e * h + r * k) <= Math.sqrt((e * e + r * r) * (h * h + k * k)) * 1e-8;
          }
        }
      }, _.each(["round", "ceil", "floor", "abs"], function(e) {
        var r = Math[e];
        this[e] = function() {
          return new a(r(this.x), r(this.y));
        };
      }, {})), n = a.extend({
        initialize: function(r, h, k, I) {
          this._x = r, this._y = h, this._owner = k, this._setter = I;
        },
        _set: function(e, r, h) {
          return this._x = e, this._y = r, h || this._owner[this._setter](this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(e) {
          this._x = e, this._owner[this._setter](this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(e) {
          this._y = e, this._owner[this._setter](this);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(e) {
          this._owner._changeSelection(this._getSelection(), e);
        },
        _getSelection: function() {
          return this._setter === "setPosition" ? 4 : 0;
        }
      }), c = _.extend({
        _class: "Size",
        _readIndex: !0,
        initialize: function(r, h) {
          var k = typeof r, I = this.__read, B = 0;
          if (k === "number") {
            var j = typeof h == "number";
            this._set(r, j ? h : r), I && (B = j ? 2 : 1);
          } else if (k === "undefined" || r === null)
            this._set(0, 0), I && (B = r === null ? 1 : 0);
          else {
            var H = k === "string" ? r.split(/[\s,]+/) || [] : r;
            B = 1, Array.isArray(H) ? this._set(+H[0], +(H.length > 1 ? H[1] : H[0])) : "width" in H ? this._set(H.width || 0, H.height || 0) : "x" in H ? this._set(H.x || 0, H.y || 0) : (this._set(0, 0), B = 0);
          }
          return I && (this.__read = B), this;
        },
        set: "#initialize",
        _set: function(e, r) {
          return this.width = e, this.height = r, this;
        },
        equals: function(e) {
          return e === this || e && (this.width === e.width && this.height === e.height || Array.isArray(e) && this.width === e[0] && this.height === e[1]) || !1;
        },
        clone: function() {
          return new c(this.width, this.height);
        },
        toString: function() {
          var e = d.instance;
          return "{ width: " + e.number(this.width) + ", height: " + e.number(this.height) + " }";
        },
        _serialize: function(e) {
          var r = e.formatter;
          return [
            r.number(this.width),
            r.number(this.height)
          ];
        },
        add: function() {
          var e = c.read(arguments);
          return new c(this.width + e.width, this.height + e.height);
        },
        subtract: function() {
          var e = c.read(arguments);
          return new c(this.width - e.width, this.height - e.height);
        },
        multiply: function() {
          var e = c.read(arguments);
          return new c(this.width * e.width, this.height * e.height);
        },
        divide: function() {
          var e = c.read(arguments);
          return new c(this.width / e.width, this.height / e.height);
        },
        modulo: function() {
          var e = c.read(arguments);
          return new c(this.width % e.width, this.height % e.height);
        },
        negate: function() {
          return new c(-this.width, -this.height);
        },
        isZero: function() {
          var e = l.isZero;
          return e(this.width) && e(this.height);
        },
        isNaN: function() {
          return isNaN(this.width) || isNaN(this.height);
        },
        statics: {
          min: function(e, r) {
            return new c(
              Math.min(e.width, r.width),
              Math.min(e.height, r.height)
            );
          },
          max: function(e, r) {
            return new c(
              Math.max(e.width, r.width),
              Math.max(e.height, r.height)
            );
          },
          random: function() {
            return new c(Math.random(), Math.random());
          }
        }
      }, _.each(["round", "ceil", "floor", "abs"], function(e) {
        var r = Math[e];
        this[e] = function() {
          return new c(r(this.width), r(this.height));
        };
      }, {})), g = c.extend({
        initialize: function(r, h, k, I) {
          this._width = r, this._height = h, this._owner = k, this._setter = I;
        },
        _set: function(e, r, h) {
          return this._width = e, this._height = r, h || this._owner[this._setter](this), this;
        },
        getWidth: function() {
          return this._width;
        },
        setWidth: function(e) {
          this._width = e, this._owner[this._setter](this);
        },
        getHeight: function() {
          return this._height;
        },
        setHeight: function(e) {
          this._height = e, this._owner[this._setter](this);
        }
      }), f = _.extend({
        _class: "Rectangle",
        _readIndex: !0,
        beans: !0,
        initialize: function(r, h, k, I) {
          var B = arguments, j = typeof r, H;
          if (j === "number" ? (this._set(r, h, k, I), H = 4) : j === "undefined" || r === null ? (this._set(0, 0, 0, 0), H = r === null ? 1 : 0) : B.length === 1 && (Array.isArray(r) ? (this._set.apply(this, r), H = 1) : r.x !== ne || r.width !== ne ? (this._set(
            r.x || 0,
            r.y || 0,
            r.width || 0,
            r.height || 0
          ), H = 1) : r.from === ne && r.to === ne && (this._set(0, 0, 0, 0), _.readSupported(B, this) && (H = 1))), H === ne) {
            var X = a.readNamed(B, "from"), ue = _.peek(B), pe = X.x, M = X.y, q, K;
            if (ue && ue.x !== ne || _.hasNamed(B, "to")) {
              var be = a.readNamed(B, "to");
              q = be.x - pe, K = be.y - M, q < 0 && (pe = be.x, q = -q), K < 0 && (M = be.y, K = -K);
            } else {
              var te = c.read(B);
              q = te.width, K = te.height;
            }
            this._set(pe, M, q, K), H = B.__index;
          }
          var he = B.__filtered;
          return he && (this.__filtered = he), this.__read && (this.__read = H), this;
        },
        set: "#initialize",
        _set: function(e, r, h, k) {
          return this.x = e, this.y = r, this.width = h, this.height = k, this;
        },
        clone: function() {
          return new f(this.x, this.y, this.width, this.height);
        },
        equals: function(e) {
          var r = _.isPlainValue(e) ? f.read(arguments) : e;
          return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
        },
        toString: function() {
          var e = d.instance;
          return "{ x: " + e.number(this.x) + ", y: " + e.number(this.y) + ", width: " + e.number(this.width) + ", height: " + e.number(this.height) + " }";
        },
        _serialize: function(e) {
          var r = e.formatter;
          return [
            r.number(this.x),
            r.number(this.y),
            r.number(this.width),
            r.number(this.height)
          ];
        },
        getPoint: function(e) {
          var r = e ? a : n;
          return new r(this.x, this.y, this, "setPoint");
        },
        setPoint: function() {
          var e = a.read(arguments);
          this.x = e.x, this.y = e.y;
        },
        getSize: function(e) {
          var r = e ? c : g;
          return new r(this.width, this.height, this, "setSize");
        },
        _fw: 1,
        _fh: 1,
        setSize: function() {
          var e = c.read(arguments), r = this._sx, h = this._sy, k = e.width, I = e.height;
          r && (this.x += (this.width - k) * r), h && (this.y += (this.height - I) * h), this.width = k, this.height = I, this._fw = this._fh = 1;
        },
        getLeft: function() {
          return this.x;
        },
        setLeft: function(e) {
          if (!this._fw) {
            var r = e - this.x;
            this.width -= this._sx === 0.5 ? r * 2 : r;
          }
          this.x = e, this._sx = this._fw = 0;
        },
        getTop: function() {
          return this.y;
        },
        setTop: function(e) {
          if (!this._fh) {
            var r = e - this.y;
            this.height -= this._sy === 0.5 ? r * 2 : r;
          }
          this.y = e, this._sy = this._fh = 0;
        },
        getRight: function() {
          return this.x + this.width;
        },
        setRight: function(e) {
          if (!this._fw) {
            var r = e - this.x;
            this.width = this._sx === 0.5 ? r * 2 : r;
          }
          this.x = e - this.width, this._sx = 1, this._fw = 0;
        },
        getBottom: function() {
          return this.y + this.height;
        },
        setBottom: function(e) {
          if (!this._fh) {
            var r = e - this.y;
            this.height = this._sy === 0.5 ? r * 2 : r;
          }
          this.y = e - this.height, this._sy = 1, this._fh = 0;
        },
        getCenterX: function() {
          return this.x + this.width / 2;
        },
        setCenterX: function(e) {
          this._fw || this._sx === 0.5 ? this.x = e - this.width / 2 : (this._sx && (this.x += (e - this.x) * 2 * this._sx), this.width = (e - this.x) * 2), this._sx = 0.5, this._fw = 0;
        },
        getCenterY: function() {
          return this.y + this.height / 2;
        },
        setCenterY: function(e) {
          this._fh || this._sy === 0.5 ? this.y = e - this.height / 2 : (this._sy && (this.y += (e - this.y) * 2 * this._sy), this.height = (e - this.y) * 2), this._sy = 0.5, this._fh = 0;
        },
        getCenter: function(e) {
          var r = e ? a : n;
          return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
        },
        setCenter: function() {
          var e = a.read(arguments);
          return this.setCenterX(e.x), this.setCenterY(e.y), this;
        },
        getArea: function() {
          return this.width * this.height;
        },
        isEmpty: function() {
          return this.width === 0 || this.height === 0;
        },
        contains: function(e) {
          return e && e.width !== ne || (Array.isArray(e) ? e : arguments).length === 4 ? this._containsRectangle(f.read(arguments)) : this._containsPoint(a.read(arguments));
        },
        _containsPoint: function(e) {
          var r = e.x, h = e.y;
          return r >= this.x && h >= this.y && r <= this.x + this.width && h <= this.y + this.height;
        },
        _containsRectangle: function(e) {
          var r = e.x, h = e.y;
          return r >= this.x && h >= this.y && r + e.width <= this.x + this.width && h + e.height <= this.y + this.height;
        },
        intersects: function() {
          var e = f.read(arguments), r = _.read(arguments) || 0;
          return e.x + e.width > this.x - r && e.y + e.height > this.y - r && e.x < this.x + this.width + r && e.y < this.y + this.height + r;
        },
        intersect: function() {
          var e = f.read(arguments), r = Math.max(this.x, e.x), h = Math.max(this.y, e.y), k = Math.min(this.x + this.width, e.x + e.width), I = Math.min(this.y + this.height, e.y + e.height);
          return new f(r, h, k - r, I - h);
        },
        unite: function() {
          var e = f.read(arguments), r = Math.min(this.x, e.x), h = Math.min(this.y, e.y), k = Math.max(this.x + this.width, e.x + e.width), I = Math.max(this.y + this.height, e.y + e.height);
          return new f(r, h, k - r, I - h);
        },
        include: function() {
          var e = a.read(arguments), r = Math.min(this.x, e.x), h = Math.min(this.y, e.y), k = Math.max(this.x + this.width, e.x), I = Math.max(this.y + this.height, e.y);
          return new f(r, h, k - r, I - h);
        },
        expand: function() {
          var e = c.read(arguments), r = e.width, h = e.height;
          return new f(
            this.x - r / 2,
            this.y - h / 2,
            this.width + r,
            this.height + h
          );
        },
        scale: function(e, r) {
          return this.expand(
            this.width * e - this.width,
            this.height * (r === ne ? e : r) - this.height
          );
        }
      }, _.each(
        [
          ["Top", "Left"],
          ["Top", "Right"],
          ["Bottom", "Left"],
          ["Bottom", "Right"],
          ["Left", "Center"],
          ["Top", "Center"],
          ["Right", "Center"],
          ["Bottom", "Center"]
        ],
        function(e, r) {
          var h = e.join(""), k = /^[RL]/.test(h);
          r >= 4 && (e[1] += k ? "Y" : "X");
          var I = e[k ? 0 : 1], B = e[k ? 1 : 0], j = "get" + I, H = "get" + B, X = "set" + I, ue = "set" + B, pe = "get" + h, M = "set" + h;
          this[pe] = function(q) {
            var K = q ? a : n;
            return new K(this[j](), this[H](), this, M);
          }, this[M] = function() {
            var q = a.read(arguments);
            this[X](q.x), this[ue](q.y);
          };
        },
        {
          beans: !0
        }
      )), p = f.extend(
        {
          initialize: function(r, h, k, I, B, j) {
            this._set(r, h, k, I, !0), this._owner = B, this._setter = j;
          },
          _set: function(e, r, h, k, I) {
            return this._x = e, this._y = r, this._width = h, this._height = k, I || this._owner[this._setter](this), this;
          }
        },
        new function() {
          var e = f.prototype;
          return _.each(
            ["x", "y", "width", "height"],
            function(r) {
              var h = _.capitalize(r), k = "_" + r;
              this["get" + h] = function() {
                return this[k];
              }, this["set" + h] = function(I) {
                this[k] = I, this._dontNotify || this._owner[this._setter](this);
              };
            },
            _.each(
              [
                "Point",
                "Size",
                "Center",
                "Left",
                "Top",
                "Right",
                "Bottom",
                "CenterX",
                "CenterY",
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ],
              function(r) {
                var h = "set" + r;
                this[h] = function() {
                  this._dontNotify = !0, e[h].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
                };
              },
              {
                isSelected: function() {
                  return !!(this._owner._selection & 2);
                },
                setSelected: function(r) {
                  var h = this._owner;
                  h._changeSelection && h._changeSelection(2, r);
                }
              }
            )
          );
        }()
      ), s = _.extend({
        _class: "Matrix",
        initialize: function e(r, h) {
          var k = arguments, I = k.length, B = !0;
          if (I >= 6 ? this._set.apply(this, k) : I === 1 || I === 2 ? r instanceof e ? this._set(
            r._a,
            r._b,
            r._c,
            r._d,
            r._tx,
            r._ty,
            h
          ) : Array.isArray(r) ? this._set.apply(
            this,
            h ? r.concat([h]) : r
          ) : B = !1 : I ? B = !1 : this.reset(), !B)
            throw new Error("Unsupported matrix parameters");
          return this;
        },
        set: "#initialize",
        _set: function(e, r, h, k, I, B, j) {
          return this._a = e, this._b = r, this._c = h, this._d = k, this._tx = I, this._ty = B, j || this._changed(), this;
        },
        _serialize: function(e, r) {
          return _.serialize(this.getValues(), e, !0, r);
        },
        _changed: function() {
          var e = this._owner;
          e && (e._applyMatrix ? e.transform(null, !0) : e._changed(25));
        },
        clone: function() {
          return new s(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        },
        equals: function(e) {
          return e === this || e && this._a === e._a && this._b === e._b && this._c === e._c && this._d === e._d && this._tx === e._tx && this._ty === e._ty;
        },
        toString: function() {
          var e = d.instance;
          return "[[" + [
            e.number(this._a),
            e.number(this._c),
            e.number(this._tx)
          ].join(", ") + "], [" + [
            e.number(this._b),
            e.number(this._d),
            e.number(this._ty)
          ].join(", ") + "]]";
        },
        reset: function(e) {
          return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, e || this._changed(), this;
        },
        apply: function(e, r) {
          var h = this._owner;
          return h ? (h.transform(null, _.pick(e, !0), r), this.isIdentity()) : !1;
        },
        translate: function() {
          var e = a.read(arguments), r = e.x, h = e.y;
          return this._tx += r * this._a + h * this._c, this._ty += r * this._b + h * this._d, this._changed(), this;
        },
        scale: function() {
          var e = arguments, r = a.read(e), h = a.read(e, 0, { readNull: !0 });
          return h && this.translate(h), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, h && this.translate(h.negate()), this._changed(), this;
        },
        rotate: function(e) {
          e *= Math.PI / 180;
          var r = a.read(arguments, 1), h = r.x, k = r.y, I = Math.cos(e), B = Math.sin(e), j = h - h * I + k * B, H = k - h * B - k * I, X = this._a, ue = this._b, pe = this._c, M = this._d;
          return this._a = I * X + B * pe, this._b = I * ue + B * M, this._c = -B * X + I * pe, this._d = -B * ue + I * M, this._tx += j * X + H * pe, this._ty += j * ue + H * M, this._changed(), this;
        },
        shear: function() {
          var e = arguments, r = a.read(e), h = a.read(e, 0, { readNull: !0 });
          h && this.translate(h);
          var k = this._a, I = this._b;
          return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * k, this._d += r.x * I, h && this.translate(h.negate()), this._changed(), this;
        },
        skew: function() {
          var e = arguments, r = a.read(e), h = a.read(e, 0, { readNull: !0 }), k = Math.PI / 180, I = new a(
            Math.tan(r.x * k),
            Math.tan(r.y * k)
          );
          return this.shear(I, h);
        },
        append: function(e, r) {
          if (e) {
            var h = this._a, k = this._b, I = this._c, B = this._d, j = e._a, H = e._c, X = e._b, ue = e._d, pe = e._tx, M = e._ty;
            this._a = j * h + X * I, this._c = H * h + ue * I, this._b = j * k + X * B, this._d = H * k + ue * B, this._tx += pe * h + M * I, this._ty += pe * k + M * B, r || this._changed();
          }
          return this;
        },
        prepend: function(e, r) {
          if (e) {
            var h = this._a, k = this._b, I = this._c, B = this._d, j = this._tx, H = this._ty, X = e._a, ue = e._c, pe = e._b, M = e._d, q = e._tx, K = e._ty;
            this._a = X * h + ue * k, this._c = X * I + ue * B, this._b = pe * h + M * k, this._d = pe * I + M * B, this._tx = X * j + ue * H + q, this._ty = pe * j + M * H + K, r || this._changed();
          }
          return this;
        },
        appended: function(e) {
          return this.clone().append(e);
        },
        prepended: function(e) {
          return this.clone().prepend(e);
        },
        invert: function() {
          var e = this._a, r = this._b, h = this._c, k = this._d, I = this._tx, B = this._ty, j = e * k - r * h, H = null;
          return j && !isNaN(j) && isFinite(I) && isFinite(B) && (this._a = k / j, this._b = -r / j, this._c = -h / j, this._d = e / j, this._tx = (h * B - k * I) / j, this._ty = (r * I - e * B) / j, H = this), H;
        },
        inverted: function() {
          return this.clone().invert();
        },
        concatenate: "#append",
        preConcatenate: "#prepend",
        chain: "#appended",
        _shiftless: function() {
          return new s(this._a, this._b, this._c, this._d, 0, 0);
        },
        _orNullIfIdentity: function() {
          return this.isIdentity() ? null : this;
        },
        isIdentity: function() {
          return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
        },
        isInvertible: function() {
          var e = this._a * this._d - this._c * this._b;
          return e && !isNaN(e) && isFinite(this._tx) && isFinite(this._ty);
        },
        isSingular: function() {
          return !this.isInvertible();
        },
        transform: function(e, r, h) {
          return arguments.length < 3 ? this._transformPoint(a.read(arguments)) : this._transformCoordinates(e, r, h);
        },
        _transformPoint: function(e, r, h) {
          var k = e.x, I = e.y;
          return r || (r = new a()), r._set(
            k * this._a + I * this._c + this._tx,
            k * this._b + I * this._d + this._ty,
            h
          );
        },
        _transformCoordinates: function(e, r, h) {
          for (var k = 0, I = 2 * h; k < I; k += 2) {
            var B = e[k], j = e[k + 1];
            r[k] = B * this._a + j * this._c + this._tx, r[k + 1] = B * this._b + j * this._d + this._ty;
          }
          return r;
        },
        _transformCorners: function(e) {
          var r = e.x, h = e.y, k = r + e.width, I = h + e.height, B = [r, h, k, h, k, I, r, I];
          return this._transformCoordinates(B, B, 4);
        },
        _transformBounds: function(e, r, h) {
          for (var k = this._transformCorners(e), I = k.slice(0, 2), B = I.slice(), j = 2; j < 8; j++) {
            var H = k[j], X = j & 1;
            H < I[X] ? I[X] = H : H > B[X] && (B[X] = H);
          }
          return r || (r = new f()), r._set(
            I[0],
            I[1],
            B[0] - I[0],
            B[1] - I[1],
            h
          );
        },
        inverseTransform: function() {
          return this._inverseTransform(a.read(arguments));
        },
        _inverseTransform: function(e, r, h) {
          var k = this._a, I = this._b, B = this._c, j = this._d, H = this._tx, X = this._ty, ue = k * j - I * B, pe = null;
          if (ue && !isNaN(ue) && isFinite(H) && isFinite(X)) {
            var M = e.x - this._tx, q = e.y - this._ty;
            r || (r = new a()), pe = r._set(
              (M * j - q * B) / ue,
              (q * k - M * I) / ue,
              h
            );
          }
          return pe;
        },
        decompose: function() {
          var e = this._a, r = this._b, h = this._c, k = this._d, I = e * k - r * h, B = Math.sqrt, j = Math.atan2, H = 180 / Math.PI, X, ue, pe;
          if (e !== 0 || r !== 0) {
            var M = B(e * e + r * r);
            X = Math.acos(e / M) * (r > 0 ? 1 : -1), ue = [M, I / M], pe = [j(e * h + r * k, M * M), 0];
          } else if (h !== 0 || k !== 0) {
            var q = B(h * h + k * k);
            X = Math.asin(h / q) * (k > 0 ? 1 : -1), ue = [I / q, q], pe = [0, j(e * h + r * k, q * q)];
          } else
            X = 0, pe = ue = [0, 0];
          return {
            translation: this.getTranslation(),
            rotation: X * H,
            scaling: new a(ue),
            skewing: new a(pe[0] * H, pe[1] * H)
          };
        },
        getValues: function() {
          return [this._a, this._b, this._c, this._d, this._tx, this._ty];
        },
        getTranslation: function() {
          return new a(this._tx, this._ty);
        },
        getScaling: function() {
          return this.decompose().scaling;
        },
        getRotation: function() {
          return this.decompose().rotation;
        },
        applyToContext: function(e) {
          this.isIdentity() || e.transform(
            this._a,
            this._b,
            this._c,
            this._d,
            this._tx,
            this._ty
          );
        }
      }, _.each(["a", "b", "c", "d", "tx", "ty"], function(e) {
        var r = _.capitalize(e), h = "_" + e;
        this["get" + r] = function() {
          return this[h];
        }, this["set" + r] = function(k) {
          this[h] = k, this._changed();
        };
      }, {})), S = _.extend({
        _class: "Line",
        initialize: function(r, h, k, I, B) {
          var j = !1;
          arguments.length >= 4 ? (this._px = r, this._py = h, this._vx = k, this._vy = I, j = B) : (this._px = r.x, this._py = r.y, this._vx = h.x, this._vy = h.y, j = k), j || (this._vx -= this._px, this._vy -= this._py);
        },
        getPoint: function() {
          return new a(this._px, this._py);
        },
        getVector: function() {
          return new a(this._vx, this._vy);
        },
        getLength: function() {
          return this.getVector().getLength();
        },
        intersect: function(e, r) {
          return S.intersect(
            this._px,
            this._py,
            this._vx,
            this._vy,
            e._px,
            e._py,
            e._vx,
            e._vy,
            !0,
            r
          );
        },
        getSide: function(e, r) {
          return S.getSide(
            this._px,
            this._py,
            this._vx,
            this._vy,
            e.x,
            e.y,
            !0,
            r
          );
        },
        getDistance: function(e) {
          return Math.abs(this.getSignedDistance(e));
        },
        getSignedDistance: function(e) {
          return S.getSignedDistance(
            this._px,
            this._py,
            this._vx,
            this._vy,
            e.x,
            e.y,
            !0
          );
        },
        isCollinear: function(e) {
          return a.isCollinear(this._vx, this._vy, e._vx, e._vy);
        },
        isOrthogonal: function(e) {
          return a.isOrthogonal(this._vx, this._vy, e._vx, e._vy);
        },
        statics: {
          intersect: function(e, r, h, k, I, B, j, H, X, ue) {
            X || (h -= e, k -= r, j -= I, H -= B);
            var pe = h * H - k * j;
            if (!l.isMachineZero(pe)) {
              var M = e - I, q = r - B, K = (j * q - H * M) / pe, be = (h * q - k * M) / pe, te = 1e-12, he = -te, D = 1 + te;
              if (ue || he < K && K < D && he < be && be < D)
                return ue || (K = K <= 0 ? 0 : K >= 1 ? 1 : K), new a(
                  e + K * h,
                  r + K * k
                );
            }
          },
          getSide: function(e, r, h, k, I, B, j, H) {
            j || (h -= e, k -= r);
            var X = I - e, ue = B - r, pe = X * k - ue * h;
            return !H && l.isMachineZero(pe) && (pe = (X * h + X * h) / (h * h + k * k), pe >= 0 && pe <= 1 && (pe = 0)), pe < 0 ? -1 : pe > 0 ? 1 : 0;
          },
          getSignedDistance: function(e, r, h, k, I, B, j) {
            return j || (h -= e, k -= r), h === 0 ? k > 0 ? I - e : e - I : k === 0 ? h < 0 ? B - r : r - B : ((I - e) * k - (B - r) * h) / (k > h ? k * Math.sqrt(1 + h * h / (k * k)) : h * Math.sqrt(1 + k * k / (h * h)));
          },
          getDistance: function(e, r, h, k, I, B, j) {
            return Math.abs(
              S.getSignedDistance(e, r, h, k, I, B, j)
            );
          }
        }
      }), b = y.extend({
        _class: "Project",
        _list: "projects",
        _reference: "project",
        _compactSerialize: !0,
        initialize: function(r) {
          y.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new je(null, null, this), this._view = Ze.create(
            this,
            r || Ce.getCanvas(1, 1)
          ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
        },
        _serialize: function(e, r) {
          return _.serialize(this._children, e, !0, r);
        },
        _changed: function(e, r) {
          if (e & 1) {
            var h = this._view;
            h && (h._needsUpdate = !0, !h._requested && h._autoUpdate && h.requestUpdate());
          }
          var k = this._changes;
          if (k && r) {
            var I = this._changesById, B = r._id, j = I[B];
            j ? j.flags |= e : k.push(I[B] = { item: r, flags: e });
          }
        },
        clear: function() {
          for (var e = this._children, r = e.length - 1; r >= 0; r--)
            e[r].remove();
        },
        isEmpty: function() {
          return !this._children.length;
        },
        remove: function e() {
          return e.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
        },
        getView: function() {
          return this._view;
        },
        getCurrentStyle: function() {
          return this._currentStyle;
        },
        setCurrentStyle: function(e) {
          this._currentStyle.set(e);
        },
        getIndex: function() {
          return this._index;
        },
        getOptions: function() {
          return this._scope.settings;
        },
        getLayers: function() {
          return this._children;
        },
        getActiveLayer: function() {
          return this._activeLayer || new T({ project: this, insert: !0 });
        },
        getSymbolDefinitions: function() {
          var e = [], r = {};
          return this.getItems({
            class: z,
            match: function(h) {
              var k = h._definition, I = k._id;
              return r[I] || (r[I] = !0, e.push(k)), !1;
            }
          }), e;
        },
        getSymbols: "getSymbolDefinitions",
        getSelectedItems: function() {
          var e = this._selectionItems, r = [];
          for (var h in e) {
            var k = e[h], I = k._selection;
            I & 1 && k.isInserted() ? r.push(k) : I || this._updateSelection(k);
          }
          return r;
        },
        _updateSelection: function(e) {
          var r = e._id, h = this._selectionItems;
          e._selection ? h[r] !== e && (this._selectionCount++, h[r] = e) : h[r] === e && (this._selectionCount--, delete h[r]);
        },
        selectAll: function() {
          for (var e = this._children, r = 0, h = e.length; r < h; r++)
            e[r].setFullySelected(!0);
        },
        deselectAll: function() {
          var e = this._selectionItems;
          for (var r in e)
            e[r].setFullySelected(!1);
        },
        addLayer: function(e) {
          return this.insertLayer(ne, e);
        },
        insertLayer: function(e, r) {
          if (r instanceof T) {
            r._remove(!1, !0), _.splice(this._children, [r], e, 0), r._setProject(this, !0);
            var h = r._name;
            h && r.setName(h), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
          } else
            r = null;
          return r;
        },
        _insertItem: function(e, r, h) {
          return r = this.insertLayer(e, r) || (this._activeLayer || this._insertItem(
            ne,
            new T(o.NO_INSERT),
            !0
          )).insertChild(e, r), h && r.activate && r.activate(), r;
        },
        getItems: function(e) {
          return o._getItems(this, e);
        },
        getItem: function(e) {
          return o._getItems(this, e, null, null, !0)[0] || null;
        },
        importJSON: function(e) {
          this.activate();
          var r = this._activeLayer;
          return _.importJSON(e, r && r.isEmpty() && r);
        },
        removeOn: function(e) {
          var r = this._removeSets;
          if (r) {
            e === "mouseup" && (r.mousedrag = null);
            var h = r[e];
            if (h) {
              for (var k in h) {
                var I = h[k];
                for (var B in r) {
                  var j = r[B];
                  j && j != h && delete j[I._id];
                }
                I.remove();
              }
              r[e] = null;
            }
          }
        },
        draw: function(e, r, h) {
          this._updateVersion++, e.save(), r.applyToContext(e);
          for (var k = this._children, I = new _({
            offset: new a(0, 0),
            pixelRatio: h,
            viewMatrix: r.isIdentity() ? null : r,
            matrices: [new s()],
            updateMatrix: !0
          }), B = 0, j = k.length; B < j; B++)
            k[B].draw(e, I);
          if (e.restore(), this._selectionCount > 0) {
            e.save(), e.strokeWidth = 1;
            var H = this._selectionItems, X = this._scope.settings.handleSize, ue = this._updateVersion;
            for (var pe in H)
              H[pe]._drawSelection(e, r, X, H, ue);
            e.restore();
          }
        }
      }), o = _.extend(
        P,
        {
          statics: {
            extend: function e(r) {
              return r._serializeFields && (r._serializeFields = _.set(
                {},
                this.prototype._serializeFields,
                r._serializeFields
              )), e.base.apply(this, arguments);
            },
            INSERT: { insert: !0 },
            NO_INSERT: { insert: !1 }
          },
          _class: "Item",
          _name: null,
          _applyMatrix: !0,
          _canApplyMatrix: !0,
          _canScaleStroke: !1,
          _pivot: null,
          _visible: !0,
          _blendMode: "normal",
          _opacity: 1,
          _locked: !1,
          _guide: !1,
          _clipMask: !1,
          _selection: 0,
          _selectBounds: !0,
          _selectChildren: !1,
          _serializeFields: {
            name: null,
            applyMatrix: null,
            matrix: new s(),
            pivot: null,
            visible: !0,
            blendMode: "normal",
            opacity: 1,
            locked: !1,
            guide: !1,
            clipMask: !1,
            selected: !1,
            data: {}
          },
          _prioritize: ["applyMatrix"]
        },
        new function() {
          var e = [
            "onMouseDown",
            "onMouseUp",
            "onMouseDrag",
            "onClick",
            "onDoubleClick",
            "onMouseMove",
            "onMouseEnter",
            "onMouseLeave"
          ];
          return _.each(
            e,
            function(r) {
              this._events[r] = {
                install: function(h) {
                  this.getView()._countItemEvent(h, 1);
                },
                uninstall: function(h) {
                  this.getView()._countItemEvent(h, -1);
                }
              };
            },
            {
              _events: {
                onFrame: {
                  install: function() {
                    this.getView()._animateItem(this, !0);
                  },
                  uninstall: function() {
                    this.getView()._animateItem(this, !1);
                  }
                },
                onLoad: {},
                onError: {}
              },
              statics: {
                _itemHandlers: e
              }
            }
          );
        }(),
        {
          initialize: function() {
          },
          _initialize: function(e, r) {
            var h = e && _.isPlainObject(e), k = h && e.internal === !0, I = this._matrix = new s(), B = h && e.project || Ae.project, j = Ae.settings;
            return this._id = k ? null : u.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && j.applyMatrix, r && I.translate(r), I._owner = this, this._style = new je(B._currentStyle, this, B), k || h && e.insert == !1 || !j.insertItems && !(h && e.insert == !0) ? this._setProject(B) : (h && e.parent || B)._insertItem(ne, this, !0), h && e !== o.NO_INSERT && e !== o.INSERT && this.set(e, {
              internal: !0,
              insert: !0,
              project: !0,
              parent: !0
            }), h;
          },
          _serialize: function(e, r) {
            var h = {}, k = this;
            function I(B) {
              for (var j in B) {
                var H = k[j];
                _.equals(H, j === "leading" ? B.fontSize * 1.2 : B[j]) || (h[j] = _.serialize(
                  H,
                  e,
                  j !== "data",
                  r
                ));
              }
            }
            return I(this._serializeFields), this instanceof A || I(this._style._defaults), [this._class, h];
          },
          _changed: function(e) {
            var r = this._symbol, h = this._parent || r, k = this._project;
            e & 8 && (this._bounds = this._position = this._decomposed = ne), e & 16 && (this._globalMatrix = ne), h && e & 72 && o._clearBoundsCache(h), e & 2 && o._clearBoundsCache(this), k && k._changed(e, this), r && r._changed(e);
          },
          getId: function() {
            return this._id;
          },
          getName: function() {
            return this._name;
          },
          setName: function(e) {
            if (this._name && this._removeNamed(), e === +e + "")
              throw new Error(
                "Names consisting only of numbers are not supported."
              );
            var r = this._getOwner();
            if (e && r) {
              var h = r._children, k = r._namedChildren;
              (k[e] = k[e] || []).push(this), e in h || (h[e] = this);
            }
            this._name = e || ne, this._changed(256);
          },
          getStyle: function() {
            return this._style;
          },
          setStyle: function(e) {
            this.getStyle().set(e);
          }
        },
        _.each(
          ["locked", "visible", "blendMode", "opacity", "guide"],
          function(e) {
            var r = _.capitalize(e), h = "_" + e, k = {
              locked: 256,
              visible: 265
            };
            this["get" + r] = function() {
              return this[h];
            }, this["set" + r] = function(I) {
              I != this[h] && (this[h] = I, this._changed(k[e] || 257));
            };
          },
          {}
        ),
        {
          beans: !0,
          getSelection: function() {
            return this._selection;
          },
          setSelection: function(e) {
            if (e !== this._selection) {
              this._selection = e;
              var r = this._project;
              r && (r._updateSelection(this), this._changed(257));
            }
          },
          _changeSelection: function(e, r) {
            var h = this._selection;
            this.setSelection(r ? h | e : h & ~e);
          },
          isSelected: function() {
            if (this._selectChildren) {
              for (var e = this._children, r = 0, h = e.length; r < h; r++)
                if (e[r].isSelected())
                  return !0;
            }
            return !!(this._selection & 1);
          },
          setSelected: function(e) {
            if (this._selectChildren)
              for (var r = this._children, h = 0, k = r.length; h < k; h++)
                r[h].setSelected(e);
            this._changeSelection(1, e);
          },
          isFullySelected: function() {
            var e = this._children, r = !!(this._selection & 1);
            if (e && r) {
              for (var h = 0, k = e.length; h < k; h++)
                if (!e[h].isFullySelected())
                  return !1;
              return !0;
            }
            return r;
          },
          setFullySelected: function(e) {
            var r = this._children;
            if (r)
              for (var h = 0, k = r.length; h < k; h++)
                r[h].setFullySelected(e);
            this._changeSelection(1, e);
          },
          isClipMask: function() {
            return this._clipMask;
          },
          setClipMask: function(e) {
            this._clipMask != (e = !!e) && (this._clipMask = e, e && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
          },
          getData: function() {
            return this._data || (this._data = {}), this._data;
          },
          setData: function(e) {
            this._data = e;
          },
          getPosition: function(e) {
            var r = e ? a : n, h = this._position || (this._position = this._getPositionFromBounds());
            return new r(h.x, h.y, this, "setPosition");
          },
          setPosition: function() {
            this.translate(a.read(arguments).subtract(this.getPosition(!0)));
          },
          _getPositionFromBounds: function(e) {
            return this._pivot ? this._matrix._transformPoint(this._pivot) : (e || this.getBounds()).getCenter(!0);
          },
          getPivot: function() {
            var e = this._pivot;
            return e ? new n(e.x, e.y, this, "setPivot") : null;
          },
          setPivot: function() {
            this._pivot = a.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = ne;
          }
        },
        _.each(
          {
            getStrokeBounds: { stroke: !0 },
            getHandleBounds: { handle: !0 },
            getInternalBounds: { internal: !0 }
          },
          function(e, r) {
            this[r] = function(h) {
              return this.getBounds(h, e);
            };
          },
          {
            beans: !0,
            getBounds: function(e, r) {
              var h = r || e instanceof s, k = _.set(
                {},
                h ? r : e,
                this._boundsOptions
              );
              (!k.stroke || this.getStrokeScaling()) && (k.cacheItem = this);
              var I = this._getCachedBounds(h && e, k).rect;
              return arguments.length ? I : new p(
                I.x,
                I.y,
                I.width,
                I.height,
                this,
                "setBounds"
              );
            },
            setBounds: function() {
              var e = f.read(arguments), r = this.getBounds(), h = this._matrix, k = new s(), I = e.getCenter();
              k.translate(I), (e.width != r.width || e.height != r.height) && (h.isInvertible() || (h.set(h._backup || new s().translate(h.getTranslation())), r = this.getBounds()), k.scale(
                r.width !== 0 ? e.width / r.width : 0,
                r.height !== 0 ? e.height / r.height : 0
              )), I = r.getCenter(), k.translate(-I.x, -I.y), this.transform(k);
            },
            _getBounds: function(e, r) {
              var h = this._children;
              return !h || !h.length ? new f() : (o._updateBoundsCache(this, r.cacheItem), o._getBounds(h, e, r));
            },
            _getBoundsCacheKey: function(e, r) {
              return [
                e.stroke ? 1 : 0,
                e.handle ? 1 : 0,
                r ? 1 : 0
              ].join("");
            },
            _getCachedBounds: function(e, r, h) {
              e = e && e._orNullIfIdentity();
              var k = r.internal && !h, I = r.cacheItem, B = k ? null : this._matrix._orNullIfIdentity(), j = I && (!e || e.equals(B)) && this._getBoundsCacheKey(r, k), H = this._bounds;
              if (o._updateBoundsCache(this._parent || this._symbol, I), j && H && j in H) {
                var X = H[j];
                return {
                  rect: X.rect.clone(),
                  nonscaling: X.nonscaling
                };
              }
              var ue = this._getBounds(e || B, r), pe = ue.rect || ue, M = this._style, q = ue.nonscaling || M.hasStroke() && !M.getStrokeScaling();
              if (j) {
                H || (this._bounds = H = {});
                var X = H[j] = {
                  rect: pe.clone(),
                  nonscaling: q,
                  internal: k
                };
              }
              return {
                rect: pe,
                nonscaling: q
              };
            },
            _getStrokeMatrix: function(e, r) {
              var h = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, k = h ? h.getViewMatrix().invert() : e;
              return k && k._shiftless();
            },
            statics: {
              _updateBoundsCache: function(e, r) {
                if (e && r) {
                  var h = r._id, k = e._boundsCache = e._boundsCache || {
                    ids: {},
                    list: []
                  };
                  k.ids[h] || (k.list.push(r), k.ids[h] = r);
                }
              },
              _clearBoundsCache: function(e) {
                var r = e._boundsCache;
                if (r) {
                  e._bounds = e._position = e._boundsCache = ne;
                  for (var h = 0, k = r.list, I = k.length; h < I; h++) {
                    var B = k[h];
                    B !== e && (B._bounds = B._position = ne, B._boundsCache && o._clearBoundsCache(B));
                  }
                }
              },
              _getBounds: function(e, r, h) {
                var k = 1 / 0, I = -k, B = k, j = I, H = !1;
                h = h || {};
                for (var X = 0, ue = e.length; X < ue; X++) {
                  var pe = e[X];
                  if (pe._visible && !pe.isEmpty(!0)) {
                    var M = pe._getCachedBounds(
                      r && r.appended(pe._matrix),
                      h,
                      !0
                    ), q = M.rect;
                    k = Math.min(q.x, k), B = Math.min(q.y, B), I = Math.max(q.x + q.width, I), j = Math.max(q.y + q.height, j), M.nonscaling && (H = !0);
                  }
                }
                return {
                  rect: isFinite(k) ? new f(k, B, I - k, j - B) : new f(),
                  nonscaling: H
                };
              }
            }
          }
        ),
        {
          beans: !0,
          _decompose: function() {
            return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          getRotation: function() {
            var e = this._decompose();
            return e ? e.rotation : 0;
          },
          setRotation: function(e) {
            var r = this.getRotation();
            if (r != null && e != null) {
              var h = this._decomposed;
              this.rotate(e - r), h && (h.rotation = e, this._decomposed = h);
            }
          },
          getScaling: function() {
            var e = this._decompose(), r = e && e.scaling;
            return new n(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
          },
          setScaling: function() {
            var e = this.getScaling(), r = a.read(arguments, 0, { clone: !0, readNull: !0 });
            if (e && r && !e.equals(r)) {
              var h = this.getRotation(), k = this._decomposed, I = new s(), B = l.isZero;
              if (B(e.x) || B(e.y))
                I.translate(k.translation), h && I.rotate(h), I.scale(r.x, r.y), this._matrix.set(I);
              else {
                var j = this.getPosition(!0);
                I.translate(j), h && I.rotate(h), I.scale(r.x / e.x, r.y / e.y), h && I.rotate(-h), I.translate(j.negate()), this.transform(I);
              }
              k && (k.scaling = r, this._decomposed = k);
            }
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var e = this._matrix;
            e.set.apply(e, arguments);
          },
          getGlobalMatrix: function(e) {
            var r = this._globalMatrix;
            if (r)
              for (var h = this._parent, k = []; h; ) {
                if (!h._globalMatrix) {
                  r = null;
                  for (var I = 0, B = k.length; I < B; I++)
                    k[I]._globalMatrix = null;
                  break;
                }
                k.push(h), h = h._parent;
              }
            if (!r) {
              r = this._globalMatrix = this._matrix.clone();
              var h = this._parent;
              h && r.prepend(h.getGlobalMatrix(!0));
            }
            return e ? r : r.clone();
          },
          getViewMatrix: function() {
            return this.getGlobalMatrix().prepend(this.getView()._matrix);
          },
          getApplyMatrix: function() {
            return this._applyMatrix;
          },
          setApplyMatrix: function(e) {
            (this._applyMatrix = this._canApplyMatrix && !!e) && this.transform(null, !0);
          },
          getTransformContent: "#getApplyMatrix",
          setTransformContent: "#setApplyMatrix"
        },
        {
          getProject: function() {
            return this._project;
          },
          _setProject: function(e, r) {
            if (this._project !== e) {
              this._project && this._installEvents(!1), this._project = e;
              for (var h = this._children, k = 0, I = h && h.length; k < I; k++)
                h[k]._setProject(e);
              r = !0;
            }
            r && this._installEvents(!0);
          },
          getView: function() {
            return this._project._view;
          },
          _installEvents: function e(r) {
            e.base.call(this, r);
            for (var h = this._children, k = 0, I = h && h.length; k < I; k++)
              h[k]._installEvents(r);
          },
          getLayer: function() {
            for (var e = this; e = e._parent; )
              if (e instanceof T)
                return e;
            return null;
          },
          getParent: function() {
            return this._parent;
          },
          setParent: function(e) {
            return e.addChild(this);
          },
          _getOwner: "#getParent",
          getChildren: function() {
            return this._children;
          },
          setChildren: function(e) {
            this.removeChildren(), this.addChildren(e);
          },
          getFirstChild: function() {
            return this._children && this._children[0] || null;
          },
          getLastChild: function() {
            return this._children && this._children[this._children.length - 1] || null;
          },
          getNextSibling: function() {
            var e = this._getOwner();
            return e && e._children[this._index + 1] || null;
          },
          getPreviousSibling: function() {
            var e = this._getOwner();
            return e && e._children[this._index - 1] || null;
          },
          getIndex: function() {
            return this._index;
          },
          setIndex: function(e) {
            var r = this._parent, h = r && r._children;
            h && r.insertChildren(
              e in h ? e : ne,
              [this]
            );
          },
          equals: function(e) {
            return e === this || e && this._class === e._class && this._style.equals(e._style) && this._matrix.equals(e._matrix) && this._locked === e._locked && this._visible === e._visible && this._blendMode === e._blendMode && this._opacity === e._opacity && this._clipMask === e._clipMask && this._guide === e._guide && this._equals(e) || !1;
          },
          _equals: function(e) {
            return _.equals(this._children, e._children);
          },
          clone: function(e) {
            var r = new this.constructor(o.NO_INSERT), h = this._children, k = _.pick(
              e ? e.insert : ne,
              e === ne || e === !0
            ), I = _.pick(e ? e.deep : ne, !0);
            h && r.copyAttributes(this), (!h || I) && r.copyContent(this), h || r.copyAttributes(this), k && r.insertAbove(this);
            var B = this._name, j = this._parent;
            if (B && j) {
              for (var h = j._children, H = B, X = 1; h[B]; )
                B = H + " " + X++;
              B !== H && r.setName(B);
            }
            return r;
          },
          copyContent: function(e) {
            for (var r = e._children, h = 0, k = r && r.length; h < k; h++)
              this.addChild(r[h].clone(!1), !0);
          },
          copyAttributes: function(e, r) {
            this.setStyle(e._style);
            for (var h = [
              "_locked",
              "_visible",
              "_blendMode",
              "_opacity",
              "_clipMask",
              "_guide"
            ], k = 0, I = h.length; k < I; k++) {
              var B = h[k];
              e.hasOwnProperty(B) && (this[B] = e[B]);
            }
            r || this._matrix.set(e._matrix, !0), this.setApplyMatrix(e._applyMatrix), this.setPivot(e._pivot), this.setSelection(e._selection);
            var j = e._data, H = e._name;
            this._data = j ? _.clone(j) : null, H && this.setName(H);
          },
          rasterize: function(e, r) {
            var h, k, I;
            _.isPlainObject(e) ? (h = e.resolution, k = e.insert, I = e.raster) : (h = e, k = r), I || (I = new L(o.NO_INSERT));
            var B = this.getStrokeBounds(), j = (h || this.getView().getResolution()) / 72, H = B.getTopLeft().floor(), X = B.getBottomRight().ceil(), ue = new c(X.subtract(H)), pe = ue.multiply(j);
            if (I.setSize(pe, !0), !pe.isZero()) {
              var M = I.getContext(!0), q = new s().scale(j).translate(H.negate());
              M.save(), q.applyToContext(M), this.draw(M, new _({ matrices: [q] })), M.restore();
            }
            return I._matrix.set(
              new s().translate(H.add(ue.divide(2))).scale(1 / j)
            ), (k === ne || k) && I.insertAbove(this), I;
          },
          contains: function() {
            var e = this._matrix;
            return e.isInvertible() && !!this._contains(e._inverseTransform(a.read(arguments)));
          },
          _contains: function(e) {
            var r = this._children;
            if (r) {
              for (var h = r.length - 1; h >= 0; h--)
                if (r[h].contains(e))
                  return !0;
              return !1;
            }
            return e.isInside(this.getInternalBounds());
          },
          isInside: function() {
            return f.read(arguments).contains(this.getBounds());
          },
          _asPathItem: function() {
            return new Q.Rectangle({
              rectangle: this.getInternalBounds(),
              matrix: this._matrix,
              insert: !1
            });
          },
          intersects: function(e, r) {
            return e instanceof o ? this._asPathItem().getIntersections(
              e._asPathItem(),
              null,
              r,
              !0
            ).length > 0 : !1;
          }
        },
        new function() {
          function e() {
            var k = arguments;
            return this._hitTest(
              a.read(k),
              J.getOptions(k)
            );
          }
          function r() {
            var k = arguments, I = a.read(k), B = J.getOptions(k), j = [];
            return this._hitTest(I, new _({ all: j }, B)), j;
          }
          function h(k, I, B, j) {
            var H = this._children;
            if (H)
              for (var X = H.length - 1; X >= 0; X--) {
                var ue = H[X], pe = ue !== j && ue._hitTest(
                  k,
                  I,
                  B
                );
                if (pe && !I.all)
                  return pe;
              }
            return null;
          }
          return b.inject({
            hitTest: e,
            hitTestAll: r,
            _hitTest: h
          }), {
            hitTest: e,
            hitTestAll: r,
            _hitTestChildren: h
          };
        }(),
        {
          _hitTest: function(e, r, h) {
            if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
              return null;
            var k = this._matrix, I = h ? h.appended(k) : this.getGlobalMatrix().prepend(this.getView()._matrix), B = Math.max(r.tolerance, 1e-12), j = r._tolerancePadding = new c(
              Q._getStrokePadding(
                B,
                k._shiftless().invert()
              )
            );
            if (e = k._inverseTransform(e), !e || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(j.multiply(2))._containsPoint(e))
              return null;
            var H = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== _.hyphenate(this._class) || r.class && !(this instanceof r.class)), X = r.match, ue = this, pe, M;
            function q(le) {
              return le && X && !X(le) && (le = null), le && r.all && r.all.push(le), le;
            }
            function K(le, m) {
              var oe = m ? pe["get" + m]() : ue.getPosition();
              if (e.subtract(oe).divide(j).length <= 1)
                return new J(le, ue, {
                  name: m ? _.hyphenate(m) : le,
                  point: oe
                });
            }
            var be = r.position, te = r.center, he = r.bounds;
            if (H && this._parent && (be || te || he)) {
              if ((te || he) && (pe = this.getInternalBounds()), M = be && K("position") || te && K("center", "Center"), !M && he)
                for (var D = [
                  "TopLeft",
                  "TopRight",
                  "BottomLeft",
                  "BottomRight",
                  "LeftCenter",
                  "TopCenter",
                  "RightCenter",
                  "BottomCenter"
                ], Se = 0; Se < 8 && !M; Se++)
                  M = K("bounds", D[Se]);
              M = q(M);
            }
            return M || (M = this._hitTestChildren(e, r, I) || H && q(this._hitTestSelf(
              e,
              r,
              I,
              this.getStrokeScaling() ? null : I._shiftless().invert()
            )) || null), M && M.point && (M.point = k.transform(M.point)), M;
          },
          _hitTestSelf: function(e, r) {
            if (r.fill && this.hasFill() && this._contains(e))
              return new J("fill", this);
          },
          matches: function(e, r) {
            function h(j, H) {
              for (var X in j)
                if (j.hasOwnProperty(X)) {
                  var ue = j[X], pe = H[X];
                  if (_.isPlainObject(ue) && _.isPlainObject(pe)) {
                    if (!h(ue, pe))
                      return !1;
                  } else if (!_.equals(ue, pe))
                    return !1;
                }
              return !0;
            }
            var k = typeof e;
            if (k === "object") {
              for (var I in e)
                if (e.hasOwnProperty(I) && !this.matches(I, e[I]))
                  return !1;
              return !0;
            } else {
              if (k === "function")
                return e(this);
              if (e === "match")
                return r(this);
              var B = /^(empty|editable)$/.test(e) ? this["is" + _.capitalize(e)]() : e === "type" ? _.hyphenate(this._class) : this[e];
              if (e === "class") {
                if (typeof r == "function")
                  return this instanceof r;
                B = this._class;
              }
              if (typeof r == "function")
                return !!r(B);
              if (r) {
                if (r.test)
                  return r.test(B);
                if (_.isPlainObject(r))
                  return h(r, B);
              }
              return _.equals(B, r);
            }
          },
          getItems: function(e) {
            return o._getItems(this, e, this._matrix);
          },
          getItem: function(e) {
            return o._getItems(this, e, this._matrix, null, !0)[0] || null;
          },
          statics: {
            _getItems: function e(r, h, k, I, B) {
              if (!I) {
                var j = typeof h == "object" && h, H = j && j.overlapping, X = j && j.inside, ue = H || X, q = ue && f.read([ue]);
                I = {
                  items: [],
                  recursive: j && j.recursive !== !1,
                  inside: !!X,
                  overlapping: !!H,
                  rect: q,
                  path: H && new Q.Rectangle({
                    rectangle: q,
                    insert: !1
                  })
                }, j && (h = _.filter({}, h, {
                  recursive: !0,
                  inside: !0,
                  overlapping: !0
                }));
              }
              var pe = r._children, M = I.items, q = I.rect;
              k = q && (k || new s());
              for (var K = 0, be = pe && pe.length; K < be; K++) {
                var te = pe[K], he = k && k.appended(te._matrix), D = !0;
                if (q) {
                  var ue = te.getBounds(he);
                  if (!q.intersects(ue))
                    continue;
                  q.contains(ue) || I.overlapping && (ue.contains(q) || I.path.intersects(te, he)) || (D = !1);
                }
                if (D && te.matches(h) && (M.push(te), B) || (I.recursive !== !1 && e(te, h, he, I, B), B && M.length > 0))
                  break;
              }
              return M;
            }
          }
        },
        {
          importJSON: function(e) {
            var r = _.importJSON(e, this);
            return r !== this ? this.addChild(r) : r;
          },
          addChild: function(e) {
            return this.insertChild(ne, e);
          },
          insertChild: function(e, r) {
            var h = r ? this.insertChildren(e, [r]) : null;
            return h && h[0];
          },
          addChildren: function(e) {
            return this.insertChildren(this._children.length, e);
          },
          insertChildren: function(e, r) {
            var h = this._children;
            if (h && r && r.length > 0) {
              r = _.slice(r);
              for (var k = {}, I = r.length - 1; I >= 0; I--) {
                var B = r[I], j = B && B._id;
                !B || k[j] ? r.splice(I, 1) : (B._remove(!1, !0), k[j] = !0);
              }
              _.splice(h, r, e, 0);
              for (var H = this._project, X = H._changes, I = 0, ue = r.length; I < ue; I++) {
                var B = r[I], pe = B._name;
                B._parent = this, B._setProject(H, !0), pe && B.setName(pe), X && B._changed(5);
              }
              this._changed(11);
            } else
              r = null;
            return r;
          },
          _insertItem: "#insertChild",
          _insertAt: function(e, r) {
            var h = e && e._getOwner(), k = e !== this && h ? this : null;
            return k && (k._remove(!1, !0), h._insertItem(e._index + r, k)), k;
          },
          insertAbove: function(e) {
            return this._insertAt(e, 1);
          },
          insertBelow: function(e) {
            return this._insertAt(e, 0);
          },
          sendToBack: function() {
            var e = this._getOwner();
            return e ? e._insertItem(0, this) : null;
          },
          bringToFront: function() {
            var e = this._getOwner();
            return e ? e._insertItem(ne, this) : null;
          },
          appendTop: "#addChild",
          appendBottom: function(e) {
            return this.insertChild(0, e);
          },
          moveAbove: "#insertAbove",
          moveBelow: "#insertBelow",
          addTo: function(e) {
            return e._insertItem(ne, this);
          },
          copyTo: function(e) {
            return this.clone(!1).addTo(e);
          },
          reduce: function(e) {
            var r = this._children;
            if (r && r.length === 1) {
              var h = r[0].reduce(e);
              return this._parent ? (h.insertAbove(this), this.remove()) : h.remove(), h;
            }
            return this;
          },
          _removeNamed: function() {
            var e = this._getOwner();
            if (e) {
              var r = e._children, h = e._namedChildren, k = this._name, I = h[k], B = I ? I.indexOf(this) : -1;
              B !== -1 && (r[k] == this && delete r[k], I.splice(B, 1), I.length ? r[k] = I[0] : delete h[k]);
            }
          },
          _remove: function(e, r) {
            var h = this._getOwner(), k = this._project, I = this._index;
            return this._style && this._style._dispose(), h ? (this._name && this._removeNamed(), I != null && (k._activeLayer === this && (k._activeLayer = this.getNextSibling() || this.getPreviousSibling()), _.splice(h._children, null, I, 1)), this._installEvents(!1), e && k._changes && this._changed(5), r && h._changed(11, this), this._parent = null, !0) : !1;
          },
          remove: function() {
            return this._remove(!0, !0);
          },
          replaceWith: function(e) {
            var r = e && e.insertBelow(this);
            return r && this.remove(), r;
          },
          removeChildren: function(e, r) {
            if (!this._children)
              return null;
            e = e || 0, r = _.pick(r, this._children.length);
            for (var h = _.splice(this._children, null, e, r - e), k = h.length - 1; k >= 0; k--)
              h[k]._remove(!0, !1);
            return h.length > 0 && this._changed(11), h;
          },
          clear: "#removeChildren",
          reverseChildren: function() {
            if (this._children) {
              this._children.reverse();
              for (var e = 0, r = this._children.length; e < r; e++)
                this._children[e]._index = e;
              this._changed(11);
            }
          },
          isEmpty: function(e) {
            var r = this._children, h = r ? r.length : 0;
            if (e) {
              for (var k = 0; k < h; k++)
                if (!r[k].isEmpty(e))
                  return !1;
              return !0;
            }
            return !h;
          },
          isEditable: function() {
            for (var e = this; e; ) {
              if (!e._visible || e._locked)
                return !1;
              e = e._parent;
            }
            return !0;
          },
          hasFill: function() {
            return this.getStyle().hasFill();
          },
          hasStroke: function() {
            return this.getStyle().hasStroke();
          },
          hasShadow: function() {
            return this.getStyle().hasShadow();
          },
          _getOrder: function(e) {
            function r(j) {
              var H = [];
              do
                H.unshift(j);
              while (j = j._parent);
              return H;
            }
            for (var h = r(this), k = r(e), I = 0, B = Math.min(h.length, k.length); I < B; I++)
              if (h[I] != k[I])
                return h[I]._index < k[I]._index ? 1 : -1;
            return 0;
          },
          hasChildren: function() {
            return this._children && this._children.length > 0;
          },
          isInserted: function() {
            return this._parent ? this._parent.isInserted() : !1;
          },
          isAbove: function(e) {
            return this._getOrder(e) === -1;
          },
          isBelow: function(e) {
            return this._getOrder(e) === 1;
          },
          isParent: function(e) {
            return this._parent === e;
          },
          isChild: function(e) {
            return e && e._parent === this;
          },
          isDescendant: function(e) {
            for (var r = this; r = r._parent; )
              if (r === e)
                return !0;
            return !1;
          },
          isAncestor: function(e) {
            return e ? e.isDescendant(this) : !1;
          },
          isSibling: function(e) {
            return this._parent === e._parent;
          },
          isGroupedWith: function(e) {
            for (var r = this._parent; r; ) {
              if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && e.isDescendant(r))
                return !0;
              r = r._parent;
            }
            return !1;
          }
        },
        _.each(["rotate", "scale", "shear", "skew"], function(e) {
          var r = e === "rotate";
          this[e] = function() {
            var h = arguments, k = (r ? _ : a).read(h), I = a.read(h, 0, { readNull: !0 });
            return this.transform(new s()[e](
              k,
              I || this.getPosition(!0)
            ));
          };
        }, {
          translate: function() {
            var e = new s();
            return this.transform(e.translate.apply(e, arguments));
          },
          transform: function(e, r, h) {
            var k = this._matrix, I = e && !e.isIdentity(), B = h && this._canApplyMatrix || this._applyMatrix && (I || !k.isIdentity() || r && this._children);
            if (!I && !B)
              return this;
            if (I) {
              !e.isInvertible() && k.isInvertible() && (k._backup = k.getValues()), k.prepend(e, !0);
              var j = this._style, H = j.getFillColor(!0), X = j.getStrokeColor(!0);
              H && H.transform(e), X && X.transform(e);
            }
            if (B && (B = this._transformContent(
              k,
              r,
              h
            ))) {
              var ue = this._pivot;
              ue && k._transformPoint(ue, ue, !0), k.reset(!0), h && this._canApplyMatrix && (this._applyMatrix = !0);
            }
            var pe = this._bounds, M = this._position;
            (I || B) && this._changed(25);
            var q = I && pe && e.decompose();
            if (q && q.skewing.isZero() && q.rotation % 90 === 0) {
              for (var K in pe) {
                var be = pe[K];
                if (be.nonscaling)
                  delete pe[K];
                else if (B || !be.internal) {
                  var te = be.rect;
                  e._transformBounds(te, te);
                }
              }
              this._bounds = pe;
              var he = pe[this._getBoundsCacheKey(
                this._boundsOptions || {}
              )];
              he && (this._position = this._getPositionFromBounds(he.rect));
            } else I && M && this._pivot && (this._position = e._transformPoint(M, M));
            return this;
          },
          _transformContent: function(e, r, h) {
            var k = this._children;
            if (k) {
              for (var I = 0, B = k.length; I < B; I++)
                k[I].transform(e, r, h);
              return !0;
            }
          },
          globalToLocal: function() {
            return this.getGlobalMatrix(!0)._inverseTransform(
              a.read(arguments)
            );
          },
          localToGlobal: function() {
            return this.getGlobalMatrix(!0)._transformPoint(
              a.read(arguments)
            );
          },
          parentToLocal: function() {
            return this._matrix._inverseTransform(a.read(arguments));
          },
          localToParent: function() {
            return this._matrix._transformPoint(a.read(arguments));
          },
          fitBounds: function(e, r) {
            e = f.read(arguments);
            var h = this.getBounds(), k = h.height / h.width, I = e.height / e.width, B = (r ? k > I : k < I) ? e.width / h.width : e.height / h.height, j = new f(
              new a(),
              new c(h.width * B, h.height * B)
            );
            j.setCenter(e.getCenter()), this.setBounds(j);
          }
        }),
        {
          _setStyles: function(e, r, h) {
            var k = this._style, I = this._matrix;
            if (k.hasFill() && (e.fillStyle = k.getFillColor().toCanvasStyle(e, I)), k.hasStroke()) {
              e.strokeStyle = k.getStrokeColor().toCanvasStyle(e, I), e.lineWidth = k.getStrokeWidth();
              var B = k.getStrokeJoin(), j = k.getStrokeCap(), H = k.getMiterLimit();
              if (B && (e.lineJoin = B), j && (e.lineCap = j), H && (e.miterLimit = H), Ae.support.nativeDash) {
                var X = k.getDashArray(), ue = k.getDashOffset();
                X && X.length && ("setLineDash" in e ? (e.setLineDash(X), e.lineDashOffset = ue) : (e.mozDash = X, e.mozDashOffset = ue));
              }
            }
            if (k.hasShadow()) {
              var pe = r.pixelRatio || 1, M = h._shiftless().prepend(
                new s().scale(pe, pe)
              ), q = M.transform(new a(k.getShadowBlur(), 0)), K = M.transform(this.getShadowOffset());
              e.shadowColor = k.getShadowColor().toCanvasStyle(e), e.shadowBlur = q.getLength(), e.shadowOffsetX = K.x, e.shadowOffsetY = K.y;
            }
          },
          draw: function(e, r, h) {
            if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
              var k = r.matrices, I = r.viewMatrix, B = this._matrix, j = k[k.length - 1].appended(B);
              if (j.isInvertible()) {
                I = I ? I.appended(j) : j, k.push(j), r.updateMatrix && (this._globalMatrix = j);
                var H = this._blendMode, X = l.clamp(this._opacity, 0, 1), ue = H === "normal", pe = ve.nativeModes[H], M = ue && X === 1 || r.dontStart || r.clip || (pe || ue && X < 1) && this._canComposite(), q = r.pixelRatio || 1, K, be, te;
                if (!M) {
                  var he = this.getStrokeBounds(I);
                  if (!he.width || !he.height) {
                    k.pop();
                    return;
                  }
                  te = r.offset, be = r.offset = he.getTopLeft().floor(), K = e, e = Ce.getContext(he.getSize().ceil().add(1).multiply(q)), q !== 1 && e.scale(q, q);
                }
                e.save();
                var D = h ? h.appended(B) : this._canScaleStroke && !this.getStrokeScaling(!0) && I, Se = !M && r.clipItem, le = !D || Se;
                if (M ? (e.globalAlpha = X, pe && (e.globalCompositeOperation = H)) : le && e.translate(-be.x, -be.y), le && (M ? B : I).applyToContext(e), Se && r.clipItem.draw(e, r.extend({ clip: !0 })), D) {
                  e.setTransform(q, 0, 0, q, 0, 0);
                  var m = r.offset;
                  m && e.translate(-m.x, -m.y);
                }
                this._draw(e, r, I, D), e.restore(), k.pop(), r.clip && !r.dontFinish && e.clip(this.getFillRule()), M || (ve.process(
                  H,
                  e,
                  K,
                  X,
                  be.subtract(te).multiply(q)
                ), Ce.release(e), r.offset = te);
              }
            }
          },
          _isUpdated: function(e) {
            var r = this._parent;
            if (r instanceof de)
              return r._isUpdated(e);
            var h = this._updateVersion === e;
            return !h && r && r._visible && r._isUpdated(e) && (this._updateVersion = e, h = !0), h;
          },
          _drawSelection: function(e, r, h, k, I) {
            var B = this._selection, j = B & 1, H = B & 2 || j && this._selectBounds, X = B & 4;
            if (this._drawSelected || (j = !1), (j || H || X) && this._isUpdated(I)) {
              var ue, pe = this.getSelectedColor(!0) || (ue = this.getLayer()) && ue.getSelectedColor(!0), M = r.appended(this.getGlobalMatrix(!0)), q = h / 2;
              if (e.strokeStyle = e.fillStyle = pe ? pe.toCanvasStyle(e) : "#009dec", j && this._drawSelected(e, M, k), X) {
                var K = this.getPosition(!0), be = this._parent, te = be ? be.localToGlobal(K) : K, he = te.x, D = te.y;
                e.beginPath(), e.arc(he, D, q, 0, Math.PI * 2, !0), e.stroke();
                for (var Se = [[0, -1], [1, 0], [0, 1], [-1, 0]], le = q, m = h + 1, oe = 0; oe < 4; oe++) {
                  var me = Se[oe], O = me[0], ce = me[1];
                  e.moveTo(he + O * le, D + ce * le), e.lineTo(he + O * m, D + ce * m), e.stroke();
                }
              }
              if (H) {
                var Oe = M._transformCorners(this.getInternalBounds());
                e.beginPath();
                for (var oe = 0; oe < 8; oe++)
                  e[oe ? "lineTo" : "moveTo"](Oe[oe], Oe[++oe]);
                e.closePath(), e.stroke();
                for (var oe = 0; oe < 8; oe++)
                  e.fillRect(
                    Oe[oe] - q,
                    Oe[++oe] - q,
                    h,
                    h
                  );
              }
            }
          },
          _canComposite: function() {
            return !1;
          }
        },
        _.each(["down", "drag", "up", "move"], function(e) {
          this["removeOn" + _.capitalize(e)] = function() {
            var r = {};
            return r[e] = !0, this.removeOn(r);
          };
        }, {
          removeOn: function(e) {
            for (var r in e)
              if (e[r]) {
                var h = "mouse" + r, k = this._project, I = k._removeSets = k._removeSets || {};
                I[h] = I[h] || {}, I[h][this._id] = this;
              }
            return this;
          }
        }),
        {
          tween: function(e, r, h) {
            h || (h = r, r = e, e = null, h || (h = r, r = null));
            var k = h && h.easing, I = h && h.start, B = h != null && (typeof h == "number" ? h : h.duration), j = new re(this, e, r, B, k, I);
            function H(X) {
              j._handleFrame(X.time * 1e3), j.running || this.off("frame", H);
            }
            return B && this.on("frame", H), j;
          },
          tweenTo: function(e, r) {
            return this.tween(null, e, r);
          },
          tweenFrom: function(e, r) {
            return this.tween(e, null, r);
          }
        }
      ), A = o.extend({
        _class: "Group",
        _selectBounds: !1,
        _selectChildren: !0,
        _serializeFields: {
          children: []
        },
        initialize: function(r) {
          this._children = [], this._namedChildren = {}, this._initialize(r) || this.addChildren(Array.isArray(r) ? r : arguments);
        },
        _changed: function e(r) {
          e.base.call(this, r), r & 2050 && (this._clipItem = ne);
        },
        _getClipItem: function() {
          var e = this._clipItem;
          if (e === ne) {
            e = null;
            for (var r = this._children, h = 0, k = r.length; h < k; h++)
              if (r[h]._clipMask) {
                e = r[h];
                break;
              }
            this._clipItem = e;
          }
          return e;
        },
        isClipped: function() {
          return !!this._getClipItem();
        },
        setClipped: function(e) {
          var r = this.getFirstChild();
          r && r.setClipMask(e);
        },
        _getBounds: function e(r, h) {
          var k = this._getClipItem();
          return k ? k._getCachedBounds(
            k._matrix.prepended(r),
            _.set({}, h, { stroke: !1 })
          ) : e.base.call(this, r, h);
        },
        _hitTestChildren: function e(r, h, k) {
          var I = this._getClipItem();
          return (!I || I.contains(r)) && e.base.call(
            this,
            r,
            h,
            k,
            I
          );
        },
        _draw: function(e, r) {
          var h = r.clip, k = !h && this._getClipItem();
          r = r.extend({ clipItem: k, clip: !1 }), h ? (e.beginPath(), r.dontStart = r.dontFinish = !0) : k && k.draw(e, r.extend({ clip: !0 }));
          for (var I = this._children, B = 0, j = I.length; B < j; B++) {
            var H = I[B];
            H !== k && H.draw(e, r);
          }
        }
      }), T = A.extend({
        _class: "Layer",
        initialize: function() {
          A.apply(this, arguments);
        },
        _getOwner: function() {
          return this._parent || this._index != null && this._project;
        },
        isInserted: function e() {
          return this._parent ? e.base.call(this) : this._index != null;
        },
        activate: function() {
          this._project._activeLayer = this;
        },
        _hitTestSelf: function() {
        }
      }), R = o.extend(
        {
          _class: "Shape",
          _applyMatrix: !1,
          _canApplyMatrix: !1,
          _canScaleStroke: !0,
          _serializeFields: {
            type: null,
            size: null,
            radius: null
          },
          initialize: function(r, h) {
            this._initialize(r, h);
          },
          _equals: function(e) {
            return this._type === e._type && this._size.equals(e._size) && _.equals(this._radius, e._radius);
          },
          copyContent: function(e) {
            this.setType(e._type), this.setSize(e._size), this.setRadius(e._radius);
          },
          getType: function() {
            return this._type;
          },
          setType: function(e) {
            this._type = e;
          },
          getShape: "#getType",
          setShape: "#setType",
          getSize: function() {
            var e = this._size;
            return new g(e.width, e.height, this, "setSize");
          },
          setSize: function() {
            var e = c.read(arguments);
            if (!this._size)
              this._size = e.clone();
            else if (!this._size.equals(e)) {
              var r = this._type, h = e.width, k = e.height;
              r === "rectangle" ? this._radius.set(c.min(this._radius, e.divide(2).abs())) : r === "circle" ? (h = k = (h + k) / 2, this._radius = h / 2) : r === "ellipse" && this._radius._set(h / 2, k / 2), this._size._set(h, k), this._changed(9);
            }
          },
          getRadius: function() {
            var e = this._radius;
            return this._type === "circle" ? e : new g(e.width, e.height, this, "setRadius");
          },
          setRadius: function(e) {
            var r = this._type;
            if (r === "circle") {
              if (e === this._radius)
                return;
              var h = e * 2;
              this._radius = e, this._size._set(h, h);
            } else if (e = c.read(arguments), !this._radius)
              this._radius = e.clone();
            else {
              if (this._radius.equals(e))
                return;
              if (this._radius.set(e), r === "rectangle") {
                var h = c.max(this._size, e.multiply(2));
                this._size.set(h);
              } else r === "ellipse" && this._size._set(e.width * 2, e.height * 2);
            }
            this._changed(9);
          },
          isEmpty: function() {
            return !1;
          },
          toPath: function(e) {
            var r = new Q[_.capitalize(this._type)]({
              center: new a(),
              size: this._size,
              radius: this._radius,
              insert: !1
            });
            return r.copyAttributes(this), Ae.settings.applyMatrix && r.setApplyMatrix(!0), (e === ne || e) && r.insertAbove(this), r;
          },
          toShape: "#clone",
          _asPathItem: function() {
            return this.toPath(!1);
          },
          _draw: function(e, r, h, k) {
            var I = this._style, B = I.hasFill(), j = I.hasStroke(), H = r.dontFinish || r.clip, X = !k;
            if (B || j || H) {
              var ue = this._type, pe = this._radius, M = ue === "circle";
              if (r.dontStart || e.beginPath(), X && M)
                e.arc(0, 0, pe, 0, Math.PI * 2, !0);
              else {
                var q = M ? pe : pe.width, K = M ? pe : pe.height, be = this._size, te = be.width, he = be.height;
                if (X && ue === "rectangle" && q === 0 && K === 0)
                  e.rect(-te / 2, -he / 2, te, he);
                else {
                  var D = te / 2, Se = he / 2, le = 1 - 0.5522847498307936, m = q * le, oe = K * le, me = [
                    -D,
                    -Se + K,
                    -D,
                    -Se + oe,
                    -D + m,
                    -Se,
                    -D + q,
                    -Se,
                    D - q,
                    -Se,
                    D - m,
                    -Se,
                    D,
                    -Se + oe,
                    D,
                    -Se + K,
                    D,
                    Se - K,
                    D,
                    Se - oe,
                    D - m,
                    Se,
                    D - q,
                    Se,
                    -D + q,
                    Se,
                    -D + m,
                    Se,
                    -D,
                    Se - oe,
                    -D,
                    Se - K
                  ];
                  k && k.transform(me, me, 32), e.moveTo(me[0], me[1]), e.bezierCurveTo(me[2], me[3], me[4], me[5], me[6], me[7]), D !== q && e.lineTo(me[8], me[9]), e.bezierCurveTo(me[10], me[11], me[12], me[13], me[14], me[15]), Se !== K && e.lineTo(me[16], me[17]), e.bezierCurveTo(me[18], me[19], me[20], me[21], me[22], me[23]), D !== q && e.lineTo(me[24], me[25]), e.bezierCurveTo(me[26], me[27], me[28], me[29], me[30], me[31]);
                }
              }
              e.closePath();
            }
            !H && (B || j) && (this._setStyles(e, r, h), B && (e.fill(I.getFillRule()), e.shadowColor = "rgba(0,0,0,0)"), j && e.stroke());
          },
          _canComposite: function() {
            return !(this.hasFill() && this.hasStroke());
          },
          _getBounds: function(e, r) {
            var h = new f(this._size).setCenter(0, 0), k = this._style, I = r.stroke && k.hasStroke() && k.getStrokeWidth();
            return e && (h = e._transformBounds(h)), I ? h.expand(Q._getStrokePadding(
              I,
              this._getStrokeMatrix(e, r)
            )) : h;
          }
        },
        new function() {
          function e(h, k, I) {
            var B = h._radius;
            if (!B.isZero())
              for (var j = h._size.divide(2), H = 1; H <= 4; H++) {
                var X = new a(H > 1 && H < 4 ? -1 : 1, H > 2 ? -1 : 1), ue = X.multiply(j), pe = ue.subtract(X.multiply(B)), M = new f(
                  I ? ue.add(X.multiply(I)) : ue,
                  pe
                );
                if (M.contains(k))
                  return { point: pe, quadrant: H };
              }
          }
          function r(h, k, I, B) {
            var j = h.divide(k);
            return (!B || j.isInQuadrant(B)) && j.subtract(j.normalize()).multiply(k).divide(I).length <= 1;
          }
          return {
            _contains: function h(k) {
              if (this._type === "rectangle") {
                var I = e(this, k);
                return I ? k.subtract(I.point).divide(this._radius).getLength() <= 1 : h.base.call(this, k);
              } else
                return k.divide(this.size).getLength() <= 0.5;
            },
            _hitTestSelf: function h(k, I, B, j) {
              var H = !1, X = this._style, ue = I.stroke && X.hasStroke(), pe = I.fill && X.hasFill();
              if (ue || pe) {
                var M = this._type, q = this._radius, K = ue ? X.getStrokeWidth() / 2 : 0, be = I._tolerancePadding.add(
                  Q._getStrokePadding(
                    K,
                    !X.getStrokeScaling() && j
                  )
                );
                if (M === "rectangle") {
                  var te = be.multiply(2), he = e(this, k, te);
                  if (he)
                    H = r(
                      k.subtract(he.point),
                      q,
                      be,
                      he.quadrant
                    );
                  else {
                    var D = new f(this._size).setCenter(0, 0), Se = D.expand(te), le = D.expand(te.negate());
                    H = Se._containsPoint(k) && !le._containsPoint(k);
                  }
                } else
                  H = r(k, q, be);
              }
              return H ? new J(ue ? "stroke" : "fill", this) : h.base.apply(this, arguments);
            }
          };
        }(),
        {
          statics: new function() {
            function e(r, h, k, I, B) {
              var j = _.create(R.prototype);
              return j._type = r, j._size = k, j._radius = I, j._initialize(_.getNamed(B), h), j;
            }
            return {
              Circle: function() {
                var r = arguments, h = a.readNamed(r, "center"), k = _.readNamed(r, "radius");
                return e(
                  "circle",
                  h,
                  new c(k * 2),
                  k,
                  r
                );
              },
              Rectangle: function() {
                var r = arguments, h = f.readNamed(r, "rectangle"), k = c.min(
                  c.readNamed(r, "radius"),
                  h.getSize(!0).divide(2)
                );
                return e(
                  "rectangle",
                  h.getCenter(!0),
                  h.getSize(!0),
                  k,
                  r
                );
              },
              Ellipse: function() {
                var r = arguments, h = R._readEllipse(r), k = h.radius;
                return e(
                  "ellipse",
                  h.center,
                  k.multiply(2),
                  k,
                  r
                );
              },
              _readEllipse: function(r) {
                var h, k;
                if (_.hasNamed(r, "radius"))
                  h = a.readNamed(r, "center"), k = c.readNamed(r, "radius");
                else {
                  var I = f.readNamed(r, "rectangle");
                  h = I.getCenter(!0), k = I.getSize(!0).divide(2);
                }
                return { center: h, radius: k };
              }
            };
          }()
        }
      ), L = o.extend({
        _class: "Raster",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !1, handle: !1 },
        _serializeFields: {
          crossOrigin: null,
          source: null
        },
        _prioritize: ["crossOrigin"],
        _smoothing: "low",
        beans: !0,
        initialize: function(r, h) {
          if (!this._initialize(
            r,
            h !== ne && a.read(arguments)
          )) {
            var k, I = typeof r, B = I === "string" ? Z.getElementById(r) : I === "object" ? r : null;
            if (B && B !== o.NO_INSERT) {
              if (B.getContext || B.naturalHeight != null)
                k = B;
              else if (B) {
                var j = c.read(arguments);
                j.isZero() || (k = Ce.getCanvas(j));
              }
            }
            k ? this.setImage(k) : this.setSource(r);
          }
          this._size || (this._size = new c(), this._loaded = !1);
        },
        _equals: function(e) {
          return this.getSource() === e.getSource();
        },
        copyContent: function(e) {
          var r = e._image, h = e._canvas;
          if (r)
            this._setImage(r);
          else if (h) {
            var k = Ce.getCanvas(e._size);
            k.getContext("2d").drawImage(h, 0, 0), this._setImage(k);
          }
          this._crossOrigin = e._crossOrigin;
        },
        getSize: function() {
          var e = this._size;
          return new g(
            e ? e.width : 0,
            e ? e.height : 0,
            this,
            "setSize"
          );
        },
        setSize: function(e, r) {
          var h = c.read(arguments);
          if (h.equals(this._size))
            r && this.clear();
          else if (h.width > 0 && h.height > 0) {
            var k = !r && this.getElement();
            this._setImage(Ce.getCanvas(h)), k && this.getContext(!0).drawImage(
              k,
              0,
              0,
              h.width,
              h.height
            );
          } else
            this._canvas && Ce.release(this._canvas), this._size = h.clone();
        },
        getWidth: function() {
          return this._size ? this._size.width : 0;
        },
        setWidth: function(e) {
          this.setSize(e, this.getHeight());
        },
        getHeight: function() {
          return this._size ? this._size.height : 0;
        },
        setHeight: function(e) {
          this.setSize(this.getWidth(), e);
        },
        getLoaded: function() {
          return this._loaded;
        },
        isEmpty: function() {
          var e = this._size;
          return !e || e.width === 0 && e.height === 0;
        },
        getResolution: function() {
          var e = this._matrix, r = new a(0, 0).transform(e), h = new a(1, 0).transform(e).subtract(r), k = new a(0, 1).transform(e).subtract(r);
          return new c(
            72 / h.getLength(),
            72 / k.getLength()
          );
        },
        getPpi: "#getResolution",
        getImage: function() {
          return this._image;
        },
        setImage: function(e) {
          var r = this;
          function h(k) {
            var I = r.getView(), B = k && k.type || "load";
            I && r.responds(B) && (Ae = I._scope, r.emit(B, new We(k)));
          }
          this._setImage(e), this._loaded ? setTimeout(h, 0) : e && He.add(e, {
            load: function(k) {
              r._setImage(e), h(k);
            },
            error: h
          });
        },
        _setImage: function(e) {
          this._canvas && Ce.release(this._canvas), e && e.getContext ? (this._image = null, this._canvas = e, this._loaded = !0) : (this._image = e, this._canvas = null, this._loaded = !!(e && e.src && e.complete)), this._size = new c(
            e ? e.naturalWidth || e.width : 0,
            e ? e.naturalHeight || e.height : 0
          ), this._context = null, this._changed(1033);
        },
        getCanvas: function() {
          if (!this._canvas) {
            var e = Ce.getContext(this._size);
            try {
              this._image && e.drawImage(this._image, 0, 0), this._canvas = e.canvas;
            } catch {
              Ce.release(e);
            }
          }
          return this._canvas;
        },
        setCanvas: "#setImage",
        getContext: function(e) {
          return this._context || (this._context = this.getCanvas().getContext("2d")), e && (this._image = null, this._changed(1025)), this._context;
        },
        setContext: function(e) {
          this._context = e;
        },
        getSource: function() {
          var e = this._image;
          return e && e.src || this.toDataURL();
        },
        setSource: function(e) {
          var r = new ge.Image(), h = this._crossOrigin;
          h && (r.crossOrigin = h), e && (r.src = e), this.setImage(r);
        },
        getCrossOrigin: function() {
          var e = this._image;
          return e && e.crossOrigin || this._crossOrigin || "";
        },
        setCrossOrigin: function(e) {
          this._crossOrigin = e;
          var r = this._image;
          r && (r.crossOrigin = e);
        },
        getSmoothing: function() {
          return this._smoothing;
        },
        setSmoothing: function(e) {
          this._smoothing = typeof e == "string" ? e : e ? "low" : "off", this._changed(257);
        },
        getElement: function() {
          return this._canvas || this._loaded && this._image;
        }
      }, {
        beans: !1,
        getSubCanvas: function() {
          var e = f.read(arguments), r = Ce.getContext(e.getSize());
          return r.drawImage(
            this.getCanvas(),
            e.x,
            e.y,
            e.width,
            e.height,
            0,
            0,
            e.width,
            e.height
          ), r.canvas;
        },
        getSubRaster: function() {
          var e = f.read(arguments), r = new L(o.NO_INSERT);
          return r._setImage(this.getSubCanvas(e)), r.translate(e.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
        },
        toDataURL: function() {
          var e = this._image, r = e && e.src;
          if (/^data:/.test(r))
            return r;
          var h = this.getCanvas();
          return h ? h.toDataURL.apply(h, arguments) : null;
        },
        drawImage: function(e) {
          var r = a.read(arguments, 1);
          this.getContext(!0).drawImage(e, r.x, r.y);
        },
        getAverageColor: function(e) {
          var r, h;
          if (e ? e instanceof W ? (h = e, r = e.getBounds()) : typeof e == "object" && ("width" in e ? r = new f(e) : "x" in e && (r = new f(e.x - 0.5, e.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
            return null;
          var k = 32, I = Math.min(r.width, k), B = Math.min(r.height, k), j = L._sampleContext;
          j ? j.clearRect(0, 0, k + 1, k + 1) : j = L._sampleContext = Ce.getContext(
            new c(k)
          ), j.save();
          var H = new s().scale(I / r.width, B / r.height).translate(-r.x, -r.y);
          H.applyToContext(j), h && h.draw(j, new _({ clip: !0, matrices: [H] })), this._matrix.applyToContext(j);
          var X = this.getElement(), ue = this._size;
          X && j.drawImage(X, -ue.width / 2, -ue.height / 2), j.restore();
          for (var pe = j.getImageData(
            0.5,
            0.5,
            Math.ceil(I),
            Math.ceil(B)
          ).data, M = [0, 0, 0], q = 0, K = 0, be = pe.length; K < be; K += 4) {
            var te = pe[K + 3];
            q += te, te /= 255, M[0] += pe[K] * te, M[1] += pe[K + 1] * te, M[2] += pe[K + 2] * te;
          }
          for (var K = 0; K < 3; K++)
            M[K] /= q;
          return q ? xe.read(M) : null;
        },
        getPixel: function() {
          var e = a.read(arguments), r = this.getContext().getImageData(e.x, e.y, 1, 1).data;
          return new xe(
            "rgb",
            [r[0] / 255, r[1] / 255, r[2] / 255],
            r[3] / 255
          );
        },
        setPixel: function() {
          var e = arguments, r = a.read(e), h = xe.read(e), k = h._convert("rgb"), I = h._alpha, B = this.getContext(!0), j = B.createImageData(1, 1), H = j.data;
          H[0] = k[0] * 255, H[1] = k[1] * 255, H[2] = k[2] * 255, H[3] = I != null ? I * 255 : 255, B.putImageData(j, r.x, r.y);
        },
        clear: function() {
          var e = this._size;
          this.getContext(!0).clearRect(0, 0, e.width + 1, e.height + 1);
        },
        createImageData: function() {
          var e = c.read(arguments);
          return this.getContext().createImageData(e.width, e.height);
        },
        getImageData: function() {
          var e = f.read(arguments);
          return e.isEmpty() && (e = new f(this._size)), this.getContext().getImageData(
            e.x,
            e.y,
            e.width,
            e.height
          );
        },
        putImageData: function(e) {
          var r = a.read(arguments, 1);
          this.getContext(!0).putImageData(e, r.x, r.y);
        },
        setImageData: function(e) {
          this.setSize(e), this.getContext(!0).putImageData(e, 0, 0);
        },
        _getBounds: function(e, r) {
          var h = new f(this._size).setCenter(0, 0);
          return e ? e._transformBounds(h) : h;
        },
        _hitTestSelf: function(e) {
          if (this._contains(e)) {
            var r = this;
            return new J("pixel", r, {
              offset: e.add(r._size.divide(2)).round(),
              color: {
                get: function() {
                  return r.getPixel(this.offset);
                }
              }
            });
          }
        },
        _draw: function(e, r, h) {
          var k = this.getElement();
          if (k && k.width > 0 && k.height > 0) {
            e.globalAlpha = l.clamp(this._opacity, 0, 1), this._setStyles(e, r, h);
            var I = this._smoothing, B = I === "off";
            Ue.setPrefixed(
              e,
              B ? "imageSmoothingEnabled" : "imageSmoothingQuality",
              B ? !1 : I
            ), e.drawImage(
              k,
              -this._size.width / 2,
              -this._size.height / 2
            );
          }
        },
        _canComposite: function() {
          return !0;
        }
      }), z = o.extend({
        _class: "SymbolItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _boundsOptions: { stroke: !0 },
        _serializeFields: {
          symbol: null
        },
        initialize: function(r, h) {
          this._initialize(
            r,
            h !== ne && a.read(arguments, 1)
          ) || this.setDefinition(r instanceof U ? r : new U(r));
        },
        _equals: function(e) {
          return this._definition === e._definition;
        },
        copyContent: function(e) {
          this.setDefinition(e._definition);
        },
        getDefinition: function() {
          return this._definition;
        },
        setDefinition: function(e) {
          this._definition = e, this._changed(9);
        },
        getSymbol: "#getDefinition",
        setSymbol: "#setDefinition",
        isEmpty: function() {
          return this._definition._item.isEmpty();
        },
        _getBounds: function(e, r) {
          var h = this._definition._item;
          return h._getCachedBounds(h._matrix.prepended(e), r);
        },
        _hitTestSelf: function(e, r, h) {
          var k = r.extend({ all: !1 }), I = this._definition._item._hitTest(e, k, h);
          return I && (I.item = this), I;
        },
        _draw: function(e, r) {
          this._definition._item.draw(e, r);
        }
      }), U = _.extend({
        _class: "SymbolDefinition",
        initialize: function(r, h) {
          this._id = u.get(), this.project = Ae.project, r && this.setItem(r, h);
        },
        _serialize: function(e, r) {
          return r.add(this, function() {
            return _.serialize(
              [this._class, this._item],
              e,
              !1,
              r
            );
          });
        },
        _changed: function(e) {
          e & 8 && o._clearBoundsCache(this), e & 1 && this.project._changed(e);
        },
        getItem: function() {
          return this._item;
        },
        setItem: function(e, r) {
          e._symbol && (e = e.clone()), this._item && (this._item._symbol = null), this._item = e, e.remove(), e.setSelected(!1), r || e.setPosition(new a()), e._symbol = this, this._changed(9);
        },
        getDefinition: "#getItem",
        setDefinition: "#setItem",
        place: function(e) {
          return new z(this, e);
        },
        clone: function() {
          return new U(this._item.clone(!1));
        },
        equals: function(e) {
          return e === this || e && this._item.equals(e._item) || !1;
        }
      }), J = _.extend({
        _class: "HitResult",
        initialize: function(r, h, k) {
          this.type = r, this.item = h, k && this.inject(k);
        },
        statics: {
          getOptions: function(e) {
            var r = e && _.read(e);
            return new _({
              type: null,
              tolerance: Ae.settings.hitTolerance,
              fill: !r,
              stroke: !r,
              segments: !r,
              handles: !1,
              ends: !1,
              position: !1,
              center: !1,
              bounds: !1,
              guides: !1,
              selected: !1
            }, r);
          }
        }
      }), F = _.extend({
        _class: "Segment",
        beans: !0,
        _selection: 0,
        initialize: function(r, h, k, I, B, j) {
          var H = arguments.length, X, ue, pe, M;
          H > 0 && (r == null || typeof r == "object" ? H === 1 && r && "point" in r ? (X = r.point, ue = r.handleIn, pe = r.handleOut, M = r.selection) : (X = r, ue = h, pe = k, M = I) : (X = [r, h], ue = k !== ne ? [k, I] : null, pe = B !== ne ? [B, j] : null)), new se(X, this, "_point"), new se(ue, this, "_handleIn"), new se(pe, this, "_handleOut"), M && this.setSelection(M);
        },
        _serialize: function(e, r) {
          var h = this._point, k = this._selection, I = k || this.hasHandles() ? [h, this._handleIn, this._handleOut] : h;
          return k && I.push(k), _.serialize(I, e, !0, r);
        },
        _changed: function(e) {
          var r = this._path;
          if (r) {
            var h = r._curves, k = this._index, I;
            h && ((!e || e === this._point || e === this._handleIn) && (I = k > 0 ? h[k - 1] : r._closed ? h[h.length - 1] : null) && I._changed(), (!e || e === this._point || e === this._handleOut) && (I = h[k]) && I._changed()), r._changed(41);
          }
        },
        getPoint: function() {
          return this._point;
        },
        setPoint: function() {
          this._point.set(a.read(arguments));
        },
        getHandleIn: function() {
          return this._handleIn;
        },
        setHandleIn: function() {
          this._handleIn.set(a.read(arguments));
        },
        getHandleOut: function() {
          return this._handleOut;
        },
        setHandleOut: function() {
          this._handleOut.set(a.read(arguments));
        },
        hasHandles: function() {
          return !this._handleIn.isZero() || !this._handleOut.isZero();
        },
        isSmooth: function() {
          var e = this._handleIn, r = this._handleOut;
          return !e.isZero() && !r.isZero() && e.isCollinear(r);
        },
        clearHandles: function() {
          this._handleIn._set(0, 0), this._handleOut._set(0, 0);
        },
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(e) {
          var r = this._selection, h = this._path;
          this._selection = e = e || 0, h && e !== r && (h._updateSelection(this, r, e), h._changed(257));
        },
        _changeSelection: function(e, r) {
          var h = this._selection;
          this.setSelection(r ? h | e : h & ~e);
        },
        isSelected: function() {
          return !!(this._selection & 7);
        },
        setSelected: function(e) {
          this._changeSelection(7, e);
        },
        getIndex: function() {
          return this._index !== ne ? this._index : null;
        },
        getPath: function() {
          return this._path || null;
        },
        getCurve: function() {
          var e = this._path, r = this._index;
          return e ? (r > 0 && !e._closed && r === e._segments.length - 1 && r--, e.getCurves()[r] || null) : null;
        },
        getLocation: function() {
          var e = this.getCurve();
          return e ? new ie(e, this === e._segment1 ? 0 : 1) : null;
        },
        getNext: function() {
          var e = this._path && this._path._segments;
          return e && (e[this._index + 1] || this._path._closed && e[0]) || null;
        },
        smooth: function(e, r, h) {
          var k = e || {}, I = k.type, B = k.factor, j = this.getPrevious(), H = this.getNext(), X = (j || this)._point, ue = this._point, pe = (H || this)._point, M = X.getDistance(ue), q = ue.getDistance(pe);
          if (!I || I === "catmull-rom") {
            var K = B === ne ? 0.5 : B, be = Math.pow(M, K), te = be * be, he = Math.pow(q, K), D = he * he;
            if (!r && j) {
              var Se = 2 * D + 3 * he * be + te, le = 3 * he * (he + be);
              this.setHandleIn(le !== 0 ? new a(
                (D * X._x + Se * ue._x - te * pe._x) / le - ue._x,
                (D * X._y + Se * ue._y - te * pe._y) / le - ue._y
              ) : new a());
            }
            if (!h && H) {
              var Se = 2 * te + 3 * be * he + D, le = 3 * be * (be + he);
              this.setHandleOut(le !== 0 ? new a(
                (te * pe._x + Se * ue._x - D * X._x) / le - ue._x,
                (te * pe._y + Se * ue._y - D * X._y) / le - ue._y
              ) : new a());
            }
          } else if (I === "geometric") {
            if (j && H) {
              var m = X.subtract(pe), oe = B === ne ? 0.4 : B, me = oe * M / (M + q);
              r || this.setHandleIn(m.multiply(me)), h || this.setHandleOut(m.multiply(me - oe));
            }
          } else
            throw new Error("Smoothing method '" + I + "' not supported.");
        },
        getPrevious: function() {
          var e = this._path && this._path._segments;
          return e && (e[this._index - 1] || this._path._closed && e[e.length - 1]) || null;
        },
        isFirst: function() {
          return !this._index;
        },
        isLast: function() {
          var e = this._path;
          return e && this._index === e._segments.length - 1 || !1;
        },
        reverse: function() {
          var e = this._handleIn, r = this._handleOut, h = e.clone();
          e.set(r), r.set(h);
        },
        reversed: function() {
          return new F(this._point, this._handleOut, this._handleIn);
        },
        remove: function() {
          return this._path ? !!this._path.removeSegment(this._index) : !1;
        },
        clone: function() {
          return new F(this._point, this._handleIn, this._handleOut);
        },
        equals: function(e) {
          return e === this || e && this._class === e._class && this._point.equals(e._point) && this._handleIn.equals(e._handleIn) && this._handleOut.equals(e._handleOut) || !1;
        },
        toString: function() {
          var e = ["point: " + this._point];
          return this._handleIn.isZero() || e.push("handleIn: " + this._handleIn), this._handleOut.isZero() || e.push("handleOut: " + this._handleOut), "{ " + e.join(", ") + " }";
        },
        transform: function(e) {
          this._transformCoordinates(e, new Array(6), !0), this._changed();
        },
        interpolate: function(e, r, h) {
          var k = 1 - h, I = h, B = e._point, j = r._point, H = e._handleIn, X = r._handleIn, ue = r._handleOut, pe = e._handleOut;
          this._point._set(
            k * B._x + I * j._x,
            k * B._y + I * j._y,
            !0
          ), this._handleIn._set(
            k * H._x + I * X._x,
            k * H._y + I * X._y,
            !0
          ), this._handleOut._set(
            k * pe._x + I * ue._x,
            k * pe._y + I * ue._y,
            !0
          ), this._changed();
        },
        _transformCoordinates: function(e, r, h) {
          var k = this._point, I = !h || !this._handleIn.isZero() ? this._handleIn : null, B = !h || !this._handleOut.isZero() ? this._handleOut : null, j = k._x, H = k._y, X = 2;
          return r[0] = j, r[1] = H, I && (r[X++] = I._x + j, r[X++] = I._y + H), B && (r[X++] = B._x + j, r[X++] = B._y + H), e && (e._transformCoordinates(r, r, X / 2), j = r[0], H = r[1], h ? (k._x = j, k._y = H, X = 2, I && (I._x = r[X++] - j, I._y = r[X++] - H), B && (B._x = r[X++] - j, B._y = r[X++] - H)) : (I || (r[X++] = j, r[X++] = H), B || (r[X++] = j, r[X++] = H))), r;
        }
      }), se = a.extend({
        initialize: function(r, h, k) {
          var I, B, j;
          if (!r)
            I = B = 0;
          else if ((I = r[0]) !== ne)
            B = r[1];
          else {
            var H = r;
            (I = H.x) === ne && (H = a.read(arguments), I = H.x), B = H.y, j = H.selected;
          }
          this._x = I, this._y = B, this._owner = h, h[k] = this, j && this.setSelected(!0);
        },
        _set: function(e, r) {
          return this._x = e, this._y = r, this._owner._changed(this), this;
        },
        getX: function() {
          return this._x;
        },
        setX: function(e) {
          this._x = e, this._owner._changed(this);
        },
        getY: function() {
          return this._y;
        },
        setY: function(e) {
          this._y = e, this._owner._changed(this);
        },
        isZero: function() {
          var e = l.isZero;
          return e(this._x) && e(this._y);
        },
        isSelected: function() {
          return !!(this._owner._selection & this._getSelection());
        },
        setSelected: function(e) {
          this._owner._changeSelection(this._getSelection(), e);
        },
        _getSelection: function() {
          var e = this._owner;
          return this === e._point ? 1 : this === e._handleIn ? 2 : this === e._handleOut ? 4 : 0;
        }
      }), ee = _.extend(
        {
          _class: "Curve",
          beans: !0,
          initialize: function(r, h, k, I, B, j, H, X) {
            var ue = arguments.length, pe, M, q, K, be, te;
            ue === 3 ? (this._path = r, pe = h, M = k) : ue ? ue === 1 ? "segment1" in r ? (pe = new F(r.segment1), M = new F(r.segment2)) : "point1" in r ? (q = r.point1, be = r.handle1, te = r.handle2, K = r.point2) : Array.isArray(r) && (q = [r[0], r[1]], K = [r[6], r[7]], be = [r[2] - r[0], r[3] - r[1]], te = [r[4] - r[6], r[5] - r[7]]) : ue === 2 ? (pe = new F(r), M = new F(h)) : ue === 4 ? (q = r, be = h, te = k, K = I) : ue === 8 && (q = [r, h], K = [H, X], be = [k - r, I - h], te = [B - H, j - X]) : (pe = new F(), M = new F()), this._segment1 = pe || new F(q, null, be), this._segment2 = M || new F(K, te, null);
          },
          _serialize: function(e, r) {
            return _.serialize(
              this.hasHandles() ? [
                this.getPoint1(),
                this.getHandle1(),
                this.getHandle2(),
                this.getPoint2()
              ] : [this.getPoint1(), this.getPoint2()],
              e,
              !0,
              r
            );
          },
          _changed: function() {
            this._length = this._bounds = ne;
          },
          clone: function() {
            return new ee(this._segment1, this._segment2);
          },
          toString: function() {
            var e = ["point1: " + this._segment1._point];
            return this._segment1._handleOut.isZero() || e.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || e.push("handle2: " + this._segment2._handleIn), e.push("point2: " + this._segment2._point), "{ " + e.join(", ") + " }";
          },
          classify: function() {
            return ee.classify(this.getValues());
          },
          remove: function() {
            var e = !1;
            if (this._path) {
              var r = this._segment2, h = r._handleOut;
              e = r.remove(), e && this._segment1._handleOut.set(h);
            }
            return e;
          },
          getPoint1: function() {
            return this._segment1._point;
          },
          setPoint1: function() {
            this._segment1._point.set(a.read(arguments));
          },
          getPoint2: function() {
            return this._segment2._point;
          },
          setPoint2: function() {
            this._segment2._point.set(a.read(arguments));
          },
          getHandle1: function() {
            return this._segment1._handleOut;
          },
          setHandle1: function() {
            this._segment1._handleOut.set(a.read(arguments));
          },
          getHandle2: function() {
            return this._segment2._handleIn;
          },
          setHandle2: function() {
            this._segment2._handleIn.set(a.read(arguments));
          },
          getSegment1: function() {
            return this._segment1;
          },
          getSegment2: function() {
            return this._segment2;
          },
          getPath: function() {
            return this._path;
          },
          getIndex: function() {
            return this._segment1._index;
          },
          getNext: function() {
            var e = this._path && this._path._curves;
            return e && (e[this._segment1._index + 1] || this._path._closed && e[0]) || null;
          },
          getPrevious: function() {
            var e = this._path && this._path._curves;
            return e && (e[this._segment1._index - 1] || this._path._closed && e[e.length - 1]) || null;
          },
          isFirst: function() {
            return !this._segment1._index;
          },
          isLast: function() {
            var e = this._path;
            return e && this._segment1._index === e._curves.length - 1 || !1;
          },
          isSelected: function() {
            return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
          },
          setSelected: function(e) {
            this.getPoint1().setSelected(e), this.getHandle1().setSelected(e), this.getHandle2().setSelected(e), this.getPoint2().setSelected(e);
          },
          getValues: function(e) {
            return ee.getValues(this._segment1, this._segment2, e);
          },
          getPoints: function() {
            for (var e = this.getValues(), r = [], h = 0; h < 8; h += 2)
              r.push(new a(e[h], e[h + 1]));
            return r;
          }
        },
        {
          getLength: function() {
            return this._length == null && (this._length = ee.getLength(this.getValues(), 0, 1)), this._length;
          },
          getArea: function() {
            return ee.getArea(this.getValues());
          },
          getLine: function() {
            return new S(this._segment1._point, this._segment2._point);
          },
          getPart: function(e, r) {
            return new ee(ee.getPart(this.getValues(), e, r));
          },
          getPartLength: function(e, r) {
            return ee.getLength(this.getValues(), e, r);
          },
          divideAt: function(e) {
            return this.divideAtTime(e && e.curve === this ? e.time : this.getTimeAt(e));
          },
          divideAtTime: function(e, r) {
            var h = 1e-8, k = 1 - h, I = null;
            if (e >= h && e <= k) {
              var B = ee.subdivide(this.getValues(), e), j = B[0], H = B[1], X = r || this.hasHandles(), ue = this._segment1, pe = this._segment2, M = this._path;
              X && (ue._handleOut._set(j[2] - j[0], j[3] - j[1]), pe._handleIn._set(H[4] - H[6], H[5] - H[7]));
              var q = j[6], K = j[7], be = new F(
                new a(q, K),
                X && new a(j[4] - q, j[5] - K),
                X && new a(H[2] - q, H[3] - K)
              );
              M ? (M.insert(ue._index + 1, be), I = this.getNext()) : (this._segment2 = be, this._changed(), I = new ee(be, pe));
            }
            return I;
          },
          splitAt: function(e) {
            var r = this._path;
            return r ? r.splitAt(e) : null;
          },
          splitAtTime: function(e) {
            return this.splitAt(this.getLocationAtTime(e));
          },
          divide: function(e, r) {
            return this.divideAtTime(e === ne ? 0.5 : r ? e : this.getTimeAt(e));
          },
          split: function(e, r) {
            return this.splitAtTime(e === ne ? 0.5 : r ? e : this.getTimeAt(e));
          },
          reversed: function() {
            return new ee(this._segment2.reversed(), this._segment1.reversed());
          },
          clearHandles: function() {
            this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
          },
          statics: {
            getValues: function(e, r, h, k) {
              var I = e._point, B = e._handleOut, j = r._handleIn, H = r._point, X = I.x, ue = I.y, pe = H.x, M = H.y, q = k ? [X, ue, X, ue, pe, M, pe, M] : [
                X,
                ue,
                X + B._x,
                ue + B._y,
                pe + j._x,
                M + j._y,
                pe,
                M
              ];
              return h && h._transformCoordinates(q, q, 4), q;
            },
            subdivide: function(e, r) {
              var h = e[0], k = e[1], I = e[2], B = e[3], j = e[4], H = e[5], X = e[6], ue = e[7];
              r === ne && (r = 0.5);
              var pe = 1 - r, M = pe * h + r * I, q = pe * k + r * B, K = pe * I + r * j, be = pe * B + r * H, te = pe * j + r * X, he = pe * H + r * ue, D = pe * M + r * K, Se = pe * q + r * be, le = pe * K + r * te, m = pe * be + r * he, oe = pe * D + r * le, me = pe * Se + r * m;
              return [
                [h, k, M, q, D, Se, oe, me],
                [oe, me, le, m, te, he, X, ue]
              ];
            },
            getMonoCurves: function(e, r) {
              var h = [], k = r ? 0 : 1, I = e[k + 0], B = e[k + 2], j = e[k + 4], H = e[k + 6];
              if (I >= B == B >= j && B >= j == j >= H || ee.isStraight(e))
                h.push(e);
              else {
                var X = 3 * (B - j) - I + H, ue = 2 * (I + j) - 4 * B, pe = B - I, M = 1e-8, q = 1 - M, K = [], be = l.solveQuadratic(X, ue, pe, K, M, q);
                if (!be)
                  h.push(e);
                else {
                  K.sort();
                  var te = K[0], he = ee.subdivide(e, te);
                  h.push(he[0]), be > 1 && (te = (K[1] - te) / (1 - te), he = ee.subdivide(he[1], te), h.push(he[0])), h.push(he[1]);
                }
              }
              return h;
            },
            solveCubic: function(e, r, h, k, I, B) {
              var j = e[r], H = e[r + 2], X = e[r + 4], ue = e[r + 6], pe = 0;
              if (!(j < h && ue < h && H < h && X < h || j > h && ue > h && H > h && X > h)) {
                var M = 3 * (H - j), q = 3 * (X - H) - M, K = ue - j - M - q;
                pe = l.solveCubic(K, q, M, j - h, k, I, B);
              }
              return pe;
            },
            getTimeOf: function(e, r) {
              var h = new a(e[0], e[1]), k = new a(e[6], e[7]), I = 1e-12, B = 1e-7, j = r.isClose(h, I) ? 0 : r.isClose(k, I) ? 1 : null;
              if (j === null)
                for (var H = [r.x, r.y], X = [], ue = 0; ue < 2; ue++)
                  for (var pe = ee.solveCubic(e, ue, H[ue], X, 0, 1), M = 0; M < pe; M++) {
                    var q = X[M];
                    if (r.isClose(ee.getPoint(e, q), B))
                      return q;
                  }
              return r.isClose(h, B) ? 0 : r.isClose(k, B) ? 1 : null;
            },
            getNearestTime: function(e, r) {
              if (ee.isStraight(e)) {
                var h = e[0], k = e[1], I = e[6], B = e[7], j = I - h, H = B - k, X = j * j + H * H;
                if (X === 0)
                  return 0;
                var ue = ((r.x - h) * j + (r.y - k) * H) / X;
                return ue < 1e-12 ? 0 : ue > 0.999999999999 ? 1 : ee.getTimeOf(
                  e,
                  new a(h + ue * j, k + ue * H)
                );
              }
              var pe = 100, M = 1 / 0, q = 0;
              function K(he) {
                if (he >= 0 && he <= 1) {
                  var D = r.getDistance(ee.getPoint(e, he), !0);
                  if (D < M)
                    return M = D, q = he, !0;
                }
              }
              for (var be = 0; be <= pe; be++)
                K(be / pe);
              for (var te = 1 / (pe * 2); te > 1e-8; )
                !K(q - te) && !K(q + te) && (te /= 2);
              return q;
            },
            getPart: function(e, r, h) {
              var k = r > h;
              if (k) {
                var I = r;
                r = h, h = I;
              }
              return r > 0 && (e = ee.subdivide(e, r)[1]), h < 1 && (e = ee.subdivide(e, (h - r) / (1 - r))[0]), k ? [e[6], e[7], e[4], e[5], e[2], e[3], e[0], e[1]] : e;
            },
            isFlatEnough: function(e, r) {
              var h = e[0], k = e[1], I = e[2], B = e[3], j = e[4], H = e[5], X = e[6], ue = e[7], pe = 3 * I - 2 * h - X, M = 3 * B - 2 * k - ue, q = 3 * j - 2 * X - h, K = 3 * H - 2 * ue - k;
              return Math.max(pe * pe, q * q) + Math.max(M * M, K * K) <= 16 * r * r;
            },
            getArea: function(e) {
              var r = e[0], h = e[1], k = e[2], I = e[3], B = e[4], j = e[5], H = e[6], X = e[7];
              return 3 * ((X - h) * (k + B) - (H - r) * (I + j) + I * (r - B) - k * (h - j) + X * (B + r / 3) - H * (j + h / 3)) / 20;
            },
            getBounds: function(e) {
              for (var r = e.slice(0, 2), h = r.slice(), k = [0, 0], I = 0; I < 2; I++)
                ee._addBounds(
                  e[I],
                  e[I + 2],
                  e[I + 4],
                  e[I + 6],
                  I,
                  0,
                  r,
                  h,
                  k
                );
              return new f(r[0], r[1], h[0] - r[0], h[1] - r[1]);
            },
            _addBounds: function(e, r, h, k, I, B, j, H, X) {
              function ue(oe, me) {
                var O = oe - me, ce = oe + me;
                O < j[I] && (j[I] = O), ce > H[I] && (H[I] = ce);
              }
              B /= 2;
              var pe = j[I] + B, M = H[I] - B;
              if (e < pe || r < pe || h < pe || k < pe || e > M || r > M || h > M || k > M)
                if (r < e != r < k && h < e != h < k)
                  ue(e, 0), ue(k, 0);
                else {
                  var q = 3 * (r - h) - e + k, K = 2 * (e + h) - 4 * r, be = r - e, te = l.solveQuadratic(q, K, be, X), he = 1e-8, D = 1 - he;
                  ue(k, 0);
                  for (var Se = 0; Se < te; Se++) {
                    var le = X[Se], m = 1 - le;
                    he <= le && le <= D && ue(
                      m * m * m * e + 3 * m * m * le * r + 3 * m * le * le * h + le * le * le * k,
                      B
                    );
                  }
                }
            }
          }
        },
        _.each(
          ["getBounds", "getStrokeBounds", "getHandleBounds"],
          function(e) {
            this[e] = function() {
              this._bounds || (this._bounds = {});
              var r = this._bounds[e];
              return r || (r = this._bounds[e] = Q[e](
                [this._segment1, this._segment2],
                !1,
                this._path
              )), r.clone();
            };
          },
          {}
        ),
        _.each({
          isStraight: function(e, r, h, k) {
            if (r.isZero() && h.isZero())
              return !0;
            var I = k.subtract(e);
            if (I.isZero())
              return !1;
            if (I.isCollinear(r) && I.isCollinear(h)) {
              var B = new S(e, k), j = 1e-7;
              if (B.getDistance(e.add(r)) < j && B.getDistance(k.add(h)) < j) {
                var H = I.dot(I), X = I.dot(r) / H, ue = I.dot(h) / H;
                return X >= 0 && X <= 1 && ue <= 0 && ue >= -1;
              }
            }
            return !1;
          },
          isLinear: function(e, r, h, k) {
            var I = k.subtract(e).divide(3);
            return r.equals(I) && h.negate().equals(I);
          }
        }, function(e, r) {
          this[r] = function(h) {
            var k = this._segment1, I = this._segment2;
            return e(
              k._point,
              k._handleOut,
              I._handleIn,
              I._point,
              h
            );
          }, this.statics[r] = function(h, k) {
            var I = h[0], B = h[1], j = h[6], H = h[7];
            return e(
              new a(I, B),
              new a(h[2] - I, h[3] - B),
              new a(h[4] - j, h[5] - H),
              new a(j, H),
              k
            );
          };
        }, {
          statics: {},
          hasHandles: function() {
            return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
          },
          hasLength: function(e) {
            return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (e || 0);
          },
          isCollinear: function(e) {
            return e && this.isStraight() && e.isStraight() && this.getLine().isCollinear(e.getLine());
          },
          isHorizontal: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
          },
          isVertical: function() {
            return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
          }
        }),
        {
          beans: !1,
          getLocationAt: function(e, r) {
            return this.getLocationAtTime(
              r ? e : this.getTimeAt(e)
            );
          },
          getLocationAtTime: function(e) {
            return e != null && e >= 0 && e <= 1 ? new ie(this, e) : null;
          },
          getTimeAt: function(e, r) {
            return ee.getTimeAt(this.getValues(), e, r);
          },
          getParameterAt: "#getTimeAt",
          getTimesWithTangent: function() {
            var e = a.read(arguments);
            return e.isZero() ? [] : ee.getTimesWithTangent(this.getValues(), e);
          },
          getOffsetAtTime: function(e) {
            return this.getPartLength(0, e);
          },
          getLocationOf: function() {
            return this.getLocationAtTime(this.getTimeOf(a.read(arguments)));
          },
          getOffsetOf: function() {
            var e = this.getLocationOf.apply(this, arguments);
            return e ? e.getOffset() : null;
          },
          getTimeOf: function() {
            return ee.getTimeOf(this.getValues(), a.read(arguments));
          },
          getParameterOf: "#getTimeOf",
          getNearestLocation: function() {
            var e = a.read(arguments), r = this.getValues(), h = ee.getNearestTime(r, e), k = ee.getPoint(r, h);
            return new ie(this, h, k, null, e.getDistance(k));
          },
          getNearestPoint: function() {
            var e = this.getNearestLocation.apply(this, arguments);
            return e && e.getPoint();
          }
        },
        new function() {
          var e = [
            "getPoint",
            "getTangent",
            "getNormal",
            "getWeightedTangent",
            "getWeightedNormal",
            "getCurvature"
          ];
          return _.each(
            e,
            function(r) {
              this[r + "At"] = function(h, k) {
                var I = this.getValues();
                return ee[r](I, k ? h : ee.getTimeAt(I, h));
              }, this[r + "AtTime"] = function(h) {
                return ee[r](this.getValues(), h);
              };
            },
            {
              statics: {
                _evaluateMethods: e
              }
            }
          );
        }(),
        new function() {
          function e(k) {
            var I = k[0], B = k[1], j = k[2], H = k[3], X = k[4], ue = k[5], pe = k[6], M = k[7], q = 9 * (j - X) + 3 * (pe - I), K = 6 * (I + X) - 12 * j, be = 3 * (j - I), te = 9 * (H - ue) + 3 * (M - B), he = 6 * (B + ue) - 12 * H, D = 3 * (H - B);
            return function(Se) {
              var le = (q * Se + K) * Se + be, m = (te * Se + he) * Se + D;
              return Math.sqrt(le * le + m * m);
            };
          }
          function r(k, I) {
            return Math.max(2, Math.min(16, Math.ceil(Math.abs(I - k) * 32)));
          }
          function h(k, I, B, j) {
            if (I == null || I < 0 || I > 1)
              return null;
            var H = k[0], X = k[1], ue = k[2], pe = k[3], M = k[4], q = k[5], K = k[6], be = k[7], te = l.isZero;
            te(ue - H) && te(pe - X) && (ue = H, pe = X), te(M - K) && te(q - be) && (M = K, q = be);
            var he = 3 * (ue - H), D = 3 * (M - ue) - he, Se = K - H - he - D, le = 3 * (pe - X), m = 3 * (q - pe) - le, oe = be - X - le - m, me, O;
            if (B === 0)
              me = I === 0 ? H : I === 1 ? K : ((Se * I + D) * I + he) * I + H, O = I === 0 ? X : I === 1 ? be : ((oe * I + m) * I + le) * I + X;
            else {
              var ce = 1e-8, Oe = 1 - ce;
              if (I < ce ? (me = he, O = le) : I > Oe ? (me = 3 * (K - M), O = 3 * (be - q)) : (me = (3 * Se * I + 2 * D) * I + he, O = (3 * oe * I + 2 * m) * I + le), j) {
                me === 0 && O === 0 && (I < ce || I > Oe) && (me = M - ue, O = q - pe);
                var Be = Math.sqrt(me * me + O * O);
                Be && (me /= Be, O /= Be);
              }
              if (B === 3) {
                var M = 6 * Se * I + 2 * D, q = 6 * oe * I + 2 * m, Ge = Math.pow(me * me + O * O, 3 / 2);
                me = Ge !== 0 ? (me * q - O * M) / Ge : 0, O = 0;
              }
            }
            return B === 2 ? new a(O, -me) : new a(me, O);
          }
          return { statics: {
            classify: function(k) {
              var I = k[0], B = k[1], j = k[2], H = k[3], X = k[4], ue = k[5], pe = k[6], M = k[7], q = I * (M - ue) + B * (X - pe) + pe * ue - M * X, K = j * (B - M) + H * (pe - I) + I * M - B * pe, be = X * (H - B) + ue * (I - j) + j * B - H * I, te = 3 * be, he = te - K, D = he - K + q, Se = Math.sqrt(D * D + he * he + te * te), le = Se !== 0 ? 1 / Se : 0, m = l.isZero, oe = "serpentine";
              D *= le, he *= le, te *= le;
              function me(Be, Ge, Fe) {
                var Ye = Ge !== ne, Ke = Ye && Ge > 0 && Ge < 1, et = Ye && Fe > 0 && Fe < 1;
                return Ye && (!(Ke || et) || Be === "loop" && !(Ke && et)) && (Be = "arch", Ke = et = !1), {
                  type: Be,
                  roots: Ke || et ? Ke && et ? Ge < Fe ? [Ge, Fe] : [Fe, Ge] : [Ke ? Ge : Fe] : null
                };
              }
              if (m(D))
                return m(he) ? me(m(te) ? "line" : "quadratic") : me(oe, te / (3 * he));
              var O = 3 * he * he - 4 * D * te;
              if (m(O))
                return me("cusp", he / (2 * D));
              var ce = O > 0 ? Math.sqrt(O / 3) : Math.sqrt(-O), Oe = 2 * D;
              return me(
                O > 0 ? oe : "loop",
                (he + ce) / Oe,
                (he - ce) / Oe
              );
            },
            getLength: function(k, I, B, j) {
              if (I === ne && (I = 0), B === ne && (B = 1), ee.isStraight(k)) {
                var H = k;
                B < 1 && (H = ee.subdivide(H, B)[0], I /= B), I > 0 && (H = ee.subdivide(H, I)[1]);
                var X = H[6] - H[0], ue = H[7] - H[1];
                return Math.sqrt(X * X + ue * ue);
              }
              return l.integrate(
                j || e(k),
                I,
                B,
                r(I, B)
              );
            },
            getTimeAt: function(k, I, B) {
              if (B === ne && (B = I < 0 ? 1 : 0), I === 0)
                return B;
              var j = Math.abs, H = 1e-12, X = I > 0, ue = X ? B : 0, pe = X ? 1 : B, M = e(k), q = ee.getLength(k, ue, pe, M), K = j(I) - q;
              if (j(K) < H)
                return X ? pe : ue;
              if (K > H)
                return null;
              var be = I / q, te = 0;
              function he(D) {
                return te += l.integrate(
                  M,
                  B,
                  D,
                  r(B, D)
                ), B = D, te - I;
              }
              return l.findRoot(
                he,
                M,
                B + be,
                ue,
                pe,
                32,
                1e-12
              );
            },
            getPoint: function(k, I) {
              return h(k, I, 0, !1);
            },
            getTangent: function(k, I) {
              return h(k, I, 1, !0);
            },
            getWeightedTangent: function(k, I) {
              return h(k, I, 1, !1);
            },
            getNormal: function(k, I) {
              return h(k, I, 2, !0);
            },
            getWeightedNormal: function(k, I) {
              return h(k, I, 2, !1);
            },
            getCurvature: function(k, I) {
              return h(k, I, 3, !1).x;
            },
            getPeaks: function(k) {
              var I = k[0], B = k[1], j = k[2], H = k[3], X = k[4], ue = k[5], pe = k[6], M = k[7], q = -I + 3 * j - 3 * X + pe, K = 3 * I - 6 * j + 3 * X, be = -3 * I + 3 * j, te = -B + 3 * H - 3 * ue + M, he = 3 * B - 6 * H + 3 * ue, D = -3 * B + 3 * H, Se = 1e-8, le = 1 - Se, m = [];
              return l.solveCubic(
                9 * (q * q + te * te),
                9 * (q * K + he * te),
                2 * (K * K + he * he) + 3 * (be * q + D * te),
                be * K + he * D,
                m,
                Se,
                le
              ), m.sort();
            }
          } };
        }(),
        new function() {
          function e(K, be, te, he, D, Se, le) {
            var m = !le && te.getPrevious() === D, oe = !le && te !== D && te.getNext() === D, me = 1e-8, O = 1 - me;
            if (he !== null && he >= (m ? me : 0) && he <= (oe ? O : 1) && Se !== null && Se >= (oe ? me : 0) && Se <= (m ? O : 1)) {
              var ce = new ie(te, he, null, le), Oe = new ie(D, Se, null, le);
              ce._intersection = Oe, Oe._intersection = ce, (!be || be(ce)) && ie.insert(K, ce, !0);
            }
          }
          function r(K, be, te, he, D, Se, le, m, oe, me, O, ce, Oe) {
            if (++oe >= 4096 || ++m >= 40)
              return oe;
            var Be = 1e-9, Ge = be[0], Fe = be[1], Ye = be[6], Ke = be[7], et = S.getSignedDistance, Je = et(Ge, Fe, Ye, Ke, be[2], be[3]), nt = et(Ge, Fe, Ye, Ke, be[4], be[5]), pt = Je * nt > 0 ? 3 / 4 : 4 / 9, vt = pt * Math.min(0, Je, nt), bt = pt * Math.max(0, Je, nt), At = et(Ge, Fe, Ye, Ke, K[0], K[1]), ot = et(Ge, Fe, Ye, Ke, K[2], K[3]), ct = et(Ge, Fe, Ye, Ke, K[4], K[5]), gt = et(Ge, Fe, Ye, Ke, K[6], K[7]), Ct = h(At, ot, ct, gt), xt = Ct[0], Ot = Ct[1], Nt, Pt;
            if (Je === 0 && nt === 0 && At === 0 && ot === 0 && ct === 0 && gt === 0 || (Nt = k(xt, Ot, vt, bt)) == null || (Pt = k(
              xt.reverse(),
              Ot.reverse(),
              vt,
              bt
            )) == null)
              return oe;
            var Gt = me + (O - me) * Nt, Bt = me + (O - me) * Pt;
            if (Math.max(Oe - ce, Bt - Gt) < Be) {
              var or = (Gt + Bt) / 2, ar = (ce + Oe) / 2;
              e(
                D,
                Se,
                le ? he : te,
                le ? ar : or,
                le ? te : he,
                le ? or : ar
              );
            } else {
              K = ee.getPart(K, Nt, Pt);
              var ur = Oe - ce;
              if (Pt - Nt > 0.8)
                if (Bt - Gt > ur) {
                  var hr = ee.subdivide(K, 0.5), or = (Gt + Bt) / 2;
                  oe = r(
                    be,
                    hr[0],
                    he,
                    te,
                    D,
                    Se,
                    !le,
                    m,
                    oe,
                    ce,
                    Oe,
                    Gt,
                    or
                  ), oe = r(
                    be,
                    hr[1],
                    he,
                    te,
                    D,
                    Se,
                    !le,
                    m,
                    oe,
                    ce,
                    Oe,
                    or,
                    Bt
                  );
                } else {
                  var hr = ee.subdivide(be, 0.5), ar = (ce + Oe) / 2;
                  oe = r(
                    hr[0],
                    K,
                    he,
                    te,
                    D,
                    Se,
                    !le,
                    m,
                    oe,
                    ce,
                    ar,
                    Gt,
                    Bt
                  ), oe = r(
                    hr[1],
                    K,
                    he,
                    te,
                    D,
                    Se,
                    !le,
                    m,
                    oe,
                    ar,
                    Oe,
                    Gt,
                    Bt
                  );
                }
              else
                ur === 0 || ur >= Be ? oe = r(
                  be,
                  K,
                  he,
                  te,
                  D,
                  Se,
                  !le,
                  m,
                  oe,
                  ce,
                  Oe,
                  Gt,
                  Bt
                ) : oe = r(
                  K,
                  be,
                  te,
                  he,
                  D,
                  Se,
                  le,
                  m,
                  oe,
                  Gt,
                  Bt,
                  ce,
                  Oe
                );
            }
            return oe;
          }
          function h(K, be, te, he) {
            var D = [0, K], Se = [1 / 3, be], le = [2 / 3, te], m = [1, he], oe = be - (2 * K + he) / 3, me = te - (K + 2 * he) / 3, O;
            if (oe * me < 0)
              O = [[D, Se, m], [D, le, m]];
            else {
              var ce = oe / me;
              O = [
                ce >= 2 ? [D, Se, m] : ce <= 0.5 ? [D, le, m] : [D, Se, le, m],
                [D, m]
              ];
            }
            return (oe || me) < 0 ? O.reverse() : O;
          }
          function k(K, be, te, he) {
            return K[0][1] < te ? I(K, !0, te) : be[0][1] > he ? I(be, !1, he) : K[0][0];
          }
          function I(K, be, te) {
            for (var he = K[0][0], D = K[0][1], Se = 1, le = K.length; Se < le; Se++) {
              var m = K[Se][0], oe = K[Se][1];
              if (be ? oe >= te : oe <= te)
                return oe === te ? m : he + (te - D) * (m - he) / (oe - D);
              he = m, D = oe;
            }
            return null;
          }
          function B(K, be, te, he, D) {
            var Se = l.isZero;
            if (Se(he) && Se(D)) {
              var le = ee.getTimeOf(K, new a(be, te));
              return le === null ? [] : [le];
            }
            for (var m = Math.atan2(-D, he), oe = Math.sin(m), me = Math.cos(m), O = [], ce = [], Oe = 0; Oe < 8; Oe += 2) {
              var Be = K[Oe] - be, Ge = K[Oe + 1] - te;
              O.push(
                Be * me - Ge * oe,
                Be * oe + Ge * me
              );
            }
            return ee.solveCubic(O, 1, 0, ce, 0, 1), ce;
          }
          function j(K, be, te, he, D, Se, le) {
            for (var m = be[0], oe = be[1], me = be[6], O = be[7], ce = B(K, m, oe, me - m, O - oe), Oe = 0, Be = ce.length; Oe < Be; Oe++) {
              var Ge = ce[Oe], Fe = ee.getPoint(K, Ge), Ye = ee.getTimeOf(be, Fe);
              Ye !== null && e(
                D,
                Se,
                le ? he : te,
                le ? Ye : Ge,
                le ? te : he,
                le ? Ge : Ye
              );
            }
          }
          function H(K, be, te, he, D, Se) {
            var le = S.intersect(
              K[0],
              K[1],
              K[6],
              K[7],
              be[0],
              be[1],
              be[6],
              be[7]
            );
            le && e(
              D,
              Se,
              te,
              ee.getTimeOf(K, le),
              he,
              ee.getTimeOf(be, le)
            );
          }
          function X(K, be, te, he, D, Se) {
            var le = 1e-12, m = Math.min, oe = Math.max;
            if (oe(K[0], K[2], K[4], K[6]) + le > m(be[0], be[2], be[4], be[6]) && m(K[0], K[2], K[4], K[6]) - le < oe(be[0], be[2], be[4], be[6]) && oe(K[1], K[3], K[5], K[7]) + le > m(be[1], be[3], be[5], be[7]) && m(K[1], K[3], K[5], K[7]) - le < oe(be[1], be[3], be[5], be[7])) {
              var me = M(K, be);
              if (me)
                for (var O = 0; O < 2; O++) {
                  var ce = me[O];
                  e(
                    D,
                    Se,
                    te,
                    ce[0],
                    he,
                    ce[1],
                    !0
                  );
                }
              else {
                var Oe = ee.isStraight(K), Be = ee.isStraight(be), Ge = Oe && Be, Fe = Oe && !Be, Ye = D.length;
                if ((Ge ? H : Oe || Be ? j : r)(
                  Fe ? be : K,
                  Fe ? K : be,
                  Fe ? he : te,
                  Fe ? te : he,
                  D,
                  Se,
                  Fe,
                  0,
                  0,
                  0,
                  1,
                  0,
                  1
                ), !Ge || D.length === Ye)
                  for (var O = 0; O < 4; O++) {
                    var Ke = O >> 1, et = O & 1, Je = Ke * 6, nt = et * 6, pt = new a(K[Je], K[Je + 1]), vt = new a(be[nt], be[nt + 1]);
                    pt.isClose(vt, le) && e(
                      D,
                      Se,
                      te,
                      Ke,
                      he,
                      et
                    );
                  }
              }
            }
            return D;
          }
          function ue(K, be, te, he) {
            var D = ee.classify(K);
            if (D.type === "loop") {
              var Se = D.roots;
              e(
                te,
                he,
                be,
                Se[0],
                be,
                Se[1]
              );
            }
            return te;
          }
          function pe(K, be, te, he, D, Se) {
            var le = 1e-7, m = !be;
            m && (be = K);
            for (var oe = K.length, me = be.length, O = new Array(oe), ce = m ? O : new Array(me), Oe = [], Be = 0; Be < oe; Be++)
              O[Be] = K[Be].getValues(he);
            if (!m)
              for (var Be = 0; Be < me; Be++)
                ce[Be] = be[Be].getValues(D);
            for (var Ge = E.findCurveBoundsCollisions(
              O,
              ce,
              le
            ), Fe = 0; Fe < oe; Fe++) {
              var Ye = K[Fe], Ke = O[Fe];
              m && ue(Ke, Ye, Oe, te);
              var et = Ge[Fe];
              if (et)
                for (var Je = 0; Je < et.length; Je++) {
                  if (Se && Oe.length)
                    return Oe;
                  var nt = et[Je];
                  if (!m || nt > Fe) {
                    var pt = be[nt], vt = ce[nt];
                    X(
                      Ke,
                      vt,
                      Ye,
                      pt,
                      Oe,
                      te
                    );
                  }
                }
            }
            return Oe;
          }
          function M(K, be) {
            function te(gt) {
              var Ct = gt[6] - gt[0], xt = gt[7] - gt[1];
              return Ct * Ct + xt * xt;
            }
            var he = Math.abs, D = S.getDistance, Se = 1e-8, le = 1e-7, m = ee.isStraight(K), oe = ee.isStraight(be), me = m && oe, O = te(K) < te(be), ce = O ? be : K, Oe = O ? K : be, Be = ce[0], Ge = ce[1], Fe = ce[6] - Be, Ye = ce[7] - Ge;
            if (D(Be, Ge, Fe, Ye, Oe[0], Oe[1], !0) < le && D(Be, Ge, Fe, Ye, Oe[6], Oe[7], !0) < le)
              !me && D(Be, Ge, Fe, Ye, ce[2], ce[3], !0) < le && D(Be, Ge, Fe, Ye, ce[4], ce[5], !0) < le && D(Be, Ge, Fe, Ye, Oe[2], Oe[3], !0) < le && D(Be, Ge, Fe, Ye, Oe[4], Oe[5], !0) < le && (m = oe = me = !0);
            else if (me)
              return null;
            if (m ^ oe)
              return null;
            for (var Ke = [K, be], et = [], Je = 0; Je < 4 && et.length < 2; Je++) {
              var nt = Je & 1, pt = nt ^ 1, vt = Je >> 1, bt = ee.getTimeOf(Ke[nt], new a(
                Ke[pt][vt ? 6 : 0],
                Ke[pt][vt ? 7 : 1]
              ));
              if (bt != null) {
                var At = nt ? [vt, bt] : [bt, vt];
                (!et.length || he(At[0] - et[0][0]) > Se && he(At[1] - et[0][1]) > Se) && et.push(At);
              }
              if (Je > 2 && !et.length)
                break;
            }
            if (et.length !== 2)
              et = null;
            else if (!me) {
              var ot = ee.getPart(K, et[0][0], et[1][0]), ct = ee.getPart(be, et[0][1], et[1][1]);
              (he(ct[2] - ot[2]) > le || he(ct[3] - ot[3]) > le || he(ct[4] - ot[4]) > le || he(ct[5] - ot[5]) > le) && (et = null);
            }
            return et;
          }
          function q(K, be) {
            var te = K[0], he = K[1], D = K[2], Se = K[3], le = K[4], m = K[5], oe = K[6], me = K[7], O = be.normalize(), ce = O.x, Oe = O.y, Be = 3 * oe - 9 * le + 9 * D - 3 * te, Ge = 3 * me - 9 * m + 9 * Se - 3 * he, Fe = 6 * le - 12 * D + 6 * te, Ye = 6 * m - 12 * Se + 6 * he, Ke = 3 * D - 3 * te, et = 3 * Se - 3 * he, Je = 2 * Be * Oe - 2 * Ge * ce, nt = [];
            if (Math.abs(Je) < l.CURVETIME_EPSILON) {
              var pt = Be * et - Ge * Ke, Je = Be * Ye - Ge * Fe;
              if (Je != 0) {
                var vt = -pt / Je;
                vt >= 0 && vt <= 1 && nt.push(vt);
              }
            } else {
              var bt = (Fe * Fe - 4 * Be * Ke) * Oe * Oe + (-2 * Fe * Ye + 4 * Ge * Ke + 4 * Be * et) * ce * Oe + (Ye * Ye - 4 * Ge * et) * ce * ce, At = Fe * Oe - Ye * ce;
              if (bt >= 0 && Je != 0) {
                var ot = Math.sqrt(bt), ct = -(At + ot) / Je, gt = (-At + ot) / Je;
                ct >= 0 && ct <= 1 && nt.push(ct), gt >= 0 && gt <= 1 && nt.push(gt);
              }
            }
            return nt;
          }
          return {
            getIntersections: function(K) {
              var be = this.getValues(), te = K && K !== this && K.getValues();
              return te ? X(be, te, this, K, []) : ue(be, this, []);
            },
            statics: {
              getOverlaps: M,
              getIntersections: pe,
              getCurveLineIntersections: B,
              getTimesWithTangent: q
            }
          };
        }()
      ), ie = _.extend(
        {
          _class: "CurveLocation",
          initialize: function(r, h, k, I, B) {
            if (h >= 0.99999999) {
              var j = r.getNext();
              j && (h = 0, r = j);
            }
            this._setCurve(r), this._time = h, this._point = k || r.getPointAtTime(h), this._overlap = I, this._distance = B, this._intersection = this._next = this._previous = null;
          },
          _setPath: function(e) {
            this._path = e, this._version = e ? e._version : 0;
          },
          _setCurve: function(e) {
            this._setPath(e._path), this._curve = e, this._segment = null, this._segment1 = e._segment1, this._segment2 = e._segment2;
          },
          _setSegment: function(e) {
            var r = e.getCurve();
            r ? this._setCurve(r) : (this._setPath(e._path), this._segment1 = e, this._segment2 = null), this._segment = e, this._time = e === this._segment1 ? 0 : 1, this._point = e._point.clone();
          },
          getSegment: function() {
            var e = this._segment;
            if (!e) {
              var r = this.getCurve(), h = this.getTime();
              h === 0 ? e = r._segment1 : h === 1 ? e = r._segment2 : h != null && (e = r.getPartLength(0, h) < r.getPartLength(h, 1) ? r._segment1 : r._segment2), this._segment = e;
            }
            return e;
          },
          getCurve: function() {
            var e = this._path, r = this;
            e && e._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
            function h(k) {
              var I = k && k.getCurve();
              if (I && (r._time = I.getTimeOf(r._point)) != null)
                return r._setCurve(I), I;
            }
            return this._curve || h(this._segment) || h(this._segment1) || h(this._segment2.getPrevious());
          },
          getPath: function() {
            var e = this.getCurve();
            return e && e._path;
          },
          getIndex: function() {
            var e = this.getCurve();
            return e && e.getIndex();
          },
          getTime: function() {
            var e = this.getCurve(), r = this._time;
            return e && r == null ? this._time = e.getTimeOf(this._point) : r;
          },
          getParameter: "#getTime",
          getPoint: function() {
            return this._point;
          },
          getOffset: function() {
            var e = this._offset;
            if (e == null) {
              e = 0;
              var r = this.getPath(), h = this.getIndex();
              if (r && h != null)
                for (var k = r.getCurves(), I = 0; I < h; I++)
                  e += k[I].getLength();
              this._offset = e += this.getCurveOffset();
            }
            return e;
          },
          getCurveOffset: function() {
            var e = this._curveOffset;
            if (e == null) {
              var r = this.getCurve(), h = this.getTime();
              this._curveOffset = e = h != null && r && r.getPartLength(0, h);
            }
            return e;
          },
          getIntersection: function() {
            return this._intersection;
          },
          getDistance: function() {
            return this._distance;
          },
          divide: function() {
            var e = this.getCurve(), r = e && e.divideAtTime(this.getTime());
            return r && this._setSegment(r._segment1), r;
          },
          split: function() {
            var e = this.getCurve(), r = e._path, h = e && e.splitAtTime(this.getTime());
            return h && this._setSegment(r.getLastSegment()), h;
          },
          equals: function(e, r) {
            var h = this === e;
            if (!h && e instanceof ie) {
              var k = this.getCurve(), I = e.getCurve(), B = k._path, j = I._path;
              if (B === j) {
                var H = Math.abs, X = 1e-7, ue = H(this.getOffset() - e.getOffset()), pe = !r && this._intersection, M = !r && e._intersection;
                h = (ue < X || B && H(B.getLength() - ue) < X) && (!pe && !M || pe && M && pe.equals(M, !0));
              }
            }
            return h;
          },
          toString: function() {
            var e = [], r = this.getPoint(), h = d.instance;
            r && e.push("point: " + r);
            var k = this.getIndex();
            k != null && e.push("index: " + k);
            var I = this.getTime();
            return I != null && e.push("time: " + h.number(I)), this._distance != null && e.push("distance: " + h.number(this._distance)), "{ " + e.join(", ") + " }";
          },
          isTouching: function() {
            var e = this._intersection;
            if (e && this.getTangent().isCollinear(e.getTangent())) {
              var r = this.getCurve(), h = e.getCurve();
              return !(r.isStraight() && h.isStraight() && r.getLine().intersect(h.getLine()));
            }
            return !1;
          },
          isCrossing: function() {
            var e = this._intersection;
            if (!e)
              return !1;
            var r = this.getTime(), h = e.getTime(), k = 1e-8, I = 1 - k, B = r >= k && r <= I, j = h >= k && h <= I;
            if (B && j)
              return !this.isTouching();
            var H = this.getCurve(), X = H && r < k ? H.getPrevious() : H, ue = e.getCurve(), pe = ue && h < k ? ue.getPrevious() : ue;
            if (r > I && (H = H.getNext()), h > I && (ue = ue.getNext()), !X || !H || !pe || !ue)
              return !1;
            var M = [];
            function q(ce, Oe) {
              var Be = ce.getValues(), Ge = ee.classify(Be).roots || ee.getPeaks(Be), Fe = Ge.length, Ye = ee.getLength(
                Be,
                Oe && Fe ? Ge[Fe - 1] : 0,
                !Oe && Fe ? Ge[0] : 1
              );
              M.push(Fe ? Ye : Ye / 32);
            }
            function K(ce, Oe, Be) {
              return Oe < Be ? ce > Oe && ce < Be : ce > Oe || ce < Be;
            }
            B || (q(X, !0), q(H, !1)), j || (q(pe, !0), q(ue, !1));
            var be = this.getPoint(), te = Math.min.apply(Math, M), he = B ? H.getTangentAtTime(r) : H.getPointAt(te).subtract(be), D = B ? he.negate() : X.getPointAt(-te).subtract(be), Se = j ? ue.getTangentAtTime(h) : ue.getPointAt(te).subtract(be), le = j ? Se.negate() : pe.getPointAt(-te).subtract(be), m = D.getAngle(), oe = he.getAngle(), me = le.getAngle(), O = Se.getAngle();
            return !!(B ? K(m, me, O) ^ K(oe, me, O) && K(m, O, me) ^ K(oe, O, me) : K(me, m, oe) ^ K(O, m, oe) && K(me, oe, m) ^ K(O, oe, m));
          },
          hasOverlap: function() {
            return !!this._overlap;
          }
        },
        _.each(ee._evaluateMethods, function(e) {
          var r = e + "At";
          this[e] = function() {
            var h = this.getCurve(), k = this.getTime();
            return k != null && h && h[r](k, !0);
          };
        }, {
          preserve: !0
        }),
        new function() {
          function e(r, h, k) {
            var I = r.length, B = 0, j = I - 1;
            function H(be, te) {
              for (var he = be + te; he >= -1 && he <= I; he += te) {
                var D = r[(he % I + I) % I];
                if (!h.getPoint().isClose(
                  D.getPoint(),
                  1e-7
                ))
                  break;
                if (h.equals(D))
                  return D;
              }
              return null;
            }
            for (; B <= j; ) {
              var X = B + j >>> 1, ue = r[X], pe;
              if (k && (pe = h.equals(ue) ? ue : H(X, -1) || H(X, 1)))
                return h._overlap && (pe._overlap = pe._intersection._overlap = !0), pe;
              var M = h.getPath(), q = ue.getPath(), K = M !== q ? M._id - q._id : h.getIndex() + h.getTime() - (ue.getIndex() + ue.getTime());
              K < 0 ? j = X - 1 : B = X + 1;
            }
            return r.splice(B, 0, h), h;
          }
          return { statics: {
            insert: e,
            expand: function(r) {
              for (var h = r.slice(), k = r.length - 1; k >= 0; k--)
                e(h, r[k]._intersection, !1);
              return h;
            }
          } };
        }()
      ), W = o.extend({
        _class: "PathItem",
        _selectBounds: !1,
        _canScaleStroke: !0,
        beans: !0,
        initialize: function() {
        },
        statics: {
          create: function(e) {
            var r, h, k;
            if (_.isPlainObject(e) ? (h = e.segments, r = e.pathData) : Array.isArray(e) ? h = e : typeof e == "string" && (r = e), h) {
              var I = h[0];
              k = I && Array.isArray(I[0]);
            } else r && (k = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
            var B = k ? de : Q;
            return new B(e);
          }
        },
        _asPathItem: function() {
          return this;
        },
        isClockwise: function() {
          return this.getArea() >= 0;
        },
        setClockwise: function(e) {
          this.isClockwise() != (e = !!e) && this.reverse();
        },
        setPathData: function(e) {
          var r = e && e.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), h, k = !1, I, B, j = new a(), H = new a();
          function X(le, m) {
            var oe = +h[le];
            return k && (oe += j[m]), oe;
          }
          function ue(le) {
            return new a(
              X(le, "x"),
              X(le + 1, "y")
            );
          }
          this.clear();
          for (var pe = 0, M = r && r.length; pe < M; pe++) {
            var q = r[pe], K = q[0], be = K.toLowerCase();
            h = q.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
            var te = h && h.length;
            switch (k = K === be, I === "z" && !/[mz]/.test(be) && this.moveTo(j), be) {
              case "m":
              case "l":
                for (var he = be === "m", D = 0; D < te; D += 2)
                  this[he ? "moveTo" : "lineTo"](j = ue(D)), he && (H = j, he = !1);
                B = j;
                break;
              case "h":
              case "v":
                var Se = be === "h" ? "x" : "y";
                j = j.clone();
                for (var D = 0; D < te; D++)
                  j[Se] = X(D, Se), this.lineTo(j);
                B = j;
                break;
              case "c":
                for (var D = 0; D < te; D += 6)
                  this.cubicCurveTo(
                    ue(D),
                    B = ue(D + 2),
                    j = ue(D + 4)
                  );
                break;
              case "s":
                for (var D = 0; D < te; D += 4)
                  this.cubicCurveTo(
                    /[cs]/.test(I) ? j.multiply(2).subtract(B) : j,
                    B = ue(D),
                    j = ue(D + 2)
                  ), I = be;
                break;
              case "q":
                for (var D = 0; D < te; D += 4)
                  this.quadraticCurveTo(
                    B = ue(D),
                    j = ue(D + 2)
                  );
                break;
              case "t":
                for (var D = 0; D < te; D += 2)
                  this.quadraticCurveTo(
                    B = /[qt]/.test(I) ? j.multiply(2).subtract(B) : j,
                    j = ue(D)
                  ), I = be;
                break;
              case "a":
                for (var D = 0; D < te; D += 7)
                  this.arcTo(
                    j = ue(D + 5),
                    new c(+h[D], +h[D + 1]),
                    +h[D + 2],
                    +h[D + 4],
                    +h[D + 3]
                  );
                break;
              case "z":
                this.closePath(1e-12), j = H;
                break;
            }
            I = be;
          }
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _contains: function(e) {
          var r = e.isInside(
            this.getBounds({ internal: !0, handle: !0 })
          ) ? this._getWinding(e) : {};
          return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
        },
        getIntersections: function(e, r, h, k) {
          var I = this === e || !e, B = this._matrix._orNullIfIdentity(), j = I ? B : (h || e._matrix)._orNullIfIdentity();
          return I || this.getBounds(B).intersects(
            e.getBounds(j),
            1e-12
          ) ? ee.getIntersections(
            this.getCurves(),
            !I && e.getCurves(),
            r,
            B,
            j,
            k
          ) : [];
        },
        getCrossings: function(e) {
          return this.getIntersections(e, function(r) {
            return r.isCrossing();
          });
        },
        getNearestLocation: function() {
          for (var e = a.read(arguments), r = this.getCurves(), h = 1 / 0, k = null, I = 0, B = r.length; I < B; I++) {
            var j = r[I].getNearestLocation(e);
            j._distance < h && (h = j._distance, k = j);
          }
          return k;
        },
        getNearestPoint: function() {
          var e = this.getNearestLocation.apply(this, arguments);
          return e && e.getPoint();
        },
        interpolate: function(e, r, h) {
          var k = !this._children, I = k ? "_segments" : "_children", B = e[I], j = r[I], H = this[I];
          if (!B || !j || B.length !== j.length)
            throw new Error("Invalid operands in interpolate() call: " + e + ", " + r);
          var X = H.length, ue = j.length;
          if (X < ue)
            for (var pe = k ? F : Q, M = X; M < ue; M++)
              this.add(new pe());
          else X > ue && this[k ? "removeSegments" : "removeChildren"](ue, X);
          for (var M = 0; M < ue; M++)
            H[M].interpolate(B[M], j[M], h);
          k && (this.setClosed(e._closed), this._changed(9));
        },
        compare: function(e) {
          var r = !1;
          if (e) {
            var h = this._children || [this], k = e._children ? e._children.slice() : [e], I = h.length, B = k.length, j = [], H = 0;
            r = !0;
            for (var X = E.findItemBoundsCollisions(h, k, l.GEOMETRIC_EPSILON), ue = I - 1; ue >= 0 && r; ue--) {
              var pe = h[ue];
              r = !1;
              var M = X[ue];
              if (M)
                for (var q = M.length - 1; q >= 0 && !r; q--)
                  pe.compare(k[M[q]]) && (j[M[q]] || (j[M[q]] = !0, H++), r = !0);
            }
            r = r && H === B;
          }
          return r;
        }
      }), Q = W.extend(
        {
          _class: "Path",
          _serializeFields: {
            segments: [],
            closed: !1
          },
          initialize: function(r) {
            this._closed = !1, this._segments = [], this._version = 0;
            var h = arguments, k = Array.isArray(r) ? typeof r[0] == "object" ? r : h : r && r.size === ne && (r.x !== ne || r.point !== ne) ? h : null;
            k && k.length > 0 ? this.setSegments(k) : (this._curves = ne, this._segmentSelection = 0, !k && typeof r == "string" && (this.setPathData(r), r = null)), this._initialize(!k && r);
          },
          _equals: function(e) {
            return this._closed === e._closed && _.equals(this._segments, e._segments);
          },
          copyContent: function(e) {
            this.setSegments(e._segments), this._closed = e._closed;
          },
          _changed: function e(r) {
            if (e.base.call(this, r), r & 8) {
              if (this._length = this._area = ne, r & 32)
                this._version++;
              else if (this._curves)
                for (var h = 0, k = this._curves.length; h < k; h++)
                  this._curves[h]._changed();
            } else r & 64 && (this._bounds = ne);
          },
          getStyle: function() {
            var e = this._parent;
            return (e instanceof de ? e : this)._style;
          },
          getSegments: function() {
            return this._segments;
          },
          setSegments: function(e) {
            var r = this.isFullySelected(), h = e && e.length;
            if (this._segments.length = 0, this._segmentSelection = 0, this._curves = ne, h) {
              var k = e[h - 1];
              typeof k == "boolean" && (this.setClosed(k), h--), this._add(F.readList(e, 0, {}, h));
            }
            r && this.setFullySelected(!0);
          },
          getFirstSegment: function() {
            return this._segments[0];
          },
          getLastSegment: function() {
            return this._segments[this._segments.length - 1];
          },
          getCurves: function() {
            var e = this._curves, r = this._segments;
            if (!e) {
              var h = this._countCurves();
              e = this._curves = new Array(h);
              for (var k = 0; k < h; k++)
                e[k] = new ee(
                  this,
                  r[k],
                  r[k + 1] || r[0]
                );
            }
            return e;
          },
          getFirstCurve: function() {
            return this.getCurves()[0];
          },
          getLastCurve: function() {
            var e = this.getCurves();
            return e[e.length - 1];
          },
          isClosed: function() {
            return this._closed;
          },
          setClosed: function(e) {
            if (this._closed != (e = !!e)) {
              if (this._closed = e, this._curves) {
                var r = this._curves.length = this._countCurves();
                e && (this._curves[r - 1] = new ee(
                  this,
                  this._segments[r - 1],
                  this._segments[0]
                ));
              }
              this._changed(41);
            }
          }
        },
        {
          beans: !0,
          getPathData: function(e, r) {
            var h = this._segments, k = h.length, I = new d(r), B = new Array(6), j = !0, H, X, ue, pe, M, q, K, be, te = [];
            function he(Se, le) {
              if (Se._transformCoordinates(e, B), H = B[0], X = B[1], j)
                te.push("M" + I.pair(H, X)), j = !1;
              else if (M = B[2], q = B[3], M === H && q === X && K === ue && be === pe) {
                if (!le) {
                  var m = H - ue, oe = X - pe;
                  te.push(
                    m === 0 ? "v" + I.number(oe) : oe === 0 ? "h" + I.number(m) : "l" + I.pair(m, oe)
                  );
                }
              } else
                te.push("c" + I.pair(K - ue, be - pe) + " " + I.pair(M - ue, q - pe) + " " + I.pair(H - ue, X - pe));
              ue = H, pe = X, K = B[4], be = B[5];
            }
            if (!k)
              return "";
            for (var D = 0; D < k; D++)
              he(h[D]);
            return this._closed && k > 0 && (he(h[0], !0), te.push("z")), te.join("");
          },
          isEmpty: function() {
            return !this._segments.length;
          },
          _transformContent: function(e) {
            for (var r = this._segments, h = new Array(6), k = 0, I = r.length; k < I; k++)
              r[k]._transformCoordinates(e, h, !0);
            return !0;
          },
          _add: function(e, j) {
            for (var h = this._segments, k = this._curves, I = e.length, B = j == null, j = B ? h.length : j, H = 0; H < I; H++) {
              var X = e[H];
              X._path && (X = e[H] = X.clone()), X._path = this, X._index = j + H, X._selection && this._updateSelection(X, 0, X._selection);
            }
            if (B)
              _.push(h, e);
            else {
              h.splice.apply(h, [j, 0].concat(e));
              for (var H = j + I, ue = h.length; H < ue; H++)
                h[H]._index = H;
            }
            if (k) {
              var pe = this._countCurves(), M = j > 0 && j + I - 1 === pe ? j - 1 : j, q = M, K = Math.min(M + I, pe);
              e._curves && (k.splice.apply(k, [M, 0].concat(e._curves)), q += e._curves.length);
              for (var H = q; H < K; H++)
                k.splice(H, 0, new ee(this, null, null));
              this._adjustCurves(M, K);
            }
            return this._changed(41), e;
          },
          _adjustCurves: function(e, r) {
            for (var h = this._segments, k = this._curves, I, B = e; B < r; B++)
              I = k[B], I._path = this, I._segment1 = h[B], I._segment2 = h[B + 1] || h[0], I._changed();
            (I = k[this._closed && !e ? h.length - 1 : e - 1]) && (I._segment2 = h[e] || h[0], I._changed()), (I = k[r]) && (I._segment1 = h[r], I._changed());
          },
          _countCurves: function() {
            var e = this._segments.length;
            return !this._closed && e > 0 ? e - 1 : e;
          },
          add: function(e) {
            var r = arguments;
            return r.length > 1 && typeof e != "number" ? this._add(F.readList(r)) : this._add([F.read(r)])[0];
          },
          insert: function(e, r) {
            var h = arguments;
            return h.length > 2 && typeof r != "number" ? this._add(F.readList(h, 1), e) : this._add([F.read(h, 1)], e)[0];
          },
          addSegment: function() {
            return this._add([F.read(arguments)])[0];
          },
          insertSegment: function(e) {
            return this._add([F.read(arguments, 1)], e)[0];
          },
          addSegments: function(e) {
            return this._add(F.readList(e));
          },
          insertSegments: function(e, r) {
            return this._add(F.readList(r), e);
          },
          removeSegment: function(e) {
            return this.removeSegments(e, e + 1)[0] || null;
          },
          removeSegments: function(e, r, h) {
            e = e || 0, r = _.pick(r, this._segments.length);
            var k = this._segments, I = this._curves, B = k.length, j = k.splice(e, r - e), H = j.length;
            if (!H)
              return j;
            for (var X = 0; X < H; X++) {
              var ue = j[X];
              ue._selection && this._updateSelection(ue, ue._selection, 0), ue._index = ue._path = null;
            }
            for (var X = e, pe = k.length; X < pe; X++)
              k[X]._index = X;
            if (I) {
              for (var M = e > 0 && r === B + (this._closed ? 1 : 0) ? e - 1 : e, I = I.splice(M, H), X = I.length - 1; X >= 0; X--)
                I[X]._path = null;
              h && (j._curves = I.slice(1)), this._adjustCurves(M, M);
            }
            return this._changed(41), j;
          },
          clear: "#removeSegments",
          hasHandles: function() {
            for (var e = this._segments, r = 0, h = e.length; r < h; r++)
              if (e[r].hasHandles())
                return !0;
            return !1;
          },
          clearHandles: function() {
            for (var e = this._segments, r = 0, h = e.length; r < h; r++)
              e[r].clearHandles();
          },
          getLength: function() {
            if (this._length == null) {
              for (var e = this.getCurves(), r = 0, h = 0, k = e.length; h < k; h++)
                r += e[h].getLength();
              this._length = r;
            }
            return this._length;
          },
          getArea: function() {
            var e = this._area;
            if (e == null) {
              var r = this._segments, h = this._closed;
              e = 0;
              for (var k = 0, I = r.length; k < I; k++) {
                var B = k + 1 === I;
                e += ee.getArea(ee.getValues(
                  r[k],
                  r[B ? 0 : k + 1],
                  null,
                  B && !h
                ));
              }
              this._area = e;
            }
            return e;
          },
          isFullySelected: function() {
            var e = this._segments.length;
            return this.isSelected() && e > 0 && this._segmentSelection === e * 7;
          },
          setFullySelected: function(e) {
            e && this._selectSegments(!0), this.setSelected(e);
          },
          setSelection: function e(r) {
            r & 1 || this._selectSegments(!1), e.base.call(this, r);
          },
          _selectSegments: function(e) {
            var r = this._segments, h = r.length, k = e ? 7 : 0;
            this._segmentSelection = k * h;
            for (var I = 0; I < h; I++)
              r[I]._selection = k;
          },
          _updateSelection: function(e, r, h) {
            e._selection = h;
            var k = this._segmentSelection += h - r;
            k > 0 && this.setSelected(!0);
          },
          divideAt: function(e) {
            var r = this.getLocationAt(e), h;
            return r && (h = r.getCurve().divideAt(r.getCurveOffset())) ? h._segment1 : null;
          },
          splitAt: function(e) {
            var r = this.getLocationAt(e), h = r && r.index, k = r && r.time, I = 1e-8, B = 1 - I;
            k > B && (h++, k = 0);
            var j = this.getCurves();
            if (h >= 0 && h < j.length) {
              k >= I && j[h++].divideAtTime(k);
              var H = this.removeSegments(h, this._segments.length, !0), X;
              return this._closed ? (this.setClosed(!1), X = this) : (X = new Q(o.NO_INSERT), X.insertAbove(this), X.copyAttributes(this)), X._add(H, 0), this.addSegment(H[0]), X;
            }
            return null;
          },
          split: function(e, r) {
            var h, k = r === ne ? e : (h = this.getCurves()[e]) && h.getLocationAtTime(r);
            return k != null ? this.splitAt(k) : null;
          },
          join: function(e, r) {
            var h = r || 0;
            if (e && e !== this) {
              var k = e._segments, I = this.getLastSegment(), B = e.getLastSegment();
              if (!B)
                return this;
              I && I._point.isClose(B._point, h) && e.reverse();
              var j = e.getFirstSegment();
              if (I && I._point.isClose(j._point, h))
                I.setHandleOut(j._handleOut), this._add(k.slice(1));
              else {
                var H = this.getFirstSegment();
                H && H._point.isClose(j._point, h) && e.reverse(), B = e.getLastSegment(), H && H._point.isClose(B._point, h) ? (H.setHandleIn(B._handleIn), this._add(k.slice(0, k.length - 1), 0)) : this._add(k.slice());
              }
              e._closed && this._add([k[0]]), e.remove();
            }
            var X = this.getFirstSegment(), ue = this.getLastSegment();
            return X !== ue && X._point.isClose(ue._point, h) && (X.setHandleIn(ue._handleIn), ue.remove(), this.setClosed(!0)), this;
          },
          reduce: function(e) {
            for (var r = this.getCurves(), h = e && e.simplify, k = h ? 1e-7 : 0, I = r.length - 1; I >= 0; I--) {
              var B = r[I];
              !B.hasHandles() && (!B.hasLength(k) || h && B.isCollinear(B.getNext())) && B.remove();
            }
            return this;
          },
          reverse: function() {
            this._segments.reverse();
            for (var e = 0, r = this._segments.length; e < r; e++) {
              var h = this._segments[e], k = h._handleIn;
              h._handleIn = h._handleOut, h._handleOut = k, h._index = e;
            }
            this._curves = null, this._changed(9);
          },
          flatten: function(e) {
            for (var r = new _e(this, e || 0.25, 256, !0), h = r.parts, k = h.length, I = [], B = 0; B < k; B++)
              I.push(new F(h[B].curve.slice(0, 2)));
            !this._closed && k > 0 && I.push(new F(h[k - 1].curve.slice(6))), this.setSegments(I);
          },
          simplify: function(e) {
            var r = new ke(this).fit(e || 2.5);
            return r && this.setSegments(r), !!r;
          },
          smooth: function(e) {
            var r = this, h = e || {}, k = h.type || "asymmetric", I = this._segments, B = I.length, j = this._closed;
            function H(xt, Ot) {
              var Nt = xt && xt.index;
              if (Nt != null) {
                var Pt = xt.path;
                if (Pt && Pt !== r)
                  throw new Error(xt._class + " " + Nt + " of " + Pt + " is not part of " + r);
                Ot && xt instanceof ee && Nt++;
              } else
                Nt = typeof xt == "number" ? xt : Ot;
              return Math.min(Nt < 0 && j ? Nt % B : Nt < 0 ? Nt + B : Nt, B - 1);
            }
            var X = j && h.from === ne && h.to === ne, ue = H(h.from, 0), pe = H(h.to, B - 1);
            if (ue > pe)
              if (j)
                ue -= B;
              else {
                var M = ue;
                ue = pe, pe = M;
              }
            if (/^(?:asymmetric|continuous)$/.test(k)) {
              var q = k === "asymmetric", K = Math.min, be = pe - ue + 1, te = be - 1, he = X ? K(be, 4) : 1, D = he, Se = he, le = [];
              if (j || (D = K(1, ue), Se = K(1, B - pe - 1)), te += D + Se, te <= 1)
                return;
              for (var m = 0, oe = ue - D; m <= te; m++, oe++)
                le[m] = I[(oe < 0 ? oe + B : oe) % B]._point;
              for (var me = le[0]._x + 2 * le[1]._x, O = le[0]._y + 2 * le[1]._y, ce = 2, Oe = te - 1, Be = [me], Ge = [O], Fe = [ce], Ye = [], Ke = [], m = 1; m < te; m++) {
                var et = m < Oe, Je = et || q ? 1 : 2, nt = et ? 4 : q ? 2 : 7, pt = et ? 4 : q ? 3 : 8, vt = et ? 2 : q ? 0 : 1, bt = Je / ce;
                ce = Fe[m] = nt - bt, me = Be[m] = pt * le[m]._x + vt * le[m + 1]._x - bt * me, O = Ge[m] = pt * le[m]._y + vt * le[m + 1]._y - bt * O;
              }
              Ye[Oe] = Be[Oe] / Fe[Oe], Ke[Oe] = Ge[Oe] / Fe[Oe];
              for (var m = te - 2; m >= 0; m--)
                Ye[m] = (Be[m] - Ye[m + 1]) / Fe[m], Ke[m] = (Ge[m] - Ke[m + 1]) / Fe[m];
              Ye[te] = (3 * le[te]._x - Ye[Oe]) / 2, Ke[te] = (3 * le[te]._y - Ke[Oe]) / 2;
              for (var m = D, At = te - Se, oe = ue; m <= At; m++, oe++) {
                var ot = I[oe < 0 ? oe + B : oe], ct = ot._point, gt = Ye[m] - ct._x, Ct = Ke[m] - ct._y;
                (X || m < At) && ot.setHandleOut(gt, Ct), (X || m > D) && ot.setHandleIn(-gt, -Ct);
              }
            } else
              for (var m = ue; m <= pe; m++)
                I[m < 0 ? m + B : m].smooth(
                  h,
                  !X && m === ue,
                  !X && m === pe
                );
          },
          toShape: function(e) {
            if (!this._closed)
              return null;
            var r = this._segments, h, k, I, B;
            function j(q, K) {
              var be = r[q], te = be.getNext(), he = r[K], D = he.getNext();
              return be._handleOut.isZero() && te._handleIn.isZero() && he._handleOut.isZero() && D._handleIn.isZero() && te._point.subtract(be._point).isCollinear(
                D._point.subtract(he._point)
              );
            }
            function H(q) {
              var K = r[q], be = K.getPrevious(), te = K.getNext();
              return be._handleOut.isZero() && K._handleIn.isZero() && K._handleOut.isZero() && te._handleIn.isZero() && K._point.subtract(be._point).isOrthogonal(
                te._point.subtract(K._point)
              );
            }
            function X(q) {
              var K = r[q], be = K.getNext(), te = K._handleOut, he = be._handleIn, D = 0.5522847498307936;
              if (te.isOrthogonal(he)) {
                var Se = K._point, le = be._point, m = new S(Se, te, !0).intersect(
                  new S(le, he, !0),
                  !0
                );
                return m && l.isZero(te.getLength() / m.subtract(Se).getLength() - D) && l.isZero(he.getLength() / m.subtract(le).getLength() - D);
              }
              return !1;
            }
            function ue(q, K) {
              return r[q]._point.getDistance(r[K]._point);
            }
            if (!this.hasHandles() && r.length === 4 && j(0, 2) && j(1, 3) && H(1) ? (h = R.Rectangle, k = new c(ue(0, 3), ue(0, 1)), B = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && X(0) && X(2) && X(4) && X(6) && j(1, 5) && j(3, 7) ? (h = R.Rectangle, k = new c(ue(1, 6), ue(0, 3)), I = k.subtract(new c(
              ue(0, 7),
              ue(1, 2)
            )).divide(2), B = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && X(0) && X(1) && X(2) && X(3) && (l.isZero(ue(0, 2) - ue(1, 3)) ? (h = R.Circle, I = ue(0, 2) / 2) : (h = R.Ellipse, I = new c(ue(2, 0) / 2, ue(3, 1) / 2)), B = r[1]._point), h) {
              var pe = this.getPosition(!0), M = new h({
                center: pe,
                size: k,
                radius: I,
                insert: !1
              });
              return M.copyAttributes(this, !0), M._matrix.prepend(this._matrix), M.rotate(B.subtract(pe).getAngle() + 90), (e === ne || e) && M.insertAbove(this), M;
            }
            return null;
          },
          toPath: "#clone",
          compare: function e(r) {
            if (!r || r instanceof de)
              return e.base.call(this, r);
            var h = this.getCurves(), k = r.getCurves(), I = h.length, B = k.length;
            if (!I || !B)
              return I == B;
            for (var j = h[0].getValues(), H = [], X = 0, ue, pe = 0, M, q = 0; q < B; q++) {
              var he = k[q].getValues();
              H.push(he);
              var K = ee.getOverlaps(j, he);
              if (K) {
                ue = !q && K[0][0] > 0 ? B - 1 : q, M = K[0][1];
                break;
              }
            }
            for (var be = Math.abs, te = 1e-8, he = H[ue], D; j && he; ) {
              var K = ee.getOverlaps(j, he);
              if (K) {
                var Se = K[0][0];
                if (be(Se - pe) < te) {
                  pe = K[1][0], pe === 1 && (j = ++X < I ? h[X].getValues() : null, pe = 0);
                  var le = K[0][1];
                  if (be(le - M) < te) {
                    if (D || (D = [ue, le]), M = K[1][1], M === 1 && (++ue >= B && (ue = 0), he = H[ue] || k[ue].getValues(), M = 0), !j)
                      return D[0] === ue && D[1] === M;
                    continue;
                  }
                }
              }
              break;
            }
            return !1;
          },
          _hitTestSelf: function(e, r, h, k) {
            var I = this, B = this.getStyle(), j = this._segments, H = j.length, X = this._closed, ue = r._tolerancePadding, pe = ue, M, q, K, be, te, he, D = r.stroke && B.hasStroke(), Se = r.fill && B.hasFill(), le = r.curves, m = D ? B.getStrokeWidth() / 2 : Se && r.tolerance > 0 || le ? 0 : null;
            m !== null && (m > 0 ? (M = B.getStrokeJoin(), q = B.getStrokeCap(), K = B.getMiterLimit(), pe = pe.add(
              Q._getStrokePadding(m, k)
            )) : M = q = "round");
            function oe(Ye, Ke) {
              return e.subtract(Ye).divide(Ke).length <= 1;
            }
            function me(Ye, Ke, et) {
              if (!r.selected || Ke.isSelected()) {
                var Je = Ye._point;
                if (Ke !== Je && (Ke = Ke.add(Je)), oe(Ke, pe))
                  return new J(et, I, {
                    segment: Ye,
                    point: Ke
                  });
              }
            }
            function O(Ye, Ke) {
              return (Ke || r.segments) && me(Ye, Ye._point, "segment") || !Ke && r.handles && (me(Ye, Ye._handleIn, "handle-in") || me(Ye, Ye._handleOut, "handle-out"));
            }
            function ce(Ye) {
              be.add(Ye);
            }
            function Oe(Ye) {
              var Ke = X || Ye._index > 0 && Ye._index < H - 1;
              if ((Ke ? M : q) === "round")
                return oe(Ye._point, pe);
              if (be = new Q({ internal: !0, closed: !0 }), Ke ? Ye.isSmooth() || Q._addBevelJoin(
                Ye,
                M,
                m,
                K,
                null,
                k,
                ce,
                !0
              ) : q === "square" && Q._addSquareCap(
                Ye,
                q,
                m,
                null,
                k,
                ce,
                !0
              ), !be.isEmpty()) {
                var et;
                return be.contains(e) || (et = be.getNearestLocation(e)) && oe(et.getPoint(), ue);
              }
            }
            if (r.ends && !r.segments && !X) {
              if (he = O(j[0], !0) || O(j[H - 1], !0))
                return he;
            } else if (r.segments || r.handles) {
              for (var Be = 0; Be < H; Be++)
                if (he = O(j[Be]))
                  return he;
            }
            if (m !== null) {
              if (te = this.getNearestLocation(e), te) {
                var Ge = te.getTime();
                Ge === 0 || Ge === 1 && H > 1 ? Oe(te.getSegment()) || (te = null) : oe(te.getPoint(), pe) || (te = null);
              }
              if (!te && M === "miter" && H > 1)
                for (var Be = 0; Be < H; Be++) {
                  var Fe = j[Be];
                  if (e.getDistance(Fe._point) <= K * m && Oe(Fe)) {
                    te = Fe.getLocation();
                    break;
                  }
                }
            }
            return !te && Se && this._contains(e) || te && !D && !le ? new J("fill", this) : te ? new J(D ? "stroke" : "curve", this, {
              location: te,
              point: te.getPoint()
            }) : null;
          }
        },
        _.each(
          ee._evaluateMethods,
          function(e) {
            this[e + "At"] = function(r) {
              var h = this.getLocationAt(r);
              return h && h[e]();
            };
          },
          {
            beans: !1,
            getLocationOf: function() {
              for (var e = a.read(arguments), r = this.getCurves(), h = 0, k = r.length; h < k; h++) {
                var I = r[h].getLocationOf(e);
                if (I)
                  return I;
              }
              return null;
            },
            getOffsetOf: function() {
              var e = this.getLocationOf.apply(this, arguments);
              return e ? e.getOffset() : null;
            },
            getLocationAt: function(e) {
              if (typeof e == "number") {
                for (var r = this.getCurves(), h = 0, k = 0, I = r.length; k < I; k++) {
                  var B = h, j = r[k];
                  if (h += j.getLength(), h > e)
                    return j.getLocationAt(e - B);
                }
                if (r.length > 0 && e <= this.getLength())
                  return new ie(r[r.length - 1], 1);
              } else if (e && e.getPath && e.getPath() === this)
                return e;
              return null;
            },
            getOffsetsWithTangent: function() {
              var e = a.read(arguments);
              if (e.isZero())
                return [];
              for (var r = [], h = 0, k = this.getCurves(), I = 0, B = k.length; I < B; I++) {
                for (var j = k[I], H = j.getTimesWithTangent(e), X = 0, ue = H.length; X < ue; X++) {
                  var pe = h + j.getOffsetAtTime(H[X]);
                  r.indexOf(pe) < 0 && r.push(pe);
                }
                h += j.length;
              }
              return r;
            }
          }
        ),
        new function() {
          function e(h, k, I, B) {
            if (B <= 0) return;
            var j = B / 2, H = B - 2, X = j - 1, ue = new Array(6), pe, M;
            function q(Se) {
              var le = ue[Se], m = ue[Se + 1];
              (pe != le || M != m) && (h.beginPath(), h.moveTo(pe, M), h.lineTo(le, m), h.stroke(), h.beginPath(), h.arc(le, m, j, 0, Math.PI * 2, !0), h.fill());
            }
            for (var K = 0, be = k.length; K < be; K++) {
              var te = k[K], he = te._selection;
              if (te._transformCoordinates(I, ue), pe = ue[0], M = ue[1], he & 2 && q(2), he & 4 && q(4), h.fillRect(pe - j, M - j, B, B), H > 0 && !(he & 1)) {
                var D = h.fillStyle;
                h.fillStyle = "#ffffff", h.fillRect(pe - X, M - X, H, H), h.fillStyle = D;
              }
            }
          }
          function r(h, k, I) {
            var B = k._segments, j = B.length, H = new Array(6), X = !0, ue, pe, M, q, K, be, te, he;
            function D(le) {
              if (I)
                le._transformCoordinates(I, H), ue = H[0], pe = H[1];
              else {
                var m = le._point;
                ue = m._x, pe = m._y;
              }
              if (X)
                h.moveTo(ue, pe), X = !1;
              else {
                if (I)
                  K = H[2], be = H[3];
                else {
                  var oe = le._handleIn;
                  K = ue + oe._x, be = pe + oe._y;
                }
                K === ue && be === pe && te === M && he === q ? h.lineTo(ue, pe) : h.bezierCurveTo(te, he, K, be, ue, pe);
              }
              if (M = ue, q = pe, I)
                te = H[4], he = H[5];
              else {
                var oe = le._handleOut;
                te = M + oe._x, he = q + oe._y;
              }
            }
            for (var Se = 0; Se < j; Se++)
              D(B[Se]);
            k._closed && j > 0 && D(B[0]);
          }
          return {
            _draw: function(h, k, I, B) {
              var j = k.dontStart, H = k.dontFinish || k.clip, X = this.getStyle(), ue = X.hasFill(), pe = X.hasStroke(), M = X.getDashArray(), q = !Ae.support.nativeDash && pe && M && M.length;
              j || h.beginPath(), (ue || pe && !q || H) && (r(h, this, B), this._closed && h.closePath());
              function K(le) {
                return M[(le % q + q) % q];
              }
              if (!H && (ue || pe) && (this._setStyles(h, k, I), ue && (h.fill(X.getFillRule()), h.shadowColor = "rgba(0,0,0,0)"), pe)) {
                if (q) {
                  j || h.beginPath();
                  for (var be = new _e(
                    this,
                    0.25,
                    32,
                    !1,
                    B
                  ), te = be.length, he = -X.getDashOffset(), D, Se = 0; he > 0; )
                    he -= K(Se--) + K(Se--);
                  for (; he < te; )
                    D = he + K(Se++), (he > 0 || D > 0) && be.drawPart(
                      h,
                      Math.max(he, 0),
                      Math.max(D, 0)
                    ), he = D + K(Se++);
                }
                h.stroke();
              }
            },
            _drawSelected: function(h, k) {
              h.beginPath(), r(h, this, k), h.stroke(), e(h, this._segments, k, Ae.settings.handleSize);
            }
          };
        }(),
        new function() {
          function e(r) {
            var h = r._segments;
            if (!h.length)
              throw new Error("Use a moveTo() command first");
            return h[h.length - 1];
          }
          return {
            moveTo: function() {
              var r = this._segments;
              r.length === 1 && this.removeSegment(0), r.length || this._add([new F(a.read(arguments))]);
            },
            moveBy: function() {
              throw new Error("moveBy() is unsupported on Path items.");
            },
            lineTo: function() {
              this._add([new F(a.read(arguments))]);
            },
            cubicCurveTo: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = a.read(r), B = e(this);
              B.setHandleOut(h.subtract(B._point)), this._add([new F(I, k.subtract(I))]);
            },
            quadraticCurveTo: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = e(this)._point;
              this.cubicCurveTo(
                h.add(I.subtract(h).multiply(1 / 3)),
                h.add(k.subtract(h).multiply(1 / 3)),
                k
              );
            },
            curveTo: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = _.pick(_.read(r), 0.5), B = 1 - I, j = e(this)._point, H = h.subtract(j.multiply(B * B)).subtract(k.multiply(I * I)).divide(2 * I * B);
              if (H.isNaN())
                throw new Error(
                  "Cannot put a curve through points with parameter = " + I
                );
              this.quadraticCurveTo(H, k);
            },
            arcTo: function() {
              var r = arguments, h = Math.abs, k = Math.sqrt, I = e(this), B = I._point, j = a.read(r), H, X = _.peek(r), ue = _.pick(X, !0), pe, M, q, K;
              if (typeof ue == "boolean")
                var be = B.add(j).divide(2), H = be.add(be.subtract(B).rotate(
                  ue ? -90 : 90
                ));
              else if (_.remain(r) <= 2)
                H = j, j = a.read(r);
              else if (!B.equals(j)) {
                var te = c.read(r), he = l.isZero;
                if (he(te.width) || he(te.height))
                  return this.lineTo(j);
                var D = _.read(r), ue = !!_.read(r), Se = !!_.read(r), be = B.add(j).divide(2), le = B.subtract(be).rotate(-D), m = le.x, oe = le.y, me = h(te.width), O = h(te.height), ce = me * me, Oe = O * O, Be = m * m, Ge = oe * oe, Fe = k(Be / ce + Ge / Oe);
                if (Fe > 1 && (me *= Fe, O *= Fe, ce = me * me, Oe = O * O), Fe = (ce * Oe - ce * Ge - Oe * Be) / (ce * Ge + Oe * Be), h(Fe) < 1e-12 && (Fe = 0), Fe < 0)
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                pe = new a(me * oe / O, -O * m / me).multiply((Se === ue ? -1 : 1) * k(Fe)).rotate(D).add(be), K = new s().translate(pe).rotate(D).scale(me, O), q = K._inverseTransform(B), M = q.getDirectedAngle(K._inverseTransform(j)), !ue && M > 0 ? M -= 360 : ue && M < 0 && (M += 360);
              }
              if (H) {
                var Ye = new S(
                  B.add(H).divide(2),
                  H.subtract(B).rotate(90),
                  !0
                ), Ke = new S(
                  H.add(j).divide(2),
                  j.subtract(H).rotate(90),
                  !0
                ), et = new S(B, j), Je = et.getSide(H);
                if (pe = Ye.intersect(Ke, !0), !pe) {
                  if (!Je)
                    return this.lineTo(j);
                  throw new Error(
                    "Cannot create an arc with the given arguments"
                  );
                }
                q = B.subtract(pe), M = q.getDirectedAngle(j.subtract(pe));
                var nt = et.getSide(pe, !0);
                nt === 0 ? M = Je * h(M) : Je === nt && (M += M < 0 ? 360 : -360);
              }
              if (M) {
                for (var pt = 1e-5, vt = h(M), bt = vt >= 360 ? 4 : Math.ceil((vt - pt) / 90), At = M / bt, ot = At * Math.PI / 360, ct = 4 / 3 * Math.sin(ot) / (1 + Math.cos(ot)), gt = [], Ct = 0; Ct <= bt; Ct++) {
                  var le = j, xt = null;
                  if (Ct < bt && (xt = q.rotate(90).multiply(ct), K ? (le = K._transformPoint(q), xt = K._transformPoint(q.add(xt)).subtract(le)) : le = pe.add(q)), !Ct)
                    I.setHandleOut(xt);
                  else {
                    var Ot = q.rotate(-90).multiply(ct);
                    K && (Ot = K._transformPoint(q.add(Ot)).subtract(le)), gt.push(new F(le, Ot, xt));
                  }
                  q = q.rotate(At);
                }
                this._add(gt);
              }
            },
            lineBy: function() {
              var r = a.read(arguments), h = e(this)._point;
              this.lineTo(h.add(r));
            },
            curveBy: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = _.read(r), B = e(this)._point;
              this.curveTo(B.add(h), B.add(k), I);
            },
            cubicCurveBy: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = a.read(r), B = e(this)._point;
              this.cubicCurveTo(
                B.add(h),
                B.add(k),
                B.add(I)
              );
            },
            quadraticCurveBy: function() {
              var r = arguments, h = a.read(r), k = a.read(r), I = e(this)._point;
              this.quadraticCurveTo(I.add(h), I.add(k));
            },
            arcBy: function() {
              var r = arguments, h = e(this)._point, k = h.add(a.read(r)), I = _.pick(_.peek(r), !0);
              typeof I == "boolean" ? this.arcTo(k, I) : this.arcTo(k, h.add(a.read(r)));
            },
            closePath: function(r) {
              this.setClosed(!0), this.join(this, r);
            }
          };
        }(),
        {
          _getBounds: function(e, r) {
            var h = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
            return Q[h](this._segments, this._closed, this, e, r);
          },
          statics: {
            getBounds: function(e, r, h, k, I, B) {
              var j = e[0];
              if (!j)
                return new f();
              var H = new Array(6), X = j._transformCoordinates(k, new Array(6)), ue = X.slice(0, 2), pe = ue.slice(), M = new Array(2);
              function q(te) {
                te._transformCoordinates(k, H);
                for (var he = 0; he < 2; he++)
                  ee._addBounds(
                    X[he],
                    X[he + 4],
                    H[he + 2],
                    H[he],
                    he,
                    B ? B[he] : 0,
                    ue,
                    pe,
                    M
                  );
                var D = X;
                X = H, H = D;
              }
              for (var K = 1, be = e.length; K < be; K++)
                q(e[K]);
              return r && q(j), new f(ue[0], ue[1], pe[0] - ue[0], pe[1] - ue[1]);
            },
            getStrokeBounds: function(e, r, h, k, I) {
              var B = h.getStyle(), j = B.hasStroke(), H = B.getStrokeWidth(), X = j && h._getStrokeMatrix(k, I), ue = j && Q._getStrokePadding(
                H,
                X
              ), pe = Q.getBounds(
                e,
                r,
                h,
                k,
                I,
                ue
              );
              if (!j)
                return pe;
              var M = H / 2, q = B.getStrokeJoin(), K = B.getStrokeCap(), be = B.getMiterLimit(), te = new f(new c(ue));
              function he(me) {
                pe = pe.include(me);
              }
              function D(me) {
                pe = pe.unite(
                  te.setCenter(me._point.transform(k))
                );
              }
              function Se(me, O) {
                O === "round" || me.isSmooth() ? D(me) : Q._addBevelJoin(
                  me,
                  O,
                  M,
                  be,
                  k,
                  X,
                  he
                );
              }
              function le(me, O) {
                O === "round" ? D(me) : Q._addSquareCap(
                  me,
                  O,
                  M,
                  k,
                  X,
                  he
                );
              }
              var m = e.length - (r ? 0 : 1);
              if (m > 0) {
                for (var oe = 1; oe < m; oe++)
                  Se(e[oe], q);
                r ? Se(e[0], q) : (le(e[0], K), le(e[e.length - 1], K));
              }
              return pe;
            },
            _getStrokePadding: function(e, r) {
              if (!r)
                return [e, e];
              var h = new a(e, 0).transform(r), k = new a(0, e).transform(r), I = h.getAngleInRadians(), B = h.getLength(), j = k.getLength(), H = Math.sin(I), X = Math.cos(I), ue = Math.tan(I), pe = Math.atan2(j * ue, B), M = Math.atan2(j, ue * B);
              return [
                Math.abs(B * Math.cos(pe) * X + j * Math.sin(pe) * H),
                Math.abs(j * Math.sin(M) * X + B * Math.cos(M) * H)
              ];
            },
            _addBevelJoin: function(e, r, h, k, I, B, j, H) {
              var X = e.getCurve(), ue = X.getPrevious(), pe = X.getPoint1().transform(I), M = ue.getNormalAtTime(1).multiply(h).transform(B), q = X.getNormalAtTime(0).multiply(h).transform(B), K = M.getDirectedAngle(q);
              if ((K < 0 || K >= 180) && (M = M.negate(), q = q.negate()), H && j(pe), j(pe.add(M)), r === "miter") {
                var be = new S(
                  pe.add(M),
                  new a(-M.y, M.x),
                  !0
                ).intersect(new S(
                  pe.add(q),
                  new a(-q.y, q.x),
                  !0
                ), !0);
                be && pe.getDistance(be) <= k * h && j(be);
              }
              j(pe.add(q));
            },
            _addSquareCap: function(e, r, h, k, I, B, j) {
              var H = e._point.transform(k), X = e.getLocation(), ue = X.getNormal().multiply(X.getTime() === 0 ? h : -h).transform(I);
              r === "square" && (j && (B(H.subtract(ue)), B(H.add(ue))), H = H.add(ue.rotate(-90))), B(H.add(ue)), B(H.subtract(ue));
            },
            getHandleBounds: function(e, r, h, k, I) {
              var B = h.getStyle(), j = I.stroke && B.hasStroke(), H, X;
              if (j) {
                var ue = h._getStrokeMatrix(k, I), pe = B.getStrokeWidth() / 2, M = pe;
                B.getStrokeJoin() === "miter" && (M = pe * B.getMiterLimit()), B.getStrokeCap() === "square" && (M = Math.max(M, pe * Math.SQRT2)), H = Q._getStrokePadding(pe, ue), X = Q._getStrokePadding(M, ue);
              }
              for (var q = new Array(6), K = 1 / 0, be = -K, te = K, he = be, D = 0, Se = e.length; D < Se; D++) {
                var le = e[D];
                le._transformCoordinates(k, q);
                for (var m = 0; m < 6; m += 2) {
                  var oe = m ? H : X, me = oe ? oe[0] : 0, O = oe ? oe[1] : 0, ce = q[m], Oe = q[m + 1], Be = ce - me, Ge = ce + me, Fe = Oe - O, Ye = Oe + O;
                  Be < K && (K = Be), Ge > be && (be = Ge), Fe < te && (te = Fe), Ye > he && (he = Ye);
                }
              }
              return new f(K, te, be - K, he - te);
            }
          }
        }
      );
      Q.inject({ statics: new function() {
        var e = 0.5522847498307936, r = [
          new F([-1, 0], [0, e], [0, -0.5522847498307936]),
          new F([0, -1], [-0.5522847498307936, 0], [e, 0]),
          new F([1, 0], [0, -0.5522847498307936], [0, e]),
          new F([0, 1], [e, 0], [-0.5522847498307936, 0])
        ];
        function h(I, B, j) {
          var H = _.getNamed(j), X = new Q(H && (H.insert == !0 ? o.INSERT : H.insert == !1 ? o.NO_INSERT : null));
          return X._add(I), X._closed = B, X.set(H, o.INSERT);
        }
        function k(I, B, j) {
          for (var H = new Array(4), X = 0; X < 4; X++) {
            var ue = r[X];
            H[X] = new F(
              ue._point.multiply(B).add(I),
              ue._handleIn.multiply(B),
              ue._handleOut.multiply(B)
            );
          }
          return h(H, !0, j);
        }
        return {
          Line: function() {
            var I = arguments;
            return h([
              new F(a.readNamed(I, "from")),
              new F(a.readNamed(I, "to"))
            ], !1, I);
          },
          Circle: function() {
            var I = arguments, B = a.readNamed(I, "center"), j = _.readNamed(I, "radius");
            return k(B, new c(j), I);
          },
          Rectangle: function() {
            var I = arguments, B = f.readNamed(I, "rectangle"), j = c.readNamed(
              I,
              "radius",
              0,
              { readNull: !0 }
            ), H = B.getBottomLeft(!0), X = B.getTopLeft(!0), ue = B.getTopRight(!0), pe = B.getBottomRight(!0), M;
            if (!j || j.isZero())
              M = [
                new F(H),
                new F(X),
                new F(ue),
                new F(pe)
              ];
            else {
              j = c.min(j, B.getSize(!0).divide(2));
              var q = j.width, K = j.height, be = q * e, te = K * e;
              M = [
                new F(H.add(q, 0), null, [-be, 0]),
                new F(H.subtract(0, K), [0, te]),
                new F(X.add(0, K), null, [0, -te]),
                new F(X.add(q, 0), [-be, 0], null),
                new F(ue.subtract(q, 0), null, [be, 0]),
                new F(ue.add(0, K), [0, -te], null),
                new F(pe.subtract(0, K), null, [0, te]),
                new F(pe.subtract(q, 0), [be, 0])
              ];
            }
            return h(M, !0, I);
          },
          RoundRectangle: "#Rectangle",
          Ellipse: function() {
            var I = arguments, B = R._readEllipse(I);
            return k(B.center, B.radius, I);
          },
          Oval: "#Ellipse",
          Arc: function() {
            var I = arguments, B = a.readNamed(I, "from"), j = a.readNamed(I, "through"), H = a.readNamed(I, "to"), X = _.getNamed(I), ue = new Q(X && X.insert == !1 && o.NO_INSERT);
            return ue.moveTo(B), ue.arcTo(j, H), ue.set(X);
          },
          RegularPolygon: function() {
            for (var I = arguments, B = a.readNamed(I, "center"), j = _.readNamed(I, "sides"), H = _.readNamed(I, "radius"), X = 360 / j, ue = j % 3 === 0, pe = new a(0, ue ? -H : H), M = ue ? -1 : 0.5, q = new Array(j), K = 0; K < j; K++)
              q[K] = new F(B.add(
                pe.rotate((K + M) * X)
              ));
            return h(q, !0, I);
          },
          Star: function() {
            for (var I = arguments, B = a.readNamed(I, "center"), j = _.readNamed(I, "points") * 2, H = _.readNamed(I, "radius1"), X = _.readNamed(I, "radius2"), ue = 360 / j, pe = new a(0, -1), M = new Array(j), q = 0; q < j; q++)
              M[q] = new F(B.add(pe.rotate(ue * q).multiply(q % 2 ? X : H)));
            return h(M, !0, I);
          }
        };
      }() });
      var de = W.extend(
        {
          _class: "CompoundPath",
          _serializeFields: {
            children: []
          },
          beans: !0,
          initialize: function(r) {
            this._children = [], this._namedChildren = {}, this._initialize(r) || (typeof r == "string" ? this.setPathData(r) : this.addChildren(Array.isArray(r) ? r : arguments));
          },
          insertChildren: function e(r, h) {
            var k = h, I = k[0];
            I && typeof I[0] == "number" && (k = [k]);
            for (var B = h.length - 1; B >= 0; B--) {
              var j = k[B];
              k === h && !(j instanceof Q) && (k = _.slice(k)), Array.isArray(j) ? k[B] = new Q({ segments: j, insert: !1 }) : j instanceof de && (k.splice.apply(k, [B, 1].concat(j.removeChildren())), j.remove());
            }
            return e.base.call(this, r, k);
          },
          reduce: function e(r) {
            for (var h = this._children, k = h.length - 1; k >= 0; k--) {
              var I = h[k].reduce(r);
              I.isEmpty() && I.remove();
            }
            if (!h.length) {
              var I = new Q(o.NO_INSERT);
              return I.copyAttributes(this), I.insertAbove(this), this.remove(), I;
            }
            return e.base.call(this);
          },
          isClosed: function() {
            for (var e = this._children, r = 0, h = e.length; r < h; r++)
              if (!e[r]._closed)
                return !1;
            return !0;
          },
          setClosed: function(e) {
            for (var r = this._children, h = 0, k = r.length; h < k; h++)
              r[h].setClosed(e);
          },
          getFirstSegment: function() {
            var e = this.getFirstChild();
            return e && e.getFirstSegment();
          },
          getLastSegment: function() {
            var e = this.getLastChild();
            return e && e.getLastSegment();
          },
          getCurves: function() {
            for (var e = this._children, r = [], h = 0, k = e.length; h < k; h++)
              _.push(r, e[h].getCurves());
            return r;
          },
          getFirstCurve: function() {
            var e = this.getFirstChild();
            return e && e.getFirstCurve();
          },
          getLastCurve: function() {
            var e = this.getLastChild();
            return e && e.getLastCurve();
          },
          getArea: function() {
            for (var e = this._children, r = 0, h = 0, k = e.length; h < k; h++)
              r += e[h].getArea();
            return r;
          },
          getLength: function() {
            for (var e = this._children, r = 0, h = 0, k = e.length; h < k; h++)
              r += e[h].getLength();
            return r;
          },
          getPathData: function(e, r) {
            for (var h = this._children, k = [], I = 0, B = h.length; I < B; I++) {
              var j = h[I], H = j._matrix;
              k.push(j.getPathData(e && !H.isIdentity() ? e.appended(H) : e, r));
            }
            return k.join("");
          },
          _hitTestChildren: function e(r, h, k) {
            return e.base.call(
              this,
              r,
              h.class === Q || h.type === "path" ? h : _.set({}, h, { fill: !1 }),
              k
            );
          },
          _draw: function(e, r, h, k) {
            var I = this._children;
            if (I.length) {
              r = r.extend({ dontStart: !0, dontFinish: !0 }), e.beginPath();
              for (var B = 0, j = I.length; B < j; B++)
                I[B].draw(e, r, k);
              if (!r.clip) {
                this._setStyles(e, r, h);
                var H = this._style;
                H.hasFill() && (e.fill(H.getFillRule()), e.shadowColor = "rgba(0,0,0,0)"), H.hasStroke() && e.stroke();
              }
            }
          },
          _drawSelected: function(e, r, h) {
            for (var k = this._children, I = 0, B = k.length; I < B; I++) {
              var j = k[I], H = j._matrix;
              h[j._id] || j._drawSelected(e, H.isIdentity() ? r : r.appended(H));
            }
          }
        },
        new function() {
          function e(r, h) {
            var k = r._children;
            if (h && !k.length)
              throw new Error("Use a moveTo() command first");
            return k[k.length - 1];
          }
          return _.each(
            [
              "lineTo",
              "cubicCurveTo",
              "quadraticCurveTo",
              "curveTo",
              "arcTo",
              "lineBy",
              "cubicCurveBy",
              "quadraticCurveBy",
              "curveBy",
              "arcBy"
            ],
            function(r) {
              this[r] = function() {
                var h = e(this, !0);
                h[r].apply(h, arguments);
              };
            },
            {
              moveTo: function() {
                var r = e(this), h = r && r.isEmpty() ? r : new Q(o.NO_INSERT);
                h !== r && this.addChild(h), h.moveTo.apply(h, arguments);
              },
              moveBy: function() {
                var r = e(this, !0), h = r && r.getLastSegment(), k = a.read(arguments);
                this.moveTo(h ? k.add(h._point) : k);
              },
              closePath: function(r) {
                e(this, !0).closePath(r);
              }
            }
          );
        }(),
        _.each(["reverse", "flatten", "simplify", "smooth"], function(e) {
          this[e] = function(r) {
            for (var h = this._children, k, I = 0, B = h.length; I < B; I++)
              k = h[I][e](r) || k;
            return k;
          };
        }, {})
      );
      W.inject(new function() {
        var e = Math.min, r = Math.max, h = Math.abs, k = {
          unite: { 1: !0, 2: !0 },
          intersect: { 2: !0 },
          subtract: { 1: !0 },
          exclude: { 1: !0, "-1": !0 }
        };
        function I(D) {
          return D._children || [D];
        }
        function B(D, Se) {
          var le = D.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
          if (Se) {
            for (var m = I(le), oe = 0, me = m.length; oe < me; oe++) {
              var D = m[oe];
              !D._closed && !D.isEmpty() && (D.closePath(1e-12), D.getFirstSegment().setHandleIn(0, 0), D.getLastSegment().setHandleOut(0, 0));
            }
            le = le.resolveCrossings().reorient(le.getFillRule() === "nonzero", !0);
          }
          return le;
        }
        function j(D, Se, le, m, oe) {
          var me = new de(o.NO_INSERT);
          return me.addChildren(D, !0), me = me.reduce({ simplify: Se }), oe && oe.insert == !1 || me.insertAbove(m && le.isSibling(m) && le.getIndex() < m.getIndex() ? m : le), me.copyAttributes(le, !0), me;
        }
        function H(D) {
          return D.hasOverlap() || D.isCrossing();
        }
        function X(D, Se, le, m) {
          if (m && (m.trace == !1 || m.stroke) && /^(subtract|intersect)$/.test(le))
            return ue(D, Se, le);
          var oe = B(D, !0), me = Se && D !== Se && B(Se, !0), O = k[le];
          O[le] = !0, me && (O.subtract || O.exclude) ^ (me.isClockwise() ^ oe.isClockwise()) && me.reverse();
          var ce = K(ie.expand(
            oe.getIntersections(me, H)
          )), Oe = I(oe), Be = me && I(me), Ge = [], Fe = [], Ye;
          function Ke(xt) {
            for (var Ot = 0, Nt = xt.length; Ot < Nt; Ot++) {
              var Pt = xt[Ot];
              _.push(Ge, Pt._segments), _.push(Fe, Pt.getCurves()), Pt._overlapsOnly = !0;
            }
          }
          function et(xt) {
            for (var Ot = [], Nt = 0, Pt = xt && xt.length; Nt < Pt; Nt++)
              Ot.push(Fe[xt[Nt]]);
            return Ot;
          }
          if (ce.length) {
            Ke(Oe), Be && Ke(Be);
            for (var Je = new Array(Fe.length), nt = 0, pt = Fe.length; nt < pt; nt++)
              Je[nt] = Fe[nt].getValues();
            for (var vt = E.findCurveBoundsCollisions(
              Je,
              Je,
              0,
              !0
            ), bt = {}, nt = 0; nt < Fe.length; nt++) {
              var At = Fe[nt], ot = At._path._id, ct = bt[ot] = bt[ot] || {};
              ct[At.getIndex()] = {
                hor: et(vt[nt].hor),
                ver: et(vt[nt].ver)
              };
            }
            for (var nt = 0, pt = ce.length; nt < pt; nt++)
              te(
                ce[nt]._segment,
                oe,
                me,
                bt,
                O
              );
            for (var nt = 0, pt = Ge.length; nt < pt; nt++) {
              var gt = Ge[nt], Ct = gt._intersection;
              gt._winding || te(
                gt,
                oe,
                me,
                bt,
                O
              ), Ct && Ct._overlap || (gt._path._overlapsOnly = !1);
            }
            Ye = he(Ge, O);
          } else
            Ye = q(
              Be ? Oe.concat(Be) : Oe.slice(),
              function(xt) {
                return !!O[xt];
              }
            );
          return j(Ye, !0, D, Se, m);
        }
        function ue(D, Se, le) {
          var m = B(D), oe = B(Se), me = m.getIntersections(oe, H), O = le === "subtract", ce = le === "divide", Oe = {}, Be = [];
          function Ge(Ke) {
            if (!Oe[Ke._id] && (ce || oe.contains(Ke.getPointAt(Ke.getLength() / 2)) ^ O))
              return Be.unshift(Ke), Oe[Ke._id] = !0;
          }
          for (var Fe = me.length - 1; Fe >= 0; Fe--) {
            var Ye = me[Fe].split();
            Ye && (Ge(Ye) && Ye.getFirstSegment().setHandleIn(0, 0), m.getLastSegment().setHandleOut(0, 0));
          }
          return Ge(m), j(Be, !1, D, Se);
        }
        function pe(D, Se) {
          for (var le = D; le; ) {
            if (le === Se)
              return;
            le = le._previous;
          }
          for (; D._next && D._next !== Se; )
            D = D._next;
          if (!D._next) {
            for (; Se._previous; )
              Se = Se._previous;
            D._next = Se, Se._previous = D;
          }
        }
        function M(D) {
          for (var Se = D.length - 1; Se >= 0; Se--)
            D[Se].clearHandles();
        }
        function q(D, Se, le) {
          var m = D && D.length;
          if (m) {
            var oe = _.each(D, function(vt, bt) {
              this[vt._id] = {
                container: null,
                winding: vt.isClockwise() ? 1 : -1,
                index: bt
              };
            }, {}), me = D.slice().sort(function(vt, bt) {
              return h(bt.getArea()) - h(vt.getArea());
            }), O = me[0], ce = E.findItemBoundsCollisions(
              me,
              null,
              l.GEOMETRIC_EPSILON
            );
            le == null && (le = O.isClockwise());
            for (var Oe = 0; Oe < m; Oe++) {
              var Be = me[Oe], Ge = oe[Be._id], Fe = 0, Ye = ce[Oe];
              if (Ye) {
                for (var Ke = null, et = Ye.length - 1; et >= 0; et--)
                  if (Ye[et] < Oe) {
                    Ke = Ke || Be.getInteriorPoint();
                    var Je = me[Ye[et]];
                    if (Je.contains(Ke)) {
                      var nt = oe[Je._id];
                      Fe = nt.winding, Ge.winding += Fe, Ge.container = nt.exclude ? nt.container : Je;
                      break;
                    }
                  }
              }
              if (Se(Ge.winding) === Se(Fe))
                Ge.exclude = !0, D[Ge.index] = null;
              else {
                var pt = Ge.container;
                Be.setClockwise(
                  pt ? !pt.isClockwise() : le
                );
              }
            }
          }
          return D;
        }
        function K(D, Se, le) {
          var m = Se && [], oe = 1e-8, me = 1 - oe, O = !1, ce = le || [], Oe = le && {}, Be, Ge, Fe;
          function Ye(Ot) {
            return Ot._path._id + "." + Ot._segment1._index;
          }
          for (var Ke = (le && le.length) - 1; Ke >= 0; Ke--) {
            var et = le[Ke];
            et._path && (Oe[Ye(et)] = !0);
          }
          for (var Ke = D.length - 1; Ke >= 0; Ke--) {
            var Je = D[Ke], nt = Je._time, pt = nt, vt = Se && !Se(Je), et = Je._curve, bt;
            if (et && (et !== Ge ? (O = !et.hasHandles() || Oe && Oe[Ye(et)], Be = [], Fe = null, Ge = et) : Fe >= oe && (nt /= Fe)), vt) {
              Be && Be.push(Je);
              continue;
            } else Se && m.unshift(Je);
            if (Fe = pt, nt < oe)
              bt = et._segment1;
            else if (nt > me)
              bt = et._segment2;
            else {
              var At = et.divideAtTime(nt, !0);
              O && ce.push(et, At), bt = At._segment1;
              for (var ot = Be.length - 1; ot >= 0; ot--) {
                var ct = Be[ot];
                ct._time = (ct._time - nt) / (1 - nt);
              }
            }
            Je._setSegment(bt);
            var gt = bt._intersection, Ct = Je._intersection;
            if (gt) {
              pe(gt, Ct);
              for (var xt = gt; xt; )
                pe(xt._intersection, gt), xt = xt._next;
            } else
              bt._intersection = Ct;
          }
          return le || M(ce), m || D;
        }
        function be(D, Se, le, m, oe) {
          var me = Array.isArray(Se) ? Se : Se[le ? "hor" : "ver"], O = le ? 1 : 0, ce = O ^ 1, Oe = [D.x, D.y], Be = Oe[O], Ge = Oe[ce], Fe = 1e-9, Ye = 1e-6, Ke = Be - Fe, et = Be + Fe, Je = 0, nt = 0, pt = 0, vt = 0, bt = !1, At = !1, ot = 1, ct = [], gt, Ct;
          function xt(wt) {
            var $t = wt[ce + 0], lr = wt[ce + 6];
            if (!(Ge < e($t, lr) || Ge > r($t, lr))) {
              var tr = wt[O + 0], Xr = wt[O + 2], gi = wt[O + 4], ii = wt[O + 6];
              if ($t === lr) {
                (tr < et && ii > Ke || ii < et && tr > Ke) && (bt = !0);
                return;
              }
              var Br = Ge === $t ? 0 : Ge === lr || Ke > r(tr, Xr, gi, ii) || et < e(tr, Xr, gi, ii) ? 1 : ee.solveCubic(wt, ce, Ge, ct, 0, 1) > 0 ? ct[0] : 1, Er = Br === 0 ? tr : Br === 1 ? ii : ee.getPoint(wt, Br)[le ? "y" : "x"], kr = $t > lr ? 1 : -1, qr = gt[ce] > gt[ce + 6] ? 1 : -1, yr = gt[O + 6];
              return Ge !== $t ? (Er < Ke ? pt += kr : Er > et ? vt += kr : bt = !0, Er > Be - Ye && Er < Be + Ye && (ot /= 2)) : (kr !== qr ? tr < Ke ? pt += kr : tr > et && (vt += kr) : tr != yr && (yr < et && Er > et ? (vt += kr, bt = !0) : yr > Ke && Er < Ke && (pt += kr, bt = !0)), ot /= 4), gt = wt, !oe && Er > Ke && Er < et && ee.getTangent(wt, Br)[le ? "x" : "y"] === 0 && be(D, Se, !le, m, !0);
            }
          }
          function Ot(wt) {
            var $t = wt[ce + 0], lr = wt[ce + 2], tr = wt[ce + 4], Xr = wt[ce + 6];
            if (Ge <= r($t, lr, tr, Xr) && Ge >= e($t, lr, tr, Xr)) {
              for (var gi = wt[O + 0], ii = wt[O + 2], Br = wt[O + 4], Er = wt[O + 6], kr = Ke > r(gi, ii, Br, Er) || et < e(gi, ii, Br, Er) ? [wt] : ee.getMonoCurves(wt, le), qr, yr = 0, Or = kr.length; yr < Or; yr++)
                if (qr = xt(kr[yr]))
                  return qr;
            }
          }
          for (var Nt = 0, Pt = me.length; Nt < Pt; Nt++) {
            var Gt = me[Nt], Bt = Gt._path, or = Gt.getValues(), ar;
            if ((!Nt || me[Nt - 1]._path !== Bt) && (gt = null, Bt._closed || (Ct = ee.getValues(
              Bt.getLastCurve().getSegment2(),
              Gt.getSegment1(),
              null,
              !m
            ), Ct[ce] !== Ct[ce + 6] && (gt = Ct)), !gt)) {
              gt = or;
              for (var ur = Bt.getLastCurve(); ur && ur !== Gt; ) {
                var hr = ur.getValues();
                if (hr[ce] !== hr[ce + 6]) {
                  gt = hr;
                  break;
                }
                ur = ur.getPrevious();
              }
            }
            if (ar = Ot(or))
              return ar;
            if (Nt + 1 === Pt || me[Nt + 1]._path !== Bt) {
              if (Ct && (ar = Ot(Ct)))
                return ar;
              bt && !pt && !vt && (pt = vt = Bt.isClockwise(m) ^ le ? 1 : -1), Je += pt, nt += vt, pt = vt = 0, bt && (At = !0, bt = !1), Ct = null;
            }
          }
          return Je = h(Je), nt = h(nt), {
            winding: r(Je, nt),
            windingL: Je,
            windingR: nt,
            quality: ot,
            onPath: At
          };
        }
        function te(D, Se, le, m, oe) {
          var me = [], O = D, ce = 0, Fe;
          do {
            var Oe = D.getCurve();
            if (Oe) {
              var Be = Oe.getLength();
              me.push({ segment: D, curve: Oe, length: Be }), ce += Be;
            }
            D = D.getNext();
          } while (D && !D._intersection && D !== O);
          for (var Ge = [0.5, 0.25, 0.75], Fe = { winding: 0, quality: -1 }, Ye = 1e-3, Ke = 1 - Ye, et = 0; et < Ge.length && Fe.quality < 0.5; et++)
            for (var Be = ce * Ge[et], Je = 0, nt = me.length; Je < nt; Je++) {
              var pt = me[Je], vt = pt.length;
              if (Be <= vt) {
                var Oe = pt.curve, bt = Oe._path, At = bt._parent, ot = At instanceof de ? At : bt, ct = l.clamp(Oe.getTimeAt(Be), Ye, Ke), gt = Oe.getPointAtTime(ct), Ct = h(Oe.getTangentAtTime(ct).y) < Math.SQRT1_2, xt = null;
                if (oe.subtract && le) {
                  var Ot = ot === Se ? le : Se, Nt = Ot._getWinding(gt, Ct, !0);
                  if (ot === Se && Nt.winding || ot === le && !Nt.winding) {
                    if (Nt.quality < 1)
                      continue;
                    xt = { winding: 0, quality: 1 };
                  }
                }
                xt = xt || be(
                  gt,
                  m[bt._id][Oe.getIndex()],
                  Ct,
                  !0
                ), xt.quality > Fe.quality && (Fe = xt);
                break;
              }
              Be -= vt;
            }
          for (var Je = me.length - 1; Je >= 0; Je--)
            me[Je].segment._winding = Fe;
        }
        function he(D, Se) {
          var le = [], m;
          function oe(Pt) {
            var Gt;
            return !!(Pt && !Pt._visited && (!Se || Se[(Gt = Pt._winding || {}).winding] && !(Se.unite && Gt.winding === 2 && Gt.windingL && Gt.windingR)));
          }
          function me(Pt) {
            if (Pt) {
              for (var Gt = 0, Bt = m.length; Gt < Bt; Gt++)
                if (Pt === m[Gt])
                  return !0;
            }
            return !1;
          }
          function O(Pt) {
            for (var Gt = Pt._segments, Bt = 0, or = Gt.length; Bt < or; Bt++)
              Gt[Bt]._visited = !0;
          }
          function ce(Pt, Gt) {
            var Bt = Pt._intersection, or = Bt, ar = [];
            Gt && (m = [Pt]);
            function ur(hr, wt) {
              for (; hr && hr !== wt; ) {
                var $t = hr._segment, lr = $t && $t._path;
                if (lr) {
                  var tr = $t.getNext() || lr.getFirstSegment(), Xr = tr._intersection;
                  $t !== Pt && (me($t) || me(tr) || tr && oe($t) && (oe(tr) || Xr && oe(Xr._segment))) && ar.push($t), Gt && m.push($t);
                }
                hr = hr._next;
              }
            }
            if (Bt) {
              for (ur(Bt); Bt && Bt._previous; )
                Bt = Bt._previous;
              ur(Bt, or);
            }
            return ar;
          }
          D.sort(function(Pt, Gt) {
            var Bt = Pt._intersection, or = Gt._intersection, ar = !!(Bt && Bt._overlap), ur = !!(or && or._overlap), hr = Pt._path, wt = Gt._path;
            return ar ^ ur ? ar ? 1 : -1 : !Bt ^ !or ? Bt ? 1 : -1 : hr !== wt ? hr._id - wt._id : Pt._index - Gt._index;
          });
          for (var Oe = 0, Be = D.length; Oe < Be; Oe++) {
            var Ge = D[Oe], Fe = oe(Ge), Ye = null, Ke = !1, et = !0, Je = [], nt, pt, vt;
            if (Fe && Ge._path._overlapsOnly) {
              var bt = Ge._path, At = Ge._intersection._segment._path;
              bt.compare(At) && (bt.getArea() && le.push(bt.clone(!1)), O(bt), O(At), Fe = !1);
            }
            for (; Fe; ) {
              var ot = !Ye, ct = ce(Ge, ot), gt = ct.shift(), Ke = !ot && (me(Ge) || me(gt)), Ct = !Ke && gt;
              if (ot && (Ye = new Q(o.NO_INSERT), nt = null), Ke) {
                (Ge.isFirst() || Ge.isLast()) && (et = Ge._path._closed), Ge._visited = !0;
                break;
              }
              if (Ct && nt && (Je.push(nt), nt = null), nt || (Ct && ct.push(Ge), nt = {
                start: Ye._segments.length,
                crossings: ct,
                visited: pt = [],
                handleIn: vt
              }), Ct && (Ge = gt), !oe(Ge)) {
                Ye.removeSegments(nt.start);
                for (var xt = 0, Ot = pt.length; xt < Ot; xt++)
                  pt[xt]._visited = !1;
                pt.length = 0;
                do
                  Ge = nt && nt.crossings.shift(), (!Ge || !Ge._path) && (Ge = null, nt = Je.pop(), nt && (pt = nt.visited, vt = nt.handleIn));
                while (nt && !oe(Ge));
                if (!Ge)
                  break;
              }
              var Nt = Ge.getNext();
              Ye.add(new F(
                Ge._point,
                vt,
                Nt && Ge._handleOut
              )), Ge._visited = !0, pt.push(Ge), Ge = Nt || Ge._path.getFirstSegment(), vt = Nt && Nt._handleIn;
            }
            Ke && (et && (Ye.getFirstSegment().setHandleIn(vt), Ye.setClosed(et)), Ye.getArea() !== 0 && le.push(Ye));
          }
          return le;
        }
        return {
          _getWinding: function(D, Se, le) {
            return be(D, this.getCurves(), Se, le);
          },
          unite: function(D, Se) {
            return X(this, D, "unite", Se);
          },
          intersect: function(D, Se) {
            return X(this, D, "intersect", Se);
          },
          subtract: function(D, Se) {
            return X(this, D, "subtract", Se);
          },
          exclude: function(D, Se) {
            return X(this, D, "exclude", Se);
          },
          divide: function(D, Se) {
            return Se && (Se.trace == !1 || Se.stroke) ? ue(this, D, "divide") : j([
              this.subtract(D, Se),
              this.intersect(D, Se)
            ], !0, this, D, Se);
          },
          resolveCrossings: function() {
            var D = this._children, Se = D || [this];
            function le(nt, pt) {
              var vt = nt && nt._intersection;
              return vt && vt._overlap && vt._path === pt;
            }
            var m = !1, oe = !1, me = this.getIntersections(null, function(nt) {
              return nt.hasOverlap() && (m = !0) || nt.isCrossing() && (oe = !0);
            }), O = m && oe && [];
            if (me = ie.expand(me), m)
              for (var ce = K(me, function(nt) {
                return nt.hasOverlap();
              }, O), Oe = ce.length - 1; Oe >= 0; Oe--) {
                var Be = ce[Oe], Ge = Be._path, Fe = Be._segment, Ye = Fe.getPrevious(), Ke = Fe.getNext();
                le(Ye, Ge) && le(Ke, Ge) && (Fe.remove(), Ye._handleOut._set(0, 0), Ke._handleIn._set(0, 0), Ye !== Fe && !Ye.getCurve().hasLength() && (Ke._handleIn.set(Ye._handleIn), Ye.remove()));
              }
            oe && (K(me, m && function(nt) {
              var pt = nt.getCurve(), vt = nt.getSegment(), bt = nt._intersection, At = bt._curve, ot = bt._segment;
              if (pt && At && pt._path && At._path)
                return !0;
              vt && (vt._intersection = null), ot && (ot._intersection = null);
            }, O), O && M(O), Se = he(_.each(Se, function(nt) {
              _.push(this, nt._segments);
            }, [])));
            var et = Se.length, Je;
            return et > 1 && D ? (Se !== D && this.setChildren(Se), Je = this) : et === 1 && !D && (Se[0] !== this && this.setSegments(Se[0].removeSegments()), Je = this), Je || (Je = new de(o.NO_INSERT), Je.addChildren(Se), Je = Je.reduce(), Je.copyAttributes(this), this.replaceWith(Je)), Je;
          },
          reorient: function(D, Se) {
            var le = this._children;
            return le && le.length ? this.setChildren(q(
              this.removeChildren(),
              function(m) {
                return !!(D ? m : m & 1);
              },
              Se
            )) : Se !== ne && this.setClockwise(Se), this;
          },
          getInteriorPoint: function() {
            var D = this.getBounds(), Se = D.getCenter(!0);
            if (!this.contains(Se)) {
              for (var le = this.getCurves(), m = Se.y, oe = [], me = [], O = 0, ce = le.length; O < ce; O++) {
                var Oe = le[O].getValues(), Be = Oe[1], Ge = Oe[3], Fe = Oe[5], Ye = Oe[7];
                if (m >= e(Be, Ge, Fe, Ye) && m <= r(Be, Ge, Fe, Ye))
                  for (var Ke = ee.getMonoCurves(Oe), et = 0, Je = Ke.length; et < Je; et++) {
                    var nt = Ke[et], pt = nt[1], vt = nt[7];
                    if (pt !== vt && (m >= pt && m <= vt || m >= vt && m <= pt)) {
                      var bt = m === pt ? nt[0] : m === vt ? nt[6] : ee.solveCubic(nt, 1, m, me, 0, 1) === 1 ? ee.getPoint(nt, me[0]).x : (nt[0] + nt[6]) / 2;
                      oe.push(bt);
                    }
                  }
              }
              oe.length > 1 && (oe.sort(function(At, ot) {
                return At - ot;
              }), Se.x = (oe[0] + oe[1]) / 2);
            }
            return Se;
          }
        };
      }());
      var _e = _.extend(
        {
          _class: "PathFlattener",
          initialize: function(e, r, h, k, I) {
            var B = [], j = [], H = 0, X = 1 / (h || 32), ue = e._segments, pe = ue[0], M;
            function q(he, D) {
              var Se = ee.getValues(he, D, I);
              B.push(Se), K(Se, he._index, 0, 1);
            }
            function K(he, D, Se, le) {
              if (le - Se > X && !(k && ee.isStraight(he)) && !ee.isFlatEnough(he, r || 0.25)) {
                var m = ee.subdivide(he, 0.5), oe = (Se + le) / 2;
                K(m[0], D, Se, oe), K(m[1], D, oe, le);
              } else {
                var me = he[6] - he[0], O = he[7] - he[1], ce = Math.sqrt(me * me + O * O);
                ce > 0 && (H += ce, j.push({
                  offset: H,
                  curve: he,
                  index: D,
                  time: le
                }));
              }
            }
            for (var be = 1, te = ue.length; be < te; be++)
              M = ue[be], q(pe, M), pe = M;
            e._closed && q(M || pe, ue[0]), this.curves = B, this.parts = j, this.length = H, this.index = 0;
          },
          _get: function(e) {
            for (var r = this.parts, h = r.length, k, I = this.index; k = I, !(!I || r[--I].offset < e); )
              ;
            for (; k < h; k++) {
              var B = r[k];
              if (B.offset >= e) {
                this.index = k;
                var j = r[k - 1], H = j && j.index === B.index ? j.time : 0, X = j ? j.offset : 0;
                return {
                  index: B.index,
                  time: H + (B.time - H) * (e - X) / (B.offset - X)
                };
              }
            }
            return {
              index: r[h - 1].index,
              time: 1
            };
          },
          drawPart: function(e, r, h) {
            for (var k = this._get(r), I = this._get(h), B = k.index, j = I.index; B <= j; B++) {
              var H = ee.getPart(
                this.curves[B],
                B === k.index ? k.time : 0,
                B === I.index ? I.time : 1
              );
              B === k.index && e.moveTo(H[0], H[1]), e.bezierCurveTo.apply(e, H.slice(2));
            }
          }
        },
        _.each(
          ee._evaluateMethods,
          function(e) {
            this[e + "At"] = function(r) {
              var h = this._get(r);
              return ee[e](this.curves[h.index], h.time);
            };
          },
          {}
        )
      ), ke = _.extend({
        initialize: function(e) {
          for (var r = this.points = [], h = e._segments, k = e._closed, I = 0, B, j = h.length; I < j; I++) {
            var H = h[I].point;
            (!B || !B.equals(H)) && r.push(B = H.clone());
          }
          k && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = k;
        },
        fit: function(e) {
          var r = this.points, h = r.length, k = null;
          return h > 0 && (k = [new F(r[0])], h > 1 && (this.fitCubic(
            k,
            e,
            0,
            h - 1,
            r[1].subtract(r[0]),
            r[h - 2].subtract(r[h - 1])
          ), this.closed && (k.shift(), k.pop()))), k;
        },
        fitCubic: function(e, r, h, k, I, B) {
          var j = this.points;
          if (k - h === 1) {
            var H = j[h], X = j[k], ue = H.getDistance(X) / 3;
            this.addCurve(e, [
              H,
              H.add(I.normalize(ue)),
              X.add(B.normalize(ue)),
              X
            ]);
            return;
          }
          for (var pe = this.chordLengthParameterize(h, k), M = Math.max(r, r * r), q, K = !0, be = 0; be <= 4; be++) {
            var te = this.generateBezier(h, k, pe, I, B), he = this.findMaxError(h, k, te, pe);
            if (he.error < r && K) {
              this.addCurve(e, te);
              return;
            }
            if (q = he.index, he.error >= M)
              break;
            K = this.reparameterize(h, k, pe, te), M = he.error;
          }
          var D = j[q - 1].subtract(j[q + 1]);
          this.fitCubic(e, r, h, q, I, D), this.fitCubic(e, r, q, k, D.negate(), B);
        },
        addCurve: function(e, r) {
          var h = e[e.length - 1];
          h.setHandleOut(r[1].subtract(r[0])), e.push(new F(r[3], r[2].subtract(r[3])));
        },
        generateBezier: function(e, r, h, k, I) {
          for (var B = 1e-12, j = Math.abs, H = this.points, X = H[e], ue = H[r], pe = [[0, 0], [0, 0]], M = [0, 0], q = 0, K = r - e + 1; q < K; q++) {
            var be = h[q], te = 1 - be, he = 3 * be * te, D = te * te * te, Se = he * te, le = he * be, m = be * be * be, oe = k.normalize(Se), me = I.normalize(le), O = H[e + q].subtract(X.multiply(D + Se)).subtract(ue.multiply(le + m));
            pe[0][0] += oe.dot(oe), pe[0][1] += oe.dot(me), pe[1][0] = pe[0][1], pe[1][1] += me.dot(me), M[0] += oe.dot(O), M[1] += me.dot(O);
          }
          var ce = pe[0][0] * pe[1][1] - pe[1][0] * pe[0][1], Oe, Be;
          if (j(ce) > B) {
            var Ge = pe[0][0] * M[1] - pe[1][0] * M[0], Fe = M[0] * pe[1][1] - M[1] * pe[0][1];
            Oe = Fe / ce, Be = Ge / ce;
          } else {
            var Ye = pe[0][0] + pe[0][1], Ke = pe[1][0] + pe[1][1];
            Oe = Be = j(Ye) > B ? M[0] / Ye : j(Ke) > B ? M[1] / Ke : 0;
          }
          var et = ue.getDistance(X), Je = B * et, nt, pt;
          if (Oe < Je || Be < Je)
            Oe = Be = et / 3;
          else {
            var vt = ue.subtract(X);
            nt = k.normalize(Oe), pt = I.normalize(Be), nt.dot(vt) - pt.dot(vt) > et * et && (Oe = Be = et / 3, nt = pt = null);
          }
          return [
            X,
            X.add(nt || k.normalize(Oe)),
            ue.add(pt || I.normalize(Be)),
            ue
          ];
        },
        reparameterize: function(e, r, h, k) {
          for (var I = e; I <= r; I++)
            h[I - e] = this.findRoot(k, this.points[I], h[I - e]);
          for (var I = 1, B = h.length; I < B; I++)
            if (h[I] <= h[I - 1])
              return !1;
          return !0;
        },
        findRoot: function(e, r, h) {
          for (var k = [], I = [], B = 0; B <= 2; B++)
            k[B] = e[B + 1].subtract(e[B]).multiply(3);
          for (var B = 0; B <= 1; B++)
            I[B] = k[B + 1].subtract(k[B]).multiply(2);
          var j = this.evaluate(3, e, h), H = this.evaluate(2, k, h), X = this.evaluate(1, I, h), ue = j.subtract(r), pe = H.dot(H) + ue.dot(X);
          return l.isMachineZero(pe) ? h : h - ue.dot(H) / pe;
        },
        evaluate: function(e, r, h) {
          for (var k = r.slice(), I = 1; I <= e; I++)
            for (var B = 0; B <= e - I; B++)
              k[B] = k[B].multiply(1 - h).add(k[B + 1].multiply(h));
          return k[0];
        },
        chordLengthParameterize: function(e, r) {
          for (var h = [0], k = e + 1; k <= r; k++)
            h[k - e] = h[k - e - 1] + this.points[k].getDistance(this.points[k - 1]);
          for (var k = 1, I = r - e; k <= I; k++)
            h[k] /= h[I];
          return h;
        },
        findMaxError: function(e, r, h, k) {
          for (var I = Math.floor((r - e + 1) / 2), B = 0, j = e + 1; j < r; j++) {
            var H = this.evaluate(3, h, k[j - e]), X = H.subtract(this.points[j]), ue = X.x * X.x + X.y * X.y;
            ue >= B && (B = ue, I = j);
          }
          return {
            error: B,
            index: I
          };
        }
      }), Pe = o.extend({
        _class: "TextItem",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _serializeFields: {
          content: null
        },
        _boundsOptions: { stroke: !1, handle: !1 },
        initialize: function(r) {
          this._content = "", this._lines = [];
          var h = r && _.isPlainObject(r) && r.x === ne && r.y === ne;
          this._initialize(h && r, !h && a.read(arguments));
        },
        _equals: function(e) {
          return this._content === e._content;
        },
        copyContent: function(e) {
          this.setContent(e._content);
        },
        getContent: function() {
          return this._content;
        },
        setContent: function(e) {
          this._content = "" + e, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
        },
        isEmpty: function() {
          return !this._content;
        },
        getCharacterStyle: "#getStyle",
        setCharacterStyle: "#setStyle",
        getParagraphStyle: "#getStyle",
        setParagraphStyle: "#setStyle"
      }), fe = Pe.extend({
        _class: "PointText",
        initialize: function() {
          Pe.apply(this, arguments);
        },
        getPoint: function() {
          var e = this._matrix.getTranslation();
          return new n(e.x, e.y, this, "setPoint");
        },
        setPoint: function() {
          var e = a.read(arguments);
          this.translate(e.subtract(this._matrix.getTranslation()));
        },
        _draw: function(e, r, h) {
          if (this._content) {
            this._setStyles(e, r, h);
            var k = this._lines, I = this._style, B = I.hasFill(), j = I.hasStroke(), H = I.getLeading(), X = e.shadowColor;
            e.font = I.getFontStyle(), e.textAlign = I.getJustification();
            for (var ue = 0, pe = k.length; ue < pe; ue++) {
              e.shadowColor = X;
              var M = k[ue];
              B && (e.fillText(M, 0, 0), e.shadowColor = "rgba(0,0,0,0)"), j && e.strokeText(M, 0, 0), e.translate(0, H);
            }
          }
        },
        _getBounds: function(e, r) {
          var h = this._style, k = this._lines, I = k.length, B = h.getJustification(), j = h.getLeading(), H = this.getView().getTextWidth(h.getFontStyle(), k), X = 0;
          B !== "left" && (X -= H / (B === "center" ? 2 : 1));
          var ue = new f(
            X,
            I ? -0.75 * j : 0,
            H,
            I * j
          );
          return e ? e._transformBounds(ue, ue) : ue;
        }
      }), xe = _.extend(
        new function() {
          var e = {
            gray: ["gray"],
            rgb: ["red", "green", "blue"],
            hsb: ["hue", "saturation", "brightness"],
            hsl: ["hue", "saturation", "lightness"],
            gradient: ["gradient", "origin", "destination", "highlight"]
          }, r = {}, h = {
            transparent: [0, 0, 0, 0]
          }, k;
          function I(H) {
            var X = H.match(
              /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
            ) || H.match(
              /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
            ), ue = "rgb", pe;
            if (X) {
              var M = X[4] ? 4 : 3;
              pe = new Array(M);
              for (var q = 0; q < M; q++) {
                var K = X[q + 1];
                pe[q] = parseInt(K.length == 1 ? K + K : K, 16) / 255;
              }
            } else if (X = H.match(/^(rgb|hsl)a?\((.*)\)$/)) {
              ue = X[1], pe = X[2].trim().split(/[,\s]+/g);
              for (var be = ue === "hsl", q = 0, te = Math.min(pe.length, 4); q < te; q++) {
                var he = pe[q], K = parseFloat(he);
                if (be)
                  if (q === 0) {
                    var D = he.match(/([a-z]*)$/)[1];
                    K *= {
                      turn: 360,
                      rad: 180 / Math.PI,
                      grad: 0.9
                    }[D] || 1;
                  } else q < 3 && (K /= 100);
                else q < 3 && (K /= /%$/.test(he) ? 100 : 255);
                pe[q] = K;
              }
            } else {
              var Se = h[H];
              if (!Se)
                if (C) {
                  k || (k = Ce.getContext(1, 1, {
                    willReadFrequently: !0
                  }), k.globalCompositeOperation = "copy"), k.fillStyle = "rgba(0,0,0,0)", k.fillStyle = H, k.fillRect(0, 0, 1, 1);
                  var le = k.getImageData(0, 0, 1, 1).data;
                  Se = h[H] = [
                    le[0] / 255,
                    le[1] / 255,
                    le[2] / 255
                  ];
                } else
                  Se = [0, 0, 0];
              pe = Se.slice();
            }
            return [ue, pe];
          }
          var B = [
            [0, 3, 1],
            [2, 0, 1],
            [1, 0, 3],
            [1, 2, 0],
            [3, 1, 0],
            [0, 1, 2]
          ], j = {
            "rgb-hsb": function(H, X, ue) {
              var pe = Math.max(H, X, ue), M = Math.min(H, X, ue), q = pe - M, K = q === 0 ? 0 : (pe == H ? (X - ue) / q + (X < ue ? 6 : 0) : pe == X ? (ue - H) / q + 2 : (H - X) / q + 4) * 60;
              return [K, pe === 0 ? 0 : q / pe, pe];
            },
            "hsb-rgb": function(H, X, ue) {
              H = (H / 60 % 6 + 6) % 6;
              var M = Math.floor(H), pe = H - M, M = B[M], q = [
                ue,
                ue * (1 - X),
                ue * (1 - X * pe),
                ue * (1 - X * (1 - pe))
              ];
              return [q[M[0]], q[M[1]], q[M[2]]];
            },
            "rgb-hsl": function(H, X, ue) {
              var pe = Math.max(H, X, ue), M = Math.min(H, X, ue), q = pe - M, K = q === 0, be = K ? 0 : (pe == H ? (X - ue) / q + (X < ue ? 6 : 0) : pe == X ? (ue - H) / q + 2 : (H - X) / q + 4) * 60, te = (pe + M) / 2, he = K ? 0 : te < 0.5 ? q / (pe + M) : q / (2 - pe - M);
              return [be, he, te];
            },
            "hsl-rgb": function(H, X, ue) {
              if (H = (H / 360 % 1 + 1) % 1, X === 0)
                return [ue, ue, ue];
              for (var pe = [H + 1 / 3, H, H - 1 / 3], M = ue < 0.5 ? ue * (1 + X) : ue + X - ue * X, q = 2 * ue - M, K = [], be = 0; be < 3; be++) {
                var te = pe[be];
                te < 0 && (te += 1), te > 1 && (te -= 1), K[be] = 6 * te < 1 ? q + (M - q) * 6 * te : 2 * te < 1 ? M : 3 * te < 2 ? q + (M - q) * (2 / 3 - te) * 6 : q;
              }
              return K;
            },
            "rgb-gray": function(H, X, ue) {
              return [H * 0.2989 + X * 0.587 + ue * 0.114];
            },
            "gray-rgb": function(H) {
              return [H, H, H];
            },
            "gray-hsb": function(H) {
              return [0, 0, H];
            },
            "gray-hsl": function(H) {
              return [0, 0, H];
            },
            "gradient-rgb": function() {
              return [];
            },
            "rgb-gradient": function() {
              return [];
            }
          };
          return _.each(e, function(H, X) {
            r[X] = [], _.each(H, function(ue, pe) {
              var M = _.capitalize(ue), q = /^(hue|saturation)$/.test(ue), K = r[X][pe] = X === "gradient" ? ue === "gradient" ? function(be) {
                var te = this._components[0];
                return be = Ee.read(
                  Array.isArray(be) ? be : arguments,
                  0,
                  { readNull: !0 }
                ), te !== be && (te && te._removeOwner(this), be && be._addOwner(this)), be;
              } : function() {
                return a.read(arguments, 0, {
                  readNull: ue === "highlight",
                  clone: !0
                });
              } : function(be) {
                return be == null || isNaN(be) ? 0 : +be;
              };
              this["get" + M] = function() {
                return this._type === X || q && /^hs[bl]$/.test(this._type) ? this._components[pe] : this._convert(X)[pe];
              }, this["set" + M] = function(be) {
                this._type !== X && !(q && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(X), this._properties = e[X], this._type = X), this._components[pe] = K.call(this, be), this._changed();
              };
            }, this);
          }, {
            _class: "Color",
            _readIndex: !0,
            initialize: function H(X) {
              var ue = arguments, pe = this.__read, M = 0, q, K, be, te;
              Array.isArray(X) && (ue = X, X = ue[0]);
              var he = X != null && typeof X;
              if (he === "string" && X in e && (q = X, X = ue[1], Array.isArray(X) ? (K = X, be = ue[2]) : (pe && (M = 1), ue = _.slice(ue, 1), he = typeof X)), !K) {
                if (te = he === "number" ? ue : he === "object" && X.length != null ? X : null, te) {
                  q || (q = te.length >= 3 ? "rgb" : "gray");
                  var D = e[q].length;
                  be = te[D], pe && (M += te === arguments ? D + (be != null ? 1 : 0) : 1), te.length > D && (te = _.slice(te, 0, D));
                } else if (he === "string") {
                  var Se = I(X);
                  q = Se[0], K = Se[1], K.length === 4 && (be = K[3], K.length--);
                } else if (he === "object")
                  if (X.constructor === H) {
                    if (q = X._type, K = X._components.slice(), be = X._alpha, q === "gradient")
                      for (var le = 1, m = K.length; le < m; le++) {
                        var oe = K[le];
                        oe && (K[le] = oe.clone());
                      }
                  } else if (X.constructor === Ee)
                    q = "gradient", te = ue;
                  else {
                    q = "hue" in X ? "lightness" in X ? "hsl" : "hsb" : "gradient" in X || "stops" in X || "radial" in X ? "gradient" : "gray" in X ? "gray" : "rgb";
                    var me = e[q], O = r[q];
                    this._components = K = [];
                    for (var le = 0, m = me.length; le < m; le++) {
                      var ce = X[me[le]];
                      ce == null && !le && q === "gradient" && "stops" in X && (ce = {
                        stops: X.stops,
                        radial: X.radial
                      }), ce = O[le].call(this, ce), ce != null && (K[le] = ce);
                    }
                    be = X.alpha;
                  }
                pe && q && (M = 1);
              }
              if (this._type = q || "rgb", !K) {
                this._components = K = [];
                for (var O = r[this._type], le = 0, m = O.length; le < m; le++) {
                  var ce = O[le].call(this, te && te[le]);
                  ce != null && (K[le] = ce);
                }
              }
              return this._components = K, this._properties = e[this._type], this._alpha = be, pe && (this.__read = M), this;
            },
            set: "#initialize",
            _serialize: function(H, X) {
              var ue = this.getComponents();
              return _.serialize(
                /^(gray|rgb)$/.test(this._type) ? ue : [this._type].concat(ue),
                H,
                !0,
                X
              );
            },
            _changed: function() {
              this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
            },
            _convert: function(H) {
              var X;
              return this._type === H ? this._components.slice() : (X = j[this._type + "-" + H]) ? X.apply(this, this._components) : j["rgb-" + H].apply(
                this,
                j[this._type + "-rgb"].apply(
                  this,
                  this._components
                )
              );
            },
            convert: function(H) {
              return new xe(H, this._convert(H), this._alpha);
            },
            getType: function() {
              return this._type;
            },
            setType: function(H) {
              this._components = this._convert(H), this._properties = e[H], this._type = H;
            },
            getComponents: function() {
              var H = this._components.slice();
              return this._alpha != null && H.push(this._alpha), H;
            },
            getAlpha: function() {
              return this._alpha != null ? this._alpha : 1;
            },
            setAlpha: function(H) {
              this._alpha = H == null ? null : Math.min(Math.max(H, 0), 1), this._changed();
            },
            hasAlpha: function() {
              return this._alpha != null;
            },
            equals: function(H) {
              var X = _.isPlainValue(H, !0) ? xe.read(arguments) : H;
              return X === this || X && this._class === X._class && this._type === X._type && this.getAlpha() === X.getAlpha() && _.equals(this._components, X._components) || !1;
            },
            toString: function() {
              for (var H = this._properties, X = [], ue = this._type === "gradient", pe = d.instance, M = 0, q = H.length; M < q; M++) {
                var K = this._components[M];
                K != null && X.push(H[M] + ": " + (ue ? K : pe.number(K)));
              }
              return this._alpha != null && X.push("alpha: " + pe.number(this._alpha)), "{ " + X.join(", ") + " }";
            },
            toCSS: function(H) {
              var X = this._convert("rgb"), ue = H || this._alpha == null ? 1 : this._alpha;
              function pe(M) {
                return Math.round((M < 0 ? 0 : M > 1 ? 1 : M) * 255);
              }
              return X = [
                pe(X[0]),
                pe(X[1]),
                pe(X[2])
              ], ue < 1 && X.push(ue < 0 ? 0 : ue), H ? "#" + ((1 << 24) + (X[0] << 16) + (X[1] << 8) + X[2]).toString(16).slice(1) : (X.length == 4 ? "rgba(" : "rgb(") + X.join(",") + ")";
            },
            toCanvasStyle: function(H, X) {
              if (this._canvasStyle)
                return this._canvasStyle;
              if (this._type !== "gradient")
                return this._canvasStyle = this.toCSS();
              var ue = this._components, pe = ue[0], M = pe._stops, q = ue[1], K = ue[2], be = ue[3], te = X && X.inverted(), he;
              if (te && (q = te._transformPoint(q), K = te._transformPoint(K), be && (be = te._transformPoint(be))), pe._radial) {
                var D = K.getDistance(q);
                if (be) {
                  var Se = be.subtract(q);
                  Se.getLength() > D && (be = q.add(Se.normalize(D - 0.1)));
                }
                var le = be || q;
                he = H.createRadialGradient(
                  le.x,
                  le.y,
                  0,
                  q.x,
                  q.y,
                  D
                );
              } else
                he = H.createLinearGradient(
                  q.x,
                  q.y,
                  K.x,
                  K.y
                );
              for (var m = 0, oe = M.length; m < oe; m++) {
                var me = M[m], O = me._offset;
                he.addColorStop(
                  O ?? m / (oe - 1),
                  me._color.toCanvasStyle()
                );
              }
              return this._canvasStyle = he;
            },
            transform: function(H) {
              if (this._type === "gradient") {
                for (var X = this._components, ue = 1, pe = X.length; ue < pe; ue++) {
                  var M = X[ue];
                  H._transformPoint(M, M, !0);
                }
                this._changed();
              }
            },
            statics: {
              _types: e,
              random: function() {
                var H = Math.random;
                return new xe(H(), H(), H());
              },
              _setOwner: function(H, X, ue) {
                return H && (H._owner && X && H._owner !== X && (H = H.clone()), !H._owner ^ !X && (H._owner = X || null, H._setter = ue || null)), H;
              }
            }
          });
        }(),
        new function() {
          var e = {
            add: function(r, h) {
              return r + h;
            },
            subtract: function(r, h) {
              return r - h;
            },
            multiply: function(r, h) {
              return r * h;
            },
            divide: function(r, h) {
              return r / h;
            }
          };
          return _.each(e, function(r, h) {
            this[h] = function(k) {
              k = xe.read(arguments);
              for (var I = this._type, B = this._components, j = k._convert(I), H = 0, X = B.length; H < X; H++)
                j[H] = r(B[H], j[H]);
              return new xe(
                I,
                j,
                this._alpha != null ? r(this._alpha, k.getAlpha()) : null
              );
            };
          }, {});
        }()
      ), Ee = _.extend({
        _class: "Gradient",
        initialize: function(r, h) {
          this._id = u.get(), r && _.isPlainObject(r) && (this.set(r), r = h = null), this._stops == null && this.setStops(r || ["white", "black"]), this._radial == null && this.setRadial(typeof h == "string" && h === "radial" || h || !1);
        },
        _serialize: function(e, r) {
          return r.add(this, function() {
            return _.serialize(
              [this._stops, this._radial],
              e,
              !0,
              r
            );
          });
        },
        _changed: function() {
          for (var e = 0, r = this._owners && this._owners.length; e < r; e++)
            this._owners[e]._changed();
        },
        _addOwner: function(e) {
          this._owners || (this._owners = []), this._owners.push(e);
        },
        _removeOwner: function(e) {
          var r = this._owners ? this._owners.indexOf(e) : -1;
          r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = ne));
        },
        clone: function() {
          for (var e = [], r = 0, h = this._stops.length; r < h; r++)
            e[r] = this._stops[r].clone();
          return new Ee(e, this._radial);
        },
        getStops: function() {
          return this._stops;
        },
        setStops: function(e) {
          if (e.length < 2)
            throw new Error(
              "Gradient stop list needs to contain at least two stops."
            );
          var r = this._stops;
          if (r)
            for (var h = 0, k = r.length; h < k; h++)
              r[h]._owner = ne;
          r = this._stops = Ie.readList(e, 0, { clone: !0 });
          for (var h = 0, k = r.length; h < k; h++)
            r[h]._owner = this;
          this._changed();
        },
        getRadial: function() {
          return this._radial;
        },
        setRadial: function(e) {
          this._radial = e, this._changed();
        },
        equals: function(e) {
          if (e === this)
            return !0;
          if (e && this._class === e._class) {
            var r = this._stops, h = e._stops, k = r.length;
            if (k === h.length) {
              for (var I = 0; I < k; I++)
                if (!r[I].equals(h[I]))
                  return !1;
              return !0;
            }
          }
          return !1;
        }
      }), Ie = _.extend({
        _class: "GradientStop",
        initialize: function(r, h) {
          var k = r, I = h;
          typeof r == "object" && h === ne && (Array.isArray(r) && typeof r[0] != "number" ? (k = r[0], I = r[1]) : ("color" in r || "offset" in r || "rampPoint" in r) && (k = r.color, I = r.offset || r.rampPoint || 0)), this.setColor(k), this.setOffset(I);
        },
        clone: function() {
          return new Ie(this._color.clone(), this._offset);
        },
        _serialize: function(e, r) {
          var h = this._color, k = this._offset;
          return _.serialize(
            k == null ? [h] : [h, k],
            e,
            !0,
            r
          );
        },
        _changed: function() {
          this._owner && this._owner._changed(129);
        },
        getOffset: function() {
          return this._offset;
        },
        setOffset: function(e) {
          this._offset = e, this._changed();
        },
        getRampPoint: "#getOffset",
        setRampPoint: "#setOffset",
        getColor: function() {
          return this._color;
        },
        setColor: function() {
          xe._setOwner(this._color, null), this._color = xe._setOwner(
            xe.read(arguments, 0),
            this,
            "setColor"
          ), this._changed();
        },
        equals: function(e) {
          return e === this || e && this._class === e._class && this._color.equals(e._color) && this._offset == e._offset || !1;
        }
      }), je = _.extend(new function() {
        var e = {
          fillColor: null,
          fillRule: "nonzero",
          strokeColor: null,
          strokeWidth: 1,
          strokeCap: "butt",
          strokeJoin: "miter",
          strokeScaling: !0,
          miterLimit: 10,
          dashOffset: 0,
          dashArray: [],
          shadowColor: null,
          shadowBlur: 0,
          shadowOffset: new a(),
          selectedColor: null
        }, r = _.set({}, e, {
          fontFamily: "sans-serif",
          fontWeight: "normal",
          fontSize: 12,
          leading: null,
          justification: "left"
        }), h = _.set({}, r, {
          fillColor: new xe()
        }), k = {
          strokeWidth: 193,
          strokeCap: 193,
          strokeJoin: 193,
          strokeScaling: 201,
          miterLimit: 193,
          fontFamily: 9,
          fontWeight: 9,
          fontSize: 9,
          font: 9,
          leading: 9,
          justification: 9
        }, I = {
          beans: !0
        }, B = {
          _class: "Style",
          beans: !0,
          initialize: function(H, X, ue) {
            this._values = {}, this._owner = X, this._project = X && X._project || ue || Ae.project, this._defaults = !X || X instanceof A ? r : X instanceof Pe ? h : e, H && this.set(H);
          }
        };
        return _.each(r, function(j, H) {
          var X = /Color$/.test(H), ue = H === "shadowOffset", pe = _.capitalize(H), M = k[H], q = "set" + pe, K = "get" + pe;
          B[q] = function(be) {
            var te = this._owner, he = te && te._children, D = he && he.length > 0 && !(te instanceof de);
            if (D)
              for (var Se = 0, le = he.length; Se < le; Se++)
                he[Se]._style[q](be);
            if ((H === "selectedColor" || !D) && H in this._defaults) {
              var m = this._values[H];
              m !== be && (X && (m && (xe._setOwner(m, null), m._canvasStyle = null), be && be.constructor === xe && (be = xe._setOwner(
                be,
                te,
                D && q
              ))), this._values[H] = be, te && te._changed(M || 129));
            }
          }, B[K] = function(be) {
            var te = this._owner, he = te && te._children, D = he && he.length > 0 && !(te instanceof de), Se;
            if (D && !be)
              for (var le = 0, m = he.length; le < m; le++) {
                var oe = he[le]._style[K]();
                if (!le)
                  Se = oe;
                else if (!_.equals(Se, oe))
                  return ne;
              }
            else if (H in this._defaults) {
              var Se = this._values[H];
              if (Se === ne)
                Se = this._defaults[H], Se && Se.clone && (Se = Se.clone());
              else {
                var me = X ? xe : ue ? a : null;
                me && !(Se && Se.constructor === me) && (this._values[H] = Se = me.read(
                  [Se],
                  0,
                  { readNull: !0, clone: !0 }
                ));
              }
            }
            return Se && X && (Se = xe._setOwner(Se, te, D && q)), Se;
          }, I[K] = function(be) {
            return this._style[K](be);
          }, I[q] = function(be) {
            this._style[q](be);
          };
        }), _.each({
          Font: "FontFamily",
          WindingRule: "FillRule"
        }, function(j, H) {
          var X = "get" + H, ue = "set" + H;
          B[X] = I[X] = "#get" + j, B[ue] = I[ue] = "#set" + j;
        }), o.inject(I), B;
      }(), {
        set: function(e) {
          var r = e instanceof je, h = r ? e._values : e;
          if (h) {
            for (var k in h)
              if (k in this._defaults) {
                var I = h[k];
                this[k] = I && r && I.clone ? I.clone() : I;
              }
          }
        },
        equals: function(e) {
          function r(h, k, I) {
            var B = h._values, j = k._values, H = k._defaults;
            for (var X in B) {
              var ue = B[X], pe = j[X];
              if (!(I && X in j) && !_.equals(
                ue,
                pe === ne ? H[X] : pe
              ))
                return !1;
            }
            return !0;
          }
          return e === this || e && this._class === e._class && r(this, e) && r(e, this, !0) || !1;
        },
        _dispose: function() {
          var e;
          e = this.getFillColor(), e && (e._canvasStyle = null), e = this.getStrokeColor(), e && (e._canvasStyle = null), e = this.getShadowColor(), e && (e._canvasStyle = null);
        },
        hasFill: function() {
          var e = this.getFillColor();
          return !!e && e.alpha > 0;
        },
        hasStroke: function() {
          var e = this.getStrokeColor();
          return !!e && e.alpha > 0 && this.getStrokeWidth() > 0;
        },
        hasShadow: function() {
          var e = this.getShadowColor();
          return !!e && e.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
        },
        getView: function() {
          return this._project._view;
        },
        getFontStyle: function() {
          var e = this.getFontSize();
          return this.getFontWeight() + " " + e + (/[a-z]/i.test(e + "") ? " " : "px ") + this.getFontFamily();
        },
        getFont: "#getFontFamily",
        setFont: "#setFontFamily",
        getLeading: function e() {
          var r = e.base.call(this), h = this.getFontSize();
          return /pt|em|%|px/.test(h) && (h = this.getView().getPixelSize(h)), r ?? h * 1.2;
        }
      }), Ue = new function() {
        function e(r, h, k, I) {
          for (var B = ["", "webkit", "moz", "Moz", "ms", "o"], j = h[0].toUpperCase() + h.substring(1), H = 0; H < 6; H++) {
            var X = B[H], ue = X ? X + j : h;
            if (ue in r) {
              if (k)
                r[ue] = I;
              else
                return r[ue];
              break;
            }
          }
        }
        return {
          getStyles: function(r) {
            var h = r && r.nodeType !== 9 ? r.ownerDocument : r, k = h && h.defaultView;
            return k && k.getComputedStyle(r, "");
          },
          getBounds: function(r, h) {
            var k = r.ownerDocument, I = k.body, B = k.documentElement, j;
            try {
              j = r.getBoundingClientRect();
            } catch {
              j = { left: 0, top: 0, width: 0, height: 0 };
            }
            var H = j.left - (B.clientLeft || I.clientLeft || 0), X = j.top - (B.clientTop || I.clientTop || 0);
            if (!h) {
              var ue = k.defaultView;
              H += ue.pageXOffset || B.scrollLeft || I.scrollLeft, X += ue.pageYOffset || B.scrollTop || I.scrollTop;
            }
            return new f(H, X, j.width, j.height);
          },
          getViewportBounds: function(r) {
            var h = r.ownerDocument, k = h.defaultView, I = h.documentElement;
            return new f(
              0,
              0,
              k.innerWidth || I.clientWidth,
              k.innerHeight || I.clientHeight
            );
          },
          getOffset: function(r, h) {
            return Ue.getBounds(r, h).getPoint();
          },
          getSize: function(r) {
            return Ue.getBounds(r, !0).getSize();
          },
          isInvisible: function(r) {
            return Ue.getSize(r).equals(new c(0, 0));
          },
          isInView: function(r) {
            return !Ue.isInvisible(r) && Ue.getViewportBounds(r).intersects(
              Ue.getBounds(r, !0)
            );
          },
          isInserted: function(r) {
            return Z.body.contains(r);
          },
          getPrefixed: function(r, h) {
            return r && e(r, h);
          },
          setPrefixed: function(r, h, k) {
            if (typeof h == "object")
              for (var I in h)
                e(r, I, !0, h[I]);
            else
              e(r, h, !0, k);
          }
        };
      }(), He = {
        add: function(e, r) {
          if (e)
            for (var h in r)
              for (var k = r[h], I = h.split(/[\s,]+/g), B = 0, j = I.length; B < j; B++) {
                var H = I[B], X = e === Z && (H === "touchstart" || H === "touchmove") ? { passive: !1 } : !1;
                e.addEventListener(H, k, X);
              }
        },
        remove: function(e, r) {
          if (e)
            for (var h in r)
              for (var k = r[h], I = h.split(/[\s,]+/g), B = 0, j = I.length; B < j; B++)
                e.removeEventListener(I[B], k, !1);
        },
        getPoint: function(e) {
          var r = e.targetTouches ? e.targetTouches.length ? e.targetTouches[0] : e.changedTouches[0] : e;
          return new a(
            r.pageX || r.clientX + Z.documentElement.scrollLeft,
            r.pageY || r.clientY + Z.documentElement.scrollTop
          );
        },
        getTarget: function(e) {
          return e.target || e.srcElement;
        },
        getRelatedTarget: function(e) {
          return e.relatedTarget || e.toElement;
        },
        getOffset: function(e, r) {
          return He.getPoint(e).subtract(Ue.getOffset(
            r || He.getTarget(e)
          ));
        }
      };
      He.requestAnimationFrame = new function() {
        var e = Ue.getPrefixed(C, "requestAnimationFrame"), r = !1, h = [], k;
        function I() {
          var B = h;
          h = [];
          for (var j = 0, H = B.length; j < H; j++)
            B[j]();
          r = e && h.length, r && e(I);
        }
        return function(B) {
          h.push(B), e ? r || (e(I), r = !0) : k || (k = setInterval(I, 1e3 / 60));
        };
      }();
      var Ze = _.extend(
        P,
        {
          _class: "View",
          initialize: function e(r, h) {
            function k(M) {
              return h[M] || parseInt(h.getAttribute(M), 10);
            }
            function I() {
              var M = Ue.getSize(h);
              return M.isNaN() || M.isZero() ? new c(k("width"), k("height")) : M;
            }
            var B;
            if (C && h) {
              this._id = h.getAttribute("id"), this._id == null && h.setAttribute("id", this._id = "paper-view-" + e._id++), He.add(h, this._viewEvents);
              var j = "none";
              if (Ue.setPrefixed(h.style, {
                userDrag: j,
                userSelect: j,
                touchCallout: j,
                contentZooming: j,
                tapHighlightColor: "rgba(0,0,0,0)"
              }), x.hasAttribute(h, "resize")) {
                var H = this;
                He.add(C, this._windowEvents = {
                  resize: function() {
                    H.setViewSize(I());
                  }
                });
              }
              if (B = I(), x.hasAttribute(h, "stats") && typeof Stats < "u") {
                this._stats = new Stats();
                var X = this._stats.domElement, ue = X.style, pe = Ue.getOffset(h);
                ue.position = "absolute", ue.left = pe.x + "px", ue.top = pe.y + "px", Z.body.appendChild(X);
              }
            } else
              B = new c(h), h = null;
            this._project = r, this._scope = r._scope, this._element = h, this._pixelRatio || (this._pixelRatio = C && C.devicePixelRatio || 1), this._setElementSize(B.width, B.height), this._viewSize = B, e._views.push(this), e._viewsById[this._id] = this, (this._matrix = new s())._owner = this, e._focused || (e._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !Ae.agent.node, this._needsUpdate = !1;
          },
          remove: function() {
            if (!this._project)
              return !1;
            Ze._focused === this && (Ze._focused = null), Ze._views.splice(Ze._views.indexOf(this), 1), delete Ze._viewsById[this._id];
            var e = this._project;
            return e._view === this && (e._view = null), He.remove(this._element, this._viewEvents), He.remove(C, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
          },
          _events: _.each(
            o._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
            function(e) {
              this[e] = {};
            },
            {
              onFrame: {
                install: function() {
                  this.play();
                },
                uninstall: function() {
                  this.pause();
                }
              }
            }
          ),
          _animate: !1,
          _time: 0,
          _count: 0,
          getAutoUpdate: function() {
            return this._autoUpdate;
          },
          setAutoUpdate: function(e) {
            this._autoUpdate = e, e && this.requestUpdate();
          },
          update: function() {
          },
          draw: function() {
            this.update();
          },
          requestUpdate: function() {
            if (!this._requested) {
              var e = this;
              He.requestAnimationFrame(function() {
                if (e._requested = !1, e._animate) {
                  e.requestUpdate();
                  var r = e._element;
                  (!Ue.getPrefixed(Z, "hidden") || x.getAttribute(r, "keepalive") === "true") && Ue.isInView(r) && e._handleFrame();
                }
                e._autoUpdate && e.update();
              }), this._requested = !0;
            }
          },
          play: function() {
            this._animate = !0, this.requestUpdate();
          },
          pause: function() {
            this._animate = !1;
          },
          _handleFrame: function() {
            Ae = this._scope;
            var e = Date.now() / 1e3, r = this._last ? e - this._last : 0;
            this._last = e, this.emit("frame", new _({
              delta: r,
              time: this._time += r,
              count: this._count++
            })), this._stats && this._stats.update();
          },
          _animateItem: function(e, r) {
            var h = this._frameItems;
            r ? (h[e._id] = {
              item: e,
              time: 0,
              count: 0
            }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete h[e._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
          },
          _handleFrameItems: function(e) {
            for (var r in this._frameItems) {
              var h = this._frameItems[r];
              h.item.emit("frame", new _(e, {
                time: h.time += e.delta,
                count: h.count++
              }));
            }
          },
          _changed: function() {
            this._project._changed(4097), this._bounds = this._decomposed = ne;
          },
          getElement: function() {
            return this._element;
          },
          getPixelRatio: function() {
            return this._pixelRatio;
          },
          getResolution: function() {
            return this._pixelRatio * 72;
          },
          getViewSize: function() {
            var e = this._viewSize;
            return new g(e.width, e.height, this, "setViewSize");
          },
          setViewSize: function() {
            var e = c.read(arguments), r = e.subtract(this._viewSize);
            r.isZero() || (this._setElementSize(e.width, e.height), this._viewSize.set(e), this._changed(), this.emit("resize", { size: e, delta: r }), this._autoUpdate && this.update());
          },
          _setElementSize: function(e, r) {
            var h = this._element;
            h && (h.width !== e && (h.width = e), h.height !== r && (h.height = r));
          },
          getBounds: function() {
            return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
              new f(new a(), this._viewSize)
            )), this._bounds;
          },
          getSize: function() {
            return this.getBounds().getSize();
          },
          isVisible: function() {
            return Ue.isInView(this._element);
          },
          isInserted: function() {
            return Ue.isInserted(this._element);
          },
          getPixelSize: function(e) {
            var r = this._element, h;
            if (r) {
              var k = r.parentNode, I = Z.createElement("div");
              I.style.fontSize = e, k.appendChild(I), h = parseFloat(Ue.getStyles(I).fontSize), k.removeChild(I);
            } else
              h = parseFloat(h);
            return h;
          },
          getTextWidth: function(e, r) {
            return 0;
          }
        },
        _.each(["rotate", "scale", "shear", "skew"], function(e) {
          var r = e === "rotate";
          this[e] = function() {
            var h = arguments, k = (r ? _ : a).read(h), I = a.read(h, 0, { readNull: !0 });
            return this.transform(new s()[e](
              k,
              I || this.getCenter(!0)
            ));
          };
        }, {
          _decompose: function() {
            return this._decomposed || (this._decomposed = this._matrix.decompose());
          },
          translate: function() {
            var e = new s();
            return this.transform(e.translate.apply(e, arguments));
          },
          getCenter: function() {
            return this.getBounds().getCenter();
          },
          setCenter: function() {
            var e = a.read(arguments);
            this.translate(this.getCenter().subtract(e));
          },
          getZoom: function() {
            var e = this._decompose().scaling;
            return (e.x + e.y) / 2;
          },
          setZoom: function(e) {
            this.transform(new s().scale(
              e / this.getZoom(),
              this.getCenter()
            ));
          },
          getRotation: function() {
            return this._decompose().rotation;
          },
          setRotation: function(e) {
            var r = this.getRotation();
            r != null && e != null && this.rotate(e - r);
          },
          getScaling: function() {
            var e = this._decompose().scaling;
            return new n(e.x, e.y, this, "setScaling");
          },
          setScaling: function() {
            var e = this.getScaling(), r = a.read(arguments, 0, { clone: !0, readNull: !0 });
            e && r && this.scale(r.x / e.x, r.y / e.y);
          },
          getMatrix: function() {
            return this._matrix;
          },
          setMatrix: function() {
            var e = this._matrix;
            e.set.apply(e, arguments);
          },
          transform: function(e) {
            this._matrix.append(e);
          },
          scrollBy: function() {
            this.translate(a.read(arguments).negate());
          }
        }),
        {
          projectToView: function() {
            return this._matrix._transformPoint(a.read(arguments));
          },
          viewToProject: function() {
            return this._matrix._inverseTransform(a.read(arguments));
          },
          getEventPoint: function(e) {
            return this.viewToProject(He.getOffset(e, this._element));
          }
        },
        {
          statics: {
            _views: [],
            _viewsById: {},
            _id: 0,
            create: function(e, r) {
              Z && typeof r == "string" && (r = Z.getElementById(r));
              var h = C ? $e : Ze;
              return new h(e, r);
            }
          }
        },
        new function() {
          if (!C)
            return;
          var e, r, h = !1, k = !1;
          function I(Fe) {
            var Ye = He.getTarget(Fe);
            return Ye.getAttribute && Ze._viewsById[Ye.getAttribute("id")];
          }
          function B() {
            var Fe = Ze._focused;
            if (!Fe || !Fe.isVisible()) {
              for (var Ye = 0, Ke = Ze._views.length; Ye < Ke; Ye++)
                if ((Fe = Ze._views[Ye]).isVisible()) {
                  Ze._focused = r = Fe;
                  break;
                }
            }
          }
          function j(Fe, Ye, Ke) {
            Fe._handleMouseEvent("mousemove", Ye, Ke);
          }
          var H = C.navigator, X, ue, pe;
          H.pointerEnabled || H.msPointerEnabled ? (X = "pointerdown MSPointerDown", ue = "pointermove MSPointerMove", pe = "pointerup pointercancel MSPointerUp MSPointerCancel") : (X = "touchstart", ue = "touchmove", pe = "touchend touchcancel", "ontouchstart" in C && H.userAgent.match(
            /mobile|tablet|ip(ad|hone|od)|android|silk/i
          ) || (X += " mousedown", ue += " mousemove", pe += " mouseup"));
          var M = {}, q = {
            mouseout: function(Fe) {
              var Ye = Ze._focused, Ke = He.getRelatedTarget(Fe);
              if (Ye && (!Ke || Ke.nodeName === "HTML")) {
                var et = He.getOffset(Fe, Ye._element), Je = et.x, nt = Math.abs, pt = nt(Je), vt = 1 << 25, bt = pt - vt;
                et.x = nt(bt) < pt ? bt * (Je < 0 ? -1 : 1) : Je, j(Ye, Fe, Ye.viewToProject(et));
              }
            },
            scroll: B
          };
          M[X] = function(Fe) {
            var Ye = Ze._focused = I(Fe);
            h || (h = !0, Ye._handleMouseEvent("mousedown", Fe));
          }, q[ue] = function(Fe) {
            var Ye = Ze._focused;
            if (!k) {
              var Ke = I(Fe);
              Ke ? Ye !== Ke && (Ye && j(Ye, Fe), e || (e = Ye), Ye = Ze._focused = r = Ke) : r && r === Ye && (e && !e.isInserted() && (e = null), Ye = Ze._focused = e, e = null, B());
            }
            Ye && j(Ye, Fe);
          }, q[X] = function() {
            k = !0;
          }, q[pe] = function(Fe) {
            var Ye = Ze._focused;
            Ye && h && Ye._handleMouseEvent("mouseup", Fe), k = h = !1;
          }, He.add(Z, q), He.add(C, {
            load: B
          });
          var K = !1, be = !1, te = {
            doubleclick: "click",
            mousedrag: "mousemove"
          }, he = !1, D, Se, le, m, oe, me, O, ce;
          function Oe(Fe, Ye, Ke, et, Je, nt, pt) {
            var vt = !1, bt;
            function At(ot, ct) {
              if (ot.responds(ct)) {
                if (bt || (bt = new De(
                  ct,
                  et,
                  Je,
                  Ye || ot,
                  nt ? Je.subtract(nt) : null
                )), ot.emit(ct, bt) && (K = !0, bt.prevented && (be = !0), bt.stopped))
                  return vt = !0;
              } else {
                var gt = te[ct];
                if (gt)
                  return At(ot, gt);
              }
            }
            for (; Fe && Fe !== pt && !At(Fe, Ke); )
              Fe = Fe._parent;
            return vt;
          }
          function Be(Fe, Ye, Ke, et, Je, nt) {
            return Fe._project.removeOn(Ke), be = K = !1, oe && Oe(
              oe,
              null,
              Ke,
              et,
              Je,
              nt
            ) || Ye && Ye !== oe && !Ye.isDescendant(oe) && Oe(Ye, null, Ke === "mousedrag" ? "mousemove" : Ke, et, Je, nt, oe) || Oe(
              Fe,
              oe || Ye || Fe,
              Ke,
              et,
              Je,
              nt
            );
          }
          var Ge = {
            mousedown: {
              mousedown: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mouseup: {
              mouseup: 1,
              mousedrag: 1,
              click: 1,
              doubleclick: 1
            },
            mousemove: {
              mousedrag: 1,
              mousemove: 1,
              mouseenter: 1,
              mouseleave: 1
            }
          };
          return {
            _viewEvents: M,
            _handleMouseEvent: function(Fe, Ye, Ke) {
              var et = this._itemEvents, Je = et.native[Fe], nt = Fe === "mousemove", pt = this._scope.tool, vt = this;
              function bt(Ot) {
                return et.virtual[Ot] || vt.responds(Ot) || pt && pt.responds(Ot);
              }
              nt && h && bt("mousedrag") && (Fe = "mousedrag"), Ke || (Ke = this.getEventPoint(Ye));
              var At = this.getBounds().contains(Ke), ot = Je && At && vt._project.hitTest(Ke, {
                tolerance: 0,
                fill: !0,
                stroke: !0
              }), ct = ot && ot.item || null, gt = !1, Ct = {};
              if (Ct[Fe.substr(5)] = !0, Je && ct !== m && (m && Oe(m, null, "mouseleave", Ye, Ke), ct && Oe(ct, null, "mouseenter", Ye, Ke), m = ct), he ^ At && (Oe(
                this,
                null,
                At ? "mouseenter" : "mouseleave",
                Ye,
                Ke
              ), gt = !0), (At || Ct.drag) && !Ke.equals(Se) && (Be(
                this,
                ct,
                nt ? Fe : "mousemove",
                Ye,
                Ke,
                Se
              ), gt = !0), he = At, Ct.down && At || Ct.up && D) {
                if (Be(this, ct, Fe, Ye, Ke, D), Ct.down) {
                  if (ce = ct === me && Date.now() - O < 300, le = me = ct, !be && ct) {
                    for (var xt = ct; xt && !xt.responds("mousedrag"); )
                      xt = xt._parent;
                    xt && (oe = ct);
                  }
                  D = Ke;
                } else Ct.up && (!be && ct === le && (O = Date.now(), Be(this, ct, ce ? "doubleclick" : "click", Ye, Ke, D), ce = !1), le = oe = null);
                he = !1, gt = !0;
              }
              Se = Ke, gt && pt && (K = pt._handleMouseEvent(Fe, Ye, Ke, Ct) || K), Ye.cancelable !== !1 && (K && !Ct.move || Ct.down && bt("mouseup")) && Ye.preventDefault();
            },
            _handleKeyEvent: function(Fe, Ye, Ke, et) {
              var Je = this._scope, nt = Je.tool, pt;
              function vt(bt) {
                bt.responds(Fe) && (Ae = Je, bt.emit(Fe, pt = pt || new Ve(Fe, Ye, Ke, et)));
              }
              this.isVisible() && (vt(this), nt && nt.responds(Fe) && vt(nt));
            },
            _countItemEvent: function(Fe, Ye) {
              var Ke = this._itemEvents, et = Ke.native, Je = Ke.virtual;
              for (var nt in Ge)
                et[nt] = (et[nt] || 0) + (Ge[nt][Fe] || 0) * Ye;
              Je[Fe] = (Je[Fe] || 0) + Ye;
            },
            statics: {
              updateFocus: B,
              _resetState: function() {
                h = k = K = he = !1, e = r = D = Se = le = m = oe = me = O = ce = null;
              }
            }
          };
        }()
      ), $e = Ze.extend({
        _class: "CanvasView",
        initialize: function(r, h) {
          if (!(h instanceof C.HTMLCanvasElement)) {
            var k = c.read(arguments, 1);
            if (k.isZero())
              throw new Error(
                "Cannot create CanvasView with the provided argument: " + _.slice(arguments, 1)
              );
            h = Ce.getCanvas(k);
          }
          var I = this._context = h.getContext("2d");
          if (I.save(), this._pixelRatio = 1, !/^off|false$/.test(x.getAttribute(h, "hidpi"))) {
            var B = C.devicePixelRatio || 1, j = Ue.getPrefixed(
              I,
              "backingStorePixelRatio"
            ) || 1;
            this._pixelRatio = B / j;
          }
          Ze.call(this, r, h), this._needsUpdate = !0;
        },
        remove: function e() {
          return this._context.restore(), e.base.call(this);
        },
        _setElementSize: function e(r, h) {
          var k = this._pixelRatio;
          if (e.base.call(this, r * k, h * k), k !== 1) {
            var I = this._element, B = this._context;
            if (!x.hasAttribute(I, "resize")) {
              var j = I.style;
              j.width = r + "px", j.height = h + "px";
            }
            B.restore(), B.save(), B.scale(k, k);
          }
        },
        getContext: function() {
          return this._context;
        },
        getPixelSize: function e(r) {
          var h = Ae.agent, k;
          if (h && h.firefox)
            k = e.base.call(this, r);
          else {
            var I = this._context, B = I.font;
            I.font = r + " serif", k = parseFloat(I.font), I.font = B;
          }
          return k;
        },
        getTextWidth: function(e, r) {
          var h = this._context, k = h.font, I = 0;
          h.font = e;
          for (var B = 0, j = r.length; B < j; B++)
            I = Math.max(I, h.measureText(r[B]).width);
          return h.font = k, I;
        },
        update: function() {
          if (!this._needsUpdate)
            return !1;
          var e = this._project, r = this._context, h = this._viewSize;
          return r.clearRect(0, 0, h.width + 1, h.height + 1), e && e.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
        }
      }), We = _.extend({
        _class: "Event",
        initialize: function(r) {
          this.event = r, this.type = r && r.type;
        },
        prevented: !1,
        stopped: !1,
        preventDefault: function() {
          this.prevented = !0, this.event.preventDefault();
        },
        stopPropagation: function() {
          this.stopped = !0, this.event.stopPropagation();
        },
        stop: function() {
          this.stopPropagation(), this.preventDefault();
        },
        getTimeStamp: function() {
          return this.event.timeStamp;
        },
        getModifiers: function() {
          return Re.modifiers;
        }
      }), Ve = We.extend({
        _class: "KeyEvent",
        initialize: function(r, h, k, I) {
          this.type = r, this.event = h, this.key = k, this.character = I;
        },
        toString: function() {
          return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
        }
      }), Re = new function() {
        var e = {
          "	": "tab",
          " ": "space",
          "\b": "backspace",
          "": "delete",
          Spacebar: "space",
          Del: "delete",
          Win: "meta",
          Esc: "escape"
        }, r = {
          tab: "	",
          space: " ",
          enter: "\r"
        }, h = {}, k = {}, I, B, j = new _({
          shift: !1,
          control: !1,
          alt: !1,
          meta: !1,
          capsLock: !1,
          space: !1
        }).inject({
          option: {
            get: function() {
              return this.alt;
            }
          },
          command: {
            get: function() {
              var ue = Ae && Ae.agent;
              return ue && ue.mac ? this.meta : this.control;
            }
          }
        });
        function H(ue) {
          var pe = ue.key || ue.keyIdentifier;
          return pe = /^U\+/.test(pe) ? String.fromCharCode(parseInt(pe.substr(2), 16)) : /^Arrow[A-Z]/.test(pe) ? pe.substr(5) : pe === "Unidentified" || pe === ne ? String.fromCharCode(ue.keyCode) : pe, e[pe] || (pe.length > 1 ? _.hyphenate(pe) : pe.toLowerCase());
        }
        function X(ue, pe, M, q) {
          var K = Ze._focused, be;
          if (h[pe] = ue, ue ? k[pe] = M : delete k[pe], pe.length > 1 && (be = _.camelize(pe)) in j) {
            j[be] = ue;
            var te = Ae && Ae.agent;
            if (be === "meta" && te && te.mac)
              if (ue)
                I = {};
              else {
                for (var he in I)
                  he in k && X(!1, he, I[he], q);
                I = null;
              }
          } else ue && I && (I[pe] = M);
          K && K._handleKeyEvent(
            ue ? "keydown" : "keyup",
            q,
            pe,
            M
          );
        }
        return He.add(Z, {
          keydown: function(ue) {
            var pe = H(ue), M = Ae && Ae.agent;
            pe.length > 1 || M && M.chrome && (ue.altKey || M.mac && ue.metaKey || !M.mac && ue.ctrlKey) ? X(
              !0,
              pe,
              r[pe] || (pe.length > 1 ? "" : pe),
              ue
            ) : B = pe;
          },
          keypress: function(ue) {
            if (B) {
              var pe = H(ue), M = ue.charCode, q = M >= 32 ? String.fromCharCode(M) : pe.length > 1 ? "" : pe;
              pe !== B && (pe = q.toLowerCase()), X(!0, pe, q, ue), B = null;
            }
          },
          keyup: function(ue) {
            var pe = H(ue);
            pe in k && X(!1, pe, k[pe], ue);
          }
        }), He.add(C, {
          blur: function(ue) {
            for (var pe in k)
              X(!1, pe, k[pe], ue);
          }
        }), {
          modifiers: j,
          isDown: function(ue) {
            return !!h[ue];
          }
        };
      }(), De = We.extend({
        _class: "MouseEvent",
        initialize: function(r, h, k, I, B) {
          this.type = r, this.event = h, this.point = k, this.target = I, this.delta = B;
        },
        toString: function() {
          return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
        }
      }), Ne = We.extend({
        _class: "ToolEvent",
        _item: null,
        initialize: function(r, h, k) {
          this.tool = r, this.type = h, this.event = k;
        },
        _choosePoint: function(e, r) {
          return e || (r ? r.clone() : null);
        },
        getPoint: function() {
          return this._choosePoint(this._point, this.tool._point);
        },
        setPoint: function(e) {
          this._point = e;
        },
        getLastPoint: function() {
          return this._choosePoint(this._lastPoint, this.tool._lastPoint);
        },
        setLastPoint: function(e) {
          this._lastPoint = e;
        },
        getDownPoint: function() {
          return this._choosePoint(this._downPoint, this.tool._downPoint);
        },
        setDownPoint: function(e) {
          this._downPoint = e;
        },
        getMiddlePoint: function() {
          return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
        },
        setMiddlePoint: function(e) {
          this._middlePoint = e;
        },
        getDelta: function() {
          return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
        },
        setDelta: function(e) {
          this._delta = e;
        },
        getCount: function() {
          return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
        },
        setCount: function(e) {
          this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = e;
        },
        getItem: function() {
          if (!this._item) {
            var e = this.tool._scope.project.hitTest(this.getPoint());
            if (e) {
              for (var r = e.item, h = r._parent; /^(Group|CompoundPath)$/.test(h._class); )
                r = h, h = h._parent;
              this._item = r;
            }
          }
          return this._item;
        },
        setItem: function(e) {
          this._item = e;
        },
        toString: function() {
          return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
        }
      }), we = y.extend({
        _class: "Tool",
        _list: "tools",
        _reference: "tool",
        _events: [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onMouseMove",
          "onActivate",
          "onDeactivate",
          "onEditOptions",
          "onKeyDown",
          "onKeyUp"
        ],
        initialize: function(r) {
          y.call(this), this._moveCount = -1, this._downCount = -1, this.set(r);
        },
        getMinDistance: function() {
          return this._minDistance;
        },
        setMinDistance: function(e) {
          this._minDistance = e, e != null && this._maxDistance != null && e > this._maxDistance && (this._maxDistance = e);
        },
        getMaxDistance: function() {
          return this._maxDistance;
        },
        setMaxDistance: function(e) {
          this._maxDistance = e, this._minDistance != null && e != null && e < this._minDistance && (this._minDistance = e);
        },
        getFixedDistance: function() {
          return this._minDistance == this._maxDistance ? this._minDistance : null;
        },
        setFixedDistance: function(e) {
          this._minDistance = this._maxDistance = e;
        },
        _handleMouseEvent: function(e, r, h, k) {
          Ae = this._scope, k.drag && !this.responds(e) && (e = "mousemove");
          var I = k.move || k.drag, B = this.responds(e), j = !1, H = this;
          function X(pe, M) {
            var q = h, K = I ? H._point : H._downPoint || q;
            if (I) {
              if (H._moveCount >= 0 && q.equals(K))
                return !1;
              if (K && (pe != null || M != null)) {
                var be = q.subtract(K), te = be.getLength();
                if (te < (pe || 0))
                  return !1;
                M && (q = K.add(be.normalize(
                  Math.min(te, M)
                )));
              }
              H._moveCount++;
            }
            return H._point = q, H._lastPoint = K || q, k.down && (H._moveCount = -1, H._downPoint = q, H._downCount++), !0;
          }
          function ue() {
            B && (j = H.emit(e, new Ne(H, e, r)) || j);
          }
          if (k.down)
            X(), ue();
          else if (k.up)
            X(null, this._maxDistance), ue();
          else if (B)
            for (; X(this._minDistance, this._maxDistance); )
              ue();
          return j;
        }
      }), re = _.extend(P, {
        _class: "Tween",
        statics: {
          easings: new _({
            linear: function(e) {
              return e;
            },
            easeInQuad: function(e) {
              return e * e;
            },
            easeOutQuad: function(e) {
              return e * (2 - e);
            },
            easeInOutQuad: function(e) {
              return e < 0.5 ? 2 * e * e : -1 + 2 * (2 - e) * e;
            },
            easeInCubic: function(e) {
              return e * e * e;
            },
            easeOutCubic: function(e) {
              return --e * e * e + 1;
            },
            easeInOutCubic: function(e) {
              return e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
            },
            easeInQuart: function(e) {
              return e * e * e * e;
            },
            easeOutQuart: function(e) {
              return 1 - --e * e * e * e;
            },
            easeInOutQuart: function(e) {
              return e < 0.5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
            },
            easeInQuint: function(e) {
              return e * e * e * e * e;
            },
            easeOutQuint: function(e) {
              return 1 + --e * e * e * e * e;
            },
            easeInOutQuint: function(e) {
              return e < 0.5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
            }
          })
        },
        initialize: function e(r, h, k, I, B, j) {
          this.object = r;
          var H = typeof B, X = H === "function";
          this.type = X ? H : H === "string" ? B : "linear", this.easing = X ? B : e.easings[this.type], this.duration = I, this.running = !1, this._then = null, this._startTime = null;
          var ue = h || k;
          this._keys = ue ? Object.keys(ue) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = ue && this._getState(h), this._to = ue && this._getState(k), j !== !1 && this.start();
        },
        then: function(e) {
          return this._then = e, this;
        },
        start: function() {
          return this._startTime = null, this.running = !0, this;
        },
        stop: function() {
          return this.running = !1, this;
        },
        update: function(e) {
          if (this.running) {
            e >= 1 && (e = 1, this.running = !1);
            for (var r = this.easing(e), h = this._keys, k = function(pe) {
              return typeof pe == "function" ? pe(r, e) : pe;
            }, I = 0, B = h && h.length; I < B; I++) {
              var j = h[I], H = k(this._from[j]), X = k(this._to[j]), ue = H && X && H.__add && X.__add ? X.__subtract(H).__multiply(r).__add(H) : (X - H) * r + H;
              this._setProperty(this._parsedKeys[j], ue);
            }
            this.responds("update") && this.emit("update", new _({
              progress: e,
              factor: r
            })), !this.running && this._then && this._then(this.object);
          }
          return this;
        },
        _events: {
          onUpdate: {}
        },
        _handleFrame: function(e) {
          var r = this._startTime, h = r ? (e - r) / this.duration : 0;
          r || (this._startTime = e), this.update(h);
        },
        _getState: function(e) {
          for (var r = this._keys, h = {}, k = 0, I = r.length; k < I; k++) {
            var B = r[k], j = this._parsedKeys[B], H = this._getProperty(j), X;
            if (e) {
              var ue = this._resolveValue(H, e[B]);
              this._setProperty(j, ue), X = this._getProperty(j), X = X && X.clone ? X.clone() : X, this._setProperty(j, H);
            } else
              X = H && H.clone ? H.clone() : H;
            h[B] = X;
          }
          return h;
        },
        _resolveValue: function(e, r) {
          if (r) {
            if (Array.isArray(r) && r.length === 2) {
              var h = r[0];
              return h && h.match && h.match(/^[+\-\*\/]=/) ? this._calculate(e, h[0], r[1]) : r;
            } else if (typeof r == "string") {
              var k = r.match(/^[+\-*/]=(.*)/);
              if (k) {
                var I = JSON.parse(k[1].replace(
                  /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                  '"$2": '
                ));
                return this._calculate(e, r[0], I);
              }
            }
          }
          return r;
        },
        _calculate: function(e, r, h) {
          return Ae.PaperScript.calculateBinary(e, r, h);
        },
        _parseKeys: function(e) {
          for (var r = {}, h = 0, k = e.length; h < k; h++) {
            var I = e[h], B = I.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
            r[I] = B.split("/");
          }
          return r;
        },
        _getProperty: function(e, r) {
          for (var h = this.object, k = 0, I = e.length - (r || 0); k < I && h; k++)
            h = h[e[k]];
          return h;
        },
        _setProperty: function(e, r) {
          var h = this._getProperty(e, 1);
          h && (h[e[e.length - 1]] = r);
        }
      }), $ = {
        request: function(e) {
          var r = new ge.XMLHttpRequest();
          return r.open(
            (e.method || "get").toUpperCase(),
            e.url,
            _.pick(e.async, !0)
          ), e.mimeType && r.overrideMimeType(e.mimeType), r.onload = function() {
            var h = r.status;
            h === 0 || h === 200 ? e.onLoad && e.onLoad.call(r, r.responseText) : r.onerror();
          }, r.onerror = function() {
            var h = r.status, k = 'Could not load "' + e.url + '" (Status: ' + h + ")";
            if (e.onError)
              e.onError(k, h);
            else
              throw new Error(k);
          }, r.send(null);
        }
      }, Ce = _.exports.CanvasProvider = {
        canvases: [],
        getCanvas: function(e, r, h) {
          if (!C)
            return null;
          var k, I = !0;
          typeof e == "object" && (r = e.height, e = e.width), this.canvases.length ? k = this.canvases.pop() : (k = Z.createElement("canvas"), I = !1);
          var B = k.getContext("2d", h || {});
          if (!B)
            throw new Error("Canvas " + k + " is unable to provide a 2D context.");
          return k.width === e && k.height === r ? I && B.clearRect(0, 0, e + 1, r + 1) : (k.width = e, k.height = r), B.save(), k;
        },
        getContext: function(e, r, h) {
          var k = this.getCanvas(e, r, h);
          return k ? k.getContext("2d", h || {}) : null;
        },
        release: function(e) {
          var r = e && e.canvas ? e.canvas : e;
          r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
        }
      }, ve = new function() {
        var e = Math.min, r = Math.max, h = Math.abs, k, I, B, j, H, X, ue, pe, M, q, K;
        function be(oe, me, O) {
          return 0.2989 * oe + 0.587 * me + 0.114 * O;
        }
        function te(oe, me, O, Be) {
          var Oe = Be - be(oe, me, O);
          M = oe + Oe, q = me + Oe, K = O + Oe;
          var Be = be(M, q, K), Ge = e(M, q, K), Fe = r(M, q, K);
          if (Ge < 0) {
            var Ye = Be - Ge;
            M = Be + (M - Be) * Be / Ye, q = Be + (q - Be) * Be / Ye, K = Be + (K - Be) * Be / Ye;
          }
          if (Fe > 255) {
            var Ke = 255 - Be, et = Fe - Be;
            M = Be + (M - Be) * Ke / et, q = Be + (q - Be) * Ke / et, K = Be + (K - Be) * Ke / et;
          }
        }
        function he(oe, me, O) {
          return r(oe, me, O) - e(oe, me, O);
        }
        function D(oe, me, O, ce) {
          var Oe = [oe, me, O], Be = r(oe, me, O), Ge = e(oe, me, O), Fe;
          Ge = Ge === oe ? 0 : Ge === me ? 1 : 2, Be = Be === oe ? 0 : Be === me ? 1 : 2, Fe = e(Ge, Be) === 0 ? r(Ge, Be) === 1 ? 2 : 1 : 0, Oe[Be] > Oe[Ge] ? (Oe[Fe] = (Oe[Fe] - Oe[Ge]) * ce / (Oe[Be] - Oe[Ge]), Oe[Be] = ce) : Oe[Fe] = Oe[Be] = 0, Oe[Ge] = 0, M = Oe[0], q = Oe[1], K = Oe[2];
        }
        var Se = {
          multiply: function() {
            M = H * k / 255, q = X * I / 255, K = ue * B / 255;
          },
          screen: function() {
            M = H + k - H * k / 255, q = X + I - X * I / 255, K = ue + B - ue * B / 255;
          },
          overlay: function() {
            M = H < 128 ? 2 * H * k / 255 : 255 - 2 * (255 - H) * (255 - k) / 255, q = X < 128 ? 2 * X * I / 255 : 255 - 2 * (255 - X) * (255 - I) / 255, K = ue < 128 ? 2 * ue * B / 255 : 255 - 2 * (255 - ue) * (255 - B) / 255;
          },
          "soft-light": function() {
            var oe = k * H / 255;
            M = oe + H * (255 - (255 - H) * (255 - k) / 255 - oe) / 255, oe = I * X / 255, q = oe + X * (255 - (255 - X) * (255 - I) / 255 - oe) / 255, oe = B * ue / 255, K = oe + ue * (255 - (255 - ue) * (255 - B) / 255 - oe) / 255;
          },
          "hard-light": function() {
            M = k < 128 ? 2 * k * H / 255 : 255 - 2 * (255 - k) * (255 - H) / 255, q = I < 128 ? 2 * I * X / 255 : 255 - 2 * (255 - I) * (255 - X) / 255, K = B < 128 ? 2 * B * ue / 255 : 255 - 2 * (255 - B) * (255 - ue) / 255;
          },
          "color-dodge": function() {
            M = H === 0 ? 0 : k === 255 ? 255 : e(255, 255 * H / (255 - k)), q = X === 0 ? 0 : I === 255 ? 255 : e(255, 255 * X / (255 - I)), K = ue === 0 ? 0 : B === 255 ? 255 : e(255, 255 * ue / (255 - B));
          },
          "color-burn": function() {
            M = H === 255 ? 255 : k === 0 ? 0 : r(0, 255 - (255 - H) * 255 / k), q = X === 255 ? 255 : I === 0 ? 0 : r(0, 255 - (255 - X) * 255 / I), K = ue === 255 ? 255 : B === 0 ? 0 : r(0, 255 - (255 - ue) * 255 / B);
          },
          darken: function() {
            M = H < k ? H : k, q = X < I ? X : I, K = ue < B ? ue : B;
          },
          lighten: function() {
            M = H > k ? H : k, q = X > I ? X : I, K = ue > B ? ue : B;
          },
          difference: function() {
            M = H - k, M < 0 && (M = -M), q = X - I, q < 0 && (q = -q), K = ue - B, K < 0 && (K = -K);
          },
          exclusion: function() {
            M = H + k * (255 - H - H) / 255, q = X + I * (255 - X - X) / 255, K = ue + B * (255 - ue - ue) / 255;
          },
          hue: function() {
            D(k, I, B, he(H, X, ue)), te(M, q, K, be(H, X, ue));
          },
          saturation: function() {
            D(H, X, ue, he(k, I, B)), te(M, q, K, be(H, X, ue));
          },
          luminosity: function() {
            te(H, X, ue, be(k, I, B));
          },
          color: function() {
            te(k, I, B, be(H, X, ue));
          },
          add: function() {
            M = e(H + k, 255), q = e(X + I, 255), K = e(ue + B, 255);
          },
          subtract: function() {
            M = r(H - k, 0), q = r(X - I, 0), K = r(ue - B, 0);
          },
          average: function() {
            M = (H + k) / 2, q = (X + I) / 2, K = (ue + B) / 2;
          },
          negation: function() {
            M = 255 - h(255 - k - H), q = 255 - h(255 - I - X), K = 255 - h(255 - B - ue);
          }
        }, le = this.nativeModes = _.each([
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "lighter",
          "darker",
          "copy",
          "xor"
        ], function(oe) {
          this[oe] = !0;
        }, {}), m = Ce.getContext(1, 1, { willReadFrequently: !0 });
        m && (_.each(Se, function(oe, me) {
          var O = me === "darken", ce = !1;
          m.save();
          try {
            m.fillStyle = O ? "#300" : "#a00", m.fillRect(0, 0, 1, 1), m.globalCompositeOperation = me, m.globalCompositeOperation === me && (m.fillStyle = O ? "#a00" : "#300", m.fillRect(0, 0, 1, 1), ce = m.getImageData(0, 0, 1, 1).data[0] !== O ? 170 : 51);
          } catch {
          }
          m.restore(), le[me] = ce;
        }), Ce.release(m)), this.process = function(oe, me, O, ce, Oe) {
          var Be = me.canvas, Ge = oe === "normal";
          if (Ge || le[oe])
            O.save(), O.setTransform(1, 0, 0, 1, 0, 0), O.globalAlpha = ce, Ge || (O.globalCompositeOperation = oe), O.drawImage(Be, Oe.x, Oe.y), O.restore();
          else {
            var Fe = Se[oe];
            if (!Fe)
              return;
            for (var Ye = O.getImageData(
              Oe.x,
              Oe.y,
              Be.width,
              Be.height
            ), Ke = Ye.data, et = me.getImageData(
              0,
              0,
              Be.width,
              Be.height
            ).data, Je = 0, nt = Ke.length; Je < nt; Je += 4) {
              k = et[Je], H = Ke[Je], I = et[Je + 1], X = Ke[Je + 1], B = et[Je + 2], ue = Ke[Je + 2], j = et[Je + 3], pe = Ke[Je + 3], Fe();
              var pt = j * ce / 255, vt = 1 - pt;
              Ke[Je] = pt * M + vt * H, Ke[Je + 1] = pt * q + vt * X, Ke[Je + 2] = pt * K + vt * ue, Ke[Je + 3] = j * ce + vt * pe;
            }
            O.putImageData(Ye, Oe.x, Oe.y);
          }
        };
      }(), Y = new function() {
        var e = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", h = "http://www.w3.org/1999/xlink", k = {
          href: h,
          xlink: r,
          xmlns: r + "/",
          "xmlns:xlink": r + "/"
        };
        function I(H, X, ue) {
          return j(Z.createElementNS(e, H), X, ue);
        }
        function B(H, X) {
          var ue = k[X], pe = ue ? H.getAttributeNS(ue, X) : H.getAttribute(X);
          return pe === "null" ? null : pe;
        }
        function j(H, X, ue) {
          for (var pe in X) {
            var M = X[pe], q = k[pe];
            typeof M == "number" && ue && (M = ue.number(M)), q ? H.setAttributeNS(q, pe, M) : H.setAttribute(pe, M);
          }
          return H;
        }
        return {
          svg: e,
          xmlns: r,
          xlink: h,
          create: I,
          get: B,
          set: j
        };
      }(), G = _.each({
        fillColor: ["fill", "color"],
        fillRule: ["fill-rule", "string"],
        strokeColor: ["stroke", "color"],
        strokeWidth: ["stroke-width", "number"],
        strokeCap: ["stroke-linecap", "string"],
        strokeJoin: ["stroke-linejoin", "string"],
        strokeScaling: ["vector-effect", "lookup", {
          true: "none",
          false: "non-scaling-stroke"
        }, function(e, r) {
          return !r && (e instanceof W || e instanceof R || e instanceof Pe);
        }],
        miterLimit: ["stroke-miterlimit", "number"],
        dashArray: ["stroke-dasharray", "array"],
        dashOffset: ["stroke-dashoffset", "number"],
        fontFamily: ["font-family", "string"],
        fontWeight: ["font-weight", "string"],
        fontSize: ["font-size", "number"],
        justification: ["text-anchor", "lookup", {
          left: "start",
          center: "middle",
          right: "end"
        }],
        opacity: ["opacity", "number"],
        blendMode: ["mix-blend-mode", "style"]
      }, function(e, r) {
        var h = _.capitalize(r), k = e[2];
        this[r] = {
          type: e[1],
          property: r,
          attribute: e[0],
          toSVG: k,
          fromSVG: k && _.each(k, function(I, B) {
            this[I] = B;
          }, {}),
          exportFilter: e[3],
          get: "get" + h,
          set: "set" + h
        };
      }, {});
      new function() {
        var e;
        function r(Se, le, m) {
          var oe = new _(), me = Se.getTranslation();
          if (le) {
            var O;
            Se.isInvertible() ? (Se = Se._shiftless(), O = Se._inverseTransform(me), me = null) : O = new a(), oe[m ? "cx" : "x"] = O.x, oe[m ? "cy" : "y"] = O.y;
          }
          if (!Se.isIdentity()) {
            var ce = Se.decompose();
            if (ce) {
              var Oe = [], Be = ce.rotation, Ge = ce.scaling, Fe = ce.skewing;
              me && !me.isZero() && Oe.push("translate(" + e.point(me) + ")"), Be && Oe.push("rotate(" + e.number(Be) + ")"), (!l.isZero(Ge.x - 1) || !l.isZero(Ge.y - 1)) && Oe.push("scale(" + e.point(Ge) + ")"), Fe.x && Oe.push("skewX(" + e.number(Fe.x) + ")"), Fe.y && Oe.push("skewY(" + e.number(Fe.y) + ")"), oe.transform = Oe.join(" ");
            } else
              oe.transform = "matrix(" + Se.getValues().join(",") + ")";
          }
          return oe;
        }
        function h(Se, le) {
          for (var m = r(Se._matrix), oe = Se._children, me = Y.create("g", m, e), O = 0, ce = oe.length; O < ce; O++) {
            var Oe = oe[O], Be = he(Oe, le);
            if (Be)
              if (Oe.isClipMask()) {
                var Ge = Y.create("clipPath");
                Ge.appendChild(Be), be(Oe, Ge, "clip"), Y.set(me, {
                  "clip-path": "url(#" + Ge.id + ")"
                });
              } else
                me.appendChild(Be);
          }
          return me;
        }
        function k(Se, le) {
          var m = r(Se._matrix, !0), oe = Se.getSize(), me = Se.getImage();
          return m.x -= oe.width / 2, m.y -= oe.height / 2, m.width = oe.width, m.height = oe.height, m.href = le.embedImages == !1 && me && me.src || Se.toDataURL(), Y.create("image", m, e);
        }
        function I(Se, le) {
          var m = le.matchShapes;
          if (m) {
            var oe = Se.toShape(!1);
            if (oe)
              return B(oe);
          }
          var me = Se._segments, O = me.length, ce, Oe = r(Se._matrix);
          if (m && O >= 2 && !Se.hasHandles())
            if (O > 2) {
              ce = Se._closed ? "polygon" : "polyline";
              for (var Be = [], Ge = 0; Ge < O; Ge++)
                Be.push(e.point(me[Ge]._point));
              Oe.points = Be.join(" ");
            } else {
              ce = "line";
              var Fe = me[0]._point, Ye = me[1]._point;
              Oe.set({
                x1: Fe.x,
                y1: Fe.y,
                x2: Ye.x,
                y2: Ye.y
              });
            }
          else
            ce = "path", Oe.d = Se.getPathData(null, le.precision);
          return Y.create(ce, Oe, e);
        }
        function B(Se) {
          var le = Se._type, m = Se._radius, oe = r(Se._matrix, !0, le !== "rectangle");
          if (le === "rectangle") {
            le = "rect";
            var me = Se._size, O = me.width, ce = me.height;
            oe.x -= O / 2, oe.y -= ce / 2, oe.width = O, oe.height = ce, m.isZero() && (m = null);
          }
          return m && (le === "circle" ? oe.r = m : (oe.rx = m.width, oe.ry = m.height)), Y.create(le, oe, e);
        }
        function j(Se, le) {
          var m = r(Se._matrix), oe = Se.getPathData(null, le.precision);
          return oe && (m.d = oe), Y.create("path", m, e);
        }
        function H(Se, le) {
          var m = r(Se._matrix, !0), oe = Se._definition, me = K(oe, "symbol"), O = oe._item, ce = O.getStrokeBounds();
          return me || (me = Y.create("symbol", {
            viewBox: e.rectangle(ce)
          }), me.appendChild(he(O, le)), be(oe, me, "symbol")), m.href = "#" + me.id, m.x += ce.x, m.y += ce.y, m.width = ce.width, m.height = ce.height, m.overflow = "visible", Y.create("use", m, e);
        }
        function X(Se) {
          var le = K(Se, "color");
          if (!le) {
            var m = Se.getGradient(), oe = m._radial, me = Se.getOrigin(), O = Se.getDestination(), ce;
            if (oe) {
              ce = {
                cx: me.x,
                cy: me.y,
                r: me.getDistance(O)
              };
              var Oe = Se.getHighlight();
              Oe && (ce.fx = Oe.x, ce.fy = Oe.y);
            } else
              ce = {
                x1: me.x,
                y1: me.y,
                x2: O.x,
                y2: O.y
              };
            ce.gradientUnits = "userSpaceOnUse", le = Y.create((oe ? "radial" : "linear") + "Gradient", ce, e);
            for (var Be = m._stops, Ge = 0, Fe = Be.length; Ge < Fe; Ge++) {
              var Ye = Be[Ge], Ke = Ye._color, et = Ke.getAlpha(), Je = Ye._offset;
              ce = {
                offset: Je ?? Ge / (Fe - 1)
              }, Ke && (ce["stop-color"] = Ke.toCSS(!0)), et < 1 && (ce["stop-opacity"] = et), le.appendChild(
                Y.create("stop", ce, e)
              );
            }
            be(Se, le, "color");
          }
          return "url(#" + le.id + ")";
        }
        function ue(Se) {
          var le = Y.create(
            "text",
            r(Se._matrix, !0),
            e
          );
          return le.textContent = Se._content, le;
        }
        var pe = {
          Group: h,
          Layer: h,
          Raster: k,
          Path: I,
          Shape: B,
          CompoundPath: j,
          SymbolItem: H,
          PointText: ue
        };
        function M(Se, le, m, oe) {
          var me = {}, O = !oe && Se.getParent(), ce = [];
          return Se._name != null && (me.id = Se._name), _.each(G, function(Oe) {
            var Be = Oe.get, Ge = Oe.type, Fe = Se[Be]();
            if (Oe.exportFilter ? Oe.exportFilter(Se, Fe) : m.reduceAttributes == !1 || !O || !_.equals(O[Be](), Fe)) {
              if (Ge === "color" && Fe != null) {
                var Ye = Fe.getAlpha();
                Ye < 1 && (me[Oe.attribute + "-opacity"] = Ye);
              }
              Ge === "style" ? ce.push(Oe.attribute + ": " + Fe) : me[Oe.attribute] = Fe == null ? "none" : Ge === "color" ? Fe.gradient ? X(Fe) : Fe.toCSS(!0) : Ge === "array" ? Fe.join(",") : Ge === "lookup" ? Oe.toSVG[Fe] : Fe;
            }
          }), ce.length && (me.style = ce.join(";")), me.opacity === 1 && delete me.opacity, Se._visible || (me.visibility = "hidden"), Y.set(le, me, e);
        }
        var q;
        function K(Se, le) {
          return q || (q = { ids: {}, svgs: {} }), Se && q.svgs[le + "-" + (Se._id || Se.__id || (Se.__id = u.get("svg")))];
        }
        function be(Se, le, m) {
          q || K();
          var oe = q.ids[m] = (q.ids[m] || 0) + 1;
          le.id = m + "-" + oe, q.svgs[m + "-" + (Se._id || Se.__id)] = le;
        }
        function te(Se, le) {
          var m = Se, oe = null;
          if (q) {
            m = Se.nodeName.toLowerCase() === "svg" && Se;
            for (var me in q.svgs)
              oe || (m || (m = Y.create("svg"), m.appendChild(Se)), oe = m.insertBefore(
                Y.create("defs"),
                m.firstChild
              )), oe.appendChild(q.svgs[me]);
            q = null;
          }
          return le.asString ? new ge.XMLSerializer().serializeToString(m) : m;
        }
        function he(Se, le, m) {
          var oe = pe[Se._class], me = oe && oe(Se, le);
          if (me) {
            var O = le.onExport;
            O && (me = O(Se, me, le) || me);
            var ce = JSON.stringify(Se._data);
            ce && ce !== "{}" && ce !== "null" && me.setAttribute("data-paper-data", ce);
          }
          return me && M(Se, me, le, m);
        }
        function D(Se) {
          return Se || (Se = {}), e = new d(Se.precision), Se;
        }
        o.inject({
          exportSVG: function(Se) {
            return Se = D(Se), te(he(this, Se, !0), Se);
          }
        }), b.inject({
          exportSVG: function(Se) {
            Se = D(Se);
            var le = this._children, m = this.getView(), oe = _.pick(Se.bounds, "view"), me = Se.matrix || oe === "view" && m._matrix, O = me && s.read([me]), ce = oe === "view" ? new f([0, 0], m.getViewSize()) : oe === "content" ? o._getBounds(le, O, { stroke: !0 }).rect : f.read([oe], 0, { readNull: !0 }), Oe = {
              version: "1.1",
              xmlns: Y.svg,
              "xmlns:xlink": Y.xlink
            };
            ce && (Oe.width = ce.width, Oe.height = ce.height, (ce.x || ce.x === 0 || ce.y || ce.y === 0) && (Oe.viewBox = e.rectangle(ce)));
            var Be = Y.create("svg", Oe, e), Ge = Be;
            O && !O.isIdentity() && (Ge = Be.appendChild(Y.create(
              "g",
              r(O),
              e
            )));
            for (var Fe = 0, Ye = le.length; Fe < Ye; Fe++)
              Ge.appendChild(he(le[Fe], Se, !0));
            return te(Be, Se);
          }
        });
      }(), new function() {
        var e = {}, r;
        function h(le, m, oe, me, O, ce) {
          var Oe = Y.get(le, m) || ce, Be = Oe == null ? me ? null : oe ? "" : 0 : oe ? Oe : parseFloat(Oe);
          return /%\s*$/.test(Oe) ? Be / 100 * (O ? 1 : r[/x|^width/.test(m) ? "width" : "height"]) : Be;
        }
        function k(le, m, oe, me, O, ce, Oe) {
          return m = h(le, m || "x", !1, me, O, ce), oe = h(le, oe || "y", !1, me, O, Oe), me && (m == null || oe == null) ? null : new a(m, oe);
        }
        function I(le, m, oe, me, O) {
          return m = h(le, m || "width", !1, me, O), oe = h(le, oe || "height", !1, me, O), me && (m == null || oe == null) ? null : new c(m, oe);
        }
        function B(le, m, oe) {
          return le === "none" ? null : m === "number" ? parseFloat(le) : m === "array" ? le ? le.split(/[\s,]+/g).map(parseFloat) : [] : m === "color" ? he(le) || le : m === "lookup" ? oe[le] : le;
        }
        function j(le, m, oe, me) {
          var O = le.childNodes, ce = m === "clippath", Oe = m === "defs", Be = new A(), Ge = Be._project, Fe = Ge._currentStyle, Ye = [];
          if (!ce && !Oe && (Be = te(Be, le, me), Ge._currentStyle = Be._style.clone()), me)
            for (var Ke = le.querySelectorAll("defs"), et = 0, Je = Ke.length; et < Je; et++)
              D(Ke[et], oe, !1);
          for (var et = 0, Je = O.length; et < Je; et++) {
            var nt = O[et], pt;
            nt.nodeType === 1 && !/^defs$/i.test(nt.nodeName) && (pt = D(nt, oe, !1)) && !(pt instanceof U) && Ye.push(pt);
          }
          return Be.addChildren(Ye), ce && (Be = te(Be.reduce(), le, me)), Ge._currentStyle = Fe, (ce || Oe) && (Be.remove(), Be = null), Be;
        }
        function H(le, m) {
          for (var oe = le.getAttribute("points").match(
            /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
          ), me = [], O = 0, ce = oe.length; O < ce; O += 2)
            me.push(new a(
              parseFloat(oe[O]),
              parseFloat(oe[O + 1])
            ));
          var Oe = new Q(me);
          return m === "polygon" && Oe.closePath(), Oe;
        }
        function X(le) {
          return W.create(le.getAttribute("d"));
        }
        function ue(le, m) {
          var oe = (h(le, "href", !0) || "").substring(1), me = m === "radialgradient", O;
          if (oe)
            O = e[oe].getGradient(), O._radial ^ me && (O = O.clone(), O._radial = me);
          else {
            for (var ce = le.childNodes, Oe = [], Be = 0, Ge = ce.length; Be < Ge; Be++) {
              var Fe = ce[Be];
              Fe.nodeType === 1 && Oe.push(te(new Ie(), Fe));
            }
            O = new Ee(Oe, me);
          }
          var Ye, Ke, et, Je = h(le, "gradientUnits", !0) !== "userSpaceOnUse";
          me ? (Ye = k(
            le,
            "cx",
            "cy",
            !1,
            Je,
            "50%",
            "50%"
          ), Ke = Ye.add(
            h(le, "r", !1, !1, Je, "50%"),
            0
          ), et = k(le, "fx", "fy", !0, Je)) : (Ye = k(
            le,
            "x1",
            "y1",
            !1,
            Je,
            "0%",
            "0%"
          ), Ke = k(
            le,
            "x2",
            "y2",
            !1,
            Je,
            "100%",
            "0%"
          ));
          var nt = te(
            new xe(O, Ye, Ke, et),
            le
          );
          return nt._scaleToBounds = Je, null;
        }
        var pe = {
          "#document": function(le, m, oe, me) {
            for (var O = le.childNodes, ce = 0, Oe = O.length; ce < Oe; ce++) {
              var Be = O[ce];
              if (Be.nodeType === 1)
                return D(Be, oe, me);
            }
          },
          g: j,
          svg: j,
          clippath: j,
          polygon: H,
          polyline: H,
          path: X,
          lineargradient: ue,
          radialgradient: ue,
          image: function(le) {
            var m = new L(h(le, "href", !0));
            return m.on("load", function() {
              var oe = I(le);
              this.setSize(oe);
              var me = k(le).add(oe.divide(2));
              this._matrix.append(new s().translate(me));
            }), m;
          },
          symbol: function(le, m, oe, me) {
            return new U(
              j(le, m, oe, me),
              !0
            );
          },
          defs: j,
          use: function(le) {
            var m = (h(le, "href", !0) || "").substring(1), oe = e[m], me = k(le);
            return oe ? oe instanceof U ? oe.place(me) : oe.clone().translate(me) : null;
          },
          circle: function(le) {
            return new R.Circle(
              k(le, "cx", "cy"),
              h(le, "r")
            );
          },
          ellipse: function(le) {
            return new R.Ellipse({
              center: k(le, "cx", "cy"),
              radius: I(le, "rx", "ry")
            });
          },
          rect: function(le) {
            return new R.Rectangle(new f(
              k(le),
              I(le)
            ), I(le, "rx", "ry"));
          },
          line: function(le) {
            return new Q.Line(
              k(le, "x1", "y1"),
              k(le, "x2", "y2")
            );
          },
          text: function(le) {
            var m = new fe(k(le).add(
              k(le, "dx", "dy")
            ));
            return m.setContent(le.textContent.trim() || ""), m;
          },
          switch: j
        };
        function M(le, m, oe, me) {
          if (le.transform) {
            for (var O = (me.getAttribute(oe) || "").split(/\)\s*/g), ce = new s(), Oe = 0, Be = O.length; Oe < Be; Oe++) {
              var Ge = O[Oe];
              if (!Ge)
                break;
              for (var Fe = Ge.split(/\(\s*/), Ye = Fe[0].trim(), Ke = Fe[1].split(/[\s,]+/g), et = 0, Je = Ke.length; et < Je; et++)
                Ke[et] = parseFloat(Ke[et]);
              switch (Ye) {
                case "matrix":
                  ce.append(
                    new s(Ke[0], Ke[1], Ke[2], Ke[3], Ke[4], Ke[5])
                  );
                  break;
                case "rotate":
                  ce.rotate(Ke[0], Ke[1] || 0, Ke[2] || 0);
                  break;
                case "translate":
                  ce.translate(Ke[0], Ke[1] || 0);
                  break;
                case "scale":
                  ce.scale(Ke);
                  break;
                case "skewX":
                  ce.skew(Ke[0], 0);
                  break;
                case "skewY":
                  ce.skew(0, Ke[0]);
                  break;
              }
            }
            le.transform(ce);
          }
        }
        function q(le, m, oe) {
          var me = oe === "fill-opacity" ? "getFillColor" : "getStrokeColor", O = le[me] && le[me]();
          O && O.setAlpha(parseFloat(m));
        }
        var K = _.set(_.each(G, function(le) {
          this[le.attribute] = function(m, oe) {
            if (m[le.set] && (m[le.set](B(oe, le.type, le.fromSVG)), le.type === "color")) {
              var me = m[le.get]();
              if (me && me._scaleToBounds) {
                var O = m.getBounds();
                me.transform(new s().translate(O.getPoint()).scale(O.getSize()));
              }
            }
          };
        }, {}), {
          id: function(le, m) {
            e[m] = le, le.setName && le.setName(m);
          },
          "clip-path": function(le, m) {
            var oe = he(m);
            if (oe)
              if (oe = oe.clone(), oe.setClipMask(!0), le instanceof A)
                le.insertChild(0, oe);
              else
                return new A(oe, le);
          },
          gradientTransform: M,
          transform: M,
          "fill-opacity": q,
          "stroke-opacity": q,
          visibility: function(le, m) {
            le.setVisible && le.setVisible(m === "visible");
          },
          display: function(le, m) {
            le.setVisible && le.setVisible(m !== null);
          },
          "stop-color": function(le, m) {
            le.setColor && le.setColor(m);
          },
          "stop-opacity": function(le, m) {
            le._color && le._color.setAlpha(parseFloat(m));
          },
          offset: function(le, m) {
            if (le.setOffset) {
              var oe = m.match(/(.*)%$/);
              le.setOffset(oe ? oe[1] / 100 : parseFloat(m));
            }
          },
          viewBox: function(le, m, oe, me, O) {
            var ce = new f(B(m, "array")), Oe = I(me, null, null, !0), Be, Ge;
            if (le instanceof A) {
              var Fe = Oe ? Oe.divide(ce.getSize()) : 1, Ge = new s().scale(Fe).translate(ce.getPoint().negate());
              Be = le;
            } else le instanceof U && (Oe && ce.setSize(Oe), Be = le._item);
            if (Be) {
              if (be(me, "overflow", O) !== "visible") {
                var Ye = new R.Rectangle(ce);
                Ye.setClipMask(!0), Be.addChild(Ye);
              }
              Ge && Be.transform(Ge);
            }
          }
        });
        function be(le, m, oe) {
          var me = le.attributes[m], O = me && me.value;
          if (!O && le.style) {
            var ce = _.camelize(m);
            O = le.style[ce], !O && oe.node[ce] !== oe.parent[ce] && (O = oe.node[ce]);
          }
          return O ? O === "none" ? null : O : ne;
        }
        function te(le, m, oe) {
          var me = m.parentNode, O = {
            node: Ue.getStyles(m) || {},
            parent: !oe && !/^defs$/i.test(me.tagName) && Ue.getStyles(me) || {}
          };
          return _.each(K, function(ce, Oe) {
            var Be = be(m, Oe, O);
            le = Be !== ne && ce(le, Be, Oe, m, O) || le;
          }), le;
        }
        function he(le) {
          var m = le && le.match(/\((?:["'#]*)([^"')]+)/), oe = m && m[1], me = oe && e[C ? oe.replace(C.location.href.split("#")[0] + "#", "") : oe];
          return me && me._scaleToBounds && (me = me.clone(), me._scaleToBounds = !0), me;
        }
        function D(le, m, oe) {
          var me = le.nodeName.toLowerCase(), O = me !== "#document", ce = Z.body, Oe, Be, Ge;
          oe && O && (r = Ae.getView().getSize(), r = I(le, null, null, !0) || r, Oe = Y.create("svg", {
            style: "stroke-width: 1px; stroke-miterlimit: 10"
          }), Be = le.parentNode, Ge = le.nextSibling, Oe.appendChild(le), ce.appendChild(Oe));
          var Fe = Ae.settings, Ye = Fe.applyMatrix, Ke = Fe.insertItems;
          Fe.applyMatrix = !1, Fe.insertItems = !1;
          var et = pe[me], Je = et && et(le, me, m, oe) || null;
          if (Fe.insertItems = Ke, Fe.applyMatrix = Ye, Je) {
            O && !(Je instanceof A) && (Je = te(Je, le, oe));
            var nt = m.onImport, pt = O && le.getAttribute("data-paper-data");
            nt && (Je = nt(le, Je, m) || Je), m.expandShapes && Je instanceof R && (Je.remove(), Je = Je.toPath()), pt && (Je._data = JSON.parse(pt));
          }
          return Oe && (ce.removeChild(Oe), Be && (Ge ? Be.insertBefore(le, Ge) : Be.appendChild(le))), oe && (e = {}, Je && _.pick(m.applyMatrix, Ye) && Je.matrix.apply(!0, !0)), Je;
        }
        function Se(le, m, oe) {
          if (!le)
            return null;
          m = typeof m == "function" ? { onLoad: m } : m || {};
          var me = Ae, O = null;
          function ce(Fe) {
            try {
              var Ye = typeof Fe == "object" ? Fe : new ge.DOMParser().parseFromString(
                Fe.trim(),
                "image/svg+xml"
              );
              if (!Ye.nodeName)
                throw Ye = null, new Error("Unsupported SVG source: " + le);
              Ae = me, O = D(Ye, m, !0), (!m || m.insert !== !1) && oe._insertItem(ne, O);
              var Ke = m.onLoad;
              Ke && Ke(O, Fe);
            } catch (et) {
              Oe(et);
            }
          }
          function Oe(Fe, Ye) {
            var Ke = m.onError;
            if (Ke)
              Ke(Fe, Ye);
            else
              throw new Error(Fe);
          }
          if (typeof le == "string" && !/^[\s\S]*</.test(le)) {
            var Be = Z.getElementById(le);
            Be ? ce(Be) : $.request({
              url: le,
              async: !0,
              onLoad: ce,
              onError: Oe
            });
          } else if (typeof File < "u" && le instanceof File) {
            var Ge = new FileReader();
            return Ge.onload = function() {
              ce(Ge.result);
            }, Ge.onerror = function() {
              Oe(Ge.error);
            }, Ge.readAsText(le);
          } else
            ce(le);
          return O;
        }
        o.inject({
          importSVG: function(le, m) {
            return Se(le, m, this);
          }
        }), b.inject({
          importSVG: function(le, m) {
            return this.activate(), Se(le, m, this);
          }
        });
      }(), _.exports.PaperScript = (function() {
        var e = this, r = e.acorn;
        if (!r && typeof Ps < "u")
          try {
            r = B0();
          } catch {
          }
        if (!r) {
          var h, k;
          r = h = k = {}, function(te, he) {
            if (typeof h == "object" && typeof k == "object") return he(h);
            if (typeof ne == "function" && ne.amd) return ne(["exports"], he);
            he(te.acorn || (te.acorn = {}));
          }(this, function(te) {
            te.version = "0.5.0";
            var he, D, Se, le;
            te.parse = function(qe, tt) {
              return D = String(qe), Se = D.length, oe(tt), Ns(), Hs(he.program);
            };
            var m = te.defaultOptions = {
              ecmaVersion: 5,
              strictSemicolons: !1,
              allowTrailingCommas: !0,
              forbidReserved: !1,
              allowReturnOutsideFunction: !1,
              locations: !1,
              onComment: null,
              ranges: !1,
              program: null,
              sourceFile: null,
              directSourceFile: null
            };
            function oe(qe) {
              he = qe || {};
              for (var tt in m) Object.prototype.hasOwnProperty.call(he, tt) || (he[tt] = m[tt]);
              le = he.sourceFile || null;
            }
            var me = te.getLineInfo = function(qe, tt) {
              for (var dt = 1, mt = 0; ; ) {
                Pr.lastIndex = mt;
                var Ft = Pr.exec(qe);
                if (Ft && Ft.index < tt)
                  ++dt, mt = Ft.index + Ft[0].length;
                else break;
              }
              return { line: dt, column: tt - mt };
            };
            te.tokenize = function(qe, tt) {
              D = String(qe), Se = D.length, oe(tt), Ns();
              var dt = {};
              function mt(Ft) {
                return pt = Oe, ln(Ft), dt.start = ce, dt.end = Oe, dt.startLoc = Be, dt.endLoc = Ge, dt.type = Fe, dt.value = Ye, dt;
              }
              return mt.jumpTo = function(Ft, Ut) {
                if (O = Ft, he.locations) {
                  et = 1, Je = Pr.lastIndex = 0;
                  for (var Wt; (Wt = Pr.exec(D)) && Wt.index < Ft; )
                    ++et, Je = Wt.index + Wt[0].length;
                }
                Ke = Ut, Fi();
              }, mt;
            };
            var O, ce, Oe, Be, Ge, Fe, Ye, Ke, et, Je, nt, pt, vt, bt, At, ot;
            function ct(qe, tt) {
              var dt = me(D, qe);
              tt += " (" + dt.line + ":" + dt.column + ")";
              var mt = new SyntaxError(tt);
              throw mt.pos = qe, mt.loc = dt, mt.raisedAt = O, mt;
            }
            var gt = [], Ct = { type: "num" }, xt = { type: "regexp" }, Ot = { type: "string" }, Nt = { type: "name" }, Pt = { type: "eof" }, Gt = { keyword: "break" }, Bt = { keyword: "case", beforeExpr: !0 }, or = { keyword: "catch" }, ar = { keyword: "continue" }, ur = { keyword: "debugger" }, hr = { keyword: "default" }, wt = { keyword: "do", isLoop: !0 }, $t = { keyword: "else", beforeExpr: !0 }, lr = { keyword: "finally" }, tr = { keyword: "for", isLoop: !0 }, Xr = { keyword: "function" }, gi = { keyword: "if" }, ii = { keyword: "return", beforeExpr: !0 }, Br = { keyword: "switch" }, Er = { keyword: "throw", beforeExpr: !0 }, kr = { keyword: "try" }, qr = { keyword: "var" }, yr = { keyword: "while", isLoop: !0 }, Or = { keyword: "with" }, yn = { keyword: "new", beforeExpr: !0 }, wn = { keyword: "this" }, bn = { keyword: "null", atomValue: null }, Yi = { keyword: "true", atomValue: !0 }, ya = { keyword: "false", atomValue: !1 }, Xi = { keyword: "in", binop: 7, beforeExpr: !0 }, Qt = {
              break: Gt,
              case: Bt,
              catch: or,
              continue: ar,
              debugger: ur,
              default: hr,
              do: wt,
              else: $t,
              finally: lr,
              for: tr,
              function: Xr,
              if: gi,
              return: ii,
              switch: Br,
              throw: Er,
              try: kr,
              var: qr,
              while: yr,
              with: Or,
              null: bn,
              true: Yi,
              false: ya,
              new: yn,
              in: Xi,
              instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
              this: wn,
              typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
              void: { keyword: "void", prefix: !0, beforeExpr: !0 },
              delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
            }, qi = { type: "[", beforeExpr: !0 }, Qi = { type: "]" }, _i = { type: "{", beforeExpr: !0 }, ni = { type: "}" }, Vt = { type: "(", beforeExpr: !0 }, Qr = { type: ")" }, Kr = { type: ",", beforeExpr: !0 }, zr = { type: ";", beforeExpr: !0 }, Fr = { type: ":", beforeExpr: !0 }, oi = { type: "." }, ui = { type: "?", beforeExpr: !0 }, Di = { binop: 10, beforeExpr: !0 }, v = { isAssign: !0, beforeExpr: !0 }, V = { isAssign: !0, beforeExpr: !0 }, Te = { postfix: !0, prefix: !0, isUpdate: !0 }, Le = { prefix: !0, beforeExpr: !0 }, Xe = { binop: 1, beforeExpr: !0 }, at = { binop: 2, beforeExpr: !0 }, lt = { binop: 3, beforeExpr: !0 }, Et = { binop: 4, beforeExpr: !0 }, Tt = { binop: 5, beforeExpr: !0 }, Yt = { binop: 6, beforeExpr: !0 }, zt = { binop: 7, beforeExpr: !0 }, fr = { binop: 8, beforeExpr: !0 }, $r = { binop: 9, prefix: !0, beforeExpr: !0 }, Ci = { binop: 10, beforeExpr: !0 };
            te.tokTypes = {
              bracketL: qi,
              bracketR: Qi,
              braceL: _i,
              braceR: ni,
              parenL: Vt,
              parenR: Qr,
              comma: Kr,
              semi: zr,
              colon: Fr,
              dot: oi,
              question: ui,
              slash: Di,
              eq: v,
              name: Nt,
              eof: Pt,
              num: Ct,
              regexp: xt,
              string: Ot
            };
            for (var Bi in Qt) te.tokTypes["_" + Bi] = Qt[Bi];
            function ki(qe) {
              qe = qe.split(" ");
              var tt = "", dt = [];
              e: for (var mt = 0; mt < qe.length; ++mt) {
                for (var Ft = 0; Ft < dt.length; ++Ft)
                  if (dt[Ft][0].length == qe[mt].length) {
                    dt[Ft].push(qe[mt]);
                    continue e;
                  }
                dt.push([qe[mt]]);
              }
              function Ut(rr) {
                if (rr.length == 1) return tt += "return str === " + JSON.stringify(rr[0]) + ";";
                tt += "switch(str){";
                for (var jr = 0; jr < rr.length; ++jr) tt += "case " + JSON.stringify(rr[jr]) + ":";
                tt += "return true}return false;";
              }
              if (dt.length > 3) {
                dt.sort(function(rr, jr) {
                  return jr.length - rr.length;
                }), tt += "switch(str.length){";
                for (var mt = 0; mt < dt.length; ++mt) {
                  var Wt = dt[mt];
                  tt += "case " + Wt[0].length + ":", Ut(Wt);
                }
                tt += "}";
              } else
                Ut(qe);
              return new Function("str", tt);
            }
            var Ai = ki("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), yi = ki("class enum extends super const export import"), wa = ki("implements interface let package private protected public static yield"), Yn = ki("eval arguments"), Ki = ki("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), Qa = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Xn = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ls = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", qn = new RegExp("[" + Xn + "]"), ba = new RegExp("[" + Xn + Ls + "]"), Qn = /[\n\r\u2028\u2029]/, Pr = /\r\n|[\n\r\u2028\u2029]/g, zi = te.isIdentifierStart = function(qe) {
              return qe < 65 ? qe === 36 : qe < 91 ? !0 : qe < 97 ? qe === 95 : qe < 123 ? !0 : qe >= 170 && qn.test(String.fromCharCode(qe));
            }, Sa = te.isIdentifierChar = function(qe) {
              return qe < 48 ? qe === 36 : qe < 58 ? !0 : qe < 65 ? !1 : qe < 91 ? !0 : qe < 97 ? qe === 95 : qe < 123 ? !0 : qe >= 170 && ba.test(String.fromCharCode(qe));
            };
            function wi() {
              this.line = et, this.column = O - Je;
            }
            function Ns() {
              et = 1, O = Je = 0, Ke = !0, Fi();
            }
            function xr(qe, tt) {
              Oe = O, he.locations && (Ge = new wi()), Fe = qe, Fi(), Ye = tt, Ke = qe.beforeExpr;
            }
            function Ka() {
              var qe = he.onComment && he.locations && new wi(), tt = O, dt = D.indexOf("*/", O += 2);
              if (dt === -1 && ct(O - 2, "Unterminated comment"), O = dt + 2, he.locations) {
                Pr.lastIndex = tt;
                for (var mt; (mt = Pr.exec(D)) && mt.index < O; )
                  ++et, Je = mt.index + mt[0].length;
              }
              he.onComment && he.onComment(
                !0,
                D.slice(tt + 2, dt),
                tt,
                O,
                qe,
                he.locations && new wi()
              );
            }
            function un() {
              for (var qe = O, tt = he.onComment && he.locations && new wi(), dt = D.charCodeAt(O += 2); O < Se && dt !== 10 && dt !== 13 && dt !== 8232 && dt !== 8233; )
                ++O, dt = D.charCodeAt(O);
              he.onComment && he.onComment(
                !1,
                D.slice(qe + 2, O),
                qe,
                O,
                tt,
                he.locations && new wi()
              );
            }
            function Fi() {
              for (; O < Se; ) {
                var qe = D.charCodeAt(O);
                if (qe === 32)
                  ++O;
                else if (qe === 13) {
                  ++O;
                  var tt = D.charCodeAt(O);
                  tt === 10 && ++O, he.locations && (++et, Je = O);
                } else if (qe === 10 || qe === 8232 || qe === 8233)
                  ++O, he.locations && (++et, Je = O);
                else if (qe > 8 && qe < 14)
                  ++O;
                else if (qe === 47) {
                  var tt = D.charCodeAt(O + 1);
                  if (tt === 42)
                    Ka();
                  else if (tt === 47)
                    un();
                  else break;
                } else if (qe === 160)
                  ++O;
                else if (qe >= 5760 && Qa.test(String.fromCharCode(qe)))
                  ++O;
                else
                  break;
              }
            }
            function Ds() {
              var qe = D.charCodeAt(O + 1);
              return qe >= 48 && qe <= 57 ? zs(!0) : (++O, xr(oi));
            }
            function Ko() {
              var qe = D.charCodeAt(O + 1);
              return Ke ? (++O, Bs()) : qe === 61 ? Ar(V, 2) : Ar(Di, 1);
            }
            function $o() {
              var qe = D.charCodeAt(O + 1);
              return qe === 61 ? Ar(V, 2) : Ar(Ci, 1);
            }
            function Jo(qe) {
              var tt = D.charCodeAt(O + 1);
              return tt === qe ? Ar(qe === 124 ? Xe : at, 2) : tt === 61 ? Ar(V, 2) : Ar(qe === 124 ? lt : Tt, 1);
            }
            function $a() {
              var qe = D.charCodeAt(O + 1);
              return qe === 61 ? Ar(V, 2) : Ar(Et, 1);
            }
            function eu(qe) {
              var tt = D.charCodeAt(O + 1);
              return tt === qe ? tt == 45 && D.charCodeAt(O + 2) == 62 && Qn.test(D.slice(pt, O)) ? (O += 3, un(), Fi(), ln()) : Ar(Te, 2) : tt === 61 ? Ar(V, 2) : Ar($r, 1);
            }
            function tu(qe) {
              var tt = D.charCodeAt(O + 1), dt = 1;
              return tt === qe ? (dt = qe === 62 && D.charCodeAt(O + 2) === 62 ? 3 : 2, D.charCodeAt(O + dt) === 61 ? Ar(V, dt + 1) : Ar(fr, dt)) : tt == 33 && qe == 60 && D.charCodeAt(O + 2) == 45 && D.charCodeAt(O + 3) == 45 ? (O += 4, un(), Fi(), ln()) : (tt === 61 && (dt = D.charCodeAt(O + 2) === 61 ? 3 : 2), Ar(zt, dt));
            }
            function ru(qe) {
              var tt = D.charCodeAt(O + 1);
              return tt === 61 ? Ar(Yt, D.charCodeAt(O + 2) === 61 ? 3 : 2) : Ar(qe === 61 ? v : Le, 1);
            }
            function iu(qe) {
              switch (qe) {
                case 46:
                  return Ds();
                case 40:
                  return ++O, xr(Vt);
                case 41:
                  return ++O, xr(Qr);
                case 59:
                  return ++O, xr(zr);
                case 44:
                  return ++O, xr(Kr);
                case 91:
                  return ++O, xr(qi);
                case 93:
                  return ++O, xr(Qi);
                case 123:
                  return ++O, xr(_i);
                case 125:
                  return ++O, xr(ni);
                case 58:
                  return ++O, xr(Fr);
                case 63:
                  return ++O, xr(ui);
                case 48:
                  var tt = D.charCodeAt(O + 1);
                  if (tt === 120 || tt === 88) return nu();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  return zs(!1);
                case 34:
                case 39:
                  return Ja(qe);
                case 47:
                  return Ko();
                case 37:
                case 42:
                  return $o();
                case 124:
                case 38:
                  return Jo(qe);
                case 94:
                  return $a();
                case 43:
                case 45:
                  return eu(qe);
                case 60:
                case 62:
                  return tu(qe);
                case 61:
                case 33:
                  return ru(qe);
                case 126:
                  return Ar(Le, 1);
              }
              return !1;
            }
            function ln(qe) {
              if (qe ? O = ce + 1 : ce = O, he.locations && (Be = new wi()), qe) return Bs();
              if (O >= Se) return xr(Pt);
              var tt = D.charCodeAt(O);
              if (zi(tt) || tt === 92) return es();
              var dt = iu(tt);
              if (dt === !1) {
                var mt = String.fromCharCode(tt);
                if (mt === "\\" || qn.test(mt)) return es();
                ct(O, "Unexpected character '" + mt + "'");
              }
              return dt;
            }
            function Ar(qe, tt) {
              var dt = D.slice(O, O + tt);
              O += tt, xr(qe, dt);
            }
            function Bs() {
              for (var Ft = "", qe, tt, dt = O; ; ) {
                O >= Se && ct(dt, "Unterminated regular expression");
                var mt = D.charAt(O);
                if (Qn.test(mt) && ct(dt, "Unterminated regular expression"), qe)
                  qe = !1;
                else {
                  if (mt === "[") tt = !0;
                  else if (mt === "]" && tt) tt = !1;
                  else if (mt === "/" && !tt) break;
                  qe = mt === "\\";
                }
                ++O;
              }
              var Ft = D.slice(dt, O);
              ++O;
              var Ut = Fs();
              Ut && !/^[gmsiy]*$/.test(Ut) && ct(dt, "Invalid regexp flag");
              try {
                var Wt = new RegExp(Ft, Ut);
              } catch (rr) {
                rr instanceof SyntaxError && ct(dt, rr.message), ct(rr);
              }
              return xr(xt, Wt);
            }
            function Kn(qe, tt) {
              for (var dt = O, mt = 0, Ft = 0, Ut = tt ?? 1 / 0; Ft < Ut; ++Ft) {
                var Wt = D.charCodeAt(O), rr;
                if (Wt >= 97 ? rr = Wt - 97 + 10 : Wt >= 65 ? rr = Wt - 65 + 10 : Wt >= 48 && Wt <= 57 ? rr = Wt - 48 : rr = 1 / 0, rr >= qe) break;
                ++O, mt = mt * qe + rr;
              }
              return O === dt || tt != null && O - dt !== tt ? null : mt;
            }
            function nu() {
              O += 2;
              var qe = Kn(16);
              return qe == null && ct(ce + 2, "Expected hexadecimal number"), zi(D.charCodeAt(O)) && ct(O, "Identifier directly after number"), xr(Ct, qe);
            }
            function zs(qe) {
              var tt = O, dt = !1, mt = D.charCodeAt(O) === 48;
              !qe && Kn(10) === null && ct(tt, "Invalid number"), D.charCodeAt(O) === 46 && (++O, Kn(10), dt = !0);
              var Ft = D.charCodeAt(O);
              (Ft === 69 || Ft === 101) && (Ft = D.charCodeAt(++O), (Ft === 43 || Ft === 45) && ++O, Kn(10) === null && ct(tt, "Invalid number"), dt = !0), zi(D.charCodeAt(O)) && ct(O, "Identifier directly after number");
              var Ut = D.slice(tt, O), Wt;
              return dt ? Wt = parseFloat(Ut) : !mt || Ut.length === 1 ? Wt = parseInt(Ut, 10) : /[89]/.test(Ut) || ot ? ct(tt, "Invalid number") : Wt = parseInt(Ut, 8), xr(Ct, Wt);
            }
            function Ja(qe) {
              O++;
              for (var tt = ""; ; ) {
                O >= Se && ct(ce, "Unterminated string constant");
                var dt = D.charCodeAt(O);
                if (dt === qe)
                  return ++O, xr(Ot, tt);
                if (dt === 92) {
                  dt = D.charCodeAt(++O);
                  var mt = /^[0-7]+/.exec(D.slice(O, O + 3));
                  for (mt && (mt = mt[0]); mt && parseInt(mt, 8) > 255; ) mt = mt.slice(0, -1);
                  if (mt === "0" && (mt = null), ++O, mt)
                    ot && ct(O - 2, "Octal literal in strict mode"), tt += String.fromCharCode(parseInt(mt, 8)), O += mt.length - 1;
                  else
                    switch (dt) {
                      case 110:
                        tt += `
`;
                        break;
                      case 114:
                        tt += "\r";
                        break;
                      case 120:
                        tt += String.fromCharCode(Ea(2));
                        break;
                      case 117:
                        tt += String.fromCharCode(Ea(4));
                        break;
                      case 85:
                        tt += String.fromCharCode(Ea(8));
                        break;
                      case 116:
                        tt += "	";
                        break;
                      case 98:
                        tt += "\b";
                        break;
                      case 118:
                        tt += "\v";
                        break;
                      case 102:
                        tt += "\f";
                        break;
                      case 48:
                        tt += "\0";
                        break;
                      case 13:
                        D.charCodeAt(O) === 10 && ++O;
                      case 10:
                        he.locations && (Je = O, ++et);
                        break;
                      default:
                        tt += String.fromCharCode(dt);
                        break;
                    }
                } else
                  (dt === 13 || dt === 10 || dt === 8232 || dt === 8233) && ct(ce, "Unterminated string constant"), tt += String.fromCharCode(dt), ++O;
              }
            }
            function Ea(qe) {
              var tt = Kn(16, qe);
              return tt === null && ct(ce, "Bad character escape sequence"), tt;
            }
            var Sn;
            function Fs() {
              Sn = !1;
              for (var qe, tt = !0, dt = O; ; ) {
                var mt = D.charCodeAt(O);
                if (Sa(mt))
                  Sn && (qe += D.charAt(O)), ++O;
                else if (mt === 92) {
                  Sn || (qe = D.slice(dt, O)), Sn = !0, D.charCodeAt(++O) != 117 && ct(O, "Expecting Unicode escape sequence \\uXXXX"), ++O;
                  var Ft = Ea(4), Ut = String.fromCharCode(Ft);
                  Ut || ct(O - 1, "Invalid Unicode escape"), (tt ? zi(Ft) : Sa(Ft)) || ct(O - 4, "Invalid Unicode escape"), qe += Ut;
                } else
                  break;
                tt = !1;
              }
              return Sn ? qe : D.slice(dt, O);
            }
            function es() {
              var qe = Fs(), tt = Nt;
              return !Sn && Ki(qe) && (tt = Qt[qe]), xr(tt, qe);
            }
            function er() {
              nt = ce, pt = Oe, vt = Ge, ln();
            }
            function ts(qe) {
              if (ot = qe, O = ce, he.locations)
                for (; O < Je; )
                  Je = D.lastIndexOf(`
`, Je - 2) + 1, --et;
              Fi(), ln();
            }
            function Us() {
              this.type = null, this.start = ce, this.end = null;
            }
            function js() {
              this.start = Be, this.end = null, le !== null && (this.source = le);
            }
            function Lr() {
              var qe = new Us();
              return he.locations && (qe.loc = new js()), he.directSourceFile && (qe.sourceFile = he.directSourceFile), he.ranges && (qe.range = [ce, 0]), qe;
            }
            function $i(qe) {
              var tt = new Us();
              return tt.start = qe.start, he.locations && (tt.loc = new js(), tt.loc.start = qe.loc.start), he.ranges && (tt.range = [qe.range[0], 0]), tt;
            }
            function qt(qe, tt) {
              return qe.type = tt, qe.end = pt, he.locations && (qe.loc.end = vt), he.ranges && (qe.range[1] = pt), qe;
            }
            function $n(qe) {
              return he.ecmaVersion >= 5 && qe.type === "ExpressionStatement" && qe.expression.type === "Literal" && qe.expression.value === "use strict";
            }
            function sr(qe) {
              if (Fe === qe)
                return er(), !0;
            }
            function xa() {
              return !he.strictSemicolons && (Fe === Pt || Fe === ni || Qn.test(D.slice(pt, ce)));
            }
            function Ji() {
              !sr(zr) && !xa() && Ti();
            }
            function wr(qe) {
              Fe === qe ? er() : Ti();
            }
            function Ti() {
              ct(ce, "Unexpected token");
            }
            function Jn(qe) {
              qe.type !== "Identifier" && qe.type !== "MemberExpression" && ct(qe.start, "Assigning to rvalue"), ot && qe.type === "Identifier" && Yn(qe.name) && ct(qe.start, "Assigning to " + qe.name + " in strict mode");
            }
            function Hs(qe) {
              nt = pt = O, he.locations && (vt = new wi()), bt = ot = null, At = [], ln();
              var tt = qe || Lr(), dt = !0;
              for (qe || (tt.body = []); Fe !== Pt; ) {
                var mt = bi();
                tt.body.push(mt), dt && $n(mt) && ts(!0), dt = !1;
              }
              return qt(tt, "Program");
            }
            var en = { kind: "loop" }, au = { kind: "switch" };
            function bi() {
              (Fe === Di || Fe === V && Ye == "/=") && ln(!0);
              var qe = Fe, tt = Lr();
              switch (qe) {
                case Gt:
                case ar:
                  er();
                  var dt = qe === Gt;
                  sr(zr) || xa() ? tt.label = null : Fe !== Nt ? Ti() : (tt.label = Mr(), Ji());
                  for (var mt = 0; mt < At.length; ++mt) {
                    var Ft = At[mt];
                    if ((tt.label == null || Ft.name === tt.label.name) && (Ft.kind != null && (dt || Ft.kind === "loop") || tt.label && dt))
                      break;
                  }
                  return mt === At.length && ct(tt.start, "Unsyntactic " + qe.keyword), qt(tt, dt ? "BreakStatement" : "ContinueStatement");
                case ur:
                  return er(), Ji(), qt(tt, "DebuggerStatement");
                case wt:
                  return er(), At.push(en), tt.body = bi(), At.pop(), wr(yr), tt.test = ea(), Ji(), qt(tt, "DoWhileStatement");
                case tr:
                  if (er(), At.push(en), wr(Vt), Fe === zr) return Ca(tt, null);
                  if (Fe === qr) {
                    var Ut = Lr();
                    return er(), Cn(Ut, !0), qt(Ut, "VariableDeclaration"), Ut.declarations.length === 1 && sr(Xi) ? xn(tt, Ut) : Ca(tt, Ut);
                  }
                  var Ut = Ur(!1, !0);
                  return sr(Xi) ? (Jn(Ut), xn(tt, Ut)) : Ca(tt, Ut);
                case Xr:
                  return er(), rs(tt, !0);
                case gi:
                  return er(), tt.test = ea(), tt.consequent = bi(), tt.alternate = sr($t) ? bi() : null, qt(tt, "IfStatement");
                case ii:
                  return !bt && !he.allowReturnOutsideFunction && ct(ce, "'return' outside of function"), er(), sr(zr) || xa() ? tt.argument = null : (tt.argument = Ur(), Ji()), qt(tt, "ReturnStatement");
                case Br:
                  er(), tt.discriminant = ea(), tt.cases = [], wr(_i), At.push(au);
                  for (var Wt, rr; Fe != ni; )
                    if (Fe === Bt || Fe === hr) {
                      var jr = Fe === Bt;
                      Wt && qt(Wt, "SwitchCase"), tt.cases.push(Wt = Lr()), Wt.consequent = [], er(), jr ? Wt.test = Ur() : (rr && ct(nt, "Multiple default clauses"), rr = !0, Wt.test = null), wr(Fr);
                    } else
                      Wt || Ti(), Wt.consequent.push(bi());
                  return Wt && qt(Wt, "SwitchCase"), er(), At.pop(), qt(tt, "SwitchStatement");
                case Er:
                  return er(), Qn.test(D.slice(pt, ce)) && ct(pt, "Illegal newline after throw"), tt.argument = Ur(), Ji(), qt(tt, "ThrowStatement");
                case kr:
                  if (er(), tt.block = En(), tt.handler = null, Fe === or) {
                    var Ui = Lr();
                    er(), wr(Vt), Ui.param = Mr(), ot && Yn(Ui.param.name) && ct(Ui.param.start, "Binding " + Ui.param.name + " in strict mode"), wr(Qr), Ui.guard = null, Ui.body = En(), tt.handler = qt(Ui, "CatchClause");
                  }
                  return tt.guardedHandlers = gt, tt.finalizer = sr(lr) ? En() : null, !tt.handler && !tt.finalizer && ct(tt.start, "Missing catch or finally clause"), qt(tt, "TryStatement");
                case qr:
                  return er(), Cn(tt), Ji(), qt(tt, "VariableDeclaration");
                case yr:
                  return er(), tt.test = ea(), At.push(en), tt.body = bi(), At.pop(), qt(tt, "WhileStatement");
                case Or:
                  return ot && ct(ce, "'with' in strict mode"), er(), tt.object = ea(), tt.body = bi(), qt(tt, "WithStatement");
                case _i:
                  return En();
                case zr:
                  return er(), qt(tt, "EmptyStatement");
                default:
                  var fn = Ye, Tn = Ur();
                  if (qe === Nt && Tn.type === "Identifier" && sr(Fr)) {
                    for (var mt = 0; mt < At.length; ++mt)
                      At[mt].name === fn && ct(Tn.start, "Label '" + fn + "' is already declared");
                    var Zs = Fe.isLoop ? "loop" : Fe === Br ? "switch" : null;
                    return At.push({ name: fn, kind: Zs }), tt.body = bi(), At.pop(), tt.label = Tn, qt(tt, "LabeledStatement");
                  } else
                    return tt.expression = Tn, Ji(), qt(tt, "ExpressionStatement");
              }
            }
            function ea() {
              wr(Vt);
              var qe = Ur();
              return wr(Qr), qe;
            }
            function En(qe) {
              var tt = Lr(), dt = !0, mt = !1, Ft;
              for (tt.body = [], wr(_i); !sr(ni); ) {
                var Ut = bi();
                tt.body.push(Ut), dt && qe && $n(Ut) && (Ft = mt, ts(mt = !0)), dt = !1;
              }
              return mt && !Ft && ts(!1), qt(tt, "BlockStatement");
            }
            function Ca(qe, tt) {
              return qe.init = tt, wr(zr), qe.test = Fe === zr ? null : Ur(), wr(zr), qe.update = Fe === Qr ? null : Ur(), wr(Qr), qe.body = bi(), At.pop(), qt(qe, "ForStatement");
            }
            function xn(qe, tt) {
              return qe.left = tt, qe.right = Ur(), wr(Qr), qe.body = bi(), At.pop(), qt(qe, "ForInStatement");
            }
            function Cn(qe, tt) {
              for (qe.declarations = [], qe.kind = "var"; ; ) {
                var dt = Lr();
                if (dt.id = Mr(), ot && Yn(dt.id.name) && ct(dt.id.start, "Binding " + dt.id.name + " in strict mode"), dt.init = sr(v) ? Ur(!0, tt) : null, qe.declarations.push(qt(dt, "VariableDeclarator")), !sr(Kr)) break;
              }
              return qe;
            }
            function Ur(qe, tt) {
              var dt = kn(tt);
              if (!qe && Fe === Kr) {
                var mt = $i(dt);
                for (mt.expressions = [dt]; sr(Kr); ) mt.expressions.push(kn(tt));
                return qt(mt, "SequenceExpression");
              }
              return dt;
            }
            function kn(qe) {
              var tt = su(qe);
              if (Fe.isAssign) {
                var dt = $i(tt);
                return dt.operator = Ye, dt.left = tt, er(), dt.right = kn(qe), Jn(tt), qt(dt, "AssignmentExpression");
              }
              return tt;
            }
            function su(qe) {
              var tt = Gs(qe);
              if (sr(ui)) {
                var dt = $i(tt);
                return dt.test = tt, dt.consequent = Ur(!0), wr(Fr), dt.alternate = Ur(!0, qe), qt(dt, "ConditionalExpression");
              }
              return tt;
            }
            function Gs(qe) {
              return ta(ra(), -1, qe);
            }
            function ta(qe, tt, dt) {
              var mt = Fe.binop;
              if (mt != null && (!dt || Fe !== Xi) && mt > tt) {
                var Ft = $i(qe);
                Ft.left = qe, Ft.operator = Ye;
                var Ut = Fe;
                er(), Ft.right = ta(ra(), mt, dt);
                var Wt = qt(Ft, Ut === Xe || Ut === at ? "LogicalExpression" : "BinaryExpression");
                return ta(Wt, tt, dt);
              }
              return qe;
            }
            function ra() {
              if (Fe.prefix) {
                var qe = Lr(), tt = Fe.isUpdate;
                return qe.operator = Ye, qe.prefix = !0, Ke = !0, er(), qe.argument = ra(), tt ? Jn(qe.argument) : ot && qe.operator === "delete" && qe.argument.type === "Identifier" && ct(qe.start, "Deleting local variable in strict mode"), qt(qe, tt ? "UpdateExpression" : "UnaryExpression");
              }
              for (var dt = Vs(); Fe.postfix && !xa(); ) {
                var qe = $i(dt);
                qe.operator = Ye, qe.prefix = !1, qe.argument = dt, Jn(dt), er(), dt = qt(qe, "UpdateExpression");
              }
              return dt;
            }
            function Vs() {
              return An(ka());
            }
            function An(qe, tt) {
              if (sr(oi)) {
                var dt = $i(qe);
                return dt.object = qe, dt.property = Mr(!0), dt.computed = !1, An(qt(dt, "MemberExpression"), tt);
              } else if (sr(qi)) {
                var dt = $i(qe);
                return dt.object = qe, dt.property = Ur(), dt.computed = !0, wr(Qi), An(qt(dt, "MemberExpression"), tt);
              } else if (!tt && sr(Vt)) {
                var dt = $i(qe);
                return dt.callee = qe, dt.arguments = is(Qr, !1), An(qt(dt, "CallExpression"), tt);
              } else return qe;
            }
            function ka() {
              switch (Fe) {
                case wn:
                  var mt = Lr();
                  return er(), qt(mt, "ThisExpression");
                case Nt:
                  return Mr();
                case Ct:
                case Ot:
                case xt:
                  var mt = Lr();
                  return mt.value = Ye, mt.raw = D.slice(ce, Oe), er(), qt(mt, "Literal");
                case bn:
                case Yi:
                case ya:
                  var mt = Lr();
                  return mt.value = Fe.atomValue, mt.raw = Fe.keyword, er(), qt(mt, "Literal");
                case Vt:
                  var qe = Be, tt = ce;
                  er();
                  var dt = Ur();
                  return dt.start = tt, dt.end = Oe, he.locations && (dt.loc.start = qe, dt.loc.end = Ge), he.ranges && (dt.range = [tt, Oe]), wr(Qr), dt;
                case qi:
                  var mt = Lr();
                  return er(), mt.elements = is(Qi, !0, !0), qt(mt, "ArrayExpression");
                case _i:
                  return uu();
                case Xr:
                  var mt = Lr();
                  return er(), rs(mt, !1);
                case yn:
                  return ou();
                default:
                  Ti();
              }
            }
            function ou() {
              var qe = Lr();
              return er(), qe.callee = An(ka(), !0), sr(Vt) ? qe.arguments = is(Qr, !1) : qe.arguments = gt, qt(qe, "NewExpression");
            }
            function uu() {
              var qe = Lr(), tt = !0, dt = !1;
              for (qe.properties = [], er(); !sr(ni); ) {
                if (tt)
                  tt = !1;
                else if (wr(Kr), he.allowTrailingCommas && sr(ni)) break;
                var mt = { key: Ws() }, Ft = !1, Ut;
                if (sr(Fr) ? (mt.value = Ur(!0), Ut = mt.kind = "init") : he.ecmaVersion >= 5 && mt.key.type === "Identifier" && (mt.key.name === "get" || mt.key.name === "set") ? (Ft = dt = !0, Ut = mt.kind = mt.key.name, mt.key = Ws(), Fe !== Vt && Ti(), mt.value = rs(Lr(), !1)) : Ti(), mt.key.type === "Identifier" && (ot || dt))
                  for (var Wt = 0; Wt < qe.properties.length; ++Wt) {
                    var rr = qe.properties[Wt];
                    if (rr.key.name === mt.key.name) {
                      var jr = Ut == rr.kind || Ft && rr.kind === "init" || Ut === "init" && (rr.kind === "get" || rr.kind === "set");
                      jr && !ot && Ut === "init" && rr.kind === "init" && (jr = !1), jr && ct(mt.key.start, "Redefinition of property");
                    }
                  }
                qe.properties.push(mt);
              }
              return qt(qe, "ObjectExpression");
            }
            function Ws() {
              return Fe === Ct || Fe === Ot ? ka() : Mr(!0);
            }
            function rs(qe, tt) {
              Fe === Nt ? qe.id = Mr() : tt ? Ti() : qe.id = null, qe.params = [];
              var dt = !0;
              for (wr(Vt); !sr(Qr); )
                dt ? dt = !1 : wr(Kr), qe.params.push(Mr());
              var mt = bt, Ft = At;
              if (bt = !0, At = [], qe.body = En(!0), bt = mt, At = Ft, ot || qe.body.body.length && $n(qe.body.body[0]))
                for (var Ut = qe.id ? -1 : 0; Ut < qe.params.length; ++Ut) {
                  var Wt = Ut < 0 ? qe.id : qe.params[Ut];
                  if ((wa(Wt.name) || Yn(Wt.name)) && ct(Wt.start, "Defining '" + Wt.name + "' in strict mode"), Ut >= 0) for (var rr = 0; rr < Ut; ++rr) Wt.name === qe.params[rr].name && ct(Wt.start, "Argument name clash in strict mode");
                }
              return qt(qe, tt ? "FunctionDeclaration" : "FunctionExpression");
            }
            function is(qe, tt, dt) {
              for (var mt = [], Ft = !0; !sr(qe); ) {
                if (Ft)
                  Ft = !1;
                else if (wr(Kr), tt && he.allowTrailingCommas && sr(qe)) break;
                dt && Fe === Kr ? mt.push(null) : mt.push(Ur(!0));
              }
              return mt;
            }
            function Mr(qe) {
              var tt = Lr();
              return qe && he.forbidReserved == "everywhere" && (qe = !1), Fe === Nt ? (!qe && (he.forbidReserved && (he.ecmaVersion === 3 ? Ai : yi)(Ye) || ot && wa(Ye)) && D.slice(ce, Oe).indexOf("\\") == -1 && ct(ce, "The keyword '" + Ye + "' is reserved"), tt.name = Ye) : qe && Fe.keyword ? tt.name = Fe.keyword : Ti(), Ke = !1, er(), qt(tt, "Identifier");
            }
          }), r.version || (r = null);
        }
        function I(te, he) {
          return (e.acorn || r).parse(te, he);
        }
        var B = {
          "+": "__add",
          "-": "__subtract",
          "*": "__multiply",
          "/": "__divide",
          "%": "__modulo",
          "==": "__equals",
          "!=": "__equals"
        }, j = {
          "-": "__negate",
          "+": "__self"
        }, H = _.each(
          ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
          function(te) {
            this["__" + te] = "#" + te;
          },
          {
            __self: function() {
              return this;
            }
          }
        );
        a.inject(H), c.inject(H), xe.inject(H);
        function X(te, he, D) {
          var Se = B[he];
          if (te && te[Se]) {
            var le = te[Se](D);
            return he === "!=" ? !le : le;
          }
          switch (he) {
            case "+":
              return te + D;
            case "-":
              return te - D;
            case "*":
              return te * D;
            case "/":
              return te / D;
            case "%":
              return te % D;
            case "==":
              return te == D;
            case "!=":
              return te != D;
          }
        }
        function ue(te, he) {
          var D = j[te];
          if (he && he[D])
            return he[D]();
          switch (te) {
            case "+":
              return +he;
            case "-":
              return -he;
          }
        }
        function pe(te, he) {
          if (!te)
            return "";
          he = he || {};
          var D = [];
          function Se(ot) {
            for (var ct = 0, gt = D.length; ct < gt; ct++) {
              var Ct = D[ct];
              if (Ct[0] >= ot)
                break;
              ot += Ct[1];
            }
            return ot;
          }
          function le(ot) {
            return te.substring(
              Se(ot.range[0]),
              Se(ot.range[1])
            );
          }
          function m(ot, ct) {
            return te.substring(
              Se(ot.range[1]),
              Se(ct.range[0])
            );
          }
          function oe(ot, ct) {
            for (var gt = Se(ot.range[0]), Ct = Se(ot.range[1]), xt = 0, Ot = D.length - 1; Ot >= 0; Ot--)
              if (gt > D[Ot][0]) {
                xt = Ot + 1;
                break;
              }
            D.splice(xt, 0, [gt, ct.length - Ct + gt]), te = te.substring(0, gt) + ct + te.substring(Ct);
          }
          function me(ot, ct) {
            switch (ot.type) {
              case "UnaryExpression":
                if (ot.operator in j && ot.argument.type !== "Literal") {
                  var gt = le(ot.argument);
                  oe(ot, '$__("' + ot.operator + '", ' + gt + ")");
                }
                break;
              case "BinaryExpression":
                if (ot.operator in B && ot.left.type !== "Literal") {
                  var Ct = le(ot.left), xt = le(ot.right), Ot = m(ot.left, ot.right), Nt = ot.operator;
                  oe(ot, "__$__(" + Ct + "," + Ot.replace(
                    new RegExp("\\" + Nt),
                    '"' + Nt + '"'
                  ) + ", " + xt + ")");
                }
                break;
              case "UpdateExpression":
              case "AssignmentExpression":
                var Pt = ct && ct.type;
                if (!(Pt === "ForStatement" || Pt === "BinaryExpression" && /^[=!<>]/.test(ct.operator) || Pt === "MemberExpression" && ct.computed)) {
                  if (ot.type === "UpdateExpression") {
                    var gt = le(ot.argument), Gt = "__$__(" + gt + ', "' + ot.operator[0] + '", 1)', Bt = gt + " = " + Gt;
                    ot.prefix ? Bt = "(" + Bt + ")" : (Pt === "AssignmentExpression" || Pt === "VariableDeclarator" || Pt === "BinaryExpression") && (le(ct.left || ct.id) === gt && (Bt = Gt), Bt = gt + "; " + Bt), oe(ot, Bt);
                  } else if (/^.=$/.test(ot.operator) && ot.left.type !== "Literal") {
                    var Ct = le(ot.left), xt = le(ot.right), Gt = Ct + " = __$__(" + Ct + ', "' + ot.operator[0] + '", ' + xt + ")";
                    oe(ot, /^\(.*\)$/.test(le(ot)) ? "(" + Gt + ")" : Gt);
                  }
                }
                break;
            }
          }
          function O(ot) {
            switch (ot.type) {
              case "ExportDefaultDeclaration":
                oe({
                  range: [ot.start, ot.declaration.start]
                }, "module.exports = ");
                break;
              case "ExportNamedDeclaration":
                var ct = ot.declaration, gt = ot.specifiers;
                if (ct) {
                  var Ct = ct.declarations;
                  Ct && (Ct.forEach(function(Ot) {
                    oe(Ot, "module.exports." + le(Ot));
                  }), oe({
                    range: [
                      ot.start,
                      ct.start + ct.kind.length
                    ]
                  }, ""));
                } else if (gt) {
                  var xt = gt.map(function(Ot) {
                    var Nt = le(Ot);
                    return "module.exports." + Nt + " = " + Nt + "; ";
                  }).join("");
                  xt && oe(ot, xt);
                }
                break;
            }
          }
          function ce(ot, ct, gt) {
            if (ot) {
              for (var Ct in ot)
                if (Ct !== "range" && Ct !== "loc") {
                  var xt = ot[Ct];
                  if (Array.isArray(xt))
                    for (var Ot = 0, Nt = xt.length; Ot < Nt; Ot++)
                      ce(xt[Ot], ot, gt);
                  else xt && typeof xt == "object" && ce(xt, ot, gt);
                }
              gt.operatorOverloading !== !1 && me(ot, ct), gt.moduleExports !== !1 && O(ot);
            }
          }
          function Oe(ot) {
            var ct = "", gt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (ot = (Math.abs(ot) << 1) + (ot < 0 ? 1 : 0); ot || !ct; ) {
              var Ct = ot & 31;
              ot >>= 5, ot && (Ct |= 32), ct += gt[Ct];
            }
            return ct;
          }
          var Be = he.url || "", Ge = he.sourceMaps, Fe = he.paperFeatures || {}, Ye = he.source || te, Ke = he.offset || 0, et = Ae.agent, Je = et.versionNumber, nt = !1, pt = /\r\n|\n|\r/mg, vt;
          if (Ge && (et.chrome && Je >= 30 || et.webkit && Je >= 537.76 || et.firefox && Je >= 23 || et.node)) {
            if (et.node)
              Ke -= 2;
            else if (C && Be && !C.location.href.indexOf(Be)) {
              var bt = Z.getElementsByTagName("html")[0].innerHTML;
              Ke = bt.substr(0, bt.indexOf(te) + 1).match(
                pt
              ).length + 1;
            }
            nt = Ke > 0 && !(et.chrome && Je >= 36 || et.safari && Je >= 600 || et.firefox && Je >= 40 || et.node);
            var At = ["AA" + Oe(nt ? 0 : Ke) + "A"];
            At.length = (te.match(pt) || []).length + 1 + (nt ? Ke : 0), vt = {
              version: 3,
              file: Be,
              names: [],
              mappings: At.join(";AACA"),
              sourceRoot: "",
              sources: [Be],
              sourcesContent: [Ye]
            };
          }
          return (Fe.operatorOverloading !== !1 || Fe.moduleExports !== !1) && ce(I(te, {
            ranges: !0,
            preserveParens: !0,
            sourceType: "module"
          }), null, Fe), vt && (nt && (te = new Array(Ke + 1).join(`
`) + te), /^(inline|both)$/.test(Ge) && (te += `
//# sourceMappingURL=data:application/json;base64,` + ge.btoa(unescape(encodeURIComponent(
            JSON.stringify(vt)
          )))), te += `
//# sourceURL=` + (Be || "paperscript")), {
            url: Be,
            source: Ye,
            code: te,
            map: vt
          };
        }
        function M(te, he, D) {
          Ae = he;
          var Se = he.getView(), le = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(te) && !/\bnew\s+Tool\b/.test(te) ? new we() : null, m = le ? le._events : [], oe = ["onFrame", "onResize"].concat(m), me = [], O = [], ce, Oe = typeof te == "object" ? te : pe(te, D);
          te = Oe.code;
          function Be(Je, nt) {
            for (var pt in Je)
              (nt || !/^_/.test(pt)) && new RegExp("([\\b\\s\\W]|^)" + pt.replace(/\$/g, "\\$") + "\\b").test(te) && (me.push(pt), O.push(Je[pt]));
          }
          Be(
            { __$__: X, $__: ue, paper: he, tool: le },
            !0
          ), Be(he), te = "var module = { exports: {} }; " + te;
          var Ke = _.each(oe, function(Je) {
            new RegExp("\\s+" + Je + "\\b").test(te) && (me.push(Je), this.push("module.exports." + Je + " = " + Je + ";"));
          }, []).join(`
`);
          Ke && (te += `
` + Ke), te += `
return module.exports;`;
          var Ge = Ae.agent;
          if (Z && (Ge.chrome || Ge.firefox && Ge.versionNumber < 40)) {
            var Fe = Z.createElement("script"), Ye = Z.head || Z.getElementsByTagName("head")[0];
            Ge.firefox && (te = `
` + te), Fe.appendChild(Z.createTextNode(
              "document.__paperscript__ = function(" + me + ") {" + te + `
}`
            )), Ye.appendChild(Fe), ce = Z.__paperscript__, delete Z.__paperscript__, Ye.removeChild(Fe);
          } else
            ce = Function(me, te);
          var Ke = ce && ce.apply(he, O), et = Ke || {};
          return _.each(m, function(Je) {
            var nt = et[Je];
            nt && (le[Je] = nt);
          }), Se && (et.onResize && Se.setOnResize(et.onResize), Se.emit("resize", {
            size: Se.size,
            delta: new a()
          }), et.onFrame && Se.setOnFrame(et.onFrame), Se.requestUpdate()), Ke;
        }
        function q(te) {
          if (/^text\/(?:x-|)paperscript$/.test(te.type) && x.getAttribute(te, "ignore") !== "true") {
            var he = x.getAttribute(te, "canvas"), D = Z.getElementById(he), Se = te.src || te.getAttribute("data-src"), le = x.hasAttribute(te, "async"), m = "data-paper-scope";
            if (!D)
              throw new Error('Unable to find canvas with id "' + he + '"');
            var oe = x.get(D.getAttribute(m)) || new x().setup(D);
            return D.setAttribute(m, oe._id), Se ? $.request({
              url: Se,
              async: le,
              mimeType: "text/plain",
              onLoad: function(me) {
                M(me, oe, Se);
              }
            }) : M(te.innerHTML, oe, te.baseURI), te.setAttribute("data-paper-ignore", "true"), oe;
          }
        }
        function K() {
          _.each(
            Z && Z.getElementsByTagName("script"),
            q
          );
        }
        function be(te) {
          return te ? q(te) : K();
        }
        return C && (Z.readyState === "complete" ? setTimeout(K) : He.add(C, { load: K })), {
          compile: pe,
          execute: M,
          load: be,
          parse: I,
          calculateBinary: X,
          calculateUnary: ue
        };
      }).call(this);
      var Ae = new (x.inject(_.exports, {
        Base: _,
        Numerical: l,
        Key: Re,
        DomEvent: He,
        DomElement: Ue,
        document: Z,
        window: C,
        Symbol: U,
        PlacedSymbol: z
      }))();
      return Ae.agent.node && Gc(Ae), typeof ne == "function" && ne.amd ? ne("paper", Ae) : Me && (Me.exports = Ae), Ae;
    }).call(z0, typeof self == "object" ? self : null);
  }(Vo)), Vo.exports;
}
var U0 = F0();
const Ts = /* @__PURE__ */ Yo(U0), Vn = {
  heart: {
    name: "Heart",
    width: 150,
    height: 150,
    svg: "<svg version='1.0' xmlns='http://www.w3.org/2000/svg' width='150' height='150' viewBox='0 0 150 150'><path d='M54.0982,131.36312c-37.55979,-34.26132 -50.98892,-55.93441 -51.09775,-82.4662c-0.09925,-24.18698 16.47831,-47.53097 33.65802,-47.39635c8.57878,0.06736 26.98082,8.96949 33.49705,16.20469c3.28326,3.64551 4.83837,3.28603 12.14819,-2.80822c19.89425,-16.58593 39.32119,-16.93407 51.90293,-0.93003c20.10829,25.57781 16.44736,56.12239 -10.52395,87.80537c-14.3395,16.84451 -45.65381,46.72762 -48.96555,46.72762c-1.00772,0 -10.28624,-7.71161 -20.61895,-17.13688l0,0.00001z' fill='black'/></svg>",
    svg_d: "M54.0982,131.36312c-37.55979,-34.26132 -50.98892,-55.93441 -51.09775,-82.4662c-0.09925,-24.18698 16.47831,-47.53097 33.65802,-47.39635c8.57878,0.06736 26.98082,8.96949 33.49705,16.20469c3.28326,3.64551 4.83837,3.28603 12.14819,-2.80822c19.89425,-16.58593 39.32119,-16.93407 51.90293,-0.93003c20.10829,25.57781 16.44736,56.12239 -10.52395,87.80537c-14.3395,16.84451 -45.65381,46.72762 -48.96555,46.72762c-1.00772,0 -10.28624,-7.71161 -20.61895,-17.13688l0,0.00001z",
    svg_border: "M119.3 2.15c13.2 4.35 24.25 19.95 27.2 38.5.85 5.2.35 17.2-.95 22.85-3.55 15.6-11.65 29.05-28.45 47.3-9.6 10.4-32.75 31.7-39.75 36.55l-1.9 1.35-1.8-.95c-6.5-3.5-36.95-33.35-50.25-49.3-9.7-11.6-17.5-27.5-19.7-40.15-1.15-6.65-.75-16.45 1-22.95 3.1-11.55 11.8-24.65 19.35-29.1 13.05-7.65 27.5-4.7 44.55 9.15 3.8 3.1 6.3 4.6 7.65 4.6.4 0 2.05-1.2 3.65-2.65 6.2-5.7 14.6-10.6 23.85-13.85 5.3-1.9 12.1-2.45 15.55-1.35zm-12.6 2.65c-8.6 2.45-18.65 7.95-24.85 13.6-1.85 1.65-3.9 3.15-4.65 3.3-2.15.55-4.5-.6-9.6-4.6-6.85-5.35-12.4-8.75-17.5-10.6-3.65-1.4-5.25-1.7-10-1.9-6.9-.3-10.65.6-15.1 3.45-7.7 4.95-15.15 16.25-18.35 27.7-1.25 4.55-1.4 5.75-1.4 13.25.05 6.85.2 9 1.15 12.75 3.25 13 9.95 25.2 21.05 38.45 13 15.5 44.5 45.8 47.6 45.8 2.1 0 17.75-13.75 33-29 18.95-18.95 27.8-31.15 33.1-45.5 2.95-8.05 3.6-12.05 3.6-22.5-.05-8.2-.15-9.75-1.2-13.5-2.85-10.1-6.85-17.35-13-23.5-8.05-8-14.4-9.95-23.85-7.2z",
    svg_border_width: 4,
    maskClass: "mask-heart",
    fillColor: "rgba(255,255,255,0.7)",
    mapDimensions: {
      zoom: 12,
      targetSize: 300
    }
  },
  dogtag: {
    name: "Dog Tag",
    width: 84,
    height: 150,
    svg: `<svg version='1.0' xmlns='http://www.w3.org/2000/svg' width='84' height='150' viewBox='0 0 84 150'><path transform="translate(0, 0)" d='M42 150c-15.4 0-27.9-2.8-37.5-8.4C1.7 140 0 137.7 0 135V15C0 12.3 1.7 10 4.5 8.4 14.1 2.8 26.6 0 42 0s27.9 2.8 37.5 8.4C82.3 10 84 12.3 84 15v120c0 2.7-1.7 5-4.5 6.6C69.9 147.2 57.4 150 42 150z' fill='#000000'/></svg>`,
    svg_d: "M42 150c-15.4 0-27.9-2.8-37.5-8.4C1.7 140 0 137.7 0 135V15C0 12.3 1.7 10 4.5 8.4 14.1 2.8 26.6 0 42 0s27.9 2.8 37.5 8.4C82.3 10 84 12.3 84 15v120c0 2.7-1.7 5-4.5 6.6C69.9 147.2 57.4 150 42 150z",
    svg_border: "M42 150c-15.4 0-27.9-2.8-37.5-8.4C1.7 140 0 137.7 0 135V15C0 12.3 1.7 10 4.5 8.4 14.1 2.8 26.6 0 42 0s27.9 2.8 37.5 8.4C82.3 10 84 12.3 84 15v120c0 2.7-1.7 5-4.5 6.6C69.9 147.2 57.4 150 42 150z",
    svg_border_width: 4,
    maskClass: "mask-dogtag",
    fillColor: "rgba(255,255,255,0.7)",
    mapDimensions: {
      zoom: 13,
      targetSize: 400
    }
  }
}, j0 = ({
  map: Me,
  metalType: ge,
  previewContent: ne,
  setPreviewContent: C,
  setPreviewType: Z,
  cf: _,
  setCustomFields: P,
  shape: x,
  selectedMarker: y,
  showErrors: E
}) => {
  const d = () => {
    var W;
    const l = Vn[x], u = Me.current.getCenter(), a = Me.current.project(u), n = 24, c = 24, g = document.createElement("canvas");
    g.width = l.width, g.height = l.height, Ts.setup(g);
    const f = new Ts.Path(l.svg_d);
    f.position = new Ts.Point(l.width / 2, l.height / 2);
    const p = Me.current.queryRenderedFeatures({
      layers: ["road-network", "parks", "water", "background"],
      geometry: {
        type: "Circle",
        coordinates: u.toArray()
      }
    });
    let s = [];
    const S = document.createElement("canvas");
    S.width = l.width, S.height = l.height;
    const b = S.getContext("2d");
    p.forEach((Q) => {
      if (Q.layer.id === "parks" && Q.geometry.coordinates.forEach((de) => {
        const _e = de[0].map((fe) => {
          if (fe[0] && fe[1]) {
            const xe = Me.current.project([fe[0], fe[1]]);
            return {
              x: xe.x - (a.x - l.width / 2),
              y: xe.y - (a.y - l.height / 2)
            };
          }
        }).filter(Boolean), ke = new Ts.Path();
        _e.forEach((fe) => {
          ke.add(new Ts.Point(fe.x, fe.y));
        }), ke.closed = !0;
        const Pe = ke.intersect(f);
        Pe && Pe.segments && (b.fillStyle = "#91d891", b.beginPath(), Pe.segments.forEach((fe, xe) => {
          const Ee = fe.point;
          xe === 0 ? b.moveTo(Ee.x, Ee.y) : b.lineTo(Ee.x, Ee.y);
        }), b.closePath(), b.fill());
      }), Q.geometry.type === "LineString") {
        const de = Q.geometry.coordinates.map((_e) => {
          const ke = Me.current.project([_e[0], _e[1]]);
          return {
            x: ke.x - (a.x - l.width / 2),
            y: ke.y - (a.y - l.height / 2)
          };
        });
        s.push(de);
      }
      Q.geometry.type === "MultiLineString" && Q.geometry.coordinates.forEach((de) => {
        const _e = de.map((ke) => {
          const Pe = Me.current.project([ke[0], ke[1]]);
          return {
            x: Pe.x - (a.x - l.width / 2),
            y: Pe.y - (a.y - l.height / 2)
          };
        });
        s.push(_e);
      });
    });
    const o = document.createElement("canvas");
    o.width = l.width, o.height = l.height;
    const A = o.getContext("2d");
    A.save(), A.beginPath();
    const T = new Path2D(l.svg_d);
    A.clip(T), y !== "none" && (A.rect(0, 0, l.width, l.height), A.rect(
      l.width / 2 - n / 2,
      l.height / 2 - c / 2,
      n,
      c
    ), A.clip("evenodd")), A.strokeStyle = `var(--metal-${ge}-color)`, A.beginPath(), s.forEach((Q) => {
      Q.forEach((de, _e) => {
        _e === 0 ? A.moveTo(de.x, de.y) : A.lineTo(de.x, de.y);
      });
    }), A.stroke();
    const R = document.createElement("canvas");
    R.width = l.width, R.height = l.height;
    const L = R.getContext("2d");
    L.fillStyle = `var(--metal-${ge}-color)`, L.beginPath();
    const z = y && ((W = Zo[y]) != null && W.props.d) ? Zo[y].props.d : "", U = new Path2D(z), J = l.width / 2 - n / 2, F = l.height / 2 - c / 2;
    L.translate(J, F), L.fill(U);
    const se = new Vl.Potrace(), ee = new Vl.Potrace(), ie = new Vl.Potrace();
    ie.loadImage(R.toDataURL(), () => {
      const Q = ie.getPathTag().replace("<path", '<path class="marker-path"');
      ee.loadImage(S.toDataURL(), () => {
        const de = ee.getPathTag().replace("<path", '<path class="park-area"');
        se.loadImage(o.toDataURL(), () => {
          const _e = se.getPathTag(), ke = `<svg width="${l.width}" height="${l.height}" viewBox="0 0 ${l.width} ${l.height}" xmlns="http://www.w3.org/2000/svg">
                        ${_e}${de}${Q}
                    </svg>`;
          C(ke), Z("svg"), P(_);
        });
      });
    });
  };
  return /* @__PURE__ */ ft.jsx("div", { className: "design-confirmation", children: /* @__PURE__ */ ft.jsx(
    "div",
    {
      className: `confirm-button ${E && !ne ? "so-btn-danger" : ""}`,
      onClick: d,
      children: "Capture Map"
    }
  ) });
}, H0 = ({
  previewContent: Me,
  previewType: ge,
  width: ne,
  height: C,
  currentVariant: Z,
  setUploads: _,
  showErrors: P,
  setUserInteracted: x
}) => {
  const [y, E] = Xt.useState("transparent"), [d, l] = Xt.useState(null), u = {
    image: {
      type: "image/jpeg",
      extension: "jpg",
      accept: ".jpg,.jpeg,.png,.tiff,.bmp,.webp,.bpg",
      getBlob: (a) => fetch(a).then((n) => n.blob())
    },
    svg: {
      type: "image/svg+xml",
      extension: "svg",
      accept: ".svg",
      getBlob: (a) => {
        const n = a.startsWith("<?xml") ? a : `<?xml version="1.0" encoding="UTF-8"?>${a}`;
        return new Blob([n], { type: "image/svg+xml" });
      }
    }
  };
  return ga.useEffect(() => {
    Me && (async () => {
      const n = document.querySelector(".preview-block");
      let c;
      if (ge === "image") {
        const p = await htmlToImage.toPng(n, {
          quality: 1,
          pixelRatio: 2,
          skipAutoScale: !0
        });
        c = await fetch(p).then((s) => s.blob());
      } else {
        const s = n.querySelector("svg").outerHTML;
        c = s.startsWith("<?xml") ? s : `<?xml version="1.0" encoding="UTF-8"?>${s}`;
      }
      const g = u[ge], f = new File([c], `map-snapshot.${g.extension}`, { type: g.type });
      _((p) => ({
        ...p,
        file: f,
        Upload: null
      })), x(!1), l(f);
    })();
  }, [Me, ge]), /* @__PURE__ */ ft.jsxs("div", { className: "preview-wrapper", children: [
    /* @__PURE__ */ ft.jsx("div", { className: "preview-grid", children: /* @__PURE__ */ ft.jsx(
      "div",
      {
        className: `preview-block bg-${y}`,
        style: {
          width: ne + "px",
          height: C + "px"
        },
        children: ge === "image" ? /* @__PURE__ */ ft.jsx("img", { src: Me, alt: "Map preview" }) : /* @__PURE__ */ ft.jsx("div", { dangerouslySetInnerHTML: { __html: Me } })
      }
    ) }),
    d && /* @__PURE__ */ ft.jsx(
      ud,
      {
        currentVariant: Z,
        registeredFile: d,
        setUploads: _,
        showErrors: P,
        setUserInteracted: x
      },
      d ? d.lastModified : "no-file"
    )
  ] });
}, G0 = ({ currentVariant: Me, productInfo: ge, setUploads: ne, showErrors: C, setUserInteracted: Z }) => {
  var T, R, L, z;
  const [_, P] = Xt.useState("none"), x = ga.useRef(null), y = ga.useRef(null), d = nf().filter((U) => {
    var J;
    return U.field_type === "custom" && ((J = U.slug) == null ? void 0 : J.includes("capture-"));
  }), l = ((T = ge.variant_metafields[Me.id]) == null ? void 0 : T.metal) || "", [u, a] = Xt.useState(l), [n, c] = Xt.useState(null), [g, f] = Xt.useState(null), [p, s] = Xt.useState(null), S = (R = ge.variant_metafields[Me.id]) == null ? void 0 : R.shape;
  Xt.useEffect(() => {
    var J;
    const U = ((J = ge.variant_metafields[Me.id]) == null ? void 0 : J.metal) || "";
    a(U);
  }, [Me, ge]);
  const b = ga.useRef(null), [o, A] = ga.useState({ x: 0, y: 0 });
  return ga.useEffect(() => {
    var F, se;
    const U = ((F = b.current) == null ? void 0 : F.offsetWidth) / 2 - Vn[S].width / 2, J = ((se = b.current) == null ? void 0 : se.offsetHeight) / 2 - Vn[S].height / 2;
    A({ x: U, y: J });
  }, []), ga.useEffect(() => ((async () => {
    const J = document.createElement("link");
    J.href = "https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css", J.rel = "stylesheet", document.head.appendChild(J);
    const F = document.createElement("link");
    F.href = "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css", F.rel = "stylesheet", document.head.appendChild(F);
    const se = document.createElement("script");
    se.src = "https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js", document.head.appendChild(se), await new Promise((W) => se.onload = W);
    const ee = document.createElement("script");
    ee.src = "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.min.js", document.head.appendChild(ee), await new Promise((W) => ee.onload = W), window.mapboxgl.accessToken = ge.additions.mapbox.access_token, y.current = new window.mapboxgl.Map({
      container: x.current,
      preserveDrawingBuffer: !0,
      style: {
        version: 8,
        sources: {
          "mapbox-streets": {
            type: "vector",
            url: "mapbox://mapbox.mapbox-streets-v8"
          }
        },
        layers: [
          {
            id: "buildings",
            type: "fill-extrusion",
            source: "mapbox-streets",
            "source-layer": "building",
            paint: {
              "fill-extrusion-color": "#aaa",
              "fill-extrusion-height": ["get", "height"],
              "fill-extrusion-base": ["get", "min_height"],
              "fill-extrusion-opacity": 0.6
            }
          },
          {
            id: "background",
            type: "background",
            paint: {
              "background-color": "#ffffff"
            }
          },
          {
            id: "water",
            type: "fill",
            source: "mapbox-streets",
            "source-layer": "water",
            paint: {
              "fill-color": "#82b8ff"
            }
          },
          {
            id: "parks",
            type: "fill",
            source: "mapbox-streets",
            "source-layer": "landuse",
            filter: ["==", "class", "park"],
            paint: {
              "fill-color": "#91d891"
            }
          },
          {
            id: "road-network",
            type: "line",
            source: "mapbox-streets",
            "source-layer": "road",
            filter: [
              "in",
              "class",
              "motorway",
              "trunk",
              "primary",
              "secondary",
              "tertiary",
              "street",
              "street_limited",
              "residential"
            ],
            paint: {
              "line-color": "#222222",
              "line-width": [
                "match",
                ["get", "class"],
                "motorway",
                2,
                "trunk",
                1.5,
                "primary",
                1,
                "secondary",
                0.8,
                "tertiary",
                0.6,
                "street",
                0.5,
                "street_limited",
                0.4,
                "residential",
                0.3,
                0.3
              ]
            }
          }
        ]
      },
      center: [-74.006, 40.7128],
      zoom: 12
    });
    const ie = new window.MapboxGeocoder({
      accessToken: window.mapboxgl.accessToken,
      mapboxgl: window.mapboxgl,
      marker: !1,
      placeholder: "Enter address to search"
    });
    y.current.addControl(ie, "top-left");
  })(), () => {
    y.current && y.current.remove();
    const J = document.querySelectorAll('link[href*="mapbox"]'), F = document.querySelectorAll('script[src*="mapbox"]');
    J.forEach((se) => se.remove()), F.forEach((se) => se.remove());
  }), []), /* @__PURE__ */ ft.jsx(ft.Fragment, { children: /* @__PURE__ */ ft.jsxs("div", { className: "so-tw", children: [
    /* @__PURE__ */ ft.jsxs("div", { className: "map-container", children: [
      /* @__PURE__ */ ft.jsx("div", { ref: x, className: "map" }),
      /* @__PURE__ */ ft.jsx("div", { className: "map-overlay", ref: b, children: /* @__PURE__ */ ft.jsxs("svg", { width: "100%", height: "100%", children: [
        /* @__PURE__ */ ft.jsx("defs", { children: /* @__PURE__ */ ft.jsxs("mask", { id: "shape-mask", children: [
          /* @__PURE__ */ ft.jsx("rect", { width: "100%", height: "100%", fill: Vn[S].fillColor }),
          /* @__PURE__ */ ft.jsx("g", { transform: `translate(${o.x}, ${o.y})`, children: /* @__PURE__ */ ft.jsx("path", { d: Vn[S].svg_d, fill: "black" }) })
        ] }) }),
        /* @__PURE__ */ ft.jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: Vn[S].fillColor,
            mask: "url(#shape-mask)"
          }
        ),
        /* @__PURE__ */ ft.jsx(
          "g",
          {
            className: `metal-${u}-border`,
            transform: `translate(${o.x}, ${o.y})`,
            children: /* @__PURE__ */ ft.jsx(
              "path",
              {
                d: Vn[S].svg_border,
                strokeWidth: Vn[S].svg_border_width
              }
            )
          }
        )
      ] }) }),
      /* @__PURE__ */ ft.jsx(Tc, { renderInMap: !0, selectedType: _, metalType: u })
    ] }),
    /* @__PURE__ */ ft.jsxs("div", { className: "flex items-end justify-between", children: [
      /* @__PURE__ */ ft.jsx(
        Tc,
        {
          renderInMap: !1,
          selectedType: _,
          onMarkerChange: P,
          metalType: u
        }
      ),
      d.map((U) => /* @__PURE__ */ ft.jsx(
        j0,
        {
          map: y,
          metalType: u,
          currentVariant: Me,
          previewContent: n,
          setPreviewContent: c,
          setPreviewType: s,
          setCustomFields: f,
          selectedMarker: _,
          cf: U,
          shape: S,
          showErrors: C,
          setUserInteracted: Z
        },
        U.id
      ))
    ] }),
    n && /* @__PURE__ */ ft.jsx(
      H0,
      {
        previewContent: n,
        previewType: p,
        width: ((L = b.current) == null ? void 0 : L.offsetWidth) + "px",
        height: ((z = b.current) == null ? void 0 : z.offsetHeight) + "px",
        currentVariant: Me,
        customFields: g,
        setUploads: ne,
        showErrors: C,
        setUserInteracted: Z
      }
    )
  ] }) });
}, V0 = () => {
  var R, L, z, U, J, F, se, ee, ie, W, Q, de, _e, ke, Pe, fe, xe, Ee, Ie, je;
  const Me = rf(), ge = nf(), ne = Me.shop_info.sectionID ? "product-form-" + Me.shop_info.sectionID : _p(), [C, Z] = Xt.useState(yp()), [_, P] = Xt.useState({}), [x, y] = Xt.useState({}), [E, d] = Xt.useState(!1);
  Xt.useEffect(() => {
    const Ue = ($e) => {
      Z(
        Me.product.variants.filter(
          (We) => We.id === parseInt(document.querySelector('[name="id"]').value)
        )[0]
      ), d(!1);
    }, He = Me.trigger_selector ? Me.trigger_selector : Me.variant_id_input, Ze = document.querySelectorAll(He);
    return Ze.forEach(($e) => $e.addEventListener("change", Ue)), () => {
      Ze.forEach(($e) => $e.removeEventListener("change", Ue));
    };
  }, []), Xt.useEffect(() => {
    l.length === 0 && y({});
  }, [C.id]);
  const l = ge.filter(
    (Ue) => {
      var He;
      return Ue.field_type === "engraving" && ((He = Me.variant_metafields[C.id]) == null ? void 0 : He.engravable);
    }
  ), u = ge.filter((Ue) => {
    var He;
    return Ue.field_type === "custom" && ((He = Ue.slug) == null ? void 0 : He.includes("capture-"));
  }), a = (u == null ? void 0 : u.length) > 0 ? !1 : (R = Me.variant_metafields[C.id]) == null ? void 0 : R.uploadable, n = {
    inputs: l.slice(0, Me.variant_metafields[C.id].engravings || l.length).reduce((Ue, He) => {
      var Ze;
      return He.id.key === "cf_2" || (Ze = x[He.id.key]) != null && Ze.length || Ue.push(He.id.key), Ue;
    }, []),
    upload: a || (u == null ? void 0 : u.length) > 0 ? ["file"].filter((Ue) => !_[Ue]).concat(_.file ? ["Upload"].filter((Ue) => !_[Ue]) : []) : []
  }, c = Xt.useMemo(() => n.inputs.length > 0, [n.inputs]), g = Xt.useMemo(() => n.upload.length > 0, [n.upload]), f = c || g, p = c && E, s = g && E, S = (L = ge.filter(
    (Ue) => {
      var He;
      return Ue.field_type === "custom" && ((He = Ue.class) == null ? void 0 : He.includes("so-flower-month"));
    }
  )[0]) == null ? void 0 : L.options, b = () => {
    const Ue = S == null ? void 0 : S.findIndex((He) => He === C.option3);
    return Ue >= 0 ? "#f" + (Ue + 1 < 10 ? "0" + (Ue + 1) : Ue + 1) + "#" : !1;
  }, o = ge.filter(
    (Ue) => {
      var He;
      return Ue.field_type === "custom" && ((He = Ue.slug) == null ? void 0 : He.includes("font-family-preview"));
    }
  ), A = {};
  A.font = ((J = (U = (z = Me.additions) == null ? void 0 : z.engraving) == null ? void 0 : U.shapes[Me.variant_metafields[C.id].shape]) == null ? void 0 : J.font) || ((se = (F = Me.additions) == null ? void 0 : F.engraving) == null ? void 0 : se.font) || !1, A.zone = ((Q = (W = (ie = (ee = Me.additions) == null ? void 0 : ee.engraving) == null ? void 0 : ie.shapes[Me.variant_metafields[C.id].shape]) == null ? void 0 : W.font) == null ? void 0 : Q.zone) || ((ke = (_e = (de = Me.additions) == null ? void 0 : de.engraving) == null ? void 0 : _e.shapes[Me.variant_metafields[C.id].shape]) == null ? void 0 : ke.zone) || !1, A.imgSrc = ((xe = (fe = (Pe = Me.additions) == null ? void 0 : Pe.engraving) == null ? void 0 : fe.shapes[Me.variant_metafields[C.id].shape]) == null ? void 0 : xe.imgSrc[Me.variant_metafields[C.id].metal]) || !1;
  const T = {
    fields: o,
    // TODO: Symbols might be not only at the end -> previewSymbolAtEnd?
    symbolAtEnd: ge.filter(
      (Ue) => {
        var He;
        return Ue.field_type === "custom" && ((He = Ue.class) == null ? void 0 : He.includes("symbol-at-the-end"));
      }
    ),
    flowerSymbol: b(),
    chains: Me.additions.chains,
    isVertical: (Ie = (Ee = o[0]) == null ? void 0 : Ee.class) == null ? void 0 : Ie.includes("dangle"),
    inputFields: l.slice(
      0,
      Me.variant_metafields[C.id].engravings || l.length
    ),
    itemPreview: ((je = Me.product_metafields) == null ? void 0 : je.item_preview) || !1,
    engraving: A || !1
  };
  return /* @__PURE__ */ ft.jsxs("div", { className: "so-hyper so-tw", "data-version": "2.2.1", children: [
    l.length > 0 && /* @__PURE__ */ ft.jsx(
      Ap,
      {
        previewConfig: T,
        currentVariant: C,
        productInfo: Me,
        productCustomFields: ge,
        formId: ne,
        inputFields: l,
        inputs: x,
        setInputs: y,
        validationErrors: n,
        showErrors: p
      }
    ),
    (u == null ? void 0 : u.length) > 0 ? /* @__PURE__ */ ft.jsx(
      G0,
      {
        currentVariant: C,
        productInfo: Me,
        productCustomFields: ge,
        formId: ne,
        uploads: _,
        setUploads: P,
        validationErrors: n,
        showErrors: s,
        setUserInteracted: d
      }
    ) : a == 1 && /* @__PURE__ */ ft.jsx(
      C0,
      {
        currentVariant: C,
        productInfo: Me,
        productCustomFields: ge,
        formId: ne,
        uploads: _,
        setUploads: P,
        validationErrors: n,
        showErrors: s,
        setUserInteracted: d
      }
    ),
    /* @__PURE__ */ ft.jsx(
      mp,
      {
        uploads: _,
        validationErrors: n,
        hasErrors: f,
        setUserInteracted: d
      }
    )
  ] });
};
document.addEventListener("DOMContentLoaded", () => {
  const Me = document.querySelectorAll("#so-hyper")[0];
  Me && dp.createRoot(Me).render(
    /* @__PURE__ */ ft.jsx(Xt.StrictMode, { children: /* @__PURE__ */ ft.jsx(V0, {}) })
  );
});
